export const geometry = {
  type: 'FeatureCollection',
  name: 'counties',
  crs: {
    type: 'name',
    properties: {
      name: 'urn:ogc:def:crs:EPSG::3857',
    },
  },
  features: [
    {
      type: 'Feature',
      properties: {
        NAME: 'Bladen',
        GEOID: '37017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8783330.239931889, 4141517.196230457],
              [-8771931.012755167, 4143631.631689704],
              [-8740374.831422035, 4142961.8159280876],
              [-8737990.590568224, 4144353.9871736704],
              [-8726418.15026383, 4129886.074698991],
              [-8726555.073237503, 4128775.444420739],
              [-8724594.18040718, 4123284.4699383406],
              [-8711244.52443227, 4103380.756189694],
              [-8711358.849549314, 4097302.643369595],
              [-8702568.283319842, 4091460.446776026],
              [-8711427.533675134, 4082567.9109513396],
              [-8720164.332590554, 4078260.546150771],
              [-8732493.0775154, 4079590.9018213283],
              [-8755096.834079444, 4090854.6296689655],
              [-8775354.755014006, 4091085.368293785],
              [-8779652.577914553, 4094083.1045373417],
              [-8772612.733316785, 4121724.740250585],
              [-8783330.239931889, 4141517.196230457],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stanly',
        GEOID: '37167',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8960926.79519519, 4191380.301497295],
              [-8938445.378751524, 4232437.740897107],
              [-8925881.638381615, 4232606.071216467],
              [-8917636.871615501, 4226495.323412788],
              [-8911261.60437777, 4214486.868814911],
              [-8916489.167665424, 4198612.432497185],
              [-8913948.856885519, 4183342.3203755035],
              [-8918098.736182803, 4190260.2477081856],
              [-8924797.386541286, 4183991.156267137],
              [-8936375.726778697, 4190510.8945111088],
              [-8945298.31792425, 4186318.4835314313],
              [-8961773.936520126, 4189050.139421844],
              [-8960926.79519519, 4191380.301497295],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Summit',
        GEOID: '39153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9093354.13123523, 5032415.87244881],
              [-9093127.039474012, 5053306.9821991185],
              [-9091519.586026955, 5053323.127765735],
              [-9082617.588987201, 5053367.417119003],
              [-9079789.73996258, 5053397.634720613],
              [-9083453.598363057, 5064276.035936688],
              [-9074504.179220222, 5064127.299590534],
              [-9067009.371863585, 5063978.120671709],
              [-9060481.93088194, 5063848.221224275],
              [-9060497.181652179, 5053234.105298167],
              [-9060528.68506807, 5032381.28612483],
              [-9060575.439254206, 5027167.109328625],
              [-9060658.706233319, 5016094.044728428],
              [-9060655.032690123, 5010650.136118744],
              [-9063679.471935485, 4998560.790945016],
              [-9088984.28462414, 4999667.304041713],
              [-9088979.163927564, 5010654.855291512],
              [-9093521.22179091, 5010658.837095315],
              [-9093354.13123523, 5032415.87244881],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sullivan',
        GEOID: '42113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8550865.420851491, 5099764.983727996],
              [-8484787.061672533, 5092511.917522542],
              [-8485676.72704295, 5088029.116701673],
              [-8491795.848132368, 5068037.4694295],
              [-8494805.14792698, 5058204.176370677],
              [-8505692.305446055, 5057940.236821044],
              [-8510107.57040939, 5053082.280185479],
              [-8526241.66080751, 5057334.729533351],
              [-8543714.924679877, 5072348.754021858],
              [-8550865.420851491, 5099764.983727996],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Upshur',
        GEOID: '48459',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10592354.564384753, 3850386.603432852],
              [-10592284.433105553, 3882388.3031794266],
              [-10544175.711408405, 3882635.0504707],
              [-10542610.11408989, 3879277.690123976],
              [-10538877.905522063, 3873391.0700078662],
              [-10542194.001833305, 3867871.950747833],
              [-10542155.040011527, 3849230.99197038],
              [-10547051.873092033, 3851260.3947578273],
              [-10555338.941264646, 3841094.5325506623],
              [-10573858.274391996, 3834051.2658949676],
              [-10573897.236213775, 3834040.966379429],
              [-10576463.929712996, 3831298.9725068533],
              [-10577025.536544047, 3834760.633541818],
              [-10592429.148443585, 3838381.9486068245],
              [-10592354.564384753, 3850386.603432852],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brown',
        GEOID: '48049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11042433.848515252, 3773715.9519494213],
              [-11033839.315909067, 3773761.93475567],
              [-11012213.946349602, 3773556.064533537],
              [-10983720.609486157, 3724062.318857917],
              [-10993919.255954672, 3722411.4922587974],
              [-10996133.845904514, 3712321.312035998],
              [-11019695.395367347, 3695775.8397917706],
              [-11025276.175399285, 3696589.2388645033],
              [-11030717.583428752, 3692755.0800946034],
              [-11031484.129442353, 3691109.925955086],
              [-11043201.619043253, 3693578.1970142326],
              [-11042433.848515252, 3773715.9519494213],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cherokee',
        GEOID: '45021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9114217.653030455, 4188848.9124288517],
              [-9102387.08538934, 4188329.6002673497],
              [-9071900.082372097, 4186991.46131936],
              [-9057800.345724763, 4186203.033032396],
              [-9062394.622372748, 4170178.173926079],
              [-9071093.127383336, 4168618.5368240876],
              [-9071659.966230456, 4156946.6301050154],
              [-9067780.37065682, 4142061.3311004764],
              [-9070528.626245523, 4145753.115858284],
              [-9096104.167935787, 4152007.0449171653],
              [-9100934.209321817, 4154410.5063402643],
              [-9106630.316346217, 4171426.612455306],
              [-9114217.653030455, 4188848.9124288517],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cullman',
        GEOID: '01043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9697262.591427721, 4027779.563512059],
              [-9697030.935567379, 4069061.7211218067],
              [-9697053.199465537, 4071015.796698422],
              [-9638257.027415803, 4069788.732584575],
              [-9626634.048062585, 4069527.838575985],
              [-9623906.163940696, 4063675.34014006],
              [-9631242.897620408, 4062733.1012353664],
              [-9636243.703105316, 4051718.1096140128],
              [-9640395.58615343, 4044797.411711489],
              [-9650516.08633941, 4041249.9901233604],
              [-9649770.691029059, 4036745.8502689553],
              [-9661854.310435178, 4022366.5362483356],
              [-9676378.498357449, 4016619.2620892036],
              [-9680716.730233153, 4009780.420863514],
              [-9695018.83577129, 4014053.7313821977],
              [-9701608.949626252, 4027892.3454370154],
              [-9697262.591427721, 4027779.563512059],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grant',
        GEOID: '54023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8848438.227109605, 4751216.80521465],
              [-8841485.211714657, 4754408.010304045],
              [-8833619.042536732, 4761576.888562639],
              [-8825823.672554951, 4766122.3977670595],
              [-8823449.129540823, 4768511.526263293],
              [-8809207.346122712, 4766534.0272485595],
              [-8792002.028264685, 4755766.554487558],
              [-8804220.121615684, 4727146.019405794],
              [-8799455.42477075, 4711250.386424596],
              [-8809189.535004184, 4694969.288700689],
              [-8833186.788953982, 4715586.927720347],
              [-8834054.969662677, 4716589.065637958],
              [-8827431.237321498, 4732163.708843286],
              [-8833810.289421916, 4734070.687470049],
              [-8828354.85513661, 4751682.563410618],
              [-8848471.845595824, 4749628.762990908],
              [-8848438.227109605, 4751216.80521465],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Haakon',
        GEOID: '46055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11354706.950130071, 5544852.622682965],
              [-11354636.150933927, 5544967.6711380705],
              [-11342235.827576501, 5549151.459239721],
              [-11333570.718413154, 5546639.706391271],
              [-11322866.23617847, 5555560.860792525],
              [-11302383.115914037, 5553746.865819164],
              [-11294038.272925701, 5564429.770585525],
              [-11285732.503078632, 5567162.239314335],
              [-11283557.09758955, 5572509.080037752],
              [-11268815.836660232, 5573207.761311978],
              [-11258501.3066018, 5581799.114174811],
              [-11260469.212560045, 5572841.346222089],
              [-11260544.019257857, 5518699.447708437],
              [-11261831.429168882, 5491490.676450677],
              [-11248491.235350687, 5491552.598518631],
              [-11248476.763816884, 5464663.812231161],
              [-11250400.587256774, 5464657.467926759],
              [-11355404.700698363, 5464595.727242082],
              [-11354706.950130071, 5544852.622682965],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kewaunee',
        GEOID: '55061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9769544.0821653, 5567167.051233756],
              [-9768108.207799902, 5569268.009374651],
              [-9766901.711670391, 5570816.123282051],
              [-9726595.227182401, 5570581.348005364],
              [-9729504.834782612, 5563645.730226751],
              [-9734551.392578233, 5556622.265772293],
              [-9740306.498932755, 5537013.397715459],
              [-9745278.560108347, 5516266.234284069],
              [-9770069.323269209, 5516215.059863442],
              [-9769544.0821653, 5567167.051233756],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fulton',
        GEOID: '18049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9625467.531118562, 5037662.302615456],
              [-9582109.146052036, 5037873.189059816],
              [-9581929.699032877, 5024869.222042781],
              [-9567416.086462231, 5018667.922523842],
              [-9567513.491016675, 5012222.927256368],
              [-9592228.97832107, 5011765.989282472],
              [-9592290.53799948, 4999051.577033841],
              [-9625630.391533593, 4999059.383855123],
              [-9625467.531118562, 5037662.302615456],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hardin',
        GEOID: '19083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10408315.05963332, 5244889.7729123235],
              [-10355718.27002586, 5244755.271016164],
              [-10353035.692936722, 5231741.536146038],
              [-10352898.99260203, 5192378.353733479],
              [-10378507.81882004, 5192321.093263104],
              [-10404258.354749832, 5192383.613898997],
              [-10404212.936397586, 5231766.286471255],
              [-10408315.05963332, 5244889.7729123235],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Neosho',
        GEOID: '20133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10633849.906453364, 4541742.1058914345],
              [-10585156.868749043, 4541702.272283062],
              [-10585149.076384686, 4533547.751495888],
              [-10585168.779934557, 4492744.618848574],
              [-10633363.551598089, 4492766.05378577],
              [-10633856.696942301, 4492764.512710394],
              [-10633849.906453364, 4541742.1058914345],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pawnee',
        GEOID: '31133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10738286.290491907, 4904114.006568065],
              [-10694100.133691842, 4904094.312935212],
              [-10687803.903292576, 4904013.204757831],
              [-10687859.876729006, 4866044.68014114],
              [-10689352.802687474, 4866046.763173804],
              [-10703854.949350566, 4866014.211814897],
              [-10713295.621406272, 4866042.6942481],
              [-10713299.615372725, 4866042.700461116],
              [-10738291.308415525, 4866081.577632189],
              [-10738286.290491907, 4904114.006568065],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '01059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9813358.822054688, 4091146.9759599213],
              [-9811650.875743126, 4107179.7068555816],
              [-9743757.9597448, 4105203.7086318224],
              [-9743764.082316795, 4069775.7955498626],
              [-9755452.96280856, 4070099.091090015],
              [-9815402.59787714, 4071991.685201181],
              [-9813358.822054688, 4091146.9759599213],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Randolph',
        GEOID: '29175',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10319008.218907982, 4807652.062961851],
              [-10318442.827214241, 4809467.633524502],
              [-10274885.959495632, 4808757.17247884],
              [-10275905.312072827, 4771613.375104106],
              [-10276399.90457042, 4757035.729172674],
              [-10289286.026185667, 4757372.238181186],
              [-10320136.887225132, 4767845.28221977],
              [-10319008.218907982, 4807652.062961851],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Los Alamos',
        GEOID: '35028',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11844361.871710451, 4295131.893909868],
              [-11827491.180241749, 4295989.007828704],
              [-11827211.545680875, 4291095.7579607675],
              [-11827501.866912864, 4278515.017078405],
              [-11818996.501218805, 4276947.221977239],
              [-11827751.445211224, 4267074.11444252],
              [-11846484.177802425, 4275879.910239948],
              [-11844361.871710451, 4295131.893909868],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lee',
        GEOID: '37105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8833209.720769085, 4234500.272857441],
              [-8821475.533244567, 4241493.228510604],
              [-8807274.83976254, 4249577.198539303],
              [-8790860.112928128, 4235001.810311758],
              [-8814673.133120662, 4205701.839849022],
              [-8824692.889167473, 4212006.875455968],
              [-8834288.629273854, 4227892.7034963295],
              [-8833209.720769085, 4234500.272857441],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Putnam',
        GEOID: '39137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9395307.804734021, 5010913.2334958725],
              [-9388898.585051598, 5010968.832899807],
              [-9388864.187328942, 5036787.158132027],
              [-9376242.783462804, 5036837.138909374],
              [-9337606.793834709, 5037127.269105224],
              [-9337525.975884391, 5000612.034584604],
              [-9363028.491988696, 4998299.500156096],
              [-9363036.28435305, 4991859.880825173],
              [-9388744.964154303, 4991580.960174767],
              [-9395187.691003455, 4998083.726970154],
              [-9395307.804734021, 5010913.2334958725],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fairfield',
        GEOID: '45039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9064472.84594637, 4100122.0492068334],
              [-9063934.17093042, 4105872.622200167],
              [-9003241.114757566, 4101968.529417483],
              [-9005604.538866596, 4094341.865472646],
              [-9003434.365393583, 4090437.043921197],
              [-8991267.033730388, 4079551.9222223125],
              [-8997500.368617358, 4064947.271448786],
              [-9027550.174601074, 4057556.090683573],
              [-9037049.400708936, 4058419.4123394284],
              [-9036726.240227163, 4052264.2458223514],
              [-9052157.125401946, 4061000.8844010653],
              [-9054983.081995225, 4064700.497796857],
              [-9063993.726857994, 4095379.8050615448],
              [-9064472.84594637, 4100122.0492068334],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bastrop',
        GEOID: '48021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10852687.43874881, 3530820.660611228],
              [-10852676.752077695, 3530843.847629539],
              [-10842528.310699526, 3550928.9331005644],
              [-10839127.500255791, 3557595.566448436],
              [-10835222.857796727, 3555437.3682182212],
              [-10826010.50201664, 3550276.3584717694],
              [-10820207.528281078, 3547049.4613708314],
              [-10815669.366599908, 3543549.632777242],
              [-10807100.326157114, 3536931.521422758],
              [-10800713.59301183, 3510163.0479977145],
              [-10819612.748241765, 3490288.2494494035],
              [-10833147.86248834, 3476141.0829271944],
              [-10870278.144683965, 3512286.4043184766],
              [-10852687.43874881, 3530820.660611228],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sawyer',
        GEOID: '55113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10191442.093711391, 5805551.6065721745],
              [-10121678.280150738, 5805161.2568002585],
              [-10121744.069969798, 5777313.790308572],
              [-10094113.904437963, 5777393.728402205],
              [-10094312.164451065, 5722569.062008737],
              [-10190218.915146558, 5722464.141273413],
              [-10191442.093711391, 5805551.6065721745],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hutchinson',
        GEOID: '48233',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11312672.48776755, 4308247.695102639],
              [-11252812.546663793, 4308229.932428364],
              [-11252849.616054226, 4249180.445387025],
              [-11312601.799890898, 4249014.736383079],
              [-11312672.48776755, 4308247.695102639],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Douglas',
        GEOID: '55031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10274078.670548398, 5819543.902193212],
              [-10273983.025112225, 5847462.8895264305],
              [-10273939.74382389, 5860125.872901868],
              [-10273919.817635037, 5887278.78395343],
              [-10264268.417783258, 5887521.933960614],
              [-10261774.749869999, 5892470.747340422],
              [-10257349.466152495, 5898373.223460329],
              [-10252553.488530647, 5898836.10805601],
              [-10247050.298183791, 5894950.423237489],
              [-10243095.227995396, 5894293.263516742],
              [-10237150.655867547, 5890409.429923354],
              [-10228809.93170037, 5891654.406372114],
              [-10221358.65026463, 5891648.726333518],
              [-10201930.616133934, 5898882.722702603],
              [-10194003.443875054, 5902579.388157888],
              [-10191448.721190345, 5902577.323480247],
              [-10191514.89665837, 5901055.857794163],
              [-10191442.093711391, 5805551.6065721745],
              [-10246918.607226184, 5805640.317527491],
              [-10274102.226707628, 5805596.011195032],
              [-10274078.670548398, 5819543.902193212],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Concho',
        GEOID: '48095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11144331.591566255, 3708339.3803215516],
              [-11100968.642400606, 3707880.995467351],
              [-11090195.364720615, 3693605.3437204584],
              [-11087627.224068016, 3696804.3789910483],
              [-11087780.065728873, 3644091.3876666017],
              [-11144774.865778595, 3644182.1197544937],
              [-11144331.591566255, 3708339.3803215516],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fluvanna',
        GEOID: '51065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8737616.557079159, 4550782.080359288],
              [-8717068.982829554, 4580340.412314643],
              [-8705754.692424309, 4573401.137208893],
              [-8689875.634979593, 4565969.736532519],
              [-8699363.729138374, 4547541.420869122],
              [-8700656.371065466, 4543961.908980835],
              [-8703067.996514013, 4543459.459229144],
              [-8709608.907154042, 4535794.930258269],
              [-8734589.112207545, 4545605.281777536],
              [-8737616.557079159, 4550782.080359288],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Forest',
        GEOID: '55041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9912755.195663812, 5777520.445373552],
              [-9900000.987645155, 5777509.3916086545],
              [-9899950.498802492, 5791911.982913198],
              [-9886500.827718692, 5783812.754118322],
              [-9878490.945078151, 5784726.42683524],
              [-9872172.25135179, 5782667.657173625],
              [-9871347.239395475, 5736054.403595054],
              [-9843459.591881435, 5735978.822719461],
              [-9843771.286455655, 5681070.55907833],
              [-9871589.35928795, 5681335.692909649],
              [-9899199.821269915, 5681328.402812993],
              [-9898869.981618695, 5695047.450125056],
              [-9912609.923728326, 5694936.661952577],
              [-9912733.599682597, 5763595.6143387435],
              [-9912755.195663812, 5777520.445373552],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Muskegon',
        GEOID: '26121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9625074.67202095, 5384143.826060433],
              [-9577872.326232444, 5383394.8765830435],
              [-9577812.436346397, 5356755.682859388],
              [-9550148.986286815, 5356676.7646927545],
              [-9550172.808657845, 5343252.678668335],
              [-9563278.007030973, 5343367.678395918],
              [-9563171.919556247, 5330088.863532002],
              [-9603969.764717104, 5330006.048546318],
              [-9608681.999060318, 5341717.499540142],
              [-9618875.85879073, 5363627.954964829],
              [-9623430.050478572, 5377961.523499672],
              [-9625074.67202095, 5384143.826060433],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Becker',
        GEOID: '27005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10708341.79274648, 5966780.428142816],
              [-10694137.203082277, 5966889.118378349],
              [-10636709.37021337, 5966830.189768862],
              [-10594183.766257469, 5967004.0303149745],
              [-10593497.8155552, 5910257.452993587],
              [-10593575.739198755, 5896106.903759471],
              [-10602958.747758228, 5895882.025101801],
              [-10706106.052093389, 5896141.650868332],
              [-10706052.730057297, 5938381.878165718],
              [-10708341.79274648, 5966780.428142816],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Latimer',
        GEOID: '40077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10631863.85541812, 4167849.60795605],
              [-10614250.774265317, 4167863.474306784],
              [-10614228.065089198, 4171835.8088295152],
              [-10567321.371253636, 4171803.850444205],
              [-10567299.66395293, 4156030.756098093],
              [-10575142.344718298, 4156023.287091277],
              [-10575107.835676152, 4144204.2217441997],
              [-10581976.470897079, 4144196.2180323508],
              [-10581988.048124122, 4120578.6397721856],
              [-10632627.061846998, 4120633.600101245],
              [-10631863.85541812, 4167849.60795605],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ouachita',
        GEOID: '22073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10287629.703482153, 3828528.04776063],
              [-10287598.645344224, 3840063.6166979717],
              [-10266358.218583923, 3841021.3362828814],
              [-10248648.846071584, 3858594.6971433517],
              [-10231504.41997502, 3850411.7266760073],
              [-10235094.584872592, 3840628.2774206344],
              [-10231714.702493127, 3829902.8693482755],
              [-10240748.390490495, 3816076.370891174],
              [-10245222.209505985, 3799735.3098836807],
              [-10253205.820746697, 3797297.650757592],
              [-10276108.24750454, 3799784.4210038097],
              [-10276105.798475742, 3805488.741790312],
              [-10287637.273207529, 3816962.1419367786],
              [-10287629.703482153, 3828528.04776063],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kalawao',
        GEOID: '15005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-17478748.34648902, 2415825.386733431],
              [-17475382.504914965, 2417198.992852655],
              [-17473024.20150251, 2417190.9923915593],
              [-17468377.837276287, 2412049.5958192223],
              [-17468016.22272309, 2412044.026530014],
              [-17466054.933461905, 2407580.400944576],
              [-17468039.87130224, 2407324.288698711],
              [-17470718.5522092, 2410987.786651299],
              [-17474226.00672511, 2412786.3940053605],
              [-17478786.65494342, 2413635.0870510037],
              [-17478748.34648902, 2415825.386733431],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Choctaw',
        GEOID: '01023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9848286.458886575, 3749385.5902555413],
              [-9848286.18236325, 3754541.738024437],
              [-9846586.0847293, 3770276.1758797565],
              [-9844110.072126634, 3793228.6517738537],
              [-9843790.878686035, 3796190.7575041833],
              [-9843015.451758672, 3803898.1117699086],
              [-9788396.40763596, 3804147.690235639],
              [-9798246.401459312, 3800811.324168832],
              [-9796902.997844419, 3787660.4947125106],
              [-9808759.302850338, 3764129.751984751],
              [-9804296.05918647, 3762021.9310649326],
              [-9809630.93446325, 3756782.723896429],
              [-9816195.444835328, 3738991.450647817],
              [-9805943.36501123, 3723903.8726776787],
              [-9847725.722644474, 3723725.851683206],
              [-9848287.184238667, 3735870.878834914],
              [-9848286.458886575, 3749385.5902555413],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Taylor',
        GEOID: '12123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9349981.217652617, 3515029.6760459025],
              [-9341434.403206144, 3535131.0835546157],
              [-9334917.092298161, 3538730.9264618647],
              [-9330825.878372528, 3542627.0558830434],
              [-9291700.750901887, 3542713.7017491497],
              [-9291756.299327793, 3537059.6276121023],
              [-9280400.932030443, 3537071.097947834],
              [-9280805.021782024, 3489152.9222784536],
              [-9278797.93136302, 3480718.5465923203],
              [-9275012.95735656, 3480769.9995812513],
              [-9280304.974629378, 3460650.7956404807],
              [-9285618.088410504, 3460697.456997272],
              [-9285682.039993167, 3461270.228668324],
              [-9293348.168046135, 3464858.78606222],
              [-9299368.103469254, 3468001.22887971],
              [-9304422.00835127, 3476239.334808744],
              [-9309095.311894262, 3485167.876029598],
              [-9315128.049058821, 3493079.7439148333],
              [-9327318.646495594, 3500591.4372257255],
              [-9343212.954710549, 3508572.659765356],
              [-9349981.217652617, 3515029.6760459025],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Porter',
        GEOID: '18127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9709597.675899427, 5105550.030277714],
              [-9698803.587138772, 5108739.467232047],
              [-9687900.176974041, 5112369.138288459],
              [-9677320.487060523, 5118606.209397346],
              [-9677012.128899043, 5047332.307275992],
              [-9681247.390245765, 5044795.356473502],
              [-9699416.289616099, 5054654.859532346],
              [-9709159.305408798, 5048106.402113181],
              [-9709597.675899427, 5105550.030277714],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hamilton',
        GEOID: '20075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11359556.725154627, 4616562.3780264],
              [-11306440.377394978, 4616666.361094453],
              [-11303638.465811713, 4616675.151252658],
              [-11303688.002985114, 4555099.174531137],
              [-11301940.954896605, 4542242.5021741595],
              [-11359259.656663178, 4542555.9234613385],
              [-11359514.50497896, 4595402.800898428],
              [-11359556.725154627, 4616562.3780264],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ottawa',
        GEOID: '26139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9603969.764717104, 5330006.048546318],
              [-9563171.919556247, 5330088.863532002],
              [-9563278.007030973, 5343367.678395918],
              [-9550172.808657845, 5343252.678668335],
              [-9549932.46987722, 5316672.822723955],
              [-9549233.828753004, 5298969.652700251],
              [-9549220.359094618, 5290124.149223758],
              [-9549263.996335007, 5276755.814585212],
              [-9587580.610344017, 5276786.445785238],
              [-9588732.099156782, 5276777.347398563],
              [-9596690.608176226, 5276656.32027145],
              [-9597313.941341016, 5294264.492561199],
              [-9598668.365585499, 5310188.72226893],
              [-9601823.27127407, 5324676.176873819],
              [-9603969.764717104, 5330006.048546318],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Manistee',
        GEOID: '26101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9612620.371325092, 5501015.768772727],
              [-9603388.868592588, 5519038.315654211],
              [-9601520.482259113, 5527706.530325555],
              [-9601185.187952844, 5540494.965242447],
              [-9599861.250222545, 5546003.576465356],
              [-9553194.019637974, 5545171.546193603],
              [-9553570.724794818, 5490887.307398674],
              [-9578319.385307468, 5491335.950708337],
              [-9616650.065676857, 5493137.263132377],
              [-9612620.371325092, 5501015.768772727],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bronx',
        GEOID: '36005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8231796.3276737975, 4991385.860774572],
              [-8230749.527151816, 4993877.325557945],
              [-8230394.593967924, 4995047.794169931],
              [-8228962.837955134, 4999770.746088701],
              [-8228789.249849179, 5000343.519088235],
              [-8221097.904661057, 4999082.215160817],
              [-8218055.320338695, 4996110.470930334],
              [-8209596.486191786, 4993438.913513631],
              [-8213036.035818318, 4984608.917332696],
              [-8218448.946058138, 4983465.140043603],
              [-8220571.920067059, 4983036.90148784],
              [-8227896.965200238, 4982312.232883418],
              [-8233839.034537133, 4986525.895642251],
              [-8231796.3276737975, 4991385.860774572],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cimarron',
        GEOID: '40025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11466187.854184994, 4393928.094830813],
              [-11466126.183187095, 4426509.913601755],
              [-11466152.343267433, 4439121.283519302],
              [-11448317.847647442, 4439050.753782956],
              [-11432304.872855302, 4438430.641977827],
              [-11394138.540158864, 4438341.022166393],
              [-11359290.196205013, 4438142.690503197],
              [-11357727.73709927, 4438151.3522242615],
              [-11358188.02403762, 4369649.605165908],
              [-11372673.359346652, 4369685.655789684],
              [-11466178.503347768, 4369695.488038599],
              [-11466151.118753035, 4383874.250907231],
              [-11466187.854184994, 4393928.094830813],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cavalier',
        GEOID: '38019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11020607.700084398, 6274859.068665839],
              [-11006050.854061322, 6274896.178289039],
              [-10903766.944978667, 6274948.7993648155],
              [-10903697.03505654, 6227094.854445696],
              [-10901200.918114483, 6197691.681141669],
              [-10944720.605123168, 6197800.806043241],
              [-11017333.641050674, 6197877.9845919],
              [-11017330.969382897, 6227161.66972309],
              [-11020617.343390096, 6227168.418770256],
              [-11020607.700084398, 6274859.068665839],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Towner',
        GEOID: '38095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11079150.25141994, 6274737.748266624],
              [-11062493.286797727, 6274752.291064028],
              [-11020607.700084398, 6274859.068665839],
              [-11020617.343390096, 6227168.418770256],
              [-11017330.969382897, 6227161.66972309],
              [-11017333.641050674, 6197877.9845919],
              [-11017398.540313808, 6168710.973587522],
              [-11042927.55045692, 6168742.141891519],
              [-11075501.080616413, 6168790.402715871],
              [-11075531.136878928, 6197979.208934577],
              [-11075510.320134148, 6227207.225895611],
              [-11079171.95214481, 6227211.444072103],
              [-11079150.25141994, 6274737.748266624],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'White',
        GEOID: '05145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10253801.157383459, 4213283.931356397],
              [-10224913.19292515, 4212678.143981473],
              [-10224711.259368852, 4223351.184234847],
              [-10218667.835533174, 4225965.475237077],
              [-10218456.66245914, 4236704.09016137],
              [-10194848.247490684, 4236202.474922196],
              [-10195160.721301341, 4224153.087318061],
              [-10168730.134602295, 4223715.16911993],
              [-10169769.969965793, 4219474.617882406],
              [-10178854.085692488, 4214192.128800762],
              [-10178820.244567288, 4204330.185946228],
              [-10175467.746782556, 4192817.7927987343],
              [-10181849.915828718, 4176044.2399173514],
              [-10195084.801408619, 4176334.0193323526],
              [-10197763.148357106, 4166700.1204619505],
              [-10207492.249213457, 4172356.6754799443],
              [-10219408.11014695, 4168016.549093191],
              [-10227910.136256287, 4167221.5619748235],
              [-10242865.909844363, 4174250.3608688973],
              [-10254720.211099448, 4172920.952593248],
              [-10253801.157383459, 4213283.931356397],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crisp',
        GEOID: '13081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9346526.713312482, 3767327.3666838524],
              [-9307385.110557204, 3766978.4827428428],
              [-9307673.761996834, 3744172.743456888],
              [-9307716.731320279, 3737626.7564059626],
              [-9328876.451449756, 3737554.8450344387],
              [-9333618.661757547, 3741172.0322650378],
              [-9344095.384314066, 3743365.4567625932],
              [-9342209.298181556, 3751457.0134274405],
              [-9341943.021959579, 3753763.7936715316],
              [-9346526.713312482, 3767327.3666838524],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Candler',
        GEOID: '13043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9156531.94976208, 3809539.1559981196],
              [-9144711.155673726, 3831820.573237454],
              [-9137086.215832349, 3837054.2203342333],
              [-9131563.767213585, 3834242.2046877462],
              [-9119144.742181707, 3817964.0207961625],
              [-9124755.021878704, 3798644.5157401124],
              [-9131018.969625644, 3799974.2841236996],
              [-9154112.086671218, 3805236.2211036165],
              [-9156531.94976208, 3809539.1559981196],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carroll',
        GEOID: '18015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9656967.050830882, 4973483.3307875255],
              [-9638235.097476115, 4973444.839670381],
              [-9631937.197284484, 4967078.849031336],
              [-9615056.37574212, 4967084.868520202],
              [-9615156.118005872, 4947856.220515974],
              [-9615305.84272099, 4928897.577215292],
              [-9650805.962293437, 4928942.182453865],
              [-9650882.550103102, 4947931.390143105],
              [-9659336.152233943, 4947961.868440664],
              [-9656967.050830882, 4973483.3307875255],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: "O'Brien",
        GEOID: '19141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10671299.452948583, 5351258.553616236],
              [-10618552.27070906, 5350900.121411535],
              [-10618563.847936105, 5298267.292132957],
              [-10671017.035400439, 5298145.70292203],
              [-10671299.452948583, 5351258.553616236],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mitchell',
        GEOID: '20123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10963565.436441598, 4803289.018807421],
              [-10901723.006526304, 4803206.562914995],
              [-10901378.361382807, 4799653.806484454],
              [-10901417.211885093, 4765655.827970035],
              [-10901697.403043421, 4761440.990706943],
              [-10901489.458234617, 4753129.395493434],
              [-10963873.234833643, 4753202.245455686],
              [-10963565.436441598, 4803289.018807421],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clark',
        GEOID: '17023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9797696.483174792, 4790772.44632142],
              [-9791682.336365195, 4790851.338513752],
              [-9761341.429913051, 4791724.530468442],
              [-9743980.56332393, 4790245.888232354],
              [-9743975.811988283, 4789130.706464737],
              [-9743978.26101708, 4771626.762617896],
              [-9749175.211444763, 4770540.704482052],
              [-9751631.58732861, 4766592.010663492],
              [-9751002.503676813, 4758894.4480704805],
              [-9750862.258327737, 4757179.186146174],
              [-9749030.273467751, 4751958.408136557],
              [-9756088.59710099, 4745582.001089133],
              [-9755850.196809493, 4744256.202034547],
              [-9757909.672650876, 4746364.5443849],
              [-9790592.073272366, 4746752.966835048],
              [-9796979.696973573, 4746615.545428381],
              [-9797464.493355978, 4776101.781750171],
              [-9797696.483174792, 4790772.44632142],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Worcester',
        GEOID: '24047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8422636.054128757, 4585339.926385548],
              [-8409171.182480875, 4592074.0589370085],
              [-8409730.896880584, 4604706.6422410635],
              [-8417174.385951968, 4618861.439876754],
              [-8389553.459937867, 4620525.394811179],
              [-8383457.9385805, 4628885.687939154],
              [-8386953.74021088, 4643538.560733269],
              [-8369606.565660584, 4643336.069423092],
              [-8354409.674055449, 4643371.747892376],
              [-8358481.629709177, 4625336.110555891],
              [-8360421.817114213, 4623527.802955631],
              [-8364905.988842347, 4610618.5254017105],
              [-8368709.219245299, 4597808.746490955],
              [-8370535.0815332895, 4592998.122597122],
              [-8375930.737252042, 4583270.245394644],
              [-8418463.131696882, 4578608.05359909],
              [-8422636.054128757, 4585339.926385548],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Benzie',
        GEOID: '26019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9601136.207376895, 5574266.220355459],
              [-9591317.160371983, 5578831.428163944],
              [-9583404.348327415, 5580916.71490799],
              [-9582214.586541254, 5586691.445254253],
              [-9566472.431138776, 5586693.680363057],
              [-9552895.349444175, 5586096.043753199],
              [-9553194.019637974, 5545171.546193603],
              [-9599861.250222545, 5546003.576465356],
              [-9598044.08588113, 5553569.830051469],
              [-9601745.792908477, 5566287.991394061],
              [-9601136.207376895, 5574266.220355459],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Perkins',
        GEOID: '31135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11360350.069076855, 5012915.454892307],
              [-11271095.659831678, 5012924.305405005],
              [-11270871.685016204, 4967869.195558738],
              [-11281714.426058449, 4967911.922780268],
              [-11360298.099748353, 4967831.729722487],
              [-11360297.860235674, 4975476.261232729],
              [-11360333.705111708, 5012692.277127216],
              [-11360345.228502197, 5012692.272351576],
              [-11360350.069076855, 5012915.454892307],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stevens',
        GEOID: '20189',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11305229.666613111, 4493395.812146244],
              [-11301801.471574642, 4493382.782280422],
              [-11253248.69642872, 4493288.77157699],
              [-11250850.095360598, 4493300.400277119],
              [-11250665.774291005, 4438791.243957095],
              [-11266811.083950536, 4438705.917521118],
              [-11297294.813309368, 4438495.034907366],
              [-11305079.702415371, 4438450.425239011],
              [-11305229.666613111, 4493395.812146244],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Perkins',
        GEOID: '46105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11461152.094379978, 5655092.994078415],
              [-11459458.809285326, 5771554.922551079],
              [-11452577.265323665, 5771550.854399935],
              [-11433053.94170885, 5771551.334675458],
              [-11415919.200407986, 5771542.209444954],
              [-11391126.457376981, 5771508.750346711],
              [-11364334.63893031, 5771475.451465086],
              [-11354663.749375409, 5771465.908913548],
              [-11354564.683820838, 5696202.554085529],
              [-11354587.39299696, 5627548.958032678],
              [-11461162.113134151, 5627752.967911418],
              [-11461152.094379978, 5655092.994078415],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brunswick',
        GEOID: '51025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8685971.660437472, 4408188.12401646],
              [-8683325.373502335, 4442279.155017394],
              [-8679370.748591904, 4437335.6039298605],
              [-8670654.3211433, 4437548.275244202],
              [-8665090.684312943, 4438536.988087075],
              [-8644853.023525707, 4424413.580882039],
              [-8644608.677243415, 4399252.681020406],
              [-8656994.414399803, 4375935.302203676],
              [-8671763.18973574, 4375853.318018587],
              [-8688064.166787146, 4375762.829028816],
              [-8685971.660437472, 4408188.12401646],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Patrick',
        GEOID: '51141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8972681.02022805, 4390802.163280333],
              [-8964060.104902547, 4389616.283328557],
              [-8957231.544698307, 4398583.2306740135],
              [-8956607.264993938, 4402699.883659008],
              [-8948629.77632522, 4410942.827414849],
              [-8931769.994166616, 4421298.313973664],
              [-8912978.930162238, 4417051.364692526],
              [-8910178.243093371, 4410482.5486018825],
              [-8916066.59887837, 4408423.562291785],
              [-8911509.851667952, 4375546.919485728],
              [-8938425.563882165, 4375731.69823234],
              [-8953605.312285716, 4376597.181843208],
              [-8954551.143010618, 4376649.323043629],
              [-8973707.807625268, 4377705.435037472],
              [-8972681.02022805, 4390802.163280333],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pike',
        GEOID: '01109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9594780.421050053, 3758907.867200004],
              [-9572982.283640876, 3759052.3385932846],
              [-9573125.885784002, 3770013.468602482],
              [-9567498.128926948, 3771437.395947462],
              [-9561637.603014644, 3769527.7878536345],
              [-9560602.109111285, 3759012.8417006065],
              [-9550104.458490498, 3759012.9729193044],
              [-9550215.6666618, 3747615.8500914485],
              [-9535367.984299285, 3747605.100325173],
              [-9536256.981752759, 3735283.503869668],
              [-9544058.02902857, 3714119.8031739797],
              [-9545451.637733812, 3713277.25841551],
              [-9550003.603031838, 3713266.2776122475],
              [-9589717.165330812, 3713237.126242147],
              [-9593477.203771336, 3713063.657425993],
              [-9589856.537333284, 3719174.5977852745],
              [-9589989.23016631, 3735900.870428328],
              [-9595670.865656909, 3735835.2557287877],
              [-9594780.421050053, 3758907.867200004],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Barrow',
        GEOID: '13013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9330541.679712532, 4045934.0952065154],
              [-9324959.00724925, 4037727.862648071],
              [-9302214.542848838, 4033067.0128548187],
              [-9299339.16040165, 4024225.758469563],
              [-9311544.89728917, 4016213.6529295878],
              [-9324236.321115019, 4014690.6009534574],
              [-9328473.586212574, 4019385.675012915],
              [-9336267.175082503, 4029381.57420908],
              [-9330541.679712532, 4045934.0952065154],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pike',
        GEOID: '18125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9736324.60074708, 4655070.745207179],
              [-9723961.56941907, 4656312.884049293],
              [-9716954.118793124, 4651946.28240928],
              [-9711745.81377738, 4656694.749640531],
              [-9696635.640055573, 4655599.432765229],
              [-9692851.779244019, 4652393.002693085],
              [-9692929.480248593, 4612336.135365352],
              [-9718012.099233624, 4612205.047872783],
              [-9720072.066410752, 4614246.800830848],
              [-9719997.037073957, 4633456.344387177],
              [-9730167.631030796, 4632608.16382838],
              [-9736279.405033818, 4645411.312793404],
              [-9736324.60074708, 4655070.745207179],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hancock',
        GEOID: '19081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10460738.747432597, 5350921.061420824],
              [-10408109.118575353, 5350937.874601066],
              [-10408218.43431531, 5298056.791810463],
              [-10460830.36337352, 5297942.804440279],
              [-10460738.747432597, 5350921.061420824],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Spencer',
        GEOID: '21215',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9519695.758468462, 4581017.584382723],
              [-9510706.375628432, 4594235.617482911],
              [-9509893.854665132, 4596162.885022057],
              [-9509362.192777105, 4600274.845603836],
              [-9488028.035005555, 4592067.128417993],
              [-9483988.362004159, 4590001.050793855],
              [-9473471.898389427, 4584692.152589061],
              [-9480990.416797604, 4579131.417747205],
              [-9480839.912846053, 4575444.1351476945],
              [-9506635.421850123, 4570943.26738056],
              [-9516614.434963303, 4578105.620637238],
              [-9519695.758468462, 4581017.584382723],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lapeer',
        GEOID: '26087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9290803.515806094, 5347472.403065839],
              [-9278669.802629117, 5347839.412707888],
              [-9278971.367129676, 5361151.99297906],
              [-9252920.157255253, 5361885.270541101],
              [-9252767.760872357, 5355251.000041263],
              [-9239565.603222746, 5355439.54996237],
              [-9239101.066987667, 5335456.777183543],
              [-9237697.328208763, 5295812.103811583],
              [-9250971.509568917, 5295038.114305268],
              [-9289985.985465707, 5293790.050328215],
              [-9290806.298793362, 5345996.5652852915],
              [-9290803.515806094, 5347472.403065839],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Benton',
        GEOID: '27009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10503340.38260071, 5751865.0631008055],
              [-10437754.94612698, 5751893.176943718],
              [-10437252.56126503, 5710060.825054182],
              [-10480670.724898113, 5709968.611298259],
              [-10486704.129979618, 5719591.002688412],
              [-10484364.750880597, 5729149.5323112765],
              [-10494286.100497548, 5744399.031673295],
              [-10503340.38260071, 5751865.0631008055],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Beltrami',
        GEOID: '27007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10642401.024458138, 6196979.293017342],
              [-10613483.003737317, 6197201.897392366],
              [-10598947.572546475, 6197159.864398312],
              [-10598834.805902302, 6167956.768853147],
              [-10511755.022909774, 6168184.983736651],
              [-10510535.517888132, 6095733.927794407],
              [-10510624.128202805, 6081242.334928869],
              [-10510372.100875648, 6014985.997269776],
              [-10510384.123380655, 6009556.202854287],
              [-10538640.01577024, 6009280.015732764],
              [-10553080.380115941, 6009230.174682625],
              [-10595747.13718617, 6009711.32551003],
              [-10596914.7673251, 6085676.830769144],
              [-10606279.964766048, 6094444.043355906],
              [-10600858.594244923, 6110175.7774353875],
              [-10640238.309391009, 6110275.468844022],
              [-10641284.712604465, 6113072.293262213],
              [-10641451.803160144, 6135670.258271632],
              [-10642401.024458138, 6196979.293017342],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pontotoc',
        GEOID: '28115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9934857.012643872, 4079853.107187157],
              [-9899516.525221221, 4079839.079585501],
              [-9887949.984849837, 4077886.0409834776],
              [-9887900.670315417, 4038870.1565596336],
              [-9922925.678301157, 4038758.3410834875],
              [-9934645.17165289, 4038734.956735749],
              [-9934761.945798734, 4050465.9570474736],
              [-9934857.012643872, 4079853.107187157],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lamar',
        GEOID: '01075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9824439.877642967, 3988426.764466757],
              [-9823765.556923106, 3994600.5643439675],
              [-9819183.816565672, 4036637.4148490047],
              [-9794660.244063407, 4035800.1991709513],
              [-9790763.95056615, 4031783.6020308854],
              [-9790747.920559475, 4018055.64198202],
              [-9790161.71212096, 3965073.218544462],
              [-9826674.223550081, 3966400.132703268],
              [-9824439.877642967, 3988426.764466757],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Indian River',
        GEOID: '12061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9003650.881803175, 3224935.726603954],
              [-9002282.653941836, 3226616.245073643],
              [-8962229.233237471, 3226557.841325571],
              [-8955394.433488674, 3231399.089892039],
              [-8948271.995481811, 3216238.7685138],
              [-8942401.116856866, 3198327.0217022556],
              [-8940812.655808514, 3193278.2589531983],
              [-8981236.591012457, 3193420.145114248],
              [-8992072.98684373, 3193453.169105151],
              [-8992171.059315119, 3204062.8654229813],
              [-9002757.876848033, 3203948.8891314026],
              [-9003650.881803175, 3224935.726603954],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Leon',
        GEOID: '12073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9430446.692558844, 3546436.0378787285],
              [-9422795.036039678, 3553558.0231923824],
              [-9408700.652671361, 3561718.8563958276],
              [-9395966.370841553, 3564626.3450577375],
              [-9392958.740839303, 3577478.725750183],
              [-9382620.556395348, 3591882.9111069166],
              [-9364751.383747702, 3591006.3306807675],
              [-9360160.577108983, 3590735.3502125395],
              [-9351667.002119353, 3590234.0174362687],
              [-9348324.077810831, 3570856.3398367087],
              [-9355433.942368306, 3564565.380729131],
              [-9359151.79072182, 3559498.3661777745],
              [-9359246.189650012, 3538769.466765754],
              [-9377689.936843114, 3538850.285777552],
              [-9382668.14447139, 3542596.240011342],
              [-9430247.096711854, 3542192.546136608],
              [-9430446.692558844, 3546436.0378787285],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Joseph',
        GEOID: '26149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9546780.235856429, 5130890.235781033],
              [-9547087.143692546, 5171369.956096691],
              [-9494843.014231918, 5171703.769873782],
              [-9494681.913926484, 5125059.60834548],
              [-9535599.777972143, 5124982.218095689],
              [-9550247.722440865, 5124954.513769283],
              [-9546780.235856429, 5130890.235781033],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cheboygan',
        GEOID: '26031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9432399.57038583, 5667194.390612283],
              [-9432350.033212429, 5745243.191203637],
              [-9430865.253844228, 5744780.651824187],
              [-9412431.525405297, 5732175.094611803],
              [-9402231.209144419, 5724820.617638304],
              [-9396883.643445691, 5727531.996477788],
              [-9387521.117672522, 5726728.037561837],
              [-9374313.766473997, 5720653.460753316],
              [-9378891.9647047, 5720616.369329383],
              [-9378292.397927288, 5652861.429852188],
              [-9391648.510432664, 5652863.009636543],
              [-9432579.462682953, 5653368.39690312],
              [-9432399.57038583, 5667194.390612283],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sioux',
        GEOID: '31165',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11583141.113087825, 5312060.890334451],
              [-11522134.944312112, 5312087.34673944],
              [-11519385.769042738, 5279298.544213207],
              [-11519350.035486193, 5226706.6460927855],
              [-11515392.627588492, 5226719.7688361835],
              [-11515345.428124396, 5174576.761861154],
              [-11510620.91761564, 5174554.86054712],
              [-11510617.8006699, 5161509.733632468],
              [-11583100.496734697, 5161236.835418615],
              [-11583096.80793049, 5163424.114810856],
              [-11583103.932377899, 5198496.3930867],
              [-11583138.88669801, 5236168.34838086],
              [-11583089.370849859, 5253064.183112941],
              [-11583080.889243308, 5255961.323671098],
              [-11583141.113087825, 5312060.890334451],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fulton',
        GEOID: '39051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9395314.793981038, 5117029.175793959],
              [-9390958.890795527, 5117183.433045464],
              [-9365800.45862894, 5118074.426719003],
              [-9337522.354144087, 5119157.650699898],
              [-9337806.50100119, 5084522.306787876],
              [-9388897.58317618, 5084221.536262935],
              [-9393284.684308343, 5103739.239597206],
              [-9395314.793981038, 5117029.175793959],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Anson',
        GEOID: '37007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8936375.726778697, 4190510.8945111088],
              [-8924797.386541286, 4183991.156267137],
              [-8918098.736182803, 4190260.2477081856],
              [-8913948.856885519, 4183342.3203755035],
              [-8904773.459176376, 4175518.5748871616],
              [-8897095.865215855, 4179578.7051908746],
              [-8891888.896033999, 4168680.667947668],
              [-8888809.687599167, 4150300.6481146584],
              [-8897175.152872315, 4137796.4446609183],
              [-8897477.25010739, 4137800.996146698],
              [-8914155.688499413, 4138052.281281022],
              [-8941274.18190995, 4138581.7152557713],
              [-8936375.726778697, 4190510.8945111088],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Warren',
        GEOID: '37185',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8718956.461519804, 4375516.708807429],
              [-8697715.866716163, 4375709.251461024],
              [-8688064.166787146, 4375762.829028816],
              [-8671763.18973574, 4375853.318018587],
              [-8671735.344718393, 4370230.320570458],
              [-8673120.047864372, 4353373.762466515],
              [-8683649.535859525, 4328539.30152408],
              [-8694973.622379962, 4329538.547073616],
              [-8697770.19062767, 4334576.467790953],
              [-8717091.469366696, 4337310.932030982],
              [-8713774.148541056, 4342826.83647512],
              [-8718956.461519804, 4375516.708807429],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '01073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9714509.431455811, 3963586.3017155738],
              [-9715028.514241382, 3965788.3046374368],
              [-9705478.192487247, 3969322.5886561396],
              [-9704769.755247837, 3977061.137665815],
              [-9691225.178844549, 3982752.778876365],
              [-9685459.719777381, 4000268.8070700816],
              [-9679637.599089403, 4004027.8077838505],
              [-9671876.738149768, 4007771.9583495334],
              [-9657991.30146567, 4007417.457863726],
              [-9645309.562435519, 3998363.6544815507],
              [-9637796.498682389, 3997333.061965908],
              [-9633895.752405502, 3997313.9133186922],
              [-9631004.228632146, 3967988.72407464],
              [-9631050.537540317, 3965082.699321592],
              [-9648552.076563345, 3957391.8060100265],
              [-9665937.843315948, 3939456.7781055593],
              [-9671717.662597425, 3939546.313647864],
              [-9682386.745234035, 3929362.7410513274],
              [-9687784.182064636, 3928063.1513656424],
              [-9692113.619700568, 3928122.783154081],
              [-9692115.400812421, 3931987.5217384696],
              [-9704805.822762854, 3938923.1765848123],
              [-9706485.299920453, 3940929.6722561857],
              [-9722833.34637988, 3957922.9225265565],
              [-9714509.431455811, 3963586.3017155738],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gilpin',
        GEOID: '08047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11766438.896072103, 4850187.714176815],
              [-11763776.022532837, 4856130.22169848],
              [-11732856.25472857, 4856479.9514133055],
              [-11732834.881386336, 4853291.1739157885],
              [-11732846.013335418, 4829257.4296597],
              [-11743859.295837559, 4830808.025156562],
              [-11765395.72112388, 4844457.99316865],
              [-11766438.896072103, 4850187.714176815],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'DeKalb',
        GEOID: '13089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9389586.539504701, 4008047.5247193733],
              [-9389609.582639296, 4009681.892894944],
              [-9389611.475070639, 4014162.354764108],
              [-9389509.840375545, 4024520.647416304],
              [-9381683.07829736, 4023112.0408879435],
              [-9377232.525055446, 4015978.797854546],
              [-9370109.970076019, 4009766.211335446],
              [-9359287.93445906, 3998965.635113676],
              [-9353476.94572016, 3995658.278719454],
              [-9363727.021793425, 3977177.6992499214],
              [-9371335.931628125, 3981387.9404621543],
              [-9378160.929608662, 3979325.209914931],
              [-9380546.39497687, 3981523.400728944],
              [-9382148.393768875, 3981555.6279373104],
              [-9389823.983978564, 3981622.088481779],
              [-9389586.539504701, 4008047.5247193733],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kendall',
        GEOID: '17093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9863122.064859742, 5119063.469979224],
              [-9841143.923833953, 5119467.199569661],
              [-9837895.621092606, 5119517.909327785],
              [-9825275.553060353, 5119822.471814399],
              [-9825200.189765086, 5119823.068420345],
              [-9825148.426201867, 5115526.529618378],
              [-9824754.800482424, 5100276.26289707],
              [-9824422.623121895, 5089453.965322708],
              [-9824193.416290352, 5080885.60469611],
              [-9862457.153541232, 5079989.603310198],
              [-9863156.239943415, 5105922.236851017],
              [-9863122.064859742, 5119063.469979224],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Buchanan',
        GEOID: '19019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10250483.613918837, 5257646.854859358],
              [-10197651.160949368, 5257936.961896685],
              [-10196529.283121154, 5205483.856375609],
              [-10222590.066471785, 5205883.43749344],
              [-10248602.871121883, 5205611.931200696],
              [-10248538.417136716, 5231376.778202669],
              [-10250483.613918837, 5257646.854859358],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kalkaska',
        GEOID: '26079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9499207.851465924, 5592031.504489928],
              [-9498635.669283247, 5598048.899744101],
              [-9445159.233059537, 5599199.936373015],
              [-9445562.209616208, 5544874.945403784],
              [-9499337.427353207, 5545067.57871081],
              [-9499207.851465924, 5592031.504489928],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morrison',
        GEOID: '27097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10536775.19166047, 5836402.264367127],
              [-10523557.337962657, 5829006.139656754],
              [-10511513.12565628, 5833767.184336504],
              [-10502067.66686247, 5824963.87215559],
              [-10507326.733566016, 5818597.978520081],
              [-10505731.52526295, 5805559.320532962],
              [-10442921.72897266, 5805477.681455855],
              [-10442917.164873539, 5777638.19285461],
              [-10437754.94612698, 5751893.176943718],
              [-10503340.38260071, 5751865.0631008055],
              [-10494286.100497548, 5744399.031673295],
              [-10521172.429191904, 5744266.88095597],
              [-10535720.773443677, 5744198.252734321],
              [-10536775.19166047, 5836402.264367127],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lawrence',
        GEOID: '01079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9743757.9597448, 4105203.7086318224],
              [-9734333.874293225, 4116787.8394969483],
              [-9732274.575033039, 4136738.0318384925],
              [-9723114.539413624, 4136259.631353579],
              [-9717958.331919571, 4130068.8420606884],
              [-9713814.018596828, 4131127.56956068],
              [-9709594.67593729, 4131750.8755015116],
              [-9696492.371870922, 4121296.25877836],
              [-9697053.199465537, 4071015.796698422],
              [-9697030.935567379, 4069061.7211218067],
              [-9743764.082316795, 4069775.7955498626],
              [-9743757.9597448, 4105203.7086318224],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hot Spring',
        GEOID: '05059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10398044.946051713, 4082214.9832766633],
              [-10346931.933937037, 4081189.990597261],
              [-10343259.281296786, 4096964.9240755835],
              [-10329691.43911992, 4096626.134258291],
              [-10323647.681325773, 4092612.088627392],
              [-10317654.351260953, 4092506.357894933],
              [-10317758.323665354, 4085469.3244951884],
              [-10315833.72098903, 4084560.4864101377],
              [-10316910.403103981, 4048910.342696705],
              [-10340053.947878886, 4049751.7524084942],
              [-10356958.591792278, 4049641.7131920336],
              [-10356613.167412348, 4060624.660835476],
              [-10374784.84976995, 4066102.680087654],
              [-10392435.890869113, 4066502.661878351],
              [-10398144.799634956, 4074483.831550173],
              [-10398044.946051713, 4082214.9832766633],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'De Baca',
        GEOID: '35011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11676495.6418179, 4075497.160033336],
              [-11676526.588636339, 4110253.3138293214],
              [-11626737.72186465, 4110324.453145406],
              [-11626756.980136557, 4122056.8415833525],
              [-11615045.056510197, 4122135.2313890797],
              [-11615055.29790335, 4133896.939613248],
              [-11591603.175499968, 4133934.210719929],
              [-11591573.898473889, 4110358.129518725],
              [-11571525.03554304, 4110338.789259856],
              [-11571217.90506794, 4039880.1742398725],
              [-11594548.355267884, 4039979.904067373],
              [-11594622.828007225, 4028186.120733479],
              [-11664735.739491006, 4028820.4219020326],
              [-11664771.918325514, 4040579.2422861885],
              [-11676677.315226873, 4040679.112655441],
              [-11676495.6418179, 4075497.160033336],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brown',
        GEOID: '17009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10120441.075330062, 4881133.025830563],
              [-10096212.276839416, 4881028.383011122],
              [-10086340.019117905, 4863277.227931058],
              [-10075944.225831194, 4864182.78861716],
              [-10075818.323487105, 4860898.871935571],
              [-10083726.014835097, 4848028.183681915],
              [-10082401.535533639, 4842620.968849814],
              [-10117837.646398878, 4842863.6628096895],
              [-10120806.87117681, 4843454.329820708],
              [-10120441.075330062, 4881133.025830563],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Reno',
        GEOID: '20155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10961941.285070924, 4603859.410621328],
              [-10933346.647470856, 4601876.200508479],
              [-10900642.316909682, 4603994.781755048],
              [-10876119.189685378, 4604009.083620796],
              [-10876133.438580198, 4566906.571838361],
              [-10875768.64460887, 4542065.42529976],
              [-10887917.051958632, 4541896.374588679],
              [-10961051.842339488, 4541730.282472354],
              [-10961053.62345134, 4552648.872002595],
              [-10961881.506504368, 4554662.705610295],
              [-10961941.285070924, 4603859.410621328],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Saline',
        GEOID: '31151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10839000.818675267, 4967990.036258845],
              [-10788360.691757483, 4967890.632560643],
              [-10788265.402273363, 4942328.3625335395],
              [-10788357.908770213, 4919763.468926818],
              [-10788645.892292894, 4916894.565452811],
              [-10839032.767369125, 4916991.701230458],
              [-10839000.818675267, 4967990.036258845],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Callaway',
        GEOID: '29027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10265481.354954943, 4680857.552523103],
              [-10256448.557513503, 4695048.43637353],
              [-10259482.570235075, 4702436.025018225],
              [-10253681.377611365, 4730872.421765165],
              [-10200649.996711848, 4730134.514998414],
              [-10202116.408364069, 4679274.208769116],
              [-10225237.021323867, 4674559.442662126],
              [-10242393.135966964, 4660391.740258107],
              [-10259389.39582128, 4661410.818458638],
              [-10265957.023139102, 4670686.435827808],
              [-10265481.354954943, 4680857.552523103],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Seneca',
        GEOID: '36099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8569522.901466917, 5290870.85248451],
              [-8567585.051771188, 5313974.690969649],
              [-8539741.820733974, 5315630.934859753],
              [-8542294.821935827, 5307450.166232142],
              [-8541726.647254817, 5269561.7655450255],
              [-8534480.527640611, 5254832.660055236],
              [-8525513.297379252, 5243712.56858575],
              [-8537832.580147378, 5243241.123591631],
              [-8559978.590965284, 5242447.426643256],
              [-8559951.095051058, 5259795.856689608],
              [-8565748.614131572, 5276184.151605816],
              [-8568416.16308945, 5276152.764221645],
              [-8569522.901466917, 5290870.85248451],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Choctaw',
        GEOID: '28019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9957979.295396032, 3952946.196138742],
              [-9949857.647986736, 3956562.619084479],
              [-9936542.612373462, 3964347.227784372],
              [-9917280.444284048, 3966293.3650469864],
              [-9917279.553728122, 3966202.019856784],
              [-9917303.376099152, 3954629.859500414],
              [-9917259.182261307, 3933327.8995482987],
              [-9919557.373148736, 3921622.5873537115],
              [-9931192.708965428, 3921553.9426782927],
              [-9931248.257391335, 3909834.2685506954],
              [-9942818.137347443, 3909763.6997613194],
              [-9942657.058044266, 3933268.374225802],
              [-9957952.356079262, 3933319.7763878917],
              [-9957979.295396032, 3952946.196138742],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Blaine',
        GEOID: '40011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10980209.370107554, 4323334.3176010195],
              [-10932747.748610388, 4323333.766051659],
              [-10932364.80956206, 4262866.671795066],
              [-10944194.286570698, 4262875.447613952],
              [-10944181.039551293, 4239085.810114399],
              [-10978678.727109147, 4239095.935135358],
              [-10979684.610027956, 4241071.177102527],
              [-10979662.346129796, 4274838.784789203],
              [-10980209.370107554, 4323334.3176010195],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Potter',
        GEOID: '48375',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11372705.53067949, 4248463.943151751],
              [-11312598.348986682, 4248485.99078215],
              [-11312614.045034884, 4188793.941434583],
              [-11373230.847356545, 4188809.740819917],
              [-11372705.53067949, 4248463.943151751],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Trinity',
        GEOID: '48455',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10623751.22488758, 3640296.575373994],
              [-10570688.451891657, 3683101.980922176],
              [-10559822.667714817, 3663300.262379422],
              [-10557868.565373434, 3651799.7533902023],
              [-10568575.27399793, 3638211.0814177413],
              [-10597635.561027985, 3609986.5959967356],
              [-10603446.995044848, 3620640.745994646],
              [-10611806.53220597, 3614522.049786248],
              [-10619511.733400207, 3614283.3141099107],
              [-10623701.576394685, 3624622.6564347497],
              [-10623751.22488758, 3640296.575373994],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rusk',
        GEOID: '55107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10190218.915146558, 5722464.141273413],
              [-10094312.164451065, 5722569.062008737],
              [-10094314.836118843, 5681212.712942518],
              [-10121762.882963741, 5681441.399977645],
              [-10121749.413305355, 5667618.300720731],
              [-10190333.35158309, 5667643.460628757],
              [-10190218.915146558, 5722464.141273413],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Vega Baja',
        GEOID: '72145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7397067.619207837, 2082921.4417878264],
              [-7395950.083663403, 2093984.1908518185],
              [-7393943.103740251, 2094822.9654985797],
              [-7385992.924268609, 2093716.7469360833],
              [-7385795.852848072, 2087886.8999154964],
              [-7389060.296915584, 2077881.5574435224],
              [-7391113.139645305, 2081108.1681367229],
              [-7396489.982370112, 2081022.6580796863],
              [-7397067.619207837, 2082921.4417878264],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wahkiakum',
        GEOID: '53069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13773177.32284494, 5842241.2035214575],
              [-13732186.925986568, 5842104.518378991],
              [-13721136.68541348, 5842013.019592554],
              [-13716559.450591043, 5842361.430104639],
              [-13715952.045942867, 5807810.068958266],
              [-13723485.304030236, 5803590.871680831],
              [-13732789.220900351, 5803815.846318794],
              [-13733645.099996468, 5803836.542308092],
              [-13740259.036222458, 5809535.1557123065],
              [-13739900.810101084, 5817178.880654696],
              [-13745691.0934147, 5823583.043446603],
              [-13753262.488581004, 5821969.290465832],
              [-13766825.877978237, 5823212.829972305],
              [-13770306.059218904, 5829405.924077845],
              [-13773327.249894029, 5827159.500588284],
              [-13773177.32284494, 5842241.2035214575],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crane',
        GEOID: '48103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11439997.494947081, 3717679.005921952],
              [-11389993.224960703, 3717628.3975594086],
              [-11388118.827374728, 3643950.4812753373],
              [-11397869.524212291, 3644073.1893337998],
              [-11402404.791586703, 3657911.798840213],
              [-11412815.167726705, 3666912.6795294425],
              [-11421455.118685136, 3667485.5710155317],
              [-11429851.6139172, 3675691.4391760337],
              [-11440010.741966484, 3670964.125869568],
              [-11439997.494947081, 3717679.005921952],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marshall',
        GEOID: '47117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9680432.420253666, 4220698.038125445],
              [-9668050.24197324, 4235527.854307141],
              [-9660529.83113372, 4260324.038074907],
              [-9657149.614795782, 4258932.935179614],
              [-9649862.863567436, 4260797.832104584],
              [-9644657.898136413, 4257487.324359951],
              [-9647410.606504751, 4230913.313506625],
              [-9642335.328280503, 4213922.241779636],
              [-9640209.793923296, 4213587.656576974],
              [-9640558.780526934, 4208410.183896453],
              [-9656620.624575533, 4198299.576855115],
              [-9665682.253765086, 4199771.779612587],
              [-9674381.871970579, 4206645.019021328],
              [-9680432.420253666, 4220698.038125445],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Randall',
        GEOID: '48381',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11373230.847356545, 4188809.740819917],
              [-11312614.045034884, 4188793.941434583],
              [-11313317.138938734, 4129640.312174257],
              [-11354420.302441278, 4129713.60682767],
              [-11373383.132419951, 4129608.880972733],
              [-11373230.847356545, 4188809.740819917],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lavaca',
        GEOID: '48285',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10820709.467865063, 3449754.665069488],
              [-10813869.55307276, 3455834.710436257],
              [-10783989.064034538, 3456424.456144879],
              [-10774962.166526113, 3449340.581463748],
              [-10749071.813315885, 3418409.573739703],
              [-10759971.215978947, 3409274.598925148],
              [-10791154.14305945, 3383698.0442063157],
              [-10795361.017936017, 3388895.436115281],
              [-10824719.307242926, 3424674.3531121],
              [-10820709.467865063, 3449754.665069488],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jasper',
        GEOID: '29097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10532866.653019225, 4461461.723962467],
              [-10532800.183216926, 4486383.456818987],
              [-10532790.57780251, 4489989.7286184905],
              [-10473169.5723305, 4487905.925352347],
              [-10473364.381439388, 4479725.579007759],
              [-10469855.591089584, 4479617.418193607],
              [-10470623.472937074, 4445817.195142795],
              [-10532839.033663152, 4447026.431282266],
              [-10532866.653019225, 4461461.723962467],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Warren',
        GEOID: '17187',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10106161.567648554, 5022487.420294706],
              [-10067670.515997473, 5021785.499080754],
              [-10068217.762614215, 4970375.293830053],
              [-10068347.67245997, 4957602.599458461],
              [-10106657.82993851, 4958762.424955499],
              [-10106161.567648554, 5022487.420294706],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '18107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9695099.765041098, 4897206.577455493],
              [-9650914.164838485, 4897142.5816082405],
              [-9650932.75519345, 4891938.2933746595],
              [-9650851.158006698, 4854725.764933713],
              [-9650857.391898183, 4846321.31704514],
              [-9685850.673829047, 4846591.0776398415],
              [-9694986.107840998, 4846672.29731584],
              [-9694926.440593934, 4859116.023277697],
              [-9695099.765041098, 4897206.577455493],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lee',
        GEOID: '28081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9887949.984849837, 4077886.0409834776],
              [-9883995.471258897, 4095454.227046677],
              [-9878098.098595142, 4097342.6300047506],
              [-9856422.412625838, 4097380.7255122433],
              [-9856459.148057802, 4091449.6452052956],
              [-9856600.85776958, 4040764.735729058],
              [-9875425.206301704, 4040791.215836727],
              [-9876149.896186769, 4038812.7703547613],
              [-9887900.670315417, 4038870.1565596336],
              [-9887949.984849837, 4077886.0409834776],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lowndes',
        GEOID: '28087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9870838.398003059, 3962683.6432259097],
              [-9854466.974450564, 3968663.6515044975],
              [-9848737.471578926, 3965124.7620182186],
              [-9853324.16855808, 3981929.791094005],
              [-9841373.241984988, 3985023.7226772644],
              [-9832307.271335293, 3994692.0554752643],
              [-9823765.556923106, 3994600.5643439675],
              [-9824439.877642967, 3988426.764466757],
              [-9826674.223550081, 3966400.132703268],
              [-9830005.608783722, 3933636.450681111],
              [-9870596.389430074, 3933450.280307811],
              [-9870838.398003059, 3962683.6432259097],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '39113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9404868.033922838, 4854104.673656777],
              [-9398248.420402816, 4854268.833060258],
              [-9368389.082067845, 4854754.795622694],
              [-9368338.543019027, 4849389.042358804],
              [-9356515.856499327, 4848491.936907939],
              [-9356819.090792248, 4844234.98034547],
              [-9361183.037470324, 4842478.747719406],
              [-9363549.355886117, 4804804.10423975],
              [-9391494.666896388, 4806466.615080445],
              [-9404182.973776497, 4806687.774387179],
              [-9404868.033922838, 4854104.673656777],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Phelps',
        GEOID: '31137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11092259.450718904, 4965976.610920238],
              [-11070100.081562104, 4964946.2744547175],
              [-11067084.993153969, 4963909.001541798],
              [-11062489.724574022, 4962945.802673774],
              [-11040583.384619797, 4962399.74345183],
              [-11040600.639140869, 4917033.915423378],
              [-11090811.96338012, 4917098.0404431615],
              [-11092119.96739694, 4917109.726140935],
              [-11092259.450718904, 4965976.610920238],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '17181',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9963293.804716287, 4517298.616895901],
              [-9962843.503632458, 4518856.084294799],
              [-9957901.928349933, 4523099.717332788],
              [-9924540.924112568, 4523138.215471496],
              [-9912043.41883968, 4522591.246095303],
              [-9912420.346635507, 4485183.336250421],
              [-9935090.783574536, 4485920.164929136],
              [-9960164.434053719, 4485884.449625278],
              [-9955100.016766666, 4488867.575918452],
              [-9954850.104509834, 4496056.204837063],
              [-9959888.53598263, 4504328.10268995],
              [-9964474.787683822, 4513215.022970445],
              [-9963293.804716287, 4517298.616895901],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chambers',
        GEOID: '01017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9528188.879018534, 3909560.2354510087],
              [-9488031.931187732, 3909657.913825063],
              [-9482875.211823193, 3878079.6490373826],
              [-9482684.031530535, 3876910.5490077315],
              [-9480075.036624812, 3872320.104439601],
              [-9476019.692371696, 3862383.1607962083],
              [-9493887.55904244, 3859617.3057595496],
              [-9526160.303937808, 3860360.4993199594],
              [-9528185.984711774, 3859326.0491172364],
              [-9528188.879018534, 3909560.2354510087],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Columbia',
        GEOID: '13073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9175545.541428555, 3981985.9567349534],
              [-9162512.032807495, 3988648.4780788887],
              [-9152236.393854856, 3986951.812153611],
              [-9150433.979375917, 3982919.6838038363],
              [-9146221.76116379, 3976639.948468124],
              [-9144056.427250078, 3975939.105587174],
              [-9140961.451977186, 3974937.444293974],
              [-9140024.82775031, 3974634.331328763],
              [-9131341.684829453, 3967860.2345457436],
              [-9159682.736629494, 3943545.2063431176],
              [-9160946.101530507, 3942470.988199738],
              [-9176853.879403846, 3968608.752904611],
              [-9175545.541428555, 3981985.9567349534],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jersey',
        GEOID: '17083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10083384.820595816, 4748190.906123562],
              [-10053656.282662528, 4746666.521803026],
              [-10053716.395187555, 4753959.944994198],
              [-10035237.137076888, 4759262.992322826],
              [-10035005.815175021, 4721678.161687554],
              [-10049220.75755187, 4721578.036364703],
              [-10049543.33049222, 4710124.077245801],
              [-10052006.52780897, 4710704.49625666],
              [-10062816.206962451, 4715948.831249918],
              [-10068955.91557778, 4716143.24567765],
              [-10070825.644325027, 4717261.842052073],
              [-10078271.91638368, 4715728.652643595],
              [-10085943.165133225, 4738529.642163749],
              [-10083384.820595816, 4748190.906123562],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sanilac',
        GEOID: '26151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9252920.157255253, 5361885.270541101],
              [-9251110.102334954, 5363592.752168815],
              [-9252636.069914749, 5415360.543740945],
              [-9195711.18772674, 5417662.794678007],
              [-9194298.088889116, 5400900.042715529],
              [-9188302.977712445, 5376484.669016774],
              [-9186427.912209522, 5346337.239992782],
              [-9184530.627887838, 5337704.501178072],
              [-9239101.066987667, 5335456.777183543],
              [-9239565.603222746, 5355439.54996237],
              [-9252767.760872357, 5355251.000041263],
              [-9252920.157255253, 5361885.270541101],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cape Girardeau',
        GEOID: '29031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10003294.454471724, 4522972.000070488],
              [-9974496.770120448, 4523497.210415242],
              [-9963293.804716287, 4517298.616895901],
              [-9964474.787683822, 4513215.022970445],
              [-9959888.53598263, 4504328.10268995],
              [-9954850.104509834, 4496056.204837063],
              [-9955100.016766666, 4488867.575918452],
              [-9960164.434053719, 4485884.449625278],
              [-9962555.639662545, 4484476.2364589935],
              [-9964990.419565175, 4478475.990563116],
              [-9961189.669877445, 4475542.638393862],
              [-9976481.262682822, 4471635.05455547],
              [-9992617.57947076, 4456693.359558862],
              [-10003907.156949049, 4456715.838230921],
              [-10003294.454471724, 4522972.000070488],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dare',
        GEOID: '37055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8461210.595397932, 4286293.343688296],
              [-8457292.594599973, 4297407.960625803],
              [-8442475.302458445, 4304589.611645589],
              [-8434263.708900586, 4308461.262558896],
              [-8439476.578015456, 4331426.646570506],
              [-8434750.337886754, 4332602.433685118],
              [-8428923.712927235, 4316274.033388983],
              [-8422269.813004047, 4303432.872792343],
              [-8412390.98743258, 4281828.066276338],
              [-8406737.738412134, 4268894.440797553],
              [-8404185.850405188, 4263329.468737136],
              [-8400019.49582327, 4245254.774549277],
              [-8403148.909348449, 4217233.285557321],
              [-8408364.89540906, 4194612.364551273],
              [-8419704.566658206, 4193854.030482372],
              [-8432402.605529271, 4189134.3635500553],
              [-8439578.212710548, 4232063.348511245],
              [-8449298.741966108, 4255164.769044236],
              [-8463340.248576298, 4255150.655423509],
              [-8461210.595397932, 4286293.343688296],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Polk',
        GEOID: '47139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9437203.081142034, 4162241.9793702164],
              [-9428753.857062351, 4187140.1701438683],
              [-9429162.399593562, 4196686.363836771],
              [-9425131.632151429, 4200366.769327022],
              [-9405999.26258828, 4202743.639415848],
              [-9390569.713247387, 4195682.296804045],
              [-9387096.433815146, 4193733.710198009],
              [-9382741.212218596, 4191878.1390697416],
              [-9386667.51981712, 4162305.949129048],
              [-9407504.636062277, 4162254.99546098],
              [-9420020.397731656, 4162295.214870235],
              [-9431814.809100695, 4162253.22907134],
              [-9437203.081142034, 4162241.9793702164],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Livingston',
        GEOID: '22063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10128500.272505023, 3578859.794055776],
              [-10120132.942979546, 3587298.3359017507],
              [-10081890.690390388, 3587380.8906221977],
              [-10081861.190725328, 3571359.814700207],
              [-10079547.749067662, 3558979.4861781285],
              [-10071492.893352842, 3548005.641139114],
              [-10072836.074328754, 3539204.503421794],
              [-10080441.53325924, 3528720.865483212],
              [-10084657.647653546, 3530356.1562803504],
              [-10089198.369683003, 3532041.7724660756],
              [-10096071.569003053, 3526085.343139359],
              [-10111233.061010115, 3544572.218077934],
              [-10118020.878280725, 3548005.38315558],
              [-10129130.674781386, 3563051.441911777],
              [-10128500.272505023, 3578859.794055776],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fleming',
        GEOID: '21069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9343083.601462247, 4649203.5054356605],
              [-9335172.34789055, 4644094.583450474],
              [-9310968.37364635, 4653912.7088782815],
              [-9304262.598840455, 4640528.520359337],
              [-9289928.544608459, 4633502.497188282],
              [-9295974.528792422, 4617559.876520564],
              [-9302339.220678529, 4610070.327838599],
              [-9310227.31979614, 4605950.781317071],
              [-9311537.550202776, 4603654.941271331],
              [-9320268.11522671, 4620840.971026022],
              [-9333956.182453634, 4621460.095846947],
              [-9332981.246353267, 4627336.75719802],
              [-9341500.972261637, 4630428.889510829],
              [-9348618.40654449, 4641692.435770236],
              [-9343083.601462247, 4649203.5054356605],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Livingston',
        GEOID: '29117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10437535.090132665, 4860066.226093693],
              [-10393005.512703503, 4861235.987726898],
              [-10393322.884571753, 4822992.634301963],
              [-10382431.38559254, 4822957.763695704],
              [-10381810.000194931, 4811344.522167501],
              [-10383670.37152507, 4810243.173008096],
              [-10437132.558853954, 4809632.649187686],
              [-10437203.246730609, 4834700.851974778],
              [-10437535.090132665, 4860066.226093693],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hickory',
        GEOID: '29085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10416021.040063994, 4567413.542222251],
              [-10409719.688968148, 4567218.398728613],
              [-10408811.65588175, 4589760.796533616],
              [-10359970.563254673, 4588255.763803802],
              [-10360777.406923942, 4565679.391184492],
              [-10373051.382659316, 4565893.410753945],
              [-10373631.245886859, 4551596.523891838],
              [-10415420.360091671, 4553046.92939139],
              [-10416521.198536128, 4555161.327391436],
              [-10416021.040063994, 4567413.542222251],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wood',
        GEOID: '39173',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9337838.894973012, 5073674.354997371],
              [-9334613.524046768, 5073666.636269176],
              [-9322697.551793784, 5081353.54305643],
              [-9315224.34041836, 5093340.961968042],
              [-9304977.381290836, 5101389.859087082],
              [-9302483.268099615, 5103863.8710784605],
              [-9285820.076161752, 5104093.632038972],
              [-9285673.691031357, 5086407.537657359],
              [-9286254.444814827, 5049879.548083441],
              [-9286389.252718177, 5036972.886818658],
              [-9337606.793834709, 5037127.269105224],
              [-9337838.894973012, 5073674.354997371],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Okfuskee',
        GEOID: '40107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10756230.7697688, 4226940.186003255],
              [-10755761.335476125, 4251062.034761708],
              [-10708107.131259887, 4251073.26664902],
              [-10708138.4120368, 4239137.666739297],
              [-10696444.410848457, 4239167.357845972],
              [-10696414.911183398, 4215215.902997696],
              [-10684590.220912864, 4215209.213138883],
              [-10684597.90195773, 4203347.381260066],
              [-10735803.977166709, 4203377.79424807],
              [-10735795.294246426, 4227624.393834749],
              [-10746418.290613847, 4217113.119766325],
              [-10756100.971242538, 4218471.88892966],
              [-10756230.7697688, 4226940.186003255],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Winchester',
        GEOID: '51840',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8703825.41432937, 4751060.0727909645],
              [-8698220.255328948, 4748176.83162159],
              [-8703368.893097626, 4740498.525476622],
              [-8703234.975750204, 4741270.915763534],
              [-8704808.922030529, 4742053.986323476],
              [-8703825.41432937, 4751060.0727909645],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Taylor',
        GEOID: '48441',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11148262.171466675, 3832132.6733264555],
              [-11093718.515284732, 3831848.42955298],
              [-11090714.00222822, 3831058.5765485945],
              [-11090918.162174337, 3773983.837115611],
              [-11100108.476695249, 3774090.9140253416],
              [-11148859.734493254, 3774163.04367206],
              [-11148262.171466675, 3832132.6733264555],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tyler',
        GEOID: '54095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9025333.469580907, 4794941.169262824],
              [-9021038.21170263, 4799039.123194236],
              [-9010620.595121743, 4808985.173393696],
              [-8999779.301232876, 4808142.11607652],
              [-8987275.562068503, 4792328.914972581],
              [-8974424.728731837, 4786390.7932860665],
              [-8984966.127912506, 4783489.921752033],
              [-9004493.792987462, 4763915.337886819],
              [-9006240.841075972, 4775979.800998577],
              [-9017751.053785015, 4772063.665991434],
              [-9020210.769253584, 4788895.225931264],
              [-9030378.898163617, 4787446.473703568],
              [-9025333.469580907, 4794941.169262824],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calumet',
        GEOID: '55015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9841096.056452911, 5503295.5664239],
              [-9817556.548249258, 5502960.70057733],
              [-9800928.644589974, 5502816.346880006],
              [-9800767.676606288, 5448696.540615095],
              [-9814179.448857062, 5448668.581479427],
              [-9814110.43077277, 5455803.543088721],
              [-9841109.080833334, 5455883.466479493],
              [-9841096.056452911, 5503295.5664239],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Polk',
        GEOID: '31143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10890191.64311401, 5037957.63365664],
              [-10871300.50288741, 5057413.268474071],
              [-10865267.988361832, 5058745.415787009],
              [-10864587.826273084, 5061601.5042279335],
              [-10856145.24477183, 5065874.317743488],
              [-10838976.884984748, 5070989.946118271],
              [-10838969.315259375, 5019268.803715899],
              [-10889972.455036638, 5019214.780451984],
              [-10890191.64311401, 5037957.63365664],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scotts Bluff',
        GEOID: '31157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11583129.869819256, 5143837.91750163],
              [-11583100.496734697, 5161236.835418615],
              [-11510617.8006699, 5161509.733632468],
              [-11506354.041533533, 5161418.353945097],
              [-11506274.225458635, 5122641.252781885],
              [-11507139.289221589, 5116028.5107904505],
              [-11583107.520788291, 5115841.230582752],
              [-11583129.869819256, 5143837.91750163],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Boone',
        GEOID: '05009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10386389.016129224, 4367216.246505097],
              [-10385379.053978251, 4369399.4686257625],
              [-10366735.448710179, 4369342.917536128],
              [-10336465.465573732, 4369366.788539354],
              [-10339849.120015826, 4368354.507913483],
              [-10340544.866833283, 4316337.144762474],
              [-10346552.891070887, 4316473.7036012],
              [-10362314.506452816, 4317111.735945643],
              [-10382229.785994714, 4317189.184332878],
              [-10386199.772994876, 4317359.379800574],
              [-10386389.016129224, 4367216.246505097],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pinellas',
        GEOID: '12103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9223864.540749427, 3270698.520628292],
              [-9200685.601270834, 3270836.282800903],
              [-9200622.928397516, 3267258.2127114274],
              [-9200424.223106451, 3246348.865371527],
              [-9192030.95613962, 3237505.608474865],
              [-9191247.436269354, 3228355.408821725],
              [-9193489.241469013, 3225883.824751472],
              [-9197519.452313691, 3221248.4222521125],
              [-9197775.153184043, 3215315.736897724],
              [-9200836.55050035, 3211241.632571737],
              [-9206680.378489034, 3201815.5579891666],
              [-9209803.892081201, 3200265.4628347284],
              [-9210404.01545607, 3208500.6332545215],
              [-9211267.409426663, 3215139.6648923247],
              [-9216165.578341056, 3222725.011568635],
              [-9222433.0883117, 3230616.866761213],
              [-9221804.801105661, 3241053.6629669275],
              [-9220407.674122877, 3251373.44274142],
              [-9220388.928502262, 3251511.959238168],
              [-9222917.884694103, 3261896.667906271],
              [-9223864.540749427, 3270698.520628292],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Teton',
        GEOID: '16081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12400855.575911399, 5453516.97723312],
              [-12377308.720621353, 5454942.6715472415],
              [-12361719.893460823, 5462878.495605629],
              [-12361641.504167615, 5451274.089152033],
              [-12361596.419773843, 5417262.334244362],
              [-12361512.992602644, 5388550.635043125],
              [-12379569.06288191, 5395122.228370369],
              [-12383607.511368906, 5407108.338701582],
              [-12400965.11429034, 5407127.253116894],
              [-12400855.575911399, 5453516.97723312],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morton',
        GEOID: '20129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11359254.57396796, 4443998.033847073],
              [-11359261.587095879, 4453969.047236944],
              [-11359259.360706063, 4475152.871242457],
              [-11359256.635924859, 4493494.595222321],
              [-11305229.666613111, 4493395.812146244],
              [-11305079.702415371, 4438450.425239011],
              [-11343727.731392112, 4438228.963623774],
              [-11357727.73709927, 4438151.3522242615],
              [-11359290.196205013, 4438142.690503197],
              [-11359254.57396796, 4443998.033847073],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hillsdale',
        GEOID: '26059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9442841.783900203, 5171840.987826764],
              [-9429824.639244292, 5171525.764394775],
              [-9391279.263681704, 5171989.1554441415],
              [-9390958.890795527, 5117183.433045464],
              [-9395314.793981038, 5117029.175793959],
              [-9399602.622008316, 5116877.331738036],
              [-9440569.864412602, 5115563.204513563],
              [-9440547.711833935, 5125128.364030064],
              [-9442690.087035272, 5125125.827998392],
              [-9442841.783900203, 5171840.987826764],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Steuben',
        GEOID: '36101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8652978.56711718, 5221681.069813782],
              [-8652080.775423933, 5231828.76623925],
              [-8651819.508579042, 5241469.788955103],
              [-8645218.040136019, 5241469.940027123],
              [-8645062.41548789, 5248322.336215122],
              [-8626246.304598084, 5247850.50952049],
              [-8622321.513311185, 5247791.098220815],
              [-8612399.941055253, 5247711.430220893],
              [-8587607.977260685, 5247787.167715466],
              [-8583534.574453576, 5233723.729459383],
              [-8582694.55757605, 5201864.764875155],
              [-8567707.725850042, 5202788.365595311],
              [-8567785.734032592, 5161096.793550894],
              [-8572450.715394272, 5161106.4711836055],
              [-8639507.919599187, 5160852.09716457],
              [-8655082.719797364, 5160793.01686994],
              [-8652978.56711718, 5221681.069813782],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Knox',
        GEOID: '39083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9211123.584644556, 4916876.453022776],
              [-9200166.629804756, 4916215.226057604],
              [-9197618.081382535, 4946173.919652004],
              [-9169931.69950785, 4946319.252497573],
              [-9165708.683305116, 4946924.340812835],
              [-9152700.778166939, 4948859.262302272],
              [-9148132.114945292, 4949578.233090013],
              [-9148748.602285307, 4932470.878546499],
              [-9150006.957809232, 4900744.487246694],
              [-9181328.032377811, 4901727.278603629],
              [-9211771.01880301, 4906276.606567866],
              [-9211123.584644556, 4916876.453022776],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nowata',
        GEOID: '40105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10665500.3753952, 4431015.666093434],
              [-10662933.55619158, 4439005.16305248],
              [-10639204.262641028, 4439010.610585308],
              [-10633506.547317008, 4439011.97472434],
              [-10620727.676852377, 4439015.034224298],
              [-10623411.70044066, 4431133.498305729],
              [-10623393.778002642, 4383156.540271199],
              [-10665477.777538566, 4383147.666252489],
              [-10665500.3753952, 4431015.666093434],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '47181',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9798869.34532979, 4217322.72799158],
              [-9793183.034420578, 4219050.406773736],
              [-9796973.351762598, 4221566.821461922],
              [-9794878.875543324, 4225704.728790167],
              [-9764674.00150893, 4229761.621671421],
              [-9756696.512840213, 4228312.334896605],
              [-9748843.590681693, 4218162.156742509],
              [-9748553.93736665, 4170548.978561362],
              [-9752266.205012854, 4164359.4439037023],
              [-9754373.163747866, 4164388.319523372],
              [-9779627.214748718, 4164649.7984387847],
              [-9794436.051473489, 4164684.3353606374],
              [-9794065.241385115, 4204135.554756232],
              [-9798869.34532979, 4217322.72799158],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morgan',
        GEOID: '54065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8734233.11247599, 4797297.210864847],
              [-8731698.145031644, 4802716.029372906],
              [-8725551.082750041, 4811198.988563185],
              [-8719966.07497072, 4812106.851742902],
              [-8717766.956036828, 4812464.349082444],
              [-8707975.516265633, 4816494.480167269],
              [-8692077.423187993, 4818271.451851939],
              [-8685995.939237695, 4810969.197531255],
              [-8698386.677967682, 4807088.213732129],
              [-8708426.864950242, 4777786.316945934],
              [-8721557.829976304, 4788645.331323461],
              [-8733014.498010274, 4794519.861703846],
              [-8735047.814745033, 4797331.4538835],
              [-8734233.11247599, 4797297.210864847],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cobb',
        GEOID: '13067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9432972.754443925, 4039468.361133688],
              [-9424223.599065026, 4039312.5910650897],
              [-9420324.522580503, 4039788.2407794218],
              [-9414476.687090151, 4039051.724654432],
              [-9408214.743094048, 4039374.1461955192],
              [-9397471.966954533, 4038648.408188438],
              [-9392553.426573323, 4026909.971752049],
              [-9400119.255765088, 4015589.305839625],
              [-9402058.552614199, 4008920.2399881235],
              [-9401542.47545488, 4005570.212086408],
              [-9404285.499027517, 4004298.7285107137],
              [-9415194.586486276, 3994413.061426648],
              [-9420198.954194888, 4002619.578716838],
              [-9431448.011378529, 4002804.9925762573],
              [-9431458.141452191, 4015864.658152211],
              [-9433173.129527353, 4021768.4230676703],
              [-9432972.754443925, 4039468.361133688],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '13305',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9143005.184477318, 3733602.9961534883],
              [-9137120.502235513, 3740674.6720268796],
              [-9133606.368550152, 3740632.876879483],
              [-9126299.24585499, 3735108.933926862],
              [-9124753.129447361, 3735687.7876618686],
              [-9111569.784791697, 3719765.9016908216],
              [-9094999.878587117, 3708947.668502703],
              [-9092786.624471165, 3703315.205983782],
              [-9090706.508466203, 3702904.683584229],
              [-9085012.293873146, 3693861.5437311656],
              [-9086374.399162492, 3691718.26920249],
              [-9093901.934449423, 3684874.782321865],
              [-9098330.557751652, 3675686.747573472],
              [-9106051.454994092, 3680077.960631572],
              [-9119653.138296159, 3677749.5315767243],
              [-9132776.70438527, 3681379.6333931587],
              [-9135254.453611346, 3693464.390325348],
              [-9142980.805508835, 3694103.914147525],
              [-9143005.184477318, 3733602.9961534883],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marshall',
        GEOID: '17123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9978515.292418594, 5033208.879064004],
              [-9978504.271789007, 5034283.569366668],
              [-9959320.806579582, 5034273.664524151],
              [-9944088.849334847, 5034185.999717423],
              [-9947335.704922816, 5027671.455931248],
              [-9925494.820829175, 5027693.172674256],
              [-9912761.986152751, 5027809.143859522],
              [-9912746.62406302, 5001395.819488675],
              [-9925246.133086743, 5001592.80693166],
              [-9960014.215687735, 5000726.50449813],
              [-9957271.637393061, 5008396.25549679],
              [-9978537.444997262, 5008464.225546851],
              [-9978515.292418594, 5033208.879064004],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Decatur',
        GEOID: '18031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9538356.57866861, 4771937.847390791],
              [-9532358.127907217, 4771960.304600014],
              [-9532213.07861071, 4786733.187467005],
              [-9495282.61490106, 4786808.876178029],
              [-9495167.39922809, 4760175.14350285],
              [-9511143.304629795, 4749730.890073766],
              [-9525199.1714543, 4740706.3273894],
              [-9538609.05127373, 4740433.372994302],
              [-9538356.57866861, 4771937.847390791],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Butler',
        GEOID: '19023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10355511.661050947, 5297910.43228002],
              [-10303087.639293198, 5297844.016507972],
              [-10303118.920070112, 5257685.898478405],
              [-10303097.546727879, 5244610.796959012],
              [-10355718.27002586, 5244755.271016164],
              [-10355511.661050947, 5297910.43228002],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greenwood',
        GEOID: '20073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10744866.942190152, 4591634.1923476355],
              [-10726534.514487844, 4591555.980087193],
              [-10726443.00986641, 4603845.675364937],
              [-10682091.65494201, 4603601.983803768],
              [-10682112.137728315, 4585105.575435539],
              [-10682315.852396466, 4541959.574741729],
              [-10682329.878652306, 4523600.766238161],
              [-10745147.24466797, 4524057.9978356995],
              [-10744866.942190152, 4591634.1923476355],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '39169',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9142595.64007069, 5011133.273315779],
              [-9125680.309486179, 5010861.026387424],
              [-9093521.22179091, 5010658.837095315],
              [-9088979.163927564, 5010654.855291512],
              [-9088984.28462414, 4999667.304041713],
              [-9089012.782413783, 4986677.528329742],
              [-9089241.432647873, 4963511.558615706],
              [-9142246.653467054, 4963527.99611249],
              [-9142595.64007069, 5011133.273315779],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Woodward',
        GEOID: '40153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11088040.775976311, 4382492.811716586],
              [-11053497.447427232, 4382821.412518326],
              [-11053489.543743387, 4413986.367509821],
              [-11048502.096597375, 4409182.865334023],
              [-11036198.175918978, 4408908.353594197],
              [-11016173.803276101, 4383357.73288947],
              [-11016213.989612276, 4370598.016100842],
              [-11015714.72169607, 4322876.954958447],
              [-11063161.871659432, 4323252.550715461],
              [-11086984.799286647, 4323219.458053969],
              [-11088040.775976311, 4382492.811716586],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clark',
        GEOID: '46025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10907283.192452446, 5645687.017304798],
              [-10853010.710550075, 5645424.354691377],
              [-10852686.993470848, 5590723.386028181],
              [-10852789.40740238, 5549998.912663789],
              [-10892949.24953994, 5550079.195244302],
              [-10893305.249271497, 5563643.696690557],
              [-10906837.803169781, 5563710.021490505],
              [-10907283.192452446, 5645687.017304798],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Trousdale',
        GEOID: '47169',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9603397.551512871, 4363119.588081537],
              [-9598905.364781396, 4367905.751825223],
              [-9592206.937061895, 4361928.881262986],
              [-9571126.587729353, 4359407.852802159],
              [-9570931.778620465, 4356503.315593237],
              [-9582481.955026703, 4349630.143851867],
              [-9588705.04852052, 4341407.851990697],
              [-9596470.362239785, 4347873.736808592],
              [-9602913.089088935, 4341940.864350882],
              [-9605008.121905666, 4348542.790706995],
              [-9603397.551512871, 4363119.588081537],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bee',
        GEOID: '48025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10909894.747706456, 3336279.166586472],
              [-10899859.740889404, 3340011.668376724],
              [-10884656.170114823, 3333460.7813558634],
              [-10875532.647288388, 3317422.3749553785],
              [-10860162.097277615, 3313940.194208442],
              [-10859368.723266732, 3305883.709541339],
              [-10839799.869980182, 3298066.919608773],
              [-10858222.355150543, 3269750.6908261795],
              [-10861273.733712677, 3265354.2846510424],
              [-10889018.335681047, 3271288.628014051],
              [-10888022.916794375, 3272117.9669186124],
              [-10919302.580512377, 3332820.345654379],
              [-10909894.747706456, 3336279.166586472],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fisher',
        GEOID: '48151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11204960.193753941, 3890456.0873814696],
              [-11189747.049503151, 3890384.04325031],
              [-11148004.021567525, 3889992.916357238],
              [-11148262.171466675, 3832132.6733264555],
              [-11205489.629252153, 3832465.2458669282],
              [-11204960.193753941, 3890456.0873814696],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Angelina',
        GEOID: '48005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10575723.989057694, 3688159.9818279096],
              [-10560418.894907506, 3701369.9511732315],
              [-10545148.309799468, 3692272.094058885],
              [-10524714.726708435, 3688961.654301116],
              [-10523182.85919563, 3684616.031736305],
              [-10519232.57574534, 3685553.5069231554],
              [-10514061.56275901, 3674551.5628176373],
              [-10508116.545353197, 3672078.393953208],
              [-10500390.861372652, 3661972.2565293526],
              [-10488410.769092971, 3655271.4042084254],
              [-10478462.70279823, 3645649.2643475845],
              [-10514995.978564728, 3637077.7856730614],
              [-10522656.206684686, 3639987.8221242544],
              [-10526587.34318256, 3640407.551700265],
              [-10527893.343448546, 3641639.5338097177],
              [-10546252.042550683, 3646222.597877685],
              [-10557868.565373434, 3651799.7533902023],
              [-10559822.667714817, 3663300.262379422],
              [-10570688.451891657, 3683101.980922176],
              [-10572759.884976339, 3685999.184957143],
              [-10575723.989057694, 3688159.9818279096],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sheridan',
        GEOID: '56033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12012655.76750493, 5621764.561393207],
              [-11950307.74804415, 5621742.992265665],
              [-11898803.781877808, 5620873.686922886],
              [-11829222.653894704, 5620543.655097926],
              [-11829208.283387234, 5620543.586938091],
              [-11802635.656249763, 5621141.163908156],
              [-11800943.151479915, 5553138.427231959],
              [-11844469.183699574, 5552817.818044538],
              [-11847610.619729763, 5552012.907579222],
              [-11952331.536386773, 5552490.970806028],
              [-11979746.187384432, 5574618.75426308],
              [-11994747.379324751, 5577954.488008632],
              [-12003838.842137838, 5588546.902597165],
              [-12009331.679772053, 5619232.751143294],
              [-12012655.76750493, 5621764.561393207],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Reagan',
        GEOID: '48383',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11329630.453717032, 3717627.35139393],
              [-11273004.455140311, 3717566.5431802394],
              [-11273061.005441634, 3705229.156875939],
              [-11273096.293720217, 3701601.369820842],
              [-11273859.054871133, 3643062.3140519294],
              [-11329673.756998952, 3643114.9549947577],
              [-11329630.453717032, 3717627.35139393],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Richmond',
        GEOID: '51159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8564583.099062966, 4590319.5129530495],
              [-8557915.39552292, 4597008.353283827],
              [-8545409.09601026, 4579705.382969689],
              [-8530883.46093461, 4574712.822986048],
              [-8522179.612588463, 4569756.961741016],
              [-8516812.45465936, 4556680.594110714],
              [-8523147.31292193, 4556465.495640603],
              [-8534662.980286023, 4548166.317634192],
              [-8547527.394600565, 4564671.005008017],
              [-8561473.83436562, 4577797.844808517],
              [-8564583.099062966, 4590319.5129530495],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wirt',
        GEOID: '54105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9081605.138218435, 4725422.183738116],
              [-9064179.073810166, 4741125.101408239],
              [-9050053.8549429, 4748288.13561708],
              [-9044736.679465158, 4726696.8681063475],
              [-9034963.16213198, 4726056.854755363],
              [-9047234.466199577, 4712556.635462249],
              [-9047871.436325897, 4709484.326808687],
              [-9055162.751653364, 4706732.902090819],
              [-9066766.361415183, 4713316.163199248],
              [-9072831.0472736, 4709921.413336892],
              [-9076121.428782469, 4722452.268386091],
              [-9081605.138218435, 4725422.183738116],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Platte',
        GEOID: '56031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11720440.791920397, 5252165.708418794],
              [-11676572.67490553, 5252636.541203568],
              [-11673424.114427932, 5252785.675929085],
              [-11650212.442124663, 5252716.553354062],
              [-11649956.295976348, 5109142.464465732],
              [-11719519.623134082, 5109685.978850002],
              [-11718804.172766754, 5122414.6276993],
              [-11720151.249924844, 5225822.0341930315],
              [-11720440.791920397, 5252165.708418794],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Freestone',
        GEOID: '48161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10741964.954384662, 3736587.16125237],
              [-10692769.197859919, 3764954.9716230896],
              [-10692547.226795277, 3764084.4623764795],
              [-10693592.071535861, 3757580.9371475265],
              [-10689174.802821696, 3757739.562744537],
              [-10684507.955809167, 3735064.014986351],
              [-10672860.486167977, 3731259.212782949],
              [-10671226.872640586, 3722353.2765246877],
              [-10663748.317929601, 3718803.1674460764],
              [-10662993.460462535, 3713321.3124520457],
              [-10713012.535941184, 3686553.1422040476],
              [-10741964.954384662, 3736587.16125237],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Webster',
        GEOID: '28155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9963888.690564793, 3991509.997757188],
              [-9931531.899453877, 3991531.411992185],
              [-9928783.643865172, 3993756.4347198736],
              [-9911274.980394734, 3993867.2754931566],
              [-9911322.402497811, 3982531.981285237],
              [-9909476.614020968, 3978575.0596856247],
              [-9909506.670283483, 3970155.096608654],
              [-9917260.072817234, 3970145.0773015274],
              [-9917280.444284048, 3966293.3650469864],
              [-9936542.612373462, 3964347.227784372],
              [-9949857.647986736, 3956562.619084479],
              [-9963817.557410179, 3956495.7689782083],
              [-9963859.413538717, 3985593.9699783637],
              [-9963888.690564793, 3991509.997757188],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cheyenne',
        GEOID: '20023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11360348.176645512, 4866389.576156573],
              [-11335904.308898652, 4866368.504224215],
              [-11303634.12435157, 4866321.419516383],
              [-11289024.107744023, 4866317.578571956],
              [-11289345.154513346, 4803414.509025581],
              [-11360149.789486405, 4803388.2239183355],
              [-11360153.159997463, 4804236.963398499],
              [-11360293.630095022, 4839673.448856641],
              [-11360348.176645512, 4866389.576156573],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '31179',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10838925.455380002, 5213833.110333518],
              [-10799970.869369257, 5213755.686367948],
              [-10799964.3015193, 5200675.906190763],
              [-10778295.628677918, 5200651.6882980345],
              [-10778231.063373256, 5200651.6882980345],
              [-10778361.641135957, 5174532.209241114],
              [-10800145.640969802, 5174557.110679799],
              [-10839001.152633741, 5174608.863878299],
              [-10838925.455380002, 5213833.110333518],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lancaster',
        GEOID: '31109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10788360.691757483, 4967890.632560643],
              [-10788088.626921983, 4970262.794929921],
              [-10788076.493097488, 5019146.14477138],
              [-10787805.652776387, 5019142.454694765],
              [-10738308.777029047, 5018993.671973393],
              [-10738307.886473121, 5014712.126678482],
              [-10738297.088482514, 4980527.848125025],
              [-10738282.39430973, 4942238.737745191],
              [-10788265.402273363, 4942328.3625335395],
              [-10788360.691757483, 4967890.632560643],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Renville',
        GEOID: '38075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11356998.684487032, 6242194.811074998],
              [-11356942.404097514, 6274650.418593211],
              [-11312892.009803394, 6274720.22219324],
              [-11298565.080018809, 6274716.291475208],
              [-11298559.180085797, 6227497.272594994],
              [-11293504.273328366, 6198188.555456567],
              [-11249909.890941355, 6198063.787672445],
              [-11249925.69830905, 6183465.974510962],
              [-11336996.130464355, 6183650.120482855],
              [-11337015.277416768, 6227508.240233033],
              [-11356973.414962621, 6227531.862886175],
              [-11356998.684487032, 6242194.811074998],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yuma',
        GEOID: '08125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11444062.99407034, 4866313.426764089],
              [-11442929.205056611, 4917121.557924053],
              [-11441412.810953027, 4929862.119208175],
              [-11428593.703671236, 4929866.068247792],
              [-11360299.284968976, 4930090.58010256],
              [-11360299.70277852, 4916820.7073894115],
              [-11360299.752667017, 4915237.415960205],
              [-11360348.176645512, 4866389.576156573],
              [-11360293.630095022, 4839673.448856641],
              [-11360153.159997463, 4804236.963398499],
              [-11443970.042295529, 4803339.416876367],
              [-11444062.99407034, 4866313.426764089],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rice',
        GEOID: '27131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10411080.458423607, 5549957.365925748],
              [-10392532.07090916, 5550017.96799812],
              [-10384051.418142054, 5550010.314621336],
              [-10384069.785858035, 5538777.882810488],
              [-10357108.093868414, 5538758.071010783],
              [-10357294.442696001, 5495936.62818903],
              [-10357823.32159676, 5495935.075508754],
              [-10370778.127337828, 5495912.095871473],
              [-10397971.252548808, 5495882.439803258],
              [-10411181.091243284, 5495844.709970599],
              [-10411080.458423607, 5549957.365925748],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Musselshell',
        GEOID: '30065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12134889.823993709, 5901476.804648991],
              [-12092799.033968847, 5901263.972949763],
              [-12003323.210256483, 5902317.2967107175],
              [-11999455.0805904, 5889969.868248531],
              [-12004441.414541502, 5876483.327632936],
              [-11998149.85956085, 5860195.244667874],
              [-11998247.041476311, 5843905.156117734],
              [-12014550.894097893, 5843921.619682691],
              [-12023835.050949544, 5834489.0037794225],
              [-12025773.679881709, 5822765.663717677],
              [-12058217.634153917, 5822756.324512725],
              [-12067573.369438147, 5818242.941268611],
              [-12067566.57894921, 5801680.529344607],
              [-12109304.486188255, 5801601.014323845],
              [-12109253.167903, 5824914.426577213],
              [-12118493.242236298, 5838968.120515537],
              [-12118328.934667885, 5853026.650211455],
              [-12123238.458170343, 5873286.064717722],
              [-12132599.42547064, 5873438.782499306],
              [-12134889.823993709, 5901476.804648991],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'York',
        GEOID: '31185',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10889972.455036638, 5019214.780451984],
              [-10838969.315259375, 5019268.803715899],
              [-10839000.818675267, 4967990.036258845],
              [-10889804.696564011, 4967977.115189253],
              [-10889909.67084383, 4967979.758133917],
              [-10889972.455036638, 5019214.780451984],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Durham',
        GEOID: '37063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8795297.307831148, 4287200.197046371],
              [-8788740.255864952, 4333601.599032643],
              [-8772235.805520961, 4333114.9567519035],
              [-8772824.462988274, 4312693.823451951],
              [-8766551.609682072, 4310372.403607467],
              [-8760767.782898927, 4302196.7135467185],
              [-8767323.832989706, 4289833.234973516],
              [-8772727.948989756, 4290021.146953295],
              [-8775311.56305158, 4282333.153453037],
              [-8783783.64421789, 4282486.730974651],
              [-8796054.836965997, 4281815.566455701],
              [-8795297.307831148, 4287200.197046371],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bledsoe',
        GEOID: '47007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9509334.362904405, 4241261.399299612],
              [-9491699.463131407, 4262331.497290012],
              [-9490438.769898174, 4268417.551515077],
              [-9454201.381338203, 4268820.628607499],
              [-9452812.782010047, 4267913.794677956],
              [-9474152.728395117, 4241800.197634713],
              [-9478453.111643953, 4230848.780571818],
              [-9477206.110708086, 4226385.716407891],
              [-9480892.010367742, 4225970.941685786],
              [-9487301.230050165, 4212130.670785939],
              [-9507051.645426199, 4230982.90559208],
              [-9510708.379379267, 4237696.034426105],
              [-9509334.362904405, 4241261.399299612],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Moore',
        GEOID: '48341',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11372734.80770557, 4308226.214663013],
              [-11312672.48776755, 4308247.695102639],
              [-11312601.799890898, 4249014.736383079],
              [-11312598.348986682, 4248485.99078215],
              [-11372705.53067949, 4248463.943151751],
              [-11372711.875890465, 4249488.31472299],
              [-11372734.80770557, 4308226.214663013],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Piute',
        GEOID: '49031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12525501.568225497, 4651783.106322877],
              [-12481781.728772368, 4652028.79615396],
              [-12441777.956560895, 4650620.889771327],
              [-12450947.120378556, 4639629.738298507],
              [-12450329.742482617, 4600818.700844173],
              [-12462367.164300056, 4600068.890204481],
              [-12517232.645129884, 4600637.648508645],
              [-12507530.706229288, 4611253.756918305],
              [-12505117.41098838, 4626550.387673585],
              [-12525615.893342542, 4647443.462360113],
              [-12525501.568225497, 4651783.106322877],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Covington',
        GEOID: '51580',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8906115.52695738, 4546331.027723459],
              [-8904156.860516872, 4553124.992697461],
              [-8901893.623949554, 4551690.6377183],
              [-8903332.98496551, 4548543.358232313],
              [-8901831.062395727, 4545170.055603974],
              [-8904731.714367328, 4543921.926101453],
              [-8906115.52695738, 4546331.027723459],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Escambia',
        GEOID: '01053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9753356.260199469, 3664537.528889188],
              [-9747055.243062098, 3662302.519662465],
              [-9732379.77195184, 3666611.593368716],
              [-9658519.957727447, 3666729.708902919],
              [-9659472.629929656, 3659042.1940202154],
              [-9651431.243873222, 3657737.4206116665],
              [-9651427.792969007, 3633905.161630982],
              [-9650090.841904474, 3632255.896324138],
              [-9660939.038910864, 3632357.3338597734],
              [-9666091.686852222, 3632405.514683373],
              [-9676764.109073555, 3632447.5911549055],
              [-9702901.146275382, 3632622.651589642],
              [-9703012.611423165, 3632622.110787787],
              [-9719550.311957404, 3632541.874137943],
              [-9732194.536319159, 3632496.9402851523],
              [-9742629.848025102, 3632431.228065657],
              [-9751457.032384971, 3632414.3685098146],
              [-9753316.185182784, 3633752.2924482366],
              [-9753356.260199469, 3664537.528889188],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Guaynabo',
        GEOID: '72061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7360636.757372866, 2086117.8821903227],
              [-7361733.810954634, 2087314.184426294],
              [-7359140.178138642, 2088985.7941529679],
              [-7358181.272044947, 2077691.4485794576],
              [-7356044.828377644, 2072375.924042815],
              [-7356711.632127496, 2070945.437786772],
              [-7363100.925621067, 2070300.1632725506],
              [-7360636.757372866, 2086117.8821903227],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sabana Grande',
        GEOID: '72121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7455160.919992705, 2052493.0670078972],
              [-7455940.7130257115, 2054386.8487272032],
              [-7450225.793007367, 2055261.6998212615],
              [-7447388.927103991, 2042213.9128864629],
              [-7445565.513844797, 2040453.418355663],
              [-7448485.869366269, 2040344.1972567583],
              [-7453813.731515125, 2041350.270725965],
              [-7456550.966474241, 2043696.6006166257],
              [-7455160.919992705, 2052493.0670078972],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jewell',
        GEOID: '20089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10965465.769647388, 4866288.12273168],
              [-10939813.537301173, 4866281.957287119],
              [-10917774.163903786, 4866276.660186466],
              [-10901720.883253645, 4866267.264388736],
              [-10901682.708870638, 4815755.469826718],
              [-10901723.006526304, 4803206.562914995],
              [-10963565.436441598, 4803289.018807421],
              [-10965556.051575962, 4803305.047965164],
              [-10965465.769647388, 4866288.12273168],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Minnehaha',
        GEOID: '46099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10812360.728694549, 5441945.717416147],
              [-10785596.740120575, 5442009.312856685],
              [-10743228.541924655, 5441887.987954861],
              [-10737088.779348116, 5442182.488094915],
              [-10737133.911123214, 5396418.811809226],
              [-10737127.788551223, 5388449.124315824],
              [-10753343.476136098, 5388459.406534906],
              [-10789623.945339004, 5388390.3470735485],
              [-10812404.031976467, 5388340.62458008],
              [-10812360.728694549, 5441945.717416147],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Schuyler',
        GEOID: '36097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8583534.574453576, 5233723.729459383],
              [-8570412.90079581, 5233882.226289556],
              [-8570255.272396846, 5230624.971548863],
              [-8559333.939794099, 5230597.055352266],
              [-8559978.590965284, 5242447.426643256],
              [-8537832.580147378, 5243241.123591631],
              [-8537248.264140205, 5203662.852716321],
              [-8529221.794895539, 5203444.072907798],
              [-8531776.911167717, 5196054.266897454],
              [-8541842.530844735, 5198209.157645605],
              [-8541980.010415863, 5205079.325873949],
              [-8567707.725850042, 5202788.365595311],
              [-8582694.55757605, 5201864.764875155],
              [-8583534.574453576, 5233723.729459383],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bradford',
        GEOID: '42015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8563457.365456462, 5161087.814239493],
              [-8522410.711851351, 5161002.662326348],
              [-8522355.736004971, 5161001.721062562],
              [-8512938.857626429, 5160840.492236127],
              [-8511728.159556357, 5160819.763757096],
              [-8476480.400688684, 5160809.647263011],
              [-8473102.188682435, 5108966.3652563775],
              [-8482322.336826878, 5108370.15486756],
              [-8484787.061672533, 5092511.917522542],
              [-8550865.420851491, 5099764.983727996],
              [-8557654.01735854, 5100789.802113567],
              [-8563457.365456462, 5161087.814239493],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '20059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10631931.648988012, 4640908.661361998],
              [-10631906.602102585, 4678114.853158109],
              [-10631093.524541833, 4684326.817789396],
              [-10581631.38047562, 4684295.277588117],
              [-10582673.330909444, 4678062.79365098],
              [-10582679.8987594, 4634659.367139789],
              [-10631938.439476952, 4634706.6615513805],
              [-10631931.648988012, 4640908.661361998],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fayette',
        GEOID: '13113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9418690.909053111, 3962195.4279604917],
              [-9412826.264319649, 3965652.762042104],
              [-9401895.580879677, 3968661.51432784],
              [-9399611.972845543, 3968292.9908461506],
              [-9395084.386515997, 3959956.4702178785],
              [-9393324.870644521, 3956956.3887277883],
              [-9394042.324762683, 3942181.792618746],
              [-9399028.213435823, 3929399.7488041646],
              [-9406221.678930884, 3929522.487589934],
              [-9420649.018896164, 3953829.4185196543],
              [-9418690.909053111, 3962195.4279604917],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scott',
        GEOID: '17171',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10085446.234926324, 4835481.106466754],
              [-10072528.498575693, 4835362.311458374],
              [-10072564.343451727, 4830176.406035807],
              [-10060081.866310095, 4830169.745432903],
              [-10060272.890556298, 4817492.686348957],
              [-10052224.157413471, 4813265.128239878],
              [-10052350.505035521, 4796460.909265929],
              [-10083436.918117505, 4796682.569294965],
              [-10090665.449252168, 4822929.693669598],
              [-10085446.234926324, 4835481.106466754],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cochise',
        GEOID: '04003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12296413.737217806, 3712752.9361212323],
              [-12295431.008753082, 3728086.708010142],
              [-12295405.071311729, 3819539.1375490655],
              [-12264117.392590389, 3819410.4195806365],
              [-12159184.74626189, 3819159.449924393],
              [-12146513.47126387, 3819383.9112375663],
              [-12139124.64006247, 3819410.2876981855],
              [-12139200.78259417, 3774354.2090391717],
              [-12139300.858816393, 3736634.3124319986],
              [-12139395.369064078, 3676006.5625894614],
              [-12226185.0534636, 3676210.523953237],
              [-12296370.167931842, 3676089.8903656867],
              [-12296413.737217806, 3712752.9361212323],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Modoc',
        GEOID: '06049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13520555.104330167, 5153484.394323848],
              [-13519478.310678428, 5160558.533954817],
              [-13518595.547333734, 5160542.052246255],
              [-13497610.598804804, 5160615.448784541],
              [-13473576.275464572, 5159979.314299735],
              [-13456291.777192209, 5160003.317979952],
              [-13435396.361790257, 5160032.336367191],
              [-13414117.641125124, 5160048.512649869],
              [-13378550.395899728, 5160168.787167957],
              [-13358246.27737649, 5160161.597614893],
              [-13358258.299881494, 5142257.106599642],
              [-13358147.425668662, 5104042.259214854],
              [-13358323.978381062, 5039515.775951642],
              [-13414154.933154538, 5039510.746897518],
              [-13506592.63455844, 5039502.759581628],
              [-13519361.982027845, 5039443.298659246],
              [-13519638.722281955, 5127542.679387286],
              [-13520555.104330167, 5153484.394323848],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kankakee',
        GEOID: '17091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9824112.153062072, 5029203.418085707],
              [-9822987.71488557, 5031384.986911402],
              [-9823293.175568307, 5042118.2180132335],
              [-9797429.872994343, 5042701.466889457],
              [-9797664.645800427, 5055573.698458452],
              [-9743435.231875895, 5056404.106866833],
              [-9743421.903799748, 5036870.845693636],
              [-9743407.637307273, 5016005.806205696],
              [-9743401.318186028, 5013866.418084007],
              [-9810802.126825886, 5012013.777384224],
              [-9823644.499881253, 5011539.298199444],
              [-9824112.153062072, 5029203.418085707],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Worth',
        GEOID: '19195',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10408077.540043337, 5388317.255792705],
              [-10378189.33375688, 5388322.822764567],
              [-10358188.673035672, 5388321.361793278],
              [-10355423.039664652, 5388321.159774422],
              [-10355400.230240664, 5350948.573913397],
              [-10408109.118575353, 5350937.874601066],
              [-10408077.540043337, 5388317.255792705],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Emmet',
        GEOID: '19063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10565846.441958696, 5388480.718846877],
              [-10561351.529601373, 5388474.753151774],
              [-10559160.769548949, 5388474.2036123425],
              [-10513329.969920952, 5388462.707230125],
              [-10513361.919759374, 5350868.48221679],
              [-10565747.313653816, 5350874.596062465],
              [-10565846.441958696, 5388480.718846877],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gogebic',
        GEOID: '26053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10065300.857996957, 5871534.939491575],
              [-10055225.330885258, 5878281.297229316],
              [-10045204.684282519, 5880994.421959503],
              [-10023810.30266645, 5888094.717563136],
              [-10009677.848032283, 5899790.864494354],
              [-10005877.799186183, 5903876.661238399],
              [-10003591.677512143, 5903865.91109722],
              [-10003661.474832868, 5875834.67780559],
              [-9989811.21510786, 5875810.540662464],
              [-9989874.333259141, 5861752.2916046],
              [-9948076.758773027, 5861801.94439719],
              [-9948122.733722724, 5833886.811706911],
              [-9906434.141018098, 5833762.670127889],
              [-9906456.96467474, 5795832.757367521],
              [-9917634.885542735, 5802572.592288456],
              [-9978502.824635625, 5819505.432332028],
              [-10010864.472133335, 5828541.878840093],
              [-10032166.94552081, 5834495.291945754],
              [-10036369.478937238, 5847990.193522053],
              [-10042672.945103409, 5860831.2588852355],
              [-10050558.929150695, 5863888.100280135],
              [-10055699.663235528, 5869460.079724085],
              [-10061860.195175517, 5866285.437326735],
              [-10065300.857996957, 5871534.939491575],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harper',
        GEOID: '20077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10948250.100898258, 4492775.3002427695],
              [-10887831.781228684, 4493088.7039089],
              [-10887528.992213724, 4490255.661559017],
              [-10887303.67826377, 4438925.391735364],
              [-10914357.546092357, 4438873.5951912645],
              [-10921776.231371783, 4438862.583110307],
              [-10947954.523131495, 4438823.724905764],
              [-10948250.100898258, 4492775.3002427695],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McNairy',
        GEOID: '47109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9883141.20548655, 4197578.338618312],
              [-9876238.61782093, 4197573.295160005],
              [-9867463.63632017, 4213050.785270582],
              [-9859763.555822507, 4215926.826047244],
              [-9836476.520223973, 4215778.002176545],
              [-9837851.761213234, 4205274.8847511355],
              [-9838471.422441367, 4163309.363848526],
              [-9848421.658183545, 4163342.05767713],
              [-9883680.437099952, 4163235.9285481144],
              [-9883141.20548655, 4197578.338618312],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Allen',
        GEOID: '39003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9395072.697969466, 4985230.793102911],
              [-9388744.964154303, 4991580.960174767],
              [-9363036.28435305, 4991859.880825173],
              [-9363028.491988696, 4998299.500156096],
              [-9337525.975884391, 5000612.034584604],
              [-9337485.900867706, 4985815.933788372],
              [-9337500.483721001, 4960073.939849492],
              [-9362836.020589115, 4959836.123048938],
              [-9375639.097864231, 4966130.165151243],
              [-9395006.351552954, 4965978.8129237285],
              [-9395072.697969466, 4985230.793102911],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'York',
        GEOID: '51199',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8544372.15495352, 4488619.277636115],
              [-8533601.994219271, 4492226.551120489],
              [-8516156.894178076, 4472858.242280559],
              [-8502241.714007786, 4473940.012322723],
              [-8504155.873834126, 4470536.43193756],
              [-8498930.306390017, 4465573.853215662],
              [-8506243.448244972, 4460846.722146379],
              [-8504340.998147314, 4454056.007773003],
              [-8504841.37925843, 4452475.615140964],
              [-8508760.938529262, 4452338.146246046],
              [-8523197.851970749, 4469891.823880478],
              [-8526135.350693805, 4468954.409574018],
              [-8527197.11599699, 4472360.029231668],
              [-8535995.363271328, 4476248.478306277],
              [-8536164.457577841, 4479971.428614203],
              [-8541306.193538092, 4481835.28693388],
              [-8544372.15495352, 4488619.277636115],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Evans',
        GEOID: '13109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9131018.969625644, 3799974.2841236996],
              [-9124755.021878704, 3798644.5157401124],
              [-9107746.628199892, 3794522.7791410326],
              [-9103803.469197012, 3783396.5898644826],
              [-9101074.137921743, 3777046.7451195256],
              [-9096879.39686967, 3775045.057436202],
              [-9101674.706574574, 3769599.890109953],
              [-9115834.87976195, 3769927.967404254],
              [-9125976.41933169, 3774013.7922776043],
              [-9131018.969625644, 3799974.2841236996],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Poinsett',
        GEOID: '05111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10134188.809804048, 4260573.956381831],
              [-10050673.47690672, 4259408.176771606],
              [-10050691.62198372, 4223642.343852931],
              [-10074684.311834395, 4224073.153990508],
              [-10086742.884355085, 4225035.5352055775],
              [-10134440.725811714, 4224481.844855138],
              [-10134188.809804048, 4260573.956381831],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lamar',
        GEOID: '13171',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9380800.982652314, 3899477.57592132],
              [-9378517.819896143, 3900525.527409776],
              [-9378465.054457508, 3920420.0337366313],
              [-9364638.72842302, 3919036.8514845464],
              [-9364614.906051992, 3922256.505459564],
              [-9355456.76286392, 3922230.5626984322],
              [-9356867.960048705, 3886214.861804524],
              [-9364567.372629423, 3886305.9792367783],
              [-9364458.390847934, 3893920.433461398],
              [-9380909.073877875, 3894110.8847604254],
              [-9380800.982652314, 3899477.57592132],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gilmer',
        GEOID: '13123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9423985.041396257, 4127101.1723369774],
              [-9415659.234040847, 4140143.8211768847],
              [-9419703.582460858, 4144247.6318067657],
              [-9397897.9866458, 4144165.831110814],
              [-9389093.394160487, 4140095.002816148],
              [-9372739.78172652, 4112079.0049049295],
              [-9379236.164570233, 4105372.961092396],
              [-9388311.708696134, 4106807.6537947105],
              [-9389304.010637067, 4104616.211478159],
              [-9392175.942180045, 4102691.4473544867],
              [-9399509.002316559, 4102807.0050056134],
              [-9402933.523811834, 4104718.0006637457],
              [-9406787.515902586, 4104744.090204974],
              [-9423680.91654741, 4102752.402178049],
              [-9423698.393707465, 4107381.2035701335],
              [-9423985.041396257, 4127101.1723369774],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rush',
        GEOID: '18139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9532676.612970375, 4834918.581163077],
              [-9528605.10259461, 4834968.124995941],
              [-9495728.89473965, 4835121.6834693905],
              [-9495342.170828635, 4797223.463431672],
              [-9495282.61490106, 4786808.876178029],
              [-9532213.07861071, 4786733.187467005],
              [-9532647.335944297, 4822219.86655878],
              [-9532676.612970375, 4834918.581163077],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fayette',
        GEOID: '21067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9420420.702620547, 4595881.87942567],
              [-9418690.129816676, 4598308.599166232],
              [-9395570.630051784, 4608835.325270666],
              [-9390381.249349473, 4604668.9734375775],
              [-9393095.552493485, 4595182.794427304],
              [-9382725.919287112, 4588898.953271115],
              [-9389659.676410154, 4565087.580206712],
              [-9388395.643592194, 4564181.236646593],
              [-9393824.917797163, 4557621.667002092],
              [-9399341.355163423, 4557863.010383519],
              [-9404229.282684667, 4570984.201227645],
              [-9414367.593989173, 4576260.09132287],
              [-9416967.349377159, 4577572.138927693],
              [-9424345.939185409, 4579967.725190075],
              [-9420420.702620547, 4595881.87942567],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clark',
        GEOID: '21049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9389659.676410154, 4565087.580206712],
              [-9382725.919287112, 4588898.953271115],
              [-9359801.451270089, 4595700.913603124],
              [-9347086.872990154, 4569650.2643965],
              [-9353884.041097991, 4561000.420350738],
              [-9351056.19207337, 4556508.345832793],
              [-9359198.09962999, 4554490.06797011],
              [-9359780.300566839, 4558689.7103222255],
              [-9379911.98519884, 4561921.576402547],
              [-9381161.323844012, 4567784.367300618],
              [-9388395.643592194, 4564181.236646593],
              [-9389659.676410154, 4565087.580206712],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Genesee',
        GEOID: '26049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9343275.404944882, 5345575.856857213],
              [-9316953.911346816, 5345735.491623195],
              [-9290806.298793362, 5345996.5652852915],
              [-9289985.985465707, 5293790.050328215],
              [-9316259.611682735, 5292397.24611276],
              [-9315937.787034852, 5279040.23601327],
              [-9342211.747210355, 5278669.849924869],
              [-9342942.33702843, 5332204.50957098],
              [-9343275.404944882, 5345575.856857213],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bertie',
        GEOID: '37015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8597234.886824485, 4315078.707332068],
              [-8604052.537718628, 4323809.763619556],
              [-8604801.829211159, 4329239.4397162935],
              [-8594807.342688756, 4334603.383865506],
              [-8591669.134923803, 4334077.221291182],
              [-8538937.871371465, 4334219.3875572765],
              [-8542316.30659755, 4321361.19191733],
              [-8536260.748937378, 4304880.46746919],
              [-8527764.734080544, 4297601.6436336255],
              [-8536396.113438183, 4294170.059375317],
              [-8544950.682347175, 4282045.922597953],
              [-8553213.594190286, 4284521.906433335],
              [-8559478.766451621, 4274873.377550267],
              [-8559803.374086775, 4281640.707832074],
              [-8564814.754923306, 4287077.748875884],
              [-8572185.218408728, 4281159.414701993],
              [-8576504.41465151, 4281597.302670095],
              [-8574666.975136474, 4290950.169923221],
              [-8593406.275577633, 4291928.768000436],
              [-8594512.234718664, 4301353.833356754],
              [-8608065.605361726, 4310444.983485442],
              [-8597234.886824485, 4315078.707332068],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Todd',
        GEOID: '46121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11268675.462782342, 5371398.638922341],
              [-11160011.832400415, 5371585.065741244],
              [-11155796.051964583, 5371572.657595111],
              [-11155754.752433497, 5331534.271749566],
              [-11154036.27021385, 5311663.913226846],
              [-11154036.40248467, 5311663.913126071],
              [-11243316.32618218, 5311595.895316113],
              [-11268650.905457104, 5311647.45301402],
              [-11268675.462782342, 5371398.638922341],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Outagamie',
        GEOID: '55087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9878135.61326354, 5557299.247769946],
              [-9863584.040746534, 5557285.179286305],
              [-9823411.174228547, 5556383.434934045],
              [-9817317.656622013, 5556704.326246282],
              [-9817556.548249258, 5502960.70057733],
              [-9841096.056452911, 5503295.5664239],
              [-9854534.656700965, 5503284.067346904],
              [-9878466.009512214, 5503171.408235988],
              [-9878135.61326354, 5557299.247769946],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Toa Baja',
        GEOID: '72137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7375800.253130764, 2090877.4640768978],
              [-7368891.900392289, 2092712.0095625804],
              [-7367872.190315958, 2092603.8265482648],
              [-7362443.917986404, 2093092.070111352],
              [-7361475.5881900545, 2092890.5027031559],
              [-7361491.4684231775, 2092122.636544927],
              [-7365956.827157368, 2088058.3305158233],
              [-7369014.105652514, 2083164.8584097822],
              [-7375200.575033861, 2083739.450571215],
              [-7375800.253130764, 2090877.4640768978],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '18105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9649797.964304304, 4769921.797350632],
              [-9643698.546764757, 4771491.448782401],
              [-9641571.008656716, 4770527.462349523],
              [-9615932.905412627, 4770455.638477804],
              [-9614671.76690143, 4728603.246953059],
              [-9608890.611786064, 4728665.599815546],
              [-9608817.252241628, 4720363.862783445],
              [-9649426.936441489, 4720583.569154775],
              [-9649507.643072315, 4745441.149735716],
              [-9649797.964304304, 4769921.797350632],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Miguel',
        GEOID: '08113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12138477.274349362, 4601066.758310871],
              [-12018696.654574018, 4600967.055710811],
              [-12010423.39001826, 4595819.623429345],
              [-12010228.246950898, 4581066.752783048],
              [-11999736.718902105, 4577804.200802486],
              [-11993370.802501602, 4566075.126284031],
              [-12004662.161091745, 4547930.832637549],
              [-12007014.341932207, 4547762.2500589425],
              [-12021333.034074476, 4559209.532988049],
              [-12045781.131961983, 4554160.866501873],
              [-12051058.232423037, 4564547.996496178],
              [-12113845.096898224, 4562607.701766142],
              [-12138567.163253656, 4562640.678881268],
              [-12138477.274349362, 4601066.758310871],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carroll',
        GEOID: '19027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10585465.11241905, 5192549.385751274],
              [-10559590.121298552, 5192442.227369089],
              [-10534030.498295471, 5192397.741215098],
              [-10534021.370097226, 5140444.123511393],
              [-10546951.351591844, 5140388.968054864],
              [-10585688.864595544, 5140535.452081027],
              [-10585465.11241905, 5192549.385751274],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tishomingo',
        GEOID: '28141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9836583.1941898, 4163303.159643478],
              [-9824847.974896217, 4163264.600978641],
              [-9818386.21241414, 4163287.837931541],
              [-9813327.075516058, 4153339.5219066055],
              [-9807012.032122847, 4149241.458801679],
              [-9811061.27860045, 4112719.649640371],
              [-9811650.875743126, 4107179.7068555816],
              [-9813358.822054688, 4091146.9759599213],
              [-9832760.786940783, 4091219.439190419],
              [-9832928.434093919, 4128701.749506846],
              [-9836799.346747274, 4130718.1035586093],
              [-9836583.1941898, 4163303.159643478],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Toombs',
        GEOID: '13279',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9177066.0543533, 3801856.883692141],
              [-9173742.388316683, 3809834.331534528],
              [-9173741.052482795, 3809846.454971775],
              [-9167672.4704422, 3801764.04378352],
              [-9154112.086671218, 3805236.2211036165],
              [-9148450.15473049, 3785113.252739225],
              [-9153249.805895533, 3751905.6397003955],
              [-9173532.55107654, 3756681.967007111],
              [-9176236.056229945, 3758872.3072953336],
              [-9181980.141954878, 3759236.965320663],
              [-9177066.0543533, 3801856.883692141],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lake',
        GEOID: '39085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9071278.667297715, 5106380.213673383],
              [-9068757.867105475, 5108567.546759525],
              [-9060141.07060113, 5117211.483346274],
              [-9048819.099151019, 5125132.393351974],
              [-9037402.506133733, 5129077.166653163],
              [-9022658.462217145, 5136976.077321196],
              [-9017131.38343309, 5138412.918628932],
              [-9017282.95532623, 5118403.400528956],
              [-9028262.062744696, 5118279.623926529],
              [-9028168.999650395, 5107421.836538383],
              [-9049681.157287722, 5107337.228333967],
              [-9049815.965191074, 5096776.145036176],
              [-9060405.231752783, 5096741.327357841],
              [-9071185.07728273, 5096791.173218355],
              [-9071278.667297715, 5106380.213673383],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Green',
        GEOID: '21087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9539782.581345672, 4481263.037941983],
              [-9535330.580950378, 4498091.959945705],
              [-9532754.759252911, 4505073.148832004],
              [-9527111.306347655, 4504811.142383586],
              [-9527296.764619317, 4499613.74328987],
              [-9515376.450906193, 4489920.072846824],
              [-9501427.005514886, 4465963.376506395],
              [-9504486.844358321, 4462593.627657912],
              [-9520808.842056904, 4454373.705956058],
              [-9532545.478610221, 4456552.345377785],
              [-9538575.544107001, 4464565.354829298],
              [-9539782.581345672, 4481263.037941983],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '31035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10940268.382088892, 4967940.995017082],
              [-10889909.67084383, 4967979.758133917],
              [-10889804.696564011, 4967977.115189253],
              [-10889730.557783144, 4917013.465618749],
              [-10939763.882156616, 4916986.880936199],
              [-10940266.93493551, 4916985.128102508],
              [-10940268.382088892, 4967940.995017082],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greenlee',
        GEOID: '04011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12188976.62498544, 3982262.5096498597],
              [-12187272.880178848, 3987440.8128702883],
              [-12174413.920519354, 3993777.0499517936],
              [-12172560.117039172, 3998958.804900423],
              [-12139012.816730978, 3999061.633568504],
              [-12139089.68574236, 3949822.9760375544],
              [-12139082.895253422, 3923073.5324423336],
              [-12139082.89308681, 3923064.223194104],
              [-12139069.543850843, 3865846.838771723],
              [-12139069.536914526, 3865817.18090144],
              [-12139124.64006247, 3819410.2876981855],
              [-12146513.47126387, 3819383.9112375663],
              [-12158990.493750453, 3832964.8483424177],
              [-12156784.03012344, 3847062.0793712814],
              [-12161098.328308623, 3861106.6513598626],
              [-12170941.197684567, 3874518.5772701497],
              [-12189010.020832676, 3905716.077339241],
              [-12188976.62498544, 3982262.5096498597],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Boyd',
        GEOID: '21019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9218437.94310662, 4635096.671218513],
              [-9213808.165484527, 4640877.681119541],
              [-9202127.401020283, 4651399.373964186],
              [-9197046.45579731, 4647043.455936047],
              [-9194285.621106148, 4639185.847154245],
              [-9194540.68350356, 4633373.378036773],
              [-9194764.962833503, 4628265.122470129],
              [-9191859.301484818, 4624131.624580396],
              [-9192963.479513995, 4614603.291619827],
              [-9193286.062706871, 4613458.1698594615],
              [-9196582.253520703, 4617082.20050568],
              [-9216608.852553396, 4613920.08750067],
              [-9214107.614914762, 4630774.72563559],
              [-9219196.808075357, 4632385.799597254],
              [-9218437.94310662, 4635096.671218513],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bourbon',
        GEOID: '20011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10585156.868749043, 4541702.272283062],
              [-10584222.898221286, 4554000.779142264],
              [-10584020.742026005, 4584753.776280674],
              [-10532393.461549634, 4584661.98868634],
              [-10532434.065478005, 4577702.364123819],
              [-10532814.778136518, 4534630.067180531],
              [-10532813.381176883, 4533349.683748756],
              [-10585149.076384686, 4533547.751495888],
              [-10585156.868749043, 4541702.272283062],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chemung',
        GEOID: '36015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8567707.725850042, 5202788.365595311],
              [-8541980.010415863, 5205079.325873949],
              [-8541842.530844735, 5198209.157645605],
              [-8531776.911167717, 5196054.266897454],
              [-8529221.794895539, 5203444.072907798],
              [-8520210.03683786, 5203278.862890765],
              [-8523019.74078548, 5183845.0925663905],
              [-8522355.736004971, 5161001.721062562],
              [-8522410.711851351, 5161002.662326348],
              [-8563457.365456462, 5161087.814239493],
              [-8567785.734032592, 5161096.793550894],
              [-8567707.725850042, 5202788.365595311],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adair',
        GEOID: '40001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10552784.826867884, 4322851.171146955],
              [-10526623.5140636, 4322931.503037883],
              [-10525470.060913056, 4314696.589874889],
              [-10523262.007353583, 4298949.954698023],
              [-10519085.077420037, 4268786.878218542],
              [-10518917.104370968, 4267533.450943507],
              [-10516699.54421893, 4250999.321666263],
              [-10553900.025526652, 4251007.108259253],
              [-10552784.826867884, 4322851.171146955],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hansford',
        GEOID: '48195',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11312722.470218915, 4369575.147471277],
              [-11252748.092678623, 4369535.818971088],
              [-11252810.431593467, 4308546.084844097],
              [-11252812.546663793, 4308229.932428364],
              [-11312672.48776755, 4308247.695102639],
              [-11312722.470218915, 4369575.147471277],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sussex',
        GEOID: '51183',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8640510.784148334, 4422093.466413142],
              [-8615961.385524204, 4438129.031818281],
              [-8592421.766001057, 4452905.757785859],
              [-8588901.509743702, 4454734.408261172],
              [-8567726.427524496, 4446708.062239541],
              [-8566429.555456754, 4431366.659517794],
              [-8619482.309698503, 4398436.043324467],
              [-8626147.230251279, 4400290.057938265],
              [-8622660.592480142, 4420022.771011229],
              [-8628413.80640332, 4417535.158064538],
              [-8640510.784148334, 4422093.466413142],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harding',
        GEOID: '46063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11582285.734120572, 5771589.436616487],
              [-11539465.133514067, 5771578.390238593],
              [-11514314.943598123, 5771586.394858884],
              [-11490219.283218466, 5771573.107193159],
              [-11465425.317803495, 5771558.449763712],
              [-11459458.809285326, 5771554.922551079],
              [-11461152.094379978, 5655092.994078415],
              [-11581694.934475856, 5655099.277185003],
              [-11581719.674509885, 5674565.272602386],
              [-11581876.189713942, 5699119.946813508],
              [-11581895.447985848, 5709785.617508275],
              [-11581968.918849774, 5740376.336493697],
              [-11582100.164529417, 5758694.865966345],
              [-11582139.922965381, 5761455.962943588],
              [-11582285.734120572, 5771589.436616487],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yancey',
        GEOID: '37199',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9184749.399047824, 4298146.699015091],
              [-9179912.605052374, 4301516.899762083],
              [-9174611.525780024, 4310666.583839571],
              [-9167346.193014685, 4312231.813804884],
              [-9156469.610847237, 4301353.558141263],
              [-9150221.02519003, 4302731.236729909],
              [-9143057.615957482, 4276336.120358319],
              [-9149727.657206833, 4264261.841294452],
              [-9156901.085193552, 4259262.600139991],
              [-9158855.521493409, 4260028.338496708],
              [-9159894.577620475, 4262919.601059694],
              [-9165496.285716683, 4266193.21238679],
              [-9168491.002658002, 4276052.754378313],
              [-9173683.611625547, 4275631.700418245],
              [-9183305.0665343, 4288254.875061952],
              [-9184749.399047824, 4298146.699015091],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hancock',
        GEOID: '28045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9985350.76365306, 3562046.5827400074],
              [-9979466.406147933, 3568337.200991991],
              [-9968049.256533192, 3570162.1565705985],
              [-9968018.309714751, 3587166.7411804707],
              [-9945444.275454747, 3587082.8939383593],
              [-9945377.595079761, 3549650.2643209784],
              [-9941612.409319993, 3542685.6939551905],
              [-9945811.629774366, 3541293.403364989],
              [-9954703.60805995, 3535131.7278570635],
              [-9957246.256549159, 3529940.6158041647],
              [-9960403.165988566, 3528197.065744357],
              [-9965822.198800381, 3526805.1798159922],
              [-9975078.525779335, 3531486.1448986796],
              [-9978034.392218368, 3543235.1367359357],
              [-9982966.513577454, 3556879.0088055255],
              [-9985350.76365306, 3562046.5827400074],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Izard',
        GEOID: '05065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10265204.392061852, 4324741.687462506],
              [-10259191.469766652, 4324559.929803634],
              [-10258869.199840805, 4336628.49348251],
              [-10207043.85430454, 4335531.408374686],
              [-10205118.917669745, 4329357.950357975],
              [-10206024.390407858, 4300694.987468924],
              [-10209171.949010035, 4292610.456662322],
              [-10213935.643979553, 4292765.004370772],
              [-10224633.78100326, 4282392.633577768],
              [-10236163.3633037, 4291219.76366282],
              [-10253484.898710117, 4291176.320262519],
              [-10248470.400927842, 4303975.440074985],
              [-10256878.139428474, 4316073.815681586],
              [-10263148.321066897, 4318909.591004756],
              [-10265332.075517789, 4319658.590203737],
              [-10265204.392061852, 4324741.687462506],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tippecanoe',
        GEOID: '18157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9695410.791698374, 4948080.998464193],
              [-9659336.152233943, 4947961.868440664],
              [-9650882.550103102, 4947931.390143105],
              [-9650805.962293437, 4928942.182453865],
              [-9650914.164838485, 4897142.5816082405],
              [-9695099.765041098, 4897206.577455493],
              [-9695053.56745242, 4919361.234462075],
              [-9695223.663634352, 4935319.011194062],
              [-9695410.791698374, 4948080.998464193],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Boone',
        GEOID: '18011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9650932.75519345, 4891938.2933746595],
              [-9617875.987124424, 4891724.554965039],
              [-9613156.485992752, 4891858.450537805],
              [-9600456.156607637, 4892247.326199037],
              [-9600163.831624815, 4855202.604742973],
              [-9609798.978830935, 4854908.514534147],
              [-9613023.793159727, 4854910.256405123],
              [-9650851.158006698, 4854725.764933713],
              [-9650932.75519345, 4891938.2933746595],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '19121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10490926.144306934, 5086920.485407098],
              [-10452544.742354285, 5086834.125150108],
              [-10440723.169029493, 5088144.92237603],
              [-10440565.540630529, 5036271.247362073],
              [-10465611.646822581, 5035491.5925483415],
              [-10490931.04236453, 5035546.593638304],
              [-10490926.144306934, 5086920.485407098],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Taylor',
        GEOID: '21217',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9527111.306347655, 4504811.142383586],
              [-9517687.554854551, 4506639.433159066],
              [-9514059.430010619, 4504204.96198393],
              [-9500054.992790861, 4504754.337780663],
              [-9489625.803656911, 4497840.9205401465],
              [-9476481.866100984, 4502465.43844811],
              [-9470368.978903053, 4496924.838833169],
              [-9476757.60447968, 4492804.580743628],
              [-9480543.803000541, 4482460.751907655],
              [-9483590.394824572, 4477107.643761135],
              [-9496920.792527575, 4473508.34574685],
              [-9501427.005514886, 4465963.376506395],
              [-9515376.450906193, 4489920.072846824],
              [-9527296.764619317, 4499613.74328987],
              [-9527111.306347655, 4504811.142383586],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Saline',
        GEOID: '20169',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10901357.433318539, 4715713.764275752],
              [-10839358.488199187, 4715636.030171608],
              [-10840426.153435385, 4711492.218712868],
              [-10839391.550087953, 4665868.218482266],
              [-10900938.3154357, 4665943.294229932],
              [-10901360.995542243, 4703224.393313618],
              [-10901357.433318539, 4715713.764275752],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Barry',
        GEOID: '26015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9522888.624103395, 5276746.564589],
              [-9496624.12608461, 5277010.26887256],
              [-9470421.633022198, 5277147.658856545],
              [-9470128.19484447, 5224317.856120455],
              [-9495427.775517058, 5224079.749207861],
              [-9522624.462951742, 5224318.610110071],
              [-9522888.624103395, 5276746.564589],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Waseca',
        GEOID: '27161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10438202.784438442, 5495798.440676279],
              [-10411181.091243284, 5495844.709970599],
              [-10397971.252548808, 5495882.439803258],
              [-10397979.8241496, 5441968.407971955],
              [-10424879.956460813, 5441971.340768961],
              [-10438179.407345375, 5441943.093341873],
              [-10438202.784438442, 5495798.440676279],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Blue Earth',
        GEOID: '27013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10505413.04019979, 5506457.739941708],
              [-10469227.526522528, 5489363.07758237],
              [-10465353.27428445, 5502583.5832863385],
              [-10438209.46360789, 5502562.451504516],
              [-10438202.784438442, 5495798.440676279],
              [-10438179.407345375, 5441943.093341873],
              [-10491541.741091022, 5441941.549769119],
              [-10505106.132363673, 5441957.139865823],
              [-10505092.328746814, 5482278.886777776],
              [-10505413.04019979, 5506457.739941708],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Davidson',
        GEOID: '37057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8959837.088699814, 4277654.335820073],
              [-8949956.03673853, 4278812.865980744],
              [-8946748.476930814, 4284911.702308529],
              [-8949453.317918109, 4296874.112210008],
              [-8929364.0460121, 4300167.169040754],
              [-8929351.578229131, 4304310.7387546925],
              [-8910372.495604806, 4302101.757239912],
              [-8910776.696675876, 4289714.331119176],
              [-8913000.08086549, 4232812.556285268],
              [-8925881.638381615, 4232606.071216467],
              [-8928881.698658494, 4243249.897792492],
              [-8942361.709757123, 4256514.14269554],
              [-8942796.635007652, 4262226.46740049],
              [-8952672.56627236, 4262965.948657473],
              [-8956641.996675067, 4265320.199120218],
              [-8959837.088699814, 4277654.335820073],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ross',
        GEOID: '39141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9282493.404498884, 4767568.426717269],
              [-9281008.06853323, 4775878.271513436],
              [-9269210.762857432, 4795891.917714334],
              [-9237798.96290386, 4794521.881629356],
              [-9239317.806036241, 4790671.344071569],
              [-9210655.820144244, 4788982.467003145],
              [-9211531.01398086, 4774546.098037952],
              [-9212813.414514799, 4755769.428994899],
              [-9213122.994018694, 4751504.992358311],
              [-9215683.230987448, 4745875.196445667],
              [-9278872.626741342, 4750013.576333683],
              [-9283354.683399154, 4760140.203026133],
              [-9282493.404498884, 4767568.426717269],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Van Buren',
        GEOID: '47175',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9529268.566759737, 4272449.678957443],
              [-9528769.07620455, 4274001.728347733],
              [-9522626.466702575, 4272769.32157852],
              [-9520017.805755327, 4272049.075265303],
              [-9520775.446209665, 4274136.108775063],
              [-9519745.184322374, 4275307.306390827],
              [-9517749.448491432, 4274030.690689997],
              [-9514945.867115803, 4276246.469375007],
              [-9509264.78822266, 4275153.006399314],
              [-9491663.506935881, 4276152.700452644],
              [-9492141.624148838, 4272228.9951441875],
              [-9490438.769898174, 4268417.551515077],
              [-9491699.463131407, 4262331.497290012],
              [-9509334.362904405, 4241261.399299612],
              [-9513347.653186485, 4238446.447650589],
              [-9524221.229727682, 4236548.555522801],
              [-9528350.848877639, 4248171.302721701],
              [-9530634.456911772, 4267720.639182283],
              [-9529268.566759737, 4272449.678957443],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Falls',
        GEOID: '48145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10828950.004490525, 3669139.9304568297],
              [-10775851.720577043, 3700763.085764973],
              [-10753113.490068117, 3661470.5651291],
              [-10778968.443680273, 3646506.154299675],
              [-10781190.158077523, 3645804.100779038],
              [-10805803.899367334, 3630959.677350424],
              [-10828950.004490525, 3669139.9304568297],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lynn',
        GEOID: '48305',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11363040.438530348, 3947129.8966000425],
              [-11305260.613431552, 3947819.741062132],
              [-11305321.839151489, 3890131.8259406225],
              [-11320221.952994168, 3890239.690964447],
              [-11363072.164585222, 3889956.2986323102],
              [-11363040.438530348, 3947129.8966000425],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Deaf Smith',
        GEOID: '48117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11470665.215231728, 4157650.9754732586],
              [-11470662.118478449, 4183567.489080352],
              [-11470651.760262728, 4188799.424773295],
              [-11373230.847356545, 4188809.740819917],
              [-11373383.132419951, 4129608.880972733],
              [-11413051.276366679, 4129543.0383108836],
              [-11470668.575008916, 4129601.2941442137],
              [-11470665.215231728, 4157650.9754732586],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Trujillo Alto',
        GEOID: '72139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7349898.767971456, 2082054.9023957502],
              [-7347036.966502144, 2082082.8206439766],
              [-7340285.662024513, 2073768.2856916562],
              [-7340677.617951595, 2071927.340103672],
              [-7343530.068583683, 2073864.552707538],
              [-7349507.257322336, 2073283.322623593],
              [-7351710.047406155, 2074140.4581455737],
              [-7349898.767971456, 2082054.9023957502],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Converse',
        GEOID: '56009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11808556.514094247, 5387540.804344951],
              [-11801799.198364114, 5387617.22317266],
              [-11697429.494700557, 5388150.638003896],
              [-11677408.01636444, 5388334.025627237],
              [-11677245.378588393, 5279004.895514422],
              [-11676572.67490553, 5252636.541203568],
              [-11720440.791920397, 5252165.708418794],
              [-11720151.249924844, 5225822.0341930315],
              [-11725575.626072217, 5225777.391012723],
              [-11730351.566185722, 5204540.430177269],
              [-11747145.001927814, 5204347.813624545],
              [-11756881.672509538, 5206694.992696331],
              [-11752626.707612947, 5217667.895257929],
              [-11750444.845593398, 5225698.511854751],
              [-11808037.208669698, 5226098.645625218],
              [-11808309.83010265, 5226095.930751765],
              [-11808445.305922944, 5278236.6896416675],
              [-11807959.730304105, 5280888.289574747],
              [-11808556.514094247, 5387540.804344951],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gloucester',
        GEOID: '51073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8539574.730178295, 4499397.433621687],
              [-8532282.079016935, 4506387.347418276],
              [-8533092.707548892, 4523518.286822504],
              [-8522167.144805497, 4516759.153590159],
              [-8508990.367999787, 4511046.51238744],
              [-8510146.198272692, 4497821.157223804],
              [-8505137.029950326, 4493972.365114456],
              [-8508986.36049812, 4492172.056027299],
              [-8503447.659233699, 4482079.226447646],
              [-8500611.238608288, 4476840.038799867],
              [-8502241.714007786, 4473940.012322723],
              [-8516156.894178076, 4472858.242280559],
              [-8533601.994219271, 4492226.551120489],
              [-8539574.730178295, 4499397.433621687],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kimble',
        GEOID: '48267',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11144888.189020224, 3595191.5050358814],
              [-11074493.639224734, 3595243.9435003437],
              [-11074563.102586988, 3567937.074470011],
              [-11054470.268457277, 3567961.7509388668],
              [-11054216.682657247, 3540449.8866227535],
              [-11104580.291959906, 3540971.357167699],
              [-11144913.458544632, 3540919.531444144],
              [-11144888.189020224, 3595191.5050358814],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lea',
        GEOID: '35025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11556578.056194734, 3890674.3453248646],
              [-11551224.701882485, 3890694.2474671714],
              [-11551218.467991002, 3947891.3411098276],
              [-11546147.642546387, 3971146.783886004],
              [-11522694.852226062, 3971224.273482822],
              [-11471764.127621453, 3971285.4340434056],
              [-11472196.553501619, 3946973.669281003],
              [-11472598.187062327, 3924438.6981003834],
              [-11472972.87605343, 3889877.276622433],
              [-11473130.962145261, 3875325.9176802533],
              [-11473116.713250441, 3840742.4282972068],
              [-11473109.477483539, 3832053.459328404],
              [-11473078.97594306, 3782360.0049888864],
              [-11473079.020593978, 3774742.855642835],
              [-11473079.087262554, 3763378.622886138],
              [-11502253.476770671, 3763359.19549223],
              [-11546378.405529568, 3763332.3606258933],
              [-11546384.641742285, 3832073.3948014397],
              [-11556545.662222914, 3832076.563356531],
              [-11556578.056194734, 3890674.3453248646],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Costilla',
        GEOID: '08023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11768730.853068048, 4478992.821723078],
              [-11771294.652260507, 4488957.205616716],
              [-11744269.396841642, 4517473.488120379],
              [-11742593.927185712, 4519967.511667972],
              [-11721451.127618836, 4530720.7576503735],
              [-11709424.392472513, 4525836.248436047],
              [-11705709.32710627, 4480044.33105255],
              [-11705805.813057618, 4438476.0021021925],
              [-11713093.059961936, 4438488.377675903],
              [-11716520.676052112, 4438494.198633046],
              [-11735223.908978252, 4438529.182831765],
              [-11747982.45845705, 4438531.831042744],
              [-11768303.720181873, 4438528.207175256],
              [-11768526.212666009, 4438527.778904031],
              [-11774337.45922185, 4444931.563166432],
              [-11768730.853068048, 4478992.821723078],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Guthrie',
        GEOID: '19077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10546951.351591844, 5140388.968054864],
              [-10534021.370097226, 5140444.123511393],
              [-10495239.4406167, 5140479.399254813],
              [-10495207.937200807, 5101443.7484489875],
              [-10490899.761587616, 5101392.9852572745],
              [-10490926.144306934, 5086920.485407098],
              [-10542025.798082715, 5086990.198468921],
              [-10542038.711143646, 5101573.560528793],
              [-10546876.544894032, 5101573.709396863],
              [-10546951.351591844, 5140388.968054864],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Smith',
        GEOID: '28129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9988745.108344534, 3792492.1160278893],
              [-9985538.773051215, 3792718.1814836147],
              [-9943356.589724408, 3792680.6790606156],
              [-9942673.978606867, 3737359.8088753913],
              [-9952099.065933859, 3736675.1769362427],
              [-9980129.091076626, 3734552.2389382203],
              [-9981137.756982703, 3769513.078521127],
              [-9988705.25596683, 3769491.1458891225],
              [-9988745.108344534, 3792492.1160278893],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rush',
        GEOID: '20165',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11085761.175443847, 4678295.851155733],
              [-11025374.693148637, 4678334.3617822975],
              [-11024299.903465027, 4678327.515438062],
              [-11024237.23059171, 4628751.2667601],
              [-11085728.558833046, 4628900.592190804],
              [-11085761.175443847, 4678295.851155733],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kiowa',
        GEOID: '20097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11082921.749192182, 4542041.777741405],
              [-11022137.967634333, 4541771.805253286],
              [-11022031.991479097, 4504881.83298593],
              [-11021909.651358714, 4492804.30054706],
              [-11081097.111418592, 4492364.54124524],
              [-11082467.009072293, 4493830.570592353],
              [-11082536.472434549, 4504503.27914755],
              [-11082921.749192182, 4542041.777741405],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Vernon',
        GEOID: '29217',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10532814.778136518, 4534630.067180531],
              [-10532434.065478005, 4577702.364123819],
              [-10532393.461549634, 4584661.98868634],
              [-10532374.505215181, 4587912.758952558],
              [-10490502.462324975, 4583101.794624398],
              [-10479086.759863615, 4587639.193460387],
              [-10470520.391088601, 4584601.272447274],
              [-10471343.042125564, 4565448.023639654],
              [-10472216.788808798, 4528654.891123035],
              [-10532810.38372773, 4530602.901531534],
              [-10532813.381176883, 4533349.683748756],
              [-10532814.778136518, 4534630.067180531],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Granville',
        GEOID: '37077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8772235.805520961, 4333114.9567519035],
              [-8771561.093093524, 4375424.998151252],
              [-8764642.458275437, 4375404.109568935],
              [-8739689.325997729, 4375328.77198713],
              [-8733824.224437563, 4375381.936932338],
              [-8738327.220708383, 4371672.645683061],
              [-8739829.477236638, 4363384.069131889],
              [-8738203.09947615, 4324755.340095988],
              [-8743568.476293402, 4311751.366718638],
              [-8743746.810117655, 4303625.011729436],
              [-8758976.42965308, 4310875.101546994],
              [-8766551.609682072, 4310372.403607467],
              [-8772824.462988274, 4312693.823451951],
              [-8772235.805520961, 4333114.9567519035],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greeley',
        GEOID: '31077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10993047.40170278, 5122167.4200131465],
              [-10942233.950337829, 5122287.666286389],
              [-10941703.179005723, 5119096.877323547],
              [-10941742.363466486, 5083509.472749088],
              [-10941750.712428294, 5070615.699103638],
              [-10992168.534322966, 5070657.8419753425],
              [-10992973.15160242, 5070643.893257985],
              [-10993047.40170278, 5122167.4200131465],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Perry',
        GEOID: '42099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8646380.883536844, 4908148.674899745],
              [-8631729.012158634, 4924126.71587297],
              [-8591948.769484676, 4950911.824590497],
              [-8565969.583320796, 4957649.535474012],
              [-8570764.559067225, 4948760.785287668],
              [-8565967.690889452, 4934337.398645181],
              [-8573916.125171075, 4919305.422623323],
              [-8562135.294779912, 4913792.128921077],
              [-8568730.863289922, 4911141.599501379],
              [-8594386.443694066, 4907743.26586799],
              [-8618449.04218496, 4903121.350525118],
              [-8611684.935965888, 4911688.320529182],
              [-8638998.95414387, 4892915.254756163],
              [-8640024.985890513, 4894836.966756197],
              [-8638694.940614514, 4899159.30612157],
              [-8646380.883536844, 4908148.674899745],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henderson',
        GEOID: '17071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10143523.283065537, 4964195.499215566],
              [-10143234.17949039, 4968123.601594652],
              [-10142957.223454854, 4971888.133236815],
              [-10140281.99345211, 4979902.743652152],
              [-10140425.595595233, 4985986.569656425],
              [-10135044.411410287, 4992943.5522424625],
              [-10128455.299430741, 4999391.1058923835],
              [-10124756.264071172, 5005565.967828125],
              [-10123987.157709282, 5015185.727963814],
              [-10124718.542647002, 5022653.345683433],
              [-10106161.567648554, 5022487.420294706],
              [-10106657.82993851, 4958762.424955499],
              [-10119411.036081752, 4959268.672362471],
              [-10150719.042711066, 4959108.890259081],
              [-10143523.283065537, 4964195.499215566],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hood',
        GEOID: '48221',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10916750.24722747, 3836890.3119489555],
              [-10866682.079853378, 3836449.4479433694],
              [-10866483.931159766, 3805207.2415023465],
              [-10885127.051560879, 3804927.3285228815],
              [-10903257.100428924, 3793996.0974730933],
              [-10903773.622866208, 3795416.8224037527],
              [-10916940.492237234, 3830658.455469967],
              [-10916750.24722747, 3836890.3119489555],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Johnson',
        GEOID: '17087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9912420.346635507, 4485183.336250421],
              [-9912043.41883968, 4522591.246095303],
              [-9874990.169731686, 4522970.73555094],
              [-9875224.385940315, 4486197.521568718],
              [-9897225.681420187, 4486006.689335045],
              [-9899545.356969336, 4481376.253725435],
              [-9912404.873226287, 4480214.205487727],
              [-9912420.346635507, 4485183.336250421],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Staunton',
        GEOID: '51790',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8804915.089196704, 4605604.078423396],
              [-8798001.146943025, 4607578.65620387],
              [-8795506.69979333, 4605131.063037735],
              [-8799785.598380443, 4596558.088603829],
              [-8806823.550546864, 4600959.836102117],
              [-8804915.089196704, 4605604.078423396],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bureau',
        GEOID: '17011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10003431.154806416, 5098867.668974551],
              [-9977732.271120355, 5099008.161887306],
              [-9925976.166307366, 5099058.763651384],
              [-9925658.23784166, 5058202.397977884],
              [-9944715.689387506, 5056822.760195185],
              [-9947145.571232542, 5046775.867720669],
              [-9959352.86659293, 5046899.172795388],
              [-9959320.806579582, 5034273.664524151],
              [-9978504.271789007, 5034283.569366668],
              [-9978552.695767501, 5046897.692533072],
              [-10002924.317164836, 5046989.617252483],
              [-10003431.154806416, 5098867.668974551],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Buena Vista',
        GEOID: '19021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10618563.847936105, 5298267.292132957],
              [-10565765.90400878, 5298237.350643307],
              [-10565832.139105802, 5245284.070986289],
              [-10618544.700983686, 5245500.647238271],
              [-10618563.847936105, 5298267.292132957],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'LaGrange',
        GEOID: '18087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9535599.777972143, 5124982.218095689],
              [-9494681.913926484, 5125059.60834548],
              [-9488075.791067105, 5125072.102934573],
              [-9484061.521207126, 5125076.854791076],
              [-9483762.049479375, 5090303.86072139],
              [-9535042.820066677, 5089844.408294806],
              [-9535599.777972143, 5124982.218095689],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '28153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9901128.988045363, 3740304.0235486566],
              [-9897467.022076227, 3740577.062895334],
              [-9886192.02745123, 3741395.6938129845],
              [-9865693.87905554, 3744513.4975313363],
              [-9848286.458886575, 3749385.5902555413],
              [-9848287.184238667, 3735870.878834914],
              [-9847725.722644474, 3723725.851683206],
              [-9847264.046798784, 3713748.396500281],
              [-9846147.297350096, 3689481.153241499],
              [-9889813.584445208, 3689202.7533872253],
              [-9901141.567147823, 3689170.789219946],
              [-9901128.988045363, 3740304.0235486566],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '21171',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9570905.84117911, 4400527.960599873],
              [-9548127.201695027, 4416319.178736301],
              [-9544450.207594635, 4417033.560180865],
              [-9530397.1237574, 4415815.273794599],
              [-9528526.956312073, 4413774.028366921],
              [-9519756.650229925, 4401722.970521924],
              [-9514590.535301192, 4401985.49063925],
              [-9517474.934627136, 4396084.098260705],
              [-9510737.01886592, 4385994.363854711],
              [-9516519.92471562, 4385576.926380291],
              [-9543627.222599199, 4386330.72211929],
              [-9549938.430325055, 4386508.653270385],
              [-9559434.03369439, 4386776.36729949],
              [-9570772.611134253, 4387469.313611825],
              [-9567983.815865278, 4390574.883708956],
              [-9570905.84117911, 4400527.960599873],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pima',
        GEOID: '04019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12616271.703657314, 3829775.62302906],
              [-12531066.095611783, 3829812.714398252],
              [-12490460.864191554, 3830016.12499977],
              [-12444687.959369723, 3830018.633004283],
              [-12395595.729971416, 3829302.685233596],
              [-12373995.518616872, 3830609.480837423],
              [-12340736.260394093, 3830605.2566198255],
              [-12338882.902191876, 3830954.023648251],
              [-12295373.345256852, 3830971.185045972],
              [-12295405.071311729, 3819539.1375490655],
              [-12295431.008753082, 3728086.708010142],
              [-12362924.46129901, 3727427.466311797],
              [-12374740.246010277, 3727395.1399156954],
              [-12374689.261683496, 3700705.2346672015],
              [-12397274.65053156, 3700635.3697116766],
              [-12397314.321588071, 3688044.4366762014],
              [-12508419.369724289, 3729377.679565496],
              [-12616257.340439048, 3768595.1047039875],
              [-12616271.703657314, 3829775.62302906],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grant',
        GEOID: '40053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10921776.231371783, 4438862.583110307],
              [-10914357.546092357, 4438873.5951912645],
              [-10887303.67826377, 4438925.391735364],
              [-10883562.34479829, 4438932.55480292],
              [-10849458.731562298, 4438942.902568752],
              [-10849471.307340302, 4382613.990753218],
              [-10920919.162157677, 4382607.196926517],
              [-10921485.667046323, 4384960.7534368085],
              [-10921776.231371783, 4438862.583110307],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ochiltree',
        GEOID: '48357',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11252748.092678623, 4369535.818971088],
              [-11238164.811661048, 4369575.354725405],
              [-11230374.87878001, 4369596.473549302],
              [-11197918.568044322, 4369566.977101973],
              [-11192745.676663704, 4369571.981702225],
              [-11192810.11661182, 4308403.429563298],
              [-11252810.431593467, 4308546.084844097],
              [-11252748.092678623, 4369535.818971088],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harper',
        GEOID: '40059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11132235.33899225, 4439332.478828202],
              [-11131414.85709104, 4439334.13005539],
              [-11093839.742210206, 4439134.24654562],
              [-11080866.225038745, 4439094.192875734],
              [-11071413.811260788, 4439065.010147623],
              [-11062287.345739761, 4422337.42342507],
              [-11053489.543743387, 4413986.367509821],
              [-11053497.447427232, 4382821.412518326],
              [-11088040.775976311, 4382492.811716586],
              [-11132300.848918263, 4382561.719993577],
              [-11132235.33899225, 4439332.478828202],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yabucoa',
        GEOID: '72151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7348226.860539231, 2046395.1931564207],
              [-7339646.465508377, 2048525.2085326207],
              [-7338874.019561764, 2051594.791332457],
              [-7333462.55647532, 2051384.4302028927],
              [-7330178.854135901, 2051304.9011396787],
              [-7325146.065044617, 2045882.4251294555],
              [-7325843.739205938, 2044200.0643580034],
              [-7328511.844761271, 2040383.4137690873],
              [-7330490.721899339, 2038949.2426559262],
              [-7332023.974695798, 2040561.2352492127],
              [-7345808.778560221, 2044448.6394868623],
              [-7348226.860539231, 2046395.1931564207],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stephenson',
        GEOID: '17177',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10010570.407709464, 5237047.587678484],
              [-10000675.316838162, 5236915.213787509],
              [-9962339.234572442, 5236402.3814121885],
              [-9952120.195602246, 5236240.510122178],
              [-9951718.575914329, 5207103.806840273],
              [-9951538.572297717, 5191273.633265565],
              [-9984076.591539646, 5190852.277360198],
              [-10007411.04924126, 5190425.831327254],
              [-10009809.65030938, 5190508.47441118],
              [-10010628.61408458, 5237048.1140348],
              [-10010570.407709464, 5237047.587678484],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'LaPorte',
        GEOID: '18091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9677320.487060523, 5118606.209397346],
              [-9674680.096886415, 5120163.438167936],
              [-9665295.641173562, 5125131.945649456],
              [-9644867.949167958, 5125047.619483903],
              [-9644725.580386817, 5125047.031783627],
              [-9631832.083014052, 5125032.281019604],
              [-9632106.18027151, 5108760.02638553],
              [-9627625.68208657, 5096864.6777350325],
              [-9631886.769555157, 5076403.461186171],
              [-9645003.656474818, 5076366.786901376],
              [-9655852.074811095, 5059909.9539940385],
              [-9664162.854035247, 5052767.084051901],
              [-9670353.664876735, 5051441.832281813],
              [-9677012.128899043, 5047332.307275992],
              [-9677320.487060523, 5118606.209397346],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Onondaga',
        GEOID: '36067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8513628.271944707, 5346666.927203061],
              [-8489107.5937492, 5348187.030933107],
              [-8482405.826444972, 5344383.036392883],
              [-8483750.788532738, 5352925.865146951],
              [-8469007.635172075, 5342374.4207933],
              [-8459545.92373261, 5339925.326495586],
              [-8457563.768879546, 5325875.625390063],
              [-8451062.821936708, 5325037.412785477],
              [-8448712.867486063, 5280208.367441725],
              [-8490857.75878345, 5277219.3875385085],
              [-8500019.464195227, 5289084.604037996],
              [-8510457.22492997, 5288524.336060228],
              [-8515043.921909126, 5312727.448886393],
              [-8513628.271944707, 5346666.927203061],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gooding',
        GEOID: '16047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12811332.171955755, 5342167.963563269],
              [-12756613.076256322, 5342210.873306234],
              [-12756587.472773438, 5289304.924544042],
              [-12759138.69286344, 5287613.554478418],
              [-12759048.96935386, 5258742.86168502],
              [-12780831.967312288, 5261031.085049365],
              [-12785912.58887209, 5274800.022135599],
              [-12794352.276066585, 5276563.386212473],
              [-12790791.610834071, 5290551.176634411],
              [-12797324.506470764, 5299031.516455275],
              [-12805946.423671685, 5298566.256315958],
              [-12811409.761640836, 5298976.036656066],
              [-12811332.171955755, 5342167.963563269],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crittenden',
        GEOID: '21055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9836016.102810051, 4495690.301315589],
              [-9827470.216821345, 4502382.003543703],
              [-9813599.140351556, 4504393.179911389],
              [-9803049.72616755, 4507324.878911982],
              [-9803490.141706174, 4509612.079180099],
              [-9797848.656918706, 4515657.766927702],
              [-9788651.440589368, 4506232.760274519],
              [-9788322.714133054, 4496293.887797732],
              [-9779160.563443314, 4497910.442856448],
              [-9773967.731836788, 4492129.328709772],
              [-9806077.504997635, 4470105.290889607],
              [-9806777.481955744, 4464182.101472384],
              [-9816618.904178305, 4456710.532701527],
              [-9817657.626346897, 4459652.299033168],
              [-9820491.931901986, 4477248.373405603],
              [-9831529.704692101, 4494729.987840804],
              [-9836016.102810051, 4495690.301315589],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Appanoose',
        GEOID: '19007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10363576.869478412, 4997374.72846382],
              [-10312536.437671732, 4997438.792473201],
              [-10312404.222800016, 4952193.783384186],
              [-10317835.468072472, 4952025.561585676],
              [-10320941.756425606, 4951992.40766275],
              [-10346211.02891466, 4951722.708756472],
              [-10363543.051034534, 4951148.175642479],
              [-10363576.869478412, 4997374.72846382],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Elliott',
        GEOID: '21063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9268826.933253177, 4595738.832684241],
              [-9261669.646592623, 4603276.881882591],
              [-9266713.755359447, 4606638.414867829],
              [-9259308.226234425, 4617207.678702327],
              [-9245426.685732502, 4606236.876629192],
              [-9231147.066731505, 4604193.168810735],
              [-9227121.642624931, 4595373.796561843],
              [-9241979.5663806, 4580421.365460416],
              [-9261163.254229005, 4580930.268660904],
              [-9269324.08609906, 4587789.621359209],
              [-9268826.933253177, 4595738.832684241],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Caroline',
        GEOID: '24011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8461887.306582466, 4682565.140223639],
              [-8448790.234532164, 4695222.020519211],
              [-8454641.29828775, 4709980.217575889],
              [-8453705.991926106, 4718276.603310737],
              [-8441907.79569438, 4737216.166422805],
              [-8432246.02245282, 4742194.751838656],
              [-8429457.233108558, 4697324.917876361],
              [-8427726.474745816, 4669577.414014843],
              [-8442370.328178626, 4679378.0551206255],
              [-8454186.335528878, 4675097.409166541],
              [-8461887.306582466, 4682565.140223639],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'De Soto',
        GEOID: '22031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10468785.023057412, 3789066.914754741],
              [-10458586.941675562, 3789006.4063651324],
              [-10437845.671511978, 3808768.0444004983],
              [-10426903.967442416, 3805052.59700205],
              [-10421139.621570159, 3794530.149164037],
              [-10412375.772018477, 3788688.198777992],
              [-10412775.408990424, 3776729.117695667],
              [-10401860.866876615, 3761890.417792713],
              [-10392281.379415892, 3754416.9959714],
              [-10399442.450939134, 3754657.8240594934],
              [-10401823.5748472, 3743012.1547430507],
              [-10450479.197557107, 3742886.818516478],
              [-10453964.065861898, 3749292.275269894],
              [-10461523.104564724, 3753655.848183811],
              [-10467308.089804841, 3760644.520789534],
              [-10468688.96282607, 3762313.312893395],
              [-10468783.361754265, 3781433.149977378],
              [-10468785.023057412, 3789066.914754741],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cecil',
        GEOID: '24015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8486249.838422397, 4825574.736783532],
              [-8475387.068763297, 4825592.291699536],
              [-8436747.91465713, 4825654.735242456],
              [-8434333.239801401, 4775912.200040437],
              [-8458222.55762606, 4774355.308265746],
              [-8467127.317833286, 4777366.337573399],
              [-8464841.169270664, 4778301.0015262],
              [-8461047.178385448, 4781224.149273953],
              [-8461651.865859438, 4786785.809081822],
              [-8464472.065934364, 4786717.672405508],
              [-8464954.047234328, 4792714.78809111],
              [-8470797.875223013, 4803334.940246798],
              [-8483956.284312742, 4820475.607713335],
              [-8486249.838422397, 4825574.736783532],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Menominee',
        GEOID: '55078',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9905451.412553374, 5640121.5992464],
              [-9867488.683205599, 5640014.168843661],
              [-9849963.989728484, 5639941.7605289975],
              [-9850567.007410113, 5598792.895489422],
              [-9878067.931013137, 5598939.09517967],
              [-9877996.018622084, 5612580.45658213],
              [-9905355.12119384, 5612512.357353746],
              [-9905395.307530016, 5626075.02538471],
              [-9905451.412553374, 5640121.5992464],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wapello',
        GEOID: '19179',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10312677.81342504, 5036162.27230388],
              [-10287060.081647765, 5036257.496032078],
              [-10261427.767017197, 5036363.958450998],
              [-10261327.356836502, 4997561.619821107],
              [-10312536.437671732, 4997438.792473201],
              [-10312677.81342504, 5036162.27230388],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kootenai',
        GEOID: '16055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13028978.635399304, 6103105.122394984],
              [-12983650.17960462, 6103041.446203747],
              [-12969202.579492014, 6105421.891836799],
              [-12969288.85209738, 6088597.7989236675],
              [-12949744.934376767, 6088639.467825316],
              [-12949730.240203984, 6009914.979618759],
              [-12978355.268025037, 6010027.501389725],
              [-12983087.45957866, 6002914.360677814],
              [-13028887.790803267, 6002025.30163541],
              [-13029015.098492695, 6062930.6198294265],
              [-13028978.635399304, 6103105.122394984],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Haywood',
        GEOID: '47075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9963330.200679485, 4243067.853542835],
              [-9952163.408599539, 4276246.606665383],
              [-9947068.09286695, 4275557.156205003],
              [-9945139.037410991, 4271664.268035255],
              [-9915176.283269076, 4258416.4572190875],
              [-9916215.116757158, 4222666.14924983],
              [-9927756.164965149, 4222855.779714753],
              [-9927911.233015826, 4217980.80084658],
              [-9946117.201776592, 4218419.446888424],
              [-9949187.39333267, 4218364.54689412],
              [-9960219.154870285, 4218788.321859427],
              [-9959739.479184456, 4238407.591813426],
              [-9963330.200679485, 4243067.853542835],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adams',
        GEOID: '19003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10567290.647074176, 5035749.74553114],
              [-10542021.345303085, 5035687.202682469],
              [-10516419.420893501, 5035610.466263535],
              [-10516439.013123881, 4997529.513722157],
              [-10567387.717670146, 4997699.0292291455],
              [-10567290.647074176, 5035749.74553114],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Putnam',
        GEOID: '17155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9959352.86659293, 5046899.172795388],
              [-9947145.571232542, 5046775.867720669],
              [-9944715.689387506, 5056822.760195185],
              [-9925658.23784166, 5058202.397977884],
              [-9925494.820829175, 5027693.172674256],
              [-9947335.704922816, 5027671.455931248],
              [-9944088.849334847, 5034185.999717423],
              [-9959320.806579582, 5034273.664524151],
              [-9959352.86659293, 5046899.172795388],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Schuyler',
        GEOID: '17169',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10120274.096093873, 4894041.102116263],
              [-10120027.746060748, 4907356.114337448],
              [-10068873.211776005, 4906180.159945852],
              [-10069015.144126765, 4893429.637133944],
              [-10040968.643699363, 4892708.780747158],
              [-10041702.016504709, 4888607.005417118],
              [-10058219.602548616, 4884009.608284921],
              [-10067272.99409585, 4868930.743353205],
              [-10075944.225831194, 4864182.78861716],
              [-10086340.019117905, 4863277.227931058],
              [-10096212.276839416, 4881028.383011122],
              [-10120441.075330062, 4881133.025830563],
              [-10120274.096093873, 4894041.102116263],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Macon',
        GEOID: '47111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9597579.66096554, 4370606.4642442735],
              [-9596359.629386678, 4388941.037171354],
              [-9582598.17257509, 4388192.069340543],
              [-9570772.611134253, 4387469.313611825],
              [-9559434.03369439, 4386776.36729949],
              [-9549938.430325055, 4386508.653270385],
              [-9550882.02513369, 4384922.061789736],
              [-9552757.981192537, 4369567.531025119],
              [-9554332.150111845, 4357438.34784126],
              [-9561869.147555493, 4358629.386919667],
              [-9571126.587729353, 4359407.852802159],
              [-9592206.937061895, 4361928.881262986],
              [-9598905.364781396, 4367905.751825223],
              [-9597579.66096554, 4370606.4642442735],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cerro Gordo',
        GEOID: '19033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10408109.118575353, 5350937.874601066],
              [-10355400.230240664, 5350948.573913397],
              [-10355394.552946633, 5344420.3049472105],
              [-10355511.661050947, 5297910.43228002],
              [-10408218.43431531, 5298056.791810463],
              [-10408109.118575353, 5350937.874601066],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Branch',
        GEOID: '26023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9494843.014231918, 5171703.769873782],
              [-9442841.783900203, 5171840.987826764],
              [-9442690.087035272, 5125125.827998392],
              [-9484061.521207126, 5125076.854791076],
              [-9488075.791067105, 5125072.102934573],
              [-9494681.913926484, 5125059.60834548],
              [-9494843.014231918, 5171703.769873782],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '19041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10618552.27070906, 5350900.121411535],
              [-10565747.313653816, 5350874.596062465],
              [-10565765.90400878, 5298237.350643307],
              [-10618563.847936105, 5298267.292132957],
              [-10618552.27070906, 5350900.121411535],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rowan',
        GEOID: '37159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8991451.37880714, 4255604.766878324],
              [-8984354.093352124, 4280403.453832745],
              [-8982571.089068089, 4281856.499987721],
              [-8958082.025607966, 4268794.149634982],
              [-8956641.996675067, 4265320.199120218],
              [-8952672.56627236, 4262965.948657473],
              [-8942796.635007652, 4262226.46740049],
              [-8942361.709757123, 4256514.14269554],
              [-8928881.698658494, 4243249.897792492],
              [-8925881.638381615, 4232606.071216467],
              [-8938445.378751524, 4232437.740897107],
              [-8987643.918263538, 4232832.111032761],
              [-8988338.329247108, 4240184.018882198],
              [-8991451.37880714, 4255604.766878324],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Albany',
        GEOID: '56001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11835809.417871784, 5070800.743294821],
              [-11807480.945174202, 5070783.974909896],
              [-11808206.302976212, 5179933.447180053],
              [-11808037.208669698, 5226098.645625218],
              [-11750444.845593398, 5225698.511854751],
              [-11752626.707612947, 5217667.895257929],
              [-11756881.672509538, 5206694.992696331],
              [-11747145.001927814, 5204347.813624545],
              [-11730351.566185722, 5204540.430177269],
              [-11725575.626072217, 5225777.391012723],
              [-11720151.249924844, 5225822.0341930315],
              [-11718804.172766754, 5122414.6276993],
              [-11719519.623134082, 5109685.978850002],
              [-11719366.446850732, 5012072.173349555],
              [-11719397.394333191, 5012072.185499379],
              [-11821078.407097464, 5012009.295398079],
              [-11824086.139657363, 5012007.435110011],
              [-11835618.417661019, 5012078.381952536],
              [-11835809.417871784, 5070800.743294821],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Aleutians West',
        GEOID: '02016',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [19979768.926665604, 6795660.789875537],
              [19991072.196441263, 6803171.09617542],
              [19997082.2244297, 6804775.849605448],
              [20012341.45494968, 6794828.106578651],
              [20008900.56948926, 6784184.2439922625],
              [19998489.08015435, 6777315.522663754],
              [19986692.776353966, 6780427.452989567],
              [19980138.062097076, 6785902.198895698],
              [19979768.926665604, 6795660.789875537],
            ],
          ],
          [
            [
              [19881715.93618762, 6738029.747000419],
              [19888407.016820733, 6743021.164472314],
              [19917876.625618435, 6732406.070432236],
              [19947923.648614883, 6706262.885129524],
              [19959115.487580255, 6695788.742910749],
              [19972747.115825348, 6695246.637844604],
              [19979668.73912389, 6685910.4830032205],
              [19954382.85074867, 6681165.598059923],
              [19929699.089499153, 6701262.148139224],
              [19918420.86660892, 6715601.444181967],
              [19911633.717255257, 6720415.82793671],
              [19900852.53589142, 6719902.518515553],
              [19882202.73632086, 6730991.61528541],
              [19881715.93618762, 6738029.747000419],
            ],
          ],
          [
            [
              [19866453.14344394, 6797928.695874896],
              [19876385.84764895, 6795419.902853151],
              [19880725.637997523, 6791568.852201739],
              [19874914.537939135, 6782649.961022211],
              [19870806.626089882, 6782000.1030158745],
              [19863010.69951064, 6793895.776380951],
              [19866453.14344394, 6797928.695874896],
            ],
          ],
          [
            [
              [19837627.740539454, 6769605.765365151],
              [19851571.28599775, 6770668.980634044],
              [19856949.130597968, 6762716.077977141],
              [19856511.088401698, 6754662.358824101],
              [19845031.93383059, 6757778.921951696],
              [19837627.740539454, 6769605.765365151],
            ],
          ],
          [
            [
              [19825296.991863776, 6810101.80166108],
              [19832098.16747328, 6811238.787093413],
              [19837279.421852764, 6805823.425457563],
              [19837233.44690307, 6798526.503709263],
              [19828332.451738726, 6795969.995949534],
              [19823687.423346393, 6803554.391844402],
              [19825296.991863776, 6810101.80166108],
            ],
          ],
          [
            [
              [19727270.495424595, 6785737.949620371],
              [19738150.973774225, 6788069.337636976],
              [19744444.532505713, 6794409.267446239],
              [19754816.837379865, 6800080.432129019],
              [19761547.99302966, 6811535.914248081],
              [19768256.66214232, 6826372.654052338],
              [19775757.70339044, 6823828.547081966],
              [19778796.502850115, 6816807.616924014],
              [19771353.125098225, 6805283.517958922],
              [19767232.18886855, 6800453.0938680805],
              [19771627.638962522, 6791239.585279847],
              [19770453.440973632, 6786080.169451212],
              [19759129.46577269, 6786040.27915922],
              [19749139.209390935, 6787626.656274766],
              [19744878.678519804, 6782415.233948617],
              [19740756.072497766, 6776071.337290465],
              [19738255.72541506, 6768719.738993899],
              [19732737.28429796, 6775191.994934235],
              [19723452.57084886, 6778316.09365521],
              [19727270.495424595, 6785737.949620371],
            ],
          ],
          [
            [
              [19354451.05672579, 6944704.760231152],
              [19377082.420523554, 6938292.550406412],
              [19385188.928482097, 6937023.4508803785],
              [19387196.130220596, 6928810.799680897],
              [19366821.323820703, 6929068.018177804],
              [19349446.91165616, 6938691.346663539],
              [19354451.05672579, 6944704.760231152],
            ],
          ],
          [
            [
              [19307144.058001336, 6885654.212700969],
              [19320136.48973029, 6887288.80342597],
              [19329300.532851376, 6895469.855761034],
              [19344299.49840188, 6892853.178650701],
              [19336446.242284883, 6879128.664287958],
              [19341572.393516425, 6871379.921220908],
              [19339056.016427044, 6864858.093203575],
              [19330773.51235355, 6864819.999231988],
              [19318804.99730091, 6871438.294523504],
              [19312415.48116836, 6867051.80788601],
              [19293888.355676655, 6874976.50691092],
              [19307144.058001336, 6885654.212700969],
            ],
          ],
          [
            [
              [19198038.155282486, 6974594.951936967],
              [19218560.46000768, 6983918.953739139],
              [19235214.5237473, 6984582.925771775],
              [19271851.549279217, 6981213.500876324],
              [19286249.389579438, 6972713.020038547],
              [19305622.988479137, 6958682.341280513],
              [19305451.22250484, 6951392.941368444],
              [19289933.062849276, 6951233.3883562265],
              [19281086.614235427, 6955099.298447762],
              [19276851.018930234, 6945210.285523858],
              [19268984.9610718, 6943655.335645977],
              [19256334.94809653, 6944446.487047183],
              [19247543.8252696, 6939033.871103597],
              [19237052.96513775, 6944116.984528316],
              [19231929.93085195, 6950445.434723924],
              [19230913.58390101, 6960368.9585436955],
              [19221530.13006357, 6966923.491402109],
              [19212082.66751893, 6968458.782520242],
              [19199590.61690109, 6962719.934568054],
              [19198038.155282486, 6974594.951936967],
            ],
          ],
          [
            [
              [-18678400.66469083, 7045302.798992598],
              [-18667664.56772076, 7055098.746429506],
              [-18656169.160503995, 7056090.318264598],
              [-18641268.71270284, 7065326.354189511],
              [-18631519.90829662, 7066794.178102445],
              [-18621393.8421361, 7072014.78700027],
              [-18611286.700289015, 7080531.753282577],
              [-18605460.46077988, 7085618.0698090345],
              [-18608348.64496851, 7095870.670810429],
              [-18602359.21108587, 7100965.528775258],
              [-18598350.26226393, 7107070.084746883],
              [-18594946.334874455, 7115034.453317922],
              [-18590998.16649449, 7123976.070518034],
              [-18601279.300705686, 7132366.862008887],
              [-18606158.545306645, 7137447.183972563],
              [-18606050.12012261, 7144965.151175733],
              [-18593833.919202957, 7159785.410209004],
              [-18576939.628002204, 7168019.5290514715],
              [-18561699.878393117, 7173092.544604954],
              [-18550795.02107501, 7172901.951572213],
              [-18544423.761338945, 7162552.433718074],
              [-18535628.964968823, 7155766.28148724],
              [-18527691.328677807, 7161760.270062878],
              [-18518789.554277036, 7170600.042641757],
              [-18508481.59206856, 7165905.678706755],
              [-18504154.04686397, 7167548.682608327],
              [-18504153.712905496, 7162623.386100162],
              [-18496949.52202229, 7157976.3224338135],
              [-18502488.818601195, 7154248.9805721715],
              [-18506969.428105623, 7146867.760289724],
              [-18514658.15401522, 7145484.891604092],
              [-18524108.288227648, 7134130.887968124],
              [-18516524.313958883, 7129936.363304592],
              [-18501160.33179807, 7139176.501701876],
              [-18491618.69296421, 7142500.389738957],
              [-18489892.46162048, 7137447.372577331],
              [-18494470.698318336, 7119390.058101917],
              [-18506203.661328454, 7115557.119685342],
              [-18514686.87444385, 7108707.831783633],
              [-18528562.515012756, 7102390.580891848],
              [-18535695.088746354, 7091723.746939826],
              [-18543713.320348702, 7081725.772490057],
              [-18552087.106404644, 7073614.997651496],
              [-18562431.35876712, 7064980.792427261],
              [-18576783.669395603, 7062914.090095508],
              [-18589723.669644397, 7062786.480448968],
              [-18598746.893609628, 7061997.700295702],
              [-18608872.737131163, 7059721.475656526],
              [-18622841.44079438, 7050632.980274445],
              [-18624655.391896855, 7045080.956521892],
              [-18636854.560934413, 7044246.958773797],
              [-18644702.807674326, 7032933.998151938],
              [-18650383.663928486, 7034561.544626152],
              [-18659614.944022007, 7029443.053653304],
              [-18673594.556995317, 7033761.039819024],
              [-18685144.73340156, 7040298.493974706],
              [-18678400.66469083, 7045302.798992598],
            ],
          ],
          [
            [
              [-18844889.204565324, 6943280.771677984],
              [-18817943.876540847, 6963401.337619891],
              [-18808481.05190647, 6971304.909463248],
              [-18797527.325331908, 6986029.092151143],
              [-18789086.524942506, 6991333.080387677],
              [-18791275.622728955, 7005228.374749425],
              [-18786648.07149668, 7016885.042579206],
              [-18766450.263087146, 7036173.409897104],
              [-18751220.8661907, 7032228.390890311],
              [-18748486.636857837, 7042921.205433877],
              [-18745685.170552533, 7056917.3449909445],
              [-18739759.85669659, 7071533.514832901],
              [-18728204.2256353, 7080125.236002618],
              [-18704680.747438323, 7087778.409207499],
              [-18692175.44980108, 7080277.654135178],
              [-18678204.297109067, 7079643.471655858],
              [-18680314.135418072, 7071134.9395729145],
              [-18685737.62100952, 7062675.8746250225],
              [-18684122.486517604, 7054810.370092582],
              [-18697121.04081855, 7046471.3957919665],
              [-18711917.070937343, 7036499.099585897],
              [-18734650.514708158, 7025141.354977062],
              [-18739865.387573864, 7014608.130975745],
              [-18747596.192250982, 7003497.579763687],
              [-18752558.92647004, 6993333.310551691],
              [-18770020.613115363, 6984621.407871885],
              [-18778314.360457424, 6976785.24653747],
              [-18785779.77946849, 6965907.510856593],
              [-18796409.23236638, 6966005.891408872],
              [-18813554.77165785, 6951612.746511953],
              [-18831959.557029173, 6941792.996201196],
              [-18842133.49057073, 6937788.565081915],
              [-18844889.204565324, 6943280.771677984],
            ],
          ],
          [
            [
              [-18904087.796574276, 7685597.940994244],
              [-18881309.71368765, 7683401.987996733],
              [-18865795.22757528, 7683892.081467111],
              [-18863509.17051235, 7675519.689342999],
              [-18877851.351067174, 7666056.10568903],
              [-18889339.633836526, 7666616.964057706],
              [-18904087.796574276, 7685597.940994244],
            ],
          ],
          [
            [
              [-18943313.779503576, 6943312.245420806],
              [-18934579.429616954, 6968100.59540587],
              [-18927245.812882982, 6972814.624914104],
              [-18908457.86582435, 6966096.889882865],
              [-18897901.772470895, 6978938.796103462],
              [-18904297.967772897, 6995361.831081098],
              [-18896200.4766931, 7000256.039173586],
              [-18888694.87134585, 6989488.483236471],
              [-18886730.304972336, 6974078.328031607],
              [-18887189.72051084, 6957945.46847395],
              [-18891348.728006367, 6941876.54281927],
              [-18904114.290613085, 6944537.9770228015],
              [-18918914.216914054, 6943992.73430515],
              [-18932966.74415383, 6931448.967085337],
              [-18947455.30983905, 6929332.594384325],
              [-18943313.779503576, 6943312.245420806],
            ],
          ],
          [
            [
              [-18971072.853005752, 7803762.14986855],
              [-18958053.37064053, 7808926.157400492],
              [-18940342.99625278, 7809908.481736086],
              [-18939217.33356187, 7797271.411286186],
              [-18956186.208821453, 7786360.548595933],
              [-18971275.45447899, 7793138.585738531],
              [-18971072.853005752, 7803762.14986855],
            ],
          ],
          [
            [
              [-19015366.43311443, 6916000.002958603],
              [-18999069.482301272, 6927345.362872257],
              [-18983551.433965202, 6924019.225561088],
              [-18989430.88419094, 6907000.58827788],
              [-19000669.032064483, 6905909.002998507],
              [-19012088.29674955, 6898403.471396105],
              [-19018037.32165703, 6901686.049737408],
              [-19015366.43311443, 6916000.002958603],
            ],
          ],
          [
            [
              [-19070437.855002224, 6889853.57272531],
              [-19064216.208661787, 6896269.626934853],
              [-19057452.99299864, 6891061.107314525],
              [-19060872.282477845, 6879030.978369798],
              [-19069492.975164372, 6881895.037505019],
              [-19070437.855002224, 6889853.57272531],
            ],
          ],
          [
            [
              [-19215110.446349017, 6855795.16539928],
              [-19207634.45198632, 6865092.129020628],
              [-19196843.808465764, 6871214.471691154],
              [-19183291.99629557, 6866661.4747470375],
              [-19180509.120345235, 6860006.116006007],
              [-19193085.328498114, 6850319.103810913],
              [-19205739.682933528, 6846243.956092084],
              [-19218195.999994826, 6844503.678430364],
              [-19215110.446349017, 6855795.16539928],
            ],
          ],
          [
            [
              [-19514479.94918853, 6810185.259646264],
              [-19484385.504089005, 6816797.108136447],
              [-19468358.72568001, 6823411.830274355],
              [-19449207.654442403, 6823189.3362369975],
              [-19431336.979987904, 6829180.862169765],
              [-19421128.092126235, 6838736.226696032],
              [-19420350.74812203, 6857044.580905136],
              [-19406306.569844056, 6867951.59692639],
              [-19390224.13168966, 6876022.2851053495],
              [-19377188.73063726, 6871012.361553867],
              [-19367944.203524332, 6857756.590392663],
              [-19374822.74617994, 6842957.908140459],
              [-19372111.44866218, 6824338.682685972],
              [-19358455.66408759, 6825469.691838434],
              [-19331119.82728941, 6826602.129196343],
              [-19317262.665755972, 6828991.960585875],
              [-19300042.208447196, 6819718.17098459],
              [-19277686.360389147, 6822990.42051232],
              [-19252462.254331317, 6819562.840057768],
              [-19256070.230347417, 6811714.630353907],
              [-19277146.906136762, 6808057.983445252],
              [-19302128.447024155, 6805311.742793539],
              [-19315384.038029347, 6804703.121395],
              [-19335674.13029674, 6810134.026117286],
              [-19349630.92277444, 6807960.611319028],
              [-19358579.117402878, 6809068.87671746],
              [-19380705.09071244, 6813168.588278406],
              [-19400569.274608064, 6816322.415081967],
              [-19412189.025696043, 6814903.756291518],
              [-19415086.894680377, 6802442.1790463235],
              [-19431515.9817291, 6806769.978938826],
              [-19451588.444392, 6801446.942400909],
              [-19468922.447581384, 6803685.899544009],
              [-19482559.19652305, 6801391.243148724],
              [-19498240.327913135, 6802207.239352944],
              [-19516902.929225136, 6801479.494089403],
              [-19514479.94918853, 6810185.259646264],
            ],
          ],
          [
            [
              [-19697998.14476458, 6743677.246152746],
              [-19694320.148788765, 6763506.229668249],
              [-19679269.864953008, 6769872.907161764],
              [-19677109.042317223, 6776271.266682331],
              [-19682447.368498214, 6786952.931552491],
              [-19678394.22583843, 6793961.180540966],
              [-19670017.211517256, 6793700.831756045],
              [-19656792.901288975, 6800710.9475018745],
              [-19653358.027081057, 6792094.298179684],
              [-19653974.95969904, 6783838.675677051],
              [-19656392.819039065, 6771656.840063419],
              [-19640283.99816535, 6775061.850271472],
              [-19626914.52732108, 6777097.898143434],
              [-19611585.610799864, 6778898.569748605],
              [-19611003.632502, 6790733.15806137],
              [-19612604.406779606, 6799927.28596669],
              [-19615739.7202378, 6811833.59554399],
              [-19608873.75668465, 6821411.598639469],
              [-19598462.37866923, 6819943.107058254],
              [-19593075.18323178, 6812109.195904027],
              [-19579708.495374776, 6799247.113350454],
              [-19570840.116821237, 6798256.969522982],
              [-19554857.53225008, 6799015.701355191],
              [-19531056.97984052, 6802429.699399166],
              [-19528205.976361815, 6795124.270360975],
              [-19552126.308543473, 6788136.500217985],
              [-19568755.102758683, 6785551.1426781835],
              [-19588116.12255592, 6772373.622435999],
              [-19592059.392878294, 6764320.940404655],
              [-19609839.453267284, 6758447.169530231],
              [-19624504.237706423, 6753551.619249107],
              [-19644222.147791147, 6750853.611358838],
              [-19652782.393994167, 6745832.238384444],
              [-19665256.52217399, 6738577.03973961],
              [-19671871.014997434, 6731781.736299464],
              [-19682287.847667906, 6731031.056765948],
              [-19696750.141953297, 6726504.960583402],
              [-19702145.35239408, 6729352.6322566485],
              [-19697998.14476458, 6743677.246152746],
            ],
          ],
          [
            [
              [-19778147.17626032, 6753857.785615707],
              [-19758332.86349657, 6758699.912759567],
              [-19738409.45763185, 6760124.23646765],
              [-19728950.41786016, 6764724.365897398],
              [-19725762.450282823, 6783911.758086842],
              [-19723728.86582501, 6789855.835206159],
              [-19714600.110982507, 6788583.181656369],
              [-19708569.266249295, 6781812.66059691],
              [-19714532.762690578, 6769381.863002372],
              [-19715259.345006984, 6749535.490307356],
              [-19724693.894490696, 6745562.473906153],
              [-19734176.20003596, 6742562.441495338],
              [-19742290.166400388, 6745436.036113982],
              [-19757423.939854246, 6742879.864264416],
              [-19776061.82823929, 6737733.3270969475],
              [-19782342.028631885, 6746649.309399914],
              [-19778147.17626032, 6753857.785615707],
            ],
          ],
          [
            [
              [-19836809.319643144, 6783050.149371478],
              [-19824958.469292272, 6785564.859756413],
              [-19809536.48967675, 6784833.735755352],
              [-19802337.346887663, 6773209.227751579],
              [-19787866.48100148, 6772515.797206729],
              [-19772045.977608923, 6773964.355989129],
              [-19775827.166752696, 6764376.565485523],
              [-19787598.53498714, 6759154.690497982],
              [-19795669.420708634, 6748233.393082754],
              [-19800170.73563835, 6742358.493133977],
              [-19804759.8816463, 6727524.380642221],
              [-19819952.20915232, 6733510.337532815],
              [-19827989.921665553, 6742081.483439463],
              [-19820969.446659185, 6746918.750695212],
              [-19812824.422156822, 6748867.795788209],
              [-19814343.042650227, 6760720.162587444],
              [-19824451.075053234, 6765492.027841945],
              [-19839819.2873547, 6775730.981910154],
              [-19836809.319643144, 6783050.149371478],
            ],
          ],
          [
            [
              [-19913871.01638122, 6722809.311845956],
              [-19890360.56256466, 6732783.7064605495],
              [-19876259.277387913, 6729944.693146649],
              [-19879967.774904206, 6721646.684879081],
              [-19896642.98934707, 6717791.432811199],
              [-19906814.362540342, 6718643.283930492],
              [-19913871.01638122, 6722809.311845956],
            ],
          ],
          [
            [
              [-19912479.077468343, 6770871.659473002],
              [-19901660.381436106, 6773327.628653219],
              [-19896506.066373397, 6761154.179792192],
              [-19903079.927582704, 6754341.418950144],
              [-19914606.949534856, 6760303.441534765],
              [-19912479.077468343, 6770871.659473002],
            ],
          ],
          [
            [
              [-19945587.943059057, 6670804.913875804],
              [-19925698.04436106, 6694941.2398868],
              [-19918048.50291222, 6689437.825203625],
              [-19916045.75395336, 6681761.297765766],
              [-19934239.47757014, 6665806.808980852],
              [-19940310.39732004, 6660277.299396559],
              [-19945587.943059057, 6670804.913875804],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Boulder',
        GEOID: '08013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11765768.196140073, 4857576.257454251],
              [-11759657.090053994, 4871580.302524867],
              [-11761273.894338278, 4903863.681537658],
              [-11706253.011499302, 4903974.83907162],
              [-11694679.012722036, 4904058.572738929],
              [-11694712.853847235, 4886054.670743449],
              [-11694714.74627858, 4868516.182282677],
              [-11694426.762755899, 4865980.062066537],
              [-11696550.293362271, 4858707.825590646],
              [-11700737.90996693, 4859695.021876218],
              [-11707042.266689027, 4853459.673926041],
              [-11726344.732434109, 4853421.7938299],
              [-11732834.881386336, 4853291.1739157885],
              [-11732856.25472857, 4856479.9514133055],
              [-11763776.022532837, 4856130.22169848],
              [-11765768.196140073, 4857576.257454251],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '13303',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9244981.407769332, 3893393.423740911],
              [-9245328.279302642, 3906018.05262206],
              [-9240490.668191241, 3906040.2394111957],
              [-9227146.355551885, 3913715.6773145837],
              [-9223381.530373259, 3921405.4799963357],
              [-9211499.84452344, 3926983.5760154417],
              [-9210517.116058715, 3918471.3356411606],
              [-9201882.508435845, 3912084.3208525567],
              [-9194769.304293646, 3899553.925020013],
              [-9189449.011870163, 3897872.7667576866],
              [-9185065.918239668, 3884392.263902921],
              [-9186201.488365248, 3871748.362144474],
              [-9213732.245591806, 3864696.8613062934],
              [-9217527.238352438, 3870079.393864404],
              [-9233614.017966976, 3863406.150047319],
              [-9234548.879050659, 3863022.670564007],
              [-9236652.928746141, 3873984.620875057],
              [-9242527.369594794, 3876223.557669467],
              [-9247716.193699649, 3888213.108824059],
              [-9244981.407769332, 3893393.423740911],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greene',
        GEOID: '18055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9711594.4192699, 4746306.533589738],
              [-9690871.294183314, 4745777.128686991],
              [-9649507.643072315, 4745441.149735716],
              [-9649426.936441489, 4720583.569154775],
              [-9649491.056468187, 4708029.414901123],
              [-9674137.080410326, 4707958.8920199815],
              [-9688738.635378698, 4707709.419470054],
              [-9695790.836439943, 4707925.991046203],
              [-9699254.09711801, 4708403.923923786],
              [-9711626.701922232, 4708483.891543412],
              [-9711594.4192699, 4746306.533589738],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Logan',
        GEOID: '20109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11296500.99402052, 4740993.353632782],
              [-11286874.307095699, 4741044.445158808],
              [-11222324.698483802, 4740792.290894143],
              [-11223086.123800829, 4678769.969880646],
              [-11257559.65502918, 4678875.808055769],
              [-11297189.839029549, 4678813.474657987],
              [-11296500.99402052, 4740993.353632782],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Caldwell',
        GEOID: '21033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9806077.504997635, 4470105.290889607],
              [-9773967.731836788, 4492129.328709772],
              [-9775344.419979429, 4488095.531738824],
              [-9779501.869002085, 4484104.016722536],
              [-9774411.117368618, 4472764.135120881],
              [-9760561.636880046, 4459929.244561424],
              [-9763934.060853628, 4442118.952486982],
              [-9766433.851338882, 4439399.922383969],
              [-9780317.618230619, 4432239.179186221],
              [-9782422.447162537, 4433548.929122923],
              [-9800806.415789085, 4463493.593761188],
              [-9806777.481955744, 4464182.101472384],
              [-9806077.504997635, 4470105.290889607],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Otsego',
        GEOID: '26137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9446288.346654654, 5639913.365270473],
              [-9432634.677150387, 5639628.786626626],
              [-9432579.462682953, 5653368.39690312],
              [-9391648.510432664, 5652863.009636543],
              [-9392218.800183998, 5598729.139973659],
              [-9445159.233059537, 5599199.936373015],
              [-9446288.346654654, 5639913.365270473],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Roscommon',
        GEOID: '26143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9445562.209616208, 5544874.945403784],
              [-9392097.016661072, 5544274.592557128],
              [-9391807.140707046, 5490319.512608079],
              [-9418531.054264333, 5490310.822936806],
              [-9445648.593541065, 5490449.393141987],
              [-9445562.209616208, 5544874.945403784],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sandoval',
        GEOID: '35043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11980680.38055117, 4330909.055893809],
              [-11898389.673372058, 4330462.13472535],
              [-11898419.061717628, 4300479.508961561],
              [-11827380.194709428, 4300818.690026847],
              [-11827491.180241749, 4295989.007828704],
              [-11844361.871710451, 4295131.893909868],
              [-11846484.177802425, 4275879.910239948],
              [-11827751.445211224, 4267074.11444252],
              [-11827567.656731922, 4224285.7642603],
              [-11827157.333088858, 4196361.705065204],
              [-11827052.024850568, 4193226.8259777813],
              [-11866515.786212202, 4193525.912109914],
              [-11870087.917352267, 4193735.7541330205],
              [-11881016.819680387, 4193543.080853163],
              [-11884809.697370697, 4193545.2610129435],
              [-11933142.616522301, 4193744.883714015],
              [-11937778.628035877, 4205476.219985262],
              [-11945626.20685884, 4205500.7733138725],
              [-11945546.16814496, 4300422.681690205],
              [-11980928.400376655, 4300661.000472492],
              [-11980680.38055117, 4330909.055893809],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Auglaize',
        GEOID: '39011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9401618.951945053, 4965969.4177122945],
              [-9395006.351552954, 4965978.8129237285],
              [-9375639.097864231, 4966130.165151243],
              [-9362836.020589115, 4959836.123048938],
              [-9337500.483721001, 4960073.939849492],
              [-9337471.318014413, 4944537.462185802],
              [-9350135.802523492, 4944023.772489308],
              [-9351101.27646714, 4936397.610325518],
              [-9388589.784784138, 4936099.190929046],
              [-9388530.006217582, 4921200.426121367],
              [-9399192.966282198, 4917596.739923255],
              [-9401546.81691502, 4918974.210706439],
              [-9401490.823211152, 4931743.065416301],
              [-9401566.965742856, 4948812.661448898],
              [-9401618.951945053, 4965969.4177122945],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brule',
        GEOID: '46015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11065932.279826803, 5419945.825755704],
              [-11066287.277682945, 5430629.943178477],
              [-11055230.580579393, 5443063.795462449],
              [-11060244.18780574, 5455291.555182031],
              [-11012502.931747701, 5455410.892809594],
              [-10999230.754138384, 5455423.259491716],
              [-10998027.83572087, 5442038.640999107],
              [-10997763.229291255, 5388264.5067119],
              [-11053789.661090566, 5388367.173902961],
              [-11062416.47634908, 5412494.513325643],
              [-11072849.227706734, 5414946.52714011],
              [-11065932.279826803, 5419945.825755704],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Beadle',
        GEOID: '46005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10987875.164202051, 5564110.014106241],
              [-10906837.803169781, 5563710.021490505],
              [-10893305.249271497, 5563643.696690557],
              [-10892949.24953994, 5550079.195244302],
              [-10893019.603458121, 5495704.815940787],
              [-10946258.149930006, 5495930.572737442],
              [-10987284.16902543, 5495936.7834570715],
              [-10987875.164202051, 5564110.014106241],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Comal',
        GEOID: '48091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10981236.292410122, 3470837.109932164],
              [-10955398.370680058, 3495525.900624104],
              [-10942438.778200889, 3508434.5534264497],
              [-10922809.81238931, 3492351.664667591],
              [-10912707.902558293, 3484095.7633790933],
              [-10910999.927611051, 3478058.0282647056],
              [-10909228.94583202, 3471768.3527210997],
              [-10919322.284062248, 3462928.559673794],
              [-10931310.168706283, 3457118.866654322],
              [-10943922.44437418, 3451528.910778357],
              [-10943924.893402977, 3451540.0485882503],
              [-10945895.35970951, 3453290.596437799],
              [-10951396.434986042, 3460255.194015219],
              [-10948560.125680119, 3469450.435827275],
              [-10958719.476368386, 3467564.127299718],
              [-10958897.142275691, 3469613.377665428],
              [-10970590.252908109, 3472828.664335692],
              [-10981236.292410122, 3470837.109932164],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Roberts',
        GEOID: '48393',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11252849.616054226, 4249180.445387025],
              [-11252812.546663793, 4308229.932428364],
              [-11252810.431593467, 4308546.084844097],
              [-11192810.11661182, 4308403.429563298],
              [-11192086.20596319, 4308397.233189219],
              [-11192079.192835271, 4248362.743728253],
              [-11252834.810561951, 4248336.17732279],
              [-11252849.616054226, 4249180.445387025],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Boone',
        GEOID: '54005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9120684.958656322, 4583008.384766097],
              [-9122995.506007226, 4596232.925371062],
              [-9114703.985054981, 4598826.025942595],
              [-9109660.210246628, 4609073.473597823],
              [-9088554.034792224, 4610658.766433289],
              [-9074301.355107997, 4595310.694725417],
              [-9067710.795975072, 4577632.872817695],
              [-9080501.628106201, 4569218.2642727895],
              [-9074122.353366803, 4549972.771746115],
              [-9081057.780282205, 4546043.201588283],
              [-9084508.907135777, 4549620.330119379],
              [-9097266.566058649, 4552550.381568979],
              [-9104335.910321478, 4570445.722324837],
              [-9125999.462466285, 4577518.891135577],
              [-9120684.958656322, 4583008.384766097],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Juana Díaz',
        GEOID: '72075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7408002.64410795, 2055479.949833792],
              [-7405183.923281573, 2055342.1814391466],
              [-7404777.050542725, 2047503.5605388882],
              [-7394988.727717272, 2047154.9423993588],
              [-7394618.590410383, 2042538.5636649928],
              [-7393957.909232526, 2039808.7529961735],
              [-7397547.156131614, 2035223.291597995],
              [-7403875.251347809, 2035865.2255981164],
              [-7407258.731154231, 2034678.2400986494],
              [-7406132.142704152, 2037858.0226158078],
              [-7408620.022003889, 2055354.2478516335],
              [-7408002.64410795, 2055479.949833792],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Loíza',
        GEOID: '72087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7346061.139845851, 2091510.8376635343],
              [-7336509.704896805, 2090396.7847203414],
              [-7328326.38648961, 2087571.4995772622],
              [-7327910.21607516, 2087420.5467666725],
              [-7332330.659892934, 2081863.815924447],
              [-7332609.181258898, 2085467.3140753654],
              [-7338100.46042024, 2084772.537508291],
              [-7339338.555796845, 2087762.6400418717],
              [-7346285.309988771, 2091481.7978603742],
              [-7346061.139845851, 2091510.8376635343],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Trimble',
        GEOID: '21223',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9512123.806704704, 4680696.767509477],
              [-9506738.058420634, 4683923.224751777],
              [-9500111.431772692, 4683625.392471389],
              [-9499186.11452656, 4683757.21883632],
              [-9485686.87479468, 4661718.256282865],
              [-9480888.448144037, 4662463.322268661],
              [-9493284.652680302, 4649771.004579442],
              [-9497111.705454286, 4649248.164629953],
              [-9504318.19532977, 4652979.459344229],
              [-9510354.969988374, 4653733.763817934],
              [-9508421.097801937, 4656895.579937239],
              [-9510181.734744422, 4662582.608088621],
              [-9510710.939727554, 4664292.609757216],
              [-9510997.253457874, 4672988.765514839],
              [-9512123.806704704, 4680696.767509477],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grant',
        GEOID: '27051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10716211.52414811, 5797771.1641584085],
              [-10661039.803399112, 5797584.90935736],
              [-10659788.349683613, 5741961.262445673],
              [-10714948.715844551, 5741943.391766249],
              [-10714910.087981246, 5769882.69414583],
              [-10716297.685433984, 5783812.914431646],
              [-10716211.52414811, 5797771.1641584085],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '28037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10147201.72431931, 3712234.126352287],
              [-10100833.371541226, 3712372.1597471233],
              [-10089245.123869136, 3712409.4133464317],
              [-10089253.027552983, 3678196.7506521465],
              [-10128181.453483392, 3678113.9793511173],
              [-10137391.916832136, 3676840.1538792076],
              [-10140693.318970593, 3674504.3906123163],
              [-10143205.688558305, 3674418.256197034],
              [-10147678.83965685, 3677856.4142791433],
              [-10147201.72431931, 3712234.126352287],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Texas',
        GEOID: '29215',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10269474.71904817, 4505235.713940437],
              [-10269163.24711293, 4523710.646130042],
              [-10244650.1386428, 4523429.485180917],
              [-10220142.818786187, 4522912.567817069],
              [-10214097.057241205, 4522899.220194325],
              [-10214124.330516448, 4498388.281074415],
              [-10202055.739241587, 4498194.984555004],
              [-10203055.4995884, 4445928.49712607],
              [-10251268.082370458, 4446949.935764262],
              [-10269374.308867473, 4447424.911105524],
              [-10269474.71904817, 4505235.713940437],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wolfe',
        GEOID: '21237',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9309767.013701709, 4554786.019964875],
              [-9300900.416260025, 4554256.553696988],
              [-9294629.78934364, 4559936.087590606],
              [-9293425.089814276, 4557398.936843519],
              [-9282535.705905387, 4553137.674517295],
              [-9268702.589381961, 4538913.03144728],
              [-9267202.002646066, 4532858.194209653],
              [-9286102.04843193, 4535827.848216017],
              [-9294675.207695883, 4525825.848430042],
              [-9297660.796438958, 4528485.354686709],
              [-9308162.788519887, 4532479.751680913],
              [-9318329.041016584, 4539448.613628897],
              [-9309767.013701709, 4554786.019964875],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Baylor',
        GEOID: '48023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11073578.704329904, 4006534.6720119263],
              [-11015420.059003938, 4006537.352297151],
              [-11015501.990149165, 3948189.612735426],
              [-11073221.814042421, 3948388.153625773],
              [-11073450.46427651, 3993120.1918941448],
              [-11073578.704329904, 4006534.6720119263],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hancock',
        GEOID: '47067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9292070.952084968, 4383424.945663836],
              [-9270275.31114789, 4383246.251467463],
              [-9237787.663482662, 4382844.563178929],
              [-9220641.623746363, 4382632.569811528],
              [-9234009.536117764, 4375597.572544908],
              [-9240718.761827875, 4378464.181966155],
              [-9252983.609365005, 4371563.224934088],
              [-9270753.428360844, 4355066.761094066],
              [-9273380.790982548, 4354167.888471544],
              [-9282576.114880545, 4357625.087401143],
              [-9280639.267060233, 4363990.005807019],
              [-9283856.622983139, 4374472.534759777],
              [-9292070.952084968, 4383424.945663836],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lawrence',
        GEOID: '46081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11583427.003721816, 5554233.673697692],
              [-11557260.66731228, 5559514.836865398],
              [-11529098.394614452, 5559408.672620109],
              [-11529849.02194087, 5505156.587394214],
              [-11516337.062148385, 5505239.273693624],
              [-11516274.389275067, 5487252.881137645],
              [-11583395.944631435, 5487300.845671763],
              [-11583394.852266854, 5493399.414850754],
              [-11583392.917776, 5504209.478518109],
              [-11583427.003721816, 5554233.673697692],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McCook',
        GEOID: '46087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10865730.409526587, 5442113.351005073],
              [-10839119.039974492, 5442031.077416595],
              [-10812360.728694549, 5441945.717416147],
              [-10812404.031976467, 5388340.62458008],
              [-10842679.816526495, 5388355.971000213],
              [-10865562.873692943, 5388362.5699686855],
              [-10865730.409526587, 5442113.351005073],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jerauld',
        GEOID: '46073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11012386.714199314, 5495913.182744907],
              [-10987284.16902543, 5495936.7834570715],
              [-10946258.149930006, 5495930.572737442],
              [-10946213.399494706, 5455807.407840177],
              [-10999230.754138384, 5455423.259491716],
              [-11012502.931747701, 5455410.892809594],
              [-11012386.714199314, 5495913.182744907],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clinton',
        GEOID: '42035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8693315.407245105, 5044391.785063482],
              [-8681671.945105582, 5066692.914915509],
              [-8681717.363457827, 5082632.096279435],
              [-8638184.206790755, 5083189.863698646],
              [-8638089.919182053, 5077616.612339526],
              [-8630214.621805882, 5065369.162683277],
              [-8610536.452779373, 5044833.835007653],
              [-8587643.154219773, 5022500.856807901],
              [-8587648.608874822, 5018883.710017965],
              [-8609441.068989968, 5010448.983508869],
              [-8628041.999304071, 5006915.628859985],
              [-8628849.622209774, 5007853.101920397],
              [-8640814.6863582, 5025800.748355776],
              [-8654189.945815993, 5028227.685794385],
              [-8660496.08364994, 5039216.40386651],
              [-8670978.372180998, 5038670.487781978],
              [-8671587.401115129, 5049694.311971307],
              [-8687173.020382114, 5035028.9747668],
              [-8689711.550050162, 5038120.313588714],
              [-8693315.407245105, 5044391.785063482],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Goochland',
        GEOID: '51075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8699363.729138374, 4547541.420869122],
              [-8689875.634979593, 4565969.736532519],
              [-8677156.381281044, 4557865.688875381],
              [-8670553.57700413, 4545690.892948549],
              [-8660356.489008486, 4541263.408895503],
              [-8650827.874555055, 4538016.42206892],
              [-8641806.654340658, 4537930.311101469],
              [-8640221.464791762, 4519919.1929154685],
              [-8644559.474028487, 4518013.448982266],
              [-8662315.266768485, 4523989.847420108],
              [-8673888.486309316, 4535965.007491385],
              [-8680942.802440885, 4526484.161112689],
              [-8690954.65480385, 4531138.226491576],
              [-8694105.107712794, 4539441.999598131],
              [-8700656.371065466, 4543961.908980835],
              [-8699363.729138374, 4547541.420869122],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lewis',
        GEOID: '47101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9757265.466757657, 4241444.782095638],
              [-9758064.963340534, 4247000.68226279],
              [-9750104.172595434, 4252995.1848915005],
              [-9735956.689830009, 4247791.4432786945],
              [-9722558.832515582, 4253816.246877337],
              [-9724014.112218725, 4243615.364172782],
              [-9717878.738483652, 4238661.525407367],
              [-9714788.732058214, 4232838.538125204],
              [-9717583.073916107, 4224476.242503917],
              [-9734720.820843222, 4226275.700500547],
              [-9734758.112872638, 4221189.930456307],
              [-9748843.590681693, 4218162.156742509],
              [-9756696.512840213, 4228312.334896605],
              [-9764674.00150893, 4229761.621671421],
              [-9757265.466757657, 4241444.782095638],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '47113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9915176.283269076, 4258416.4572190875],
              [-9909812.910202654, 4255438.960571121],
              [-9898103.992202545, 4272766.851140196],
              [-9874797.030415159, 4271911.564132612],
              [-9863670.75862986, 4271675.383888194],
              [-9863304.851463623, 4249292.334620357],
              [-9864422.053873224, 4244090.078024707],
              [-9871352.360092051, 4230556.74643662],
              [-9889802.452496128, 4222174.054312467],
              [-9916215.116757158, 4222666.14924983],
              [-9915176.283269076, 4258416.4572190875],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Karnes',
        GEOID: '48255',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10930571.118606908, 3360678.169788836],
              [-10908787.118773062, 3378968.9089153153],
              [-10879080.51077946, 3403899.9746100027],
              [-10866244.148976596, 3389624.0915545514],
              [-10882049.067640446, 3376551.3915893743],
              [-10861959.127817491, 3351904.701115218],
              [-10884656.170114823, 3333460.7813558634],
              [-10899859.740889404, 3340011.668376724],
              [-10909894.747706456, 3336279.166586472],
              [-10920254.47347815, 3348557.261783364],
              [-10930571.118606908, 3360678.169788836],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lyon',
        GEOID: '27083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10697018.262823498, 5563535.450652115],
              [-10642588.709119618, 5563450.825674139],
              [-10641566.350916171, 5549752.290259337],
              [-10641427.535511153, 5495750.929496748],
              [-10693770.850638077, 5495889.892628111],
              [-10695418.601740798, 5495920.169791508],
              [-10695622.31640895, 5549881.1453360235],
              [-10697018.262823498, 5563535.450652115],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Perry',
        GEOID: '47135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9800827.566492336, 4224468.180588874],
              [-9793291.014326649, 4234913.728445685],
              [-9800104.546399632, 4248710.988703492],
              [-9799987.77225379, 4261786.340072112],
              [-9792857.758868482, 4275292.205761424],
              [-9791967.425581116, 4278754.36666013],
              [-9779715.82506339, 4273657.892201069],
              [-9764585.057235787, 4278456.244720869],
              [-9767589.570292298, 4254479.662837344],
              [-9758064.963340534, 4247000.68226279],
              [-9757265.466757657, 4241444.782095638],
              [-9764674.00150893, 4229761.621671421],
              [-9794878.875543324, 4225704.728790167],
              [-9796973.351762598, 4221566.821461922],
              [-9800827.566492336, 4224468.180588874],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Robertson',
        GEOID: '47147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9701534.922164874, 4378898.41147798],
              [-9697597.83638477, 4389620.174255234],
              [-9691566.856699433, 4389707.420180574],
              [-9663983.073057616, 4390106.464384312],
              [-9658445.36967319, 4390255.434279811],
              [-9640979.679521622, 4390725.292847606],
              [-9636045.293018544, 4389149.1093898],
              [-9650653.120632578, 4356801.382867991],
              [-9657499.603274835, 4356561.406942498],
              [-9665320.68805899, 4348863.028082929],
              [-9675136.84075714, 4353397.960111526],
              [-9683466.544294728, 4351536.006732382],
              [-9691824.74562196, 4358763.4389571855],
              [-9698203.352444414, 4363474.306962374],
              [-9701534.922164874, 4378898.41147798],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sevier',
        GEOID: '47155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9327936.024391534, 4285101.040697838],
              [-9311981.937610023, 4298745.791952301],
              [-9314468.815034345, 4305918.279305213],
              [-9292383.473338922, 4290016.748098792],
              [-9274113.829829423, 4286299.390043145],
              [-9268661.846448328, 4276571.577831339],
              [-9268031.283015143, 4261493.351608459],
              [-9268988.921846239, 4259843.478391529],
              [-9272596.76780889, 4253629.916710427],
              [-9278174.764853561, 4254003.128261525],
              [-9286447.361492371, 4247252.213385086],
              [-9289882.124380797, 4246120.163445223],
              [-9294992.134286173, 4240653.657792292],
              [-9304954.338156242, 4241198.584554506],
              [-9312227.063128749, 4241382.7874192055],
              [-9313312.751167428, 4241313.10105996],
              [-9313301.85281236, 4258133.967256593],
              [-9318025.806723662, 4261007.454131482],
              [-9327936.024391534, 4285101.040697838],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Portage',
        GEOID: '55097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10001491.969276799, 5572058.144460751],
              [-9932341.860068887, 5571497.637739626],
              [-9932460.749285055, 5503185.39342945],
              [-9974001.509705909, 5503547.772790887],
              [-9988113.036275808, 5503851.268790015],
              [-9988333.33754809, 5544894.146109561],
              [-10001449.111272844, 5544942.694416311],
              [-10001491.969276799, 5572058.144460751],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Price',
        GEOID: '55099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10094312.164451065, 5722569.062008737],
              [-10094113.904437963, 5777393.728402205],
              [-10052379.67074211, 5777360.888016023],
              [-10023647.55357091, 5777456.84636391],
              [-10023524.990811547, 5763900.801240694],
              [-10023586.99576792, 5709335.223911975],
              [-10023459.980228923, 5681840.15030652],
              [-10094314.836118843, 5681212.712942518],
              [-10094312.164451065, 5722569.062008737],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Charlotte',
        GEOID: '51037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8783618.446093554, 4442213.9025193425],
              [-8774670.808062572, 4467770.249833782],
              [-8769448.142832516, 4471089.643600659],
              [-8758792.641173782, 4473837.537974589],
              [-8760001.459524307, 4467534.328317359],
              [-8743826.292234082, 4460095.722624759],
              [-8732306.506048828, 4450175.863052771],
              [-8737803.907782163, 4423955.084986615],
              [-8755115.535753898, 4397082.431466219],
              [-8757667.201121863, 4419325.440566008],
              [-8766379.509749306, 4427970.72816368],
              [-8765729.849201037, 4439864.94082677],
              [-8771403.914966261, 4432973.85627146],
              [-8782295.413945476, 4435858.729090996],
              [-8783618.446093554, 4442213.9025193425],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brooks',
        GEOID: '48047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10967561.806161076, 3156637.9737328454],
              [-10935187.871848576, 3156304.481130563],
              [-10915775.311127102, 3156115.885395253],
              [-10907760.085151006, 3156054.8991402853],
              [-10907739.045767244, 3149646.4437586213],
              [-10907695.297207361, 3096126.785988783],
              [-10945006.918853488, 3096396.628014584],
              [-10956355.4956619, 3096453.240626626],
              [-10955828.620511973, 3130380.578831668],
              [-10961245.315614484, 3130308.829992119],
              [-10964184.261490919, 3152864.2002486815],
              [-10967561.806161076, 3156637.9737328454],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dunn',
        GEOID: '55033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10258810.757108137, 5654572.024985373],
              [-10204173.147275966, 5654325.061107841],
              [-10204257.193491513, 5640562.692577148],
              [-10202586.065295724, 5626211.114229326],
              [-10202481.981571833, 5598872.3549634],
              [-10202471.517539697, 5571852.725686196],
              [-10256443.7707754, 5571968.7428826755],
              [-10256571.342911849, 5599170.255689286],
              [-10256545.182831513, 5640651.828869092],
              [-10258810.757108137, 5654572.024985373],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Iroquois',
        GEOID: '17075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9810802.126825886, 5012013.777384224],
              [-9743401.318186028, 5013866.418084007],
              [-9743351.309644932, 4996952.211101009],
              [-9743364.945216527, 4973609.394873826],
              [-9743382.256463373, 4944054.238650217],
              [-9743447.241804725, 4937584.558880625],
              [-9788913.820629165, 4936808.5921402555],
              [-9809239.757772602, 4937091.518032678],
              [-9809272.151744422, 4941355.567293023],
              [-9810802.126825886, 5012013.777384224],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '13181',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9199075.142197529, 4025323.745014493],
              [-9190870.761984702, 4022969.90281851],
              [-9190184.833704304, 4021466.6273417766],
              [-9185299.577850841, 4020341.639637867],
              [-9176193.643503953, 4010964.1632996434],
              [-9164319.193421034, 4004662.377971594],
              [-9154814.512658123, 3992721.704713203],
              [-9152236.393854856, 3986951.812153611],
              [-9162512.032807495, 3988648.4780788887],
              [-9175545.541428555, 3981985.9567349534],
              [-9181577.94463464, 3980502.473421274],
              [-9194269.368460491, 4005639.0898168655],
              [-9191906.055670949, 4010869.2448956263],
              [-9195623.01346854, 4010011.1270842426],
              [-9200049.521700442, 4026679.9981672093],
              [-9199075.142197529, 4025323.745014493],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harford',
        GEOID: '24025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8523672.086997874, 4825547.573376843],
              [-8506921.940541357, 4825557.3323223535],
              [-8486962.772301096, 4825574.119412594],
              [-8486272.73159666, 4825574.699786762],
              [-8486249.838422397, 4825574.736783532],
              [-8483956.284312742, 4820475.607713335],
              [-8470797.875223013, 4803334.940246798],
              [-8464954.047234328, 4792714.78809111],
              [-8464472.065934364, 4786717.672405508],
              [-8467064.108182315, 4786655.048482197],
              [-8476575.468114674, 4779896.165455612],
              [-8485234.788664501, 4772330.999752758],
              [-8493299.663133493, 4764899.118733031],
              [-8496506.704410225, 4760838.616566755],
              [-8494409.518456701, 4766189.586749774],
              [-8501858.350863643, 4782217.118103198],
              [-8503328.213420078, 4787735.928984679],
              [-8507135.228685716, 4790433.808272738],
              [-8519522.63898221, 4799893.870574159],
              [-8523367.168916248, 4817045.556315712],
              [-8523672.086997874, 4825547.573376843],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '31095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10839032.767369125, 4916991.701230458],
              [-10788645.892292894, 4916894.565452811],
              [-10788685.077362103, 4866153.586300824],
              [-10799010.850080656, 4866154.8809537],
              [-10839089.655560171, 4866224.098133224],
              [-10839032.767369125, 4916991.701230458],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Red Willow',
        GEOID: '31145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11216377.677327154, 4916862.43051917],
              [-11153968.853842702, 4916938.385985798],
              [-11153499.419550026, 4866170.866209297],
              [-11185050.480186583, 4866196.878634819],
              [-11214194.670185266, 4866271.131633797],
              [-11216421.648526018, 4866276.805508639],
              [-11216377.677327154, 4916862.43051917],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Webster',
        GEOID: '31181',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10990220.109275613, 4916992.577647848],
              [-10989899.620461619, 4916991.5551609],
              [-10940266.93493551, 4916985.128102508],
              [-10939763.882156616, 4916986.880936199],
              [-10939813.537301173, 4866281.957287119],
              [-10965465.769647388, 4866288.12273168],
              [-10977632.991812635, 4866291.047091921],
              [-10990169.566212501, 4866281.786161016],
              [-10990220.109275613, 4916992.577647848],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Butler',
        GEOID: '39017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9441835.678342413, 4777943.194048918],
              [-9441691.763938189, 4796717.219846312],
              [-9441641.196875228, 4803322.183889161],
              [-9404151.13640213, 4803476.460472642],
              [-9404182.973776497, 4806687.774387179],
              [-9391494.666896388, 4806466.615080445],
              [-9387805.205013027, 4800590.565382324],
              [-9390156.27265858, 4763626.076555594],
              [-9420973.73785081, 4766470.001285061],
              [-9441994.208185507, 4765478.75421418],
              [-9441835.678342413, 4777943.194048918],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '17191',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9873923.17241243, 4646734.183318256],
              [-9873867.290028054, 4665399.399294233],
              [-9861184.883080957, 4665577.038066851],
              [-9824387.891440766, 4664464.959066899],
              [-9812612.070426691, 4664249.166794659],
              [-9812569.76902019, 4660133.462705788],
              [-9812913.30096878, 4615667.167487778],
              [-9837345.146210631, 4615556.876517096],
              [-9874304.998265851, 4615747.1220917385],
              [-9873923.17241243, 4646734.183318256],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Keokuk',
        GEOID: '19107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10287256.226590542, 5087792.901231802],
              [-10274510.033575222, 5087828.875774914],
              [-10235386.687216435, 5087971.437373499],
              [-10235334.144416781, 5036499.403996797],
              [-10261427.767017197, 5036363.958450998],
              [-10287060.081647765, 5036257.496032078],
              [-10287256.226590542, 5087792.901231802],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Williamson',
        GEOID: '17199',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9924263.515941512, 4559949.2007252285],
              [-9874791.353121128, 4560138.003497757],
              [-9874990.169731686, 4522970.73555094],
              [-9912043.41883968, 4522591.246095303],
              [-9924540.924112568, 4523138.215471496],
              [-9924263.515941512, 4559949.2007252285],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hardee',
        GEOID: '12049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9134248.348053558, 3204463.3607245283],
              [-9079610.960860364, 3204496.411218839],
              [-9079669.848870995, 3166095.183783924],
              [-9134404.64061863, 3165797.304610081],
              [-9134248.348053558, 3204463.3607245283],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lumpkin',
        GEOID: '13187',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9371827.295860486, 4110018.8007199187],
              [-9368429.602362495, 4116180.926964086],
              [-9354901.50124384, 4115327.2453760463],
              [-9344092.378687816, 4128711.0968128033],
              [-9334863.54762309, 4126191.8061767714],
              [-9337048.415268889, 4112473.9926922033],
              [-9333405.150974207, 4096881.1712583206],
              [-9343254.810839087, 4091999.053224464],
              [-9348683.083168639, 4085120.7592311455],
              [-9362195.933517054, 4091350.811313819],
              [-9372103.702156128, 4101432.6892152773],
              [-9371827.295860486, 4110018.8007199187],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Glades',
        GEOID: '12043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9079499.41873059, 3127681.1253762124],
              [-9046625.103306973, 3127529.5324345673],
              [-9046676.42159223, 3138609.3826105343],
              [-9035611.70948534, 3138689.0535451137],
              [-9035707.110288952, 3149681.1160598057],
              [-9010274.836783338, 3149224.75035807],
              [-9003372.24911772, 3144629.631490365],
              [-9004148.145968549, 3118340.1578916665],
              [-9010795.589361269, 3094646.9859558083],
              [-9079877.904999286, 3094709.701002168],
              [-9079499.41873059, 3127681.1253762124],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Long',
        GEOID: '13183',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9126126.478005279, 3736375.9000274674],
              [-9108651.099062588, 3765264.279470818],
              [-9100396.981459247, 3759794.143161341],
              [-9102077.905770225, 3746853.2958947984],
              [-9088319.261986142, 3732561.6514745164],
              [-9071625.45718831, 3723939.4607395404],
              [-9079886.587919569, 3707842.8410633653],
              [-9090706.508466203, 3702904.683584229],
              [-9092786.624471165, 3703315.205983782],
              [-9094999.878587117, 3708947.668502703],
              [-9111569.784791697, 3719765.9016908216],
              [-9124753.129447361, 3735687.7876618686],
              [-9126126.478005279, 3736375.9000274674],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '13195',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9284315.815882662, 4055352.246195114],
              [-9279064.096265506, 4058891.823704641],
              [-9274426.52627906, 4063652.0391193717],
              [-9258747.621278789, 4060874.8467692505],
              [-9252136.913318032, 4065589.8241398684],
              [-9248201.101401543, 4058866.513049929],
              [-9251015.59208727, 4051747.0370864905],
              [-9236878.79599296, 4034606.7592738457],
              [-9244960.034427099, 4030924.31466803],
              [-9253307.771722196, 4035189.6926252795],
              [-9268284.139416069, 4028680.910215281],
              [-9272298.988171019, 4029895.618786958],
              [-9279595.869473027, 4034251.156363697],
              [-9282571.996059386, 4035550.161614135],
              [-9279264.471348936, 4044415.4050681856],
              [-9284315.815882662, 4055352.246195114],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wharton',
        GEOID: '48481',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10725545.774770617, 3427429.568699839],
              [-10720921.00652561, 3441297.702296334],
              [-10706199.0038682, 3456565.3331590793],
              [-10699203.68706675, 3455260.4866639497],
              [-10696568.754719675, 3452448.772614061],
              [-10691635.52016568, 3447402.8209200734],
              [-10693308.763431793, 3436029.25827153],
              [-10683713.357283885, 3428118.719479636],
              [-10680750.03243897, 3418153.421748355],
              [-10669712.259648852, 3409110.500308505],
              [-10672647.977260053, 3404914.5640918054],
              [-10682796.752596693, 3394351.9713489744],
              [-10721088.653678745, 3370974.630908331],
              [-10757950.655901559, 3407223.897267927],
              [-10725545.774770617, 3427429.568699839],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oconee',
        GEOID: '13219',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9299339.16040165, 4024225.758469563],
              [-9296123.362951612, 4019578.605711935],
              [-9285772.3201002, 4017869.310195827],
              [-9270234.456894767, 4008407.2721186746],
              [-9273650.406789249, 4003511.5754819135],
              [-9270725.041890692, 3996858.7741092974],
              [-9271961.801433405, 3993182.56970804],
              [-9284734.488487534, 3988363.6096518473],
              [-9293304.753444728, 4002725.4142952613],
              [-9295837.383179765, 4004357.817413168],
              [-9298869.392150503, 4004781.6317812805],
              [-9311544.89728917, 4016213.6529295878],
              [-9299339.16040165, 4024225.758469563],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Peach',
        GEOID: '13225',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9351782.329111814, 3831997.481755396],
              [-9351211.594082518, 3833074.5683003473],
              [-9324856.48199823, 3854575.3860376417],
              [-9317562.71764196, 3854439.9378823815],
              [-9320051.376178136, 3831921.3051522616],
              [-9333769.277028592, 3824968.717496682],
              [-9352859.679143714, 3829981.540991569],
              [-9351782.329111814, 3831997.481755396],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Young',
        GEOID: '48503',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11015501.990149165, 3948189.612735426],
              [-10956138.422654852, 3948011.0755114164],
              [-10956793.760497153, 3896354.3289025994],
              [-10956867.008722095, 3888974.296365337],
              [-10973387.37775327, 3889246.1231295886],
              [-11015161.018548865, 3889586.943628178],
              [-11015501.990149165, 3948189.612735426],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Arlington',
        GEOID: '51013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8590778.467677968, 4706391.350573536],
              [-8585501.812494874, 4711708.012388302],
              [-8584935.659012271, 4712275.931616156],
              [-8584932.301979976, 4712271.12956013],
              [-8581641.80915162, 4707959.893355636],
              [-8575953.27185259, 4702797.317152405],
              [-8575949.638024257, 4698960.568712582],
              [-8581375.198971167, 4696972.028416076],
              [-8583934.879342468, 4699271.300250418],
              [-8588265.430173308, 4703877.981838698],
              [-8590778.467677968, 4706391.350573536],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Natrona',
        GEOID: '56025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11971690.552433176, 5278781.631574539],
              [-11967003.89055129, 5278766.464379871],
              [-11967104.300731985, 5331484.242273112],
              [-11968741.14252461, 5384194.339115015],
              [-11970729.976547122, 5388598.294343473],
              [-11923512.367373774, 5388433.163878956],
              [-11921232.210243855, 5387221.478672645],
              [-11808556.514094247, 5387540.804344951],
              [-11807959.730304105, 5280888.289574747],
              [-11808445.305922944, 5278236.6896416675],
              [-11808309.83010265, 5226095.930751765],
              [-11872755.91158811, 5225775.581158508],
              [-11969397.036964364, 5226267.572618167],
              [-11971527.135420691, 5227396.444411258],
              [-11971690.552433176, 5278781.631574539],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Spartanburg',
        GEOID: '45083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9152242.851704404, 4190174.5802678936],
              [-9133585.132091695, 4189682.084856838],
              [-9132612.174177876, 4189656.4029353424],
              [-9124787.237879336, 4189312.8933565533],
              [-9114217.653030455, 4188848.9124288517],
              [-9106630.316346217, 4171426.612455306],
              [-9100934.209321817, 4154410.5063402643],
              [-9096104.167935787, 4152007.0449171653],
              [-9104085.3301477, 4141769.05197028],
              [-9111945.822031597, 4108917.5742474818],
              [-9112978.087669723, 4106981.527414465],
              [-9136171.058298538, 4123761.0973204914],
              [-9144539.055740958, 4134776.8419487015],
              [-9146576.313741967, 4136272.3739743703],
              [-9153416.339853758, 4143587.410130852],
              [-9152242.851704404, 4190174.5802678936],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Saluda',
        GEOID: '45081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9127164.420937436, 4028347.5123931207],
              [-9113736.062082533, 4046991.677331446],
              [-9112677.079766616, 4052912.9428396192],
              [-9098321.65219239, 4054021.7744472143],
              [-9080165.109285535, 4042195.421901485],
              [-9072814.238030491, 4038726.6243935646],
              [-9069418.436963841, 4039085.726995614],
              [-9080496.173451152, 4012328.903483729],
              [-9089432.234255092, 4003922.3621304813],
              [-9110031.238109443, 4010890.427183093],
              [-9116464.614121368, 4025501.3388249916],
              [-9129121.974183036, 4023653.1829333226],
              [-9127164.420937436, 4028347.5123931207],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '55131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9842695.60621612, 5368487.0672919685],
              [-9840690.408228463, 5395072.316148756],
              [-9814023.490250459, 5394981.860531298],
              [-9800626.746130943, 5394892.48080621],
              [-9800566.07700846, 5368136.086222574],
              [-9803064.420340335, 5368045.127324038],
              [-9803167.613508299, 5341259.880931281],
              [-9842645.289806282, 5341653.825534912],
              [-9842695.60621612, 5368487.0672919685],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Garfield',
        GEOID: '53023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13119207.931045258, 5881024.408610859],
              [-13106853.471318038, 5892363.953284766],
              [-13090926.3238533, 5888787.5907800095],
              [-13076118.271229506, 5893182.470443075],
              [-13066987.067358207, 5879405.924295144],
              [-13052684.739181086, 5868133.436564089],
              [-13049774.62505277, 5854736.276207941],
              [-13049849.877028545, 5846508.072800183],
              [-13071060.470165312, 5841961.541857057],
              [-13071076.945449952, 5799914.339793214],
              [-13077812.442559889, 5799920.442787751],
              [-13077806.794615686, 5779959.301510733],
              [-13091553.4794415, 5780150.539407464],
              [-13092497.153187884, 5834757.464102649],
              [-13099515.067845965, 5834624.11972515],
              [-13106456.61733336, 5856224.632285327],
              [-13120487.771230908, 5856097.4277189085],
              [-13119207.931045258, 5881024.408610859],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pipestone',
        GEOID: '27117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10737036.04511269, 5495944.94125848],
              [-10737036.041764868, 5495948.364389946],
              [-10695418.601740798, 5495920.169791508],
              [-10693770.850638077, 5495889.892628111],
              [-10693864.581649322, 5442110.263802736],
              [-10737088.77905055, 5442182.790584228],
              [-10737036.04511269, 5495944.94125848],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rock',
        GEOID: '27133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10737133.911123214, 5396418.811809226],
              [-10737088.779348116, 5442182.488094915],
              [-10737088.77905055, 5442182.790584228],
              [-10693864.581649322, 5442110.263802736],
              [-10692495.351912566, 5442115.048966801],
              [-10692589.175821044, 5388418.079473969],
              [-10708766.253964875, 5388440.683696749],
              [-10737127.788551223, 5388449.124315824],
              [-10737133.911123214, 5396418.811809226],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '41031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13563932.63634911, 5541756.695255697],
              [-13558034.373129426, 5557838.712393266],
              [-13558715.648413084, 5571820.159722344],
              [-13554233.14647731, 5584120.563820015],
              [-13560529.376876576, 5591466.936471087],
              [-13553481.294636492, 5594785.337614692],
              [-13550372.5865366, 5594094.721135483],
              [-13479619.254022285, 5593742.056189847],
              [-13399687.518172575, 5593506.169151992],
              [-13403387.221449088, 5589261.88102442],
              [-13401370.668873368, 5553142.802094401],
              [-13450461.896396257, 5552952.810008293],
              [-13450388.870810295, 5539480.059553716],
              [-13468414.279356996, 5539477.719394641],
              [-13468364.29690563, 5526036.565278184],
              [-13481629.016109064, 5526088.751924203],
              [-13563516.07881456, 5526404.993810426],
              [-13563932.63634911, 5541756.695255697],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wheatland',
        GEOID: '30107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12275571.722915053, 5894949.124454258],
              [-12241738.056119781, 5901842.042399008],
              [-12225091.562105538, 5892179.420118657],
              [-12216840.45012845, 5892285.075835973],
              [-12177145.923462402, 5892208.471256526],
              [-12178746.809059499, 5859329.026221883],
              [-12178675.787224375, 5815627.435778317],
              [-12206613.083231308, 5815578.846904449],
              [-12276532.855398564, 5815772.0777496565],
              [-12275571.722915053, 5894949.124454258],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Louisa',
        GEOID: '51109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8711194.20802243, 4588302.9871703135],
              [-8706228.802135598, 4597966.398432291],
              [-8694273.645421853, 4600997.916055866],
              [-8677759.398962671, 4596179.581466195],
              [-8664910.680696331, 4594444.710468221],
              [-8648129.490098225, 4580528.597564763],
              [-8660356.489008486, 4541263.408895503],
              [-8670553.57700413, 4545690.892948549],
              [-8677156.381281044, 4557865.688875381],
              [-8689875.634979593, 4565969.736532519],
              [-8705754.692424309, 4573401.137208893],
              [-8717068.982829554, 4580340.412314643],
              [-8711194.20802243, 4588302.9871703135],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Steele',
        GEOID: '27147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10397971.252548808, 5495882.439803258],
              [-10370778.127337828, 5495912.095871473],
              [-10357823.32159676, 5495935.075508754],
              [-10357829.555488244, 5442021.97025406],
              [-10358225.630236486, 5442018.265648149],
              [-10397979.8241496, 5441968.407971955],
              [-10397971.252548808, 5495882.439803258],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Miller',
        GEOID: '29131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10318185.122593055, 4628770.854953449],
              [-10311942.54818835, 4628715.497112032],
              [-10310988.874110725, 4640460.309632263],
              [-10296516.895029634, 4640041.249927496],
              [-10286308.786404401, 4639686.291750138],
              [-10286856.812257577, 4627759.131004384],
              [-10263042.12227268, 4626934.836944519],
              [-10263175.594342142, 4620791.754682898],
              [-10261583.391665326, 4602228.441313546],
              [-10262028.446989516, 4581734.081482966],
              [-10286619.479103206, 4582418.127433061],
              [-10298831.67252119, 4582581.621247049],
              [-10304876.543510247, 4588843.38487365],
              [-10308706.267952006, 4603572.814833414],
              [-10318858.828151336, 4610839.002840104],
              [-10318185.122593055, 4628770.854953449],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Todd',
        GEOID: '27153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10592669.598543698, 5839660.842627929],
              [-10545455.88555253, 5839616.477097192],
              [-10543862.235722331, 5836836.091267936],
              [-10536775.19166047, 5836402.264367127],
              [-10535720.773443677, 5744198.252734321],
              [-10590906.409129024, 5744113.026795664],
              [-10591590.91267791, 5797474.282283546],
              [-10591581.005243232, 5825714.931403077],
              [-10592669.598543698, 5839660.842627929],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fayette',
        GEOID: '01057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9790747.920559475, 4018055.64198202],
              [-9767099.430574335, 4017358.2213206263],
              [-9755587.325433949, 4017427.9748861482],
              [-9755599.347938953, 4011627.5415793657],
              [-9743973.362959486, 4011040.1790298196],
              [-9743610.016141536, 3987526.305935704],
              [-9731977.685951093, 3987133.364189005],
              [-9731961.878583401, 3975497.56197552],
              [-9755118.225099744, 3976531.6795339026],
              [-9759008.062066535, 3964753.0132057182],
              [-9778380.102493363, 3965176.5727884485],
              [-9790161.71212096, 3965073.218544462],
              [-9790747.920559475, 4018055.64198202],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fremont',
        GEOID: '19071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10674280.922870498, 4973522.262796853],
              [-10668209.446523141, 4980389.063243247],
              [-10668219.222235074, 4980502.029730483],
              [-10669005.714840788, 4989594.893154441],
              [-10665599.33842251, 4995641.478256948],
              [-10666491.929109953, 4997300.660155722],
              [-10663867.986382203, 4997842.184500329],
              [-10618205.62181473, 4997831.13849401],
              [-10616608.63239981, 4972339.533484306],
              [-10616976.771900179, 4950636.470198723],
              [-10634705.174101127, 4950917.394426508],
              [-10660582.836889405, 4951351.118478886],
              [-10658688.290475594, 4954011.487724487],
              [-10662393.337087667, 4961333.100739463],
              [-10669531.699434785, 4965638.095478093],
              [-10674280.922870498, 4973522.262796853],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '18021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9711554.566892195, 4758848.496930193],
              [-9711397.049812723, 4796522.67341677],
              [-9706949.61351655, 4809015.66060188],
              [-9686249.754203541, 4808676.116371317],
              [-9686413.505174499, 4789735.511555157],
              [-9678114.414496878, 4789702.775582436],
              [-9678391.822667936, 4770785.399197943],
              [-9690767.544417897, 4770868.5967570525],
              [-9690871.294183314, 4745777.128686991],
              [-9711594.4192699, 4746306.533589738],
              [-9711554.566892195, 4758848.496930193],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Box Butte',
        GEOID: '31013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11515392.627588492, 5226719.7688361835],
              [-11440678.770230735, 5227107.124226588],
              [-11438034.375726942, 5225679.056102445],
              [-11437217.068025537, 5174828.780609034],
              [-11432270.697771627, 5161704.929571238],
              [-11506354.041533533, 5161418.353945097],
              [-11510617.8006699, 5161509.733632468],
              [-11510620.91761564, 5174554.86054712],
              [-11515345.428124396, 5174576.761861154],
              [-11515392.627588492, 5226719.7688361835],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hinds',
        GEOID: '28049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10099864.001415398, 3792897.4052129816],
              [-10097253.893314768, 3808918.520565997],
              [-10089571.401296651, 3812570.3241836163],
              [-10080405.243105242, 3830123.573668176],
              [-10076887.101918211, 3829534.3339622836],
              [-10068852.061072752, 3838866.4770352393],
              [-10068832.802800845, 3827592.056418137],
              [-10045876.163450984, 3827478.427973762],
              [-10045889.855748352, 3815945.05349491],
              [-10032500.7926737, 3815859.750701436],
              [-10026067.527981266, 3815870.0344679346],
              [-10029182.692611625, 3814645.933133586],
              [-10038758.395209663, 3799616.0220521335],
              [-10040445.330773143, 3787994.853869652],
              [-10047118.266329255, 3783172.804060388],
              [-10044394.501028527, 3769839.971414464],
              [-10098714.627672955, 3769659.2533122846],
              [-10099864.001415398, 3792897.4052129816],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hendricks',
        GEOID: '18063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9650851.158006698, 4854725.764933713],
              [-9613023.793159727, 4854910.256405123],
              [-9609798.978830935, 4854908.514534147],
              [-9609696.564899407, 4846514.354661976],
              [-9609910.075682748, 4840180.7300670305],
              [-9609804.322166495, 4812634.328610508],
              [-9610868.87045695, 4812606.576653458],
              [-9625343.409886327, 4812324.291591552],
              [-9625307.11973233, 4808095.594673149],
              [-9646574.15185093, 4808186.037103044],
              [-9645056.199274471, 4810589.562498588],
              [-9649997.894109767, 4812382.829313535],
              [-9650857.391898183, 4846321.31704514],
              [-9650851.158006698, 4854725.764933713],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Perry',
        GEOID: '17145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9973424.540785126, 4610447.927843315],
              [-9923865.103483962, 4609544.544638596],
              [-9924114.793101812, 4597091.276574592],
              [-9921865.805429315, 4597063.399557867],
              [-9920592.42177413, 4587899.757457705],
              [-9927204.688207759, 4572408.799738433],
              [-9973679.128460573, 4573114.536894273],
              [-9973424.540785126, 4610447.927843315],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Vance',
        GEOID: '37181',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8738327.220708383, 4371672.645683061],
              [-8733824.224437563, 4375381.936932338],
              [-8718956.461519804, 4375516.708807429],
              [-8713774.148541056, 4342826.83647512],
              [-8717091.469366696, 4337310.932030982],
              [-8725014.634123908, 4333014.346267326],
              [-8729883.748651205, 4323253.653805922],
              [-8738203.09947615, 4324755.340095988],
              [-8739829.477236638, 4363384.069131889],
              [-8738327.220708383, 4371672.645683061],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Allen',
        GEOID: '20001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10633160.727485862, 4554065.462030539],
              [-10633123.101497974, 4584827.838267016],
              [-10584020.742026005, 4584753.776280674],
              [-10584222.898221286, 4554000.779142264],
              [-10585156.868749043, 4541702.272283062],
              [-10633849.906453364, 4541742.1058914345],
              [-10633160.727485862, 4554065.462030539],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Comanche',
        GEOID: '48093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11012213.946349602, 3773556.064533537],
              [-10970664.72564745, 3797677.3009772217],
              [-10945767.119656114, 3755602.687899588],
              [-10939498.162532093, 3759366.612503367],
              [-10937175.3700372, 3760554.760078119],
              [-10932507.521149255, 3752487.527973788],
              [-10926739.167775331, 3742550.885748557],
              [-10960932.953123318, 3721900.3807273903],
              [-10964168.565442717, 3727084.3135808185],
              [-10983720.609486157, 3724062.318857917],
              [-11012213.946349602, 3773556.064533537],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harvey',
        GEOID: '20079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10876119.189685378, 4604009.083620796],
              [-10839373.627649935, 4603989.117655281],
              [-10815032.841751551, 4604125.198512055],
              [-10815012.804243209, 4591822.865949738],
              [-10814964.157625731, 4567105.2369371215],
              [-10876133.438580198, 4566906.571838361],
              [-10876119.189685378, 4604009.083620796],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gratiot',
        GEOID: '26057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9445009.28570544, 5383197.169026161],
              [-9418468.270071525, 5383173.855457152],
              [-9392011.63461163, 5383179.683843909],
              [-9391790.665422408, 5331544.033629908],
              [-9391776.082569113, 5329941.086704119],
              [-9443999.283965472, 5330079.713196054],
              [-9445009.28570544, 5383197.169026161],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lyon',
        GEOID: '20111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10726053.725607106, 4653382.827842804],
              [-10725923.81576135, 4684357.216356296],
              [-10680651.403370123, 4684370.203565101],
              [-10681066.625070784, 4678131.540782372],
              [-10681136.533711003, 4640933.104555091],
              [-10681104.473697653, 4616178.802615681],
              [-10682063.602430329, 4614278.6931425845],
              [-10682091.65494201, 4603601.983803768],
              [-10726443.00986641, 4603845.675364937],
              [-10726053.725607106, 4653382.827842804],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Smith',
        GEOID: '47159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9588705.04852052, 4341407.851990697],
              [-9582481.955026703, 4349630.143851867],
              [-9570931.778620465, 4356503.315593237],
              [-9571126.587729353, 4359407.852802159],
              [-9561869.147555493, 4358629.386919667],
              [-9554332.150111845, 4357438.34784126],
              [-9554291.407178214, 4335803.494953709],
              [-9549002.395531643, 4333420.934319655],
              [-9552232.887154466, 4329086.302163911],
              [-9552037.744087104, 4318741.989893988],
              [-9558339.42914142, 4313537.034989168],
              [-9563470.589750046, 4316722.021869186],
              [-9580122.64973883, 4312464.606899677],
              [-9586345.520593664, 4337683.026270604],
              [-9588705.04852052, 4341407.851990697],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ingham',
        GEOID: '26065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9417936.274225025, 5277010.572159494],
              [-9393662.94793806, 5277010.875446438],
              [-9391319.56133737, 5277905.007931564],
              [-9368446.745564077, 5278035.586301393],
              [-9366501.326142972, 5224797.858074023],
              [-9417673.782865733, 5224401.700133987],
              [-9417936.274225025, 5277010.572159494],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ionia',
        GEOID: '26067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9496945.505454531, 5330070.867879832],
              [-9483708.17084583, 5330183.87505055],
              [-9443999.283965472, 5330079.713196054],
              [-9444021.102585668, 5277101.407037098],
              [-9470421.633022198, 5277147.658856545],
              [-9496624.12608461, 5277010.26887256],
              [-9496945.505454531, 5330070.867879832],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Logan',
        GEOID: '21141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9690713.888423333, 4447615.465207164],
              [-9682168.447712589, 4449368.975096796],
              [-9678271.374978898, 4448726.215602904],
              [-9667580.139763622, 4446986.9007748375],
              [-9648556.974620938, 4439074.170718471],
              [-9641557.650317824, 4422818.952273968],
              [-9646489.326398944, 4421872.476532204],
              [-9657114.994434146, 4401138.7822768185],
              [-9658445.36967319, 4390255.434279811],
              [-9663983.073057616, 4390106.464384312],
              [-9691566.856699433, 4389707.420180574],
              [-9690713.888423333, 4447615.465207164],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dimmit',
        GEOID: '48127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11144676.904626697, 3330935.628953928],
              [-11066161.597977838, 3329977.1987439627],
              [-11064682.71854265, 3330004.8496807017],
              [-11064509.171456505, 3274797.1541504846],
              [-11144608.220500877, 3273937.2099774736],
              [-11144676.904626697, 3330935.628953928],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Medina',
        GEOID: '48325',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11066472.847274097, 3455759.5374047584],
              [-11018824.76562985, 3455239.1010357873],
              [-11017443.95866605, 3446072.410596136],
              [-11012521.188144192, 3447404.356678659],
              [-10999095.055679107, 3463855.001476251],
              [-10998895.905110076, 3407592.494538402],
              [-10998911.155880317, 3387161.299631976],
              [-11066702.499383602, 3387276.077807583],
              [-11066472.847274097, 3455759.5374047584],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mason',
        GEOID: '21161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9349902.69950977, 4663638.705865874],
              [-9340192.309913017, 4688391.593199672],
              [-9334371.404154293, 4686128.767384607],
              [-9332359.860955657, 4681073.410746745],
              [-9326749.915217131, 4678168.053969978],
              [-9325474.19385264, 4672822.11711985],
              [-9318093.893685602, 4669955.430002672],
              [-9315157.548723884, 4668815.106285805],
              [-9311531.583937451, 4670499.007323768],
              [-9309047.44451322, 4666163.396137033],
              [-9310968.37364635, 4653912.7088782815],
              [-9335172.34789055, 4644094.583450474],
              [-9343083.601462247, 4649203.5054356605],
              [-9347562.763813296, 4662661.987216596],
              [-9349902.69950977, 4663638.705865874],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lake',
        GEOID: '26085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9578319.385307468, 5491335.950708337],
              [-9553570.724794818, 5490887.307398674],
              [-9525002.58123356, 5490990.3490916705],
              [-9524766.472593587, 5436932.012781914],
              [-9577693.43581074, 5436951.759788588],
              [-9577940.787719281, 5463843.885895116],
              [-9578319.385307468, 5491335.950708337],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kandiyohi',
        GEOID: '27067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10603761.027328378, 5686700.59346155],
              [-10590015.741883187, 5686681.088713044],
              [-10548961.558956591, 5686753.874942279],
              [-10548977.811602246, 5673006.187918198],
              [-10548433.347972777, 5604550.3327552],
              [-10603016.745212933, 5604426.669231382],
              [-10602790.766646622, 5645543.214887971],
              [-10603759.914133469, 5659180.418074689],
              [-10603761.027328378, 5686700.59346155],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mecosta',
        GEOID: '26107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9524766.472593587, 5436932.012781914],
              [-9472043.112725094, 5436653.245102633],
              [-9471618.428867718, 5383202.077153423],
              [-9524757.01043687, 5383499.637222333],
              [-9524766.472593587, 5436932.012781914],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '37123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8925881.638381615, 4232606.071216467],
              [-8913000.08086549, 4232812.556285268],
              [-8879728.354859741, 4233608.859234825],
              [-8872461.75245923, 4198712.493643976],
              [-8862623.781140883, 4186146.773165888],
              [-8889002.49295722, 4188894.4585983325],
              [-8913948.856885519, 4183342.3203755035],
              [-8916489.167665424, 4198612.432497185],
              [-8911261.60437777, 4214486.868814911],
              [-8917636.871615501, 4226495.323412788],
              [-8925881.638381615, 4232606.071216467],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Day',
        GEOID: '46037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10907245.90042303, 5659449.648619764],
              [-10907038.2895727, 5714646.798392371],
              [-10839553.519947056, 5714511.747527285],
              [-10838582.146070395, 5709914.873376034],
              [-10823270.03879229, 5709824.250984974],
              [-10823175.973822568, 5668502.262803507],
              [-10823180.092643728, 5645455.135069695],
              [-10825723.297730392, 5645351.587138857],
              [-10853010.710550075, 5645424.354691377],
              [-10907283.192452446, 5645687.017304798],
              [-10907245.90042303, 5659449.648619764],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hoke',
        GEOID: '37093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8845307.700389516, 4169813.0923474566],
              [-8831584.901481468, 4185862.0475706304],
              [-8821667.00276873, 4192859.8944496163],
              [-8805103.553094618, 4187582.9039354525],
              [-8806810.08088848, 4180969.7505166857],
              [-8798349.354310228, 4158032.766366936],
              [-8798553.068978379, 4157457.156635617],
              [-8815545.321331028, 4141306.846113297],
              [-8832964.261291886, 4141962.7284226823],
              [-8833549.356535496, 4156306.433854465],
              [-8845307.700389516, 4169813.0923474566],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Moore',
        GEOID: '37125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8879728.354859741, 4233608.859234825],
              [-8856111.590929477, 4234095.038576465],
              [-8833209.720769085, 4234500.272857441],
              [-8834288.629273854, 4227892.7034963295],
              [-8824692.889167473, 4212006.875455968],
              [-8814673.133120662, 4205701.839849022],
              [-8819066.356824819, 4200379.312993153],
              [-8804905.070442533, 4190013.1482106093],
              [-8805103.553094618, 4187582.9039354525],
              [-8821667.00276873, 4192859.8944496163],
              [-8831584.901481468, 4185862.0475706304],
              [-8845307.700389516, 4169813.0923474566],
              [-8858352.118320674, 4173384.8808575138],
              [-8862623.781140883, 4186146.773165888],
              [-8872461.75245923, 4198712.493643976],
              [-8879728.354859741, 4233608.859234825],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Todd',
        GEOID: '21219',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9713668.746661343, 4449203.363479077],
              [-9712654.069502762, 4444761.418734775],
              [-9690713.888423333, 4447615.465207164],
              [-9691566.856699433, 4389707.420180574],
              [-9697597.83638477, 4389620.174255234],
              [-9722196.715787003, 4389264.327010552],
              [-9713668.746661343, 4449203.363479077],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kanabec',
        GEOID: '27065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10410385.045564622, 5777431.37484815],
              [-10400857.432986606, 5777368.737658249],
              [-10400783.850803193, 5805060.819650054],
              [-10384380.255917858, 5805936.991425857],
              [-10358709.536062967, 5805724.368764505],
              [-10358844.232646827, 5777342.305217225],
              [-10368616.748104585, 5777305.780519262],
              [-10368496.968332492, 5737291.374156157],
              [-10409895.573763603, 5737875.235456814],
              [-10410385.045564622, 5777431.37484815],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fayette',
        GEOID: '17051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9936083.864751903, 4721552.682899126],
              [-9935313.97915358, 4725709.92308723],
              [-9935321.660198443, 4752876.364504639],
              [-9923027.869593706, 4752933.119909657],
              [-9920518.505632244, 4752836.420385721],
              [-9885763.558731167, 4752696.90457825],
              [-9885926.530465689, 4709024.7981856875],
              [-9873318.707577424, 4709448.559513223],
              [-9873500.603625381, 4696820.848317612],
              [-9922812.132420547, 4696527.210973248],
              [-9922840.518890701, 4683973.31622976],
              [-9935730.425368635, 4684784.946649933],
              [-9936011.952360852, 4709847.157375691],
              [-9936083.864751903, 4721552.682899126],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hamilton',
        GEOID: '17065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9874551.57093796, 4597126.795116048],
              [-9874304.998265851, 4615747.1220917385],
              [-9837345.146210631, 4615556.876517096],
              [-9837806.676819462, 4566492.604366913],
              [-9837807.678694878, 4566392.00740305],
              [-9874775.991031397, 4566267.708714144],
              [-9874551.57093796, 4597126.795116048],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Webster',
        GEOID: '21233',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9788651.440589368, 4506232.760274519],
              [-9766564.874379545, 4528465.674018315],
              [-9739935.693708923, 4529754.976740614],
              [-9738529.839859694, 4523200.740122981],
              [-9726556.649388442, 4518856.3772770995],
              [-9740133.953722028, 4507319.968682701],
              [-9750872.165762417, 4503695.5843586875],
              [-9775344.419979429, 4488095.531738824],
              [-9773967.731836788, 4492129.328709772],
              [-9779160.563443314, 4497910.442856448],
              [-9788322.714133054, 4496293.887797732],
              [-9788651.440589368, 4506232.760274519],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Donley',
        GEOID: '48129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11252873.327105764, 4188660.873368407],
              [-11191947.835836133, 4188797.6188757084],
              [-11192139.861957753, 4129650.337662278],
              [-11237139.207638063, 4129725.935550364],
              [-11253370.70259063, 4129721.1937323366],
              [-11252873.327105764, 4188660.873368407],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Anoka',
        GEOID: '27003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10409493.376443366, 5687061.042517037],
              [-10354890.38697283, 5686580.869862137],
              [-10354876.694675462, 5668388.637308055],
              [-10354996.69708654, 5641042.776872765],
              [-10378059.646550108, 5641148.010733173],
              [-10377988.736034472, 5629386.473731512],
              [-10377974.264500668, 5627138.904266805],
              [-10384263.481772017, 5627090.7009387165],
              [-10383972.826581554, 5632818.777351595],
              [-10385673.454442404, 5640706.73095368],
              [-10387393.563214142, 5644184.861118211],
              [-10394268.321007062, 5649614.295956047],
              [-10400171.70492332, 5655411.247261715],
              [-10409729.373763848, 5660282.527965502],
              [-10409493.376443366, 5687061.042517037],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Edwards',
        GEOID: '48137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11209916.471442532, 3540659.1168443016],
              [-11144913.458544632, 3540919.531444144],
              [-11104580.291959906, 3540971.357167699],
              [-11104967.572468374, 3513082.3844168065],
              [-11128345.222132415, 3514140.3380548814],
              [-11132205.336795164, 3490294.9266318427],
              [-11135386.625203053, 3484061.6235903674],
              [-11133528.480262732, 3455244.863626714],
              [-11144427.771606302, 3455215.1542966156],
              [-11209865.153157275, 3455296.342886511],
              [-11209916.471442532, 3540659.1168443016],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kingfisher',
        GEOID: '40073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10932747.748610388, 4323333.766051659],
              [-10920876.638112193, 4323331.97351643],
              [-10873199.947358815, 4323302.465671545],
              [-10873022.838048963, 4262980.483743436],
              [-10932364.80956206, 4262866.671795066],
              [-10932747.748610388, 4323333.766051659],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fayette',
        GEOID: '48149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10833147.86248834, 3476141.0829271944],
              [-10819612.748241765, 3490288.2494494035],
              [-10800713.59301183, 3510163.0479977145],
              [-10800036.547868825, 3507716.0131279794],
              [-10780831.486678189, 3518472.7680967785],
              [-10775120.24020304, 3524203.143889988],
              [-10758719.650943957, 3522224.290055548],
              [-10755909.613037864, 3509243.28119566],
              [-10750105.860065864, 3498604.04266407],
              [-10783989.064034538, 3456424.456144879],
              [-10813869.55307276, 3455834.710436257],
              [-10812845.525076954, 3458102.273275934],
              [-10833378.293834282, 3475899.560936347],
              [-10833147.86248834, 3476141.0829271944],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Aiken',
        GEOID: '45003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9130014.917158335, 3965696.7002669447],
              [-9089432.234255092, 4003922.3621304813],
              [-9080496.173451152, 4012328.903483729],
              [-9063403.510917809, 3993199.7035874766],
              [-9037725.666615507, 3982294.605196047],
              [-9058393.243276186, 3960581.0067750853],
              [-9099535.59123949, 3923057.699588503],
              [-9101760.53198681, 3921517.0780334473],
              [-9101875.081658, 3922366.130893314],
              [-9111114.710713334, 3927435.8381472123],
              [-9111110.762473475, 3928168.716535138],
              [-9111070.182917016, 3935703.834773491],
              [-9120710.562139206, 3940992.5682252604],
              [-9119306.155443357, 3949952.3321439563],
              [-9119998.006078636, 3956913.5551212477],
              [-9127189.467822863, 3961090.645065824],
              [-9130014.917158335, 3965696.7002669447],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brookings',
        GEOID: '46011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10812242.173436854, 5549880.520579732],
              [-10785244.97052967, 5549981.575468067],
              [-10737131.274365084, 5549960.302589466],
              [-10737011.237044362, 5521346.283499202],
              [-10737036.041764868, 5495948.364389946],
              [-10737036.04511269, 5495944.94125848],
              [-10785658.188479494, 5495778.100892749],
              [-10812425.516638191, 5495813.50146116],
              [-10812242.173436854, 5549880.520579732],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pennington',
        GEOID: '46103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11583395.944631435, 5487300.845671763],
              [-11516274.389275067, 5487252.881137645],
              [-11397785.032718781, 5487161.515432825],
              [-11398394.729569854, 5496905.552069524],
              [-11392618.695151065, 5519575.050949514],
              [-11387984.130790869, 5523656.704281271],
              [-11386077.673191542, 5535132.6134622],
              [-11375676.2026108, 5531791.202636033],
              [-11367115.399810325, 5533146.203418308],
              [-11354706.950130071, 5544852.622682965],
              [-11355404.700698363, 5464595.727242082],
              [-11356690.552136516, 5420460.318737778],
              [-11358314.703507192, 5417492.3304393785],
              [-11370079.058613714, 5419279.229635167],
              [-11374094.6866051, 5417248.171345973],
              [-11444689.834122999, 5417217.998287058],
              [-11432013.661067387, 5434258.381218026],
              [-11431085.813111624, 5443122.921690748],
              [-11583403.938405588, 5442795.339374613],
              [-11583395.944631435, 5487300.845671763],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Archer',
        GEOID: '48009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11015420.059003938, 4006537.352297151],
              [-10956462.473692551, 4006808.3323701117],
              [-10956222.24623142, 3957428.636418624],
              [-10956138.422654852, 3948011.0755114164],
              [-11015501.990149165, 3948189.612735426],
              [-11015420.059003938, 4006537.352297151],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cocke',
        GEOID: '47029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9272527.415766127, 4287491.412093982],
              [-9270317.278595915, 4301674.326532578],
              [-9268314.306998074, 4300758.283373548],
              [-9265631.618589446, 4312336.501204624],
              [-9266878.619525312, 4317723.758694156],
              [-9259009.556040626, 4318159.678916956],
              [-9260377.449943492, 4324727.20741554],
              [-9258006.233470106, 4325540.740324353],
              [-9258718.678211184, 4322258.98769807],
              [-9250957.038035113, 4317271.043195323],
              [-9227690.19784398, 4291524.046890811],
              [-9229566.663920714, 4290571.705139845],
              [-9228354.394665975, 4283380.490746761],
              [-9232553.254539207, 4276886.810495144],
              [-9235805.202203352, 4272511.435483729],
              [-9237114.793313444, 4270749.924998512],
              [-9244920.070729904, 4271449.226541895],
              [-9250337.211110376, 4269852.123771134],
              [-9257499.95242598, 4268109.14859957],
              [-9261588.717322817, 4262915.2131316345],
              [-9267943.279135259, 4261644.982065872],
              [-9268031.283015143, 4261493.351608459],
              [-9268661.846448328, 4276571.577831339],
              [-9274113.829829423, 4286299.390043145],
              [-9272527.415766127, 4287491.412093982],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bailey',
        GEOID: '48017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11470751.730668537, 4039466.0763114104],
              [-11470757.065186592, 4043963.009322937],
              [-11470787.333999647, 4069513.015233336],
              [-11470788.944904776, 4070874.4010663335],
              [-11423066.245675387, 4070893.421233867],
              [-11423099.307564152, 4005344.151316516],
              [-11471178.084318276, 4005284.3873296673],
              [-11470751.730668537, 4039466.0763114104],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dickson',
        GEOID: '47043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9747891.363757446, 4325121.8990681255],
              [-9743085.590020409, 4334922.51700671],
              [-9741961.931080343, 4346775.6442948915],
              [-9718539.864939474, 4343698.514088829],
              [-9716688.844446564, 4345009.7550829975],
              [-9701832.367844274, 4342718.814146125],
              [-9706313.867904631, 4334933.421809412],
              [-9701479.819016932, 4324986.8858707035],
              [-9705119.6324074, 4307465.751918892],
              [-9706038.352164919, 4297303.554812665],
              [-9707531.8144534, 4295006.880859975],
              [-9744299.306428527, 4299668.406969673],
              [-9746341.351167642, 4302855.788268757],
              [-9747891.363757446, 4325121.8990681255],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Butte',
        GEOID: '46019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11583649.954480242, 5621117.058786711],
              [-11581583.864731118, 5621288.493491449],
              [-11581677.261783892, 5641219.797655736],
              [-11581694.934475856, 5655099.277185003],
              [-11461152.094379978, 5655092.994078415],
              [-11461162.113134151, 5627752.967911418],
              [-11461913.964974968, 5559438.223367882],
              [-11529098.394614452, 5559408.672620109],
              [-11557260.66731228, 5559514.836865398],
              [-11583427.003721816, 5554233.673697692],
              [-11583439.783281624, 5573059.940793378],
              [-11583649.954480242, 5621117.058786711],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chester',
        GEOID: '45023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9070140.009903165, 4139651.3079424486],
              [-9005548.099884765, 4139547.8449544446],
              [-9003088.60705518, 4135114.752607391],
              [-9001324.527084576, 4122624.401580097],
              [-9005346.722925922, 4113953.5619181045],
              [-9003241.114757566, 4101968.529417483],
              [-9063934.17093042, 4105872.622200167],
              [-9063175.862559136, 4114198.168906705],
              [-9071233.278622245, 4127660.996130174],
              [-9070140.009903165, 4139651.3079424486],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Santa Isabel',
        GEOID: '72133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7397547.156131614, 2035223.291597995],
              [-7393957.909232526, 2039808.7529961735],
              [-7394618.590410383, 2042538.5636649928],
              [-7386802.848961789, 2041872.9941010375],
              [-7383960.305764383, 2039408.6421606601],
              [-7384727.901040895, 2034780.7100296852],
              [-7384755.794845591, 2034793.1789444797],
              [-7389950.964161422, 2030410.3034921205],
              [-7396677.1104341345, 2035135.0340692583],
              [-7397547.156131614, 2035223.291597995],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Elbert',
        GEOID: '13105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9248201.101401543, 4058866.513049929],
              [-9237293.349776674, 4057043.7558977734],
              [-9214429.520938538, 4067588.6814416684],
              [-9211129.261938587, 4061728.4559455365],
              [-9210127.165731916, 4057770.218567085],
              [-9207833.20313569, 4048714.3590063415],
              [-9199754.079771876, 4039725.4737702655],
              [-9194436.213290341, 4030617.282099467],
              [-9194083.242271885, 4030012.9874910037],
              [-9190870.761984702, 4022969.90281851],
              [-9199075.142197529, 4025323.745014493],
              [-9200049.521700442, 4026679.9981672093],
              [-9208836.970984172, 4026717.1856423146],
              [-9214972.456038734, 4024925.3435558947],
              [-9233091.03899923, 4030810.562661451],
              [-9236878.79599296, 4034606.7592738457],
              [-9251015.59208727, 4051747.0370864905],
              [-9248201.101401543, 4058866.513049929],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Florence',
        GEOID: '45041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8913338.046839539, 4040381.25153419],
              [-8874958.537318232, 4068737.377226092],
              [-8867461.72621076, 4069855.574166189],
              [-8864750.985290451, 4068885.8708682144],
              [-8861143.12059384, 4067880.4102379153],
              [-8855235.06125897, 4059850.304381068],
              [-8857896.042366892, 4053493.7202564813],
              [-8851603.59683031, 4041862.0316163395],
              [-8851785.270239286, 4027993.7158567477],
              [-8830342.575964214, 4001860.940382535],
              [-8849506.114984786, 3998679.7071153196],
              [-8865017.595470902, 4004395.0663563134],
              [-8870766.57925343, 4002636.7266935925],
              [-8891713.345197018, 4013403.6218870375],
              [-8899501.702050878, 4013466.914752439],
              [-8902731.859715227, 4021624.166668042],
              [-8893705.630123746, 4027193.1154742944],
              [-8894852.888795862, 4029118.7865973786],
              [-8905625.387239415, 4035232.550621721],
              [-8908445.777858157, 4038638.7319942284],
              [-8913338.046839539, 4040381.25153419],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carlton',
        GEOID: '27017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10359562.02072346, 5904051.990756253],
              [-10274975.57168572, 5903659.359181828],
              [-10273919.817635037, 5887278.78395343],
              [-10273939.74382389, 5860125.872901868],
              [-10273983.025112225, 5847462.8895264305],
              [-10358818.18388598, 5847793.833309267],
              [-10359562.02072346, 5904051.990756253],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dixie',
        GEOID: '12029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9285618.088410504, 3460697.456997272],
              [-9280304.974629378, 3460650.7956404807],
              [-9275012.95735656, 3480769.9995812513],
              [-9230679.858828647, 3480965.035228985],
              [-9233919.14469124, 3472020.3114581886],
              [-9234494.889097624, 3450393.672674941],
              [-9232541.2320342, 3451109.3936000606],
              [-9237777.923520098, 3435731.969780494],
              [-9246255.68198044, 3420199.713747854],
              [-9257988.067419002, 3412492.6559655294],
              [-9258394.849812467, 3412653.8815566534],
              [-9259056.31022676, 3419590.9261384746],
              [-9262053.92147484, 3425943.5400320655],
              [-9266291.075252905, 3430896.2668880434],
              [-9272328.82179455, 3431502.7722212817],
              [-9273784.992053619, 3435457.958942256],
              [-9284218.300008725, 3442419.349016206],
              [-9284609.699338356, 3451669.3503026916],
              [-9285618.088410504, 3460697.456997272],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crow Wing',
        GEOID: '27035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10507326.733566016, 5818597.978520081],
              [-10502067.66686247, 5824963.87215559],
              [-10500872.652128804, 5882074.330194615],
              [-10502204.701155636, 5910389.023262194],
              [-10439099.240297802, 5909960.0041416995],
              [-10439308.632259982, 5875353.2434353605],
              [-10442926.738349747, 5820655.41553744],
              [-10441354.2392228, 5819408.051214924],
              [-10442970.70954861, 5817974.982894113],
              [-10442921.72897266, 5805477.681455855],
              [-10505731.52526295, 5805559.320532962],
              [-10507326.733566016, 5818597.978520081],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Baraga',
        GEOID: '26013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9871687.65439832, 5917917.683092402],
              [-9857557.203514986, 5917916.706445444],
              [-9857584.142831758, 5932046.858374099],
              [-9845024.875940649, 5932609.263777756],
              [-9846810.531193294, 5929567.076817207],
              [-9849318.670640359, 5917715.682269076],
              [-9837601.848956402, 5921251.289384831],
              [-9823325.79217911, 5930592.517690688],
              [-9812110.46480118, 5936634.648350859],
              [-9803372.33005187, 5928791.596836765],
              [-9801071.32080891, 5928610.196171408],
              [-9801092.17292195, 5903857.460411836],
              [-9795174.094832908, 5889853.531693083],
              [-9809010.773580039, 5889734.762911024],
              [-9809091.814169336, 5847903.962428787],
              [-9871744.761297097, 5847934.320844697],
              [-9871687.65439832, 5917917.683092402],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sargent',
        GEOID: '38081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10910057.608121486, 5825756.488767005],
              [-10829223.293840423, 5825707.360896612],
              [-10826860.203689862, 5824171.6488159625],
              [-10826892.708981175, 5779898.126007958],
              [-10823403.844820224, 5770044.133198858],
              [-10858392.340012984, 5769980.332350808],
              [-10884490.304073542, 5770001.940951155],
              [-10906947.654314568, 5770088.534679322],
              [-10910211.985799603, 5770101.121748125],
              [-10910057.608121486, 5825756.488767005],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Barton',
        GEOID: '20009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11024299.903465027, 4678327.515438062],
              [-10963423.392771346, 4678344.488674905],
              [-10962733.768525882, 4676155.316808439],
              [-10962785.42076961, 4653409.008216801],
              [-10962725.753522545, 4616332.482413575],
              [-11010898.372607408, 4616374.730582719],
              [-11024226.209962124, 4616394.43700276],
              [-11024237.23059171, 4628751.2667601],
              [-11024299.903465027, 4678327.515438062],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Delaware',
        GEOID: '18035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9526564.950286843, 4921247.919134941],
              [-9511619.30677243, 4921191.804337319],
              [-9486635.984773185, 4921176.314371389],
              [-9486508.746595208, 4910612.571753738],
              [-9486022.05778146, 4877121.878334475],
              [-9526298.674064865, 4877158.830634246],
              [-9526564.950286843, 4921247.919134941],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. James',
        GEOID: '22093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10126031.985435663, 3512094.234294001],
              [-10120674.400982765, 3518119.901172247],
              [-10090221.06184492, 3524960.8571146],
              [-10095436.602627568, 3508172.1040715463],
              [-10091814.489036137, 3489321.3788476335],
              [-10105281.698393324, 3493531.3305631885],
              [-10117337.487926746, 3491389.6464448944],
              [-10121819.210626082, 3495191.6522750063],
              [-10125606.29970287, 3500712.4950476885],
              [-10126031.985435663, 3512094.234294001],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clare',
        GEOID: '26035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9471886.374882057, 5490894.290609302],
              [-9445648.593541065, 5490449.393141987],
              [-9418531.054264333, 5490310.822936806],
              [-9418300.956876865, 5436913.808547633],
              [-9472043.112725094, 5436653.245102633],
              [-9471886.374882057, 5490894.290609302],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ramsey',
        GEOID: '38071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11042927.55045692, 6168742.141891519],
              [-11017398.540313808, 6168710.973587522],
              [-11017333.641050674, 6197877.9845919],
              [-10944720.605123168, 6197800.806043241],
              [-10944784.279871901, 6168585.2960974],
              [-10941827.856835414, 6168580.771742273],
              [-10941835.87183875, 6139386.974204717],
              [-10956298.054804651, 6139328.024419738],
              [-10956360.282400005, 6110368.337675835],
              [-10967820.623977171, 6110374.1628152765],
              [-10967814.612724667, 6092734.796220178],
              [-10978927.526171071, 6092957.859429201],
              [-10984126.369030097, 6106921.380890471],
              [-10997732.505111795, 6098759.03775452],
              [-10992867.62072515, 6103936.634526266],
              [-10998799.057153087, 6116826.018691562],
              [-11019655.876948114, 6105234.598872129],
              [-11020745.138165526, 6115725.641571263],
              [-11028461.026030881, 6110508.142114002],
              [-11028471.267424034, 6124817.190545072],
              [-11042883.579258058, 6132731.720879931],
              [-11042927.55045692, 6168742.141891519],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ada',
        GEOID: '16001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12970112.393690268, 5435648.239624796],
              [-12944455.14349376, 5435679.707051678],
              [-12942380.70478283, 5433586.27764187],
              [-12912259.320366533, 5402992.989996339],
              [-12910357.983463783, 5402432.436978995],
              [-12910264.697730498, 5367697.684781401],
              [-12910684.372210788, 5329253.32235208],
              [-12942694.95970534, 5329075.975818252],
              [-12956025.246088851, 5341482.808777617],
              [-12960402.328466844, 5356759.353488087],
              [-12970045.045398338, 5356297.018614449],
              [-12965781.508900957, 5382132.780304659],
              [-12970181.523094052, 5409004.586035343],
              [-12970112.393690268, 5435648.239624796],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '39097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9311560.259378897, 4833014.082717603],
              [-9304978.160527272, 4832398.399751552],
              [-9296975.847612107, 4867422.882364411],
              [-9295590.921827149, 4882153.751562055],
              [-9262479.941166107, 4881610.117957647],
              [-9262960.17344939, 4875432.694369393],
              [-9267909.88328802, 4873009.250324341],
              [-9266646.518387008, 4838733.017839786],
              [-9267618.671500105, 4821782.362713118],
              [-9312246.098761676, 4824884.366350133],
              [-9311560.259378897, 4833014.082717603],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Anderson',
        GEOID: '20003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10631938.439476952, 4634706.6615513805],
              [-10582679.8987594, 4634659.367139789],
              [-10584020.742026005, 4584753.776280674],
              [-10633123.101497974, 4584827.838267016],
              [-10631938.439476952, 4634706.6615513805],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clarke',
        GEOID: '19039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10465611.646822581, 5035491.5925483415],
              [-10440565.540630529, 5036271.247362073],
              [-10414779.493783174, 5036158.280025155],
              [-10414666.39318053, 4997351.753887229],
              [-10465679.996989928, 4997165.602905701],
              [-10465611.646822581, 5035491.5925483415],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Amelia',
        GEOID: '51007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8709084.703671899, 4490540.416145068],
              [-8703514.610311076, 4501254.084858869],
              [-8697619.797995608, 4502675.080338608],
              [-8682872.971091751, 4508758.062735041],
              [-8671761.72743771, 4505583.294734309],
              [-8666795.430994952, 4497582.738871634],
              [-8669247.02014069, 4490129.88456748],
              [-8656049.983187659, 4476628.953222226],
              [-8644203.36297744, 4476223.999692161],
              [-8644026.364987077, 4476124.687041317],
              [-8654833.59511176, 4466004.879830878],
              [-8660202.868111191, 4465985.735179434],
              [-8663562.712982314, 4467298.551836556],
              [-8708661.13300943, 4480476.8585895905],
              [-8709084.703671899, 4490540.416145068],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wilkinson',
        GEOID: '13319',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9279335.047906097, 3885504.514935485],
              [-9254417.515725914, 3896266.053689641],
              [-9247716.193699649, 3888213.108824059],
              [-9242527.369594794, 3876223.557669467],
              [-9236652.928746141, 3873984.620875057],
              [-9234548.879050659, 3863022.670564007],
              [-9233614.017966976, 3863406.150047319],
              [-9234738.344823986, 3856651.746764849],
              [-9264735.608008051, 3840242.7621069774],
              [-9284823.65539966, 3881802.149990298],
              [-9279335.047906097, 3885504.514935485],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Zavala',
        GEOID: '48507',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11144350.738518674, 3386636.9761429043],
              [-11066702.499383602, 3387276.077807583],
              [-11066161.597977838, 3329977.1987439627],
              [-11144676.904626697, 3330935.628953928],
              [-11144350.738518674, 3386636.9761429043],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Geauga',
        GEOID: '39055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9060496.625054725, 5073943.623729465],
              [-9060462.33865156, 5078235.274280712],
              [-9060405.231752783, 5096741.327357841],
              [-9049815.965191074, 5096776.145036176],
              [-9049681.157287722, 5107337.228333967],
              [-9028168.999650395, 5107421.836538383],
              [-9028262.062744696, 5118279.623926529],
              [-9017282.95532623, 5118403.400528956],
              [-9017226.627663888, 5086624.0990496855],
              [-9017248.2236451, 5063787.127567912],
              [-9060481.93088194, 5063848.221224275],
              [-9060496.625054725, 5073943.623729465],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Floyd',
        GEOID: '21071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9232923.503165584, 4539431.0231308],
              [-9211936.105607856, 4545045.869522689],
              [-9199526.208774222, 4539971.97970596],
              [-9192385.620037287, 4536342.169627231],
              [-9190933.568599379, 4535000.007186318],
              [-9196588.042134225, 4533010.081357566],
              [-9197562.75559561, 4509528.26079494],
              [-9193287.975829659, 4504342.268171432],
              [-9203046.68767056, 4481963.204023101],
              [-9207324.695701744, 4478952.10670736],
              [-9211949.01866879, 4482130.870133673],
              [-9213142.474929582, 4498589.991680525],
              [-9221203.007938433, 4497033.598329695],
              [-9220757.396016788, 4504400.613326608],
              [-9231219.980997976, 4507140.817033309],
              [-9226057.205653964, 4513999.0255108485],
              [-9232923.503165584, 4539431.0231308],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lubbock',
        GEOID: '48303',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11364131.814818084, 4005284.3873296673],
              [-11306006.008741904, 4006058.3952843477],
              [-11305260.613431552, 3947819.741062132],
              [-11363040.438530348, 3947129.8966000425],
              [-11364131.814818084, 4005284.3873296673],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Terrell',
        GEOID: '13273',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9417603.985545006, 3752836.385876871],
              [-9401299.465006478, 3752712.186060896],
              [-9400241.595885469, 3759039.4791256376],
              [-9390646.746335015, 3748244.990276269],
              [-9388490.487798352, 3746728.895454436],
              [-9383651.874811528, 3745516.2876706976],
              [-9383988.282312706, 3713787.4845251204],
              [-9400975.302649288, 3713776.6339905816],
              [-9403935.955826426, 3713684.9931150405],
              [-9411712.735453244, 3713689.176420998],
              [-9410441.466868386, 3720919.949276096],
              [-9417972.453059532, 3733419.2845598995],
              [-9417603.985545006, 3752836.385876871],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cherokee',
        GEOID: '19035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10671017.035400439, 5298145.70292203],
              [-10618563.847936105, 5298267.292132957],
              [-10618544.700983686, 5245500.647238271],
              [-10657907.38424768, 5245431.578067807],
              [-10671080.710149175, 5245331.073504615],
              [-10671017.035400439, 5298145.70292203],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Boise',
        GEOID: '16015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12943458.834051162, 5488874.81288824],
              [-12936868.942835184, 5488899.636648674],
              [-12925583.26153907, 5488349.185560025],
              [-12924534.854574777, 5502100.205997344],
              [-12859659.52513282, 5501936.599994162],
              [-12846425.97538681, 5505707.739898772],
              [-12841536.378073202, 5519137.16099487],
              [-12834537.72168703, 5518123.229868819],
              [-12821663.622576786, 5511444.746038521],
              [-12820407.938720638, 5496885.986245227],
              [-12804433.257833332, 5489534.372033381],
              [-12806590.518245416, 5474549.230401852],
              [-12800714.741562873, 5457664.995478126],
              [-12809258.51248126, 5456358.847234576],
              [-12816904.15774792, 5462944.6660723],
              [-12821993.90750597, 5479463.079264803],
              [-12827403.70080005, 5480739.192458316],
              [-12823678.060082182, 5476125.224083611],
              [-12833715.293289049, 5455469.170944622],
              [-12858372.115221797, 5447640.485752962],
              [-12862693.092576427, 5433412.784792904],
              [-12867731.19009075, 5434279.819013467],
              [-12871384.584459094, 5423484.873016238],
              [-12879387.676610695, 5413803.075835797],
              [-12890475.097893704, 5409685.207620583],
              [-12899249.18883854, 5402405.847290398],
              [-12910357.983463783, 5402432.436978995],
              [-12912259.320366533, 5402992.989996339],
              [-12942380.70478283, 5433586.27764187],
              [-12944455.14349376, 5435679.707051678],
              [-12943458.834051162, 5488874.81288824],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Highland',
        GEOID: '39071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9335884.681312136, 4757162.080447951],
              [-9330117.6637721, 4753671.256626316],
              [-9326880.492979832, 4759398.285698932],
              [-9305293.973922653, 4776068.370110229],
              [-9281008.06853323, 4775878.271513436],
              [-9282493.404498884, 4767568.426717269],
              [-9283354.683399154, 4760140.203026133],
              [-9278872.626741342, 4750013.576333683],
              [-9282446.650312752, 4729581.156062116],
              [-9307599.845854945, 4724377.7643117495],
              [-9314437.756896414, 4724598.417422258],
              [-9336612.15418447, 4724723.647364355],
              [-9335884.681312136, 4757162.080447951],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pulaski',
        GEOID: '17153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9935090.783574536, 4485920.164929136],
              [-9912420.346635507, 4485183.336250421],
              [-9912404.873226287, 4480214.205487727],
              [-9899545.356969336, 4481376.253725435],
              [-9899420.214881077, 4470709.755362962],
              [-9899836.568757253, 4470877.974147809],
              [-9900033.850800553, 4470866.549139392],
              [-9907542.437868435, 4470431.720639292],
              [-9913895.218569025, 4465451.236123851],
              [-9918460.542205948, 4458774.02612124],
              [-9926146.039850317, 4449456.8744810885],
              [-9925982.757759249, 4449162.811183773],
              [-9936575.78558172, 4453856.125232733],
              [-9935090.783574536, 4485920.164929136],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Isanti',
        GEOID: '27059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10409895.573763603, 5737875.235456814],
              [-10368496.968332492, 5737291.374156157],
              [-10368517.117160324, 5709816.460681985],
              [-10355192.174112372, 5709664.630623031],
              [-10354890.38697283, 5686580.869862137],
              [-10409493.376443366, 5687061.042517037],
              [-10409563.953000529, 5709921.868826899],
              [-10409895.573763603, 5737875.235456814],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dooly',
        GEOID: '13093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9353909.644580875, 3785799.7237400305],
              [-9339164.598788869, 3801711.2372923573],
              [-9333958.854121411, 3801565.8560395786],
              [-9319493.44289028, 3801459.454940283],
              [-9315786.058568902, 3801423.9003288676],
              [-9308043.67666474, 3801247.9724023095],
              [-9307001.05831397, 3799552.2970321076],
              [-9307260.878005482, 3778863.1782993125],
              [-9307385.110557204, 3766978.4827428428],
              [-9346526.713312482, 3767327.3666838524],
              [-9354565.76165961, 3783421.309116739],
              [-9353909.644580875, 3785799.7237400305],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Watonwan',
        GEOID: '27165',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10559744.966710245, 5482173.152415711],
              [-10505092.328746814, 5482278.886777776],
              [-10505106.132363673, 5441957.139865823],
              [-10559148.405559083, 5441965.166460558],
              [-10559698.769121565, 5441964.240314654],
              [-10559744.966710245, 5482173.152415711],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lafayette',
        GEOID: '05073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10447342.671230024, 3914611.7442550366],
              [-10436221.965419266, 3919745.6470364244],
              [-10430918.03696093, 3927979.960207151],
              [-10430547.120417608, 3936901.708784989],
              [-10426797.768648198, 3938791.4120954284],
              [-10434345.118804492, 3951302.9228499136],
              [-10433181.830125703, 3959452.6210102034],
              [-10406490.755818201, 3958666.793546273],
              [-10406588.383011624, 3954816.903856106],
              [-10393409.3798161, 3954448.1545405844],
              [-10401917.973775394, 3929621.39842162],
              [-10406341.92165901, 3929864.485681693],
              [-10407316.234383631, 3897777.6555847214],
              [-10410709.380886873, 3897791.9537119335],
              [-10433227.025838964, 3897886.839580648],
              [-10442314.567381844, 3897878.7709986735],
              [-10448492.93552839, 3907601.7903431216],
              [-10447342.671230024, 3914611.7442550366],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Alexander',
        GEOID: '37003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9055171.87985161, 4276453.367933439],
              [-9053427.614750369, 4300151.208299449],
              [-9046222.126750302, 4304174.470799407],
              [-9020088.429133201, 4306904.836408533],
              [-9017495.575553644, 4294883.244506317],
              [-9021480.590685062, 4281080.0253565125],
              [-9029069.017733457, 4269924.433620792],
              [-9032803.341371609, 4276964.65899004],
              [-9044597.084823703, 4275293.715823424],
              [-9046335.11603346, 4273851.839161339],
              [-9054089.743081609, 4272626.037080917],
              [-9055171.87985161, 4276453.367933439],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Somervell',
        GEOID: '48425',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10903257.100428924, 3793996.0974730933],
              [-10885127.051560879, 3804927.3285228815],
              [-10866483.931159766, 3805207.2415023465],
              [-10866458.216357393, 3790063.5634878404],
              [-10869477.53490618, 3789762.9561744984],
              [-10894266.82703297, 3774779.2508472567],
              [-10903257.100428924, 3793996.0974730933],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Warren',
        GEOID: '13301',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9224668.272367338, 3957402.214591872],
              [-9218958.69568455, 3964682.2434154884],
              [-9211829.795494149, 3963214.335392095],
              [-9203892.715800589, 3975189.6302024713],
              [-9200523.074814277, 3976389.3274833164],
              [-9189208.895728521, 3942224.171981171],
              [-9170925.893880123, 3936804.4676570604],
              [-9176283.478333022, 3931840.124233951],
              [-9190509.66397844, 3938824.58622944],
              [-9212338.636886565, 3928992.4037652137],
              [-9219937.194008622, 3952202.8261752706],
              [-9223037.330507724, 3954325.9522220776],
              [-9224668.272367338, 3957402.214591872],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mecklenburg',
        GEOID: '37119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9023338.512986401, 4173831.8262763466],
              [-9020970.747417228, 4180547.96811625],
              [-9021587.841463896, 4183844.3479624013],
              [-9017525.075218704, 4185240.469778234],
              [-9018554.112591598, 4200450.484933726],
              [-9013828.26624895, 4211593.188027663],
              [-9008314.055272507, 4213000.416535752],
              [-9011853.79244075, 4218383.939398153],
              [-9010464.52519565, 4225907.121066468],
              [-9011017.115147948, 4230462.411225926],
              [-9006495.206112435, 4234060.300997984],
              [-8992852.334598774, 4232861.238098832],
              [-8990876.079678722, 4218575.134928309],
              [-8982710.461070562, 4211052.865472956],
              [-8979751.477685787, 4200352.18051585],
              [-8972321.235633807, 4195740.763796766],
              [-8966823.833900472, 4192239.6947504855],
              [-8991551.343709873, 4168387.9613371184],
              [-8999130.743751822, 4164081.1208292553],
              [-9006134.32910798, 4173681.9049641686],
              [-9006441.43368687, 4174103.085732383],
              [-9009637.421379056, 4178487.1950109634],
              [-9021497.288608681, 4169957.763835594],
              [-9023338.512986401, 4173831.8262763466],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '39101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9286253.66557839, 4966257.2969596265],
              [-9274088.671624502, 4966299.28311604],
              [-9273435.337533036, 4968486.4825523],
              [-9251914.274336444, 4968619.959101533],
              [-9223743.98663528, 4968928.915110041],
              [-9223905.511216423, 4960324.086517103],
              [-9234810.591173511, 4958748.195835351],
              [-9234886.956344197, 4937502.528879814],
              [-9241832.958611226, 4929181.884233482],
              [-9267191.20465546, 4930672.875677002],
              [-9267158.142766694, 4939015.132501626],
              [-9269325.421932949, 4939880.230424468],
              [-9286091.361760814, 4939635.143330008],
              [-9285824.083663419, 4942672.517609332],
              [-9286253.66557839, 4966257.2969596265],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Newton',
        GEOID: '18111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9743421.903799748, 5036870.845693636],
              [-9728632.869211229, 5036385.251075138],
              [-9715506.742773829, 5044638.040057689],
              [-9714551.17626486, 4973564.867814964],
              [-9743364.945216527, 4973609.394873826],
              [-9743351.309644932, 4996952.211101009],
              [-9743401.318186028, 5013866.418084007],
              [-9743407.637307273, 5016005.806205696],
              [-9743421.903799748, 5036870.845693636],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Johnson',
        GEOID: '20091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10581614.237274038, 4719110.739509456],
              [-10566818.875072194, 4722048.734255922],
              [-10565195.391618464, 4720439.914450018],
              [-10561414.647752654, 4729989.434548356],
              [-10531699.952773636, 4727988.353117997],
              [-10531751.56567995, 4719065.773164461],
              [-10531821.289947208, 4699809.474876063],
              [-10531876.46614862, 4684596.840158712],
              [-10531880.21453701, 4684226.019284004],
              [-10565177.691819428, 4684251.606701321],
              [-10581631.38047562, 4684295.277588117],
              [-10581614.237274038, 4719110.739509456],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Davis',
        GEOID: '19051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10312536.437671732, 4997438.792473201],
              [-10261327.356836502, 4997561.619821107],
              [-10261406.171035983, 4953597.145686845],
              [-10280444.496415699, 4953117.474488789],
              [-10291903.815331163, 4952828.767910356],
              [-10312404.222800016, 4952193.783384186],
              [-10312536.437671732, 4997438.792473201],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kit Carson',
        GEOID: '08063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11483190.236611307, 4740020.798193209],
              [-11483092.60941788, 4803023.602790452],
              [-11443970.042295529, 4803339.416876367],
              [-11360153.159997463, 4804236.963398499],
              [-11360149.789486405, 4803388.2239183355],
              [-11360038.263183143, 4775344.862523559],
              [-11359842.421218736, 4740761.681130939],
              [-11359772.320919638, 4728411.6038922835],
              [-11434266.767561043, 4727212.94952757],
              [-11484055.411693752, 4727060.315099181],
              [-11483190.236611307, 4740020.798193209],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Livingston',
        GEOID: '17105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9899740.388717208, 5027974.460595381],
              [-9861375.128090722, 5028328.002622406],
              [-9824112.153062072, 5029203.418085707],
              [-9823644.499881253, 5011539.298199444],
              [-9822269.704169953, 4956189.490679705],
              [-9847263.712840313, 4956062.929491371],
              [-9860068.45990779, 4955946.34212613],
              [-9861156.05133284, 4976654.37359559],
              [-9899567.843506476, 4976026.72489281],
              [-9899797.05033802, 5001689.165741317],
              [-9899740.388717208, 5027974.460595381],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Troup',
        GEOID: '13285',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9488494.393680159, 3912511.417002534],
              [-9475225.848286366, 3917046.495684192],
              [-9474176.99604411, 3921228.684163125],
              [-9471956.84011973, 3918116.6387408436],
              [-9455367.898282224, 3925166.319615465],
              [-9446809.655830039, 3925055.2040241393],
              [-9446834.591395976, 3920706.560137307],
              [-9446768.801576916, 3878392.0107288845],
              [-9448987.844306389, 3877897.1091137505],
              [-9482875.211823193, 3878079.6490373826],
              [-9488031.931187732, 3909657.913825063],
              [-9488494.393680159, 3912511.417002534],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fayette',
        GEOID: '19065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10250473.261206193, 5297828.970437386],
              [-10250426.284381079, 5324582.440724739],
              [-10197456.129201498, 5324408.535987587],
              [-10197651.160949368, 5257936.961896685],
              [-10250483.613918837, 5257646.854859358],
              [-10250473.261206193, 5297828.970437386],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McPherson',
        GEOID: '20113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10900938.3154357, 4665943.294229932],
              [-10839391.550087953, 4665868.218482266],
              [-10839373.627649935, 4603989.117655281],
              [-10876119.189685378, 4604009.083620796],
              [-10900642.316909682, 4603994.781755048],
              [-10900879.761383545, 4653539.057370925],
              [-10900938.3154357, 4665943.294229932],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '19069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10408218.43431531, 5298056.791810463],
              [-10355511.661050947, 5297910.43228002],
              [-10355718.27002586, 5244755.271016164],
              [-10408315.05963332, 5244889.7729123235],
              [-10408218.43431531, 5298056.791810463],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dale',
        GEOID: '01045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9550003.603031838, 3713266.2776122475],
              [-9545451.637733812, 3713277.25841551],
              [-9514147.149769364, 3713606.425667252],
              [-9508514.272215731, 3713462.6263283053],
              [-9508625.257748052, 3673722.296664517],
              [-9516241.737308128, 3664750.8049149206],
              [-9536308.96795496, 3667514.092567136],
              [-9541230.625281911, 3658122.0970630767],
              [-9550255.185081031, 3658275.138126615],
              [-9550003.603031838, 3713266.2776122475],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McLennan',
        GEOID: '48309',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10865364.502360348, 3709318.798020666],
              [-10828855.605562333, 3729948.6671288507],
              [-10802139.039091438, 3745351.007028806],
              [-10790444.815264115, 3725157.891447446],
              [-10775851.720577043, 3700763.085764973],
              [-10828950.004490525, 3669139.9304568297],
              [-10836220.614392707, 3664505.8893543105],
              [-10844589.613710545, 3674403.661620766],
              [-10865364.502360348, 3709318.798020666],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Okeechobee',
        GEOID: '12093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9032516.025765872, 3198799.453099392],
              [-9032704.378344294, 3204068.2689531012],
              [-9002757.876848033, 3203948.8891314026],
              [-8992171.059315119, 3204062.8654229813],
              [-8992072.98684373, 3193453.169105151],
              [-8981236.591012457, 3193420.145114248],
              [-8981018.516129995, 3149230.8835337497],
              [-8980970.0921515, 3138674.670218813],
              [-9004148.145968549, 3118340.1578916665],
              [-9003372.24911772, 3144629.631490365],
              [-9010274.836783338, 3149224.75035807],
              [-9013666.519028828, 3150707.8057152987],
              [-9020711.37300368, 3168416.1533567677],
              [-9027838.158123756, 3170916.6525210715],
              [-9040732.740020305, 3189683.671058696],
              [-9032516.025765872, 3198799.453099392],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Menard',
        GEOID: '17129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10018207.592694825, 4881781.137359139],
              [-10015423.826188559, 4886637.2836883105],
              [-9990834.797825705, 4884393.225488682],
              [-9978485.681434043, 4888473.153863486],
              [-9974404.931540543, 4883749.747014129],
              [-9971902.803345984, 4879367.635576366],
              [-9971809.5176127, 4862473.726407995],
              [-9985164.516923167, 4862354.8991229],
              [-9985565.823687477, 4853857.351080806],
              [-9993065.640421202, 4851771.75501677],
              [-10018142.582112204, 4851700.506210422],
              [-10018207.592694825, 4881781.137359139],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dickenson',
        GEOID: '51051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9189829.11727013, 4467223.6934816055],
              [-9178198.952811103, 4473159.167099428],
              [-9167754.846865386, 4476139.793694022],
              [-9163193.803789007, 4480488.928175628],
              [-9160815.635087298, 4481844.943640188],
              [-9145774.368130293, 4454530.325181975],
              [-9144826.593985677, 4444912.596110775],
              [-9159920.403742338, 4438887.812372576],
              [-9164692.11371519, 4435062.823727197],
              [-9168538.870039044, 4432936.104274965],
              [-9180222.852473214, 4442192.709486795],
              [-9188993.715152817, 4456561.001639643],
              [-9189829.11727013, 4467223.6934816055],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Phillips',
        GEOID: '08095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11428580.901929794, 4968953.878711795],
              [-11427091.55846247, 4975448.489061515],
              [-11360297.860235674, 4975476.261232729],
              [-11360298.099748353, 4967831.729722487],
              [-11360299.284968976, 4930090.58010256],
              [-11428593.703671236, 4929866.068247792],
              [-11428580.901929794, 4968953.878711795],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Thomas',
        GEOID: '20193',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11286579.421764588, 4803415.6642938135],
              [-11214422.684429841, 4803368.587221285],
              [-11212122.823750053, 4803367.287550644],
              [-11212243.38275858, 4740795.304652986],
              [-11222324.698483802, 4740792.290894143],
              [-11286874.307095699, 4741044.445158808],
              [-11286579.421764588, 4803415.6642938135],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Latah',
        GEOID: '16057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13028814.655062215, 5962872.409168645],
              [-13020788.699442564, 5960903.192366837],
              [-13006042.651775142, 5947372.67439726],
              [-12964058.617141949, 5948049.518146864],
              [-12949731.576037873, 5945651.892111416],
              [-12949733.579788707, 5931416.902345262],
              [-12949745.15701575, 5881557.215551382],
              [-12963833.529131563, 5881742.011642175],
              [-12981159.517317612, 5882090.216957728],
              [-12993109.108056817, 5867776.073534179],
              [-13028808.451175122, 5867587.523786891],
              [-13028814.655062215, 5962872.409168645],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '19125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10389293.786921982, 5087536.6236671815],
              [-10338399.294967733, 5087640.382555046],
              [-10338215.617807925, 5036127.968332924],
              [-10363757.429692477, 5036098.543902863],
              [-10389212.746332685, 5036067.788815179],
              [-10389270.743787387, 5085024.305399978],
              [-10389293.786921982, 5087536.6236671815],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clarke',
        GEOID: '13059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9299339.16040165, 4024225.758469563],
              [-9295517.450963225, 4028745.2277106424],
              [-9290059.567649122, 4029447.7756200037],
              [-9282360.489026878, 4033879.444293988],
              [-9279595.869473027, 4034251.156363697],
              [-9272298.988171019, 4029895.618786958],
              [-9268284.139416069, 4028680.910215281],
              [-9270536.355353797, 4022324.397565321],
              [-9266330.148394175, 4015976.517731831],
              [-9270234.456894767, 4008407.2721186746],
              [-9285772.3201002, 4017869.310195827],
              [-9296123.362951612, 4019578.605711935],
              [-9299339.16040165, 4024225.758469563],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '19137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10618137.160327893, 5035971.975513866],
              [-10592700.879320612, 5035857.385232355],
              [-10567290.647074176, 5035749.74553114],
              [-10567387.717670146, 4997699.0292291455],
              [-10618205.62181473, 4997831.13849401],
              [-10618137.160327893, 5035971.975513866],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Plymouth',
        GEOID: '19149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10755897.92449133, 5278432.337295464],
              [-10751006.768704854, 5285774.345900077],
              [-10746544.415596914, 5293492.7575881425],
              [-10746836.220627915, 5298069.512576349],
              [-10671017.035400439, 5298145.70292203],
              [-10671080.710149175, 5245331.073504615],
              [-10740106.974083642, 5245437.589719592],
              [-10745310.439041473, 5257514.894678597],
              [-10752527.949546544, 5264614.467338593],
              [-10756212.847330783, 5270282.589578459],
              [-10755897.92449133, 5278432.337295464],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Poweshiek',
        GEOID: '19157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10326663.771609325, 5140385.829136016],
              [-10274584.617634054, 5140446.5150831025],
              [-10274510.033575222, 5087828.875774914],
              [-10287256.226590542, 5087792.901231802],
              [-10325607.238322206, 5087680.816120836],
              [-10326748.374422327, 5101450.149691622],
              [-10326663.771609325, 5140385.829136016],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tazewell',
        GEOID: '17179',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10005978.59003373, 4937768.348471592],
              [-10004556.81749732, 4940791.088585987],
              [-9993196.552142374, 4946652.998773586],
              [-9982620.309961088, 4946768.596597311],
              [-9973353.29631102, 4965991.878154624],
              [-9969035.992499584, 4969146.834818645],
              [-9969216.330074668, 4975189.138997938],
              [-9944188.70291809, 4975280.241352094],
              [-9943874.336676091, 4955802.039685886],
              [-9937423.038226148, 4952688.176397173],
              [-9936794.083103165, 4913333.630084763],
              [-9974557.995840384, 4912572.18949244],
              [-9987019.990195712, 4912439.180689526],
              [-9987262.332727166, 4929453.914075016],
              [-10010369.587348072, 4929492.817882445],
              [-10005978.59003373, 4937768.348471592],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Elbert',
        GEOID: '08039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11650767.592425248, 4803060.425593382],
              [-11648708.070526082, 4803057.681928886],
              [-11545429.186552808, 4803121.364019624],
              [-11546020.181729427, 4702613.595566401],
              [-11583408.391185218, 4702905.407045704],
              [-11582967.56600168, 4740042.897425219],
              [-11651020.28766935, 4740242.223201245],
              [-11650767.592425248, 4803060.425593382],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Warren',
        GEOID: '21227',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9642816.562439203, 4464378.407049271],
              [-9628822.811890561, 4465677.608889209],
              [-9617911.052764025, 4462814.630543743],
              [-9604840.474752532, 4450346.931764398],
              [-9597811.428145371, 4453617.024895423],
              [-9586112.306260454, 4447622.858663851],
              [-9592037.620116396, 4429913.31579982],
              [-9595897.846098635, 4430094.363580802],
              [-9618646.206681222, 4407955.887462417],
              [-9618061.668035066, 4412270.532562581],
              [-9638407.642686844, 4415476.615238516],
              [-9641557.650317824, 4422818.952273968],
              [-9648556.974620938, 4439074.170718471],
              [-9642816.562439203, 4464378.407049271],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Polk',
        GEOID: '19153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10443518.29012382, 5140542.178442265],
              [-10430417.210571853, 5140534.854182479],
              [-10391444.368164618, 5140495.094013016],
              [-10391527.63514373, 5101397.153485782],
              [-10389293.786921982, 5087536.6236671815],
              [-10389270.743787387, 5085024.305399978],
              [-10399209.459244903, 5088089.323585666],
              [-10440723.169029493, 5088144.92237603],
              [-10443358.101376569, 5101316.319948354],
              [-10443518.29012382, 5140542.178442265],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sherman',
        GEOID: '48421',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11372673.359346652, 4369685.655789684],
              [-11358188.02403762, 4369649.605165908],
              [-11335281.365028173, 4369592.596077415],
              [-11312722.470218915, 4369575.147471277],
              [-11312672.48776755, 4308247.695102639],
              [-11372734.80770557, 4308226.214663013],
              [-11372673.359346652, 4369685.655789684],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Valencia',
        GEOID: '35061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11933770.235811394, 4158116.8421057174],
              [-11918595.162826454, 4158064.956841336],
              [-11913968.05687214, 4146366.7908188906],
              [-11880090.196239023, 4146235.8579978542],
              [-11876209.042192517, 4151162.840623404],
              [-11847065.042905385, 4150553.3808861733],
              [-11846005.17003354, 4149244.5803035325],
              [-11845705.275325343, 4146262.85852637],
              [-11851503.573642293, 4146254.9890188477],
              [-11851579.048257051, 4138160.8825633945],
              [-11851604.540420443, 4134458.1878647194],
              [-11851812.03995128, 4130617.8395152264],
              [-11851819.609676655, 4125490.2604684206],
              [-11852162.807666771, 4099005.308170092],
              [-11846273.00472839, 4099072.593240427],
              [-11846277.791466493, 4087995.158787437],
              [-11885390.673793146, 4100362.5717632137],
              [-11898123.063191608, 4106886.883586414],
              [-11933643.442911379, 4106782.2354815877],
              [-11933770.235811394, 4158116.8421057174],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Lorenzo',
        GEOID: '72129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7352936.788194696, 2050787.3255650287],
              [-7351055.043522327, 2051505.8912377278],
              [-7346824.791552692, 2061790.8776992036],
              [-7341633.852377511, 2064404.305372522],
              [-7339227.681584013, 2060670.7220870354],
              [-7339109.3489653, 2054275.0935262984],
              [-7338874.019561764, 2051594.791332457],
              [-7339646.465508377, 2048525.2085326207],
              [-7348226.860539231, 2046395.1931564207],
              [-7352851.406145257, 2050413.587664792],
              [-7352936.788194696, 2050787.3255650287],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Villalba',
        GEOID: '72149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7405183.923281573, 2055342.1814391466],
              [-7399467.222151377, 2058373.651900888],
              [-7396574.585183112, 2058238.3245088041],
              [-7393770.224571049, 2054563.1514107466],
              [-7394988.727717272, 2047154.9423993588],
              [-7404777.050542725, 2047503.5605388882],
              [-7405183.923281573, 2055342.1814391466],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scott',
        GEOID: '28123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9993252.323207263, 3843142.8903275444],
              [-9988731.750005638, 3846853.881515778],
              [-9988714.829443038, 3839324.2081619445],
              [-9943346.125692276, 3839216.543982905],
              [-9943356.589724408, 3792680.6790606156],
              [-9985538.773051215, 3792718.1814836147],
              [-9988745.108344534, 3792492.1160278893],
              [-9988704.922008358, 3809701.89696339],
              [-9994722.85368064, 3840598.154456141],
              [-9993252.323207263, 3843142.8903275444],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Frontier',
        GEOID: '31063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11218537.05280956, 4968211.7527259365],
              [-11156807.946135893, 4968229.225959178],
              [-11129916.719383944, 4968192.370688606],
              [-11129855.493664006, 4929839.448826238],
              [-11142535.006304344, 4929892.834002565],
              [-11142501.944415577, 4917116.299352024],
              [-11153968.853842702, 4916938.385985798],
              [-11216377.677327154, 4916862.43051917],
              [-11218486.17980227, 4916856.441747672],
              [-11218537.05280956, 4968211.7527259365],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Limestone',
        GEOID: '01083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9715776.13594155, 4133151.679088473],
              [-9708719.816059146, 4138905.799213372],
              [-9708257.236818744, 4163751.9323108136],
              [-9666571.175070409, 4162903.1440913873],
              [-9660711.504542695, 4162783.8379578656],
              [-9660709.280064123, 4162783.8273579357],
              [-9661424.839839697, 4103001.631101942],
              [-9666783.09220954, 4103778.0064916816],
              [-9696492.371870922, 4121296.25877836],
              [-9709594.67593729, 4131750.8755015116],
              [-9713814.018596828, 4131127.56956068],
              [-9715776.13594155, 4133151.679088473],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Flagler',
        GEOID: '12035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9075172.318803964, 3455108.739110891],
              [-9052952.837122135, 3455515.708303319],
              [-9040301.443401547, 3461283.6561159],
              [-9035088.507878613, 3446513.647328826],
              [-9028341.027419787, 3430106.2100324268],
              [-9034231.347799506, 3428055.97496039],
              [-9033585.694752906, 3409540.147015167],
              [-9063331.264568284, 3408927.5187481698],
              [-9065190.522703514, 3426471.233244804],
              [-9069966.240178034, 3426215.6890613497],
              [-9074831.235884173, 3439471.9081557267],
              [-9075172.318803964, 3455108.739110891],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hernando',
        GEOID: '12053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9202231.828997953, 3310188.2648178586],
              [-9201301.086735431, 3317837.6415508576],
              [-9202576.25150247, 3327674.635384942],
              [-9202638.857822848, 3336794.928863727],
              [-9174769.08798027, 3336865.4536380996],
              [-9174694.61524093, 3333190.5462063234],
              [-9157481.059740586, 3333410.9206544864],
              [-9158791.401466712, 3331960.0941792494],
              [-9151373.18191974, 3321290.0374761294],
              [-9134261.70639245, 3314866.6851871093],
              [-9134286.75327788, 3309423.694512678],
              [-9156394.692829933, 3309435.599032568],
              [-9156410.94547559, 3303906.582835357],
              [-9205097.194179991, 3303718.966023266],
              [-9202231.828997953, 3310188.2648178586],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Okaloosa',
        GEOID: '12091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9660939.038910864, 3632357.3338597734],
              [-9650090.841904474, 3632255.896324138],
              [-9636204.073366592, 3632126.0474262172],
              [-9616739.934094936, 3632038.548365161],
              [-9617712.303669006, 3552166.2185568186],
              [-9619348.298709655, 3552534.0645427853],
              [-9643936.213877602, 3554592.776909854],
              [-9662570.913178077, 3553071.1436980627],
              [-9660939.038910864, 3632357.3338597734],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dougherty',
        GEOID: '13095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9400975.302649288, 3713776.6339905816],
              [-9383988.282312706, 3713787.4845251204],
              [-9355647.675790628, 3713999.529443963],
              [-9352885.950543538, 3717490.6968024285],
              [-9350419.333266541, 3714208.178977038],
              [-9350591.87847727, 3690514.008586687],
              [-9364044.171022695, 3690347.778005431],
              [-9366547.078453688, 3690047.6814228822],
              [-9374391.6516504, 3689483.6502542016],
              [-9398690.804059228, 3689588.6783758006],
              [-9396758.854296511, 3692233.466440467],
              [-9401479.023345128, 3704166.989360457],
              [-9400975.302649288, 3713776.6339905816],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Seminole',
        GEOID: '13253',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9464506.400522366, 3642553.446570202],
              [-9453520.885290984, 3642179.9292642158],
              [-9432195.633078696, 3641738.0456980397],
              [-9438425.628380941, 3606995.457252671],
              [-9446957.582110042, 3595337.9467518535],
              [-9447094.411087489, 3595343.7714079157],
              [-9453045.217106823, 3603184.8923889566],
              [-9454841.134451792, 3611213.874615287],
              [-9454998.651531266, 3617006.4177791704],
              [-9460348.554939298, 3624568.0175253064],
              [-9462831.536181442, 3629767.57932931],
              [-9462434.904835746, 3632837.7143835262],
              [-9463424.86906737, 3639705.064969238],
              [-9464506.400522366, 3642553.446570202],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pike',
        GEOID: '28113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10079779.404928003, 3678231.6842193333],
              [-10047740.764921773, 3678322.9290807983],
              [-10047647.695202991, 3632835.0885727433],
              [-10057271.494445529, 3632796.285934124],
              [-10057408.871676434, 3632795.98307589],
              [-10079709.877582988, 3632746.8189615784],
              [-10079779.404928003, 3678231.6842193333],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jasper',
        GEOID: '28061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9943356.589724408, 3792680.6790606156],
              [-9897844.172511034, 3792774.6327209915],
              [-9897467.022076227, 3740577.062895334],
              [-9901128.988045363, 3740304.0235486566],
              [-9942673.978606867, 3737359.8088753913],
              [-9943356.589724408, 3792680.6790606156],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Edmunds',
        GEOID: '46045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11099410.948765935, 5715427.556507569],
              [-10990016.951204913, 5715087.2788374815],
              [-10989710.26600778, 5710538.12595016],
              [-10989736.314768625, 5659979.122009902],
              [-11084452.39219059, 5660232.091351202],
              [-11099553.660353133, 5660311.46195045],
              [-11099410.948765935, 5715427.556507569],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lawrence',
        GEOID: '47099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9748553.93736665, 4170548.978561362],
              [-9748843.590681693, 4218162.156742509],
              [-9734758.112872638, 4221189.930456307],
              [-9734720.820843222, 4226275.700500547],
              [-9717583.073916107, 4224476.242503917],
              [-9710168.973190293, 4222379.7970475685],
              [-9707791.856783893, 4222909.199261443],
              [-9710671.02409377, 4203043.392364885],
              [-9709737.236338781, 4163776.605462412],
              [-9752266.205012854, 4164359.4439037023],
              [-9748553.93736665, 4170548.978561362],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harrison',
        GEOID: '28047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9945444.275454747, 3587082.8939383593],
              [-9934159.48471456, 3590892.817527961],
              [-9894580.952957919, 3590909.902680049],
              [-9895627.022212904, 3554218.3819042696],
              [-9904232.352809697, 3553882.8425709675],
              [-9916700.581056507, 3550953.576259774],
              [-9928233.614261162, 3546193.5658250903],
              [-9940212.036748482, 3543150.0346014965],
              [-9941612.409319993, 3542685.6939551905],
              [-9945377.595079761, 3549650.2643209784],
              [-9945444.275454747, 3587082.8939383593],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Maricao',
        GEOID: '72093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7460614.016568705, 2060440.8159604538],
              [-7455999.155758379, 2061899.1583692015],
              [-7447047.287586747, 2059535.3953313092],
              [-7443265.430526026, 2059418.6907383143],
              [-7440234.089472235, 2057521.1628637218],
              [-7442462.705677917, 2053776.6540112216],
              [-7450225.793007367, 2055261.6998212615],
              [-7455940.7130257115, 2054386.8487272032],
              [-7459946.99017987, 2056972.9688536348],
              [-7464134.495465042, 2057931.2342427352],
              [-7460614.016568705, 2060440.8159604538],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Luquillo',
        GEOID: '72089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7321530.888174135, 2080449.7852050115],
              [-7318343.306351048, 2084208.0925634457],
              [-7315763.091397662, 2083471.8608054887],
              [-7309388.2353850845, 2083135.52289892],
              [-7317260.004590359, 2071305.951633958],
              [-7319656.267949177, 2072312.6104976384],
              [-7320242.921665655, 2071591.4362414149],
              [-7321530.888174135, 2080449.7852050115],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Las Piedras',
        GEOID: '72085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7339109.3489653, 2054275.0935262984],
              [-7332476.043147911, 2063280.2560535131],
              [-7330679.68052498, 2067414.2640628063],
              [-7328873.0765088955, 2069790.8985713362],
              [-7327518.652264413, 2069533.9263803586],
              [-7326671.95621744, 2067634.167886593],
              [-7327723.8140859455, 2061019.3359575307],
              [-7330900.315755732, 2058284.136538651],
              [-7333462.55647532, 2051384.4302028927],
              [-7338874.019561764, 2051594.791332457],
              [-7339109.3489653, 2054275.0935262984],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Waushara',
        GEOID: '55137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9974001.509705909, 5503547.772790887],
              [-9932460.749285055, 5503185.39342945],
              [-9894819.17666822, 5503065.587632206],
              [-9894765.743312636, 5462847.817984794],
              [-9926204.482582983, 5462786.089465111],
              [-9973998.170121185, 5462672.534825761],
              [-9974001.509705909, 5503547.772790887],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '47173',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9351317.792876733, 4337889.029791659],
              [-9348723.93742176, 4339905.089709195],
              [-9345817.60815613, 4354089.620966321],
              [-9342067.143191813, 4354125.0210394515],
              [-9340332.896844745, 4358564.7824586695],
              [-9329187.25546805, 4360764.596220638],
              [-9321116.035788082, 4348194.507098109],
              [-9313813.254553063, 4348111.722295086],
              [-9319078.221189622, 4324560.067706618],
              [-9321081.9720239, 4323291.434722181],
              [-9340280.688003562, 4322784.436861629],
              [-9344348.52483613, 4326297.09540338],
              [-9350697.520674035, 4335402.890921232],
              [-9351317.792876733, 4337889.029791659],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Autauga',
        GEOID: '01001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9675622.41637598, 3850812.3835077295],
              [-9652890.41975854, 3850490.137983626],
              [-9652982.703616409, 3856304.6029320597],
              [-9619464.070980081, 3856528.4460331765],
              [-9619247.665889978, 3817242.337780327],
              [-9624633.302854557, 3816649.5170903634],
              [-9628776.836940866, 3808608.742018376],
              [-9653392.136703545, 3816303.147316006],
              [-9660456.137630813, 3814942.553566708],
              [-9664324.823894354, 3804068.135484523],
              [-9664191.797102854, 3808129.9253402846],
              [-9674376.528635023, 3833970.454551767],
              [-9675622.41637598, 3850812.3835077295],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Howard',
        GEOID: '29089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10346462.0543664, 4739124.528501855],
              [-10335928.336230595, 4754127.356419267],
              [-10329376.627599956, 4771007.500789463],
              [-10320136.887225132, 4767845.28221977],
              [-10289286.026185667, 4757372.238181186],
              [-10304280.984234503, 4721397.55544858],
              [-10303519.002320023, 4717474.322105967],
              [-10336307.267777255, 4719119.761443458],
              [-10345428.898172347, 4730921.59834618],
              [-10346462.0543664, 4739124.528501855],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Linn',
        GEOID: '29115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10393005.512703503, 4861235.987726898],
              [-10393004.844786556, 4870753.156992743],
              [-10336703.899122952, 4871357.261586046],
              [-10335733.861080179, 4871364.240626733],
              [-10336896.370522533, 4822440.217189142],
              [-10361874.905783674, 4823413.840332291],
              [-10382431.38559254, 4822957.763695704],
              [-10393322.884571753, 4822992.634301963],
              [-10393005.512703503, 4861235.987726898],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Palo Pinto',
        GEOID: '48363',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10973432.684786024, 3860027.93558653],
              [-10973387.37775327, 3889246.1231295886],
              [-10956867.008722095, 3888974.296365337],
              [-10956793.760497153, 3896354.3289025994],
              [-10915554.453257369, 3895746.2390166265],
              [-10916750.24722747, 3836890.3119489555],
              [-10916940.492237234, 3830658.455469967],
              [-10962206.559417486, 3830844.9833471966],
              [-10973458.622227378, 3831125.3747172225],
              [-10973432.684786024, 3860027.93558653],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Roger Mills',
        GEOID: '40129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11131993.183923595, 4284252.34128058],
              [-11123616.481483009, 4288748.165237588],
              [-11119515.694081165, 4298949.266811705],
              [-11110736.482439755, 4300627.426378104],
              [-11109839.803941414, 4288333.217228446],
              [-11100456.90670143, 4281342.918933876],
              [-11089626.856081134, 4278914.759913784],
              [-11082799.965669256, 4282197.160855338],
              [-11075823.127903277, 4297695.322521326],
              [-11063044.763555119, 4302399.977884329],
              [-11063051.442724565, 4286709.450678294],
              [-11062475.253040219, 4283441.487786985],
              [-11062465.34560554, 4274809.40848307],
              [-11062602.82517667, 4239115.637905632],
              [-11061165.579231035, 4233240.854249962],
              [-11084704.86479571, 4233250.153369341],
              [-11084729.577722667, 4221331.041089872],
              [-11131992.365259355, 4221427.891884859],
              [-11131992.71656775, 4248337.957543823],
              [-11131993.183923595, 4284252.34128058],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gwinnett',
        GEOID: '13135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9380033.657402277, 4027110.950711756],
              [-9371099.934307644, 4028479.3665087055],
              [-9361712.361649048, 4035612.9056114885],
              [-9363972.258631641, 4037660.269317464],
              [-9357832.654755918, 4051365.6040090113],
              [-9338602.880638327, 4043068.197898406],
              [-9330541.679712532, 4045934.0952065154],
              [-9336267.175082503, 4029381.57420908],
              [-9328473.586212574, 4019385.675012915],
              [-9334703.247556347, 4013412.338044743],
              [-9340647.597045217, 4007719.4192106277],
              [-9348837.149343897, 4000110.355954485],
              [-9353476.94572016, 3995658.278719454],
              [-9359287.93445906, 3998965.635113676],
              [-9370109.970076019, 4009766.211335446],
              [-9377232.525055446, 4015978.797854546],
              [-9381683.07829736, 4023112.0408879435],
              [-9380033.657402277, 4027110.950711756],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Johnson',
        GEOID: '13167',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9233614.017966976, 3863406.150047319],
              [-9217527.238352438, 3870079.393864404],
              [-9213732.245591806, 3864696.8613062934],
              [-9186201.488365248, 3871748.362144474],
              [-9179210.29038496, 3864579.6986047924],
              [-9176527.490656842, 3863790.0391402044],
              [-9183794.649654808, 3853744.4678184963],
              [-9179969.044034207, 3848520.2280335585],
              [-9194370.891836096, 3839576.529274404],
              [-9191024.516623357, 3833412.9769220417],
              [-9200303.552778432, 3830774.7545312364],
              [-9202621.66985471, 3843937.646046141],
              [-9216645.810624339, 3850291.532275078],
              [-9224240.58288371, 3857636.346671187],
              [-9234738.344823986, 3856651.746764849],
              [-9233614.017966976, 3863406.150047319],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lee',
        GEOID: '05077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10141201.26980708, 4145837.913063579],
              [-10141116.666994078, 4151901.023790112],
              [-10064232.636163305, 4150859.192486514],
              [-10064170.60379944, 4141516.9221733725],
              [-10070383.594627086, 4141470.406209869],
              [-10071466.955911485, 4135221.5632353188],
              [-10075025.506073676, 4131932.724779027],
              [-10079540.513300762, 4123467.8065940565],
              [-10079997.479810467, 4118238.2025118265],
              [-10082572.345564974, 4114209.1961626527],
              [-10084378.9036486, 4115254.180069445],
              [-10135853.1475109, 4115839.663034411],
              [-10135581.082675401, 4127816.2292675506],
              [-10141488.585412819, 4127908.340698278],
              [-10141201.26980708, 4145837.913063579],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Francis',
        GEOID: '05123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10146753.997327339, 4164216.812264428],
              [-10135130.906654632, 4164022.4768082723],
              [-10134823.664860046, 4184037.7170809847],
              [-10074747.096027201, 4183496.5618060133],
              [-10063330.725648899, 4184043.4350891584],
              [-10064232.636163305, 4150859.192486514],
              [-10141116.666994078, 4151901.023790112],
              [-10141201.26980708, 4145837.913063579],
              [-10147045.097795764, 4151907.9470339543],
              [-10146753.997327339, 4164216.812264428],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cross',
        GEOID: '05037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10134502.285490124, 4212127.940995204],
              [-10134440.725811714, 4224481.844855138],
              [-10086742.884355085, 4225035.5352055775],
              [-10074684.311834395, 4224073.153990508],
              [-10075134.710494144, 4188194.398665238],
              [-10074747.096027201, 4183496.5618060133],
              [-10134823.664860046, 4184037.7170809847],
              [-10134502.285490124, 4212127.940995204],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oneida',
        GEOID: '55085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10023524.990811547, 5763900.801240694],
              [-9940883.181958474, 5764572.633257733],
              [-9926942.864765413, 5757395.616781913],
              [-9927232.852038931, 5764228.552940418],
              [-9912733.599682597, 5763595.6143387435],
              [-9912609.923728326, 5694936.661952577],
              [-9947960.429905148, 5695801.2587950975],
              [-9954725.871958109, 5695369.505481969],
              [-9955108.143089494, 5709378.306821336],
              [-10023586.99576792, 5709335.223911975],
              [-10023524.990811547, 5763900.801240694],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Vilas',
        GEOID: '55125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10023647.55357091, 5777456.84636391],
              [-10010832.3424713, 5777459.8901348375],
              [-10010864.472133335, 5828541.878840093],
              [-9978502.824635625, 5819505.432332028],
              [-9917634.885542735, 5802572.592288456],
              [-9906456.96467474, 5795832.757367521],
              [-9899950.498802492, 5791911.982913198],
              [-9900000.987645155, 5777509.3916086545],
              [-9912755.195663812, 5777520.445373552],
              [-9912733.599682597, 5763595.6143387435],
              [-9927232.852038931, 5764228.552940418],
              [-9926942.864765413, 5757395.616781913],
              [-9940883.181958474, 5764572.633257733],
              [-10023524.990811547, 5763900.801240694],
              [-10023647.55357091, 5777456.84636391],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Davison',
        GEOID: '46035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10945515.871565394, 5442421.922101369],
              [-10905667.612682562, 5442364.498382764],
              [-10905367.829293856, 5388242.101168209],
              [-10922084.899865264, 5388127.925814434],
              [-10944998.56989168, 5388182.251008927],
              [-10945515.871565394, 5442421.922101369],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Paulding',
        GEOID: '39125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9440298.576838242, 5049666.132042687],
              [-9401734.390257008, 5049802.847168642],
              [-9401716.801777463, 5043282.383367683],
              [-9388864.076009452, 5043222.603292857],
              [-9388864.187328942, 5036787.158132027],
              [-9388898.585051598, 5010968.832899807],
              [-9395307.804734021, 5010913.2334958725],
              [-9440211.15092909, 5010774.465260896],
              [-9440252.826502824, 5030266.729354332],
              [-9440298.576838242, 5049666.132042687],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lebanon',
        GEOID: '42075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8535760.367826262, 4935168.572854781],
              [-8519883.314132381, 4946947.197180466],
              [-8509282.025065664, 4938276.58745265],
              [-8483160.572592553, 4918491.803748322],
              [-8477114.477089096, 4911965.123296853],
              [-8494520.726628004, 4903077.299624121],
              [-8523325.869385162, 4894559.332276693],
              [-8535760.367826262, 4935168.572854781],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Buffalo',
        GEOID: '46017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11084813.178660253, 5495268.22368875],
              [-11054045.473280407, 5495642.244719655],
              [-11012386.714199314, 5495913.182744907],
              [-11012502.931747701, 5455410.892809594],
              [-11060244.18780574, 5455291.555182031],
              [-11059145.575751103, 5462571.357896593],
              [-11083250.809606967, 5481165.946495621],
              [-11084813.178660253, 5495268.22368875],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Beaver',
        GEOID: '42007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8963412.57195909, 4990438.540115653],
              [-8923207.187615307, 4991000.771909702],
              [-8922433.18319582, 4971726.850470657],
              [-8922084.753189638, 4964417.570037108],
              [-8921743.224991884, 4955485.578970552],
              [-8925599.666111436, 4954900.490849439],
              [-8945731.462062927, 4935581.552101138],
              [-8963335.984677989, 4935555.816670374],
              [-8963333.077308176, 4959209.992678288],
              [-8963412.57195909, 4990438.540115653],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crawford',
        GEOID: '42039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8963378.242596766, 5138471.279299565],
              [-8862375.316037431, 5138544.9560808055],
              [-8862464.482949557, 5104800.669143675],
              [-8886509.826919377, 5104532.471392461],
              [-8905534.66185442, 5084894.71651421],
              [-8919509.376770135, 5083460.14141766],
              [-8963352.465812268, 5084740.637324715],
              [-8963353.754942933, 5086362.3608014295],
              [-8963373.820241809, 5111639.7858789],
              [-8963378.242596766, 5138471.279299565],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Daviess',
        GEOID: '29061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10488154.622944655, 4885816.305879038],
              [-10437763.07244981, 4885275.091890915],
              [-10437535.090132665, 4860066.226093693],
              [-10437203.246730609, 4834700.851974778],
              [-10486946.583830565, 4835320.87841046],
              [-10486696.226295771, 4869582.854492013],
              [-10488388.839153284, 4871012.968344394],
              [-10488154.622944655, 4885816.305879038],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Buchanan',
        GEOID: '29021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10587992.732777001, 4801332.354640483],
              [-10583888.494470943, 4804628.047366562],
              [-10580602.009144252, 4807279.049230619],
              [-10580255.332706187, 4809959.40800257],
              [-10579522.09876407, 4815630.836801693],
              [-10572158.648406565, 4820476.330988858],
              [-10572132.043048266, 4825791.795641893],
              [-10564143.53374996, 4825921.476485636],
              [-10559808.196181016, 4829611.139392462],
              [-10561007.441055331, 4833009.013424801],
              [-10561754.804815559, 4839921.012703454],
              [-10531138.863202624, 4839805.919228715],
              [-10531075.0771344, 4829273.066173739],
              [-10530959.082224993, 4797900.921119169],
              [-10585528.386731982, 4798346.602586227],
              [-10587992.732777001, 4801332.354640483],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scotland',
        GEOID: '29199',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10280444.496415699, 4953117.474488789],
              [-10261406.171035983, 4953597.145686845],
              [-10235061.017558353, 4954408.191387424],
              [-10235799.014610333, 4909755.151632785],
              [-10280110.183198558, 4910035.987193267],
              [-10280352.191771545, 4916423.945216695],
              [-10280444.496415699, 4953117.474488789],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jones',
        GEOID: '37103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8652978.233158708, 4164987.120759299],
              [-8638535.197145225, 4173584.004652099],
              [-8628091.313838493, 4187390.7463074266],
              [-8630286.422877444, 4196953.239942631],
              [-8624331.943314912, 4195042.996085773],
              [-8584234.10613372, 4173730.0854449905],
              [-8580312.988390017, 4138270.027237823],
              [-8589598.481075557, 4136067.409325856],
              [-8590078.268080875, 4134706.089385537],
              [-8601371.296463381, 4153766.5184448613],
              [-8612429.21808133, 4151473.9629852073],
              [-8627569.002787689, 4159755.427116923],
              [-8646719.740066819, 4160334.8237437294],
              [-8652978.233158708, 4164987.120759299],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Guadalupe',
        GEOID: '48187',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10943922.44437418, 3451528.910778357],
              [-10931310.168706283, 3457118.866654322],
              [-10919322.284062248, 3462928.559673794],
              [-10909228.94583202, 3471768.3527210997],
              [-10903027.6709584, 3478754.5055038934],
              [-10895423.993139766, 3485336.7936136797],
              [-10886978.962609716, 3471744.759891253],
              [-10884921.889739348, 3472642.0872589266],
              [-10883519.820752805, 3467465.8135355995],
              [-10868475.436850058, 3458621.928549703],
              [-10872016.621171681, 3453224.913000098],
              [-10891541.61457886, 3423691.054808578],
              [-10904421.05702466, 3423901.198710514],
              [-10921908.68111134, 3422270.0857184497],
              [-10924245.945140034, 3431992.0873824838],
              [-10922926.920493625, 3436581.273952839],
              [-10939779.355565837, 3445991.919788065],
              [-10943922.44437418, 3451528.910778357],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Limestone',
        GEOID: '48293',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10790444.815264115, 3725157.891447446],
              [-10766722.520456577, 3739036.122162451],
              [-10741964.954384662, 3736587.16125237],
              [-10713012.535941184, 3686553.1422040476],
              [-10722610.947715344, 3681424.745926174],
              [-10722200.401433297, 3679216.512867509],
              [-10753113.490068117, 3661470.5651291],
              [-10775851.720577043, 3700763.085764973],
              [-10790444.815264115, 3725157.891447446],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Suwannee',
        GEOID: '12121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9267041.813898817, 3537100.740436633],
              [-9260929.260659356, 3551824.3751298883],
              [-9258549.917863142, 3553163.6569979186],
              [-9248709.83147447, 3560594.4236077247],
              [-9239746.83135376, 3558861.7438049354],
              [-9216652.044515822, 3546945.1153640975],
              [-9216583.137751022, 3501776.3625280494],
              [-9212970.152357835, 3499118.1450125175],
              [-9217306.93708016, 3494828.253822464],
              [-9224296.576587578, 3492121.2668502326],
              [-9226137.355687337, 3489013.3566630417],
              [-9235411.382465323, 3502656.517085039],
              [-9257390.859325001, 3517674.3917142474],
              [-9264637.980814625, 3518124.533934936],
              [-9267041.813898817, 3537100.740436633],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '53043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13244069.883171495, 6097446.098261786],
              [-13240912.75109311, 6097257.815924325],
              [-13230539.666982519, 6099854.747976198],
              [-13214923.99145302, 6090790.255812054],
              [-13212331.583151426, 6097330.436248739],
              [-13199196.1058768, 6095602.338750258],
              [-13196267.735351993, 6087573.737078982],
              [-13176783.93015641, 6079064.58156553],
              [-13173652.958158357, 6089290.757423504],
              [-13163095.97424898, 6097477.672932493],
              [-13159335.60184998, 6097791.597945303],
              [-13144403.09403548, 6073656.498177183],
              [-13122505.548321025, 6081520.004517095],
              [-13115767.824821273, 6077918.791452349],
              [-13116066.38369558, 5984652.51699955],
              [-13131350.66110099, 5984709.598238274],
              [-13244768.190337244, 5984896.755161422],
              [-13244069.883171495, 6097446.098261786],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ben Hill',
        GEOID: '13017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9292970.683652857, 3743284.600010862],
              [-9260672.223955115, 3743570.6807036777],
              [-9259273.494553298, 3743356.0212628795],
              [-9254953.185115611, 3738978.3505281755],
              [-9239038.839392312, 3734595.453582184],
              [-9239335.171876805, 3720484.372702309],
              [-9259151.82234986, 3721166.9137438866],
              [-9269169.129367875, 3718004.4998839665],
              [-9275765.254475338, 3721457.443521581],
              [-9275729.520918794, 3731400.735580016],
              [-9290016.04172822, 3731567.920514112],
              [-9290598.910582015, 3736249.380811054],
              [-9292970.683652857, 3743284.600010862],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Berrien',
        GEOID: '13019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9280804.79914304, 3684955.3821596974],
              [-9280651.846162692, 3693293.8127893354],
              [-9277224.764319131, 3694721.151640182],
              [-9255724.406547826, 3694236.2606048184],
              [-9255156.231866818, 3687466.632953611],
              [-9243243.376559576, 3668520.2033536127],
              [-9244736.95016755, 3656626.533102862],
              [-9243775.261086585, 3651816.2722149384],
              [-9257893.466825932, 3651880.3966812715],
              [-9261555.766753541, 3636048.9059294513],
              [-9272362.774239244, 3636292.2178723575],
              [-9270662.814295338, 3640979.2125177006],
              [-9275192.404375717, 3645477.919493393],
              [-9276915.407454217, 3664553.2835850655],
              [-9287885.164035456, 3678334.2695610286],
              [-9280804.79914304, 3684955.3821596974],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Uinta',
        GEOID: '56041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12361655.083267089, 5049527.72928537],
              [-12361650.966324335, 5065690.109576778],
              [-12361560.6862173, 5096124.599213459],
              [-12361563.966228507, 5098248.564427235],
              [-12254581.431050565, 5097916.716926395],
              [-12250487.32281817, 5097976.241680481],
              [-12250541.08965188, 5011943.023332941],
              [-12258684.778800696, 5011914.071412547],
              [-12305236.363460626, 5011802.714620352],
              [-12361664.6586217, 5012040.6214743825],
              [-12361655.083267089, 5049527.72928537],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Manitowoc',
        GEOID: '55071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9800928.644589974, 5502816.346880006],
              [-9783657.091634925, 5502729.797909072],
              [-9783594.64140059, 5516278.0833315225],
              [-9770069.323269209, 5516215.059863442],
              [-9745278.560108347, 5516266.234284069],
              [-9745507.345542617, 5515312.70488604],
              [-9742877.199933644, 5505759.65501731],
              [-9741281.323713632, 5498122.597541403],
              [-9744901.544873722, 5490187.927040556],
              [-9751685.577281645, 5485844.957711538],
              [-9757730.33695121, 5478124.227139381],
              [-9762599.117520036, 5460172.213239601],
              [-9765900.802667022, 5448776.38487589],
              [-9800767.676606288, 5448696.540615095],
              [-9800928.644589974, 5502816.346880006],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Orleans',
        GEOID: '50019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8074296.328052844, 5595323.270200481],
              [-8076704.571194863, 5623012.108206674],
              [-8074281.299921586, 5622758.967212876],
              [-8053807.419174888, 5622407.0707919365],
              [-8017596.190695254, 5622590.810968638],
              [-8005542.182273686, 5622748.1030911235],
              [-8003616.634701805, 5622792.390031265],
              [-8007045.106718886, 5606939.240736149],
              [-8001025.282615257, 5602081.31098447],
              [-8012144.429953144, 5587975.650631072],
              [-8008317.04322069, 5585233.296048371],
              [-8016395.276028574, 5574230.983379352],
              [-8027749.752769999, 5582190.657396884],
              [-8044276.467012149, 5549757.132053442],
              [-8056724.323792145, 5556286.372624389],
              [-8068692.950164273, 5564073.877952193],
              [-8061458.630416092, 5578001.646647982],
              [-8079363.925232226, 5587200.706607545],
              [-8074296.328052844, 5595323.270200481],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Thurston',
        GEOID: '31173',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10778231.063373256, 5200651.6882980345],
              [-10768800.410071723, 5200623.409097839],
              [-10767562.648653593, 5202714.64273543],
              [-10729005.695863962, 5202465.794702905],
              [-10725850.811603947, 5203149.4209797],
              [-10724074.799019275, 5200729.005265188],
              [-10724110.421256328, 5193829.518474672],
              [-10724209.840104219, 5193217.388014465],
              [-10725382.691716606, 5185999.016233457],
              [-10716604.927228574, 5178009.891112428],
              [-10717047.644843457, 5168058.095888818],
              [-10721140.639880944, 5163254.654539485],
              [-10748438.516732762, 5163357.738766408],
              [-10748510.317804324, 5174464.105639226],
              [-10778361.641135957, 5174532.209241114],
              [-10778231.063373256, 5200651.6882980345],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pershing',
        GEOID: '32027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13281866.412519518, 4942252.064255065],
              [-13281483.69611017, 5006499.183330351],
              [-13223275.513610803, 5006568.76166174],
              [-13223279.187153999, 4991114.393072556],
              [-13184479.001276987, 4991080.100535454],
              [-13096094.66517185, 4991393.300375386],
              [-13096114.591360703, 4965893.22875281],
              [-13057906.291216236, 4965600.369200581],
              [-13057842.727786994, 4942696.096334916],
              [-13084687.645630771, 4866092.53870294],
              [-13191468.640784405, 4865749.88129672],
              [-13272085.882058421, 4865852.90978168],
              [-13284789.662347749, 4865740.14523287],
              [-13281866.412519518, 4942252.064255065],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Augustine',
        GEOID: '48405',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10508458.741467893, 3717925.119877793],
              [-10474130.70481401, 3713612.0469486583],
              [-10462302.34100028, 3706921.944989802],
              [-10462166.30858253, 3693432.0234789946],
              [-10468947.3353642, 3686107.965729712],
              [-10468377.379571341, 3650199.0931750857],
              [-10468844.921432672, 3648154.966967661],
              [-10478462.70279823, 3645649.2643475845],
              [-10488410.769092971, 3655271.4042084254],
              [-10500390.861372652, 3661972.2565293526],
              [-10500150.967869991, 3662676.663698027],
              [-10501855.491913017, 3664063.8558064355],
              [-10500900.03672354, 3679977.4465810726],
              [-10497497.22252897, 3701310.1382639254],
              [-10498657.171623036, 3709513.514862338],
              [-10508458.741467893, 3717925.119877793],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'East Feliciana',
        GEOID: '22037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10165774.490802241, 3593773.9372287854],
              [-10156214.595571896, 3610003.9665831593],
              [-10154829.669786938, 3617273.481879132],
              [-10149681.491096154, 3632648.391697472],
              [-10136767.021307964, 3632661.3438261896],
              [-10110685.050885484, 3632687.5018936126],
              [-10114827.456048338, 3625216.561862414],
              [-10112859.884048566, 3618286.795252675],
              [-10113956.937630337, 3616318.2256197846],
              [-10114264.402063904, 3616285.412282758],
              [-10112368.631135697, 3612926.1998897106],
              [-10113268.983177233, 3596349.734251647],
              [-10158395.455716029, 3594534.8128350955],
              [-10163208.799178438, 3587319.4274164536],
              [-10164589.494822748, 3587890.464576082],
              [-10165774.490802241, 3593773.9372287854],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Camden',
        GEOID: '37029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8514992.890324134, 4376668.407058502],
              [-8495158.027179547, 4376643.200177458],
              [-8477929.00180323, 4359305.474468803],
              [-8472979.40328409, 4349924.703195209],
              [-8465931.321044004, 4350245.534630478],
              [-8454579.182011887, 4340025.650994194],
              [-8447811.736208092, 4323116.044139841],
              [-8449850.107404009, 4312444.357834132],
              [-8462774.634243578, 4312551.389038022],
              [-8462797.900017153, 4313938.757944343],
              [-8463552.980123205, 4322496.684444657],
              [-8474149.482451817, 4337003.325412836],
              [-8484349.798712695, 4341745.280696862],
              [-8486032.726774508, 4351940.529376803],
              [-8508959.755139818, 4365188.69305663],
              [-8514976.573617194, 4371119.182066975],
              [-8520612.664487889, 4376675.548887093],
              [-8514992.890324134, 4376668.407058502],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chowan',
        GEOID: '37041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8538937.871371465, 4334219.3875572765],
              [-8537823.229310151, 4341446.387112774],
              [-8534862.576133015, 4344081.466716475],
              [-8522580.808033284, 4349034.27675354],
              [-8525971.711042339, 4333538.386741635],
              [-8523964.620623333, 4315693.784275189],
              [-8505138.268340377, 4310652.396595255],
              [-8504452.206318617, 4304260.498349678],
              [-8517265.636306377, 4297969.623355083],
              [-8527764.734080544, 4297601.6436336255],
              [-8536260.748937378, 4304880.46746919],
              [-8542316.30659755, 4321361.19191733],
              [-8538937.871371465, 4334219.3875572765],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Blanco',
        GEOID: '48031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10975174.500858465, 3567967.3063809476],
              [-10955113.838061592, 3568254.125564379],
              [-10948387.80310837, 3566187.2358524255],
              [-10923286.927726848, 3558450.557858179],
              [-10928565.809299758, 3549433.1447551795],
              [-10942438.778200889, 3508434.5534264497],
              [-10955398.370680058, 3495525.900624104],
              [-10974754.492419703, 3521423.6184041016],
              [-10975174.500858465, 3567967.3063809476],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Norton',
        GEOID: '51720',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9200821.522369092, 4429582.14561881],
              [-9196629.007706836, 4432183.181995513],
              [-9193799.822848326, 4431077.646231129],
              [-9197434.738181198, 4428945.876650084],
              [-9197029.869193183, 4426117.872526028],
              [-9199887.106563374, 4425193.375568578],
              [-9200821.522369092, 4429582.14561881],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pasquotank',
        GEOID: '37139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8514976.573617194, 4371119.182066975],
              [-8508959.755139818, 4365188.69305663],
              [-8486032.726774508, 4351940.529376803],
              [-8484349.798712695, 4341745.280696862],
              [-8474149.482451817, 4337003.325412836],
              [-8463552.980123205, 4322496.684444657],
              [-8462797.900017153, 4313938.757944343],
              [-8466761.987084303, 4311716.518604805],
              [-8477864.547818061, 4308813.91281373],
              [-8480028.932677556, 4315656.305468558],
              [-8492638.647997163, 4331417.953160388],
              [-8502012.750997372, 4336270.378939496],
              [-8510788.177776098, 4352771.742588878],
              [-8514984.25466206, 4365299.709897161],
              [-8514976.573617194, 4371119.182066975],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Newport News',
        GEOID: '51700',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8531701.770511432, 4460570.031898665],
              [-8524621.182980033, 4465214.528068193],
              [-8526135.350693805, 4468954.409574018],
              [-8523197.851970749, 4469891.823880478],
              [-8508760.938529262, 4452338.146246046],
              [-8509608.859090634, 4441868.266183012],
              [-8503074.62762005, 4432287.236712404],
              [-8504760.895266585, 4429486.055279829],
              [-8509851.980858527, 4431010.234143564],
              [-8532173.765152395, 4456566.167476709],
              [-8531701.770511432, 4460570.031898665],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dawson',
        GEOID: '48115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11377800.401134117, 3889857.3252090234],
              [-11363072.164585222, 3889956.2986323102],
              [-11320221.952994168, 3890239.690964447],
              [-11319938.75620959, 3832453.3634003857],
              [-11377152.855656173, 3832195.7808567774],
              [-11377800.401134117, 3889857.3252090234],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Martin',
        GEOID: '48317',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11378080.592292445, 3832192.216196537],
              [-11377152.855656173, 3832195.7808567774],
              [-11319938.75620959, 3832453.3634003857],
              [-11320636.840736354, 3774806.054606252],
              [-11329661.957132928, 3774726.3004600005],
              [-11378104.192024492, 3774709.876690061],
              [-11378080.592292445, 3832192.216196537],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Napa',
        GEOID: '06055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13650819.280025113, 4674155.9507457],
              [-13632617.875363467, 4679531.972193534],
              [-13625281.8096007, 4693635.157306559],
              [-13624955.309534201, 4702244.446746245],
              [-13613037.667488856, 4698768.928786857],
              [-13605936.374532172, 4678787.514407873],
              [-13599713.058399376, 4672415.272669425],
              [-13592475.065107996, 4652200.654500948],
              [-13595047.435901247, 4640195.997347416],
              [-13587810.555804776, 4625781.816050647],
              [-13603907.688131955, 4624121.9767758325],
              [-13602793.268709624, 4602476.631060187],
              [-13604740.580562072, 4601330.307637938],
              [-13626261.08716121, 4601434.78386351],
              [-13619891.163259035, 4606863.906333232],
              [-13641523.768585403, 4653142.227648249],
              [-13648065.569781361, 4658483.430914346],
              [-13652937.133337455, 4664335.483156983],
              [-13650819.280025113, 4674155.9507457],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morehouse',
        GEOID: '22067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10249085.748196114, 3896429.896159619],
              [-10227492.46552683, 3896329.771069766],
              [-10184528.485416185, 3896124.5492480625],
              [-10181324.239793636, 3896099.9992911154],
              [-10178601.288071392, 3896079.136902335],
              [-10178781.616703982, 3892773.278726157],
              [-10193120.902952045, 3876147.7578436825],
              [-10201049.522364305, 3851231.831550183],
              [-10212704.561730871, 3836901.406401493],
              [-10219610.15502274, 3838540.5938192867],
              [-10223529.936932553, 3831563.5325021814],
              [-10231714.702493127, 3829902.8693482755],
              [-10235094.584872592, 3840628.2774206344],
              [-10231504.41997502, 3850411.7266760073],
              [-10248648.846071584, 3858594.6971433517],
              [-10247262.807091717, 3868089.921975505],
              [-10250923.993824417, 3890684.8271156005],
              [-10249085.748196114, 3896429.896159619],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Caddo',
        GEOID: '40015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10978678.727109147, 4239095.935135358],
              [-10944181.039551293, 4239085.810114399],
              [-10943410.15207755, 4215265.326162147],
              [-10919998.327329835, 4215335.501975468],
              [-10919623.291965352, 4144182.6524321553],
              [-10978307.699246334, 4144187.2647343725],
              [-10978445.512775935, 4177118.7745488607],
              [-10978132.259728843, 4179816.0456497003],
              [-10978699.543853926, 4227147.794706154],
              [-10978678.727109147, 4239095.935135358],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lake',
        GEOID: '41037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13506662.431879167, 5366418.124156782],
              [-13506724.325516047, 5406307.510181484],
              [-13400390.05547897, 5406200.030987985],
              [-13397406.470486728, 5405531.812129817],
              [-13346826.344774477, 5405464.77765232],
              [-13346869.536736906, 5339259.876473796],
              [-13350837.18602776, 5339251.633068759],
              [-13350724.085425114, 5299347.681583087],
              [-13352080.40210094, 5273446.262103795],
              [-13287688.533207495, 5273838.423134449],
              [-13287108.126696646, 5160094.5335725],
              [-13327807.298452957, 5160424.61896044],
              [-13358246.27737649, 5160161.597614893],
              [-13378550.395899728, 5160168.787167957],
              [-13414117.641125124, 5160048.512649869],
              [-13435396.361790257, 5160032.336367191],
              [-13456291.777192209, 5160003.317979952],
              [-13456670.407036778, 5273119.2969023185],
              [-13508584.474207202, 5273487.645158731],
              [-13506662.431879167, 5366418.124156782],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greene',
        GEOID: '29077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10421859.079439156, 4498852.683855169],
              [-10373027.226329815, 4497420.292314428],
              [-10360881.268008852, 4497109.842772291],
              [-10361259.642958058, 4476814.020070656],
              [-10359630.259571318, 4471929.9321638085],
              [-10359978.912216483, 4451476.808222491],
              [-10420494.970398976, 4452796.894593121],
              [-10420073.514806831, 4478242.767266423],
              [-10422381.279170468, 4478488.722157519],
              [-10421859.079439156, 4498852.683855169],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jim Hogg',
        GEOID: '48247',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11015583.364696933, 3157169.850225426],
              [-10998152.73618954, 3156996.3963932833],
              [-10998179.007589368, 3167773.050889515],
              [-10967451.488545699, 3166426.404856349],
              [-10967561.806161076, 3156637.9737328454],
              [-10964184.261490919, 3152864.2002486815],
              [-10961245.315614484, 3130308.829992119],
              [-10955828.620511973, 3130380.578831668],
              [-10956355.4956619, 3096453.240626626],
              [-11015534.495440476, 3096722.4653761927],
              [-11015583.364696933, 3157169.850225426],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Starke',
        GEOID: '18149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9677012.128899043, 5047332.307275992],
              [-9670353.664876735, 5051441.832281813],
              [-9664162.854035247, 5052767.084051901],
              [-9655852.074811095, 5059909.9539940385],
              [-9645003.656474818, 5076366.786901376],
              [-9631886.769555157, 5076403.461186171],
              [-9625418.21658414, 5076415.636485661],
              [-9625467.531118562, 5037662.302615456],
              [-9677022.258972704, 5037791.850827093],
              [-9677012.128899043, 5047332.307275992],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lawrence',
        GEOID: '42073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8963433.264849892, 4998583.915664743],
              [-8963405.743615746, 5010482.261001828],
              [-8963358.801693033, 5030810.4826908745],
              [-8934302.0673042, 5031234.686303944],
              [-8921941.485004986, 5029140.917451456],
              [-8916341.780659612, 5022643.196397294],
              [-8923959.262095107, 5012410.988987396],
              [-8923207.187615307, 4991000.771909702],
              [-8963412.57195909, 4990438.540115653],
              [-8963430.894600362, 4997650.565202894],
              [-8963433.264849892, 4998583.915664743],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Laclede',
        GEOID: '29105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10336614.064293882, 4564707.25894147],
              [-10310431.386100832, 4564253.74122039],
              [-10302515.791068994, 4551286.855962011],
              [-10286948.53951799, 4559551.724995162],
              [-10287442.575418131, 4539093.71348025],
              [-10269096.678057436, 4529880.808615569],
              [-10269163.24711293, 4523710.646130042],
              [-10269474.71904817, 4505235.713940437],
              [-10317833.019043675, 4506442.196943751],
              [-10336402.223302903, 4506782.38263633],
              [-10335600.72296919, 4540092.587014646],
              [-10336614.064293882, 4564707.25894147],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McDonald',
        GEOID: '29119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10532861.754961632, 4406618.019976247],
              [-10471701.82484439, 4404013.919506881],
              [-10472613.561184434, 4369498.700369426],
              [-10504241.068600718, 4369585.1180998795],
              [-10532818.562999206, 4369559.360661618],
              [-10532806.98577216, 4385245.467244951],
              [-10532826.664655548, 4392919.824343309],
              [-10532861.754961632, 4406618.019976247],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Macon',
        GEOID: '29121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10335733.861080179, 4871364.240626733],
              [-10279805.501752257, 4871351.009532936],
              [-10279765.872013535, 4859157.8459732225],
              [-10273440.030629717, 4859040.655739759],
              [-10274712.857687447, 4808756.594536354],
              [-10274885.959495632, 4808757.17247884],
              [-10318442.827214241, 4809467.633524502],
              [-10318129.128889186, 4822166.624325635],
              [-10336896.370522533, 4822440.217189142],
              [-10335733.861080179, 4871364.240626733],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '29127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10223621.330234494, 4858422.779664671],
              [-10178702.832404815, 4857988.396393196],
              [-10177824.825680615, 4852542.754898736],
              [-10178614.637467792, 4843517.54515571],
              [-10174362.455558471, 4839982.162630137],
              [-10170323.561793508, 4835117.192574791],
              [-10170662.596804617, 4830941.568972348],
              [-10171011.738885593, 4826643.291170912],
              [-10164110.746981, 4820448.191281212],
              [-10209722.42389201, 4820488.192714926],
              [-10209694.59401931, 4816316.048483365],
              [-10224332.661780663, 4816441.702230431],
              [-10223621.330234494, 4858422.779664671],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '27163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10354876.694675462, 5668388.637308055],
              [-10324689.92950427, 5668251.020482905],
              [-10326203.910792857, 5666491.240840288],
              [-10326674.058495825, 5654645.926243057],
              [-10326767.632694235, 5652290.198030368],
              [-10324195.927524192, 5641011.280179705],
              [-10323826.237789003, 5639391.066241283],
              [-10330772.796653487, 5631823.733333422],
              [-10326207.918294527, 5625059.1492600255],
              [-10324972.04930774, 5612327.092306376],
              [-10326777.792351263, 5599818.657449062],
              [-10326788.264020506, 5599746.170354767],
              [-10326950.419298118, 5598623.771621349],
              [-10331037.291763611, 5585128.084711781],
              [-10329598.35372504, 5583657.890220242],
              [-10354489.414166993, 5586257.563271821],
              [-10353829.40090608, 5597308.105360968],
              [-10354943.931647902, 5604338.675886548],
              [-10350952.90526398, 5604348.732225453],
              [-10351000.43868655, 5641004.280835401],
              [-10354996.69708654, 5641042.776872765],
              [-10354876.694675462, 5668388.637308055],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hitchcock',
        GEOID: '31087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11279264.061427107, 4917015.218457483],
              [-11218486.17980227, 4916856.441747672],
              [-11216377.677327154, 4916862.43051917],
              [-11216421.648526018, 4866276.805508639],
              [-11249983.02784681, 4866277.532119535],
              [-11275995.498538436, 4866314.153377667],
              [-11279504.625910113, 4866315.075919841],
              [-11279264.061427107, 4917015.218457483],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '22111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10322140.860698394, 3871168.567524751],
              [-10322071.193975389, 3897207.7479387913],
              [-10321938.704503113, 3897205.9202132127],
              [-10297206.853233572, 3896918.1112627345],
              [-10266197.91851718, 3896509.2435543374],
              [-10249090.516446276, 3896429.918269442],
              [-10249085.748196114, 3896429.896159619],
              [-10250923.993824417, 3890684.8271156005],
              [-10247262.807091717, 3868089.921975505],
              [-10248648.846071584, 3858594.6971433517],
              [-10266358.218583923, 3841021.3362828814],
              [-10287598.645344224, 3840063.6166979717],
              [-10287596.307634916, 3851590.8602222507],
              [-10299096.278950807, 3851678.6685264595],
              [-10304989.421473911, 3861979.3835841417],
              [-10322148.65306275, 3863430.2420295756],
              [-10322140.860698394, 3871168.567524751],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Barton',
        GEOID: '29011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10532810.38372773, 4530602.901531534],
              [-10472216.788808798, 4528654.891123035],
              [-10472423.954381166, 4520483.159699959],
              [-10473169.5723305, 4487905.925352347],
              [-10532790.57780251, 4489989.7286184905],
              [-10532773.144646961, 4496538.022950006],
              [-10532810.38372773, 4530602.901531534],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hayes',
        GEOID: '31085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11281714.426058449, 4967911.922780268],
              [-11270871.685016204, 4967869.195558738],
              [-11218537.05280956, 4968211.7527259365],
              [-11218486.17980227, 4916856.441747672],
              [-11279264.061427107, 4917015.218457483],
              [-11281427.555730674, 4916999.296850439],
              [-11281714.426058449, 4967911.922780268],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clark',
        GEOID: '39023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9356515.856499327, 4848491.936907939],
              [-9354852.409348402, 4871783.13746109],
              [-9296975.847612107, 4867422.882364411],
              [-9304978.160527272, 4832398.399751552],
              [-9311560.259378897, 4833014.082717603],
              [-9331843.227198888, 4836597.5589907905],
              [-9344111.636959722, 4843269.180793698],
              [-9356819.090792248, 4844234.98034547],
              [-9356515.856499327, 4848491.936907939],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Alleghany',
        GEOID: '37005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9056199.161115253, 4380203.317019849],
              [-9036550.24411222, 4379605.579391317],
              [-9023765.645872574, 4378925.577395085],
              [-9005938.942616941, 4378195.309450036],
              [-9005931.720088264, 4378195.335390087],
              [-9013944.70643632, 4363199.443787296],
              [-9013222.242941072, 4356080.6413252195],
              [-9019849.64882545, 4352094.68332867],
              [-9027466.57366349, 4361441.78682715],
              [-9035018.933196867, 4360299.13892455],
              [-9045114.831775382, 4351183.064166645],
              [-9044057.630571319, 4353402.799647061],
              [-9056199.161115253, 4380203.317019849],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mercer',
        GEOID: '34021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8340959.114653353, 4915448.808629548],
              [-8332960.968527874, 4916451.8429340655],
              [-8320925.661780761, 4927772.275914487],
              [-8318021.781543926, 4920616.792224511],
              [-8306958.961868381, 4921951.134811458],
              [-8306687.1196718635, 4920404.03894774],
              [-8306934.471580408, 4913254.19805917],
              [-8291628.041596332, 4902823.3543892205],
              [-8298118.635826524, 4897481.516495373],
              [-8306056.606076011, 4892481.1834846735],
              [-8303079.811572709, 4886053.360230633],
              [-8316690.177795057, 4892320.906866863],
              [-8316766.209007269, 4890392.25439758],
              [-8316030.943770579, 4890455.4781635795],
              [-8316263.824145317, 4889481.527394359],
              [-8317622.033252488, 4887768.096308959],
              [-8318168.533711545, 4888185.582509505],
              [-8317970.9085366335, 4888318.768031609],
              [-8320964.69676814, 4892849.190487674],
              [-8322312.479997061, 4894889.433990843],
              [-8329359.226403257, 4901099.879209789],
              [-8332988.353122609, 4906336.576122898],
              [-8338198.327930715, 4911911.981234398],
              [-8340959.114653353, 4915448.808629548],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harding',
        GEOID: '35021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11625768.574377803, 4330733.127631247],
              [-11578209.214367721, 4330675.313400721],
              [-11578213.778466843, 4324662.668013619],
              [-11554294.22552162, 4324586.131401982],
              [-11554353.670129703, 4312425.210793381],
              [-11506536.605498433, 4312468.188370992],
              [-11507637.221303908, 4300436.578888881],
              [-11507665.385135079, 4264838.117233016],
              [-11508178.901946107, 4217935.735462288],
              [-11536823.967275504, 4216961.548877192],
              [-11546459.337120607, 4221485.40426183],
              [-11574655.673582617, 4273376.242885984],
              [-11579642.898089647, 4270596.787237823],
              [-11618428.612432858, 4270296.006783055],
              [-11620612.25556426, 4281045.550232767],
              [-11613660.130725238, 4295145.9218666395],
              [-11623374.09213084, 4317664.084608413],
              [-11625768.574377803, 4330733.127631247],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Erath',
        GEOID: '48143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10962151.790228015, 3802634.3968862775],
              [-10962206.559417486, 3830844.9833471966],
              [-10916940.492237234, 3830658.455469967],
              [-10903773.622866208, 3795416.8224037527],
              [-10903257.100428924, 3793996.0974730933],
              [-10894266.82703297, 3774779.2508472567],
              [-10909918.124799522, 3765660.1158419447],
              [-10932507.521149255, 3752487.527973788],
              [-10937175.3700372, 3760554.760078119],
              [-10939498.162532093, 3759366.612503367],
              [-10945767.119656114, 3755602.687899588],
              [-10970664.72564745, 3797677.3009772217],
              [-10962151.790228015, 3802634.3968862775],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crosby',
        GEOID: '48107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11306006.008741904, 4006058.3952843477],
              [-11247850.2577227, 4006483.7467118283],
              [-11247586.43052952, 3948146.9448887953],
              [-11305260.613431552, 3947819.741062132],
              [-11306006.008741904, 4006058.3952843477],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Roane',
        GEOID: '47145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9437878.04780573, 4276568.2827645475],
              [-9432059.711980438, 4281152.409736461],
              [-9426604.945612077, 4288032.084020523],
              [-9418070.525530921, 4294277.047911847],
              [-9400491.730781281, 4298692.963403587],
              [-9388887.56442201, 4307362.626099107],
              [-9386466.142858276, 4299466.569634007],
              [-9381070.153181054, 4288267.244840193],
              [-9380156.888078583, 4286449.725492009],
              [-9387569.319012037, 4285895.1161708],
              [-9389534.5533025, 4277579.7777690515],
              [-9415900.352057906, 4251804.32293166],
              [-9419840.282795552, 4251835.418220037],
              [-9419747.442340229, 4260500.200412074],
              [-9431416.174004162, 4266673.296564979],
              [-9434824.665492762, 4266878.230355564],
              [-9437878.04780573, 4276568.2827645475],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dickinson',
        GEOID: '26043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9811150.77947105, 5751821.454872583],
              [-9804346.598235292, 5760435.275128988],
              [-9808955.447793117, 5767892.229324658],
              [-9809123.600044647, 5767988.284132233],
              [-9809184.877263641, 5819958.389361625],
              [-9753323.643588666, 5819964.023301821],
              [-9753489.954907913, 5778108.237150537],
              [-9753523.907352604, 5764154.011959844],
              [-9762379.37284521, 5764153.372125808],
              [-9762403.083896749, 5736063.970840218],
              [-9777530.341602098, 5736030.896175368],
              [-9782735.922848612, 5741149.29966144],
              [-9792438.30702717, 5742613.726367879],
              [-9795656.108228043, 5747627.917357983],
              [-9801515.743584419, 5745570.7580978405],
              [-9802461.565847406, 5745958.339671028],
              [-9807861.399837598, 5748171.421437191],
              [-9811150.77947105, 5751821.454872583],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Woodson',
        GEOID: '20207',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10682112.137728315, 4585105.575435539],
              [-10633123.101497974, 4584827.838267016],
              [-10633160.727485862, 4554065.462030539],
              [-10633849.906453364, 4541742.1058914345],
              [-10682315.852396466, 4541959.574741729],
              [-10682112.137728315, 4585105.575435539],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Douglas',
        GEOID: '17041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9848789.569100616, 4835738.5488016065],
              [-9847576.854567915, 4837036.437607283],
              [-9847567.83768916, 4848387.782752585],
              [-9834986.508839706, 4848439.859693945],
              [-9789173.862959659, 4848490.921472191],
              [-9792639.461347036, 4835812.870757748],
              [-9792397.118815579, 4820406.6074691815],
              [-9803176.964345526, 4815580.232188748],
              [-9848666.115785327, 4815440.420204196],
              [-9848789.569100616, 4835738.5488016065],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Potter',
        GEOID: '42105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8705919.226846058, 5160842.87765206],
              [-8686390.8896398, 5160891.814289683],
              [-8664221.947006792, 5160758.348972161],
              [-8655082.719797364, 5160793.01686994],
              [-8639507.919599187, 5160852.09716457],
              [-8638312.112885676, 5092658.564243667],
              [-8638184.206790755, 5083189.863698646],
              [-8681717.363457827, 5082632.096279435],
              [-8688535.459629932, 5082727.184871105],
              [-8705565.115331488, 5103951.724587941],
              [-8705919.226846058, 5160842.87765206],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Quay',
        GEOID: '35037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11591603.175499968, 4133934.210719929],
              [-11591155.448507996, 4183203.055685637],
              [-11561367.354647133, 4196872.004245597],
              [-11536832.538876297, 4196655.832966756],
              [-11536823.967275504, 4216961.548877192],
              [-11508178.901946107, 4217935.735462288],
              [-11507665.385135079, 4264838.117233016],
              [-11470511.360920837, 4264826.803492865],
              [-11470533.321827602, 4248799.7292644],
              [-11470651.760262728, 4188799.424773295],
              [-11470662.118478449, 4183567.489080352],
              [-11470665.215231728, 4157650.9754732586],
              [-11497538.873696595, 4157655.044590079],
              [-11497557.57537105, 4145548.9268323407],
              [-11509299.666579414, 4145608.4872319507],
              [-11509352.654657032, 4133769.5411321335],
              [-11521082.6120409, 4133830.9361764058],
              [-11521083.391277337, 4122021.370037997],
              [-11544475.51247518, 4122163.933838513],
              [-11544508.908322418, 4110332.2974321777],
              [-11548079.814948086, 4110286.3137602177],
              [-11571525.03554304, 4110338.789259856],
              [-11591573.898473889, 4110358.129518725],
              [-11591603.175499968, 4133934.210719929],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McLeod',
        GEOID: '27085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10519901.717204498, 5618325.445732202],
              [-10492538.161853112, 5618289.249837247],
              [-10465394.239857063, 5618170.748640441],
              [-10465200.3213041, 5577151.105427796],
              [-10492315.745510507, 5577212.359275425],
              [-10492387.323943088, 5563508.076497144],
              [-10519450.873266784, 5563447.071534423],
              [-10519477.478625085, 5577105.204478234],
              [-10519472.357928507, 5601474.017696625],
              [-10519958.4901448, 5604581.445318596],
              [-10519901.717204498, 5618325.445732202],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Newton',
        GEOID: '29145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10532823.57237629, 4438954.159470866],
              [-10532839.033663152, 4447026.431282266],
              [-10470623.472937074, 4445817.195142795],
              [-10471016.319420084, 4429601.363790989],
              [-10471701.82484439, 4404013.919506881],
              [-10532861.754961632, 4406618.019976247],
              [-10532823.57237629, 4438954.159470866],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stanton',
        GEOID: '31167',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10839001.152633741, 5174608.863878299],
              [-10800145.640969802, 5174557.110679799],
              [-10800207.089328721, 5122556.510187977],
              [-10826090.42941103, 5122572.175575795],
              [-10838963.971923815, 5122590.377296669],
              [-10839001.152633741, 5174608.863878299],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Spotsylvania',
        GEOID: '51177',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8677759.398962671, 4596179.581466195],
              [-8651203.24387801, 4626967.194349559],
              [-8649840.915949682, 4630526.562902098],
              [-8643484.684344877, 4632978.213568977],
              [-8640477.165662114, 4631519.6757392865],
              [-8638807.373300215, 4626640.786597265],
              [-8630631.624618394, 4623194.4109941125],
              [-8626371.650344716, 4618165.616883725],
              [-8621374.629722498, 4619710.614671072],
              [-8615110.014058616, 4614177.630289522],
              [-8612822.064564342, 4614317.531024408],
              [-8629221.540628515, 4594328.845835394],
              [-8643125.567667577, 4578110.423086072],
              [-8648129.490098225, 4580528.597564763],
              [-8664910.680696331, 4594444.710468221],
              [-8677759.398962671, 4596179.581466195],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'LaMoure',
        GEOID: '38045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11024706.664884387, 5881922.5968452925],
              [-10958185.58809054, 5882069.953234321],
              [-10913079.59833805, 5882006.244392802],
              [-10913158.746496005, 5825783.87163314],
              [-11020976.682706377, 5825800.301393607],
              [-11024789.263946556, 5825841.053774642],
              [-11024706.664884387, 5881922.5968452925],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ramsey',
        GEOID: '27123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10378059.646550108, 5641148.010733173],
              [-10354996.69708654, 5641042.776872765],
              [-10351000.43868655, 5641004.280835401],
              [-10350952.90526398, 5604348.732225453],
              [-10354943.931647902, 5604338.675886548],
              [-10363403.878989719, 5609452.668408326],
              [-10372587.514341183, 5603959.685771681],
              [-10375013.722643021, 5607196.383409906],
              [-10375877.339252595, 5627150.403791652],
              [-10377974.264500668, 5627138.904266805],
              [-10377988.736034472, 5629386.473731512],
              [-10378059.646550108, 5641148.010733173],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Banner',
        GEOID: '31007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11583107.520788291, 5115841.230582752],
              [-11507139.289221589, 5116028.5107904505],
              [-11506987.115477676, 5077111.584352465],
              [-11507944.017820533, 5070725.3599881055],
              [-11583047.619645841, 5070514.794413083],
              [-11583047.60471556, 5070528.594526325],
              [-11583086.296212759, 5095931.893481068],
              [-11583097.475847434, 5103284.504755136],
              [-11583107.520788291, 5115841.230582752],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '37191',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8717048.61136274, 4203034.391475383],
              [-8699979.214602973, 4211638.636926632],
              [-8700164.784194125, 4220805.81270924],
              [-8690132.00376689, 4243703.2421759],
              [-8688327.29218215, 4245156.205873765],
              [-8668866.30748218, 4243837.113759158],
              [-8663162.296773931, 4243719.668049032],
              [-8663633.512178458, 4221663.675929118],
              [-8661351.907895159, 4214106.943715963],
              [-8662667.704276336, 4212552.431575537],
              [-8664468.964956863, 4188076.0466039465],
              [-8670885.75436466, 4183797.563402468],
              [-8687868.54456059, 4190076.7615009914],
              [-8701112.113060774, 4189692.77162945],
              [-8702237.775751676, 4192094.7321717646],
              [-8710329.032939987, 4194635.667284217],
              [-8717048.61136274, 4203034.391475383],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ransom',
        GEOID: '38073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10913079.59833805, 5882006.244392802],
              [-10873911.167585494, 5881876.720718903],
              [-10829154.27575613, 5881782.699725329],
              [-10829223.293840423, 5825707.360896612],
              [-10910057.608121486, 5825756.488767005],
              [-10913158.746496005, 5825783.87163314],
              [-10913079.59833805, 5882006.244392802],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gray',
        GEOID: '48179',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11252834.810561951, 4248336.17732279],
              [-11192079.192835271, 4248362.743728253],
              [-11191947.835836133, 4188797.6188757084],
              [-11252873.327105764, 4188660.873368407],
              [-11252834.810561951, 4248336.17732279],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cleveland',
        GEOID: '37045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9095119.992317682, 4212543.968902652],
              [-9093910.617369706, 4242988.466771604],
              [-9080024.735407645, 4239999.5624798825],
              [-9076724.001186132, 4240824.303718044],
              [-9074209.29388911, 4239942.228369602],
              [-9067595.914260576, 4221079.146899588],
              [-9056584.412870286, 4208900.163416892],
              [-9052693.462708589, 4199331.693264213],
              [-9053401.676116984, 4185957.0799574098],
              [-9057800.345724763, 4186203.033032396],
              [-9071900.082372097, 4186991.46131936],
              [-9102387.08538934, 4188329.6002673497],
              [-9095119.992317682, 4212543.968902652],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Venango',
        GEOID: '42121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8905534.66185442, 5084894.71651421],
              [-8886509.826919377, 5104532.471392461],
              [-8862464.482949557, 5104800.669143675],
              [-8851243.144319123, 5104905.061298693],
              [-8851266.076134227, 5081208.554010095],
              [-8847468.634344796, 5077479.69828564],
              [-8847430.674398435, 5069515.449489892],
              [-8847466.073996507, 5061985.335103915],
              [-8861494.667545766, 5059875.8621701915],
              [-8871605.037658084, 5037872.745394877],
              [-8892818.302462632, 5037813.294476711],
              [-8905534.66185442, 5037724.266669514],
              [-8905534.66185442, 5084894.71651421],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stone',
        GEOID: '29209',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10420729.186607605, 4428355.875353488],
              [-10420631.559414178, 4438522.771376346],
              [-10390277.517262124, 4438060.599284361],
              [-10390788.473724864, 4413671.406252476],
              [-10386593.732672792, 4413610.918071284],
              [-10387814.696706578, 4369406.856609953],
              [-10400244.841828771, 4369444.560788655],
              [-10417754.568105983, 4369488.414282059],
              [-10416587.767591624, 4414051.168642069],
              [-10420943.587946871, 4414124.869980207],
              [-10420729.186607605, 4428355.875353488],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Butler',
        GEOID: '31023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10838976.884984748, 5070989.946118271],
              [-10830024.014937699, 5071616.493648839],
              [-10826212.212933956, 5069179.093433062],
              [-10817857.128552467, 5068081.826306499],
              [-10787516.556058796, 5079900.780126857],
              [-10787511.212723238, 5079448.2105027735],
              [-10787805.652776387, 5019142.454694765],
              [-10788076.493097488, 5019146.14477138],
              [-10838969.315259375, 5019268.803715899],
              [-10838976.884984748, 5070989.946118271],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Howard',
        GEOID: '05061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10492381.646649057, 4076634.903418705],
              [-10456837.667197235, 4075908.934947067],
              [-10455775.567935579, 4053871.4568261504],
              [-10444074.998897279, 4053508.926366492],
              [-10444337.044978607, 4029996.20127509],
              [-10445269.45703349, 3994975.6081964835],
              [-10459280.462103205, 3995408.180158462],
              [-10459448.888492776, 3995415.4099119073],
              [-10460097.658485118, 4001463.2212172183],
              [-10471817.151836852, 4018974.60127252],
              [-10470436.790151015, 4024535.4121974106],
              [-10474655.353574118, 4039353.7173817027],
              [-10474023.949422337, 4053917.076735313],
              [-10491165.035934176, 4054679.5888504577],
              [-10492381.646649057, 4076634.903418705],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wythe',
        GEOID: '51197',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9059113.591701109, 4432479.88689394],
              [-9041883.783555105, 4445776.468393733],
              [-9029604.687123155, 4442259.077282873],
              [-9007157.668402145, 4449335.629330964],
              [-9004995.287293486, 4442926.542924044],
              [-8987989.453962961, 4422254.480196032],
              [-8996032.509811755, 4418668.917643915],
              [-9021601.817610536, 4412162.363581624],
              [-9026731.642385272, 4406737.80556431],
              [-9046043.013689615, 4406127.913620099],
              [-9053278.557952197, 4425142.705271013],
              [-9059113.591701109, 4432479.88689394],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Steele',
        GEOID: '38091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10907619.15467566, 6052509.356913566],
              [-10896219.482220974, 6052489.353583319],
              [-10850616.339622602, 6052468.193086101],
              [-10850793.560251944, 5995247.843082465],
              [-10848252.692874588, 5981182.583917836],
              [-10876585.952310275, 5981332.936992369],
              [-10904991.792053958, 5981420.493853017],
              [-10907816.746771818, 5995465.281502672],
              [-10907619.15467566, 6052509.356913566],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Buena Vista',
        GEOID: '51530',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8836709.160281662, 4543063.879806698],
              [-8831276.65781146, 4545681.599596595],
              [-8831143.185742, 4544484.375426796],
              [-8835855.117148297, 4536741.714701923],
              [-8834994.394845482, 4540835.119691972],
              [-8836709.160281662, 4543063.879806698],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dodge',
        GEOID: '31053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10787517.891892686, 5122524.135134334],
              [-10748472.580496946, 5122412.986589222],
              [-10736121.126395978, 5122376.733047376],
              [-10736184.355866749, 5113706.378735931],
              [-10735071.940195251, 5085619.81253348],
              [-10723296.56445914, 5070503.22008701],
              [-10739071.426860472, 5070518.50409802],
              [-10749975.950220108, 5076418.309114438],
              [-10787511.212723238, 5079448.2105027735],
              [-10787516.556058796, 5079900.780126857],
              [-10787517.891892686, 5122524.135134334],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '37109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9076479.54358435, 4241359.24869347],
              [-9012428.757610697, 4238469.706492195],
              [-9010164.519167963, 4236076.903710773],
              [-9011017.115147948, 4230462.411225926],
              [-9010464.52519565, 4225907.121066468],
              [-9011853.79244075, 4218383.939398153],
              [-9067595.914260576, 4221079.146899588],
              [-9074209.29388911, 4239942.228369602],
              [-9076724.001186132, 4240824.303718044],
              [-9076479.54358435, 4241359.24869347],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '05097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10456296.431833, 4118530.950389938],
              [-10450469.301767936, 4118485.203800684],
              [-10443661.001711018, 4124716.9859050536],
              [-10431782.544126432, 4129321.5334343044],
              [-10396604.694479832, 4129063.726245701],
              [-10397484.118457098, 4121181.999819017],
              [-10398044.946051713, 4082214.9832766633],
              [-10398144.799634956, 4074483.831550173],
              [-10405995.272764679, 4074662.330403246],
              [-10456837.667197235, 4075908.934947067],
              [-10456296.431833, 4118530.950389938],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harrisonburg',
        GEOID: '51660',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8783435.882128652, 4644048.809461759],
              [-8781880.303564306, 4643953.708256389],
              [-8779919.744692456, 4648810.968024952],
              [-8774984.95166559, 4639007.244642276],
              [-8784731.641001485, 4634676.694196234],
              [-8783435.882128652, 4644048.809461759],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brown',
        GEOID: '20013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10663083.740000913, 4866010.110840289],
              [-10662690.11485012, 4866009.5616294835],
              [-10613188.67175873, 4865946.472939975],
              [-10613171.309163094, 4815641.680680658],
              [-10638149.844424235, 4815626.065498676],
              [-10663176.135746924, 4815644.716968876],
              [-10663083.740000913, 4866010.110840289],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adair',
        GEOID: '19001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10542025.798082715, 5086990.198468921],
              [-10490926.144306934, 5086920.485407098],
              [-10490931.04236453, 5035546.593638304],
              [-10516419.420893501, 5035610.466263535],
              [-10542021.345303085, 5035687.202682469],
              [-10542025.798082715, 5086990.198468921],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coosa',
        GEOID: '01037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9631066.678866481, 3898034.0741863796],
              [-9630376.275384583, 3907047.590586814],
              [-9628137.306466257, 3908976.0428035352],
              [-9592886.98783115, 3909168.732780736],
              [-9574691.705741499, 3909200.892383081],
              [-9574497.0079521, 3907290.6061356943],
              [-9574978.01947182, 3871330.700497329],
              [-9574276.261401858, 3862827.163043443],
              [-9609040.559140163, 3862656.9404494287],
              [-9610956.812854676, 3864567.3866597293],
              [-9615218.122962244, 3862641.321392063],
              [-9624350.885306414, 3870628.140414153],
              [-9623739.62998247, 3877225.300927492],
              [-9630912.501371734, 3885931.5667101783],
              [-9631066.678866481, 3898034.0741863796],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Burleigh',
        GEOID: '38015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11239378.287875878, 5967658.337035137],
              [-11215368.566143112, 5967778.334075781],
              [-11215364.558641445, 5995725.59070661],
              [-11206898.822686108, 5995683.053842213],
              [-11144557.236174094, 5995656.119410445],
              [-11140323.533300243, 5939019.353413583],
              [-11140987.99934079, 5882438.922442209],
              [-11205630.337088518, 5882609.7948102625],
              [-11219647.576049715, 5891722.404834249],
              [-11218720.062052425, 5899181.257227169],
              [-11233016.267657552, 5926478.278824417],
              [-11236142.230278518, 5939273.573325698],
              [-11229964.443817453, 5945243.343995061],
              [-11239378.287875878, 5967658.337035137],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mayes',
        GEOID: '40097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10623843.508745447, 4371047.5773754725],
              [-10611883.342654618, 4371058.657373825],
              [-10575989.486043235, 4371010.18246557],
              [-10576609.869565425, 4322909.770807479],
              [-10588542.985019993, 4322884.262680911],
              [-10588529.292722624, 4310883.36526967],
              [-10598500.068193486, 4310905.952810487],
              [-10624328.861725306, 4310973.715715549],
              [-10623843.508745447, 4371047.5773754725],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Aibonito',
        GEOID: '72009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7382135.111393335, 2055357.8794917352],
              [-7374726.24268359, 2056942.6247115356],
              [-7374107.528953761, 2058657.0807442088],
              [-7371231.478589625, 2054319.0223847383],
              [-7372076.504844239, 2048710.8297684412],
              [-7375754.166861574, 2046432.547618438],
              [-7382810.264104997, 2052302.49199845],
              [-7382135.111393335, 2055357.8794917352],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McDonough',
        GEOID: '17109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10119411.036081752, 4959268.672362471],
              [-10106657.82993851, 4958762.424955499],
              [-10068347.67245997, 4957602.599458461],
              [-10068873.211776005, 4906180.159945852],
              [-10120027.746060748, 4907356.114337448],
              [-10119411.036081752, 4959268.672362471],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Phillips',
        GEOID: '20147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11090240.641296312, 4866200.6319351075],
              [-11076488.81845822, 4866236.696669661],
              [-11040570.599672135, 4866248.751494222],
              [-11030158.202987514, 4866252.246091615],
              [-11028090.037118545, 4866253.773867553],
              [-11028001.165214414, 4803380.428672682],
              [-11087663.514222015, 4803265.336134838],
              [-11090532.996736191, 4803281.076441471],
              [-11090240.641296312, 4866200.6319351075],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grand Traverse',
        GEOID: '26055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9552895.349444175, 5586096.043753199],
              [-9530955.836281693, 5586099.650468286],
              [-9523954.920411399, 5625778.526429367],
              [-9520046.637503441, 5617428.617174043],
              [-9515056.18473118, 5620113.0741110565],
              [-9510181.668426517, 5624142.982711473],
              [-9514904.456265228, 5599421.680860183],
              [-9504678.87047994, 5599440.369206355],
              [-9499207.851465924, 5592031.504489928],
              [-9499337.427353207, 5545067.57871081],
              [-9553194.019637974, 5545171.546193603],
              [-9552895.349444175, 5586096.043753199],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Poquoson',
        GEOID: '51735',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8506243.448244972, 4460846.722146379],
              [-8498930.306390017, 4465573.853215662],
              [-8498475.017579963, 4465141.588403385],
              [-8494911.45804069, 4458428.825785333],
              [-8492912.03957186, 4455031.70389806],
              [-8502993.475711264, 4454671.033203299],
              [-8504340.998147314, 4454056.007773003],
              [-8506243.448244972, 4460846.722146379],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '28059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9894580.952957919, 3590909.902680049],
              [-9894581.064277412, 3598458.000152369],
              [-9888964.662008418, 3598282.513574875],
              [-9842030.854235789, 3598458.836693767],
              [-9842008.876277415, 3597963.2767925933],
              [-9841080.583043693, 3573586.537387747],
              [-9840088.949019706, 3551124.9185091183],
              [-9841748.054710489, 3547601.774373166],
              [-9845818.785849817, 3548329.0276434394],
              [-9848644.07452615, 3544752.1139636906],
              [-9854278.955830613, 3547340.83507013],
              [-9860895.229765914, 3546176.2834202657],
              [-9864354.705581296, 3549130.2414647792],
              [-9870011.294186465, 3550179.726624023],
              [-9874104.17790446, 3547804.8025537864],
              [-9879264.726858655, 3548312.129300271],
              [-9885209.022380225, 3549555.9817347988],
              [-9887259.358728956, 3549985.0460164454],
              [-9895627.022212904, 3554218.3819042696],
              [-9894580.952957919, 3590909.902680049],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Benton',
        GEOID: '19011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10274654.526274271, 5205652.265346503],
              [-10248602.871121883, 5205611.931200696],
              [-10222590.066471785, 5205883.43749344],
              [-10222622.349124115, 5140307.804913098],
              [-10274584.617634054, 5140446.5150831025],
              [-10274654.526274271, 5205652.265346503],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yalobusha',
        GEOID: '28161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10011127.11648292, 4050885.2990972633],
              [-9987744.012163829, 4050779.015881079],
              [-9987701.599437837, 4054685.5104298475],
              [-9964145.281991074, 4054472.200939294],
              [-9964179.568394238, 4050586.4978028466],
              [-9963912.958213788, 4011020.203065932],
              [-9993044.934995914, 4011002.1040683514],
              [-9993072.31959065, 4014998.387019516],
              [-10010527.549705507, 4015108.36052009],
              [-10010460.53537205, 4047690.5101537607],
              [-10011127.11648292, 4050885.2990972633],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Orange',
        GEOID: '37135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8822954.857957719, 4334170.940395969],
              [-8811382.640292302, 4333954.242080981],
              [-8788740.255864952, 4333601.599032643],
              [-8795297.307831148, 4287200.197046371],
              [-8796054.836965997, 4281815.566455701],
              [-8803371.978415329, 4281481.23591928],
              [-8822018.215762183, 4283683.830756374],
              [-8824100.446837472, 4288132.140135827],
              [-8822954.857957719, 4334170.940395969],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Foard',
        GEOID: '48155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11137184.212340383, 4059697.755259023],
              [-11136103.41140427, 4060909.318460951],
              [-11131684.250258759, 4058967.352111151],
              [-11106573.022164594, 4041334.9453758034],
              [-11093322.329216998, 4042099.1678966703],
              [-11081688.329234194, 4036293.5725566396],
              [-11073539.07459118, 4040304.23365899],
              [-11073578.704329904, 4006534.6720119263],
              [-11073450.46427651, 3993120.1918941448],
              [-11082401.441892216, 4001784.985538847],
              [-11098631.712330384, 4001973.467001787],
              [-11113597.28203365, 4006775.230108489],
              [-11131552.114023188, 4006797.6109793535],
              [-11137345.848241016, 4006798.549100645],
              [-11137184.212340383, 4059697.755259023],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Prince George',
        GEOID: '51149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8616039.865765212, 4462947.905063904],
              [-8608310.28560249, 4466670.91173987],
              [-8613544.305420607, 4473290.7544903485],
              [-8613610.65183712, 4474786.015904039],
              [-8611726.458135955, 4477834.254204002],
              [-8610908.816476079, 4481946.969382964],
              [-8608966.95927868, 4482830.674063366],
              [-8607710.384866605, 4476502.919384053],
              [-8600606.754200613, 4478598.2704685405],
              [-8599693.489098145, 4480139.202927956],
              [-8603217.64153768, 4482826.894997162],
              [-8601732.194252534, 4483910.842810216],
              [-8585481.663667042, 4481414.8789190585],
              [-8579311.780889822, 4476772.334283645],
              [-8571155.847077364, 4481142.826224413],
              [-8568532.71459631, 4473801.457780888],
              [-8572970.132138312, 4471617.577478686],
              [-8588901.509743702, 4454734.408261172],
              [-8592421.766001057, 4452905.757785859],
              [-8615961.385524204, 4438129.031818281],
              [-8615532.471526176, 4444088.817146134],
              [-8616039.865765212, 4462947.905063904],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Howard',
        GEOID: '19089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10302967.090361176, 5388435.317970392],
              [-10291369.810327906, 5388452.959208164],
              [-10261304.091062926, 5388498.693924844],
              [-10250276.670220498, 5388497.44856982],
              [-10250407.360067643, 5344440.9249081435],
              [-10303106.563606633, 5344420.457687494],
              [-10302967.090361176, 5388435.317970392],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Heard',
        GEOID: '13149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9494923.260483768, 3952251.66415225],
              [-9463866.362167856, 3951919.923283907],
              [-9457553.211205987, 3932136.1194885164],
              [-9455367.898282224, 3925166.319615465],
              [-9471956.84011973, 3918116.6387408436],
              [-9474176.99604411, 3921228.684163125],
              [-9475225.848286366, 3917046.495684192],
              [-9488494.393680159, 3912511.417002534],
              [-9494923.260483768, 3952251.66415225],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'DeSoto',
        GEOID: '12027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9134487.46231978, 3149453.8075248254],
              [-9134404.64061863, 3165797.304610081],
              [-9079669.848870995, 3166095.183783924],
              [-9079509.771443233, 3127699.6215768154],
              [-9126332.753021719, 3127876.4614823163],
              [-9134595.66486483, 3127485.167126611],
              [-9134487.46231978, 3149453.8075248254],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rowan',
        GEOID: '21205',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9302339.220678529, 4610070.327838599],
              [-9295974.528792422, 4617559.876520564],
              [-9289928.544608459, 4633502.497188282],
              [-9285381.700007007, 4635582.712735472],
              [-9277516.310065517, 4624662.2677661795],
              [-9273044.27216188, 4609139.068065071],
              [-9266713.755359447, 4606638.414867829],
              [-9261669.646592623, 4603276.881882591],
              [-9268826.933253177, 4595738.832684241],
              [-9287456.13871794, 4586061.670185941],
              [-9287823.938315522, 4584226.311963488],
              [-9291104.078431236, 4581824.088665916],
              [-9295049.018545968, 4586579.191192903],
              [-9291090.386133868, 4590692.431596401],
              [-9299009.098111449, 4592811.40783656],
              [-9310227.31979614, 4605950.781317071],
              [-9302339.220678529, 4610070.327838599],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Collingsworth',
        GEOID: '48087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11191947.835836133, 4188797.6188757084],
              [-11131991.937331311, 4188737.417956186],
              [-11131991.828324262, 4168011.1112316023],
              [-11131991.62505966, 4129465.7553117075],
              [-11178246.298950825, 4129623.512727977],
              [-11192139.861957753, 4129650.337662278],
              [-11191947.835836133, 4188797.6188757084],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ozaukee',
        GEOID: '55089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9803064.420340335, 5368045.127324038],
              [-9800566.07700846, 5368136.086222574],
              [-9800626.746130943, 5394892.48080621],
              [-9772851.658209996, 5394992.986206373],
              [-9773098.660572167, 5387281.782966432],
              [-9778410.381394858, 5376223.963851122],
              [-9783781.769464614, 5358917.475133826],
              [-9784569.80013994, 5342021.980294697],
              [-9784602.451392122, 5341262.573215328],
              [-9787728.60201069, 5341264.156209682],
              [-9791579.477155702, 5341304.160695489],
              [-9803167.613508299, 5341259.880931281],
              [-9803064.420340335, 5368045.127324038],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lackawanna',
        GEOID: '42069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8441879.631863208, 5075566.075052851],
              [-8434915.37319969, 5087246.015544257],
              [-8429099.263764214, 5107541.898052104],
              [-8400437.166552726, 5107441.201197088],
              [-8398015.6336695, 5050489.919512133],
              [-8405245.723277032, 5046701.855825369],
              [-8409414.304248767, 5045445.516249876],
              [-8415835.435116706, 5036191.696927449],
              [-8419858.632833464, 5037663.042040973],
              [-8425465.461626248, 5062505.436198037],
              [-8441649.868434211, 5071512.016765913],
              [-8441879.631863208, 5075566.075052851],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Goliad',
        GEOID: '48175',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10884656.170114823, 3333460.7813558634],
              [-10861959.127817491, 3351904.701115218],
              [-10843757.723155847, 3366137.75997995],
              [-10832045.020293051, 3358352.346730694],
              [-10820561.63558129, 3357057.4058401915],
              [-10815682.947577782, 3347186.4418082843],
              [-10818290.717969105, 3326177.136596918],
              [-10815885.326412044, 3318935.239300591],
              [-10839799.869980182, 3298066.919608773],
              [-10859368.723266732, 3305883.709541339],
              [-10860162.097277615, 3313940.194208442],
              [-10875532.647288388, 3317422.3749553785],
              [-10884656.170114823, 3333460.7813558634],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McLean',
        GEOID: '17113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9937423.038226148, 4952688.176397173],
              [-9922323.88513393, 4953040.7585094115],
              [-9912373.703768862, 4957541.729648254],
              [-9905731.492392212, 4963047.357492999],
              [-9905975.949993992, 4975873.896848026],
              [-9899567.843506476, 4976026.72489281],
              [-9861156.05133284, 4976654.37359559],
              [-9860068.45990779, 4955946.34212613],
              [-9847263.712840313, 4956062.929491371],
              [-9847317.368834876, 4924072.484931455],
              [-9847368.68712013, 4906997.28673953],
              [-9860111.095272765, 4906933.956993568],
              [-9898478.359650085, 4907132.994707063],
              [-9923995.013329718, 4907012.316669809],
              [-9923995.903885644, 4907082.651210962],
              [-9936672.7448582, 4906849.031566856],
              [-9936794.083103165, 4913333.630084763],
              [-9937423.038226148, 4952688.176397173],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shelby',
        GEOID: '39149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9399192.966282198, 4917596.739923255],
              [-9388530.006217582, 4921200.426121367],
              [-9388589.784784138, 4936099.190929046],
              [-9351101.27646714, 4936397.610325518],
              [-9351249.108750917, 4911520.724318702],
              [-9352480.636277562, 4905760.533273428],
              [-9353388.55804447, 4892708.780747158],
              [-9375178.123852855, 4895049.023541896],
              [-9398991.25536488, 4894616.607412618],
              [-9399220.12823795, 4917556.568409192],
              [-9399192.966282198, 4917596.739923255],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oldham',
        GEOID: '48359',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11470533.321827602, 4248799.7292644],
              [-11372711.875890465, 4249488.31472299],
              [-11372705.53067949, 4248463.943151751],
              [-11373230.847356545, 4188809.740819917],
              [-11470651.760262728, 4188799.424773295],
              [-11470533.321827602, 4248799.7292644],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carson City',
        GEOID: '32510',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13358713.377169533, 4745424.03005077],
              [-13345068.164736891, 4745407.121721721],
              [-13332832.371586857, 4752556.384942931],
              [-13326350.682915928, 4757670.6639401885],
              [-13319263.193576103, 4749683.489189495],
              [-13309523.072090162, 4749559.529747525],
              [-13308358.670216465, 4733967.858052398],
              [-13331757.247944774, 4738015.565742072],
              [-13358629.978174409, 4737826.236977436],
              [-13358713.377169533, 4745424.03005077],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Delaware',
        GEOID: '36025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8395194.909092288, 5208154.522046541],
              [-8386962.721428637, 5208251.7717806585],
              [-8370918.131901111, 5214807.4411247],
              [-8331609.438590153, 5238075.05606071],
              [-8316855.041960921, 5238861.588918643],
              [-8306537.394956747, 5224764.379296124],
              [-8287013.180786005, 5214308.513387075],
              [-8297455.394300377, 5191199.699279066],
              [-8287926.779846947, 5186362.331548163],
              [-8296751.29852111, 5182946.0042733075],
              [-8324548.665928117, 5163432.655328705],
              [-8365288.47140127, 5138555.406693585],
              [-8370135.11060287, 5140397.93640011],
              [-8378239.392171603, 5143784.8358085],
              [-8381440.606768344, 5153057.374060929],
              [-8386935.670792372, 5159896.786188246],
              [-8389021.233565455, 5160033.667749798],
              [-8393738.850152712, 5162582.23711821],
              [-8395540.222152729, 5190239.210863627],
              [-8395194.909092288, 5208154.522046541],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Culebra',
        GEOID: '72049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7273845.737139456, 2078003.9974093214],
              [-7264257.232799977, 2077631.8713382164],
              [-7260431.738498866, 2075150.6581683767],
              [-7262623.507953094, 2072819.4761343743],
              [-7267300.2624003, 2070373.3183655848],
              [-7273331.775050463, 2073667.2116789771],
              [-7273845.737139456, 2078003.9974093214],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wabash',
        GEOID: '18169',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9567416.086462231, 5018667.922523842],
              [-9550746.326674411, 5018773.011320243],
              [-9538319.397958685, 5019234.707030747],
              [-9538209.970899235, 5012623.244989534],
              [-9533828.769700086, 5012681.656766435],
              [-9533243.897095459, 4961312.118288608],
              [-9558424.81119086, 4961101.41589061],
              [-9566744.162015803, 4960998.414000831],
              [-9567513.491016675, 5012222.927256368],
              [-9567416.086462231, 5018667.922523842],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McCracken',
        GEOID: '21145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9899836.568757253, 4470877.974147809],
              [-9899420.214881077, 4470709.755362962],
              [-9889072.641914487, 4466529.9039938385],
              [-9879946.336100783, 4460692.104339944],
              [-9873369.023987263, 4458800.279682788],
              [-9864180.379258713, 4454833.659390598],
              [-9858570.314349622, 4450821.777883076],
              [-9855289.959446, 4448476.628399135],
              [-9850706.206458243, 4448583.441368138],
              [-9849971.924245603, 4448600.5520900125],
              [-9849877.717123121, 4442252.663570142],
              [-9850133.417993473, 4439261.368676118],
              [-9850005.28925957, 4431038.786731681],
              [-9886606.469915453, 4431702.899820498],
              [-9886946.550959827, 4432710.848844462],
              [-9900033.850800553, 4470866.549139392],
              [-9899836.568757253, 4470877.974147809],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '05087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10457817.946633162, 4313164.256033296],
              [-10451539.30471344, 4333011.724058735],
              [-10449456.62836019, 4343008.902135822],
              [-10443505.377062889, 4342886.373541487],
              [-10425926.24835478, 4342405.527891228],
              [-10421727.83375951, 4328342.719159692],
              [-10414064.711332792, 4318010.005940335],
              [-10406093.456555558, 4317844.761661312],
              [-10402318.723942248, 4311738.005966088],
              [-10402886.008067332, 4296149.380365033],
              [-10411003.870613942, 4284340.821665163],
              [-10410510.168672273, 4268130.824320444],
              [-10430188.894296233, 4268834.34830765],
              [-10453029.650056181, 4269581.274817802],
              [-10454106.443490624, 4267613.774080727],
              [-10459901.290903358, 4267775.375371236],
              [-10457817.946633162, 4313164.256033296],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nottoway',
        GEOID: '51135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8708661.13300943, 4480476.8585895905],
              [-8663562.712982314, 4467298.551836556],
              [-8660202.868111191, 4465985.735179434],
              [-8671816.607946672, 4459181.522264978],
              [-8670654.3211433, 4437548.275244202],
              [-8679370.748591904, 4437335.6039298605],
              [-8683325.373502335, 4442279.155017394],
              [-8692051.040468674, 4440657.024616704],
              [-8709565.047274671, 4455858.890145671],
              [-8708661.13300943, 4480476.8585895905],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bibb',
        GEOID: '01007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9731765.399682151, 3895752.4777178145],
              [-9720255.2982926, 3896124.1510203406],
              [-9716181.67284651, 3912978.800240465],
              [-9706983.565961242, 3912659.363930875],
              [-9706965.309564753, 3921422.3748477106],
              [-9692113.619700568, 3928122.783154081],
              [-9687784.182064636, 3928063.1513656424],
              [-9687645.032701144, 3917331.2103739297],
              [-9671568.939757725, 3901929.361183149],
              [-9671005.217856348, 3873590.8601252967],
              [-9686928.246499926, 3873692.876281815],
              [-9720327.09936416, 3872962.6190886237],
              [-9720359.270697, 3878740.468960191],
              [-9731683.468536926, 3878658.8209162788],
              [-9731765.399682151, 3895752.4777178145],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cotton',
        GEOID: '40033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10982998.70258836, 4083442.048060609],
              [-10965525.104757523, 4085399.151760659],
              [-10942252.65201228, 4089258.0855918946],
              [-10936485.411833264, 4097100.95618877],
              [-10925133.940718092, 4097083.8001117287],
              [-10924816.123571876, 4094690.986070958],
              [-10924808.665165994, 4067778.413927555],
              [-10924726.291608883, 4047778.340677588],
              [-10928136.450023767, 4044142.7239093166],
              [-10934388.375265699, 4045900.7447764273],
              [-10944793.185431166, 4048479.7748745102],
              [-10949832.95273785, 4049917.4858561484],
              [-10953664.346971972, 4046063.598005748],
              [-10955443.789032303, 4040231.1142039327],
              [-10956457.575634956, 4039811.153647298],
              [-10962194.202954007, 4037435.0506981704],
              [-10968109.052777817, 4041560.106747689],
              [-10973556.583379276, 4048821.564490895],
              [-10977254.147278264, 4049796.5404904056],
              [-10977177.138497835, 4073700.9774892447],
              [-10983004.045923918, 4073662.0181982904],
              [-10982998.70258836, 4083442.048060609],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crowley',
        GEOID: '08025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11583229.500763515, 4653487.549740372],
              [-11534145.286368545, 4653509.604080856],
              [-11522086.713847855, 4652636.146220315],
              [-11522344.863747004, 4627888.571612047],
              [-11521763.664685573, 4616931.628687705],
              [-11522609.692815604, 4603825.001714524],
              [-11534845.819924109, 4603675.048188479],
              [-11534833.463460632, 4595451.471772983],
              [-11558927.89932589, 4595449.349491697],
              [-11583710.512283234, 4600140.938739569],
              [-11583229.500763515, 4653487.549740372],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Reeves',
        GEOID: '48389',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11579956.707734192, 3763311.939800119],
              [-11575024.416877937, 3763314.9393972587],
              [-11564490.311641848, 3746307.0708330465],
              [-11558234.267578756, 3748616.8001361247],
              [-11556016.004085721, 3736341.7161336583],
              [-11549041.949307011, 3729165.4968637116],
              [-11535563.05140329, 3724653.468278306],
              [-11533911.181479407, 3717690.513796069],
              [-11522611.362607965, 3714308.1908304184],
              [-11515156.40762903, 3689209.1462307065],
              [-11502636.415819002, 3686371.3131145495],
              [-11495037.302099489, 3688402.6306037423],
              [-11486081.426426189, 3680926.431151191],
              [-11467136.518885534, 3681064.762969346],
              [-11531038.804658469, 3602457.820684132],
              [-11588620.703702632, 3646419.305515244],
              [-11579956.707734192, 3763311.939800119],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Itawamba',
        GEOID: '28057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9856459.148057802, 4091449.6452052956],
              [-9832760.786940783, 4091219.439190419],
              [-9813358.822054688, 4091146.9759599213],
              [-9815402.59787714, 4071991.685201181],
              [-9818778.000829812, 4040426.5124094277],
              [-9856600.85776958, 4040764.735729058],
              [-9856459.148057802, 4091449.6452052956],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Haralson',
        GEOID: '13143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9505200.688805385, 4015610.563124312],
              [-9485844.503193645, 4015276.6756694675],
              [-9467757.201010061, 4015984.2969759065],
              [-9466260.065178385, 4014388.18741781],
              [-9466378.620436078, 4003578.297165054],
              [-9467821.654995231, 3990548.1382481004],
              [-9494410.649329677, 3982180.933872797],
              [-9499795.651762685, 3982318.3280883045],
              [-9502290.956082933, 3997686.7151040384],
              [-9505200.688805385, 4015610.563124312],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bon Homme',
        GEOID: '46009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10926295.966459248, 5287824.941001175],
              [-10922339.71017969, 5292112.148549243],
              [-10921503.36684536, 5325296.230905583],
              [-10917893.721036896, 5337628.587580832],
              [-10868956.337050285, 5337695.744584716],
              [-10868727.696884098, 5289442.809730268],
              [-10876028.909578344, 5288226.299280056],
              [-10887195.812977782, 5290383.370158247],
              [-10893497.94331006, 5291460.117291414],
              [-10895605.221270777, 5289572.474391872],
              [-10898734.85743494, 5281408.0490718745],
              [-10903760.487166293, 5276970.993297279],
              [-10913210.064781262, 5276150.034888847],
              [-10920965.248426868, 5282865.076512979],
              [-10925792.061547661, 5287651.811902003],
              [-10926295.966459248, 5287824.941001175],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rock',
        GEOID: '55105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9948525.821598886, 5288414.4120700685],
              [-9908946.621925302, 5288808.261719797],
              [-9898381.289054113, 5288579.146707931],
              [-9882618.894435747, 5288058.838041524],
              [-9882625.684924686, 5286813.06885921],
              [-9882554.302496253, 5235288.526749279],
              [-9900798.353615059, 5235485.281035025],
              [-9906606.488839032, 5235547.920148891],
              [-9912210.064117396, 5235608.353534842],
              [-9948155.195339337, 5236177.704600818],
              [-9948525.821598886, 5288414.4120700685],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Martin',
        GEOID: '18101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9676217.753012743, 4695526.192800684],
              [-9674137.080410326, 4707958.8920199815],
              [-9649491.056468187, 4708029.414901123],
              [-9649518.775021393, 4676873.056717963],
              [-9649436.064639734, 4654054.574807472],
              [-9666702.051620245, 4654067.3812568765],
              [-9672073.662328983, 4649571.594030568],
              [-9676356.123139799, 4651063.995952192],
              [-9676217.753012743, 4695526.192800684],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McPherson',
        GEOID: '31117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11288516.158265408, 5122589.332934701],
              [-11225731.186221568, 5122172.194029962],
              [-11211176.385439327, 5122076.26658591],
              [-11211346.926899225, 5070558.865874577],
              [-11273290.880190123, 5070770.026010137],
              [-11288604.545941098, 5070841.551433023],
              [-11288516.158265408, 5122589.332934701],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coke',
        GEOID: '48081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11223408.505046166, 3774684.9126027776],
              [-11206015.836485133, 3774526.851717961],
              [-11162191.80198862, 3774004.595509395],
              [-11158124.410434013, 3774128.095555975],
              [-11158193.87379627, 3723075.3021866423],
              [-11223828.847443402, 3723492.000788495],
              [-11223408.505046166, 3774684.9126027776],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pickens',
        GEOID: '45077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9233239.761838928, 4162271.436485703],
              [-9228107.376715904, 4171496.7826466886],
              [-9215392.909755459, 4175519.935271766],
              [-9213030.326343868, 4175013.1268242705],
              [-9211672.167095186, 4170400.7640023013],
              [-9191817.890634242, 4174028.5097253365],
              [-9194337.718627838, 4164996.226701116],
              [-9188073.214283446, 4166014.3723989036],
              [-9182433.434921388, 4139285.462774524],
              [-9215869.913773509, 4119495.461871258],
              [-9221723.871835856, 4112781.8763726284],
              [-9223423.72046027, 4126545.9815645856],
              [-9228401.816769052, 4128934.6216719714],
              [-9230142.964924552, 4160054.427330046],
              [-9233239.761838928, 4162271.436485703],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jeff Davis',
        GEOID: '48243',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11679325.160634883, 3589141.1956084184],
              [-11588620.703702632, 3646419.305515244],
              [-11531038.804658469, 3602457.820684132],
              [-11514885.455988439, 3589440.5355104157],
              [-11555038.841595536, 3556687.3226688863],
              [-11566207.526106825, 3556643.8225846193],
              [-11686404.066276273, 3584636.56397558],
              [-11679325.160634883, 3589141.1956084184],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crawford',
        GEOID: '26039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9445159.233059537, 5599199.936373015],
              [-9392218.800183998, 5598729.139973659],
              [-9392097.016661072, 5544274.592557128],
              [-9445562.209616208, 5544874.945403784],
              [-9445159.233059537, 5599199.936373015],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greene',
        GEOID: '42059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8963351.978724808, 4860450.813601163],
              [-8939110.512709016, 4868930.307270044],
              [-8905338.18295317, 4863518.973895423],
              [-8897023.841505311, 4854548.244115267],
              [-8896210.35830054, 4825489.300422731],
              [-8914013.644829161, 4825531.860095889],
              [-8952467.96104828, 4825508.55885475],
              [-8963372.150449445, 4825539.530702699],
              [-8963351.978724808, 4860450.813601163],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Esmeralda',
        GEOID: '32009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13174826.933508266, 4564420.757573279],
              [-13101304.528660467, 4646575.355903559],
              [-13042816.266322263, 4579664.838480431],
              [-13042859.521072337, 4435094.248955445],
              [-13051644.458539626, 4443323.24966062],
              [-13100145.581441818, 4488481.196639443],
              [-13117165.668581251, 4504112.925242692],
              [-13138169.091231568, 4523435.246024022],
              [-13183344.135264661, 4564776.139070745],
              [-13174826.933508266, 4564420.757573279],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Danville',
        GEOID: '51590',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8849993.916993441, 4386030.168304052],
              [-8841237.859806115, 4383569.467594791],
              [-8838555.39403647, 4389605.600323527],
              [-8834872.833961535, 4384578.835564973],
              [-8827921.043080987, 4380368.65793234],
              [-8832435.262095891, 4375339.593153268],
              [-8846566.242253846, 4375297.063635492],
              [-8845053.891950509, 4380304.89270151],
              [-8852014.031792866, 4383963.413454369],
              [-8849993.916993441, 4386030.168304052],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bradford',
        GEOID: '12007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9162361.974133907, 3497954.1523411307],
              [-9157138.08438945, 3507161.0623446372],
              [-9144600.058821913, 3517695.23842911],
              [-9144069.955406757, 3521959.4964332865],
              [-9133700.21088089, 3521961.9422411923],
              [-9133331.409407891, 3471086.870756417],
              [-9133680.062053056, 3467438.5114110517],
              [-9134390.391723808, 3467382.369196154],
              [-9143017.763579777, 3482479.998642661],
              [-9158539.81941752, 3483386.290523303],
              [-9174810.832789319, 3493667.991327213],
              [-9162361.974133907, 3497954.1523411307],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ripley',
        GEOID: '18137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9511143.304629795, 4749730.890073766],
              [-9495167.39922809, 4760175.14350285],
              [-9486411.342040764, 4765954.64307806],
              [-9469456.381717531, 4765775.957195439],
              [-9476907.440514289, 4714233.626002731],
              [-9477277.466501685, 4711589.239439624],
              [-9484773.05309476, 4709332.102072162],
              [-9511682.424923709, 4709216.933557685],
              [-9511143.304629795, 4749730.890073766],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sierra',
        GEOID: '35051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12022572.020007003, 3958925.57152273],
              [-11990528.927221142, 3958767.821700949],
              [-11852664.301972795, 3958628.2242457992],
              [-11841365.596296258, 3959173.9451048765],
              [-11841265.186115563, 3947427.881970454],
              [-11838350.28524914, 3947264.4223800916],
              [-11837771.98049447, 3902311.324495542],
              [-11898705.598086929, 3871804.660836153],
              [-11898688.009607384, 3866042.6610762943],
              [-11944522.919385588, 3866160.897561036],
              [-11944540.285226151, 3843039.8165083365],
              [-11978921.755235616, 3843050.2559953285],
              [-11993222.302300883, 3846228.120308754],
              [-11991489.948385159, 3865884.308135943],
              [-11997245.277378662, 3875911.085309102],
              [-11998075.72077998, 3889037.443455828],
              [-12006549.805697128, 3895640.978027502],
              [-12004269.982525682, 3904301.8262083186],
              [-12006769.327732971, 3921995.7500786358],
              [-12022571.57472904, 3922047.501575133],
              [-12022572.020007003, 3958925.57152273],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Salem',
        GEOID: '51775',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8918972.148907566, 4479194.160489781],
              [-8908033.450464258, 4482172.717100378],
              [-8909284.45890179, 4475813.886457595],
              [-8914646.384814832, 4476242.183800071],
              [-8918972.148907566, 4479194.160489781],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'El Paso',
        GEOID: '08041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11691764.000536123, 4702910.983142809],
              [-11692280.634292895, 4740284.126600235],
              [-11651020.28766935, 4740242.223201245],
              [-11582967.56600168, 4740042.897425219],
              [-11583408.391185218, 4702905.407045704],
              [-11583229.500763515, 4653487.549740372],
              [-11682038.016625514, 4653085.742200697],
              [-11682137.424930792, 4671643.538702229],
              [-11681755.376438389, 4692618.569160716],
              [-11696582.019417146, 4692975.370465822],
              [-11691764.000536123, 4702910.983142809],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pueblo',
        GEOID: '08101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11694025.122033115, 4615933.118181433],
              [-11681908.106779758, 4615975.931781247],
              [-11682038.016625514, 4653085.742200697],
              [-11583229.500763515, 4653487.549740372],
              [-11583710.512283234, 4600140.938739569],
              [-11584032.225611625, 4542015.878096203],
              [-11616312.317593386, 4553674.975153782],
              [-11649182.06891788, 4565383.128790751],
              [-11690074.838582825, 4562666.937735641],
              [-11694103.268315652, 4567492.70125804],
              [-11694025.122033115, 4615933.118181433],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fremont',
        GEOID: '08043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11801062.819932517, 4642704.112004779],
              [-11789704.447008915, 4651102.830890472],
              [-11786298.627188096, 4664837.870245],
              [-11796498.609490503, 4677869.961845774],
              [-11725185.562576478, 4678391.129563581],
              [-11715017.417648438, 4678347.769219736],
              [-11715303.508739779, 4671317.557777623],
              [-11682137.424930792, 4671643.538702229],
              [-11682038.016625514, 4653085.742200697],
              [-11681908.106779758, 4615975.931781247],
              [-11694025.122033115, 4615933.118181433],
              [-11777256.701548412, 4616936.023879072],
              [-11799842.42435495, 4639443.4551378945],
              [-11801062.819932517, 4642704.112004779],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Willacy',
        GEOID: '48489',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10904568.44403047, 3075050.58478703],
              [-10893913.27633021, 3073335.6903749565],
              [-10829999.537639128, 3073627.6188829164],
              [-10826243.60503036, 3061534.6093343],
              [-10823302.457980404, 3050136.397593095],
              [-10841486.805543663, 3050116.012918537],
              [-10847748.972178748, 3039383.00285599],
              [-10854422.464332314, 3037862.2563367807],
              [-10893934.093074989, 3042265.8456690256],
              [-10893939.102452075, 3052881.4190923376],
              [-10909776.415087743, 3054771.7788082557],
              [-10904568.44403047, 3075050.58478703],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jones',
        GEOID: '48253',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11148004.021567525, 3889992.916357238],
              [-11130705.306656724, 3890011.888629265],
              [-11088757.228219057, 3889592.781044929],
              [-11088760.011206327, 3831058.180513143],
              [-11090714.00222822, 3831058.5765485945],
              [-11093718.515284732, 3831848.42955298],
              [-11148262.171466675, 3832132.6733264555],
              [-11148004.021567525, 3889992.916357238],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mason',
        GEOID: '48319',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11074592.268293576, 3625037.9719261834],
              [-11030906.269965645, 3625089.497973837],
              [-11030272.862063032, 3622616.8783123363],
              [-11016690.214393891, 3622541.4862717013],
              [-11016647.912987389, 3567787.3371457164],
              [-11054470.268457277, 3567961.7509388668],
              [-11074563.102586988, 3567937.074470011],
              [-11074493.639224734, 3595243.9435003437],
              [-11074592.268293576, 3625037.9719261834],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Teller',
        GEOID: '08119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11725195.136052685, 4740265.470955942],
              [-11692280.634292895, 4740284.126600235],
              [-11691764.000536123, 4702910.983142809],
              [-11696582.019417146, 4692975.370465822],
              [-11681755.376438389, 4692618.569160716],
              [-11682137.424930792, 4671643.538702229],
              [-11715303.508739779, 4671317.557777623],
              [-11715017.417648438, 4678347.769219736],
              [-11725185.562576478, 4678391.129563581],
              [-11725331.391109418, 4740264.8969366625],
              [-11725195.136052685, 4740265.470955942],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Glasscock',
        GEOID: '48173',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11329661.957132928, 3774726.3004600005],
              [-11320636.840736354, 3774806.054606252],
              [-11272680.960700067, 3774754.0238346267],
              [-11273004.455140311, 3717566.5431802394],
              [-11329630.453717032, 3717627.35139393],
              [-11329661.957132928, 3774726.3004600005],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stonewall',
        GEOID: '48433',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11189551.238518845, 3948233.8807923696],
              [-11130944.9775204, 3948172.2789037847],
              [-11130705.306656724, 3890011.888629265],
              [-11148004.021567525, 3889992.916357238],
              [-11189747.049503151, 3890384.04325031],
              [-11189551.238518845, 3948233.8807923696],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Taney',
        GEOID: '29213',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10386593.732672792, 4413610.918071284],
              [-10342619.97346116, 4412541.933096054],
              [-10326537.980584728, 4412113.562768757],
              [-10327368.968713736, 4369375.065791245],
              [-10334776.402139867, 4369368.120541613],
              [-10336465.465573732, 4369366.788539354],
              [-10366735.448710179, 4369342.917536128],
              [-10385379.053978251, 4369399.4686257625],
              [-10387814.696706578, 4369406.856609953],
              [-10386593.732672792, 4413610.918071284],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chautauqua',
        GEOID: '20019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10745099.7112454, 4481387.869257887],
              [-10682708.03096253, 4480898.348654882],
              [-10682693.807905206, 4438998.504135157],
              [-10686761.30789584, 4438995.424917139],
              [-10710891.009085646, 4438977.158036749],
              [-10742362.921564247, 4438917.6406384865],
              [-10745178.641693924, 4438922.514741895],
              [-10745099.7112454, 4481387.869257887],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '37043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9351431.30908383, 4162202.89849972],
              [-9334220.120966304, 4182997.36099263],
              [-9321685.880261455, 4185094.37342353],
              [-9312969.007534888, 4185687.212525428],
              [-9293270.935061064, 4162641.021004369],
              [-9300652.257675314, 4162359.6471987865],
              [-9308534.150341175, 4162059.1996708345],
              [-9343760.350968737, 4162180.4518037173],
              [-9343784.691615263, 4162180.53558714],
              [-9351431.30908383, 4162202.89849972],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Otsego',
        GEOID: '36077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8390696.04319137, 5222712.899310053],
              [-8393892.137091536, 5237566.291202994],
              [-8385185.951036084, 5249594.163599364],
              [-8381898.686472958, 5273102.9262038125],
              [-8376949.3105927985, 5279237.720562356],
              [-8376564.92439109, 5292449.0415395005],
              [-8372579.130023237, 5293720.321649542],
              [-8372410.369675194, 5290162.568745908],
              [-8360204.966746148, 5298034.146209187],
              [-8338579.931145154, 5285364.231514651],
              [-8335472.33624017, 5296500.907950329],
              [-8322612.8199832225, 5291178.237546764],
              [-8309810.5219445415, 5286064.715295556],
              [-8311949.414640645, 5274104.016552947],
              [-8307843.840500696, 5255319.360740153],
              [-8316855.041960921, 5238861.588918643],
              [-8331609.438590153, 5238075.05606071],
              [-8370918.131901111, 5214807.4411247],
              [-8386962.721428637, 5208251.7717806585],
              [-8395194.909092288, 5208154.522046541],
              [-8390696.04319137, 5222712.899310053],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Titus',
        GEOID: '48449',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10589316.766800497, 3947112.297703685],
              [-10554502.597930316, 3945262.296108694],
              [-10554065.44628997, 3943670.6271309205],
              [-10555294.970065784, 3893032.58638694],
              [-10568241.538164532, 3905108.164844314],
              [-10589392.352734743, 3899894.9128149915],
              [-10589316.766800497, 3947112.297703685],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Van Zandt',
        GEOID: '48467',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10695220.564366676, 3873885.649486737],
              [-10679372.23110142, 3873717.1218101825],
              [-10667700.159852762, 3864413.4222393967],
              [-10660125.536421226, 3864856.5221850285],
              [-10648759.259813778, 3857064.9194430234],
              [-10646041.39444606, 3858247.6284699063],
              [-10641535.626736712, 3853835.201985298],
              [-10641508.798739431, 3826465.585988628],
              [-10625352.44444315, 3810031.338917827],
              [-10695120.15418598, 3810330.7436648416],
              [-10695220.564366676, 3873885.649486737],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Garfield',
        GEOID: '31071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11045424.11267694, 5174157.945467624],
              [-10994041.484755564, 5174248.247443536],
              [-10993816.396745179, 5122168.911893144],
              [-11044231.101694109, 5122203.374385806],
              [-11045323.591176754, 5122230.079173163],
              [-11045424.11267694, 5174157.945467624],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Camp',
        GEOID: '48063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10592295.11977667, 3897089.3620458567],
              [-10589392.352734743, 3899894.9128149915],
              [-10568241.538164532, 3905108.164844314],
              [-10555294.970065784, 3893032.58638694],
              [-10549620.68166158, 3885463.799941196],
              [-10544175.711408405, 3882635.0504707],
              [-10592284.433105553, 3882388.3031794266],
              [-10592063.57523582, 3895732.036028445],
              [-10592295.11977667, 3897089.3620458567],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Martin',
        GEOID: '22099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10182611.00718727, 3497893.8933280366],
              [-10158485.624503572, 3499881.434364305],
              [-10150424.757536247, 3483791.9737935294],
              [-10140390.975233598, 3477995.8102732236],
              [-10141206.72446213, 3464968.9982532067],
              [-10154029.060009154, 3471610.255943989],
              [-10173097.643504078, 3475774.248342458],
              [-10171667.299366875, 3482281.3467919175],
              [-10182611.00718727, 3497893.8933280366],
            ],
          ],
          [
            [
              [-10238964.606970022, 3556025.931076498],
              [-10205648.019209484, 3554390.4138024976],
              [-10214252.681889333, 3567691.216800969],
              [-10208101.166828096, 3567651.8128398415],
              [-10201329.156925177, 3560586.2890097983],
              [-10199209.188542511, 3543452.0208272305],
              [-10192719.818826718, 3534688.197807587],
              [-10182984.15012041, 3533083.0117356046],
              [-10181707.315561011, 3516731.177966948],
              [-10171132.18657463, 3511113.363413792],
              [-10196904.7637636, 3507814.122093876],
              [-10203420.516198711, 3517468.8861137303],
              [-10211328.764144154, 3519303.755637073],
              [-10221268.370157598, 3509208.559756511],
              [-10235938.275293317, 3512964.16767699],
              [-10230878.359158799, 3523439.8112513386],
              [-10239159.193439927, 3527041.099398004],
              [-10235027.681858627, 3533998.837078177],
              [-10240137.246486038, 3551018.2163982578],
              [-10238964.606970022, 3556025.931076498],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henderson',
        GEOID: '48213',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10737002.88808255, 3810479.131023542],
              [-10708515.451152118, 3809969.2713574073],
              [-10695120.15418598, 3810330.7436648416],
              [-10625352.44444315, 3810031.338917827],
              [-10629757.134054856, 3793866.865285853],
              [-10628627.463862287, 3782651.6175977583],
              [-10626548.349732742, 3781118.0355950417],
              [-10623053.362999797, 3774404.3986640014],
              [-10692547.226795277, 3764084.4623764795],
              [-10692769.197859919, 3764954.9716230896],
              [-10698400.182982204, 3773203.846765957],
              [-10702981.981903765, 3791133.7078744364],
              [-10708597.15965836, 3790505.739651377],
              [-10729315.609326333, 3806555.2626637802],
              [-10736928.971940665, 3808758.557350388],
              [-10737002.88808255, 3810479.131023542],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Moore',
        GEOID: '47127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9631953.004652178, 4212190.99933373],
              [-9620490.659324177, 4207295.906046694],
              [-9602150.995854964, 4220077.227896635],
              [-9604635.090292018, 4216659.7788133705],
              [-9602585.030549569, 4209306.108356901],
              [-9600784.549105478, 4208006.045629138],
              [-9607548.432685569, 4195341.85877837],
              [-9608894.507968241, 4181151.452624365],
              [-9613925.592354642, 4180613.02418067],
              [-9617134.821954722, 4195914.667448872],
              [-9632172.749327004, 4206298.649816815],
              [-9631953.004652178, 4212190.99933373],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Broome',
        GEOID: '36007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8474772.98291975, 5222645.504321302],
              [-8462660.643085007, 5222445.131453204],
              [-8445144.075930722, 5223454.426672382],
              [-8442080.786183072, 5197642.381912969],
              [-8420016.929149374, 5198304.500801524],
              [-8419884.57027482, 5190328.764187182],
              [-8402800.145383794, 5190261.899629146],
              [-8395540.222152729, 5190239.210863627],
              [-8393738.850152712, 5162582.23711821],
              [-8389021.233565455, 5160033.667749798],
              [-8402077.236610582, 5160890.6159395715],
              [-8402745.740315804, 5160889.292440349],
              [-8410534.015698958, 5160873.873277695],
              [-8445885.129780933, 5160803.885750381],
              [-8472063.35519435, 5160808.379523182],
              [-8471950.81118916, 5165709.350922911],
              [-8472409.336171737, 5172183.3664921755],
              [-8469262.668125482, 5199717.917584697],
              [-8474772.98291975, 5222645.504321302],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '51113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8732208.878855404, 4654253.361166232],
              [-8720565.861993844, 4668426.94559802],
              [-8708724.47379969, 4654931.2843994275],
              [-8693586.804163659, 4636642.5107243955],
              [-8693439.75111632, 4623487.653479166],
              [-8708778.018474761, 4612054.263889165],
              [-8715073.469637595, 4618014.887428584],
              [-8721826.555227077, 4618696.519761702],
              [-8730746.02942689, 4631359.095879528],
              [-8733325.858626023, 4646821.347484188],
              [-8732208.878855404, 4654253.361166232],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chenango',
        GEOID: '36017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8448017.454627078, 5270032.105673769],
              [-8396680.912974888, 5273302.256556608],
              [-8381898.686472958, 5273102.9262038125],
              [-8385185.951036084, 5249594.163599364],
              [-8393892.137091536, 5237566.291202994],
              [-8390696.04319137, 5222712.899310053],
              [-8395194.909092288, 5208154.522046541],
              [-8395540.222152729, 5190239.210863627],
              [-8402800.145383794, 5190261.899629146],
              [-8419884.57027482, 5190328.764187182],
              [-8420016.929149374, 5198304.500801524],
              [-8442080.786183072, 5197642.381912969],
              [-8445144.075930722, 5223454.426672382],
              [-8448017.454627078, 5270032.105673769],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rappahannock',
        GEOID: '51157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8718406.152552964, 4684192.380143996],
              [-8714624.629450716, 4687253.9164368],
              [-8705298.393831545, 4689717.201875182],
              [-8697455.71306618, 4702333.086990416],
              [-8686456.679458858, 4692136.378781235],
              [-8682437.600563258, 4680275.628362481],
              [-8675724.033393007, 4678196.437358433],
              [-8702448.503547747, 4653294.896424384],
              [-8708724.47379969, 4654931.2843994275],
              [-8720565.861993844, 4668426.94559802],
              [-8718406.152552964, 4684192.380143996],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Campbell',
        GEOID: '51031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8843538.61104183, 4446896.790069627],
              [-8831028.304027501, 4472391.490206668],
              [-8822955.19191619, 4488819.680361753],
              [-8818165.002907865, 4485566.0943159545],
              [-8803715.621683408, 4494291.128736656],
              [-8801869.165289618, 4493023.416544924],
              [-8796653.958465446, 4499107.812752261],
              [-8785491.953123603, 4473421.784162583],
              [-8774670.808062572, 4467770.249833782],
              [-8783618.446093554, 4442213.9025193425],
              [-8791086.648091892, 4446086.804594357],
              [-8804510.554167163, 4447682.285503324],
              [-8815894.196615174, 4446889.676099257],
              [-8818407.679397793, 4455689.267897945],
              [-8832246.695854234, 4458243.243373741],
              [-8843538.61104183, 4446896.790069627],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '40147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10686761.30789584, 4438995.424917139],
              [-10682693.807905206, 4438998.504135157],
              [-10678669.693795023, 4439001.550509646],
              [-10662933.55619158, 4439005.16305248],
              [-10665500.3753952, 4431015.666093434],
              [-10665477.777538566, 4383147.666252489],
              [-10665800.047464414, 4380795.201648513],
              [-10665818.749138867, 4359060.18548559],
              [-10686801.471277982, 4359077.617005102],
              [-10686761.30789584, 4438995.424917139],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greene',
        GEOID: '51079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8744495.878971202, 4626833.791668435],
              [-8736992.611333262, 4639153.167066915],
              [-8733325.858626023, 4646821.347484188],
              [-8730746.02942689, 4631359.095879528],
              [-8721826.555227077, 4618696.519761702],
              [-8715073.469637595, 4618014.887428584],
              [-8723968.564868923, 4605462.029908009],
              [-8756741.245597444, 4618763.16815737],
              [-8744495.878971202, 4626833.791668435],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ohio',
        GEOID: '54069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8987579.909556333, 4877584.955892948],
              [-8984150.156044992, 4887995.5851159245],
              [-8983769.588505082, 4888803.984309647],
              [-8981721.0768923, 4893156.5555332145],
              [-8979476.073265564, 4891980.546231723],
              [-8963343.471259862, 4889172.5802888675],
              [-8963347.43752249, 4868327.2226065975],
              [-8987737.364295065, 4870817.887631429],
              [-8987579.909556333, 4877584.955892948],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wilcox',
        GEOID: '01131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9759131.404062334, 3762175.890044237],
              [-9754120.579823257, 3764030.2463449286],
              [-9754259.617867257, 3780695.529765062],
              [-9742898.461956386, 3780757.445525454],
              [-9742021.264368935, 3798277.2097732313],
              [-9737361.430484328, 3798135.819733735],
              [-9720950.377193112, 3789469.986421],
              [-9704594.983647292, 3769549.1952179265],
              [-9674438.08831343, 3769609.083507057],
              [-9668829.812367264, 3769659.2533122846],
              [-9668941.911094494, 3758345.4818893885],
              [-9674658.834863674, 3758280.663617726],
              [-9674431.743102456, 3741098.3965035463],
              [-9740558.971537875, 3740917.977680547],
              [-9753826.251089599, 3740639.165795252],
              [-9759027.542977422, 3747011.5183270704],
              [-9759131.404062334, 3762175.890044237],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Logan',
        GEOID: '54045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9149422.196524097, 4575863.4026329275],
              [-9126899.703188328, 4582924.161168534],
              [-9120684.958656322, 4583008.384766097],
              [-9125999.462466285, 4577518.891135577],
              [-9104335.910321478, 4570445.722324837],
              [-9097266.566058649, 4552550.381568979],
              [-9084508.907135777, 4549620.330119379],
              [-9101719.45700987, 4545057.274305148],
              [-9094995.425807487, 4537330.368147107],
              [-9106261.292234238, 4531577.367171857],
              [-9120432.374731712, 4534601.513421173],
              [-9127468.43446679, 4528779.303940279],
              [-9137398.578323515, 4537352.316671374],
              [-9140711.780327994, 4558826.889097276],
              [-9149422.196524097, 4575863.4026329275],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sumter',
        GEOID: '01119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9839446.141758405, 3839439.719830491],
              [-9837674.985861853, 3857115.723614321],
              [-9834797.627252683, 3885888.3020611187],
              [-9833973.277959457, 3894144.5077491836],
              [-9815245.66693988, 3894754.4605289125],
              [-9815632.724809367, 3886293.909783695],
              [-9819193.501361372, 3885324.2825306016],
              [-9810885.616443979, 3873138.9524413054],
              [-9802096.274728905, 3841412.162030217],
              [-9788176.885600114, 3846596.9109303667],
              [-9778399.58340425, 3842995.680044829],
              [-9784800.120166391, 3841315.577455843],
              [-9779797.978847597, 3833359.633681243],
              [-9799635.44606543, 3820364.2317082947],
              [-9801273.178413982, 3812911.576585168],
              [-9788396.40763596, 3804147.690235639],
              [-9843015.451758672, 3803898.1117699086],
              [-9839446.141758405, 3839439.719830491],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Highland',
        GEOID: '51091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8883750.995979048, 4623867.8738865],
              [-8876015.07060535, 4629942.807833444],
              [-8871014.042481462, 4640554.241605397],
              [-8871171.336921953, 4645146.019884224],
              [-8868726.760904133, 4651849.96979285],
              [-8866494.471155256, 4663327.364886604],
              [-8854638.388788318, 4657874.31040903],
              [-8847298.872121336, 4644219.681107741],
              [-8835461.602748342, 4639958.122111666],
              [-8828893.092167625, 4638709.239907719],
              [-8828603.208920568, 4633631.442113099],
              [-8843009.175543617, 4610017.762480531],
              [-8851252.940434312, 4604944.412035002],
              [-8872853.151788857, 4610720.120139389],
              [-8882962.9137413, 4617250.940130533],
              [-8881908.547086928, 4618105.920382203],
              [-8883750.995979048, 4623867.8738865],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pleasants',
        GEOID: '54073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9058110.359168721, 4771743.748999704],
              [-9055569.735711705, 4771321.87720498],
              [-9044607.103577875, 4777689.538734872],
              [-9037578.168290205, 4783559.2446082225],
              [-9031186.98236529, 4786246.630809155],
              [-9030378.898163617, 4787446.473703568],
              [-9020210.769253584, 4788895.225931264],
              [-9017751.053785015, 4772063.665991434],
              [-9041484.369222142, 4765911.625816492],
              [-9043537.21195186, 4760180.463668368],
              [-9057392.592373444, 4767728.7257006895],
              [-9058110.359168721, 4771743.748999704],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grenada',
        GEOID: '28043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10033948.280012485, 4003226.8738691094],
              [-10010549.257006213, 4005174.3741689264],
              [-10010527.549705507, 4015108.36052009],
              [-9993072.31959065, 4014998.387019516],
              [-9993044.934995914, 4011002.1040683514],
              [-9963912.958213788, 4011020.203065932],
              [-9963888.690564793, 3991509.997757188],
              [-9963859.413538717, 3985593.9699783637],
              [-9995030.874711668, 3985476.52053313],
              [-10032978.01933073, 3985507.1535871807],
              [-10033981.23058176, 3991487.11133766],
              [-10033948.280012485, 4003226.8738691094],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Caldwell',
        GEOID: '29025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10486959.608210988, 4829077.032390694],
              [-10486946.583830565, 4835320.87841046],
              [-10437203.246730609, 4834700.851974778],
              [-10437132.558853954, 4809632.649187686],
              [-10437224.508753352, 4797090.9791907985],
              [-10487233.676797323, 4797472.272991861],
              [-10486959.608210988, 4829077.032390694],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Schuyler',
        GEOID: '29197',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10317835.468072472, 4952025.561585676],
              [-10312404.222800016, 4952193.783384186],
              [-10291903.815331163, 4952828.767910356],
              [-10280444.496415699, 4953117.474488789],
              [-10280352.191771545, 4916423.945216695],
              [-10317554.27503873, 4915980.075409314],
              [-10320354.294190653, 4930951.38295223],
              [-10317469.115628274, 4947794.092448065],
              [-10320941.756425606, 4951992.40766275],
              [-10317835.468072472, 4952025.561585676],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sullivan',
        GEOID: '29211',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10393559.661128672, 4921755.743371363],
              [-10336606.160610035, 4922178.82845804],
              [-10336641.337569125, 4915873.456157194],
              [-10336703.899122952, 4871357.261586046],
              [-10393004.844786556, 4870753.156992743],
              [-10393523.482294165, 4873437.814863454],
              [-10393590.719266603, 4904718.109613281],
              [-10393559.661128672, 4921755.743371363],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sheridan',
        GEOID: '30091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11694963.17984422, 6274730.553343566],
              [-11674690.262316216, 6274690.189551578],
              [-11637744.325197345, 6274783.5116688935],
              [-11582652.309203753, 6274840.523505819],
              [-11582670.565600242, 6249005.7226573555],
              [-11582580.126176316, 6212987.584203432],
              [-11582520.840885125, 6189459.392022973],
              [-11582434.808919773, 6171866.710567258],
              [-11647108.966040835, 6171876.98126837],
              [-11647105.181178149, 6186471.391834686],
              [-11661567.47546354, 6186506.151479136],
              [-11661564.80379576, 6201055.691771588],
              [-11685580.314142046, 6201066.288917147],
              [-11685572.410458202, 6215691.15279615],
              [-11692837.677024825, 6215697.7242346825],
              [-11692795.709576797, 6259690.77112135],
              [-11694963.17984422, 6274730.553343566],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '54049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8961014.514953934, 4802687.582919078],
              [-8953742.457898373, 4813662.795295905],
              [-8949620.631112771, 4813381.636833313],
              [-8944239.00164986, 4809669.929810777],
              [-8922650.367522359, 4809490.897389253],
              [-8898755.193545619, 4786692.099548605],
              [-8915281.239870826, 4777145.519368436],
              [-8927521.040522527, 4778149.608804582],
              [-8936958.372993508, 4784239.239282946],
              [-8960560.55407048, 4789162.575350965],
              [-8961014.514953934, 4802687.582919078],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harrison',
        GEOID: '54033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8964759.859221675, 4773387.879844686],
              [-8966175.06390813, 4783327.065365482],
              [-8960560.55407048, 4789162.575350965],
              [-8936958.372993508, 4784239.239282946],
              [-8927521.040522527, 4778149.608804582],
              [-8927767.947153106, 4760520.097345328],
              [-8924081.379576506, 4756436.193112392],
              [-8930571.305889754, 4746192.236067545],
              [-8930848.046143865, 4737840.960747123],
              [-8938978.376473442, 4736559.133901592],
              [-8969849.05238227, 4745713.521557669],
              [-8971919.706230516, 4745631.105692513],
              [-8964420.112135775, 4749743.673986732],
              [-8972761.058941932, 4763446.856646925],
              [-8964759.859221675, 4773387.879844686],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gilmer',
        GEOID: '54021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9017187.888481092, 4699639.912338328],
              [-9020622.651369518, 4723044.491338523],
              [-9017683.705493085, 4722930.026584288],
              [-8996058.669892093, 4737354.464296241],
              [-8986636.142913388, 4735386.049671703],
              [-8985354.744254865, 4722879.169692835],
              [-8972996.499664959, 4707953.59924744],
              [-8980139.092152728, 4706311.6854768535],
              [-9015203.39591872, 4681343.061609085],
              [-9022657.237702748, 4690206.70321536],
              [-9017187.888481092, 4699639.912338328],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Braxton',
        GEOID: '54007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9015203.39591872, 4681343.061609085],
              [-8980139.092152728, 4706311.6854768535],
              [-8972996.499664959, 4707953.59924744],
              [-8970513.073144853, 4701476.168368571],
              [-8958337.058561374, 4697836.141532981],
              [-8956469.228825355, 4684378.338418606],
              [-8962182.479051337, 4671026.507082553],
              [-8978004.429597277, 4654084.741136083],
              [-8992964.767284473, 4658505.211309353],
              [-9003657.560972624, 4651303.9783114055],
              [-9007226.129888983, 4659384.722463593],
              [-9020405.021765018, 4674203.427941881],
              [-9015203.39591872, 4681343.061609085],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Barranquitas',
        GEOID: '72019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7386232.336571473, 2060291.4135192519],
              [-7386136.4904899, 2065804.0918330431],
              [-7381962.677502098, 2066752.2225382403],
              [-7376749.251789776, 2066277.038152451],
              [-7376424.978113095, 2059209.0694030966],
              [-7373854.277112206, 2059189.7360735459],
              [-7374107.528953761, 2058657.0807442088],
              [-7374726.24268359, 2056942.6247115356],
              [-7382135.111393335, 2055357.8794917352],
              [-7383079.657272717, 2056902.4392953224],
              [-7388694.055790875, 2057889.1722571165],
              [-7386232.336571473, 2060291.4135192519],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fayette',
        GEOID: '54019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9059272.44461447, 4575062.869232879],
              [-9053532.366391206, 4605236.42746197],
              [-9042664.355824549, 4616718.676823994],
              [-9024722.882173907, 4609148.985191463],
              [-9013474.604226701, 4609939.8358929865],
              [-9003763.871086331, 4594051.143828183],
              [-8991260.35456094, 4577345.1668197485],
              [-8995824.453683462, 4572243.63114398],
              [-8988910.511429785, 4560386.032666782],
              [-8995317.950000355, 4560924.413111552],
              [-9010766.2010157, 4553905.094300051],
              [-9023255.80260474, 4556218.687609557],
              [-9025032.795636274, 4561904.511991618],
              [-9049732.141614506, 4563800.948573323],
              [-9055543.352992387, 4576136.097997363],
              [-9059272.44461447, 4575062.869232879],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gurabo',
        GEOID: '72063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7349507.257322336, 2073283.322623593],
              [-7343530.068583683, 2073864.552707538],
              [-7340677.617951595, 2071927.340103672],
              [-7338017.750038581, 2069191.1455364416],
              [-7341057.551373674, 2067142.6697076606],
              [-7341633.852377511, 2064404.305372522],
              [-7346824.791552692, 2061790.8776992036],
              [-7350414.17721383, 2071622.622893242],
              [-7349507.257322336, 2073283.322623593],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ciales',
        GEOID: '72039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7412852.277724359, 2077156.0806380608],
              [-7406489.032991634, 2078712.732934978],
              [-7398650.805005899, 2081074.9728316192],
              [-7398836.931194505, 2070728.0774054185],
              [-7397815.018269022, 2067737.0874430907],
              [-7402864.693010387, 2067622.4458744363],
              [-7404104.903457314, 2057025.2218061315],
              [-7407547.681349078, 2056647.7382304522],
              [-7406199.602315571, 2058644.0750353665],
              [-7410162.242229341, 2072522.9529255375],
              [-7414656.098753173, 2075998.1392790936],
              [-7412852.277724359, 2077156.0806380608],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Halifax',
        GEOID: '37083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8673120.047864372, 4353373.762466515],
              [-8671735.344718393, 4370230.320570458],
              [-8643407.539937757, 4366960.116260351],
              [-8633413.721332299, 4358286.033189578],
              [-8636800.394200703, 4346885.780158383],
              [-8631836.65810623, 4342430.667810029],
              [-8621236.593553916, 4345418.039405959],
              [-8614636.349625291, 4330045.172165684],
              [-8606201.22652992, 4323962.826388136],
              [-8604052.537718628, 4323809.763619556],
              [-8597234.886824485, 4315078.707332068],
              [-8608065.605361726, 4310444.983485442],
              [-8609453.648092428, 4309430.975095591],
              [-8616419.576548308, 4301304.707502374],
              [-8629224.88021324, 4305682.735897425],
              [-8631791.239753988, 4313850.587020314],
              [-8649296.897598175, 4321715.089920872],
              [-8651833.42351539, 4319059.27642897],
              [-8670274.387721224, 4320452.856178995],
              [-8683649.535859525, 4328539.30152408],
              [-8673120.047864372, 4353373.762466515],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '19097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10118721.300516797, 5205307.474138142],
              [-10092842.969811575, 5205226.658458648],
              [-10092784.861037381, 5218397.423052826],
              [-10072671.285049323, 5218313.448117099],
              [-10068438.286525475, 5214613.410546577],
              [-10065188.313991766, 5209026.493394036],
              [-10066719.95886559, 5202748.494997868],
              [-10063354.659339417, 5196892.046388459],
              [-10056398.972276691, 5191484.769059129],
              [-10053897.346608536, 5190076.098604367],
              [-10048708.019977277, 5187154.644423542],
              [-10041844.171494452, 5183341.484537914],
              [-10036694.309211375, 5176926.795750564],
              [-10036948.896886818, 5167034.139747244],
              [-10036529.940542221, 5165937.044052274],
              [-10118760.596297046, 5166006.097198429],
              [-10118721.300516797, 5205307.474138142],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gallatin',
        GEOID: '21077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9464500.225091103, 4687141.473422996],
              [-9457986.132705685, 4689926.679294468],
              [-9446227.343573699, 4691667.3505737],
              [-9441326.280352544, 4691076.525756091],
              [-9440254.273656204, 4700311.4238385465],
              [-9439748.084222708, 4701527.116866793],
              [-9437513.14251491, 4701546.0744389165],
              [-9424320.001744056, 4689820.726305283],
              [-9437751.700183682, 4688095.218554537],
              [-9438310.746666444, 4681708.457038953],
              [-9441211.398638045, 4679118.86915368],
              [-9454869.298282962, 4673389.502601835],
              [-9458001.27215643, 4675878.387943486],
              [-9464500.225091103, 4687141.473422996],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stark',
        GEOID: '17175',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10017035.287137281, 5034398.141041884],
              [-10004102.745294373, 5034337.380926755],
              [-10004048.310063375, 5044288.04610306],
              [-10002924.317164836, 5046989.617252483],
              [-9978552.695767501, 5046897.692533072],
              [-9978504.271789007, 5034283.569366668],
              [-9978515.292418594, 5033208.879064004],
              [-9978537.444997262, 5008464.225546851],
              [-10017137.701068811, 5008580.409725721],
              [-10017035.287137281, 5034398.141041884],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '20027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10839160.89610303, 4765600.295662836],
              [-10839020.076947175, 4803220.570260402],
              [-10793395.227048099, 4803131.47232524],
              [-10793726.29121372, 4753244.777432321],
              [-10793673.525775082, 4743341.390924348],
              [-10793891.489338055, 4740640.168996367],
              [-10839307.281233422, 4740591.519174572],
              [-10839160.89610303, 4765600.295662836],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ward',
        GEOID: '38101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11380592.293963214, 6227533.044020559],
              [-11371569.292636964, 6227533.718954564],
              [-11371526.879910972, 6242210.361428792],
              [-11356998.684487032, 6242194.811074998],
              [-11356973.414962621, 6227531.862886175],
              [-11337015.277416768, 6227508.240233033],
              [-11336996.130464355, 6183650.120482855],
              [-11249925.69830905, 6183465.974510962],
              [-11244842.405081466, 6168871.843475908],
              [-11239984.311183756, 6110622.983178159],
              [-11240076.483722132, 6081721.212751576],
              [-11340323.804002635, 6081536.426117499],
              [-11340287.625168128, 6110711.361913344],
              [-11345918.832929397, 6110710.862595899],
              [-11345931.523351347, 6169022.3265960645],
              [-11351626.851139313, 6168982.946013143],
              [-11351618.279538522, 6198365.789389059],
              [-11380624.799254524, 6198232.275058999],
              [-11380592.293963214, 6227533.044020559],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kingsbury',
        GEOID: '46077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10892949.24953994, 5550079.195244302],
              [-10852789.40740238, 5549998.912663789],
              [-10812242.173436854, 5549880.520579732],
              [-10812425.516638191, 5495813.50146116],
              [-10839191.620282488, 5495664.136835207],
              [-10892555.623820495, 5495705.126469007],
              [-10893019.603458121, 5495704.815940787],
              [-10892949.24953994, 5550079.195244302],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cochran',
        GEOID: '48079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11471764.127621453, 3971285.4340434056],
              [-11471764.070117813, 3971288.670405903],
              [-11471178.084318276, 4005284.3873296673],
              [-11423099.307564152, 4005344.151316516],
              [-11420804.901539411, 3946983.6399171064],
              [-11472196.553501619, 3946973.669281003],
              [-11471764.127621453, 3971285.4340434056],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Toa Alta',
        GEOID: '72135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7380890.002888814, 2082553.4483427326],
              [-7375200.575033861, 2083739.450571215],
              [-7369014.105652514, 2083164.8584097822],
              [-7369300.642021816, 2077370.4606705164],
              [-7369445.134720867, 2077191.6150271704],
              [-7369752.710473928, 2076993.4207147113],
              [-7369520.720655115, 2076091.6024188432],
              [-7369816.941820115, 2074693.4528809774],
              [-7369877.276984126, 2074573.2608438316],
              [-7371262.648047049, 2076702.7001369507],
              [-7378041.671077886, 2076207.9335532861],
              [-7382571.038519284, 2080598.5147697309],
              [-7380890.002888814, 2082553.4483427326],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stanton',
        GEOID: '20187',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11359259.656663178, 4542555.9234613385],
              [-11301940.954896605, 4542242.5021741595],
              [-11301801.471574642, 4493382.782280422],
              [-11305229.666613111, 4493395.812146244],
              [-11359256.635924859, 4493494.595222321],
              [-11359251.331193902, 4529295.342698918],
              [-11359249.675910363, 4540491.7128651785],
              [-11359259.656663178, 4542555.9234613385],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Thomas',
        GEOID: '31171',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11226139.72875278, 5174195.4461841425],
              [-11161740.624092435, 5173892.594620099],
              [-11161501.509826211, 5122090.439320436],
              [-11211176.385439327, 5122076.26658591],
              [-11225731.186221568, 5122172.194029962],
              [-11226139.72875278, 5174195.4461841425],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Arenac',
        GEOID: '26011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9369328.173292177, 5490513.480631534],
              [-9337921.605354672, 5490513.170279413],
              [-9302373.817941004, 5490782.997240004],
              [-9302718.708822642, 5489599.694402681],
              [-9304538.337219149, 5474228.2708785795],
              [-9315176.473037317, 5471071.476508965],
              [-9316685.965332475, 5463704.479395301],
              [-9327222.243816568, 5463164.357213155],
              [-9336299.569054324, 5459365.369014571],
              [-9339853.260363527, 5451281.977219905],
              [-9355829.126560623, 5451702.102584909],
              [-9355892.13339241, 5464973.914794551],
              [-9369358.229554692, 5464962.618459492],
              [-9369328.173292177, 5490513.480631534],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Darke',
        GEOID: '39037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9441023.96316241, 4866678.7084928835],
              [-9440861.966756444, 4881534.870356867],
              [-9440440.210888702, 4911107.427164154],
              [-9440351.514238698, 4917337.925808274],
              [-9399220.12823795, 4917556.568409192],
              [-9398991.25536488, 4894616.607412618],
              [-9398248.420402816, 4854268.833060258],
              [-9404868.033922838, 4854104.673656777],
              [-9441163.765738208, 4853875.730184792],
              [-9441023.96316241, 4866678.7084928835],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morgan',
        GEOID: '08087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11593979.957947893, 4916970.229028728],
              [-11593670.489763487, 4942440.248221662],
              [-11530678.1295083, 4942292.922568438],
              [-11517916.017805796, 4942273.884623486],
              [-11517713.08237408, 4929554.976540786],
              [-11518449.238166695, 4866160.548450464],
              [-11544465.827679483, 4866140.784886042],
              [-11593961.924190387, 4866066.671870049],
              [-11593979.957947893, 4916970.229028728],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ford',
        GEOID: '17053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9847263.712840313, 4956062.929491371],
              [-9822269.704169953, 4956189.490679705],
              [-9823644.499881253, 5011539.298199444],
              [-9810802.126825886, 5012013.777384224],
              [-9809272.151744422, 4941355.567293023],
              [-9809239.757772602, 4937091.518032678],
              [-9788913.820629165, 4936808.5921402555],
              [-9788588.545077067, 4924152.881312816],
              [-9834741.60595996, 4924009.191515109],
              [-9847317.368834876, 4924072.484931455],
              [-9847263.712840313, 4956062.929491371],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Navarro',
        GEOID: '48349',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10786436.645678611, 3773025.1800082177],
              [-10729315.609326333, 3806555.2626637802],
              [-10708597.15965836, 3790505.739651377],
              [-10702981.981903765, 3791133.7078744364],
              [-10698400.182982204, 3773203.846765957],
              [-10692769.197859919, 3764954.9716230896],
              [-10741964.954384662, 3736587.16125237],
              [-10766722.520456577, 3739036.122162451],
              [-10786436.645678611, 3773025.1800082177],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Miner',
        GEOID: '46097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10892555.623820495, 5495705.126469007],
              [-10839191.620282488, 5495664.136835207],
              [-10839119.039974492, 5442031.077416595],
              [-10865730.409526587, 5442113.351005073],
              [-10892735.738756599, 5442236.53122301],
              [-10892555.623820495, 5495705.126469007],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Vermilion',
        GEOID: '17183',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9789670.125249617, 4898763.014145533],
              [-9788588.545077067, 4924152.881312816],
              [-9788913.820629165, 4936808.5921402555],
              [-9743447.241804725, 4937584.558880625],
              [-9743468.335751222, 4935485.446162954],
              [-9743801.040387738, 4902436.249984571],
              [-9743908.754510509, 4887477.756644897],
              [-9744051.954519987, 4867626.213656203],
              [-9744068.262144592, 4848954.568434693],
              [-9746857.76228543, 4846883.181498598],
              [-9753277.445999987, 4848755.953719565],
              [-9789173.862959659, 4848490.921472191],
              [-9789670.125249617, 4898763.014145533],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chase',
        GEOID: '20017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10779918.332895212, 4628794.133724516],
              [-10777898.440734768, 4653495.5177546805],
              [-10726053.725607106, 4653382.827842804],
              [-10726443.00986641, 4603845.675364937],
              [-10726534.514487844, 4591555.980087193],
              [-10744866.942190152, 4591634.1923476355],
              [-10780265.427067505, 4591528.4008597685],
              [-10779918.332895212, 4628794.133724516],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stafford',
        GEOID: '20185',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11023093.756782282, 4579459.151808658],
              [-11010959.932285817, 4579489.524240147],
              [-11010898.372607408, 4616374.730582719],
              [-10962725.753522545, 4616332.482413575],
              [-10961903.547763545, 4613193.701273118],
              [-10961941.285070924, 4603859.410621328],
              [-10961881.506504368, 4554662.705610295],
              [-11022112.141512468, 4554780.946431161],
              [-11023139.509092998, 4556833.533803153],
              [-11023093.756782282, 4579459.151808658],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Juncos',
        GEOID: '72077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7341057.551373674, 2067142.6697076606],
              [-7338017.750038581, 2069191.1455364416],
              [-7330679.68052498, 2067414.2640628063],
              [-7332476.043147911, 2063280.2560535131],
              [-7339109.3489653, 2054275.0935262984],
              [-7339227.681584013, 2060670.7220870354],
              [-7341633.852377511, 2064404.305372522],
              [-7341057.551373674, 2067142.6697076606],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '18175',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9607991.372939434, 4683514.5103235645],
              [-9604120.34896659, 4687893.488160881],
              [-9583684.762124723, 4690692.657954092],
              [-9563421.497854607, 4686939.42747788],
              [-9561045.605962606, 4683703.881207276],
              [-9560746.04521288, 4661034.187679115],
              [-9558002.353723299, 4661104.6714015715],
              [-9556543.734435435, 4659020.55182758],
              [-9560649.531214364, 4650795.284973087],
              [-9572732.260064555, 4648671.876854623],
              [-9572877.30936106, 4638693.667639082],
              [-9577129.37995089, 4638630.15774074],
              [-9601867.687750898, 4639310.316613691],
              [-9607837.64072265, 4639337.313613467],
              [-9607840.646348901, 4677092.6812419435],
              [-9607991.372939434, 4683514.5103235645],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'DeWitt',
        GEOID: '48123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10866244.148976596, 3389624.0915545514],
              [-10835305.679497877, 3415806.1498230635],
              [-10824719.307242926, 3424674.3531121],
              [-10795361.017936017, 3388895.436115281],
              [-10832045.020293051, 3358352.346730694],
              [-10843757.723155847, 3366137.75997995],
              [-10861959.127817491, 3351904.701115218],
              [-10882049.067640446, 3376551.3915893743],
              [-10866244.148976596, 3389624.0915545514],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Noble',
        GEOID: '18113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9535042.820066677, 5089844.408294806],
              [-9483762.049479375, 5090303.86072139],
              [-9483540.523692697, 5051390.887470606],
              [-9496418.741624096, 5051383.3346289955],
              [-9521955.321492583, 5051679.380816868],
              [-9534729.010422131, 5055918.767110616],
              [-9534873.614440672, 5064281.6710576685],
              [-9534904.783898093, 5076992.941510568],
              [-9535042.820066677, 5089844.408294806],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cass',
        GEOID: '48067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10536641.385632535, 3931045.381637182],
              [-10527758.424225705, 3928511.329009915],
              [-10521680.936625846, 3932807.629246072],
              [-10510311.98835062, 3933063.4336687624],
              [-10506267.751250101, 3929286.729093771],
              [-10489784.006331395, 3927346.2627621586],
              [-10488357.335737389, 3934783.901314192],
              [-10468812.844407033, 3931362.40460824],
              [-10468787.591894912, 3916599.2908970546],
              [-10468814.865170158, 3897855.24213388],
              [-10468819.164502919, 3879531.129577362],
              [-10536834.413629571, 3879321.299828314],
              [-10536641.385632535, 3931045.381637182],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lee',
        GEOID: '21129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9340325.32711937, 4515046.46591219],
              [-9331064.213402314, 4532221.276710432],
              [-9319901.540143529, 4539442.562494203],
              [-9318329.041016584, 4539448.613628897],
              [-9308162.788519887, 4532479.751680913],
              [-9297660.796438958, 4528485.354686709],
              [-9303992.426436298, 4509908.259126317],
              [-9310284.204055935, 4514647.047579105],
              [-9331839.4423362, 4507182.342906479],
              [-9338064.650900342, 4511513.581448821],
              [-9340325.32711937, 4515046.46591219],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Weakley',
        GEOID: '47183',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9901770.188312331, 4357248.153477376],
              [-9886998.648481518, 4357285.638791092],
              [-9888196.227608878, 4369913.090790831],
              [-9887036.95990226, 4369910.7517137155],
              [-9853595.906111984, 4369843.277265465],
              [-9855150.364804545, 4321559.715276629],
              [-9855363.096351448, 4316514.079047068],
              [-9869083.780189175, 4316778.934683343],
              [-9873227.202955991, 4309258.563172023],
              [-9892217.083570926, 4319576.851111719],
              [-9902963.978531599, 4331326.465792777],
              [-9901770.188312331, 4357248.153477376],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '18095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9558103.320501449, 4897808.654357436],
              [-9558147.06906133, 4921078.845050591],
              [-9526564.950286843, 4921247.919134941],
              [-9526298.674064865, 4877158.830634246],
              [-9526298.117467409, 4858062.817408493],
              [-9558168.553723052, 4857752.380403519],
              [-9558103.320501449, 4897808.654357436],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lafayette',
        GEOID: '55065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10066276.68465325, 5283530.774963537],
              [-10000766.054877335, 5283672.964682176],
              [-10000675.316838162, 5236915.213787509],
              [-10010570.407709464, 5237047.587678484],
              [-10010628.61408458, 5237048.1140348],
              [-10043599.568544772, 5237346.27286466],
              [-10066218.237549746, 5237257.592763433],
              [-10066276.68465325, 5283530.774963537],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hempstead',
        GEOID: '05057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10460642.010795096, 3993961.5177651076],
              [-10459280.462103205, 3995408.180158462],
              [-10445269.45703349, 3994975.6081964835],
              [-10444337.044978607, 4029996.20127509],
              [-10424862.256661776, 4026515.1396288206],
              [-10411494.566929357, 4021152.4945068387],
              [-10403553.257095145, 4023007.7612535614],
              [-10405167.167072667, 4005357.9533577873],
              [-10406490.755818201, 3958666.793546273],
              [-10433181.830125703, 3959452.6210102034],
              [-10438727.655837532, 3961661.7122586886],
              [-10444649.630108753, 3976534.3528286708],
              [-10460206.862905586, 3984541.382144615],
              [-10460642.010795096, 3993961.5177651076],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marshall',
        GEOID: '19127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10378507.81882004, 5192321.093263104],
              [-10352898.99260203, 5192378.353733479],
              [-10326826.743343847, 5192509.558160839],
              [-10326663.771609325, 5140385.829136016],
              [-10378522.95827079, 5140436.350907465],
              [-10378507.81882004, 5192321.093263104],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Delaware',
        GEOID: '40041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10575989.486043235, 4371010.18246557],
              [-10575985.033263603, 4383173.179076124],
              [-10575285.167624986, 4393295.895916735],
              [-10532826.664655548, 4392919.824343309],
              [-10532806.98577216, 4385245.467244951],
              [-10532818.562999206, 4369559.360661618],
              [-10529287.620070733, 4341975.533857764],
              [-10526623.5140636, 4322931.503037883],
              [-10552784.826867884, 4322851.171146955],
              [-10576609.869565425, 4322909.770807479],
              [-10575989.486043235, 4371010.18246557],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calhoun',
        GEOID: '17013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10122876.851137891, 4779061.965114627],
              [-10087070.274977509, 4778522.548934567],
              [-10084569.593936328, 4750162.822933992],
              [-10087164.451266719, 4742073.937044351],
              [-10085943.165133225, 4738529.642163749],
              [-10078271.91638368, 4715728.652643595],
              [-10070825.644325027, 4717261.842052073],
              [-10068955.91557778, 4716143.24567765],
              [-10070827.648075862, 4716202.514997375],
              [-10074426.94117168, 4708846.400242637],
              [-10080613.633192006, 4703179.497285497],
              [-10085028.67551636, 4703789.328119835],
              [-10091919.351996463, 4710257.360387206],
              [-10092401.24370568, 4712322.69287067],
              [-10094050.341008719, 4719393.717008581],
              [-10098194.988289936, 4729406.266523545],
              [-10094572.318101047, 4736090.4863521755],
              [-10097557.46156616, 4743304.068379361],
              [-10099269.736052036, 4753823.426994],
              [-10100012.946894078, 4758392.758577546],
              [-10112274.343526995, 4770554.37844154],
              [-10122876.851137891, 4779061.965114627],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Knox',
        GEOID: '31107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10943617.297217367, 5294710.275547218],
              [-10940480.334399361, 5292964.277319572],
              [-10935127.536684567, 5290859.766156212],
              [-10926295.966459248, 5287824.941001175],
              [-10925792.061547661, 5287651.811902003],
              [-10920965.248426868, 5282865.076512979],
              [-10913210.064781262, 5276150.034888847],
              [-10903760.487166293, 5276970.993297279],
              [-10898734.85743494, 5281408.0490718745],
              [-10895605.221270777, 5289572.474391872],
              [-10893497.94331006, 5291460.117291414],
              [-10887195.812977782, 5290383.370158247],
              [-10876028.909578344, 5288226.299280056],
              [-10868727.696884098, 5289442.809730268],
              [-10864699.925000314, 5290113.974910262],
              [-10855425.675583344, 5289737.836769467],
              [-10851971.306698995, 5289168.603826988],
              [-10852013.73319053, 5226904.394191816],
              [-10890879.040969659, 5226769.544925032],
              [-10942732.105059128, 5226653.25029029],
              [-10943311.523008706, 5228841.971243545],
              [-10943279.129036887, 5275695.460413222],
              [-10943845.745245023, 5279245.759575907],
              [-10943617.297217367, 5294710.275547218],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adjuntas',
        GEOID: '72001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7439756.751495713, 2064239.872226886],
              [-7438064.583916164, 2064526.6641831968],
              [-7434104.949628648, 2066860.5295588258],
              [-7424312.062704073, 2062950.9404390205],
              [-7421725.443016, 2055444.9218972588],
              [-7424349.911330943, 2052832.990691765],
              [-7430533.486405527, 2050857.0142061326],
              [-7432696.535431132, 2053354.132055439],
              [-7435870.031474667, 2053173.974247987],
              [-7439184.012715582, 2057601.887693766],
              [-7439756.751495713, 2064239.872226886],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Decatur',
        GEOID: '19053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10465679.996989928, 4997165.602905701],
              [-10414666.39318053, 4997351.753887229],
              [-10414706.097978836, 4950537.844466349],
              [-10419209.564238787, 4950513.882653876],
              [-10438912.246265817, 4950225.799390103],
              [-10446324.54316723, 4950117.42249446],
              [-10465756.696119083, 4949719.176743231],
              [-10465679.996989928, 4997165.602905701],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Perry',
        GEOID: '39127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9179718.35254094, 4855830.4424297875],
              [-9174803.93098089, 4854678.880550066],
              [-9154244.111587297, 4853345.45353834],
              [-9146274.8605609, 4852781.047025274],
              [-9147127.790499356, 4839928.245732153],
              [-9136317.220789948, 4839272.714967304],
              [-9136729.659503339, 4832714.419521818],
              [-9137128.739877833, 4826447.0195674645],
              [-9130894.291795956, 4826014.685632919],
              [-9132458.664600072, 4803568.882924321],
              [-9133489.037806856, 4800882.481341415],
              [-9145915.96652258, 4801712.510442372],
              [-9157538.277958853, 4802515.750728499],
              [-9157358.830939693, 4806625.369698562],
              [-9170487.406405888, 4807513.22857372],
              [-9169890.845254727, 4815927.818751337],
              [-9172346.8871801, 4841712.151374702],
              [-9180785.795138158, 4842316.087510343],
              [-9179718.35254094, 4855830.4424297875],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tattnall',
        GEOID: '13267',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9154112.086671218, 3805236.2211036165],
              [-9131018.969625644, 3799974.2841236996],
              [-9125976.41933169, 3774013.7922776043],
              [-9115834.87976195, 3769927.967404254],
              [-9101674.706574574, 3769599.890109953],
              [-9108651.099062588, 3765264.279470818],
              [-9126126.478005279, 3736375.9000274674],
              [-9124753.129447361, 3735687.7876618686],
              [-9126299.24585499, 3735108.933926862],
              [-9133606.368550152, 3740632.876879483],
              [-9140645.767869955, 3750255.076217218],
              [-9153249.805895533, 3751905.6397003955],
              [-9148450.15473049, 3785113.252739225],
              [-9154112.086671218, 3805236.2211036165],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Walker',
        GEOID: '48471',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10671426.91376554, 3615115.7317581386],
              [-10655112.931070296, 3621248.7332453104],
              [-10643950.369131, 3621091.8681280543],
              [-10644132.821776409, 3623715.889330787],
              [-10623751.22488758, 3640296.575373994],
              [-10623701.576394685, 3624622.6564347497],
              [-10619511.733400207, 3614283.3141099107],
              [-10611806.53220597, 3614522.049786248],
              [-10615332.688396338, 3568547.9282182525],
              [-10642028.772080926, 3569146.5368527286],
              [-10667773.519397195, 3584826.99293872],
              [-10671426.91376554, 3615115.7317581386],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Manassas Park',
        GEOID: '51685',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8624251.79328154, 4691405.566819628],
              [-8621124.049548721, 4688850.065455457],
              [-8620618.43642154, 4690703.225549572],
              [-8618419.65383939, 4687678.199267024],
              [-8619171.171721734, 4686437.806986736],
              [-8622662.484911485, 4689110.4984740075],
              [-8624562.152021872, 4690374.492782739],
              [-8624251.79328154, 4691405.566819628],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coshocton',
        GEOID: '39031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9148748.602285307, 4932470.878546499],
              [-9095818.967400374, 4930787.846736765],
              [-9096170.29171332, 4919973.724428436],
              [-9085454.90016854, 4919581.270604463],
              [-9086195.508740786, 4898154.464269166],
              [-9091562.889308874, 4887906.016235228],
              [-9096614.233842602, 4888079.329112021],
              [-9149026.678373309, 4890222.542831129],
              [-9148629.824388629, 4898928.060968567],
              [-9150006.957809232, 4900744.487246694],
              [-9148748.602285307, 4932470.878546499],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lawrence',
        GEOID: '17101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9785886.375757553, 4700223.372975981],
              [-9744380.24135431, 4700564.211948535],
              [-9742868.962291326, 4696860.429279405],
              [-9740338.336307123, 4687033.930175635],
              [-9745524.71138318, 4675597.046179018],
              [-9753827.141645525, 4670162.2408751715],
              [-9755789.926907193, 4662899.678164464],
              [-9756970.443732627, 4659783.604702094],
              [-9786350.911992632, 4660278.404873281],
              [-9785886.375757553, 4700223.372975981],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cowley',
        GEOID: '20035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10815059.335790358, 4505600.407564999],
              [-10745190.659269378, 4505721.180057836],
              [-10745099.7112454, 4481387.869257887],
              [-10745178.641693924, 4438922.514741895],
              [-10770142.70049171, 4438965.7284401925],
              [-10809195.13633486, 4438967.122292772],
              [-10814434.829764862, 4438963.545057124],
              [-10815059.335790358, 4505600.407564999],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pendleton',
        GEOID: '21191',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9410091.255750349, 4691912.002359901],
              [-9397380.684972083, 4694005.850860707],
              [-9393961.172853895, 4694823.995748327],
              [-9376697.305998005, 4703740.411049282],
              [-9376804.167654872, 4699160.533428073],
              [-9376013.535884261, 4697317.856515456],
              [-9372769.392711071, 4663682.431090128],
              [-9373696.238791415, 4661977.855490802],
              [-9395400.756508833, 4658925.738612665],
              [-9400770.252147248, 4654487.726275618],
              [-9403858.588780325, 4656380.6310610175],
              [-9410091.255750349, 4691912.002359901],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Alamosa',
        GEOID: '08003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11804244.33097939, 4495128.648102369],
              [-11804142.139686842, 4543937.271625042],
              [-11739447.927056404, 4544375.262107313],
              [-11744401.644396704, 4522731.041607928],
              [-11742593.927185712, 4519967.511667972],
              [-11744269.396841642, 4517473.488120379],
              [-11771294.652260507, 4488957.205616716],
              [-11804197.688112745, 4488978.912924225],
              [-11804244.33097939, 4495128.648102369],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hancock',
        GEOID: '39063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9337606.793834709, 5037127.269105224],
              [-9286389.252718177, 5036972.886818658],
              [-9286307.432892444, 5011145.366801442],
              [-9290485.364701407, 5011113.215860521],
              [-9296816.994698744, 4998356.2058479125],
              [-9296945.568710612, 4985553.366320221],
              [-9337485.900867706, 4985815.933788372],
              [-9337525.975884391, 5000612.034584604],
              [-9337606.793834709, 5037127.269105224],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sherman',
        GEOID: '31163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11043256.499552215, 5070652.203129726],
              [-10992973.15160242, 5070643.893257985],
              [-10992168.534322966, 5070657.8419753425],
              [-10992635.630906336, 5019223.489099896],
              [-11043735.507321099, 5019277.069596991],
              [-11043256.499552215, 5070652.203129726],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bennett',
        GEOID: '46007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11366924.375564124, 5371508.472511339],
              [-11268675.462782342, 5371398.638922341],
              [-11268650.905457104, 5311647.45301402],
              [-11363770.39596377, 5311841.030581445],
              [-11366709.862905366, 5331666.973184812],
              [-11366924.375564124, 5371508.472511339],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mellette',
        GEOID: '46095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11268664.219513772, 5432847.297884314],
              [-11267510.392991701, 5435137.063242763],
              [-11250429.307685398, 5440883.33719085],
              [-11235561.699134031, 5439350.71892844],
              [-11225602.946168173, 5428403.873801041],
              [-11220529.560375271, 5427460.180125476],
              [-11219850.845439905, 5423050.928654842],
              [-11213769.239018885, 5420306.784007893],
              [-11197394.141923195, 5429807.648462494],
              [-11169683.047121553, 5421742.287120039],
              [-11163121.653695216, 5418639.779907957],
              [-11157646.627179531, 5421266.995515143],
              [-11157662.879825186, 5385010.745565406],
              [-11155796.051964583, 5371572.657595111],
              [-11160011.832400415, 5371585.065741244],
              [-11268675.462782342, 5371398.638922341],
              [-11268664.219513772, 5432847.297884314],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lac qui Parle',
        GEOID: '27073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10737605.738616295, 5663953.766340324],
              [-10721337.45274067, 5661217.632990167],
              [-10698205.373873316, 5649378.364517944],
              [-10690756.318827394, 5645515.117647969],
              [-10667147.235941993, 5619456.876714347],
              [-10664883.776735693, 5613527.136237504],
              [-10657360.248950431, 5611457.90713666],
              [-10657428.487798287, 5604453.224534102],
              [-10669689.550472729, 5604503.506977864],
              [-10669862.874919895, 5590929.233085252],
              [-10737302.617542954, 5590961.115329271],
              [-10737415.005487103, 5617955.664017848],
              [-10737605.738616295, 5663953.766340324],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Garden',
        GEOID: '31069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11430016.144124592, 5161770.694874565],
              [-11362007.504975276, 5162356.909986296],
              [-11362148.658089602, 5122425.071133658],
              [-11352976.48864569, 5122453.566848176],
              [-11352877.08034041, 5070737.0829439685],
              [-11360739.130697178, 5070803.859546559],
              [-11360770.188835109, 5045074.92130519],
              [-11422538.925247498, 5045084.83719922],
              [-11422424.600130454, 5070796.885079777],
              [-11425464.624104528, 5077319.175717012],
              [-11425440.245136043, 5122580.232070932],
              [-11428601.050757628, 5122627.676013065],
              [-11430016.144124592, 5161770.694874565],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Smith',
        GEOID: '20183',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11028090.037118545, 4866253.773867553],
              [-10990169.566212501, 4866281.786161016],
              [-10977632.991812635, 4866291.047091921],
              [-10965465.769647388, 4866288.12273168],
              [-10965556.051575962, 4803305.047965164],
              [-11025571.951286323, 4803367.431958484],
              [-11028001.165214414, 4803380.428672682],
              [-11028090.037118545, 4866253.773867553],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Amherst',
        GEOID: '51009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8832671.157072628, 4531593.819487179],
              [-8820159.959502371, 4553018.747836351],
              [-8813401.307938349, 4551647.243812319],
              [-8809597.854896415, 4553203.338409472],
              [-8802189.876742596, 4548154.62776291],
              [-8801737.696970992, 4539982.253086289],
              [-8792683.192228848, 4536505.5029298635],
              [-8779684.192649936, 4514939.204096666],
              [-8788667.341598483, 4509472.272545567],
              [-8796653.958465446, 4499107.812752261],
              [-8801869.165289618, 4493023.416544924],
              [-8803715.621683408, 4494291.128736656],
              [-8807629.169701736, 4494755.210185688],
              [-8814912.024747903, 4504236.518405175],
              [-8832274.303087948, 4511559.475476286],
              [-8842880.49021226, 4525469.16259766],
              [-8832671.157072628, 4531593.819487179],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dallas',
        GEOID: '19049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10495239.4406167, 5140479.399254813],
              [-10482303.893147541, 5140516.020397377],
              [-10443518.29012382, 5140542.178442265],
              [-10443358.101376569, 5101316.319948354],
              [-10440723.169029493, 5088144.92237603],
              [-10452544.742354285, 5086834.125150108],
              [-10490926.144306934, 5086920.485407098],
              [-10490899.761587616, 5101392.9852572745],
              [-10495207.937200807, 5101443.7484489875],
              [-10495239.4406167, 5140479.399254813],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clinton',
        GEOID: '39027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9351592.19542154, 4758274.011211118],
              [-9348277.434944188, 4803531.191790232],
              [-9314123.613293393, 4800800.045260509],
              [-9304697.858049456, 4800057.284898916],
              [-9303881.997501433, 4797015.212846766],
              [-9305293.973922653, 4776068.370110229],
              [-9326880.492979832, 4759398.285698932],
              [-9330117.6637721, 4753671.256626316],
              [-9335884.681312136, 4757162.080447951],
              [-9350071.34853832, 4758154.2589278435],
              [-9351592.19542154, 4758274.011211118],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tripp',
        GEOID: '46123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11157646.627179531, 5421266.995515143],
              [-11144769.633762527, 5416890.71929891],
              [-11132720.523398554, 5419862.055892615],
              [-11129885.772565505, 5417150.109264978],
              [-11113895.840907957, 5417450.610490051],
              [-11103655.672269376, 5420718.576998031],
              [-11093725.751051633, 5429311.902156883],
              [-11090046.975839388, 5425666.303294486],
              [-11090045.97396397, 5388367.634296515],
              [-11080127.741292764, 5388358.733358537],
              [-11080080.320838217, 5311697.490312079],
              [-11115255.274529526, 5311693.458639113],
              [-11154036.27021385, 5311663.913226846],
              [-11155754.752433497, 5331534.271749566],
              [-11155796.051964583, 5371572.657595111],
              [-11157662.879825186, 5385010.745565406],
              [-11157646.627179531, 5421266.995515143],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montmorency',
        GEOID: '26119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9391648.510432664, 5652863.009636543],
              [-9378292.397927288, 5652861.429852188],
              [-9353294.270435767, 5652813.562517914],
              [-9337615.031477025, 5653389.725218227],
              [-9338423.099660696, 5598979.767694203],
              [-9392218.800183998, 5598729.139973659],
              [-9391648.510432664, 5652863.009636543],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Buffalo',
        GEOID: '31019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11068050.133139146, 5019198.544010627],
              [-11043735.507321099, 5019277.069596991],
              [-10992635.630906336, 5019223.489099896],
              [-10989679.987106284, 5019228.507646307],
              [-10989619.3179838, 4968030.855204459],
              [-10989948.489718076, 4966690.232795952],
              [-11010176.24307063, 4961252.399251535],
              [-11040583.384619797, 4962399.74345183],
              [-11062489.724574022, 4962945.802673774],
              [-11067084.993153969, 4963909.001541798],
              [-11068090.987392267, 4968158.452215696],
              [-11068050.133139146, 5019198.544010627],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'La Plata',
        GEOID: '08067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12054838.75364987, 4459473.398596373],
              [-12054834.7461482, 4470317.5040271375],
              [-12046960.561966939, 4479244.81059803],
              [-12044521.329284677, 4488696.8614666],
              [-12034288.95301045, 4492496.789319508],
              [-12026780.675995424, 4502288.75355361],
              [-12025053.66541526, 4521749.8430425655],
              [-12019174.994425954, 4528635.913026955],
              [-11964861.435631482, 4528623.823294842],
              [-11964856.092295924, 4498186.854685138],
              [-11964812.232322486, 4439107.425687349],
              [-12022574.35771631, 4439106.9266376905],
              [-12064728.816934396, 4439046.110309965],
              [-12054838.75364987, 4459473.398596373],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stokes',
        GEOID: '37169',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8954551.143010618, 4376649.323043629],
              [-8953605.312285716, 4376597.181843208],
              [-8938425.563882165, 4375731.69823234],
              [-8911509.851667952, 4375546.919485728],
              [-8908602.617574245, 4375526.961257087],
              [-8909468.692659054, 4336067.443440427],
              [-8955841.832175244, 4336663.5600793455],
              [-8954551.143010618, 4376649.323043629],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Floyd',
        GEOID: '51063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8968817.67730007, 4433626.388022993],
              [-8966109.608047543, 4436965.878176751],
              [-8963446.95714726, 4440671.24419091],
              [-8944282.638890253, 4442117.000512864],
              [-8925388.047759436, 4454925.094096842],
              [-8919883.187620219, 4456251.474875975],
              [-8920544.981992984, 4434181.294489173],
              [-8931769.994166616, 4421298.313973664],
              [-8948629.77632522, 4410942.827414849],
              [-8956607.264993938, 4402699.883659008],
              [-8957231.544698307, 4398583.2306740135],
              [-8976134.373471439, 4429602.060102227],
              [-8968817.67730007, 4433626.388022993],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nevada',
        GEOID: '05099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10406490.755818201, 3958666.793546273],
              [-10405167.167072667, 4005357.9533577873],
              [-10403553.257095145, 4023007.7612535614],
              [-10399365.863129467, 4021928.3820615355],
              [-10394280.009553595, 4023039.031623105],
              [-10382154.9792969, 4006303.7677940703],
              [-10368217.111132639, 4003963.8971513235],
              [-10364322.153469272, 3998899.208114183],
              [-10365665.891042637, 3955575.5184527515],
              [-10377346.533892086, 3953912.528399229],
              [-10393409.3798161, 3954448.1545405844],
              [-10406588.383011624, 3954816.903856106],
              [-10406490.755818201, 3958666.793546273],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Johnson',
        GEOID: '18081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9601293.279178403, 4812846.517994609],
              [-9568141.778222714, 4813525.901216195],
              [-9568133.429260904, 4771552.627684725],
              [-9583005.26795292, 4771094.298790582],
              [-9601493.542942341, 4770731.997666988],
              [-9601293.279178403, 4812846.517994609],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tate',
        GEOID: '28137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10044491.460305007, 4123503.8243398773],
              [-10041040.222131943, 4126493.4301682687],
              [-10037843.571634324, 4131179.6007280755],
              [-10022099.43341245, 4124263.2028708463],
              [-10008980.542741952, 4133008.433210837],
              [-9987967.875659814, 4132982.0067829834],
              [-9987844.422344524, 4121224.1022147173],
              [-9981927.791408863, 4121236.6923509017],
              [-9981845.97158313, 4103485.1023071166],
              [-9987733.993409658, 4103472.53206292],
              [-10040865.673170378, 4103492.941821365],
              [-10045467.620919773, 4113203.539209554],
              [-10044491.460305007, 4123503.8243398773],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '47089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9318471.084686834, 4313457.821831154],
              [-9313819.043166583, 4311715.692168683],
              [-9312980.362122947, 4313136.704513391],
              [-9314573.45535569, 4317835.941353739],
              [-9299752.600990456, 4325691.483017856],
              [-9291514.736032771, 4324684.870627624],
              [-9286927.705095144, 4321907.967142018],
              [-9270075.047383951, 4318633.381350319],
              [-9265631.618589446, 4312336.501204624],
              [-9268314.306998074, 4300758.283373548],
              [-9270317.278595915, 4301674.326532578],
              [-9272527.415766127, 4287491.412093982],
              [-9274113.829829423, 4286299.390043145],
              [-9292383.473338922, 4290016.748098792],
              [-9314468.815034345, 4305918.279305213],
              [-9318471.084686834, 4313457.821831154],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Aguada',
        GEOID: '72003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7485025.530129841, 2081351.157691331],
              [-7483646.909769759, 2081869.563741636],
              [-7476235.912394761, 2086251.6058243138],
              [-7473123.433027107, 2083176.8240253225],
              [-7472480.451648287, 2081043.302449945],
              [-7472896.007307417, 2074795.1183110126],
              [-7478760.874679861, 2074220.4280385107],
              [-7483712.810908308, 2078411.666842383],
              [-7485025.530129841, 2081351.157691331],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'DeKalb',
        GEOID: '18033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9483762.049479375, 5090303.86072139],
              [-9440444.758697465, 5090854.163933776],
              [-9440366.289741125, 5075388.46820541],
              [-9440352.902725047, 5072752.455992873],
              [-9440305.099087428, 5052434.914376411],
              [-9483540.523692697, 5051390.887470606],
              [-9483762.049479375, 5090303.86072139],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Vega Alta',
        GEOID: '72143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7389060.296915584, 2077881.5574435224],
              [-7385795.852848072, 2087886.8999154964],
              [-7385992.924268609, 2093716.7469360833],
              [-7382205.131353045, 2093189.7202450694],
              [-7382154.734090769, 2093191.7379624434],
              [-7380474.001951719, 2087227.0054361918],
              [-7380890.002888814, 2082553.4483427326],
              [-7382571.038519284, 2080598.5147697309],
              [-7384738.985602482, 2080659.8601687835],
              [-7387748.285397095, 2076589.5325034782],
              [-7389060.296915584, 2077881.5574435224],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carolina',
        GEOID: '72031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7346285.309988771, 2091481.7978603742],
              [-7339338.555796845, 2087762.6400418717],
              [-7338100.46042024, 2084772.537508291],
              [-7336152.814609321, 2074587.6838507066],
              [-7338017.750038581, 2069191.1455364416],
              [-7340677.617951595, 2071927.340103672],
              [-7340285.662024513, 2073768.2856916562],
              [-7347036.966502144, 2082082.8206439766],
              [-7346130.714527596, 2084254.110377973],
              [-7350907.082940557, 2090883.0861684873],
              [-7346285.309988771, 2091481.7978603742],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fountain',
        GEOID: '18045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9733796.201152693, 4860302.084495292],
              [-9730065.662377229, 4884488.731741943],
              [-9733637.682197804, 4890049.77507813],
              [-9712057.619671091, 4910984.23121746],
              [-9695053.56745242, 4919361.234462075],
              [-9695099.765041098, 4897206.577455493],
              [-9694926.440593934, 4859116.023277697],
              [-9731574.486755442, 4859035.137522456],
              [-9733796.201152693, 4860302.084495292],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '39111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9051787.544692513, 4846992.251275239],
              [-9043296.650532255, 4846753.952765556],
              [-8997223.97398643, 4844173.223119576],
              [-8997317.248055002, 4843756.6361425705],
              [-8997394.392462121, 4837079.471645328],
              [-9002399.76204615, 4831641.991640822],
              [-8998569.112874214, 4825228.195957899],
              [-8997928.169420475, 4824155.443431873],
              [-9001914.631705273, 4817054.521857201],
              [-9010620.595121743, 4808985.173393696],
              [-9021038.21170263, 4799039.123194236],
              [-9020974.309640933, 4803957.066537825],
              [-9048390.519111466, 4808821.902248423],
              [-9048113.66753786, 4823471.430170798],
              [-9051787.544692513, 4846992.251275239],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cherry',
        GEOID: '31031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11363777.267034661, 5311841.044564907],
              [-11363770.39596377, 5311841.030581445],
              [-11268650.905457104, 5311647.45301402],
              [-11243316.32618218, 5311595.895316113],
              [-11154036.40248467, 5311663.913126071],
              [-11154043.549221024, 5288576.261929014],
              [-11152350.60240504, 5278697.757294866],
              [-11152339.136497488, 5226127.905977476],
              [-11150606.782581763, 5173847.745207848],
              [-11161740.624092435, 5173892.594620099],
              [-11226139.72875278, 5174195.4461841425],
              [-11290752.678154936, 5174799.678103199],
              [-11355278.687034784, 5175421.350988185],
              [-11359072.010003056, 5175482.260313784],
              [-11362015.07470065, 5228538.878053341],
              [-11364045.87617119, 5279380.907041706],
              [-11363777.267034661, 5311841.044564907],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Colquitt',
        GEOID: '13071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9352379.112901958, 3646059.5656345054],
              [-9351167.622883653, 3647455.5501685264],
              [-9350773.774525227, 3676327.6892353143],
              [-9324018.802830009, 3675970.4624329875],
              [-9319014.769079871, 3674164.286985567],
              [-9312330.70157468, 3675766.6353841717],
              [-9296580.886058774, 3675342.310653739],
              [-9296286.334686134, 3659527.517554502],
              [-9303510.524360655, 3642900.6232744264],
              [-9303410.559457922, 3637149.238832448],
              [-9321466.469545102, 3637643.4461640813],
              [-9351268.700981293, 3638150.5358809237],
              [-9351240.982428087, 3642790.794330874],
              [-9352379.112901958, 3646059.5656345054],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '28025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9911274.980394734, 3993867.2754931566],
              [-9899820.87270905, 3995859.646831006],
              [-9899773.22796699, 4003636.176530089],
              [-9876262.885469925, 4003496.301898236],
              [-9876223.589689672, 3985948.198347378],
              [-9850770.610758774, 3985075.0879188436],
              [-9853324.16855808, 3981929.791094005],
              [-9848737.471578926, 3965124.7620182186],
              [-9854466.974450564, 3968663.6515044975],
              [-9870838.398003059, 3962683.6432259097],
              [-9870869.122182518, 3970558.681534106],
              [-9881897.544135408, 3970568.968391668],
              [-9909506.670283483, 3970155.096608654],
              [-9909476.614020968, 3978575.0596856247],
              [-9911322.402497811, 3982531.981285237],
              [-9911274.980394734, 3993867.2754931566],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coffee',
        GEOID: '47031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9604635.090292018, 4216659.7788133705],
              [-9602150.995854964, 4220077.227896635],
              [-9599588.977774357, 4225580.917390795],
              [-9600767.851181861, 4250090.657080894],
              [-9600794.679179141, 4257898.358940614],
              [-9596535.70678088, 4259939.506806528],
              [-9583371.39775814, 4252132.951173079],
              [-9571813.317668056, 4253952.982356809],
              [-9567708.96804251, 4242082.540176819],
              [-9559779.680713303, 4235333.628159569],
              [-9558972.614405053, 4215691.712559551],
              [-9563857.424980553, 4203250.551228452],
              [-9576486.287252577, 4210705.948406013],
              [-9591066.691517698, 4213267.823915514],
              [-9602585.030549569, 4209306.108356901],
              [-9604635.090292018, 4216659.7788133705],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gillespie',
        GEOID: '48171',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11054470.268457277, 3567961.7509388668],
              [-11016647.912987389, 3567787.3371457164],
              [-10975174.500858465, 3567967.3063809476],
              [-10974754.492419703, 3521423.6184041016],
              [-11011740.393235767, 3521338.147755797],
              [-11054135.419428969, 3520824.306219912],
              [-11054216.682657247, 3540449.8866227535],
              [-11054470.268457277, 3567961.7509388668],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wilkes',
        GEOID: '13317',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9237995.441805108, 4000023.4297718904],
              [-9225556.824542848, 4018302.076806705],
              [-9214972.456038734, 4024925.3435558947],
              [-9208836.970984172, 4026717.1856423146],
              [-9200049.521700442, 4026679.9981672093],
              [-9195623.01346854, 4010011.1270842426],
              [-9191906.055670949, 4010869.2448956263],
              [-9194269.368460491, 4005639.0898168655],
              [-9181577.94463464, 3980502.473421274],
              [-9184662.051127069, 3983238.3879976952],
              [-9200523.074814277, 3976389.3274833164],
              [-9203892.715800589, 3975189.6302024713],
              [-9218696.31564475, 3982682.299718016],
              [-9226127.782211129, 3977990.722364963],
              [-9233845.562507825, 3993051.12157702],
              [-9237995.441805108, 4000023.4297718904],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Meade',
        GEOID: '20119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11204600.85443766, 4505502.780643502],
              [-11156019.581502095, 4505550.752379245],
              [-11143887.872075954, 4505501.097428691],
              [-11142138.041000174, 4493172.625386944],
              [-11141910.141493931, 4439313.008220717],
              [-11193473.469457457, 4439209.237267111],
              [-11202450.494293123, 4439130.986141301],
              [-11202516.730931029, 4492371.545868438],
              [-11204610.427913869, 4493275.60173938],
              [-11204600.85443766, 4505502.780643502],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fulton',
        GEOID: '42057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8725274.794961123, 4825727.844333652],
              [-8716205.143581, 4840616.722679207],
              [-8703128.442997513, 4874508.798238705],
              [-8705951.616603522, 4878486.004208385],
              [-8697933.16236219, 4889967.762437423],
              [-8674633.658980686, 4881063.45788023],
              [-8667835.26635845, 4874893.2111809105],
              [-8674120.69876711, 4866007.672492282],
              [-8683220.844500482, 4840776.0212834915],
              [-8693937.64937607, 4825693.406408801],
              [-8721057.560184678, 4825721.166605431],
              [-8721084.334589906, 4825721.209001011],
              [-8725274.794961123, 4825727.844333652],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Edwards',
        GEOID: '17047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9812569.76902019, 4660133.462705788],
              [-9790983.138643522, 4660276.981069898],
              [-9793451.31439339, 4636077.299927189],
              [-9790674.11573708, 4620561.135991011],
              [-9795068.786594618, 4616180.078545521],
              [-9799204.194358097, 4615605.359034848],
              [-9812913.30096878, 4615667.167487778],
              [-9812569.76902019, 4660133.462705788],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mahaska',
        GEOID: '19123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10338399.294967733, 5087640.382555046],
              [-10325607.238322206, 5087680.816120836],
              [-10287256.226590542, 5087792.901231802],
              [-10287060.081647765, 5036257.496032078],
              [-10312677.81342504, 5036162.27230388],
              [-10338215.617807925, 5036127.968332924],
              [-10338399.294967733, 5087640.382555046],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stephens',
        GEOID: '48429',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11031311.361592643, 3856554.243826492],
              [-11031318.04076209, 3889602.7311938163],
              [-11015161.018548865, 3889586.943628178],
              [-10973387.37775327, 3889246.1231295886],
              [-10973432.684786024, 3860027.93558653],
              [-10973458.622227378, 3831125.3747172225],
              [-11031321.825624777, 3831073.229869594],
              [-11031311.361592643, 3856554.243826492],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lake',
        GEOID: '47095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9982914.416055763, 4334838.86787413],
              [-9974490.647548454, 4333434.04586623],
              [-9969137.84983366, 4338907.09292179],
              [-9975542.060138999, 4343235.176191124],
              [-9974286.932880303, 4347918.790567718],
              [-9968107.291165166, 4348096.574909754],
              [-9965620.821841538, 4348168.109871398],
              [-9964249.922312418, 4352808.244442027],
              [-9967807.359279698, 4358581.936496083],
              [-9965434.473013949, 4364370.359961876],
              [-9967461.712260785, 4369354.411207106],
              [-9953887.524872946, 4369506.599650608],
              [-9945861.536477137, 4369826.522122478],
              [-9947523.05562582, 4357084.381537108],
              [-9956925.879054658, 4333079.625665535],
              [-9961198.766389266, 4329922.514835614],
              [-9961790.09552436, 4326457.917332556],
              [-9977303.406289408, 4326170.52451943],
              [-9984537.899509493, 4331619.697275611],
              [-9982914.416055763, 4334838.86787413],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carter',
        GEOID: '29035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10154878.984321361, 4422930.2915296545],
              [-10154246.689613653, 4451128.357471059],
              [-10132051.364261327, 4452451.331165607],
              [-10126118.035402047, 4446578.339961841],
              [-10105533.614400988, 4446123.6271113735],
              [-10099986.45285527, 4446013.438900616],
              [-10094291.347706286, 4428865.38834874],
              [-10092363.516764728, 4422798.354639528],
              [-10092516.358425587, 4412858.2513635],
              [-10142978.485477597, 4414557.354155179],
              [-10155101.066705491, 4414836.461795107],
              [-10154878.984321361, 4422930.2915296545],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Meade',
        GEOID: '21163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9626008.209885344, 4585956.925160806],
              [-9621793.987922383, 4591689.775742252],
              [-9621741.48565283, 4591743.71703642],
              [-9616580.896168534, 4597047.12620724],
              [-9613151.283807082, 4598553.699522276],
              [-9609240.266306644, 4600272.014573937],
              [-9604496.052248018, 4593351.19245306],
              [-9596456.892581401, 4582516.619075823],
              [-9584136.830576835, 4580687.399189435],
              [-9577192.72074115, 4575242.627304159],
              [-9573181.39633393, 4578186.35889763],
              [-9570798.751828967, 4561894.357975277],
              [-9574303.534677101, 4553808.987583139],
              [-9590317.177386187, 4551052.850049701],
              [-9600502.020237844, 4562064.862148896],
              [-9627805.960342651, 4585596.094284625],
              [-9626008.209885344, 4585956.925160806],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kalamazoo',
        GEOID: '26077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9547282.398079397, 5224210.337817056],
              [-9522624.462951742, 5224318.610110071],
              [-9495427.775517058, 5224079.749207861],
              [-9494843.014231918, 5171703.769873782],
              [-9547087.143692546, 5171369.956096691],
              [-9547282.398079397, 5224210.337817056],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '29139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10202116.408364069, 4679274.208769116],
              [-10200649.996711848, 4730134.514998414],
              [-10200160.190952359, 4742872.428810499],
              [-10175607.00746554, 4742110.106797035],
              [-10159042.55591601, 4741723.011047023],
              [-10159493.956451178, 4720634.844208407],
              [-10159565.200925285, 4699326.612650786],
              [-10176363.868683442, 4699536.287970067],
              [-10176676.119855117, 4680184.6120923655],
              [-10192210.532156337, 4675457.590237116],
              [-10201359.547146166, 4679330.6964885285],
              [-10202116.408364069, 4679274.208769116],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '19185',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10414666.39318053, 4997351.753887229],
              [-10363576.869478412, 4997374.72846382],
              [-10363543.051034534, 4951148.175642479],
              [-10367830.05326315, 4951006.072505001],
              [-10391167.07131305, 4950663.090666035],
              [-10394389.131460028, 4950645.946668583],
              [-10414706.097978836, 4950537.844466349],
              [-10414666.39318053, 4997351.753887229],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Faribault',
        GEOID: '27043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10491541.741091022, 5441941.549769119],
              [-10438179.407345375, 5441943.093341873],
              [-10424879.956460813, 5441971.340768961],
              [-10424907.010567306, 5388317.987072279],
              [-10460777.15265692, 5388328.654390019],
              [-10491635.743894951, 5388416.202370332],
              [-10491541.741091022, 5441941.549769119],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Macon',
        GEOID: '01087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9576037.89234366, 3818566.401839156],
              [-9557070.498265866, 3825923.1077112104],
              [-9560802.261555731, 3828206.935817026],
              [-9550895.717431057, 3828363.0693106465],
              [-9551054.792983402, 3839831.630062034],
              [-9541488.997820042, 3839930.0520832706],
              [-9539618.830374716, 3841792.82655381],
              [-9516630.68760896, 3828719.5576206013],
              [-9510978.663102914, 3828739.7514661094],
              [-9510474.385809619, 3817229.547520473],
              [-9510418.503425242, 3794151.388506816],
              [-9557470.469196288, 3793799.6177245732],
              [-9562181.62136615, 3803451.604145168],
              [-9562198.319289768, 3799461.3183055124],
              [-9564491.946078075, 3799381.663115302],
              [-9572505.836220281, 3807510.022018595],
              [-9576037.89234366, 3818566.401839156],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lawrence',
        GEOID: '18093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9649491.056468187, 4708029.414901123],
              [-9649426.936441489, 4720583.569154775],
              [-9608817.252241628, 4720363.862783445],
              [-9604688.968925562, 4720386.4920332655],
              [-9604120.34896659, 4687893.488160881],
              [-9607991.372939434, 4683514.5103235645],
              [-9607840.646348901, 4677092.6812419435],
              [-9649518.775021393, 4676873.056717963],
              [-9649491.056468187, 4708029.414901123],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oakland',
        GEOID: '26125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9316259.611682735, 5292397.24611276],
              [-9289985.985465707, 5293790.050328215],
              [-9250971.509568917, 5295038.114305268],
              [-9249697.79195526, 5254946.276771171],
              [-9249525.358064022, 5250227.41983128],
              [-9249189.395840809, 5241428.395312708],
              [-9248801.00213743, 5228197.928691374],
              [-9256436.739969412, 5228025.044909693],
              [-9262177.708748603, 5227835.117769084],
              [-9274786.533512285, 5227425.557933835],
              [-9287800.783861436, 5226958.99813343],
              [-9300955.74204695, 5226389.744913868],
              [-9313523.823877, 5225788.400966659],
              [-9315524.457765538, 5265750.211622445],
              [-9315937.787034852, 5279040.23601327],
              [-9316259.611682735, 5292397.24611276],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Armstrong',
        GEOID: '48011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11312614.045034884, 4188793.941434583],
              [-11252873.327105764, 4188660.873368407],
              [-11253370.70259063, 4129721.1937323366],
              [-11295762.61183809, 4129614.9775350927],
              [-11313317.138938734, 4129640.312174257],
              [-11312614.045034884, 4188793.941434583],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Juneau',
        GEOID: '55057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10053563.108248733, 5462561.766257783],
              [-10053543.961296316, 5489490.9274852425],
              [-10053561.549775863, 5504017.8617633935],
              [-10027751.235279515, 5504058.422639093],
              [-10007932.024458172, 5504130.220492531],
              [-10010225.651246475, 5489059.286066127],
              [-10021643.24613918, 5479651.392823936],
              [-10013683.457269497, 5453377.263665691],
              [-10016603.033554532, 5450848.722251691],
              [-10003740.734310314, 5431985.9492666535],
              [-9995045.34624547, 5414076.383220814],
              [-9994809.460244479, 5410060.993736515],
              [-9994910.53834212, 5410060.686087109],
              [-10053530.825596403, 5410051.30278514],
              [-10053507.448503336, 5423981.538679612],
              [-10053562.996929241, 5462554.185776133],
              [-10053563.108248733, 5462561.766257783],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wells',
        GEOID: '18179',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9512119.687883545, 4961382.255608102],
              [-9499411.677453566, 4961500.521765964],
              [-9499563.405919516, 5000118.960133272],
              [-9470378.886337735, 5000228.120864148],
              [-9469779.764838286, 4948864.244796555],
              [-9484548.187723357, 4948717.994988314],
              [-9505631.320043167, 4948667.58473819],
              [-9511918.088285718, 4948672.127511735],
              [-9512119.687883545, 4961382.255608102],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Foster',
        GEOID: '38031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11050223.429883512, 6038521.326256555],
              [-10964979.305294164, 6038456.957259581],
              [-10964885.90824139, 5995537.214747734],
              [-11050271.742542515, 5995644.951499848],
              [-11050223.429883512, 6038521.326256555],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'District of Columbia',
        GEOID: '11001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8584932.301979976, 4712271.12956013],
              [-8576166.893955423, 4721033.8818413345],
              [-8571884.237695077, 4716735.486341343],
              [-8561514.465979757, 4706335.1415625075],
              [-8569318.407562329, 4698466.088675866],
              [-8575942.919139948, 4691870.298312257],
              [-8575949.638024257, 4698960.568712582],
              [-8575953.27185259, 4702797.317152405],
              [-8581641.80915162, 4707959.893355636],
              [-8584932.301979976, 4712271.12956013],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pope',
        GEOID: '17151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9874990.169731686, 4522970.73555094],
              [-9841991.28779787, 4523059.954805519],
              [-9842413.208569197, 4497983.278870246],
              [-9842712.860737193, 4498090.698426144],
              [-9847974.599108517, 4495085.908756016],
              [-9850321.881891387, 4486548.393098291],
              [-9853406.99025923, 4479739.151659289],
              [-9848630.493548272, 4469838.143269403],
              [-9843401.037829278, 4460021.701014214],
              [-9845608.392012218, 4452859.421007848],
              [-9849117.405001003, 4448620.464688261],
              [-9849971.924245603, 4448600.5520900125],
              [-9850706.206458243, 4448583.441368138],
              [-9850699.143645685, 4461342.575911953],
              [-9875224.385940315, 4486197.521568718],
              [-9874990.169731686, 4522970.73555094],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Alger',
        GEOID: '26003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9697748.789263593, 5861834.680154832],
              [-9682230.675307943, 5865139.513743391],
              [-9674080.307470022, 5855365.431087784],
              [-9663752.641711675, 5852703.183682531],
              [-9656983.303476537, 5857462.022990389],
              [-9650915.055394413, 5869743.04515702],
              [-9643315.830355411, 5866293.042797395],
              [-9635562.53914115, 5858807.913314062],
              [-9624675.381622078, 5869241.548584873],
              [-9594406.944158442, 5885781.102615699],
              [-9588871.137200782, 5888851.186663368],
              [-9572924.508825155, 5888971.403611185],
              [-9558404.344137248, 5891063.2664431995],
              [-9558440.50723906, 5861609.319005821],
              [-9614102.590345005, 5861786.256025254],
              [-9614106.597846672, 5833701.244876066],
              [-9641981.888897235, 5833916.6381908525],
              [-9642004.598073358, 5805816.134985221],
              [-9697724.12203655, 5805873.8308725115],
              [-9697748.789263593, 5861834.680154832],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Blaine',
        GEOID: '31009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11161740.624092435, 5173892.594620099],
              [-11150606.782581763, 5173847.745207848],
              [-11097101.51460994, 5173881.79474231],
              [-11097087.59967359, 5122160.557368139],
              [-11159915.207082406, 5122084.621037409],
              [-11161501.509826211, 5122090.439320436],
              [-11161740.624092435, 5173892.594620099],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Attala',
        GEOID: '28007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10007217.353327278, 3886361.41930166],
              [-9990862.071100948, 3923807.0562379244],
              [-9985526.8618657, 3933242.14056749],
              [-9979266.92162043, 3933262.9144240143],
              [-9957952.356079262, 3933319.7763878917],
              [-9942657.058044266, 3933268.374225802],
              [-9942818.137347443, 3909763.6997613194],
              [-9942963.7432414, 3886235.6847943463],
              [-9988715.052082019, 3886006.2360547925],
              [-9988699.689992288, 3880059.1104268692],
              [-10014956.173007736, 3879330.180851773],
              [-10007217.353327278, 3886361.41930166],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Eddy',
        GEOID: '38027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11053714.186475806, 6081407.3764055],
              [-10971245.813389389, 6081514.862406242],
              [-10967810.271264527, 6081318.635117525],
              [-10967772.64527664, 6052541.924418236],
              [-10964989.991965279, 6052528.037751464],
              [-10964979.305294164, 6038456.957259581],
              [-11050223.429883512, 6038521.326256555],
              [-11053726.876897756, 6052625.740845867],
              [-11053714.186475806, 6081407.3764055],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Antrim',
        GEOID: '26009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9510181.668426517, 5624142.982711473],
              [-9504531.48347413, 5628816.414632355],
              [-9502983.029357197, 5637529.114074668],
              [-9504509.776173426, 5650041.7992785005],
              [-9504215.925660843, 5654270.297429689],
              [-9486948.347264351, 5653940.961230036],
              [-9487056.772448383, 5640095.411981596],
              [-9446288.346654654, 5639913.365270473],
              [-9445159.233059537, 5599199.936373015],
              [-9498635.669283247, 5598048.899744101],
              [-9499207.851465924, 5592031.504489928],
              [-9504678.87047994, 5599440.369206355],
              [-9514904.456265228, 5599421.680860183],
              [-9510181.668426517, 5624142.982711473],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lipscomb',
        GEOID: '48295',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11192745.676663704, 4369571.981702225],
              [-11166571.4447149, 4369597.304436317],
              [-11132367.86251345, 4369599.222225938],
              [-11131994.27504062, 4369599.243172936],
              [-11131993.495804183, 4308285.148278696],
              [-11192086.20596319, 4308397.233189219],
              [-11192810.11661182, 4308403.429563298],
              [-11192745.676663704, 4369571.981702225],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clinton',
        GEOID: '19045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10118760.596297046, 5166006.097198429],
              [-10036529.940542221, 5165937.044052274],
              [-10034407.138953535, 5160380.1324940175],
              [-10036220.422139067, 5151723.751023758],
              [-10036359.686574573, 5150476.086119436],
              [-10037129.123142414, 5143585.669944259],
              [-10038947.63834401, 5137736.650264697],
              [-10038863.258169988, 5132856.287723105],
              [-10045734.481279334, 5128494.591740493],
              [-10046431.647710042, 5128052.157416316],
              [-10053342.027740017, 5122442.228229105],
              [-10053469.917183345, 5120401.3301130785],
              [-10071266.135550097, 5127126.369536627],
              [-10094047.66934094, 5125248.796716853],
              [-10118760.596297046, 5126796.349743178],
              [-10118772.952760523, 5152930.603760593],
              [-10118760.596297046, 5166006.097198429],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Vieques',
        GEOID: '72147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7299982.663021789, 2049634.2764394572],
              [-7292085.658344916, 2055418.445971624],
              [-7280090.537933977, 2056486.6478874108],
              [-7267822.684770593, 2054890.3404128067],
              [-7268187.033463961, 2049662.9701212705],
              [-7277447.03398611, 2050198.4367181922],
              [-7286014.29331705, 2047628.394673374],
              [-7296111.750368436, 2047052.3605594363],
              [-7299982.663021789, 2049634.2764394572],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gilchrist',
        GEOID: '12041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9233919.14469124, 3472020.3114581886],
              [-9230679.858828647, 3480965.035228985],
              [-9227647.849857911, 3481310.9741742103],
              [-9226137.355687337, 3489013.3566630417],
              [-9224296.576587578, 3492121.2668502326],
              [-9217306.93708016, 3494828.253822464],
              [-9213956.443046262, 3494312.2688906216],
              [-9213741.15115107, 3490317.911574955],
              [-9201508.140988305, 3481735.0700727594],
              [-9201257.33817555, 3447732.117331384],
              [-9212406.76441493, 3447432.1283445717],
              [-9214238.19267746, 3450300.7381143915],
              [-9223545.392663706, 3450219.324916501],
              [-9232541.2320342, 3451109.3936000606],
              [-9234494.889097624, 3450393.672674941],
              [-9233919.14469124, 3472020.3114581886],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wexford',
        GEOID: '26165',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9553194.019637974, 5545171.546193603],
              [-9499337.427353207, 5545067.57871081],
              [-9499423.922597554, 5491030.231504057],
              [-9525002.58123356, 5490990.3490916705],
              [-9553570.724794818, 5490887.307398674],
              [-9553194.019637974, 5545171.546193603],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pembina',
        GEOID: '38067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10903766.944978667, 6274948.7993648155],
              [-10884346.701930419, 6274958.790358265],
              [-10823487.111799337, 6274977.96433674],
              [-10823355.198202746, 6265680.634609406],
              [-10818847.649381546, 6252425.332868773],
              [-10814976.6254087, 6236364.424988155],
              [-10811488.429164693, 6226403.111020898],
              [-10809123.55790228, 6218702.0779608665],
              [-10813899.831974257, 6204522.503575183],
              [-10814435.119348958, 6197820.762036938],
              [-10814477.409382246, 6197291.520194346],
              [-10901200.918114483, 6197691.681141669],
              [-10903697.03505654, 6227094.854445696],
              [-10903766.944978667, 6274948.7993648155],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Alpena',
        GEOID: '26007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9338423.099660696, 5598979.767694203],
              [-9337615.031477025, 5653389.725218227],
              [-9282399.237032467, 5654184.91143804],
              [-9274686.23465108, 5643587.351423625],
              [-9269117.143165676, 5625748.515040716],
              [-9277394.971820552, 5628064.269103441],
              [-9283962.599138374, 5632605.668228221],
              [-9288726.739385854, 5629562.79284347],
              [-9288033.218958214, 5621523.375346668],
              [-9288370.96229328, 5612213.23010561],
              [-9278792.921985934, 5603618.105479493],
              [-9275195.966599423, 5602739.389008817],
              [-9274724.318003625, 5599287.008214192],
              [-9338423.322299676, 5598951.9721722035],
              [-9338423.099660696, 5598979.767694203],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lenawee',
        GEOID: '26091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9391279.263681704, 5171989.1554441415],
              [-9365527.280598532, 5171707.369007943],
              [-9325670.338795418, 5173335.066944918],
              [-9324471.188694643, 5119657.631280538],
              [-9337522.354144087, 5119157.650699898],
              [-9365800.45862894, 5118074.426719003],
              [-9390958.890795527, 5117183.433045464],
              [-9391279.263681704, 5171989.1554441415],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fond du Lac',
        GEOID: '55039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9894710.528845204, 5449235.967756425],
              [-9840998.651898468, 5448895.037474354],
              [-9841109.080833334, 5455883.466479493],
              [-9814110.43077277, 5455803.543088721],
              [-9814179.448857062, 5448668.581479427],
              [-9814023.490250459, 5394981.860531298],
              [-9840690.408228463, 5395072.316148756],
              [-9840758.869715298, 5408504.726396898],
              [-9894750.047264434, 5408905.688583382],
              [-9894710.528845204, 5449235.967756425],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Guayanilla',
        GEOID: '72059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7442588.935310856, 2031819.7425954281],
              [-7440225.406551953, 2033565.894243251],
              [-7435870.031474667, 2053173.974247987],
              [-7432696.535431132, 2053354.132055439],
              [-7432260.385666204, 2042111.5898286884],
              [-7428683.022510072, 2039596.2882592925],
              [-7433398.950518512, 2035726.3519054037],
              [-7434466.960612708, 2035011.7970440763],
              [-7440437.136223442, 2031688.8875548448],
              [-7442588.935310856, 2031819.7425954281],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Midland',
        GEOID: '26111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9418300.956876865, 5436913.808547633],
              [-9391655.412241094, 5436635.349955898],
              [-9369462.981195528, 5438539.526798878],
              [-9369553.038663581, 5398968.889715621],
              [-9369825.660096532, 5385622.560626756],
              [-9392011.63461163, 5383179.683843909],
              [-9418468.270071525, 5383173.855457152],
              [-9418300.956876865, 5436913.808547633],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Osborne',
        GEOID: '20141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11025571.951286323, 4803367.431958484],
              [-10965556.051575962, 4803305.047965164],
              [-10963565.436441598, 4803289.018807421],
              [-10963873.234833643, 4753202.245455686],
              [-10963856.314271042, 4740697.142684218],
              [-11024804.069438832, 4740757.99151159],
              [-11025938.081091542, 4740742.6357587995],
              [-11025571.951286323, 4803367.431958484],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rooks',
        GEOID: '20163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11087663.514222015, 4803265.336134838],
              [-11028001.165214414, 4803380.428672682],
              [-11025571.951286323, 4803367.431958484],
              [-11025938.081091542, 4740742.6357587995],
              [-11086505.791517764, 4740648.349077898],
              [-11087998.697208792, 4740666.144365853],
              [-11087663.514222015, 4803265.336134838],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Sebastián',
        GEOID: '72131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7463982.210401637, 2078442.863978052],
              [-7461430.767672654, 2083644.3097445085],
              [-7451540.698832616, 2081656.660990917],
              [-7449725.189257271, 2083624.131969522],
              [-7447151.482630129, 2080445.6799091813],
              [-7446532.434941827, 2080560.7458019825],
              [-7448383.67807372, 2073022.671485151],
              [-7448079.441905382, 2067193.6593082338],
              [-7450849.404794792, 2067228.4729709355],
              [-7462657.174502724, 2070403.3307875795],
              [-7462628.788032571, 2071486.0350918726],
              [-7464259.395933712, 2073473.3901828206],
              [-7463982.210401637, 2078442.863978052],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Germán',
        GEOID: '72125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7469592.601418126, 2050005.657764345],
              [-7467428.327878123, 2050043.1359124712],
              [-7468019.323054746, 2055093.240049888],
              [-7464134.495465042, 2057931.2342427352],
              [-7459946.99017987, 2056972.9688536348],
              [-7455940.7130257115, 2054386.8487272032],
              [-7455160.919992705, 2052493.0670078972],
              [-7456550.966474241, 2043696.6006166257],
              [-7465965.81240808, 2045313.1142028715],
              [-7470544.60570339, 2044114.2404819203],
              [-7469592.601418126, 2050005.657764345],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cuming',
        GEOID: '31039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10800145.640969802, 5174557.110679799],
              [-10778361.641135957, 5174532.209241114],
              [-10748510.317804324, 5174464.105639226],
              [-10748438.516732762, 5163357.738766408],
              [-10748472.580496946, 5122412.986589222],
              [-10787517.891892686, 5122524.135134334],
              [-10800207.089328721, 5122556.510187977],
              [-10800145.640969802, 5174557.110679799],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Manatí',
        GEOID: '72091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7407541.670096575, 2085057.5079850173],
              [-7405103.884567695, 2088120.637275656],
              [-7406559.547801946, 2093748.5617100282],
              [-7399439.058320206, 2092526.131188732],
              [-7395950.083663403, 2093984.1908518185],
              [-7397067.619207837, 2082921.4417878264],
              [-7396489.982370112, 2081022.6580796863],
              [-7398650.805005899, 2081074.9728316192],
              [-7406489.032991634, 2078712.732934978],
              [-7407541.670096575, 2085057.5079850173],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Golden Valley',
        GEOID: '38033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11582296.754750159, 5931289.41677471],
              [-11582212.8198541, 5962898.7525858665],
              [-11582270.740483774, 5996126.803878607],
              [-11540126.816567343, 5995999.703920545],
              [-11540156.093593419, 5938775.746546329],
              [-11533761.790722763, 5938794.184068598],
              [-11533724.498693349, 5881855.484854686],
              [-11555054.9829217, 5881817.552217498],
              [-11555061.216813186, 5867431.834033144],
              [-11582250.380533405, 5867461.439160097],
              [-11582279.289132712, 5883752.98399786],
              [-11582300.094334882, 5895496.578647311],
              [-11582296.754750159, 5931289.41677471],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Huntington',
        GEOID: '18069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9533828.769700086, 5012681.656766435],
              [-9499520.32527658, 5013116.068492163],
              [-9499563.405919516, 5000118.960133272],
              [-9499411.677453566, 4961500.521765964],
              [-9512119.687883545, 4961382.255608102],
              [-9533243.897095459, 4961312.118288608],
              [-9533828.769700086, 5012681.656766435],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Blackford',
        GEOID: '18009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9511918.088285718, 4948672.127511735],
              [-9505631.320043167, 4948667.58473819],
              [-9484548.187723357, 4948717.994988314],
              [-9484490.524227126, 4938258.289221898],
              [-9485145.08283299, 4935849.954014956],
              [-9485187.16160051, 4922196.950643341],
              [-9486635.984773185, 4921176.314371389],
              [-9511619.30677243, 4921191.804337319],
              [-9511918.088285718, 4948672.127511735],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Moody',
        GEOID: '46101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10785658.188479494, 5495778.100892749],
              [-10737036.04511269, 5495944.94125848],
              [-10737088.77905055, 5442182.790584228],
              [-10737088.779348116, 5442182.488094915],
              [-10743228.541924655, 5441887.987954861],
              [-10785596.740120575, 5442009.312856685],
              [-10785658.188479494, 5495778.100892749],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cedar',
        GEOID: '19031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10170841.197425697, 5140041.45115762],
              [-10170802.903520865, 5153104.969484596],
              [-10118772.952760523, 5152930.603760593],
              [-10118760.596297046, 5126796.349743178],
              [-10118925.349143421, 5100821.657334348],
              [-10170866.466950107, 5101006.241066696],
              [-10170841.197425697, 5140041.45115762],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '01089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9660709.280064123, 4162783.8273579357],
              [-9625551.243375638, 4162616.295977038],
              [-9608960.494317977, 4162668.824864519],
              [-9608127.071398713, 4162671.463617419],
              [-9602081.755131694, 4155428.227046123],
              [-9609718.383519601, 4155366.8488595174],
              [-9613443.690278998, 4114065.717889882],
              [-9609861.31774578, 4109573.996630209],
              [-9610676.287737878, 4097462.7258540373],
              [-9620666.098841667, 4093381.265681895],
              [-9632859.033987746, 4096516.5835917788],
              [-9634720.407193298, 4102349.241485091],
              [-9637914.052064667, 4107133.5000287504],
              [-9645432.347833863, 4102749.023298915],
              [-9650214.633158343, 4107819.024821789],
              [-9661424.839839697, 4103001.631101942],
              [-9660709.280064123, 4162783.8273579357],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Miami',
        GEOID: '18103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9592228.97832107, 5011765.989282472],
              [-9567513.491016675, 5012222.927256368],
              [-9566744.162015803, 4960998.414000831],
              [-9558424.81119086, 4961101.41589061],
              [-9558296.793776447, 4948466.385942842],
              [-9574959.540436348, 4948261.6744346265],
              [-9591846.595870197, 4948044.951588537],
              [-9592290.53799948, 4999051.577033841],
              [-9592228.97832107, 5011765.989282472],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Logan',
        GEOID: '39091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9351249.108750917, 4911520.724318702],
              [-9351101.27646714, 4936397.610325518],
              [-9350135.802523492, 4944023.772489308],
              [-9337471.318014413, 4944537.462185802],
              [-9335160.99330249, 4943357.495342799],
              [-9297429.140578618, 4939466.045585506],
              [-9300892.401256688, 4899329.900278836],
              [-9326814.035243828, 4903803.727009558],
              [-9352480.636277562, 4905760.533273428],
              [-9351249.108750917, 4911520.724318702],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tipton',
        GEOID: '18159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9600505.916420024, 4924666.556606463],
              [-9580227.178740684, 4925000.445308061],
              [-9558127.142872479, 4925247.653042722],
              [-9558147.06906133, 4921078.845050591],
              [-9558103.320501449, 4897808.654357436],
              [-9600498.235375157, 4897356.4372347295],
              [-9600525.953928366, 4920391.180380528],
              [-9600505.916420024, 4924666.556606463],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Louisa',
        GEOID: '19115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10183951.739134384, 5075061.599869122],
              [-10181323.374637265, 5075110.888217209],
              [-10171097.232254524, 5074962.133187098],
              [-10171187.512361556, 5062037.966637408],
              [-10138357.557534566, 5061677.493678775],
              [-10142784.789563615, 5049291.128444535],
              [-10139140.078115555, 5044021.526424645],
              [-10134697.428557483, 5036877.951806348],
              [-10129840.559174174, 5036349.467664099],
              [-10125314.308678519, 5028740.509230951],
              [-10124759.872657463, 5023075.506583804],
              [-10171340.91061987, 5023279.32039818],
              [-10171295.046989663, 5036154.731334335],
              [-10184143.431297531, 5036325.957147785],
              [-10183951.739134384, 5075061.599869122],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Polk',
        GEOID: '37149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9168178.862805817, 4197156.059188346],
              [-9157286.584590169, 4217444.39817906],
              [-9145109.456811784, 4219427.497683072],
              [-9124723.741101792, 4198965.649665162],
              [-9124787.237879336, 4189312.8933565533],
              [-9132612.174177876, 4189656.4029353424],
              [-9133585.132091695, 4189682.084856838],
              [-9152242.851704404, 4190174.5802678936],
              [-9161076.90193219, 4190407.774459722],
              [-9167513.536590606, 4190918.497785217],
              [-9168178.862805817, 4197156.059188346],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Taylor',
        GEOID: '19173',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10567387.717670146, 4997699.0292291455],
              [-10516439.013123881, 4997529.513722157],
              [-10516486.738808924, 4949262.773163233],
              [-10523463.161673447, 4949230.465057023],
              [-10534388.937893651, 4949380.0327291135],
              [-10555311.667989401, 4949666.459390041],
              [-10565878.099290261, 4949843.378832046],
              [-10567395.510034503, 4972215.848037086],
              [-10567387.717670146, 4997699.0292291455],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marquette',
        GEOID: '55077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9973998.170121185, 5462672.534825761],
              [-9926204.482582983, 5462786.089465111],
              [-9929509.224306162, 5436499.132004146],
              [-9926123.664632667, 5429246.2362685],
              [-9934749.700654747, 5428347.616285915],
              [-9934756.602463176, 5410373.570824415],
              [-9974175.947347982, 5410304.809111126],
              [-9973998.170121185, 5462672.534825761],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Decatur',
        GEOID: '20039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11214194.670185266, 4866271.131633797],
              [-11185050.480186583, 4866196.878634819],
              [-11153499.419550026, 4866170.866209297],
              [-11151741.4115989, 4866169.821913793],
              [-11152025.660811415, 4803202.08634482],
              [-11212122.823750053, 4803367.287550644],
              [-11214422.684429841, 4803368.587221285],
              [-11214194.670185266, 4866271.131633797],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lane',
        GEOID: '20101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11208537.556910073, 4678792.792035787],
              [-11159467.257451454, 4678528.05817513],
              [-11159154.783640798, 4616545.142742333],
              [-11208169.42335402, 4616807.004526002],
              [-11208537.556910073, 4678792.792035787],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yellow Medicine',
        GEOID: '27173',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10737302.617542954, 5590961.115329271],
              [-10669862.874919895, 5590929.233085252],
              [-10669689.550472729, 5604503.506977864],
              [-10657428.487798287, 5604453.224534102],
              [-10657360.248950431, 5611457.90713666],
              [-10630797.41469632, 5588437.1039790325],
              [-10629101.462254087, 5582642.254079926],
              [-10621644.280885335, 5579821.123434623],
              [-10615446.345596438, 5574186.976503705],
              [-10615471.169842886, 5549667.481187099],
              [-10641566.350916171, 5549752.290259337],
              [-10642588.709119618, 5563450.825674139],
              [-10697018.262823498, 5563535.450652115],
              [-10737188.646879781, 5563668.385719738],
              [-10737302.617542954, 5590961.115329271],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rolette',
        GEOID: '38079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11152287.927564487, 6274730.780243198],
              [-11122351.11283116, 6274700.030744435],
              [-11079150.25141994, 6274737.748266624],
              [-11079171.95214481, 6227211.444072103],
              [-11075510.320134148, 6227207.225895611],
              [-11075531.136878928, 6197979.208934577],
              [-11148185.917615483, 6198042.600871921],
              [-11148145.397320833, 6227294.289483294],
              [-11152324.331005214, 6227300.026262682],
              [-11152287.927564487, 6274730.780243198],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Norton',
        GEOID: '20137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11151741.4115989, 4866169.821913793],
              [-11111176.973664822, 4866145.725773457],
              [-11090566.48711867, 4866199.777392302],
              [-11090240.641296312, 4866200.6319351075],
              [-11090532.996736191, 4803281.076441471],
              [-11149945.767445432, 4803257.971412708],
              [-11152025.660811415, 4803202.08634482],
              [-11151741.4115989, 4866169.821913793],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Roseau',
        GEOID: '27135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10731800.928277781, 6274858.679141773],
              [-10683931.543485839, 6274858.679141773],
              [-10613307.341580845, 6274647.601073216],
              [-10610961.481847594, 6274650.713589811],
              [-10608863.244869396, 6258624.453517912],
              [-10601579.16530883, 6254769.826680637],
              [-10585533.351266906, 6261402.647666825],
              [-10585355.128762145, 6226313.525934785],
              [-10613504.154440567, 6226307.789822119],
              [-10613483.003737317, 6197201.897392366],
              [-10642401.024458138, 6196979.293017342],
              [-10729844.710866071, 6197890.763678391],
              [-10731747.049644237, 6226989.739556261],
              [-10731800.928277781, 6274858.679141773],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Barron',
        GEOID: '55005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10258635.206271157, 5722804.38189335],
              [-10244890.47742342, 5722833.99633751],
              [-10190218.915146558, 5722464.141273413],
              [-10190333.35158309, 5667643.460628757],
              [-10190434.874958694, 5654095.484011952],
              [-10204173.147275966, 5654325.061107841],
              [-10258810.757108137, 5654572.024985373],
              [-10258635.206271157, 5722804.38189335],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '13197',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9424010.310920669, 3828455.984891688],
              [-9421783.698465822, 3833725.2509544007],
              [-9415943.321381353, 3832153.00500459],
              [-9400302.376327442, 3837321.0220706216],
              [-9401282.099165915, 3833656.721614753],
              [-9394509.643985033, 3817784.1563624777],
              [-9394243.701721529, 3802391.155184607],
              [-9398643.493275642, 3793822.779268544],
              [-9398728.87532508, 3785154.2820845745],
              [-9398839.74953791, 3780920.7153692883],
              [-9409515.622663457, 3780986.181679854],
              [-9423119.087077377, 3793928.322781187],
              [-9424187.865508482, 3793915.0310905464],
              [-9424010.310920669, 3828455.984891688],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Runnels',
        GEOID: '48399',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11158124.410434013, 3774128.095555975],
              [-11148859.734493254, 3774163.04367206],
              [-11100108.476695249, 3774090.9140253416],
              [-11100968.642400606, 3707880.995467351],
              [-11144331.591566255, 3708339.3803215516],
              [-11157973.683843482, 3708591.4470757344],
              [-11158193.87379627, 3723075.3021866423],
              [-11158124.410434013, 3774128.095555975],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stewart',
        GEOID: '13259',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9467879.778008614, 3771485.4826930882],
              [-9467395.746623456, 3774787.26569049],
              [-9468696.626192866, 3781178.3760059145],
              [-9461907.91836633, 3787677.85695662],
              [-9454378.490648055, 3792098.9460056433],
              [-9453244.71810136, 3793651.3323890627],
              [-9443562.132325126, 3793651.700740431],
              [-9439820.238961602, 3793651.832338358],
              [-9424187.865508482, 3793915.0310905464],
              [-9423119.087077377, 3793928.322781187],
              [-9421093.18366443, 3787494.896997839],
              [-9423842.775087023, 3752854.353643562],
              [-9441019.149877446, 3754366.8896424845],
              [-9451804.672701422, 3753399.563495902],
              [-9459269.86907351, 3756776.5577605176],
              [-9466835.364306804, 3760115.785343861],
              [-9469235.584292576, 3762241.7793138865],
              [-9467879.778008614, 3771485.4826930882],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bell',
        GEOID: '48027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10898968.517046114, 3641761.9589925352],
              [-10892214.540900704, 3645822.171656168],
              [-10888811.058789192, 3647850.43818011],
              [-10844589.613710545, 3674403.661620766],
              [-10836220.614392707, 3664505.8893543105],
              [-10828950.004490525, 3669139.9304568297],
              [-10805803.899367334, 3630959.677350424],
              [-10826831.483261239, 3618419.367452318],
              [-10833112.685529249, 3600631.3890345944],
              [-10867555.26993916, 3615920.969580657],
              [-10890220.140903652, 3620571.853030323],
              [-10891539.610828023, 3623573.138274218],
              [-10899478.805591911, 3637284.8710556016],
              [-10898968.517046114, 3641761.9589925352],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rains',
        GEOID: '48379',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10680581.940007871, 3892633.276208002],
              [-10671367.023879495, 3892592.669155513],
              [-10650692.100132423, 3892595.1905043484],
              [-10649422.390020434, 3890053.4154577074],
              [-10646041.39444606, 3858247.6284699063],
              [-10648759.259813778, 3857064.9194430234],
              [-10660125.536421226, 3864856.5221850285],
              [-10667700.159852762, 3864413.4222393967],
              [-10679372.23110142, 3873717.1218101825],
              [-10685252.794522066, 3878911.5870745564],
              [-10680581.940007871, 3892633.276208002],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tazewell',
        GEOID: '51185',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9117165.592954893, 4458995.507681771],
              [-9101692.406373609, 4467290.306044338],
              [-9099149.983917011, 4472542.378889529],
              [-9092420.494665947, 4467365.776247478],
              [-9079287.243781138, 4467952.226077396],
              [-9076219.83521233, 4470293.738180119],
              [-9070708.295903664, 4474095.556913876],
              [-9064517.485062176, 4476950.409285175],
              [-9057193.775762888, 4486281.108017692],
              [-9041937.216910688, 4471895.955802687],
              [-9053407.131964063, 4458492.223383315],
              [-9047010.046106137, 4451995.807617205],
              [-9065495.315469304, 4440519.5697165495],
              [-9069704.194096707, 4441682.416373226],
              [-9092886.144095935, 4429762.769958104],
              [-9103768.626196394, 4433341.771138684],
              [-9116068.984651089, 4454887.1241686065],
              [-9117165.592954893, 4458995.507681771],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Covington',
        GEOID: '28031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9991492.36205782, 3733766.6759717334],
              [-9980129.091076626, 3734552.2389382203],
              [-9952099.065933859, 3736675.1769362427],
              [-9951870.972297223, 3689245.285429142],
              [-9957708.343755443, 3689245.285429142],
              [-9972759.072869165, 3689200.796394991],
              [-9972770.204818245, 3699610.6861332003],
              [-9991549.246317616, 3712192.690496703],
              [-9991492.36205782, 3733766.6759717334],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Otter Tail',
        GEOID: '27111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10717949.332718885, 5882012.404515035],
              [-10705848.12483322, 5882003.326441674],
              [-10706106.052093389, 5896141.650868332],
              [-10602958.747758228, 5895882.025101801],
              [-10593575.739198755, 5896106.903759471],
              [-10592666.258958975, 5881878.665991477],
              [-10592669.598543698, 5839660.842627929],
              [-10591581.005243232, 5825714.931403077],
              [-10591590.91267791, 5797474.282283546],
              [-10661039.803399112, 5797584.90935736],
              [-10716211.52414811, 5797771.1641584085],
              [-10717840.57357638, 5825691.092383417],
              [-10717949.332718885, 5882012.404515035],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shawano',
        GEOID: '55115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9932349.541113753, 5626126.846010439],
              [-9905395.307530016, 5626075.02538471],
              [-9905355.12119384, 5612512.357353746],
              [-9877996.018622084, 5612580.45658213],
              [-9878067.931013137, 5598939.09517967],
              [-9850567.007410113, 5598792.895489422],
              [-9823746.134576343, 5598367.971892104],
              [-9823130.98307022, 5571226.164532435],
              [-9824196.644555585, 5569315.748957745],
              [-9823411.174228547, 5556383.434934045],
              [-9863584.040746534, 5557285.179286305],
              [-9863481.181537041, 5571022.643235249],
              [-9932341.860068887, 5571497.637739626],
              [-9932349.541113753, 5626126.846010439],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Clair',
        GEOID: '26147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9239101.066987667, 5335456.777183543],
              [-9184530.627887838, 5337704.501178072],
              [-9182304.192992575, 5327584.2939506],
              [-9174500.140090514, 5312817.4128140155],
              [-9175910.112760901, 5304668.761094196],
              [-9180508.60960608, 5294857.617110686],
              [-9180238.214562945, 5275802.051453105],
              [-9184963.9495861, 5256926.241627779],
              [-9193208.382393742, 5244336.816148737],
              [-9203790.747147022, 5239527.806942928],
              [-9206831.105079567, 5254477.143899244],
              [-9199409.43462838, 5260549.387257207],
              [-9206999.642788628, 5262708.893795765],
              [-9209380.989335679, 5267337.514899043],
              [-9210464.46193957, 5296389.522777066],
              [-9237697.328208763, 5295812.103811583],
              [-9239101.066987667, 5335456.777183543],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kenton',
        GEOID: '21117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9418511.462033954, 4732167.723761367],
              [-9412156.90022151, 4735914.04983513],
              [-9407222.634563707, 4736259.23830802],
              [-9401020.053084588, 4720756.158007732],
              [-9401017.158777826, 4695853.091702548],
              [-9397380.684972083, 4694005.850860707],
              [-9410091.255750349, 4691912.002359901],
              [-9419372.62961473, 4693388.89282941],
              [-9417398.712403983, 4704415.7833130965],
              [-9420081.03163931, 4732897.539971056],
              [-9418511.462033954, 4732167.723761367],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lucas',
        GEOID: '19117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10414779.493783174, 5036158.280025155],
              [-10389212.746332685, 5036067.788815179],
              [-10363757.429692477, 5036098.543902863],
              [-10363576.869478412, 4997374.72846382],
              [-10414666.39318053, 4997351.753887229],
              [-10414779.493783174, 5036158.280025155],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sibley',
        GEOID: '27143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10534106.529507682, 5577025.622495339],
              [-10519477.478625085, 5577105.204478234],
              [-10519450.873266784, 5563447.071534423],
              [-10492387.323943088, 5563508.076497144],
              [-10492315.745510507, 5577212.359275425],
              [-10465200.3213041, 5577151.105427796],
              [-10451635.150795013, 5577085.308917011],
              [-10451656.858095717, 5570252.1216623],
              [-10438225.604934055, 5570269.49759573],
              [-10438210.354163816, 5565071.194740662],
              [-10453176.146506066, 5556836.875015392],
              [-10454058.46479009, 5549886.299577073],
              [-10451271.915296555, 5545989.59006308],
              [-10456189.676441329, 5536394.224357015],
              [-10533517.760720877, 5536287.23796168],
              [-10534106.529507682, 5577025.622495339],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wilson',
        GEOID: '48493',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10954654.533842579, 3390219.12437198],
              [-10924245.945140034, 3431992.0873824838],
              [-10921908.68111134, 3422270.0857184497],
              [-10904421.05702466, 3423901.198710514],
              [-10891541.61457886, 3423691.054808578],
              [-10893589.781889964, 3420638.155526589],
              [-10879080.51077946, 3403899.9746100027],
              [-10908787.118773062, 3378968.9089153153],
              [-10930571.118606908, 3360678.169788836],
              [-10954654.533842579, 3390219.12437198],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Spalding',
        GEOID: '13255',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9406221.678930884, 3929522.487589934],
              [-9399028.213435823, 3929399.7488041646],
              [-9394042.324762683, 3942181.792618746],
              [-9390288.854172116, 3942188.3227619864],
              [-9367599.826878121, 3939939.638675673],
              [-9362256.602639535, 3934951.04755523],
              [-9360743.659440164, 3933280.3591655497],
              [-9364614.906051992, 3922256.505459564],
              [-9364638.72842302, 3919036.8514845464],
              [-9378465.054457508, 3920420.0337366313],
              [-9401079.720331654, 3923063.4207012695],
              [-9406138.857229734, 3919734.6071054754],
              [-9406758.795473963, 3924682.209381832],
              [-9406221.678930884, 3929522.487589934],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rockwall',
        GEOID: '48397',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10744208.37608262, 3892955.8816807494],
              [-10738626.816814244, 3892915.0080977697],
              [-10719758.274444275, 3892882.0970047135],
              [-10719768.8497959, 3874314.134029567],
              [-10719774.861048402, 3870666.0224861605],
              [-10744442.592291247, 3870590.6558265546],
              [-10744208.37608262, 3892955.8816807494],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Swisher',
        GEOID: '48437',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11354420.302441278, 4129713.60682767],
              [-11313317.138938734, 4129640.312174257],
              [-11295762.61183809, 4129614.9775350927],
              [-11295764.615588922, 4070812.422342672],
              [-11306148.052412156, 4070839.7813042975],
              [-11354367.648322133, 4070913.3678052016],
              [-11354420.302441278, 4129713.60682767],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pine',
        GEOID: '27115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10368616.748104585, 5777305.780519262],
              [-10358844.232646827, 5777342.305217225],
              [-10358709.536062967, 5805724.368764505],
              [-10358818.18388598, 5847793.833309267],
              [-10273983.025112225, 5847462.8895264305],
              [-10274078.670548398, 5819543.902193212],
              [-10274102.226707628, 5805596.011195032],
              [-10274124.756817587, 5792276.2081942335],
              [-10279045.746227594, 5788710.075931424],
              [-10280550.89706261, 5782863.108869583],
              [-10285106.20194536, 5783481.072060145],
              [-10291445.735626549, 5780710.112179446],
              [-10294020.666768085, 5776015.818240709],
              [-10302138.195356224, 5775561.901220038],
              [-10306021.353153566, 5771739.924873264],
              [-10314432.653877905, 5768249.2542104935],
              [-10321668.75473794, 5761748.401720243],
              [-10325935.630820047, 5754001.648960363],
              [-10327832.29230418, 5746762.434886091],
              [-10333344.499529792, 5738247.165970622],
              [-10334984.136179183, 5737090.394135856],
              [-10368496.968332492, 5737291.374156157],
              [-10368616.748104585, 5777305.780519262],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grays Harbor',
        GEOID: '53027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13842981.174785584, 6029599.914289771],
              [-13808819.9313656, 6027125.090660045],
              [-13748615.790396309, 6026991.742715248],
              [-13748516.04813256, 5984376.137572309],
              [-13746726.253359584, 5955574.451953889],
              [-13714771.770888396, 5955968.93449906],
              [-13709926.367412636, 5941400.140578301],
              [-13710164.145844968, 5913907.838997529],
              [-13710173.94196016, 5908413.888371726],
              [-13731414.03476199, 5908434.3757092],
              [-13733591.332682414, 5908209.993198651],
              [-13814392.214147592, 5908528.032719932],
              [-13814885.953057908, 5911222.889749448],
              [-13819003.994980825, 5926668.424922751],
              [-13823666.72317219, 5930061.933581434],
              [-13822442.431412444, 5941177.684314871],
              [-13824605.48043805, 5967878.851288378],
              [-13825423.567375889, 5970521.692012547],
              [-13829927.108695421, 5989093.3443919],
              [-13839169.966015987, 6000304.696782863],
              [-13842981.174785584, 6029599.914289771],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coffee',
        GEOID: '13069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9255724.406547826, 3694236.2606048184],
              [-9251947.670183685, 3695013.270254238],
              [-9246064.101136787, 3712383.6626007035],
              [-9239335.171876805, 3720484.372702309],
              [-9239038.839392312, 3734595.453582184],
              [-9224836.698756907, 3734774.075746586],
              [-9221302.082285238, 3739202.102519556],
              [-9221331.80458928, 3720253.379572049],
              [-9198033.637041666, 3720420.0185688925],
              [-9198137.275487594, 3705473.059594769],
              [-9194712.642672831, 3693846.9259599554],
              [-9198127.034094442, 3693854.495875006],
              [-9198215.421770131, 3680103.1218653205],
              [-9219206.826829528, 3680175.607366357],
              [-9222162.247990599, 3685240.4855210767],
              [-9255156.231866818, 3687466.632953611],
              [-9255724.406547826, 3694236.2606048184],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '22049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10327462.377636276, 3794327.2119758967],
              [-10327910.327267228, 3822981.9369727448],
              [-10310598.03137855, 3822921.780660799],
              [-10310671.168284, 3828649.4733644365],
              [-10287629.703482153, 3828528.04776063],
              [-10287637.273207529, 3816962.1419367786],
              [-10276105.798475742, 3805488.741790312],
              [-10276108.24750454, 3799784.4210038097],
              [-10276149.101757662, 3782506.8622104283],
              [-10332089.260951607, 3782609.9394369237],
              [-10327462.377636276, 3794327.2119758967],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tompkins',
        GEOID: '36109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8537832.580147378, 5243241.123591631],
              [-8525513.297379252, 5243712.56858575],
              [-8534480.527640611, 5254832.660055236],
              [-8511310.154868428, 5254100.160149192],
              [-8489845.975931631, 5254852.478584764],
              [-8488485.095156685, 5222228.027945597],
              [-8488127.759591237, 5205524.189976363],
              [-8506512.841412691, 5208789.373074882],
              [-8506612.36103746, 5200453.735667494],
              [-8520210.03683786, 5203278.862890765],
              [-8529221.794895539, 5203444.072907798],
              [-8537248.264140205, 5203662.852716321],
              [-8537832.580147378, 5243241.123591631],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Portsmouth',
        GEOID: '51740',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8504760.895266585, 4429486.055279829],
              [-8503074.62762005, 4432287.236712404],
              [-8498333.085229201, 4428626.1550969705],
              [-8497360.486838141, 4424670.954128068],
              [-8497771.923676113, 4421701.4491045885],
              [-8492559.72247819, 4414331.514566986],
              [-8492802.6216071, 4411080.039113471],
              [-8500783.672499524, 4409570.529658813],
              [-8504838.596271161, 4412160.834208024],
              [-8503408.808731413, 4418525.208667088],
              [-8507076.451994577, 4420493.759289769],
              [-8504760.895266585, 4429486.055279829],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nolan',
        GEOID: '48353',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11205489.629252153, 3832465.2458669282],
              [-11148262.171466675, 3832132.6733264555],
              [-11148859.734493254, 3774163.04367206],
              [-11158124.410434013, 3774128.095555975],
              [-11162191.80198862, 3774004.595509395],
              [-11206015.836485133, 3774526.851717961],
              [-11205489.629252153, 3832465.2458669282],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '27063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10625723.917583928, 5441942.630270019],
              [-10586548.80766192, 5441940.160553861],
              [-10559698.769121565, 5441964.240314654],
              [-10559148.405559083, 5441965.166460558],
              [-10559160.769548949, 5388474.2036123425],
              [-10561351.529601373, 5388474.753151774],
              [-10565846.441958696, 5388480.718846877],
              [-10599278.414073113, 5388525.09023352],
              [-10618519.942863455, 5388462.741184914],
              [-10625938.790768735, 5388438.701725406],
              [-10625723.917583928, 5441942.630270019],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Metcalfe',
        GEOID: '21169',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9548647.731633978, 4458405.5056192335],
              [-9545003.020185914, 4462803.035460647],
              [-9538575.544107001, 4464565.354829298],
              [-9532545.478610221, 4456552.345377785],
              [-9520808.842056904, 4454373.705956058],
              [-9518220.441256978, 4440177.334278985],
              [-9511731.405499658, 4433146.319130164],
              [-9512454.202953378, 4430487.526435397],
              [-9524575.670986366, 4418338.515103658],
              [-9529129.194757266, 4421307.498104003],
              [-9528526.956312073, 4413774.028366921],
              [-9530397.1237574, 4415815.273794599],
              [-9544450.207594635, 4417033.560180865],
              [-9546324.27122214, 4454427.447585802],
              [-9548647.731633978, 4458405.5056192335],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wilson',
        GEOID: '20205',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10682329.878652306, 4523600.766238161],
              [-10682315.852396466, 4541959.574741729],
              [-10633849.906453364, 4541742.1058914345],
              [-10633856.696942301, 4492764.512710394],
              [-10682397.004305255, 4493136.759030481],
              [-10682329.878652306, 4523600.766238161],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oklahoma',
        GEOID: '40109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10873022.838048963, 4262980.483743436],
              [-10813694.670152724, 4262770.823857186],
              [-10813741.201699875, 4227113.899139917],
              [-10813810.66506213, 4215213.582025812],
              [-10833371.503345342, 4215271.742998104],
              [-10845141.75838488, 4215275.838852796],
              [-10872727.062161926, 4215253.311670833],
              [-10872728.620634796, 4219227.819540434],
              [-10873022.838048963, 4262980.483743436],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Schenectady',
        GEOID: '36093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8266954.299100984, 5281053.34726591],
              [-8246980.131548456, 5296361.10685344],
              [-8247992.804956202, 5305256.917152907],
              [-8232683.92594333, 5296353.81294042],
              [-8226998.616909536, 5298459.710284092],
              [-8226058.189851315, 5289331.496974138],
              [-8216421.37285283, 5278373.794236828],
              [-8219009.4396942835, 5277371.945499661],
              [-8257710.32858551, 5270961.793678557],
              [-8267954.059447799, 5268581.460819253],
              [-8266954.299100984, 5281053.34726591],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '01027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9592715.555815328, 3921306.2398679694],
              [-9586897.665267998, 3921150.5968652996],
              [-9586633.94939431, 3934701.8606924256],
              [-9571282.435016464, 3934418.185734404],
              [-9570862.983175155, 3946101.205982978],
              [-9564989.43288243, 3948012.5421988387],
              [-9562890.726522503, 3961680.6682220967],
              [-9556988.678440135, 3961692.282102362],
              [-9560984.157603689, 3957779.598732069],
              [-9549290.379054327, 3957769.189810591],
              [-9547363.661307678, 3961672.3916708687],
              [-9533788.80600289, 3961310.8990553804],
              [-9533526.871241054, 3937922.789793129],
              [-9534921.147863239, 3909466.411822965],
              [-9570661.494896818, 3909287.271918693],
              [-9574497.0079521, 3907290.6061356943],
              [-9574691.705741499, 3909200.892383081],
              [-9592886.98783115, 3909168.732780736],
              [-9592715.555815328, 3921306.2398679694],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Craig',
        GEOID: '51045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8957302.789172417, 4498673.396434442],
              [-8950073.701440299, 4503744.810025981],
              [-8938024.925034799, 4514154.850377848],
              [-8937000.340441538, 4521032.547372818],
              [-8930426.479232231, 4526330.401192841],
              [-8930528.58640919, 4526443.735129526],
              [-8921763.485139208, 4522570.452550619],
              [-8907847.324275648, 4529740.2144412575],
              [-8902116.26293114, 4515264.362408823],
              [-8913810.152799992, 4498158.26002046],
              [-8933000.408498352, 4488557.238992332],
              [-8934745.452836027, 4486818.625361295],
              [-8941720.286851171, 4490642.806423789],
              [-8953531.61878281, 4483298.029047336],
              [-8955053.244902464, 4484991.1224757545],
              [-8957831.433245175, 4499077.318353712],
              [-8957302.789172417, 4498673.396434442],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sheboygan',
        GEOID: '55117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9814179.448857062, 5448668.581479427],
              [-9800767.676606288, 5448696.540615095],
              [-9765900.802667022, 5448776.38487589],
              [-9766728.736669991, 5445920.968201324],
              [-9765658.95636347, 5436154.816557539],
              [-9762747.28376228, 5429509.365075315],
              [-9763630.492602235, 5422659.210109638],
              [-9763409.968690975, 5415983.758369121],
              [-9772753.124872744, 5398070.905633205],
              [-9772851.658209996, 5394992.986206373],
              [-9800626.746130943, 5394892.48080621],
              [-9814023.490250459, 5394981.860531298],
              [-9814179.448857062, 5448668.581479427],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hancock',
        GEOID: '54029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8975375.619822193, 4956442.91127595],
              [-8970528.991832035, 4955795.293892102],
              [-8963333.077308176, 4959209.992678288],
              [-8963335.984677989, 4935555.816670374],
              [-8963337.384392204, 4924188.117988006],
              [-8969432.606167214, 4924204.773871383],
              [-8975396.95196919, 4923534.713326366],
              [-8972895.866845284, 4931064.601925664],
              [-8974821.694036005, 4941870.288878799],
              [-8979915.896573689, 4950953.598437701],
              [-8975375.619822193, 4956442.91127595],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morovis',
        GEOID: '72101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7398650.805005899, 2081074.9728316192],
              [-7396489.982370112, 2081022.6580796863],
              [-7391113.139645305, 2081108.1681367229],
              [-7389060.296915584, 2077881.5574435224],
              [-7387748.285397095, 2076589.5325034782],
              [-7389133.099862565, 2071986.7833549175],
              [-7389836.193766415, 2071614.064145682],
              [-7390607.526518121, 2069573.5505302274],
              [-7397815.018269022, 2067737.0874430907],
              [-7398836.931194505, 2070728.0774054185],
              [-7398650.805005899, 2081074.9728316192],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chambers',
        GEOID: '48071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10577025.75918303, 3456327.6361071514],
              [-10565757.332407989, 3473545.1198403914],
              [-10565184.037030403, 3481212.298501513],
              [-10573287.762001682, 3488683.2585817534],
              [-10513261.509578679, 3489358.871007654],
              [-10503881.840603927, 3489092.576333437],
              [-10503452.875945926, 3447385.5206345734],
              [-10505311.182865713, 3446559.2036132803],
              [-10518097.730705282, 3440874.9523642403],
              [-10524802.33514769, 3448716.6010938673],
              [-10548920.927342452, 3442530.777030211],
              [-10552153.867994068, 3445889.9313597176],
              [-10565315.61666852, 3438984.868551467],
              [-10577378.19669088, 3446424.963679127],
              [-10577025.75918303, 3456327.6361071514],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Charles City',
        GEOID: '51036',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8599393.371750966, 4492487.262919533],
              [-8596566.30196278, 4492238.038554099],
              [-8591340.408467492, 4507712.513700305],
              [-8573973.677347815, 4497252.942752406],
              [-8560927.033026842, 4495544.700205373],
              [-8560966.551446075, 4491879.9727491075],
              [-8557623.18185959, 4490165.7406611135],
              [-8558593.776499815, 4470243.8300757455],
              [-8562869.892099656, 4470562.994381522],
              [-8568532.71459631, 4473801.457780888],
              [-8571155.847077364, 4481142.826224413],
              [-8579311.780889822, 4476772.334283645],
              [-8585481.663667042, 4481414.8789190585],
              [-8601732.194252534, 4483910.842810216],
              [-8599393.371750966, 4492487.262919533],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Potter',
        GEOID: '46107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11175566.059570996, 5625616.528204731],
              [-11163079.574927697, 5624601.018702157],
              [-11168178.11892552, 5637173.644068743],
              [-11160916.971180055, 5660460.718522804],
              [-11099553.660353133, 5660311.46195045],
              [-11084452.39219059, 5660232.091351202],
              [-11084382.1495919, 5605362.122882109],
              [-11095686.97784043, 5605399.838481899],
              [-11177005.977184407, 5605430.011075073],
              [-11175566.059570996, 5625616.528204731],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wilson',
        GEOID: '47189',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9639631.823127098, 4334400.065641651],
              [-9635018.298150662, 4344613.644276443],
              [-9631545.130037911, 4338955.147104481],
              [-9623761.559922155, 4346902.224631172],
              [-9606699.732887762, 4343863.187576],
              [-9605008.121905666, 4348542.790706995],
              [-9602913.089088935, 4341940.864350882],
              [-9596470.362239785, 4347873.736808592],
              [-9588705.04852052, 4341407.851990697],
              [-9586345.520593664, 4337683.026270604],
              [-9580122.64973883, 4312464.606899677],
              [-9580535.311091201, 4310264.70532986],
              [-9575129.191340316, 4295264.610108367],
              [-9583550.8447773, 4297106.438274076],
              [-9590531.912683927, 4294348.557546898],
              [-9601498.774958408, 4295275.750091029],
              [-9630871.313160138, 4314473.998417551],
              [-9635466.136462124, 4319207.585577328],
              [-9639631.823127098, 4334400.065641651],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gunnison',
        GEOID: '08051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11981877.844313633, 4622161.815672434],
              [-11966847.486666726, 4622166.071244876],
              [-11966918.174543379, 4674305.226638355],
              [-11966912.71988833, 4752934.413074504],
              [-11958838.383262621, 4758637.44581896],
              [-11955099.495525347, 4758450.982676336],
              [-11952998.006178152, 4750063.2770738425],
              [-11942632.157834463, 4738691.202139726],
              [-11918568.223509682, 4738703.6851227665],
              [-11911366.075094339, 4727728.627270088],
              [-11900768.45957082, 4720538.7395019615],
              [-11895788.582150184, 4723023.718539904],
              [-11889130.229447365, 4718564.139850124],
              [-11883284.063749373, 4727765.175744257],
              [-11877229.619284108, 4729648.532346319],
              [-11866570.2214432, 4721384.234365464],
              [-11861560.510399029, 4721486.936072011],
              [-11851633.149529574, 4708838.674981499],
              [-11836167.198715193, 4708931.664626333],
              [-11845171.60968648, 4697254.532599138],
              [-11846334.230448324, 4682452.70001899],
              [-11850196.460181396, 4678615.351124307],
              [-11842156.187319871, 4670018.868691843],
              [-11839293.717933616, 4655051.533656555],
              [-11827355.259143488, 4639322.1100311745],
              [-11911252.417894239, 4639727.215045165],
              [-11911310.08139047, 4600223.037879569],
              [-11974484.003735144, 4600250.640323262],
              [-11975777.870176632, 4612085.015706755],
              [-11981877.844313633, 4622161.815672434],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Atkinson',
        GEOID: '13003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9255156.231866818, 3687466.632953611],
              [-9222162.247990599, 3685240.4855210767],
              [-9219206.826829528, 3680175.607366357],
              [-9198215.421770131, 3680103.1218653205],
              [-9198287.445480675, 3668479.1758656176],
              [-9206033.500928033, 3668919.1539758258],
              [-9202968.096110059, 3656634.2102058125],
              [-9236316.966522926, 3656666.610235379],
              [-9244736.95016755, 3656626.533102862],
              [-9243243.376559576, 3668520.2033536127],
              [-9255156.231866818, 3687466.632953611],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dodge',
        GEOID: '13091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9278093.056347316, 3799132.4313810924],
              [-9273442.350660956, 3808282.1063219886],
              [-9258804.060260622, 3822860.3054460282],
              [-9254990.143186552, 3818974.028555941],
              [-9238512.18688137, 3782658.1914533926],
              [-9226694.064460794, 3789075.7317528287],
              [-9225587.6600418, 3786964.841869958],
              [-9231487.704373334, 3781080.569479656],
              [-9232233.656281138, 3783447.080306356],
              [-9233068.552462088, 3779608.309553606],
              [-9262420.496558024, 3750233.834240232],
              [-9272029.817642279, 3761276.9706689008],
              [-9272379.917440824, 3773708.7260958753],
              [-9277067.247239657, 3777217.718098626],
              [-9271923.507528573, 3786807.1451331414],
              [-9281143.544353526, 3796137.8440188183],
              [-9278093.056347316, 3799132.4313810924],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bingham',
        GEOID: '16011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12579960.955552911, 5328872.252574971],
              [-12579917.095673539, 5355418.905624119],
              [-12573204.307739723, 5355425.481223183],
              [-12572070.964003956, 5380625.054280948],
              [-12558698.042255469, 5380591.013662983],
              [-12558650.620152391, 5393907.825208479],
              [-12545583.159086643, 5394537.888302514],
              [-12545386.23490743, 5407306.249987481],
              [-12538942.61750235, 5407834.3417064445],
              [-12525653.63064992, 5407841.877304548],
              [-12525671.775726922, 5376912.603075049],
              [-12479282.049606603, 5376895.283011091],
              [-12472644.513648564, 5374609.624770825],
              [-12472661.100252692, 5367956.159970162],
              [-12448020.976243563, 5367853.105907741],
              [-12448023.09131389, 5355037.834659963],
              [-12421924.79329486, 5354969.787916062],
              [-12422085.093361603, 5315024.46401864],
              [-12474798.657114904, 5315376.495528319],
              [-12543298.103899129, 5315279.959616953],
              [-12551335.14849542, 5304596.822121689],
              [-12558684.01599963, 5291177.326311331],
              [-12579966.29888847, 5291149.989289535],
              [-12579960.955552911, 5328872.252574971],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brown',
        GEOID: '18013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9615932.905412627, 4770455.638477804],
              [-9601493.542942341, 4770731.997666988],
              [-9583005.26795292, 4771094.298790582],
              [-9582273.78757892, 4733085.891331496],
              [-9582412.046386484, 4728874.87889708],
              [-9608890.611786064, 4728665.599815546],
              [-9614671.76690143, 4728603.246953059],
              [-9615932.905412627, 4770455.638477804],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Daviess',
        GEOID: '18027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9715804.07713374, 4677555.049100634],
              [-9711351.074863028, 4684958.641386821],
              [-9711675.237220217, 4695560.196655077],
              [-9708536.472857809, 4694203.131046827],
              [-9695790.836439943, 4707925.991046203],
              [-9688738.635378698, 4707709.419470054],
              [-9674137.080410326, 4707958.8920199815],
              [-9676217.753012743, 4695526.192800684],
              [-9676356.123139799, 4651063.995952192],
              [-9678969.570825152, 4648943.945499966],
              [-9692851.779244019, 4652393.002693085],
              [-9696635.640055573, 4655599.432765229],
              [-9711745.81377738, 4656694.749640531],
              [-9715804.07713374, 4677555.049100634],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Catawba',
        GEOID: '37035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9065068.739180585, 4256383.679071632],
              [-9057376.33972779, 4268718.14299308],
              [-9056231.752723452, 4269879.70299312],
              [-9054089.743081609, 4272626.037080917],
              [-9046335.11603346, 4273851.839161339],
              [-9044597.084823703, 4275293.715823424],
              [-9032803.341371609, 4276964.65899004],
              [-9029069.017733457, 4269924.433620792],
              [-9023705.75598653, 4260878.719133586],
              [-9017471.08526567, 4260819.493318056],
              [-9016260.374483803, 4259709.205787022],
              [-9014879.12224204, 4257020.252135214],
              [-9013127.844012879, 4255351.262383611],
              [-9011450.92720357, 4251391.873521078],
              [-9008812.543952279, 4248866.969890516],
              [-9009474.115686063, 4244533.600894573],
              [-9012428.757610697, 4238469.706492195],
              [-9076479.54358435, 4241359.24869347],
              [-9065068.739180585, 4256383.679071632],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Barceloneta',
        GEOID: '72017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7411637.002843369, 2092395.5050742521],
              [-7412347.975459522, 2094742.3614082374],
              [-7406559.547801946, 2093748.5617100282],
              [-7405103.884567695, 2088120.637275656],
              [-7407541.670096575, 2085057.5079850173],
              [-7412562.401770333, 2083178.8182952676],
              [-7411637.002843369, 2092395.5050742521],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '21225',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9810847.322539147, 4536730.0376393255],
              [-9802748.495625462, 4543128.494778684],
              [-9799235.47513501, 4551101.594977435],
              [-9792804.770790862, 4548655.050504405],
              [-9788975.268988086, 4549760.347466392],
              [-9785406.700071724, 4553713.586339126],
              [-9789227.630273711, 4561169.217636688],
              [-9787810.0190502, 4565251.150444555],
              [-9775531.436723962, 4545918.301038706],
              [-9769647.31107961, 4545950.828546041],
              [-9766564.874379545, 4528465.674018315],
              [-9788651.440589368, 4506232.760274519],
              [-9797848.656918706, 4515657.766927702],
              [-9803490.141706174, 4509612.079180099],
              [-9804157.132461961, 4513076.898614579],
              [-9810767.283825265, 4519274.917393712],
              [-9810836.748998655, 4519525.663000829],
              [-9813933.210143426, 4530708.946716816],
              [-9810847.322539147, 4536730.0376393255],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pender',
        GEOID: '37141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8711427.533675134, 4082567.9109513396],
              [-8702568.283319842, 4091460.446776026],
              [-8711358.849549314, 4097302.643369595],
              [-8711244.52443227, 4103380.756189694],
              [-8695610.14722832, 4124117.7686890345],
              [-8695611.483062208, 4126138.17294557],
              [-8680776.045843678, 4125079.6463815295],
              [-8647312.182396822, 4125975.6495711757],
              [-8635739.185494972, 4092979.655802519],
              [-8628954.434473513, 4087684.4391122544],
              [-8642292.452598479, 4077184.2649384537],
              [-8651028.713891832, 4067842.035087699],
              [-8663180.998448383, 4081159.099264077],
              [-8686251.183678854, 4073437.836374505],
              [-8698204.670600235, 4078823.608429257],
              [-8700993.001205627, 4076840.6748806727],
              [-8705466.04098468, 4076341.6248806417],
              [-8711427.533675134, 4082567.9109513396],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Larue',
        GEOID: '21123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9559651.106701437, 4515206.658706867],
              [-9544082.185358072, 4530746.348052252],
              [-9537908.295079187, 4541675.247448163],
              [-9528067.65209306, 4536214.71234078],
              [-9531613.400513807, 4514714.1544095585],
              [-9520186.45478388, 4516659.3163398495],
              [-9518150.53261676, 4515921.729712427],
              [-9514059.430010619, 4504204.96198393],
              [-9517687.554854551, 4506639.433159066],
              [-9527111.306347655, 4504811.142383586],
              [-9532754.759252911, 4505073.148832004],
              [-9535330.580950378, 4498091.959945705],
              [-9561543.20408645, 4500659.04584779],
              [-9559651.106701437, 4515206.658706867],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jim Wells',
        GEOID: '48249',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10935525.503864154, 3256283.943661934],
              [-10896302.192602634, 3256149.4737128713],
              [-10891378.531524846, 3253338.3983356874],
              [-10887200.711035375, 3253810.9694167087],
              [-10886881.112777308, 3248426.4998904183],
              [-10901993.512888933, 3234508.0826425343],
              [-10902869.819920456, 3203150.201960204],
              [-10915929.59994134, 3203141.4061042704],
              [-10915775.311127102, 3156115.885395253],
              [-10935187.871848576, 3156304.481130563],
              [-10935525.503864154, 3256283.943661934],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Orange',
        GEOID: '18117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9649518.775021393, 4676873.056717963],
              [-9607840.646348901, 4677092.6812419435],
              [-9607837.64072265, 4639337.313613467],
              [-9607859.236703863, 4635245.094665721],
              [-9641913.65004938, 4635442.806551209],
              [-9649331.980915843, 4635344.234201468],
              [-9649436.064639734, 4654054.574807472],
              [-9649518.775021393, 4676873.056717963],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Claiborne',
        GEOID: '22027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10379274.249328472, 3897695.5143572846],
              [-10374687.333896015, 3897686.9008720806],
              [-10351455.580749398, 3897593.9610906886],
              [-10349499.629311675, 3897586.1362435706],
              [-10322071.193975389, 3897207.7479387913],
              [-10322140.860698394, 3871168.567524751],
              [-10322148.65306275, 3863430.2420295756],
              [-10333625.247285573, 3863334.139141172],
              [-10339443.917069338, 3840384.917766865],
              [-10372612.895185081, 3840337.2240885403],
              [-10372060.305232784, 3846776.1552559184],
              [-10379137.775818441, 3857701.178088137],
              [-10379274.249328472, 3897695.5143572846],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Huron',
        GEOID: '39077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9221870.813563703, 5055214.567525783],
              [-9166304.465219842, 5054256.209572379],
              [-9166492.483839791, 5043553.469923473],
              [-9166501.723357527, 5042204.9189462],
              [-9165656.808422405, 5022046.240498647],
              [-9176835.511687865, 5021989.8394398885],
              [-9176383.109277284, 5011300.96115987],
              [-9208881.72141947, 5011698.291131613],
              [-9220539.098495342, 5011843.717370318],
              [-9221543.868219243, 5044401.8482457595],
              [-9221716.302110482, 5050077.0779498285],
              [-9221870.813563703, 5055214.567525783],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stevens',
        GEOID: '27149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10714948.715844551, 5741943.391766249],
              [-10659788.349683613, 5741961.262445673],
              [-10658552.035418862, 5686666.975547523],
              [-10699699.504078744, 5686616.231765348],
              [-10713535.626228422, 5686723.111191517],
              [-10714837.841631722, 5714176.435718915],
              [-10714948.715844551, 5741943.391766249],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sevier',
        GEOID: '49041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12525156.366484549, 4660668.6768516125],
              [-12517600.333407974, 4676118.525620093],
              [-12502286.778976487, 4675408.396111035],
              [-12492090.247578297, 4682693.2779077785],
              [-12492769.85306959, 4702324.222931215],
              [-12482684.41852321, 4715843.608757958],
              [-12475036.769505711, 4715843.608757958],
              [-12469350.681235481, 4728193.7343624355],
              [-12451452.065588795, 4726397.349434302],
              [-12389788.080817241, 4726294.168019721],
              [-12390489.950206693, 4651748.394395676],
              [-12440211.913964417, 4651742.134880339],
              [-12441777.956560895, 4650620.889771327],
              [-12481781.728772368, 4652028.79615396],
              [-12525501.568225497, 4651783.106322877],
              [-12525156.366484549, 4660668.6768516125],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calhoun',
        GEOID: '19025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10565832.139105802, 5245284.070986289],
              [-10513349.340656916, 5245062.512431039],
              [-10513350.342532331, 5232155.05618666],
              [-10508300.667790968, 5232143.284197938],
              [-10508284.526464803, 5192362.422964262],
              [-10534030.498295471, 5192397.741215098],
              [-10559590.121298552, 5192442.227369089],
              [-10559398.317815913, 5232248.32707748],
              [-10565832.361744784, 5232277.606479101],
              [-10565832.139105802, 5245284.070986289],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dawson',
        GEOID: '31047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11156910.805345386, 5019217.142118444],
              [-11068050.133139146, 5019198.544010627],
              [-11068090.987392267, 4968158.452215696],
              [-11067084.993153969, 4963909.001541798],
              [-11070100.081562104, 4964946.2744547175],
              [-11092259.450718904, 4965976.610920238],
              [-11098471.857541606, 4968187.378351878],
              [-11129916.719383944, 4968192.370688606],
              [-11156807.946135893, 4968229.225959178],
              [-11156910.805345386, 5019217.142118444],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dolores',
        GEOID: '08033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12138567.163253656, 4562640.678881268],
              [-12113845.096898224, 4562607.701766142],
              [-12051058.232423037, 4564547.996496178],
              [-12045781.131961983, 4554160.866501873],
              [-12021333.034074476, 4559209.532988049],
              [-12007014.341932207, 4547762.2500589425],
              [-12008363.645480113, 4540286.377876239],
              [-12019040.186522605, 4536637.6064123325],
              [-12019174.994425954, 4528635.913026955],
              [-12050405.566248517, 4527688.457842865],
              [-12124593.995609732, 4527555.62418554],
              [-12138698.143979665, 4506901.517773736],
              [-12138567.163253656, 4562640.678881268],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Highlands',
        GEOID: '12055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9079610.960860364, 3204496.411218839],
              [-9075866.952426516, 3204468.3874105536],
              [-9032704.378344294, 3204068.2689531012],
              [-9032516.025765872, 3198799.453099392],
              [-9040732.740020305, 3189683.671058696],
              [-9027838.158123756, 3170916.6525210715],
              [-9020711.37300368, 3168416.1533567677],
              [-9013666.519028828, 3150707.8057152987],
              [-9010274.836783338, 3149224.75035807],
              [-9035707.110288952, 3149681.1160598057],
              [-9035611.70948534, 3138689.0535451137],
              [-9046676.42159223, 3138609.3826105343],
              [-9046625.103306973, 3127529.5324345673],
              [-9079499.41873059, 3127681.1253762124],
              [-9079509.771443233, 3127699.6215768154],
              [-9079669.848870995, 3166095.183783924],
              [-9079610.960860364, 3204496.411218839],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kossuth',
        GEOID: '19109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10513361.919759374, 5350868.48221679],
              [-10513329.969920952, 5388462.707230125],
              [-10507513.193713095, 5388461.248127587],
              [-10491635.743894951, 5388416.202370332],
              [-10460777.15265692, 5388328.654390019],
              [-10460738.747432597, 5350921.061420824],
              [-10460830.36337352, 5297942.804440279],
              [-10513341.54829256, 5297990.0710347975],
              [-10513361.919759374, 5350868.48221679],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Christian',
        GEOID: '21047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9763934.060853628, 4442118.952486982],
              [-9760561.636880046, 4459929.244561424],
              [-9742665.581581647, 4453828.348558677],
              [-9721947.577191638, 4461039.19444881],
              [-9721235.355089543, 4458641.5024900045],
              [-9722007.244438704, 4457496.47817839],
              [-9713668.746661343, 4449203.363479077],
              [-9722196.715787003, 4389264.327010552],
              [-9723512.172634738, 4389245.297953294],
              [-9756168.190536907, 4388773.052478778],
              [-9762072.12079412, 4388606.889733747],
              [-9758235.8387589, 4434423.996826343],
              [-9766433.851338882, 4439399.922383969],
              [-9763934.060853628, 4442118.952486982],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Edgecombe',
        GEOID: '37065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8663822.755312806, 4282364.7479361],
              [-8650299.886210222, 4316526.0676896935],
              [-8649296.897598175, 4321715.089920872],
              [-8631791.239753988, 4313850.587020314],
              [-8629224.88021324, 4305682.735897425],
              [-8616419.576548308, 4301304.707502374],
              [-8609718.588480515, 4287593.387304547],
              [-8610603.689751813, 4275775.848133156],
              [-8615032.535693023, 4277675.206673458],
              [-8630740.60639988, 4266759.988301372],
              [-8645642.835312886, 4255984.623530225],
              [-8651576.720769621, 4263371.704219663],
              [-8655239.465975191, 4276951.890151159],
              [-8663822.755312806, 4282364.7479361],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Randolph',
        GEOID: '37151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8910776.696675876, 4289714.331119176],
              [-8873636.50704557, 4287803.38778514],
              [-8854544.65777707, 4286849.759827146],
              [-8854622.581420625, 4279081.472528233],
              [-8856111.590929477, 4234095.038576465],
              [-8879728.354859741, 4233608.859234825],
              [-8913000.08086549, 4232812.556285268],
              [-8910776.696675876, 4289714.331119176],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sumner',
        GEOID: '20191',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10887892.227712186, 4505409.643163517],
              [-10815059.335790358, 4505600.407564999],
              [-10814434.829764862, 4438963.545057124],
              [-10840840.261941137, 4438945.517598402],
              [-10849458.731562298, 4438942.902568752],
              [-10883562.34479829, 4438932.55480292],
              [-10887303.67826377, 4438925.391735364],
              [-10887528.992213724, 4490255.661559017],
              [-10887831.781228684, 4493088.7039089],
              [-10887892.227712186, 4505409.643163517],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wilkes',
        GEOID: '37193',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9067617.287602806, 4328236.911045684],
              [-9070035.5922208, 4333729.957007635],
              [-9057702.394516323, 4339831.759277949],
              [-9056870.837920096, 4351159.839210025],
              [-9045114.831775382, 4351183.064166645],
              [-9035018.933196867, 4360299.13892455],
              [-9027466.57366349, 4361441.78682715],
              [-9019849.64882545, 4352094.68332867],
              [-9013222.242941072, 4356080.6413252195],
              [-9002267.625810578, 4345633.448439676],
              [-9002763.999420026, 4333185.481258523],
              [-9003697.524669819, 4308290.793805432],
              [-9014170.907641612, 4308716.557613716],
              [-9020088.429133201, 4306904.836408533],
              [-9046222.126750302, 4304174.470799407],
              [-9053427.614750369, 4300151.208299449],
              [-9061163.540124068, 4309715.075168967],
              [-9077602.200648999, 4316797.813818566],
              [-9067617.287602806, 4328236.911045684],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Van Buren',
        GEOID: '26159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9613130.214592926, 5199128.64246868],
              [-9605140.81473869, 5220267.537594279],
              [-9604311.044211544, 5223998.519166253],
              [-9547282.398079397, 5224210.337817056],
              [-9547087.143692546, 5171369.956096691],
              [-9598293.775498979, 5171693.422370649],
              [-9598363.127541743, 5197506.444983566],
              [-9614261.346080715, 5197465.653334674],
              [-9613130.214592926, 5199128.64246868],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carver',
        GEOID: '27019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10465394.239857063, 5618170.748640441],
              [-10438135.547466002, 5618053.035844922],
              [-10438099.257312005, 5604356.274486974],
              [-10410677.370547444, 5604456.838575415],
              [-10410646.757687477, 5590759.1578940805],
              [-10417129.11427535, 5589207.604683165],
              [-10418862.470066493, 5586359.651366068],
              [-10421523.785132887, 5575527.011156158],
              [-10438210.354163816, 5565071.194740662],
              [-10438225.604934055, 5570269.49759573],
              [-10451656.858095717, 5570252.1216623],
              [-10451635.150795013, 5577085.308917011],
              [-10465200.3213041, 5577151.105427796],
              [-10465394.239857063, 5618170.748640441],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Berkeley',
        GEOID: '45015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8945840.332524924, 3929525.283173894],
              [-8933816.157726886, 3935093.4234212674],
              [-8930301.912722034, 3954349.0318187657],
              [-8922257.521039348, 3954982.337902749],
              [-8916880.121717088, 3961445.1893051895],
              [-8902315.858778132, 3961952.195786629],
              [-8869604.62640853, 3935850.482122143],
              [-8845305.807958173, 3926567.1324050194],
              [-8843966.077886475, 3923671.3382119043],
              [-8851997.222549757, 3915004.493211368],
              [-8865771.117104081, 3911790.828510111],
              [-8886480.327254318, 3884552.8554600775],
              [-8894124.41404811, 3876572.4817019184],
              [-8896019.962337337, 3871289.5047346125],
              [-8896564.871244771, 3871302.6184826605],
              [-8900043.160054097, 3883387.124715944],
              [-8903967.728702014, 3882596.2016816502],
              [-8908155.011348203, 3884880.2780846264],
              [-8909983.656623464, 3893164.365713824],
              [-8922173.252184818, 3898171.4859717404],
              [-8933539.862750737, 3907215.933788798],
              [-8937850.487392725, 3910608.2939639236],
              [-8938549.017197452, 3919147.776672707],
              [-8945840.332524924, 3929525.283173894],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hand',
        GEOID: '46059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11055333.885066848, 5605356.465555719],
              [-10989070.29025521, 5605309.007012696],
              [-10987832.751476059, 5602732.79071016],
              [-10987875.164202051, 5564110.014106241],
              [-10987284.16902543, 5495936.7834570715],
              [-11012386.714199314, 5495913.182744907],
              [-11054045.473280407, 5495642.244719655],
              [-11054080.538920008, 5550544.973150858],
              [-11055333.885066848, 5605356.465555719],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greenwood',
        GEOID: '45047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9165405.003734231, 4074902.175822002],
              [-9155620.354451975, 4083945.0549965245],
              [-9146995.320305312, 4073219.8598726187],
              [-9137512.346843107, 4069053.770744861],
              [-9122077.788125128, 4056112.5665756236],
              [-9116749.480698308, 4048464.4409886524],
              [-9113736.062082533, 4046991.677331446],
              [-9127164.420937436, 4028347.5123931207],
              [-9129121.974183036, 4023653.1829333226],
              [-9133427.366808955, 4022521.001349118],
              [-9133222.093667934, 4026572.7324468615],
              [-9150493.980581453, 4025928.488089349],
              [-9155477.642864779, 4031324.1344446694],
              [-9162289.059867436, 4024987.0895020976],
              [-9164593.818604821, 4037415.028494762],
              [-9157941.031876544, 4043361.4237166215],
              [-9155777.314933993, 4058329.751988091],
              [-9165405.003734231, 4074902.175822002],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Caroline',
        GEOID: '51033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8629221.540628515, 4594328.845835394],
              [-8612822.064564342, 4614317.531024408],
              [-8607967.978168301, 4614113.421165739],
              [-8597177.223328255, 4614123.626562641],
              [-8595456.557959065, 4607296.914758436],
              [-8584513.518055612, 4600627.739559239],
              [-8590536.236466002, 4590668.6730109975],
              [-8579405.957179036, 4574450.190157868],
              [-8590222.760779927, 4574327.912842075],
              [-8591796.150462799, 4564131.442942611],
              [-8598433.68642084, 4566706.64070187],
              [-8610029.949096264, 4549685.971820181],
              [-8615829.917205576, 4548011.8152143555],
              [-8621195.40534232, 4564564.500993976],
              [-8625498.348939443, 4562962.840565486],
              [-8643125.567667577, 4578110.423086072],
              [-8629221.540628515, 4594328.845835394],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Murray',
        GEOID: '27101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10693770.850638077, 5495889.892628111],
              [-10641427.535511153, 5495750.929496748],
              [-10626842.121868946, 5495814.898854828],
              [-10626828.76353005, 5441936.147266519],
              [-10692495.351912566, 5442115.048966801],
              [-10693864.581649322, 5442110.263802736],
              [-10693770.850638077, 5495889.892628111],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lancaster',
        GEOID: '51103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8534662.980286023, 4548166.317634192],
              [-8523147.31292193, 4556465.495640603],
              [-8516812.45465936, 4556680.594110714],
              [-8506981.051190969, 4554513.321036289],
              [-8496493.435987836, 4534680.688466954],
              [-8496918.771098673, 4533049.459867847],
              [-8491389.198032498, 4525633.309648085],
              [-8492439.03397191, 4521296.496076398],
              [-8519128.901943276, 4527414.780184391],
              [-8525651.890145289, 4542349.340948782],
              [-8534662.980286023, 4548166.317634192],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Middlesex',
        GEOID: '51119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8540774.865608536, 4545112.045594887],
              [-8534662.980286023, 4548166.317634192],
              [-8525651.890145289, 4542349.340948782],
              [-8519128.901943276, 4527414.780184391],
              [-8492439.03397191, 4521296.496076398],
              [-8493450.055765554, 4517121.721066957],
              [-8492507.491058977, 4514094.525946047],
              [-8505267.510269187, 4514019.661643774],
              [-8508990.367999787, 4511046.51238744],
              [-8522167.144805497, 4516759.153590159],
              [-8533092.707548892, 4523518.286822504],
              [-8537490.717991153, 4526989.729562216],
              [-8543890.252877876, 4541157.4257353],
              [-8540774.865608536, 4545112.045594887],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Forest',
        GEOID: '42053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8851243.144319123, 5104905.061298693],
              [-8789346.39049232, 5104732.7627305435],
              [-8789670.886807984, 5077023.381649859],
              [-8801310.7867238, 5079421.178792415],
              [-8804825.81096509, 5062719.237303603],
              [-8806122.349074358, 5060560.982691711],
              [-8817491.96526653, 5061415.005585883],
              [-8817304.725883015, 5076111.852510928],
              [-8838797.513928944, 5076887.366943181],
              [-8838816.438242378, 5069530.286815832],
              [-8847430.674398435, 5069515.449489892],
              [-8847468.634344796, 5077479.69828564],
              [-8851266.076134227, 5081208.554010095],
              [-8851243.144319123, 5104905.061298693],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Garrard',
        GEOID: '21079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9427574.538376886, 4540970.0929312855],
              [-9430644.952571945, 4553379.195681401],
              [-9423963.334095554, 4548945.9067479465],
              [-9423930.494845768, 4552606.883120028],
              [-9414418.244357483, 4541149.684643651],
              [-9409351.53773403, 4546914.449229754],
              [-9400953.372709602, 4536836.39787296],
              [-9389554.702130333, 4514514.098706369],
              [-9392494.315923713, 4505208.502693998],
              [-9400565.758242661, 4507052.154233172],
              [-9423034.484264374, 4524462.97503846],
              [-9424118.402146228, 4527920.955950085],
              [-9423450.262562487, 4530225.272343218],
              [-9433757.779493, 4538971.851266934],
              [-9427574.538376886, 4540970.0929312855],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Camden',
        GEOID: '34007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8363814.055957157, 4850871.677773931],
              [-8363944.1018814165, 4854623.543040126],
              [-8364070.09078598, 4858259.713258873],
              [-8363685.442424065, 4858816.1978773],
              [-8362233.319187893, 4860917.31787202],
              [-8355655.447217773, 4864781.408174961],
              [-8351105.04365176, 4861211.005035181],
              [-8350921.03253348, 4860040.520190176],
              [-8350419.204268984, 4859641.578906101],
              [-8350760.621147247, 4858744.854571571],
              [-8350640.61873617, 4858216.297098057],
              [-8349423.674062818, 4857439.775205613],
              [-8348341.537292817, 4857134.874827533],
              [-8346184.499519715, 4857010.8846834265],
              [-8347356.582438278, 4855837.700900884],
              [-8347185.70701991, 4855391.169628566],
              [-8341288.668314629, 4849386.285927708],
              [-8338093.464970388, 4835623.227721291],
              [-8328859.624528577, 4835182.817784241],
              [-8319597.508936104, 4826751.2711475175],
              [-8326707.596132561, 4818806.282706563],
              [-8335298.45519555, 4809191.216712707],
              [-8342691.961815568, 4822205.253852395],
              [-8358654.397558888, 4833962.375486571],
              [-8364706.339756507, 4850538.739846181],
              [-8363814.055957157, 4850871.677773931],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cleburne',
        GEOID: '05023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10268167.716906765, 4261091.084708496],
              [-10223268.002170715, 4260096.0594369145],
              [-10217996.35636471, 4261028.567364297],
              [-10218456.66245914, 4236704.09016137],
              [-10218667.835533174, 4225965.475237077],
              [-10224711.259368852, 4223351.184234847],
              [-10224913.19292515, 4212678.143981473],
              [-10253801.157383459, 4213283.931356397],
              [-10269530.156154584, 4213419.480499205],
              [-10268167.716906765, 4261091.084708496],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'DeKalb',
        GEOID: '17037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9900725.677530218, 5183823.620361634],
              [-9874660.552719446, 5184006.360885409],
              [-9861644.187299969, 5184014.319262508],
              [-9861607.78582648, 5170940.334298964],
              [-9863080.542689675, 5163664.900414977],
              [-9863122.064859742, 5119063.469979224],
              [-9863156.239943415, 5105922.236851017],
              [-9875424.093106797, 5105788.4937074715],
              [-9887200.470718326, 5105916.577303849],
              [-9900601.667617474, 5105465.015766524],
              [-9900897.888782475, 5144778.185221684],
              [-9900725.677530218, 5183823.620361634],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Missaukee',
        GEOID: '26113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9499337.427353207, 5545067.57871081],
              [-9445562.209616208, 5544874.945403784],
              [-9445648.593541065, 5490449.393141987],
              [-9471886.374882057, 5490894.290609302],
              [-9499423.922597554, 5491030.231504057],
              [-9499337.427353207, 5545067.57871081],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Garland',
        GEOID: '05051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10397484.118457098, 4121181.999819017],
              [-10396604.694479832, 4129063.726245701],
              [-10396623.284834793, 4132987.969663813],
              [-10384748.723432384, 4133101.536046517],
              [-10361081.420453297, 4132925.224054372],
              [-10349289.56943255, 4132975.9083854235],
              [-10350475.344648479, 4114689.6989596],
              [-10338848.469113084, 4114405.845507082],
              [-10331342.418487875, 4108357.3330721688],
              [-10329691.43911992, 4096626.134258291],
              [-10343259.281296786, 4096964.9240755835],
              [-10346931.933937037, 4081189.990597261],
              [-10398044.946051713, 4082214.9832766633],
              [-10397484.118457098, 4121181.999819017],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hardeman',
        GEOID: '48197',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11131685.177345624, 4104400.1490153903],
              [-11124082.576190958, 4106506.0178389065],
              [-11114367.711332668, 4097075.528579433],
              [-11111709.637428269, 4094496.638685094],
              [-11105775.863291025, 4087398.4359276956],
              [-11098159.383730948, 4080081.3279229584],
              [-11087424.17731681, 4079225.1193182706],
              [-11085693.604512937, 4083674.7939234246],
              [-11073508.81094473, 4082217.410263046],
              [-11073539.07459118, 4040304.23365899],
              [-11081688.329234194, 4036293.5725566396],
              [-11093322.329216998, 4042099.1678966703],
              [-11106573.022164594, 4041334.9453758034],
              [-11131684.250258759, 4058967.352111151],
              [-11131695.270888349, 4070750.2921385695],
              [-11131685.177345624, 4104400.1490153903],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '12125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9192317.269869942, 3502374.65023416],
              [-9179223.092126401, 3521101.1756676137],
              [-9144069.955406757, 3521959.4964332865],
              [-9144600.058821913, 3517695.23842911],
              [-9157138.08438945, 3507161.0623446372],
              [-9162361.974133907, 3497954.1523411307],
              [-9174810.832789319, 3493667.991327213],
              [-9185062.356015962, 3496512.125507529],
              [-9187164.735919083, 3495952.908541987],
              [-9192317.269869942, 3502374.65023416],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cass',
        GEOID: '26027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9598644.915576762, 5125098.511152685],
              [-9598293.775498979, 5171693.422370649],
              [-9547087.143692546, 5171369.956096691],
              [-9546780.235856429, 5130890.235781033],
              [-9550247.722440865, 5124954.513769283],
              [-9550250.843620889, 5124954.507866062],
              [-9580440.69275347, 5125044.350541037],
              [-9598642.205505162, 5125098.517253894],
              [-9598644.915576762, 5125098.511152685],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pawnee',
        GEOID: '20145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11085728.558833046, 4628900.592190804],
              [-11024237.23059171, 4628751.2667601],
              [-11024226.209962124, 4616394.43700276],
              [-11010898.372607408, 4616374.730582719],
              [-11010959.932285817, 4579489.524240147],
              [-11023093.756782282, 4579459.151808658],
              [-11047422.520175662, 4579421.292344315],
              [-11059623.581644567, 4579531.056918504],
              [-11059631.374008924, 4591807.308026219],
              [-11084029.71208405, 4591775.909379143],
              [-11084081.475647267, 4606206.708779012],
              [-11084133.90712743, 4615168.032296821],
              [-11085663.214291949, 4616529.405727563],
              [-11085728.558833046, 4628900.592190804],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jack',
        GEOID: '48237',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10956138.422654852, 3948011.0755114164],
              [-10956222.24623142, 3957428.636418624],
              [-10906963.371555395, 3957472.9398191404],
              [-10906968.714890955, 3953019.295206623],
              [-10900202.938879522, 3953035.9693287318],
              [-10900587.32508123, 3895474.3941586562],
              [-10915554.453257369, 3895746.2390166265],
              [-10956793.760497153, 3896354.3289025994],
              [-10956138.422654852, 3948011.0755114164],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crawford',
        GEOID: '19047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10650027.188813915, 5192700.130936813],
              [-10611363.14667414, 5192628.590550318],
              [-10585465.11241905, 5192549.385751274],
              [-10585688.864595544, 5140535.452081027],
              [-10637387.417231793, 5140546.662685719],
              [-10650244.15050147, 5140501.521397622],
              [-10650027.188813915, 5192700.130936813],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bleckley',
        GEOID: '13023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9294946.270655965, 3822816.1120867855],
              [-9285387.488620529, 3829399.8319563125],
              [-9264735.608008051, 3840242.7621069774],
              [-9254990.143186552, 3818974.028555941],
              [-9258804.060260622, 3822860.3054460282],
              [-9273442.350660956, 3808282.1063219886],
              [-9278093.056347316, 3799132.4313810924],
              [-9294959.183716897, 3816158.2472299095],
              [-9294946.270655965, 3822816.1120867855],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ida',
        GEOID: '19093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10657907.38424768, 5245431.578067807],
              [-10618544.700983686, 5245500.647238271],
              [-10618481.80547139, 5232369.067462548],
              [-10611236.242454635, 5232360.162806434],
              [-10611363.14667414, 5192628.590550318],
              [-10650027.188813915, 5192700.130936813],
              [-10649853.86436675, 5232346.277596698],
              [-10657930.761340747, 5232379.4813930625],
              [-10657907.38424768, 5245431.578067807],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Osceola',
        GEOID: '19143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10671191.71812042, 5388388.180902283],
              [-10668238.946188202, 5388384.055014877],
              [-10629542.287437627, 5388427.025256712],
              [-10625938.790768735, 5388438.701725406],
              [-10618519.942863455, 5388462.741184914],
              [-10618552.27070906, 5350900.121411535],
              [-10671299.452948583, 5351258.553616236],
              [-10671191.71812042, 5388388.180902283],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mills',
        GEOID: '19129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10672053.531179216, 5030752.025769494],
              [-10671297.679429766, 5036015.054152967],
              [-10618137.160327893, 5035971.975513866],
              [-10618205.62181473, 4997831.13849401],
              [-10663867.986382203, 4997842.184500329],
              [-10666491.929109953, 4997300.660155722],
              [-10668612.200440833, 5001243.0354129905],
              [-10667560.78785029, 5008268.27847029],
              [-10671740.723410087, 5014908.941356983],
              [-10671619.024944747, 5020139.491260282],
              [-10671513.74296836, 5024666.740995742],
              [-10672053.531179216, 5030752.025769494],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Early',
        GEOID: '13099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9474200.59577616, 3666377.8399518477],
              [-9472150.313394729, 3671123.449717661],
              [-9472045.223735653, 3672898.1361010144],
              [-9471944.928934215, 3674592.089359863],
              [-9472452.323173251, 3679966.3653159738],
              [-9469504.360418063, 3688897.4663844854],
              [-9470129.530678358, 3693728.2877316657],
              [-9467909.867844352, 3700406.754673484],
              [-9465410.252185667, 3696036.9152782927],
              [-9442097.724423742, 3698010.957159468],
              [-9438671.867094578, 3689548.885006202],
              [-9421812.196255466, 3689231.8473753748],
              [-9420699.00134753, 3675956.3873105175],
              [-9422267.938250773, 3666426.8040878177],
              [-9452964.065198034, 3666039.1332780593],
              [-9453520.885290984, 3642179.9292642158],
              [-9464506.400522366, 3642553.446570202],
              [-9466121.361092854, 3646807.9195710314],
              [-9474125.34380038, 3656987.1018656488],
              [-9474200.59577616, 3666377.8399518477],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McIntosh',
        GEOID: '13191',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9090706.508466203, 3702904.683584229],
              [-9079886.587919569, 3707842.8410633653],
              [-9071625.45718831, 3723939.4607395404],
              [-9065387.335563237, 3716415.952186442],
              [-9051894.077445202, 3718681.8011202053],
              [-9041616.17149924, 3714894.6821191236],
              [-9036341.03433447, 3703026.0820293836],
              [-9036610.57927623, 3700084.691160803],
              [-9040644.686303088, 3693001.86579141],
              [-9045667.75568615, 3685383.561393705],
              [-9047974.51817437, 3678434.1183799976],
              [-9045928.465933591, 3672280.856885778],
              [-9046309.17281333, 3671067.8313571704],
              [-9070500.907692315, 3676473.9193333187],
              [-9086374.399162492, 3691718.26920249],
              [-9085012.293873146, 3693861.5437311656],
              [-9090706.508466203, 3702904.683584229],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Delaware',
        GEOID: '39041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9267191.20465546, 4930672.875677002],
              [-9241832.958611226, 4929181.884233482],
              [-9231144.395063726, 4926434.073457268],
              [-9231679.50785597, 4918121.029723506],
              [-9211123.584644556, 4916876.453022776],
              [-9211771.01880301, 4906276.606567866],
              [-9213004.438761, 4884248.075219219],
              [-9236323.645692375, 4885569.79285056],
              [-9240097.042471794, 4885774.079348472],
              [-9258439.934206236, 4886757.1305956505],
              [-9258701.423690112, 4901500.7860322315],
              [-9267172.614300497, 4901531.266700294],
              [-9267191.20465546, 4930672.875677002],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bacon',
        GEOID: '13005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9198033.637041666, 3720420.0185688925],
              [-9186239.44831161, 3720399.090468889],
              [-9186242.453937862, 3725407.690086843],
              [-9183381.543024473, 3725290.9684482045],
              [-9153421.571869828, 3701864.006573611],
              [-9161641.06911153, 3696964.300534046],
              [-9166585.992212057, 3688736.606683072],
              [-9174645.857303962, 3687039.2939350777],
              [-9181794.127085762, 3687093.427936308],
              [-9183270.000894697, 3693768.2252244423],
              [-9194712.642672831, 3693846.9259599554],
              [-9198137.275487594, 3705473.059594769],
              [-9198033.637041666, 3720420.0185688925],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Olmsted',
        GEOID: '27109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10318135.808058634, 5442037.869204688],
              [-10316902.610739626, 5444076.095073307],
              [-10316947.583813906, 5495748.7557885535],
              [-10302715.83219395, 5495655.597351279],
              [-10276902.51207135, 5495522.227172948],
              [-10276900.842278989, 5482129.432698765],
              [-10250242.050623816, 5482013.777999365],
              [-10250219.898045149, 5441807.8773502335],
              [-10289766.147149459, 5441984.769904038],
              [-10291371.70816517, 5439805.338720016],
              [-10316961.276111273, 5439742.221460337],
              [-10318135.808058634, 5442037.869204688],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '55081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10127544.37203758, 5485521.27604794],
              [-10119451.44505691, 5489971.932190238],
              [-10080360.715308927, 5490269.391938968],
              [-10067259.635756956, 5490411.220177388],
              [-10053543.961296316, 5489490.9274852425],
              [-10053563.108248733, 5462561.766257783],
              [-10053562.996929241, 5462554.185776133],
              [-10053507.448503336, 5423981.538679612],
              [-10120127.599643987, 5423034.908380351],
              [-10120379.738290634, 5476517.056942076],
              [-10127079.94712199, 5476417.896391925],
              [-10127544.37203758, 5485521.27604794],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pike',
        GEOID: '39131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9278872.626741342, 4750013.576333683],
              [-9215683.230987448, 4745875.196445667],
              [-9218043.092872776, 4714236.202458142],
              [-9244373.492030108, 4715505.329420303],
              [-9263129.379075395, 4715964.722088467],
              [-9269664.946379868, 4723933.750312768],
              [-9274537.623130871, 4729150.818545165],
              [-9282446.650312752, 4729581.156062116],
              [-9278872.626741342, 4750013.576333683],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ector',
        GEOID: '48135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11443541.907533938, 3774577.830396137],
              [-11386542.098107133, 3774734.9722195915],
              [-11386575.159995899, 3717621.7282560286],
              [-11389993.224960703, 3717628.3975594086],
              [-11439997.494947081, 3717679.005921952],
              [-11443525.543568792, 3717688.029140508],
              [-11443541.907533938, 3774577.830396137],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gaines',
        GEOID: '48165',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11473130.962145261, 3875325.9176802533],
              [-11472972.87605343, 3889877.276622433],
              [-11420825.71828419, 3889840.741272108],
              [-11377800.401134117, 3889857.3252090234],
              [-11377152.855656173, 3832195.7808567774],
              [-11378080.592292445, 3832192.216196537],
              [-11473109.477483539, 3832053.459328404],
              [-11473116.713250441, 3840742.4282972068],
              [-11473130.962145261, 3875325.9176802533],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Racine',
        GEOID: '55101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9830221.700675279, 5287967.897062209],
              [-9803899.093882302, 5288154.334609936],
              [-9776207.139135055, 5287995.0041735945],
              [-9770141.569618734, 5279287.926589912],
              [-9772189.73692984, 5266543.75403652],
              [-9774075.60655814, 5261620.912486997],
              [-9817077.317841392, 5261832.55643931],
              [-9817062.512349116, 5253017.24781359],
              [-9830166.82016632, 5252920.594976369],
              [-9830221.700675279, 5287967.897062209],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bates',
        GEOID: '29013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10532228.013100546, 4613068.838866345],
              [-10532245.67159926, 4634485.172584119],
              [-10532256.065612227, 4647111.994855057],
              [-10532256.02063048, 4647116.428604466],
              [-10498782.74000865, 4646248.182028323],
              [-10487595.576461893, 4642708.091821709],
              [-10471347.272266215, 4642778.165279884],
              [-10472401.356524535, 4609905.123329972],
              [-10469586.420560846, 4609698.975618769],
              [-10470520.391088601, 4584601.272447274],
              [-10479086.759863615, 4587639.193460387],
              [-10490502.462324975, 4583101.794624398],
              [-10532374.505215181, 4587912.758952558],
              [-10532228.013100546, 4613068.838866345],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Johnson',
        GEOID: '29101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10477289.84064323, 4697802.272975566],
              [-10476742.037429037, 4709832.993005465],
              [-10445633.137809912, 4712781.468068531],
              [-10408069.37751714, 4711424.963001096],
              [-10407605.397879513, 4707216.786400501],
              [-10409600.243154528, 4658300.363544234],
              [-10471191.870257068, 4659890.568156981],
              [-10477353.070114002, 4660080.213348666],
              [-10477289.84064323, 4697802.272975566],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henry',
        GEOID: '29083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10471347.272266215, 4642778.165279884],
              [-10471581.822433315, 4645469.035525289],
              [-10471191.870257068, 4659890.568156981],
              [-10409600.243154528, 4658300.363544234],
              [-10409790.933442257, 4652076.597523915],
              [-10410986.616092868, 4608739.982479146],
              [-10414718.602021713, 4607869.896275292],
              [-10469586.420560846, 4609698.975618769],
              [-10472401.356524535, 4609905.123329972],
              [-10471347.272266215, 4642778.165279884],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '28097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9995030.874711668, 3985476.52053313],
              [-9963859.413538717, 3985593.9699783637],
              [-9963817.557410179, 3956495.7689782083],
              [-9949857.647986736, 3956562.619084479],
              [-9957979.295396032, 3952946.196138742],
              [-9957952.356079262, 3933319.7763878917],
              [-9979266.92162043, 3933262.9144240143],
              [-9979382.02597391, 3948857.6516968487],
              [-9994845.750398478, 3950688.75597506],
              [-9995030.874711668, 3985476.52053313],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ward',
        GEOID: '48475',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11533911.181479407, 3717690.513796069],
              [-11502368.915082626, 3717640.5592397004],
              [-11443525.543568792, 3717688.029140508],
              [-11439997.494947081, 3717679.005921952],
              [-11440010.741966484, 3670964.125869568],
              [-11446619.78013488, 3667457.4402349573],
              [-11458513.488489706, 3678297.7715011854],
              [-11467136.518885534, 3681064.762969346],
              [-11486081.426426189, 3680926.431151191],
              [-11495037.302099489, 3688402.6306037423],
              [-11502636.415819002, 3686371.3131145495],
              [-11515156.40762903, 3689209.1462307065],
              [-11522611.362607965, 3714308.1908304184],
              [-11533911.181479407, 3717690.513796069],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kent',
        GEOID: '48263',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11247586.43052952, 3948146.9448887953],
              [-11189551.238518845, 3948233.8807923696],
              [-11189747.049503151, 3890384.04325031],
              [-11204960.193753941, 3890456.0873814696],
              [-11242175.524040531, 3890662.271374999],
              [-11247572.181634698, 3891352.496695495],
              [-11247586.43052952, 3948146.9448887953],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greene',
        GEOID: '36039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8297455.394300377, 5191199.699279066],
              [-8287013.180786005, 5214308.513387075],
              [-8264881.307543432, 5217644.538036295],
              [-8265951.199169445, 5222324.367012005],
              [-8213566.250552965, 5230774.664129046],
              [-8213912.565488823, 5201962.702306407],
              [-8227698.705187134, 5180066.4311056435],
              [-8237915.0514546875, 5187528.969527555],
              [-8245968.682655108, 5175459.0067075],
              [-8271880.965805022, 5178123.339657672],
              [-8287926.779846947, 5186362.331548163],
              [-8297455.394300377, 5191199.699279066],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Johnson',
        GEOID: '05071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10430188.894296233, 4268834.34830765],
              [-10410510.168672273, 4268130.824320444],
              [-10410551.468203356, 4264139.513427864],
              [-10371019.356674377, 4263372.801247357],
              [-10371392.054329554, 4245405.093486577],
              [-10377333.17555319, 4245575.265774039],
              [-10377607.355459014, 4227744.811166207],
              [-10385653.194295079, 4227925.507979678],
              [-10385998.729994502, 4208466.398765023],
              [-10399232.502379498, 4208378.256161775],
              [-10401188.163193753, 4222180.2019479945],
              [-10418902.099805214, 4216145.8329043975],
              [-10431757.942518966, 4214992.682351347],
              [-10430188.894296233, 4268834.34830765],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Culpeper',
        GEOID: '51047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8702448.503547747, 4653294.896424384],
              [-8675724.033393007, 4678196.437358433],
              [-8672880.265681202, 4678407.817639767],
              [-8669246.79750171, 4662383.999779752],
              [-8662170.328791473, 4654586.340520727],
              [-8653478.057672368, 4637950.754287666],
              [-8642281.988566346, 4637539.0423324965],
              [-8640477.165662114, 4631519.6757392865],
              [-8643484.684344877, 4632978.213568977],
              [-8649840.915949682, 4630526.562902098],
              [-8657323.589481823, 4635092.126228142],
              [-8672787.870503845, 4633460.462628695],
              [-8687364.267267296, 4623533.61967723],
              [-8693439.75111632, 4623487.653479166],
              [-8693586.804163659, 4636642.5107243955],
              [-8708724.47379969, 4654931.2843994275],
              [-8702448.503547747, 4653294.896424384],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cabell',
        GEOID: '54011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9177966.517714327, 4639920.8924364],
              [-9170697.021007052, 4641029.456778749],
              [-9164265.648745963, 4643088.171453835],
              [-9162064.194496034, 4649776.69395304],
              [-9160845.023432866, 4658880.183026084],
              [-9159605.185241444, 4661667.675276798],
              [-9158729.841788303, 4663636.142177747],
              [-9152573.539988963, 4663351.291944887],
              [-9134334.954617394, 4646681.998927587],
              [-9133444.510010539, 4632456.370610329],
              [-9152777.254657114, 4623369.759632217],
              [-9157681.100865541, 4611854.733587465],
              [-9163072.415124148, 4617409.014144635],
              [-9160049.089073695, 4624848.992574373],
              [-9166482.242446637, 4622631.783357003],
              [-9184856.186723126, 4638167.827845731],
              [-9177966.517714327, 4639920.8924364],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mercer',
        GEOID: '29129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10438912.246265817, 4950225.799390103],
              [-10419209.564238787, 4950513.882653876],
              [-10414706.097978836, 4950537.844466349],
              [-10394389.131460028, 4950645.946668583],
              [-10394439.641703391, 4934801.998802459],
              [-10393559.661128672, 4921755.743371363],
              [-10393590.719266603, 4904718.109613281],
              [-10437685.482764727, 4904378.780336878],
              [-10437852.350681426, 4934846.338170391],
              [-10438912.246265817, 4950225.799390103],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Comerío',
        GEOID: '72045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7376749.251789776, 2066277.038152451],
              [-7372454.323195991, 2067324.4745916002],
              [-7370033.235590727, 2069956.6661142416],
              [-7368312.347582553, 2067867.6717750423],
              [-7365913.412555958, 2063818.0715252238],
              [-7370669.537800101, 2057818.0537205818],
              [-7373854.277112206, 2059189.7360735459],
              [-7376424.978113095, 2059209.0694030966],
              [-7376749.251789776, 2066277.038152451],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Canóvanas',
        GEOID: '72029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7338100.46042024, 2084772.537508291],
              [-7332609.181258898, 2085467.3140753654],
              [-7332330.659892934, 2081863.815924447],
              [-7332378.304634994, 2071967.7896344308],
              [-7328873.0765088955, 2069790.8985713362],
              [-7330679.68052498, 2067414.2640628063],
              [-7338017.750038581, 2069191.1455364416],
              [-7336152.814609321, 2074587.6838507066],
              [-7338100.46042024, 2084772.537508291],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Santa Rosa',
        GEOID: '12113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9719706.71584197, 3612929.571096434],
              [-9716731.257172555, 3623070.018779507],
              [-9703012.611423165, 3632622.110787787],
              [-9702901.146275382, 3632622.651589642],
              [-9676764.109073555, 3632447.5911549055],
              [-9666091.686852222, 3632405.514683373],
              [-9660939.038910864, 3632357.3338597734],
              [-9662570.913178077, 3553071.1436980627],
              [-9668167.350077555, 3552614.1974383113],
              [-9675801.61290411, 3551068.9832821283],
              [-9702093.857328149, 3545748.744889242],
              [-9710373.112137632, 3544702.1980536687],
              [-9710201.701120585, 3553037.323053905],
              [-9699757.038577417, 3557689.9315171544],
              [-9698707.073140254, 3568008.778479649],
              [-9708141.066026513, 3575125.6612407155],
              [-9713614.534069326, 3582368.813538071],
              [-9714785.949070944, 3595362.5458765673],
              [-9719137.984563507, 3597333.7631937624],
              [-9719706.71584197, 3612929.571096434],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'George',
        GEOID: '28039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9894637.16930077, 3621168.6785912775],
              [-9889008.52188779, 3621108.3460083394],
              [-9888993.382437043, 3632487.20030966],
              [-9886187.908630071, 3632408.3717232123],
              [-9843539.626564113, 3632525.946942491],
              [-9842030.854235789, 3598458.836693767],
              [-9888964.662008418, 3598282.513574875],
              [-9894581.064277412, 3598458.000152369],
              [-9894637.16930077, 3621168.6785912775],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Whitley',
        GEOID: '18183',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9538585.785500154, 5038687.792154559],
              [-9534729.010422131, 5055918.767110616],
              [-9521955.321492583, 5051679.380816868],
              [-9496418.741624096, 5051383.3346289955],
              [-9499844.153675297, 5038797.830939362],
              [-9499520.32527658, 5013116.068492163],
              [-9533828.769700086, 5012681.656766435],
              [-9538209.970899235, 5012623.244989534],
              [-9538319.397958685, 5019234.707030747],
              [-9538585.785500154, 5038687.792154559],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chippewa',
        GEOID: '55017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10204173.147275966, 5654325.061107841],
              [-10190434.874958694, 5654095.484011952],
              [-10190333.35158309, 5667643.460628757],
              [-10121749.413305355, 5667618.300720731],
              [-10121542.359052481, 5626425.647343616],
              [-10121465.21464536, 5612777.050769742],
              [-10121418.237820245, 5599085.6113115065],
              [-10202481.981571833, 5598872.3549634],
              [-10202586.065295724, 5626211.114229326],
              [-10204257.193491513, 5640562.692577148],
              [-10204173.147275966, 5654325.061107841],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tama',
        GEOID: '19171',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10326896.540664574, 5205524.791971704],
              [-10300783.214514287, 5205573.102222494],
              [-10274654.526274271, 5205652.265346503],
              [-10274584.617634054, 5140446.5150831025],
              [-10326663.771609325, 5140385.829136016],
              [-10326826.743343847, 5192509.558160839],
              [-10326896.540664574, 5205524.791971704],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ogle',
        GEOID: '17141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9984076.591539646, 5190852.277360198],
              [-9951538.572297717, 5191273.633265565],
              [-9926692.952508584, 5191623.024222188],
              [-9926670.577290934, 5183519.861431608],
              [-9917657.260760386, 5183577.519325311],
              [-9900725.677530218, 5183823.620361634],
              [-9900897.888782475, 5144778.185221684],
              [-9953590.74711049, 5143944.231300711],
              [-9954937.71294909, 5147270.76125325],
              [-9977491.375742277, 5146253.521420832],
              [-9983729.27472837, 5150550.418642075],
              [-9984076.591539646, 5190852.277360198],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Trego',
        GEOID: '20195',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11148417.684795314, 4740622.804283835],
              [-11087998.697208792, 4740666.144365853],
              [-11086505.791517764, 4740648.349077898],
              [-11087234.600223986, 4678292.570627597],
              [-11149072.577359652, 4678410.52767181],
              [-11148417.684795314, 4740622.804283835],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Treutlen',
        GEOID: '13283',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9211519.325434327, 3806551.1787186707],
              [-9200303.552778432, 3830774.7545312364],
              [-9182626.908196386, 3828045.5252428837],
              [-9170715.611362016, 3821285.67209803],
              [-9173741.052482795, 3809846.454971775],
              [-9173742.388316683, 3809834.331534528],
              [-9200477.767781524, 3804221.1866525444],
              [-9201166.612790553, 3802433.82418798],
              [-9203201.978360215, 3801911.534472386],
              [-9208566.909899507, 3803977.6491854913],
              [-9211519.325434327, 3806551.1787186707],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Parker',
        GEOID: '48367',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10915554.453257369, 3895746.2390166265],
              [-10900587.32508123, 3895474.3941586562],
              [-10873639.436708467, 3894822.5497018737],
              [-10858568.55876691, 3894531.0830392023],
              [-10859281.114827478, 3836437.1652684878],
              [-10866682.079853378, 3836449.4479433694],
              [-10916750.24722747, 3836890.3119489555],
              [-10915554.453257369, 3895746.2390166265],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Powell',
        GEOID: '21197',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9353884.041097991, 4561000.420350738],
              [-9347086.872990154, 4569650.2643965],
              [-9330234.10395947, 4565340.806281725],
              [-9325098.267932232, 4567900.782015468],
              [-9313318.105458016, 4556105.645567404],
              [-9309767.013701709, 4554786.019964875],
              [-9318329.041016584, 4539448.613628897],
              [-9319901.540143529, 4539442.562494203],
              [-9326078.881326629, 4545123.168848295],
              [-9340401.1356926, 4545487.426760669],
              [-9347213.99984864, 4557923.629052487],
              [-9351056.19207337, 4556508.345832793],
              [-9353884.041097991, 4561000.420350738],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dawson',
        GEOID: '13085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9388311.708696134, 4106807.6537947105],
              [-9379236.164570233, 4105372.961092396],
              [-9372739.78172652, 4112079.0049049295],
              [-9371827.295860486, 4110018.8007199187],
              [-9372103.702156128, 4101432.6892152773],
              [-9362195.933517054, 4091350.811313819],
              [-9348683.083168639, 4085120.7592311455],
              [-9348770.357649421, 4076951.5179416104],
              [-9346059.06013166, 4073740.206530286],
              [-9379566.004221454, 4073894.562669318],
              [-9379511.568990454, 4080075.3930463707],
              [-9379431.530276576, 4091726.573744389],
              [-9386423.730132282, 4091798.136101747],
              [-9389304.010637067, 4104616.211478159],
              [-9388311.708696134, 4106807.6537947105],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Haskell',
        GEOID: '20081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11253250.254901592, 4542245.739696691],
              [-11204557.32851676, 4542237.012464338],
              [-11204600.85443766, 4505502.780643502],
              [-11204610.427913869, 4493275.60173938],
              [-11250850.095360598, 4493300.400277119],
              [-11253248.69642872, 4493288.77157699],
              [-11253250.254901592, 4542245.739696691],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Guilford',
        GEOID: '37081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8910372.495604806, 4302101.757239912],
              [-8909851.075109929, 4320793.214661049],
              [-8909468.692659054, 4336067.443440427],
              [-8853507.382761858, 4333897.37674732],
              [-8854544.65777707, 4286849.759827146],
              [-8873636.50704557, 4287803.38778514],
              [-8910776.696675876, 4289714.331119176],
              [-8910372.495604806, 4302101.757239912],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mingo',
        GEOID: '54059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9173142.71021978, 4560075.39786668],
              [-9162305.535152072, 4571467.091664055],
              [-9149422.196524097, 4575863.4026329275],
              [-9140711.780327994, 4558826.889097276],
              [-9137398.578323515, 4537352.316671374],
              [-9127468.43446679, 4528779.303940279],
              [-9120432.374731712, 4534601.513421173],
              [-9106261.292234238, 4531577.367171857],
              [-9105437.528002368, 4527500.3827491645],
              [-9112161.447885262, 4515896.456391646],
              [-9116066.312983308, 4512746.334002958],
              [-9120659.57781242, 4510709.837000977],
              [-9124669.083231814, 4514336.368215123],
              [-9135369.224006353, 4515279.525478176],
              [-9143956.075567674, 4522393.147112993],
              [-9153368.806431191, 4530534.596394856],
              [-9161161.950023154, 4535187.092107183],
              [-9163895.61799162, 4543601.2018711325],
              [-9164639.348276556, 4545891.546888035],
              [-9169383.451015692, 4551457.327158103],
              [-9172555.145493409, 4557278.291049188],
              [-9173142.71021978, 4560075.39786668],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morgan',
        GEOID: '29141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10360203.443629412, 4654569.264392977],
              [-10359388.918915277, 4677802.357475161],
              [-10334883.380170519, 4676504.1266801],
              [-10335109.804014793, 4664078.957621484],
              [-10310988.874110725, 4640460.309632263],
              [-10311942.54818835, 4628715.497112032],
              [-10318185.122593055, 4628770.854953449],
              [-10318858.828151336, 4610839.002840104],
              [-10326501.245152768, 4606247.3574992],
              [-10331223.529271707, 4606465.192045841],
              [-10354381.322941434, 4606269.452341127],
              [-10361361.277653152, 4616658.846932903],
              [-10360203.443629412, 4654569.264392977],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harmon',
        GEOID: '40057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11131991.828324262, 4168011.1112316023],
              [-11119544.859787755, 4167994.389823945],
              [-11119528.607142098, 4156266.2360817175],
              [-11102014.37769712, 4156281.4460327188],
              [-11100786.968991632, 4132458.776369368],
              [-11094862.879650088, 4126511.9856589017],
              [-11094825.364981689, 4097100.95618877],
              [-11114367.711332668, 4097075.528579433],
              [-11124082.576190958, 4106506.0178389065],
              [-11131685.177345624, 4104400.1490153903],
              [-11131991.49205335, 4104315.310190816],
              [-11131991.62505966, 4129465.7553117075],
              [-11131991.828324262, 4168011.1112316023],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cook',
        GEOID: '13075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9303510.524360655, 3642900.6232744264],
              [-9296286.334686134, 3659527.517554502],
              [-9296580.886058774, 3675342.310653739],
              [-9290796.391358683, 3675193.4877047287],
              [-9287885.164035456, 3678334.2695610286],
              [-9276915.407454217, 3664553.2835850655],
              [-9275192.404375717, 3645477.919493393],
              [-9270662.814295338, 3640979.2125177006],
              [-9272362.774239244, 3636292.2178723575],
              [-9292463.17809433, 3636900.9733563294],
              [-9300924.683909018, 3639806.810020594],
              [-9303510.524360655, 3642900.6232744264],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lee',
        GEOID: '17103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9977491.375742277, 5146253.521420832],
              [-9954937.71294909, 5147270.76125325],
              [-9953590.74711049, 5143944.231300711],
              [-9900897.888782475, 5144778.185221684],
              [-9900601.667617474, 5105465.015766524],
              [-9926047.299461985, 5105522.80016086],
              [-9925976.166307366, 5099058.763651384],
              [-9977732.271120355, 5099008.161887306],
              [-9977491.375742277, 5146253.521420832],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jones',
        GEOID: '28067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9952099.065933859, 3736675.1769362427],
              [-9942673.978606867, 3737359.8088753913],
              [-9901128.988045363, 3740304.0235486566],
              [-9901141.567147823, 3689170.789219946],
              [-9923697.567650318, 3689248.286161611],
              [-9951870.972297223, 3689245.285429142],
              [-9952099.065933859, 3736675.1769362427],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Elk',
        GEOID: '42047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8801310.7867238, 5079421.178792415],
              [-8789670.886807984, 5077023.381649859],
              [-8789346.39049232, 5104732.7627305435],
              [-8789347.948965192, 5104801.4137342],
              [-8736733.125600224, 5105700.176595056],
              [-8729576.284217633, 5101574.156001091],
              [-8729677.584954256, 5072270.687134869],
              [-8711190.868437707, 5072222.452206871],
              [-8709282.62972653, 5046396.34071278],
              [-8754906.811708663, 5049846.231974306],
              [-8761984.727572279, 5042161.568382674],
              [-8764771.277065817, 5051199.254450495],
              [-8791112.140255284, 5068044.590252202],
              [-8804825.81096509, 5062719.237303603],
              [-8801310.7867238, 5079421.178792415],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rutherford',
        GEOID: '47149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9649862.863567436, 4260797.832104584],
              [-9641751.568870783, 4271809.461179698],
              [-9642370.950517558, 4296249.9238748],
              [-9634355.056624515, 4312711.593447424],
              [-9630871.313160138, 4314473.998417551],
              [-9601498.774958408, 4295275.750091029],
              [-9590531.912683927, 4294348.557546898],
              [-9589257.527153326, 4288845.753852964],
              [-9596535.70678088, 4259939.506806528],
              [-9600794.679179141, 4257898.358940614],
              [-9600767.851181861, 4250090.657080894],
              [-9611540.794903379, 4254521.7271220945],
              [-9618307.461470738, 4248263.462387954],
              [-9633935.604783207, 4259093.311485995],
              [-9644657.898136413, 4257487.324359951],
              [-9649862.863567436, 4260797.832104584],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Seminole',
        GEOID: '40133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10773097.342416344, 4219939.957754807],
              [-10756100.971242538, 4218471.88892966],
              [-10746418.290613847, 4217113.119766325],
              [-10735795.294246426, 4227624.393834749],
              [-10735803.977166709, 4203377.79424807],
              [-10735807.650709905, 4179624.9752944964],
              [-10741265.97930197, 4179636.815028507],
              [-10741305.163762731, 4151736.631949902],
              [-10745513.151834207, 4146172.495205144],
              [-10750912.369776662, 4152551.0129653104],
              [-10765811.927021887, 4151890.0280587366],
              [-10767666.17578003, 4144489.6460003546],
              [-10773019.530092278, 4150294.1330598933],
              [-10773097.342416344, 4219939.957754807],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harlan',
        GEOID: '31083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11090811.96338012, 4917098.0404431615],
              [-11040600.639140869, 4917033.915423378],
              [-11040570.599672135, 4866248.751494222],
              [-11076488.81845822, 4866236.696669661],
              [-11090240.641296312, 4866200.6319351075],
              [-11090566.48711867, 4866199.777392302],
              [-11090811.96338012, 4917098.0404431615],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hood River',
        GEOID: '41027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13572489.694582885, 5725130.451490693],
              [-13569941.439823149, 5726350.375525282],
              [-13566190.974858832, 5731332.149365477],
              [-13559972.334144648, 5733481.3470791895],
              [-13551489.788946202, 5731453.589766151],
              [-13544060.103491675, 5733213.705138174],
              [-13529003.474444943, 5736634.994530323],
              [-13527990.478680441, 5736203.68969926],
              [-13518716.421138309, 5732256.029642332],
              [-13518710.874326196, 5703663.448071361],
              [-13523301.912765492, 5662250.409464071],
              [-13547190.07361431, 5662217.515655089],
              [-13547305.623245755, 5680540.156481181],
              [-13560894.39348689, 5694497.966957514],
              [-13570581.749534192, 5703955.149674819],
              [-13572489.694582885, 5725130.451490693],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mineral',
        GEOID: '08079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11926568.866632486, 4570790.684359948],
              [-11911252.52921373, 4573217.740331423],
              [-11897734.446849247, 4573933.41595248],
              [-11894183.689051416, 4568013.529147654],
              [-11877068.651300423, 4561573.665398983],
              [-11877104.496176457, 4556177.389065151],
              [-11879083.645403272, 4532106.807250534],
              [-11878989.135155588, 4495601.735240922],
              [-11925516.452166526, 4493945.6031499505],
              [-11925510.10695555, 4498224.560514025],
              [-11927342.203135027, 4533685.302740135],
              [-11926568.866632486, 4570790.684359948],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brown',
        GEOID: '31017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11154043.549221024, 5288576.261929014],
              [-11144566.030413866, 5281531.090339816],
              [-11096069.026332831, 5271101.823115671],
              [-11094518.1231871, 5226305.732437246],
              [-11094365.281526241, 5173871.894865102],
              [-11097101.51460994, 5173881.79474231],
              [-11150606.782581763, 5173847.745207848],
              [-11152339.136497488, 5226127.905977476],
              [-11152350.60240504, 5278697.757294866],
              [-11154043.549221024, 5288576.261929014],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rio Blanco',
        GEOID: '08103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12139471.969350098, 4898350.884187951],
              [-12035104.034322038, 4898207.240708402],
              [-11982894.74786203, 4898581.64078241],
              [-11963382.890154766, 4897997.886106072],
              [-11960097.740661966, 4898456.401794795],
              [-11915426.453521023, 4898744.789179578],
              [-11915344.745014781, 4879253.262066305],
              [-11946473.014225304, 4879140.781518308],
              [-11946668.71389012, 4853593.343924474],
              [-11959238.242873551, 4853993.4938500635],
              [-11959249.931420084, 4841033.745440716],
              [-12015659.07962874, 4840543.669394432],
              [-12015663.977686336, 4821641.4512037],
              [-12084256.376245372, 4821522.242198008],
              [-12084245.800893746, 4815234.537243347],
              [-12122216.990522824, 4815259.549483497],
              [-12139487.53328266, 4816724.938967974],
              [-12139458.93249332, 4847789.860358796],
              [-12139498.784871025, 4892257.671170732],
              [-12139471.969350098, 4898350.884187951],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tom Green',
        GEOID: '48451',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11273061.005441634, 3705229.156875939],
              [-11228268.936653182, 3705991.0587974284],
              [-11227806.181529954, 3724703.975075189],
              [-11223828.847443402, 3723492.000788495],
              [-11158193.87379627, 3723075.3021866423],
              [-11157973.683843482, 3708591.4470757344],
              [-11144331.591566255, 3708339.3803215516],
              [-11144774.865778595, 3644182.1197544937],
              [-11208621.937084096, 3643997.796526371],
              [-11209100.722213997, 3700983.1313858316],
              [-11273096.293720217, 3701601.369820842],
              [-11273061.005441634, 3705229.156875939],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Taos',
        GEOID: '35055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11804130.896418272, 4345524.845270809],
              [-11795390.980557108, 4349550.250685358],
              [-11793048.150553875, 4364435.137776976],
              [-11797760.749877116, 4399239.627656311],
              [-11796736.72188131, 4423262.924504499],
              [-11800569.163720673, 4438463.762309246],
              [-11799584.608414274, 4438467.995404459],
              [-11768526.212666009, 4438527.778904031],
              [-11768303.720181873, 4438528.207175256],
              [-11747982.45845705, 4438531.831042744],
              [-11735223.908978252, 4438529.182831765],
              [-11716520.676052112, 4438494.198633046],
              [-11713093.059961936, 4438488.377675903],
              [-11710823.455832804, 4427352.934463632],
              [-11714080.10753596, 4417900.730159545],
              [-11714220.370094359, 4400675.454581705],
              [-11723260.62594168, 4400770.86844168],
              [-11729805.766722362, 4394739.52944758],
              [-11727662.532566119, 4388616.150624633],
              [-11730596.914343432, 4376857.284004949],
              [-11724026.058760377, 4368490.204596348],
              [-11728268.221915526, 4362650.015333008],
              [-11724981.513949854, 4356552.278281105],
              [-11726535.8679998, 4336713.399021445],
              [-11734151.56832344, 4333255.7301979335],
              [-11735299.828870973, 4318758.805019808],
              [-11747588.164820662, 4302412.226161749],
              [-11770464.654137151, 4314408.280208412],
              [-11783941.436970549, 4332375.236275368],
              [-11806363.074847657, 4341562.4076672755],
              [-11804130.896418272, 4345524.845270809],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Boone',
        GEOID: '21015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9450709.845509471, 4729181.208202545],
              [-9446648.687846351, 4732870.645759796],
              [-9442136.68624552, 4736791.95953798],
              [-9434410.22302854, 4742801.375843784],
              [-9430324.686396934, 4740691.689269464],
              [-9426228.017816251, 4735756.263687311],
              [-9420081.03163931, 4732897.539971056],
              [-9417398.712403983, 4704415.7833130965],
              [-9419372.62961473, 4693388.89282941],
              [-9424320.001744056, 4689820.726305283],
              [-9437513.14251491, 4701546.0744389165],
              [-9439748.084222708, 4701527.116866793],
              [-9438379.542111756, 4704814.612731231],
              [-9443284.946793051, 4706965.043534132],
              [-9447064.969196318, 4709337.9164785845],
              [-9448549.245512664, 4710269.808383316],
              [-9443523.727100803, 4716152.550823032],
              [-9445397.011491872, 4721803.785272818],
              [-9448527.897899128, 4726150.69659649],
              [-9450709.845509471, 4729181.208202545],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Plaquemines',
        GEOID: '22075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10026371.430191131, 3481610.9836789784],
              [-10019650.96121245, 3490127.9981161137],
              [-10014173.819626441, 3491035.4734684317],
              [-10008814.23142271, 3486576.4036379238],
              [-10004251.468134074, 3477283.980946029],
              [-9987701.042840382, 3472436.150345614],
              [-9977363.469647357, 3462570.17399293],
              [-9965164.96852674, 3458526.3729150333],
              [-9963202.04446455, 3456520.434854801],
              [-9963621.85774536, 3456271.0300196004],
              [-9967013.094712889, 3458455.923503862],
              [-9974461.147883395, 3453554.613938964],
              [-9970287.33489559, 3445041.551891242],
              [-9970843.04179363, 3438678.3039057283],
              [-9966673.34762699, 3431073.805768108],
              [-9961126.074761778, 3427451.29178954],
              [-9949736.198422281, 3425606.6197634083],
              [-9942175.823885566, 3425127.8936991966],
              [-9936138.633941375, 3418592.5607758183],
              [-9929741.88204192, 3419556.190217387],
              [-9922389.007036043, 3411248.0273126005],
              [-9920420.433160855, 3403617.322024257],
              [-9910326.093055211, 3403058.795024527],
              [-9909024.322929876, 3396907.521001278],
              [-9914850.451119523, 3387196.968657802],
              [-9920406.740863487, 3385080.307227012],
              [-9923998.13027546, 3379422.903349179],
              [-9923338.450973019, 3374579.873724133],
              [-9931777.247611584, 3378512.0021375488],
              [-9936305.835816545, 3383075.7995211263],
              [-9943280.78115118, 3376950.822229564],
              [-9952070.011546763, 3367224.479774413],
              [-9952355.434721155, 3377805.3492288557],
              [-9947631.926087817, 3384793.8574628667],
              [-9950906.611548483, 3391383.912404515],
              [-9955628.450389462, 3394627.0309996856],
              [-9961184.628813935, 3403046.0406333283],
              [-9970280.210448181, 3406550.650406753],
              [-9974966.761010578, 3407762.188023344],
              [-9978641.640040645, 3412676.3458235683],
              [-9988270.664674774, 3414398.934316373],
              [-10001237.047642883, 3416287.980211654],
              [-10005781.331896044, 3414791.7342403918],
              [-10007923.488927599, 3412996.16032371],
              [-10016246.143267049, 3432966.1709231795],
              [-10017032.39283052, 3454463.863930021],
              [-10027179.164416328, 3474256.8701678724],
              [-10026371.430191131, 3481610.9836789784],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adams',
        GEOID: '38001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11465401.49330203, 5825448.35684271],
              [-11457508.162168352, 5825578.180063814],
              [-11409963.830289528, 5825848.302241574],
              [-11409966.724596288, 5813434.927782382],
              [-11354352.954149349, 5813338.900357842],
              [-11354429.430639524, 5788920.5257867575],
              [-11354434.114767106, 5771465.68232644],
              [-11354663.749375409, 5771465.908913548],
              [-11364334.63893031, 5771475.451465086],
              [-11391126.457376981, 5771508.750346711],
              [-11415919.200407986, 5771542.209444954],
              [-11433053.94170885, 5771551.334675458],
              [-11452577.265323665, 5771550.854399935],
              [-11459458.809285326, 5771554.922551079],
              [-11465425.317803495, 5771558.449763712],
              [-11465401.49330203, 5825448.35684271],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Canyon',
        GEOID: '16027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13027005.00244744, 5438216.890629148],
              [-13022771.303858278, 5447073.638456554],
              [-13019306.703061633, 5446914.431469175],
              [-13019317.612371732, 5440172.939767532],
              [-13008033.60086798, 5433419.416015102],
              [-12992395.216162357, 5435648.239624796],
              [-12970112.393690268, 5435648.239624796],
              [-12970181.523094052, 5409004.586035343],
              [-12965781.508900957, 5382132.780304659],
              [-12970045.045398338, 5356297.018614449],
              [-12977533.507544, 5358691.987723438],
              [-12982364.996083412, 5368461.646751557],
              [-13000038.857678188, 5385110.768736851],
              [-13007123.452711252, 5402887.701192806],
              [-13014532.878018454, 5404221.345454426],
              [-13027237.305123674, 5416099.453420004],
              [-13027005.00244744, 5438216.890629148],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hancock',
        GEOID: '23009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7669510.384377841, 5497987.79366694],
              [-7659294.706027232, 5536658.576598037],
              [-7658595.842264034, 5553808.2744417135],
              [-7663870.7163352715, 5561088.370874134],
              [-7660542.486199534, 5569288.513886122],
              [-7660539.03529532, 5571871.670363193],
              [-7652541.84307673, 5568243.938413231],
              [-7646639.349716398, 5577809.723485589],
              [-7641764.001297616, 5574985.084559254],
              [-7638373.098288562, 5580837.726340078],
              [-7619286.926314092, 5584289.730444968],
              [-7620363.385790064, 5590333.513236014],
              [-7622930.747206231, 5604078.000631069],
              [-7625507.014181658, 5618486.44053718],
              [-7611569.479975868, 5621107.928287759],
              [-7613908.413796925, 5634644.282454377],
              [-7599836.962243711, 5637297.284218275],
              [-7603534.661769391, 5656464.691969635],
              [-7575846.276143871, 5661372.597234464],
              [-7567705.036504195, 5614579.153918373],
              [-7581415.81290724, 5611937.230314979],
              [-7571642.184254572, 5557061.962260849],
              [-7565564.696654712, 5531201.99917009],
              [-7563474.111837023, 5528646.3868290465],
              [-7567373.861019086, 5525533.252093425],
              [-7571282.7336188, 5526035.007472447],
              [-7575217.209701398, 5516766.88011457],
              [-7581275.550348842, 5522002.2732592765],
              [-7583709.773654017, 5525547.738899825],
              [-7590782.012223604, 5523477.137902502],
              [-7589051.328100242, 5516403.820340781],
              [-7591090.255893611, 5513024.151314475],
              [-7595272.0838847505, 5506841.701609714],
              [-7589131.700772594, 5500468.782690866],
              [-7603846.912941067, 5501854.72040615],
              [-7604767.525129925, 5496003.548959364],
              [-7606575.687618881, 5482105.557480401],
              [-7618540.974406287, 5483438.94416577],
              [-7625712.621281153, 5480887.3837622665],
              [-7628882.132348719, 5479357.5913040275],
              [-7630780.997696971, 5485535.389384631],
              [-7649977.487286817, 5483296.293530839],
              [-7661950.343799596, 5497843.67374967],
              [-7669510.384377841, 5497987.79366694],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dallas',
        GEOID: '01047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9737458.723719282, 3803757.824339029],
              [-9731744.026339918, 3803821.966940539],
              [-9731900.875502447, 3826875.595132747],
              [-9697131.791026039, 3827797.1446554307],
              [-9686772.95581027, 3859458.6421172367],
              [-9686761.601222208, 3850693.375109905],
              [-9675622.41637598, 3850812.3835077295],
              [-9674376.528635023, 3833970.454551767],
              [-9664191.797102854, 3808129.9253402846],
              [-9669697.102520037, 3799452.2336371485],
              [-9663679.838764697, 3792848.4539718693],
              [-9674587.924348038, 3792885.43056291],
              [-9674438.08831343, 3769609.083507057],
              [-9704594.983647292, 3769549.1952179265],
              [-9720950.377193112, 3789469.986421],
              [-9737361.430484328, 3798135.819733735],
              [-9737458.723719282, 3803757.824339029],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lafayette',
        GEOID: '28071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9987733.993409658, 4103472.53206292],
              [-9981845.97158313, 4103485.1023071166],
              [-9960494.225332035, 4103458.204704949],
              [-9954685.24034397, 4098723.2016516603],
              [-9943704.79709161, 4099648.045645499],
              [-9934834.080828767, 4095549.1799486154],
              [-9934857.012643872, 4079853.107187157],
              [-9934761.945798734, 4050465.9570474736],
              [-9964179.568394238, 4050586.4978028466],
              [-9964145.281991074, 4054472.200939294],
              [-9987701.599437837, 4054685.5104298475],
              [-9987733.993409658, 4103472.53206292],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cayuga',
        GEOID: '36011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8542294.821935827, 5307450.166232142],
              [-8539741.820733974, 5315630.934859753],
              [-8538463.650340686, 5324180.833892682],
              [-8540654.258255377, 5363496.970012454],
              [-8536519.12147551, 5365810.0233457815],
              [-8530498.740774427, 5375101.988349607],
              [-8528989.218709946, 5376147.110786269],
              [-8527630.928052612, 5350647.775077169],
              [-8513628.271944707, 5346666.927203061],
              [-8515043.921909126, 5312727.448886393],
              [-8510457.22492997, 5288524.336060228],
              [-8500019.464195227, 5289084.604037996],
              [-8490857.75878345, 5277219.3875385085],
              [-8489845.975931631, 5254852.478584764],
              [-8511310.154868428, 5254100.160149192],
              [-8534480.527640611, 5254832.660055236],
              [-8541726.647254817, 5269561.7655450255],
              [-8542294.821935827, 5307450.166232142],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stutsman',
        GEOID: '38093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11074143.76206517, 5995625.571924401],
              [-11050271.742542515, 5995644.951499848],
              [-10964885.90824139, 5995537.214747734],
              [-10961325.799606329, 5995343.423348148],
              [-10961349.288018884, 5981410.8199243],
              [-10958231.229081767, 5938754.372122383],
              [-10958185.58809054, 5882069.953234321],
              [-11024706.664884387, 5881922.5968452925],
              [-11070692.189933633, 5882152.62951988],
              [-11070325.16957249, 5938955.228508232],
              [-11074143.76206517, 5995625.571924401],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cumberland',
        GEOID: '34011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8395393.956967764, 4777533.789004615],
              [-8389951.09315898, 4787270.8059398215],
              [-8375504.160963322, 4802068.423274695],
              [-8357906.66453923, 4787831.811027446],
              [-8355847.365279045, 4803470.106460432],
              [-8347322.184715623, 4795706.926658008],
              [-8332933.4726136485, 4782583.147918339],
              [-8333521.128205546, 4768162.006195363],
              [-8340733.740653024, 4749940.462105902],
              [-8339516.996973993, 4747013.6710839],
              [-8348739.393152913, 4749104.067282171],
              [-8354359.357645611, 4752547.333131684],
              [-8359068.951342603, 4751912.289821399],
              [-8364175.510343763, 4747758.339580215],
              [-8367515.09506756, 4753604.151056372],
              [-8372618.314483996, 4759379.163358089],
              [-8376163.506307289, 4762678.663617823],
              [-8380724.933762034, 4763615.288750181],
              [-8385335.898390183, 4769407.989420459],
              [-8388542.345002992, 4771617.405751545],
              [-8393412.127447234, 4776176.958346052],
              [-8395393.956967764, 4777533.789004615],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '17081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9923865.103483962, 4609544.544638596],
              [-9923507.879238008, 4646586.87329672],
              [-9873923.17241243, 4646734.183318256],
              [-9874304.998265851, 4615747.1220917385],
              [-9874551.57093796, 4597126.795116048],
              [-9921865.805429315, 4597063.399557867],
              [-9924114.793101812, 4597091.276574592],
              [-9923865.103483962, 4609544.544638596],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fayette',
        GEOID: '18041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9495728.89473965, 4835121.6834693905],
              [-9486771.46059348, 4835247.719078614],
              [-9482760.730659688, 4824687.40575315],
              [-9466005.58882243, 4824578.724530712],
              [-9466173.90389251, 4797329.827319528],
              [-9495342.170828635, 4797223.463431672],
              [-9495728.89473965, 4835121.6834693905],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '20105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10963873.234833643, 4753202.245455686],
              [-10901489.458234617, 4753129.395493434],
              [-10901357.433318539, 4715713.764275752],
              [-10901360.995542243, 4703224.393313618],
              [-10963284.577366326, 4703180.355169527],
              [-10963167.914539976, 4738047.129826341],
              [-10963856.314271042, 4740697.142684218],
              [-10963873.234833643, 4753202.245455686],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chattooga',
        GEOID: '13055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9520810.38028755, 4108124.7110695024],
              [-9502275.705312693, 4107222.33194812],
              [-9474151.169922248, 4107962.0843825755],
              [-9482255.228851996, 4087496.965234904],
              [-9499435.499824595, 4078558.864514281],
              [-9505276.433506519, 4067282.862369272],
              [-9513713.318207871, 4067295.5255441284],
              [-9515049.870812593, 4075044.367577907],
              [-9518091.53328664, 4092698.6454316997],
              [-9519268.539785383, 4099374.09357169],
              [-9520810.38028755, 4108124.7110695024],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '17135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9985541.444718994, 4796919.3872815],
              [-9966840.883460632, 4797095.885983303],
              [-9966527.073816085, 4771767.260611426],
              [-9922997.924650682, 4771770.715504838],
              [-9923027.869593706, 4752933.119909657],
              [-9935321.660198443, 4752876.364504639],
              [-9935313.97915358, 4725709.92308723],
              [-9972706.196111038, 4725730.271498076],
              [-9978597.334883308, 4721546.810071514],
              [-9985197.467492443, 4721525.324145835],
              [-9985541.444718994, 4796919.3872815],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oktibbeha',
        GEOID: '28105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9917279.553728122, 3966202.019856784],
              [-9917280.444284048, 3966293.3650469864],
              [-9917260.072817234, 3970145.0773015274],
              [-9909506.670283483, 3970155.096608654],
              [-9881897.544135408, 3970568.968391668],
              [-9870869.122182518, 3970558.681534106],
              [-9870838.398003059, 3962683.6432259097],
              [-9870596.389430074, 3933450.280307811],
              [-9886623.835756017, 3933383.96282659],
              [-9903645.699093217, 3933341.8820508244],
              [-9917259.182261307, 3933327.8995482987],
              [-9917303.376099152, 3954629.859500414],
              [-9917279.553728122, 3966202.019856784],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Guayama',
        GEOID: '72057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7369972.789107225, 2039067.886829836],
              [-7365581.569153905, 2043409.163468547],
              [-7362558.35442294, 2041870.0672814972],
              [-7361450.057572601, 2047925.962024816],
              [-7353002.578013754, 2050110.8309909853],
              [-7357038.243513484, 2044134.262118135],
              [-7356243.867627183, 2041406.5813860754],
              [-7357500.775997729, 2040023.4441056727],
              [-7354667.62833523, 2031182.666665527],
              [-7358065.611094014, 2032625.4972846222],
              [-7364383.994071949, 2029287.2927639317],
              [-7371635.756914196, 2027930.632481206],
              [-7369972.789107225, 2039067.886829836],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dickinson',
        GEOID: '20041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10840426.153435385, 4711492.218712868],
              [-10839358.488199187, 4715636.030171608],
              [-10839307.281233422, 4740591.519174572],
              [-10793891.489338055, 4740640.168996367],
              [-10793924.105948858, 4716645.188288985],
              [-10789776.23040241, 4718655.500278235],
              [-10789832.001467299, 4703117.300886332],
              [-10785772.73623552, 4703076.8376861755],
              [-10789890.332880473, 4694800.709066843],
              [-10790230.079966374, 4665869.500606155],
              [-10839391.550087953, 4665868.218482266],
              [-10840426.153435385, 4711492.218712868],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Spencer',
        GEOID: '18147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9714629.65650587, 4568803.216736552],
              [-9701882.684254114, 4586998.768329782],
              [-9694847.403755471, 4586311.16834185],
              [-9692847.66042286, 4596148.311029313],
              [-9686738.558087613, 4596151.282424222],
              [-9686742.676908774, 4608224.891647435],
              [-9661585.25122593, 4608444.467926331],
              [-9659455.709367055, 4579166.59215629],
              [-9662341.778485361, 4581619.6307788715],
              [-9664052.418564292, 4578865.635175497],
              [-9670978.055900594, 4575297.416715522],
              [-9676752.531846514, 4570241.347610255],
              [-9682317.885792283, 4568934.91362463],
              [-9685943.959562333, 4568083.80269822],
              [-9689587.89177396, 4561789.433720884],
              [-9691233.97308432, 4555079.866348568],
              [-9696552.59571544, 4546651.673151812],
              [-9700102.351637857, 4552234.344885425],
              [-9704840.220485508, 4557041.591780158],
              [-9713209.999039782, 4560700.343057642],
              [-9714895.08756122, 4561842.1533145355],
              [-9714629.65650587, 4568803.216736552],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Beauregard',
        GEOID: '22011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10430932.953772698, 3558936.1072809775],
              [-10431762.50661809, 3568810.3408819763],
              [-10433886.259863442, 3573778.222794404],
              [-10428891.799589511, 3579950.9468994327],
              [-10428979.96462622, 3584169.4218005096],
              [-10422833.236303087, 3591252.646118344],
              [-10421473.357403558, 3598832.034391567],
              [-10416087.163841525, 3607187.2667515525],
              [-10414897.603762908, 3615802.9495013137],
              [-10414447.745486427, 3616846.4287503874],
              [-10406003.287768018, 3614474.846931578],
              [-10399589.50398647, 3617581.6698288866],
              [-10350314.04270632, 3616937.934077799],
              [-10350393.858781217, 3580695.0750325155],
              [-10367216.905507859, 3580636.36050143],
              [-10367312.751589432, 3558118.262289182],
              [-10367307.630892856, 3555464.9887551987],
              [-10395587.34565347, 3555409.8768092813],
              [-10395534.246256363, 3566705.638097977],
              [-10406856.662984438, 3566759.1201342344],
              [-10406826.829360904, 3555393.0980445617],
              [-10434926.567024104, 3555362.59591838],
              [-10430932.953772698, 3558936.1072809775],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Divide',
        GEOID: '38023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11582652.309203753, 6274840.523505819],
              [-11507704.346956855, 6274683.402528699],
              [-11459092.240685059, 6274751.145793494],
              [-11459220.812534207, 6227563.247369911],
              [-11453182.175436635, 6227566.453318332],
              [-11453192.082871316, 6212867.252601584],
              [-11582580.126176316, 6212987.584203432],
              [-11582670.565600242, 6249005.7226573555],
              [-11582652.309203753, 6274840.523505819],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'LaSalle',
        GEOID: '17099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9926047.299461985, 5105522.80016086],
              [-9900601.667617474, 5105465.015766524],
              [-9887200.470718326, 5105916.577303849],
              [-9875424.093106797, 5105788.4937074715],
              [-9863156.239943415, 5105922.236851017],
              [-9862457.153541232, 5079989.603310198],
              [-9861375.128090722, 5028328.002622406],
              [-9899740.388717208, 5027974.460595381],
              [-9899797.05033802, 5001689.165741317],
              [-9912746.62406302, 5001395.819488675],
              [-9912761.986152751, 5027809.143859522],
              [-9925494.820829175, 5027693.172674256],
              [-9925658.23784166, 5058202.397977884],
              [-9925976.166307366, 5099058.763651384],
              [-9926047.299461985, 5105522.80016086],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Genesee',
        GEOID: '36037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8734740.061437061, 5331569.5060845325],
              [-8682618.606055288, 5332234.865131902],
              [-8672448.90265438, 5332323.33918952],
              [-8672247.08041757, 5317613.849915043],
              [-8672882.82602949, 5310109.284029496],
              [-8677969.904119762, 5297653.890665308],
              [-8677906.897287972, 5291104.88337782],
              [-8691176.959826965, 5292233.963282741],
              [-8734614.93832941, 5291819.769269856],
              [-8734622.508054784, 5325483.108755265],
              [-8734740.061437061, 5331569.5060845325],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hormigueros',
        GEOID: '72067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7476187.279372212, 2055491.313424739],
              [-7469357.717292553, 2056114.9147936634],
              [-7468019.323054746, 2055093.240049888],
              [-7467428.327878123, 2050043.1359124712],
              [-7469592.601418126, 2050005.657764345],
              [-7472431.471072337, 2051016.3034176233],
              [-7476187.279372212, 2055491.313424739],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McDowell',
        GEOID: '37111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9158855.521493409, 4260028.338496708],
              [-9156901.085193552, 4259262.600139991],
              [-9149727.657206833, 4264261.841294452],
              [-9143057.615957482, 4276336.120358319],
              [-9125990.55690702, 4284815.385567815],
              [-9126189.373517578, 4288431.626784716],
              [-9121873.962137485, 4295125.705111169],
              [-9117806.793221863, 4284585.932573211],
              [-9126738.289926678, 4274106.322572185],
              [-9113658.583716942, 4262110.332392728],
              [-9108619.595646692, 4242296.183743205],
              [-9110661.863024786, 4237818.887991122],
              [-9124593.608617056, 4235595.1503655715],
              [-9147016.693647545, 4235841.906109828],
              [-9160595.111176036, 4244532.642646803],
              [-9158855.521493409, 4260028.338496708],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Republic',
        GEOID: '20157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10901720.883253645, 4866267.264388736],
              [-10889439.659056272, 4866260.076337626],
              [-10884503.105814982, 4866257.187034534],
              [-10844280.924762575, 4866233.063630661],
              [-10839089.655560171, 4866224.098133224],
              [-10839030.763618292, 4815795.37585694],
              [-10901682.708870638, 4815755.469826718],
              [-10901720.883253645, 4866267.264388736],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McCreary',
        GEOID: '21147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9420140.28882324, 4410422.495569785],
              [-9415571.29164312, 4411777.941585357],
              [-9415197.480793037, 4420602.98702623],
              [-9397236.971509468, 4431710.700053388],
              [-9390692.27600675, 4433449.180725056],
              [-9391591.403533887, 4431223.614367547],
              [-9383945.42430875, 4431572.943212515],
              [-9386240.498250438, 4415960.754250169],
              [-9390463.291814188, 4412797.906845405],
              [-9385078.87936401, 4394153.363773161],
              [-9376128.342795936, 4382413.299098093],
              [-9376143.709115995, 4382413.505355549],
              [-9379927.36971997, 4382491.2446153965],
              [-9406490.070223188, 4383037.018949762],
              [-9437494.537059514, 4383942.823109911],
              [-9420140.28882324, 4410422.495569785],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kearny',
        GEOID: '20093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11303638.465811713, 4616675.151252658],
              [-11257232.264406757, 4616859.7463079905],
              [-11254764.31129587, 4616866.55171889],
              [-11254821.084236177, 4555302.264958721],
              [-11253250.254901592, 4542245.739696691],
              [-11301940.954896605, 4542242.5021741595],
              [-11303688.002985114, 4555099.174531137],
              [-11303638.465811713, 4616675.151252658],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Major',
        GEOID: '40093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11016213.989612276, 4370598.016100842],
              [-11003224.34087059, 4370505.779426962],
              [-10999236.208793432, 4364205.648902421],
              [-10978924.965822782, 4354777.177615196],
              [-10968704.61205356, 4355468.235717652],
              [-10968712.070459444, 4364549.745638428],
              [-10920934.85820588, 4364532.443648541],
              [-10920876.638112193, 4323331.97351643],
              [-10932747.748610388, 4323333.766051659],
              [-10980209.370107554, 4323334.3176010195],
              [-11015714.72169607, 4322876.954958447],
              [-11016213.989612276, 4370598.016100842],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bristol',
        GEOID: '44001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7944338.503596563, 5121462.831053733],
              [-7939016.876222088, 5127671.667311579],
              [-7932781.870659859, 5123947.248857404],
              [-7926905.15142351, 5114701.566944637],
              [-7932262.676554798, 5106927.30618465],
              [-7940527.258190272, 5114202.6001984645],
              [-7944338.503596563, 5121462.831053733],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '18177',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9484525.812505707, 4847620.005893613],
              [-9484584.589196846, 4866599.280653249],
              [-9441023.96316241, 4866678.7084928835],
              [-9441163.765738208, 4853875.730184792],
              [-9441465.556390135, 4826294.102870826],
              [-9464664.522916844, 4826665.002868604],
              [-9466005.58882243, 4824578.724530712],
              [-9482760.730659688, 4824687.40575315],
              [-9486771.46059348, 4835247.719078614],
              [-9484525.812505707, 4847620.005893613],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Boundary',
        GEOID: '16021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13027981.719659662, 6274723.615718784],
              [-12997355.835311087, 6274851.722304694],
              [-12959537.153384399, 6274878.192251939],
              [-12918537.071730327, 6275016.142742015],
              [-12918533.010867551, 6190786.950896241],
              [-13000433.151314575, 6190523.105022161],
              [-13000466.101883851, 6249008.260077945],
              [-13028047.195793422, 6248884.08319229],
              [-13027981.719659662, 6274723.615718784],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Palo Alto',
        GEOID: '19147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10565747.313653816, 5350874.596062465],
              [-10513361.919759374, 5350868.48221679],
              [-10513341.54829256, 5297990.0710347975],
              [-10565765.90400878, 5298237.350643307],
              [-10565747.313653816, 5350874.596062465],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stanislaus',
        GEOID: '06099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13522192.836678717, 4506475.583751959],
              [-13496510.762235764, 4532069.682289881],
              [-13481908.984628413, 4543060.923575736],
              [-13469179.266897729, 4545602.18401809],
              [-13460863.366976997, 4542472.368773379],
              [-13461470.726118764, 4590368.584148794],
              [-13431061.024221312, 4555700.1420184],
              [-13401487.77697768, 4527808.923265699],
              [-13401494.122188656, 4527761.130516291],
              [-13468524.15169441, 4494430.687306016],
              [-13465629.956253277, 4487465.250749191],
              [-13494906.09177598, 4457909.2311748145],
              [-13501080.64997181, 4464739.730631559],
              [-13514125.067902965, 4460089.437750879],
              [-13520759.709554246, 4478590.575466947],
              [-13514826.603333946, 4482543.888784739],
              [-13522273.32067056, 4506529.872612531],
              [-13522192.836678717, 4506475.583751959],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crawford',
        GEOID: '20037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10585149.076384686, 4533547.751495888],
              [-10532813.381176883, 4533349.683748756],
              [-10532810.38372773, 4530602.901531534],
              [-10532773.144646961, 4496538.022950006],
              [-10532790.57780251, 4489989.7286184905],
              [-10532800.183216926, 4486383.456818987],
              [-10583719.066205956, 4486596.138293546],
              [-10585168.779934557, 4492744.618848574],
              [-10585149.076384686, 4533547.751495888],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Houghton',
        GEOID: '26061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9906269.05421325, 5890016.760267386],
              [-9892347.883972608, 5889885.65795159],
              [-9892284.765821328, 5903802.206131515],
              [-9899918.388582986, 5903765.478479305],
              [-9900017.29053394, 5947560.025800089],
              [-9899029.168490529, 5948957.721200756],
              [-9895093.801852005, 5958505.9512671735],
              [-9886822.095769119, 5965184.605870086],
              [-9874000.984736495, 5975572.027997654],
              [-9861227.29580695, 5981723.670400321],
              [-9853216.133619674, 5988899.737491447],
              [-9829398.826999336, 5988898.055777373],
              [-9829336.933362456, 5974744.765154713],
              [-9818429.256982181, 5974734.098579303],
              [-9822820.179051924, 5964863.349046527],
              [-9833969.605291309, 5955222.653335326],
              [-9839040.653374905, 5942812.209163893],
              [-9845024.875940649, 5932609.263777756],
              [-9857584.142831758, 5932046.858374099],
              [-9857557.203514986, 5917916.706445444],
              [-9871687.65439832, 5917917.683092402],
              [-9871744.761297097, 5847934.320844697],
              [-9906459.076584036, 5847864.076796777],
              [-9906269.05421325, 5890016.760267386],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Joaquin',
        GEOID: '06077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13534226.139674999, 4592771.94355752],
              [-13522216.547730258, 4616172.139429074],
              [-13519545.325229183, 4615512.788811618],
              [-13513985.027983546, 4611603.6256573945],
              [-13501080.204693846, 4614779.628005191],
              [-13494428.308521494, 4614009.950351261],
              [-13472673.363074746, 4621928.612993237],
              [-13469157.114319062, 4611316.672899656],
              [-13463214.434622554, 4593042.680027029],
              [-13461470.726118764, 4590368.584148794],
              [-13460863.366976997, 4542472.368773379],
              [-13469179.266897729, 4545602.18401809],
              [-13481908.984628413, 4543060.923575736],
              [-13496510.762235764, 4532069.682289881],
              [-13522192.836678717, 4506475.583751959],
              [-13531624.93713363, 4515029.056851703],
              [-13531658.778258834, 4543190.8577569015],
              [-13531663.008399483, 4553534.059634938],
              [-13529121.58442467, 4558119.7258192655],
              [-13534226.139674999, 4592771.94355752],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kent',
        GEOID: '26081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9550148.986286815, 5356676.7646927545],
              [-9524778.16114012, 5356870.696580335],
              [-9496930.254684294, 5356860.602234062],
              [-9496916.228428451, 5343446.789258437],
              [-9496945.505454531, 5330070.867879832],
              [-9496624.12608461, 5277010.26887256],
              [-9522888.624103395, 5276746.564589],
              [-9549263.996335007, 5276755.814585212],
              [-9549220.359094618, 5290124.149223758],
              [-9549233.828753004, 5298969.652700251],
              [-9549932.46987722, 5316672.822723955],
              [-9550172.808657845, 5343252.678668335],
              [-9550148.986286815, 5356676.7646927545],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Edgar',
        GEOID: '17045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9792639.461347036, 4835812.870757748],
              [-9789173.862959659, 4848490.921472191],
              [-9753277.445999987, 4848755.953719565],
              [-9746857.76228543, 4846883.181498598],
              [-9744068.262144592, 4848954.568434693],
              [-9744095.92571885, 4817360.656544007],
              [-9744060.557600928, 4809039.926784131],
              [-9743980.56332393, 4790245.888232354],
              [-9761341.429913051, 4791724.530468442],
              [-9791682.336365195, 4790851.338513752],
              [-9792397.118815579, 4820406.6074691815],
              [-9792639.461347036, 4835812.870757748],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Obion',
        GEOID: '47131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9956925.879054658, 4333079.625665535],
              [-9947523.05562582, 4357084.381537108],
              [-9945861.536477137, 4369826.522122478],
              [-9930968.622830462, 4370420.191151091],
              [-9903479.610412953, 4369943.928418766],
              [-9889021.214856096, 4369914.755384033],
              [-9888196.227608878, 4369913.090790831],
              [-9886998.648481518, 4357285.638791092],
              [-9901770.188312331, 4357248.153477376],
              [-9902963.978531599, 4331326.465792777],
              [-9903119.046582274, 4328401.624517241],
              [-9924629.534427239, 4328821.420714147],
              [-9961198.766389266, 4329922.514835614],
              [-9956925.879054658, 4333079.625665535],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fall River',
        GEOID: '46047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11583314.500811996, 5384985.362818691],
              [-11570032.797768954, 5385140.0702077355],
              [-11466009.186402272, 5384836.934860865],
              [-11465975.403834797, 5312011.313119684],
              [-11518910.434817052, 5312088.745107143],
              [-11522134.944312112, 5312087.34673944],
              [-11583141.113087825, 5312060.890334451],
              [-11583224.49138643, 5356187.058790436],
              [-11583314.500811996, 5384985.362818691],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kent',
        GEOID: '44003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7991592.339659082, 5119903.945383535],
              [-7954491.397754364, 5120976.526319349],
              [-7948142.401916459, 5126329.475498395],
              [-7945793.004063266, 5124394.30955906],
              [-7944338.503596563, 5121462.831053733],
              [-7940527.258190272, 5114202.6001984645],
              [-7946045.5879878765, 5108743.042733837],
              [-7957610.013288936, 5101634.150024293],
              [-7991554.85182535, 5100779.852639698],
              [-7991554.554297038, 5100788.462410334],
              [-7991566.6425739415, 5107207.366723304],
              [-7991590.399173074, 5119834.702243726],
              [-7991592.339659082, 5119903.945383535],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lee',
        GEOID: '45061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8958976.700355474, 4051476.332644391],
              [-8954245.84463574, 4067067.9684221535],
              [-8944858.494616127, 4069604.92027073],
              [-8937696.309897978, 4077802.429713474],
              [-8932635.05792957, 4072452.055267401],
              [-8925287.860217722, 4078080.776726961],
              [-8918107.975700539, 4055287.508930437],
              [-8923212.530950863, 4050524.74741233],
              [-8913338.046839539, 4040381.25153419],
              [-8908445.777858157, 4038638.7319942284],
              [-8905625.387239415, 4035232.550621721],
              [-8925644.193907753, 4022369.7570457915],
              [-8930978.401267583, 4028154.567722443],
              [-8941373.081359388, 4039596.9839274148],
              [-8959139.338131523, 4043934.452615629],
              [-8958976.700355474, 4051476.332644391],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Deschutes',
        GEOID: '41017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13577072.566403367, 5407906.775975133],
              [-13579449.12621231, 5413239.0971348565],
              [-13576758.645439329, 5428921.613183424],
              [-13578207.468612002, 5443427.203926405],
              [-13572986.5844938, 5451398.473674016],
              [-13566503.44866949, 5451782.144852932],
              [-13565066.202723857, 5460065.805344799],
              [-13555153.53602719, 5483197.834877181],
              [-13557561.59925203, 5504107.3756598085],
              [-13560876.805007344, 5506138.457787796],
              [-13563316.59428706, 5509754.428600183],
              [-13563516.07881456, 5526404.993810426],
              [-13481629.016109064, 5526088.751924203],
              [-13481099.024013398, 5486842.285542015],
              [-13468241.400187794, 5486206.495890355],
              [-13468165.257656092, 5459385.937481199],
              [-13441633.592859404, 5458838.182452421],
              [-13441588.953743597, 5445551.902222558],
              [-13400500.039135873, 5445711.108367196],
              [-13400429.573898202, 5432296.648447268],
              [-13387102.29314094, 5432276.294631997],
              [-13387034.499571048, 5418942.639210847],
              [-13346921.300300125, 5418856.106967652],
              [-13346826.344774477, 5405464.77765232],
              [-13397406.470486728, 5405531.812129817],
              [-13400390.05547897, 5406200.030987985],
              [-13506724.325516047, 5406307.510181484],
              [-13581240.813416628, 5406131.146553841],
              [-13577072.566403367, 5407906.775975133],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ford',
        GEOID: '20057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11157228.622491602, 4567286.550377815],
              [-11084068.228627864, 4567145.167952116],
              [-11084145.818312945, 4554822.944090344],
              [-11082921.749192182, 4542041.777741405],
              [-11082536.472434549, 4504503.27914755],
              [-11106847.869987365, 4504458.678298562],
              [-11143887.872075954, 4505501.097428691],
              [-11156019.581502095, 4505550.752379245],
              [-11155842.360872753, 4554988.399605866],
              [-11157228.622491602, 4567286.550377815],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mercer',
        GEOID: '42085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8963355.974650418, 5032036.095144004],
              [-8963322.16799808, 5046704.372220513],
              [-8963334.093807, 5061658.306113395],
              [-8963352.465812268, 5084740.637324715],
              [-8919509.376770135, 5083460.14141766],
              [-8905534.66185442, 5084894.71651421],
              [-8905534.66185442, 5037724.266669514],
              [-8916341.780659612, 5022643.196397294],
              [-8921941.485004986, 5029140.917451456],
              [-8934302.0673042, 5031234.686303944],
              [-8963358.801693033, 5030810.4826908745],
              [-8963355.974650418, 5032036.095144004],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grant',
        GEOID: '35017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12139082.89308681, 3923064.223194104],
              [-12082971.304043654, 3922939.1534425225],
              [-12072597.440696629, 3922013.444009154],
              [-12022571.57472904, 3922047.501575133],
              [-12006769.327732971, 3921995.7500786358],
              [-12004269.982525682, 3904301.8262083186],
              [-12006549.805697128, 3895640.978027502],
              [-11998075.72077998, 3889037.443455828],
              [-11997245.277378662, 3875911.085309102],
              [-11991489.948385159, 3865884.308135943],
              [-11993222.302300883, 3846228.120308754],
              [-11978921.755235616, 3843050.2559953285],
              [-12014044.390414786, 3842908.8611941803],
              [-12014018.67561241, 3831422.8027483434],
              [-12048035.351650547, 3831346.3658048306],
              [-12046657.327674018, 3773798.458367237],
              [-12046677.253862869, 3745489.9422305445],
              [-12080896.308735268, 3745421.1297847116],
              [-12082358.82420531, 3773794.3855849043],
              [-12082284.796743933, 3831317.4545504],
              [-12094503.112733912, 3831304.6491314513],
              [-12094475.616819685, 3842823.100123679],
              [-12117451.514441453, 3842776.057335033],
              [-12117636.527435152, 3865778.255224682],
              [-12139069.543850843, 3865846.838771723],
              [-12139082.89308681, 3923064.223194104],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Conway',
        GEOID: '05029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10357244.348925145, 4178697.0244325097],
              [-10341147.550556438, 4187099.860594862],
              [-10336617.069920134, 4187402.049604996],
              [-10336084.183517706, 4226973.534339016],
              [-10294757.490477646, 4225961.375402329],
              [-10294990.036893914, 4214057.525747452],
              [-10300178.081762334, 4195257.5004558675],
              [-10299440.144857867, 4179478.9529478448],
              [-10303140.404731834, 4179285.711046503],
              [-10310280.659510298, 4174488.1314566717],
              [-10357223.86613884, 4174339.5922543765],
              [-10357244.348925145, 4178697.0244325097],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Warren',
        GEOID: '42123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8862375.316037431, 5138544.9560808055],
              [-8862237.700098446, 5160757.735441714],
              [-8846835.11512269, 5160718.055096527],
              [-8801059.694832126, 5160805.400138249],
              [-8792354.577092027, 5160822.010646973],
              [-8785207.015704634, 5160845.108509315],
              [-8784863.88855655, 5137176.151451227],
              [-8788527.85827652, 5135619.897261604],
              [-8789347.948965192, 5104801.4137342],
              [-8789346.39049232, 5104732.7627305435],
              [-8851243.144319123, 5104905.061298693],
              [-8862464.482949557, 5104800.669143675],
              [-8862375.316037431, 5138544.9560808055],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Falls Church',
        GEOID: '51610',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8593276.031773405, 4707224.939540821],
              [-8592623.922196336, 4706824.299105356],
              [-8590778.467677968, 4706391.350573536],
              [-8588265.430173308, 4703877.981838698],
              [-8589233.575784737, 4703521.369806612],
              [-8590886.113625564, 4704297.524605089],
              [-8592724.10973805, 4704230.602511916],
              [-8593226.049322037, 4705368.624066238],
              [-8592735.241687132, 4706555.831654566],
              [-8593276.031773405, 4707224.939540821],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Martinsville',
        GEOID: '51690',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8894881.163946522, 4395169.145611513],
              [-8892341.187125092, 4398974.675590201],
              [-8890621.7462703, 4399119.787411027],
              [-8887454.150159776, 4397947.145955045],
              [-8888164.145872055, 4393547.383076683],
              [-8886258.578828657, 4391734.365364971],
              [-8886794.470857335, 4389922.487765979],
              [-8887526.841787264, 4391722.708867667],
              [-8888151.78940858, 4389586.176705377],
              [-8889947.929392526, 4390484.000984409],
              [-8889892.15832764, 4392061.5850865],
              [-8893779.546265634, 4393490.895102861],
              [-8894881.163946522, 4395169.145611513],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Park',
        GEOID: '30067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12361396.995963333, 5621660.025766315],
              [-12360712.431697454, 5677011.488450326],
              [-12347324.036539748, 5676992.796799334],
              [-12347471.312226068, 5704532.066877373],
              [-12340684.1628724, 5704534.926928715],
              [-12340587.314915411, 5714991.513453994],
              [-12333617.824235827, 5714996.603946868],
              [-12333171.767036218, 5803109.351337714],
              [-12332399.877687057, 5811283.327322701],
              [-12290703.826576548, 5811181.373310192],
              [-12276526.732826568, 5809948.369636293],
              [-12277732.990828807, 5801824.6220214],
              [-12277722.972074635, 5745971.105385653],
              [-12269735.353332251, 5745957.696333302],
              [-12269568.819374027, 5676600.914717131],
              [-12270530.619774481, 5648660.501439633],
              [-12252326.098167093, 5648660.501439633],
              [-12224241.86043231, 5648660.501439633],
              [-12222732.368137155, 5647904.170088413],
              [-12222711.303420976, 5621981.24068036],
              [-12244592.955780666, 5622021.181372956],
              [-12281260.594172554, 5621388.616644294],
              [-12323654.507170845, 5620313.138028544],
              [-12332530.67808874, 5621986.230147966],
              [-12361392.148508238, 5621733.231400162],
              [-12361396.995963333, 5621660.025766315],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '12019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9133698.652408019, 3527601.0396377877],
              [-9099135.397670088, 3527908.5794295804],
              [-9096065.651391974, 3528149.6711136173],
              [-9092534.374505028, 3528059.7763494626],
              [-9092599.941685105, 3519143.6540755234],
              [-9093623.858361423, 3507565.315112798],
              [-9083780.655027008, 3497897.4908730783],
              [-9081578.421540644, 3483022.457069884],
              [-9107306.916211259, 3482548.141556327],
              [-9118097.114453852, 3477041.4112553596],
              [-9121455.289532611, 3471134.054044356],
              [-9133680.062053056, 3467438.5114110517],
              [-9133331.409407891, 3471086.870756417],
              [-9133700.21088089, 3521961.9422411923],
              [-9133698.652408019, 3527601.0396377877],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wright',
        GEOID: '29229',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10317833.019043675, 4506442.196943751],
              [-10269474.71904817, 4505235.713940437],
              [-10269374.308867473, 4447424.911105524],
              [-10317743.518173078, 4448456.9574388275],
              [-10317833.019043675, 4506442.196943751],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mahoning',
        GEOID: '39099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9026486.962144507, 5010576.399341721],
              [-9017067.440792054, 5010539.826107757],
              [-9017141.46825343, 5021504.685747519],
              [-9017133.675889077, 5032154.704413028],
              [-8963355.974650418, 5032036.095144004],
              [-8963358.801693033, 5030810.4826908745],
              [-8963405.743615746, 5010482.261001828],
              [-8963433.264849892, 4998583.915664743],
              [-8963430.894600362, 4997650.565202894],
              [-8997055.313293165, 4997740.56171464],
              [-9005280.710467879, 5002049.709380539],
              [-9005305.089436363, 4997749.398436529],
              [-9026527.816397628, 4997839.828017931],
              [-9026486.962144507, 5010576.399341721],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Miami',
        GEOID: '39109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9398991.25536488, 4894616.607412618],
              [-9375178.123852855, 4895049.023541896],
              [-9353388.55804447, 4892708.780747158],
              [-9354852.409348402, 4871783.13746109],
              [-9356515.856499327, 4848491.936907939],
              [-9368338.543019027, 4849389.042358804],
              [-9368389.082067845, 4854754.795622694],
              [-9398248.420402816, 4854268.833060258],
              [-9398991.25536488, 4894616.607412618],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Travis',
        GEOID: '48453',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10923286.927726848, 3558450.557858179],
              [-10923049.149294516, 3566237.0986826997],
              [-10914863.381858524, 3584034.1084754653],
              [-10904493.748652147, 3584563.7274774606],
              [-10893447.62690022, 3568191.464057774],
              [-10892432.281824695, 3564451.977531115],
              [-10884091.55765752, 3559027.3838839876],
              [-10864363.294860153, 3568178.931793948],
              [-10839127.500255791, 3557595.566448436],
              [-10842528.310699526, 3550928.9331005644],
              [-10852676.752077695, 3530843.847629539],
              [-10852687.43874881, 3530820.660611228],
              [-10870278.144683965, 3512286.4043184766],
              [-10872102.782457555, 3511761.3522540103],
              [-10877051.37910128, 3506699.3503929777],
              [-10884972.206149187, 3513280.229469419],
              [-10888495.356713302, 3516231.9335217355],
              [-10893409.332995389, 3520425.0378918904],
              [-10893416.123484327, 3520430.7011847077],
              [-10928565.809299758, 3549433.1447551795],
              [-10923286.927726848, 3558450.557858179],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Merrick',
        GEOID: '31121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10941212.482690308, 5070616.292663933],
              [-10939968.376061205, 5051410.436029219],
              [-10920614.146752903, 5051366.007544066],
              [-10915225.281523092, 5055673.85451402],
              [-10876526.173743717, 5058046.345284847],
              [-10876333.368385663, 5070761.419252261],
              [-10864610.98072717, 5070789.910618042],
              [-10864587.826273084, 5061601.5042279335],
              [-10865267.988361832, 5058745.415787009],
              [-10871300.50288741, 5057413.268474071],
              [-10890191.64311401, 5037957.63365664],
              [-10895291.968223684, 5030522.969928715],
              [-10910484.295729697, 5023079.825771376],
              [-10940766.536810191, 4992990.805530157],
              [-10940746.165343376, 5016265.5071592145],
              [-10941277.493272932, 5019182.602803698],
              [-10941212.482690308, 5070616.292663933],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shelby',
        GEOID: '21211',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9514277.170934608, 4619809.179074618],
              [-9498274.660174603, 4623327.3408769695],
              [-9493669.261520995, 4630131.048185408],
              [-9461897.009056231, 4626941.932857962],
              [-9457365.41522502, 4626471.484395992],
              [-9462034.043349398, 4618344.283065494],
              [-9464796.213874452, 4597672.607342948],
              [-9467475.896656828, 4589650.216401146],
              [-9473471.898389427, 4584692.152589061],
              [-9483988.362004159, 4590001.050793855],
              [-9488028.035005555, 4592067.128417993],
              [-9509362.192777105, 4600274.845603836],
              [-9507229.86793096, 4616749.300788981],
              [-9514277.170934608, 4619809.179074618],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marshall',
        GEOID: '54051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9002399.76204615, 4831641.991640822],
              [-8997394.392462121, 4837079.471645328],
              [-8997317.248055002, 4843756.6361425705],
              [-8997223.97398643, 4844173.223119576],
              [-8994992.674448257, 4854144.0078026615],
              [-8990660.676464036, 4858715.376587315],
              [-8987949.712904748, 4861698.905138067],
              [-8987737.364295065, 4870817.887631429],
              [-8963347.43752249, 4868327.2226065975],
              [-8963351.978724808, 4860450.813601163],
              [-8963372.150449445, 4825539.530702699],
              [-8998569.112874214, 4825228.195957899],
              [-9002399.76204615, 4831641.991640822],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hardy',
        GEOID: '54031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8809189.535004184, 4694969.288700689],
              [-8799455.42477075, 4711250.386424596],
              [-8804220.121615684, 4727146.019405794],
              [-8792002.028264685, 4755766.554487558],
              [-8752334.106956936, 4738661.214346906],
              [-8745401.908306768, 4740517.3250595145],
              [-8739485.277371107, 4734375.022777717],
              [-8742171.882729342, 4729232.458565867],
              [-8745449.66436832, 4722961.830178522],
              [-8751988.793896498, 4719179.6214628825],
              [-8758797.539231377, 4711054.34909366],
              [-8768947.205123944, 4706462.434679165],
              [-8774332.174171578, 4697490.030195319],
              [-8779687.643554153, 4687778.704921804],
              [-8794130.01165069, 4698789.366174378],
              [-8796806.020889869, 4692865.529179977],
              [-8800613.147475, 4687553.425160462],
              [-8809189.535004184, 4694969.288700689],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Putnam',
        GEOID: '12107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9133870.529701805, 3465374.8691897765],
              [-9134390.391723808, 3467382.369196154],
              [-9133680.062053056, 3467438.5114110517],
              [-9121455.289532611, 3471134.054044356],
              [-9118097.114453852, 3477041.4112553596],
              [-9107306.916211259, 3482548.141556327],
              [-9081578.421540644, 3483022.457069884],
              [-9075347.09040451, 3472672.7344415993],
              [-9075299.668301433, 3467812.286374412],
              [-9075172.318803964, 3455108.739110891],
              [-9074831.235884173, 3439471.9081557267],
              [-9069966.240178034, 3426215.6890613497],
              [-9065190.522703514, 3426471.233244804],
              [-9066514.556727009, 3424119.1387706143],
              [-9092676.529494772, 3417003.864473427],
              [-9099413.47375809, 3422957.5578479376],
              [-9103285.499606352, 3437834.745020057],
              [-9110722.086869305, 3442126.7750885654],
              [-9128686.381015562, 3439659.4130537612],
              [-9134420.893264286, 3435761.1229310245],
              [-9133870.529701805, 3465374.8691897765],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Río Grande',
        GEOID: '72119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7332330.659892934, 2081863.815924447],
              [-7327910.21607516, 2087420.5467666725],
              [-7321671.596010496, 2085157.8176108187],
              [-7318343.306351048, 2084208.0925634457],
              [-7321530.888174135, 2080449.7852050115],
              [-7320242.921665655, 2071591.4362414149],
              [-7321130.138007278, 2070348.6988337396],
              [-7327518.652264413, 2069533.9263803586],
              [-7328873.0765088955, 2069790.8985713362],
              [-7332378.304634994, 2071967.7896344308],
              [-7332330.659892934, 2081863.815924447],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ellis',
        GEOID: '20051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11086505.791517764, 4740648.349077898],
              [-11025938.081091542, 4740742.6357587995],
              [-11024804.069438832, 4740757.99151159],
              [-11025374.693148637, 4678334.3617822975],
              [-11085761.175443847, 4678295.851155733],
              [-11087234.600223986, 4678292.570627597],
              [-11086505.791517764, 4740648.349077898],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hettinger',
        GEOID: '38041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11457892.882328534, 5881898.929273102],
              [-11365339.853932172, 5882054.390726517],
              [-11360291.737663679, 5882035.2618484935],
              [-11359812.173297342, 5825914.344103432],
              [-11354352.954149349, 5813338.900357842],
              [-11409966.724596288, 5813434.927782382],
              [-11409963.830289528, 5825848.302241574],
              [-11457508.162168352, 5825578.180063814],
              [-11457892.882328534, 5881898.929273102],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Codington',
        GEOID: '46029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10853010.710550075, 5645424.354691377],
              [-10825723.297730392, 5645351.587138857],
              [-10823180.092643728, 5645455.135069695],
              [-10785071.757401993, 5645202.265544494],
              [-10784893.312258253, 5617880.875778236],
              [-10785140.998125268, 5590786.300676137],
              [-10852686.993470848, 5590723.386028181],
              [-10853010.710550075, 5645424.354691377],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Davidson',
        GEOID: '47037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9689400.095792992, 4306307.329478149],
              [-9680716.730233153, 4337423.180257913],
              [-9674359.942030892, 4351130.116868453],
              [-9675136.84075714, 4353397.960111526],
              [-9665320.68805899, 4348863.028082929],
              [-9657499.603274835, 4356561.406942498],
              [-9644619.938190054, 4335780.441182381],
              [-9639631.823127098, 4334400.065641651],
              [-9635466.136462124, 4319207.585577328],
              [-9630871.313160138, 4314473.998417551],
              [-9634355.056624515, 4312711.593447424],
              [-9642370.950517558, 4296249.9238748],
              [-9661516.010502657, 4305674.476139646],
              [-9676876.541759258, 4307908.5569783375],
              [-9689161.983402185, 4299147.242293377],
              [-9690776.004699195, 4306895.198938644],
              [-9689400.095792992, 4306307.329478149],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Knox',
        GEOID: '48275',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11131552.114023188, 4006797.6109793535],
              [-11113597.28203365, 4006775.230108489],
              [-11098631.712330384, 4001973.467001787],
              [-11082401.441892216, 4001784.985538847],
              [-11073450.46427651, 3993120.1918941448],
              [-11073221.814042421, 3948388.153625773],
              [-11130944.9775204, 3948172.2789037847],
              [-11131552.114023188, 4006797.6109793535],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grant',
        GEOID: '41023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13321851.483056538, 5620752.790533749],
              [-13318680.77000027, 5620670.777108821],
              [-13265160.69653617, 5620929.727986209],
              [-13193440.108966352, 5620872.427577149],
              [-13184246.34354123, 5615607.223249033],
              [-13176244.030626064, 5620067.4267892875],
              [-13162935.562862746, 5614974.164104794],
              [-13161107.9194629, 5600321.435075694],
              [-13168612.522934731, 5599986.117356957],
              [-13167474.837738823, 5582402.423812458],
              [-13178008.778513609, 5581344.738349239],
              [-13193523.70990394, 5575337.489790297],
              [-13191841.338439582, 5568978.446794132],
              [-13177448.841474917, 5565978.49620565],
              [-13169738.96486207, 5557018.663795045],
              [-13181205.7629697, 5535759.810284702],
              [-13191081.248956446, 5505027.741249552],
              [-13161549.85784135, 5505164.669480719],
              [-13161174.599837886, 5498393.919657721],
              [-13161041.239087915, 5471612.993293483],
              [-13201058.369638283, 5471675.555484749],
              [-13226635.6924404, 5472846.662164418],
              [-13226640.25653952, 5459367.534114153],
              [-13320176.68131755, 5459087.157963022],
              [-13319991.22304589, 5513081.7081722],
              [-13319647.691097302, 5593746.293737775],
              [-13321851.483056538, 5620752.790533749],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kinney',
        GEOID: '48271',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11221212.566234957, 3405313.784448547],
              [-11216309.438479297, 3406014.5783396563],
              [-11209777.099440057, 3429179.671688863],
              [-11209865.153157275, 3455296.342886511],
              [-11144427.771606302, 3455215.1542966156],
              [-11144350.738518674, 3386636.9761429043],
              [-11206668.412401143, 3386280.05393947],
              [-11207051.441707984, 3388351.5509714135],
              [-11212929.778738813, 3392090.7869920004],
              [-11217959.97256929, 3397108.81977722],
              [-11220523.883081239, 3404663.0140673593],
              [-11221212.566234957, 3405313.784448547],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washburn',
        GEOID: '55129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10246918.607226184, 5805640.317527491],
              [-10191442.093711391, 5805551.6065721745],
              [-10190218.915146558, 5722464.141273413],
              [-10244890.47742342, 5722833.99633751],
              [-10245111.669251624, 5777764.753114749],
              [-10246918.607226184, 5805640.317527491],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Storey',
        GEOID: '32029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13320323.400406418, 4769274.288521236],
              [-13324458.02893346, 4796436.521189684],
              [-13316226.39786726, 4795221.3774497835],
              [-13307227.10759255, 4802742.309924905],
              [-13288274.852965506, 4806089.456563272],
              [-13278593.730809685, 4811099.992237198],
              [-13300319.844508316, 4770119.411699911],
              [-13319082.076764582, 4759927.399446425],
              [-13326350.682915928, 4757670.6639401885],
              [-13320323.400406418, 4769274.288521236],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Eaton',
        GEOID: '26045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9470421.633022198, 5277147.658856545],
              [-9444021.102585668, 5277101.407037098],
              [-9417936.274225025, 5277010.572159494],
              [-9417673.782865733, 5224401.700133987],
              [-9430819.50153351, 5224331.729538986],
              [-9470128.19484447, 5224317.856120455],
              [-9470421.633022198, 5277147.658856545],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Conejos',
        GEOID: '08021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11875382.161014903, 4495513.169913285],
              [-11804244.33097939, 4495128.648102369],
              [-11804197.688112745, 4488978.912924225],
              [-11771294.652260507, 4488957.205616716],
              [-11768730.853068048, 4478992.821723078],
              [-11774337.45922185, 4444931.563166432],
              [-11768526.212666009, 4438527.778904031],
              [-11799584.608414274, 4438467.995404459],
              [-11800569.163720673, 4438463.762309246],
              [-11838064.082838312, 4438302.554174943],
              [-11852880.104693986, 4438239.012682642],
              [-11865453.019033598, 4458665.242112039],
              [-11866366.506775048, 4466318.605527773],
              [-11875380.045944579, 4471014.006934349],
              [-11875382.161014903, 4495513.169913285],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shawnee',
        GEOID: '20177',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10690658.91427295, 4742921.089615403],
              [-10690631.084400253, 4752733.8308194475],
              [-10640971.348237881, 4752670.754559232],
              [-10641782.533367291, 4730939.519900126],
              [-10631039.645908287, 4729790.310715427],
              [-10631091.966068959, 4703040.806986291],
              [-10680725.208192522, 4703063.3976482665],
              [-10680743.798547484, 4735817.226225329],
              [-10685974.033502914, 4740857.876230087],
              [-10691019.255464647, 4739811.718889265],
              [-10690658.91427295, 4742921.089615403],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gray',
        GEOID: '20069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11205883.700249562, 4579783.223183035],
              [-11157175.189136019, 4579569.199320813],
              [-11157228.622491602, 4567286.550377815],
              [-11155842.360872753, 4554988.399605866],
              [-11156019.581502095, 4505550.752379245],
              [-11204600.85443766, 4505502.780643502],
              [-11204557.32851676, 4542237.012464338],
              [-11205883.700249562, 4579783.223183035],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '31111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11273290.880190123, 5070770.026010137],
              [-11211346.926899225, 5070558.865874577],
              [-11159901.180826567, 5070527.259027856],
              [-11158232.279020594, 5070531.117135052],
              [-11158458.257586904, 5020290.431351456],
              [-11156910.805345386, 5019217.142118444],
              [-11156807.946135893, 4968229.225959178],
              [-11218537.05280956, 4968211.7527259365],
              [-11270871.685016204, 4967869.195558738],
              [-11271095.659831678, 5012924.305405005],
              [-11273367.245360807, 5019334.4881437365],
              [-11273290.880190123, 5070770.026010137],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Russell',
        GEOID: '51167',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9173464.423548173, 4421886.3926359955],
              [-9161437.79972134, 4425979.21373478],
              [-9164692.11371519, 4435062.823727197],
              [-9159920.403742338, 4438887.812372576],
              [-9144826.593985677, 4444912.596110775],
              [-9133245.248122018, 4445613.8419097485],
              [-9129057.186239393, 4455828.455665428],
              [-9117165.592954893, 4458995.507681771],
              [-9116068.984651089, 4454887.1241686065],
              [-9103768.626196394, 4433341.771138684],
              [-9110063.854720246, 4429220.349131376],
              [-9122181.426571056, 4420251.514263386],
              [-9136959.422932334, 4418883.719580454],
              [-9139759.108125787, 4411011.085495788],
              [-9165164.998912081, 4398618.083824841],
              [-9167867.61350956, 4408465.257924226],
              [-9173464.423548173, 4421886.3926359955],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '20125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10682723.17041328, 4489906.907230985],
              [-10682397.004305255, 4493136.759030481],
              [-10633856.696942301, 4492764.512710394],
              [-10633363.551598089, 4492766.05378577],
              [-10633506.547317008, 4439011.97472434],
              [-10639204.262641028, 4439010.610585308],
              [-10662933.55619158, 4439005.16305248],
              [-10678669.693795023, 4439001.550509646],
              [-10682693.807905206, 4438998.504135157],
              [-10682708.03096253, 4480898.348654882],
              [-10682723.17041328, 4489906.907230985],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '16065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12465205.811315285, 5454211.712835335],
              [-12449672.178250501, 5454176.627042383],
              [-12418672.483051844, 5447401.086922598],
              [-12412260.369062662, 5454493.176839311],
              [-12400855.575911399, 5453516.97723312],
              [-12400965.11429034, 5407127.253116894],
              [-12419467.415535599, 5407136.633451037],
              [-12426154.266028058, 5407862.331101797],
              [-12436319.182690866, 5412257.102339379],
              [-12460475.623512497, 5429325.929437789],
              [-12465949.202874802, 5427421.805600809],
              [-12465205.811315285, 5454211.712835335],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Apache',
        GEOID: '04001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12245219.350555358, 4438823.556440097],
              [-12188965.270397378, 4438982.036526837],
              [-12138858.697798962, 4438979.109432515],
              [-12138882.074892031, 4421640.497765424],
              [-12138915.025461303, 4316736.215593852],
              [-12138930.851553492, 4300993.118605198],
              [-12138947.864711089, 4284094.617163056],
              [-12138978.143612584, 4247671.901197421],
              [-12139033.803357981, 4213404.191892126],
              [-12138984.811024914, 4187757.522187183],
              [-12138928.632619632, 4158421.980685238],
              [-12138928.606439183, 4158408.3276939187],
              [-12138960.659257174, 4106854.4361904655],
              [-12138965.453190634, 4099164.19886234],
              [-12138992.615146387, 4012036.8764239447],
              [-12139012.816730978, 3999061.633568504],
              [-12172560.117039172, 3998958.804900423],
              [-12174413.920519354, 3993777.0499517936],
              [-12187272.880178848, 3987440.8128702883],
              [-12188976.62498544, 3982262.5096498597],
              [-12200936.902395759, 3976938.294795556],
              [-12219236.936126247, 3958578.9785093493],
              [-12233094.65425714, 3970918.593407253],
              [-12233095.433493575, 3999001.795133948],
              [-12229478.440598719, 3998989.2060769205],
              [-12229491.687618123, 4045732.1114384597],
              [-12228250.809254251, 4092551.323717381],
              [-12230141.570805373, 4104204.4680804256],
              [-12228501.7233865, 4116072.5386830554],
              [-12227847.610058596, 4139794.0965758925],
              [-12227751.875296514, 4234482.903413375],
              [-12225878.590905447, 4254278.523802739],
              [-12245219.016596887, 4254302.227325082],
              [-12245219.350555358, 4438823.556440097],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lee',
        GEOID: '12071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9159427.957220566, 3097173.2115005716],
              [-9151081.30221488, 3094831.3914272026],
              [-9120528.109493794, 3094771.6682293243],
              [-9079877.904999286, 3094709.701002168],
              [-9079784.841904983, 3073626.7621578407],
              [-9079636.564343248, 3062798.4865875226],
              [-9079460.345589321, 3051519.7189706177],
              [-9090294.626350267, 3051327.296339468],
              [-9090115.847248053, 3038465.9405520535],
              [-9099941.684741903, 3038383.104785715],
              [-9108051.532285176, 3038302.25654416],
              [-9111109.061022284, 3040056.8087376407],
              [-9119694.660466226, 3053264.195238073],
              [-9123368.203662403, 3055216.152128495],
              [-9129747.03312384, 3055178.8510957444],
              [-9136548.876650289, 3051449.3625927223],
              [-9142299.196266707, 3053217.078038112],
              [-9148315.569466121, 3058187.9890796077],
              [-9155515.49149165, 3073721.504940783],
              [-9157625.663759124, 3085853.0450486913],
              [-9157662.510510577, 3093124.3299046787],
              [-9159427.957220566, 3097173.2115005716],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bear Lake',
        GEOID: '16007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12426161.056516998, 5192119.106330225],
              [-12417928.646214362, 5213761.560926795],
              [-12423169.122562947, 5223408.136052435],
              [-12421002.511313638, 5225596.708943065],
              [-12425217.735152017, 5248719.650447277],
              [-12397435.95247372, 5249816.88712228],
              [-12387564.807947116, 5244158.498661786],
              [-12383453.44519365, 5251742.841077808],
              [-12382604.300117876, 5232902.305648212],
              [-12375518.480570413, 5232128.191926164],
              [-12361531.887053847, 5238274.685088881],
              [-12361704.399679912, 5213465.427448409],
              [-12361660.873759013, 5161214.175940458],
              [-12398111.327824362, 5161113.212057583],
              [-12408937.37094299, 5160940.347595745],
              [-12412992.205178913, 5160932.36030942],
              [-12412992.966547346, 5160932.358809663],
              [-12414525.164102849, 5172136.275572969],
              [-12423156.766099468, 5175821.61940924],
              [-12426161.056516998, 5192119.106330225],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clark',
        GEOID: '18019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9572732.260064555, 4648671.876854623],
              [-9560649.531214364, 4650795.284973087],
              [-9556543.734435435, 4659020.55182758],
              [-9550498.084209941, 4665221.621159392],
              [-9542275.358703006, 4665325.039794372],
              [-9525606.600790603, 4665412.647307875],
              [-9517445.323642585, 4665495.412168896],
              [-9510181.734744422, 4662582.608088621],
              [-9508421.097801937, 4656895.579937239],
              [-9510354.969988374, 4653733.763817934],
              [-9510373.196392488, 4653703.968903025],
              [-9514961.563164005, 4650881.34568943],
              [-9517690.22652233, 4645785.52110639],
              [-9527585.638697926, 4643262.5806961665],
              [-9531355.69589262, 4638515.215769536],
              [-9532782.716583902, 4633019.741702897],
              [-9534091.483698357, 4627982.246752425],
              [-9538250.379874393, 4621250.170772322],
              [-9545753.424873352, 4617336.277717321],
              [-9550601.266999602, 4618766.2504143715],
              [-9546853.484081369, 4629018.691405984],
              [-9552069.915419944, 4636718.651073523],
              [-9572877.30936106, 4638693.667639082],
              [-9572732.260064555, 4648671.876854623],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brazoria',
        GEOID: '48039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10669712.259648852, 3409110.500308505],
              [-10659160.285116557, 3417013.1851451085],
              [-10645022.375827339, 3413036.0346418913],
              [-10639872.179585788, 3419008.4731877465],
              [-10636576.677380344, 3431568.7289884286],
              [-10626837.22381135, 3431671.116029435],
              [-10624691.095348347, 3440746.5089264517],
              [-10622564.22515725, 3449706.0239580823],
              [-10612214.629459217, 3452122.300578534],
              [-10608459.266437307, 3451791.2279553832],
              [-10607243.880236825, 3451965.8529834338],
              [-10603610.746015806, 3446320.15651363],
              [-10599443.61219745, 3446614.744871973],
              [-10601298.083594576, 3435036.660994341],
              [-10596746.118296549, 3427214.256510442],
              [-10581641.065271318, 3401123.330989107],
              [-10588158.9890597, 3385265.633299222],
              [-10589281.478521915, 3384217.2832279066],
              [-10596657.174023405, 3378585.202907433],
              [-10608429.878091738, 3367257.6780319996],
              [-10617919.08544543, 3358646.1029445985],
              [-10624287.005596768, 3357714.90168482],
              [-10631794.770198938, 3353357.648844724],
              [-10638548.590840256, 3353995.835300911],
              [-10650998.785329558, 3371285.463410397],
              [-10661000.062340898, 3371969.3716364913],
              [-10661117.281764703, 3384075.7863301947],
              [-10669562.423614245, 3389373.5997351487],
              [-10672647.977260053, 3404914.5640918054],
              [-10669712.259648852, 3409110.500308505],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kerr',
        GEOID: '48265',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11104580.291959906, 3540971.357167699],
              [-11054216.682657247, 3540449.8866227535],
              [-11054135.419428969, 3520824.306219912],
              [-11011740.393235767, 3521338.147755797],
              [-11011470.777429067, 3475481.4295155806],
              [-11040331.802570604, 3490068.2895988445],
              [-11087730.30591649, 3491688.3510731277],
              [-11097575.290362757, 3491804.3160993983],
              [-11097426.567523055, 3513058.7152536763],
              [-11104967.572468374, 3513082.3844168065],
              [-11104580.291959906, 3540971.357167699],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Live Oak',
        GEOID: '48297',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10946605.57806077, 3326437.845763506],
              [-10920254.47347815, 3348557.261783364],
              [-10909894.747706456, 3336279.166586472],
              [-10919302.580512377, 3332820.345654379],
              [-10888022.916794375, 3272117.9669186124],
              [-10889018.335681047, 3271288.628014051],
              [-10898632.44350341, 3263382.9751566877],
              [-10896302.192602634, 3256149.4737128713],
              [-10935525.503864154, 3256283.943661934],
              [-10946526.76386129, 3256263.0036009694],
              [-10946605.57806077, 3326437.845763506],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Garfield',
        GEOID: '49017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12544506.699610671, 4551998.486045786],
              [-12532186.86024509, 4551850.548641808],
              [-12533283.579868384, 4563957.80161058],
              [-12519900.194087762, 4563963.584906338],
              [-12521069.382699564, 4600272.156125414],
              [-12517232.645129884, 4600637.648508645],
              [-12462367.164300056, 4600068.890204481],
              [-12450329.742482617, 4600818.700844173],
              [-12427172.95068831, 4600649.82237379],
              [-12321665.673148332, 4600833.564546748],
              [-12237128.427325523, 4600904.202816223],
              [-12246200.854505684, 4594928.130405921],
              [-12253762.008278836, 4579265.759205575],
              [-12260360.248456627, 4580186.701974441],
              [-12267673.048445817, 4571875.893421737],
              [-12269072.000486616, 4564258.537260632],
              [-12290185.189068941, 4562476.819678891],
              [-12293850.4946228, 4552185.876443692],
              [-12297652.16655288, 4552409.199483431],
              [-12292800.640505128, 4548250.963961234],
              [-12299347.339758681, 4537632.305104351],
              [-12300981.175925054, 4530099.858111376],
              [-12307825.766135968, 4528386.389415552],
              [-12317100.23819192, 4514794.7393309465],
              [-12384373.389465565, 4514641.853135273],
              [-12450324.733105531, 4514048.018845172],
              [-12510298.108770406, 4515048.150661516],
              [-12543897.67067654, 4515163.837430513],
              [-12544506.699610671, 4551998.486045786],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wasatch',
        GEOID: '49051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12420475.30220524, 4936896.85009305],
              [-12422580.799054105, 4950157.727323957],
              [-12418052.767446596, 4954885.094265393],
              [-12410987.096726969, 4953421.649404207],
              [-12400350.074103707, 4966812.673873065],
              [-12397498.402708055, 4957764.089631272],
              [-12373312.796179837, 4945950.2109006485],
              [-12369918.66490555, 4952120.553171183],
              [-12353801.383750536, 4952486.601885615],
              [-12345551.273648866, 4964985.9064198015],
              [-12344402.567823369, 4851370.968983971],
              [-12365642.326666726, 4851443.666482065],
              [-12365709.786278147, 4857691.397660433],
              [-12379369.91231288, 4872828.0575886695],
              [-12384219.76856827, 4873969.51077571],
              [-12381566.802463684, 4890287.222260584],
              [-12387495.12194588, 4903620.948177673],
              [-12391510.193339812, 4907819.005166524],
              [-12403939.237125862, 4907722.689396014],
              [-12409934.348302534, 4918712.112655952],
              [-12418271.95552397, 4918789.105060943],
              [-12425203.820215667, 4929799.519829014],
              [-12420475.30220524, 4936896.85009305],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fauquier',
        GEOID: '51061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8689823.871416373, 4706202.7012039395],
              [-8683400.40283913, 4718726.67033574],
              [-8678712.739081826, 4723638.897944132],
              [-8644533.870545603, 4713460.862041073],
              [-8651285.508981707, 4698611.576570209],
              [-8647268.54515643, 4689984.511242835],
              [-8641173.023799064, 4678243.220201193],
              [-8630747.953486275, 4658348.763619102],
              [-8642165.659698468, 4645550.501904275],
              [-8642281.988566346, 4637539.0423324965],
              [-8653478.057672368, 4637950.754287666],
              [-8662170.328791473, 4654586.340520727],
              [-8669246.79750171, 4662383.999779752],
              [-8672880.265681202, 4678407.817639767],
              [-8675724.033393007, 4678196.437358433],
              [-8682437.600563258, 4680275.628362481],
              [-8686456.679458858, 4692136.378781235],
              [-8697455.71306618, 4702333.086990416],
              [-8689823.871416373, 4706202.7012039395],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Richland',
        GEOID: '55103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10093522.130024904, 5396504.366285752],
              [-10053382.214076193, 5396678.703258842],
              [-10040123.506125262, 5396833.074861379],
              [-10040120.6118185, 5370004.462683049],
              [-10040329.447183227, 5337038.5425213305],
              [-10047705.810601663, 5342110.699979232],
              [-10053365.293513592, 5343474.126952054],
              [-10057773.100071043, 5343958.124318806],
              [-10066602.07152484, 5342607.148777109],
              [-10079468.7122292, 5344213.038690029],
              [-10092980.449382704, 5338154.714605396],
              [-10093178.041478863, 5376579.082570635],
              [-10093522.130024904, 5396504.366285752],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dane',
        GEOID: '55025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10000735.442017369, 5343388.601473752],
              [-9988891.382155435, 5350438.841769097],
              [-9987636.254896741, 5356689.152965305],
              [-9947853.117916023, 5354887.826656107],
              [-9908452.029427705, 5355426.857511947],
              [-9908417.854344033, 5342116.044565518],
              [-9908946.621925302, 5288808.261719797],
              [-9948525.821598886, 5288414.4120700685],
              [-9949542.613827793, 5290136.297672241],
              [-10000739.004241074, 5290291.3436282305],
              [-10000735.442017369, 5343388.601473752],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Seward',
        GEOID: '20175',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11250850.095360598, 4493300.400277119],
              [-11204610.427913869, 4493275.60173938],
              [-11202516.730931029, 4492371.545868438],
              [-11202450.494293123, 4439130.986141301],
              [-11227197.820512768, 4438915.271100273],
              [-11237197.961294752, 4438862.420601723],
              [-11250665.774291005, 4438791.243957095],
              [-11250850.095360598, 4493300.400277119],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Helena',
        GEOID: '22091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10113431.28699481, 3593883.9810297643],
              [-10113268.983177233, 3596349.734251647],
              [-10112368.631135697, 3612926.1998897106],
              [-10114264.402063904, 3616285.412282758],
              [-10113956.937630337, 3616318.2256197846],
              [-10112859.884048566, 3618286.795252675],
              [-10114827.456048338, 3625216.561862414],
              [-10110685.050885484, 3632687.5018936126],
              [-10103220.618021289, 3632694.9881149423],
              [-10081894.074576212, 3632742.003758311],
              [-10081891.358307334, 3610017.7075119806],
              [-10081890.690390388, 3587380.8906221977],
              [-10120132.942979546, 3587298.3359017507],
              [-10113431.28699481, 3593883.9810297643],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: "Queen Anne's",
        GEOID: '24035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8500548.56573497, 4712962.65442973],
              [-8496159.1268935, 4722584.777772952],
              [-8493882.754626269, 4727352.830610876],
              [-8489785.044140648, 4725762.077485783],
              [-8483768.710970754, 4720608.776969957],
              [-8477752.226451851, 4735286.075564388],
              [-8465583.447635274, 4744998.938068574],
              [-8461427.000488034, 4756038.630239107],
              [-8445399.554162093, 4759106.5661136545],
              [-8433167.792510703, 4757069.298658255],
              [-8432246.02245282, 4742194.751838656],
              [-8441907.79569438, 4737216.166422805],
              [-8453705.991926106, 4718276.603310737],
              [-8454641.29828775, 4709980.217575889],
              [-8471074.392838143, 4713690.294800184],
              [-8471804.203419784, 4704827.197062294],
              [-8482196.630399307, 4701028.861442223],
              [-8483108.809029331, 4706317.120418708],
              [-8482950.178754952, 4711418.094357738],
              [-8488207.798305118, 4711399.205612471],
              [-8495674.99842804, 4708975.727709238],
              [-8497464.12528407, 4701671.59206615],
              [-8502159.9153642, 4700273.973540826],
              [-8500548.56573497, 4712962.65442973],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Middlesex',
        GEOID: '25017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8003734.328355301, 5268156.75254694],
              [-7993339.406789446, 5267770.164521471],
              [-7986707.81498739, 5267523.543356648],
              [-7974506.864837975, 5267160.124740512],
              [-7942854.280825815, 5266140.082655446],
              [-7936434.597111258, 5265963.775338211],
              [-7932137.664766639, 5271933.2529763775],
              [-7932082.575178589, 5271934.473545108],
              [-7930197.811320076, 5261788.650874806],
              [-7932202.56402977, 5259930.573475553],
              [-7922038.092644928, 5250985.326828164],
              [-7919930.0354477735, 5252545.186006253],
              [-7907468.486370414, 5249090.975995601],
              [-7909624.410948607, 5232539.464957071],
              [-7901790.747061992, 5224705.113101616],
              [-7901740.831579085, 5224135.965430532],
              [-7912694.825143666, 5218431.030005656],
              [-7910814.86158315, 5216415.276077804],
              [-7912292.62782343, 5214921.179841986],
              [-7916699.432505463, 5215698.8578601675],
              [-7922343.775966646, 5215070.172096853],
              [-7921148.4272745075, 5210577.030195137],
              [-7924963.123585012, 5203475.068914807],
              [-7929388.963899971, 5209144.528832109],
              [-7933735.4334179945, 5210252.537763119],
              [-7940391.448411505, 5207979.896546516],
              [-7937404.969112502, 5198242.542679505],
              [-7941996.675468743, 5191091.353968914],
              [-7956907.809941012, 5184493.636073028],
              [-7959635.916701883, 5189695.898736537],
              [-7965548.317496895, 5188356.833166637],
              [-7969001.559420793, 5199937.664308223],
              [-7964922.368000164, 5200912.071492439],
              [-7961812.435385874, 5200976.905161488],
              [-7959014.753943257, 5204493.780496724],
              [-7957873.840482117, 5210569.200084447],
              [-7965034.912005357, 5209997.9206269],
              [-7968824.450110942, 5207676.718193733],
              [-7973225.354859963, 5213622.831933522],
              [-7965922.573624943, 5222887.6460482525],
              [-7963660.561572024, 5242673.003239593],
              [-7974468.459613651, 5239801.799166976],
              [-7979266.329666842, 5240769.445068931],
              [-7977666.891223123, 5253038.726356525],
              [-7990040.49790276, 5257975.855381957],
              [-7999249.736737104, 5256399.814196275],
              [-8003734.328355301, 5268156.75254694],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Goodhue',
        GEOID: '27049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10357108.093868414, 5538758.071010783],
              [-10357092.397820212, 5545543.247467001],
              [-10329624.981383918, 5549856.311306468],
              [-10329623.200272063, 5563415.943519083],
              [-10322883.806979949, 5563380.122970184],
              [-10322837.147560453, 5576753.010193313],
              [-10318926.176443266, 5572761.331904736],
              [-10310191.38127868, 5560780.303898684],
              [-10302538.722884098, 5555282.831003629],
              [-10285840.910584599, 5552249.592603073],
              [-10281637.15265377, 5552350.048901759],
              [-10276673.988007419, 5549279.214457137],
              [-10276355.376774102, 5549082.117117894],
              [-10273787.681399465, 5540878.802263702],
              [-10268707.02076712, 5536009.815983914],
              [-10289291.369521225, 5536176.665879677],
              [-10289330.553981984, 5522614.085004644],
              [-10302700.47010422, 5522649.901165775],
              [-10302715.83219395, 5495655.597351279],
              [-10316947.583813906, 5495748.7557885535],
              [-10357294.442696001, 5495936.62818903],
              [-10357108.093868414, 5538758.071010783],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Valley',
        GEOID: '30105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11956233.84113653, 6085339.119435488],
              [-11956215.69605953, 6143272.710804673],
              [-11952343.670211269, 6143261.516920813],
              [-11952290.45949467, 6157774.0742568225],
              [-11940179.566813307, 6157707.968619561],
              [-11940159.640624454, 6172667.912384713],
              [-11944700.807931876, 6172654.500478593],
              [-11944772.942961909, 6187242.854208472],
              [-11939909.28308966, 6192934.086084026],
              [-11932635.77888072, 6192023.48203287],
              [-11934152.506942777, 6201904.009806898],
              [-11934120.892207392, 6260063.065485017],
              [-11931202.096554516, 6274846.394685937],
              [-11868610.151111985, 6274790.638127477],
              [-11825913.337779244, 6274763.489745986],
              [-11812340.856216105, 6274739.130663492],
              [-11816776.345294423, 6245038.126667753],
              [-11802231.674585847, 6245046.242614699],
              [-11802238.242435802, 6201105.649859065],
              [-11778095.939189501, 6201094.548036498],
              [-11778114.084266502, 6143372.453968871],
              [-11782488.049698751, 6108566.728598158],
              [-11800553.533262137, 6112461.315197493],
              [-11825391.805964878, 6111250.641718564],
              [-11844461.168696238, 6117162.472153143],
              [-11846466.58932288, 6099780.111578245],
              [-11855717.795605253, 6099918.081374939],
              [-11856674.697948113, 6086747.637634022],
              [-11867005.703291183, 6071118.160074007],
              [-11879122.050627595, 6069025.948294641],
              [-11881624.95805859, 6062741.270591067],
              [-11895786.467079857, 6063273.577642233],
              [-11899246.833451165, 6052925.635088497],
              [-11912449.8816567, 6050990.39299205],
              [-11938904.068087798, 6050735.027014248],
              [-11957370.413137529, 6055722.725347551],
              [-11956233.84113653, 6085339.119435488],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pike',
        GEOID: '29163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10181329.831167731, 4786440.818149428],
              [-10150431.269817708, 4807729.226791167],
              [-10149469.079707788, 4806825.15274651],
              [-10146579.559685268, 4800156.749516457],
              [-10141239.786350897, 4799131.401865778],
              [-10137232.062043356, 4792774.653849244],
              [-10134333.859100554, 4786111.264128128],
              [-10123107.17713456, 4779246.861544311],
              [-10122876.851137891, 4779061.965114627],
              [-10112274.343526995, 4770554.37844154],
              [-10100012.946894078, 4758392.758577546],
              [-10099269.736052036, 4753823.426994],
              [-10150438.672472598, 4754273.214990416],
              [-10150718.974950414, 4741608.908900532],
              [-10159042.55591601, 4741723.011047023],
              [-10175607.00746554, 4742110.106797035],
              [-10178857.759235684, 4767428.275119686],
              [-10181329.831167731, 4786440.818149428],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '37115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9235805.202203352, 4272511.435483729],
              [-9232553.254539207, 4276886.810495144],
              [-9228354.394665975, 4283380.490746761],
              [-9229566.663920714, 4290571.705139845],
              [-9227690.19784398, 4291524.046890811],
              [-9224013.602441981, 4293390.230034559],
              [-9219049.421069548, 4290166.997480796],
              [-9215858.447865957, 4294041.069455917],
              [-9214960.322214238, 4299590.946116839],
              [-9208912.111640457, 4303126.503562484],
              [-9198147.516880747, 4309170.292634071],
              [-9195624.862573624, 4305741.086249223],
              [-9194491.784803096, 4304201.1736779725],
              [-9196201.652181681, 4297105.20028898],
              [-9190300.494655238, 4294280.073309946],
              [-9184749.399047824, 4298146.699015091],
              [-9183305.0665343, 4288254.875061952],
              [-9173683.611625547, 4275631.700418245],
              [-9185323.0662634, 4273600.381345291],
              [-9217833.478271611, 4257510.212508185],
              [-9226594.544836026, 4256436.851032969],
              [-9234739.012740932, 4265823.42479679],
              [-9235805.202203352, 4272511.435483729],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '48077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10956457.575634956, 4039811.153647298],
              [-10955443.789032303, 4040231.1142039327],
              [-10953664.346971972, 4046063.598005748],
              [-10949832.95273785, 4049917.4858561484],
              [-10944793.185431166, 4048479.7748745102],
              [-10934388.375265699, 4045900.7447764273],
              [-10928136.450023767, 4044142.7239093166],
              [-10924726.291608883, 4047778.340677588],
              [-10923044.362556411, 4049571.89668682],
              [-10920367.240122324, 4042814.9085034835],
              [-10920341.414000459, 4035334.9268018594],
              [-10918531.693038633, 4029125.9034023406],
              [-10909940.945295135, 4028260.102816468],
              [-10903473.8394775, 4027600.725888235],
              [-10904155.448719626, 4018651.6826310907],
              [-10903956.292679824, 4014205.6454732264],
              [-10906846.486090064, 4013872.024203676],
              [-10906963.371555395, 3957472.9398191404],
              [-10956222.24623142, 3957428.636418624],
              [-10956462.473692551, 4006808.3323701117],
              [-10956457.575634956, 4039811.153647298],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Southeast Fairbanks',
        GEOID: '02240',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-16363955.016537555, 9415378.879181972],
              [-16325578.290003516, 9415382.979989253],
              [-16306796.576836368, 9421679.494661221],
              [-16291014.478668133, 9420293.350014914],
              [-16278508.40179445, 9429128.897979643],
              [-16278325.503871078, 9442737.409620462],
              [-16253065.552937213, 9447204.654627971],
              [-16244400.666412845, 9458397.37516148],
              [-16223702.810850672, 9467583.532313269],
              [-16208464.953672923, 9458025.80387828],
              [-16182968.894099085, 9466321.31210927],
              [-16182951.750897506, 9473706.522910543],
              [-16150541.971708972, 9479785.421516262],
              [-16139693.219414221, 9495647.792980399],
              [-16118844.525942022, 9495566.655654902],
              [-16091513.587201439, 9503957.249409769],
              [-16081224.326667415, 9499446.73720641],
              [-16065181.406932252, 9515513.513539376],
              [-16038078.561828304, 9517839.468451468],
              [-16037690.947361363, 9525509.681736566],
              [-16002458.32852529, 9516162.655004794],
              [-15990734.605032906, 9521851.50077562],
              [-15975051.469891988, 9543888.081524074],
              [-15977685.511683138, 9556046.479072174],
              [-15967075.428376649, 9560539.703309208],
              [-15974752.465739718, 9571132.865385193],
              [-15977149.063057005, 9597864.254993265],
              [-15959260.68880347, 9607580.287729852],
              [-15960243.973865649, 9618152.449817376],
              [-15945636.741603248, 9622218.59574641],
              [-15927794.898896864, 9640299.181379505],
              [-15903586.026595067, 9645447.588042751],
              [-15888842.427956445, 9670183.875997514],
              [-15890061.265061142, 9688215.814851701],
              [-15874381.803463412, 9712106.03421303],
              [-15856567.790629731, 9710531.951475693],
              [-15841551.793197135, 9725405.072221646],
              [-15814651.438246941, 9732025.724605441],
              [-15791311.080612317, 9726785.332744932],
              [-15783884.846062005, 9741738.371726148],
              [-15739222.575799817, 9772098.821862573],
              [-15733476.486324053, 9798360.19311115],
              [-15706426.851936704, 9829762.872212717],
              [-15696322.5961741, 9833034.822390921],
              [-15696273.119506959, 8836426.504845526],
              [-15788644.199571382, 8836427.916498922],
              [-15788645.09012731, 8886981.239067983],
              [-15809036.037853366, 8887092.639200293],
              [-15804844.747705508, 8898130.967392769],
              [-15804846.640136851, 8981232.35973598],
              [-15821375.91472729, 8981231.636232495],
              [-15821408.531338092, 9002155.876664294],
              [-15842272.475580534, 9002156.118535263],
              [-15842273.47745595, 9023141.237232916],
              [-15863654.946011087, 9023139.781760342],
              [-15887464.626618892, 9030344.588811442],
              [-15890020.744766489, 9016833.322089434],
              [-15901831.074822713, 9002967.399591247],
              [-15930375.284693452, 9006441.415114967],
              [-15935503.662314804, 9010259.97933417],
              [-15919732.58477616, 9043406.22862894],
              [-15941793.77014208, 9058465.76708379],
              [-15929247.840890696, 9070792.66453777],
              [-15918891.677342707, 9099177.737270096],
              [-15929694.009409795, 9102186.059545308],
              [-15933418.87089123, 9128991.815989688],
              [-16094589.678690527, 9128980.24510516],
              [-16158512.224610785, 9132481.414937707],
              [-16158513.337805696, 9153851.603707032],
              [-16265056.220568523, 9153846.909816211],
              [-16268322.445747886, 9145514.187859092],
              [-16289298.711356536, 9147130.394530166],
              [-16307672.104631454, 9141804.39075137],
              [-16307141.110660372, 9219653.990533642],
              [-16363961.361748528, 9218839.208722103],
              [-16363955.016537555, 9415378.879181972],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '05079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10238770.35445859, 4025753.975144717],
              [-10236250.081187027, 4037417.850413918],
              [-10236231.156873593, 4041347.581179561],
              [-10213005.569633976, 4041433.746981421],
              [-10210961.187185556, 4037548.6001015916],
              [-10209361.526102858, 4052117.0461408054],
              [-10197125.176355371, 4040631.9328697617],
              [-10179679.185758248, 4039568.8937679534],
              [-10178669.963254716, 4032855.988965797],
              [-10177018.761247778, 4030745.4277259205],
              [-10191151.104562458, 4025687.1239697677],
              [-10192150.753589783, 3999752.74398396],
              [-10203960.63836804, 4000939.737193896],
              [-10238718.59089537, 4000878.254840184],
              [-10238770.35445859, 4025753.975144717],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cleveland',
        GEOID: '05025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10293898.883245159, 4036465.5595881753],
              [-10278881.661298165, 4036812.0944721964],
              [-10267372.45046454, 4037172.0773151345],
              [-10236250.081187027, 4037417.850413918],
              [-10238770.35445859, 4025753.975144717],
              [-10238718.59089537, 4000878.254840184],
              [-10238704.119361566, 3989180.768770332],
              [-10278221.981995724, 3989634.6670820443],
              [-10279447.164311394, 3994331.2655122704],
              [-10278601.581459329, 4001317.3451968073],
              [-10278951.12466042, 4005747.3653742075],
              [-10292169.312316705, 4025126.421799265],
              [-10293898.883245159, 4036465.5595881753],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Colusa',
        GEOID: '06011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13668373.695806267, 4776678.870140381],
              [-13663249.882284034, 4776720.781268915],
              [-13602388.39972161, 4777007.538729774],
              [-13596135.249965278, 4781220.114772795],
              [-13581963.833509332, 4781085.824444537],
              [-13568734.179945495, 4776806.908466446],
              [-13569746.74203375, 4772979.713152116],
              [-13570766.428569417, 4765293.434834701],
              [-13574912.523004012, 4747465.376751602],
              [-13568632.656569893, 4732043.692206153],
              [-13558198.124100385, 4721053.647932859],
              [-13562664.484709993, 4710859.889525365],
              [-13618845.650601504, 4710826.26370846],
              [-13626520.68421374, 4716343.389524759],
              [-13626999.135385167, 4724568.041513988],
              [-13635666.693577314, 4729264.923579568],
              [-13634109.556540096, 4746619.135305496],
              [-13656778.323686767, 4755924.941063324],
              [-13667255.268882265, 4766430.0032493435],
              [-13663741.91443334, 4774541.058261572],
              [-13668373.695806267, 4776678.870140381],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cherokee',
        GEOID: '13057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9422559.59531665, 4076592.6978085884],
              [-9423554.680244852, 4084338.247165392],
              [-9415717.565454023, 4084284.408444041],
              [-9415695.301555865, 4080142.8350094054],
              [-9398095.133463996, 4080895.2448572074],
              [-9395451.184238164, 4079033.3310133168],
              [-9379511.568990454, 4080075.3930463707],
              [-9379566.004221454, 4073894.562669318],
              [-9379634.3543888, 4060682.5612871214],
              [-9379640.365641303, 4053792.4634937267],
              [-9390055.305880431, 4052555.556118847],
              [-9397471.966954533, 4038648.408188438],
              [-9408214.743094048, 4039374.1461955192],
              [-9414476.687090151, 4039051.724654432],
              [-9420324.522580503, 4039788.2407794218],
              [-9424223.599065026, 4039312.5910650897],
              [-9422559.59531665, 4076592.6978085884],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Macon',
        GEOID: '13193',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9379180.616144327, 3812248.061192522],
              [-9372868.68969686, 3816044.4643222988],
              [-9363218.848317953, 3830988.2144574733],
              [-9351782.329111814, 3831997.481755396],
              [-9352859.679143714, 3829981.540991569],
              [-9333769.277028592, 3824968.717496682],
              [-9332691.48171873, 3814454.649831295],
              [-9334867.332485776, 3813611.7743489835],
              [-9333958.854121411, 3801565.8560395786],
              [-9339164.598788869, 3801711.2372923573],
              [-9353909.644580875, 3785799.7237400305],
              [-9365835.969546502, 3787670.8857495203],
              [-9371059.191374013, 3793500.6272750413],
              [-9375343.544616172, 3793691.0485851816],
              [-9379325.220162867, 3802248.7945822286],
              [-9379180.616144327, 3812248.061192522],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Macon',
        GEOID: '17115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9931685.186392698, 4853886.8146563405],
              [-9923403.572875133, 4853982.172738465],
              [-9923549.735366546, 4873044.005970835],
              [-9879066.466845553, 4873965.729467756],
              [-9879122.905827386, 4835783.315761439],
              [-9886585.541851183, 4828301.7666568905],
              [-9886347.986057833, 4815676.6703436775],
              [-9910293.365124919, 4815815.618107091],
              [-9922922.004757961, 4815952.688136834],
              [-9923238.374750795, 4837105.697867408],
              [-9931643.664222633, 4838901.561359128],
              [-9931685.186392698, 4853886.8146563405],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pottawatomie',
        GEOID: '20149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10765343.049326668, 4787999.498666642],
              [-10751276.718470028, 4803121.508423918],
              [-10713273.02354964, 4803105.335155924],
              [-10690673.27448726, 4803088.006683488],
              [-10690631.084400253, 4752733.8308194475],
              [-10690658.91427295, 4742921.089615403],
              [-10691019.255464647, 4739811.718889265],
              [-10695972.638846476, 4749427.38462621],
              [-10712683.252887418, 4752124.493286056],
              [-10723561.95012519, 4744456.106647104],
              [-10729979.51876942, 4746465.202520819],
              [-10748775.369511902, 4747771.408218194],
              [-10749270.741245933, 4756300.795753192],
              [-10757760.2995723, 4763703.7490956625],
              [-10767563.316570537, 4779649.952310965],
              [-10765343.049326668, 4787999.498666642],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '21229',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9506883.107717138, 4541446.3836871525],
              [-9490468.93748018, 4560573.010246259],
              [-9484894.05738125, 4557757.421964706],
              [-9479166.001662994, 4564978.814802475],
              [-9476261.453509215, 4567730.887523874],
              [-9465555.07884319, 4564115.080191156],
              [-9465658.383330647, 4562712.916363875],
              [-9462214.603563465, 4558923.324181164],
              [-9464942.042407392, 4534157.463288921],
              [-9465109.578241035, 4532128.463538559],
              [-9465515.449104467, 4527466.788227144],
              [-9480645.103737162, 4527444.298230934],
              [-9501044.40042503, 4530896.095342643],
              [-9506883.107717138, 4541446.3836871525],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rapides',
        GEOID: '22079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10346823.286114024, 3677863.7136196382],
              [-10321429.974430189, 3700152.594215351],
              [-10318524.980998447, 3684754.0139788515],
              [-10311740.837271031, 3683564.652900814],
              [-10263226.356029943, 3694967.3244149582],
              [-10249512.462681158, 3677688.530647124],
              [-10251046.556583779, 3676380.8636146793],
              [-10255426.42194904, 3672559.0208647083],
              [-10267356.197818883, 3674578.667371245],
              [-10267470.634255419, 3649834.3012514613],
              [-10264580.891593916, 3627870.92430026],
              [-10272644.76418749, 3628213.778156942],
              [-10284068.815610658, 3632931.350981997],
              [-10294863.2439939, 3626552.1742289336],
              [-10295633.129592227, 3620947.0713172685],
              [-10307933.37672743, 3619263.2187731653],
              [-10309415.039149888, 3619642.0300148507],
              [-10333112.843669452, 3618471.7740740227],
              [-10333749.479837298, 3665556.1570891584],
              [-10339327.142923495, 3674035.0240181317],
              [-10350649.2256931, 3677849.7666692585],
              [-10346823.286114024, 3677863.7136196382],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hennepin',
        GEOID: '27053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10438135.547466002, 5618053.035844922],
              [-10437524.069503075, 5634320.772195283],
              [-10427994.341854736, 5645331.698495904],
              [-10426985.341990186, 5645868.233722739],
              [-10426355.496311277, 5645683.702404321],
              [-10424819.509977313, 5646525.884243728],
              [-10424532.417010557, 5646991.920153682],
              [-10423803.719623825, 5647632.758959103],
              [-10423807.170528037, 5648981.369362595],
              [-10426051.03750396, 5652133.02086348],
              [-10410782.790105226, 5660430.361052912],
              [-10409729.373763848, 5660282.527965502],
              [-10400171.70492332, 5655411.247261715],
              [-10394268.321007062, 5649614.295956047],
              [-10387393.563214142, 5644184.861118211],
              [-10385673.454442404, 5640706.73095368],
              [-10383972.826581554, 5632818.777351595],
              [-10384263.481772017, 5627090.7009387165],
              [-10377974.264500668, 5627138.904266805],
              [-10375877.339252595, 5627150.403791652],
              [-10375013.722643021, 5607196.383409906],
              [-10372587.514341183, 5603959.685771681],
              [-10374747.223782063, 5599822.310927188],
              [-10380751.017879015, 5591890.9083826],
              [-10389405.217732266, 5588691.995670777],
              [-10401480.488176575, 5592131.147026954],
              [-10410646.757687477, 5590759.1578940805],
              [-10410677.370547444, 5604456.838575415],
              [-10438099.257312005, 5604356.274486974],
              [-10438135.547466002, 5618053.035844922],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mahnomen',
        GEOID: '27087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10694198.651441194, 6023929.756077843],
              [-10637050.230494179, 6024054.488607022],
              [-10636731.411472548, 6021166.987946284],
              [-10636709.37021337, 5966830.189768862],
              [-10694137.203082277, 5966889.118378349],
              [-10694198.651441194, 6023929.756077843],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '28089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10068852.061072752, 3838866.4770352393],
              [-10063824.650229547, 3838989.725841065],
              [-10059250.866311325, 3842770.3752131034],
              [-10049680.173090372, 3850317.713129567],
              [-10040204.991992522, 3851030.0397445243],
              [-10024223.186657803, 3860271.4353713267],
              [-10014956.173007736, 3879330.180851773],
              [-9988699.689992288, 3880059.1104268692],
              [-9988731.750005638, 3846853.881515778],
              [-9993252.323207263, 3843142.8903275444],
              [-9994722.85368064, 3840598.154456141],
              [-10000941.383075336, 3841444.268978393],
              [-10003514.978382984, 3839129.224428733],
              [-10027141.983706404, 3818448.771620912],
              [-10026067.527981266, 3815870.0344679346],
              [-10032500.7926737, 3815859.750701436],
              [-10045889.855748352, 3815945.05349491],
              [-10045876.163450984, 3827478.427973762],
              [-10068832.802800845, 3827592.056418137],
              [-10068852.061072752, 3838866.4770352393],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yellowstone',
        GEOID: '30111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12125429.782346606, 5801587.039030403],
              [-12109304.486188255, 5801601.014323845],
              [-12067566.57894921, 5801680.529344607],
              [-12067573.369438147, 5818242.941268611],
              [-12058217.634153917, 5822756.324512725],
              [-12025773.679881709, 5822765.663717677],
              [-12023835.050949544, 5834489.0037794225],
              [-12014550.894097893, 5843921.619682691],
              [-11998247.041476311, 5843905.156117734],
              [-11998149.85956085, 5860195.244667874],
              [-11993400.302166663, 5857898.020402315],
              [-11979358.79555647, 5836866.572845538],
              [-11963074.980443232, 5808883.538916228],
              [-11968129.219283719, 5787307.311556479],
              [-11986265.390723757, 5787340.509565106],
              [-11986266.94919663, 5778067.383641429],
              [-12000102.292109871, 5778054.72710228],
              [-12000109.861835247, 5773416.7608156325],
              [-12009355.168184608, 5768842.51377409],
              [-12009352.162558358, 5764215.916120703],
              [-12027776.206201589, 5764255.266276713],
              [-12030249.725287015, 5745723.679696747],
              [-12030269.762795357, 5703526.97439134],
              [-12044010.929419389, 5698919.390260875],
              [-12057709.238039464, 5698915.738045476],
              [-12057723.598253775, 5694312.908876372],
              [-12094342.256069714, 5694878.570135278],
              [-12100348.833153937, 5704177.427602683],
              [-12111756.631931452, 5708839.705902305],
              [-12109556.847473886, 5722628.767075161],
              [-12116349.117524128, 5718236.018618195],
              [-12123218.64330098, 5729665.937421905],
              [-12122876.781144755, 5773847.989272264],
              [-12125429.782346606, 5801587.039030403],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Essex',
        GEOID: '34013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8278512.713149541, 4977169.3372266255],
              [-8273945.1631228, 4998870.254322733],
              [-8267928.233325935, 4997223.921976148],
              [-8259669.328984489, 4991279.823143303],
              [-8252115.633617221, 4985818.728662172],
              [-8253179.736629714, 4983681.766496572],
              [-8254065.171859484, 4980899.960122439],
              [-8256119.127784111, 4975252.4697380075],
              [-8250734.047416988, 4974013.847848692],
              [-8250673.044336032, 4969716.327172121],
              [-8250259.047149772, 4968555.64344117],
              [-8252860.027052157, 4964440.173694772],
              [-8260935.699511755, 4966827.795599218],
              [-8269389.190323105, 4971445.126120272],
              [-8270727.807199894, 4970422.438009869],
              [-8279024.003570753, 4974014.141690547],
              [-8278512.713149541, 4977169.3372266255],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Socorro',
        GEOID: '35053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11991869.213890292, 4106697.7335240897],
              [-11933643.442911379, 4106782.2354815877],
              [-11898123.063191608, 4106886.883586414],
              [-11885390.673793146, 4100362.5717632137],
              [-11846277.791466493, 4087995.158787437],
              [-11846171.815311257, 4063743.3578445013],
              [-11791624.819544591, 4063765.9856069917],
              [-11791481.996637903, 4005411.553675721],
              [-11805728.331111154, 4005409.141656026],
              [-11805734.565002639, 3981941.559110365],
              [-11841461.665016813, 3983306.596923995],
              [-11841365.596296258, 3959173.9451048765],
              [-11852664.301972795, 3958628.2242457992],
              [-11990528.927221142, 3958767.821700949],
              [-11990923.777454985, 4063747.937268976],
              [-11991939.679127963, 4065683.3138793544],
              [-11991869.213890292, 4106697.7335240897],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wilson',
        GEOID: '37195',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8704306.648488069, 4263607.841972048],
              [-8673531.262063362, 4278140.417388692],
              [-8665636.483776301, 4278300.801602675],
              [-8663822.755312806, 4282364.7479361],
              [-8655239.465975191, 4276951.890151159],
              [-8651576.720769621, 4263371.704219663],
              [-8645642.835312886, 4255984.623530225],
              [-8649601.467724985, 4252882.572817691],
              [-8660854.198451823, 4243832.18594183],
              [-8663162.296773931, 4243719.668049032],
              [-8668866.30748218, 4243837.113759158],
              [-8688327.29218215, 4245156.205873765],
              [-8690132.00376689, 4243703.2421759],
              [-8695793.379110163, 4245779.941495324],
              [-8700871.106363207, 4261184.450092455],
              [-8704306.648488069, 4263607.841972048],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Baldwin',
        GEOID: '13009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9287283.816146193, 3919932.263355496],
              [-9279987.157483164, 3917757.165042645],
              [-9270031.298824068, 3920183.129346],
              [-9250387.972798178, 3915435.149531914],
              [-9250795.513453973, 3901970.000636544],
              [-9245328.279302642, 3906018.05262206],
              [-9244981.407769332, 3893393.423740911],
              [-9247716.193699649, 3888213.108824059],
              [-9254417.515725914, 3896266.053689641],
              [-9279335.047906097, 3885504.514935485],
              [-9285714.990562443, 3910290.2515559723],
              [-9287283.816146193, 3919932.263355496],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dauphin',
        GEOID: '42043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8565967.690889452, 4934337.398645181],
              [-8570764.559067225, 4948760.785287668],
              [-8565969.583320796, 4957649.535474012],
              [-8562614.191229304, 4954039.199122673],
              [-8538385.72669713, 4962038.900284303],
              [-8519883.314132381, 4946947.197180466],
              [-8535760.367826262, 4935168.572854781],
              [-8523325.869385162, 4894559.332276693],
              [-8535771.165816868, 4887579.497199426],
              [-8537944.90151359, 4888687.55026088],
              [-8540611.671235034, 4883405.896256553],
              [-8544069.588577544, 4891522.476614853],
              [-8549402.014825525, 4895064.618275528],
              [-8552086.039068041, 4895386.429114164],
              [-8553730.45058604, 4898199.222170461],
              [-8555907.303228501, 4898886.361599169],
              [-8563157.430344375, 4908052.501847197],
              [-8562135.294779912, 4913792.128921077],
              [-8573916.125171075, 4919305.422623323],
              [-8565967.690889452, 4934337.398645181],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jones',
        GEOID: '46075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11250400.587256774, 5464657.467926759],
              [-11248476.763816884, 5464663.812231161],
              [-11248491.235350687, 5491552.598518631],
              [-11172826.37558308, 5491585.18924896],
              [-11172711.382549094, 5441792.133151511],
              [-11169683.047121553, 5421742.287120039],
              [-11197394.141923195, 5429807.648462494],
              [-11213769.239018885, 5420306.784007893],
              [-11219850.845439905, 5423050.928654842],
              [-11220529.560375271, 5427460.180125476],
              [-11225602.946168173, 5428403.873801041],
              [-11235561.699134031, 5439350.71892844],
              [-11250429.307685398, 5440883.33719085],
              [-11250400.587256774, 5464657.467926759],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Llano',
        GEOID: '48299',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11016690.214393891, 3622541.4862717013],
              [-10958934.322985616, 3622550.6993880784],
              [-10960225.629078818, 3617031.580446069],
              [-10951263.853472505, 3611324.9799638274],
              [-10957411.027073601, 3605028.4139328627],
              [-10950710.372964282, 3599091.8445507055],
              [-10958178.797601601, 3590391.2751710536],
              [-10955078.883741481, 3577630.906045832],
              [-10948492.666068697, 3575529.895138116],
              [-10948387.80310837, 3566187.2358524255],
              [-10955113.838061592, 3568254.125564379],
              [-10975174.500858465, 3567967.3063809476],
              [-11016647.912987389, 3567787.3371457164],
              [-11016690.214393891, 3622541.4862717013],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Leon',
        GEOID: '48289',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10722200.401433297, 3679216.512867509],
              [-10722610.947715344, 3681424.745926174],
              [-10713012.535941184, 3686553.1422040476],
              [-10662993.460462535, 3713321.3124520457],
              [-10657247.259667275, 3717954.6748112733],
              [-10654400.931607181, 3712955.5511329123],
              [-10657647.78719515, 3698384.8874329487],
              [-10658489.139906565, 3692395.285657484],
              [-10654510.02470816, 3691868.4675730565],
              [-10648516.026726395, 3676651.1702745194],
              [-10656083.41439103, 3668004.82990561],
              [-10656470.47226052, 3654074.3567065685],
              [-10660445.357318277, 3644990.288689326],
              [-10683912.396533422, 3644698.577412706],
              [-10713501.339825256, 3629338.862388094],
              [-10713750.472845653, 3640691.4944941583],
              [-10715680.307538046, 3642762.329947401],
              [-10716638.21175632, 3642864.230143562],
              [-10723527.886361007, 3665549.5161360367],
              [-10722200.401433297, 3679216.512867509],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Milam',
        GEOID: '48331',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10833112.685529249, 3600631.3890345944],
              [-10826831.483261239, 3618419.367452318],
              [-10805803.899367334, 3630959.677350424],
              [-10781190.158077523, 3645804.100779038],
              [-10778968.443680273, 3646506.154299675],
              [-10774962.945762549, 3641286.8209014335],
              [-10770865.386625938, 3623299.060848733],
              [-10762921.62776293, 3620572.242255037],
              [-10764021.79829044, 3615166.5682293028],
              [-10754698.123019561, 3601276.8729711305],
              [-10755831.800713798, 3597839.9875313295],
              [-10793941.805747895, 3575371.6645204406],
              [-10815269.506988978, 3562473.656620376],
              [-10828204.720499665, 3598471.0808005105],
              [-10833112.685529249, 3600631.3890345944],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Floyd',
        GEOID: '48153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11306148.052412156, 4070839.7813042975],
              [-11295764.615588922, 4070812.422342672],
              [-11247886.547876699, 4070833.1774109523],
              [-11247881.315860633, 4046378.2838526615],
              [-11247850.2577227, 4006483.7467118283],
              [-11306006.008741904, 4006058.3952843477],
              [-11306115.435801353, 4038773.3931028447],
              [-11306148.052412156, 4070839.7813042975],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hot Springs',
        GEOID: '56017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12168661.819791084, 5436594.160396787],
              [-12144244.334763542, 5437261.546496413],
              [-12144163.628132718, 5450671.195717057],
              [-12124115.544438303, 5450714.456871874],
              [-12124471.989447823, 5464026.927831423],
              [-12110645.440774355, 5464057.718845297],
              [-12110700.877880767, 5477771.220571917],
              [-12083815.105783867, 5477738.21406795],
              [-12077079.83131291, 5477793.53489544],
              [-12076988.215371987, 5464183.514361406],
              [-12070045.552689685, 5464212.603852759],
              [-12070323.740097176, 5450498.307633411],
              [-12056942.803345352, 5450482.857560705],
              [-12056979.984055279, 5441736.719960334],
              [-12043127.497940455, 5441989.24628675],
              [-12041979.01475394, 5437469.671006558],
              [-12017656.819210516, 5437423.077861166],
              [-12017671.17942483, 5424284.573325412],
              [-11990876.466671396, 5424268.704970423],
              [-11990914.537937248, 5410786.305685549],
              [-11977438.089062324, 5410887.992355966],
              [-11977432.300448803, 5388603.665736999],
              [-11977435.862672508, 5384136.049033221],
              [-12039902.572292171, 5383882.798222643],
              [-12060115.520152451, 5382216.669331797],
              [-12073375.007339822, 5384442.8430493735],
              [-12073373.782825422, 5388873.620639698],
              [-12086643.622725433, 5388888.967942655],
              [-12086643.622725433, 5393386.823208287],
              [-12099880.066778207, 5393340.605466129],
              [-12099835.53898189, 5400022.307684015],
              [-12113149.79535873, 5399991.576173419],
              [-12113149.79535873, 5404556.32390179],
              [-12126493.106122663, 5406694.69165336],
              [-12152931.151227595, 5406787.107102122],
              [-12152910.000524344, 5419009.771545401],
              [-12168661.819791084, 5436594.160396787],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '54037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8686867.003101924, 4761603.49311932],
              [-8681604.374174671, 4767625.121039021],
              [-8679241.506663091, 4774401.961430396],
              [-8675224.542837817, 4776418.909827218],
              [-8665903.984512677, 4785840.392086597],
              [-8661874.652675886, 4793654.096561806],
              [-8660456.119952746, 4790045.138571216],
              [-8653978.550102977, 4779375.220716304],
              [-8654637.33884949, 4772394.487166578],
              [-8651697.279778149, 4767802.112981256],
              [-8658214.924644604, 4754570.974208243],
              [-8661672.174070172, 4745846.192412001],
              [-8663790.80661895, 4740644.330791406],
              [-8663806.929384515, 4740657.742522319],
              [-8686576.125272479, 4759616.11041282],
              [-8686614.247849291, 4759647.842543078],
              [-8686614.445378203, 4759648.006960688],
              [-8686867.003101924, 4761603.49311932],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Aguadilla',
        GEOID: '72005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7477220.101607791, 2092207.1373716695],
              [-7472393.733764957, 2097530.7006562827],
              [-7469237.650968116, 2097526.229881476],
              [-7464913.6205811035, 2093806.8518805718],
              [-7464696.213615584, 2091573.6245310723],
              [-7472339.855131414, 2085468.604631583],
              [-7473123.433027107, 2083176.8240253225],
              [-7476235.912394761, 2086251.6058243138],
              [-7476173.364435862, 2086288.5937966844],
              [-7477220.101607791, 2092207.1373716695],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Quebradillas',
        GEOID: '72115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7453542.997154595, 2095440.5497244957],
              [-7449955.5092837205, 2094661.9238544235],
              [-7447448.344834175, 2094778.6269707126],
              [-7447151.482630129, 2080445.6799091813],
              [-7449725.189257271, 2083624.131969522],
              [-7452529.104591371, 2084595.268893861],
              [-7453542.997154595, 2095440.5497244957],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mineral',
        GEOID: '54057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8812774.133927219, 4779259.106736883],
              [-8804406.470443271, 4789567.506484106],
              [-8801747.983790558, 4789625.435342786],
              [-8798205.306889141, 4789702.631371339],
              [-8789425.316011295, 4784933.261831994],
              [-8787852.037647912, 4790606.875693921],
              [-8777654.949652268, 4801347.2256369],
              [-8768763.194005664, 4813531.972508415],
              [-8765190.951546106, 4809385.560197724],
              [-8761634.071176281, 4801608.987664451],
              [-8755838.574943092, 4799952.370442795],
              [-8768352.091126163, 4785938.562535525],
              [-8777642.70450828, 4769176.712452334],
              [-8792002.028264685, 4755766.554487558],
              [-8809207.346122712, 4766534.0272485595],
              [-8823449.129540823, 4768511.526263293],
              [-8812774.133927219, 4779259.106736883],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Roanoke',
        GEOID: '51161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8933000.408498352, 4488557.238992332],
              [-8913810.152799992, 4498158.26002046],
              [-8912530.31261434, 4496175.88650437],
              [-8899505.264274584, 4489825.392827747],
              [-8890542.152834382, 4484983.282804219],
              [-8888580.369448133, 4482314.634139649],
              [-8889796.980163012, 4476410.458226489],
              [-8888551.537700018, 4470572.221351402],
              [-8901316.877667753, 4458268.797417459],
              [-8914772.62111739, 4461559.082746312],
              [-8919883.187620219, 4456251.474875975],
              [-8925388.047759436, 4454925.094096842],
              [-8926664.548360363, 4471696.713913811],
              [-8934745.452836027, 4486818.625361295],
              [-8933000.408498352, 4488557.238992332],
            ],
            [
              [-8914646.384814832, 4476242.183800071],
              [-8909284.45890179, 4475813.886457595],
              [-8899638.958983026, 4468843.14433575],
              [-8892039.511305042, 4479870.961205937],
              [-8902667.51704955, 4485963.567050237],
              [-8908033.450464258, 4482172.717100378],
              [-8918972.148907566, 4479194.160489781],
              [-8914646.384814832, 4476242.183800071],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henry',
        GEOID: '51089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8916066.59887837, 4408423.562291785],
              [-8910178.243093371, 4410482.5486018825],
              [-8905533.771298494, 4415540.0346652735],
              [-8879038.062697332, 4409644.616989097],
              [-8876773.935574088, 4412212.137860516],
              [-8868729.543891402, 4415136.715805578],
              [-8865556.827084305, 4419073.3443258535],
              [-8873816.600948079, 4375379.689048399],
              [-8893500.041609472, 4375463.010227935],
              [-8908594.834656326, 4375526.907827227],
              [-8908602.617574245, 4375526.961257087],
              [-8911509.851667952, 4375546.919485728],
              [-8916066.59887837, 4408423.562291785],
            ],
            [
              [-8893779.546265634, 4393490.895102861],
              [-8889892.15832764, 4392061.5850865],
              [-8889947.929392526, 4390484.000984409],
              [-8888151.78940858, 4389586.176705377],
              [-8887526.841787264, 4391722.708867667],
              [-8886794.470857335, 4389922.487765979],
              [-8886258.578828657, 4391734.365364971],
              [-8888164.145872055, 4393547.383076683],
              [-8887454.150159776, 4397947.145955045],
              [-8890621.7462703, 4399119.787411027],
              [-8892341.187125092, 4398974.675590201],
              [-8894881.163946522, 4395169.145611513],
              [-8893779.546265634, 4393490.895102861],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adams',
        GEOID: '53001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13288058.670514386, 5927813.625383403],
              [-13245088.233873274, 5927615.143630004],
              [-13244768.190337244, 5984896.755161422],
              [-13131350.66110099, 5984709.598238274],
              [-13131173.106513174, 5928180.127766392],
              [-13137432.824119462, 5907030.291107973],
              [-13159104.05730913, 5899548.673313813],
              [-13175650.36378166, 5899189.703400902],
              [-13288144.052563822, 5899363.826335713],
              [-13288058.670514386, 5927813.625383403],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Corozal',
        GEOID: '72047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7387748.285397095, 2076589.5325034782],
              [-7384738.985602482, 2080659.8601687835],
              [-7382571.038519284, 2080598.5147697309],
              [-7378041.671077886, 2076207.9335532861],
              [-7380046.535107073, 2067715.8704987797],
              [-7381962.677502098, 2066752.2225382403],
              [-7386136.4904899, 2065804.0918330431],
              [-7389133.099862565, 2071986.7833549175],
              [-7387748.285397095, 2076589.5325034782],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crockett',
        GEOID: '48105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11388118.827374728, 3643950.4812753373],
              [-11329673.756998952, 3643114.9549947577],
              [-11273859.054871133, 3643062.3140519294],
              [-11239058.021700865, 3643466.680235213],
              [-11238881.135029996, 3594635.411904777],
              [-11238887.36892148, 3540594.6586128958],
              [-11327693.271938251, 3540629.2081840746],
              [-11316575.794392725, 3549632.977183629],
              [-11325692.749369204, 3557767.773549154],
              [-11315208.234448329, 3575836.2787233274],
              [-11315898.52661074, 3583557.5481413123],
              [-11328808.693235999, 3587776.0738980635],
              [-11333150.153376935, 3593785.200490945],
              [-11341612.215789078, 3623096.750950435],
              [-11352766.874044526, 3631083.0357255572],
              [-11375931.45820319, 3633241.0970635256],
              [-11377078.16027785, 3636779.115934376],
              [-11387169.16079877, 3637513.2666077577],
              [-11397869.524212291, 3644073.1893337998],
              [-11388118.827374728, 3643950.4812753373],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yoakum',
        GEOID: '48501',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11472598.187062327, 3924438.6981003834],
              [-11472196.553501619, 3946973.669281003],
              [-11420804.901539411, 3946983.6399171064],
              [-11420825.71828419, 3889840.741272108],
              [-11472972.87605343, 3889877.276622433],
              [-11472598.187062327, 3924438.6981003834],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mora',
        GEOID: '35033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11768415.70758961, 4297696.560573713],
              [-11751781.01344139, 4297016.340838536],
              [-11747588.164820662, 4302412.226161749],
              [-11735299.828870973, 4318758.805019808],
              [-11734151.56832344, 4333255.7301979335],
              [-11726535.8679998, 4336713.399021445],
              [-11673545.563992387, 4336652.10129697],
              [-11673563.152471932, 4330641.370106539],
              [-11625768.574377803, 4330733.127631247],
              [-11623374.09213084, 4317664.084608413],
              [-11613660.130725238, 4295145.9218666395],
              [-11620612.25556426, 4281045.550232767],
              [-11618428.612432858, 4270296.006783055],
              [-11660788.461666968, 4270820.868578686],
              [-11690617.298461461, 4268976.622615176],
              [-11700761.175740507, 4274222.859838829],
              [-11727266.79177635, 4282843.759006988],
              [-11768755.454675512, 4282911.072260488],
              [-11768415.70758961, 4297696.560573713],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wyoming',
        GEOID: '36121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8734614.93832941, 5291819.769269856],
              [-8691176.959826965, 5292233.963282741],
              [-8677906.897287972, 5291104.88337782],
              [-8678059.40499036, 5261471.174319762],
              [-8689699.527545158, 5241181.850080818],
              [-8687179.476912579, 5239423.891355445],
              [-8717300.082092442, 5239377.824491603],
              [-8733063.812544696, 5239074.5439982815],
              [-8734565.84643397, 5241661.048069757],
              [-8734487.14355398, 5278615.2487886585],
              [-8737049.272954078, 5290281.169133327],
              [-8734614.93832941, 5291819.769269856],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Licking',
        GEOID: '39089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9214340.050011538, 4862473.435875001],
              [-9213634.061800927, 4873360.302496859],
              [-9213004.438761, 4884248.075219219],
              [-9211771.01880301, 4906276.606567866],
              [-9181328.032377811, 4901727.278603629],
              [-9150006.957809232, 4900744.487246694],
              [-9148629.824388629, 4898928.060968567],
              [-9149026.678373309, 4890222.542831129],
              [-9149881.723382091, 4868949.931031274],
              [-9150325.442872392, 4858699.4033319],
              [-9154244.111587297, 4853345.45353834],
              [-9174803.93098089, 4854678.880550066],
              [-9179718.35254094, 4855830.4424297875],
              [-9182570.914492518, 4855167.621196934],
              [-9215305.189996716, 4857177.995884328],
              [-9214340.050011538, 4862473.435875001],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chickasaw',
        GEOID: '28017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9928589.8366317, 4003547.213922978],
              [-9922782.96671396, 4003605.3610910256],
              [-9922925.678301157, 4038758.3410834875],
              [-9887900.670315417, 4038870.1565596336],
              [-9876149.896186769, 4038812.7703547613],
              [-9876262.885469925, 4003496.301898236],
              [-9899773.22796699, 4003636.176530089],
              [-9899820.87270905, 3995859.646831006],
              [-9911274.980394734, 3993867.2754931566],
              [-9928783.643865172, 3993756.4347198736],
              [-9928589.8366317, 4003547.213922978],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grant',
        GEOID: '22043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10349765.905533653, 3725162.471260981],
              [-10310408.565605218, 3725247.5252550603],
              [-10310324.853348142, 3736712.636186321],
              [-10281758.490898736, 3736645.0524485973],
              [-10280496.35051212, 3714127.3856881135],
              [-10272015.80906451, 3702567.707660941],
              [-10272297.113417743, 3697363.917726239],
              [-10263226.356029943, 3694967.3244149582],
              [-10311740.837271031, 3683564.652900814],
              [-10318524.980998447, 3684754.0139788515],
              [-10321429.974430189, 3700152.594215351],
              [-10331139.59437565, 3710728.4091887353],
              [-10342506.09362208, 3714208.178977038],
              [-10348773.603592722, 3721472.8793368046],
              [-10349765.905533653, 3725162.471260981],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adair',
        GEOID: '21001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9520808.842056904, 4454373.705956058],
              [-9504486.844358321, 4462593.627657912],
              [-9501427.005514886, 4465963.376506395],
              [-9496920.792527575, 4473508.34574685],
              [-9483590.394824572, 4477107.643761135],
              [-9480543.803000541, 4482460.751907655],
              [-9468490.573815407, 4474995.805803324],
              [-9466978.632491454, 4465068.509513022],
              [-9485069.719537724, 4438669.399544068],
              [-9487985.733599052, 4428667.5122643905],
              [-9512454.202953378, 4430487.526435397],
              [-9511731.405499658, 4433146.319130164],
              [-9518220.441256978, 4440177.334278985],
              [-9520808.842056904, 4454373.705956058],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson Davis',
        GEOID: '28065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10015925.097855601, 3732064.6448806743],
              [-9991492.36205782, 3733766.6759717334],
              [-9991549.246317616, 3712192.690496703],
              [-9972770.204818245, 3699610.6861332003],
              [-9972759.072869165, 3689200.796394991],
              [-9980261.227312196, 3689216.060942723],
              [-9999188.212414833, 3689253.635295232],
              [-9999087.579595154, 3683505.0574740507],
              [-10014183.39310265, 3683566.0873676147],
              [-10016088.292229105, 3700790.2484517996],
              [-10015925.097855601, 3732064.6448806743],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crawford',
        GEOID: '29055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10189642.391503736, 4609272.666726127],
              [-10170981.571303587, 4609097.699583568],
              [-10168922.606001876, 4608294.163917069],
              [-10140734.173223713, 4608296.147179084],
              [-10141207.503698565, 4542763.052412777],
              [-10146384.305298414, 4542875.5273381],
              [-10147143.94950359, 4536757.893786163],
              [-10164655.61860028, 4537138.88330174],
              [-10164394.68571386, 4549405.800151785],
              [-10188939.074960904, 4549659.77143503],
              [-10188515.281659456, 4599338.10017154],
              [-10189561.016955968, 4601004.569445097],
              [-10189642.391503736, 4609272.666726127],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Polk',
        GEOID: '29167',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10422666.257066896, 4555358.640520443],
              [-10416521.198536128, 4555161.327391436],
              [-10415420.360091671, 4553046.92939139],
              [-10373631.245886859, 4551596.523891838],
              [-10371991.287148492, 4541305.915060672],
              [-10373027.226329815, 4497420.292314428],
              [-10421859.079439156, 4498852.683855169],
              [-10421289.123646295, 4519235.731215849],
              [-10420560.648898542, 4543008.415422663],
              [-10422666.257066896, 4555358.640520443],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rockingham',
        GEOID: '33015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7953906.079871773, 5301460.029672026],
              [-7945671.999776774, 5303930.234217882],
              [-7947364.278675814, 5313388.879021677],
              [-7948541.370971464, 5318222.773478266],
              [-7943326.609425252, 5327516.752309511],
              [-7939051.050422862, 5336723.388899867],
              [-7937688.722494535, 5339174.542318988],
              [-7931217.1638972685, 5353959.237664486],
              [-7917926.952530442, 5342474.596955645],
              [-7906654.5182537325, 5332992.413280932],
              [-7911803.044702922, 5324412.803549736],
              [-7889817.44527125, 5324220.917593725],
              [-7883596.164694713, 5330747.707250365],
              [-7876566.084406708, 5324154.771958834],
              [-7870713.01690029, 5321082.259650181],
              [-7874237.280659315, 5313829.147984273],
              [-7877548.47891296, 5308220.465759102],
              [-7881268.1083783265, 5300454.799650941],
              [-7882693.345931402, 5295032.610721401],
              [-7883345.33007653, 5292553.240830906],
              [-7888627.885192633, 5292244.595566505],
              [-7895980.426240037, 5294421.581833251],
              [-7899954.643380849, 5292051.849322946],
              [-7907157.125754665, 5290548.291248813],
              [-7909106.9326886255, 5286293.36483911],
              [-7910830.668950843, 5282533.382987956],
              [-7916638.653419082, 5283385.2359921625],
              [-7920348.708052648, 5283929.427572607],
              [-7924400.848837015, 5280166.651377261],
              [-7923922.063707113, 5272115.280154652],
              [-7930999.871915956, 5271958.462025932],
              [-7944250.672518327, 5279339.64969661],
              [-7943834.44894225, 5281421.703387038],
              [-7951224.727297033, 5285348.5983453905],
              [-7952920.568419779, 5295304.308431053],
              [-7953906.079871773, 5301460.029672026],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mercer',
        GEOID: '54055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9051521.491109516, 4498444.21017301],
              [-9049323.376444312, 4497026.029977738],
              [-9051096.91857163, 4503348.20637539],
              [-9041605.150869653, 4510493.017605907],
              [-9039016.750069728, 4519635.184295181],
              [-9027412.917668926, 4521478.849529682],
              [-9002060.682877192, 4499857.254713126],
              [-9001087.874851473, 4497953.320795406],
              [-9001867.098282704, 4497801.954604562],
              [-9003881.981066063, 4492758.06821582],
              [-8998564.360310359, 4485880.2631371245],
              [-9007890.70724902, 4481868.315705169],
              [-9014746.45800619, 4481125.167699245],
              [-9016434.923445366, 4480942.149885436],
              [-9029412.883640518, 4477997.097922484],
              [-9041937.216910688, 4471895.955802687],
              [-9057193.775762888, 4486281.108017692],
              [-9051521.491109516, 4498444.21017301],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sullivan',
        GEOID: '47163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9206375.58572324, 4363479.704648058],
              [-9196122.615343217, 4372313.541285621],
              [-9196012.069455983, 4382816.793467547],
              [-9182437.331103565, 4382918.330884634],
              [-9160941.361560961, 4382814.484477513],
              [-9155291.739894036, 4382787.191485921],
              [-9147565.832695628, 4382749.868193164],
              [-9144403.387395218, 4382743.397453228],
              [-9120867.18866275, 4382695.239708861],
              [-9119587.014518628, 4385745.988364287],
              [-9108910.378637785, 4385538.801699689],
              [-9113887.345270522, 4383777.046550987],
              [-9126399.656035686, 4370791.909594277],
              [-9149199.000945058, 4355857.6928777965],
              [-9161578.396238213, 4355317.90570938],
              [-9175127.425421134, 4362338.638894455],
              [-9195154.024453826, 4359010.38129999],
              [-9203970.862083126, 4360200.211093934],
              [-9206375.58572324, 4363479.704648058],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lake',
        GEOID: '18089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9743435.244540991, 5056422.687262126],
              [-9743284.000687467, 5081957.390356998],
              [-9743231.752511822, 5090794.264898523],
              [-9743132.010248069, 5117389.076022653],
              [-9737198.458749808, 5112097.00317646],
              [-9731084.124398496, 5114384.609159159],
              [-9725476.182410803, 5105646.263343984],
              [-9713909.75335891, 5104276.193921646],
              [-9709597.675899427, 5105550.030277714],
              [-9709159.305408798, 5048106.402113181],
              [-9715506.742773829, 5044638.040057689],
              [-9728632.869211229, 5036385.251075138],
              [-9743421.903799748, 5036870.845693636],
              [-9743435.231875895, 5056404.106866833],
              [-9743435.244540991, 5056422.687262126],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Owen',
        GEOID: '18119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9690767.544417897, 4770868.5967570525],
              [-9678391.822667936, 4770785.399197943],
              [-9678114.414496878, 4789702.775582436],
              [-9649809.096253382, 4789229.485921093],
              [-9643820.107648702, 4785051.747734214],
              [-9643698.546764757, 4771491.448782401],
              [-9649797.964304304, 4769921.797350632],
              [-9649507.643072315, 4745441.149735716],
              [-9690871.294183314, 4745777.128686991],
              [-9690767.544417897, 4770868.5967570525],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Warren',
        GEOID: '19181',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10440723.169029493, 5088144.92237603],
              [-10399209.459244903, 5088089.323585666],
              [-10389270.743787387, 5085024.305399978],
              [-10389212.746332685, 5036067.788815179],
              [-10414779.493783174, 5036158.280025155],
              [-10440565.540630529, 5036271.247362073],
              [-10440723.169029493, 5088144.92237603],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greenup',
        GEOID: '21089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9252450.500323595, 4655886.486679148],
              [-9242197.752582554, 4676408.865891502],
              [-9242894.6049396, 4681196.0620064335],
              [-9240833.08694492, 4683077.9860209115],
              [-9233188.888831636, 4684965.064009854],
              [-9227182.757025376, 4686791.536797744],
              [-9226414.31786902, 4684728.032405375],
              [-9225178.894871606, 4681411.402827958],
              [-9225000.783686336, 4675677.469490355],
              [-9222966.086033618, 4665153.245776937],
              [-9218538.730064875, 4660600.985389511],
              [-9217266.30546602, 4659293.03793954],
              [-9208887.732671974, 4658498.235883685],
              [-9203419.496645227, 4652507.388981644],
              [-9202127.401020283, 4651399.373964186],
              [-9213808.165484527, 4640877.681119541],
              [-9218437.94310662, 4635096.671218513],
              [-9219196.808075357, 4632385.799597254],
              [-9236250.28614794, 4635187.85551283],
              [-9245278.630809749, 4645382.025029079],
              [-9258043.414180031, 4650865.840482186],
              [-9252450.500323595, 4655886.486679148],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harney',
        GEOID: '41025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13350724.085425114, 5299347.681583087],
              [-13350837.18602776, 5339251.633068759],
              [-13346869.536736906, 5339259.876473796],
              [-13346826.344774477, 5405464.77765232],
              [-13346921.300300125, 5418856.106967652],
              [-13333573.425437067, 5418818.692031807],
              [-13333336.76019964, 5459112.829113607],
              [-13320176.68131755, 5459087.157963022],
              [-13226640.25653952, 5459367.534114153],
              [-13226635.6924404, 5472846.662164418],
              [-13201058.369638283, 5471675.555484749],
              [-13161041.239087915, 5471612.993293483],
              [-13161537.1674194, 5430045.665487859],
              [-13161169.033863347, 5298985.91659626],
              [-13159599.985640615, 5202396.587825647],
              [-13157439.942241263, 5201783.978538851],
              [-13157670.954221655, 5160529.182620462],
              [-13191471.201132692, 5160297.301343686],
              [-13222069.255608566, 5159884.803944702],
              [-13247133.172919145, 5160049.710894121],
              [-13270205.02794198, 5159957.4465272995],
              [-13283107.415610088, 5160062.086937743],
              [-13287108.126696646, 5160094.5335725],
              [-13287688.533207495, 5273838.423134449],
              [-13352080.40210094, 5273446.262103795],
              [-13350724.085425114, 5299347.681583087],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Richardson',
        GEOID: '31147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10687803.903292576, 4904013.204757831],
              [-10636340.269988948, 4904203.06032728],
              [-10636261.197943436, 4903660.771210175],
              [-10627955.428096367, 4900308.030335157],
              [-10628898.52682237, 4893376.011885467],
              [-10623460.013099665, 4886456.860766282],
              [-10619235.54974355, 4881687.258258114],
              [-10621519.603055647, 4876093.524935453],
              [-10617982.203596707, 4869882.90397995],
              [-10614177.303401394, 4870200.553470894],
              [-10609670.311177649, 4865941.98886863],
              [-10613188.67175873, 4865946.472939975],
              [-10662690.11485012, 4866009.5616294835],
              [-10663083.740000913, 4866010.110840289],
              [-10687859.876729006, 4866044.68014114],
              [-10687803.903292576, 4904013.204757831],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cape May',
        GEOID: '34009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8343992.841384977, 4721852.344863883],
              [-8338237.735030456, 4734203.922677315],
              [-8336261.814068876, 4742265.839155539],
              [-8338406.606697991, 4746762.013450948],
              [-8339516.996973993, 4747013.6710839],
              [-8340733.740653024, 4749940.462105902],
              [-8333521.128205546, 4768162.006195363],
              [-8310356.878005355, 4763089.7208646815],
              [-8297842.547412873, 4764739.223161286],
              [-8302319.833409062, 4760538.646677687],
              [-8309620.944851721, 4752084.695816898],
              [-8312385.564405573, 4747459.488860329],
              [-8317162.395075, 4738847.0253086295],
              [-8316220.075585437, 4736427.158718665],
              [-8324335.377783757, 4724977.1209437745],
              [-8327579.227745474, 4719658.9439809555],
              [-8333873.343074417, 4713139.4072751645],
              [-8341566.967041612, 4711437.698622954],
              [-8345318.767839817, 4712138.039327817],
              [-8343992.841384977, 4721852.344863883],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '05067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10194848.247490684, 4236202.474922196],
              [-10171214.006400364, 4235643.707737155],
              [-10171126.064002639, 4251199.968615156],
              [-10166263.072047332, 4250793.29474838],
              [-10168844.125760866, 4262042.187632329],
              [-10155943.421292324, 4274874.750281145],
              [-10152176.815001845, 4285499.376557083],
              [-10145524.918829491, 4285495.941380398],
              [-10133691.434319187, 4284818.683131148],
              [-10134188.809804048, 4260573.956381831],
              [-10134440.725811714, 4224481.844855138],
              [-10134502.285490124, 4212127.940995204],
              [-10158076.636694398, 4212579.048089062],
              [-10158229.367035765, 4224635.978954397],
              [-10168730.134602295, 4223715.16911993],
              [-10195160.721301341, 4224153.087318061],
              [-10194848.247490684, 4236202.474922196],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Humboldt',
        GEOID: '06023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13846700.06165121, 4939594.442481264],
              [-13837163.54351393, 4962267.965917971],
              [-13823288.682181455, 4989302.646517879],
              [-13816768.922244674, 5010758.087768804],
              [-13817581.665846957, 5019498.627352554],
              [-13820817.166846864, 5025206.109061214],
              [-13821871.91902213, 5032817.762755396],
              [-13817273.199537968, 5040366.611168834],
              [-13813889.86625429, 5054869.672161209],
              [-13810638.446567198, 5077397.283496903],
              [-13811127.99177474, 5081133.711472511],
              [-13778074.712522896, 5081053.02003118],
              [-13778039.98084177, 5068669.314547997],
              [-13765919.95996216, 5068864.261732508],
              [-13746602.466085823, 5068099.3317522],
              [-13737748.113788124, 5038919.703310377],
              [-13743950.279217672, 5023609.507041791],
              [-13737502.209032964, 5014376.193589823],
              [-13745892.915651508, 4999805.9216383835],
              [-13754654.427493881, 5005007.349025222],
              [-13761741.360236255, 5001936.844672463],
              [-13754619.584493263, 4987237.745351458],
              [-13752861.738414148, 4973976.823845718],
              [-13752906.154890973, 4866221.728557528],
              [-13806422.68555996, 4866131.098089983],
              [-13807613.673363365, 4867877.949092203],
              [-13811287.661837505, 4869039.037931798],
              [-13813311.227541145, 4877347.813251448],
              [-13819196.243741423, 4882864.377369589],
              [-13824530.896379218, 4884930.460153082],
              [-13832382.37138436, 4892757.156768894],
              [-13841807.23607237, 4901460.242514331],
              [-13844071.919793071, 4903939.099308001],
              [-13842926.442232804, 4914221.589374974],
              [-13844288.213563683, 4920565.649190181],
              [-13849212.319919432, 4929808.002899109],
              [-13846700.06165121, 4939594.442481264],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '08057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11895642.859222148, 5012447.662073788],
              [-11835618.417661019, 5012078.381952536],
              [-11824086.139657363, 5012007.435110011],
              [-11821078.407097464, 5012009.295398079],
              [-11820494.304967426, 5002607.569047313],
              [-11805206.131379843, 4983569.114258403],
              [-11789946.566901391, 4948597.53836731],
              [-11789608.712246835, 4941137.532630337],
              [-11783716.460279655, 4936856.746049375],
              [-11787816.13448659, 4935453.0613046745],
              [-11789298.242187012, 4924067.514994891],
              [-11795375.284508906, 4916664.072658419],
              [-11801939.01564455, 4920337.700610694],
              [-11825477.74461177, 4913047.152148498],
              [-11839246.184511045, 4918035.27743485],
              [-11849227.312694553, 4916428.034929483],
              [-11854394.986096157, 4925933.171676749],
              [-11868029.286009027, 4921227.31444553],
              [-11872458.799867181, 4930854.548120501],
              [-11872570.230677465, 4938097.998177806],
              [-11878474.171191176, 4955953.234673918],
              [-11870767.856802031, 4981340.749616505],
              [-11872729.194910318, 4990111.864469065],
              [-11876862.264964491, 4995863.970867885],
              [-11882169.087729588, 4993309.66080512],
              [-11891707.943576172, 5002334.381793137],
              [-11894749.080745155, 5001312.428847401],
              [-11895642.859222148, 5012447.662073788],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fairfield',
        GEOID: '09001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8203794.047031296, 5029356.709896114],
              [-8180057.7479903, 5043774.547221169],
              [-8187655.525875923, 5056014.481766061],
              [-8186897.460893641, 5066524.798884355],
              [-8186803.439816206, 5067829.167519144],
              [-8186789.706030574, 5068019.7131642485],
              [-8186785.713920962, 5068075.10130089],
              [-8186097.943560745, 5077622.255259841],
              [-8185286.281349535, 5090411.518672469],
              [-8184210.855552816, 5107383.107338173],
              [-8183977.283955082, 5111185.7988163205],
              [-8182753.23814037, 5111048.922918821],
              [-8175466.598231513, 5085079.737875741],
              [-8160884.524174032, 5081739.646458474],
              [-8159469.3194875745, 5078688.826534232],
              [-8149442.550312843, 5074571.105462518],
              [-8146724.239667163, 5070291.769021798],
              [-8142748.575372972, 5066728.959112004],
              [-8139208.504246254, 5061464.669021877],
              [-8133875.966678783, 5056840.393420356],
              [-8135991.148323347, 5053225.514154982],
              [-8135980.016374268, 5049967.355089735],
              [-8139943.101565998, 5038897.961403666],
              [-8137585.446216047, 5036521.328485716],
              [-8138384.517375402, 5035041.541592767],
              [-8140822.525543267, 5034018.359613455],
              [-8145562.772746023, 5035000.777694299],
              [-8148882.390635172, 5035688.829087134],
              [-8155528.386874512, 5029687.774716032],
              [-8156358.783495874, 5029566.740924299],
              [-8159408.582387736, 5029122.232898726],
              [-8163131.730734673, 5028579.611837459],
              [-8167766.629053343, 5027696.718269568],
              [-8165755.642452163, 5024981.614877479],
              [-8169428.740370377, 5020936.882968389],
              [-8173318.020739713, 5019359.58118849],
              [-8178446.954958522, 5019918.287240801],
              [-8183864.206658486, 5018057.1901964685],
              [-8188880.819511085, 5014819.533295335],
              [-8192635.737255032, 5014701.209039382],
              [-8199497.136709058, 5010154.635722668],
              [-8199501.3678806815, 5010206.821911841],
              [-8199722.669997406, 5012936.69613632],
              [-8199741.70563033, 5014975.924173135],
              [-8207338.370321046, 5027205.6656565415],
              [-8203794.047031296, 5029356.709896114],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clark',
        GEOID: '16033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12578555.99225961, 5501745.496973868],
              [-12558373.87989828, 5501148.131582715],
              [-12559824.916243251, 5528363.824184892],
              [-12559276.013051668, 5528711.866236298],
              [-12559976.769246211, 5534173.032893504],
              [-12549612.145416923, 5543015.946998686],
              [-12546576.57422248, 5543619.02627075],
              [-12534782.05153395, 5541744.991539455],
              [-12520460.131126452, 5540030.48167864],
              [-12510906.915065555, 5535044.0421550805],
              [-12507737.426523691, 5547650.570320714],
              [-12499641.159958294, 5553840.150836853],
              [-12492462.277316527, 5549941.903090516],
              [-12481709.148464369, 5547600.602210599],
              [-12471582.637025885, 5549035.576981313],
              [-12453367.540066874, 5553146.551978168],
              [-12446400.053138124, 5544975.944692274],
              [-12434856.667220823, 5552548.465070724],
              [-12425159.518877147, 5552067.625549927],
              [-12425196.250490293, 5527748.598886362],
              [-12444586.6586331, 5527804.067359587],
              [-12444577.419115365, 5514633.702288992],
              [-12451338.408388695, 5514629.812639575],
              [-12451959.014549866, 5494544.445586897],
              [-12458165.076161591, 5487805.903543178],
              [-12471530.428184705, 5487761.22615937],
              [-12471603.119812192, 5474322.760691393],
              [-12485141.573643489, 5474388.129623342],
              [-12545121.517158322, 5474494.084047609],
              [-12545176.954264736, 5461101.01470699],
              [-12578470.49889068, 5461166.134868751],
              [-12578555.99225961, 5501745.496973868],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Echols',
        GEOID: '13101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9254324.229992628, 3605461.087576065],
              [-9251008.467639862, 3610636.842837702],
              [-9249322.97922976, 3613110.0616518566],
              [-9241679.449033422, 3613213.1447173757],
              [-9236326.873957608, 3615798.799365071],
              [-9222413.830039792, 3611337.6851894096],
              [-9213486.674795117, 3598045.2544649947],
              [-9192897.355736464, 3593362.2525460115],
              [-9193209.40502128, 3579828.1685929713],
              [-9204956.351101212, 3580636.786069802],
              [-9225860.05883577, 3582075.851120376],
              [-9254148.567836156, 3583959.0787725034],
              [-9254726.07756969, 3583999.303032056],
              [-9254324.229992628, 3605461.087576065],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Allen',
        GEOID: '21003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9620116.51451562, 4394079.106387866],
              [-9618646.206681222, 4407955.887462417],
              [-9595897.846098635, 4430094.363580802],
              [-9592037.620116396, 4429913.31579982],
              [-9585322.939751238, 4420315.101309259],
              [-9580746.484165234, 4425055.842466064],
              [-9581263.785838952, 4412069.906390692],
              [-9570905.84117911, 4400527.960599873],
              [-9567983.815865278, 4390574.883708956],
              [-9570772.611134253, 4387469.313611825],
              [-9582598.17257509, 4388192.069340543],
              [-9596359.629386678, 4388941.037171354],
              [-9619283.755553836, 4390188.800198285],
              [-9620116.51451562, 4394079.106387866],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Caddo',
        GEOID: '22017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10468824.608699977, 3854629.3510082844],
              [-10468821.766978586, 3868453.039747733],
              [-10468819.164502919, 3879531.129577362],
              [-10468814.865170158, 3897855.24213388],
              [-10443388.270454017, 3897877.817687168],
              [-10446510.112758383, 3888239.904757992],
              [-10440118.592874995, 3876385.2302594264],
              [-10444468.06801927, 3867787.597230362],
              [-10439901.742506929, 3866716.214463382],
              [-10443902.119728077, 3860314.8423826336],
              [-10439776.84203826, 3857166.924914469],
              [-10435030.512909308, 3841111.0480166045],
              [-10436893.110629259, 3834013.3690036866],
              [-10428447.078223795, 3824226.291082419],
              [-10429029.835758096, 3815338.5863228003],
              [-10426076.752306331, 3816730.869960918],
              [-10417545.337851426, 3806511.129782661],
              [-10413351.709994262, 3806373.857805324],
              [-10411133.446501223, 3799331.7636882453],
              [-10405171.842491282, 3794485.4026657287],
              [-10421139.621570159, 3794530.149164037],
              [-10426903.967442416, 3805052.59700205],
              [-10437845.671511978, 3808768.0444004983],
              [-10458586.941675562, 3789006.4063651324],
              [-10468785.023057412, 3789066.914754741],
              [-10468789.818284728, 3811128.5780781074],
              [-10468795.298855547, 3814914.76232841],
              [-10468828.112189561, 3837608.6991876955],
              [-10468824.608699977, 3854629.3510082844],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cumberland',
        GEOID: '23005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7883847.047021534, 5477379.644024622],
              [-7861864.341896623, 5491948.6613523625],
              [-7857745.743376253, 5484421.433210194],
              [-7858669.695149838, 5470404.41883751],
              [-7852932.622552826, 5466316.111169217],
              [-7845806.394030202, 5470407.670393786],
              [-7832870.623922061, 5463344.755417274],
              [-7827471.628618587, 5471294.768948861],
              [-7817883.680876562, 5461429.404456399],
              [-7805261.8317324575, 5451016.672614983],
              [-7801363.311845387, 5454068.4338102555],
              [-7796175.712254929, 5461676.439244827],
              [-7789717.84595503, 5452340.29679131],
              [-7776449.230569417, 5456894.858863313],
              [-7780478.996136134, 5446661.769984675],
              [-7779830.462603943, 5429392.733415314],
              [-7782968.211269762, 5430705.948248783],
              [-7790548.178036857, 5425971.550546507],
              [-7792506.06524093, 5420732.89922394],
              [-7799352.6213803785, 5421190.597909318],
              [-7800301.880500673, 5421254.058561533],
              [-7803055.368105444, 5414865.418998602],
              [-7811091.29950683, 5415305.5969753],
              [-7813593.427701389, 5410757.999761557],
              [-7816530.369826988, 5403243.843478776],
              [-7815309.862929932, 5397237.218085036],
              [-7819693.179199407, 5394473.851173324],
              [-7828110.8251347225, 5392573.97736306],
              [-7830072.439009041, 5392704.0646557845],
              [-7847134.5468748575, 5404789.078806266],
              [-7843320.0732033355, 5410264.198406677],
              [-7853586.1792832725, 5421565.782584681],
              [-7865793.14068519, 5420812.056873351],
              [-7865041.622802843, 5432597.951848693],
              [-7879525.73570843, 5436725.905926221],
              [-7881598.727265983, 5443169.852439945],
              [-7872004.322993493, 5459534.866925288],
              [-7883847.047021534, 5477379.644024622],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Traverse',
        GEOID: '27155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10781473.13222312, 5719568.083699876],
              [-10778638.826668033, 5725100.90762186],
              [-10769613.71027146, 5732654.855149529],
              [-10761551.84142872, 5737559.13862738],
              [-10756859.39093331, 5745348.563547263],
              [-10752026.009962559, 5750983.036412435],
              [-10750331.504673703, 5759836.181618871],
              [-10749418.796168689, 5769978.251525402],
              [-10750597.892215172, 5783000.964628777],
              [-10750423.509586522, 5783858.070218685],
              [-10716297.685433984, 5783812.914431646],
              [-10714910.087981246, 5769882.69414583],
              [-10714948.715844551, 5741943.391766249],
              [-10714837.841631722, 5714176.435718915],
              [-10779669.55186461, 5714272.302573822],
              [-10780619.97964568, 5715524.917441722],
              [-10781473.13222312, 5719568.083699876],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ozark',
        GEOID: '29153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10326537.980584728, 4412113.562768757],
              [-10253899.45249383, 4410463.921004768],
              [-10254799.259558342, 4369390.294250169],
              [-10258125.168138688, 4369382.983879042],
              [-10280385.810257763, 4369334.054954871],
              [-10300296.367743045, 4369386.494260298],
              [-10304203.839827383, 4369396.785570396],
              [-10327368.968713736, 4369375.065791245],
              [-10326537.980584728, 4412113.562768757],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Humboldt',
        GEOID: '32013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13283723.889542894, 5008485.309628526],
              [-13281051.21988844, 5046998.350886388],
              [-13283081.91003949, 5073676.729991907],
              [-13283107.415610088, 5160062.086937743],
              [-13270205.02794198, 5159957.4465272995],
              [-13247133.172919145, 5160049.710894121],
              [-13222069.255608566, 5159884.803944702],
              [-13191471.201132692, 5160297.301343686],
              [-13157670.954221655, 5160529.182620462],
              [-13157650.892676316, 5160529.320251213],
              [-13121614.324477738, 5160730.038387469],
              [-13093813.840124987, 5160749.810850463],
              [-13069310.416450555, 5160873.090086427],
              [-13046399.195452936, 5161036.3663768405],
              [-13027296.659513319, 5160962.966597495],
              [-13026406.795631418, 5160955.454441945],
              [-13026430.81651393, 5012379.128861721],
              [-13026458.089789174, 4959831.134973076],
              [-13051852.737306898, 4959744.577590655],
              [-13057842.727786994, 4942696.096334916],
              [-13057906.291216236, 4965600.369200581],
              [-13096114.591360703, 4965893.22875281],
              [-13096094.66517185, 4991393.300375386],
              [-13184479.001276987, 4991080.100535454],
              [-13223279.187153999, 4991114.393072556],
              [-13223275.513610803, 5006568.76166174],
              [-13281483.69611017, 5006499.183330351],
              [-13283723.889542894, 5008485.309628526],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McKinley',
        GEOID: '35031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12139033.803357981, 4213404.191892126],
              [-12138978.143612584, 4247671.901197421],
              [-12138947.864711089, 4284094.617163056],
              [-12138930.851553492, 4300993.118605198],
              [-11980928.400376655, 4300661.000472492],
              [-11945546.16814496, 4300422.681690205],
              [-11945626.20685884, 4205500.7733138725],
              [-11981181.874857193, 4205316.079059787],
              [-11981128.998099066, 4211316.950101579],
              [-11992920.849119816, 4211293.885093778],
              [-11992918.956688473, 4205405.288453907],
              [-12074682.120800715, 4205633.22582317],
              [-12074678.55857701, 4204621.798174337],
              [-12074758.59729089, 4158321.804847167],
              [-12138928.632619632, 4158421.980685238],
              [-12138984.811024914, 4187757.522187183],
              [-12139033.803357981, 4213404.191892126],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '29095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10531751.56567995, 4719065.773164461],
              [-10531699.952773636, 4727988.353117997],
              [-10531642.472578973, 4737934.503886258],
              [-10529925.814711452, 4743898.805187246],
              [-10528213.609623559, 4747657.812161326],
              [-10529370.441771884, 4739353.108467173],
              [-10525210.321081446, 4740438.5392551],
              [-10524059.166227154, 4742133.2153179245],
              [-10522303.769176833, 4743004.201089689],
              [-10519181.034821102, 4743237.175239925],
              [-10517979.34091799, 4742535.2546273945],
              [-10515416.098322984, 4738928.524939267],
              [-10511427.966245823, 4742004.61204695],
              [-10508819.082659591, 4745300.443923108],
              [-10508551.915881688, 4746741.6226773625],
              [-10509520.395451589, 4749441.604507278],
              [-10504772.841808237, 4745079.482322897],
              [-10501347.875035, 4747967.152589474],
              [-10496402.172698038, 4755664.653731798],
              [-10487689.196153648, 4751378.424608072],
              [-10483348.181290673, 4752347.189602615],
              [-10475700.977551138, 4742248.615182164],
              [-10476277.83515243, 4723818.559153268],
              [-10476742.037429037, 4709832.993005465],
              [-10477289.84064323, 4697802.272975566],
              [-10531821.289947208, 4699809.474876063],
              [-10531751.56567995, 4719065.773164461],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Queens',
        GEOID: '36081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8233465.388768698, 4973597.1889870735],
              [-8228847.967610084, 4980202.794685577],
              [-8227896.965200238, 4982312.232883418],
              [-8220571.920067059, 4983036.90148784],
              [-8218448.946058138, 4983465.140043603],
              [-8213036.035818318, 4984608.917332696],
              [-8209845.28525371, 4980309.968504509],
              [-8204428.256192728, 4975902.6988736605],
              [-8206998.511915654, 4971762.690855415],
              [-8207494.328927645, 4971006.692223603],
              [-8207257.3297317475, 4969586.507017973],
              [-8207099.590013293, 4965195.224572131],
              [-8207371.20957083, 4964023.922500882],
              [-8207342.711781186, 4962793.472420537],
              [-8207015.432478255, 4961358.778625129],
              [-8208884.1527702, 4959708.34108318],
              [-8209881.65574212, 4951953.844593299],
              [-8212587.41827042, 4952164.824255437],
              [-8218216.399767785, 4950023.414540903],
              [-8220759.382089555, 4959902.435357705],
              [-8222479.15690282, 4965419.226376583],
              [-8223027.9619924305, 4967402.291692969],
              [-8224241.233122587, 4966886.080529377],
              [-8229038.546578322, 4970611.7513512205],
              [-8229084.855486492, 4970691.942591654],
              [-8233465.388768698, 4973597.1889870735],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '21111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9568102.77698443, 4581536.566795176],
              [-9564837.259138513, 4583477.986276315],
              [-9562919.112992655, 4595128.182614127],
              [-9561889.16143467, 4604874.726206408],
              [-9561761.390288405, 4606084.480317003],
              [-9555627.686345696, 4613352.864059952],
              [-9553011.678312056, 4619477.3257062975],
              [-9550601.266999602, 4618766.2504143715],
              [-9545753.424873352, 4617336.277717321],
              [-9538250.379874393, 4621250.170772322],
              [-9534091.483698357, 4627982.246752425],
              [-9532782.716583902, 4633019.741702897],
              [-9527308.898443813, 4627487.623269342],
              [-9515172.958877023, 4620431.220233236],
              [-9514277.170934608, 4619809.179074618],
              [-9507229.86793096, 4616749.300788981],
              [-9509362.192777105, 4600274.845603836],
              [-9509893.854665132, 4596162.885022057],
              [-9521097.827455005, 4591279.766838004],
              [-9541480.53753874, 4591767.281839665],
              [-9560430.120498007, 4585155.045942146],
              [-9566610.133348888, 4579250.078882468],
              [-9568102.77698443, 4581536.566795176],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Swain',
        GEOID: '37173',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9341575.55632047, 4228430.846079299],
              [-9333972.54641878, 4234672.190805589],
              [-9325426.994388543, 4240535.561966139],
              [-9313312.751167428, 4241313.10105996],
              [-9312227.063128749, 4241382.7874192055],
              [-9304954.338156242, 4241198.584554506],
              [-9294992.134286173, 4240653.657792292],
              [-9289882.124380797, 4246120.163445223],
              [-9286447.361492371, 4247252.213385086],
              [-9278174.764853561, 4254003.128261525],
              [-9272596.76780889, 4253629.916710427],
              [-9268988.921846239, 4259843.478391529],
              [-9259775.322817793, 4255490.209524964],
              [-9256865.208689475, 4239236.181319338],
              [-9260259.006005289, 4234003.271432274],
              [-9265797.261991747, 4235397.777119771],
              [-9278671.695060462, 4227676.333044081],
              [-9277322.836790519, 4208953.242427152],
              [-9291524.086869998, 4204433.299586107],
              [-9315227.680003082, 4201929.247104655],
              [-9304723.79549081, 4223131.214223189],
              [-9345630.967688218, 4226573.209226054],
              [-9341575.55632047, 4228430.846079299],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Val Verde',
        GEOID: '48465',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11327693.271938251, 3540629.2081840746],
              [-11238887.36892148, 3540594.6586128958],
              [-11209916.471442532, 3540659.1168443016],
              [-11209865.153157275, 3455296.342886511],
              [-11209777.099440057, 3429179.671688863],
              [-11216309.438479297, 3406014.5783396563],
              [-11221212.566234957, 3405313.784448547],
              [-11226421.92366194, 3410237.4119379665],
              [-11230671.879181445, 3414886.8403249243],
              [-11242779.543597577, 3421980.9035437535],
              [-11249964.548811337, 3434153.8336664755],
              [-11258575.334063178, 3436056.494074194],
              [-11264722.06238631, 3442034.7954081176],
              [-11271643.351726383, 3442042.087236539],
              [-11277280.348101173, 3449410.5971412393],
              [-11277480.611865109, 3457450.332141214],
              [-11284144.86450094, 3460438.1326356367],
              [-11287867.165634086, 3469926.575368352],
              [-11293751.847875888, 3472695.0466624093],
              [-11299287.098236095, 3473324.805839483],
              [-11305782.145245919, 3477182.257614434],
              [-11316135.85976511, 3473399.3120724135],
              [-11322775.622112967, 3473719.527083808],
              [-11328051.632703664, 3475155.924491922],
              [-11327693.271938251, 3540629.2081840746],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Northumberland',
        GEOID: '51133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8528886.83454774, 4579655.09087427],
              [-8517131.492013877, 4585005.776873065],
              [-8515050.2671201, 4581858.989620804],
              [-8507868.935449535, 4576182.560015043],
              [-8495564.235534701, 4570237.536794005],
              [-8486633.406746829, 4563781.624217355],
              [-8488262.344855607, 4555871.249338616],
              [-8494824.517518379, 4550485.256123958],
              [-8495108.493539391, 4539993.933791294],
              [-8496493.435987836, 4534680.688466954],
              [-8506981.051190969, 4554513.321036289],
              [-8516812.45465936, 4556680.594110714],
              [-8522179.612588463, 4569756.961741016],
              [-8530883.46093461, 4574712.822986048],
              [-8528886.83454774, 4579655.09087427],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Buckingham',
        GEOID: '51029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8774485.015832435, 4527378.515269966],
              [-8765234.032189045, 4527505.0213318225],
              [-8758298.49395415, 4536603.138356229],
              [-8754350.214254696, 4534835.572157528],
              [-8754600.905747961, 4541787.851389215],
              [-8738325.550916024, 4546013.630860606],
              [-8737616.557079159, 4550782.080359288],
              [-8734589.112207545, 4545605.281777536],
              [-8709608.907154042, 4535794.930258269],
              [-8710641.17279217, 4528067.851315538],
              [-8734693.75252889, 4486559.734312724],
              [-8739859.19954068, 4485166.256661389],
              [-8749092.59470453, 4494725.3637508135],
              [-8753123.918744117, 4492828.677676367],
              [-8753687.640645493, 4497278.591632765],
              [-8774785.355818598, 4516406.427651483],
              [-8774485.015832435, 4527378.515269966],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Prince William',
        GEOID: '51153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8651285.508981707, 4698611.576570209],
              [-8644533.870545603, 4713460.862041073],
              [-8633075.866677742, 4705439.271978678],
              [-8632715.302847061, 4699715.3801290225],
              [-8631267.036271842, 4699831.8703372795],
              [-8628241.483831571, 4698931.714432296],
              [-8626159.920673227, 4694496.844187341],
              [-8623724.361534161, 4692535.012615963],
              [-8620924.676340712, 4693585.446827705],
              [-8613960.751635667, 4682004.949169993],
              [-8611217.616743539, 4682417.027624348],
              [-8604981.944147263, 4679526.12358761],
              [-8603037.860560048, 4678286.009574488],
              [-8598958.223861458, 4674835.622825535],
              [-8596552.59355765, 4669547.903080193],
              [-8599063.754738728, 4669553.421776589],
              [-8604470.542406557, 4659142.415147864],
              [-8604911.146361101, 4657185.337391007],
              [-8606399.74081002, 4650576.053982089],
              [-8625571.819803368, 4663423.50072808],
              [-8630747.953486275, 4658348.763619102],
              [-8641173.023799064, 4678243.220201193],
              [-8647268.54515643, 4689984.511242835],
              [-8651285.508981707, 4698611.576570209],
            ],
            [
              [-8629916.396890046, 4681303.826251975],
              [-8624051.974795567, 4682736.656731444],
              [-8622662.484911485, 4689110.4984740075],
              [-8619171.171721734, 4686437.806986736],
              [-8618419.65383939, 4687678.199267024],
              [-8620618.43642154, 4690703.225549572],
              [-8621124.049548721, 4688850.065455457],
              [-8624251.79328154, 4691405.566819628],
              [-8624562.152021872, 4690374.492782739],
              [-8629916.396890046, 4681303.826251975],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Vernon',
        GEOID: '55123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10158682.78868824, 5423084.93135175],
              [-10120127.599643987, 5423034.908380351],
              [-10053507.448503336, 5423981.538679612],
              [-10053530.825596403, 5410051.30278514],
              [-10053382.214076193, 5396678.703258842],
              [-10093522.130024904, 5396504.366285752],
              [-10093178.041478863, 5376579.082570635],
              [-10150496.335968828, 5376582.607770634],
              [-10153524.599903954, 5376034.6518762605],
              [-10155930.508231394, 5380865.182189407],
              [-10154308.583250536, 5388473.678887766],
              [-10155990.175478458, 5398345.591941578],
              [-10158229.255716275, 5403804.291953437],
              [-10160491.93568614, 5413995.436609698],
              [-10158682.78868824, 5423084.93135175],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brunswick',
        GEOID: '37019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8754241.3437927, 4030125.254338305],
              [-8744931.026860712, 4037109.862221687],
              [-8743613.672006665, 4048389.116937548],
              [-8740281.990966713, 4051095.4468141315],
              [-8729999.63224112, 4047548.077114021],
              [-8724586.610681806, 4056347.443057978],
              [-8711264.673260104, 4057883.614771908],
              [-8700993.001205627, 4076840.6748806727],
              [-8698204.670600235, 4078823.608429257],
              [-8686251.183678854, 4073437.836374505],
              [-8678089.572572364, 4060332.066099402],
              [-8670169.199209392, 4033938.0126370382],
              [-8673517.792404976, 4025005.747581991],
              [-8675665.27173954, 4018138.6143705733],
              [-8678486.649196025, 4009122.7794886683],
              [-8683673.358230555, 4009845.16827601],
              [-8685000.731838774, 4013811.8133841716],
              [-8698165.708778458, 4017015.7643166864],
              [-8713660.825299429, 4017040.713834184],
              [-8725662.958838286, 4015643.3564524823],
              [-8743153.811190197, 4008827.4831866473],
              [-8751485.51847862, 4017464.461536129],
              [-8755374.94139627, 4021426.735687417],
              [-8754241.3437927, 4030125.254338305],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wichita',
        GEOID: '48485',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11015322.41929021, 4056317.4134051073],
              [-11013974.90937446, 4056184.9806975904],
              [-11006406.185875935, 4050366.404263128],
              [-10999123.776107732, 4049754.9809590587],
              [-10991378.388577316, 4046404.642549762],
              [-10986128.561391506, 4046695.5336591117],
              [-10981453.254097678, 4050903.865128209],
              [-10977254.147278264, 4049796.5404904056],
              [-10973556.583379276, 4048821.564490895],
              [-10968109.052777817, 4041560.106747689],
              [-10962194.202954007, 4037435.0506981704],
              [-10956457.575634956, 4039811.153647298],
              [-10956462.473692551, 4006808.3323701117],
              [-11015420.059003938, 4006537.352297151],
              [-11015322.41929021, 4056317.4134051073],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '28095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9876262.885469925, 4003496.301898236],
              [-9876149.896186769, 4038812.7703547613],
              [-9875425.206301704, 4040791.215836727],
              [-9856600.85776958, 4040764.735729058],
              [-9818778.000829812, 4040426.5124094277],
              [-9819183.816565672, 4036637.4148490047],
              [-9823765.556923106, 3994600.5643439675],
              [-9832307.271335293, 3994692.0554752643],
              [-9841373.241984988, 3985023.7226772644],
              [-9853324.16855808, 3981929.791094005],
              [-9850770.610758774, 3985075.0879188436],
              [-9876223.589689672, 3985948.198347378],
              [-9876262.885469925, 4003496.301898236],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bristol Bay',
        GEOID: '02060',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-17492291.378969006, 8111698.263732141],
              [-17484087.46645602, 8124441.974647785],
              [-17476441.821189355, 8145195.970363501],
              [-17478950.962511834, 8150940.151995359],
              [-17487776.84718068, 8151624.945183878],
              [-17482224.646097083, 8155751.825366801],
              [-17400782.527396284, 8155751.825366801],
              [-17400782.527396284, 8097990.969299292],
              [-17503242.28211149, 8097991.183062272],
              [-17492291.378969006, 8111698.263732141],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yukon-Koyukuk',
        GEOID: '02290',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-17927800.945505504, 8991332.566838888],
              [-17922015.11497152, 8991335.947936693],
              [-17922016.673444394, 9075512.569835925],
              [-17916141.78731778, 9100071.666460812],
              [-17906629.536829494, 9103182.409718515],
              [-17906631.095302362, 9167218.720366938],
              [-17885408.813619062, 9167220.4529352],
              [-17887958.25259721, 9188696.970760323],
              [-17887961.703501422, 9231825.966557218],
              [-17866486.058657076, 9231831.960840944],
              [-17866486.72657402, 9253501.76460698],
              [-17823533.09917602, 9253503.768791208],
              [-17823530.42750824, 9275237.4743679],
              [-17803631.066653524, 9275237.725657187],
              [-17803630.176097598, 9297036.770325469],
              [-17781891.705935486, 9297037.274446962],
              [-17781894.377603266, 9362843.664459098],
              [-17805250.653925076, 9362843.664459098],
              [-17806916.77274378, 9451540.504814431],
              [-17806920.668925956, 9541359.142906103],
              [-17786060.175587732, 9541360.447459534],
              [-17786062.847255513, 9586691.193860805],
              [-17763493.043136157, 9586699.596886916],
              [-17764668.910917405, 9678263.268324638],
              [-17741807.1157737, 9678265.13057815],
              [-17742721.382751588, 9747724.499774266],
              [-17765867.82183325, 9747724.499774266],
              [-17767126.51131565, 9865040.71120272],
              [-17696701.571299173, 9865045.902518686],
              [-17696702.684494082, 9912523.938320944],
              [-17578048.352452442, 9912529.990353135],
              [-17578050.0222448, 10008472.60220939],
              [-17482868.963309795, 10008476.506920688],
              [-17482866.959558956, 9960340.954055576],
              [-17435276.87536942, 9960342.338985566],
              [-17435278.322522797, 10008477.622552888],
              [-17387684.119512096, 10008516.66979268],
              [-17387687.793055292, 9984370.179457797],
              [-17363892.91793976, 9984371.01328829],
              [-17363892.361342303, 9960344.83186025],
              [-17316302.611111235, 9960346.493777195],
              [-17311358.689886123, 10008482.363991743],
              [-17311359.135164086, 10032675.619974412],
              [-17238984.322946876, 10032679.258419195],
              [-17238985.992739238, 10081318.228396753],
              [-17166612.29371694, 10081321.892406764],
              [-17166613.9635093, 10105769.180964846],
              [-17159478.829427414, 10105769.463806408],
              [-17159489.182140056, 10204426.10964828],
              [-17176942.185865097, 10204425.822750842],
              [-17176943.63301848, 10229310.673939196],
              [-17226569.194097172, 10229308.946351757],
              [-17220065.130208597, 10304504.635791844],
              [-17220066.46604249, 10329752.343034346],
              [-17245242.482080296, 10329750.882290239],
              [-17245243.817914184, 10355091.033262609],
              [-17270420.27922995, 10355089.567141596],
              [-17270421.615063842, 10380523.194956787],
              [-17295597.853740633, 10380521.72341576],
              [-17290001.155021507, 10406049.283375278],
              [-17290003.49273081, 10447006.82402071],
              [-17138812.922559097, 10446997.314774934],
              [-17003088.303201757, 10446999.989248976],
              [-16909461.375677712, 10446999.394921321],
              [-16797001.08274279, 10446998.503429934],
              [-16622830.830086617, 10446997.017611215],
              [-16447801.747558974, 10446993.748811154],
              [-16342782.828625105, 10446997.314774934],
              [-16252645.65581794, 10446997.314774934],
              [-16252645.65581794, 10597209.227338398],
              [-16116721.997211065, 10597209.227338398],
              [-15998694.171263607, 10597210.74601685],
              [-15833296.451079398, 10597211.353488324],
              [-15696338.70077374, 10596712.33520736],
              [-15696322.60439638, 9833212.69829394],
              [-15696322.5961741, 9833034.822390921],
              [-15706426.851936704, 9829762.872212717],
              [-15733476.486324053, 9798360.19311115],
              [-15739222.575799817, 9772098.821862573],
              [-15783884.846062005, 9741738.371726148],
              [-15791311.080612317, 9726785.332744932],
              [-15814651.438246941, 9732025.724605441],
              [-15841551.793197135, 9725405.072221646],
              [-15856567.790629731, 9710531.951475693],
              [-15874381.803463412, 9712106.03421303],
              [-15890061.265061142, 9688215.814851701],
              [-15888842.427956445, 9670183.875997514],
              [-15903586.026595067, 9645447.588042751],
              [-15927794.898896864, 9640299.181379505],
              [-15945636.741603248, 9622218.59574641],
              [-15960243.973865649, 9618152.449817376],
              [-15959260.68880347, 9607580.287729852],
              [-15977149.063057005, 9597864.254993265],
              [-15974752.465739718, 9571132.865385193],
              [-15967075.428376649, 9560539.703309208],
              [-15977685.511683138, 9556046.479072174],
              [-15975051.469891988, 9543888.081524074],
              [-15990734.605032906, 9521851.50077562],
              [-16002458.32852529, 9516162.655004794],
              [-16037690.947361363, 9525509.681736566],
              [-16040623.770665802, 9540664.11115418],
              [-16033322.770542635, 9547419.047845623],
              [-16044234.08439121, 9555653.523552418],
              [-16028553.843557049, 9599748.458071899],
              [-16040969.862962676, 9613743.057294354],
              [-16017102.518858636, 9632400.202786794],
              [-16027072.18113459, 9639867.098493736],
              [-16066895.393131997, 9636799.359246697],
              [-16079396.683267573, 9623780.666995488],
              [-16106247.946322326, 9636385.738779739],
              [-16139490.951899452, 9644547.602275085],
              [-16166478.136052461, 9626626.967350755],
              [-16182793.009303633, 9626700.9125792],
              [-16213718.56572142, 9617412.8754995],
              [-16228010.318546917, 9629476.26937003],
              [-16211889.58648769, 9644498.35659954],
              [-16218072.71628431, 9658352.635695053],
              [-16247065.543702945, 9662705.954747027],
              [-16261540.973688249, 9673996.014526336],
              [-16268118.953718716, 9691888.753377689],
              [-16253524.968475718, 9703691.241033113],
              [-16251202.95521726, 9716788.940027593],
              [-16265931.525724627, 9715597.058932146],
              [-16274785.544063851, 9728858.2427835],
              [-16296843.946442503, 9719458.568289833],
              [-16309238.592505896, 9723390.2135923],
              [-16313721.539719632, 9699839.198413754],
              [-16353182.96337196, 9683412.689994123],
              [-16395036.086283978, 9682450.862023696],
              [-16426055.93031047, 9663877.207207648],
              [-16548888.973397512, 9663871.897372406],
              [-16549118.959465489, 9501400.030723734],
              [-16536592.956402957, 9508257.176895406],
              [-16522586.292793382, 9497266.845989607],
              [-16520159.416574601, 9485982.162542881],
              [-16505436.300722284, 9475756.88486507],
              [-16494889.22424758, 9452312.614362923],
              [-16480482.81234657, 9437610.903081322],
              [-16601370.992609965, 9441317.294734377],
              [-16779118.38578329, 9441306.747846037],
              [-16840634.64959056, 9349069.685214808],
              [-16866721.03642407, 9355005.122752277],
              [-16872127.824091904, 9367418.622981241],
              [-16897628.11380639, 9367417.095551569],
              [-16901697.8430703, 9349065.368677123],
              [-16926769.552745234, 9349063.845193861],
              [-16926699.866744, 9305212.52321437],
              [-16946083.261758886, 9305211.26146033],
              [-16945992.313734904, 9261627.60429004],
              [-17017790.157031335, 9261623.84215414],
              [-17010836.585038934, 9218304.714572886],
              [-17010835.02656606, 9185986.038610142],
              [-16989526.91755536, 9185987.279416556],
              [-16989526.360957902, 9175246.50648817],
              [-16968218.2519472, 9175247.745429065],
              [-16968216.693474334, 9145306.419898957],
              [-17031620.15660902, 9033718.912965354],
              [-17032104.39639397, 9022574.595551088],
              [-17031864.168932837, 8928863.776987571],
              [-17039687.81406528, 8928869.28363526],
              [-17039688.148023754, 8908158.397676757],
              [-17075854.292109616, 8908152.429366052],
              [-17075854.292109616, 8887497.550321015],
              [-17116693.18314102, 8887494.693725588],
              [-17116693.628418982, 8866898.066321319],
              [-17203013.433247864, 8866894.74312361],
              [-17309918.66095322, 8866890.945185242],
              [-17396664.59679286, 8866887.859361788],
              [-17484268.02667008, 8866885.010910537],
              [-17484269.362503972, 8887479.458569083],
              [-17647630.381284628, 8887477.792225791],
              [-17647629.268089723, 8866881.687718837],
              [-17729302.597372893, 8866876.465563536],
              [-17729302.820011877, 8846339.66014123],
              [-17870637.830385704, 8846335.636296837],
              [-17913081.94847434, 8846336.346386863],
              [-17913083.172988743, 8908122.826617975],
              [-17927799.7209911, 8908123.542812059],
              [-17927800.945505504, 8991332.566838888],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'North Slope',
        GEOID: '02185',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-18572429.073554754, 10547934.263930539],
              [-18544914.568973854, 10568581.544559108],
              [-18515599.360309884, 10579694.225942513],
              [-18510552.245916806, 10603665.738564776],
              [-18504612.349207565, 10631852.951526726],
              [-18500566.99891214, 10666398.78703463],
              [-18503991.854365885, 10711504.125561872],
              [-18470545.579398572, 10710039.41236298],
              [-18425864.60746193, 10706152.017026318],
              [-18364102.77285797, 10714548.508603973],
              [-18315049.28264246, 10725334.148233505],
              [-18284577.79842762, 10729367.477993777],
              [-18248270.055949464, 10751035.663629219],
              [-18208978.171881616, 10789437.610762179],
              [-18172311.98064311, 10846532.427309569],
              [-18161925.315554645, 10885764.304717993],
              [-18161915.29680047, 10943791.608566456],
              [-18153081.2046501, 10983844.810326455],
              [-18143861.835742094, 11012075.55149402],
              [-18121486.172814682, 11045677.541501367],
              [-18089814.887128066, 11101470.135132695],
              [-18067410.949049994, 11135514.497109685],
              [-18020317.461108882, 11176740.631146004],
              [-17987216.05392405, 11168018.324606989],
              [-17954519.961005192, 11166002.278205177],
              [-17901597.895845637, 11192443.090999018],
              [-17835033.07049191, 11253172.043355448],
              [-17796554.820582267, 11302621.562580915],
              [-17771976.70152951, 11332325.441098284],
              [-17718924.83784369, 11359701.483673215],
              [-17712597.66062598, 11340124.620515466],
              [-17683481.82517002, 11331643.26357321],
              [-17652367.248256866, 11332522.392070372],
              [-17629256.09745378, 11340907.270338818],
              [-17592085.962880455, 11345161.253769483],
              [-17562703.73988302, 11359952.580993515],
              [-17524025.67148741, 11394345.895811243],
              [-17496760.85652436, 11435022.019902667],
              [-17466714.39012536, 11484704.423335234],
              [-17455970.723429922, 11501085.93006062],
              [-17429142.39219027, 11523912.073968923],
              [-17424965.016978763, 11504366.324178202],
              [-17400339.36450344, 11491722.41822891],
              [-17374123.958380096, 11485698.930458855],
              [-17370807.08283242, 11465723.416876603],
              [-17354163.705763917, 11468898.918774616],
              [-17319943.760335594, 11461534.16868854],
              [-17312489.25063462, 11437402.476347784],
              [-17313892.989413522, 11425454.379840432],
              [-17333055.52655868, 11409166.47110316],
              [-17339354.094667252, 11397365.286696509],
              [-17360502.79416714, 11390257.747026501],
              [-17363532.24278959, 11374470.936975311],
              [-17357486.5925641, 11352100.612840645],
              [-17335989.351738535, 11344787.300138034],
              [-17314971.007362366, 11350218.950725837],
              [-17308612.883326218, 11363372.715615837],
              [-17311660.588345155, 11381985.239440657],
              [-17295059.17872468, 11400287.583768947],
              [-17283753.793878697, 11429389.525040712],
              [-17261285.29049597, 11452179.616119096],
              [-17248160.722531438, 11445583.603876833],
              [-17207892.566529334, 11404775.847796926],
              [-17210918.78688655, 11382607.746428633],
              [-17206927.315224662, 11343017.82764068],
              [-17191094.45536863, 11344820.524554431],
              [-17175519.52277276, 11341511.429615973],
              [-17157393.37008689, 11326833.769765692],
              [-17131009.87153245, 11363309.483653242],
              [-17106061.281214334, 11362537.489549125],
              [-17079333.69411385, 11364809.53263694],
              [-17058429.563535232, 11375813.732332142],
              [-17037359.78955432, 11372624.901824195],
              [-17021222.470890965, 11362683.315225339],
              [-16998137.59148771, 11362074.539396957],
              [-16967710.18979122, 11354133.193422846],
              [-16945392.746957496, 11342561.636545183],
              [-16941987.149775654, 11332638.80565479],
              [-16959348.2036013, 11315431.38303534],
              [-16959768.87995701, 11299726.405255252],
              [-16973255.458905596, 11294968.511527125],
              [-16968850.880613383, 11272544.53249555],
              [-16953589.98030104, 11267636.124465032],
              [-16929319.325681854, 11261678.332598738],
              [-16917866.999108024, 11254552.830704868],
              [-16886861.515295845, 11249378.336553501],
              [-16890983.56472043, 11234603.30875962],
              [-16891604.1708816, 11212198.058255905],
              [-16865394.55337178, 11210501.498649484],
              [-16842371.567605406, 11200420.330553776],
              [-16828744.837417908, 11192065.887423243],
              [-16811518.591495614, 11211411.551618157],
              [-16798530.27858782, 11220415.302167473],
              [-16785457.14022804, 11221201.191412726],
              [-16759974.77295157, 11227319.668215461],
              [-16744049.740557153, 11220010.576514281],
              [-16731488.22657706, 11206278.23426181],
              [-16706212.579594992, 11213237.34454324],
              [-16683084.50822931, 11237030.930354869],
              [-16669001.479449054, 11232822.094678622],
              [-16638006.459669009, 11239534.524595544],
              [-16606546.792334395, 11228671.52788642],
              [-16578698.106642133, 11209083.150179645],
              [-16549536.630194945, 11210162.835959667],
              [-16528388.932570476, 11186602.438455136],
              [-16527176.218037773, 11171563.794351727],
              [-16514406.425290406, 11168538.862530915],
              [-16497935.593432631, 11183000.100598603],
              [-16470998.837008948, 11171759.424035115],
              [-16460113.905879691, 11164861.603718927],
              [-16449136.134295112, 11140637.210650424],
              [-16412003.069112219, 11130454.116150776],
              [-16389938.989439538, 11136607.833158549],
              [-16381954.4876429, 11119553.671311697],
              [-16362975.405018572, 11116930.126310823],
              [-16351249.232497392, 11129498.715948008],
              [-16309210.762633199, 11129540.423630947],
              [-16267070.324115444, 11120647.716009034],
              [-16253359.325073417, 11114567.771701919],
              [-16236871.35001406, 11122959.69559207],
              [-16210712.271553062, 11096233.448045911],
              [-16189731.219206307, 11080767.02724798],
              [-16160815.202236319, 11066017.019992664],
              [-16130450.69605213, 11057174.318549048],
              [-16118240.061107015, 11062142.917144584],
              [-16104847.324489165, 11057943.131111262],
              [-16080703.908047957, 11080196.455175253],
              [-16060608.847528426, 11084588.488267042],
              [-16020460.359978925, 11106476.849691859],
              [-15976272.756025482, 11113917.678657798],
              [-15966020.119603928, 11109499.0907849],
              [-15950065.698863948, 11118058.500021357],
              [-15918663.806345053, 11097517.889697695],
              [-15890501.8676057, 11082572.633386346],
              [-15857787.29565137, 11055099.998840831],
              [-15852381.509858958, 11041596.199556552],
              [-15834070.2328599, 11035143.891008671],
              [-15809108.840800343, 11016184.405028226],
              [-15775460.07567928, 11000545.229560595],
              [-15744009.091264946, 10970210.024143968],
              [-15719476.056605961, 10966696.982064478],
              [-15696345.647530971, 10954338.153202798],
              [-15696338.70077374, 10596712.33520736],
              [-15833296.451079398, 10597211.353488324],
              [-15998694.171263607, 10597210.74601685],
              [-16116721.997211065, 10597209.227338398],
              [-16252645.65581794, 10597209.227338398],
              [-16252645.65581794, 10446997.314774934],
              [-16342782.828625105, 10446997.314774934],
              [-16447801.747558974, 10446993.748811154],
              [-16622830.830086617, 10446997.017611215],
              [-16797001.08274279, 10446998.503429934],
              [-16909461.375677712, 10446999.394921321],
              [-17003088.303201757, 10446999.989248976],
              [-17138812.922559097, 10446997.314774934],
              [-17290003.49273081, 10447006.82402071],
              [-17290003.938008778, 10457388.654827608],
              [-17392202.911601868, 10457383.893021109],
              [-17392204.470074736, 10483197.221532252],
              [-17494404.556862734, 10483192.740549233],
              [-17494406.115335606, 10509103.064116975],
              [-17608416.8661383, 10509094.068301102],
              [-17776996.542647343, 10509084.472777156],
              [-17776997.655842252, 10535093.132306067],
              [-17828868.64236974, 10535089.821331153],
              [-17828867.306535847, 10509081.474178677],
              [-17932607.164520502, 10509075.17712612],
              [-17932608.61167388, 10535083.50038348],
              [-17984478.596325953, 10535080.189413209],
              [-17984479.48688188, 10509071.578812966],
              [-18036346.91118566, 10509068.880079336],
              [-18036348.247019548, 10535077.179441622],
              [-18114152.6674002, 10535072.664486716],
              [-18114151.331566315, 10509064.682051355],
              [-18213568.65372346, 10509058.98473177],
              [-18311996.456926946, 10509053.887134043],
              [-18311993.562620185, 10457330.918146173],
              [-18411856.418386053, 10457325.715528982],
              [-18444319.041326147, 10473912.323394537],
              [-18464796.372977063, 10479777.28894141],
              [-18476249.144828856, 10488998.66074373],
              [-18488993.334093343, 10513075.868106952],
              [-18513893.834391434, 10533467.93661629],
              [-18545926.240506183, 10546864.105836052],
              [-18572429.073554754, 10547934.263930539],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Trinity',
        GEOID: '06105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13754654.427493881, 5005007.349025222],
              [-13745892.915651508, 4999805.9216383835],
              [-13737502.209032964, 5014376.193589823],
              [-13743950.279217672, 5023609.507041791],
              [-13737748.113788124, 5038919.703310377],
              [-13722732.338994512, 5030484.991515412],
              [-13718956.159227822, 5023523.119916495],
              [-13704439.763669906, 5023473.798381178],
              [-13696394.81538977, 5012940.236348168],
              [-13683116.737847438, 5011455.2306311885],
              [-13680877.212331658, 5016542.627536177],
              [-13689334.265366713, 5028886.634153308],
              [-13679598.151382443, 5042647.31292665],
              [-13671296.055078572, 5042249.157434665],
              [-13653745.869438067, 5055098.119518881],
              [-13646126.606890721, 5065440.351461378],
              [-13637070.654995197, 5063064.264744253],
              [-13639157.45016961, 5043887.751406422],
              [-13636456.839322964, 5039323.638357174],
              [-13630565.47791171, 5035664.285191214],
              [-13631866.914078575, 5026602.224987288],
              [-13638124.182656065, 5025363.848870292],
              [-13639727.072003998, 5014465.154977064],
              [-13648589.216666048, 5006111.499619211],
              [-13647820.555582125, 4997565.890823898],
              [-13655123.11417816, 4986692.092388083],
              [-13655544.013172852, 4978999.999936793],
              [-13664692.694204206, 4966706.382010959],
              [-13658766.823750807, 4949018.556828557],
              [-13675149.045293909, 4939627.676614905],
              [-13681581.530749908, 4930831.144074675],
              [-13692150.648483785, 4926892.8902865425],
              [-13699954.924024828, 4914339.581107404],
              [-13699580.556577291, 4907732.174998332],
              [-13689798.24500434, 4901067.358198867],
              [-13691142.205216687, 4887107.942342289],
              [-13684951.728333674, 4862764.844740575],
              [-13752917.843437506, 4862602.723897265],
              [-13752906.154890973, 4866221.728557528],
              [-13752861.738414148, 4973976.823845718],
              [-13754619.584493263, 4987237.745351458],
              [-13761741.360236255, 5001936.844672463],
              [-13754654.427493881, 5005007.349025222],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kern',
        GEOID: '06029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13379951.12905238, 4271654.798984281],
              [-13306922.203507269, 4271704.61451851],
              [-13252967.984029075, 4271866.688120245],
              [-13225170.616622068, 4271811.656932067],
              [-13143238.35820331, 4271974.967253821],
              [-13136595.256270733, 4271648.897985657],
              [-13127290.727952266, 4272882.413354372],
              [-13094845.215207187, 4272759.165335657],
              [-13096959.172337351, 4260781.791866583],
              [-13092974.93644237, 4256796.042626428],
              [-13094525.72826861, 4240802.818880394],
              [-13094735.565508755, 4139754.500684564],
              [-13098663.028463434, 4139789.214883074],
              [-13110582.674259612, 4139894.3073526877],
              [-13172021.3483818, 4139409.534199994],
              [-13235290.114932628, 4139171.6979463366],
              [-13233812.905289803, 4135464.737430898],
              [-13244427.997973377, 4138388.935133961],
              [-13274141.841733882, 4138657.262163183],
              [-13277848.892096788, 4147541.455860173],
              [-13296261.803790942, 4150472.755523566],
              [-13299646.138950037, 4150459.1822875463],
              [-13299642.242767861, 4174334.423343569],
              [-13309466.855747312, 4175801.9466011655],
              [-13308650.438601833, 4188366.004591744],
              [-13321275.738650152, 4187662.4371967106],
              [-13321231.99009027, 4199614.993432395],
              [-13337126.854902681, 4199759.100299667],
              [-13337115.38899513, 4211665.114749949],
              [-13344999.70325005, 4211712.338242179],
              [-13344985.56567472, 4223718.858217581],
              [-13348727.459038245, 4223736.483923431],
              [-13367987.400737846, 4235669.969841715],
              [-13367903.688480766, 4247709.283632456],
              [-13379925.748208478, 4247686.689837787],
              [-13379951.12905238, 4271654.798984281],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Blount',
        GEOID: '01009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9680716.730233153, 4009780.420863514],
              [-9676378.498357449, 4016619.2620892036],
              [-9661854.310435178, 4022366.5362483356],
              [-9649770.691029059, 4036745.8502689553],
              [-9650516.08633941, 4041249.9901233604],
              [-9640395.58615343, 4044797.411711489],
              [-9636243.703105316, 4051718.1096140128],
              [-9631242.897620408, 4062733.1012353664],
              [-9623906.163940696, 4063675.34014006],
              [-9619007.772387318, 4056362.114586987],
              [-9607263.454789137, 4042112.880009625],
              [-9610478.139044266, 4034241.3495649896],
              [-9614681.340377638, 4020717.473039238],
              [-9609724.283452615, 4020768.059200157],
              [-9611972.937166639, 4013088.369631288],
              [-9618669.80641327, 4006788.0957534625],
              [-9637766.331100386, 4002243.2674658876],
              [-9637796.498682389, 3997333.061965908],
              [-9645309.562435519, 3998363.6544815507],
              [-9657991.30146567, 4007417.457863726],
              [-9671876.738149768, 4007771.9583495334],
              [-9679637.599089403, 4004027.8077838505],
              [-9680716.730233153, 4009780.420863514],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '48315',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10542610.11408989, 3879277.690123976],
              [-10536834.413629571, 3879321.299828314],
              [-10468819.164502919, 3879531.129577362],
              [-10468821.766978586, 3868453.039747733],
              [-10468824.608699977, 3854629.3510082844],
              [-10474355.681504901, 3860085.5016580108],
              [-10483669.00406314, 3854849.461666836],
              [-10491061.50880774, 3862264.0877325707],
              [-10507533.899138384, 3854807.5297997994],
              [-10520507.07259543, 3854723.005132418],
              [-10542194.001833305, 3867871.950747833],
              [-10538877.905522063, 3873391.0700078662],
              [-10542610.11408989, 3879277.690123976],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Daggett',
        GEOID: '49009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12245223.773995738, 5011961.927158423],
              [-12213463.462055743, 5012074.840422042],
              [-12161736.188990869, 5012490.492256353],
              [-12139398.931287784, 5012438.86668301],
              [-12139218.482393209, 4986722.397468061],
              [-12139196.747267975, 4962702.165985387],
              [-12151753.947612455, 4965816.012801908],
              [-12152016.884249711, 4980821.15529179],
              [-12156350.663345782, 4980800.425022226],
              [-12156450.182970552, 4991478.225186177],
              [-12177739.03370935, 4991443.637002372],
              [-12177736.139402587, 4981567.621346087],
              [-12187829.588952305, 4974141.963735047],
              [-12192322.33228123, 4986764.913005923],
              [-12230695.49659156, 4977568.658477111],
              [-12242517.069916354, 4984310.789903926],
              [-12245223.135418046, 4984897.9346098825],
              [-12245223.773995738, 5011961.927158423],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rutland',
        GEOID: '50021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8172469.877539359, 5412700.695022835],
              [-8170151.871782569, 5419010.079493016],
              [-8166521.092156276, 5427333.569039473],
              [-8149290.48788842, 5429420.729752799],
              [-8150696.898335102, 5440297.0200077705],
              [-8129655.51082434, 5441751.692293872],
              [-8128196.446258512, 5435307.657880666],
              [-8121742.364821299, 5438638.279487557],
              [-8113191.358136014, 5443081.857481463],
              [-8112225.995511853, 5440658.467250954],
              [-8103690.462235791, 5439062.002260295],
              [-8102145.570342559, 5435212.797000495],
              [-8106130.0288765235, 5426265.867153877],
              [-8106290.106304286, 5421725.653040699],
              [-8093032.177589787, 5416490.026153295],
              [-8101034.267865973, 5402451.956625631],
              [-8103064.846697532, 5387621.980188796],
              [-8100891.111000812, 5384992.48991899],
              [-8095598.091852573, 5382512.510733712],
              [-8099583.774900935, 5366032.468496889],
              [-8110007.732018817, 5368625.043848476],
              [-8111617.74581416, 5357860.454548207],
              [-8123668.0806925325, 5356468.460655189],
              [-8154748.909772632, 5359997.626268507],
              [-8154467.957405215, 5367463.8689316185],
              [-8153266.820099555, 5393750.584852641],
              [-8158840.698323066, 5401367.525923337],
              [-8162802.447680908, 5407732.688626234],
              [-8170379.408821751, 5398844.134619391],
              [-8173631.051147823, 5403560.186797601],
              [-8172469.877539359, 5412700.695022835],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carroll',
        GEOID: '21041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9492820.116445225, 4684664.204148042],
              [-9488724.78369843, 4681998.813778673],
              [-9484616.607192496, 4678424.761320528],
              [-9483004.409025036, 4677022.514971062],
              [-9478505.209165644, 4678137.531218252],
              [-9470163.705762032, 4684720.579015229],
              [-9464500.225091103, 4687141.473422996],
              [-9458001.27215643, 4675878.387943486],
              [-9454869.298282962, 4673389.502601835],
              [-9455746.718509395, 4671727.2092928095],
              [-9470459.259010088, 4664085.509553954],
              [-9480888.448144037, 4662463.322268661],
              [-9485686.87479468, 4661718.256282865],
              [-9499186.11452656, 4683757.21883632],
              [-9492820.116445225, 4684664.204148042],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Beaver',
        GEOID: '49001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12696005.02596275, 4660687.217348475],
              [-12576511.38717221, 4660609.586923561],
              [-12525156.366484549, 4660668.6768516125],
              [-12525501.568225497, 4651783.106322877],
              [-12525615.893342542, 4647443.462360113],
              [-12505117.41098838, 4626550.387673585],
              [-12507530.706229288, 4611253.756918305],
              [-12517232.645129884, 4600637.648508645],
              [-12521069.382699564, 4600272.156125414],
              [-12631600.731498022, 4600448.530772612],
              [-12695977.168800302, 4600462.406839003],
              [-12696003.28706258, 4614797.205109343],
              [-12696001.283311745, 4636731.862049792],
              [-12696005.068174431, 4660679.35579069],
              [-12696005.02596275, 4660687.217348475],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Windsor',
        GEOID: '50027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8124114.026572651, 5447290.193317262],
              [-8112581.104687485, 5450407.152579587],
              [-8111326.2000677725, 5444058.031103355],
              [-8103094.457682083, 5459541.053039565],
              [-8102189.652860915, 5454456.2351635555],
              [-8078950.039365457, 5445863.368226576],
              [-8038547.645677385, 5430383.341170915],
              [-8039723.945116667, 5428350.390621081],
              [-8046707.684691073, 5422268.740417074],
              [-8051685.558360877, 5405038.751081385],
              [-8052139.129777097, 5404608.030895275],
              [-8057242.4047022965, 5399763.244246122],
              [-8057404.26324191, 5387375.539276305],
              [-8059185.018459337, 5377507.596997813],
              [-8059188.60614682, 5377487.726649181],
              [-8061020.254261347, 5367348.724061679],
              [-8060299.444754622, 5363476.865312716],
              [-8059812.994383695, 5360864.787962253],
              [-8061933.742002797, 5352156.758231703],
              [-8063272.714874809, 5347489.639706224],
              [-8091328.098824725, 5345899.406531478],
              [-8106214.965647999, 5350942.46001913],
              [-8106274.187617104, 5357626.121247328],
              [-8111617.74581416, 5357860.454548207],
              [-8110007.732018817, 5368625.043848476],
              [-8099583.774900935, 5366032.468496889],
              [-8095598.091852573, 5382512.510733712],
              [-8100891.111000812, 5384992.48991899],
              [-8103064.846697532, 5387621.980188796],
              [-8101034.267865973, 5402451.956625631],
              [-8093032.177589787, 5416490.026153295],
              [-8106290.106304286, 5421725.653040699],
              [-8106130.0288765235, 5426265.867153877],
              [-8102145.570342559, 5435212.797000495],
              [-8103690.462235791, 5439062.002260295],
              [-8112225.995511853, 5440658.467250954],
              [-8113191.358136014, 5443081.857481463],
              [-8121742.364821299, 5438638.279487557],
              [-8124114.026572651, 5447290.193317262],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '51121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8973125.964232752, 4473293.830942098],
              [-8961310.624799445, 4477597.827514075],
              [-8953531.61878281, 4483298.029047336],
              [-8941720.286851171, 4490642.806423789],
              [-8934745.452836027, 4486818.625361295],
              [-8926664.548360363, 4471696.713913811],
              [-8925388.047759436, 4454925.094096842],
              [-8944282.638890253, 4442117.000512864],
              [-8963446.95714726, 4440671.24419091],
              [-8966109.608047543, 4436965.878176751],
              [-8966021.888288798, 4445864.337945236],
              [-8970176.776963165, 4451611.893539982],
              [-8967506.222379036, 4453053.28315737],
              [-8967338.5752259, 4455545.335434309],
              [-8964541.227741756, 4454627.061745441],
              [-8964895.891639424, 4455579.538412524],
              [-8962169.677309897, 4458039.651069434],
              [-8962475.471951105, 4459725.759418752],
              [-8963975.279450564, 4459738.468396617],
              [-8964164.967862874, 4458123.293797817],
              [-8964637.519101294, 4457575.089904537],
              [-8964532.09954351, 4457779.092156668],
              [-8962974.29458935, 4467288.069898407],
              [-8970792.373747254, 4464612.441600912],
              [-8973125.964232752, 4473293.830942098],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grayson',
        GEOID: '51077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9088891.332849327, 4385150.330662628],
              [-9084323.337544626, 4388779.017846711],
              [-9077431.770508595, 4397583.368637637],
              [-9046043.013689615, 4406127.913620099],
              [-9026731.642385272, 4406737.80556431],
              [-9021601.817610536, 4412162.363581624],
              [-9009339.196463222, 4393429.41098938],
              [-9010656.996595232, 4394083.131541307],
              [-9011268.140599687, 4392235.745556432],
              [-9011062.756139174, 4390205.530029283],
              [-9008163.662640445, 4389535.675463414],
              [-9009214.07335557, 4387001.90163114],
              [-9007532.70376663, 4387567.145414478],
              [-9007324.536318844, 4390467.07329516],
              [-8999091.35537876, 4378219.902915986],
              [-9005931.720088264, 4378195.335390087],
              [-9005938.942616941, 4378195.309450036],
              [-9023765.645872574, 4378925.577395085],
              [-9036550.24411222, 4379605.579391317],
              [-9056199.161115253, 4380203.317019849],
              [-9072519.686657852, 4380699.827382345],
              [-9092301.605449779, 4381850.058903091],
              [-9088891.332849327, 4385150.330662628],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pemiscot',
        GEOID: '29155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10014447.22029583, 4354252.79414803],
              [-9991163.301643034, 4353919.951140193],
              [-9988560.985906761, 4359605.833131016],
              [-9975485.1758792, 4357360.471487436],
              [-9968107.291165166, 4348096.574909754],
              [-9974286.932880303, 4347918.790567718],
              [-9975542.060138999, 4343235.176191124],
              [-9969137.84983366, 4338907.09292179],
              [-9974490.647548454, 4333434.04586623],
              [-9982914.416055763, 4334838.86787413],
              [-9984537.899509493, 4331619.697275611],
              [-9977303.406289408, 4326170.52451943],
              [-9976876.224236153, 4325848.84794541],
              [-9973347.173739027, 4319300.900089347],
              [-9979015.339571238, 4314888.707430568],
              [-9983135.162606006, 4311978.364291218],
              [-9984516.414847769, 4303443.470624961],
              [-9989042.442704441, 4300705.03222914],
              [-10007753.9132729, 4300533.997375316],
              [-10014231.84993973, 4300485.715970212],
              [-10014447.22029583, 4354252.79414803],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sumter',
        GEOID: '12119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9162896.196370224, 3370605.662020015],
              [-9123098.699175192, 3370562.6587324245],
              [-9123105.044386167, 3318709.021087071],
              [-9123482.86273792, 3292563.2065645666],
              [-9123526.054700349, 3287978.290233197],
              [-9134411.987705022, 3288467.501085111],
              [-9134286.75327788, 3309423.694512678],
              [-9134261.70639245, 3314866.6851871093],
              [-9151373.18191974, 3321290.0374761294],
              [-9158791.401466712, 3331960.0941792494],
              [-9157481.059740586, 3333410.9206544864],
              [-9147026.935040697, 3349320.0188444587],
              [-9162896.196370224, 3370605.662020015],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Honolulu',
        GEOID: '15003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-17614327.040543497, 2461628.920797711],
              [-17602462.386575766, 2461980.044812497],
              [-17597373.416054152, 2466932.4533925797],
              [-17594122.552964516, 2472096.143845321],
              [-17587622.385258116, 2476503.041420167],
              [-17584987.230272055, 2477066.6687886883],
              [-17580085.053855993, 2469696.753446071],
              [-17574826.20979143, 2460607.912194029],
              [-17570328.345765926, 2455182.2156422096],
              [-17571279.570814755, 2447620.9980843044],
              [-17567762.9881006, 2444457.765502871],
              [-17562271.820258744, 2446973.6411119583],
              [-17557589.054559037, 2446721.259744396],
              [-17557791.4333933, 2440034.602912024],
              [-17556263.68470165, 2434677.5806490406],
              [-17549718.09864301, 2429347.4094501827],
              [-17550086.32782696, 2428795.397694676],
              [-17552085.752892688, 2425798.365856436],
              [-17555094.830048323, 2423385.7505797613],
              [-17561451.17297262, 2425058.156141319],
              [-17563983.02347122, 2423535.3049434274],
              [-17567284.31429019, 2422633.2199654593],
              [-17571898.284544583, 2425838.26829877],
              [-17576234.401349965, 2428463.187938286],
              [-17582995.501942784, 2429181.196303745],
              [-17586422.91774482, 2429586.156897092],
              [-17591206.87286166, 2428797.7530010836],
              [-17598309.05637427, 2427543.166892053],
              [-17599978.848736174, 2427435.635111231],
              [-17602881.05918064, 2433042.2647402524],
              [-17603054.75838042, 2433536.817316612],
              [-17604097.66989552, 2436506.4659173815],
              [-17608427.99808738, 2440152.853440633],
              [-17608811.827691633, 2443234.7038011556],
              [-17614416.986692056, 2450115.5568543132],
              [-17614213.383343395, 2454453.6841511335],
              [-17619390.63022121, 2461028.327263163],
              [-17614327.040543497, 2461628.920797711],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Billings',
        GEOID: '38007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11540126.816567343, 5995999.703920545],
              [-11476950.111235399, 5995894.590579741],
              [-11469533.116202824, 5995890.977331293],
              [-11469545.583985792, 5938904.810020522],
              [-11491621.352205006, 5938858.470955467],
              [-11491685.694870684, 5881850.135370278],
              [-11533724.498693349, 5881855.484854686],
              [-11533761.790722763, 5938794.184068598],
              [-11540156.093593419, 5938775.746546329],
              [-11540126.816567343, 5995999.703920545],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mineral',
        GEOID: '30061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12878878.055981845, 6017028.769483368],
              [-12872394.1409211, 6021067.16918838],
              [-12860285.474629551, 6023315.841198724],
              [-12829466.33964496, 6020845.793081321],
              [-12799767.190057242, 6007084.813955405],
              [-12798288.087983072, 5993252.5580884125],
              [-12779166.293771548, 5986079.0043304125],
              [-12769711.929418474, 5978974.152807723],
              [-12769712.931293894, 5971862.494511577],
              [-12755736.99186378, 5962297.8114520535],
              [-12753439.246254314, 5953079.146701622],
              [-12744266.520212948, 5953100.065980544],
              [-12737124.03904467, 5945869.23706071],
              [-12748904.53547736, 5943584.038582752],
              [-12753443.142436493, 5936102.881274847],
              [-12751550.488454023, 5900934.825103219],
              [-12765766.00553945, 5898412.647251304],
              [-12768235.16505361, 5899774.458307538],
              [-12775824.03737997, 5899547.861148083],
              [-12778368.800939506, 5906031.505607048],
              [-12788448.558191856, 5911407.499376473],
              [-12795427.511028156, 5920550.143134805],
              [-12793663.208418574, 5928078.111774422],
              [-12797447.058773668, 5931127.515387042],
              [-12805264.814429559, 5937431.217763481],
              [-12809673.400223443, 5945679.325284795],
              [-12815201.860094711, 5952075.243795458],
              [-12822831.030076737, 5963488.117681038],
              [-12830215.408498509, 5970640.41847038],
              [-12834258.977682084, 5976396.25604781],
              [-12838132.116725253, 5983945.921698832],
              [-12843132.81089067, 5985471.537483331],
              [-12854168.357290968, 5988697.19207151],
              [-12860960.182063248, 5993498.18769943],
              [-12866153.013669774, 6002186.0606916165],
              [-12880816.128316555, 6010535.677125262],
              [-12878878.055981845, 6017028.769483368],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hill',
        GEOID: '30041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12328699.840452071, 6260296.477675025],
              [-12327861.493366906, 6274523.419077833],
              [-12304323.09835816, 6274588.215107089],
              [-12293918.733470656, 6274723.615718784],
              [-12264245.855282765, 6274736.171775141],
              [-12189566.284328172, 6274936.053130433],
              [-12188320.9285815, 6274932.795922439],
              [-12190098.057535691, 6260266.4962133225],
              [-12190077.908707857, 6201860.271333894],
              [-12185512.139792971, 6194688.521138691],
              [-12185512.139792971, 6182490.755440434],
              [-12189121.45164296, 6182259.807680958],
              [-12195233.225645984, 6155818.902443773],
              [-12193301.943800211, 6129270.757603427],
              [-12214744.19279732, 6128986.368489359],
              [-12214747.421062555, 6143788.146548476],
              [-12227979.857613659, 6143366.940497262],
              [-12227993.215952555, 6157909.29953376],
              [-12314764.198677624, 6157994.318501978],
              [-12314779.11548939, 6143488.404770828],
              [-12329287.384724477, 6143466.6847603265],
              [-12328699.840452071, 6260296.477675025],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clark',
        GEOID: '32003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12901586.675506217, 4417118.270975406],
              [-12886675.42971446, 4417094.067822414],
              [-12775303.841399493, 4418702.44538063],
              [-12696005.8224851, 4417265.235328801],
              [-12695931.485991018, 4384060.480835881],
              [-12695718.977083094, 4345512.686205587],
              [-12695790.444196183, 4337681.36942178],
              [-12695635.932742963, 4327357.929867772],
              [-12701539.427978711, 4317373.712172701],
              [-12705806.63801929, 4307938.711339049],
              [-12707311.900173796, 4304001.72953944],
              [-12714209.812420802, 4302769.909485565],
              [-12720550.014018934, 4305537.50274058],
              [-12725611.043348357, 4309308.551330707],
              [-12727967.009051505, 4315494.955176537],
              [-12731844.600874308, 4320331.548333437],
              [-12736836.612119444, 4320696.440928552],
              [-12740365.885255553, 4318029.16286322],
              [-12744638.327312198, 4318440.700348345],
              [-12747386.471581412, 4321412.614632111],
              [-12754100.150071153, 4321502.777301462],
              [-12760314.449325198, 4320041.793509452],
              [-12764620.621187553, 4316779.623702299],
              [-12772371.463373018, 4314991.629370755],
              [-12773170.40335844, 4310331.224727834],
              [-12773165.643992241, 4309697.747159225],
              [-12773107.730485125, 4301992.352090824],
              [-12771814.198002107, 4292907.041703163],
              [-12768375.761570482, 4287113.7548166085],
              [-12764971.166264063, 4282072.9832398975],
              [-12768758.589299321, 4275138.455089337],
              [-12768046.033238756, 4264038.580255761],
              [-12767166.386622507, 4252761.605177897],
              [-12763158.773634456, 4247197.853693041],
              [-12764238.461375661, 4235387.792288965],
              [-12764393.752065318, 4225135.016584028],
              [-12760234.521930808, 4219671.295674917],
              [-12755780.85174315, 4199594.406890517],
              [-12754179.854826562, 4182749.3344816417],
              [-12757115.683757253, 4180343.5475698584],
              [-12759429.45937339, 4180422.75668181],
              [-12760004.313223846, 4173190.9290106986],
              [-12760941.400697347, 4164133.505810317],
              [-12779950.539584186, 4182880.561867231],
              [-12806618.570757097, 4209092.2860840885],
              [-12819560.129478758, 4221669.0036325855],
              [-12835553.957318481, 4237264.005752853],
              [-12846774.294073498, 4248131.179959239],
              [-12873841.182981921, 4274420.934871048],
              [-12873880.035668852, 4274458.163578493],
              [-12895930.412261426, 4295607.434296599],
              [-12895895.800497886, 4317428.009985477],
              [-12901456.209063007, 4324345.492794258],
              [-12901586.675506217, 4417118.270975406],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '36115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8197194.493041999, 5387966.026346934],
              [-8181193.3181158835, 5412536.057028808],
              [-8175094.123215319, 5435112.384352309],
              [-8168905.444090864, 5435802.1824700525],
              [-8165363.352566607, 5429989.243797977],
              [-8166521.092156276, 5427333.569039473],
              [-8170151.871782569, 5419010.079493016],
              [-8172469.877539359, 5412700.695022835],
              [-8173631.051147823, 5403560.186797601],
              [-8170379.408821751, 5398844.134619391],
              [-8162802.447680908, 5407732.688626234],
              [-8158840.698323066, 5401367.525923337],
              [-8153266.820099555, 5393750.584852641],
              [-8154467.957405215, 5367463.8689316185],
              [-8154748.909772632, 5359997.626268507],
              [-8156354.600135179, 5317441.2932486385],
              [-8156380.062371839, 5316648.044589204],
              [-8156805.756549043, 5303395.956006884],
              [-8174259.560992842, 5305680.071679334],
              [-8197062.2454869365, 5303039.851458765],
              [-8190651.689970625, 5320634.793076004],
              [-8192553.472151336, 5358682.809247241],
              [-8197194.493041999, 5387966.026346934],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ottawa',
        GEOID: '39123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9224305.03686888, 5115206.002968082],
              [-9220116.974986253, 5119547.738722608],
              [-9215330.125562653, 5115252.217777548],
              [-9216015.519667467, 5107658.683893375],
              [-9221940.276925957, 5105465.611480155],
              [-9224305.03686888, 5115206.002968082],
            ],
          ],
          [
            [
              [-9285820.076161752, 5104093.632038972],
              [-9259819.627975129, 5104695.831374136],
              [-9257754.252621377, 5104841.221559789],
              [-9246930.834692102, 5100554.761482954],
              [-9242642.696587255, 5094649.522176034],
              [-9232211.726341452, 5088507.214338789],
              [-9223880.798289465, 5097731.597297288],
              [-9221049.943638593, 5099400.779031974],
              [-9208112.058460126, 5092607.847426938],
              [-9205071.829732206, 5085884.0344302645],
              [-9209510.453903472, 5083303.828145021],
              [-9234199.335849568, 5080168.588968429],
              [-9247027.23737113, 5080009.655479944],
              [-9277165.542350028, 5080060.008890196],
              [-9285673.691031357, 5086407.537657359],
              [-9285820.076161752, 5104093.632038972],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cuyahoga',
        GEOID: '39035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9123781.64091206, 5086455.887144215],
              [-9121281.07452952, 5085101.881232754],
              [-9108439.433922943, 5085669.068625418],
              [-9107131.92197173, 5085726.820464853],
              [-9102436.147656843, 5085108.813522273],
              [-9099116.584676145, 5084671.952540455],
              [-9087416.572235297, 5092388.920424849],
              [-9071278.667297715, 5106380.213673383],
              [-9071185.07728273, 5096791.173218355],
              [-9060405.231752783, 5096741.327357841],
              [-9060462.33865156, 5078235.274280712],
              [-9060496.625054725, 5073943.623729465],
              [-9060481.93088194, 5063848.221224275],
              [-9067009.371863585, 5063978.120671709],
              [-9074504.179220222, 5064127.299590534],
              [-9083453.598363057, 5064276.035936688],
              [-9079789.73996258, 5053397.634720613],
              [-9082617.588987201, 5053367.417119003],
              [-9091519.586026955, 5053323.127765735],
              [-9093127.039474012, 5053306.9821991185],
              [-9095375.804507528, 5053322.979641149],
              [-9110288.052174702, 5053072.356090397],
              [-9114623.167104665, 5052995.629848336],
              [-9114501.494901229, 5064206.042076579],
              [-9124999.145522015, 5064292.496430884],
              [-9123781.64091206, 5086455.887144215],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wasco',
        GEOID: '41065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13559206.678686973, 5623548.934152762],
              [-13542985.64776654, 5631973.778871774],
              [-13542309.71581844, 5637592.355772401],
              [-13551081.691692952, 5648424.27922251],
              [-13545525.401948987, 5660778.213210382],
              [-13547190.07361431, 5662217.515655089],
              [-13523301.912765492, 5662250.409464071],
              [-13518710.874326196, 5703663.448071361],
              [-13518716.421138309, 5732256.029642332],
              [-13516812.431730207, 5731445.780556748],
              [-13507258.770391345, 5733192.5045418395],
              [-13493678.794389984, 5727820.496337494],
              [-13490123.472493026, 5717503.865362912],
              [-13483261.627761042, 5719035.711258514],
              [-13479113.084297648, 5724102.255517279],
              [-13463421.934153391, 5725464.182917226],
              [-13460077.675467484, 5724129.782868585],
              [-13459468.088479394, 5709837.4468198195],
              [-13450331.652592028, 5702961.877962983],
              [-13455027.553991651, 5684896.3461403735],
              [-13464812.759871362, 5670511.994367018],
              [-13471404.98879665, 5670005.957964483],
              [-13472338.959324405, 5656021.395730595],
              [-13457341.663566263, 5653426.694417635],
              [-13438886.227826625, 5642154.342081816],
              [-13439578.969017835, 5634712.86433829],
              [-13414414.196248595, 5634672.818761027],
              [-13413459.854254026, 5632277.029794261],
              [-13409011.97267989, 5600388.814234888],
              [-13399687.518172575, 5593506.169151992],
              [-13479619.254022285, 5593742.056189847],
              [-13550372.5865366, 5594094.721135483],
              [-13553481.294636492, 5594785.337614692],
              [-13551391.71647481, 5603548.345498573],
              [-13559206.678686973, 5623548.934152762],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fairfield',
        GEOID: '39045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9219953.780612752, 4836196.224386915],
              [-9217529.464742254, 4840247.548175075],
              [-9217166.229243796, 4845572.842206661],
              [-9218455.754225146, 4857395.781859107],
              [-9215305.189996716, 4857177.995884328],
              [-9182570.914492518, 4855167.621196934],
              [-9179718.35254094, 4855830.4424297875],
              [-9180785.795138158, 4842316.087510343],
              [-9172346.8871801, 4841712.151374702],
              [-9169890.845254727, 4815927.818751337],
              [-9182781.419649608, 4816903.120969447],
              [-9183426.404779263, 4808396.109415944],
              [-9196943.151309855, 4809227.773228667],
              [-9197226.125455452, 4802782.886077455],
              [-9209630.456314545, 4801405.121668217],
              [-9222035.343771094, 4802420.883294967],
              [-9219953.780612752, 4836196.224386915],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Comanche',
        GEOID: '40031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11001260.88769198, 4108899.183072644],
              [-11001264.561235175, 4144210.1906177904],
              [-10978307.699246334, 4144187.2647343725],
              [-10919623.291965352, 4144182.6524321553],
              [-10919218.64561632, 4141454.5383343645],
              [-10919228.441731507, 4120630.4865778643],
              [-10925095.090215804, 4120635.7660310604],
              [-10925133.940718092, 4097083.8001117287],
              [-10936485.411833264, 4097100.95618877],
              [-10942252.65201228, 4089258.0855918946],
              [-10965525.104757523, 4085399.151760659],
              [-10982998.70258836, 4083442.048060609],
              [-10983001.596895123, 4097146.7508846456],
              [-11001267.78950041, 4097134.5929826233],
              [-11001260.88769198, 4108899.183072644],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hanson',
        GEOID: '46061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10905667.612682562, 5442364.498382764],
              [-10892735.738756599, 5442236.53122301],
              [-10865730.409526587, 5442113.351005073],
              [-10865562.873692943, 5388362.5699686855],
              [-10905367.829293856, 5388242.101168209],
              [-10905667.612682562, 5442364.498382764],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hays',
        GEOID: '48209',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10928565.809299758, 3549433.1447551795],
              [-10893416.123484327, 3520430.7011847077],
              [-10893409.332995389, 3520425.0378918904],
              [-10888495.356713302, 3516231.9335217355],
              [-10884972.206149187, 3513280.229469419],
              [-10877051.37910128, 3506699.3503929777],
              [-10877311.087473301, 3506199.727728516],
              [-10898093.323209498, 3485256.570319229],
              [-10895423.993139766, 3485336.7936136797],
              [-10903027.6709584, 3478754.5055038934],
              [-10909228.94583202, 3471768.3527210997],
              [-10910999.927611051, 3478058.0282647056],
              [-10912707.902558293, 3484095.7633790933],
              [-10922809.81238931, 3492351.664667591],
              [-10942438.778200889, 3508434.5534264497],
              [-10928565.809299758, 3549433.1447551795],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Overton',
        GEOID: '47133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9517306.842196038, 4356226.417810667],
              [-9511846.621172627, 4369359.396417625],
              [-9493869.191326458, 4373974.895633943],
              [-9492062.364671394, 4375166.109358415],
              [-9475564.593496848, 4356792.115686667],
              [-9475764.968580276, 4342615.075051875],
              [-9471340.241460225, 4327647.880911911],
              [-9475468.636095785, 4320552.798324157],
              [-9484883.259390645, 4321623.960422212],
              [-9508843.889227971, 4333173.0600791],
              [-9517273.66898778, 4342294.470929981],
              [-9517547.848893605, 4352351.288887762],
              [-9517306.842196038, 4356226.417810667],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dillon',
        GEOID: '45033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8864750.985290451, 4068885.8708682144],
              [-8844364.411200698, 4112442.203372666],
              [-8834127.438651185, 4102267.475825952],
              [-8802171.754046177, 4069063.6112697553],
              [-8803820.707282716, 4068476.5074504726],
              [-8808507.035206132, 4062912.3576334016],
              [-8818097.765935427, 4063166.4998511043],
              [-8836570.567515625, 4069233.26197101],
              [-8847752.387726828, 4067550.1718802922],
              [-8855235.06125897, 4059850.304381068],
              [-8861143.12059384, 4067880.4102379153],
              [-8864750.985290451, 4068885.8708682144],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coryell',
        GEOID: '48099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10929348.274000544, 3693119.191886999],
              [-10883309.315595714, 3720392.4196445905],
              [-10874782.576559423, 3725436.8706719363],
              [-10865364.502360348, 3709318.798020666],
              [-10844589.613710545, 3674403.661620766],
              [-10888811.058789192, 3647850.43818011],
              [-10892214.540900704, 3645822.171656168],
              [-10898968.517046114, 3641761.9589925352],
              [-10929348.274000544, 3693119.191886999],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Orange',
        GEOID: '48361',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10477123.751962967, 3534651.602762213],
              [-10453061.82138902, 3534781.3610236337],
              [-10431867.722606016, 3534948.7106368016],
              [-10432123.40440724, 3532538.0317345834],
              [-10431055.293893078, 3525927.3450981644],
              [-10430907.461609304, 3518047.321443861],
              [-10431074.886123458, 3510530.3559831916],
              [-10431341.581181701, 3510258.8919221424],
              [-10435209.06937254, 3506322.8958822116],
              [-10442638.198229609, 3497708.878091891],
              [-10445149.454622416, 3489977.8927179254],
              [-10447591.344603593, 3487118.9077144708],
              [-10446378.644439753, 3497034.623019866],
              [-10448466.218850601, 3500644.7693518843],
              [-10467591.686605321, 3507151.161912891],
              [-10476935.955982, 3524177.651521202],
              [-10474186.364559406, 3529882.6524680816],
              [-10477123.751962967, 3534651.602762213],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mills',
        GEOID: '48333',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11019695.395367347, 3695775.8397917706],
              [-10996133.845904514, 3712321.312035998],
              [-10993919.255954672, 3722411.4922587974],
              [-10983720.609486157, 3724062.318857917],
              [-10964168.565442717, 3727084.3135808185],
              [-10960932.953123318, 3721900.3807273903],
              [-10939485.472110143, 3686945.2448301446],
              [-10940652.879610091, 3684995.6822776184],
              [-10971953.916670324, 3662730.9506777134],
              [-10979099.180825874, 3669320.071374738],
              [-10974684.472459994, 3675089.2345250766],
              [-10980991.055571904, 3673604.635061053],
              [-10982175.383634454, 3680897.3568960484],
              [-10988695.477529706, 3678134.7047110563],
              [-10986859.03989009, 3685756.8446979146],
              [-10990138.51208886, 3688494.994950959],
              [-10994093.248318782, 3681670.6512667434],
              [-10995360.06412401, 3686231.4865562296],
              [-11004409.448169578, 3686557.4466556874],
              [-11006436.353457943, 3690585.2509562196],
              [-11013192.110715203, 3689623.5139892516],
              [-11019695.395367347, 3695775.8397917706],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bandera',
        GEOID: '48019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11087730.30591649, 3491688.3510731277],
              [-11040331.802570604, 3490068.2895988445],
              [-11011470.777429067, 3475481.4295155806],
              [-10996003.713419776, 3467630.3965841555],
              [-10999095.055679107, 3463855.001476251],
              [-11012521.188144192, 3447404.356678659],
              [-11017443.95866605, 3446072.410596136],
              [-11018824.76562985, 3455239.1010357873],
              [-11066472.847274097, 3455759.5374047584],
              [-11087769.71301623, 3455716.892591825],
              [-11087730.30591649, 3491688.3510731277],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brown',
        GEOID: '55009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9824196.644555585, 5569315.748957745],
              [-9823130.98307022, 5571226.164532435],
              [-9821119.217232605, 5570088.5390556455],
              [-9795845.06264889, 5570918.213384117],
              [-9796347.290946377, 5568784.836321195],
              [-9795972.255581897, 5560220.180466535],
              [-9800701.775467739, 5554482.233994156],
              [-9796729.45075827, 5549269.841831785],
              [-9789859.145744981, 5547782.674834105],
              [-9784859.453454984, 5554725.077947888],
              [-9781296.784471637, 5560086.644133711],
              [-9771086.115498114, 5564911.303795785],
              [-9769544.0821653, 5567167.051233756],
              [-9770069.323269209, 5516215.059863442],
              [-9783594.64140059, 5516278.0833315225],
              [-9783657.091634925, 5502729.797909072],
              [-9800928.644589974, 5502816.346880006],
              [-9817556.548249258, 5502960.70057733],
              [-9817317.656622013, 5556704.326246282],
              [-9823411.174228547, 5556383.434934045],
              [-9824196.644555585, 5569315.748957745],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Campbell',
        GEOID: '56005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11802635.656249763, 5621141.163908156],
              [-11782952.697253322, 5621583.828502826],
              [-11697073.712292919, 5621568.182023334],
              [-11698058.8951015, 5588019.881374026],
              [-11697372.053843306, 5492747.357419419],
              [-11697429.494700557, 5388150.638003896],
              [-11801799.198364114, 5387617.22317266],
              [-11800890.274721788, 5437872.510974641],
              [-11801477.596355213, 5546422.215137463],
              [-11800943.151479915, 5553138.427231959],
              [-11802635.656249763, 5621141.163908156],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Eau Claire',
        GEOID: '55035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10202481.981571833, 5598872.3549634],
              [-10121418.237820245, 5599085.6113115065],
              [-10121429.703727797, 5558188.420136322],
              [-10134951.125677, 5558242.66746975],
              [-10148510.284933586, 5558296.915127124],
              [-10188972.916086107, 5558173.412285722],
              [-10202458.938437238, 5558244.074465417],
              [-10202471.517539697, 5571852.725686196],
              [-10202481.981571833, 5598872.3549634],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Isabela',
        GEOID: '72071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7469237.650968116, 2097526.229881476],
              [-7463112.025942107, 2097517.55258026],
              [-7453542.997154595, 2095440.5497244957],
              [-7452529.104591371, 2084595.268893861],
              [-7449725.189257271, 2083624.131969522],
              [-7451540.698832616, 2081656.660990917],
              [-7461430.767672654, 2083644.3097445085],
              [-7464696.213615584, 2091573.6245310723],
              [-7464913.6205811035, 2093806.8518805718],
              [-7469237.650968116, 2097526.229881476],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Vermillion',
        GEOID: '18165',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9744068.262144592, 4848954.568434693],
              [-9744051.954519987, 4867626.213656203],
              [-9743908.754510509, 4887477.756644897],
              [-9739387.890494728, 4884473.881623758],
              [-9730065.662377229, 4884488.731741943],
              [-9733796.201152693, 4860302.084495292],
              [-9731574.486755442, 4859035.137522456],
              [-9724187.54798538, 4845919.880408967],
              [-9728876.213618102, 4815625.19798928],
              [-9727366.276044983, 4809131.252756423],
              [-9744060.557600928, 4809039.926784131],
              [-9744095.92571885, 4817360.656544007],
              [-9744068.262144592, 4848954.568434693],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brown',
        GEOID: '46013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10989947.088638509, 5770527.243523093],
              [-10978926.969573615, 5770455.733710596],
              [-10955454.030425455, 5770179.773726672],
              [-10917159.791634098, 5770127.912135201],
              [-10910211.985799603, 5770101.121748125],
              [-10906947.654314568, 5770088.534679322],
              [-10907038.2895727, 5714646.798392371],
              [-10907245.90042303, 5659449.648619764],
              [-10989210.664133098, 5659974.062695749],
              [-10989736.314768625, 5659979.122009902],
              [-10989710.26600778, 5710538.12595016],
              [-10990016.951204913, 5715087.2788374815],
              [-10989947.088638509, 5770527.243523093],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wetzel',
        GEOID: '54103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9001914.631705273, 4817054.521857201],
              [-8997928.169420475, 4824155.443431873],
              [-8998569.112874214, 4825228.195957899],
              [-8963372.150449445, 4825539.530702699],
              [-8952467.96104828, 4825508.55885475],
              [-8950911.71456699, 4825011.140987139],
              [-8949620.631112771, 4813381.636833313],
              [-8953742.457898373, 4813662.795295905],
              [-8961014.514953934, 4802687.582919078],
              [-8960560.55407048, 4789162.575350965],
              [-8966175.06390813, 4783327.065365482],
              [-8970468.656668026, 4786540.724458416],
              [-8974424.728731837, 4786390.7932860665],
              [-8987275.562068503, 4792328.914972581],
              [-8999779.301232876, 4808142.11607652],
              [-9010620.595121743, 4808985.173393696],
              [-9001914.631705273, 4817054.521857201],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Florida',
        GEOID: '72054',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7412562.401770333, 2083178.8182952676],
              [-7407541.670096575, 2085057.5079850173],
              [-7406489.032991634, 2078712.732934978],
              [-7412852.277724359, 2077156.0806380608],
              [-7412562.401770333, 2083178.8182952676],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Garza',
        GEOID: '48169',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11305260.613431552, 3947819.741062132],
              [-11247586.43052952, 3948146.9448887953],
              [-11247572.181634698, 3891352.496695495],
              [-11262568.920795387, 3890473.0702245757],
              [-11305321.839151489, 3890131.8259406225],
              [-11305260.613431552, 3947819.741062132],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yates',
        GEOID: '36123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8612454.598925233, 5259616.489579515],
              [-8609182.807771327, 5271369.006281539],
              [-8606444.236978322, 5275704.254507294],
              [-8568416.16308945, 5276152.764221645],
              [-8565748.614131572, 5276184.151605816],
              [-8559951.095051058, 5259795.856689608],
              [-8559978.590965284, 5242447.426643256],
              [-8559333.939794099, 5230597.055352266],
              [-8570255.272396846, 5230624.971548863],
              [-8570412.90079581, 5233882.226289556],
              [-8583534.574453576, 5233723.729459383],
              [-8587607.977260685, 5247787.167715466],
              [-8612399.941055253, 5247711.430220893],
              [-8612454.598925233, 5259616.489579515],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gladwin',
        GEOID: '26051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9418531.054264333, 5490310.822936806],
              [-9391807.140707046, 5490319.512608079],
              [-9369328.173292177, 5490513.480631534],
              [-9369358.229554692, 5464962.618459492],
              [-9369462.981195528, 5438539.526798878],
              [-9391655.412241094, 5436635.349955898],
              [-9418300.956876865, 5436913.808547633],
              [-9418531.054264333, 5490310.822936806],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Alcona',
        GEOID: '26001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9338423.322299676, 5598951.9721722035],
              [-9274724.318003625, 5599287.008214192],
              [-9272576.396342076, 5583581.258507729],
              [-9270334.978394954, 5572748.492099578],
              [-9274529.608127534, 5560132.146340411],
              [-9274801.99305557, 5544970.795068857],
              [-9338217.381241709, 5544548.227410097],
              [-9338423.322299676, 5598951.9721722035],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wright',
        GEOID: '27171',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10493066.595475907, 5666333.498557961],
              [-10474353.677754069, 5675598.002696811],
              [-10469300.552108487, 5688339.778431882],
              [-10436938.08370354, 5668039.224186484],
              [-10415495.389428467, 5669070.570127285],
              [-10410782.790105226, 5660430.361052912],
              [-10426051.03750396, 5652133.02086348],
              [-10423807.170528037, 5648981.369362595],
              [-10423803.719623825, 5647632.758959103],
              [-10424532.417010557, 5646991.920153682],
              [-10424819.509977313, 5646525.884243728],
              [-10426355.496311277, 5645683.702404321],
              [-10426985.341990186, 5645868.233722739],
              [-10427994.341854736, 5645331.698495904],
              [-10437524.069503075, 5634320.772195283],
              [-10438135.547466002, 5618053.035844922],
              [-10465394.239857063, 5618170.748640441],
              [-10492538.161853112, 5618289.249837247],
              [-10492605.732784025, 5659268.9486611625],
              [-10493066.595475907, 5666333.498557961],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hughes',
        GEOID: '40063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10741265.97930197, 4179636.815028507],
              [-10735807.650709905, 4179624.9752944964],
              [-10735803.977166709, 4203377.79424807],
              [-10684597.90195773, 4203347.381260066],
              [-10684857.72164924, 4184496.256250104],
              [-10696563.077425642, 4170645.1151173012],
              [-10696912.620626735, 4132327.1933962614],
              [-10731920.596730385, 4132342.2352437605],
              [-10732160.601552535, 4154463.868171327],
              [-10741305.163762731, 4151736.631949902],
              [-10741265.97930197, 4179636.815028507],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Panola',
        GEOID: '28107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10040865.673170378, 4103492.941821365],
              [-9987733.993409658, 4103472.53206292],
              [-9987701.599437837, 4054685.5104298475],
              [-9987744.012163829, 4050779.015881079],
              [-10011127.11648292, 4050885.2990972633],
              [-10014143.206766473, 4050246.4039584887],
              [-10033833.064339513, 4050316.3591389284],
              [-10033720.07505636, 4064467.0645685294],
              [-10040359.726084724, 4069345.7823218065],
              [-10040855.097818753, 4097636.860356488],
              [-10040865.673170378, 4103492.941821365],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jasper',
        GEOID: '19099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10391444.368164618, 5140495.094013016],
              [-10378522.95827079, 5140436.350907465],
              [-10326663.771609325, 5140385.829136016],
              [-10326748.374422327, 5101450.149691622],
              [-10325607.238322206, 5087680.816120836],
              [-10338399.294967733, 5087640.382555046],
              [-10389293.786921982, 5087536.6236671815],
              [-10391527.63514373, 5101397.153485782],
              [-10391444.368164618, 5140495.094013016],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '12037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9487584.886926338, 3461145.18634783],
              [-9474335.181040527, 3474890.8100168696],
              [-9466537.695988422, 3475323.9283266],
              [-9468068.784264792, 3492064.6312329574],
              [-9464988.573954543, 3499873.9811500306],
              [-9462998.40409814, 3505330.384683931],
              [-9411445.123397376, 3504967.7259660284],
              [-9409167.749254728, 3501201.364428867],
              [-9402902.799632372, 3503788.0316006923],
              [-9388813.741029475, 3498506.4331567185],
              [-9387989.66140927, 3493748.6526892125],
              [-9389695.076008223, 3490292.872113798],
              [-9398018.211695855, 3491086.967914963],
              [-9403193.343503343, 3493851.7920829123],
              [-9410490.336124843, 3491998.2356018657],
              [-9415117.553398648, 3489139.312317071],
              [-9413730.0672654, 3479173.5133393556],
              [-9418074.533032589, 3476074.384950415],
              [-9427939.221028727, 3473126.9368225946],
              [-9437327.350284776, 3464044.911056397],
              [-9448434.475117657, 3459377.047920725],
              [-9467174.332156269, 3450571.0950561734],
              [-9479668.386524942, 3457728.779980586],
              [-9487584.886926338, 3461145.18634783],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'LaSalle',
        GEOID: '22059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10281758.490898736, 3736645.0524485973],
              [-10278804.07161308, 3740113.00448398],
              [-10276194.186151434, 3753782.1563050854],
              [-10241998.06309414, 3753770.876398305],
              [-10242297.1785659, 3675132.7601198535],
              [-10244281.671128271, 3677375.9708162486],
              [-10251046.556583779, 3676380.8636146793],
              [-10249512.462681158, 3677688.530647124],
              [-10263226.356029943, 3694967.3244149582],
              [-10272297.113417743, 3697363.917726239],
              [-10272015.80906451, 3702567.707660941],
              [-10280496.35051212, 3714127.3856881135],
              [-10281758.490898736, 3736645.0524485973],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tioga',
        GEOID: '42117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8639507.919599187, 5160852.09716457],
              [-8572450.715394272, 5161106.4711836055],
              [-8567785.734032592, 5161096.793550894],
              [-8563457.365456462, 5161087.814239493],
              [-8557654.01735854, 5100789.802113567],
              [-8567201.556125406, 5094033.820705854],
              [-8638312.112885676, 5092658.564243667],
              [-8639507.919599187, 5160852.09716457],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Somerset',
        GEOID: '34035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8326457.57255624, 4941146.904067625],
              [-8317029.8135614665, 4951159.8319338905],
              [-8318423.088308236, 4971060.30201353],
              [-8310807.944582049, 4973364.03820001],
              [-8299534.953707886, 4976735.202278228],
              [-8294829.033554092, 4967861.560473517],
              [-8295871.095307409, 4960724.627921044],
              [-8288964.50014012, 4964302.204130078],
              [-8282700.441073692, 4963436.562886938],
              [-8282561.959627146, 4961536.177972268],
              [-8284886.4219144005, 4956385.568426002],
              [-8289215.63691135, 4953400.390669405],
              [-8295964.492360184, 4949073.804936468],
              [-8288834.033696912, 4937558.444077556],
              [-8292132.207570136, 4935129.79291698],
              [-8302762.773662929, 4926897.861650444],
              [-8306687.1196718635, 4920404.03894774],
              [-8306958.961868381, 4921951.134811458],
              [-8318021.781543926, 4920616.792224511],
              [-8320925.661780761, 4927772.275914487],
              [-8326457.57255624, 4941146.904067625],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sharp',
        GEOID: '05135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10206024.390407858, 4300694.987468924],
              [-10205118.917669745, 4329357.950357975],
              [-10207043.85430454, 4335531.408374686],
              [-10193089.176897168, 4335068.145344626],
              [-10193065.577165121, 4347146.960048175],
              [-10180661.357625518, 4346879.561666816],
              [-10180167.980529418, 4369299.880520264],
              [-10175395.995083136, 4369244.558797017],
              [-10160717.914252447, 4352279.394471488],
              [-10158896.504744088, 4336163.526710928],
              [-10169017.004930068, 4332448.79202992],
              [-10169840.323883977, 4285581.408898492],
              [-10181801.380530732, 4285839.189595031],
              [-10181636.627684357, 4291930.005395735],
              [-10209171.949010035, 4292610.456662322],
              [-10206024.390407858, 4300694.987468924],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ventura',
        GEOID: '06111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13300224.188418392, 4079784.7981613073],
              [-13296666.895417938, 4083188.2593458854],
              [-13296252.564273205, 4091270.4756607893],
              [-13296261.915110432, 4104395.333466809],
              [-13296261.803790942, 4150472.755523566],
              [-13277848.892096788, 4147541.455860173],
              [-13274141.841733882, 4138657.262163183],
              [-13244427.997973377, 4138388.935133961],
              [-13233812.905289803, 4135464.737430898],
              [-13217922.493257027, 4095999.7781753736],
              [-13208311.947658371, 4072308.7716605933],
              [-13206216.469563678, 4065049.915784519],
              [-13210028.828164877, 4060628.431088443],
              [-13210055.099564705, 4055576.608762409],
              [-13212937.16118134, 4051457.631134453],
              [-13216225.538939375, 4051363.9895046945],
              [-13223518.635378696, 4051411.482935935],
              [-13231042.05184447, 4045836.1958348327],
              [-13240429.401864083, 4038872.7100508832],
              [-13240838.891886577, 4035079.653556933],
              [-13241979.080495417, 4035271.5125765833],
              [-13254807.20465596, 4040956.415463199],
              [-13259240.5033768, 4041507.0085898563],
              [-13272371.639191287, 4050538.873289043],
              [-13275633.30027153, 4057479.62937268],
              [-13277091.696920412, 4062811.483473767],
              [-13277811.96206266, 4063274.4379457645],
              [-13281866.189880535, 4065880.668673254],
              [-13288851.042649848, 4072002.261365335],
              [-13298341.697156923, 4079140.958648523],
              [-13300224.188418392, 4079784.7981613073],
            ],
          ],
          [
            [
              [-13299421.56934829, 4036054.759716365],
              [-13296295.422277162, 4036076.1739158253],
              [-13287563.521419337, 4035624.4602182764],
              [-13287435.615324415, 4028875.6093829237],
              [-13290610.66984082, 4028081.794727638],
              [-13301312.097177241, 4028334.106109139],
              [-13299421.56934829, 4036054.759716365],
            ],
          ],
          [
            [
              [-13311466.933038395, 3932345.8372873347],
              [-13303846.779935125, 3936160.16584881],
              [-13294571.86260121, 3930667.5351377167],
              [-13294837.69354522, 3925628.625091237],
              [-13298752.35475846, 3923933.993941021],
              [-13307785.59747786, 3926325.8441565735],
              [-13311466.933038395, 3932345.8372873347],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Alpine',
        GEOID: '06003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13366407.777163489, 4651705.71595788],
              [-13366397.535770336, 4679184.485231583],
              [-13354436.924401542, 4689634.097507938],
              [-13344678.546519114, 4703094.853084018],
              [-13347687.289716275, 4712125.302827191],
              [-13312439.531429455, 4680891.6501144385],
              [-13312186.518350288, 4680665.795024685],
              [-13315933.516286984, 4665038.575589278],
              [-13307391.526480453, 4647631.028515589],
              [-13318175.37951207, 4625706.466200627],
              [-13325542.503412768, 4638374.985466144],
              [-13345509.212559413, 4629865.7239783835],
              [-13360559.830353646, 4640850.111624635],
              [-13366416.905361734, 4642777.312456015],
              [-13366407.777163489, 4651705.71595788],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Alameda',
        GEOID: '06001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13618126.415371489, 4552591.2430091],
              [-13614811.320935665, 4555450.533341119],
              [-13617570.183869997, 4564438.721346495],
              [-13611154.364343615, 4566130.431641896],
              [-13596591.54855804, 4551853.648261081],
              [-13586039.907984218, 4550946.908103967],
              [-13581513.212210601, 4547065.696345536],
              [-13580729.745634397, 4546031.514100168],
              [-13582176.899014711, 4544890.99099708],
              [-13582288.218505504, 4543807.046569414],
              [-13579861.45360621, 4541864.422764066],
              [-13577913.251197835, 4541146.588208602],
              [-13576610.813155554, 4539753.426492824],
              [-13566900.63661264, 4542665.218515062],
              [-13533890.288771275, 4552835.00596897],
              [-13531663.008399483, 4553534.059634938],
              [-13531658.778258834, 4543190.8577569015],
              [-13531624.93713363, 4515029.056851703],
              [-13522192.836678717, 4506475.583751959],
              [-13522273.32067056, 4506529.872612531],
              [-13564921.376066336, 4506861.924553797],
              [-13572633.479069004, 4502604.965527584],
              [-13587620.644753482, 4503993.466287432],
              [-13590047.409652777, 4505922.19009094],
              [-13594028.973879978, 4509974.493628701],
              [-13595360.321841594, 4512023.619757462],
              [-13593445.437109241, 4513080.407849029],
              [-13597051.965971962, 4520524.738529646],
              [-13597999.183519121, 4528802.35913359],
              [-13599100.970345747, 4532528.692959548],
              [-13599128.408433728, 4532621.507810137],
              [-13604775.089604216, 4536948.527494738],
              [-13608786.598774442, 4540847.92729656],
              [-13609080.70486912, 4544891.272592309],
              [-13615817.98309091, 4548005.477424757],
              [-13618126.415371489, 4552591.2430091],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dade',
        GEOID: '13083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9529523.377074165, 4161799.1403622804],
              [-9514959.875909435, 4161662.63567943],
              [-9505011.047840469, 4161569.3856030246],
              [-9502667.998418845, 4161622.314801264],
              [-9510437.093780203, 4146917.5395843037],
              [-9512312.938519562, 4141030.1827468863],
              [-9512296.01795696, 4131210.9008437856],
              [-9516762.267247077, 4123066.2030312684],
              [-9516791.766912136, 4119050.82341069],
              [-9521646.438605512, 4112872.557360585],
              [-9524654.151227377, 4129969.532219532],
              [-9527035.08965327, 4144931.019941691],
              [-9528410.182166232, 4153581.054663014],
              [-9529523.377074165, 4161799.1403622804],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stephens',
        GEOID: '13257',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9290699.09812373, 4093592.069333626],
              [-9280154.248038847, 4119843.8758366],
              [-9277370.716058766, 4121335.6148172077],
              [-9277220.53417848, 4120750.0194222312],
              [-9270460.101502605, 4115722.2121877377],
              [-9264164.093742318, 4111000.028615772],
              [-9256725.168770058, 4108058.7655519852],
              [-9250969.597771958, 4101196.1856809454],
              [-9259314.5714454, 4093035.021478551],
              [-9283866.975695783, 4090856.5198433097],
              [-9290699.09812373, 4093592.069333626],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Knox',
        GEOID: '18083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9767287.894472249, 4641142.153079244],
              [-9764283.047457265, 4647440.333916567],
              [-9757617.125029072, 4651996.217371908],
              [-9758348.048805622, 4656148.499781803],
              [-9756970.443732627, 4659783.604702094],
              [-9755789.926907193, 4662899.678164464],
              [-9753827.141645525, 4670162.2408751715],
              [-9745524.71138318, 4675597.046179018],
              [-9740338.336307123, 4687033.930175635],
              [-9742868.962291326, 4696860.429279405],
              [-9744380.24135431, 4700564.211948535],
              [-9745728.648690315, 4703869.974374252],
              [-9743652.28011106, 4708207.767920696],
              [-9713767.375730187, 4707589.691987814],
              [-9711626.701922232, 4708483.891543412],
              [-9699254.09711801, 4708403.923923786],
              [-9695790.836439943, 4707925.991046203],
              [-9708536.472857809, 4694203.131046827],
              [-9711675.237220217, 4695560.196655077],
              [-9711351.074863028, 4684958.641386821],
              [-9715804.07713374, 4677555.049100634],
              [-9711745.81377738, 4656694.749640531],
              [-9716954.118793124, 4651946.28240928],
              [-9723961.56941907, 4656312.884049293],
              [-9736324.60074708, 4655070.745207179],
              [-9739862.222845, 4649689.077949898],
              [-9751511.362278553, 4643294.705297318],
              [-9768408.430357415, 4638765.306204023],
              [-9767287.894472249, 4641142.153079244],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Saratoga',
        GEOID: '36091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8255464.569178248, 5368694.875162165],
              [-8224744.731179443, 5372755.335688537],
              [-8218253.580351799, 5358565.01960687],
              [-8219364.882828386, 5350676.203819526],
              [-8211760.314453827, 5345842.578296216],
              [-8208695.911511269, 5352350.443052854],
              [-8192553.472151336, 5358682.809247241],
              [-8190651.689970625, 5320634.793076004],
              [-8197062.2454869365, 5303039.851458765],
              [-8199841.893172043, 5301708.46521433],
              [-8202362.277763094, 5297337.022834756],
              [-8201169.044141281, 5280940.628326213],
              [-8201659.629137207, 5279042.359480956],
              [-8207214.583047284, 5285005.130529227],
              [-8216421.37285283, 5278373.794236828],
              [-8226058.189851315, 5289331.496974138],
              [-8226998.616909536, 5298459.710284092],
              [-8232683.92594333, 5296353.81294042],
              [-8247992.804956202, 5305256.917152907],
              [-8248428.843401641, 5308833.494838054],
              [-8248492.295511391, 5309374.5883765435],
              [-8253243.411378449, 5350710.287856269],
              [-8255464.569178248, 5368694.875162165],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oliver',
        GEOID: '38065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11328363.303953335, 5981569.867238412],
              [-11271881.130158717, 5985419.372449473],
              [-11247122.784850366, 5988946.631358391],
              [-11240778.241792094, 5982975.020996967],
              [-11239378.287875878, 5967658.337035137],
              [-11229964.443817453, 5945243.343995061],
              [-11236142.230278518, 5939273.573325698],
              [-11328360.298327083, 5939023.2694536075],
              [-11328363.303953335, 5981569.867238412],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'DuPage',
        GEOID: '17043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9825378.300950356, 5158939.152868504],
              [-9815495.46787722, 5159136.991969186],
              [-9789321.027326487, 5160008.071994638],
              [-9787237.5717368, 5152235.417592998],
              [-9787256.718689216, 5147035.175558671],
              [-9786909.513197433, 5130529.326568283],
              [-9786885.579506911, 5129758.277766409],
              [-9786800.197457474, 5126814.708754453],
              [-9786586.018757187, 5119156.682726311],
              [-9789591.756328097, 5116636.529120798],
              [-9789697.621163841, 5115976.626754769],
              [-9790240.748959422, 5115477.779060233],
              [-9791139.097250124, 5115124.307656225],
              [-9792405.356457898, 5114169.806158395],
              [-9793924.533548752, 5114238.673772062],
              [-9794128.359536394, 5114070.828462891],
              [-9796665.219412085, 5114007.3282503635],
              [-9799340.449414827, 5113946.213419394],
              [-9799493.958992632, 5120455.193288434],
              [-9812612.070426691, 5120040.981226652],
              [-9825200.189765086, 5119823.068420345],
              [-9825275.553060353, 5119822.471814399],
              [-9825368.616154658, 5132868.684167015],
              [-9825368.838793637, 5132904.380041011],
              [-9825334.775029456, 5143430.616511557],
              [-9825326.537387138, 5145897.116746503],
              [-9825378.300950356, 5158939.152868504],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hamilton',
        GEOID: '18057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9600498.235375157, 4897356.4372347295],
              [-9558103.320501449, 4897808.654357436],
              [-9558168.553723052, 4857752.380403519],
              [-9566528.424842646, 4855359.669317918],
              [-9600163.831624815, 4855202.604742973],
              [-9600456.156607637, 4892247.326199037],
              [-9600498.235375157, 4897356.4372347295],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '19135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10363757.429692477, 5036098.543902863],
              [-10338215.617807925, 5036127.968332924],
              [-10312677.81342504, 5036162.27230388],
              [-10312536.437671732, 4997438.792473201],
              [-10363576.869478412, 4997374.72846382],
              [-10363757.429692477, 5036098.543902863],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '19183',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10235386.687216435, 5087971.437373499],
              [-10222383.234857893, 5088076.687541745],
              [-10187940.65044798, 5088010.237089701],
              [-10183951.739134384, 5075061.599869122],
              [-10184143.431297531, 5036325.957147785],
              [-10209783.093014492, 5036385.54680636],
              [-10235334.144416781, 5036499.403996797],
              [-10235386.687216435, 5087971.437373499],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Casey',
        GEOID: '21045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9476757.60447968, 4492804.580743628],
              [-9470368.978903053, 4496924.838833169],
              [-9467168.65486224, 4496725.402632405],
              [-9466573.206905985, 4515380.051567601],
              [-9450813.261316419, 4513538.302849323],
              [-9445173.147995885, 4515816.845830107],
              [-9445549.63051375, 4498813.43380612],
              [-9431301.84888712, 4489411.667958092],
              [-9429473.53757033, 4480941.450183836],
              [-9431066.51948358, 4472378.9058054],
              [-9451148.555622688, 4455329.510214344],
              [-9457081.216565024, 4453371.649085464],
              [-9466978.632491454, 4465068.509513022],
              [-9468490.573815407, 4474995.805803324],
              [-9480543.803000541, 4482460.751907655],
              [-9476757.60447968, 4492804.580743628],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Magoffin',
        GEOID: '21153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9269536.372368002, 4546423.685774603],
              [-9252127.673800295, 4560248.410293279],
              [-9253906.670582663, 4564524.156712335],
              [-9240035.260154404, 4559561.171741082],
              [-9234016.549245685, 4550469.055709278],
              [-9232923.503165584, 4539431.0231308],
              [-9226057.205653964, 4513999.0255108485],
              [-9231219.980997976, 4507140.817033309],
              [-9233789.680123447, 4509475.780572455],
              [-9240872.49404466, 4520750.615600939],
              [-9249513.780836979, 4527592.873665052],
              [-9254540.189804766, 4524029.472968503],
              [-9267202.002646066, 4532858.194209653],
              [-9268702.589381961, 4538913.03144728],
              [-9269536.372368002, 4546423.685774603],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Acadia',
        GEOID: '22001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10311745.624009136, 3565547.94988385],
              [-10296302.493690368, 3565464.2470352827],
              [-10268643.607729908, 3565424.720883811],
              [-10260991.951210741, 3555131.223142466],
              [-10260960.336475356, 3548563.6718607936],
              [-10259049.092137925, 3548584.827463622],
              [-10259043.303524405, 3547644.3403667193],
              [-10257221.00346012, 3542018.101766454],
              [-10268986.24912257, 3530744.2725676135],
              [-10273083.029022744, 3522516.380430429],
              [-10288499.776622195, 3509891.046284769],
              [-10300908.782899903, 3517420.7594211837],
              [-10301375.434205307, 3517335.4443684486],
              [-10301407.716857638, 3517084.6497378023],
              [-10301883.273722306, 3517308.9363389136],
              [-10301742.343246963, 3517509.5494504846],
              [-10302123.835141912, 3517730.755133155],
              [-10302387.996293562, 3517556.775704179],
              [-10303051.237819709, 3517828.297895992],
              [-10303054.132126471, 3518418.2030597795],
              [-10303412.135608861, 3518468.3925898904],
              [-10303696.89086631, 3517890.195472673],
              [-10304175.23071825, 3518011.160421782],
              [-10304433.49193689, 3517654.3171322425],
              [-10304636.093410132, 3517840.1369102206],
              [-10304829.789324112, 3517438.9034202434],
              [-10304595.01651803, 3517011.1751825674],
              [-10304955.914307183, 3516716.251817875],
              [-10305243.563871393, 3516798.860552402],
              [-10305481.230984237, 3516524.658235917],
              [-10305833.334533615, 3516604.177585759],
              [-10305821.53466759, 3516344.647822791],
              [-10306156.049737426, 3516079.2046642136],
              [-10306663.777934933, 3516093.8727309857],
              [-10306772.314438457, 3515910.9091085605],
              [-10307212.471705053, 3516332.552861362],
              [-10307470.732923692, 3516158.5925609237],
              [-10307737.899701597, 3516341.3024067767],
              [-10308075.30907819, 3516046.2659092452],
              [-10308720.850805303, 3516196.549672053],
              [-10308870.352881435, 3515774.6530995886],
              [-10309395.669558492, 3515700.6714587198],
              [-10309301.60458877, 3515299.634121489],
              [-10309700.684963264, 3515420.445771113],
              [-10309891.15261201, 3514972.0717791845],
              [-10310260.955960428, 3514977.732643567],
              [-10310258.172973158, 3515517.4561691075],
              [-10310909.50331379, 3515086.5761167523],
              [-10311021.713360509, 3515423.5336238416],
              [-10307197.332254305, 3527012.7682120437],
              [-10311632.968684454, 3551790.6981338016],
              [-10307582.163733978, 3557695.74060741],
              [-10311745.624009136, 3565547.94988385],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Evangeline',
        GEOID: '22039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10311563.060044236, 3566416.787361824],
              [-10306348.96641497, 3576085.3986563813],
              [-10307933.37672743, 3619263.2187731653],
              [-10295633.129592227, 3620947.0713172685],
              [-10294863.2439939, 3626552.1742289336],
              [-10284068.815610658, 3632931.350981997],
              [-10272644.76418749, 3628213.778156942],
              [-10267853.573303748, 3613051.97245166],
              [-10265072.033187296, 3613103.4488051147],
              [-10260586.30298629, 3602647.61703074],
              [-10260585.523749854, 3590453.659473058],
              [-10264937.670561908, 3576788.701141428],
              [-10270638.898282886, 3572989.268052128],
              [-10288234.168317162, 3572999.8663946874],
              [-10296302.493690368, 3565464.2470352827],
              [-10311745.624009136, 3565547.94988385],
              [-10311563.060044236, 3566416.787361824],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hampshire',
        GEOID: '25015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8133644.533457425, 5219445.775069802],
              [-8127334.1654828265, 5219238.235553737],
              [-8124016.733337697, 5235850.223750342],
              [-8123585.370310874, 5244638.452386532],
              [-8112613.721298288, 5242396.056973511],
              [-8111977.753047386, 5233764.4855330745],
              [-8099356.571820226, 5228006.338651728],
              [-8093024.6078644125, 5229067.977371048],
              [-8089491.438546128, 5222551.121989979],
              [-8069537.753779904, 5226186.125298264],
              [-8068848.129534439, 5222214.911434992],
              [-8056750.595191972, 5224226.020635078],
              [-8054708.216494388, 5206540.563076905],
              [-8049985.821055954, 5212602.0840266505],
              [-8047145.058970401, 5213857.663201911],
              [-8038468.929177464, 5207737.383194999],
              [-8038822.702519205, 5205160.140297192],
              [-8038500.54391285, 5198691.898623193],
              [-8039629.2122300025, 5197788.095231416],
              [-8047460.42708782, 5195828.746648205],
              [-8052170.132104301, 5194099.6354597965],
              [-8059027.746695639, 5188842.678958696],
              [-8064776.507839185, 5195082.012184128],
              [-8081065.666287983, 5192722.524992118],
              [-8082578.498167865, 5193329.589342464],
              [-8084464.806939356, 5196385.641040756],
              [-8081676.253694985, 5201223.006371422],
              [-8082902.437886072, 5203800.8340502195],
              [-8083257.547061702, 5203957.47614478],
              [-8091464.353881456, 5188490.085244201],
              [-8103325.779583951, 5196525.320814133],
              [-8116560.331205382, 5196867.988515785],
              [-8113541.56925405, 5210934.511757832],
              [-8121119.0869923495, 5212623.3202460315],
              [-8126342.086180879, 5207932.778320736],
              [-8133323.265406996, 5210382.785129977],
              [-8133644.533457425, 5219445.775069802],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dodge',
        GEOID: '27039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10357823.32159676, 5495935.075508754],
              [-10357294.442696001, 5495936.62818903],
              [-10316947.583813906, 5495748.7557885535],
              [-10316902.610739626, 5444076.095073307],
              [-10318135.808058634, 5442037.869204688],
              [-10357829.555488244, 5442021.97025406],
              [-10357823.32159676, 5495935.075508754],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Schoharie',
        GEOID: '36095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8307843.840500696, 5255319.360740153],
              [-8311949.414640645, 5274104.016552947],
              [-8309810.5219445415, 5286064.715295556],
              [-8288282.779578502, 5277480.527029202],
              [-8283437.376102745, 5278012.988985533],
              [-8269863.300034394, 5279122.444898528],
              [-8266954.299100984, 5281053.34726591],
              [-8267954.059447799, 5268581.460819253],
              [-8257710.32858551, 5270961.793678557],
              [-8256536.019277132, 5261486.91920885],
              [-8264533.990732156, 5243847.3578324085],
              [-8266939.938886671, 5224587.034233743],
              [-8265951.199169445, 5222324.367012005],
              [-8264881.307543432, 5217644.538036295],
              [-8287013.180786005, 5214308.513387075],
              [-8306537.394956747, 5224764.379296124],
              [-8316855.041960921, 5238861.588918643],
              [-8307843.840500696, 5255319.360740153],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Audrain',
        GEOID: '29007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10275905.312072827, 4771613.375104106],
              [-10227439.366129722, 4770173.817497073],
              [-10209997.49435376, 4770364.959772842],
              [-10210053.042779664, 4768261.299271087],
              [-10178857.759235684, 4767428.275119686],
              [-10175607.00746554, 4742110.106797035],
              [-10200160.190952359, 4742872.428810499],
              [-10200649.996711848, 4730134.514998414],
              [-10253681.377611365, 4730872.421765165],
              [-10253012.013513224, 4756080.599260058],
              [-10276399.90457042, 4757035.729172674],
              [-10275905.312072827, 4771613.375104106],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Johnson',
        GEOID: '31097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10738282.39430973, 4942238.737745191],
              [-10694130.857871301, 4942258.507848747],
              [-10694100.133691842, 4904094.312935212],
              [-10738286.290491907, 4904114.006568065],
              [-10738282.39430973, 4942238.737745191],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wyandot',
        GEOID: '39175',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9296816.994698744, 4998356.2058479125],
              [-9290485.364701407, 5011113.215860521],
              [-9286307.432892444, 5011145.366801442],
              [-9252067.561275266, 5011375.145886934],
              [-9251914.274336444, 4968619.959101533],
              [-9273435.337533036, 4968486.4825523],
              [-9274088.671624502, 4966299.28311604],
              [-9286253.66557839, 4966257.2969596265],
              [-9294654.056992631, 4968417.175315634],
              [-9294790.757327328, 4984340.205130804],
              [-9296945.568710612, 4985553.366320221],
              [-9296816.994698744, 4998356.2058479125],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carlisle',
        GEOID: '21039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9924788.387340602, 4409754.289424144],
              [-9923873.675084753, 4417822.551204767],
              [-9920845.562296195, 4424049.176641184],
              [-9918915.6661918, 4431409.963484489],
              [-9916396.456207661, 4427341.238918752],
              [-9886946.550959827, 4432710.848844462],
              [-9886606.469915453, 4431702.899820498],
              [-9886643.427986396, 4407528.952319859],
              [-9914922.586149557, 4407480.033760572],
              [-9919029.496123392, 4410888.471496346],
              [-9924798.841250498, 4409360.455733325],
              [-9924788.387340602, 4409754.289424144],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grand Isle',
        GEOID: '50013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8169733.644455661, 5561835.906778094],
              [-8167016.78096336, 5574462.140439808],
              [-8166138.581500491, 5582409.164053527],
              [-8163551.405214965, 5590433.607746979],
              [-8164395.483467228, 5591357.343850848],
              [-8167029.916663273, 5594241.001861909],
              [-8168604.419541052, 5599042.896824265],
              [-8164057.7975785835, 5608571.340713266],
              [-8164699.1091650445, 5616873.474759805],
              [-8164519.216867922, 5623228.1838001665],
              [-8147730.729173323, 5623546.440373514],
              [-8153075.461894883, 5613903.6966607785],
              [-8152012.80603577, 5610105.151551219],
              [-8147783.778580532, 5607159.603385768],
              [-8154856.351108594, 5583730.034585833],
              [-8151798.738654974, 5577997.416461012],
              [-8155888.171468756, 5557612.8242929885],
              [-8166696.493943083, 5552900.035049912],
              [-8167207.69389007, 5553695.301647412],
              [-8169733.644455661, 5561835.906778094],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Klickitat',
        GEOID: '53039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13537811.740473451, 5787417.97206897],
              [-13527802.893736737, 5787404.019145596],
              [-13447538.646568025, 5786924.180255511],
              [-13343403.047793603, 5786899.162630407],
              [-13343661.853296764, 5754462.710604457],
              [-13354525.534716215, 5752248.121854664],
              [-13358283.809128199, 5750222.7815631805],
              [-13366147.957471976, 5745986.270409681],
              [-13374074.12785544, 5744070.892925191],
              [-13381799.923155475, 5736540.911035112],
              [-13389748.357437095, 5735791.308379365],
              [-13403307.51669368, 5732283.954953544],
              [-13412723.678502271, 5732389.6651133215],
              [-13414651.306763988, 5732411.305708676],
              [-13424147.193287125, 5739825.810661753],
              [-13429023.209622853, 5739714.146288001],
              [-13430976.728671703, 5738170.566580201],
              [-13435079.212560987, 5734929.84550996],
              [-13453592.089157872, 5727869.403644375],
              [-13458033.848160014, 5723314.369089942],
              [-13460077.675467484, 5724129.782868585],
              [-13463421.934153391, 5725464.182917226],
              [-13479113.084297648, 5724102.255517279],
              [-13483261.627761042, 5719035.711258514],
              [-13490123.472493026, 5717503.865362912],
              [-13493678.794389984, 5727820.496337494],
              [-13507258.770391345, 5733192.5045418395],
              [-13516812.431730207, 5731445.780556748],
              [-13518716.421138309, 5732256.029642332],
              [-13527990.478680441, 5736203.68969926],
              [-13537479.340473939, 5745565.969363689],
              [-13537811.740473451, 5787417.97206897],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cass',
        GEOID: '38017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10876585.952310275, 5981332.936992369],
              [-10848252.692874588, 5981182.583917836],
              [-10779735.278516958, 5981005.6519308705],
              [-10778684.370502757, 5966680.578370188],
              [-10777850.462034235, 5955330.218505116],
              [-10779456.357008418, 5943724.43791051],
              [-10771716.201494072, 5927804.662645402],
              [-10774480.26445047, 5905843.920913907],
              [-10774262.300887497, 5892075.388621445],
              [-10774671.733974632, 5883003.754222621],
              [-10774589.748622362, 5882820.0133585],
              [-10777542.107044738, 5881918.38206749],
              [-10829154.27575613, 5881782.699725329],
              [-10873911.167585494, 5881876.720718903],
              [-10873855.730479078, 5938562.330982938],
              [-10876585.952310275, 5981332.936992369],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henry',
        GEOID: '18065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9528578.608555803, 4847493.378448152],
              [-9526298.117467409, 4858062.817408493],
              [-9526298.674064865, 4877158.830634246],
              [-9486022.05778146, 4877121.878334475],
              [-9485928.215450723, 4868209.924064656],
              [-9484584.589196846, 4866599.280653249],
              [-9484525.812505707, 4847620.005893613],
              [-9486771.46059348, 4835247.719078614],
              [-9495728.89473965, 4835121.6834693905],
              [-9528605.10259461, 4834968.124995941],
              [-9528578.608555803, 4847493.378448152],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grant',
        GEOID: '20067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11301940.954896605, 4542242.5021741595],
              [-11253250.254901592, 4542245.739696691],
              [-11253248.69642872, 4493288.77157699],
              [-11301801.471574642, 4493382.782280422],
              [-11301940.954896605, 4542242.5021741595],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hamilton',
        GEOID: '31081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10940766.536810191, 4992990.805530157],
              [-10910484.295729697, 5023079.825771376],
              [-10895291.968223684, 5030522.969928715],
              [-10890191.64311401, 5037957.63365664],
              [-10889972.455036638, 5019214.780451984],
              [-10889909.67084383, 4967979.758133917],
              [-10940268.382088892, 4967940.995017082],
              [-10940796.927031178, 4967939.967209257],
              [-10940766.536810191, 4992990.805530157],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '21137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9445173.147995885, 4515816.845830107],
              [-9424070.98004315, 4525640.75816273],
              [-9424118.402146228, 4527920.955950085],
              [-9423034.484264374, 4524462.97503846],
              [-9400565.758242661, 4507052.154233172],
              [-9406823.360778622, 4485037.040669232],
              [-9412782.181801295, 4488807.496439166],
              [-9431066.51948358, 4472378.9058054],
              [-9429473.53757033, 4480941.450183836],
              [-9431301.84888712, 4489411.667958092],
              [-9445549.63051375, 4498813.43380612],
              [-9445173.147995885, 4515816.845830107],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Avoyelles',
        GEOID: '22009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10272644.76418749, 3628213.778156942],
              [-10264580.891593916, 3627870.92430026],
              [-10267470.634255419, 3649834.3012514613],
              [-10267356.197818883, 3674578.667371245],
              [-10255426.42194904, 3672559.0208647083],
              [-10251046.556583779, 3676380.8636146793],
              [-10244281.671128271, 3677375.9708162486],
              [-10242297.1785659, 3675132.7601198535],
              [-10240346.304489749, 3662031.617321902],
              [-10233250.577507604, 3671097.916075507],
              [-10222945.286966907, 3667387.5042678593],
              [-10205470.57594116, 3657194.7817717935],
              [-10210112.821346221, 3650243.9613759303],
              [-10210647.15490203, 3638497.702294776],
              [-10213576.527302254, 3635192.7405380383],
              [-10219692.8654044, 3629599.700213994],
              [-10220827.767613038, 3613038.6171605047],
              [-10244607.05799986, 3613218.849968594],
              [-10265072.033187296, 3613103.4488051147],
              [-10267853.573303748, 3613051.97245166],
              [-10272644.76418749, 3628213.778156942],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Howard',
        GEOID: '24027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8590391.63244746, 4772434.940807075],
              [-8590311.371094598, 4772500.4443777995],
              [-8582919.534266943, 4774708.956171495],
              [-8558495.592708936, 4771957.425467825],
              [-8548627.342489094, 4766700.065015134],
              [-8548645.598885585, 4759826.031753825],
              [-8540126.095616193, 4754021.161210192],
              [-8537880.44752842, 4752384.97662673],
              [-8539559.034130093, 4750638.157181564],
              [-8539690.613768209, 4749461.138922018],
              [-8540721.432252955, 4747898.21796854],
              [-8543386.198223565, 4747429.331422284],
              [-8545442.491857499, 4745310.637849784],
              [-8547278.706858132, 4742534.393405064],
              [-8547885.95468041, 4740135.312918986],
              [-8549047.79620582, 4739245.059666122],
              [-8550818.77798485, 4739228.701780968],
              [-8552076.24295285, 4738475.837238656],
              [-8552305.227145413, 4737432.939138243],
              [-8553829.970210807, 4736456.566083116],
              [-8559189.224456068, 4740448.87178462],
              [-8566982.924645487, 4740887.439999905],
              [-8568669.303611515, 4744933.325844177],
              [-8579405.623220563, 4758135.426465339],
              [-8586569.477731073, 4761403.601142271],
              [-8592410.522732487, 4770385.542327826],
              [-8590391.63244746, 4772434.940807075],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Estill',
        GEOID: '21065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9364969.013352204, 4529034.319703152],
              [-9360768.261047628, 4532651.884374023],
              [-9359064.62756053, 4551368.287308949],
              [-9364220.723735092, 4553659.897102066],
              [-9359780.300566839, 4558689.7103222255],
              [-9359198.09962999, 4554490.06797011],
              [-9351056.19207337, 4556508.345832793],
              [-9347213.99984864, 4557923.629052487],
              [-9340401.1356926, 4545487.426760669],
              [-9326078.881326629, 4545123.168848295],
              [-9319901.540143529, 4539442.562494203],
              [-9331064.213402314, 4532221.276710432],
              [-9340325.32711937, 4515046.46591219],
              [-9346968.20641297, 4520462.229878645],
              [-9360896.501101023, 4518328.169845429],
              [-9364969.013352204, 4529034.319703152],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Arthur',
        GEOID: '31005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11352976.48864569, 5122453.566848176],
              [-11290681.767639302, 5122568.296524995],
              [-11288516.158265408, 5122589.332934701],
              [-11288604.545941098, 5070841.551433023],
              [-11352877.08034041, 5070737.0829439685],
              [-11352976.48864569, 5122453.566848176],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Worth',
        GEOID: '13321',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9351777.31973473, 3737301.5213116044],
              [-9344095.384314066, 3743365.4567625932],
              [-9333618.661757547, 3741172.0322650378],
              [-9328876.451449756, 3737554.8450344387],
              [-9328222.226802364, 3713915.3385405266],
              [-9319531.29151715, 3713797.550692324],
              [-9311806.832051005, 3706733.540948946],
              [-9311938.411689123, 3696593.9384869626],
              [-9313631.692463579, 3695914.7312557893],
              [-9312071.772439094, 3689230.8036436606],
              [-9312330.70157468, 3675766.6353841717],
              [-9319014.769079871, 3674164.286985567],
              [-9324018.802830009, 3675970.4624329875],
              [-9350773.774525227, 3676327.6892353143],
              [-9350591.87847727, 3690514.008586687],
              [-9350419.333266541, 3714208.178977038],
              [-9352885.950543538, 3717490.6968024285],
              [-9351777.31973473, 3737301.5213116044],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morton',
        GEOID: '38059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11365349.872686345, 5938999.283736041],
              [-11328360.298327083, 5939023.2694536075],
              [-11236142.230278518, 5939273.573325698],
              [-11233016.267657552, 5926478.278824417],
              [-11218720.062052425, 5899181.257227169],
              [-11219647.576049715, 5891722.404834249],
              [-11205630.337088518, 5882609.7948102625],
              [-11194403.209844561, 5875057.786692161],
              [-11197649.731474057, 5849186.696729783],
              [-11212239.486576404, 5843082.339885604],
              [-11230416.957547529, 5846151.264346921],
              [-11246125.250893367, 5826013.085662703],
              [-11248671.12764781, 5840066.273261479],
              [-11276551.984672913, 5840075.630814285],
              [-11276558.886481341, 5881938.645440841],
              [-11323207.653056733, 5882050.337994641],
              [-11323213.219031274, 5896168.44195757],
              [-11365301.337388357, 5896117.620142835],
              [-11365349.872686345, 5938999.283736041],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wake',
        GEOID: '37183',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8787145.492839847, 4269280.110750837],
              [-8784157.009790013, 4279031.211290128],
              [-8783783.64421789, 4282486.730974651],
              [-8775311.56305158, 4282333.153453037],
              [-8772727.948989756, 4290021.146953295],
              [-8767323.832989706, 4289833.234973516],
              [-8760767.782898927, 4302196.7135467185],
              [-8766551.609682072, 4310372.403607467],
              [-8758976.42965308, 4310875.101546994],
              [-8743746.810117655, 4303625.011729436],
              [-8717140.895220608, 4286421.966870652],
              [-8711415.065892166, 4275623.7380286055],
              [-8735073.79727046, 4260389.4302997785],
              [-8754465.541247157, 4241623.104277991],
              [-8761834.891537672, 4234699.40797501],
              [-8784748.004966632, 4243485.464801325],
              [-8793689.743064603, 4247108.304561895],
              [-8787145.492839847, 4269280.110750837],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greene',
        GEOID: '17061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10087164.451266719, 4742073.937044351],
              [-10084569.593936328, 4750162.822933992],
              [-10087070.274977509, 4778522.548934567],
              [-10086714.943162896, 4787410.369425561],
              [-10083436.918117505, 4796682.569294965],
              [-10052350.505035521, 4796460.909265929],
              [-10035869.543104088, 4796478.659204884],
              [-10035237.137076888, 4759262.992322826],
              [-10053716.395187555, 4753959.944994198],
              [-10053656.282662528, 4746666.521803026],
              [-10083384.820595816, 4748190.906123562],
              [-10085943.165133225, 4738529.642163749],
              [-10087164.451266719, 4742073.937044351],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cass',
        GEOID: '17017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10075818.323487105, 4860898.871935571],
              [-10075944.225831194, 4864182.78861716],
              [-10067272.99409585, 4868930.743353205],
              [-10058219.602548616, 4884009.608284921],
              [-10050501.599612935, 4873991.61691262],
              [-10040424.402708875, 4873759.068638538],
              [-10018207.592694825, 4881781.137359139],
              [-10018142.582112204, 4851700.506210422],
              [-10018131.338843632, 4847483.805304745],
              [-10083726.014835097, 4848028.183681915],
              [-10075818.323487105, 4860898.871935571],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kiowa',
        GEOID: '40075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11066191.654240353, 4179453.3686153754],
              [-11060729.76342458, 4179756.710058704],
              [-10992838.009740598, 4179702.9544648607],
              [-10981808.808551272, 4180769.67748384],
              [-10978445.512775935, 4177118.7745488607],
              [-10978307.699246334, 4144187.2647343725],
              [-11001264.561235175, 4144210.1906177904],
              [-11001260.88769198, 4108899.183072644],
              [-11020752.81921039, 4108892.827305989],
              [-11020743.691012146, 4114777.6435738313],
              [-11032112.19400941, 4114788.1969738556],
              [-11026475.086315129, 4123397.5317015615],
              [-11037228.883084232, 4123505.17839273],
              [-11036723.047318067, 4143452.983093698],
              [-11048065.612873975, 4139733.3467727522],
              [-11054717.843004799, 4144550.693010377],
              [-11057118.781782228, 4169549.044545613],
              [-11061636.015399128, 4175828.338766253],
              [-11066191.654240353, 4179453.3686153754],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Murray',
        GEOID: '40099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10837187.312850755, 4097055.9721998386],
              [-10814015.938203154, 4097021.390036251],
              [-10820262.631429018, 4112733.4477121085],
              [-10790457.394366574, 4114634.091259206],
              [-10790467.9697182, 4108743.400211093],
              [-10778764.617692629, 4108737.8558955863],
              [-10778764.395053647, 4096948.0383768],
              [-10784722.882117849, 4096956.6838514134],
              [-10784744.144140592, 4073600.815984576],
              [-10790583.07407168, 4073558.2172824293],
              [-10801185.921611266, 4073555.116750246],
              [-10802052.4325276, 4079323.1726842327],
              [-10837192.656186314, 4079432.691342645],
              [-10837187.312850755, 4097055.9721998386],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Snyder',
        GEOID: '42109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8611300.438444689, 4983964.873487645],
              [-8565152.386938881, 4995840.410853891],
              [-8549363.832240181, 4994951.356460164],
              [-8554863.349043842, 4984211.367093352],
              [-8556462.89880705, 4969174.735940618],
              [-8564893.68044228, 4959147.939294773],
              [-8583785.043307861, 4966951.559731611],
              [-8603654.236580571, 4967251.50706065],
              [-8611018.68881349, 4968436.704635592],
              [-8611300.438444689, 4983964.873487645],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clarendon',
        GEOID: '45027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8965013.33370221, 3981087.6067993282],
              [-8955574.331438867, 3993612.6645860067],
              [-8934799.776747536, 4001442.4582176623],
              [-8927307.863697657, 4007201.680331406],
              [-8902731.859715227, 4021624.166668042],
              [-8899501.702050878, 4013466.914752439],
              [-8891713.345197018, 4013403.6218870375],
              [-8896131.059189148, 4004476.8000731245],
              [-8905073.687843045, 3997679.8856520844],
              [-8902707.480746744, 3991479.348702793],
              [-8916880.121717088, 3961445.1893051895],
              [-8922257.521039348, 3954982.337902749],
              [-8930301.912722034, 3954349.0318187657],
              [-8949323.964669807, 3954565.5553632],
              [-8960804.121116336, 3969669.771368547],
              [-8965729.006708521, 3979098.1944063357],
              [-8965013.33370221, 3981087.6067993282],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'White',
        GEOID: '47185',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9538087.18550089, 4277426.9559553],
              [-9532560.618060967, 4279642.052110509],
              [-9535952.300306458, 4296700.661829456],
              [-9533913.70647156, 4302692.839361591],
              [-9518671.06255571, 4311911.972518598],
              [-9496594.849058531, 4304969.253692766],
              [-9491567.994812781, 4297753.373573982],
              [-9489173.7352048, 4288662.397938183],
              [-9489812.37512348, 4272964.625223794],
              [-9492141.624148838, 4272228.9951441875],
              [-9491663.506935881, 4276152.700452644],
              [-9509264.78822266, 4275153.006399314],
              [-9514945.867115803, 4276246.469375007],
              [-9517749.448491432, 4274030.690689997],
              [-9519745.184322374, 4275307.306390827],
              [-9520775.446209665, 4274136.108775063],
              [-9520017.805755327, 4272049.075265303],
              [-9522626.466702575, 4272769.32157852],
              [-9528769.07620455, 4274001.728347733],
              [-9529268.566759737, 4272449.678957443],
              [-9536029.333394086, 4275825.407930806],
              [-9538087.18550089, 4277426.9559553],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Putnam',
        GEOID: '29171',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10394389.131460028, 4950645.946668583],
              [-10391167.07131305, 4950663.090666035],
              [-10367830.05326315, 4951006.072505001],
              [-10363543.051034534, 4951148.175642479],
              [-10346211.02891466, 4951722.708756472],
              [-10320941.756425606, 4951992.40766275],
              [-10317469.115628274, 4947794.092448065],
              [-10320354.294190653, 4930951.38295223],
              [-10317554.27503873, 4915980.075409314],
              [-10336641.337569125, 4915873.456157194],
              [-10336606.160610035, 4922178.82845804],
              [-10393559.661128672, 4921755.743371363],
              [-10394439.641703391, 4934801.998802459],
              [-10394389.131460028, 4950645.946668583],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Atlantic',
        GEOID: '34001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8339152.558605796, 4804873.28576166],
              [-8335298.45519555, 4809191.216712707],
              [-8326707.596132561, 4818806.282706563],
              [-8319597.508936104, 4826751.2711475175],
              [-8318221.6000299, 4825635.051960567],
              [-8310480.665279117, 4811857.013864107],
              [-8290592.992970935, 4800974.157989998],
              [-8284106.294922919, 4801810.836414741],
              [-8280032.33551836, 4793336.399601815],
              [-8270037.997736029, 4794755.01226226],
              [-8270101.412425201, 4794659.093236395],
              [-8271521.626488742, 4789428.778237042],
              [-8278495.458628467, 4779421.753121877],
              [-8283582.981996701, 4773487.944401671],
              [-8295728.4950397005, 4766723.229947217],
              [-8297842.547412873, 4764739.223161286],
              [-8310356.878005355, 4763089.7208646815],
              [-8333521.128205546, 4768162.006195363],
              [-8332933.4726136485, 4782583.147918339],
              [-8347322.184715623, 4795706.926658008],
              [-8339152.558605796, 4804873.28576166],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gallatin',
        GEOID: '30031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12446104.499890069, 5748086.317107846],
              [-12434995.705264825, 5747676.294900241],
              [-12429940.6871879, 5753707.506437382],
              [-12421885.49751461, 5765407.5353368465],
              [-12403175.140141059, 5779759.837766914],
              [-12403644.129155772, 5790282.475370036],
              [-12395355.391190793, 5800018.89430757],
              [-12395052.602175837, 5810493.134087544],
              [-12363360.388424953, 5811305.036925197],
              [-12332399.877687057, 5811283.327322701],
              [-12333171.767036218, 5803109.351337714],
              [-12333617.824235827, 5714996.603946868],
              [-12340587.314915411, 5714991.513453994],
              [-12340684.1628724, 5704534.926928715],
              [-12347471.312226068, 5704532.066877373],
              [-12347324.036539748, 5676992.796799334],
              [-12360712.431697454, 5677011.488450326],
              [-12361396.995963333, 5621660.025766315],
              [-12362796.221245613, 5600553.887443885],
              [-12362642.934306791, 5578385.505164771],
              [-12362623.089061012, 5569133.449263772],
              [-12362609.204501081, 5562665.931394521],
              [-12361915.238795476, 5539101.429640606],
              [-12370117.258877123, 5542157.59563672],
              [-12372444.170193177, 5548725.731942114],
              [-12378889.791349089, 5554969.022326629],
              [-12381416.966429077, 5562427.410804752],
              [-12386380.591204058, 5569449.108074919],
              [-12392494.146318935, 5578249.351038544],
              [-12398446.314525379, 5582437.130458831],
              [-12395428.639415737, 5676877.954883666],
              [-12395578.920728307, 5723154.029667037],
              [-12416157.553115843, 5723204.822081984],
              [-12429905.17627034, 5739314.8778460035],
              [-12436800.862127528, 5739304.350035034],
              [-12436819.118524019, 5743945.928868724],
              [-12441430.63974962, 5743975.454062217],
              [-12441436.31704365, 5746253.817609809],
              [-12446117.969548453, 5746241.04667758],
              [-12446104.499890069, 5748086.317107846],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Toole',
        GEOID: '30101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12489313.293370016, 6274673.693130765],
              [-12483787.260718497, 6274677.633563535],
              [-12451540.119306013, 6274533.41071431],
              [-12412213.614876527, 6274346.094358415],
              [-12386504.378570106, 6274391.359859661],
              [-12387110.4017857, 6143454.989392903],
              [-12401995.15353865, 6143456.827235297],
              [-12430557.619805878, 6143457.99677157],
              [-12430575.096965933, 6165190.023240984],
              [-12445057.651398648, 6165249.65419791],
              [-12445063.77397064, 6172500.432719487],
              [-12466768.736966021, 6172698.927498394],
              [-12466774.859538015, 6180125.851070626],
              [-12488353.029633382, 6186677.768807273],
              [-12489313.293370016, 6274673.693130765],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tillman',
        GEOID: '40141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11047114.9444226, 4086236.529879252],
              [-11038810.28777044, 4108036.8600952537],
              [-11032112.19400941, 4114788.1969738556],
              [-11020743.691012146, 4114777.6435738313],
              [-11020752.81921039, 4108892.827305989],
              [-11001260.88769198, 4108899.183072644],
              [-11001267.78950041, 4097134.5929826233],
              [-10983001.596895123, 4097146.7508846456],
              [-10982998.70258836, 4083442.048060609],
              [-10983004.045923918, 4073662.0181982904],
              [-10977177.138497835, 4073700.9774892447],
              [-10977254.147278264, 4049796.5404904056],
              [-10981453.254097678, 4050903.865128209],
              [-10986128.561391506, 4046695.5336591117],
              [-10991378.388577316, 4046404.642549762],
              [-10999123.776107732, 4049754.9809590587],
              [-11006406.185875935, 4050366.404263128],
              [-11013974.90937446, 4056184.9806975904],
              [-11015322.41929021, 4056317.4134051073],
              [-11020954.196169237, 4056870.9187987144],
              [-11027175.17459273, 4055857.909430446],
              [-11035274.00150641, 4056947.6452232855],
              [-11041725.856553808, 4057615.3216307885],
              [-11044184.79278594, 4071038.843327189],
              [-11045298.867211971, 4072575.87295623],
              [-11047114.9444226, 4086236.529879252],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '16041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12481830.820667805, 5203801.586407601],
              [-12465984.936431346, 5203849.887876394],
              [-12456286.782393437, 5199445.986182701],
              [-12453938.831693625, 5223523.184493575],
              [-12438143.263867006, 5225706.354494911],
              [-12423169.122562947, 5223408.136052435],
              [-12417928.646214362, 5213761.560926795],
              [-12426161.056516998, 5192119.106330225],
              [-12423156.766099468, 5175821.61940924],
              [-12414525.164102849, 5172136.275572969],
              [-12412992.966547346, 5160932.358809663],
              [-12440039.702712158, 5160879.081827467],
              [-12479966.114091383, 5160619.7072101105],
              [-12479946.960925112, 5186465.366034624],
              [-12475682.08859384, 5196737.174900738],
              [-12481830.820667805, 5203801.586407601],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Clair',
        GEOID: '17163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10047173.468292104, 4654694.87589059],
              [-10046463.039806448, 4656669.414844018],
              [-10039293.730640886, 4666181.346404513],
              [-10038915.244372189, 4673021.696357855],
              [-10038961.373113248, 4673139.00590918],
              [-10022884.681100506, 4672864.741215208],
              [-9986131.883298162, 4672376.784370126],
              [-9985830.875395056, 4638329.094911584],
              [-9985720.78041866, 4610466.77278374],
              [-10007515.689562604, 4610658.199657107],
              [-10007761.149039803, 4620126.7188728405],
              [-10022773.584248694, 4623160.504927493],
              [-10034940.025355965, 4639877.12642598],
              [-10047819.399457773, 4652899.928872969],
              [-10047173.468292104, 4654694.87589059],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '18077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9538281.326692834, 4695264.452649654],
              [-9530127.841909172, 4696527.639634727],
              [-9522068.867373195, 4709105.199887083],
              [-9511682.424923709, 4709216.933557685],
              [-9484773.05309476, 4709332.102072162],
              [-9484616.607192496, 4678424.761320528],
              [-9488724.78369843, 4681998.813778673],
              [-9492820.116445225, 4684664.204148042],
              [-9499186.11452656, 4683757.21883632],
              [-9500111.431772692, 4683625.392471389],
              [-9506738.058420634, 4683923.224751777],
              [-9512123.806704704, 4680696.767509477],
              [-9510997.253457874, 4672988.765514839],
              [-9510710.939727554, 4664292.609757216],
              [-9510181.734744422, 4662582.608088621],
              [-9517445.323642585, 4665495.412168896],
              [-9525606.600790603, 4665412.647307875],
              [-9525712.354306856, 4675752.902569339],
              [-9538225.555627946, 4684030.4008352645],
              [-9538281.326692834, 4695264.452649654],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Van Buren',
        GEOID: '19177',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10261327.356836502, 4997561.619821107],
              [-10210021.094085807, 4997762.948092326],
              [-10210088.665016718, 4984878.225271694],
              [-10209851.330491103, 4954067.957375536],
              [-10211238.372717632, 4955519.6002067765],
              [-10234635.16933409, 4954421.301840361],
              [-10235061.017558353, 4954408.191387424],
              [-10261406.171035983, 4953597.145686845],
              [-10261327.356836502, 4997561.619821107],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harrison',
        GEOID: '19085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10700788.793511795, 5140942.218261997],
              [-10650244.15050147, 5140501.521397622],
              [-10637387.417231793, 5140546.662685719],
              [-10637483.81991082, 5101603.18532037],
              [-10630765.688641446, 5101595.741896807],
              [-10630788.397817567, 5087276.488106963],
              [-10686005.469349204, 5087397.880002724],
              [-10687236.507848002, 5092916.316891506],
              [-10695631.555926684, 5090565.862511178],
              [-10696892.4717989, 5095457.32755841],
              [-10699818.504614402, 5103257.554872231],
              [-10699081.34694637, 5111458.127036745],
              [-10698686.705074392, 5112644.558471457],
              [-10696422.703547755, 5119453.776443307],
              [-10693855.342131589, 5130022.4042589525],
              [-10698683.713725256, 5137092.923690693],
              [-10700788.793511795, 5140942.218261997],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Worth',
        GEOID: '29227',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10534388.937893651, 4949380.0327291135],
              [-10523463.161673447, 4949230.465057023],
              [-10516486.738808924, 4949262.773163233],
              [-10498621.772024965, 4949345.507057257],
              [-10489885.05216957, 4949417.407106114],
              [-10489809.83245326, 4934530.552578242],
              [-10487885.452415917, 4921939.151081209],
              [-10530655.402654108, 4922298.66933485],
              [-10531767.818325607, 4924059.767745839],
              [-10534373.696285587, 4934846.04550064],
              [-10534388.937893651, 4949380.0327291135],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Iron',
        GEOID: '26071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9906459.076584036, 5847864.076796777],
              [-9871744.761297097, 5847934.320844697],
              [-9809091.814169336, 5847903.962428787],
              [-9809184.877263641, 5819958.389361625],
              [-9809123.600044647, 5767988.284132233],
              [-9815930.949725203, 5771877.767951899],
              [-9823533.959626893, 5774419.203085925],
              [-9830570.798598407, 5773840.463011073],
              [-9838436.967776334, 5779011.868762406],
              [-9841741.04158257, 5777094.805273308],
              [-9854744.15998264, 5783686.588431484],
              [-9862223.382610567, 5782774.465542982],
              [-9864361.050792271, 5778847.317638704],
              [-9869336.698072257, 5778632.62066603],
              [-9871715.81822949, 5782518.959720573],
              [-9872172.25135179, 5782667.657173625],
              [-9878490.945078151, 5784726.42683524],
              [-9886500.827718692, 5783812.754118322],
              [-9899950.498802492, 5791911.982913198],
              [-9906456.96467474, 5795832.757367521],
              [-9906434.141018098, 5833762.670127889],
              [-9906459.076584036, 5847864.076796777],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Winona',
        GEOID: '27169',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10250231.586591683, 5495314.956074312],
              [-10225196.164320897, 5496014.343209354],
              [-10221055.304652218, 5490893.2043317435],
              [-10210123.174058864, 5485404.182719481],
              [-10202194.554646604, 5475368.564594386],
              [-10193891.233828334, 5469606.119219462],
              [-10192325.253909148, 5469189.395479252],
              [-10179113.905384, 5465674.469467949],
              [-10177225.114167525, 5463012.410883479],
              [-10169862.14250417, 5452642.41143159],
              [-10162467.856647717, 5442680.487637214],
              [-10162095.34015022, 5441805.562025203],
              [-10211384.089931082, 5441785.495899332],
              [-10250219.898045149, 5441807.8773502335],
              [-10250242.050623816, 5482013.777999365],
              [-10250231.586591683, 5495314.956074312],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stone',
        GEOID: '28131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9945373.03098064, 3621055.020033948],
              [-9922793.096787622, 3621050.4789031576],
              [-9894637.16930077, 3621168.6785912775],
              [-9894581.064277412, 3598458.000152369],
              [-9894580.952957919, 3590909.902680049],
              [-9934159.48471456, 3590892.817527961],
              [-9945444.275454747, 3587082.8939383593],
              [-9945373.03098064, 3621055.020033948],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Logan',
        GEOID: '40083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10873199.947358815, 4323302.465671545],
              [-10849285.73774915, 4323274.75043266],
              [-10839709.589873148, 4323256.411532567],
              [-10837412.400861138, 4322531.567295634],
              [-10837383.235154552, 4298548.511653368],
              [-10834015.820558054, 4302118.133703079],
              [-10820654.36471712, 4293027.9055226995],
              [-10813640.234921725, 4292642.356009306],
              [-10813694.670152724, 4262770.823857186],
              [-10873022.838048963, 4262980.483743436],
              [-10873199.947358815, 4323302.465671545],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harrison',
        GEOID: '39067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9054511.08735426, 4897125.963164461],
              [-9054126.367194079, 4910263.697573557],
              [-9047527.125140872, 4910134.9529817],
              [-9046929.562114293, 4929136.692908044],
              [-9043337.95006334, 4928986.787894752],
              [-9040512.884025987, 4929132.451661623],
              [-9010412.316354467, 4927851.825149719],
              [-9001906.728021428, 4927592.85380656],
              [-9003842.351327341, 4889146.799488217],
              [-9026864.335218297, 4890239.7323679505],
              [-9038685.017987162, 4890988.525940269],
              [-9042028.498893138, 4890687.981941174],
              [-9054678.957146376, 4890968.275718254],
              [-9054511.08735426, 4897125.963164461],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Alachua',
        GEOID: '12001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9201508.140988305, 3481735.0700727594],
              [-9199554.929202847, 3481520.6464599343],
              [-9187164.735919083, 3495952.908541987],
              [-9185062.356015962, 3496512.125507529],
              [-9174810.832789319, 3493667.991327213],
              [-9158539.81941752, 3483386.290523303],
              [-9143017.763579777, 3482479.998642661],
              [-9134390.391723808, 3467382.369196154],
              [-9133870.529701805, 3465374.8691897765],
              [-9134420.893264286, 3435761.1229310245],
              [-9134392.395474643, 3432004.3588462654],
              [-9150421.95687091, 3429489.590373112],
              [-9151736.64005718, 3437402.372041018],
              [-9173462.976394793, 3437527.8239396713],
              [-9190177.15265944, 3436889.3235002444],
              [-9190266.096932584, 3444250.80484298],
              [-9201257.33817555, 3447732.117331384],
              [-9201508.140988305, 3481735.0700727594],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sherman',
        GEOID: '20181',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11360149.789486405, 4803388.2239183355],
              [-11289345.154513346, 4803414.509025581],
              [-11286579.421764588, 4803415.6642938135],
              [-11286874.307095699, 4741044.445158808],
              [-11296500.99402052, 4740993.353632782],
              [-11359842.421218736, 4740761.681130939],
              [-11360038.263183143, 4775344.862523559],
              [-11360149.789486405, 4803388.2239183355],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cole',
        GEOID: '29051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10296516.895029634, 4640041.249927496],
              [-10285349.435032744, 4684372.772465507],
              [-10281224.713940382, 4675868.548693629],
              [-10265957.023139102, 4670686.435827808],
              [-10259389.39582128, 4661410.818458638],
              [-10242393.135966964, 4660391.740258107],
              [-10246234.326316277, 4645534.86258411],
              [-10260023.249001859, 4645990.971827428],
              [-10254192.334074106, 4636362.6713819],
              [-10263042.12227268, 4626934.836944519],
              [-10286856.812257577, 4627759.131004384],
              [-10286308.786404401, 4639686.291750138],
              [-10296516.895029634, 4640041.249927496],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Columbus',
        GEOID: '37047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8802170.575303806, 4069062.388284627],
              [-8789753.374550661, 4088443.4303163607],
              [-8779652.577914553, 4094083.1045373417],
              [-8775354.755014006, 4091085.368293785],
              [-8755096.834079444, 4090854.6296689655],
              [-8732493.0775154, 4079590.9018213283],
              [-8720164.332590554, 4078260.546150771],
              [-8711427.533675134, 4082567.9109513396],
              [-8705466.04098468, 4076341.6248806417],
              [-8700993.001205627, 4076840.6748806727],
              [-8711264.673260104, 4057883.614771908],
              [-8724586.610681806, 4056347.443057978],
              [-8729999.63224112, 4047548.077114021],
              [-8740281.990966713, 4051095.4468141315],
              [-8743613.672006665, 4048389.116937548],
              [-8744931.026860712, 4037109.862221687],
              [-8754241.3437927, 4030125.254338305],
              [-8755374.94139627, 4021426.735687417],
              [-8773279.425747145, 4039684.34611043],
              [-8802162.269508878, 4069053.770744861],
              [-8802170.575303806, 4069062.388284627],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Trumbull',
        GEOID: '39155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9017248.2236451, 5063787.127567912],
              [-9017226.627663888, 5086624.0990496855],
              [-8963353.754942933, 5086362.3608014295],
              [-8963352.465812268, 5084740.637324715],
              [-8963334.093807, 5061658.306113395],
              [-8963322.16799808, 5046704.372220513],
              [-8963355.974650418, 5032036.095144004],
              [-9017133.675889077, 5032154.704413028],
              [-9017199.354388643, 5052521.362614812],
              [-9017233.97475028, 5063786.9792828085],
              [-9017248.2236451, 5063787.127567912],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bullitt',
        GEOID: '21029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9560430.120498007, 4585155.045942146],
              [-9541480.53753874, 4591767.281839665],
              [-9521097.827455005, 4591279.766838004],
              [-9509893.854665132, 4596162.885022057],
              [-9510706.375628432, 4594235.617482911],
              [-9519695.758468462, 4581017.584382723],
              [-9516614.434963303, 4578105.620637238],
              [-9526305.575873295, 4563211.07823089],
              [-9537926.106197713, 4553307.189660163],
              [-9544285.677387241, 4552872.064075145],
              [-9555464.491972193, 4562386.698165873],
              [-9557320.521842191, 4571713.41537955],
              [-9566610.133348888, 4579250.078882468],
              [-9560430.120498007, 4585155.045942146],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Flathead',
        GEOID: '30029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12803976.6252821, 6144528.189487392],
              [-12784831.78793598, 6144556.7632126445],
              [-12785021.587667782, 6202801.034551907],
              [-12789349.244191863, 6202808.437250153],
              [-12789339.336757181, 6217158.057638232],
              [-12761555.884286523, 6217177.101261937],
              [-12767469.620915426, 6221509.202548686],
              [-12758556.491926592, 6232861.295439064],
              [-12771968.486816345, 6242641.726093273],
              [-12767418.413949663, 6248113.950975609],
              [-12770439.068332337, 6264462.731767862],
              [-12766653.537728421, 6270328.106251059],
              [-12771356.254472066, 6274960.9968718],
              [-12765920.72152053, 6274984.412233082],
              [-12732275.51862317, 6275097.251215427],
              [-12710482.947188534, 6274810.999470825],
              [-12698011.541246708, 6274752.101308226],
              [-12692782.70287444, 6268304.653571427],
              [-12696888.83361184, 6256040.173034914],
              [-12690882.256527618, 6246608.7071978245],
              [-12667104.858572137, 6248691.5958597595],
              [-12657353.159859156, 6227461.332588125],
              [-12662642.61678369, 6209673.679949342],
              [-12645788.400599625, 6203082.173365572],
              [-12639603.267052168, 6205050.741867653],
              [-12631130.072690947, 6198436.751258329],
              [-12632442.30684842, 6182570.816553363],
              [-12618729.52669454, 6177670.683089142],
              [-12616219.049538169, 6171642.130087206],
              [-12622188.445912467, 6163857.815474998],
              [-12617958.082623342, 6158627.63602936],
              [-12604447.681303725, 6146165.567819343],
              [-12604806.797981026, 6135254.626054215],
              [-12580751.212618053, 6128681.30702838],
              [-12565625.120209062, 6102815.294129256],
              [-12577403.056293463, 6099191.853184266],
              [-12588746.512405299, 6093254.012605964],
              [-12588119.004435696, 6065350.31982675],
              [-12597560.455727838, 6060359.532987168],
              [-12595173.431886757, 6039823.498522596],
              [-12615375.359117448, 6039823.498522596],
              [-12631031.332302615, 6040574.618823013],
              [-12649687.811042622, 6040569.666167549],
              [-12646330.971797751, 6060636.861016923],
              [-12650412.389608195, 6060398.252474558],
              [-12654988.956513688, 6074500.235861143],
              [-12653472.45109061, 6088734.095164782],
              [-12662278.490729304, 6099031.29007688],
              [-12672868.313888468, 6103341.439470911],
              [-12677569.113345686, 6115493.492860662],
              [-12693654.891084807, 6115452.359562326],
              [-12699136.262811467, 6110706.701618318],
              [-12694712.760205815, 6100626.749128282],
              [-12745212.290606728, 6100533.486905768],
              [-12743553.630193908, 6071979.377950991],
              [-12757710.352477072, 6071967.779600578],
              [-12757723.933454948, 6086184.833335536],
              [-12800555.220732568, 6085720.476985388],
              [-12802929.442832207, 6109786.842229956],
              [-12803976.6252821, 6144528.189487392],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Turner',
        GEOID: '13287',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9328876.451449756, 3737554.8450344387],
              [-9307716.731320279, 3737626.7564059626],
              [-9307673.761996834, 3744172.743456888],
              [-9299812.824834974, 3744043.3904837617],
              [-9292970.683652857, 3743284.600010862],
              [-9290598.910582015, 3736249.380811054],
              [-9290016.04172822, 3731567.920514112],
              [-9289936.448292304, 3725119.9444874967],
              [-9295255.627520878, 3710132.7089776713],
              [-9311760.9684208, 3710456.3020532643],
              [-9311806.832051005, 3706733.540948946],
              [-9319531.29151715, 3713797.550692324],
              [-9328222.226802364, 3713915.3385405266],
              [-9328876.451449756, 3737554.8450344387],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Platte',
        GEOID: '31141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10890440.664814914, 5122445.808844204],
              [-10838963.971923815, 5122590.377296669],
              [-10826090.42941103, 5122572.175575795],
              [-10826212.212933956, 5069179.093433062],
              [-10830024.014937699, 5071616.493648839],
              [-10838976.884984748, 5070989.946118271],
              [-10856145.24477183, 5065874.317743488],
              [-10864587.826273084, 5061601.5042279335],
              [-10864610.98072717, 5070789.910618042],
              [-10876333.368385663, 5070761.419252261],
              [-10876318.006295934, 5090357.241892052],
              [-10890368.641104368, 5090264.754369294],
              [-10890440.664814914, 5122445.808844204],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'De Witt',
        GEOID: '17039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9923995.013329718, 4907012.316669809],
              [-9898478.359650085, 4907132.994707063],
              [-9860111.095272765, 4906933.956993568],
              [-9879086.504353896, 4880311.922315252],
              [-9879066.466845553, 4873965.729467756],
              [-9923549.735366546, 4873044.005970835],
              [-9923995.013329718, 4907012.316669809],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Somerset',
        GEOID: '24039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8453866.514631828, 4605885.773637016],
              [-8445153.426767947, 4607839.298682724],
              [-8446416.158424107, 4610510.031540105],
              [-8434529.873803074, 4619791.309774586],
              [-8422730.898334913, 4621729.033145141],
              [-8417174.385951968, 4618861.439876754],
              [-8409730.896880584, 4604706.6422410635],
              [-8409171.182480875, 4592074.0589370085],
              [-8422636.054128757, 4585339.926385548],
              [-8418463.131696882, 4578608.05359909],
              [-8423513.69699417, 4572477.267832964],
              [-8429408.175351167, 4575373.670501954],
              [-8436215.696171647, 4575554.98731335],
              [-8444777.500847539, 4567892.1743373005],
              [-8448335.160453802, 4567685.874416129],
              [-8449033.133661076, 4575826.121172656],
              [-8444419.052087186, 4584905.292972291],
              [-8444572.005067537, 4587924.357978788],
              [-8445120.698837657, 4593699.0402939515],
              [-8453278.079803495, 4596987.268798965],
              [-8453866.514631828, 4605885.773637016],
            ],
          ],
          [
            [
              [-8465425.70791682, 4583033.397610742],
              [-8461098.051392742, 4584612.438082666],
              [-8458064.817907605, 4580116.770175688],
              [-8458572.323466131, 4570688.069659124],
              [-8465460.996195402, 4572871.144620145],
              [-8465425.70791682, 4583033.397610742],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Siskiyou',
        GEOID: '06093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13765791.05199182, 5118242.0438768035],
              [-13770630.778173553, 5135471.5463893125],
              [-13763854.872088455, 5144419.443026765],
              [-13755242.083085777, 5146481.459876937],
              [-13750084.744229924, 5160855.492070109],
              [-13740695.742584841, 5161225.2610610025],
              [-13730987.79243174, 5160845.82771225],
              [-13718012.310272798, 5161723.964348736],
              [-13708545.449129345, 5162364.700463112],
              [-13697335.019809008, 5161436.180405489],
              [-13670042.374973258, 5161589.279614556],
              [-13636763.969798062, 5162246.795273963],
              [-13613232.598621387, 5162142.633994089],
              [-13613207.874990279, 5162142.524555888],
              [-13592323.781920008, 5161843.202021953],
              [-13563913.934674656, 5161439.326254903],
              [-13544837.781454356, 5161032.022292531],
              [-13519478.310678428, 5160558.533954817],
              [-13520555.104330167, 5153484.394323848],
              [-13519638.722281955, 5127542.679387286],
              [-13519361.982027845, 5039443.298659246],
              [-13636456.839322964, 5039323.638357174],
              [-13639157.45016961, 5043887.751406422],
              [-13637070.654995197, 5063064.264744253],
              [-13646126.606890721, 5065440.351461378],
              [-13653745.869438067, 5055098.119518881],
              [-13671296.055078572, 5042249.157434665],
              [-13679598.151382443, 5042647.31292665],
              [-13689334.265366713, 5028886.634153308],
              [-13680877.212331658, 5016542.627536177],
              [-13683116.737847438, 5011455.2306311885],
              [-13696394.81538977, 5012940.236348168],
              [-13704439.763669906, 5023473.798381178],
              [-13718956.159227822, 5023523.119916495],
              [-13722732.338994512, 5030484.991515412],
              [-13737748.113788124, 5038919.703310377],
              [-13746602.466085823, 5068099.3317522],
              [-13765919.95996216, 5068864.261732508],
              [-13760401.518845066, 5080746.118897206],
              [-13764437.518303268, 5091580.777888813],
              [-13772355.45104441, 5100595.398242278],
              [-13765791.05199182, 5118242.0438768035],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'La Paz',
        GEOID: '04012',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12771159.973354712, 3949191.552273827],
              [-12765440.266598264, 3950958.6919751163],
              [-12761130.198553732, 3951549.132224193],
              [-12760458.220472347, 3952992.216483465],
              [-12756911.189852668, 3960612.508123684],
              [-12748820.043983847, 3968834.8940705075],
              [-12749330.666488117, 3976106.2325751195],
              [-12748887.058317304, 3983450.9069457445],
              [-12746637.514047354, 3987656.486738274],
              [-12745699.313378949, 3991153.456609109],
              [-12746623.042513553, 3996683.498774724],
              [-12748359.849208908, 4005700.1956986845],
              [-12746709.315118916, 4010592.135923055],
              [-12747051.06595565, 4015468.1958406186],
              [-12749976.430854209, 4019205.224699549],
              [-12747146.800717734, 4023065.0679617915],
              [-12741050.834082404, 4030274.8556588213],
              [-12738902.033951622, 4034525.6158115393],
              [-12738299.476967935, 4039405.516092075],
              [-12738069.586799469, 4041267.868312081],
              [-12735611.095845299, 4043788.974219848],
              [-12729166.921842767, 4046870.7712398446],
              [-12723016.965254402, 4051211.150802054],
              [-12715993.707260763, 4053929.591963682],
              [-12710242.38576893, 4061069.6939986884],
              [-12705901.482225446, 4063705.1062535387],
              [-12706097.644008636, 4069577.633544335],
              [-12693887.548820563, 4063742.953777724],
              [-12673914.160504472, 4062590.8833004795],
              [-12654700.527713044, 4057038.7753526196],
              [-12646572.423773281, 4059637.705593897],
              [-12639161.996590663, 4070015.5373767526],
              [-12620347.110215258, 4068073.8958562943],
              [-12616228.400375396, 4071565.4244135185],
              [-12616255.673650641, 4028698.2315927525],
              [-12616208.696825527, 3970712.85176344],
              [-12616274.264005603, 3945508.6437692684],
              [-12685751.652516445, 3945529.0396706047],
              [-12685751.207238482, 3957142.803498233],
              [-12720234.979859987, 3956998.555299124],
              [-12720338.840944897, 3899262.0749790156],
              [-12747981.562233381, 3898573.476295551],
              [-12754448.580077337, 3900155.307772677],
              [-12760363.207262166, 3899426.322718884],
              [-12765095.398815788, 3900346.790067706],
              [-12769032.991844127, 3909293.7836326603],
              [-12766047.848379014, 3916496.634353626],
              [-12765907.363181634, 3925912.4849610114],
              [-12765505.945097834, 3929279.540598102],
              [-12770934.774024839, 3933604.3567201653],
              [-12769231.919774175, 3938311.7966541694],
              [-12769163.569606826, 3945402.3990334426],
              [-12771159.973354712, 3949191.552273827],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '12087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9033433.966286954, 2840224.9275830146],
              [-9021209.973002942, 2847838.9088764433],
              [-8999899.303643951, 2857546.7762521324],
              [-8973560.889483282, 2876603.826950911],
              [-8963063.684140457, 2887473.9281613873],
              [-8961276.1157573, 2895000.798551358],
              [-8960706.271283926, 2900306.5611154297],
              [-8960414.057620596, 2901016.5741421087],
              [-8959307.20792364, 2903379.8768118215],
              [-8955726.393863292, 2905281.7900478477],
              [-8952187.658570463, 2904798.012934903],
              [-8949522.781280365, 2906918.2073562685],
              [-8949539.479203982, 2909306.20143342],
              [-8946983.583695369, 2913895.914778583],
              [-8934997.702802166, 2919328.9866046435],
              [-8931428.86214718, 2917203.1440226124],
              [-8932115.084588075, 2915940.797391422],
              [-8945432.012632692, 2894576.9991000257],
              [-8960858.445027843, 2875661.593212217],
              [-8978049.291352067, 2859310.769851412],
              [-9013121.164843433, 2839903.2627110686],
              [-9028386.183976931, 2835199.8872658587],
              [-9033433.966286954, 2840224.9275830146],
            ],
          ],
          [
            [
              [-9066066.91565133, 2974717.991721159],
              [-9002751.865595527, 2974995.951082912],
              [-9002755.093860762, 2969495.5411023553],
              [-9002762.329627665, 2920519.6177478544],
              [-9001090.315332135, 2897564.797855998],
              [-9003015.024871765, 2897171.2673883443],
              [-9007519.456747223, 2893110.2731301663],
              [-9017947.198727792, 2891155.435156804],
              [-9025768.617470419, 2890343.227948868],
              [-9032717.068766244, 2898238.8444803483],
              [-9035904.034468165, 2905972.962517759],
              [-9033365.504800115, 2916676.43260103],
              [-9033216.559321433, 2925889.9133035736],
              [-9040055.583557809, 2937893.350099895],
              [-9043653.206861265, 2949504.6087343534],
              [-9049150.385955619, 2958705.064410224],
              [-9056506.934504695, 2962407.4635193325],
              [-9059604.288016526, 2971456.7695250455],
              [-9066066.91565133, 2974717.991721159],
            ],
          ],
          [
            [
              [-9107236.005695622, 2822866.907034076],
              [-9100509.302825458, 2833246.6275576265],
              [-9091723.078056127, 2838881.5775094912],
              [-9081956.017253416, 2843438.1499001333],
              [-9080458.992741227, 2845847.7450481914],
              [-9066250.061616885, 2852837.949243896],
              [-9050837.210199611, 2845704.443275495],
              [-9043955.216639787, 2835755.434728701],
              [-9054971.39344869, 2831318.478495002],
              [-9061616.833090577, 2829575.8455904187],
              [-9066295.146010654, 2831918.955187832],
              [-9074475.904069562, 2829293.5895712124],
              [-9083151.031987082, 2825849.138277027],
              [-9093159.656084815, 2821634.497508077],
              [-9107329.848026361, 2820018.1580511024],
              [-9107236.005695622, 2822866.907034076],
            ],
          ],
          [
            [
              [-9129858.01865616, 2819724.696937141],
              [-9126406.891802587, 2824328.0813502884],
              [-9113583.220421674, 2824748.9430056848],
              [-9119165.224968012, 2814226.0911702686],
              [-9131325.320864307, 2814297.6558485096],
              [-9129858.01865616, 2819724.696937141],
            ],
          ],
          [
            [
              [-9149129.760221783, 2823595.7018868704],
              [-9144239.272352252, 2829445.6765497155],
              [-9137843.299689233, 2825477.4600504646],
              [-9139414.46298229, 2818527.536493812],
              [-9148174.972949248, 2818060.3473964483],
              [-9149129.760221783, 2823595.7018868704],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Escambia',
        GEOID: '12033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9750703.962011829, 3626446.903543009],
              [-9751469.06087205, 3632414.345535916],
              [-9751457.032384971, 3632414.3685098146],
              [-9742629.848025102, 3632431.228065657],
              [-9732194.536319159, 3632496.9402851523],
              [-9719550.311957404, 3632541.874137943],
              [-9703012.611423165, 3632622.110787787],
              [-9716731.257172555, 3623070.018779507],
              [-9719706.71584197, 3612929.571096434],
              [-9719137.984563507, 3597333.7631937624],
              [-9714785.949070944, 3595362.5458765673],
              [-9713614.534069326, 3582368.813538071],
              [-9708141.066026513, 3575125.6612407155],
              [-9698707.073140254, 3568008.778479649],
              [-9699757.038577417, 3557689.9315171544],
              [-9710201.701120585, 3553037.323053905],
              [-9710373.112137632, 3544702.1980536687],
              [-9714610.06427549, 3544166.655746074],
              [-9720364.280074086, 3544467.634622101],
              [-9731534.189099774, 3541800.3397775996],
              [-9742495.262760732, 3539648.3206769857],
              [-9735143.500949763, 3547857.430467621],
              [-9732861.674027484, 3555482.5420251116],
              [-9725605.535659106, 3559800.6149179535],
              [-9730958.222054409, 3562466.5539264944],
              [-9734301.925599366, 3568950.3999087596],
              [-9732824.49331756, 3574477.5180491884],
              [-9729455.854206663, 3581476.625272017],
              [-9729344.53471587, 3588309.7334701563],
              [-9734031.307917248, 3592899.317672156],
              [-9743084.922103465, 3598806.9084716165],
              [-9745160.696648287, 3602588.7992874244],
              [-9755477.230457554, 3615340.3475321513],
              [-9750703.962011829, 3626446.903543009],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Barber',
        GEOID: '20007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11022031.991479097, 4504881.83298593],
              [-10961036.146291284, 4504964.867000593],
              [-10961066.2025538, 4492787.628864762],
              [-10948250.100898258, 4492775.3002427695],
              [-10947954.523131495, 4438823.724905764],
              [-10948725.323804457, 4438822.580756489],
              [-10969941.591268469, 4438901.087390221],
              [-10997468.01000167, 4439002.944366937],
              [-11020663.101699172, 4439017.314787637],
              [-11020782.986792397, 4491509.732090955],
              [-11021909.651358714, 4492804.30054706],
              [-11022031.991479097, 4504881.83298593],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Catoosa',
        GEOID: '13047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9491662.507477855, 4161853.440453187],
              [-9467186.465980766, 4162098.739000986],
              [-9459914.077775491, 4162142.574012316],
              [-9469019.341396676, 4139375.905961652],
              [-9478274.555180721, 4132348.8753450387],
              [-9484627.22456182, 4133357.2679111594],
              [-9484663.292076837, 4144119.1656424035],
              [-9491629.888449661, 4144095.5616716444],
              [-9491662.507477855, 4161853.440453187],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Burke',
        GEOID: '13033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9158516.442324454, 3887050.3303837855],
              [-9160612.254377617, 3903646.1691046446],
              [-9154086.037910372, 3926033.7230490004],
              [-9157985.114394896, 3930850.4656305956],
              [-9147594.553124253, 3934761.926090843],
              [-9139011.263786638, 3925954.006535009],
              [-9111110.762473475, 3928168.716535138],
              [-9111114.710713334, 3927435.8381472123],
              [-9101875.081658, 3922366.130893314],
              [-9101760.53198681, 3921517.0780334473],
              [-9100939.997935338, 3915437.011001589],
              [-9090175.180536648, 3909003.683653217],
              [-9085446.63033141, 3907168.1728837155],
              [-9083854.682488386, 3906550.281466793],
              [-9077432.797354521, 3901198.798679645],
              [-9102322.363372007, 3883285.9525443558],
              [-9112389.207563426, 3889184.168890941],
              [-9137252.638471084, 3884262.5722426022],
              [-9144337.010865169, 3870474.7590052285],
              [-9151992.22960804, 3869298.901264999],
              [-9163432.199718393, 3873525.6762392204],
              [-9158516.442324454, 3887050.3303837855],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Breckinridge',
        GEOID: '21027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9645466.863316856, 4560359.519898786],
              [-9641961.628749909, 4558660.24461395],
              [-9640250.98213489, 4566261.641960382],
              [-9630178.794607915, 4565716.0718785105],
              [-9631938.310479393, 4574938.466611029],
              [-9631565.501504725, 4584841.548272996],
              [-9627805.960342651, 4585596.094284625],
              [-9600502.020237844, 4562064.862148896],
              [-9590317.177386187, 4551052.850049701],
              [-9604119.12445219, 4522161.755395159],
              [-9619088.701657124, 4518368.476146359],
              [-9630430.71061558, 4526293.718401863],
              [-9639467.515558688, 4518065.972020126],
              [-9644791.926803328, 4525751.924361326],
              [-9644602.127071526, 4531769.874946256],
              [-9643069.591641776, 4531799.827168947],
              [-9648936.685404034, 4550203.3725064425],
              [-9645466.863316856, 4560359.519898786],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Baltimore',
        GEOID: '24005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8559700.737516265, 4787403.881410588],
              [-8549816.012011785, 4818953.518075897],
              [-8547900.55977062, 4825488.173368769],
              [-8539960.563533382, 4825538.083417944],
              [-8523672.086997874, 4825547.573376843],
              [-8523367.168916248, 4817045.556315712],
              [-8519522.63898221, 4799893.870574159],
              [-8507135.228685716, 4790433.808272738],
              [-8503328.213420078, 4787735.928984679],
              [-8501858.350863643, 4782217.118103198],
              [-8494409.518456701, 4766189.586749774],
              [-8496506.704410225, 4760838.616566755],
              [-8499242.454149492, 4757376.119384356],
              [-8504309.160772948, 4754915.448904656],
              [-8507623.364652844, 4751180.4591653915],
              [-8511875.99184013, 4751209.191209301],
              [-8515761.153388306, 4751051.165980232],
              [-8516387.279985229, 4750257.952507928],
              [-8519223.412190957, 4753005.106338415],
              [-8519226.863095172, 4764312.060871377],
              [-8519257.587274631, 4775106.680931808],
              [-8529988.786187103, 4775100.776864865],
              [-8537363.813771648, 4775103.080890575],
              [-8539450.72026555, 4773773.313829705],
              [-8539450.163668096, 4772561.773382329],
              [-8539435.469495311, 4761555.317352041],
              [-8536496.078340916, 4759911.583143565],
              [-8533736.57948364, 4758337.410054719],
              [-8531994.652091706, 4757390.781720928],
              [-8537880.44752842, 4752384.97662673],
              [-8540126.095616193, 4754021.161210192],
              [-8548645.598885585, 4759826.031753825],
              [-8548627.342489094, 4766700.065015134],
              [-8558495.592708936, 4771957.425467825],
              [-8557505.29451884, 4772960.13308518],
              [-8559055.084469665, 4784967.567825314],
              [-8559700.737516265, 4787403.881410588],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Glacier',
        GEOID: '30035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12698011.541246708, 6274752.101308226],
              [-12680123.450381428, 6274667.6227215715],
              [-12656244.863008818, 6274459.603502349],
              [-12620950.239216374, 6274617.39901544],
              [-12592055.150310654, 6274600.4316146],
              [-12489313.293370016, 6274673.693130765],
              [-12488353.029633382, 6186677.768807273],
              [-12532012.311283525, 6187646.749509024],
              [-12531887.856092818, 6158530.727371054],
              [-12617958.082623342, 6158627.63602936],
              [-12622188.445912467, 6163857.815474998],
              [-12616219.049538169, 6171642.130087206],
              [-12618729.52669454, 6177670.683089142],
              [-12632442.30684842, 6182570.816553363],
              [-12631130.072690947, 6198436.751258329],
              [-12639603.267052168, 6205050.741867653],
              [-12645788.400599625, 6203082.173365572],
              [-12662642.61678369, 6209673.679949342],
              [-12657353.159859156, 6227461.332588125],
              [-12667104.858572137, 6248691.5958597595],
              [-12690882.256527618, 6246608.7071978245],
              [-12696888.83361184, 6256040.173034914],
              [-12692782.70287444, 6268304.653571427],
              [-12698011.541246708, 6274752.101308226],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Burt',
        GEOID: '31021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10748438.516732762, 5163357.738766408],
              [-10721140.639880944, 5163254.654539485],
              [-10717047.644843457, 5168058.095888818],
              [-10711563.378810037, 5164373.207967751],
              [-10701425.067505531, 5157179.149656369],
              [-10704381.824500492, 5147515.926125282],
              [-10700788.793511795, 5140942.218261997],
              [-10698683.713725256, 5137092.923690693],
              [-10693855.342131589, 5130022.4042589525],
              [-10696422.703547755, 5119453.776443307],
              [-10698686.705074392, 5112644.558471457],
              [-10701591.935422229, 5113572.676112105],
              [-10736184.355866749, 5113706.378735931],
              [-10736121.126395978, 5122376.733047376],
              [-10748472.580496946, 5122412.986589222],
              [-10748438.516732762, 5163357.738766408],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '36055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8682441.385425946, 5355447.1960252],
              [-8682429.340093587, 5367742.129702443],
              [-8682345.650663864, 5367734.281246039],
              [-8662496.82885797, 5364412.246617232],
              [-8661576.262266373, 5364358.310961609],
              [-8656229.318887325, 5364045.041719093],
              [-8645111.61870282, 5355146.710485482],
              [-8632940.279537957, 5347926.507044761],
              [-8627362.950410232, 5350157.622189568],
              [-8613462.70778339, 5353776.032863234],
              [-8612953.532882968, 5317254.423912024],
              [-8625637.275663953, 5317234.320831905],
              [-8625314.337821163, 5303324.825556329],
              [-8636208.063190192, 5303446.329957044],
              [-8656098.07320768, 5302913.942507255],
              [-8652970.552113842, 5310202.114222488],
              [-8672882.82602949, 5310109.284029496],
              [-8672247.08041757, 5317613.849915043],
              [-8672448.90265438, 5332323.33918952],
              [-8682618.606055288, 5332234.865131902],
              [-8682441.385425946, 5355447.1960252],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '37099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9278671.695060462, 4227676.333044081],
              [-9265797.261991747, 4235397.777119771],
              [-9260259.006005289, 4234003.271432274],
              [-9257837.695761045, 4233347.247586154],
              [-9230710.249049632, 4203638.967526768],
              [-9237649.349508232, 4181823.027685301],
              [-9245850.590353444, 4171198.4264099994],
              [-9240460.9249891, 4167539.8686320805],
              [-9251607.7004588, 4163970.6998926047],
              [-9251608.47930643, 4163970.678648857],
              [-9255465.032134278, 4174476.1611908968],
              [-9264430.592603277, 4185289.8951694905],
              [-9264490.259850342, 4196359.524350027],
              [-9270348.225414358, 4194914.895079405],
              [-9277322.836790519, 4208953.242427152],
              [-9278671.695060462, 4227676.333044081],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brown',
        GEOID: '39015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9356697.77183, 4689009.932207949],
              [-9350071.34853832, 4758154.2589278435],
              [-9335884.681312136, 4757162.080447951],
              [-9336612.15418447, 4724723.647364355],
              [-9314437.756896414, 4724598.417422258],
              [-9318093.893685602, 4669955.430002672],
              [-9325474.19385264, 4672822.11711985],
              [-9326749.915217131, 4678168.053969978],
              [-9332359.860955657, 4681073.410746745],
              [-9334371.404154293, 4686128.767384607],
              [-9340192.309913017, 4688391.593199672],
              [-9342872.762346685, 4689433.764510042],
              [-9348478.811903033, 4691221.765227104],
              [-9356585.987778526, 4688978.853319833],
              [-9356697.77183, 4689009.932207949],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Preble',
        GEOID: '39135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9441465.652355017, 4826285.344457439],
              [-9441465.556390135, 4826294.102870826],
              [-9441163.765738208, 4853875.730184792],
              [-9404868.033922838, 4854104.673656777],
              [-9404182.973776497, 4806687.774387179],
              [-9404151.13640213, 4803476.460472642],
              [-9441641.196875228, 4803322.183889161],
              [-9441465.652355017, 4826285.344457439],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gallia',
        GEOID: '39053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9192271.851517696, 4699418.800653304],
              [-9178868.539548226, 4699432.9505137205],
              [-9176656.62126616, 4726697.584668815],
              [-9164140.41431882, 4725636.411211194],
              [-9138825.360237012, 4722069.505056027],
              [-9139204.030244574, 4716069.413916283],
              [-9143200.327544678, 4708155.584847392],
              [-9146184.135175902, 4696582.6513410555],
              [-9151496.301276555, 4693445.316008827],
              [-9150633.241264436, 4687404.811771335],
              [-9148855.468996467, 4673026.40077267],
              [-9147697.746292219, 4665744.423055237],
              [-9152573.539988963, 4663351.291944887],
              [-9158729.841788303, 4663636.142177747],
              [-9159605.185241444, 4661667.675276798],
              [-9168459.610561598, 4662425.441075123],
              [-9167657.442310942, 4675377.026067489],
              [-9180794.255419457, 4676262.411293836],
              [-9182030.013086751, 4689104.644369179],
              [-9193062.21990233, 4690075.472280458],
              [-9192271.851517696, 4699418.800653304],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marlboro',
        GEOID: '45069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8897175.152872315, 4137796.4446609183],
              [-8871378.211250173, 4137407.787190801],
              [-8869413.713481817, 4137378.1905644042],
              [-8845646.115092577, 4113716.763429938],
              [-8844364.411200698, 4112442.203372666],
              [-8864750.985290451, 4068885.8708682144],
              [-8867461.72621076, 4069855.574166189],
              [-8877792.397595355, 4087605.0785198906],
              [-8878037.634433573, 4098038.231055576],
              [-8886632.834956702, 4100452.1609734064],
              [-8880785.778702788, 4111395.3842240367],
              [-8891305.804541223, 4122352.8032048712],
              [-8897477.25010739, 4137800.996146698],
              [-8897175.152872315, 4137796.4446609183],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Richmond',
        GEOID: '51760',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8637887.317708809, 4516856.8854919765],
              [-8630865.952146513, 4522016.347919534],
              [-8630794.596352916, 4521955.937678861],
              [-8630765.208007347, 4521918.146333685],
              [-8629831.348799082, 4521115.990520917],
              [-8629809.418859396, 4521113.883362517],
              [-8629272.970233263, 4520644.278585853],
              [-8629241.244178386, 4520626.017384257],
              [-8629222.09722597, 4520604.665865907],
              [-8629139.4981638, 4520541.8757981],
              [-8629093.300575122, 4520496.64470769],
              [-8629063.912229553, 4520566.317524648],
              [-8629013.818458695, 4520547.494580756],
              [-8628995.562062206, 4520535.695140667],
              [-8628940.0136363, 4520515.748498409],
              [-8628925.764741477, 4520543.842371686],
              [-8628889.363267988, 4520521.5077362815],
              [-8628837.265746295, 4520482.878762481],
              [-8628735.29709273, 4520617.870089219],
              [-8627328.997965539, 4519666.084958111],
              [-8627307.513303816, 4519655.97200383],
              [-8627253.523350783, 4519616.082112848],
              [-8627223.91236623, 4519664.9612960415],
              [-8627060.161395274, 4519879.86386311],
              [-8626943.609888414, 4520039.990215289],
              [-8626928.025159702, 4520058.95270882],
              [-8626540.076734288, 4520583.7358014155],
              [-8626244.18952776, 4520279.622476411],
              [-8626219.253961822, 4520273.863371745],
              [-8625297.751217034, 4519298.794348261],
              [-8624206.263609806, 4520068.785126408],
              [-8624198.025967488, 4520078.055700029],
              [-8624208.489999622, 4520098.984752513],
              [-8624349.531794457, 4520351.260384909],
              [-8624375.691874793, 4520517.574597878],
              [-8624556.474727841, 4520817.902064699],
              [-8624563.710494744, 4520844.170592898],
              [-8624626.494687552, 4520948.683465578],
              [-8624672.135678777, 4521036.90213344],
              [-8624815.403863426, 4521286.9527205285],
              [-8624830.877272647, 4521292.852862771],
              [-8624848.465752192, 4521324.320344289],
              [-8624912.029181436, 4521337.384996131],
              [-8624945.758987145, 4521337.384996131],
              [-8624962.679549746, 4521482.502065329],
              [-8624969.024760723, 4521781.592871789],
              [-8624943.75523631, 4522062.288033882],
              [-8624937.521344827, 4522102.749219208],
              [-8624723.34264454, 4522776.984862927],
              [-8624735.476469038, 4522802.555814031],
              [-8624772.100581508, 4522822.787819664],
              [-8624786.46079582, 4522845.829873774],
              [-8624809.503930416, 4522866.764466966],
              [-8624839.782831911, 4522868.450476294],
              [-8624827.760326905, 4522916.642357932],
              [-8624815.181224445, 4522904.699742652],
              [-8624791.470172906, 4522894.443154536],
              [-8624677.590333825, 4522867.466970818],
              [-8624573.840568407, 4522865.640460896],
              [-8624529.53541107, 4522868.450476294],
              [-8624021.47325509, 4522846.953877711],
              [-8623790.04003373, 4522876.318523428],
              [-8623708.999444434, 4522898.377187144],
              [-8623586.43668507, 4522921.70041087],
              [-8623550.03521158, 4522945.58569392],
              [-8623482.019002706, 4522950.50325897],
              [-8623457.640034221, 4522616.816592088],
              [-8622192.716660338, 4522720.504192587],
              [-8622277.764751304, 4523322.137368221],
              [-8621425.280090809, 4523467.14148111],
              [-8621417.265087472, 4523383.820073503],
              [-8620977.553098837, 4523281.109437803],
              [-8620930.13099576, 4523249.214548353],
              [-8620315.981365053, 4522887.558601034],
              [-8620316.426643016, 4522870.838989977],
              [-8614515.901936252, 4513967.720434476],
              [-8618452.381769683, 4501611.489028066],
              [-8638041.717842538, 4513894.722413758],
              [-8637887.317708809, 4516856.8854919765],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'King and Queen',
        GEOID: '51097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8591796.150462799, 4564131.442942611],
              [-8590222.760779927, 4574327.912842075],
              [-8579405.957179036, 4574450.190157868],
              [-8576315.950753596, 4561415.156101398],
              [-8565280.181714313, 4548809.844171602],
              [-8549556.192320272, 4550468.069597895],
              [-8543890.252877876, 4541157.4257353],
              [-8537490.717991153, 4526989.729562216],
              [-8533092.707548892, 4523518.286822504],
              [-8532282.079016935, 4506387.347418276],
              [-8539574.730178295, 4499397.433621687],
              [-8542878.581345549, 4504412.675105916],
              [-8548466.81978337, 4511500.388707499],
              [-8546857.696543952, 4516673.779342428],
              [-8562203.86758624, 4536193.047570566],
              [-8575304.72449923, 4540060.218521769],
              [-8583078.721138775, 4549243.532226805],
              [-8590414.230304092, 4564891.916154283],
              [-8591796.150462799, 4564131.442942611],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Talladega',
        GEOID: '01121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9629484.049665874, 3919106.5453643803],
              [-9624463.429311607, 3927394.311285633],
              [-9613255.115061596, 3934781.3708318095],
              [-9611448.733684493, 3942466.1904262207],
              [-9615629.00320276, 3947316.1532245786],
              [-9604868.19330574, 3963181.224828217],
              [-9599672.801350925, 3961130.290474174],
              [-9592342.63552117, 3977788.5974809136],
              [-9594834.856281051, 3988359.060377728],
              [-9589680.095940378, 3985793.6902966113],
              [-9579116.655500531, 3985190.66055101],
              [-9572912.37500066, 3973409.9617589964],
              [-9550606.620713465, 3973288.3604414132],
              [-9550773.043352202, 3969367.73918364],
              [-9551795.73551412, 3966558.724252718],
              [-9556988.678440135, 3961692.282102362],
              [-9562890.726522503, 3961680.6682220967],
              [-9564989.43288243, 3948012.5421988387],
              [-9570862.983175155, 3946101.205982978],
              [-9571282.435016464, 3934418.185734404],
              [-9586633.94939431, 3934701.8606924256],
              [-9586897.665267998, 3921150.5968652996],
              [-9592715.555815328, 3921306.2398679694],
              [-9592886.98783115, 3909168.732780736],
              [-9628137.306466257, 3908976.0428035352],
              [-9629484.049665874, 3919106.5453643803],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Petersburg',
        GEOID: '02195',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-14860858.137446329, 7708512.882464325],
              [-14862898.51239308, 7718533.186238457],
              [-14854477.52687304, 7736110.973036194],
              [-14835995.15181663, 7744155.098751287],
              [-14840877.51630629, 7760665.385719901],
              [-14817137.51875676, 7761283.997091354],
              [-14803418.393391905, 7745290.237074938],
              [-14794717.773310995, 7720083.745361484],
              [-14782850.113717016, 7714661.520082113],
              [-14776906.209506107, 7701829.236412915],
              [-14763108.269941773, 7691098.385875611],
              [-14762225.2837408, 7678780.225322735],
              [-14768885.30623598, 7667294.167545495],
              [-14783989.580024775, 7659710.047919775],
              [-14798038.545040848, 7663081.094815797],
              [-14810137.192578223, 7662305.38836153],
              [-14825918.622829515, 7649378.779181277],
              [-14838951.68617261, 7651011.066832503],
              [-14851732.042224053, 7649822.761256571],
              [-14854618.346028892, 7686410.427553737],
              [-14869988.339442208, 7710783.69609562],
              [-14860858.137446329, 7708512.882464325],
            ],
          ],
          [
            [
              [-14883048.676060548, 7923900.7835958265],
              [-14866646.528328596, 7920246.811439938],
              [-14860378.127802026, 7930587.7173034195],
              [-14844838.260845758, 7919629.951624137],
              [-14836648.040630134, 7924327.707477119],
              [-14826442.269714206, 7913107.060432993],
              [-14802968.6626491, 7909039.10932113],
              [-14799908.935125157, 7914028.335873503],
              [-14791232.026095781, 7907225.3977117995],
              [-14787792.031191291, 7896877.118683679],
              [-14793007.794612922, 7886610.135341395],
              [-14786289.997302018, 7879738.410764344],
              [-14767118.070407577, 7884117.737202104],
              [-14756420.194934912, 7863822.163529274],
              [-14735136.576212183, 7831723.338848635],
              [-14722246.113136793, 7804325.018842161],
              [-14735507.047477541, 7779607.612941591],
              [-14699854.97680016, 7770581.506163581],
              [-14707410.667387074, 7737919.322984167],
              [-14712004.608664325, 7740380.6808710415],
              [-14718189.519572796, 7737996.074853425],
              [-14732964.065029863, 7713514.684554484],
              [-14743108.721545342, 7713336.32599016],
              [-14754933.441128528, 7701809.203790447],
              [-14756150.801767193, 7710662.057232668],
              [-14782347.728855064, 7730774.046579704],
              [-14793512.962462137, 7758691.337877603],
              [-14798537.033720622, 7770001.485607357],
              [-14823464.584654978, 7777770.762601225],
              [-14833034.276000509, 7788131.368849352],
              [-14841377.115238015, 7783194.080546148],
              [-14857470.90798047, 7792759.645555375],
              [-14866141.026520904, 7809860.339735776],
              [-14860009.660287501, 7822754.796434572],
              [-14858039.416619949, 7835844.017637324],
              [-14862817.805762252, 7857488.056139972],
              [-14863333.660282588, 7869372.750890376],
              [-14874594.962610215, 7879376.914132314],
              [-14880794.233733002, 7888990.802227372],
              [-14878354.221814306, 7907411.500880273],
              [-14883752.700626845, 7923757.143264458],
              [-14883048.676060548, 7923900.7835958265],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Anchorage',
        GEOID: '02020',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-16723390.624177774, 8663250.141698532],
              [-16722552.017703949, 8670313.609174516],
              [-16696531.568758667, 8677454.098070463],
              [-16686526.952162605, 8687479.36222655],
              [-16669912.184203234, 8717641.839223545],
              [-16626616.805968499, 8737819.480047481],
              [-16613370.788439516, 8737819.480047481],
              [-16606648.53834898, 8724360.173241857],
              [-16526766.673631145, 8724364.12990747],
              [-16527834.672825815, 8591123.786844462],
              [-16557478.830585081, 8591129.728514615],
              [-16558286.453490788, 8564773.67497914],
              [-16590805.43709979, 8564769.120918477],
              [-16590397.896443997, 8591126.986204712],
              [-16606857.818991672, 8604343.846034521],
              [-16626612.241869371, 8604346.822253112],
              [-16669922.733194293, 8626107.394782161],
              [-16666438.793451501, 8628418.99887006],
              [-16679213.261617482, 8643340.190137882],
              [-16698484.780544126, 8657707.347629376],
              [-16705231.298283651, 8660595.995394276],
              [-16727522.803676024, 8655126.917921703],
              [-16723390.624177774, 8663250.141698532],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Saguache',
        GEOID: '08109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11911310.08139047, 4600223.037879569],
              [-11911252.417894239, 4639727.215045165],
              [-11827355.259143488, 4639322.1100311745],
              [-11808385.861314863, 4639447.717872646],
              [-11804627.270027718, 4644367.383601652],
              [-11801062.819932517, 4642704.112004779],
              [-11799842.42435495, 4639443.4551378945],
              [-11777256.701548412, 4616936.023879072],
              [-11763828.565332493, 4600095.7844908],
              [-11753548.432996716, 4574792.743758373],
              [-11741223.361615065, 4564740.2684695665],
              [-11741392.56724107, 4562488.102552494],
              [-11736290.683658525, 4558501.779749385],
              [-11739447.927056404, 4544375.262107313],
              [-11804142.139686842, 4543937.271625042],
              [-11865140.879181415, 4543860.685016802],
              [-11865226.03859187, 4556062.09229059],
              [-11877104.496176457, 4556177.389065151],
              [-11877068.651300423, 4561573.665398983],
              [-11894183.689051416, 4568013.529147654],
              [-11897734.446849247, 4573933.41595248],
              [-11911252.52921373, 4573217.740331423],
              [-11911310.08139047, 4600223.037879569],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clayton',
        GEOID: '13063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9401883.44705518, 3974473.8275405723],
              [-9401827.453351311, 3979126.136591982],
              [-9401791.05187782, 3981750.1966099422],
              [-9389823.983978564, 3981622.088481779],
              [-9382148.393768875, 3981555.6279373104],
              [-9377987.716480985, 3973920.300395342],
              [-9382438.492361885, 3968413.7380919876],
              [-9383640.854181942, 3953281.681976837],
              [-9390224.73414542, 3948157.211825037],
              [-9390288.854172116, 3942188.3227619864],
              [-9394042.324762683, 3942181.792618746],
              [-9393324.870644521, 3956956.3887277883],
              [-9395084.386515997, 3959956.4702178785],
              [-9399611.972845543, 3968292.9908461506],
              [-9401895.580879677, 3968661.51432784],
              [-9401883.44705518, 3974473.8275405723],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Houston',
        GEOID: '13153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9334867.332485776, 3813611.7743489835],
              [-9332691.48171873, 3814454.649831295],
              [-9333769.277028592, 3824968.717496682],
              [-9320051.376178136, 3831921.3051522616],
              [-9317562.71764196, 3854439.9378823815],
              [-9317569.619450392, 3854515.4659101446],
              [-9313671.433521794, 3852180.9339891016],
              [-9306048.49743125, 3850834.73077386],
              [-9301974.426707199, 3850033.032506836],
              [-9294946.270655965, 3822816.1120867855],
              [-9294959.183716897, 3816158.2472299095],
              [-9297788.81385337, 3816233.7954623476],
              [-9308043.67666474, 3801247.9724023095],
              [-9315786.058568902, 3801423.9003288676],
              [-9319493.44289028, 3801459.454940283],
              [-9333958.854121411, 3801565.8560395786],
              [-9334867.332485776, 3813611.7743489835],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calhoun',
        GEOID: '13037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9440778.922416313, 3699733.298891338],
              [-9441879.092943823, 3713502.497792887],
              [-9417311.660562182, 3715835.1405863133],
              [-9411712.735453244, 3713689.176420998],
              [-9403935.955826426, 3713684.9931150405],
              [-9400975.302649288, 3713776.6339905816],
              [-9401479.023345128, 3704166.989360457],
              [-9396758.854296511, 3692233.466440467],
              [-9398690.804059228, 3689588.6783758006],
              [-9408000.1191158, 3689973.049851157],
              [-9421812.196255466, 3689231.8473753748],
              [-9438671.867094578, 3689548.885006202],
              [-9442097.724423742, 3698010.957159468],
              [-9440778.922416313, 3699733.298891338],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marshall',
        GEOID: '28093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9988065.150857514, 4163091.203035854],
              [-9979130.202541651, 4163074.8837320404],
              [-9955853.538399843, 4163032.37000553],
              [-9946694.770915193, 4163065.27363886],
              [-9946697.621601589, 4142760.1194605804],
              [-9940744.477872947, 4142757.8136040783],
              [-9940645.069567667, 4107345.9135945113],
              [-9934779.75691726, 4107387.5584817347],
              [-9934834.080828767, 4095549.1799486154],
              [-9943704.79709161, 4099648.045645499],
              [-9954685.24034397, 4098723.2016516603],
              [-9960494.225332035, 4103458.204704949],
              [-9981845.97158313, 4103485.1023071166],
              [-9981927.791408863, 4121236.6923509017],
              [-9987844.422344524, 4121224.1022147173],
              [-9987967.875659814, 4132982.0067829834],
              [-9988065.150857514, 4163091.203035854],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nodaway',
        GEOID: '29147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10597867.773578208, 4950349.672773114],
              [-10583023.87598595, 4950130.466584783],
              [-10565878.099290261, 4949843.378832046],
              [-10555311.667989401, 4949666.459390041],
              [-10534388.937893651, 4949380.0327291135],
              [-10534373.696285587, 4934846.04550064],
              [-10531767.818325607, 4924059.767745839],
              [-10530655.402654108, 4922298.66933485],
              [-10531485.289457973, 4884287.674680359],
              [-10580147.269024363, 4884865.524549247],
              [-10582584.275316808, 4901840.891451236],
              [-10595457.483871125, 4904045.88135343],
              [-10595133.989430878, 4935781.169837753],
              [-10597867.773578208, 4950349.672773114],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '13207',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9364567.372629423, 3886305.9792367783],
              [-9356867.960048705, 3886214.861804524],
              [-9355456.76286392, 3922230.5626984322],
              [-9333317.20857648, 3921451.5085466155],
              [-9331051.411660874, 3919252.052632449],
              [-9330359.783664575, 3912813.4313713964],
              [-9320265.554878423, 3899640.63164407],
              [-9318630.828156123, 3889039.5660530115],
              [-9321243.27396606, 3888803.0314935585],
              [-9335678.96289315, 3877356.6377997175],
              [-9338806.038709024, 3875192.350890771],
              [-9346114.942516038, 3875246.148442944],
              [-9349453.970642382, 3875281.1302345446],
              [-9364671.456353314, 3875352.8167311223],
              [-9364567.372629423, 3886305.9792367783],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yuba',
        GEOID: '06115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13539095.031563314, 4764105.642139784],
              [-13515024.084110612, 4770455.926348011],
              [-13506885.850097189, 4782763.862045022],
              [-13503624.411655929, 4796373.314499048],
              [-13486345.95689245, 4797363.454129518],
              [-13478196.034332493, 4807589.2188534755],
              [-13470713.36080035, 4813686.936262564],
              [-13476137.514308741, 4798892.943821809],
              [-13472116.87694027, 4777915.1058369335],
              [-13483849.50599192, 4776284.539624936],
              [-13499284.064709898, 4760811.57025934],
              [-13500775.857206019, 4726631.517822387],
              [-13506631.485060725, 4727692.508907568],
              [-13510361.578558227, 4726219.505457204],
              [-13515831.373057844, 4721163.364764879],
              [-13530138.933251034, 4717719.452873829],
              [-13533713.290780915, 4709982.363722442],
              [-13537578.637459729, 4729961.049486129],
              [-13534881.58883679, 4734527.193865134],
              [-13539095.031563314, 4764105.642139784],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '08059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11732957.33282621, 4803081.652917775],
              [-11732846.013335418, 4829257.4296597],
              [-11732834.881386336, 4853291.1739157885],
              [-11726344.732434109, 4853421.7938299],
              [-11707042.266689027, 4853459.673926041],
              [-11706932.839629577, 4850185.828046106],
              [-11694434.443800762, 4853485.362809014],
              [-11694473.850900503, 4835626.414969399],
              [-11695797.99624349, 4810669.478005597],
              [-11699339.514523586, 4810580.891776728],
              [-11695016.978696086, 4810069.476994941],
              [-11694495.112923246, 4811016.604851385],
              [-11693972.245274989, 4803086.273837895],
              [-11694453.145475216, 4802656.104196339],
              [-11696677.86549872, 4800079.805103194],
              [-11707613.113037815, 4780118.612478137],
              [-11712795.591931695, 4758999.599588972],
              [-11725195.136052685, 4740265.470955942],
              [-11725331.391109418, 4740264.8969366625],
              [-11732837.775693098, 4740247.532868901],
              [-11732868.83383103, 4779314.138257134],
              [-11732957.33282621, 4803081.652917775],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '12133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9557865.764708096, 3566708.8676830824],
              [-9564047.113392865, 3585621.738920822],
              [-9556157.233163401, 3594254.6415754417],
              [-9553618.59217586, 3605607.000074895],
              [-9550119.709260736, 3605552.0559138414],
              [-9544093.539946133, 3599854.080546617],
              [-9531064.70674369, 3599530.0112263756],
              [-9528941.064817823, 3610762.592259385],
              [-9515843.436170071, 3610627.3792728395],
              [-9510277.238991424, 3604917.8830633233],
              [-9510556.428274333, 3576715.007671094],
              [-9516297.842331488, 3576716.8176809675],
              [-9516477.066711664, 3559802.1642680783],
              [-9557167.902820313, 3560314.4931646003],
              [-9572667.583440404, 3553692.1053463724],
              [-9557865.764708096, 3566708.8676830824],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bartow',
        GEOID: '13015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9467374.373281224, 4041755.1605887],
              [-9464728.42030456, 4075506.4632302127],
              [-9462799.587487584, 4081620.454605505],
              [-9461034.171683094, 4080556.3979329485],
              [-9423554.680244852, 4084338.247165392],
              [-9422559.59531665, 4076592.6978085884],
              [-9424223.599065026, 4039312.5910650897],
              [-9432972.754443925, 4039468.361133688],
              [-9452142.52735598, 4038917.0602534045],
              [-9453556.396208547, 4039884.744051139],
              [-9467393.854192114, 4039936.356164596],
              [-9467374.373281224, 4041755.1605887],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pulaski',
        GEOID: '18131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9677022.258972704, 5037791.850827093],
              [-9625467.531118562, 5037662.302615456],
              [-9625630.391533593, 4999059.383855123],
              [-9638212.054341521, 4999211.986373061],
              [-9677087.826152783, 4999431.909072526],
              [-9677022.258972704, 5037791.850827093],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scott',
        GEOID: '18143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9561045.605962606, 4683703.881207276],
              [-9558955.582522962, 4682523.474419429],
              [-9551719.259023944, 4690193.851362486],
              [-9550695.45366712, 4694136.132495411],
              [-9543775.166202463, 4697608.638452016],
              [-9538281.326692834, 4695264.452649654],
              [-9538225.555627946, 4684030.4008352645],
              [-9525712.354306856, 4675752.902569339],
              [-9525606.600790603, 4665412.647307875],
              [-9542275.358703006, 4665325.039794372],
              [-9550498.084209941, 4665221.621159392],
              [-9556543.734435435, 4659020.55182758],
              [-9558002.353723299, 4661104.6714015715],
              [-9560746.04521288, 4661034.187679115],
              [-9561045.605962606, 4683703.881207276],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chickasaw',
        GEOID: '19037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10303106.563606633, 5344420.457687494],
              [-10250407.360067643, 5344440.9249081435],
              [-10250426.284381079, 5324582.440724739],
              [-10250473.261206193, 5297828.970437386],
              [-10303087.639293198, 5297844.016507972],
              [-10303106.563606633, 5344420.457687494],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gosper',
        GEOID: '31073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11142535.006304344, 4929892.834002565],
              [-11129855.493664006, 4929839.448826238],
              [-11129916.719383944, 4968192.370688606],
              [-11098471.857541606, 4968187.378351878],
              [-11092259.450718904, 4965976.610920238],
              [-11092119.96739694, 4917109.726140935],
              [-11142501.944415577, 4917116.299352024],
              [-11142535.006304344, 4929892.834002565],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '21151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9402270.282285687, 4551694.300848517],
              [-9403856.807668472, 4558698.874315512],
              [-9399341.355163423, 4557863.010383519],
              [-9393824.917797163, 4557621.667002092],
              [-9388395.643592194, 4564181.236646593],
              [-9381161.323844012, 4567784.367300618],
              [-9379911.98519884, 4561921.576402547],
              [-9359780.300566839, 4558689.7103222255],
              [-9364220.723735092, 4553659.897102066],
              [-9359064.62756053, 4551368.287308949],
              [-9360768.261047628, 4532651.884374023],
              [-9364969.013352204, 4529034.319703152],
              [-9360896.501101023, 4518328.169845429],
              [-9369965.922654932, 4517109.504220109],
              [-9373044.24053384, 4512239.207816541],
              [-9380683.317950547, 4511179.838270487],
              [-9389554.702130333, 4514514.098706369],
              [-9400953.372709602, 4536836.39787296],
              [-9409351.53773403, 4546914.449229754],
              [-9402270.282285687, 4551694.300848517],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Logan',
        GEOID: '31113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11211176.385439327, 5122076.26658591],
              [-11161501.509826211, 5122090.439320436],
              [-11159915.207082406, 5122084.621037409],
              [-11159901.180826567, 5070527.259027856],
              [-11211346.926899225, 5070558.865874577],
              [-11211176.385439327, 5122076.26658591],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'West Baton Rouge',
        GEOID: '22121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10184073.522657314, 3567613.7009293996],
              [-10176244.534189314, 3569471.3711747457],
              [-10164524.261601143, 3587383.7373464117],
              [-10166905.942106664, 3588500.7384034027],
              [-10164589.494822748, 3587890.464576082],
              [-10163208.799178438, 3587319.4274164536],
              [-10165170.693884179, 3580171.051105648],
              [-10157464.713453505, 3572616.134548485],
              [-10161407.649817403, 3568773.517504062],
              [-10153373.722166853, 3570953.9058989985],
              [-10152024.418618947, 3568715.763160284],
              [-10151904.972805327, 3561873.8159651123],
              [-10152232.47474724, 3557946.179490222],
              [-10156738.46509557, 3548823.2174390047],
              [-10145892.718427073, 3545174.2023233715],
              [-10164725.74987948, 3545068.3242665036],
              [-10166305.8187318, 3548206.869900964],
              [-10180533.674169578, 3564744.1413773033],
              [-10184073.522657314, 3567613.7009293996],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '22041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10233960.239261411, 3772093.134391118],
              [-10226721.466733597, 3775334.6527266754],
              [-10229674.43886587, 3783220.4009262156],
              [-10216348.382623008, 3795294.4188902276],
              [-10215163.943240965, 3806709.0044533713],
              [-10200748.5144612, 3816624.7289680564],
              [-10183144.004909188, 3816697.906818317],
              [-10182659.98776322, 3804932.070523376],
              [-10192100.771138417, 3796126.392623713],
              [-10184922.779052574, 3790033.0419632844],
              [-10184593.607318299, 3775448.574385652],
              [-10188873.062502865, 3757974.9465108314],
              [-10186999.555472814, 3754128.821840474],
              [-10194162.63074689, 3747904.6553209242],
              [-10196522.715271197, 3759341.549022204],
              [-10202153.03247654, 3759429.4682692727],
              [-10211243.159455737, 3747898.1004274925],
              [-10219671.269423185, 3749298.6998072215],
              [-10229113.16599329, 3759566.7285558283],
              [-10233960.239261411, 3772093.134391118],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oscoda',
        GEOID: '26135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9392218.800183998, 5598729.139973659],
              [-9338423.099660696, 5598979.767694203],
              [-9338423.322299676, 5598951.9721722035],
              [-9338217.381241709, 5544548.227410097],
              [-9392097.016661072, 5544274.592557128],
              [-9392218.800183998, 5598729.139973659],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Winston',
        GEOID: '28159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9942818.137347443, 3909763.6997613194],
              [-9931248.257391335, 3909834.2685506954],
              [-9931192.708965428, 3921553.9426782927],
              [-9919557.373148736, 3921622.5873537115],
              [-9917259.182261307, 3933327.8995482987],
              [-9903645.699093217, 3933341.8820508244],
              [-9886623.835756017, 3933383.96282659],
              [-9886593.668174013, 3885482.234399935],
              [-9897907.179342823, 3885565.3887572326],
              [-9899698.53258867, 3884589.3237086134],
              [-9909407.595936675, 3886192.18202963],
              [-9942963.7432414, 3886235.6847943463],
              [-9942818.137347443, 3909763.6997613194],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Christian',
        GEOID: '29043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10420494.970398976, 4452796.894593121],
              [-10359978.912216483, 4451476.808222491],
              [-10342811.554304816, 4451041.141918615],
              [-10341945.04338848, 4448959.206175902],
              [-10342619.97346116, 4412541.933096054],
              [-10386593.732672792, 4413610.918071284],
              [-10390788.473724864, 4413671.406252476],
              [-10390277.517262124, 4438060.599284361],
              [-10420631.559414178, 4438522.771376346],
              [-10420494.970398976, 4452796.894593121],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carroll',
        GEOID: '39019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9052249.297940323, 4961084.689014297],
              [-9043734.581409035, 4960931.36064637],
              [-9043286.743097574, 4971649.294678026],
              [-9038986.693807213, 4972476.294393297],
              [-9026595.721287014, 4972277.102985772],
              [-9007658.383471733, 4972147.5426117005],
              [-9007764.470946461, 4959894.072940042],
              [-9001515.996608742, 4953432.2054827595],
              [-9001691.102167761, 4946984.4121493995],
              [-9008075.608923227, 4947116.86342047],
              [-9008481.47978666, 4934182.000282218],
              [-9010412.316354467, 4927851.825149719],
              [-9040512.884025987, 4929132.451661623],
              [-9043337.95006334, 4928986.787894752],
              [-9046929.562114293, 4929136.692908044],
              [-9046760.69044676, 4935460.8175351685],
              [-9046349.921525732, 4948395.608323956],
              [-9052685.670344234, 4948630.949544575],
              [-9052249.297940323, 4961084.689014297],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Spink',
        GEOID: '46115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10989210.664133098, 5659974.062695749],
              [-10907245.90042303, 5659449.648619764],
              [-10907283.192452446, 5645687.017304798],
              [-10906837.803169781, 5563710.021490505],
              [-10987875.164202051, 5564110.014106241],
              [-10987832.751476059, 5602732.79071016],
              [-10989070.29025521, 5605309.007012696],
              [-10989210.664133098, 5659974.062695749],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Warren',
        GEOID: '47177',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9573189.671852224, 4261058.866295653],
              [-9560691.832620863, 4278580.930379972],
              [-9558801.405028213, 4279501.286518682],
              [-9538087.18550089, 4277426.9559553],
              [-9536029.333394086, 4275825.407930806],
              [-9529268.566759737, 4272449.678957443],
              [-9530634.456911772, 4267720.639182283],
              [-9528350.848877639, 4248171.302721701],
              [-9524221.229727682, 4236548.555522801],
              [-9529763.93849377, 4236367.1696257],
              [-9553475.880588664, 4232663.777248786],
              [-9559779.680713303, 4235333.628159569],
              [-9567708.96804251, 4242082.540176819],
              [-9571813.317668056, 4253952.982356809],
              [-9573189.671852224, 4261058.866295653],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cumberland',
        GEOID: '47035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9492141.624148838, 4272228.9951441875],
              [-9489812.37512348, 4272964.625223794],
              [-9489173.7352048, 4288662.397938183],
              [-9491567.994812781, 4297753.373573982],
              [-9489581.609819066, 4314486.122575198],
              [-9479160.769646926, 4314327.131859138],
              [-9473312.37755912, 4319703.939814659],
              [-9465436.300946513, 4324098.102585497],
              [-9451887.828361047, 4322148.413614531],
              [-9440500.623689331, 4313081.3261704575],
              [-9431068.189275943, 4299921.5688528465],
              [-9426604.945612077, 4288032.084020523],
              [-9432059.711980438, 4281152.409736461],
              [-9437878.04780573, 4276568.2827645475],
              [-9440074.270039592, 4276302.758573925],
              [-9452812.782010047, 4267913.794677956],
              [-9454201.381338203, 4268820.628607499],
              [-9490438.769898174, 4268417.551515077],
              [-9492141.624148838, 4272228.9951441875],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gregg',
        GEOID: '48183',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10573858.274391996, 3834051.2658949676],
              [-10555338.941264646, 3841094.5325506623],
              [-10547051.873092033, 3851260.3947578273],
              [-10542155.040011527, 3849230.99197038],
              [-10542176.85863172, 3818804.303279276],
              [-10528510.498705504, 3815261.8572432348],
              [-10529865.59086693, 3811404.6828717054],
              [-10573727.585309807, 3812085.5490522287],
              [-10573897.236213775, 3834040.966379429],
              [-10573858.274391996, 3834051.2658949676],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shackelford',
        GEOID: '48417',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11088757.228219057, 3889592.781044929],
              [-11073089.789126338, 3889601.1391694276],
              [-11031318.04076209, 3889602.7311938163],
              [-11031311.361592643, 3856554.243826492],
              [-11031321.825624777, 3831073.229869594],
              [-11033352.62709532, 3831078.906386196],
              [-11088760.011206327, 3831058.180513143],
              [-11088757.228219057, 3889592.781044929],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nicholas',
        GEOID: '54067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9042641.869287409, 4616747.315899601],
              [-9007011.505910736, 4638187.872634539],
              [-8996554.486904087, 4647251.633655694],
              [-9003657.560972624, 4651303.9783114055],
              [-8992964.767284473, 4658505.211309353],
              [-8978004.429597277, 4654084.741136083],
              [-8975191.831342893, 4629611.195207552],
              [-8954151.779666021, 4617260.280751417],
              [-8984814.399446554, 4590610.125301377],
              [-9003763.871086331, 4594051.143828183],
              [-9013474.604226701, 4609939.8358929865],
              [-9024722.882173907, 4609148.985191463],
              [-9042664.355824549, 4616718.676823994],
              [-9042641.869287409, 4616747.315899601],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morgan',
        GEOID: '49029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12453615.559892362, 5040116.914642868],
              [-12445498.031304225, 5044428.338143238],
              [-12431939.87392306, 5039106.6561411265],
              [-12422889.599321565, 5047592.108449101],
              [-12411809.525124947, 5045867.928911147],
              [-12403298.704775838, 5065781.471641943],
              [-12393415.315105248, 5065212.54921951],
              [-12385607.254701518, 5056201.024352585],
              [-12387777.428174531, 5045581.5328903925],
              [-12381151.469443535, 5044123.6347069405],
              [-12385960.248806823, 5033611.39353967],
              [-12397273.648656143, 5031538.24568189],
              [-12398815.20096465, 5025219.253947378],
              [-12412959.23282586, 5021673.143244583],
              [-12422473.821023453, 5011311.432528389],
              [-12414894.522173302, 5005535.751478839],
              [-12409847.296460735, 4991461.593405882],
              [-12415306.404289236, 4980701.773065919],
              [-12427825.060265375, 4982728.2343179565],
              [-12430379.174662137, 4990270.360737058],
              [-12438700.083959952, 4991860.469584326],
              [-12447233.390846202, 5006107.077460661],
              [-12445700.187499506, 5011246.834688311],
              [-12449776.929891339, 5015731.799713242],
              [-12451780.458086634, 5032878.069910114],
              [-12453615.559892362, 5040116.914642868],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coconino',
        GEOID: '04005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12614721.468428528, 4313944.819721752],
              [-12604140.328189647, 4313169.904103536],
              [-12601004.680772983, 4321687.378751503],
              [-12594362.135437855, 4323545.28729595],
              [-12580108.565197704, 4333562.953919908],
              [-12568298.791738937, 4335594.908433581],
              [-12564078.001926016, 4339546.4520268645],
              [-12555996.540852897, 4339913.099466374],
              [-12548377.278305553, 4348334.372018443],
              [-12543655.105506102, 4347735.950868997],
              [-12537857.475106098, 4354641.100966802],
              [-12537136.904042192, 4366142.478680092],
              [-12541260.400620157, 4375674.472914417],
              [-12536906.36137676, 4382934.969319083],
              [-12538880.389906997, 4393829.827427787],
              [-12534617.076048596, 4415705.538897133],
              [-12526704.26400403, 4432479.190393853],
              [-12527736.418322666, 4439210.509727913],
              [-12507600.837508487, 4439249.659995082],
              [-12402414.381391006, 4439312.759785206],
              [-12401644.60846214, 4439313.221561922],
              [-12387442.133868262, 4439171.60245208],
              [-12363865.778913155, 4439439.788273322],
              [-12328710.415803695, 4439552.417190643],
              [-12328733.792896762, 4168088.0572204976],
              [-12328709.079969805, 4064213.7013437976],
              [-12332319.505014705, 4069137.452110978],
              [-12339549.483302746, 4064737.8098435774],
              [-12351884.128160603, 4071106.0966233723],
              [-12367223.731352935, 4082158.051787606],
              [-12372837.907232111, 4079292.151582333],
              [-12384326.969237905, 4089829.256808906],
              [-12400682.808061687, 4086156.2306532105],
              [-12403054.358493548, 4079575.6606472204],
              [-12403558.969745314, 4087662.8473416725],
              [-12414088.79169894, 4086740.606143409],
              [-12409011.39840437, 4091043.108613623],
              [-12412392.06002027, 4095876.591257888],
              [-12418210.28452607, 4092321.5002877545],
              [-12417923.636837278, 4137076.679641322],
              [-12443102.435862353, 4137216.45280324],
              [-12443049.447784737, 4161300.098956561],
              [-12468681.317137342, 4160606.260723659],
              [-12505023.346018659, 4160215.8174260654],
              [-12505154.703017795, 4184049.9699592562],
              [-12517019.579624504, 4184203.67666126],
              [-12516847.145733267, 4199334.2835600795],
              [-12528096.425555889, 4196045.096983204],
              [-12545132.871746384, 4206305.470688719],
              [-12551811.150638053, 4205584.527856896],
              [-12573916.084563855, 4212380.995469693],
              [-12576414.650534708, 4217404.250965229],
              [-12595583.866849313, 4229112.002605373],
              [-12598523.035364727, 4232919.7659581285],
              [-12616301.092002885, 4235872.819360153],
              [-12616285.841232646, 4273552.478739953],
              [-12613669.721879514, 4281972.158651597],
              [-12616377.791132042, 4288774.967657387],
              [-12614404.319199257, 4295309.307638718],
              [-12618529.151611112, 4306177.36919788],
              [-12614721.468428528, 4313944.819721752],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Augusta',
        GEOID: '51015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8843009.175543617, 4610017.762480531],
              [-8828603.208920568, 4633631.442113099],
              [-8828893.092167625, 4638709.239907719],
              [-8827386.041608237, 4638422.723226689],
              [-8820023.593126148, 4646610.050312296],
              [-8819667.705015514, 4647420.647139146],
              [-8784560.097666174, 4622409.918485347],
              [-8781800.71012839, 4622416.443854471],
              [-8766342.662997853, 4608659.51554906],
              [-8769869.487105167, 4590840.358302505],
              [-8776303.308395054, 4586119.7680861205],
              [-8783361.854667276, 4572562.8182935305],
              [-8794810.73033689, 4562726.03300372],
              [-8801192.120146615, 4567791.9871329265],
              [-8811760.347324565, 4564039.614386629],
              [-8814720.109945778, 4567311.3842162965],
              [-8847970.12865082, 4591589.499554941],
              [-8842850.545269238, 4602449.5889897905],
              [-8851252.940434312, 4604944.412035002],
              [-8843009.175543617, 4610017.762480531],
            ],
            [
              [-8806823.550546864, 4600959.836102117],
              [-8799785.598380443, 4596558.088603829],
              [-8795506.69979333, 4605131.063037735],
              [-8798001.146943025, 4607578.65620387],
              [-8804915.089196704, 4605604.078423396],
              [-8806823.550546864, 4600959.836102117],
            ],
            [
              [-8785589.802956013, 4583890.653997471],
              [-8779875.21689614, 4585085.221924328],
              [-8779150.30437209, 4592959.223410569],
              [-8783530.281056846, 4593534.09756484],
              [-8788704.633627899, 4589246.509969522],
              [-8785589.802956013, 4583890.653997471],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ashley',
        GEOID: '05003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10256702.588591496, 3916953.6756767277],
              [-10255693.700046435, 3923048.2531061354],
              [-10238864.41942831, 3935461.8240787643],
              [-10240298.548428198, 3948280.282431195],
              [-10180987.857692014, 3947048.301942201],
              [-10181324.239793636, 3896099.9992911154],
              [-10184528.485416185, 3896124.5492480625],
              [-10227492.46552683, 3896329.771069766],
              [-10249085.748196114, 3896429.896159619],
              [-10249090.516446276, 3896429.918269442],
              [-10257378.18658112, 3908351.2175881406],
              [-10256702.588591496, 3916953.6756767277],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Miller',
        GEOID: '05091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10468911.685052494, 3968765.8004061896],
              [-10462503.16136167, 3966356.265444605],
              [-10460404.12104327, 3972685.317033033],
              [-10444649.630108753, 3976534.3528286708],
              [-10438727.655837532, 3961661.7122586886],
              [-10433181.830125703, 3959452.6210102034],
              [-10434345.118804492, 3951302.9228499136],
              [-10426797.768648198, 3938791.4120954284],
              [-10430547.120417608, 3936901.708784989],
              [-10430918.03696093, 3927979.960207151],
              [-10436221.965419266, 3919745.6470364244],
              [-10447342.671230024, 3914611.7442550366],
              [-10448492.93552839, 3907601.7903431216],
              [-10442314.567381844, 3897878.7709986735],
              [-10443388.270454017, 3897877.817687168],
              [-10468814.865170158, 3897855.24213388],
              [-10468787.591894912, 3916599.2908970546],
              [-10468812.844407033, 3931362.40460824],
              [-10468826.331077708, 3939254.659487582],
              [-10468817.536837937, 3953296.2221395494],
              [-10468866.517413884, 3968727.2326910845],
              [-10468911.685052494, 3968765.8004061896],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Walla Walla',
        GEOID: '53071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13249626.17291546, 5815136.732609374],
              [-13231516.27287525, 5820898.019311323],
              [-13221070.60845666, 5828219.675905192],
              [-13218766.406316731, 5838149.636434161],
              [-13206257.101177821, 5846946.595661571],
              [-13204227.301582694, 5861574.5466098655],
              [-13188203.306160966, 5876582.962159745],
              [-13161151.4453838, 5875951.152603485],
              [-13162624.981483432, 5827760.172475853],
              [-13148625.998918723, 5827823.167498188],
              [-13148682.437900558, 5813752.292172114],
              [-13134751.582864212, 5813696.3142495435],
              [-13135362.663372366, 5780379.774857058],
              [-13176642.10912514, 5780448.896752617],
              [-13203247.373269482, 5780487.557719666],
              [-13211160.056830317, 5780499.055927769],
              [-13245586.611233555, 5780325.9839351615],
              [-13245597.580607753, 5780317.204391287],
              [-13240487.510638278, 5784761.699472381],
              [-13244199.013780816, 5802736.138886888],
              [-13251638.940628493, 5811278.181350669],
              [-13249626.17291546, 5815136.732609374],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calloway',
        GEOID: '21035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9850182.732527895, 4404362.633661937],
              [-9808452.840292182, 4403921.116227273],
              [-9805034.775327375, 4398308.436312648],
              [-9803966.776132705, 4394335.053646599],
              [-9802319.915585909, 4387724.170587055],
              [-9799878.011235867, 4376806.9813893335],
              [-9801733.039230447, 4369647.850184169],
              [-9802054.17378386, 4369639.991437734],
              [-9810294.84390634, 4369438.3292263765],
              [-9850558.963320462, 4369818.283765223],
              [-9850182.732527895, 4404362.633661937],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Suffolk',
        GEOID: '51800',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8563912.62176992, 4377892.9052338675],
              [-8560200.784668908, 4389607.403947003],
              [-8537206.741970139, 4410743.060352024],
              [-8519672.475016817, 4427343.8843384925],
              [-8509851.980858527, 4431010.234143564],
              [-8504760.895266585, 4429486.055279829],
              [-8507076.451994577, 4420493.759289769],
              [-8511061.689764977, 4413622.320414779],
              [-8512241.676367387, 4403795.944221131],
              [-8514992.890324134, 4376668.407058502],
              [-8520612.664487889, 4376675.548887093],
              [-8542471.708606698, 4376703.328259758],
              [-8562220.098229567, 4376025.00278539],
              [-8563912.62176992, 4377892.9052338675],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '51620',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8568081.98197809, 4397453.272660759],
              [-8566306.213460956, 4398577.954111301],
              [-8563210.529741485, 4398445.902036327],
              [-8563378.956131054, 4397176.563652869],
              [-8561829.277499722, 4397151.71156423],
              [-8563270.419627532, 4395093.631857448],
              [-8561806.34568462, 4393585.412003757],
              [-8562443.87240839, 4392149.150673023],
              [-8561545.52411769, 4390179.722924059],
              [-8564354.671467857, 4391699.673446115],
              [-8567408.387739299, 4392863.440674572],
              [-8565749.616006987, 4394024.4199707415],
              [-8567648.949158903, 4394439.433031662],
              [-8568081.98197809, 4397453.272660759],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Botetourt',
        GEOID: '51023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8913810.152799992, 4498158.26002046],
              [-8902116.26293114, 4515264.362408823],
              [-8907847.324275648, 4529740.2144412575],
              [-8896382.084640888, 4537392.133663428],
              [-8885156.738508785, 4551347.999854955],
              [-8869287.143220786, 4546012.645171129],
              [-8870332.655878317, 4531753.8442144925],
              [-8849754.691407727, 4513634.320159371],
              [-8859754.187307214, 4501961.333462582],
              [-8862944.047315896, 4503142.197173332],
              [-8863939.577522058, 4502758.938268142],
              [-8864839.26164665, 4503002.522712078],
              [-8867576.830564238, 4506928.280089645],
              [-8871056.900485419, 4505716.831662867],
              [-8874286.946830276, 4501871.73291476],
              [-8882236.716945786, 4496241.053325449],
              [-8884876.436030967, 4495521.297712855],
              [-8882425.403482681, 4492322.23342042],
              [-8880914.909312107, 4492456.862553854],
              [-8881976.34065682, 4488161.488676415],
              [-8888580.369448133, 4482314.634139649],
              [-8890542.152834382, 4484983.282804219],
              [-8899505.264274584, 4489825.392827747],
              [-8912530.31261434, 4496175.88650437],
              [-8913810.152799992, 4498158.26002046],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marathon',
        GEOID: '55073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10053824.041135153, 5626848.743029106],
              [-10040741.551938144, 5626818.971313155],
              [-10040769.270491352, 5640528.14264119],
              [-10023617.163349925, 5640466.615686345],
              [-9954853.555414049, 5640290.556262189],
              [-9932394.06891007, 5640206.787261335],
              [-9932349.541113753, 5626126.846010439],
              [-9932341.860068887, 5571497.637739626],
              [-10001491.969276799, 5572058.144460751],
              [-10014748.116879443, 5572039.982247469],
              [-10053959.294316465, 5572090.867850611],
              [-10053824.041135153, 5626848.743029106],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Park',
        GEOID: '56029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12362796.221245613, 5600553.887443885],
              [-12361396.995963333, 5621660.025766315],
              [-12361392.148508238, 5621733.231400162],
              [-12332530.67808874, 5621986.230147966],
              [-12323654.507170845, 5620313.138028544],
              [-12281260.594172554, 5621388.616644294],
              [-12244592.955780666, 5622021.181372956],
              [-12222711.303420976, 5621981.24068036],
              [-12197757.617738703, 5621935.692805386],
              [-12145339.941191928, 5622450.998051545],
              [-12140755.47060259, 5621462.135453146],
              [-12091689.34503822, 5621470.537576799],
              [-12088439.094792439, 5601305.629058519],
              [-12086337.828084225, 5546395.829258659],
              [-12086379.127615308, 5492008.103295809],
              [-12083793.287163671, 5491548.097903086],
              [-12083815.105783867, 5477738.21406795],
              [-12110700.877880767, 5477771.220571917],
              [-12110645.440774355, 5464057.718845297],
              [-12124471.989447823, 5464026.927831423],
              [-12124115.544438303, 5450714.456871874],
              [-12144163.628132718, 5450671.195717057],
              [-12144244.334763542, 5437261.546496413],
              [-12168661.819791084, 5436594.160396787],
              [-12183067.897733623, 5454682.98829237],
              [-12194196.618547717, 5459463.262955642],
              [-12205270.236213868, 5453500.749331472],
              [-12207951.366149625, 5441598.883023238],
              [-12221755.762244426, 5435045.288953016],
              [-12227717.47757386, 5437607.909010182],
              [-12224725.209661337, 5446973.119114925],
              [-12229420.554463508, 5458943.029702298],
              [-12244038.918674987, 5457563.409820603],
              [-12251063.846460989, 5466683.690233768],
              [-12251083.66133035, 5485989.664330317],
              [-12258412.491326215, 5485982.839958239],
              [-12257532.06547353, 5496347.942474733],
              [-12261964.362318957, 5510813.775797542],
              [-12270035.470679432, 5517512.030450175],
              [-12270570.249513203, 5523478.851008232],
              [-12278166.691564936, 5532437.655667824],
              [-12275924.494381377, 5545592.423699487],
              [-12278116.931752551, 5550619.324884265],
              [-12286925.977017496, 5556113.038486272],
              [-12319494.16384143, 5556078.0282051135],
              [-12319490.601617724, 5569137.939850659],
              [-12362623.089061012, 5569133.449263772],
              [-12362642.934306791, 5578385.505164771],
              [-12362796.221245613, 5600553.887443885],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dorado',
        GEOID: '72051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7382154.734090769, 2093191.7379624434],
              [-7375808.490773082, 2093445.8193607442],
              [-7368891.900392289, 2092712.0095625804],
              [-7375800.253130764, 2090877.4640768978],
              [-7375200.575033861, 2083739.450571215],
              [-7380890.002888814, 2082553.4483427326],
              [-7380474.001951719, 2087227.0054361918],
              [-7382154.734090769, 2093191.7379624434],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nacogdoches',
        GEOID: '48347',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10568397.719410114, 3743054.351251345],
              [-10514394.853314444, 3742887.4007104426],
              [-10512201.748026326, 3739995.4860232626],
              [-10508458.741467893, 3717925.119877793],
              [-10498657.171623036, 3709513.514862338],
              [-10497497.22252897, 3701310.1382639254],
              [-10500900.03672354, 3679977.4465810726],
              [-10501855.491913017, 3664063.8558064355],
              [-10500150.967869991, 3662676.663698027],
              [-10500390.861372652, 3661972.2565293526],
              [-10508116.545353197, 3672078.393953208],
              [-10514061.56275901, 3674551.5628176373],
              [-10519232.57574534, 3685553.5069231554],
              [-10523182.85919563, 3684616.031736305],
              [-10524714.726708435, 3688961.654301116],
              [-10545148.309799468, 3692272.094058885],
              [-10560418.894907506, 3701369.9511732315],
              [-10566915.723029183, 3708237.4574542777],
              [-10572916.845458359, 3736207.731917293],
              [-10568397.719410114, 3743054.351251345],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Saline',
        GEOID: '17165',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9874791.353121128, 4560138.003497757],
              [-9874775.991031397, 4566267.708714144],
              [-9837807.678694878, 4566392.00740305],
              [-9837902.188942563, 4523015.415334429],
              [-9841991.28779787, 4523059.954805519],
              [-9874990.169731686, 4522970.73555094],
              [-9874791.353121128, 4560138.003497757],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cortland',
        GEOID: '36023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8490857.75878345, 5277219.3875385085],
              [-8448712.867486063, 5280208.367441725],
              [-8448017.454627078, 5270032.105673769],
              [-8445144.075930722, 5223454.426672382],
              [-8462660.643085007, 5222445.131453204],
              [-8474772.98291975, 5222645.504321302],
              [-8488485.095156685, 5222228.027945597],
              [-8489845.975931631, 5254852.478584764],
              [-8490857.75878345, 5277219.3875385085],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wilkin',
        GEOID: '27167',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10774144.43387352, 5881822.066721337],
              [-10717949.332718885, 5882012.404515035],
              [-10717840.57357638, 5825691.092383417],
              [-10716211.52414811, 5797771.1641584085],
              [-10716297.685433984, 5783812.914431646],
              [-10750423.509586522, 5783858.070218685],
              [-10748398.553035568, 5793816.9815087775],
              [-10752980.797235092, 5815650.604077171],
              [-10753578.58290065, 5831706.688331561],
              [-10758727.777266786, 5837986.239077118],
              [-10765607.210478319, 5850381.908845511],
              [-10769541.352602443, 5871513.242885373],
              [-10774144.43387352, 5881822.066721337],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Putnam',
        GEOID: '36079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8235569.995061636, 5060352.417491841],
              [-8231775.1136204945, 5070744.947719811],
              [-8235581.349649697, 5077297.198737168],
              [-8230270.185424459, 5084631.68021742],
              [-8201272.571267719, 5088558.9502088325],
              [-8190863.976239567, 5090307.429369799],
              [-8185286.281349535, 5090411.518672469],
              [-8186097.943560745, 5077622.255259841],
              [-8186785.713920962, 5068075.10130089],
              [-8186789.706030574, 5068019.7131642485],
              [-8186803.439816206, 5067829.167519144],
              [-8186897.460893641, 5066524.798884355],
              [-8213152.809964159, 5062991.165937441],
              [-8235703.578450589, 5059907.730610554],
              [-8235569.995061636, 5060352.417491841],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jones',
        GEOID: '19105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10170511.91437193, 5205489.424810275],
              [-10144553.990230793, 5205386.48454684],
              [-10118721.300516797, 5205307.474138142],
              [-10118760.596297046, 5166006.097198429],
              [-10118772.952760523, 5152930.603760593],
              [-10170802.903520865, 5153104.969484596],
              [-10170511.91437193, 5205489.424810275],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Erie',
        GEOID: '42049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8963381.38996718, 5157613.092878222],
              [-8942292.023755886, 5166398.775671755],
              [-8922711.815881275, 5178185.016617161],
              [-8920722.42526131, 5183465.807473931],
              [-8915412.374230979, 5186956.973072528],
              [-8907821.609473277, 5185444.833189344],
              [-8897090.521880297, 5192119.707475436],
              [-8888267.00508155, 5196319.635921375],
              [-8879059.769998036, 5201489.272208658],
              [-8879078.805630963, 5180659.77821218],
              [-8878988.748162912, 5160800.889903024],
              [-8862237.700098446, 5160757.735441714],
              [-8862375.316037431, 5138544.9560808055],
              [-8963378.242596766, 5138471.279299565],
              [-8963381.38996718, 5157613.092878222],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lawrence',
        GEOID: '29109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10470623.472937074, 4445817.195142795],
              [-10469855.591089584, 4479617.418193607],
              [-10422381.279170468, 4478488.722157519],
              [-10420073.514806831, 4478242.767266423],
              [-10420494.970398976, 4452796.894593121],
              [-10420631.559414178, 4438522.771376346],
              [-10420729.186607605, 4428355.875353488],
              [-10471016.319420084, 4429601.363790989],
              [-10470623.472937074, 4445817.195142795],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Atchison',
        GEOID: '29005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10660582.836889405, 4951351.118478886],
              [-10634705.174101127, 4950917.394426508],
              [-10616976.771900179, 4950636.470198723],
              [-10612709.110637324, 4950568.846048424],
              [-10597867.773578208, 4950349.672773114],
              [-10595133.989430878, 4935781.169837753],
              [-10595457.483871125, 4904045.88135343],
              [-10636374.966594394, 4904441.024771265],
              [-10636943.809060981, 4908343.2129397085],
              [-10641993.817760816, 4911065.5427165795],
              [-10648124.404757785, 4912930.343962753],
              [-10646710.424585728, 4919330.1142093055],
              [-10647644.506432975, 4923677.675143519],
              [-10651534.566038745, 4933507.6115647685],
              [-10652688.169921836, 4937932.5864183],
              [-10654642.31365193, 4942347.316554126],
              [-10654866.135759206, 4942853.094013989],
              [-10659632.725035483, 4942674.714382615],
              [-10660582.836889405, 4951351.118478886],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '42065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8817697.23840755, 5017124.930715427],
              [-8818197.285560196, 5019795.4724806985],
              [-8817763.807463046, 5023962.299368423],
              [-8817491.96526653, 5061415.005585883],
              [-8806122.349074358, 5060560.982691711],
              [-8804825.81096509, 5062719.237303603],
              [-8791112.140255284, 5068044.590252202],
              [-8764771.277065817, 5051199.254450495],
              [-8761984.727572279, 5042161.568382674],
              [-8768232.979271015, 5042294.727727768],
              [-8772480.37444223, 5031858.663357964],
              [-8772551.062318886, 4998483.6107491935],
              [-8818207.972231312, 4999274.000241705],
              [-8817697.23840755, 5017124.930715427],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pulaski',
        GEOID: '13235',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9308043.67666474, 3801247.9724023095],
              [-9297788.81385337, 3816233.7954623476],
              [-9294959.183716897, 3816158.2472299095],
              [-9278093.056347316, 3799132.4313810924],
              [-9281143.544353526, 3796137.8440188183],
              [-9271923.507528573, 3786807.1451331414],
              [-9277067.247239657, 3777217.718098626],
              [-9279716.651120538, 3779610.6755406386],
              [-9307260.878005482, 3778863.1782993125],
              [-9307001.05831397, 3799552.2970321076],
              [-9308043.67666474, 3801247.9724023095],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cass',
        GEOID: '31025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10738307.886473121, 5014712.126678482],
              [-10725574.049921278, 5014585.54183247],
              [-10722203.295740059, 5018981.1259155655],
              [-10711043.29414905, 5011502.131395418],
              [-10692933.50542833, 5021986.443575081],
              [-10687248.97563097, 5021287.806560059],
              [-10684308.693920648, 5020215.735673652],
              [-10671619.024944747, 5020139.491260282],
              [-10671740.723410087, 5014908.941356983],
              [-10667560.78785029, 5008268.27847029],
              [-10668612.200440833, 5001243.0354129905],
              [-10666491.929109953, 4997300.660155722],
              [-10665599.33842251, 4995641.478256948],
              [-10669005.714840788, 4989594.893154441],
              [-10668219.222235074, 4980502.029730483],
              [-10738297.088482514, 4980527.848125025],
              [-10738307.886473121, 5014712.126678482],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Burke',
        GEOID: '38013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11459092.240685059, 6274751.145793494],
              [-11449260.278456496, 6274764.84716299],
              [-11378743.611179609, 6274615.871947969],
              [-11356942.404097514, 6274650.418593211],
              [-11356998.684487032, 6242194.811074998],
              [-11371526.879910972, 6242210.361428792],
              [-11371569.292636964, 6227533.718954564],
              [-11380592.293963214, 6227533.044020559],
              [-11380624.799254524, 6198232.275058999],
              [-11453190.747037426, 6198240.850853519],
              [-11453192.082871316, 6212867.252601584],
              [-11453182.175436635, 6227566.453318332],
              [-11459220.812534207, 6227563.247369911],
              [-11459092.240685059, 6274751.145793494],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carroll',
        GEOID: '17015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10053897.346608536, 5190076.098604367],
              [-10009809.65030938, 5190508.47441118],
              [-10007411.04924126, 5190425.831327254],
              [-9984076.591539646, 5190852.277360198],
              [-9983729.27472837, 5150550.418642075],
              [-10033025.775392283, 5150346.473143483],
              [-10036359.686574573, 5150476.086119436],
              [-10036220.422139067, 5151723.751023758],
              [-10034407.138953535, 5160380.1324940175],
              [-10036529.940542221, 5165937.044052274],
              [-10036948.896886818, 5167034.139747244],
              [-10036694.309211375, 5176926.795750564],
              [-10041844.171494452, 5183341.484537914],
              [-10048708.019977277, 5187154.644423542],
              [-10053897.346608536, 5190076.098604367],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Randolph',
        GEOID: '01111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9533526.871241054, 3937922.789793129],
              [-9533788.80600289, 3961310.8990553804],
              [-9500867.40243467, 3962044.174859623],
              [-9496102.909663398, 3959558.505847626],
              [-9494923.260483768, 3952251.66415225],
              [-9488494.393680159, 3912511.417002534],
              [-9488031.931187732, 3909657.913825063],
              [-9528188.879018534, 3909560.2354510087],
              [-9534921.147863239, 3909466.411822965],
              [-9533526.871241054, 3937922.789793129],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Los Angeles',
        GEOID: '06037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13201820.24023327, 3957482.147474884],
              [-13189665.932950499, 3960189.3827700997],
              [-13176924.081395319, 3949756.564907011],
              [-13167566.342360254, 3942048.258659001],
              [-13171905.910069847, 3935068.783880871],
              [-13177418.896531897, 3937864.706325342],
              [-13187504.442397764, 3938662.8465680643],
              [-13189423.70173853, 3944507.422424677],
              [-13198421.990137825, 3953103.7332081217],
              [-13201820.24023327, 3957482.147474884],
            ],
          ],
          [
            [
              [-13201827.364680681, 3900076.830150826],
              [-13195820.119679514, 3892773.4114307603],
              [-13185434.233827481, 3881431.460655987],
              [-13175051.798879666, 3871696.1701862044],
              [-13183081.273750585, 3868866.096516611],
              [-13190013.583720246, 3874694.0064485287],
              [-13200433.64465595, 3886238.0721458597],
              [-13207120.049870448, 3897577.7724201116],
              [-13201827.364680681, 3900076.830150826],
            ],
          ],
          [
            [
              [-13240429.401864083, 4038872.7100508832],
              [-13231042.05184447, 4045836.1958348327],
              [-13223518.635378696, 4051411.482935935],
              [-13216225.538939375, 4051363.9895046945],
              [-13212937.16118134, 4051457.631134453],
              [-13210055.099564705, 4055576.608762409],
              [-13210028.828164877, 4060628.431088443],
              [-13206216.469563678, 4065049.915784519],
              [-13208311.947658371, 4072308.7716605933],
              [-13217922.493257027, 4095999.7781753736],
              [-13233812.905289803, 4135464.737430898],
              [-13235290.114932628, 4139171.6979463366],
              [-13172021.3483818, 4139409.534199994],
              [-13110582.674259612, 4139894.3073526877],
              [-13098663.028463434, 4139789.214883074],
              [-13097320.849362938, 4082264.7648376636],
              [-13096334.447355019, 4067696.8983824532],
              [-13099788.802473824, 4051127.4671021234],
              [-13101585.49905523, 4045145.276161766],
              [-13102781.626983803, 4041572.742801497],
              [-13103536.039172908, 4039486.7741299598],
              [-13107240.195229053, 4031467.976295822],
              [-13109846.184508525, 4031411.1645915397],
              [-13113718.65563475, 4025519.5950347083],
              [-13111575.532797998, 4021608.60050499],
              [-13126763.74148285, 4021777.279799014],
              [-13131991.97268745, 4021561.231191036],
              [-13133094.258285284, 4015759.237535622],
              [-13138896.341464922, 4010855.7043399992],
              [-13142229.358338762, 4008159.3079096545],
              [-13142742.87514979, 4005208.2757977024],
              [-13146063.646879643, 4000123.4819992473],
              [-13148510.195799666, 3994452.731034419],
              [-13150471.787395569, 3995713.0387139353],
              [-13156149.304065006, 3993423.9188187704],
              [-13161517.818519292, 3990636.928924938],
              [-13164496.818721121, 3989090.7138365246],
              [-13171011.012683362, 3990305.3774728174],
              [-13172802.24269597, 3991425.122194689],
              [-13175185.493588109, 3992915.123872132],
              [-13179849.891571838, 3993397.0127598895],
              [-13183389.962698555, 3998591.720401657],
              [-13179593.968062503, 4002556.479741963],
              [-13181642.358012592, 4013225.009163793],
              [-13186974.895580063, 4024655.1418549786],
              [-13193531.947546257, 4032496.4111109967],
              [-13202889.24130336, 4034046.4243994453],
              [-13211326.590788545, 4033268.2346900473],
              [-13218627.590911712, 4033113.4896787917],
              [-13225324.794116817, 4028968.3947762707],
              [-13230839.450371226, 4033397.190471222],
              [-13240838.891886577, 4035079.653556933],
              [-13240429.401864083, 4038872.7100508832],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mendocino',
        GEOID: '06045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13806422.68555996, 4866131.098089983],
              [-13752906.154890973, 4866221.728557528],
              [-13752917.843437506, 4862602.723897265],
              [-13684951.728333674, 4862764.844740575],
              [-13682254.902349714, 4856702.222731506],
              [-13686739.964633774, 4852541.15856392],
              [-13685357.042599652, 4836654.065882961],
              [-13680350.11454275, 4823729.865043964],
              [-13679534.810592182, 4805111.019646199],
              [-13680086.732627533, 4797734.078119848],
              [-13699330.64432046, 4794058.030847342],
              [-13700659.019804094, 4780238.050120125],
              [-13691722.847680666, 4755522.224358704],
              [-13700959.359790256, 4746596.303708802],
              [-13698544.060798515, 4728666.316517347],
              [-13698554.858789122, 4724693.84421717],
              [-13690810.139175652, 4721282.393115061],
              [-13686605.045410935, 4707389.005001003],
              [-13672437.079859203, 4700228.089967145],
              [-13701313.912368432, 4700556.569461268],
              [-13707464.982151704, 4694368.700787437],
              [-13733289.211584402, 4689788.31233607],
              [-13752512.530466622, 4688444.7535504345],
              [-13755970.669153024, 4692804.967001336],
              [-13763390.113214392, 4699331.186299425],
              [-13765751.088294627, 4703428.858625186],
              [-13771394.3185609, 4709250.124846508],
              [-13773882.531819113, 4715226.898056612],
              [-13769190.192643197, 4724722.071234183],
              [-13772614.93677745, 4739639.522298607],
              [-13777555.9636958, 4749449.360814488],
              [-13781240.638841059, 4760615.72023832],
              [-13784172.794228554, 4773487.656444684],
              [-13782988.243527021, 4785837.653130422],
              [-13777620.974278422, 4801168.053256448],
              [-13779385.054249026, 4811089.153282919],
              [-13780535.763825357, 4820145.365580586],
              [-13784641.894562755, 4825780.940736979],
              [-13787109.736354154, 4841564.869577411],
              [-13793338.061864035, 4846057.799912638],
              [-13798602.137944667, 4854668.139267305],
              [-13806422.68555996, 4866131.098089983],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Baker',
        GEOID: '12003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9179358.567946697, 3578874.793853892],
              [-9174839.343066614, 3578441.962461568],
              [-9152533.464972276, 3576305.8228576174],
              [-9153737.941862661, 3570672.8401570646],
              [-9150569.566515703, 3564679.9474128424],
              [-9151610.737713093, 3558242.839826032],
              [-9148240.540129326, 3551019.764669109],
              [-9144150.995996054, 3550344.7365948404],
              [-9138741.202701973, 3550007.7521486217],
              [-9133873.644608272, 3550988.512335565],
              [-9133679.171497129, 3538745.620744483],
              [-9133698.652408019, 3527601.0396377877],
              [-9133700.21088089, 3521961.9422411923],
              [-9144069.955406757, 3521959.4964332865],
              [-9179223.092126401, 3521101.1756676137],
              [-9179221.75629251, 3524724.589939326],
              [-9179382.104829283, 3578876.413872758],
              [-9179358.567946697, 3578874.793853892],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Suffolk',
        GEOID: '36103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8017110.16979845, 5052857.87962885],
              [-8006854.97302861, 5055229.234740635],
              [-8005795.100156768, 5049484.20432009],
              [-8018872.134698725, 5047039.206634422],
              [-8017110.16979845, 5052857.87962885],
            ],
          ],
          [
            [
              [-8180353.412557848, 5004438.445682647],
              [-8174932.042036723, 5002743.723486384],
              [-8170056.025700998, 5005750.215890734],
              [-8163209.65437823, 5001962.776917809],
              [-8152575.014735519, 4998588.152875291],
              [-8151846.717355506, 4998357.089575593],
              [-8142908.764120225, 5001859.785055539],
              [-8142427.752600505, 5005830.549138173],
              [-8138608.937468843, 5008203.405966291],
              [-8130825.144714103, 5007106.536397763],
              [-8110719.286203968, 5007340.937648757],
              [-8093825.217642198, 5009075.240120765],
              [-8080161.640703251, 5011985.753413135],
              [-8071142.3129202, 5018734.78366302],
              [-8064567.4498354755, 5025052.064137873],
              [-8058396.676502332, 5028329.627793107],
              [-8054424.129153884, 5033006.519487637],
              [-8047409.442761035, 5035360.300885793],
              [-8036060.865952625, 5040932.150266101],
              [-8035267.157983268, 5038683.20723232],
              [-8043356.856698708, 5028706.083760728],
              [-8046517.105722837, 5022358.224001514],
              [-8039212.654695454, 5018333.623731075],
              [-8033137.05952694, 5020189.902321954],
              [-8029107.961877168, 5029339.502420003],
              [-8024377.217476925, 5027327.983297109],
              [-8025657.836899011, 5020312.869690995],
              [-8020783.93563361, 5015366.764832881],
              [-8010505.473090194, 5022854.7901210915],
              [-8006029.316365396, 5024225.166784436],
              [-7998997.152812495, 5022760.436174178],
              [-8007987.648847432, 5013246.912092764],
              [-8025842.404614747, 5006278.363870596],
              [-8048257.474641899, 4998066.936629161],
              [-8059069.157546215, 4992693.893814418],
              [-8099291.783876586, 4977648.31892027],
              [-8117775.049488919, 4970142.366732305],
              [-8127719.330920972, 4965204.472251568],
              [-8142584.475884154, 4960325.989138261],
              [-8149526.262569921, 4958048.647368501],
              [-8160430.674610065, 4956563.1710283095],
              [-8165447.732740628, 4957992.321881814],
              [-8173519.689083694, 4955461.658234892],
              [-8173440.917457547, 4963918.981852553],
              [-8174858.793811782, 4973987.4021179695],
              [-8175136.424621822, 4975729.006313059],
              [-8177781.264403578, 4992701.253936036],
              [-8181687.692274354, 5001017.660926814],
              [-8180353.412557848, 5004438.445682647],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Charles',
        GEOID: '29183',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10125457.91082164, 4703190.935745172],
              [-10109794.25659161, 4703920.307112721],
              [-10097519.056341836, 4707736.884037755],
              [-10092401.24370568, 4712322.69287067],
              [-10091919.351996463, 4710257.360387206],
              [-10085028.67551636, 4703789.328119835],
              [-10080613.633192006, 4703179.497285497],
              [-10074426.94117168, 4708846.400242637],
              [-10070827.648075862, 4716202.514997375],
              [-10068955.91557778, 4716143.24567765],
              [-10062816.206962451, 4715948.831249918],
              [-10052006.52780897, 4710704.49625666],
              [-10049543.33049222, 4710124.077245801],
              [-10044395.05762598, 4708911.063770049],
              [-10041828.731613059, 4707176.210012006],
              [-10031369.675327752, 4700108.879407068],
              [-10031857.254697425, 4693884.713293136],
              [-10040536.946714068, 4696100.987513523],
              [-10054400.119500007, 4706091.429753622],
              [-10061308.050501185, 4696198.290055978],
              [-10067803.43146948, 4697013.896269709],
              [-10072443.450484727, 4687972.438079777],
              [-10073539.947469039, 4686180.154382381],
              [-10078726.767823061, 4676952.206569772],
              [-10092281.696938993, 4677156.858131694],
              [-10100276.551448278, 4670135.590028786],
              [-10101399.097193437, 4669460.220931755],
              [-10104873.378501093, 4663769.169954818],
              [-10120784.495959159, 4655242.369992248],
              [-10126117.478804592, 4657066.950648583],
              [-10125457.91082164, 4703190.935745172],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Curry',
        GEOID: '41015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13865114.309179248, 5287736.069873239],
              [-13857154.631629057, 5304591.80314424],
              [-13857037.103508735, 5305021.838541753],
              [-13832380.478953015, 5305116.68108839],
              [-13828065.178892413, 5301898.217240783],
              [-13819365.7833259, 5289257.094359598],
              [-13821424.19203016, 5272472.524424726],
              [-13818413.222443182, 5261376.554146889],
              [-13803203.974374572, 5264246.466534428],
              [-13795347.712631324, 5277713.314287379],
              [-13782639.034284404, 5279885.7174720615],
              [-13779494.369988983, 5281492.099282575],
              [-13772056.892170105, 5279161.274437759],
              [-13784833.25276743, 5256172.547061994],
              [-13791444.851284115, 5236255.015420558],
              [-13804551.608130112, 5235622.998434082],
              [-13808290.384547897, 5219226.479638964],
              [-13791194.827707792, 5213797.862768737],
              [-13780484.668179082, 5196640.94534676],
              [-13787870.605073722, 5181240.702853495],
              [-13783817.462413939, 5174098.844638377],
              [-13783806.17446039, 5160323.486236625],
              [-13803749.105920987, 5160402.151022157],
              [-13827172.619215233, 5160748.762309728],
              [-13833724.773123836, 5167805.5068136165],
              [-13838603.349807851, 5171150.569140079],
              [-13842749.555561936, 5180442.128249514],
              [-13843804.196417712, 5188093.789738816],
              [-13846322.68857742, 5195067.880872311],
              [-13849367.165331125, 5198584.37007949],
              [-13849319.743228046, 5207142.943139913],
              [-13850989.312950963, 5213835.068535409],
              [-13852052.52540753, 5227143.477319089],
              [-13848040.570959343, 5242204.329705932],
              [-13848246.845975779, 5250909.261183396],
              [-13849605.055082947, 5260050.003789122],
              [-13853793.005646082, 5262754.469204609],
              [-13853534.521788461, 5264891.310353672],
              [-13860391.691101836, 5271684.24065665],
              [-13865114.309179248, 5287736.069873239],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '47103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9665682.253765086, 4199771.779612587],
              [-9656620.624575533, 4198299.576855115],
              [-9640558.780526934, 4208410.183896453],
              [-9640209.793923296, 4213587.656576974],
              [-9631953.004652178, 4212190.99933373],
              [-9632172.749327004, 4206298.649816815],
              [-9617134.821954722, 4195914.667448872],
              [-9613925.592354642, 4180613.02418067],
              [-9608894.507968241, 4181151.452624365],
              [-9608960.494317977, 4162668.824864519],
              [-9625551.243375638, 4162616.295977038],
              [-9660709.280064123, 4162783.8273579357],
              [-9660711.504542695, 4162783.8379578656],
              [-9666571.175070409, 4162903.1440913873],
              [-9665682.253765086, 4199771.779612587],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hartley',
        GEOID: '48205',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11470511.360920837, 4264826.803492865],
              [-11470452.058599323, 4308223.73615349],
              [-11372734.80770557, 4308226.214663013],
              [-11372711.875890465, 4249488.31472299],
              [-11470533.321827602, 4248799.7292644],
              [-11470511.360920837, 4264826.803492865],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hidalgo',
        GEOID: '48215',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10975355.975927189, 3029200.8955300483],
              [-10964072.942000125, 3054346.317331264],
              [-10945006.918853488, 3096396.628014584],
              [-10907695.297207361, 3096126.785988783],
              [-10907674.035184622, 3075553.6131722885],
              [-10904568.44403047, 3075050.58478703],
              [-10909776.415087743, 3054771.7788082557],
              [-10893939.102452075, 3052881.4190923376],
              [-10893934.093074989, 3042265.8456690256],
              [-10893934.093074989, 3013987.6388646155],
              [-10893979.351472957, 3006234.8951113797],
              [-10894970.700173255, 3006276.551956597],
              [-10903114.61148071, 3006467.135420526],
              [-10910531.383874303, 3006992.8018682613],
              [-10913678.163240047, 3004193.927669628],
              [-10919444.401543647, 3006411.1249361825],
              [-10925948.242793245, 3005995.2662392473],
              [-10931245.15812366, 3006037.3967926865],
              [-10932125.467713421, 3006358.254211267],
              [-10937007.054967122, 3008137.635927476],
              [-10943037.565741863, 3012717.503929631],
              [-10943618.777832787, 3013087.257425504],
              [-10952356.676913623, 3018647.2418006747],
              [-10958572.9799185, 3023767.6285578357],
              [-10965358.570799297, 3025709.009646163],
              [-10973451.052502004, 3028243.3594865035],
              [-10975355.975927189, 3029200.8955300483],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grand',
        GEOID: '49019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12260778.921061499, 4710837.13842855],
              [-12261881.206659334, 4718777.506396951],
              [-12252837.72254678, 4718661.514629968],
              [-12245587.484111413, 4714499.290627203],
              [-12249727.678612998, 4720742.837767546],
              [-12255868.061725153, 4719703.196888821],
              [-12262534.5407508, 4726350.057822132],
              [-12256210.369159343, 4741210.781438852],
              [-12256138.23412931, 4748853.578867939],
              [-12251218.691872682, 4754424.105387268],
              [-12253745.64431369, 4761264.829548145],
              [-12246325.866293844, 4781482.792997698],
              [-12247828.790739045, 4789114.988363551],
              [-12247811.53621797, 4789114.844160903],
              [-12239950.821695097, 4788038.140755459],
              [-12145732.565035958, 4788063.806105635],
              [-12139509.231790349, 4793221.250607766],
              [-12139526.707252115, 4774331.916909256],
              [-12139558.786076562, 4739749.727778675],
              [-12140499.435773766, 4650299.987597422],
              [-12247971.724965224, 4650299.134147595],
              [-12244507.573731227, 4654159.872755908],
              [-12251589.051818551, 4662220.087573303],
              [-12249189.782833483, 4671989.771201782],
              [-12252990.78684662, 4672554.9721598765],
              [-12257716.410550283, 4683305.450095295],
              [-12254479.351077506, 4686202.850388902],
              [-12265098.22862377, 4708394.339296074],
              [-12260778.921061499, 4710837.13842855],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stafford',
        GEOID: '51179',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8642165.659698468, 4645550.501904275],
              [-8630747.953486275, 4658348.763619102],
              [-8625571.819803368, 4663423.50072808],
              [-8606399.74081002, 4650576.053982089],
              [-8607514.907840772, 4645627.56144834],
              [-8606921.12967688, 4633754.850170425],
              [-8603254.098647783, 4629220.090108895],
              [-8608365.611389415, 4626698.403908337],
              [-8607967.978168301, 4614113.421165739],
              [-8612822.064564342, 4614317.531024408],
              [-8615110.014058616, 4614177.630289522],
              [-8621374.629722498, 4619710.614671072],
              [-8623659.35095154, 4624578.554856862],
              [-8630631.624618394, 4623194.4109941125],
              [-8638807.373300215, 4626640.786597265],
              [-8640477.165662114, 4631519.6757392865],
              [-8642281.988566346, 4637539.0423324965],
              [-8642165.659698468, 4645550.501904275],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coffee',
        GEOID: '01031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9595066.734780373, 3690033.720587243],
              [-9595159.463916205, 3701766.055855344],
              [-9589500.648921218, 3702775.116545924],
              [-9589717.165330812, 3713237.126242147],
              [-9550003.603031838, 3713266.2776122475],
              [-9550255.185081031, 3658275.138126615],
              [-9587436.228964457, 3656415.3495875956],
              [-9595013.858022245, 3657736.9000833365],
              [-9595304.95849067, 3686156.0956606464],
              [-9595066.734780373, 3690033.720587243],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clarke',
        GEOID: '01025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9809630.93446325, 3756782.723896429],
              [-9804296.05918647, 3762021.9310649326],
              [-9759131.404062334, 3762175.890044237],
              [-9759027.542977422, 3747011.5183270704],
              [-9753826.251089599, 3740639.165795252],
              [-9740558.971537875, 3740917.977680547],
              [-9742251.139117425, 3723710.364417437],
              [-9747896.15049555, 3723617.6019166093],
              [-9747737.186262697, 3704851.7508801753],
              [-9753796.417466067, 3700342.594193409],
              [-9748663.364426097, 3689383.4503528667],
              [-9758886.83514106, 3687828.1087149223],
              [-9772158.790111398, 3674986.1550647337],
              [-9769972.030034255, 3671425.6886996683],
              [-9774299.129960882, 3674249.246854978],
              [-9777849.887758715, 3662792.2679141085],
              [-9790169.393165823, 3657830.205137836],
              [-9791619.99745035, 3673882.959346979],
              [-9785881.366380466, 3674773.6134247286],
              [-9783568.370000765, 3683788.8229787783],
              [-9788891.222772533, 3690337.2092615278],
              [-9785667.076360691, 3696778.5306444135],
              [-9787703.889083734, 3698249.7541861385],
              [-9789715.877560332, 3701344.2237505317],
              [-9792817.572532305, 3701844.0245632147],
              [-9799596.929521617, 3705755.898801103],
              [-9799197.960466612, 3708859.9842720004],
              [-9801842.466289897, 3708762.369336072],
              [-9804156.241906036, 3710199.361129131],
              [-9806065.816451102, 3718598.7548176902],
              [-9804877.258247903, 3720020.5596838584],
              [-9805943.36501123, 3723903.8726776787],
              [-9816195.444835328, 3738991.450647817],
              [-9809630.93446325, 3756782.723896429],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Meigs',
        GEOID: '39105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9162336.481970515, 4751149.715969012],
              [-9158096.767844161, 4750900.613336766],
              [-9123843.649207583, 4748743.704890713],
              [-9100624.077310355, 4747636.521646024],
              [-9099583.903898494, 4736949.4749310305],
              [-9100398.077224452, 4736584.122319668],
              [-9106808.761489958, 4733707.849138964],
              [-9105188.951579425, 4727453.442994623],
              [-9103233.068126189, 4718912.68859975],
              [-9108979.380240938, 4713924.885499082],
              [-9116895.977148192, 4711592.816917779],
              [-9121722.678949498, 4720711.184363776],
              [-9128984.383292412, 4725909.253295453],
              [-9132825.017044272, 4724232.7663130015],
              [-9138112.915495934, 4718231.211086311],
              [-9139204.030244574, 4716069.413916283],
              [-9138825.360237012, 4722069.505056027],
              [-9164140.41431882, 4725636.411211194],
              [-9162336.481970515, 4751149.715969012],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Custer',
        GEOID: '16037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12833046.374468874, 5560475.843911883],
              [-12820442.89304075, 5566215.701886701],
              [-12818654.99069912, 5578894.573636773],
              [-12811974.151459161, 5584871.725394938],
              [-12796856.296692487, 5577702.248289669],
              [-12780858.683990076, 5591399.780640387],
              [-12781710.166775156, 5581940.650864701],
              [-12772446.047431847, 5569710.510153423],
              [-12764200.167470828, 5568490.906895413],
              [-12753537.318725703, 5554974.648283209],
              [-12740720.54915322, 5560603.756520258],
              [-12731926.643339023, 5575937.549948158],
              [-12735412.167915253, 5580611.26491775],
              [-12715083.002506584, 5602504.681061049],
              [-12711764.345847055, 5596043.336831312],
              [-12713269.60800156, 5581312.608461868],
              [-12699868.633741396, 5583181.81701555],
              [-12692709.565968988, 5567042.371453123],
              [-12669963.097817745, 5542205.036943774],
              [-12634971.708318222, 5530991.422728361],
              [-12629400.16780402, 5536116.623774163],
              [-12616908.451144654, 5514523.548058592],
              [-12614792.490263654, 5501596.035444063],
              [-12625469.810542582, 5501627.108326011],
              [-12630066.303636925, 5474658.904473804],
              [-12629639.838667698, 5445949.845536139],
              [-12619289.241094248, 5434026.270151156],
              [-12625048.911547892, 5437121.770925126],
              [-12633438.616291018, 5425108.840943346],
              [-12663835.516447028, 5407007.001151763],
              [-12667984.505188385, 5399017.747465302],
              [-12669644.724074077, 5403757.560996763],
              [-12687579.963833235, 5420393.791841174],
              [-12693730.143060582, 5430436.002045329],
              [-12698216.429859042, 5424477.152624519],
              [-12721115.517032161, 5439347.478338381],
              [-12722981.120378368, 5447981.369546579],
              [-12730418.264238775, 5445991.385818413],
              [-12746947.538829215, 5449839.385081447],
              [-12753022.466080785, 5441389.276047964],
              [-12766249.22533786, 5454261.173211411],
              [-12781012.638845846, 5454271.52901134],
              [-12781021.878363581, 5464349.851791693],
              [-12787645.27674629, 5464351.089662935],
              [-12798552.249134723, 5455900.162362604],
              [-12800714.741562873, 5457664.995478126],
              [-12806590.518245416, 5474549.230401852],
              [-12804433.257833332, 5489534.372033381],
              [-12820407.938720638, 5496885.986245227],
              [-12821663.622576786, 5511444.746038521],
              [-12834537.72168703, 5518123.229868819],
              [-12827146.998054283, 5531218.677156937],
              [-12829252.383583656, 5546225.025480315],
              [-12835693.218001464, 5555619.31220694],
              [-12833046.374468874, 5560475.843911883],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yuma',
        GEOID: '04027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12779442.254789224, 3841487.342634094],
              [-12780523.167044828, 3844592.4940302274],
              [-12775575.794915501, 3848858.4173010625],
              [-12770531.129551224, 3858033.676238337],
              [-12768982.007517343, 3861053.183059569],
              [-12764726.931301262, 3860079.811206247],
              [-12759149.103903266, 3860983.2740430483],
              [-12753949.200841637, 3861825.585318869],
              [-12749615.644384546, 3866470.330574012],
              [-12742627.563349998, 3874768.8693945776],
              [-12741977.012245804, 3882287.9351308118],
              [-12743481.272524893, 3885171.239674324],
              [-12744001.69114435, 3891596.5134110968],
              [-12747344.392813891, 3898417.636333711],
              [-12747981.562233381, 3898573.476295551],
              [-12720338.840944897, 3899262.0749790156],
              [-12720234.979859987, 3956998.555299124],
              [-12685751.207238482, 3957142.803498233],
              [-12685751.652516445, 3945529.0396706047],
              [-12616274.264005603, 3945508.6437692684],
              [-12616250.775593046, 3864530.4509017183],
              [-12616271.703657314, 3829775.62302906],
              [-12616257.340439048, 3768595.1047039875],
              [-12662676.235269908, 3785515.662003221],
              [-12780992.935295975, 3828368.4805674413],
              [-12780761.724713597, 3832138.086302295],
              [-12778991.633490494, 3835851.441730997],
              [-12781056.610044707, 3837678.3080610754],
              [-12779442.254789224, 3841487.342634094],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Santa Cruz',
        GEOID: '04023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12397274.65053156, 3700635.3697116766],
              [-12374689.261683496, 3700705.2346672015],
              [-12374740.246010277, 3727395.1399156954],
              [-12362924.46129901, 3727427.466311797],
              [-12295431.008753082, 3728086.708010142],
              [-12296413.737217806, 3712752.9361212323],
              [-12296370.167931842, 3676089.8903656867],
              [-12364792.958951974, 3675972.2869870835],
              [-12397314.321588071, 3688044.4366762014],
              [-12397274.65053156, 3700635.3697116766],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sevier',
        GEOID: '05133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10516897.204147987, 4031441.5178545853],
              [-10516369.291295813, 4054324.7427854645],
              [-10491165.035934176, 4054679.5888504577],
              [-10474023.949422337, 4053917.076735313],
              [-10474655.353574118, 4039353.7173817027],
              [-10470436.790151015, 4024535.4121974106],
              [-10471817.151836852, 4018974.60127252],
              [-10460097.658485118, 4001463.2212172183],
              [-10459448.888492776, 3995415.4099119073],
              [-10468579.42444713, 3999573.540380979],
              [-10490464.391059123, 4002256.2619881225],
              [-10507285.100076461, 4014735.3937047045],
              [-10509525.293509183, 4021456.965716164],
              [-10517161.225207388, 4020870.5643470585],
              [-10516897.204147987, 4031441.5178545853],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Holmes',
        GEOID: '12059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9577376.63222299, 3631937.4375127866],
              [-9561635.376624828, 3631899.179713098],
              [-9545614.609468333, 3632136.436430729],
              [-9526666.092542166, 3632363.2758171842],
              [-9517594.00029466, 3632471.882507432],
              [-9521068.10515096, 3629430.005693299],
              [-9528941.064817823, 3610762.592259385],
              [-9531064.70674369, 3599530.0112263756],
              [-9544093.539946133, 3599854.080546617],
              [-9550119.709260736, 3605552.0559138414],
              [-9553618.59217586, 3605607.000074895],
              [-9556157.233163401, 3594254.6415754417],
              [-9577660.819199936, 3594441.3354038843],
              [-9577376.63222299, 3631937.4375127866],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montezuma',
        GEOID: '08083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12138698.143979665, 4506901.517773736],
              [-12124593.995609732, 4527555.62418554],
              [-12050405.566248517, 4527688.457842865],
              [-12019174.994425954, 4528635.913026955],
              [-12025053.66541526, 4521749.8430425655],
              [-12026780.675995424, 4502288.75355361],
              [-12034288.95301045, 4492496.789319508],
              [-12044521.329284677, 4488696.8614666],
              [-12046960.561966939, 4479244.81059803],
              [-12054834.7461482, 4470317.5040271375],
              [-12054838.75364987, 4459473.398596373],
              [-12064728.816934396, 4439046.110309965],
              [-12091557.487688031, 4439007.404711495],
              [-12138858.697798962, 4438979.109432515],
              [-12138698.143979665, 4506901.517773736],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Laurens',
        GEOID: '45059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9163152.119879559, 4093978.305348622],
              [-9154483.559811994, 4100979.8464373997],
              [-9154698.295109734, 4107890.824808453],
              [-9144539.055740958, 4134776.8419487015],
              [-9136171.058298538, 4123761.0973204914],
              [-9112978.087669723, 4106981.527414465],
              [-9111945.822031597, 4108917.5742474818],
              [-9092277.783078749, 4103972.3790544854],
              [-9088518.63519415, 4100685.5286755543],
              [-9095158.397542007, 4089742.452038955],
              [-9098932.684877353, 4086761.120567415],
              [-9104000.393376226, 4077930.544008507],
              [-9116546.545266593, 4069223.155407427],
              [-9122077.788125128, 4056112.5665756236],
              [-9137512.346843107, 4069053.770744861],
              [-9146995.320305312, 4073219.8598726187],
              [-9155620.354451975, 4083945.0549965245],
              [-9162742.241514456, 4091635.973751321],
              [-9163152.119879559, 4093978.305348622],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Corson',
        GEOID: '46031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11354663.749375409, 5771465.908913548],
              [-11354434.114767106, 5771465.68232644],
              [-11331723.70542191, 5771443.273337602],
              [-11305304.250671942, 5771395.726765773],
              [-11283931.68767607, 5771394.446053556],
              [-11255160.386044113, 5771377.156456724],
              [-11216786.77645582, 5771342.417276023],
              [-11188938.9842306, 5771324.338617457],
              [-11188921.615478918, 5771324.327341756],
              [-11187536.936309379, 5771320.805222123],
              [-11175033.729766022, 5759403.874482942],
              [-11166329.992739368, 5730751.585116773],
              [-11177193.550526394, 5724439.532943556],
              [-11179825.254608238, 5715655.370030927],
              [-11186112.802087223, 5706384.936324903],
              [-11170011.884897357, 5696280.338878697],
              [-11295609.88149672, 5696202.871573106],
              [-11354564.683820838, 5696202.554085529],
              [-11354663.749375409, 5771465.908913548],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fentress',
        GEOID: '47049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9475564.593496848, 4356792.115686667],
              [-9467046.314741857, 4377785.083981151],
              [-9455827.536459709, 4380900.835185283],
              [-9432305.171457637, 4373057.953552706],
              [-9424209.572809188, 4355140.471983485],
              [-9428848.255990544, 4351766.8841633275],
              [-9439654.70687879, 4341550.805555606],
              [-9448335.512090342, 4339920.833030679],
              [-9451887.828361047, 4322148.413614531],
              [-9465436.300946513, 4324098.102585497],
              [-9473312.37755912, 4319703.939814659],
              [-9475468.636095785, 4320552.798324157],
              [-9471340.241460225, 4327647.880911911],
              [-9475764.968580276, 4342615.075051875],
              [-9475564.593496848, 4356792.115686667],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fayette',
        GEOID: '47047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9977874.98270755, 4215072.14019143],
              [-9976027.079160383, 4216825.000312771],
              [-9960219.154870285, 4218788.321859427],
              [-9949187.39333267, 4218364.54689412],
              [-9946117.201776592, 4218419.446888424],
              [-9927911.233015826, 4217980.80084658],
              [-9929507.988826238, 4163127.0188445617],
              [-9946694.770915193, 4163065.27363886],
              [-9955853.538399843, 4163032.37000553],
              [-9979130.202541651, 4163074.8837320404],
              [-9977874.98270755, 4215072.14019143],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Jacinto',
        GEOID: '48407',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10611806.53220597, 3614522.049786248],
              [-10603446.995044848, 3620640.745994646],
              [-10597635.561027985, 3609986.5959967356],
              [-10589957.29915052, 3604431.455224925],
              [-10590422.503302546, 3593048.8375472897],
              [-10581429.892197285, 3591282.804884307],
              [-10571536.595092013, 3577882.0011066874],
              [-10556425.530814279, 3573296.106614844],
              [-10558588.468520394, 3567150.5535587966],
              [-10558934.226858798, 3565775.2937660157],
              [-10593819.194925122, 3547970.8134097857],
              [-10600525.30368949, 3544690.214015026],
              [-10598039.984738039, 3548889.1366737676],
              [-10609681.99972418, 3555812.5738642276],
              [-10615332.688396338, 3568547.9282182525],
              [-10611806.53220597, 3614522.049786248],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Motley',
        GEOID: '48345',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11247886.547876699, 4070833.1774109523],
              [-11237272.01179058, 4070875.6310782884],
              [-11189539.10469435, 4071056.6337393955],
              [-11189689.497326411, 4006755.1275671446],
              [-11247850.2577227, 4006483.7467118283],
              [-11247881.315860633, 4046378.2838526615],
              [-11247886.547876699, 4070833.1774109523],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sterling',
        GEOID: '48431',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11273004.455140311, 3717566.5431802394],
              [-11272680.960700067, 3774754.0238346267],
              [-11263751.022468122, 3774763.483958151],
              [-11223408.505046166, 3774684.9126027776],
              [-11223828.847443402, 3723492.000788495],
              [-11227806.181529954, 3724703.975075189],
              [-11228268.936653182, 3705991.0587974284],
              [-11273061.005441634, 3705229.156875939],
              [-11273004.455140311, 3717566.5431802394],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adams',
        GEOID: '18001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9470378.886337735, 5000228.120864148],
              [-9440190.065258907, 5000927.266750002],
              [-9440128.705270588, 4972328.07562176],
              [-9440128.708862178, 4972325.569123957],
              [-9440161.531003894, 4949446.463847456],
              [-9469779.764838286, 4948864.244796555],
              [-9470378.886337735, 5000228.120864148],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hinsdale',
        GEOID: '08053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11974512.390205296, 4574484.783886511],
              [-11968056.41633674, 4588029.264305745],
              [-11974484.003735144, 4600250.640323262],
              [-11911310.08139047, 4600223.037879569],
              [-11911252.52921373, 4573217.740331423],
              [-11926568.866632486, 4570790.684359948],
              [-11927342.203135027, 4533685.302740135],
              [-11925510.10695555, 4498224.560514025],
              [-11964856.092295924, 4498186.854685138],
              [-11964861.435631482, 4528623.823294842],
              [-11962182.532085542, 4548688.854202539],
              [-11968687.263891065, 4554938.086193588],
              [-11974512.390205296, 4574484.783886511],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greeley',
        GEOID: '20071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11359676.798008231, 4678442.587416705],
              [-11306397.185432551, 4678742.583361874],
              [-11306440.377394978, 4616666.361094453],
              [-11359556.725154627, 4616562.3780264],
              [-11359558.516157886, 4617460.939832172],
              [-11359591.204108117, 4633874.567343607],
              [-11359654.274900747, 4666696.16069714],
              [-11359676.798008231, 4678442.587416705],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stoddard',
        GEOID: '29207',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10047537.272892602, 4428246.15014668],
              [-10039495.998155659, 4438179.206665618],
              [-10035287.119528256, 4444907.01757146],
              [-10031138.1307869, 4444851.790190822],
              [-10018277.723974025, 4444699.079615108],
              [-10014254.192298794, 4456873.050652914],
              [-10003907.156949049, 4456715.838230921],
              [-9992617.57947076, 4456693.359558862],
              [-9995028.314363379, 4451254.646865611],
              [-9984192.809088033, 4428797.154799588],
              [-9984423.574392447, 4419543.316634767],
              [-9985464.300311875, 4387304.979550945],
              [-10014166.249901066, 4387565.480849032],
              [-10035273.761189362, 4387749.278182778],
              [-10034317.081485484, 4396827.390170766],
              [-10041486.168012062, 4407410.408584834],
              [-10047537.272892602, 4428246.15014668],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jasper',
        GEOID: '13159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9331347.632825876, 3953488.1806787774],
              [-9314618.762388444, 3960154.946120048],
              [-9315459.447182914, 3965360.9836273184],
              [-9298932.955579745, 3953115.8720551827],
              [-9300284.374197975, 3918148.956009283],
              [-9330359.783664575, 3912813.4313713964],
              [-9331051.411660874, 3919252.052632449],
              [-9329382.064576939, 3920947.731970437],
              [-9335592.912926767, 3944289.3539916705],
              [-9331347.632825876, 3953488.1806787774],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lake',
        GEOID: '30047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12757710.352477072, 6071967.779600578],
              [-12743553.630193908, 6071979.377950991],
              [-12745212.290606728, 6100533.486905768],
              [-12694712.760205815, 6100626.749128282],
              [-12699136.262811467, 6110706.701618318],
              [-12693654.891084807, 6115452.359562326],
              [-12677569.113345686, 6115493.492860662],
              [-12672868.313888468, 6103341.439470911],
              [-12662278.490729304, 6099031.29007688],
              [-12653472.45109061, 6088734.095164782],
              [-12654988.956513688, 6074500.235861143],
              [-12650412.389608195, 6060398.252474558],
              [-12646330.971797751, 6060636.861016923],
              [-12649687.811042622, 6040569.666167549],
              [-12684727.179242676, 6040518.65398153],
              [-12682661.757410498, 6040317.414671771],
              [-12680245.233904356, 6026451.119455671],
              [-12684987.332892658, 6020117.466123781],
              [-12676073.981264843, 6006289.895650473],
              [-12676036.021318482, 5989236.285313844],
              [-12670514.240616664, 5986043.56896421],
              [-12670545.521393577, 5971784.205746111],
              [-12683026.774020808, 5971786.007362499],
              [-12683019.538253907, 5964675.641048602],
              [-12711257.619524963, 5964659.603412652],
              [-12713033.054083627, 5971816.798682076],
              [-12713022.701370982, 6000335.425076682],
              [-12722543.968738021, 6000356.622733214],
              [-12729726.636242475, 6005941.299121384],
              [-12723979.990169255, 6023586.05064647],
              [-12733107.74313634, 6021313.259097134],
              [-12726102.964178173, 6039665.689022102],
              [-12755405.816378668, 6040848.835278847],
              [-12755483.07210528, 6064760.603289575],
              [-12757710.352477072, 6071967.779600578],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Silver Bow',
        GEOID: '30093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12588622.168534081, 5758046.016875274],
              [-12570555.79441477, 5769874.2108770935],
              [-12572306.961324438, 5779268.875847153],
              [-12562712.111773985, 5788114.202735126],
              [-12554358.029267913, 5788094.795426083],
              [-12554291.571531909, 5802142.212495681],
              [-12543591.987354822, 5802117.473121591],
              [-12532026.114900382, 5809077.588044801],
              [-12524041.279145272, 5809935.506654759],
              [-12525668.770100672, 5802233.459616475],
              [-12512794.89362941, 5762427.107761242],
              [-12512471.176550183, 5753444.048636176],
              [-12488963.617040385, 5740137.840249332],
              [-12519192.090806827, 5739193.649261066],
              [-12523268.165281713, 5741934.61599931],
              [-12528956.81390023, 5729904.31284655],
              [-12544265.470274122, 5720434.271399489],
              [-12552312.199666115, 5740090.939398378],
              [-12577806.478128098, 5749710.305641873],
              [-12588622.168534081, 5758046.016875274],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Butler',
        GEOID: '21031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9673003.291396596, 4451428.663562533],
              [-9676365.807935499, 4459284.585809175],
              [-9673582.264068212, 4468741.944309288],
              [-9664296.4374242, 4485045.160370644],
              [-9658027.035022214, 4481579.457419843],
              [-9641614.311938636, 4494325.878086557],
              [-9627705.720800452, 4489755.924007135],
              [-9625699.075659413, 4483958.855994849],
              [-9617911.052764025, 4462814.630543743],
              [-9628822.811890561, 4465677.608889209],
              [-9642816.562439203, 4464378.407049271],
              [-9648556.974620938, 4439074.170718471],
              [-9667580.139763622, 4446986.9007748375],
              [-9678271.374978898, 4448726.215602904],
              [-9673003.291396596, 4451428.663562533],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '13061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9476534.66667018, 3734503.166680799],
              [-9470387.791896997, 3733345.9578308244],
              [-9457552.543289043, 3734185.706385974],
              [-9456566.697878577, 3721367.314449827],
              [-9454475.449924536, 3720372.537993902],
              [-9455739.482742494, 3713358.4382328116],
              [-9441879.092943823, 3713502.497792887],
              [-9440778.922416313, 3699733.298891338],
              [-9442097.724423742, 3698010.957159468],
              [-9465410.252185667, 3696036.9152782927],
              [-9467909.867844352, 3700406.754673484],
              [-9466818.889022164, 3703690.605093823],
              [-9468608.79511463, 3707107.6081327903],
              [-9468632.060888207, 3713562.109144323],
              [-9476130.653107533, 3723336.309527294],
              [-9475395.944468297, 3728269.553479051],
              [-9476120.698622834, 3732236.6444866722],
              [-9476534.66667018, 3734503.166680799],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crawford',
        GEOID: '17033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9790592.073272366, 4746752.966835048],
              [-9757909.672650876, 4746364.5443849],
              [-9755850.196809493, 4744256.202034547],
              [-9754412.570847606, 4736264.917674585],
              [-9748535.90360914, 4729880.6255754065],
              [-9749262.708564527, 4721901.764155623],
              [-9743738.924111875, 4717650.867208022],
              [-9743532.871734416, 4708457.283285224],
              [-9743652.28011106, 4708207.767920696],
              [-9745728.648690315, 4703869.974374252],
              [-9744380.24135431, 4700564.211948535],
              [-9785886.375757553, 4700223.372975981],
              [-9790094.920426482, 4700229.233480485],
              [-9790592.073272366, 4746752.966835048],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sioux',
        GEOID: '19167',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10748901.755284224, 5351256.975508796],
              [-10745784.771391742, 5351588.568008863],
              [-10671299.452948583, 5351258.553616236],
              [-10671017.035400439, 5298145.70292203],
              [-10746836.220627915, 5298069.512576349],
              [-10746971.659802578, 5300194.539891969],
              [-10742365.147954062, 5305792.78428912],
              [-10744584.6359615, 5308569.502459874],
              [-10741517.450031674, 5312746.476717695],
              [-10743622.724241555, 5318051.119423433],
              [-10737677.818155231, 5322259.913718114],
              [-10736998.381430265, 5324545.697202744],
              [-10735577.664641926, 5329327.128781474],
              [-10737750.50978272, 5333817.609733352],
              [-10739611.437710311, 5345679.275431773],
              [-10744789.241185578, 5345664.915915544],
              [-10748226.675741782, 5349686.598426237],
              [-10748901.755284224, 5351256.975508796],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calcasieu',
        GEOID: '22019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10435682.733805865, 3554686.0870134914],
              [-10434926.567024104, 3555362.59591838],
              [-10406826.829360904, 3555393.0980445617],
              [-10406856.662984438, 3566759.1201342344],
              [-10395534.246256363, 3566705.638097977],
              [-10395587.34565347, 3555409.8768092813],
              [-10367307.630892856, 3555464.9887551987],
              [-10356158.538611948, 3552410.7047519907],
              [-10356128.482349433, 3537091.0744000496],
              [-10352300.761658506, 3523740.941718946],
              [-10340837.525774578, 3523658.416583641],
              [-10340158.254241757, 3514281.722519834],
              [-10352308.665342351, 3508496.919697668],
              [-10367014.415354107, 3510311.2045659083],
              [-10431341.581181701, 3510258.8919221424],
              [-10431074.886123458, 3510530.3559831916],
              [-10430907.461609304, 3518047.321443861],
              [-10431055.293893078, 3525927.3450981644],
              [-10432123.40440724, 3532538.0317345834],
              [-10431867.722606016, 3534948.7106368016],
              [-10431436.674468536, 3539013.858850216],
              [-10437351.96957031, 3546029.383934047],
              [-10435682.733805865, 3554686.0870134914],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sabine',
        GEOID: '22085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10450479.197557107, 3742886.818516478],
              [-10401823.5748472, 3743012.1547430507],
              [-10401887.249595935, 3725890.4218819146],
              [-10390446.83420762, 3725860.8476279187],
              [-10390278.073859576, 3702831.9325676267],
              [-10379057.73710456, 3702861.8427176005],
              [-10378995.620828697, 3680178.3451364897],
              [-10396182.348331762, 3680131.4120188477],
              [-10401977.529702969, 3668738.3676942624],
              [-10412314.65761803, 3668697.4697257937],
              [-10414216.362710254, 3656774.874244196],
              [-10419571.473628549, 3656489.2510797926],
              [-10419776.291766414, 3656478.3269175524],
              [-10421056.354591046, 3666479.935604954],
              [-10427902.28063585, 3671906.9414682863],
              [-10427090.316270005, 3681559.823752515],
              [-10430369.454510301, 3688512.0850408184],
              [-10436143.930456221, 3693768.2252244423],
              [-10433522.245128548, 3698389.587746719],
              [-10440397.559518922, 3701425.846471496],
              [-10445655.958305527, 3709116.112857409],
              [-10443642.633995038, 3713860.431743514],
              [-10442148.837748082, 3724084.8233551444],
              [-10447711.584022513, 3737802.1485922784],
              [-10450479.197557107, 3742886.818516478],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Concordia',
        GEOID: '22029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10224140.746978536, 3681665.82698937],
              [-10216544.304926801, 3682878.3450119696],
              [-10225350.789843457, 3687914.859268814],
              [-10225483.705315467, 3697140.804129971],
              [-10219919.400568165, 3689866.974642271],
              [-10212264.293144785, 3688924.733161574],
              [-10212231.008617036, 3693601.1673001894],
              [-10218990.550736984, 3694376.9618625464],
              [-10216872.25214668, 3701899.7914322107],
              [-10222126.643431615, 3709829.6423260737],
              [-10216439.330646984, 3717275.19105655],
              [-10212137.166286297, 3712759.6027550315],
              [-10208659.434074424, 3716521.6048252364],
              [-10207381.597639607, 3728612.739748073],
              [-10200853.043463055, 3727805.5737552303],
              [-10197045.916877925, 3732092.008517398],
              [-10190719.518896652, 3730765.4014987783],
              [-10174411.10217595, 3730959.2841771063],
              [-10172388.93130369, 3728264.704576649],
              [-10172476.926023416, 3728243.376435385],
              [-10174124.454487154, 3716691.8539546984],
              [-10181705.534449156, 3713580.149479307],
              [-10181004.22165716, 3709293.1844933648],
              [-10178788.852470882, 3703884.1870226357],
              [-10184577.688631115, 3702329.8709578738],
              [-10187641.423656728, 3697645.6550557935],
              [-10186886.232231187, 3689884.4580697007],
              [-10189333.034638824, 3683538.1804981986],
              [-10189747.699742027, 3676769.382436496],
              [-10186719.475633977, 3670682.8715628465],
              [-10192879.228337532, 3666773.986242429],
              [-10199242.918348221, 3667578.559331799],
              [-10201803.043997487, 3663229.829295381],
              [-10195757.839049956, 3657929.497067101],
              [-10195862.80142577, 3657708.9953334085],
              [-10199277.76134884, 3650537.104304386],
              [-10196274.58412622, 3644630.5904358556],
              [-10192453.208646268, 3639180.3700647224],
              [-10200010.944711655, 3633411.103798285],
              [-10210647.15490203, 3638497.702294776],
              [-10210112.821346221, 3650243.9613759303],
              [-10205470.57594116, 3657194.7817717935],
              [-10222945.286966907, 3667387.5042678593],
              [-10226049.764926149, 3672072.9220284],
              [-10224140.746978536, 3681665.82698937],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pearl River',
        GEOID: '28109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10000534.621655978, 3597370.929644308],
              [-9995571.330839466, 3609444.879202227],
              [-9990932.42501913, 3621446.601501089],
              [-9988494.827638065, 3633049.649431783],
              [-9980241.857720798, 3633074.0799748395],
              [-9963243.594115647, 3634830.599492469],
              [-9954782.978856888, 3630470.4111763197],
              [-9946279.61691366, 3634095.9585267026],
              [-9945363.012226468, 3632147.344894845],
              [-9945373.03098064, 3621055.020033948],
              [-9945444.275454747, 3587082.8939383593],
              [-9968018.309714751, 3587166.7411804707],
              [-9968049.256533192, 3570162.1565705985],
              [-9979466.406147933, 3568337.200991991],
              [-9985350.76365306, 3562046.5827400074],
              [-9986749.03855512, 3565078.161941463],
              [-9995562.313960714, 3574641.9421114544],
              [-9998924.607860632, 3586604.6648544767],
              [-9999404.657481456, 3589813.817124796],
              [-10000534.621655978, 3597370.929644308],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '28151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10154082.048086772, 3965788.7052583033],
              [-10103747.604490703, 3965784.164889296],
              [-10103776.992836272, 3931244.82776402],
              [-10098489.762301553, 3931201.2901667175],
              [-10094486.93605161, 3922143.0229360396],
              [-10094407.676574165, 3908914.7813458303],
              [-10096883.199410425, 3908092.367423148],
              [-10114807.97513745, 3907934.5088447714],
              [-10120551.949542891, 3908241.5909196273],
              [-10120537.70064807, 3896325.6559784925],
              [-10126225.681349643, 3896703.7194336713],
              [-10147840.931746203, 3896796.288605548],
              [-10143474.191170098, 3902544.1476135277],
              [-10150204.233624987, 3908367.4291343293],
              [-10147107.214071626, 3913249.058428805],
              [-10141686.177508976, 3912784.4521806748],
              [-10139465.24234816, 3919334.2504113684],
              [-10137722.201761318, 3926263.2936897343],
              [-10139662.389166355, 3931683.275102795],
              [-10144048.59974259, 3932562.483075624],
              [-10145905.408849023, 3941718.561632021],
              [-10142737.8127385, 3947601.61031039],
              [-10146511.432156902, 3952142.136853817],
              [-10149198.239386687, 3956834.1599148964],
              [-10151154.79075687, 3960926.45845884],
              [-10154082.048086772, 3965788.7052583033],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dawson',
        GEOID: '30021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11729011.947433515, 6028943.87179113],
              [-11728984.674158271, 6072058.578532792],
              [-11714681.121466752, 6072072.331009298],
              [-11714708.394741997, 6057682.187820022],
              [-11686107.523250444, 6057634.5481009185],
              [-11686159.064174682, 6043251.944819252],
              [-11643313.41668275, 6043255.577894547],
              [-11643355.940728232, 6028907.106633316],
              [-11634339.395932449, 6028924.747294911],
              [-11634366.446568714, 6000166.667287513],
              [-11624019.85649693, 6000120.000669426],
              [-11612422.480626596, 5971592.74518697],
              [-11611297.708491622, 5948939.75223701],
              [-11623104.47632414, 5926418.971033963],
              [-11644437.966178743, 5919391.242075091],
              [-11691610.7135973, 5919489.575002072],
              [-11696285.909571636, 5928890.85051952],
              [-11710477.697494399, 5928894.110101305],
              [-11710446.97331494, 5938348.757484424],
              [-11724698.317165276, 5938352.673223442],
              [-11724709.003836393, 5971749.319975141],
              [-11733776.644278448, 5971763.569075953],
              [-11729011.947433515, 6028943.87179113],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Perry',
        GEOID: '28111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9923697.567650318, 3689248.286161611],
              [-9901141.567147823, 3689170.789219946],
              [-9889813.584445208, 3689202.7533872253],
              [-9889723.304338174, 3633600.204420698],
              [-9888993.382437043, 3632487.20030966],
              [-9889008.52188779, 3621108.3460083394],
              [-9894637.16930077, 3621168.6785912775],
              [-9922793.096787622, 3621050.4789031576],
              [-9923706.918487545, 3632807.194979458],
              [-9923697.567650318, 3689248.286161611],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Barnes',
        GEOID: '38003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10961349.288018884, 5981410.8199243],
              [-10904991.792053958, 5981420.493853017],
              [-10876585.952310275, 5981332.936992369],
              [-10873855.730479078, 5938562.330982938],
              [-10873911.167585494, 5881876.720718903],
              [-10913079.59833805, 5882006.244392802],
              [-10958185.58809054, 5882069.953234321],
              [-10958231.229081767, 5938754.372122383],
              [-10961349.288018884, 5981410.8199243],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Forsyth',
        GEOID: '37067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8961834.828281593, 4315651.345047996],
              [-8954440.097147176, 4319895.264886708],
              [-8953676.11148186, 4330658.755682907],
              [-8955911.51817648, 4333891.303768236],
              [-8955841.832175244, 4336663.5600793455],
              [-8909468.692659054, 4336067.443440427],
              [-8909851.075109929, 4320793.214661049],
              [-8910372.495604806, 4302101.757239912],
              [-8929351.578229131, 4304310.7387546925],
              [-8929364.0460121, 4300167.169040754],
              [-8949453.317918109, 4296874.112210008],
              [-8957166.088837719, 4309230.333046568],
              [-8960805.234311242, 4307027.783740622],
              [-8961834.828281593, 4315651.345047996],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greene',
        GEOID: '47059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9258006.233470106, 4325540.740324353],
              [-9255346.254237602, 4326436.676563174],
              [-9248680.665767882, 4334012.349928157],
              [-9232524.979388544, 4346787.252036668],
              [-9206407.534417098, 4357241.375703985],
              [-9198529.231414678, 4358397.393692569],
              [-9200307.5602801, 4320785.081222844],
              [-9194440.577837331, 4313867.119013872],
              [-9195624.862573624, 4305741.086249223],
              [-9198147.516880747, 4309170.292634071],
              [-9208912.111640457, 4303126.503562484],
              [-9214960.322214238, 4299590.946116839],
              [-9215858.447865957, 4294041.069455917],
              [-9219049.421069548, 4290166.997480796],
              [-9224013.602441981, 4293390.230034559],
              [-9227690.19784398, 4291524.046890811],
              [-9250957.038035113, 4317271.043195323],
              [-9258718.678211184, 4322258.98769807],
              [-9258006.233470106, 4325540.740324353],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Benton',
        GEOID: '41003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13783192.514792627, 5514366.409437019],
              [-13771950.693375887, 5521394.395078205],
              [-13772455.304627651, 5532754.5856167525],
              [-13758830.4668715, 5532713.273414656],
              [-13759379.494600093, 5577729.195303639],
              [-13725902.718092304, 5577522.551355302],
              [-13708886.754688116, 5577583.651046615],
              [-13700487.587788275, 5566665.877736069],
              [-13711319.642159402, 5564123.467429775],
              [-13721257.244422011, 5551758.419468344],
              [-13716195.76981462, 5544346.083356036],
              [-13719646.11743176, 5516979.929628757],
              [-13712378.067877866, 5509454.779422127],
              [-13758345.781808587, 5508361.539797384],
              [-13778636.54199293, 5509427.100855397],
              [-13783192.514792627, 5514366.409437019],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Luzerne',
        GEOID: '42079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8494805.14792698, 5058204.176370677],
              [-8491795.848132368, 5068037.4694295],
              [-8463124.956681104, 5069113.21827821],
              [-8459052.444429925, 5069942.476853126],
              [-8441879.631863208, 5075566.075052851],
              [-8441649.868434211, 5071512.016765913],
              [-8425465.461626248, 5062505.436198037],
              [-8419858.632833464, 5037663.042040973],
              [-8415835.435116706, 5036191.696927449],
              [-8421279.069535987, 5030404.158578356],
              [-8426290.005094554, 5031632.832824277],
              [-8434699.636026535, 5019751.779142522],
              [-8430439.884391839, 5013554.187585563],
              [-8458722.15950074, 5000171.551587702],
              [-8459986.080999209, 4999515.43091661],
              [-8463414.943954622, 4997895.352785999],
              [-8483416.496101884, 5004931.149420654],
              [-8485770.680693181, 5032786.87026507],
              [-8491187.932393143, 5031802.205231446],
              [-8495818.489251673, 5043083.808403938],
              [-8494805.14792698, 5058204.176370677],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Charleston',
        GEOID: '45019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8950236.227896856, 3876532.7253076085],
              [-8938073.015054822, 3875259.7966295592],
              [-8924495.042804293, 3871559.7303736587],
              [-8922088.426732834, 3871308.3143575764],
              [-8926230.958943723, 3876842.961273667],
              [-8916371.169005182, 3880291.4919196884],
              [-8916766.353197498, 3888142.935604021],
              [-8925183.331215868, 3896636.9468051326],
              [-8922173.252184818, 3898171.4859717404],
              [-8909983.656623464, 3893164.365713824],
              [-8908155.011348203, 3884880.2780846264],
              [-8903967.728702014, 3882596.2016816502],
              [-8900043.160054097, 3883387.124715944],
              [-8896564.871244771, 3871302.6184826605],
              [-8896019.962337337, 3871289.5047346125],
              [-8894124.41404811, 3876572.4817019184],
              [-8886480.327254318, 3884552.8554600775],
              [-8865771.117104081, 3911790.828510111],
              [-8851997.222549757, 3915004.493211368],
              [-8843966.077886475, 3923671.3382119043],
              [-8833292.431150744, 3915700.013060577],
              [-8824228.798210356, 3913487.0184348803],
              [-8824796.370056558, 3911250.288591419],
              [-8826699.534308514, 3909883.5739278155],
              [-8830965.07455673, 3907254.1999852345],
              [-8832011.92304815, 3901987.1329974486],
              [-8834310.44789405, 3896189.593291197],
              [-8841377.67708655, 3897306.416056837],
              [-8848062.635147668, 3895471.8721900075],
              [-8852398.529314065, 3899997.0251902766],
              [-8858885.783959536, 3896159.726083669],
              [-8861767.845576173, 3891620.9286312517],
              [-8857665.38838197, 3885577.5900841164],
              [-8861177.184358025, 3881792.869356286],
              [-8871622.514818138, 3875463.5937664853],
              [-8875101.026266446, 3869581.3983805813],
              [-8885325.498856828, 3864332.005925657],
              [-8890904.275137933, 3860162.256857023],
              [-8892753.180560516, 3853488.140950177],
              [-8902049.137278192, 3847581.466379033],
              [-8905648.430374011, 3843108.7965803077],
              [-8914135.205713108, 3842768.7895051455],
              [-8922079.743812552, 3839486.8291637185],
              [-8926721.989217613, 3835308.005977666],
              [-8932984.044533206, 3833231.293995775],
              [-8933327.056541838, 3832999.6238329336],
              [-8942999.013841914, 3828274.5098242923],
              [-8951933.404853491, 3835238.9392566467],
              [-8951787.24236208, 3836235.097283054],
              [-8950968.82146577, 3836947.5013214643],
              [-8949648.906263432, 3837262.1138438103],
              [-8949125.148059249, 3837872.739566213],
              [-8948833.26835439, 3838957.2292468906],
              [-8949661.485365892, 3840732.387203742],
              [-8949667.385298904, 3841884.7903846055],
              [-8948732.746854203, 3843537.8827991886],
              [-8948707.254690811, 3844513.857493987],
              [-8949541.037676854, 3844870.9640841475],
              [-8950922.067279635, 3844165.6162577467],
              [-8952109.95756589, 3842921.4148698845],
              [-8952808.82132909, 3843361.0662056273],
              [-8953117.176318588, 3845658.3019235777],
              [-8948907.184496276, 3849311.775323118],
              [-8956057.124070436, 3860830.709888161],
              [-8950236.227896856, 3876532.7253076085],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '47087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9554332.150111845, 4357438.34784126],
              [-9552757.981192537, 4369567.531025119],
              [-9540533.987908527, 4372742.257704177],
              [-9526272.291345548, 4365710.70368384],
              [-9517306.842196038, 4356226.417810667],
              [-9517547.848893605, 4352351.288887762],
              [-9517273.66898778, 4342294.470929981],
              [-9524220.339171754, 4331373.796264723],
              [-9549002.395531643, 4333420.934319655],
              [-9554291.407178214, 4335803.494953709],
              [-9554332.150111845, 4357438.34784126],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hamilton',
        GEOID: '48193',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10960932.953123318, 3721900.3807273903],
              [-10926739.167775331, 3742550.885748557],
              [-10932507.521149255, 3752487.527973788],
              [-10909918.124799522, 3765660.1158419447],
              [-10883309.315595714, 3720392.4196445905],
              [-10929348.274000544, 3693119.191886999],
              [-10939485.472110143, 3686945.2448301446],
              [-10960932.953123318, 3721900.3807273903],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bexar',
        GEOID: '48029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10999095.055679107, 3463855.001476251],
              [-10996003.713419776, 3467630.3965841555],
              [-10981951.854096942, 3471437.672387945],
              [-10981236.292410122, 3470837.109932164],
              [-10970590.252908109, 3472828.664335692],
              [-10958897.142275691, 3469613.377665428],
              [-10958719.476368386, 3467564.127299718],
              [-10948560.125680119, 3469450.435827275],
              [-10951396.434986042, 3460255.194015219],
              [-10945895.35970951, 3453290.596437799],
              [-10943924.893402977, 3451540.0485882503],
              [-10943922.44437418, 3451528.910778357],
              [-10939779.355565837, 3445991.919788065],
              [-10922926.920493625, 3436581.273952839],
              [-10924245.945140034, 3431992.0873824838],
              [-10954654.533842579, 3390219.12437198],
              [-10958462.996261599, 3391708.9909701203],
              [-10998895.905110076, 3407592.494538402],
              [-10999095.055679107, 3463855.001476251],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harrison',
        GEOID: '18061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9609240.266306644, 4600272.014573937],
              [-9601687.572814794, 4620676.161027239],
              [-9601867.687750898, 4639310.316613691],
              [-9577129.37995089, 4638630.15774074],
              [-9577100.659522265, 4626242.866986564],
              [-9568491.766701767, 4616291.510361371],
              [-9568753.590144113, 4605744.995882054],
              [-9561889.16143467, 4604874.726206408],
              [-9562919.112992655, 4595128.182614127],
              [-9564837.259138513, 4583477.986276315],
              [-9568102.77698443, 4581536.566795176],
              [-9570807.65738823, 4579928.733680434],
              [-9573181.39633393, 4578186.35889763],
              [-9577192.72074115, 4575242.627304159],
              [-9584136.830576835, 4580687.399189435],
              [-9596456.892581401, 4582516.619075823],
              [-9604496.052248018, 4593351.19245306],
              [-9609240.266306644, 4600272.014573937],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Warren',
        GEOID: '18171',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9743801.040387738, 4902436.249984571],
              [-9743468.335751222, 4935485.446162954],
              [-9695223.663634352, 4935319.011194062],
              [-9695053.56745242, 4919361.234462075],
              [-9712057.619671091, 4910984.23121746],
              [-9733637.682197804, 4890049.77507813],
              [-9730065.662377229, 4884488.731741943],
              [-9739387.890494728, 4884473.881623758],
              [-9743908.754510509, 4887477.756644897],
              [-9743801.040387738, 4902436.249984571],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clayton',
        GEOID: '19043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10197456.129201498, 5324408.535987587],
              [-10149547.327726454, 5324196.283905526],
              [-10149520.286673553, 5317866.217873141],
              [-10147782.846119171, 5310066.033284493],
              [-10147385.958076574, 5308285.129378777],
              [-10145435.751917368, 5297336.41494514],
              [-10141074.254268084, 5291358.056405174],
              [-10137945.73129883, 5277863.150441182],
              [-10131992.698889678, 5269383.8788585365],
              [-10123568.930382371, 5263972.822593639],
              [-10118603.527518798, 5262530.388163766],
              [-10118653.952224867, 5258200.441918051],
              [-10144853.105702553, 5258220.11619597],
              [-10197651.160949368, 5257936.961896685],
              [-10197456.129201498, 5324408.535987587],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '22051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10049867.412473887, 3504423.56440225],
              [-10049428.813680163, 3514979.276516109],
              [-10047684.882537395, 3524572.016471029],
              [-10043281.417440085, 3526141.615125466],
              [-10036148.509748014, 3527946.185309402],
              [-10030789.9234197, 3524769.0104076993],
              [-10032644.060858352, 3500438.381686507],
              [-10034347.137748, 3496855.1445779577],
              [-10033501.109617969, 3492372.3415977345],
              [-10025271.593622094, 3496524.972497734],
              [-10019650.96121245, 3490127.9981161137],
              [-10026371.430191131, 3481610.9836789784],
              [-10027179.164416328, 3474256.8701678724],
              [-10017032.39283052, 3454463.863930021],
              [-10016246.143267049, 3432966.1709231795],
              [-10007923.488927599, 3412996.16032371],
              [-10013907.320765482, 3407981.7721154974],
              [-10025267.697439916, 3399046.1122853295],
              [-10028754.607742785, 3396596.764174814],
              [-10018637.731207252, 3413672.9813480354],
              [-10022114.795502178, 3417979.5068679703],
              [-10021049.80193376, 3430293.3686009645],
              [-10034061.046656659, 3436519.511475132],
              [-10039478.743634587, 3447543.983492446],
              [-10035644.121135231, 3450683.7454518923],
              [-10036098.52729665, 3462166.313341287],
              [-10044152.492455542, 3464024.0234283735],
              [-10037599.225352032, 3478814.289618416],
              [-10038034.929838996, 3481398.8718692875],
              [-10045490.107456913, 3485838.553583583],
              [-10049871.642614538, 3499433.47821331],
              [-10049867.412473887, 3504423.56440225],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Winneshiek',
        GEOID: '19191',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10250407.360067643, 5344440.9249081435],
              [-10250276.670220498, 5388497.44856982],
              [-10221895.321529746, 5388494.243391836],
              [-10211361.046555782, 5388494.504430286],
              [-10198071.503408318, 5388494.833744067],
              [-10197456.129201498, 5324408.535987587],
              [-10250426.284381079, 5324582.440724739],
              [-10250407.360067643, 5344440.9249081435],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Somerset',
        GEOID: '23025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7853900.990803236, 5727278.551238776],
              [-7842113.369923134, 5733048.24618425],
              [-7835061.168861891, 5737963.113006211],
              [-7838638.086740062, 5746146.861618422],
              [-7836515.891967579, 5749711.902629996],
              [-7829071.73497925, 5756950.642024759],
              [-7821209.128025031, 5762859.881899936],
              [-7820475.421261213, 5769647.086375547],
              [-7821909.661580592, 5774372.601422299],
              [-7827204.01656272, 5774238.723090545],
              [-7826097.946102199, 5780185.125057027],
              [-7827722.654070327, 5783407.33099806],
              [-7826509.828218132, 5790185.094638469],
              [-7822014.190582447, 5796548.216110443],
              [-7819032.720660531, 5803256.519939049],
              [-7824746.750122951, 5810180.067296411],
              [-7820805.594870905, 5819930.380683715],
              [-7818266.39728591, 5826046.7514713695],
              [-7815264.889855651, 5828533.705163703],
              [-7815453.687712037, 5833602.739656904],
              [-7810324.308215265, 5838387.076097653],
              [-7805566.51317876, 5842138.084309621],
              [-7801302.420083923, 5846382.946017845],
              [-7798347.555520307, 5849403.438016318],
              [-7794926.906502414, 5872731.97451706],
              [-7761318.351422323, 5872823.716893867],
              [-7762566.354233607, 5843715.665928563],
              [-7762149.685379567, 5776645.318181569],
              [-7757138.861140488, 5777726.624643763],
              [-7753020.262620118, 5758579.927185785],
              [-7759607.816126794, 5756979.411270831],
              [-7762595.185981723, 5741330.385357983],
              [-7768414.30104345, 5745995.848332911],
              [-7773753.74041935, 5738579.556124761],
              [-7759156.4155916255, 5720932.184340708],
              [-7767866.052551293, 5707377.475938915],
              [-7750170.594975302, 5623246.44910057],
              [-7738446.648843937, 5625464.855980848],
              [-7736689.136723293, 5629991.708606844],
              [-7720637.534067848, 5633095.101642617],
              [-7715055.306882528, 5605161.761397679],
              [-7712356.254508753, 5591448.578402456],
              [-7712421.376410867, 5588249.821980321],
              [-7710743.23508716, 5577850.457857883],
              [-7717491.645258028, 5576677.694510626],
              [-7722462.951077875, 5582975.67572623],
              [-7733555.604376952, 5573303.595393197],
              [-7733407.549454198, 5577260.297357944],
              [-7751506.874142786, 5574221.900092154],
              [-7745487.49531712, 5562694.241467383],
              [-7748476.2010059375, 5555214.067219003],
              [-7755130.76884607, 5556642.2728290595],
              [-7763897.957982475, 5559175.553425117],
              [-7769300.404190164, 5555224.381753525],
              [-7772598.244104913, 5559953.891575665],
              [-7784622.196263967, 5560464.741557742],
              [-7787928.1625015475, 5571475.875747001],
              [-7791940.3395887185, 5570892.078899706],
              [-7796067.954987842, 5600221.231100929],
              [-7806828.096967921, 5598058.006962329],
              [-7808960.4218140645, 5605179.6758907335],
              [-7804650.13113055, 5613230.49192678],
              [-7810105.899374328, 5641757.5078008305],
              [-7825072.916230974, 5638840.090174345],
              [-7826705.416563458, 5647247.9975890955],
              [-7838953.67749646, 5644220.687709432],
              [-7850105.330125656, 5702508.968715851],
              [-7853904.430951595, 5727273.781548902],
              [-7853900.990803236, 5727278.551238776],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dillingham',
        GEOID: '02070',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-17925938.793063514, 8180255.691100306],
              [-17907376.824571185, 8180255.907234871],
              [-17901524.758940183, 8199014.732799629],
              [-17901525.538176622, 8236673.940696976],
              [-17882776.664259255, 8236674.3762605665],
              [-17882776.998217728, 8255575.761129788],
              [-17864028.235619854, 8255576.197804727],
              [-17864034.692150317, 8274525.236712711],
              [-17857721.318549465, 8274525.45560918],
              [-17857722.0977859, 8312569.180363142],
              [-17838781.75434437, 8312569.620412322],
              [-17838782.53358081, 8350808.988137763],
              [-17813058.046411864, 8350809.651636986],
              [-17813058.825648297, 8389247.045486925],
              [-17793922.33726399, 8389247.49013123],
              [-17793923.339139406, 8427885.555385096],
              [-17786839.96862074, 8427885.778877154],
              [-17786840.413898703, 8447280.720643478],
              [-17767503.105153, 8447281.16880829],
              [-17767503.995708928, 8486224.882142847],
              [-17748167.020921703, 8486225.332690923],
              [-17748167.57751916, 8505774.512859967],
              [-17740564.901575938, 8505774.964610748],
              [-17740565.903451357, 8545029.34582974],
              [-17721022.87628667, 8545029.80000833],
              [-17721023.321564637, 8564735.876361582],
              [-17701480.40571944, 8564736.331765449],
              [-17701481.073636383, 8584495.665470904],
              [-17693333.488785733, 8584495.665470904],
              [-17693334.26802217, 8604308.360444838],
              [-17574812.18353559, 8604310.649832515],
              [-17574810.402423736, 8584498.405292263],
              [-17555056.981421452, 8584498.405292263],
              [-17555058.651213814, 8604311.336648958],
              [-17535305.007572547, 8604312.02346547],
              [-17535305.786808982, 8624177.965748774],
              [-17495798.054248486, 8624179.113564165],
              [-17495797.16369256, 8604313.16815979],
              [-17365850.137226887, 8604314.770732144],
              [-17365856.705076844, 8331675.923979224],
              [-17384215.84945694, 8331675.482791022],
              [-17384215.626817957, 8312580.181600483],
              [-17422095.757103566, 8312579.521525781],
              [-17422095.311825603, 8293533.187608442],
              [-17441035.655267134, 8293532.748690192],
              [-17441034.98735019, 8274535.087060181],
              [-17451553.343396265, 8274534.86816343],
              [-17451552.67547932, 8255585.80465992],
              [-17489050.534633543, 8255584.931308933],
              [-17489049.866716597, 8236683.740883915],
              [-17507798.851953458, 8236683.523101846],
              [-17507797.516119566, 8199024.266742466],
              [-17499012.738503613, 8199024.483423129],
              [-17499011.195626494, 8147898.6923902985],
              [-17520424.485960245, 8138433.101709004],
              [-17540893.134690877, 8126727.408988481],
              [-17563759.6052532, 8116530.536492152],
              [-17604098.449131954, 8097639.123729859],
              [-17614336.391380724, 8098682.738307129],
              [-17625447.96899323, 8108397.141664825],
              [-17630432.855790958, 8126127.44689063],
              [-17635659.86248116, 8130807.400781337],
              [-17651356.46728046, 8137867.65705216],
              [-17646402.082023215, 8149565.681942241],
              [-17657462.452669963, 8161185.733127958],
              [-17673944.86175478, 8151106.784702426],
              [-17676464.02183143, 8138296.840884203],
              [-17675323.887606725, 8127360.683126282],
              [-17684348.67004483, 8114878.938545605],
              [-17680635.608429417, 8100078.870225895],
              [-17666854.25546921, 8069421.279744915],
              [-17677013.71747697, 8053525.232049041],
              [-17686543.89040327, 8049836.786541598],
              [-17706850.680594288, 8056736.09617947],
              [-17725224.1851887, 8095080.298390622],
              [-17745415.425748277, 8131615.59322133],
              [-17759059.633095823, 8144509.98597199],
              [-17771438.583111018, 8146974.144793128],
              [-17766802.12631948, 8155501.506415357],
              [-17768385.20079805, 8165617.900584494],
              [-17779071.203997254, 8165157.8054679865],
              [-17783086.386710677, 8153596.600553878],
              [-17788066.820728775, 8142437.143645623],
              [-17800920.103094235, 8132966.784239412],
              [-17808819.111521944, 8144924.279436951],
              [-17827875.2272339, 8151493.886433078],
              [-17837032.368546557, 8159047.254986745],
              [-17847066.03952972, 8170441.011263644],
              [-17839682.2177054, 8179193.897761978],
              [-17846493.634708058, 8195635.287055819],
              [-17868606.80627618, 8182816.67792],
              [-17892489.846428424, 8163371.620250856],
              [-17902788.903077632, 8143547.907266237],
              [-17908189.45685398, 8154166.255069894],
              [-17922560.58047641, 8147970.452130351],
              [-17925938.01441618, 8145843.497567745],
              [-17925938.793063514, 8180255.691100306],
            ],
          ],
          [
            [
              [-17931175.039271444, 8102034.5350050675],
              [-17928738.144298486, 8116297.816480256],
              [-17913375.0526936, 8125889.707017456],
              [-17889111.96779979, 8141017.370662732],
              [-17886738.85889506, 8133036.154275052],
              [-17909137.00835961, 8090440.188489883],
              [-17918142.866484277, 8084548.184761793],
              [-17930857.11080574, 8083735.895700691],
              [-17931175.039271444, 8102034.5350050675],
            ],
          ],
          [
            [
              [-17963061.950811725, 8142877.988390975],
              [-17930647.656776372, 8142878.591530184],
              [-17947144.488142688, 8132502.472625701],
              [-17960062.001854338, 8125026.568975931],
              [-17960239.963787332, 8124259.982084658],
              [-17963075.086511638, 8124265.425439454],
              [-17963061.950811725, 8142877.988390975],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madera',
        GEOID: '06039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13411404.005898057, 4452550.839993272],
              [-13383640.256977266, 4461907.179169868],
              [-13370181.619220871, 4462431.440746498],
              [-13364133.631286072, 4464660.50665271],
              [-13331823.594361288, 4497407.677932861],
              [-13319509.654928716, 4497508.313087735],
              [-13319507.539858393, 4503609.755542777],
              [-13312054.477310803, 4508287.187965702],
              [-13311983.789434146, 4517500.731251865],
              [-13281416.570457222, 4548109.981025912],
              [-13276962.009713639, 4542652.971746509],
              [-13260857.752939047, 4541908.901982771],
              [-13249508.842172164, 4521068.50932133],
              [-13278930.026991373, 4491498.665696229],
              [-13284332.47319906, 4482513.657117073],
              [-13283818.62242956, 4467830.349167641],
              [-13287400.549684817, 4462438.146099145],
              [-13295227.423082488, 4461644.010510356],
              [-13299433.518722624, 4454526.9750138195],
              [-13303428.663927702, 4460112.9012991125],
              [-13310163.604440186, 4455280.510406332],
              [-13309689.94000686, 4448044.573242947],
              [-13314357.454936333, 4449010.129948414],
              [-13316161.72124311, 4442815.830233848],
              [-13325539.275147535, 4439078.073546085],
              [-13326410.461482482, 4437941.2963713175],
              [-13337603.858920729, 4418276.609243214],
              [-13350806.795806775, 4417290.47660781],
              [-13361471.759622224, 4413279.8382777255],
              [-13364770.4900929, 4414444.433761993],
              [-13383850.984773342, 4407052.561816313],
              [-13399555.60457598, 4409172.440708343],
              [-13409127.967589296, 4420008.857346885],
              [-13408470.625996161, 4426732.531435709],
              [-13418640.218077581, 4445312.027165317],
              [-13411404.005898057, 4452550.839993272],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '16051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12545176.954264736, 5461101.01470699],
              [-12545121.517158322, 5474494.084047609],
              [-12485141.573643489, 5474388.129623342],
              [-12485189.997621983, 5460993.667989576],
              [-12465224.401670245, 5460941.387189503],
              [-12465205.811315285, 5454211.712835335],
              [-12465949.202874802, 5427421.805600809],
              [-12460475.623512497, 5429325.929437789],
              [-12436319.182690866, 5412257.102339379],
              [-12426154.266028058, 5407862.331101797],
              [-12525653.63064992, 5407841.877304548],
              [-12538942.61750235, 5407834.3417064445],
              [-12545386.23490743, 5407306.249987481],
              [-12545176.954264736, 5461101.01470699],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Peoria',
        GEOID: '17143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10017202.822970925, 4970007.107073899],
              [-10017137.701068811, 5008580.409725721],
              [-9978537.444997262, 5008464.225546851],
              [-9957271.637393061, 5008396.25549679],
              [-9960014.215687735, 5000726.50449813],
              [-9970040.09430654, 4981950.653955491],
              [-9969216.330074668, 4975189.138997938],
              [-9969035.992499584, 4969146.834818645],
              [-9973353.29631102, 4965991.878154624],
              [-9982620.309961088, 4946768.596597311],
              [-9993196.552142374, 4946652.998773586],
              [-10004556.81749732, 4940791.088585987],
              [-10004673.369004179, 4957109.638205603],
              [-10017531.660746729, 4957308.08109418],
              [-10017202.822970925, 4970007.107073899],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grundy',
        GEOID: '17063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9862457.153541232, 5079989.603310198],
              [-9824193.416290352, 5080885.60469611],
              [-9824192.080456464, 5080839.109205385],
              [-9823293.175568307, 5042118.2180132335],
              [-9822987.71488557, 5031384.986911402],
              [-9824112.153062072, 5029203.418085707],
              [-9861375.128090722, 5028328.002622406],
              [-9862457.153541232, 5079989.603310198],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '18071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9608890.611786064, 4728665.599815546],
              [-9582412.046386484, 4728874.87889708],
              [-9557955.265578693, 4727533.274329472],
              [-9551079.171951883, 4731493.5266292365],
              [-9550695.45366712, 4694136.132495411],
              [-9551719.259023944, 4690193.851362486],
              [-9558955.582522962, 4682523.474419429],
              [-9561045.605962606, 4683703.881207276],
              [-9563421.497854607, 4686939.42747788],
              [-9583684.762124723, 4690692.657954092],
              [-9604120.34896659, 4687893.488160881],
              [-9604688.968925562, 4720386.4920332655],
              [-9608817.252241628, 4720363.862783445],
              [-9608890.611786064, 4728665.599815546],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hancock',
        GEOID: '18059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9568320.223366456, 4845055.570366435],
              [-9566581.858198225, 4847041.710171692],
              [-9566528.424842646, 4855359.669317918],
              [-9558168.553723052, 4857752.380403519],
              [-9526298.117467409, 4858062.817408493],
              [-9528578.608555803, 4847493.378448152],
              [-9528605.10259461, 4834968.124995941],
              [-9532676.612970375, 4834918.581163077],
              [-9532647.335944297, 4822219.86655878],
              [-9568101.814525519, 4822028.022234917],
              [-9568320.223366456, 4845055.570366435],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rice',
        GEOID: '20159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10962785.42076961, 4653409.008216801],
              [-10900879.761383545, 4653539.057370925],
              [-10900642.316909682, 4603994.781755048],
              [-10933346.647470856, 4601876.200508479],
              [-10961941.285070924, 4603859.410621328],
              [-10961903.547763545, 4613193.701273118],
              [-10962725.753522545, 4616332.482413575],
              [-10962785.42076961, 4653409.008216801],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sheridan',
        GEOID: '20179',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11212122.823750053, 4803367.287550644],
              [-11152025.660811415, 4803202.08634482],
              [-11149945.767445432, 4803257.971412708],
              [-11150227.739715613, 4740607.305226774],
              [-11212243.38275858, 4740795.304652986],
              [-11212122.823750053, 4803367.287550644],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nance',
        GEOID: '31125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10941742.363466486, 5083509.472749088],
              [-10920388.947423028, 5083516.902188369],
              [-10913910.709656313, 5087939.476038959],
              [-10890368.641104368, 5090264.754369294],
              [-10876318.006295934, 5090357.241892052],
              [-10876333.368385663, 5070761.419252261],
              [-10876526.173743717, 5058046.345284847],
              [-10915225.281523092, 5055673.85451402],
              [-10920614.146752903, 5051366.007544066],
              [-10939968.376061205, 5051410.436029219],
              [-10941212.482690308, 5070616.292663933],
              [-10941750.712428294, 5070615.699103638],
              [-10941742.363466486, 5083509.472749088],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'East Baton Rouge',
        GEOID: '22033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10163208.799178438, 3587319.4274164536],
              [-10158395.455716029, 3594534.8128350955],
              [-10113268.983177233, 3596349.734251647],
              [-10113431.28699481, 3593883.9810297643],
              [-10120132.942979546, 3587298.3359017507],
              [-10128500.272505023, 3578859.794055776],
              [-10129130.674781386, 3563051.441911777],
              [-10118020.878280725, 3548005.38315558],
              [-10128622.946583876, 3548067.944316803],
              [-10132412.929967424, 3544941.5554825943],
              [-10144166.37576385, 3543888.1212711316],
              [-10145892.718427073, 3545174.2023233715],
              [-10156738.46509557, 3548823.2174390047],
              [-10152232.47474724, 3557946.179490222],
              [-10151904.972805327, 3561873.8159651123],
              [-10152024.418618947, 3568715.763160284],
              [-10153373.722166853, 3570953.9058989985],
              [-10161407.649817403, 3568773.517504062],
              [-10157464.713453505, 3572616.134548485],
              [-10165170.693884179, 3580171.051105648],
              [-10163208.799178438, 3587319.4274164536],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shiawassee',
        GEOID: '26155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9391790.665422408, 5331544.033629908],
              [-9342942.33702843, 5332204.50957098],
              [-9342211.747210355, 5278669.849924869],
              [-9368446.745564077, 5278035.586301393],
              [-9391319.56133737, 5277905.007931564],
              [-9391776.082569113, 5329941.086704119],
              [-9391790.665422408, 5331544.033629908],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hocking',
        GEOID: '39073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9210655.820144244, 4788982.467003145],
              [-9209630.456314545, 4801405.121668217],
              [-9197226.125455452, 4802782.886077455],
              [-9196943.151309855, 4809227.773228667],
              [-9183426.404779263, 4808396.109415944],
              [-9182781.419649608, 4816903.120969447],
              [-9169890.845254727, 4815927.818751337],
              [-9170487.406405888, 4807513.22857372],
              [-9157358.830939693, 4806625.369698562],
              [-9157538.277958853, 4802515.750728499],
              [-9145915.96652258, 4801712.510442372],
              [-9146830.79009792, 4788687.869204373],
              [-9159413.343461774, 4789639.46711002],
              [-9160443.382710082, 4776854.581195737],
              [-9185469.785352265, 4778521.3965296885],
              [-9185814.987093214, 4774733.723510411],
              [-9211531.01398086, 4774546.098037952],
              [-9210655.820144244, 4788982.467003145],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Etowah',
        GEOID: '01055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9610478.139044266, 4034241.3495649896],
              [-9607263.454789137, 4042112.880009625],
              [-9596419.934510456, 4052008.3295024065],
              [-9585598.900768915, 4053846.561082843],
              [-9585285.647721821, 4055790.611985311],
              [-9556067.732292801, 4055689.6665659687],
              [-9555817.040799536, 4043675.362533873],
              [-9550886.255274339, 4042261.5633936194],
              [-9544419.038137212, 4024567.7605573162],
              [-9544640.897882363, 4020117.836117],
              [-9556352.37623076, 4023064.5311294673],
              [-9570044.22832037, 4017340.3805731847],
              [-9572938.423761504, 4010675.3885668404],
              [-9575844.085110191, 4008879.2231595377],
              [-9580742.254024586, 4007632.7033529514],
              [-9589363.391989069, 4015300.682573915],
              [-9595647.043285878, 4027314.0813404005],
              [-9605772.998126907, 4026616.0950634535],
              [-9609724.283452615, 4020768.059200157],
              [-9614681.340377638, 4020717.473039238],
              [-9610478.139044266, 4034241.3495649896],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '42125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8963347.43752249, 4868327.2226065975],
              [-8963343.471259862, 4889172.5802888675],
              [-8963338.420643736, 4915780.712951546],
              [-8963337.384392204, 4924188.117988006],
              [-8963335.984677989, 4935555.816670374],
              [-8945731.462062927, 4935581.552101138],
              [-8925851.136841137, 4914340.60331918],
              [-8896001.260662884, 4902705.646206291],
              [-8900669.33218981, 4897028.148154015],
              [-8891152.851560874, 4894671.696787847],
              [-8894971.666692538, 4888380.085134843],
              [-8891909.824098269, 4884384.490206646],
              [-8887636.714124678, 4879116.917762945],
              [-8891872.30942987, 4871295.177419498],
              [-8905338.18295317, 4863518.973895423],
              [-8939110.512709016, 4868930.307270044],
              [-8963351.978724808, 4860450.813601163],
              [-8963347.43752249, 4868327.2226065975],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wilbarger',
        GEOID: '48487',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11073539.07459118, 4040304.23365899],
              [-11073508.81094473, 4082217.410263046],
              [-11073057.6177935, 4082163.448124963],
              [-11067431.864687279, 4080004.1747705573],
              [-11064595.88933983, 4088320.730918084],
              [-11059636.717344481, 4087643.681017535],
              [-11051280.297129104, 4080831.7102844836],
              [-11045298.867211971, 4072575.87295623],
              [-11044184.79278594, 4071038.843327189],
              [-11041725.856553808, 4057615.3216307885],
              [-11035274.00150641, 4056947.6452232855],
              [-11027175.17459273, 4055857.909430446],
              [-11020954.196169237, 4056870.9187987144],
              [-11015322.41929021, 4056317.4134051073],
              [-11015420.059003938, 4006537.352297151],
              [-11073578.704329904, 4006534.6720119263],
              [-11073539.07459118, 4040304.23365899],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Uintah',
        GEOID: '49047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12249368.78457468, 4803169.883979646],
              [-12240929.765297132, 4826188.224858339],
              [-12232128.512396544, 4837824.844878005],
              [-12242562.93354656, 4837823.975436618],
              [-12242517.069916354, 4984310.789903926],
              [-12230695.49659156, 4977568.658477111],
              [-12192322.33228123, 4986764.913005923],
              [-12187829.588952305, 4974141.963735047],
              [-12177736.139402587, 4981567.621346087],
              [-12177739.03370935, 4991443.637002372],
              [-12156450.182970552, 4991478.225186177],
              [-12156350.663345782, 4980800.425022226],
              [-12152016.884249711, 4980821.15529179],
              [-12151753.947612455, 4965816.012801908],
              [-12139196.747267975, 4962702.165985387],
              [-12139195.550578102, 4961381.375220222],
              [-12139471.969350098, 4898350.884187951],
              [-12139498.784871025, 4892257.671170732],
              [-12139458.93249332, 4847789.860358796],
              [-12139487.53328266, 4816724.938967974],
              [-12139509.231790349, 4793221.250607766],
              [-12145732.565035958, 4788063.806105635],
              [-12239950.821695097, 4788038.140755459],
              [-12247811.53621797, 4789114.844160903],
              [-12249368.78457468, 4803169.883979646],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bedford',
        GEOID: '51019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8888580.369448133, 4482314.634139649],
              [-8881976.34065682, 4488161.488676415],
              [-8880914.909312107, 4492456.862553854],
              [-8882425.403482681, 4492322.23342042],
              [-8884876.436030967, 4495521.297712855],
              [-8882236.716945786, 4496241.053325449],
              [-8874286.946830276, 4501871.73291476],
              [-8871056.900485419, 4505716.831662867],
              [-8867576.830564238, 4506928.280089645],
              [-8864839.26164665, 4503002.522712078],
              [-8863939.577522058, 4502758.938268142],
              [-8862944.047315896, 4503142.197173332],
              [-8859754.187307214, 4501961.333462582],
              [-8849754.691407727, 4513634.320159371],
              [-8842560.001398267, 4519184.887720007],
              [-8842880.49021226, 4525469.16259766],
              [-8832274.303087948, 4511559.475476286],
              [-8814912.024747903, 4504236.518405175],
              [-8823960.518237546, 4501719.035153208],
              [-8822955.19191619, 4488819.680361753],
              [-8831028.304027501, 4472391.490206668],
              [-8843538.61104183, 4446896.790069627],
              [-8847664.334009608, 4439948.021809805],
              [-8860371.23124468, 4444991.393292573],
              [-8868877.821453141, 4459982.595467133],
              [-8874197.77991815, 4465584.404205707],
              [-8888551.537700018, 4470572.221351402],
              [-8889796.980163012, 4476410.458226489],
              [-8888580.369448133, 4482314.634139649],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Weston',
        GEOID: '56045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11697372.053843306, 5492747.357419419],
              [-11619025.730181472, 5493591.7601842545],
              [-11583394.852266854, 5493399.414850754],
              [-11583395.944631435, 5487300.845671763],
              [-11583403.938405588, 5442795.339374613],
              [-11583353.176717786, 5397387.144193825],
              [-11583326.714332452, 5388899.945946368],
              [-11677408.01636444, 5388334.025627237],
              [-11697429.494700557, 5388150.638003896],
              [-11697372.053843306, 5492747.357419419],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calhoun',
        GEOID: '01015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9589680.095940378, 3985793.6902966113],
              [-9578373.486579996, 3997102.61078783],
              [-9580742.254024586, 4007632.7033529514],
              [-9575844.085110191, 4008879.2231595377],
              [-9572938.423761504, 4010675.3885668404],
              [-9570044.22832037, 4017340.3805731847],
              [-9556352.37623076, 4023064.5311294673],
              [-9544640.897882363, 4020117.836117],
              [-9544419.038137212, 4024567.7605573162],
              [-9522515.703809237, 4022993.6694841185],
              [-9521166.511580821, 4020939.27556083],
              [-9533184.00720941, 3998407.44600062],
              [-9535161.15268539, 3978848.723160142],
              [-9550773.043352202, 3969367.73918364],
              [-9550606.620713465, 3973288.3604414132],
              [-9572912.37500066, 3973409.9617589964],
              [-9579116.655500531, 3985190.66055101],
              [-9589680.095940378, 3985793.6902966113],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crenshaw',
        GEOID: '01041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9629083.967415962, 3718141.0294763343],
              [-9623418.027973568, 3718189.4167689425],
              [-9623369.38135609, 3758668.5287587717],
              [-9618561.158590257, 3758556.47171487],
              [-9618702.645663053, 3769971.702964224],
              [-9607274.586738218, 3770094.242182577],
              [-9607118.850770598, 3758725.738611637],
              [-9594780.421050053, 3758907.867200004],
              [-9595670.865656909, 3735835.2557287877],
              [-9589989.23016631, 3735900.870428328],
              [-9589856.537333284, 3719174.5977852745],
              [-9593477.203771336, 3713063.657425993],
              [-9589717.165330812, 3713237.126242147],
              [-9589500.648921218, 3702775.116545924],
              [-9595159.463916205, 3701766.055855344],
              [-9595066.734780373, 3690033.720587243],
              [-9604315.158075478, 3692060.1656549354],
              [-9604662.920164715, 3701578.1232797606],
              [-9617841.032804314, 3691502.0442070775],
              [-9617997.325369388, 3701397.6375973662],
              [-9629048.345178908, 3701162.9579651547],
              [-9629083.967415962, 3718141.0294763343],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Douglas',
        GEOID: '08035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11712795.591931695, 4758999.599588972],
              [-11707613.113037815, 4780118.612478137],
              [-11696677.86549872, 4800079.805103194],
              [-11694453.145475216, 4802656.104196339],
              [-11693972.245274989, 4803086.273837895],
              [-11677906.05976625, 4803070.96704817],
              [-11650767.592425248, 4803060.425593382],
              [-11651020.28766935, 4740242.223201245],
              [-11692280.634292895, 4740284.126600235],
              [-11725195.136052685, 4740265.470955942],
              [-11712795.591931695, 4758999.599588972],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Johnston',
        GEOID: '40069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10790583.07407168, 4073558.2172824293],
              [-10784744.144140592, 4073600.815984576],
              [-10784722.882117849, 4096956.6838514134],
              [-10778764.395053647, 4096948.0383768],
              [-10743874.306290748, 4096866.9873751514],
              [-10743865.512050975, 4085279.994059226],
              [-10732014.884339087, 4085121.0291187842],
              [-10732049.393381232, 4049945.467066403],
              [-10737192.242536392, 4044174.3212431953],
              [-10751832.536687559, 4044181.447462544],
              [-10755776.474926874, 4050580.9819591027],
              [-10790606.896442708, 4051995.2781937644],
              [-10790583.07407168, 4073558.2172824293],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Issaquena',
        GEOID: '28055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10147840.931746203, 3896796.288605548],
              [-10126225.681349643, 3896703.7194336713],
              [-10120537.70064807, 3896325.6559784925],
              [-10126038.66460511, 3873838.482692419],
              [-10126162.34055938, 3850631.0945260776],
              [-10099255.863037195, 3850542.500630523],
              [-10095721.023926543, 3847125.6630659807],
              [-10098915.55935384, 3844822.3271714225],
              [-10099833.054596957, 3837873.4000047515],
              [-10114551.940308625, 3839050.0957668712],
              [-10114640.773262277, 3821486.0348203853],
              [-10125997.253754536, 3817406.898226135],
              [-10126070.947257439, 3839107.1634631883],
              [-10135501.648177411, 3838736.233690581],
              [-10135563.048917893, 3838845.4733473314],
              [-10136228.862475296, 3839553.4768197155],
              [-10138924.229622904, 3842420.0710564135],
              [-10141067.797737619, 3853605.7226052275],
              [-10136418.76184362, 3858935.68915664],
              [-10142725.344955532, 3860839.9740054877],
              [-10147619.172409786, 3865613.6831214624],
              [-10148070.57294495, 3870438.202073201],
              [-10145423.506773379, 3875275.034914884],
              [-10137933.040876882, 3880534.615869534],
              [-10138097.01448682, 3887055.1054188735],
              [-10145036.56022338, 3892720.3297097967],
              [-10148560.823982406, 3895848.978902103],
              [-10147840.931746203, 3896796.288605548],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Riley',
        GEOID: '20161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10793395.227048099, 4803131.47232524],
              [-10776455.183536634, 4803134.649223399],
              [-10751276.718470028, 4803121.508423918],
              [-10765343.049326668, 4787999.498666642],
              [-10767563.316570537, 4779649.952310965],
              [-10757760.2995723, 4763703.7490956625],
              [-10749270.741245933, 4756300.795753192],
              [-10748775.369511902, 4747771.408218194],
              [-10729979.51876942, 4746465.202520819],
              [-10730174.327878311, 4727869.662109841],
              [-10742460.660077164, 4727928.283876266],
              [-10781449.532491071, 4734309.909741234],
              [-10781279.213670159, 4753091.893055278],
              [-10793726.29121372, 4753244.777432321],
              [-10793395.227048099, 4803131.47232524],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kay',
        GEOID: '40071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10849458.731562298, 4438942.902568752],
              [-10840840.261941137, 4438945.517598402],
              [-10814434.829764862, 4438963.545057124],
              [-10809195.13633486, 4438967.122292772],
              [-10770142.70049171, 4438965.7284401925],
              [-10770426.676512722, 4408776.451482172],
              [-10785687.02022761, 4404487.95125614],
              [-10790414.536362616, 4395442.60981524],
              [-10805126.96554382, 4395180.250620395],
              [-10804381.904191941, 4382616.7637449475],
              [-10849376.017856183, 4382615.377248993],
              [-10849471.307340302, 4382613.990753218],
              [-10849458.731562298, 4438942.902568752],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Beckham',
        GEOID: '40009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11131992.365259355, 4221427.891884859],
              [-11084729.577722667, 4221331.041089872],
              [-11084704.86479571, 4233250.153369341],
              [-11061165.579231035, 4233240.854249962],
              [-11061174.039512336, 4227298.549236616],
              [-11060729.76342458, 4179756.710058704],
              [-11066191.654240353, 4179453.3686153754],
              [-11107762.35960423, 4179762.4258586946],
              [-11107787.072531188, 4167973.8619513744],
              [-11119544.859787755, 4167994.389823945],
              [-11131991.828324262, 4168011.1112316023],
              [-11131991.937331311, 4188737.417956186],
              [-11131992.365259355, 4221427.891884859],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Douglas',
        GEOID: '13097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9451212.675649384, 3999393.6699236357],
              [-9432208.8800981, 4000447.083934667],
              [-9431448.011378529, 4002804.9925762573],
              [-9420198.954194888, 4002619.578716838],
              [-9415194.586486276, 3994413.061426648],
              [-9420981.530215165, 3987669.0633789836],
              [-9439507.208553491, 3974628.3174079726],
              [-9440887.347600346, 3971754.42317151],
              [-9451669.085561637, 3971659.961752841],
              [-9451212.675649384, 3999393.6699236357],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Keith',
        GEOID: '31101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11360770.188835109, 5045074.92130519],
              [-11360739.130697178, 5070803.859546559],
              [-11352877.08034041, 5070737.0829439685],
              [-11288604.545941098, 5070841.551433023],
              [-11273290.880190123, 5070770.026010137],
              [-11273367.245360807, 5019334.4881437365],
              [-11271095.659831678, 5012924.305405005],
              [-11360350.069076855, 5012915.454892307],
              [-11360769.409598673, 5019344.082535545],
              [-11360770.188835109, 5045074.92130519],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '31177',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10736184.355866749, 5113706.378735931],
              [-10701591.935422229, 5113572.676112105],
              [-10698686.705074392, 5112644.558471457],
              [-10699081.34694637, 5111458.127036745],
              [-10699818.504614402, 5103257.554872231],
              [-10696892.4717989, 5095457.32755841],
              [-10695631.555926684, 5090565.862511178],
              [-10687236.507848002, 5092916.316891506],
              [-10686005.469349204, 5087397.880002724],
              [-10684774.454670127, 5081882.712172314],
              [-10678047.083883017, 5079801.263486181],
              [-10678582.22365021, 5070036.095626734],
              [-10681665.969209217, 5070497.136167037],
              [-10723296.56445914, 5070503.22008701],
              [-10735071.940195251, 5085619.81253348],
              [-10736184.355866749, 5113706.378735931],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clark',
        GEOID: '29045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10235799.014610333, 4909755.151632785],
              [-10235061.017558353, 4954408.191387424],
              [-10234635.16933409, 4954421.301840361],
              [-10211238.372717632, 4955519.6002067765],
              [-10209851.330491103, 4954067.957375536],
              [-10206369.926107278, 4950425.355594169],
              [-10204768.261273745, 4946328.921896345],
              [-10198980.31566944, 4944592.538582511],
              [-10197794.54045351, 4938875.031580649],
              [-10192840.489154736, 4933159.680785003],
              [-10187863.394721368, 4929039.5834485255],
              [-10185521.12131559, 4924522.128401626],
              [-10176763.505655391, 4921063.79365228],
              [-10182355.528955901, 4912905.084374625],
              [-10184942.037324483, 4905244.632866423],
              [-10185394.71695839, 4902149.341083388],
              [-10235917.569868028, 4903390.036105024],
              [-10235799.014610333, 4909755.151632785],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '32017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12901245.147308463, 4586566.609796195],
              [-12801835.617515672, 4586598.558091889],
              [-12801835.617515672, 4675555.551420478],
              [-12695925.219363924, 4675561.3203054],
              [-12696005.02596275, 4660687.217348475],
              [-12696005.068174431, 4660679.35579069],
              [-12696001.283311745, 4636731.862049792],
              [-12696003.28706258, 4614797.205109343],
              [-12695977.168800302, 4600462.406839003],
              [-12695977.126982244, 4600439.471327288],
              [-12695949.853706999, 4562680.6184718525],
              [-12696180.28505294, 4543605.588095533],
              [-12696263.10675409, 4523743.38550277],
              [-12696288.598917482, 4507910.896225172],
              [-12696207.669647677, 4478838.497255557],
              [-12696182.622762248, 4451440.525270004],
              [-12696054.716667328, 4439161.984687457],
              [-12696005.8224851, 4417265.235328801],
              [-12775303.841399493, 4418702.44538063],
              [-12886675.42971446, 4417094.067822414],
              [-12901586.675506217, 4417118.270975406],
              [-12901245.147308463, 4586566.609796195],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '34039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8289215.63691135, 4953400.390669405],
              [-8284886.4219144005, 4956385.568426002],
              [-8282561.959627146, 4961536.177972268],
              [-8282700.441073692, 4963436.562886938],
              [-8288964.50014012, 4964302.204130078],
              [-8287041.678575648, 4966435.665965249],
              [-8279978.679523797, 4972239.6448780345],
              [-8279024.003570753, 4974014.141690547],
              [-8270727.807199894, 4970422.438009869],
              [-8269389.190323105, 4971445.126120272],
              [-8260935.699511755, 4966827.795599218],
              [-8252860.027052157, 4964440.173694772],
              [-8253507.127252139, 4963423.207543466],
              [-8255469.777055038, 4960277.360166626],
              [-8256634.648345974, 4960161.820560564],
              [-8259919.898247966, 4958193.115207205],
              [-8260156.351756712, 4958051.434315056],
              [-8260316.763142945, 4952448.046651298],
              [-8270035.177328178, 4952335.753562921],
              [-8271363.330172833, 4954792.715269135],
              [-8277574.512481134, 4954115.002659853],
              [-8286814.2528559575, 4953092.217499914],
              [-8289215.63691135, 4953400.390669405],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '46071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11370079.058613714, 5419279.229635167],
              [-11358314.703507192, 5417492.3304393785],
              [-11356690.552136516, 5420460.318737778],
              [-11355404.700698363, 5464595.727242082],
              [-11250400.587256774, 5464657.467926759],
              [-11250429.307685398, 5440883.33719085],
              [-11267510.392991701, 5435137.063242763],
              [-11268664.219513772, 5432847.297884314],
              [-11268675.462782342, 5371398.638922341],
              [-11366924.375564124, 5371508.472511339],
              [-11370067.1474282, 5384810.549054724],
              [-11370079.058613714, 5419279.229635167],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dewey',
        GEOID: '46041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11297435.855104202, 5627564.711526761],
              [-11297408.58182896, 5682430.384080391],
              [-11295609.88149672, 5696202.871573106],
              [-11170011.884897357, 5696280.338878697],
              [-11162470.212035093, 5681836.822030816],
              [-11166166.909685357, 5667594.248547559],
              [-11160916.971180055, 5660460.718522804],
              [-11168178.11892552, 5637173.644068743],
              [-11163079.574927697, 5624601.018702157],
              [-11175566.059570996, 5625616.528204731],
              [-11177005.977184407, 5605430.011075073],
              [-11178556.546371667, 5596896.282585384],
              [-11190907.889153143, 5584805.08884026],
              [-11199746.65672213, 5585295.388558237],
              [-11207244.135746548, 5593724.792126211],
              [-11211836.843978206, 5585530.90492743],
              [-11233284.547630364, 5587539.314952661],
              [-11245785.615126956, 5578199.057569045],
              [-11258501.3066018, 5581799.114174811],
              [-11258426.054626023, 5620588.607016255],
              [-11298985.311096553, 5620542.327638436],
              [-11297435.855104202, 5627564.711526761],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hutchinson',
        GEOID: '46067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10922084.899865264, 5388127.925814434],
              [-10905367.829293856, 5388242.101168209],
              [-10865562.873692943, 5388362.5699686855],
              [-10842679.816526495, 5388355.971000213],
              [-10842428.345796794, 5337794.80204849],
              [-10868956.337050285, 5337695.744584716],
              [-10917893.721036896, 5337628.587580832],
              [-10921498.691426747, 5341980.751124665],
              [-10922084.899865264, 5388127.925814434],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Putnam',
        GEOID: '47141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9552232.887154466, 4329086.302163911],
              [-9549002.395531643, 4333420.934319655],
              [-9524220.339171754, 4331373.796264723],
              [-9517273.66898778, 4342294.470929981],
              [-9508843.889227971, 4333173.0600791],
              [-9484883.259390645, 4321623.960422212],
              [-9475468.636095785, 4320552.798324157],
              [-9473312.37755912, 4319703.939814659],
              [-9479160.769646926, 4314327.131859138],
              [-9489581.609819066, 4314486.122575198],
              [-9491567.994812781, 4297753.373573982],
              [-9496594.849058531, 4304969.253692766],
              [-9518671.06255571, 4311911.972518598],
              [-9533913.70647156, 4302692.839361591],
              [-9547553.90631744, 4310269.525562364],
              [-9552037.744087104, 4318741.989893988],
              [-9552232.887154466, 4329086.302163911],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Maury',
        GEOID: '47119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9722558.832515582, 4253816.246877337],
              [-9713250.074056467, 4259490.698472809],
              [-9708740.410164941, 4280090.591487374],
              [-9688767.689765796, 4272616.7044394845],
              [-9685236.41287885, 4270258.409809315],
              [-9680617.98984482, 4270787.386444669],
              [-9677639.970827118, 4267738.198631539],
              [-9660529.83113372, 4260324.038074907],
              [-9668050.24197324, 4235527.854307141],
              [-9680432.420253666, 4220698.038125445],
              [-9699168.3811101, 4226026.289632018],
              [-9707791.856783893, 4222909.199261443],
              [-9710168.973190293, 4222379.7970475685],
              [-9717583.073916107, 4224476.242503917],
              [-9714788.732058214, 4232838.538125204],
              [-9717878.738483652, 4238661.525407367],
              [-9724014.112218725, 4243615.364172782],
              [-9722558.832515582, 4253816.246877337],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tarrant',
        GEOID: '48439',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10858568.55876691, 3894531.0830392023],
              [-10842349.19763884, 3894088.056984945],
              [-10837625.689005502, 3894002.8513786886],
              [-10818129.082068475, 3893951.887573969],
              [-10801584.779346777, 3893886.9886748544],
              [-10801784.931791224, 3870993.8532026242],
              [-10801863.412032235, 3866938.798759243],
              [-10801905.379480263, 3863407.4737813305],
              [-10802021.151750688, 3857021.524386549],
              [-10802044.528843755, 3854650.2535557947],
              [-10802263.605601635, 3835548.488082721],
              [-10807656.92361108, 3835649.6478558076],
              [-10832943.14594477, 3836072.1246984545],
              [-10836839.99603948, 3836140.535931918],
              [-10841000.784646861, 3836195.2123753615],
              [-10859281.114827478, 3836437.1652684878],
              [-10858568.55876691, 3894531.0830392023],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pike',
        GEOID: '42103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8383598.089819409, 5061352.444844918],
              [-8387995.7663031975, 5066728.662451402],
              [-8378540.734033179, 5067424.059947688],
              [-8354104.614780966, 5101808.777921755],
              [-8353846.397432035, 5097541.570647099],
              [-8347009.599585476, 5085848.543432892],
              [-8336756.517885961, 5079735.61277256],
              [-8326647.372288042, 5076166.491346644],
              [-8321830.114245147, 5075622.704492177],
              [-8319450.233249785, 5075354.067551168],
              [-8314999.791327361, 5065205.282179186],
              [-8322281.31053964, 5062669.863951086],
              [-8328445.961300789, 5056122.495263352],
              [-8334201.401613783, 5045995.958814083],
              [-8338414.955659798, 5035329.843839856],
              [-8346721.282104322, 5028642.699845406],
              [-8347074.061835872, 5027991.828450128],
              [-8348114.222356304, 5026073.007682596],
              [-8366384.089041099, 5034542.281524641],
              [-8363402.285160712, 5049597.919522446],
              [-8388945.989476608, 5047688.776991081],
              [-8383598.089819409, 5061352.444844918],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morris',
        GEOID: '48343',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10554065.44628997, 3943670.6271309205],
              [-10551049.801284382, 3937710.173743339],
              [-10547179.44522848, 3939046.815403093],
              [-10541045.852605263, 3936844.2964589535],
              [-10536641.385632535, 3931045.381637182],
              [-10536834.413629571, 3879321.299828314],
              [-10542610.11408989, 3879277.690123976],
              [-10544175.711408405, 3882635.0504707],
              [-10549620.68166158, 3885463.799941196],
              [-10555294.970065784, 3893032.58638694],
              [-10554065.44628997, 3943670.6271309205],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '46127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10776359.226135569, 5324715.957865402],
              [-10736998.381430265, 5324545.697202744],
              [-10737677.818155231, 5322259.913718114],
              [-10743622.724241555, 5318051.119423433],
              [-10741517.450031674, 5312746.476717695],
              [-10744584.6359615, 5308569.502459874],
              [-10742365.147954062, 5305792.78428912],
              [-10746971.659802578, 5300194.539891969],
              [-10746836.220627915, 5298069.512576349],
              [-10746544.415596914, 5293492.7575881425],
              [-10751006.768704854, 5285774.345900077],
              [-10755897.92449133, 5278432.337295464],
              [-10756212.847330783, 5270282.589578459],
              [-10752527.949546544, 5264614.467338593],
              [-10745310.439041473, 5257514.894678597],
              [-10740106.974083642, 5245437.589719592],
              [-10739765.169927096, 5244644.799545276],
              [-10741548.285530623, 5238783.50659341],
              [-10739821.052311474, 5237621.711867567],
              [-10736264.839858592, 5234759.139206811],
              [-10742477.914598238, 5233569.461765937],
              [-10745129.656188425, 5237719.114096514],
              [-10754741.76025995, 5237093.039162376],
              [-10756573.68466251, 5240265.842801749],
              [-10760003.275992295, 5246208.59761938],
              [-10765630.030973932, 5251852.185856404],
              [-10764331.934391791, 5260233.012114696],
              [-10773297.940138754, 5260815.816678581],
              [-10775910.608587671, 5266233.993400245],
              [-10776547.200238653, 5266522.545388463],
              [-10776359.226135569, 5324715.957865402],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Roberts',
        GEOID: '46109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10823403.844820224, 5770044.133198858],
              [-10807129.157905228, 5770073.8099337],
              [-10749418.796168689, 5769978.251525402],
              [-10750331.504673703, 5759836.181618871],
              [-10752026.009962559, 5750983.036412435],
              [-10756859.39093331, 5745348.563547263],
              [-10761551.84142872, 5737559.13862738],
              [-10769613.71027146, 5732654.855149529],
              [-10778638.826668033, 5725100.90762186],
              [-10781473.13222312, 5719568.083699876],
              [-10780619.97964568, 5715524.917441722],
              [-10779669.55186461, 5714272.302573822],
              [-10773615.645965477, 5706297.687112875],
              [-10769326.839943685, 5697204.124692744],
              [-10765795.451737251, 5690571.461743104],
              [-10761861.532252105, 5686334.450431139],
              [-10755436.059924029, 5685997.65646051],
              [-10749248.477347774, 5682509.634325424],
              [-10744756.179296812, 5680854.242307259],
              [-10740389.004353503, 5676200.813496738],
              [-10738999.915559033, 5673116.966364382],
              [-10797205.359259479, 5673129.688703385],
              [-10798830.289866589, 5668378.667451624],
              [-10823175.973822568, 5668502.262803507],
              [-10823270.03879229, 5709824.250984974],
              [-10823403.844820224, 5770044.133198858],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '55053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10148510.284933586, 5558296.915127124],
              [-10134951.125677, 5558242.66746975],
              [-10121429.703727797, 5558188.420136322],
              [-10121489.704933336, 5544683.096674493],
              [-10107979.5262527, 5544658.276833371],
              [-10108023.274812581, 5531050.49586527],
              [-10080953.491597401, 5531014.334954999],
              [-10053937.253057288, 5531371.5861041],
              [-10054133.509319559, 5506691.224021435],
              [-10053561.549775863, 5504017.8617633935],
              [-10053543.961296316, 5489490.9274852425],
              [-10067259.635756956, 5490411.220177388],
              [-10080360.715308927, 5490269.391938968],
              [-10119451.44505691, 5489971.932190238],
              [-10127544.37203758, 5485521.27604794],
              [-10127079.94712199, 5476417.896391925],
              [-10145219.680785736, 5476439.277794873],
              [-10146986.655063098, 5477778.813634242],
              [-10148502.38124974, 5503815.060084602],
              [-10148510.284933586, 5558296.915127124],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Naranjito',
        GEOID: '72105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7380046.535107073, 2067715.8704987797],
              [-7378041.671077886, 2076207.9335532861],
              [-7371262.648047049, 2076702.7001369507],
              [-7369877.276984126, 2074573.2608438316],
              [-7370033.235590727, 2069956.6661142416],
              [-7372454.323195991, 2067324.4745916002],
              [-7376749.251789776, 2066277.038152451],
              [-7381962.677502098, 2066752.2225382403],
              [-7380046.535107073, 2067715.8704987797],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rincón',
        GEOID: '72117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7485025.530129841, 2081351.157691331],
              [-7483712.810908308, 2078411.666842383],
              [-7478760.874679861, 2074220.4280385107],
              [-7478740.3918935545, 2073961.2892064494],
              [-7483479.512916238, 2072456.785455407],
              [-7484581.214255987, 2072685.4597708227],
              [-7488612.426976084, 2080002.430151236],
              [-7485025.530129841, 2081351.157691331],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yakima',
        GEOID: '53077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13520469.83360022, 5929608.802787105],
              [-13511955.451027405, 5956326.812489813],
              [-13511924.392889474, 5956367.195260472],
              [-13500940.276093919, 5956572.381866694],
              [-13479683.15141, 5940606.30945322],
              [-13472621.710831018, 5927609.277242868],
              [-13428978.01390959, 5927743.227397998],
              [-13428913.33728544, 5913682.50257684],
              [-13414956.544807743, 5913533.799988831],
              [-13415111.8354974, 5899404.596291681],
              [-13355337.27644308, 5899271.404309589],
              [-13347657.34477325, 5883201.713346125],
              [-13344317.31477149, 5881610.060351923],
              [-13343403.047793603, 5786899.162630407],
              [-13447538.646568025, 5786924.180255511],
              [-13527802.893736737, 5787404.019145596],
              [-13527803.227695208, 5842782.1553739775],
              [-13513488.654374098, 5843101.706979562],
              [-13519891.974123511, 5866322.81746926],
              [-13509016.727789953, 5895110.986797406],
              [-13520333.021946033, 5906855.365362045],
              [-13527886.27203534, 5921333.685090158],
              [-13520469.83360022, 5929608.802787105],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Burnett',
        GEOID: '55013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10338206.48960968, 5734817.445337758],
              [-10334984.136179183, 5737090.394135856],
              [-10333344.499529792, 5738247.165970622],
              [-10327832.29230418, 5746762.434886091],
              [-10325935.630820047, 5754001.648960363],
              [-10321668.75473794, 5761748.401720243],
              [-10314432.653877905, 5768249.2542104935],
              [-10306021.353153566, 5771739.924873264],
              [-10302138.195356224, 5775561.901220038],
              [-10294020.666768085, 5776015.818240709],
              [-10291445.735626549, 5780710.112179446],
              [-10285106.20194536, 5783481.072060145],
              [-10280550.89706261, 5782863.108869583],
              [-10279045.746227594, 5788710.075931424],
              [-10274124.756817587, 5792276.2081942335],
              [-10274102.226707628, 5805596.011195032],
              [-10246918.607226184, 5805640.317527491],
              [-10245111.669251624, 5777764.753114749],
              [-10244890.47742342, 5722833.99633751],
              [-10258635.206271157, 5722804.38189335],
              [-10258585.669097755, 5736487.491187743],
              [-10300191.885379193, 5736976.095398411],
              [-10300293.074796325, 5723176.002525783],
              [-10340099.825358238, 5723505.920361307],
              [-10338206.48960968, 5734817.445337758],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hatillo',
        GEOID: '72065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7440215.290842848, 2095115.313882336],
              [-7436066.287736935, 2095308.445779976],
              [-7432309.341511004, 2094137.1398499017],
              [-7432705.774948867, 2092528.8305693073],
              [-7432810.415270213, 2075626.0500204663],
              [-7433613.696715777, 2075148.1956347474],
              [-7439050.540646121, 2075434.78965042],
              [-7438838.477016161, 2077735.193397621],
              [-7437322.305551555, 2082899.974342026],
              [-7440215.290842848, 2095115.313882336],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lancaster',
        GEOID: '42071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8537944.90151359, 4888687.55026088],
              [-8535771.165816868, 4887579.497199426],
              [-8523325.869385162, 4894559.332276693],
              [-8494520.726628004, 4903077.299624121],
              [-8477114.477089096, 4911965.123296853],
              [-8470496.422041945, 4906378.161064868],
              [-8446185.469767094, 4885886.344073617],
              [-8453935.755355101, 4881833.244283107],
              [-8453142.38134422, 4871388.231116559],
              [-8459683.40330374, 4859031.797550314],
              [-8459351.114623722, 4846882.311265827],
              [-8471612.622576129, 4825954.620632367],
              [-8475387.068763297, 4825592.291699536],
              [-8486249.838422397, 4825574.736783532],
              [-8486272.73159666, 4825574.699786762],
              [-8486962.772301096, 4825574.119412594],
              [-8512999.98473867, 4858294.562488452],
              [-8519829.101540364, 4873408.43862317],
              [-8532027.602660984, 4874384.299930018],
              [-8534177.961264636, 4875134.5131880455],
              [-8540611.671235034, 4883405.896256553],
              [-8537944.90151359, 4888687.55026088],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Eastland',
        GEOID: '48133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11033352.62709532, 3831078.906386196],
              [-11031321.825624777, 3831073.229869594],
              [-10973458.622227378, 3831125.3747172225],
              [-10962206.559417486, 3830844.9833471966],
              [-10962151.790228015, 3802634.3968862775],
              [-10970664.72564745, 3797677.3009772217],
              [-11012213.946349602, 3773556.064533537],
              [-11033839.315909067, 3773761.93475567],
              [-11033352.62709532, 3831078.906386196],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clearwater',
        GEOID: '27029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10640238.309391009, 6110275.468844022],
              [-10600858.594244923, 6110175.7774353875],
              [-10606279.964766048, 6094444.043355906],
              [-10596914.7673251, 6085676.830769144],
              [-10595747.13718617, 6009711.32551003],
              [-10594235.084542723, 5995350.156705539],
              [-10594183.766257469, 5967004.0303149745],
              [-10636709.37021337, 5966830.189768862],
              [-10636731.411472548, 6021166.987946284],
              [-10637050.230494179, 6024054.488607022],
              [-10636954.94101006, 6052725.924863237],
              [-10639787.688092276, 6052737.001385427],
              [-10640156.823523749, 6095876.152562982],
              [-10640238.309391009, 6110275.468844022],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Iron',
        GEOID: '29093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10147143.94950359, 4536757.893786163],
              [-10146384.305298414, 4542875.5273381],
              [-10141207.503698565, 4542763.052412777],
              [-10090570.27108754, 4542031.220813036],
              [-10090875.175172823, 4529088.86633075],
              [-10078311.880080875, 4529205.8332555685],
              [-10079691.128571805, 4522848.920884895],
              [-10079949.723748917, 4483468.235959425],
              [-10080047.01698387, 4477173.252079092],
              [-10100624.424857005, 4476953.906467746],
              [-10104798.460483791, 4491318.803395848],
              [-10104324.907369956, 4523495.383795279],
              [-10128632.631379576, 4523613.552713508],
              [-10147336.30958368, 4521399.336954519],
              [-10147143.94950359, 4536757.893786163],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sweet Grass',
        GEOID: '30097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12277732.990828807, 5801824.6220214],
              [-12276526.732826568, 5809948.369636293],
              [-12276532.855398564, 5815772.0777496565],
              [-12206613.083231308, 5815578.846904449],
              [-12206609.632327093, 5801602.299409407],
              [-12201189.820278842, 5787562.474326184],
              [-12180262.31260716, 5787524.784831025],
              [-12180915.535379134, 5773943.269088273],
              [-12190219.395780655, 5773799.308887242],
              [-12190148.039987056, 5759575.899507283],
              [-12194919.082042966, 5759660.794124794],
              [-12196598.336561583, 5745717.933117328],
              [-12196393.842656996, 5717930.005942666],
              [-12210121.205664167, 5717914.570323829],
              [-12210121.205664167, 5711009.0920713395],
              [-12223858.921383983, 5711059.179395852],
              [-12223864.26471954, 5704152.1648578625],
              [-12237577.04487342, 5704149.940468657],
              [-12237572.480774298, 5676593.945263582],
              [-12252333.111295015, 5676593.945263582],
              [-12252326.098167093, 5648660.501439633],
              [-12270530.619774481, 5648660.501439633],
              [-12269568.819374027, 5676600.914717131],
              [-12269735.353332251, 5745957.696333302],
              [-12277722.972074635, 5745971.105385653],
              [-12277732.990828807, 5801824.6220214],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Granite',
        GEOID: '30039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12676468.16358174, 5862186.884355177],
              [-12669460.824275285, 5875255.890636049],
              [-12671246.38890761, 5886898.257180603],
              [-12653463.434211858, 5886488.876822569],
              [-12653482.358525293, 5895877.803608187],
              [-12632519.78521401, 5900503.994790811],
              [-12632517.113546232, 5909940.651614345],
              [-12612821.46735967, 5914721.050769171],
              [-12591972.551248487, 5895416.374144835],
              [-12583458.836592618, 5899015.421504348],
              [-12583201.799888374, 5823211.863798254],
              [-12583201.02065194, 5816210.523111492],
              [-12610776.416994305, 5816122.51049863],
              [-12610050.613914333, 5787606.418876182],
              [-12621231.098291645, 5783335.193596156],
              [-12636700.166051771, 5770753.632859189],
              [-12651277.342051659, 5774748.304276495],
              [-12655653.867832197, 5786024.873075302],
              [-12668567.374042178, 5786388.722280055],
              [-12662953.420801984, 5798443.961996444],
              [-12670515.13117259, 5814462.663512968],
              [-12662650.743106518, 5824068.5796510205],
              [-12666576.758907815, 5826634.554637576],
              [-12666157.863663958, 5838150.604245894],
              [-12673636.974972395, 5851300.071177151],
              [-12676468.16358174, 5862186.884355177],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chouteau',
        GEOID: '30015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12402003.947778422, 6128879.453968609],
              [-12337223.907820582, 6129044.079534134],
              [-12337251.18109583, 6143460.837074617],
              [-12329287.384724477, 6143466.6847603265],
              [-12314779.11548939, 6143488.404770828],
              [-12314764.198677624, 6157994.318501978],
              [-12227993.215952555, 6157909.29953376],
              [-12227979.857613659, 6143366.940497262],
              [-12214747.421062555, 6143788.146548476],
              [-12214744.19279732, 6128986.368489359],
              [-12193301.943800211, 6129270.757603427],
              [-12193789.745808868, 6063520.542202887],
              [-12210752.721135436, 6061814.115232026],
              [-12214276.316977516, 6057523.389779882],
              [-12226983.436851569, 6059081.722008415],
              [-12228534.339997299, 6030524.09699831],
              [-12248578.638829028, 6020703.318150563],
              [-12262908.240281392, 6010129.002545152],
              [-12268921.385215573, 6010350.269315662],
              [-12316339.369472349, 6010322.137687743],
              [-12316342.709057072, 6015084.264501109],
              [-12330763.035894431, 6015194.713591481],
              [-12330689.119752545, 6028297.619147405],
              [-12341394.158584682, 6028145.295200812],
              [-12362012.42071094, 6040290.010829873],
              [-12353810.845907252, 6056881.114624208],
              [-12401976.451864196, 6056779.39374301],
              [-12401939.048515288, 6104721.975972975],
              [-12402003.947778422, 6128879.453968609],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Warren',
        GEOID: '36113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8261534.26441375, 5423553.886992938],
              [-8243988.086274914, 5425989.733185174],
              [-8175094.123215319, 5435112.384352309],
              [-8181193.3181158835, 5412536.057028808],
              [-8197194.493041999, 5387966.026346934],
              [-8192553.472151336, 5358682.809247241],
              [-8208695.911511269, 5352350.443052854],
              [-8211760.314453827, 5345842.578296216],
              [-8219364.882828386, 5350676.203819526],
              [-8218253.580351799, 5358565.01960687],
              [-8224744.731179443, 5372755.335688537],
              [-8255464.569178248, 5368694.875162165],
              [-8261534.26441375, 5423553.886992938],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cabarrus',
        GEOID: '37025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8992852.334598774, 4232861.238098832],
              [-8987643.918263538, 4232832.111032761],
              [-8938445.378751524, 4232437.740897107],
              [-8960926.79519519, 4191380.301497295],
              [-8961773.936520126, 4189050.139421844],
              [-8966823.833900472, 4192239.6947504855],
              [-8972321.235633807, 4195740.763796766],
              [-8979751.477685787, 4200352.18051585],
              [-8982710.461070562, 4211052.865472956],
              [-8990876.079678722, 4218575.134928309],
              [-8992852.334598774, 4232861.238098832],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Logan',
        GEOID: '38047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11122543.47291125, 5882362.565941805],
              [-11070692.189933633, 5882152.62951988],
              [-11024706.664884387, 5881922.5968452925],
              [-11024789.263946556, 5825841.053774642],
              [-11118416.080151107, 5825786.287772466],
              [-11122682.622274743, 5825844.275314765],
              [-11122543.47291125, 5882362.565941805],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bollinger',
        GEOID: '29017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10042983.637802213, 4483100.53089248],
              [-10034973.30988371, 4482697.987662712],
              [-10035091.753821913, 4522711.793270591],
              [-10003294.454471724, 4522972.000070488],
              [-10003907.156949049, 4456715.838230921],
              [-10014254.192298794, 4456873.050652914],
              [-10018277.723974025, 4444699.079615108],
              [-10031138.1307869, 4444851.790190822],
              [-10031038.722481623, 4451082.865749178],
              [-10043566.617975498, 4451175.803033613],
              [-10042983.637802213, 4483100.53089248],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clearfield',
        GEOID: '42033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8772551.062318886, 4998483.6107491935],
              [-8772480.37444223, 5031858.663357964],
              [-8768232.979271015, 5042294.727727768],
              [-8761984.727572279, 5042161.568382674],
              [-8754906.811708663, 5049846.231974306],
              [-8709282.62972653, 5046396.34071278],
              [-8693315.407245105, 5044391.785063482],
              [-8689711.550050162, 5038120.313588714],
              [-8687173.020382114, 5035028.9747668],
              [-8695414.670202484, 5029203.2703295965],
              [-8689184.89753922, 5012956.757353838],
              [-8691574.259089608, 5006270.109034695],
              [-8701636.20522343, 5006570.972845684],
              [-8710663.325370839, 4991034.033926524],
              [-8715029.387119241, 4990204.577850712],
              [-8724834.07390984, 4976185.433469578],
              [-8722985.502445726, 4972978.697831102],
              [-8721929.971034026, 4971838.044224035],
              [-8772164.783685831, 4971795.740506986],
              [-8772685.536263764, 4974531.317046267],
              [-8772551.062318886, 4998483.6107491935],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dickens',
        GEOID: '48125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11247850.2577227, 4006483.7467118283],
              [-11189689.497326411, 4006755.1275671446],
              [-11189551.238518845, 3948233.8807923696],
              [-11247586.43052952, 3948146.9448887953],
              [-11247850.2577227, 4006483.7467118283],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Delta',
        GEOID: '48119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10670944.232453462, 3949789.2370019658],
              [-10670834.582755031, 3956751.4293552726],
              [-10667410.506537719, 3956383.9526978685],
              [-10660074.218135972, 3961244.421954459],
              [-10650117.580240438, 3958207.8405589187],
              [-10642552.418965617, 3959820.7290782086],
              [-10630109.348923728, 3955899.4724466843],
              [-10621760.498433722, 3950144.501975321],
              [-10609708.939040951, 3945940.16470581],
              [-10609486.63401784, 3945588.8945163256],
              [-10609704.040983358, 3945477.3168011517],
              [-10631214.751467304, 3941568.7751320885],
              [-10640423.322384706, 3943098.580736991],
              [-10650350.015337216, 3935473.9444724373],
              [-10655527.37353452, 3935113.5346524324],
              [-10656732.407022357, 3935887.510537447],
              [-10662924.665017223, 3929066.5501498138],
              [-10671284.313497834, 3924452.669921416],
              [-10670944.232453462, 3949789.2370019658],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Refugio',
        GEOID: '48391',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10858222.355150543, 3269750.6908261795],
              [-10839799.869980182, 3298066.919608773],
              [-10815885.326412044, 3318935.239300591],
              [-10803392.830516243, 3318491.804517933],
              [-10788584.109975506, 3310350.1257907115],
              [-10785851.32779602, 3313069.1257771873],
              [-10777228.853997646, 3303328.9578892984],
              [-10771733.901293106, 3302855.6607242706],
              [-10774670.509460235, 3289282.3440901134],
              [-10811789.77102627, 3283349.4330070023],
              [-10800616.188457387, 3272653.711313579],
              [-10814122.582275335, 3261918.2476627147],
              [-10827024.733897256, 3258528.6282269196],
              [-10833297.030606002, 3266281.219991859],
              [-10845543.06514919, 3263817.148516337],
              [-10851689.348194357, 3270249.090083562],
              [-10858222.355150543, 3269750.6908261795],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Newton',
        GEOID: '48351',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10454138.726142954, 3653294.7316202368],
              [-10421304.151777552, 3655529.927615508],
              [-10419571.473628549, 3656489.2510797926],
              [-10414216.362710254, 3656774.874244196],
              [-10412279.36933945, 3656878.1884273924],
              [-10412856.11562125, 3649496.439423161],
              [-10411847.672354152, 3639462.335584223],
              [-10412772.403364172, 3633852.8196337386],
              [-10413920.663911706, 3628479.5256286315],
              [-10411816.168938259, 3622952.320051596],
              [-10414447.745486427, 3616846.4287503874],
              [-10414897.603762908, 3615802.9495013137],
              [-10416087.163841525, 3607187.2667515525],
              [-10421473.357403558, 3598832.034391567],
              [-10422833.236303087, 3591252.646118344],
              [-10428979.96462622, 3584169.4218005096],
              [-10428891.799589511, 3579950.9468994327],
              [-10433886.259863442, 3573778.222794404],
              [-10431762.50661809, 3568810.3408819763],
              [-10430932.953772698, 3558936.1072809775],
              [-10434926.567024104, 3555362.59591838],
              [-10435682.733805865, 3554686.0870134914],
              [-10437351.96957031, 3546029.383934047],
              [-10431436.674468536, 3539013.858850216],
              [-10431867.722606016, 3534948.7106368016],
              [-10453061.82138902, 3534781.3610236337],
              [-10449083.151468577, 3625896.291408148],
              [-10454138.726142954, 3653294.7316202368],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Webster',
        GEOID: '54101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8978004.429597277, 4654084.741136083],
              [-8962182.479051337, 4671026.507082553],
              [-8956469.228825355, 4684378.338418606],
              [-8949314.836471561, 4682723.243522835],
              [-8940986.246128881, 4676550.04612039],
              [-8936735.28873396, 4678057.659029053],
              [-8926034.368722983, 4653913.420337415],
              [-8932890.202202467, 4634448.036213634],
              [-8944762.759854043, 4628325.871507011],
              [-8945639.62348302, 4611379.44756107],
              [-8954151.779666021, 4617260.280751417],
              [-8975191.831342893, 4629611.195207552],
              [-8978004.429597277, 4654084.741136083],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hamilton',
        GEOID: '47065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9514959.875909435, 4161662.63567943],
              [-9502791.782472013, 4173745.3193069],
              [-9505247.267799933, 4183898.8520742906],
              [-9489541.868760852, 4207327.421358541],
              [-9487301.230050165, 4212130.670785939],
              [-9480892.010367742, 4225970.941685786],
              [-9477206.110708086, 4226385.716407891],
              [-9473528.893968714, 4222258.208910445],
              [-9463976.011866288, 4219641.793782022],
              [-9465642.575962953, 4215570.88092488],
              [-9456183.202232795, 4203049.8020937005],
              [-9465122.602621458, 4182401.671098711],
              [-9463100.484071199, 4176484.4899388626],
              [-9457831.50993297, 4165943.557219119],
              [-9459593.453303201, 4162144.5066107847],
              [-9459914.077775491, 4162142.574012316],
              [-9467186.465980766, 4162098.739000986],
              [-9491662.507477855, 4161853.440453187],
              [-9493054.11001487, 4161839.493994413],
              [-9502667.998418845, 4161622.314801264],
              [-9505011.047840469, 4161569.3856030246],
              [-9514959.875909435, 4161662.63567943],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Johnson',
        GEOID: '56019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11952331.536386773, 5552490.970806028],
              [-11847610.619729763, 5552012.907579222],
              [-11844469.183699574, 5552817.818044538],
              [-11800943.151479915, 5553138.427231959],
              [-11801477.596355213, 5546422.215137463],
              [-11800890.274721788, 5437872.510974641],
              [-11801799.198364114, 5387617.22317266],
              [-11808556.514094247, 5387540.804344951],
              [-11921232.210243855, 5387221.478672645],
              [-11923512.367373774, 5388433.163878956],
              [-11923837.53160638, 5437025.965715501],
              [-11925476.043191368, 5489324.443678976],
              [-11927528.106684651, 5491115.273181534],
              [-11930022.108556384, 5526541.619929815],
              [-11945059.25669223, 5537495.820646997],
              [-11952331.536386773, 5552490.970806028],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Randolph',
        GEOID: '54083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8931923.169785947, 4685034.285870533],
              [-8919597.20784837, 4685329.875642418],
              [-8915028.321987743, 4714116.397973609],
              [-8893992.500451518, 4717862.639474965],
              [-8886088.593966216, 4738272.959376681],
              [-8881701.826792525, 4727030.791710018],
              [-8850875.233402051, 4718115.941524206],
              [-8834054.969662677, 4716589.065637958],
              [-8833186.788953982, 4715586.927720347],
              [-8852067.353828957, 4706214.715160936],
              [-8851020.839296008, 4690308.947422684],
              [-8864011.935191074, 4673686.608482819],
              [-8876524.913873183, 4675882.238087315],
              [-8880677.464838246, 4684469.963006476],
              [-8890336.323095905, 4657533.110581785],
              [-8908810.683148975, 4644497.744547915],
              [-8918574.738325436, 4646597.537561182],
              [-8932890.202202467, 4634448.036213634],
              [-8926034.368722983, 4653913.420337415],
              [-8936735.28873396, 4678057.659029053],
              [-8931923.169785947, 4685034.285870533],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greenbrier',
        GEOID: '54025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9003763.871086331, 4594051.143828183],
              [-8984814.399446554, 4590610.125301377],
              [-8954151.779666021, 4617260.280751417],
              [-8945639.62348302, 4611379.44756107],
              [-8946001.077869626, 4595589.562478891],
              [-8935020.300658798, 4586013.18484009],
              [-8924391.070399892, 4584528.342770582],
              [-8901327.14941054, 4588415.263638881],
              [-8902356.713031255, 4585689.483832771],
              [-8909593.036530271, 4574894.975467702],
              [-8911772.18175197, 4572630.047911998],
              [-8920245.755201733, 4563827.607780359],
              [-8927782.307367418, 4555086.913126375],
              [-8929895.485261148, 4548857.170083411],
              [-8934295.610773733, 4540032.494283863],
              [-8937845.679532306, 4535181.811339038],
              [-8949481.70438826, 4539512.6432926],
              [-8955725.503307365, 4534861.313312589],
              [-8979402.825040622, 4541592.484327199],
              [-8979946.064155692, 4545994.761963966],
              [-8995317.950000355, 4560924.413111552],
              [-8988910.511429785, 4560386.032666782],
              [-8995824.453683462, 4572243.63114398],
              [-8991260.35456094, 4577345.1668197485],
              [-9003763.871086331, 4594051.143828183],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Decatur',
        GEOID: '47039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9823172.171281815, 4235985.119997745],
              [-9817317.656622013, 4246964.945320983],
              [-9816061.082209941, 4275440.467392151],
              [-9815914.363121076, 4279430.011756736],
              [-9801863.171715185, 4279989.922591389],
              [-9792857.758868482, 4275292.205761424],
              [-9799987.77225379, 4261786.340072112],
              [-9800104.546399632, 4248710.988703492],
              [-9793291.014326649, 4234913.728445685],
              [-9800827.566492336, 4224468.180588874],
              [-9796973.351762598, 4221566.821461922],
              [-9793183.034420578, 4219050.406773736],
              [-9798869.34532979, 4217322.72799158],
              [-9817985.239608303, 4215582.349633275],
              [-9823018.55038452, 4221550.701901325],
              [-9823638.154670276, 4223741.12946301],
              [-9823172.171281815, 4235985.119997745],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Anderson',
        GEOID: '47001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9399932.9069375, 4323139.070885757],
              [-9395769.446662342, 4324697.282046636],
              [-9392329.451757848, 4330490.834262952],
              [-9377757.062496062, 4325083.422203618],
              [-9376165.4164167, 4334368.871195526],
              [-9358620.462792264, 4332367.508120131],
              [-9354457.225156086, 4342225.544361898],
              [-9351317.792876733, 4337889.029791659],
              [-9350697.520674035, 4335402.890921232],
              [-9344348.52483613, 4326297.09540338],
              [-9361302.483283946, 4310107.566924913],
              [-9357358.879003102, 4305617.896968046],
              [-9372561.336582776, 4299659.326272706],
              [-9381212.86476825, 4292438.174307781],
              [-9381070.153181054, 4288267.244840193],
              [-9386466.142858276, 4299466.569634007],
              [-9388887.56442201, 4307362.626099107],
              [-9400901.386507401, 4320133.461060938],
              [-9399932.9069375, 4323139.070885757],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Williamson',
        GEOID: '47187',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9707218.338767326, 4292448.211433076],
              [-9707531.8144534, 4295006.880859975],
              [-9706038.352164919, 4297303.554812665],
              [-9705119.6324074, 4307465.751918892],
              [-9694298.487346368, 4306650.547751357],
              [-9690776.004699195, 4306895.198938644],
              [-9689161.983402185, 4299147.242293377],
              [-9676876.541759258, 4307908.5569783375],
              [-9661516.010502657, 4305674.476139646],
              [-9642370.950517558, 4296249.9238748],
              [-9641751.568870783, 4271809.461179698],
              [-9649862.863567436, 4260797.832104584],
              [-9657149.614795782, 4258932.935179614],
              [-9660529.83113372, 4260324.038074907],
              [-9677639.970827118, 4267738.198631539],
              [-9680617.98984482, 4270787.386444669],
              [-9685236.41287885, 4270258.409809315],
              [-9688767.689765796, 4272616.7044394845],
              [-9708740.410164941, 4280090.591487374],
              [-9707218.338767326, 4292448.211433076],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '26115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9325670.338795418, 5173335.066944918],
              [-9299563.023897635, 5173810.245861529],
              [-9271149.72574807, 5174463.355602271],
              [-9261219.727907954, 5165940.141813708],
              [-9263662.599436296, 5159266.091309645],
              [-9269520.6763198, 5151852.600418369],
              [-9275810.561508091, 5149745.584960742],
              [-9277539.687158583, 5143014.36207554],
              [-9283624.744483817, 5138979.697159416],
              [-9288683.992701389, 5132358.501627859],
              [-9286725.660219355, 5122222.022972489],
              [-9290038.082987398, 5121015.01211368],
              [-9304699.955543414, 5120436.99987642],
              [-9324458.737457624, 5119658.108290761],
              [-9324471.188694643, 5119657.631280538],
              [-9325670.338795418, 5173335.066944918],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Parmer',
        GEOID: '48369',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11470799.59804958, 4079881.567086352],
              [-11470702.304814626, 4112330.3345670267],
              [-11470668.575008916, 4129601.2941442137],
              [-11413051.276366679, 4129543.0383108836],
              [-11413101.036179064, 4070912.6939339754],
              [-11423066.245675387, 4070893.421233867],
              [-11470788.944904776, 4070874.4010663335],
              [-11470799.59804958, 4079881.567086352],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rio Arriba',
        GEOID: '35039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11980001.109018348, 4411859.134803702],
              [-11977752.677943306, 4416035.720577065],
              [-11961440.142401442, 4425739.071014122],
              [-11962076.221971834, 4432831.2073663045],
              [-11958041.33570854, 4439107.484186128],
              [-11897525.72280401, 4439126.162075733],
              [-11896691.271901025, 4438051.12190105],
              [-11852880.104693986, 4438239.012682642],
              [-11838064.082838312, 4438302.554174943],
              [-11800569.163720673, 4438463.762309246],
              [-11796736.72188131, 4423262.924504499],
              [-11797760.749877116, 4399239.627656311],
              [-11793048.150553875, 4364435.137776976],
              [-11795390.980557108, 4349550.250685358],
              [-11804130.896418272, 4345524.845270809],
              [-11806363.074847657, 4341562.4076672755],
              [-11783941.436970549, 4332375.236275368],
              [-11770464.654137151, 4314408.280208412],
              [-11747588.164820662, 4302412.226161749],
              [-11751781.01344139, 4297016.340838536],
              [-11768415.70758961, 4297696.560573713],
              [-11768341.234850269, 4300940.605162316],
              [-11807786.739815412, 4300837.816577147],
              [-11805915.79313365, 4291101.394552897],
              [-11827211.545680875, 4291095.7579607675],
              [-11827491.180241749, 4295989.007828704],
              [-11827380.194709428, 4300818.690026847],
              [-11898419.061717628, 4300479.508961561],
              [-11898389.673372058, 4330462.13472535],
              [-11980680.38055117, 4330909.055893809],
              [-11980001.109018348, 4411859.134803702],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'New York',
        GEOID: '36061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8240496.052796941, 4973071.571060094],
              [-8240257.384275266, 4973692.855212489],
              [-8239176.746563339, 4976506.385358802],
              [-8235927.163055648, 4982525.0587894665],
              [-8234437.209958511, 4985285.896961288],
              [-8234089.223195105, 4985930.818471316],
              [-8233839.034537133, 4986525.895642251],
              [-8227896.965200238, 4982312.232883418],
              [-8228847.967610084, 4980202.794685577],
              [-8233465.388768698, 4973597.1889870735],
              [-8233483.97912366, 4971532.521491758],
              [-8233809.8112732135, 4970974.82024125],
              [-8241085.106132295, 4971538.360190446],
              [-8240496.052796941, 4973071.571060094],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Swift',
        GEOID: '27151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10699699.504078744, 5686616.231765348],
              [-10658552.035418862, 5686666.975547523],
              [-10603761.027328378, 5686700.59346155],
              [-10603759.914133469, 5659180.418074689],
              [-10602790.766646622, 5645543.214887971],
              [-10690756.318827394, 5645515.117647969],
              [-10698205.373873316, 5649378.364517944],
              [-10699812.827320373, 5659349.891675221],
              [-10699699.504078744, 5686616.231765348],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Okmulgee',
        GEOID: '40111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10708107.131259887, 4251073.26664902],
              [-10708086.982432054, 4280969.183415085],
              [-10702429.61459045, 4280998.5763354665],
              [-10690357.795050355, 4280938.417078742],
              [-10666629.600309806, 4280811.50686021],
              [-10660640.834344108, 4280880.593083614],
              [-10660651.854973696, 4262950.316605474],
              [-10654731.439175349, 4262958.1326286765],
              [-10654717.635558488, 4239123.984228709],
              [-10666896.433129236, 4239109.070311608],
              [-10667011.648802208, 4227112.805736296],
              [-10672819.854553835, 4227065.789483409],
              [-10672825.86580634, 4215190.37233385],
              [-10684590.220912864, 4215209.213138883],
              [-10696414.911183398, 4215215.902997696],
              [-10696444.410848457, 4239167.357845972],
              [-10708138.4120368, 4239137.666739297],
              [-10708107.131259887, 4251073.26664902],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lawrence',
        GEOID: '28077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10046048.708661713, 3726288.110998929],
              [-10040508.448924422, 3727647.9948349437],
              [-10032398.044783698, 3730889.637915442],
              [-10015925.097855601, 3732064.6448806743],
              [-10016088.292229105, 3700790.2484517996],
              [-10014183.39310265, 3683566.0873676147],
              [-10023260.940979386, 3684111.718564835],
              [-10023258.825909061, 3676464.2748702993],
              [-10025504.140038362, 3675521.630370663],
              [-10030849.1453888, 3678400.48774701],
              [-10045903.882004192, 3678322.9290807983],
              [-10046048.708661713, 3726288.110998929],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pulaski',
        GEOID: '21199',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9451148.555622688, 4455329.510214344],
              [-9431066.51948358, 4472378.9058054],
              [-9412782.181801295, 4488807.496439166],
              [-9406823.360778622, 4485037.040669232],
              [-9384588.294368083, 4462286.857616023],
              [-9383017.019755535, 4460278.544259485],
              [-9384568.813457195, 4444460.04666091],
              [-9390692.27600675, 4433449.180725056],
              [-9397236.971509468, 4431710.700053388],
              [-9415197.480793037, 4420602.98702623],
              [-9426441.528599592, 4436446.778779375],
              [-9436572.381498218, 4433217.227532419],
              [-9443868.260924809, 4438773.936073344],
              [-9451667.97236673, 4445686.089044498],
              [-9451148.555622688, 4455329.510214344],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Robertson',
        GEOID: '21201',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9368874.435047705, 4658003.562208852],
              [-9360159.788710952, 4665760.093279574],
              [-9349902.69950977, 4663638.705865874],
              [-9347562.763813296, 4662661.987216596],
              [-9343083.601462247, 4649203.5054356605],
              [-9348618.40654449, 4641692.435770236],
              [-9350751.176668596, 4639253.62314531],
              [-9362202.946644973, 4644525.466009695],
              [-9367509.435451597, 4647328.279386429],
              [-9371309.214950336, 4650020.059866349],
              [-9368874.435047705, 4658003.562208852],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fergus',
        GEOID: '30027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12268921.385215573, 6010350.269315662],
              [-12262908.240281392, 6010129.002545152],
              [-12248578.638829028, 6020703.318150563],
              [-12228534.339997299, 6030524.09699831],
              [-12226983.436851569, 6059081.722008415],
              [-12214276.316977516, 6057523.389779882],
              [-12210752.721135436, 6061814.115232026],
              [-12193789.745808868, 6063520.542202887],
              [-12181170.34569356, 6060423.900094005],
              [-12164345.072577102, 6072525.8436535485],
              [-12148604.16262046, 6070518.274464441],
              [-12131418.10303434, 6074086.726114255],
              [-12121703.473711794, 6062790.924709207],
              [-12108401.239839962, 6048083.79953117],
              [-12081066.51623669, 6044003.693690558],
              [-12059888.205752252, 6035185.003260341],
              [-12057353.349627398, 6037866.435357617],
              [-12057624.1899485, 5993667.472581755],
              [-12088276.457016388, 5992249.587943787],
              [-12088307.18119585, 5986278.987186767],
              [-12102564.75893767, 5986312.946997216],
              [-12104529.436630681, 5958120.511246431],
              [-12090293.454870073, 5958105.466839811],
              [-12090534.127609167, 5915472.338208112],
              [-12092799.033968847, 5901263.972949763],
              [-12134889.823993709, 5901476.804648991],
              [-12177150.932839487, 5901582.247613163],
              [-12177138.019778557, 5892208.471256526],
              [-12177145.923462402, 5892208.471256526],
              [-12216840.45012845, 5892285.075835973],
              [-12218056.170287402, 5906301.348525317],
              [-12226823.4707433, 5910979.73147222],
              [-12217917.800160347, 5925118.862953583],
              [-12218045.260977305, 5972436.906657047],
              [-12230893.422646191, 5972376.138707055],
              [-12230947.969196681, 5979513.954259583],
              [-12245146.65892787, 5979486.578158544],
              [-12245176.158592932, 5986606.778729529],
              [-12259359.374914903, 5986570.192773655],
              [-12259387.538746074, 6000873.434346349],
              [-12268886.764853936, 6000832.51554723],
              [-12268921.385215573, 6010350.269315662],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Polk',
        GEOID: '41053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13772966.483729376, 5628519.109557825],
              [-13772933.644479591, 5633529.702972708],
              [-13699941.34304695, 5633314.370131894],
              [-13697295.94666774, 5612714.140163973],
              [-13704582.141298633, 5610617.737635105],
              [-13712435.954013078, 5599123.928890862],
              [-13702687.37224584, 5592293.872710071],
              [-13708309.897086827, 5582079.368370698],
              [-13708886.754688116, 5577583.651046615],
              [-13725902.718092304, 5577522.551355302],
              [-13759379.494600093, 5577729.195303639],
              [-13770718.275293313, 5577729.195303639],
              [-13773004.109717263, 5580532.749164615],
              [-13772966.483729376, 5628519.109557825],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Banks',
        GEOID: '13011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9314065.059241237, 4078094.127846162],
              [-9308007.16387176, 4086923.6177178267],
              [-9299344.837695679, 4095022.5593657875],
              [-9290699.09812373, 4093592.069333626],
              [-9283866.975695783, 4090856.5198433097],
              [-9283368.153057538, 4072498.6935968096],
              [-9277137.267199367, 4063843.701540165],
              [-9279064.096265506, 4058891.823704641],
              [-9284315.815882662, 4055352.246195114],
              [-9292991.277758654, 4064041.832440348],
              [-9302025.967631437, 4062785.760033357],
              [-9308548.621874977, 4068519.626006916],
              [-9314065.059241237, 4078094.127846162],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Mary',
        GEOID: '22101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10234189.223453972, 3461449.9787178705],
              [-10209238.40674604, 3483778.241185596],
              [-10199615.949961869, 3496517.392771951],
              [-10182611.00718727, 3497893.8933280366],
              [-10171667.299366875, 3482281.3467919175],
              [-10173097.643504078, 3475774.248342458],
              [-10154029.060009154, 3471610.255943989],
              [-10141206.72446213, 3464968.9982532067],
              [-10141806.179920053, 3457778.8602436907],
              [-10139268.8747664, 3455612.778370413],
              [-10149893.874884656, 3453478.8139873943],
              [-10160267.96087066, 3443941.1727270614],
              [-10158831.048883501, 3432320.3530357503],
              [-10153831.356593505, 3428892.2526831897],
              [-10156322.241519494, 3423326.472777538],
              [-10159720.566279061, 3421720.4322071807],
              [-10167260.049406879, 3425573.400945672],
              [-10170590.28329345, 3429296.86481229],
              [-10168758.743711429, 3432335.564924297],
              [-10173967.716644118, 3439071.0711812773],
              [-10181387.828622432, 3435598.60773918],
              [-10184129.293722201, 3439326.9966118154],
              [-10189186.64950843, 3443475.075212683],
              [-10189901.765917284, 3447869.9559023213],
              [-10190405.931891087, 3451513.5482977126],
              [-10196885.282852711, 3456225.9502361445],
              [-10201744.712584307, 3456157.946656317],
              [-10199517.988809971, 3464948.2372799856],
              [-10204338.011441829, 3470919.294554782],
              [-10212144.290733708, 3471374.2042781357],
              [-10220035.618116552, 3468262.3432731344],
              [-10225036.980198912, 3465421.903371699],
              [-10226093.067820966, 3460867.8774255896],
              [-10234189.223453972, 3461449.9787178705],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bossier',
        GEOID: '22015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10443388.270454017, 3897877.817687168],
              [-10442314.567381844, 3897878.7709986735],
              [-10433227.025838964, 3897886.839580648],
              [-10410709.380886873, 3897791.9537119335],
              [-10411762.512943696, 3892066.913423978],
              [-10404985.159705222, 3884387.357341632],
              [-10402574.424812602, 3877621.8340808214],
              [-10405455.484553821, 3866558.911739145],
              [-10402221.208068315, 3863645.483572761],
              [-10401828.138946323, 3817307.4760180144],
              [-10394210.434871847, 3817270.819233101],
              [-10399843.089786498, 3815634.1692891708],
              [-10397565.826963339, 3811809.6920760972],
              [-10400378.536537215, 3794315.7623150074],
              [-10405171.842491282, 3794485.4026657287],
              [-10411133.446501223, 3799331.7636882453],
              [-10413351.709994262, 3806373.857805324],
              [-10417545.337851426, 3806511.129782661],
              [-10426076.752306331, 3816730.869960918],
              [-10429029.835758096, 3815338.5863228003],
              [-10428447.078223795, 3824226.291082419],
              [-10436893.110629259, 3834013.3690036866],
              [-10435030.512909308, 3841111.0480166045],
              [-10439776.84203826, 3857166.924914469],
              [-10443902.119728077, 3860314.8423826336],
              [-10439901.742506929, 3866716.214463382],
              [-10444468.06801927, 3867787.597230362],
              [-10440118.592874995, 3876385.2302594264],
              [-10446510.112758383, 3888239.904757992],
              [-10443388.270454017, 3897877.817687168],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Bernard',
        GEOID: '22087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10020101.359872201, 3496607.964365713],
              [-10001532.72552117, 3505655.7502135816],
              [-10002343.786020348, 3497474.0153882345],
              [-9996041.544368578, 3495069.362211461],
              [-9990286.660653038, 3492968.519389388],
              [-9985550.350278256, 3487374.890522568],
              [-9979465.515592007, 3486029.1736123036],
              [-9974018.096310038, 3488315.166247769],
              [-9971379.379100272, 3501459.6862529013],
              [-9962433.633500636, 3508817.5000083535],
              [-9956929.32995887, 3511387.963629973],
              [-9945524.091529647, 3511158.1222019806],
              [-9941167.38061847, 3515325.7519847415],
              [-9933390.823630633, 3520909.129830784],
              [-9927834.645206159, 3522761.10301225],
              [-9928117.730671247, 3511770.6131513305],
              [-9931443.511778187, 3502717.3127123765],
              [-9933169.297843955, 3493975.098053999],
              [-9933739.253636815, 3487759.517085519],
              [-9940079.232595965, 3478259.1804538057],
              [-9937606.047469012, 3472269.838821351],
              [-9951869.191185372, 3474095.536637267],
              [-9952402.856824234, 3462714.4496177505],
              [-9959260.805374045, 3458862.1016700338],
              [-9963202.04446455, 3456520.434854801],
              [-9965164.96852674, 3458526.3729150333],
              [-9977363.469647357, 3462570.17399293],
              [-9987701.042840382, 3472436.150345614],
              [-10004251.468134074, 3477283.980946029],
              [-10008814.23142271, 3486576.4036379238],
              [-10009962.046692278, 3492722.184911916],
              [-10020101.359872201, 3496607.964365713],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shelby',
        GEOID: '17173',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9922997.924650682, 4771770.715504838],
              [-9910277.001159772, 4771332.673272844],
              [-9910293.365124919, 4815815.618107091],
              [-9886347.986057833, 4815676.6703436775],
              [-9886178.335153863, 4805130.229252783],
              [-9875980.02264382, 4804999.229133354],
              [-9875917.349770501, 4796607.671900861],
              [-9867523.080928251, 4796571.450047856],
              [-9861156.162652332, 4785988.1526720505],
              [-9848491.566823764, 4785910.163643239],
              [-9848527.745658271, 4775460.49927296],
              [-9848536.205939572, 4752519.603030327],
              [-9885763.558731167, 4752696.90457825],
              [-9920518.505632244, 4752836.420385721],
              [-9923027.869593706, 4752933.119909657],
              [-9922997.924650682, 4771770.715504838],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greene',
        GEOID: '05055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10110121.09061658, 4311603.159705798],
              [-10101957.141800784, 4321158.94999328],
              [-10108902.476150867, 4321221.124851462],
              [-10108546.142460838, 4337403.988903824],
              [-10054356.370940125, 4336338.024954477],
              [-10054483.275159629, 4328255.396352013],
              [-10039807.802069766, 4328036.279728072],
              [-10043291.770152727, 4326074.486494913],
              [-10044979.373633156, 4319829.78942706],
              [-10051536.870877312, 4316174.130766374],
              [-10056529.661358884, 4307105.848448015],
              [-10059799.671400936, 4300045.125003324],
              [-10061876.893099139, 4295766.3332512155],
              [-10113605.501997901, 4296231.768206354],
              [-10110121.09061658, 4311603.159705798],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Santa Barbara',
        GEOID: '06083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13349012.102976205, 4036639.8334716493],
              [-13342454.049134592, 4038379.628074581],
              [-13329337.05089544, 4035423.599827433],
              [-13310104.159832105, 4035981.583960928],
              [-13299421.56934829, 4036054.759716365],
              [-13301312.097177241, 4028334.106109139],
              [-13308742.945098685, 4028509.3091526055],
              [-13320804.745884608, 4026907.420939639],
              [-13327303.689076608, 4023376.3007511143],
              [-13335622.817262571, 4023825.3820735025],
              [-13344241.172239786, 4026167.172422235],
              [-13344637.246988028, 4031961.56507471],
              [-13349012.102976205, 4036639.8334716493],
            ],
          ],
          [
            [
              [-13399335.414623193, 4039074.0344794802],
              [-13385331.645320382, 4036481.414773394],
              [-13373461.981975567, 4032305.410976589],
              [-13364473.378371974, 4033869.2348093977],
              [-13356592.960299227, 4026646.8383186995],
              [-13355410.190709548, 4021081.2421695925],
              [-13363869.47013442, 4017335.6856442755],
              [-13371899.501602791, 4014807.2770494153],
              [-13378270.53869987, 4019137.4727154714],
              [-13380612.255508201, 4023016.753153628],
              [-13398952.698213845, 4027698.4686265327],
              [-13408892.860824741, 4032573.2418849077],
              [-13399335.414623193, 4039074.0344794802],
            ],
          ],
          [
            [
              [-13430730.54023507, 4160506.8556396943],
              [-13413578.07555325, 4162950.9748086184],
              [-13406815.527807048, 4162081.8906094413],
              [-13391938.12314049, 4151056.013089375],
              [-13395580.608198736, 4164739.3604582753],
              [-13379309.594826937, 4168010.1596061145],
              [-13376997.822961632, 4174118.4194336613],
              [-13367476.444275104, 4179476.367294541],
              [-13356126.086354839, 4171707.839848393],
              [-13350370.534722356, 4172009.8816495854],
              [-13330015.431872332, 4160304.3927833913],
              [-13321933.302882269, 4160263.501311488],
              [-13306659.600828487, 4149970.82824981],
              [-13299646.138950037, 4150459.1822875463],
              [-13296261.803790942, 4150472.755523566],
              [-13296261.915110432, 4104395.333466809],
              [-13296252.564273205, 4091270.4756607893],
              [-13296666.895417938, 4083188.2593458854],
              [-13300224.188418392, 4079784.7981613073],
              [-13306793.184217438, 4082031.7782297344],
              [-13315688.168129275, 4085472.428299295],
              [-13323236.074883021, 4083758.98839151],
              [-13325952.38177787, 4082018.5573619697],
              [-13334502.163948758, 4084797.978236382],
              [-13340057.00653934, 4084770.855337512],
              [-13344309.411087643, 4083826.1825041613],
              [-13355216.494795568, 4088663.8606417235],
              [-13363980.78962521, 4090960.2098929803],
              [-13374053.311110662, 4092547.272735032],
              [-13391183.822270874, 4092171.6179675427],
              [-13408591.296324182, 4088994.9866748066],
              [-13415270.020493815, 4099239.861885191],
              [-13419574.856522283, 4101920.9582082024],
              [-13423048.135954523, 4103835.452831196],
              [-13427643.627173452, 4103437.7950095516],
              [-13430222.231858186, 4107090.2335947775],
              [-13425349.889065657, 4122116.4123701546],
              [-13426783.906746054, 4127345.5245977277],
              [-13428060.518666472, 4128342.9001414445],
              [-13426273.395561274, 4144625.035153547],
              [-13433015.905799134, 4150858.378063653],
              [-13430730.54023507, 4160506.8556396943],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tolland',
        GEOID: '09013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8072146.971324608, 5152804.284144845],
              [-8069853.678494776, 5153117.990915451],
              [-8071684.921554881, 5166085.9050282445],
              [-8059250.191446521, 5165896.418568561],
              [-8050308.090981802, 5165760.156826355],
              [-8037138.770147641, 5165489.928475967],
              [-8030112.894344229, 5165345.763901439],
              [-8026375.67334695, 5165269.080418114],
              [-8026049.458867623, 5154832.035749873],
              [-8031885.383172459, 5154885.02920614],
              [-8039157.440228021, 5154714.2236687625],
              [-8039239.705331718, 5136322.690371831],
              [-8032449.216393327, 5124158.839071824],
              [-8041670.923010643, 5118262.325155181],
              [-8052209.205245569, 5107740.762547887],
              [-8051526.7054475155, 5102062.9023378715],
              [-8060685.18259406, 5101632.661334321],
              [-8060557.1651796475, 5105826.918606968],
              [-8066644.337575205, 5122943.22896519],
              [-8070307.973336703, 5140123.209910318],
              [-8072592.249287782, 5141510.52490866],
              [-8072146.971324608, 5152804.284144845],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Martin',
        GEOID: '12085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8980970.0921515, 3138674.670218813],
              [-8981018.516129995, 3149230.8835337497],
              [-8937342.091278274, 3149235.51470901],
              [-8937259.826174576, 3156459.266790031],
              [-8927602.899606047, 3156369.826976966],
              [-8922632.890362304, 3144640.5174242337],
              [-8920988.701483287, 3137411.2464982145],
              [-8918558.263040798, 3132519.7128946856],
              [-8914807.422902558, 3119790.8438749854],
              [-8921367.410390966, 3118055.5337464116],
              [-8970150.950841302, 3118217.1406063563],
              [-9004148.145968549, 3118340.1578916665],
              [-8980970.0921515, 3138674.670218813],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brooks',
        GEOID: '13027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9321466.469545102, 3637643.4461640813],
              [-9303410.559457922, 3637149.238832448],
              [-9303510.524360655, 3642900.6232744264],
              [-9300924.683909018, 3639806.810020594],
              [-9292463.17809433, 3636900.9733563294],
              [-9288670.745681984, 3621630.4596183514],
              [-9278079.364049949, 3613743.4849359337],
              [-9289532.80381869, 3609129.8931970294],
              [-9293225.048689319, 3601222.077432148],
              [-9279338.533723233, 3585713.710852956],
              [-9295172.026583293, 3586816.734424898],
              [-9307612.32018644, 3587579.7868114337],
              [-9322309.269409897, 3588481.3160384367],
              [-9321466.469545102, 3637643.4461640813],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jay',
        GEOID: '18075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9486635.984773185, 4921176.314371389],
              [-9485187.16160051, 4922196.950643341],
              [-9485145.08283299, 4935849.954014956],
              [-9484490.524227126, 4938258.289221898],
              [-9484548.187723357, 4948717.994988314],
              [-9469779.764838286, 4948864.244796555],
              [-9440161.531003894, 4949446.463847456],
              [-9440176.350012647, 4939134.153976488],
              [-9440219.137503644, 4933803.263166711],
              [-9440351.344252177, 4917349.87029974],
              [-9440351.514238698, 4917337.925808274],
              [-9440440.210888702, 4911107.427164154],
              [-9486508.746595208, 4910612.571753738],
              [-9486635.984773185, 4921176.314371389],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '18047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9495342.170828635, 4797223.463431672],
              [-9466173.90389251, 4797329.827319528],
              [-9462964.006375486, 4797047.251116634],
              [-9441691.763938189, 4796717.219846312],
              [-9441835.678342413, 4777943.194048918],
              [-9441994.208185507, 4765478.75421418],
              [-9441994.249536768, 4765475.504976539],
              [-9469456.381717531, 4765775.957195439],
              [-9486411.342040764, 4765954.64307806],
              [-9495167.39922809, 4760175.14350285],
              [-9495282.61490106, 4786808.876178029],
              [-9495342.170828635, 4797223.463431672],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Liberty',
        GEOID: '13179',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9101674.706574574, 3769599.890109953],
              [-9096879.39686967, 3775045.057436202],
              [-9093989.208930206, 3774908.6715111537],
              [-9084078.434664879, 3764422.3663446773],
              [-9082923.71758688, 3759535.103437181],
              [-9069806.274069766, 3759920.121940302],
              [-9062267.829472736, 3756001.6176612484],
              [-9056490.347900564, 3739037.8251853357],
              [-9045809.24275895, 3731030.2399906088],
              [-9034103.330385093, 3725705.2568328585],
              [-9031940.124421326, 3725377.4101308044],
              [-9032396.023354797, 3723984.207641871],
              [-9031739.127039626, 3713970.114854019],
              [-9036145.820402168, 3705156.7838963214],
              [-9036341.03433447, 3703026.0820293836],
              [-9041616.17149924, 3714894.6821191236],
              [-9051894.077445202, 3718681.8011202053],
              [-9065387.335563237, 3716415.952186442],
              [-9071625.45718831, 3723939.4607395404],
              [-9088319.261986142, 3732561.6514745164],
              [-9102077.905770225, 3746853.2958947984],
              [-9100396.981459247, 3759794.143161341],
              [-9108651.099062588, 3765264.279470818],
              [-9101674.706574574, 3769599.890109953],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Waldo',
        GEOID: '23027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7730637.475245299, 5537505.1792495],
              [-7725125.935936632, 5536450.681241351],
              [-7722502.358177616, 5550108.403285053],
              [-7727447.281278144, 5551122.933303574],
              [-7724807.116915001, 5565082.459179572],
              [-7732391.091183763, 5566181.278514136],
              [-7733555.604376952, 5573303.595393197],
              [-7722462.951077875, 5582975.67572623],
              [-7717491.645258028, 5576677.694510626],
              [-7710743.23508716, 5577850.457857883],
              [-7703887.624246657, 5579050.323904717],
              [-7701497.817418305, 5565653.209048698],
              [-7682621.927961944, 5569999.313422511],
              [-7662958.675747203, 5574748.432555938],
              [-7660539.03529532, 5571871.670363193],
              [-7660542.486199534, 5569288.513886122],
              [-7663870.7163352715, 5561088.370874134],
              [-7658595.842264034, 5553808.2744417135],
              [-7659294.706027232, 5536658.576598037],
              [-7669510.384377841, 5497987.79366694],
              [-7673806.474230037, 5496896.463884481],
              [-7675689.284033811, 5499352.0757171875],
              [-7683390.872354488, 5501172.105321612],
              [-7694583.763845136, 5505089.2887591235],
              [-7710976.672059353, 5522047.585473447],
              [-7719629.981356678, 5513282.693342385],
              [-7724944.930444603, 5518666.29318334],
              [-7729467.952675024, 5516943.668841637],
              [-7737415.051122757, 5518656.331283838],
              [-7730637.475245299, 5537505.1792495],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: "Prince George's",
        GEOID: '24033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8580450.579280639, 4680147.093082644],
              [-8577522.876672775, 4680204.156269974],
              [-8576164.667565608, 4684199.2304270025],
              [-8576128.440950336, 4685452.043427033],
              [-8575968.955108212, 4690969.322021806],
              [-8575942.919139948, 4691870.298312257],
              [-8569318.407562329, 4698466.088675866],
              [-8561514.465979757, 4706335.1415625075],
              [-8571884.237695077, 4716735.486341343],
              [-8568769.37983374, 4723779.446035016],
              [-8561280.583729602, 4738574.982002957],
              [-8559189.224456068, 4740448.87178462],
              [-8553829.970210807, 4736456.566083116],
              [-8552834.996602098, 4731564.930323888],
              [-8548306.185758155, 4728222.974474329],
              [-8543910.958303165, 4726645.275741862],
              [-8534877.715583762, 4708347.2746136505],
              [-8539389.271906633, 4695305.599126948],
              [-8536686.323350681, 4685706.547365088],
              [-8538423.130046038, 4680339.539959221],
              [-8535472.829581544, 4655406.170459606],
              [-8542740.879135435, 4658717.608179913],
              [-8543474.251940781, 4666911.635605322],
              [-8556345.0114663, 4672893.252415099],
              [-8572828.422426533, 4671941.876669379],
              [-8576905.83273531, 4666858.35093741],
              [-8581150.307457095, 4679543.139022089],
              [-8580450.579280639, 4680147.093082644],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Anne Arundel',
        GEOID: '24003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8553829.970210807, 4736456.566083116],
              [-8552305.227145413, 4737432.939138243],
              [-8552076.24295285, 4738475.837238656],
              [-8550818.77798485, 4739228.701780968],
              [-8549047.79620582, 4739245.059666122],
              [-8547885.95468041, 4740135.312918986],
              [-8547278.706858132, 4742534.393405064],
              [-8545442.491857499, 4745310.637849784],
              [-8543386.198223565, 4747429.331422284],
              [-8540721.432252955, 4747898.21796854],
              [-8539690.613768209, 4749461.138922018],
              [-8539559.034130093, 4750638.157181564],
              [-8537880.44752842, 4752384.97662673],
              [-8531994.652091706, 4757390.781720928],
              [-8524878.553642748, 4751309.610345432],
              [-8519223.412190957, 4753005.106338415],
              [-8516387.279985229, 4750257.952507928],
              [-8518811.418755533, 4747187.500748025],
              [-8508001.850921543, 4740555.354857025],
              [-8507242.540674841, 4733344.16338093],
              [-8507079.346301338, 4727699.5319124125],
              [-8504150.085220605, 4723291.905807283],
              [-8510261.636584647, 4719209.694811762],
              [-8512744.061229335, 4715444.202702735],
              [-8510406.240603186, 4713240.021808331],
              [-8512532.44287734, 4708446.554168581],
              [-8513044.08547507, 4707742.803038017],
              [-8514903.548031235, 4705185.571032047],
              [-8517827.243137429, 4700373.460131399],
              [-8514814.269799618, 4698595.141192999],
              [-8518944.33422754, 4691209.197718039],
              [-8522480.286533097, 4686830.93603558],
              [-8518908.266712522, 4682275.052730573],
              [-8518956.97426564, 4680608.643736819],
              [-8528843.19730735, 4681757.681555279],
              [-8531831.791676676, 4688676.732696518],
              [-8536686.323350681, 4685706.547365088],
              [-8539389.271906633, 4695305.599126948],
              [-8534877.715583762, 4708347.2746136505],
              [-8543910.958303165, 4726645.275741862],
              [-8548306.185758155, 4728222.974474329],
              [-8552834.996602098, 4731564.930323888],
              [-8553829.970210807, 4736456.566083116],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Essex',
        GEOID: '25009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7930197.811320076, 5261788.650874806],
              [-7932082.575178589, 5271934.473545108],
              [-7930999.871915956, 5271958.462025932],
              [-7923922.063707113, 5272115.280154652],
              [-7924400.848837015, 5280166.651377261],
              [-7920348.708052648, 5283929.427572607],
              [-7916638.653419082, 5283385.2359921625],
              [-7910830.668950843, 5282533.382987956],
              [-7909106.9326886255, 5286293.36483911],
              [-7907157.125754665, 5290548.291248813],
              [-7899954.643380849, 5292051.849322946],
              [-7895980.426240037, 5294421.581833251],
              [-7888627.885192633, 5292244.595566505],
              [-7883345.33007653, 5292553.240830906],
              [-7882001.035905709, 5278818.032941688],
              [-7878332.7247255985, 5268095.740271781],
              [-7873607.546299897, 5261816.356776145],
              [-7868239.052536898, 5260717.267189821],
              [-7864176.6703593815, 5264817.706875126],
              [-7859435.016649041, 5263042.765277665],
              [-7858489.691533226, 5256583.65946639],
              [-7865248.231777757, 5248598.247099559],
              [-7870129.257490569, 5247866.382831877],
              [-7881875.356200605, 5245478.430185138],
              [-7886818.052911316, 5243755.6344473045],
              [-7885426.4479569085, 5234738.909965751],
              [-7891048.3048809515, 5231674.982239514],
              [-7892466.624186771, 5228614.711644007],
              [-7893219.0349514205, 5226991.656809988],
              [-7894020.42396564, 5225263.255526578],
              [-7898697.964491345, 5224927.263772717],
              [-7901790.747061992, 5224705.113101616],
              [-7909624.410948607, 5232539.464957071],
              [-7907468.486370414, 5249090.975995601],
              [-7919930.0354477735, 5252545.186006253],
              [-7922038.092644928, 5250985.326828164],
              [-7932202.56402977, 5259930.573475553],
              [-7930197.811320076, 5261788.650874806],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Noxubee',
        GEOID: '28103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9886623.835756017, 3933383.96282659],
              [-9870596.389430074, 3933450.280307811],
              [-9830005.608783722, 3933636.450681111],
              [-9831418.496520799, 3919768.791021999],
              [-9833973.277959457, 3894144.5077491836],
              [-9834797.627252683, 3885888.3020611187],
              [-9886593.668174013, 3885482.234399935],
              [-9886623.835756017, 3933383.96282659],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '29099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10102176.997795101, 4630150.355083111],
              [-10100863.316484248, 4638345.859858195],
              [-10100719.936980108, 4645558.17939745],
              [-10094315.058757825, 4642606.180567505],
              [-10092303.29292021, 4647342.926038415],
              [-10075807.85945497, 4650508.658213871],
              [-10063867.730872484, 4650465.842696531],
              [-10056629.991579266, 4634254.550463483],
              [-10056927.324273046, 4633875.7489047535],
              [-10057687.384063132, 4632907.496970532],
              [-10060222.79678544, 4625206.134494831],
              [-10059266.228401054, 4612868.8637480475],
              [-10057845.585207589, 4610486.674366841],
              [-10054638.343210304, 4605110.670047645],
              [-10046889.763479467, 4597491.727074672],
              [-10046926.46284662, 4595760.339090596],
              [-10065065.52859342, 4585405.2289827755],
              [-10088672.162450025, 4580519.696834013],
              [-10089996.4191125, 4590245.128817882],
              [-10094983.087022075, 4591620.049037917],
              [-10105603.96831917, 4608300.2553659],
              [-10102176.997795101, 4630150.355083111],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Erie',
        GEOID: '36029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8806636.422482843, 5253304.943347932],
              [-8801337.50340159, 5258055.7615678925],
              [-8799678.84298877, 5264777.573533768],
              [-8791164.90569392, 5268842.208868141],
              [-8783646.943883197, 5273408.365693206],
              [-8777692.686959645, 5280328.814137101],
              [-8778308.282892127, 5282382.106694669],
              [-8779284.666997481, 5285639.713479558],
              [-8781166.077711375, 5291788.937077317],
              [-8784494.641805587, 5294720.575266083],
              [-8784127.39880546, 5301818.393203411],
              [-8786219.982593391, 5304808.838354303],
              [-8789983.026660169, 5305544.0882321],
              [-8796462.154982809, 5311173.690733006],
              [-8794846.463893434, 5320687.049728544],
              [-8796270.908097625, 5322025.559543602],
              [-8796419.172845855, 5322068.295659813],
              [-8788146.36638157, 5322168.792215581],
              [-8783760.155805333, 5319822.491095988],
              [-8782357.530221337, 5317872.767041833],
              [-8782012.328480387, 5315314.37135745],
              [-8779629.75741894, 5315513.231064628],
              [-8776356.296472672, 5314933.260785282],
              [-8774799.60471342, 5317096.037179798],
              [-8775455.721792156, 5319622.930336008],
              [-8765743.652817894, 5322689.933875296],
              [-8763921.57539259, 5325104.631642892],
              [-8750156.029800078, 5322941.219879102],
              [-8739735.968864374, 5326893.959077884],
              [-8734622.508054784, 5325483.108755265],
              [-8734614.93832941, 5291819.769269856],
              [-8737049.272954078, 5290281.169133327],
              [-8734487.14355398, 5278615.2487886585],
              [-8734565.84643397, 5241661.048069757],
              [-8760391.634339537, 5231938.031367895],
              [-8785308.164644303, 5227478.807251189],
              [-8793316.043534009, 5240591.043944185],
              [-8801005.437360555, 5241890.836067326],
              [-8806237.564747328, 5246743.525358721],
              [-8809373.034500493, 5246624.6732459655],
              [-8806636.422482843, 5253304.943347932],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Erie',
        GEOID: '39043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9234199.335849568, 5080168.588968429],
              [-9209510.453903472, 5083303.828145021],
              [-9205071.829732206, 5085884.0344302645],
              [-9204777.260474432, 5085232.810444969],
              [-9196877.027532324, 5075741.118374101],
              [-9187554.688095333, 5070209.564034389],
              [-9179471.891188323, 5069491.264697521],
              [-9168471.855705585, 5075476.698772852],
              [-9166939.56594584, 5075568.644816436],
              [-9166625.955909252, 5065206.320327469],
              [-9166608.81270767, 5064620.377527629],
              [-9166304.465219842, 5054256.209572379],
              [-9221870.813563703, 5055214.567525783],
              [-9222214.790790254, 5065942.543882591],
              [-9222575.354620932, 5076051.571980876],
              [-9234199.335849568, 5080168.588968429],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wallowa',
        GEOID: '41063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13133212.736346474, 5780376.174846944],
              [-13104291.34191794, 5780327.746688428],
              [-13091553.4794415, 5780150.539407464],
              [-13077806.794615686, 5779959.301510733],
              [-13063779.507550487, 5779764.164249305],
              [-13015028.361071974, 5779614.1807582425],
              [-13011783.843193311, 5773720.043700242],
              [-13008772.873606335, 5765500.644821187],
              [-13002027.973617421, 5756511.193053616],
              [-13000727.257409252, 5754778.67299942],
              [-12995021.910867115, 5752537.902866577],
              [-12987126.687302094, 5745482.805424883],
              [-12979073.83533811, 5744931.006038244],
              [-12972694.560598709, 5737861.360133538],
              [-12971867.90206008, 5729451.150052138],
              [-12964657.96128038, 5718990.831087143],
              [-12969027.473932998, 5711167.7824007],
              [-12978538.499906885, 5691521.789339855],
              [-12988162.403844435, 5671144.698736418],
              [-12989973.377691323, 5663967.402378859],
              [-12990544.529627917, 5661704.988744826],
              [-12997067.406510442, 5639481.9261119235],
              [-13000238.371512437, 5633764.037772157],
              [-13053991.963961475, 5634214.51453797],
              [-13053992.075280964, 5647777.857898229],
              [-13077444.64296231, 5647777.857898229],
              [-13082371.309666347, 5654605.838865964],
              [-13082516.915560305, 5663769.190914329],
              [-13089206.660359528, 5674905.754737291],
              [-13098228.771129848, 5679286.141458202],
              [-13105335.852700055, 5702930.422984134],
              [-13105334.739505146, 5719182.607865793],
              [-13112058.214110076, 5730740.908060888],
              [-13112144.152756969, 5744128.827048512],
              [-13107608.440104598, 5744146.382917907],
              [-13107572.483909072, 5758113.79293369],
              [-13132692.060965048, 5758037.544904314],
              [-13133206.468332002, 5760642.497018156],
              [-13133212.736346474, 5780376.174846944],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fayette',
        GEOID: '42051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8905338.18295317, 4863518.973895423],
              [-8891872.30942987, 4871295.177419498],
              [-8887636.714124678, 4879116.917762945],
              [-8891909.824098269, 4884384.490206646],
              [-8877106.446893089, 4884584.821280557],
              [-8860254.56841833, 4877873.462846839],
              [-8850477.043583484, 4886390.31335204],
              [-8841112.291420499, 4881856.532382496],
              [-8832225.322511999, 4872175.442180429],
              [-8826932.303363761, 4871816.725582189],
              [-8840722.116605269, 4844716.10267423],
              [-8834948.753854258, 4839898.678524918],
              [-8837928.042473245, 4825544.792835021],
              [-8847301.543789113, 4825492.494055585],
              [-8879262.705429753, 4825448.786354502],
              [-8896210.35830054, 4825489.300422731],
              [-8897023.841505311, 4854548.244115267],
              [-8905338.18295317, 4863518.973895423],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Roosevelt',
        GEOID: '30085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11778114.084266502, 6143372.453968871],
              [-11778095.939189501, 6201094.548036498],
              [-11685580.314142046, 6201066.288917147],
              [-11661564.80379576, 6201055.691771588],
              [-11661567.47546354, 6186506.151479136],
              [-11647105.181178149, 6186471.391834686],
              [-11647108.966040835, 6171876.98126837],
              [-11582434.808919773, 6171866.710567258],
              [-11582313.452673778, 6147112.074710859],
              [-11582135.483178295, 6106207.231809488],
              [-11588238.877849214, 6106857.995808656],
              [-11593086.730353769, 6116010.590222447],
              [-11604604.512788186, 6112014.51301192],
              [-11637842.397668732, 6127934.627799325],
              [-11653106.080968343, 6124061.346197797],
              [-11668796.340556672, 6126665.906040947],
              [-11676448.442353804, 6131960.99536073],
              [-11687471.854929607, 6117916.708872805],
              [-11707845.659454083, 6120483.409759591],
              [-11708330.455836488, 6124024.1725123385],
              [-11710229.67766891, 6117944.694197284],
              [-11744561.944463447, 6123139.386379409],
              [-11760674.99547781, 6119725.115074115],
              [-11782488.049698751, 6108566.728598158],
              [-11778114.084266502, 6143372.453968871],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nuckolls',
        GEOID: '31129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10939763.882156616, 4916986.880936199],
              [-10889730.557783144, 4917013.465618749],
              [-10889363.426102506, 4917014.049898293],
              [-10889439.659056272, 4866260.076337626],
              [-10901720.883253645, 4866267.264388736],
              [-10917774.163903786, 4866276.660186466],
              [-10939813.537301173, 4866281.957287119],
              [-10939763.882156616, 4916986.880936199],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nye',
        GEOID: '32023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13157549.03534224, 4721660.972720597],
              [-13120684.695410121, 4732227.374160524],
              [-13110705.125699485, 4735062.751034515],
              [-13061322.575069191, 4745108.627728277],
              [-12979957.934733989, 4744826.222341154],
              [-12902716.123059807, 4744881.496795392],
              [-12801835.617515672, 4675555.551420478],
              [-12801835.617515672, 4586598.558091889],
              [-12901245.147308463, 4586566.609796195],
              [-12901586.675506217, 4417118.270975406],
              [-12901456.209063007, 4324345.492794258],
              [-12895895.800497886, 4317428.009985477],
              [-12895930.412261426, 4295607.434296599],
              [-12901146.963517584, 4300616.831296111],
              [-12923480.547677478, 4322081.132181996],
              [-12954903.145621657, 4352007.16785438],
              [-12967410.780968208, 4363977.68742982],
              [-13024480.053757267, 4417898.504416229],
              [-13042859.521072337, 4435094.248955445],
              [-13042816.266322263, 4579664.838480431],
              [-13101304.528660467, 4646575.355903559],
              [-13157544.693882098, 4710083.948511481],
              [-13157549.03534224, 4721660.972720597],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Passaic',
        GEOID: '34031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8293659.622303307, 5025016.174828111],
              [-8278500.831068217, 5042509.631900809],
              [-8271260.137004867, 5037832.667745794],
              [-8263743.733667014, 5033439.77221335],
              [-8263731.46973568, 5033432.716961803],
              [-8261199.486985984, 5031976.216075507],
              [-8265523.175727345, 5021316.152645653],
              [-8267946.378402934, 5014987.432280532],
              [-8256693.647676094, 5008959.492376475],
              [-8253343.710239654, 5007379.267950344],
              [-8252374.006155353, 5000906.830489253],
              [-8249529.681846094, 4991610.397333784],
              [-8252115.633617221, 4985818.728662172],
              [-8259669.328984489, 4991279.823143303],
              [-8267928.233325935, 4997223.921976148],
              [-8270910.259845304, 5012771.340177717],
              [-8278031.924268804, 5014278.08620477],
              [-8287404.0235181805, 5020373.24679627],
              [-8293054.600870847, 5017396.467697502],
              [-8293659.622303307, 5025016.174828111],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Colfax',
        GEOID: '35007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11727662.532566119, 4388616.150624633],
              [-11729805.766722362, 4394739.52944758],
              [-11723260.62594168, 4400770.86844168],
              [-11714220.370094359, 4400675.454581705],
              [-11714080.10753596, 4417900.730159545],
              [-11710823.455832804, 4427352.934463632],
              [-11713093.059961936, 4438488.377675903],
              [-11705805.813057618, 4438476.0021021925],
              [-11701993.927781554, 4438469.528570305],
              [-11658716.360665342, 4438193.422915544],
              [-11614945.759524409, 4438205.687930802],
              [-11578100.834781598, 4438547.036624308],
              [-11578209.214367721, 4330675.313400721],
              [-11625768.574377803, 4330733.127631247],
              [-11673563.152471932, 4330641.370106539],
              [-11673545.563992387, 4336652.10129697],
              [-11726535.8679998, 4336713.399021445],
              [-11724981.513949854, 4356552.278281105],
              [-11728268.221915526, 4362650.015333008],
              [-11724026.058760377, 4368490.204596348],
              [-11730596.914343432, 4376857.284004949],
              [-11727662.532566119, 4388616.150624633],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Juan',
        GEOID: '35045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12138915.025461303, 4316736.215593852],
              [-12138882.074892031, 4421640.497765424],
              [-12138858.697798962, 4438979.109432515],
              [-12091557.487688031, 4439007.404711495],
              [-12064728.816934396, 4439046.110309965],
              [-12022574.35771631, 4439106.9266376905],
              [-11964812.232322486, 4439107.425687349],
              [-11958041.33570854, 4439107.484186128],
              [-11962076.221971834, 4432831.2073663045],
              [-11961440.142401442, 4425739.071014122],
              [-11977752.677943306, 4416035.720577065],
              [-11980001.109018348, 4411859.134803702],
              [-11980680.38055117, 4330909.055893809],
              [-11980928.400376655, 4300661.000472492],
              [-12138930.851553492, 4300993.118605198],
              [-12138915.025461303, 4316736.215593852],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Noble',
        GEOID: '39121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9094150.733511345, 4843100.853304203],
              [-9081478.901915874, 4842588.784073637],
              [-9081287.09843324, 4851084.972608012],
              [-9068543.020488244, 4850630.384439559],
              [-9059848.745618308, 4858779.850715718],
              [-9042933.415033799, 4858863.493451874],
              [-9043296.650532255, 4846753.952765556],
              [-9051787.544692513, 4846992.251275239],
              [-9048113.66753786, 4823471.430170798],
              [-9048390.519111466, 4808821.902248423],
              [-9060842.606032109, 4808207.997688603],
              [-9069550.684518903, 4814629.057716434],
              [-9069585.30488054, 4805574.660292832],
              [-9082355.208947401, 4806102.601259151],
              [-9082126.670032801, 4817234.123592557],
              [-9088479.450733393, 4817478.22516805],
              [-9088110.537940903, 4830174.378895322],
              [-9094517.642553002, 4830485.98418306],
              [-9094150.733511345, 4843100.853304203],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '40065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11114367.711332668, 4097075.528579433],
              [-11094825.364981689, 4097100.95618877],
              [-11094862.879650088, 4126511.9856589017],
              [-11067740.108357288, 4126574.966203139],
              [-11065805.375607299, 4138502.691991043],
              [-11048065.612873975, 4139733.3467727522],
              [-11036723.047318067, 4143452.983093698],
              [-11037228.883084232, 4123505.17839273],
              [-11026475.086315129, 4123397.5317015615],
              [-11032112.19400941, 4114788.1969738556],
              [-11038810.28777044, 4108036.8600952537],
              [-11047114.9444226, 4086236.529879252],
              [-11045298.867211971, 4072575.87295623],
              [-11051280.297129104, 4080831.7102844836],
              [-11059636.717344481, 4087643.681017535],
              [-11064595.88933983, 4088320.730918084],
              [-11067431.864687279, 4080004.1747705573],
              [-11073057.6177935, 4082163.448124963],
              [-11073508.81094473, 4082217.410263046],
              [-11085693.604512937, 4083674.7939234246],
              [-11087424.17731681, 4079225.1193182706],
              [-11098159.383730948, 4080081.3279229584],
              [-11105775.863291025, 4087398.4359276956],
              [-11111709.637428269, 4094496.638685094],
              [-11114367.711332668, 4097075.528579433],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gregory',
        GEOID: '46053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11080127.741292764, 5388358.733358537],
              [-11053802.574151495, 5388338.47608329],
              [-11055146.757002825, 5383469.727402238],
              [-11037649.114161976, 5377178.998928088],
              [-11028342.359453695, 5360911.915294681],
              [-11018542.682040181, 5351469.33959702],
              [-11009139.524652874, 5349629.747072567],
              [-11006020.241201354, 5336663.869557086],
              [-10995405.259837272, 5334208.646228802],
              [-10986171.753353935, 5323631.719752777],
              [-10967738.470192965, 5317962.780499849],
              [-10964808.429875797, 5311752.66683059],
              [-11003708.135377578, 5311706.2439237945],
              [-11048955.390934963, 5311701.05778202],
              [-11080080.320838217, 5311697.490312079],
              [-11080127.741292764, 5388358.733358537],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Emmons',
        GEOID: '38029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11205630.337088518, 5882609.7948102625],
              [-11140987.99934079, 5882438.922442209],
              [-11122543.47291125, 5882362.565941805],
              [-11122682.622274743, 5825844.275314765],
              [-11118416.080151107, 5825786.287772466],
              [-11118597.652794415, 5771006.865530876],
              [-11118623.245723477, 5771007.039091459],
              [-11148878.99276516, 5771137.346818587],
              [-11164691.035876421, 5771262.693771744],
              [-11187536.936309379, 5771320.805222123],
              [-11188921.615478918, 5771324.327341756],
              [-11188938.9842306, 5771324.338617457],
              [-11200355.351697786, 5791862.0537321875],
              [-11201985.18036249, 5803713.786478546],
              [-11194126.46959045, 5820501.678706622],
              [-11193308.271333119, 5838791.964191299],
              [-11197649.731474057, 5849186.696729783],
              [-11194403.209844561, 5875057.786692161],
              [-11205630.337088518, 5882609.7948102625],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carroll',
        GEOID: '51035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9021601.817610536, 4412162.363581624],
              [-8996032.509811755, 4418668.917643915],
              [-8987989.453962961, 4422254.480196032],
              [-8981544.834682465, 4424501.27360792],
              [-8976134.373471439, 4429602.060102227],
              [-8957231.544698307, 4398583.2306740135],
              [-8964060.104902547, 4389616.283328557],
              [-8972681.02022805, 4390802.163280333],
              [-8973707.807625268, 4377705.435037472],
              [-8984020.6914772, 4378274.030188716],
              [-8999091.35537876, 4378219.902915986],
              [-9007324.536318844, 4390467.07329516],
              [-9004495.351460334, 4393962.932785446],
              [-9003216.958428064, 4396291.920464768],
              [-9004760.737126386, 4396812.2572642],
              [-9006357.949180286, 4395547.555298466],
              [-9007411.142882682, 4396650.516988265],
              [-9008028.52077862, 4394337.9684826],
              [-9009339.196463222, 4393429.41098938],
              [-9021601.817610536, 4412162.363581624],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pacific',
        GEOID: '53049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13814392.214147592, 5908528.032719932],
              [-13733591.332682414, 5908209.993198651],
              [-13732186.925986568, 5842104.518378991],
              [-13773177.32284494, 5842241.2035214575],
              [-13773327.249894029, 5827159.500588284],
              [-13776851.199999588, 5824539.969870687],
              [-13782036.350561248, 5825911.444694245],
              [-13789760.36474943, 5818858.8740116665],
              [-13793520.848467918, 5819776.97840867],
              [-13798535.457569683, 5824850.485963149],
              [-13800213.4875739, 5827169.5556012215],
              [-13812597.113007706, 5823278.369025655],
              [-13810810.769138947, 5832890.665098783],
              [-13809964.741008919, 5859762.529025343],
              [-13811362.80249379, 5881993.9241613075],
              [-13799235.545847284, 5882920.097164254],
              [-13795075.202517863, 5888814.359399185],
              [-13800851.348256147, 5895511.190882694],
              [-13812631.844688835, 5898926.576429357],
              [-13814392.214147592, 5908528.032719932],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pend Oreille',
        GEOID: '53051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13094447.248027602, 6231304.06296841],
              [-13087143.576236654, 6231359.263526054],
              [-13087148.808252722, 6247193.183581952],
              [-13079872.743695492, 6247231.913331604],
              [-13079924.061980749, 6261833.127481289],
              [-13072289.771302143, 6261834.652242106],
              [-13072244.241630409, 6274913.463555888],
              [-13054241.542259831, 6274830.512470902],
              [-13027981.719659662, 6274723.615718784],
              [-13028047.195793422, 6248884.08319229],
              [-13028128.661387509, 6216844.096792038],
              [-13028308.776323613, 6177472.743532081],
              [-13028956.433121046, 6127659.622077071],
              [-13028968.39478561, 6114421.94385698],
              [-13073026.261053234, 6114711.993927258],
              [-13073097.060249379, 6129291.440816455],
              [-13080304.106722316, 6129294.776823233],
              [-13080037.385222374, 6216723.604969621],
              [-13094427.21051926, 6216667.15134703],
              [-13094447.248027602, 6231304.06296841],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pepin',
        GEOID: '55091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10276673.988007419, 5549279.214457137],
              [-10256454.680085499, 5549326.691012125],
              [-10256443.7707754, 5571968.7428826755],
              [-10202471.517539697, 5571852.725686196],
              [-10202458.938437238, 5558244.074465417],
              [-10243929.901537364, 5557285.804551783],
              [-10250802.831519105, 5528272.184047915],
              [-10253759.07861594, 5529726.663659762],
              [-10267271.817644862, 5534634.87884563],
              [-10268707.02076712, 5536009.815983914],
              [-10273787.681399465, 5540878.802263702],
              [-10276355.376774102, 5549082.117117894],
              [-10276673.988007419, 5549279.214457137],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Conecuh',
        GEOID: '01035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9703339.411110634, 3700409.453996023],
              [-9699829.507565923, 3716463.286547226],
              [-9690484.124994338, 3726394.8964765426],
              [-9674320.423611661, 3730936.112350133],
              [-9674417.271568652, 3715188.9843252595],
              [-9666916.230320528, 3701146.37254149],
              [-9651572.842265511, 3700982.086649469],
              [-9647178.83932492, 3685171.3610404837],
              [-9651672.139251297, 3677687.227211769],
              [-9651431.243873222, 3657737.4206116665],
              [-9659472.629929656, 3659042.1940202154],
              [-9658519.957727447, 3666729.708902919],
              [-9732379.77195184, 3666611.593368716],
              [-9703339.411110634, 3700409.453996023],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fulton',
        GEOID: '13121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9441659.348268997, 3964563.6716068103],
              [-9440887.347600346, 3971754.42317151],
              [-9439507.208553491, 3974628.3174079726],
              [-9420981.530215165, 3987669.0633789836],
              [-9415194.586486276, 3994413.061426648],
              [-9404285.499027517, 4004298.7285107137],
              [-9401542.47545488, 4005570.212086408],
              [-9402058.552614199, 4008920.2399881235],
              [-9400119.255765088, 4015589.305839625],
              [-9392553.426573323, 4026909.971752049],
              [-9397471.966954533, 4038648.408188438],
              [-9390055.305880431, 4052555.556118847],
              [-9379640.365641303, 4053792.4634937267],
              [-9379661.627664044, 4043519.938207664],
              [-9361712.361649048, 4035612.9056114885],
              [-9371099.934307644, 4028479.3665087055],
              [-9380033.657402277, 4027110.950711756],
              [-9381683.07829736, 4023112.0408879435],
              [-9389509.840375545, 4024520.647416304],
              [-9389611.475070639, 4014162.354764108],
              [-9389609.582639296, 4009681.892894944],
              [-9389586.539504701, 4008047.5247193733],
              [-9389823.983978564, 3981622.088481779],
              [-9401791.05187782, 3981750.1966099422],
              [-9401827.453351311, 3979126.136591982],
              [-9401883.44705518, 3974473.8275405723],
              [-9401895.580879677, 3968661.51432784],
              [-9412826.264319649, 3965652.762042104],
              [-9418690.909053111, 3962195.4279604917],
              [-9420716.255868603, 3963333.8279339997],
              [-9428669.365568839, 3963378.5545105925],
              [-9445538.164606197, 3963389.7695599366],
              [-9441659.348268997, 3964563.6716068103],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '13163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9201882.508435845, 3912084.3208525567],
              [-9192631.747431433, 3911221.5435260097],
              [-9193313.690632032, 3918083.656600412],
              [-9176283.478333022, 3931840.124233951],
              [-9170925.893880123, 3936804.4676570604],
              [-9167549.462404873, 3936832.7074623727],
              [-9165242.477277674, 3936348.244468934],
              [-9157985.114394896, 3930850.4656305956],
              [-9154086.037910372, 3926033.7230490004],
              [-9160612.254377617, 3903646.1691046446],
              [-9158516.442324454, 3887050.3303837855],
              [-9163432.199718393, 3873525.6762392204],
              [-9174855.471905127, 3870234.4919731906],
              [-9176527.490656842, 3863790.0391402044],
              [-9179210.29038496, 3864579.6986047924],
              [-9186201.488365248, 3871748.362144474],
              [-9185065.918239668, 3884392.263902921],
              [-9189449.011870163, 3897872.7667576866],
              [-9194769.304293646, 3899553.925020013],
              [-9201882.508435845, 3912084.3208525567],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bulloch',
        GEOID: '13031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9128335.835939052, 3843243.322091686],
              [-9110499.002609756, 3848819.018679005],
              [-9109029.251372812, 3849307.544430062],
              [-9093649.461844305, 3835235.241623274],
              [-9077882.503126819, 3827709.7771611633],
              [-9076423.995158443, 3815085.7250067024],
              [-9066564.427858884, 3800742.4574039984],
              [-9065395.127927592, 3795025.39879791],
              [-9103803.469197012, 3783396.5898644826],
              [-9107746.628199892, 3794522.7791410326],
              [-9124755.021878704, 3798644.5157401124],
              [-9119144.742181707, 3817964.0207961625],
              [-9131563.767213585, 3834242.2046877462],
              [-9128335.835939052, 3843243.322091686],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jones',
        GEOID: '13169',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9330359.783664575, 3912813.4313713964],
              [-9300284.374197975, 3918148.956009283],
              [-9288985.334562967, 3919877.7279852615],
              [-9287283.816146193, 3919932.263355496],
              [-9285714.990562443, 3910290.2515559723],
              [-9279335.047906097, 3885504.514935485],
              [-9284823.65539966, 3881802.149990298],
              [-9296681.51887845, 3874730.841608443],
              [-9302421.04050426, 3879010.8658835497],
              [-9312832.863797646, 3880425.5143688624],
              [-9316997.993865168, 3884275.0374319553],
              [-9318630.828156123, 3889039.5660530115],
              [-9320265.554878423, 3899640.63164407],
              [-9330359.783664575, 3912813.4313713964],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Baker',
        GEOID: '13007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9420699.00134753, 3675956.3873105175],
              [-9421812.196255466, 3689231.8473753748],
              [-9408000.1191158, 3689973.049851157],
              [-9398690.804059228, 3689588.6783758006],
              [-9374391.6516504, 3689483.6502542016],
              [-9366547.078453688, 3690047.6814228822],
              [-9373174.59565756, 3679007.417548304],
              [-9388747.30186361, 3672467.297713266],
              [-9395849.262737239, 3658638.7484176094],
              [-9403268.818118103, 3654583.943087025],
              [-9407396.210878244, 3642935.066872014],
              [-9411245.082272422, 3643016.8220597757],
              [-9410627.036459537, 3666031.5805251207],
              [-9422267.938250773, 3666426.8040878177],
              [-9420699.00134753, 3675956.3873105175],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Logan',
        GEOID: '17107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9974557.995840384, 4912572.18949244],
              [-9936794.083103165, 4913333.630084763],
              [-9936672.7448582, 4906849.031566856],
              [-9923995.903885644, 4907082.651210962],
              [-9923995.013329718, 4907012.316669809],
              [-9923549.735366546, 4873044.005970835],
              [-9923403.572875133, 4853982.172738465],
              [-9931685.186392698, 4853886.8146563405],
              [-9952517.29326077, 4854060.549929296],
              [-9961293.944553893, 4862561.758296742],
              [-9971809.5176127, 4862473.726407995],
              [-9971902.803345984, 4879367.635576366],
              [-9974404.931540543, 4883749.747014129],
              [-9974557.995840384, 4912572.18949244],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Putnam',
        GEOID: '18133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9686249.754203541, 4808676.116371317],
              [-9685850.673829047, 4846591.0776398415],
              [-9650857.391898183, 4846321.31704514],
              [-9649997.894109767, 4812382.829313535],
              [-9645056.199274471, 4810589.562498588],
              [-9646574.15185093, 4808186.037103044],
              [-9645646.74917313, 4803055.371475158],
              [-9649809.096253382, 4789229.485921093],
              [-9678114.414496878, 4789702.775582436],
              [-9686413.505174499, 4789735.511555157],
              [-9686249.754203541, 4808676.116371317],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Edwards',
        GEOID: '20047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11084068.228627864, 4567145.167952116],
              [-11084029.71208405, 4591775.909379143],
              [-11059631.374008924, 4591807.308026219],
              [-11059623.581644567, 4579531.056918504],
              [-11047422.520175662, 4579421.292344315],
              [-11023093.756782282, 4579459.151808658],
              [-11023139.509092998, 4556833.533803153],
              [-11022112.141512468, 4554780.946431161],
              [-11022137.967634333, 4541771.805253286],
              [-11082921.749192182, 4542041.777741405],
              [-11084145.818312945, 4554822.944090344],
              [-11084068.228627864, 4567145.167952116],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lafayette',
        GEOID: '22055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10268986.24912257, 3530744.2725676135],
              [-10257221.00346012, 3542018.101766454],
              [-10251350.236154662, 3546060.5950954654],
              [-10246895.67541108, 3552658.0707369084],
              [-10240137.246486038, 3551018.2163982578],
              [-10235027.681858627, 3533998.837078177],
              [-10239159.193439927, 3527041.099398004],
              [-10230878.359158799, 3523439.8112513386],
              [-10235938.275293317, 3512964.16767699],
              [-10237436.635639394, 3508296.1914073788],
              [-10248757.271255616, 3513055.885247987],
              [-10251236.1336766, 3520052.167098538],
              [-10273083.029022744, 3522516.380430429],
              [-10268986.24912257, 3530744.2725676135],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Newaygo',
        GEOID: '26123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9577872.326232444, 5383394.8765830435],
              [-9577693.43581074, 5436951.759788588],
              [-9524766.472593587, 5436932.012781914],
              [-9524757.01043687, 5383499.637222333],
              [-9524778.16114012, 5356870.696580335],
              [-9550148.986286815, 5356676.7646927545],
              [-9577812.436346397, 5356755.682859388],
              [-9577872.326232444, 5383394.8765830435],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clinton',
        GEOID: '29049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10531075.0771344, 4829273.066173739],
              [-10486959.608210988, 4829077.032390694],
              [-10487233.676797323, 4797472.272991861],
              [-10487480.694747392, 4787011.724738138],
              [-10530914.999706639, 4787224.092975197],
              [-10530959.082224993, 4797900.921119169],
              [-10531075.0771344, 4829273.066173739],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pettis',
        GEOID: '29159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10409600.243154528, 4658300.363544234],
              [-10407605.397879513, 4707216.786400501],
              [-10408069.37751714, 4711424.963001096],
              [-10407969.078655934, 4713486.767788385],
              [-10358329.046043435, 4711398.347033977],
              [-10359388.918915277, 4677802.357475161],
              [-10360203.443629412, 4654569.264392977],
              [-10385045.835153311, 4655336.722156901],
              [-10385201.348481948, 4651200.985786349],
              [-10409790.933442257, 4652076.597523915],
              [-10409600.243154528, 4658300.363544234],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Howard',
        GEOID: '31093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10992168.534322966, 5070657.8419753425],
              [-10941750.712428294, 5070615.699103638],
              [-10941212.482690308, 5070616.292663933],
              [-10941277.493272932, 5019182.602803698],
              [-10989679.987106284, 5019228.507646307],
              [-10992635.630906336, 5019223.489099896],
              [-10992168.534322966, 5070657.8419753425],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wheeler',
        GEOID: '31183',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10994041.484755564, 5174248.247443536],
              [-10942771.84611734, 5174298.498914214],
              [-10942196.213030448, 5171545.1093951315],
              [-10942216.361858284, 5148248.466604572],
              [-10942233.950337829, 5122287.666286389],
              [-10993047.40170278, 5122167.4200131465],
              [-10993816.396745179, 5122168.911893144],
              [-10994041.484755564, 5174248.247443536],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hooker',
        GEOID: '31091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11290752.678154936, 5174799.678103199],
              [-11226139.72875278, 5174195.4461841425],
              [-11225731.186221568, 5122172.194029962],
              [-11288516.158265408, 5122589.332934701],
              [-11290681.767639302, 5122568.296524995],
              [-11290752.678154936, 5174799.678103199],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Valley',
        GEOID: '31175',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11044231.101694109, 5122203.374385806],
              [-10993816.396745179, 5122168.911893144],
              [-10993047.40170278, 5122167.4200131465],
              [-10992973.15160242, 5070643.893257985],
              [-11043256.499552215, 5070652.203129726],
              [-11044273.180461628, 5072809.747421386],
              [-11044231.101694109, 5122203.374385806],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henry',
        GEOID: '39069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9388897.58317618, 5084221.536262935],
              [-9337806.50100119, 5084522.306787876],
              [-9337838.894973012, 5073674.354997371],
              [-9337606.793834709, 5037127.269105224],
              [-9376242.783462804, 5036837.138909374],
              [-9376268.609584667, 5075649.810392638],
              [-9388871.089137372, 5075613.88131023],
              [-9388897.58317618, 5084221.536262935],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shelby',
        GEOID: '47157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10052227.608317686, 4167794.686501573],
              [-10048286.787024112, 4169358.150867753],
              [-10040700.36372655, 4170777.423223334],
              [-10038946.07987114, 4176309.1224938664],
              [-10036571.74645201, 4181402.437812377],
              [-10028840.8304554, 4179967.516155648],
              [-10029861.2962275, 4186255.0280029387],
              [-10029138.610093271, 4191540.7855297043],
              [-10029657.581559349, 4197904.94152154],
              [-10037299.330643835, 4201259.450349576],
              [-10032320.009820653, 4205343.632954705],
              [-10028539.488593822, 4213358.326198149],
              [-10031278.059386829, 4219759.93841213],
              [-10026607.650150597, 4221554.526879669],
              [-10023797.612244502, 4220481.399379289],
              [-10023182.126779906, 4217899.546726605],
              [-10003783.369675288, 4217112.846663747],
              [-9985634.396493806, 4219545.6400132375],
              [-9977874.98270755, 4215072.14019143],
              [-9979130.202541651, 4163074.8837320404],
              [-9988065.150857514, 4163091.203035854],
              [-9991994.373135014, 4163098.379601131],
              [-9995954.492526779, 4163105.612603425],
              [-10053184.955938509, 4163295.9912598566],
              [-10052227.608317686, 4167794.686501573],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Knox',
        GEOID: '23013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7673845.499307804, 5485641.0074626515],
              [-7668643.539503032, 5490166.2031900715],
              [-7673806.474230037, 5496896.463884481],
              [-7669510.384377841, 5497987.79366694],
              [-7661950.343799596, 5497843.67374967],
              [-7649977.487286817, 5483296.293530839],
              [-7630780.997696971, 5485535.389384631],
              [-7628882.132348719, 5479357.5913040275],
              [-7634747.199834445, 5476527.437874175],
              [-7638418.96191877, 5467004.850305563],
              [-7642865.7302979985, 5466033.8204389755],
              [-7644240.748648276, 5477266.528467672],
              [-7656515.614939578, 5474384.102140133],
              [-7667034.082305144, 5469367.386003565],
              [-7670480.422420613, 5477419.157322018],
              [-7673845.499307804, 5485641.0074626515],
            ],
          ],
          [
            [
              [-7672585.696630495, 5447725.744130916],
              [-7667105.8833767045, 5450708.431198827],
              [-7664236.6235015085, 5442234.061428014],
              [-7668630.849081082, 5435126.883192442],
              [-7674859.174590968, 5439993.76714686],
              [-7672585.696630495, 5447725.744130916],
            ],
          ],
          [
            [
              [-7729467.952675024, 5516943.668841637],
              [-7724944.930444603, 5518666.29318334],
              [-7719629.981356678, 5513282.693342385],
              [-7710976.672059353, 5522047.585473447],
              [-7694583.763845136, 5505089.2887591235],
              [-7683390.872354488, 5501172.105321612],
              [-7685519.129029331, 5501675.116136235],
              [-7687116.897680687, 5492027.193087996],
              [-7689468.07664573, 5485580.676282166],
              [-7684593.5074633835, 5477681.343985396],
              [-7688627.057892788, 5471598.436805204],
              [-7685933.126215589, 5466422.7462749975],
              [-7689619.5824727, 5461365.983948115],
              [-7695687.38527686, 5461742.646315717],
              [-7700523.549234883, 5461875.680657958],
              [-7704749.125785904, 5453287.316452481],
              [-7708074.572934373, 5452887.664733041],
              [-7712205.193959747, 5446825.628506388],
              [-7716781.872184731, 5443294.127454456],
              [-7720516.1958228825, 5452724.934496576],
              [-7723400.786545227, 5456724.518115164],
              [-7721564.714106664, 5467434.525881379],
              [-7712466.794763112, 5473583.28772962],
              [-7718634.339831022, 5497900.047972781],
              [-7729228.059172363, 5500598.030638946],
              [-7731277.896275832, 5514155.910155448],
              [-7729467.952675024, 5516943.668841637],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oxford',
        GEOID: '23017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7913026.223267758, 5669737.360309045],
              [-7907937.364065633, 5670761.619958265],
              [-7905103.949066473, 5675961.173136391],
              [-7898047.183906105, 5673866.928765877],
              [-7893900.087596092, 5668272.797754763],
              [-7891752.8459381815, 5659253.139563871],
              [-7886365.873139715, 5658516.6245638095],
              [-7885206.9857486235, 5664411.923716771],
              [-7879175.969868357, 5624415.347803092],
              [-7884050.873009177, 5623692.700777302],
              [-7878514.7320930455, 5596332.82385202],
              [-7877994.424793079, 5579464.31298159],
              [-7860829.181951735, 5589405.4168477105],
              [-7849203.864889214, 5563023.958650888],
              [-7853588.405673088, 5560445.195192585],
              [-7823617.07993038, 5554019.3795125615],
              [-7826612.798747119, 5549060.564944496],
              [-7820293.859171728, 5543678.181385014],
              [-7818959.027157624, 5536741.39294947],
              [-7822911.759636713, 5533886.145105703],
              [-7821888.844835814, 5521776.649811614],
              [-7828567.457685957, 5497749.251586786],
              [-7835972.096255053, 5489237.091317652],
              [-7846381.915797605, 5474784.690475995],
              [-7845806.394030202, 5470407.670393786],
              [-7852932.622552826, 5466316.111169217],
              [-7858669.695149838, 5470404.41883751],
              [-7857745.743376253, 5484421.433210194],
              [-7861864.341896623, 5491948.6613523625],
              [-7883847.047021534, 5477379.644024622],
              [-7872004.322993493, 5459534.866925288],
              [-7881598.727265983, 5443169.852439945],
              [-7879525.73570843, 5436725.905926221],
              [-7887274.57414306, 5435274.032286206],
              [-7900424.300312506, 5432228.956765756],
              [-7902265.418574478, 5433460.065956226],
              [-7902562.747730645, 5440597.659164477],
              [-7903836.020066339, 5479834.750401626],
              [-7904656.333393994, 5505583.704372462],
              [-7904827.227499375, 5509635.67516008],
              [-7904938.416983663, 5512272.989805511],
              [-7905195.109022123, 5518339.961419922],
              [-7905850.316138705, 5533844.241501715],
              [-7906243.304054744, 5543156.256129044],
              [-7907769.82823199, 5580133.442050021],
              [-7910124.903379214, 5621529.200242513],
              [-7913026.223267758, 5669737.360309045],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Talbot',
        GEOID: '24041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8502553.652403139, 4691394.570049833],
              [-8494799.35931346, 4692613.14153527],
              [-8490512.891000973, 4700461.226408841],
              [-8484696.781565497, 4694830.853186159],
              [-8481553.34178448, 4697301.117249306],
              [-8482196.630399307, 4701028.861442223],
              [-8471804.203419784, 4704827.197062294],
              [-8471074.392838143, 4713690.294800184],
              [-8454641.29828775, 4709980.217575889],
              [-8448790.234532164, 4695222.020519211],
              [-8461887.306582466, 4682565.140223639],
              [-8454186.335528878, 4675097.409166541],
              [-8463366.742615107, 4660610.014078442],
              [-8479223.633520277, 4670355.076378786],
              [-8479779.91097665, 4674972.931490665],
              [-8482582.379157372, 4674621.892659621],
              [-8486856.045728415, 4680622.153852325],
              [-8490895.830049302, 4680603.464857344],
              [-8496172.707871377, 4675838.175416956],
              [-8499020.260445869, 4676826.422768377],
              [-8498190.373642005, 4683118.084400785],
              [-8503734.863519946, 4686924.010202501],
              [-8502553.652403139, 4691394.570049833],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bristol',
        GEOID: '25005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7946147.890599917, 5153813.091707264],
              [-7946144.589631155, 5158745.379234222],
              [-7943009.126237509, 5159412.715534568],
              [-7935773.359335947, 5163146.027745429],
              [-7919114.842816695, 5171892.726256994],
              [-7912643.172899939, 5175301.483774375],
              [-7909775.026219649, 5158741.317872866],
              [-7903658.5767980125, 5150450.3157215],
              [-7902921.5304494705, 5146975.64434751],
              [-7902265.190731754, 5146880.365266791],
              [-7900758.036145902, 5140162.520126307],
              [-7907754.800100733, 5133535.278053258],
              [-7905308.109012588, 5131002.826711502],
              [-7906610.213096397, 5127915.26891812],
              [-7894976.658391554, 5129759.9201358715],
              [-7893351.616464955, 5125624.878796785],
              [-7890878.765296473, 5124516.374485429],
              [-7888656.049023804, 5116170.746052251],
              [-7885780.889215595, 5103446.056743601],
              [-7881861.064248283, 5101474.048843166],
              [-7883858.958207049, 5098694.436897159],
              [-7887333.350834199, 5099361.18916127],
              [-7887834.585324248, 5099240.797137987],
              [-7893563.98916756, 5097864.752930807],
              [-7893683.459867009, 5097836.061472812],
              [-7897203.382165893, 5092338.799930427],
              [-7901647.590196832, 5087870.499381034],
              [-7905945.995545934, 5086694.623893597],
              [-7907637.246718455, 5086232.003137631],
              [-7913219.807862247, 5087754.845663144],
              [-7917105.637327369, 5085994.345497517],
              [-7918989.385750572, 5101629.683955067],
              [-7918476.8708149595, 5110199.57459525],
              [-7925462.391501219, 5112433.074766067],
              [-7926095.486320537, 5113428.441570652],
              [-7926905.15142351, 5114701.566944637],
              [-7932781.870659859, 5123947.248857404],
              [-7939016.876222088, 5127671.667311579],
              [-7940352.041311765, 5128469.403246586],
              [-7941487.611437347, 5135846.984625258],
              [-7941454.3269096, 5145024.4824738065],
              [-7946174.4959582165, 5144994.573543393],
              [-7946147.890599917, 5153813.091707264],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Butler',
        GEOID: '29023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10094291.347706286, 4428865.38834874],
              [-10047537.272892602, 4428246.15014668],
              [-10041486.168012062, 4407410.408584834],
              [-10034317.081485484, 4396827.390170766],
              [-10035273.761189362, 4387749.278182778],
              [-10042126.143764632, 4375463.032865902],
              [-10043327.84366958, 4369077.956135149],
              [-10073810.008553704, 4369414.510843929],
              [-10082894.131579317, 4369419.763041698],
              [-10088705.892255733, 4394532.986698668],
              [-10088609.044298744, 4412788.869101411],
              [-10092516.358425587, 4412858.2513635],
              [-10092363.516764728, 4422798.354639528],
              [-10094291.347706286, 4428865.38834874],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Daviess',
        GEOID: '21059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9728665.931099994, 4540508.6014610045],
              [-9715030.96327018, 4548410.540356221],
              [-9720796.644976327, 4553921.722825051],
              [-9718643.219792543, 4564382.325112423],
              [-9714895.08756122, 4561842.1533145355],
              [-9713209.999039782, 4560700.343057642],
              [-9704840.220485508, 4557041.591780158],
              [-9700102.351637857, 4552234.344885425],
              [-9696552.59571544, 4546651.673151812],
              [-9691233.97308432, 4555079.866348568],
              [-9689587.89177396, 4561789.433720884],
              [-9685943.959562333, 4568083.80269822],
              [-9682317.885792283, 4568934.91362463],
              [-9683366.245433524, 4564843.247586232],
              [-9672980.136942511, 4562785.692768139],
              [-9665139.90520594, 4542445.20117686],
              [-9664511.395360922, 4533429.610770227],
              [-9679091.688306553, 4527365.302502978],
              [-9689054.78273255, 4517566.452087831],
              [-9700249.182046212, 4519648.527752064],
              [-9730274.943019921, 4534819.81803931],
              [-9728665.931099994, 4540508.6014610045],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '49053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12696263.10675409, 4523743.38550277],
              [-12644535.722369727, 4523720.2009578375],
              [-12631921.88822896, 4525642.30408153],
              [-12631871.126541158, 4513113.254340505],
              [-12607304.13943748, 4513098.936626424],
              [-12607320.837361101, 4506529.4517675685],
              [-12583226.624134822, 4505450.320575589],
              [-12583231.076914454, 4508996.0337192025],
              [-12568081.050814945, 4509034.33969516],
              [-12567880.4416952, 4439148.774719873],
              [-12575370.028433105, 4439137.313070294],
              [-12686626.735033574, 4439110.271928755],
              [-12696054.716667328, 4439161.984687457],
              [-12696182.622762248, 4451440.525270004],
              [-12696207.669647677, 4478838.497255557],
              [-12696288.598917482, 4507910.896225172],
              [-12696263.10675409, 4523743.38550277],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Big Horn',
        GEOID: '30003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12100386.347822335, 5676624.199067135],
              [-12098449.722641004, 5689968.95236389],
              [-12094342.256069714, 5694878.570135278],
              [-12057723.598253775, 5694312.908876372],
              [-12057709.238039464, 5698915.738045476],
              [-12044010.929419389, 5698919.390260875],
              [-12030269.762795357, 5703526.97439134],
              [-12030249.725287015, 5745723.679696747],
              [-12027776.206201589, 5764255.266276713],
              [-12009352.162558358, 5764215.916120703],
              [-12009355.168184608, 5768842.51377409],
              [-12000109.861835247, 5773416.7608156325],
              [-12000102.292109871, 5778054.72710228],
              [-11986266.94919663, 5778067.383641429],
              [-11986265.390723757, 5787340.509565106],
              [-11968129.219283719, 5787307.311556479],
              [-11958488.394783568, 5787302.660637668],
              [-11958510.547362236, 5773408.914669484],
              [-11930817.597637592, 5773422.84558681],
              [-11930817.820276575, 5766470.033336322],
              [-11916968.11714902, 5766496.593415202],
              [-11916991.828200558, 5759549.360113415],
              [-11904405.601293508, 5759547.60148168],
              [-11904403.597542673, 5753405.225617675],
              [-11897517.373842202, 5753422.160740705],
              [-11901478.4552831, 5746476.194405369],
              [-11901496.155082135, 5729840.256791962],
              [-11880859.079961933, 5728653.868901628],
              [-11885434.644992009, 5677238.801053558],
              [-11885360.951489104, 5649860.498749106],
              [-11831003.087537294, 5649860.498749106],
              [-11829219.304016823, 5647807.067434527],
              [-11829222.653894704, 5620543.655097926],
              [-11898803.781877808, 5620873.686922886],
              [-11950307.74804415, 5621742.992265665],
              [-12012655.76750493, 5621764.561393207],
              [-12022210.342981417, 5621767.866777123],
              [-12050170.702751337, 5621620.640173655],
              [-12051292.559951158, 5622809.351716724],
              [-12046718.998671917, 5636350.155667881],
              [-12033420.32702379, 5656304.439040549],
              [-12100385.902544372, 5655860.6766136475],
              [-12100386.347822335, 5676624.199067135],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lemhi',
        GEOID: '16059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12780858.683990076, 5591399.780640387],
              [-12770938.670207016, 5604405.770734406],
              [-12771937.873956379, 5645349.219440961],
              [-12767677.78836321, 5652617.356504542],
              [-12757652.243702877, 5668214.087295335],
              [-12778721.349766847, 5690476.9104587715],
              [-12778784.91319609, 5701902.477990442],
              [-12764307.479459954, 5695978.886887267],
              [-12748728.099086149, 5714144.703690609],
              [-12746787.572720943, 5709992.459592157],
              [-12741268.686325885, 5707570.910826],
              [-12731445.409180325, 5699425.951106229],
              [-12721504.244694011, 5697504.66537264],
              [-12718456.205716603, 5706590.110415244],
              [-12711179.69588141, 5707818.233839629],
              [-12699678.054773157, 5717114.819006912],
              [-12692088.737168835, 5725076.0633811755],
              [-12692162.208032757, 5731786.3640679],
              [-12687256.58071248, 5732505.026826083],
              [-12684669.12418793, 5729627.115726052],
              [-12679165.657482643, 5723508.945726104],
              [-12674993.514287202, 5720244.218607165],
              [-12668907.121128082, 5716820.45982176],
              [-12668475.201503802, 5704261.637267738],
              [-12663703.71416993, 5697523.558652868],
              [-12664080.196687793, 5689112.373761852],
              [-12660631.741501998, 5682346.062589363],
              [-12660989.188386938, 5672873.980628923],
              [-12651467.253102953, 5658547.765958666],
              [-12643074.431414085, 5641759.874553819],
              [-12635966.570607442, 5637262.746811746],
              [-12629415.52989375, 5630853.541197006],
              [-12627829.895066889, 5622618.364445567],
              [-12629080.23558748, 5614210.902324093],
              [-12631931.684344148, 5607496.916397036],
              [-12626121.140883213, 5596775.235689875],
              [-12621086.939551068, 5595560.617420364],
              [-12612666.176670011, 5589931.106818896],
              [-12606616.852901323, 5593691.5196601255],
              [-12593728.39357677, 5584560.02732784],
              [-12590362.871411616, 5575759.14106974],
              [-12584595.965191072, 5563362.447380229],
              [-12585900.852262149, 5555224.225472612],
              [-12579862.549123049, 5546025.498254133],
              [-12579864.552873885, 5538733.735315817],
              [-12573664.0572367, 5530155.399655987],
              [-12565941.044923935, 5524486.680167853],
              [-12559824.916243251, 5528363.824184892],
              [-12558373.87989828, 5501148.131582715],
              [-12578555.99225961, 5501745.496973868],
              [-12614792.490263654, 5501596.035444063],
              [-12616908.451144654, 5514523.548058592],
              [-12629400.16780402, 5536116.623774163],
              [-12634971.708318222, 5530991.422728361],
              [-12669963.097817745, 5542205.036943774],
              [-12692709.565968988, 5567042.371453123],
              [-12699868.633741396, 5583181.81701555],
              [-12713269.60800156, 5581312.608461868],
              [-12711764.345847055, 5596043.336831312],
              [-12715083.002506584, 5602504.681061049],
              [-12735412.167915253, 5580611.26491775],
              [-12731926.643339023, 5575937.549948158],
              [-12740720.54915322, 5560603.756520258],
              [-12753537.318725703, 5554974.648283209],
              [-12764200.167470828, 5568490.906895413],
              [-12772446.047431847, 5569710.510153423],
              [-12781710.166775156, 5581940.650864701],
              [-12780858.683990076, 5591399.780640387],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Catron',
        GEOID: '35003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12139089.68574236, 3949822.9760375544],
              [-12139012.816730978, 3999061.633568504],
              [-12138992.615146387, 4012036.8764239447],
              [-12138965.453190634, 4099164.19886234],
              [-12138960.659257174, 4106854.4361904655],
              [-11991869.213890292, 4106697.7335240897],
              [-11991939.679127963, 4065683.3138793544],
              [-11990923.777454985, 4063747.937268976],
              [-11990528.927221142, 3958767.821700949],
              [-12022572.020007003, 3958925.57152273],
              [-12022571.57472904, 3922047.501575133],
              [-12072597.440696629, 3922013.444009154],
              [-12082971.304043654, 3922939.1534425225],
              [-12139082.89308681, 3923064.223194104],
              [-12139082.895253422, 3923073.5324423336],
              [-12139089.68574236, 3949822.9760375544],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Contra Costa',
        GEOID: '06013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13628317.380795142, 4573165.64435037],
              [-13621896.917844148, 4576342.14239139],
              [-13622042.635057595, 4580548.659557363],
              [-13619138.627046918, 4580733.157931259],
              [-13616790.024884516, 4580882.372485357],
              [-13610239.429448785, 4586699.775467565],
              [-13610958.448153151, 4587958.218787476],
              [-13596909.92230171, 4583913.549058142],
              [-13591634.825591486, 4586259.006473684],
              [-13586586.820642486, 4587933.265078431],
              [-13567423.058982931, 4586395.136779473],
              [-13565667.216654649, 4588757.84123201],
              [-13558855.35437403, 4582480.726747443],
              [-13551792.577961158, 4583188.422069144],
              [-13544583.639056876, 4592645.206246461],
              [-13534226.139674999, 4592771.94355752],
              [-13529121.58442467, 4558119.7258192655],
              [-13531663.008399483, 4553534.059634938],
              [-13533890.288771275, 4552835.00596897],
              [-13566900.63661264, 4542665.218515062],
              [-13576610.813155554, 4539753.426492824],
              [-13577913.251197835, 4541146.588208602],
              [-13579861.45360621, 4541864.422764066],
              [-13582288.218505504, 4543807.046569414],
              [-13582176.899014711, 4544890.99099708],
              [-13580729.745634397, 4546031.514100168],
              [-13581513.212210601, 4547065.696345536],
              [-13586039.907984218, 4550946.908103967],
              [-13596591.54855804, 4551853.648261081],
              [-13611154.364343615, 4566130.431641896],
              [-13617570.183869997, 4564438.721346495],
              [-13618217.586034449, 4566549.040678118],
              [-13623135.569818206, 4566041.124921995],
              [-13628317.380795142, 4573165.64435037],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Saline',
        GEOID: '05125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10360936.593795776, 4144612.96130464],
              [-10323744.974560725, 4143984.5965470597],
              [-10313889.748721305, 4143743.542859107],
              [-10314232.167474987, 4131929.0660833493],
              [-10302602.842910795, 4131543.9611785165],
              [-10302837.393077897, 4121755.8785632155],
              [-10290737.187067648, 4119401.6599613056],
              [-10290946.801668812, 4113298.642128329],
              [-10279979.494116368, 4113117.771407678],
              [-10280215.714075832, 4107259.920094994],
              [-10268578.374508303, 4107070.628546724],
              [-10268757.48756899, 4095261.8924694364],
              [-10286316.91272723, 4095571.0611006827],
              [-10286441.92451539, 4089645.9280795464],
              [-10307006.864605557, 4090148.8067208766],
              [-10315833.72098903, 4084560.4864101377],
              [-10317758.323665354, 4085469.3244951884],
              [-10317654.351260953, 4092506.357894933],
              [-10323647.681325773, 4092612.088627392],
              [-10329691.43911992, 4096626.134258291],
              [-10331342.418487875, 4108357.3330721688],
              [-10338848.469113084, 4114405.845507082],
              [-10350475.344648479, 4114689.6989596],
              [-10349289.56943255, 4132975.9083854235],
              [-10361081.420453297, 4132925.224054372],
              [-10360936.593795776, 4144612.96130464],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pike',
        GEOID: '21195',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9207324.695701744, 4478952.10670736],
              [-9203046.68767056, 4481963.204023101],
              [-9193287.975829659, 4504342.268171432],
              [-9197562.75559561, 4509528.26079494],
              [-9196588.042134225, 4533010.081357566],
              [-9190933.568599379, 4535000.007186318],
              [-9173183.007875448, 4533095.30789202],
              [-9174174.419260453, 4538886.013842286],
              [-9163895.61799162, 4543601.2018711325],
              [-9161161.950023154, 4535187.092107183],
              [-9153368.806431191, 4530534.596394856],
              [-9143956.075567674, 4522393.147112993],
              [-9135369.224006353, 4515279.525478176],
              [-9124669.083231814, 4514336.368215123],
              [-9150656.395718522, 4491521.779065553],
              [-9162642.165292233, 4481015.059047233],
              [-9163193.803789007, 4480488.928175628],
              [-9167754.846865386, 4476139.793694022],
              [-9178198.952811103, 4473159.167099428],
              [-9189829.11727013, 4467223.6934816055],
              [-9190334.33578044, 4466965.930078044],
              [-9191124.448441606, 4466448.16604592],
              [-9198209.41051763, 4473703.985937282],
              [-9204370.165096601, 4471046.162936893],
              [-9209761.256716227, 4477018.534610674],
              [-9207324.695701744, 4478952.10670736],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scotland',
        GEOID: '37165',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8871378.211250173, 4137407.787190801],
              [-8862594.949392766, 4138810.614157865],
              [-8856785.296487758, 4151704.7312544147],
              [-8858072.929037763, 4162822.564565577],
              [-8845307.700389516, 4169813.0923474566],
              [-8833549.356535496, 4156306.433854465],
              [-8832964.261291886, 4141962.7284226823],
              [-8831067.043210296, 4133221.473156269],
              [-8845646.115092577, 4113716.763429938],
              [-8869413.713481817, 4137378.1905644042],
              [-8871378.211250173, 4137407.787190801],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cook',
        GEOID: '17031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9825463.571680302, 5171001.964716428],
              [-9822637.837726006, 5174822.780085082],
              [-9822659.21106824, 5184113.273979654],
              [-9818332.779058559, 5184114.92573633],
              [-9798759.027714413, 5184036.092215046],
              [-9796612.342653956, 5184022.577962771],
              [-9790120.523909364, 5183951.703532173],
              [-9769323.545602966, 5183829.923722001],
              [-9767360.244258707, 5180212.349252789],
              [-9767357.135195522, 5180206.621591772],
              [-9767322.986094296, 5180165.860285094],
              [-9761525.510085963, 5173248.3644101685],
              [-9760755.555433007, 5172330.039701617],
              [-9759266.434604665, 5165345.774400657],
              [-9755413.169862887, 5150935.015198141],
              [-9754368.38964241, 5147031.407835805],
              [-9754264.849883324, 5146644.639632862],
              [-9752955.621352104, 5145014.911605885],
              [-9753096.440507958, 5143690.78474408],
              [-9753401.12195426, 5141664.799723836],
              [-9752639.36267876, 5137824.217163269],
              [-9750293.40933055, 5132715.159996396],
              [-9750148.830209538, 5132400.3823792115],
              [-9749539.411051633, 5131073.668991708],
              [-9747206.526250085, 5125996.647464703],
              [-9743877.962155877, 5123340.55699351],
              [-9743142.808238678, 5119723.734041981],
              [-9743132.010248069, 5117389.076022653],
              [-9743231.752511822, 5090794.264898523],
              [-9743284.000687467, 5081957.390356998],
              [-9772437.756755326, 5081891.7745580515],
              [-9772783.515093729, 5090542.368302358],
              [-9775216.291245526, 5095041.5150223],
              [-9786027.194913404, 5094831.755951655],
              [-9786311.28225391, 5107790.665521216],
              [-9799294.140506657, 5111661.841493413],
              [-9799340.449414827, 5113946.213419394],
              [-9796665.219412085, 5114007.3282503635],
              [-9794128.359536394, 5114070.828462891],
              [-9793924.533548752, 5114238.673772062],
              [-9792405.356457898, 5114169.806158395],
              [-9791139.097250124, 5115124.307656225],
              [-9790240.748959422, 5115477.779060233],
              [-9789697.621163841, 5115976.626754769],
              [-9789591.756328097, 5116636.529120798],
              [-9786586.018757187, 5119156.682726311],
              [-9786800.197457474, 5126814.708754453],
              [-9786885.579506911, 5129758.277766409],
              [-9786909.513197433, 5130529.326568283],
              [-9787256.718689216, 5147035.175558671],
              [-9787237.5717368, 5152235.417592998],
              [-9789321.027326487, 5160008.071994638],
              [-9815495.46787722, 5159136.991969186],
              [-9825378.300950356, 5158939.152868504],
              [-9825420.602356857, 5163300.353078063],
              [-9825463.571680302, 5171001.964716428],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '17055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9927204.688207759, 4572408.799738433],
              [-9920592.42177413, 4587899.757457705],
              [-9921865.805429315, 4597063.399557867],
              [-9874551.57093796, 4597126.795116048],
              [-9874775.991031397, 4566267.708714144],
              [-9874791.353121128, 4560138.003497757],
              [-9924263.515941512, 4559949.2007252285],
              [-9924216.650435887, 4571685.18313828],
              [-9927204.688207759, 4572408.799738433],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harlan',
        GEOID: '21095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9294043.469585631, 4424538.71723044],
              [-9285004.43825271, 4423815.619303689],
              [-9284007.238254182, 4428094.6532476535],
              [-9268463.029837774, 4434779.840258954],
              [-9259789.460393125, 4442050.354755273],
              [-9253108.732472656, 4439245.757104277],
              [-9256594.257048886, 4433057.858428345],
              [-9232779.121786026, 4441270.295943265],
              [-9224955.254014602, 4435508.70172648],
              [-9224510.977926847, 4428090.197489229],
              [-9226577.314023376, 4424777.738246381],
              [-9227878.726481816, 4422692.02694537],
              [-9240918.914272321, 4417842.1654436905],
              [-9247932.376150768, 4418301.232429939],
              [-9252285.30219926, 4410722.069041094],
              [-9254701.157788454, 4403356.811879346],
              [-9265833.552145746, 4401106.420905718],
              [-9282498.079917498, 4395510.907552178],
              [-9288109.584128896, 4392678.861451843],
              [-9290830.97247617, 4392671.372359233],
              [-9295276.66690464, 4401990.768887775],
              [-9294043.469585631, 4424538.71723044],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Geary',
        GEOID: '20061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10793891.489338055, 4740640.168996367],
              [-10793673.525775082, 4743341.390924348],
              [-10793726.29121372, 4753244.777432321],
              [-10781279.213670159, 4753091.893055278],
              [-10781449.532491071, 4734309.909741234],
              [-10742460.660077164, 4727928.283876266],
              [-10742504.074678574, 4703024.936361389],
              [-10785772.73623552, 4703076.8376861755],
              [-10789832.001467299, 4703117.300886332],
              [-10789776.23040241, 4718655.500278235],
              [-10793924.105948858, 4716645.188288985],
              [-10793891.489338055, 4740640.168996367],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pickett',
        GEOID: '47137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9493869.191326458, 4373974.895633943],
              [-9491885.366681032, 4379787.438040787],
              [-9492912.951056205, 4387125.287402575],
              [-9472857.637439229, 4386615.611107432],
              [-9459359.084502835, 4385519.9756051395],
              [-9455917.037330309, 4385240.613317201],
              [-9438267.552316247, 4383965.690358785],
              [-9432305.171457637, 4373057.953552706],
              [-9455827.536459709, 4380900.835185283],
              [-9467046.314741857, 4377785.083981151],
              [-9475564.593496848, 4356792.115686667],
              [-9492062.364671394, 4375166.109358415],
              [-9493869.191326458, 4373974.895633943],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '24043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8721057.560184678, 4825721.166605431],
              [-8693937.64937607, 4825693.406408801],
              [-8691365.089766407, 4825690.773116518],
              [-8657165.84976337, 4825559.069067434],
              [-8623840.133804588, 4825369.620906401],
              [-8623825.773999974, 4825369.621232036],
              [-8635073.160981556, 4810874.110858354],
              [-8644646.080592323, 4774579.50461954],
              [-8647041.538229425, 4767316.7332662335],
              [-8651697.279778149, 4767802.112981256],
              [-8654637.33884949, 4772394.487166578],
              [-8653978.550102977, 4779375.220716304],
              [-8660456.119952746, 4790045.138571216],
              [-8661874.652675886, 4793654.096561806],
              [-8663301.557456914, 4797285.665242609],
              [-8663975.263015194, 4806148.102262804],
              [-8674681.303722745, 4809088.627993994],
              [-8683669.907326339, 4808177.657418626],
              [-8685995.939237695, 4810969.197531255],
              [-8692077.423187993, 4818271.451851939],
              [-8707975.516265633, 4816494.480167269],
              [-8717766.956036828, 4812464.349082444],
              [-8719966.07497072, 4812106.851742902],
              [-8717799.46132814, 4821353.558099581],
              [-8721084.334589906, 4825721.209001011],
              [-8721057.560184678, 4825721.166605431],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'White',
        GEOID: '17193',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9837345.146210631, 4615556.876517096],
              [-9812913.30096878, 4615667.167487778],
              [-9799204.194358097, 4615605.359034848],
              [-9795068.786594618, 4616180.078545521],
              [-9792660.723369775, 4613015.40785597],
              [-9792797.962580297, 4612006.65662663],
              [-9793423.373201203, 4607410.941917633],
              [-9788040.964501856, 4600912.9795487905],
              [-9791908.426250996, 4593569.745341666],
              [-9794865.071926467, 4587281.935965822],
              [-9799553.180961734, 4583765.438697165],
              [-9797930.922022404, 4573998.929070902],
              [-9800663.815521376, 4564147.382544251],
              [-9802735.48580424, 4560610.321064749],
              [-9811242.061453499, 4567582.867098437],
              [-9837806.676819462, 4566492.604366913],
              [-9837345.146210631, 4615556.876517096],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wallace',
        GEOID: '20199',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11359842.421218736, 4740761.681130939],
              [-11296500.99402052, 4740993.353632782],
              [-11297189.839029549, 4678813.474657987],
              [-11306397.185432551, 4678742.583361874],
              [-11359676.798008231, 4678442.587416705],
              [-11359772.320919638, 4728411.6038922835],
              [-11359842.421218736, 4740761.681130939],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Collin',
        GEOID: '48085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10780385.31815909, 3906785.1819879264],
              [-10779934.028943414, 3930243.10487511],
              [-10779523.81661984, 3949251.5593880797],
              [-10729484.814952338, 3948228.5472825724],
              [-10729472.903766822, 3940669.8302346747],
              [-10719556.340887975, 3942111.29395945],
              [-10719758.274444275, 3892882.0970047135],
              [-10738626.816814244, 3892915.0080977697],
              [-10744208.37608262, 3892955.8816807494],
              [-10754951.931458568, 3893183.210411414],
              [-10776102.41207031, 3893578.9560630773],
              [-10780622.428674478, 3893652.0815552683],
              [-10780385.31815909, 3906785.1819879264],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Childress',
        GEOID: '48075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11178246.298950825, 4129623.512727977],
              [-11131991.62505966, 4129465.7553117075],
              [-11131991.49205335, 4104315.310190816],
              [-11131685.177345624, 4104400.1490153903],
              [-11131695.270888349, 4070750.2921385695],
              [-11178456.470149443, 4070978.7335049985],
              [-11178246.298950825, 4129623.512727977],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Knox',
        GEOID: '21121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9361062.255822813, 4432974.413497507],
              [-9346297.283841958, 4435926.45068734],
              [-9336512.077962248, 4446764.554696107],
              [-9325685.812204638, 4444241.797830209],
              [-9310953.790793056, 4433512.5682156235],
              [-9305142.913373647, 4432945.716394165],
              [-9302540.374998393, 4429566.54828726],
              [-9328378.296728455, 4409208.162468093],
              [-9337200.922971277, 4395603.915335612],
              [-9346221.252629746, 4401156.143567878],
              [-9349019.824628288, 4411382.550583942],
              [-9358165.722672373, 4418796.212309244],
              [-9361062.255822813, 4432974.413497507],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Laurel',
        GEOID: '21125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9390692.27600675, 4433449.180725056],
              [-9384568.813457195, 4444460.04666091],
              [-9383017.019755535, 4460278.544259485],
              [-9379147.44293607, 4472484.3355870545],
              [-9366187.961776389, 4483771.283864634],
              [-9364746.040412145, 4485992.548566322],
              [-9351461.283700367, 4474478.611316727],
              [-9344571.94305415, 4474088.144899569],
              [-9347449.885849632, 4462672.137634912],
              [-9338110.403211057, 4455674.330102027],
              [-9336512.077962248, 4446764.554696107],
              [-9346297.283841958, 4435926.45068734],
              [-9361062.255822813, 4432974.413497507],
              [-9371223.276303444, 4430658.9739548825],
              [-9379526.485802222, 4435322.40604487],
              [-9383945.42430875, 4431572.943212515],
              [-9391591.403533887, 4431223.614367547],
              [-9390692.27600675, 4433449.180725056],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '20115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10839391.550087953, 4665868.218482266],
              [-10790230.079966374, 4665869.500606155],
              [-10790194.791687792, 4653490.253173104],
              [-10777898.440734768, 4653495.5177546805],
              [-10779918.332895212, 4628794.133724516],
              [-10780265.427067505, 4591528.4008597685],
              [-10815012.804243209, 4591822.865949738],
              [-10815032.841751551, 4604125.198512055],
              [-10839373.627649935, 4603989.117655281],
              [-10839391.550087953, 4665868.218482266],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lawrence',
        GEOID: '21127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9241979.5663806, 4580421.365460416],
              [-9227121.642624931, 4595373.796561843],
              [-9231147.066731505, 4604193.168810735],
              [-9219836.449869456, 4608888.451279884],
              [-9216608.852553396, 4613920.08750067],
              [-9196582.253520703, 4617082.20050568],
              [-9193286.062706871, 4613458.1698594615],
              [-9194863.480582854, 4607860.405345663],
              [-9197904.506432347, 4598491.02594378],
              [-9189357.952526692, 4588338.3341425955],
              [-9179960.361113925, 4576157.281262267],
              [-9181567.049041664, 4570750.389929843],
              [-9192859.729748577, 4572940.039301406],
              [-9196369.521973798, 4562385.005750573],
              [-9220773.203384481, 4574889.892099222],
              [-9234179.187021734, 4579470.453168113],
              [-9238294.77991585, 4574336.949453478],
              [-9241979.5663806, 4580421.365460416],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Letcher',
        GEOID: '21133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9253108.732472656, 4439245.757104277],
              [-9245678.156462207, 4441531.145679198],
              [-9246065.325651186, 4456415.940381203],
              [-9239533.5432094, 4466421.459278948],
              [-9237200.39800186, 4463167.238912173],
              [-9219410.43017819, 4476622.518605721],
              [-9209761.256716227, 4477018.534610674],
              [-9204370.165096601, 4471046.162936893],
              [-9198209.41051763, 4473703.985937282],
              [-9191124.448441606, 4466448.16604592],
              [-9209048.923294643, 4454709.00235534],
              [-9208599.192551836, 4447187.072036742],
              [-9211767.456579305, 4442467.52506068],
              [-9219006.897024063, 4440109.864319923],
              [-9224955.254014602, 4435508.70172648],
              [-9232779.121786026, 4441270.295943265],
              [-9256594.257048886, 4433057.858428345],
              [-9253108.732472656, 4439245.757104277],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lewis',
        GEOID: '21135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9311095.500504836, 4670701.543530888],
              [-9309306.373648806, 4675850.011002281],
              [-9298888.7617419, 4679090.055270232],
              [-9288543.284865027, 4674420.42862858],
              [-9281407.482866196, 4673295.839056641],
              [-9275199.083545165, 4667771.637283273],
              [-9271412.328426851, 4664427.78264772],
              [-9268939.355024971, 4666403.803677922],
              [-9266180.423679058, 4668608.769399894],
              [-9258736.711968692, 4667420.988363905],
              [-9253874.944527788, 4670267.989838699],
              [-9252026.929661129, 4674751.784174984],
              [-9244230.780442912, 4679976.476056948],
              [-9242894.6049396, 4681196.0620064335],
              [-9242197.752582554, 4676408.865891502],
              [-9252450.500323595, 4655886.486679148],
              [-9258043.414180031, 4650865.840482186],
              [-9265920.603987545, 4639816.309033085],
              [-9265196.915977897, 4627467.044041744],
              [-9277516.310065517, 4624662.2677661795],
              [-9285381.700007007, 4635582.712735472],
              [-9289928.544608459, 4633502.497188282],
              [-9304262.598840455, 4640528.520359337],
              [-9310968.37364635, 4653912.7088782815],
              [-9309047.44451322, 4666163.396137033],
              [-9311531.583937451, 4670499.007323768],
              [-9311095.500504836, 4670701.543530888],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Livingston',
        GEOID: '21139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9850321.881891387, 4486548.393098291],
              [-9847974.599108517, 4495085.908756016],
              [-9842712.860737193, 4498090.698426144],
              [-9842413.208569197, 4497983.278870246],
              [-9836016.102810051, 4495690.301315589],
              [-9831529.704692101, 4494729.987840804],
              [-9820491.931901986, 4477248.373405603],
              [-9817657.626346897, 4459652.299033168],
              [-9821846.133507485, 4450483.398022085],
              [-9819405.564991333, 4439103.441960619],
              [-9822873.167129545, 4436585.713764815],
              [-9833885.002478305, 4447642.946572255],
              [-9849877.717123121, 4442252.663570142],
              [-9849971.924245603, 4448600.5520900125],
              [-9849117.405001003, 4448620.464688261],
              [-9845608.392012218, 4452859.421007848],
              [-9843401.037829278, 4460021.701014214],
              [-9848630.493548272, 4469838.143269403],
              [-9853406.99025923, 4479739.151659289],
              [-9850321.881891387, 4486548.393098291],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wabaunsee',
        GEOID: '20197',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10742504.074678574, 4703024.936361389],
              [-10742460.660077164, 4727928.283876266],
              [-10730174.327878311, 4727869.662109841],
              [-10729979.51876942, 4746465.202520819],
              [-10723561.95012519, 4744456.106647104],
              [-10712683.252887418, 4752124.493286056],
              [-10695972.638846476, 4749427.38462621],
              [-10691019.255464647, 4739811.718889265],
              [-10685974.033502914, 4740857.876230087],
              [-10680743.798547484, 4735817.226225329],
              [-10680725.208192522, 4703063.3976482665],
              [-10680651.403370123, 4684370.203565101],
              [-10725923.81576135, 4684357.216356296],
              [-10730130.022720974, 4696757.833457925],
              [-10742486.374879539, 4696804.987397802],
              [-10742504.074678574, 4703024.936361389],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hancock',
        GEOID: '17067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10185394.71695839, 4902149.341083388],
              [-10184942.037324483, 4905244.632866423],
              [-10182355.528955901, 4912905.084374625],
              [-10176763.505655391, 4921063.79365228],
              [-10171587.038014011, 4924110.19806129],
              [-10172364.715976695, 4931860.8285098765],
              [-10171025.431182962, 4940403.366890691],
              [-10173986.418318572, 4943927.394583894],
              [-10171735.204256259, 4950967.376517567],
              [-10167891.008280694, 4955497.310417974],
              [-10157664.309300499, 4959149.699669029],
              [-10150888.180576421, 4958989.360212123],
              [-10150719.042711066, 4959108.890259081],
              [-10119411.036081752, 4959268.672362471],
              [-10120027.746060748, 4907356.114337448],
              [-10120274.096093873, 4894041.102116263],
              [-10186430.436260208, 4895071.041268383],
              [-10185394.71695839, 4902149.341083388],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Big Stone',
        GEOID: '27011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10779669.55186461, 5714272.302573822],
              [-10714837.841631722, 5714176.435718915],
              [-10713535.626228422, 5686723.111191517],
              [-10699699.504078744, 5686616.231765348],
              [-10699812.827320373, 5659349.891675221],
              [-10698205.373873316, 5649378.364517944],
              [-10721337.45274067, 5661217.632990167],
              [-10737605.738616295, 5663953.766340324],
              [-10737631.063969098, 5670079.0837629475],
              [-10738999.915559033, 5673116.966364382],
              [-10740389.004353503, 5676200.813496738],
              [-10744756.179296812, 5680854.242307259],
              [-10749248.477347774, 5682509.634325424],
              [-10755436.059924029, 5685997.65646051],
              [-10761861.532252105, 5686334.450431139],
              [-10765795.451737251, 5690571.461743104],
              [-10769326.839943685, 5697204.124692744],
              [-10773615.645965477, 5706297.687112875],
              [-10779669.55186461, 5714272.302573822],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calaveras',
        GEOID: '06009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13469157.114319062, 4611316.672899656],
              [-13457732.061020475, 4610774.247730618],
              [-13448521.70899122, 4619341.325642702],
              [-13428613.776535716, 4627605.706254275],
              [-13426787.135011286, 4634583.100033921],
              [-13405450.973488905, 4646507.815895457],
              [-13395190.099425035, 4645351.88431042],
              [-13381237.537087986, 4650449.6268994715],
              [-13366407.777163489, 4651705.71595788],
              [-13366416.905361734, 4642777.312456015],
              [-13360559.830353646, 4640850.111624635],
              [-13377950.829122314, 4632397.017090069],
              [-13407600.998134086, 4587727.272688383],
              [-13409857.332892971, 4581110.83499558],
              [-13417814.227455895, 4577934.570161094],
              [-13415663.089615805, 4572843.473934368],
              [-13431061.024221312, 4555700.1420184],
              [-13461470.726118764, 4590368.584148794],
              [-13463214.434622554, 4593042.680027029],
              [-13469157.114319062, 4611316.672899656],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Duval',
        GEOID: '48131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10998735.827682316, 3256222.6373096374],
              [-10946526.76386129, 3256263.0036009694],
              [-10935525.503864154, 3256283.943661934],
              [-10935187.871848576, 3156304.481130563],
              [-10967561.806161076, 3156637.9737328454],
              [-10967451.488545699, 3166426.404856349],
              [-10998179.007589368, 3167773.050889515],
              [-10998735.827682316, 3256222.6373096374],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Barnstable',
        GEOID: '25001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7870087.290042541, 5095147.288885046],
              [-7869775.038870866, 5101627.450921233],
              [-7872066.867255927, 5103334.722380656],
              [-7869282.116165633, 5110252.470409484],
              [-7861469.825621252, 5123235.367158185],
              [-7862780.056027888, 5125529.513728746],
              [-7855300.276802507, 5129076.868061813],
              [-7852076.93791614, 5132804.782275694],
              [-7847361.527316584, 5127168.163899574],
              [-7841536.178363373, 5124036.331050746],
              [-7828411.721718337, 5121523.844648008],
              [-7822675.4283577595, 5119329.38970007],
              [-7816417.491863323, 5122556.659382027],
              [-7805942.884377131, 5124923.169322451],
              [-7795117.731814431, 5129180.629116638],
              [-7792792.045012778, 5132339.683939693],
              [-7793044.628937386, 5138894.660308817],
              [-7800046.513588794, 5143757.173634614],
              [-7800602.665764796, 5151793.937063641],
              [-7800888.534121052, 5154681.508731981],
              [-7801690.145870357, 5162783.29813935],
              [-7809146.881961143, 5164960.182640764],
              [-7813607.899235194, 5163980.013605081],
              [-7819680.488777458, 5170531.124444752],
              [-7813437.69173377, 5173321.117922317],
              [-7807831.3082189495, 5174906.637750393],
              [-7797861.534623503, 5170674.473348448],
              [-7791711.578035139, 5160868.296696308],
              [-7790163.720767417, 5152891.9085071115],
              [-7789556.989290834, 5149767.130098339],
              [-7785234.5647828225, 5132474.395507399],
              [-7784378.40657913, 5114908.891786108],
              [-7784697.670878726, 5104622.118002765],
              [-7788466.16960055, 5093973.2791047795],
              [-7793614.3620912675, 5092905.459312271],
              [-7793695.847958528, 5104195.931785518],
              [-7793144.816479101, 5111909.82162229],
              [-7798545.147616465, 5110906.018527727],
              [-7810021.964478269, 5108759.7284264695],
              [-7822385.775042715, 5103894.843071432],
              [-7828163.367934377, 5105791.025575962],
              [-7836956.828470611, 5102198.529015766],
              [-7841933.700264996, 5100030.07151091],
              [-7845380.9309363905, 5095072.9048938975],
              [-7854668.650011745, 5093559.761899802],
              [-7865178.879734993, 5089201.806462029],
              [-7866843.592210097, 5088295.614949864],
              [-7870009.477718476, 5090411.069444842],
              [-7873192.20713569, 5092802.228428704],
              [-7870087.290042541, 5095147.288885046],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bourbon',
        GEOID: '21017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9400114.023749022, 4619515.190485867],
              [-9388000.79335835, 4620297.334967065],
              [-9384919.803811666, 4623751.252551127],
              [-9382211.957198117, 4623660.595273028],
              [-9372438.773823414, 4632075.548478755],
              [-9361448.645775357, 4616080.698261117],
              [-9347417.6031973, 4609039.472310321],
              [-9348379.737556228, 4606601.305563837],
              [-9350040.735678354, 4603945.362589344],
              [-9359801.451270089, 4595700.913603124],
              [-9382725.919287112, 4588898.953271115],
              [-9393095.552493485, 4595182.794427304],
              [-9390381.249349473, 4604668.9734375775],
              [-9395570.630051784, 4608835.325270666],
              [-9397582.28456991, 4609735.812708006],
              [-9400114.023749022, 4619515.190485867],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fulton',
        GEOID: '21075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9968040.796251891, 4379963.755169088],
              [-9960795.23323514, 4378819.270347098],
              [-9952842.56881287, 4378277.633616664],
              [-9949590.703847816, 4386589.119162812],
              [-9943871.75150456, 4386818.573311851],
              [-9943575.44384331, 4386830.461816176],
              [-9938485.58276577, 4380405.808285438],
              [-9932739.715928983, 4379251.989595379],
              [-9929602.398719955, 4387054.748924545],
              [-9926987.923816958, 4390615.991059107],
              [-9923809.555058056, 4390310.424066224],
              [-9910399.007321682, 4382405.60248115],
              [-9900852.693069212, 4382321.028225877],
              [-9896690.123349981, 4380290.060408798],
              [-9889021.214856096, 4369914.755384033],
              [-9903479.610412953, 4369943.928418766],
              [-9930968.622830462, 4370420.191151091],
              [-9945861.536477137, 4369826.522122478],
              [-9953887.524872946, 4369506.599650608],
              [-9967461.712260785, 4369354.411207106],
              [-9971051.654519377, 4374916.162398325],
              [-9968040.796251891, 4379963.755169088],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carroll',
        GEOID: '24013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8595759.765005136, 4825367.92014211],
              [-8571524.874120742, 4825346.272625034],
              [-8570605.817473354, 4825345.4516899595],
              [-8547900.55977062, 4825488.173368769],
              [-8549816.012011785, 4818953.518075897],
              [-8559700.737516265, 4787403.881410588],
              [-8559055.084469665, 4784967.567825314],
              [-8557505.29451884, 4772960.13308518],
              [-8558495.592708936, 4771957.425467825],
              [-8582919.534266943, 4774708.956171495],
              [-8590311.371094598, 4772500.4443777995],
              [-8583483.812765775, 4792373.055220267],
              [-8593644.72192691, 4804435.384902435],
              [-8605822.18366377, 4810744.480662634],
              [-8595759.765005136, 4825367.92014211],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Red River',
        GEOID: '22081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10421139.621570159, 3794530.149164037],
              [-10405171.842491282, 3794485.4026657287],
              [-10400378.536537215, 3794315.7623150074],
              [-10376439.614000592, 3794297.337596363],
              [-10373547.422310293, 3782807.8133824733],
              [-10366203.230224695, 3759715.8007726436],
              [-10379259.002743913, 3759738.240500248],
              [-10379373.77313892, 3750652.780133201],
              [-10392281.379415892, 3754416.9959714],
              [-10401860.866876615, 3761890.417792713],
              [-10412775.408990424, 3776729.117695667],
              [-10412375.772018477, 3788688.198777992],
              [-10421139.621570159, 3794530.149164037],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shoshone',
        GEOID: '16079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12949751.947504686, 6109803.65078961],
              [-12944479.299823266, 6116740.24182693],
              [-12939010.952477029, 6118323.337953355],
              [-12917354.060563218, 6104298.903249953],
              [-12916484.117681118, 6102422.2027872475],
              [-12908602.1411355, 6089925.99078066],
              [-12902032.95534481, 6080785.874889657],
              [-12895859.176385412, 6076126.955526707],
              [-12894733.847652983, 6067178.333315819],
              [-12882311.149077907, 6056539.237983902],
              [-12883702.642712826, 6049610.514915967],
              [-12879028.782572377, 6044439.050951548],
              [-12882025.837223005, 6036657.295236195],
              [-12881560.187793016, 6029460.743807813],
              [-12872394.1409211, 6021067.16918838],
              [-12878878.055981845, 6017028.769483368],
              [-12880816.128316555, 6010535.677125262],
              [-12866153.013669774, 6002186.0606916165],
              [-12860960.182063248, 5993498.18769943],
              [-12854168.357290968, 5988697.19207151],
              [-12843132.81089067, 5985471.537483331],
              [-12838132.116725253, 5983945.921698832],
              [-12834258.977682084, 5976396.25604781],
              [-12830215.408498509, 5970640.41847038],
              [-12822831.030076737, 5963488.117681038],
              [-12815201.860094711, 5952075.243795458],
              [-12809673.400223443, 5945679.325284795],
              [-12805264.814429559, 5937431.217763481],
              [-12797447.058773668, 5931127.515387042],
              [-12872559.116406456, 5931203.99270257],
              [-12949733.579788707, 5931416.902345262],
              [-12949731.576037873, 5945651.892111416],
              [-12949730.240203984, 6009914.979618759],
              [-12949744.934376767, 6088639.467825316],
              [-12949751.947504686, 6109803.65078961],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fresno',
        GEOID: '06019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13431358.915178677, 4432534.21404165],
              [-13424080.40159265, 4432507.607634553],
              [-13418640.218077581, 4445312.027165317],
              [-13408470.625996161, 4426732.531435709],
              [-13409127.967589296, 4420008.857346885],
              [-13399555.60457598, 4409172.440708343],
              [-13383850.984773342, 4407052.561816313],
              [-13364770.4900929, 4414444.433761993],
              [-13361471.759622224, 4413279.8382777255],
              [-13350806.795806775, 4417290.47660781],
              [-13337603.858920729, 4418276.609243214],
              [-13326410.461482482, 4437941.2963713175],
              [-13325539.275147535, 4439078.073546085],
              [-13316161.72124311, 4442815.830233848],
              [-13314357.454936333, 4449010.129948414],
              [-13309689.94000686, 4448044.573242947],
              [-13310163.604440186, 4455280.510406332],
              [-13303428.663927702, 4460112.9012991125],
              [-13299433.518722624, 4454526.9750138195],
              [-13295227.423082488, 4461644.010510356],
              [-13287400.549684817, 4462438.146099145],
              [-13283818.62242956, 4467830.349167641],
              [-13284332.47319906, 4482513.657117073],
              [-13278930.026991373, 4491498.665696229],
              [-13249508.842172164, 4521068.50932133],
              [-13237786.565833159, 4516096.678928696],
              [-13230374.2462192, 4505635.75546766],
              [-13221974.077443939, 4503848.310900672],
              [-13223278.964515015, 4487078.222893942],
              [-13215406.450126117, 4484954.024081694],
              [-13208568.873043124, 4458893.983086092],
              [-13201674.634339312, 4458380.23052728],
              [-13184361.781853182, 4447447.928073248],
              [-13175867.436788708, 4423469.885923803],
              [-13179087.575698886, 4416058.530473365],
              [-13175840.163513463, 4403590.893144861],
              [-13245064.745460713, 4403156.492408447],
              [-13245325.010430189, 4391424.639900463],
              [-13256848.358839147, 4391475.566364911],
              [-13266477.049514802, 4391664.842872922],
              [-13280930.104282456, 4391904.6349361455],
              [-13280983.203679565, 4379854.942761738],
              [-13298930.131985255, 4380064.667536729],
              [-13307814.429225978, 4370881.79426764],
              [-13310827.068605315, 4368094.473557335],
              [-13321202.713064192, 4358412.749082296],
              [-13330978.011509221, 4356081.056245998],
              [-13353800.065594712, 4355936.1115625],
              [-13353781.25260077, 4325658.382886649],
              [-13393412.104518084, 4287857.81265509],
              [-13406546.134639328, 4296347.442340605],
              [-13432650.33259137, 4319634.468147741],
              [-13428126.197166039, 4328621.246387491],
              [-13433878.297894312, 4337466.671582444],
              [-13424747.873259446, 4345915.462547273],
              [-13424813.885717485, 4368011.396817112],
              [-13460611.562288824, 4402980.7644875115],
              [-13431358.915178677, 4432534.21404165],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tulare',
        GEOID: '06107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13307814.429225978, 4370881.79426764],
              [-13298930.131985255, 4380064.667536729],
              [-13280983.203679565, 4379854.942761738],
              [-13280930.104282456, 4391904.6349361455],
              [-13266477.049514802, 4391664.842872922],
              [-13256848.358839147, 4391475.566364911],
              [-13245325.010430189, 4391424.639900463],
              [-13245064.745460713, 4403156.492408447],
              [-13175840.163513463, 4403590.893144861],
              [-13176479.360029599, 4396211.401027823],
              [-13166270.917445894, 4383127.977049758],
              [-13168040.786030015, 4377749.60576007],
              [-13162307.609615179, 4372914.026121688],
              [-13159613.566618493, 4360647.953273864],
              [-13146867.150964191, 4348354.412101562],
              [-13149853.852902176, 4339170.150769497],
              [-13139441.473011335, 4301852.122450251],
              [-13136098.103424849, 4298381.225171407],
              [-13133558.237922909, 4282406.9198455075],
              [-13136310.946291244, 4281745.375421774],
              [-13136595.256270733, 4271648.897985657],
              [-13143238.35820331, 4271974.967253821],
              [-13225170.616622068, 4271811.656932067],
              [-13252967.984029075, 4271866.688120245],
              [-13306922.203507269, 4271704.61451851],
              [-13306704.573902767, 4307611.148600156],
              [-13305947.267406901, 4337816.127291307],
              [-13299852.413966477, 4337702.218121377],
              [-13299884.140021354, 4355933.068851543],
              [-13305884.260575112, 4356003.881257083],
              [-13305827.932912769, 4367915.859361345],
              [-13310827.068605315, 4368094.473557335],
              [-13307814.429225978, 4370881.79426764],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clearwater',
        GEOID: '16035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12963833.529131563, 5881742.011642175],
              [-12949745.15701575, 5881557.215551382],
              [-12949733.579788707, 5931416.902345262],
              [-12872559.116406456, 5931203.99270257],
              [-12797447.058773668, 5931127.515387042],
              [-12793663.208418574, 5928078.111774422],
              [-12795427.511028156, 5920550.143134805],
              [-12788448.558191856, 5911407.499376473],
              [-12778368.800939506, 5906031.505607048],
              [-12775824.03737997, 5899547.861148083],
              [-12768235.16505361, 5899774.458307538],
              [-12765766.00553945, 5898412.647251304],
              [-12760185.318715878, 5895335.520956294],
              [-12759605.121529864, 5886451.735096975],
              [-12756224.682912173, 5885544.7278938405],
              [-12871951.534625705, 5856480.663317318],
              [-12872340.262287555, 5850751.326825563],
              [-12883391.727375036, 5838693.240758022],
              [-12888440.511560477, 5823296.404427928],
              [-12892437.994474862, 5823039.403424338],
              [-12912998.370465908, 5829606.0648014555],
              [-12921531.009435214, 5838549.029102957],
              [-12932015.524356088, 5840097.73403882],
              [-12933565.759584874, 5845228.150104591],
              [-12947416.464587847, 5846781.258998907],
              [-12954151.405100329, 5855492.301830528],
              [-12954172.444484087, 5860919.395682097],
              [-12963339.715870405, 5859341.799777373],
              [-12963833.529131563, 5881742.011642175],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hyde',
        GEOID: '37095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8531248.922822883, 4260134.855225325],
              [-8505473.785285626, 4259088.10264591],
              [-8490253.739226406, 4258152.607805496],
              [-8492100.752217649, 4246331.832009612],
              [-8484091.982772019, 4245479.432302347],
              [-8476383.99859051, 4259761.023093302],
              [-8463340.248576298, 4255150.655423509],
              [-8449298.741966108, 4255164.769044236],
              [-8439578.212710548, 4232063.348511245],
              [-8432402.605529271, 4189134.3635500553],
              [-8433332.632679593, 4188788.7657787753],
              [-8450594.834797414, 4180146.2077419176],
              [-8461744.594995268, 4172290.1718236376],
              [-8467603.228476228, 4180872.5717354426],
              [-8494137.564940695, 4191291.613951718],
              [-8510902.502893142, 4209414.863202938],
              [-8518404.657336174, 4212041.543467755],
              [-8526971.137430679, 4234768.0666620005],
              [-8517010.269394496, 4234548.6886182465],
              [-8512352.216621744, 4239767.354342638],
              [-8525758.422897976, 4248548.7103709895],
              [-8531248.922822883, 4260134.855225325],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lamb',
        GEOID: '48279',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11423066.245675387, 4070893.421233867],
              [-11413101.036179064, 4070912.6939339754],
              [-11364653.012673978, 4070925.9018173427],
              [-11364131.814818084, 4005284.3873296673],
              [-11423099.307564152, 4005344.151316516],
              [-11423066.245675387, 4070893.421233867],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Page',
        GEOID: '51139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8754361.680162247, 4665208.088495313],
              [-8744028.003151398, 4684288.855387147],
              [-8739610.84575672, 4682445.708219806],
              [-8726858.530169407, 4696319.455168904],
              [-8715247.795960177, 4690260.538375334],
              [-8714624.629450716, 4687253.9164368],
              [-8718406.152552964, 4684192.380143996],
              [-8720565.861993844, 4668426.94559802],
              [-8732208.878855404, 4654253.361166232],
              [-8733325.858626023, 4646821.347484188],
              [-8736992.611333262, 4639153.167066915],
              [-8759876.781694617, 4651725.490278619],
              [-8754361.680162247, 4665208.088495313],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cumberland',
        GEOID: '51049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8734693.75252889, 4486559.734312724],
              [-8710641.17279217, 4528067.851315538],
              [-8709608.907154042, 4535794.930258269],
              [-8703067.996514013, 4543459.459229144],
              [-8700656.371065466, 4543961.908980835],
              [-8694105.107712794, 4539441.999598131],
              [-8690954.65480385, 4531138.226491576],
              [-8692879.59143865, 4528611.733576723],
              [-8697619.797995608, 4502675.080338608],
              [-8703514.610311076, 4501254.084858869],
              [-8709084.703671899, 4490540.416145068],
              [-8722188.232252667, 4481230.570846836],
              [-8734693.75252889, 4486559.734312724],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Upshur',
        GEOID: '54097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8951149.159040852, 4688540.524344439],
              [-8948638.681884484, 4703754.724781354],
              [-8940901.643315878, 4715749.839973971],
              [-8938978.376473442, 4736559.133901592],
              [-8930848.046143865, 4737840.960747123],
              [-8919830.199542603, 4727086.828895813],
              [-8910505.299757322, 4723302.937166318],
              [-8915028.321987743, 4714116.397973609],
              [-8919597.20784837, 4685329.875642418],
              [-8931923.169785947, 4685034.285870533],
              [-8936735.28873396, 4678057.659029053],
              [-8940986.246128881, 4676550.04612039],
              [-8949314.836471561, 4682723.243522835],
              [-8951149.159040852, 4688540.524344439],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Covington',
        GEOID: '01039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9651672.139251297, 3677687.227211769],
              [-9647178.83932492, 3685171.3610404837],
              [-9651572.842265511, 3700982.086649469],
              [-9629048.345178908, 3701162.9579651547],
              [-9617997.325369388, 3701397.6375973662],
              [-9617841.032804314, 3691502.0442070775],
              [-9604662.920164715, 3701578.1232797606],
              [-9604315.158075478, 3692060.1656549354],
              [-9595066.734780373, 3690033.720587243],
              [-9595304.95849067, 3686156.0956606464],
              [-9595013.858022245, 3657736.9000833365],
              [-9594689.139067601, 3634519.384878183],
              [-9594320.56568616, 3631978.6184520707],
              [-9614104.92805431, 3632026.7030106555],
              [-9616739.934094936, 3632038.548365161],
              [-9636204.073366592, 3632126.0474262172],
              [-9650090.841904474, 3632255.896324138],
              [-9651427.792969007, 3633905.161630982],
              [-9651431.243873222, 3657737.4206116665],
              [-9651672.139251297, 3677687.227211769],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Clair',
        GEOID: '01115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9637766.331100386, 4002243.2674658876],
              [-9618669.80641327, 4006788.0957534625],
              [-9611972.937166639, 4013088.369631288],
              [-9609724.283452615, 4020768.059200157],
              [-9605772.998126907, 4026616.0950634535],
              [-9595647.043285878, 4027314.0813404005],
              [-9589363.391989069, 4015300.682573915],
              [-9580742.254024586, 4007632.7033529514],
              [-9578373.486579996, 3997102.61078783],
              [-9589680.095940378, 3985793.6902966113],
              [-9594834.856281051, 3988359.060377728],
              [-9592342.63552117, 3977788.5974809136],
              [-9599672.801350925, 3961130.290474174],
              [-9604868.19330574, 3963181.224828217],
              [-9615629.00320276, 3947316.1532245786],
              [-9615579.68866834, 3962182.0780925816],
              [-9627125.412294947, 3962199.8334202864],
              [-9627081.997693539, 3968012.3652352374],
              [-9631004.228632146, 3967988.72407464],
              [-9633895.752405502, 3997313.9133186922],
              [-9637796.498682389, 3997333.061965908],
              [-9637766.331100386, 4002243.2674658876],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Southampton',
        GEOID: '51175',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8619482.309698503, 4398436.043324467],
              [-8566429.555456754, 4431366.659517794],
              [-8554867.690503983, 4438578.662672523],
              [-8551311.36673161, 4422679.779844734],
              [-8563210.529741485, 4398445.902036327],
              [-8566306.213460956, 4398577.954111301],
              [-8568081.98197809, 4397453.272660759],
              [-8567648.949158903, 4394439.433031662],
              [-8565749.616006987, 4394024.4199707415],
              [-8567408.387739299, 4392863.440674572],
              [-8564354.671467857, 4391699.673446115],
              [-8561545.52411769, 4390179.722924059],
              [-8560200.784668908, 4389607.403947003],
              [-8563912.62176992, 4377892.9052338675],
              [-8562220.098229567, 4376025.00278539],
              [-8562254.143125819, 4376023.833434964],
              [-8562396.672944294, 4376018.937921222],
              [-8589893.099653801, 4376033.73933583],
              [-8592770.975243676, 4376035.288506666],
              [-8604859.736364804, 4376017.9694760665],
              [-8611131.566777155, 4377138.040683895],
              [-8617796.709968911, 4390997.533222953],
              [-8627473.935942553, 4393278.54740717],
              [-8619482.309698503, 4398436.043324467],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Whatcom',
        GEOID: '53073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13672441.421319345, 6264918.789235037],
              [-13665360.277190493, 6275261.337055607],
              [-13608926.082096407, 6275284.584221341],
              [-13591926.92793533, 6275225.533151721],
              [-13553287.37608353, 6274420.070249305],
              [-13513690.031332947, 6274836.111861854],
              [-13483711.358503843, 6275100.984260139],
              [-13453130.462037047, 6274961.700869561],
              [-13440190.001702799, 6251879.754015409],
              [-13440206.254348453, 6238710.054063759],
              [-13431348.562466033, 6228216.779683316],
              [-13442040.465598254, 6216860.948931394],
              [-13459456.845210826, 6214148.016464757],
              [-13532450.037199391, 6214389.09724986],
              [-13605004.630394233, 6214954.846873236],
              [-13636803.376897803, 6214892.508111602],
              [-13643975.246411653, 6212297.094297089],
              [-13648635.414254729, 6211650.512005512],
              [-13655711.707711019, 6214888.969730065],
              [-13660034.418792471, 6227861.574493881],
              [-13661132.919527618, 6239167.599156576],
              [-13662520.071702395, 6247434.359489661],
              [-13669367.55622007, 6255054.21602045],
              [-13672441.421319345, 6264918.789235037],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grant',
        GEOID: '53025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13358568.769941319, 5962689.817352897],
              [-13359126.3692707, 5978079.693827465],
              [-13358862.54207752, 5994462.548191366],
              [-13349312.554281857, 6001769.916739541],
              [-13344508.561656673, 6013778.570036449],
              [-13306366.385289738, 6014389.998308943],
              [-13306340.33652889, 6028646.787409366],
              [-13292125.616791027, 6042651.517558849],
              [-13282675.482578602, 6044990.215663705],
              [-13280264.859005475, 6061776.713342129],
              [-13270664.777438954, 6073761.40154351],
              [-13270644.183333158, 6088193.737259967],
              [-13261034.97356839, 6093107.678773642],
              [-13258582.493866723, 6100495.91631444],
              [-13245041.702326123, 6100539.471616908],
              [-13244069.883171495, 6097446.098261786],
              [-13244768.190337244, 5984896.755161422],
              [-13245088.233873274, 5927615.143630004],
              [-13288058.670514386, 5927813.625383403],
              [-13288144.052563822, 5899363.826335713],
              [-13288114.664218253, 5889701.988202522],
              [-13297468.28443216, 5889874.624677818],
              [-13303946.856157344, 5897738.380474332],
              [-13315868.171745889, 5884739.169595092],
              [-13344317.31477149, 5881610.060351923],
              [-13347657.34477325, 5883201.713346125],
              [-13355337.27644308, 5899271.404309589],
              [-13350261.107662907, 5909236.996773782],
              [-13354568.39272017, 5932898.610338672],
              [-13363110.716485173, 5954071.72378223],
              [-13358568.769941319, 5962689.817352897],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clark',
        GEOID: '53011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13668707.249364577, 5756505.122874604],
              [-13661101.972709177, 5759685.4153143605],
              [-13661095.850137185, 5769659.890984973],
              [-13654185.136148738, 5768840.113129472],
              [-13634088.851114808, 5778440.679564206],
              [-13620804.094403032, 5773447.504965352],
              [-13608346.441507846, 5788983.405067233],
              [-13608718.360822931, 5708527.168950148],
              [-13610213.15804896, 5707624.634651846],
              [-13617880.510616329, 5708247.727472411],
              [-13623312.901767038, 5712651.943780574],
              [-13629810.843083622, 5710687.108834087],
              [-13635775.897997783, 5713819.345669506],
              [-13652657.276137602, 5718028.667229739],
              [-13663143.794809308, 5723504.328064459],
              [-13665184.826983104, 5726416.003324225],
              [-13667196.046913164, 5729286.079596439],
              [-13666305.465531392, 5736973.316536912],
              [-13665742.214363402, 5741838.561806681],
              [-13669544.220251957, 5749953.6899396395],
              [-13668707.249364577, 5756505.122874604],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coamo',
        GEOID: '72043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7394246.783311135, 2057693.6261675344],
              [-7393137.707224362, 2056675.7387903696],
              [-7388694.055790875, 2057889.1722571165],
              [-7383079.657272717, 2056902.4392953224],
              [-7382135.111393335, 2055357.8794917352],
              [-7382810.264104997, 2052302.49199845],
              [-7375754.166861574, 2046432.547618438],
              [-7381664.786544734, 2043046.682261905],
              [-7383960.305764383, 2039408.6421606601],
              [-7386802.848961789, 2041872.9941010375],
              [-7394618.590410383, 2042538.5636649928],
              [-7394988.727717272, 2047154.9423993588],
              [-7393770.224571049, 2054563.1514107466],
              [-7396574.585183112, 2058238.3245088041],
              [-7394246.783311135, 2057693.6261675344],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'King William',
        GEOID: '51101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8610029.949096264, 4549685.971820181],
              [-8598433.68642084, 4566706.64070187],
              [-8591796.150462799, 4564131.442942611],
              [-8590414.230304092, 4564891.916154283],
              [-8583078.721138775, 4549243.532226805],
              [-8575304.72449923, 4540060.218521769],
              [-8562203.86758624, 4536193.047570566],
              [-8546857.696543952, 4516673.779342428],
              [-8548466.81978337, 4511500.388707499],
              [-8558027.49425015, 4513434.986961225],
              [-8555840.956811987, 4520198.15251017],
              [-8569503.309236538, 4518452.6002503345],
              [-8585368.229105921, 4526849.877070662],
              [-8597263.050655656, 4539078.234367259],
              [-8607500.881584931, 4541874.6980097545],
              [-8610029.949096264, 4549685.971820181],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Roanoke',
        GEOID: '51770',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8908033.450464258, 4482172.717100378],
              [-8902667.51704955, 4485963.567050237],
              [-8892039.511305042, 4479870.961205937],
              [-8899638.958983026, 4468843.14433575],
              [-8909284.45890179, 4475813.886457595],
              [-8908033.450464258, 4482172.717100378],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Smyth',
        GEOID: '51173',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9103768.626196394, 4433341.771138684],
              [-9092886.144095935, 4429762.769958104],
              [-9069704.194096707, 4441682.416373226],
              [-9065495.315469304, 4440519.5697165495],
              [-9059113.591701109, 4432479.88689394],
              [-9053278.557952197, 4425142.705271013],
              [-9046043.013689615, 4406127.913620099],
              [-9077431.770508595, 4397583.368637637],
              [-9084323.337544626, 4388779.017846711],
              [-9086506.535398062, 4389921.1003223695],
              [-9094753.528553993, 4409780.699938447],
              [-9110063.854720246, 4429220.349131376],
              [-9103768.626196394, 4433341.771138684],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hardin',
        GEOID: '47071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9837851.761213234, 4205274.8847511355],
              [-9836476.520223973, 4215778.002176545],
              [-9836282.49035152, 4220964.539683459],
              [-9825085.975967532, 4220658.425425795],
              [-9823018.55038452, 4221550.701901325],
              [-9817985.239608303, 4215582.349633275],
              [-9798869.34532979, 4217322.72799158],
              [-9794065.241385115, 4204135.554756232],
              [-9794436.051473489, 4164684.3353606374],
              [-9796118.752031779, 4164688.259733579],
              [-9818708.482339986, 4164972.170721744],
              [-9818386.21241414, 4163287.837931541],
              [-9824847.974896217, 4163264.600978641],
              [-9836583.1941898, 4163303.159643478],
              [-9838471.422441367, 4163309.363848526],
              [-9837851.761213234, 4205274.8847511355],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Taylor',
        GEOID: '55119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10121762.882963741, 5681441.399977645],
              [-10094314.836118843, 5681212.712942518],
              [-10023459.980228923, 5681840.15030652],
              [-10023617.163349925, 5640466.615686345],
              [-10040769.270491352, 5640528.14264119],
              [-10040741.551938144, 5626818.971313155],
              [-10053824.041135153, 5626848.743029106],
              [-10067023.638436474, 5626399.49986266],
              [-10121542.359052481, 5626425.647343616],
              [-10121749.413305355, 5667618.300720731],
              [-10121762.882963741, 5681441.399977645],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Volusia',
        GEOID: '12127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9092676.529494772, 3417003.864473427],
              [-9066514.556727009, 3424119.1387706143],
              [-9065190.522703514, 3426471.233244804],
              [-9063331.264568284, 3408927.5187481698],
              [-9033585.694752906, 3409540.147015167],
              [-9034231.347799506, 3428055.97496039],
              [-9028341.027419787, 3430106.2100324268],
              [-9022074.925446408, 3414887.861602083],
              [-9013113.483798567, 3394491.539819485],
              [-9006556.654471353, 3383827.6928404868],
              [-8993170.040425498, 3359779.7504772595],
              [-8986544.82420371, 3349096.315151999],
              [-9013304.842003241, 3348969.8183494764],
              [-9012923.12746931, 3326480.1988045233],
              [-9015459.430747544, 3326480.832833107],
              [-9023681.488337535, 3343865.080805442],
              [-9024429.443996176, 3351907.8773352955],
              [-9037075.783428255, 3348090.8647864666],
              [-9042037.29313291, 3354360.7821310232],
              [-9052553.64542815, 3354602.221850064],
              [-9057726.328206843, 3360283.300171943],
              [-9056347.524993876, 3373657.472805843],
              [-9072767.261205377, 3388099.9368741983],
              [-9076018.569572974, 3398145.194150966],
              [-9085044.131247513, 3401501.575875594],
              [-9088336.516507214, 3410919.5272497237],
              [-9092676.529494772, 3417003.864473427],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Steuben',
        GEOID: '18151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9484061.521207126, 5125076.854791076],
              [-9442690.087035272, 5125125.827998392],
              [-9440547.711833935, 5125128.364030064],
              [-9440569.864412602, 5115563.204513563],
              [-9440444.758697465, 5090854.163933776],
              [-9483762.049479375, 5090303.86072139],
              [-9484061.521207126, 5125076.854791076],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Redwood',
        GEOID: '27127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10641566.350916171, 5549752.290259337],
              [-10615471.169842886, 5549667.481187099],
              [-10615446.345596438, 5574186.976503705],
              [-10602537.84876354, 5569258.304965528],
              [-10590118.378453698, 5558211.86995252],
              [-10562030.578495212, 5545768.679745143],
              [-10560415.22136431, 5542869.0851428425],
              [-10560463.645342806, 5509244.393319423],
              [-10587316.24423145, 5509150.475293141],
              [-10587460.625611007, 5495675.471071638],
              [-10588847.33250782, 5495715.3739061495],
              [-10626842.121868946, 5495814.898854828],
              [-10641427.535511153, 5495750.929496748],
              [-10641566.350916171, 5549752.290259337],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Simpson',
        GEOID: '28127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10044394.501028527, 3769839.971414464],
              [-9988705.25596683, 3769491.1458891225],
              [-9981137.756982703, 3769513.078521127],
              [-9980129.091076626, 3734552.2389382203],
              [-9991492.36205782, 3733766.6759717334],
              [-10015925.097855601, 3732064.6448806743],
              [-10032398.044783698, 3730889.637915442],
              [-10030720.01477948, 3734163.575979618],
              [-10044394.501028527, 3769839.971414464],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wyandotte',
        GEOID: '20209',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10564240.938304402, 4750778.650103628],
              [-10552196.578359805, 4750541.5155976815],
              [-10546624.294927893, 4746081.09876268],
              [-10539766.791656047, 4748105.884941031],
              [-10533488.149736324, 4744128.498097005],
              [-10531039.564204304, 4743970.617175943],
              [-10529925.814711452, 4743898.805187246],
              [-10531642.472578973, 4737934.503886258],
              [-10531699.952773636, 4727988.353117997],
              [-10561414.647752654, 4729989.434548356],
              [-10565195.391618464, 4720439.914450018],
              [-10564240.938304402, 4750778.650103628],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nash',
        GEOID: '37127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8711415.065892166, 4275623.7380286055],
              [-8683649.535859525, 4328539.30152408],
              [-8670274.387721224, 4320452.856178995],
              [-8651833.42351539, 4319059.27642897],
              [-8649296.897598175, 4321715.089920872],
              [-8650299.886210222, 4316526.0676896935],
              [-8663822.755312806, 4282364.7479361],
              [-8665636.483776301, 4278300.801602675],
              [-8673531.262063362, 4278140.417388692],
              [-8704306.648488069, 4263607.841972048],
              [-8708803.176679682, 4266448.340207058],
              [-8711415.065892166, 4275623.7380286055],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Person',
        GEOID: '37145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8809639.254489405, 4375408.201857613],
              [-8787784.24407802, 4375473.9788734475],
              [-8771561.093093524, 4375424.998151252],
              [-8772235.805520961, 4333114.9567519035],
              [-8788740.255864952, 4333601.599032643],
              [-8811382.640292302, 4333954.242080981],
              [-8809639.254489405, 4375408.201857613],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Butts',
        GEOID: '13035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9360743.659440164, 3933280.3591655497],
              [-9362256.602639535, 3934951.04755523],
              [-9357657.32655792, 3936468.3926037736],
              [-9355571.978536889, 3940669.0307297423],
              [-9346871.358455978, 3945205.908825173],
              [-9342367.260538992, 3954412.8011170956],
              [-9341378.075543802, 3953273.278037909],
              [-9335592.912926767, 3944289.3539916705],
              [-9329382.064576939, 3920947.731970437],
              [-9331051.411660874, 3919252.052632449],
              [-9333317.20857648, 3921451.5085466155],
              [-9355456.76286392, 3922230.5626984322],
              [-9364614.906051992, 3922256.505459564],
              [-9360743.659440164, 3933280.3591655497],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crawford',
        GEOID: '39033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9252067.561275266, 5011375.145886934],
              [-9223174.253481401, 5011406.707751588],
              [-9220539.098495342, 5011843.717370318],
              [-9208881.72141947, 5011698.291131613],
              [-9209145.771251632, 4969837.043839216],
              [-9221584.722472364, 4970042.206848923],
              [-9223743.98663528, 4968928.915110041],
              [-9251914.274336444, 4968619.959101533],
              [-9252067.561275266, 5011375.145886934],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Campbell',
        GEOID: '21037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9406406.562872164, 4736316.329709942],
              [-9405800.445977723, 4736358.733133344],
              [-9404375.55649557, 4738410.2673570765],
              [-9402271.506800085, 4739127.685252116],
              [-9400401.339354757, 4738080.415694686],
              [-9399031.99829851, 4733705.411138857],
              [-9395469.663273634, 4728314.708706724],
              [-9387187.381839124, 4725606.175487204],
              [-9386593.8515678, 4724620.820098309],
              [-9383927.501870735, 4720195.434004925],
              [-9382915.496379932, 4715340.703269],
              [-9376678.042671803, 4704566.218386467],
              [-9376697.305998005, 4703740.411049282],
              [-9393961.172853895, 4694823.995748327],
              [-9397380.684972083, 4694005.850860707],
              [-9401017.158777826, 4695853.091702548],
              [-9401020.053084588, 4720756.158007732],
              [-9407222.634563707, 4736259.23830802],
              [-9406406.562872164, 4736316.329709942],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Graves',
        GEOID: '21083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9887328.9334107, 4404312.757113573],
              [-9886643.427986396, 4407528.952319859],
              [-9886606.469915453, 4431702.899820498],
              [-9850005.28925957, 4431038.786731681],
              [-9850182.732527895, 4404362.633661937],
              [-9850558.963320462, 4369818.283765223],
              [-9853101.863534965, 4369842.280432537],
              [-9853595.906111984, 4369843.277265465],
              [-9887036.95990226, 4369910.7517137155],
              [-9887328.9334107, 4404312.757113573],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Barren',
        GEOID: '21009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9586112.306260454, 4447622.858663851],
              [-9581743.57284427, 4446536.633889853],
              [-9579759.414240373, 4462439.123963427],
              [-9563049.579435866, 4459808.856858611],
              [-9545003.020185914, 4462803.035460647],
              [-9548647.731633978, 4458405.5056192335],
              [-9546324.27122214, 4454427.447585802],
              [-9544450.207594635, 4417033.560180865],
              [-9548127.201695027, 4416319.178736301],
              [-9570905.84117911, 4400527.960599873],
              [-9581263.785838952, 4412069.906390692],
              [-9580746.484165234, 4425055.842466064],
              [-9585322.939751238, 4420315.101309259],
              [-9592037.620116396, 4429913.31579982],
              [-9586112.306260454, 4447622.858663851],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Robeson',
        GEOID: '37155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8845646.115092577, 4113716.763429938],
              [-8831067.043210296, 4133221.473156269],
              [-8832964.261291886, 4141962.7284226823],
              [-8815545.321331028, 4141306.846113297],
              [-8798553.068978379, 4157457.156635617],
              [-8787654.556871245, 4150756.9828823805],
              [-8783330.239931889, 4141517.196230457],
              [-8772612.733316785, 4121724.740250585],
              [-8779652.577914553, 4094083.1045373417],
              [-8789753.374550661, 4088443.4303163607],
              [-8802170.575303806, 4069062.388284627],
              [-8802171.754046177, 4069063.6112697553],
              [-8834127.438651185, 4102267.475825952],
              [-8844364.411200698, 4112442.203372666],
              [-8845646.115092577, 4113716.763429938],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cedar',
        GEOID: '31027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10851971.306698995, 5289168.603826988],
              [-10848326.720335964, 5288568.063088515],
              [-10844418.181694724, 5291585.416773658],
              [-10835970.702135874, 5290061.281254312],
              [-10831617.442128915, 5291546.232028348],
              [-10824469.951583551, 5289644.753639895],
              [-10821808.191239191, 5284635.723145822],
              [-10816366.158971634, 5280307.370487418],
              [-10812610.306992905, 5277321.294768591],
              [-10800756.896293748, 5275880.8962437175],
              [-10799730.654459087, 5274985.66202111],
              [-10799970.869369257, 5213755.686367948],
              [-10838925.455380002, 5213833.110333518],
              [-10838910.538568236, 5226934.109557385],
              [-10852013.73319053, 5226904.394191816],
              [-10851971.306698995, 5289168.603826988],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lawrence',
        GEOID: '39087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9218538.730064875, 4660600.985389511],
              [-9210617.303600429, 4664132.3702368485],
              [-9213234.64746796, 4675933.716075846],
              [-9206881.421489406, 4675580.220105392],
              [-9201990.377022423, 4685635.465390665],
              [-9200560.2555242, 4700075.575027948],
              [-9192271.851517696, 4699418.800653304],
              [-9193062.21990233, 4690075.472280458],
              [-9182030.013086751, 4689104.644369179],
              [-9180794.255419457, 4676262.411293836],
              [-9167657.442310942, 4675377.026067489],
              [-9168459.610561598, 4662425.441075123],
              [-9159605.185241444, 4661667.675276798],
              [-9160845.023432866, 4658880.183026084],
              [-9162064.194496034, 4649776.69395304],
              [-9164265.648745963, 4643088.171453835],
              [-9170697.021007052, 4641029.456778749],
              [-9177966.517714327, 4639920.8924364],
              [-9184856.186723126, 4638167.827845731],
              [-9190611.076034553, 4636703.735475584],
              [-9194285.621106148, 4639185.847154245],
              [-9197046.45579731, 4647043.455936047],
              [-9202127.401020283, 4651399.373964186],
              [-9203419.496645227, 4652507.388981644],
              [-9208887.732671974, 4658498.235883685],
              [-9217266.30546602, 4659293.03793954],
              [-9218538.730064875, 4660600.985389511],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Traill',
        GEOID: '38097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10850616.339622602, 6052468.193086101],
              [-10786134.335486619, 6052480.750420442],
              [-10784896.763162468, 6048662.462116643],
              [-10781746.087614547, 6035945.620375673],
              [-10781956.075030606, 6023935.890425903],
              [-10782125.353119679, 6014266.557090678],
              [-10780203.978708588, 5987402.192238324],
              [-10779735.278516958, 5981005.6519308705],
              [-10848252.692874588, 5981182.583917836],
              [-10850793.560251944, 5995247.843082465],
              [-10850616.339622602, 6052468.193086101],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Massac',
        GEOID: '17127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9899545.356969336, 4481376.253725435],
              [-9897225.681420187, 4486006.689335045],
              [-9875224.385940315, 4486197.521568718],
              [-9850699.143645685, 4461342.575911953],
              [-9850706.206458243, 4448583.441368138],
              [-9855289.959446, 4448476.628399135],
              [-9858570.314349622, 4450821.777883076],
              [-9864180.379258713, 4454833.659390598],
              [-9873369.023987263, 4458800.279682788],
              [-9879946.336100783, 4460692.104339944],
              [-9889072.641914487, 4466529.9039938385],
              [-9899420.214881077, 4470709.755362962],
              [-9899545.356969336, 4481376.253725435],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Craig',
        GEOID: '40035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10623411.70044066, 4431133.498305729],
              [-10620727.676852377, 4439015.034224298],
              [-10611259.396908721, 4439017.301107691],
              [-10583534.04949756, 4439035.440066088],
              [-10576199.880378664, 4439040.238358801],
              [-10579150.180345329, 4438301.857292326],
              [-10575257.337752286, 4431197.846945629],
              [-10575285.167624986, 4393295.895916735],
              [-10575985.033263603, 4383173.179076124],
              [-10575989.486043235, 4371010.18246557],
              [-10611883.342654618, 4371058.657373825],
              [-10611905.606552776, 4383169.019372466],
              [-10623393.778002642, 4383156.540271199],
              [-10623411.70044066, 4431133.498305729],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hill',
        GEOID: '48217',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10850988.258041343, 3786101.5467163846],
              [-10849877.289523225, 3787473.194528237],
              [-10807585.3451785, 3798205.8563039396],
              [-10791384.4630859, 3770149.798960078],
              [-10786436.645678611, 3773025.1800082177],
              [-10766722.520456577, 3739036.122162451],
              [-10790444.815264115, 3725157.891447446],
              [-10802139.039091438, 3745351.007028806],
              [-10828855.605562333, 3729948.6671288507],
              [-10834339.760276264, 3735561.5375645487],
              [-10829389.382520689, 3742739.453531681],
              [-10840609.05135876, 3746361.46938976],
              [-10846833.703325447, 3754585.417723437],
              [-10840291.122893054, 3759732.860210872],
              [-10852088.317249361, 3765622.566625378],
              [-10850988.258041343, 3786101.5467163846],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Boyd',
        GEOID: '31015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11048955.390934963, 5311701.05778202],
              [-11003708.135377578, 5311706.2439237945],
              [-10964808.429875797, 5311752.66683059],
              [-10962623.116952034, 5306423.756598287],
              [-10957678.750448959, 5301205.671346344],
              [-10952328.958360417, 5299560.795060469],
              [-10943617.297217367, 5294710.275547218],
              [-10943845.745245023, 5279245.759575907],
              [-10943279.129036887, 5275695.460413222],
              [-10974293.963686291, 5278505.289130573],
              [-10982428.63547601, 5282947.9258561125],
              [-11008701.259817619, 5288529.19460886],
              [-11018684.503071452, 5296221.611750965],
              [-11049243.039128095, 5282230.984604434],
              [-11048955.390934963, 5311701.05778202],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Walsh',
        GEOID: '38099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10944720.605123168, 6197800.806043241],
              [-10901200.918114483, 6197691.681141669],
              [-10814477.409382246, 6197291.520194346],
              [-10814590.79205361, 6195872.746495942],
              [-10813483.27443971, 6178780.57169403],
              [-10813342.010005891, 6164374.159488143],
              [-10812410.15454846, 6149853.741916561],
              [-10813787.998988727, 6139128.235910398],
              [-10898560.419792866, 6139340.215135164],
              [-10941835.87183875, 6139386.974204717],
              [-10941827.856835414, 6168580.771742273],
              [-10944784.279871901, 6168585.2960974],
              [-10944720.605123168, 6197800.806043241],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lauderdale',
        GEOID: '01077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9818708.482339986, 4164972.170721744],
              [-9796118.752031779, 4164688.259733579],
              [-9794436.051473489, 4164684.3353606374],
              [-9779627.214748718, 4164649.7984387847],
              [-9754373.163747866, 4164388.319523372],
              [-9752266.205012854, 4164359.4439037023],
              [-9709737.236338781, 4163776.605462412],
              [-9708916.74023836, 4163765.3612702996],
              [-9708257.236818744, 4163751.9323108136],
              [-9708719.816059146, 4138905.799213372],
              [-9715776.13594155, 4133151.679088473],
              [-9713814.018596828, 4131127.56956068],
              [-9717958.331919571, 4130068.8420606884],
              [-9723114.539413624, 4136259.631353579],
              [-9732274.575033039, 4136738.0318384925],
              [-9743167.521165634, 4141126.0648139077],
              [-9774626.409263812, 4127528.656839403],
              [-9787241.913196942, 4137340.772399782],
              [-9793134.27648361, 4147931.5908834077],
              [-9807012.032122847, 4149241.458801679],
              [-9813327.075516058, 4153339.5219066055],
              [-9818386.21241414, 4163287.837931541],
              [-9818708.482339986, 4164972.170721744],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Larimer',
        GEOID: '08069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11821078.407097464, 5012009.295398079],
              [-11719397.394333191, 5012072.185499379],
              [-11719366.446850732, 5012072.173349555],
              [-11682242.621849593, 5012057.598737369],
              [-11682485.298339522, 4916802.835101521],
              [-11694860.574811518, 4916829.4192874],
              [-11694679.012722036, 4904058.572738929],
              [-11706253.011499302, 4903974.83907162],
              [-11761273.894338278, 4903863.681537658],
              [-11779309.766917113, 4927381.850576295],
              [-11778419.322310256, 4935140.768355546],
              [-11783716.460279655, 4936856.746049375],
              [-11789608.712246835, 4941137.532630337],
              [-11789946.566901391, 4948597.53836731],
              [-11805206.131379843, 4983569.114258403],
              [-11820494.304967426, 5002607.569047313],
              [-11821078.407097464, 5012009.295398079],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Quitman',
        GEOID: '13239',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9477945.272126954, 3742229.5803598952],
              [-9474850.5902829, 3749320.5957050235],
              [-9469707.407169271, 3759026.6196717178],
              [-9469235.584292576, 3762241.7793138865],
              [-9466835.364306804, 3760115.785343861],
              [-9459269.86907351, 3756776.5577605176],
              [-9451804.672701422, 3753399.563495902],
              [-9452175.589244748, 3734053.055502222],
              [-9457552.543289043, 3734185.706385974],
              [-9470387.791896997, 3733345.9578308244],
              [-9476534.66667018, 3734503.166680799],
              [-9477945.272126954, 3742229.5803598952],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Walker',
        GEOID: '13295',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9521646.438605512, 4112872.557360585],
              [-9516791.766912136, 4119050.82341069],
              [-9516762.267247077, 4123066.2030312684],
              [-9512296.01795696, 4131210.9008437856],
              [-9512312.938519562, 4141030.1827468863],
              [-9510437.093780203, 4146917.5395843037],
              [-9502667.998418845, 4161622.314801264],
              [-9493054.11001487, 4161839.493994413],
              [-9491662.507477855, 4161853.440453187],
              [-9491629.888449661, 4144095.5616716444],
              [-9484663.292076837, 4144119.1656424035],
              [-9484627.22456182, 4133357.2679111594],
              [-9478274.555180721, 4132348.8753450387],
              [-9480953.124768188, 4125932.85214161],
              [-9467816.979576617, 4125892.357256009],
              [-9467772.34046081, 4112695.57069306],
              [-9469855.462092025, 4107921.654322055],
              [-9474151.169922248, 4107962.0843825755],
              [-9502275.705312693, 4107222.33194812],
              [-9520810.38028755, 4108124.7110695024],
              [-9521646.438605512, 4112872.557360585],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '17119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10049220.75755187, 4721578.036364703],
              [-10035005.815175021, 4721678.161687554],
              [-9985197.467492443, 4721525.324145835],
              [-9978597.334883308, 4721546.810071514],
              [-9978350.650891712, 4709984.652945928],
              [-9978448.834682591, 4709982.936028264],
              [-9974181.06804456, 4703714.973984221],
              [-9973928.150161475, 4684958.784111734],
              [-9973681.243530897, 4672508.215382927],
              [-9986131.883298162, 4672376.784370126],
              [-10022884.681100506, 4672864.741215208],
              [-10038961.373113248, 4673139.00590918],
              [-10040484.849192377, 4677014.10075553],
              [-10042121.245707037, 4682506.208844982],
              [-10037299.401890047, 4689129.2229658505],
              [-10037278.73653804, 4689157.61700126],
              [-10031857.254697425, 4693884.713293136],
              [-10031369.675327752, 4700108.879407068],
              [-10041828.731613059, 4707176.210012006],
              [-10044395.05762598, 4708911.063770049],
              [-10049543.33049222, 4710124.077245801],
              [-10049220.75755187, 4721578.036364703],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lee',
        GEOID: '19111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10210088.665016718, 4984878.225271694],
              [-10175653.761651672, 4984784.238751283],
              [-10153248.710378692, 4970186.131930119],
              [-10143234.17949039, 4968123.601594652],
              [-10143523.283065537, 4964195.499215566],
              [-10150719.042711066, 4959108.890259081],
              [-10150888.180576421, 4958989.360212123],
              [-10157664.309300499, 4959149.699669029],
              [-10167891.008280694, 4955497.310417974],
              [-10171735.204256259, 4950967.376517567],
              [-10173986.418318572, 4943927.394583894],
              [-10171025.431182962, 4940403.366890691],
              [-10172364.715976695, 4931860.8285098765],
              [-10171587.038014011, 4924110.19806129],
              [-10176763.505655391, 4921063.79365228],
              [-10185521.12131559, 4924522.128401626],
              [-10187863.394721368, 4929039.5834485255],
              [-10192840.489154736, 4933159.680785003],
              [-10197794.54045351, 4938875.031580649],
              [-10198980.31566944, 4944592.538582511],
              [-10204768.261273745, 4946328.921896345],
              [-10206369.926107278, 4950425.355594169],
              [-10209851.330491103, 4954067.957375536],
              [-10210088.665016718, 4984878.225271694],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sullivan',
        GEOID: '18153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9756088.59710099, 4745582.001089133],
              [-9749030.273467751, 4751958.408136557],
              [-9750862.258327737, 4757179.186146174],
              [-9751002.503676813, 4758894.4480704805],
              [-9711554.566892195, 4758848.496930193],
              [-9711594.4192699, 4746306.533589738],
              [-9711626.701922232, 4708483.891543412],
              [-9713767.375730187, 4707589.691987814],
              [-9743652.28011106, 4708207.767920696],
              [-9743532.871734416, 4708457.283285224],
              [-9743738.924111875, 4717650.867208022],
              [-9749262.708564527, 4721901.764155623],
              [-9748535.90360914, 4729880.6255754065],
              [-9754412.570847606, 4736264.917674585],
              [-9755850.196809493, 4744256.202034547],
              [-9756088.59710099, 4745582.001089133],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Liberty',
        GEOID: '12077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9475031.929733401, 3529280.8798892954],
              [-9465973.862767555, 3543779.54606942],
              [-9466917.852049481, 3548936.996059918],
              [-9460286.883941399, 3560471.2431163047],
              [-9461045.414951663, 3571187.2921643252],
              [-9454644.766870031, 3581736.5923875463],
              [-9449167.51396453, 3581632.6048939717],
              [-9449089.590320976, 3572259.8133911043],
              [-9437868.25169054, 3570398.7586567374],
              [-9437790.105408004, 3562790.053415145],
              [-9422795.036039678, 3553558.0231923824],
              [-9430446.692558844, 3546436.0378787285],
              [-9430247.096711854, 3542192.546136608],
              [-9425461.805761121, 3520040.454731014],
              [-9416632.389029363, 3507359.9726481983],
              [-9411445.123397376, 3504967.7259660284],
              [-9462998.40409814, 3505330.384683931],
              [-9464988.573954543, 3499873.9811500306],
              [-9474812.741656031, 3506528.8644933524],
              [-9479301.588802781, 3515386.6081007514],
              [-9475031.929733401, 3529280.8798892954],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Columbia',
        GEOID: '41009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13732789.220900351, 5803815.846318794],
              [-13723485.304030236, 5803590.871680831],
              [-13715952.045942867, 5807810.068958266],
              [-13710822.489313522, 5810684.163339663],
              [-13705199.741833555, 5810088.416559065],
              [-13692768.582977178, 5801820.445389046],
              [-13688143.035495736, 5797162.157616665],
              [-13681623.943475898, 5793777.820945479],
              [-13676284.949377961, 5782668.190896703],
              [-13671591.719646119, 5774099.081815631],
              [-13671314.756753026, 5766374.353710742],
              [-13668366.571358856, 5759173.180723317],
              [-13668707.249364577, 5756505.122874604],
              [-13669544.220251957, 5749953.6899396395],
              [-13665742.214363402, 5741838.561806681],
              [-13666305.465531392, 5736973.316536912],
              [-13668334.177387035, 5735742.835926663],
              [-13684409.936371982, 5735828.300691762],
              [-13695734.134211909, 5745029.647443874],
              [-13732552.944472292, 5745096.685916349],
              [-13732789.220900351, 5803815.846318794],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lake',
        GEOID: '06033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13700959.359790256, 4746596.303708802],
              [-13691722.847680666, 4755522.224358704],
              [-13700659.019804094, 4780238.050120125],
              [-13699330.64432046, 4794058.030847342],
              [-13680086.732627533, 4797734.078119848],
              [-13679534.810592182, 4805111.019646199],
              [-13662868.83566705, 4805191.902449389],
              [-13663249.882284034, 4776720.781268915],
              [-13668373.695806267, 4776678.870140381],
              [-13663741.91443334, 4774541.058261572],
              [-13667255.268882265, 4766430.0032493435],
              [-13656778.323686767, 4755924.941063324],
              [-13634109.556540096, 4746619.135305496],
              [-13635666.693577314, 4729264.923579568],
              [-13626999.135385167, 4724568.041513988],
              [-13626520.68421374, 4716343.389524759],
              [-13618845.650601504, 4710826.26370846],
              [-13625944.3832099, 4710975.505949952],
              [-13627944.015223019, 4707896.809402133],
              [-13624955.309534201, 4702244.446746245],
              [-13625281.8096007, 4693635.157306559],
              [-13632617.875363467, 4679531.972193534],
              [-13650819.280025113, 4674155.9507457],
              [-13666969.957027365, 4696139.422621008],
              [-13672437.079859203, 4700228.089967145],
              [-13686605.045410935, 4707389.005001003],
              [-13690810.139175652, 4721282.393115061],
              [-13698554.858789122, 4724693.84421717],
              [-13698544.060798515, 4728666.316517347],
              [-13700959.359790256, 4746596.303708802],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kittitas',
        GEOID: '53037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13521336.678475026, 6000116.878615913],
              [-13515397.11572426, 6011647.055569139],
              [-13488833.16827524, 6038923.395769019],
              [-13482300.829236003, 6040117.500689035],
              [-13478004.008210875, 6032461.685018577],
              [-13469277.450688608, 6027128.387297826],
              [-13460523.063293641, 6012441.4782896945],
              [-13447676.460097628, 6011332.301352444],
              [-13432296.002652174, 5998291.327083305],
              [-13417393.88505866, 5996816.675086257],
              [-13401664.107051097, 5984769.796387894],
              [-13368854.134293163, 5984970.5692551145],
              [-13366795.725588903, 5979024.639951937],
              [-13359126.3692707, 5978079.693827465],
              [-13358568.769941319, 5962689.817352897],
              [-13363110.716485173, 5954071.72378223],
              [-13354568.39272017, 5932898.610338672],
              [-13350261.107662907, 5909236.996773782],
              [-13355337.27644308, 5899271.404309589],
              [-13415111.8354974, 5899404.596291681],
              [-13414956.544807743, 5913533.799988831],
              [-13428913.33728544, 5913682.50257684],
              [-13428978.01390959, 5927743.227397998],
              [-13472621.710831018, 5927609.277242868],
              [-13479683.15141, 5940606.30945322],
              [-13500940.276093919, 5956572.381866694],
              [-13511924.392889474, 5956367.195260472],
              [-13502791.407906322, 5966356.156364063],
              [-13510305.362215376, 5978805.809807047],
              [-13507640.93020324, 5988104.474306733],
              [-13517246.577744301, 5989386.777898129],
              [-13521336.678475026, 6000116.878615913],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wakulla',
        GEOID: '12129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9430247.096711854, 3542192.546136608],
              [-9382668.14447139, 3542596.240011342],
              [-9377689.936843114, 3538850.285777552],
              [-9359246.189650012, 3538769.466765754],
              [-9359312.210113196, 3516293.2936904593],
              [-9364739.806520661, 3515201.081484943],
              [-9370780.002091104, 3512960.8231497244],
              [-9373992.793914888, 3514451.668983089],
              [-9383089.488744043, 3510904.105304471],
              [-9391592.962006759, 3504663.3114384105],
              [-9388846.042251945, 3498692.9586607763],
              [-9388813.741029475, 3498506.4331567185],
              [-9402902.799632372, 3503788.0316006923],
              [-9409167.749254728, 3501201.364428867],
              [-9411445.123397376, 3504967.7259660284],
              [-9416632.389029363, 3507359.9726481983],
              [-9425461.805761121, 3520040.454731014],
              [-9430247.096711854, 3542192.546136608],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Walton',
        GEOID: '12131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9616739.934094936, 3632038.548365161],
              [-9614104.92805431, 3632026.7030106555],
              [-9594320.56568616, 3631978.6184520707],
              [-9577376.63222299, 3631937.4375127866],
              [-9577660.819199936, 3594441.3354038843],
              [-9556157.233163401, 3594254.6415754417],
              [-9564047.113392865, 3585621.738920822],
              [-9557865.764708096, 3566708.8676830824],
              [-9572667.583440404, 3553692.1053463724],
              [-9573042.35096752, 3538161.6497334344],
              [-9573469.195093608, 3538403.789747027],
              [-9583490.843571762, 3542630.7950525023],
              [-9598251.58541197, 3547791.387630445],
              [-9617712.303669006, 3552166.2185568186],
              [-9616739.934094936, 3632038.548365161],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Douglas',
        GEOID: '27041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10661039.803399112, 5797584.90935736],
              [-10591590.91267791, 5797474.282283546],
              [-10590906.409129024, 5744113.026795664],
              [-10590899.618640084, 5741795.162245596],
              [-10659788.349683613, 5741961.262445673],
              [-10661039.803399112, 5797584.90935736],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Aurora',
        GEOID: '46003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10999230.754138384, 5455423.259491716],
              [-10946213.399494706, 5455807.407840177],
              [-10946217.406996375, 5445066.734235371],
              [-10945515.871565394, 5442421.922101369],
              [-10944998.56989168, 5388182.251008927],
              [-10987877.39059187, 5388284.763825435],
              [-10997763.229291255, 5388264.5067119],
              [-10998027.83572087, 5442038.640999107],
              [-10999230.754138384, 5455423.259491716],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wichita',
        GEOID: '20203',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11306397.185432551, 4678742.583361874],
              [-11297189.839029549, 4678813.474657987],
              [-11257559.65502918, 4678875.808055769],
              [-11257232.264406757, 4616859.7463079905],
              [-11303638.465811713, 4616675.151252658],
              [-11306440.377394978, 4616666.361094453],
              [-11306397.185432551, 4678742.583361874],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chatham',
        GEOID: '37037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8854622.581420625, 4279081.472528233],
              [-8820655.331236402, 4279211.10914188],
              [-8822018.215762183, 4283683.830756374],
              [-8803371.978415329, 4281481.23591928],
              [-8796054.836965997, 4281815.566455701],
              [-8783783.64421789, 4282486.730974651],
              [-8784157.009790013, 4279031.211290128],
              [-8787145.492839847, 4269280.110750837],
              [-8793689.743064603, 4247108.304561895],
              [-8784748.004966632, 4243485.464801325],
              [-8790860.112928128, 4235001.810311758],
              [-8807274.83976254, 4249577.198539303],
              [-8821475.533244567, 4241493.228510604],
              [-8833209.720769085, 4234500.272857441],
              [-8856111.590929477, 4234095.038576465],
              [-8854622.581420625, 4279081.472528233],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McLean',
        GEOID: '21149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9739935.693708923, 4529754.976740614],
              [-9737428.778776258, 4532190.620147234],
              [-9730274.943019921, 4534819.81803931],
              [-9700249.182046212, 4519648.527752064],
              [-9689054.78273255, 4517566.452087831],
              [-9699893.8502316, 4506948.341148302],
              [-9695905.718154442, 4497257.427798002],
              [-9708279.436153566, 4492337.363351448],
              [-9717742.372107431, 4493862.936507376],
              [-9721368.938478496, 4494793.744440678],
              [-9726556.649388442, 4518856.3772770995],
              [-9738529.839859694, 4523200.740122981],
              [-9739935.693708923, 4529754.976740614],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Davis',
        GEOID: '49011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12518057.18859819, 5025231.955764407],
              [-12488565.53854131, 5034939.529005639],
              [-12451780.458086634, 5032878.069910114],
              [-12449776.929891339, 5015731.799713242],
              [-12445700.187499506, 5011246.834688311],
              [-12447233.390846202, 5006107.077460661],
              [-12438700.083959952, 4991860.469584326],
              [-12461803.887676643, 4986091.1591506675],
              [-12463182.356931137, 5000817.256376895],
              [-12468513.892623188, 5000820.792181497],
              [-12496750.081462903, 4978342.362297122],
              [-12522720.807345483, 5023689.249685975],
              [-12518057.18859819, 5025231.955764407],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Weber',
        GEOID: '49057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12522720.807345483, 5023689.249685975],
              [-12494284.243422342, 5062110.465191275],
              [-12470974.721286666, 5062104.534818781],
              [-12463684.18519563, 5066378.757618797],
              [-12463139.387607688, 5076550.0112394085],
              [-12455030.541939834, 5075436.613335054],
              [-12441131.969555821, 5066895.387147802],
              [-12430666.378948383, 5075801.248492768],
              [-12413329.815410713, 5074950.553550512],
              [-12409601.169066591, 5069172.713612358],
              [-12403298.704775838, 5065781.471641943],
              [-12411809.525124947, 5045867.928911147],
              [-12422889.599321565, 5047592.108449101],
              [-12431939.87392306, 5039106.6561411265],
              [-12445498.031304225, 5044428.338143238],
              [-12453615.559892362, 5040116.914642868],
              [-12451780.458086634, 5032878.069910114],
              [-12488565.53854131, 5034939.529005639],
              [-12518057.18859819, 5025231.955764407],
              [-12522720.807345483, 5023689.249685975],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Martin',
        GEOID: '21159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9202881.044268258, 4558514.468128211],
              [-9196369.521973798, 4562385.005750573],
              [-9192859.729748577, 4572940.039301406],
              [-9181567.049041664, 4570750.389929843],
              [-9182472.730701638, 4567703.794971685],
              [-9174806.602648668, 4561412.335673163],
              [-9172555.145493409, 4557278.291049188],
              [-9169383.451015692, 4551457.327158103],
              [-9164639.348276556, 4545891.546888035],
              [-9163895.61799162, 4543601.2018711325],
              [-9174174.419260453, 4538886.013842286],
              [-9173183.007875448, 4533095.30789202],
              [-9190933.568599379, 4535000.007186318],
              [-9192385.620037287, 4536342.169627231],
              [-9199526.208774222, 4539971.97970596],
              [-9202881.044268258, 4558514.468128211],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Keweenaw',
        GEOID: '26083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9851861.764407529, 5990113.51163496],
              [-9842721.654976966, 6002873.267874055],
              [-9827862.951984862, 6011293.801099018],
              [-9820363.023931647, 6015629.610292869],
              [-9805605.399037182, 6018959.219807365],
              [-9788241.450904775, 6020569.2456181245],
              [-9773983.093926517, 6019673.944706428],
              [-9760500.41116011, 6016773.25254029],
              [-9750640.955180041, 6011576.962944943],
              [-9752111.040375456, 6005739.875915205],
              [-9773884.019579712, 6006319.165242449],
              [-9789615.578699127, 6005977.966869953],
              [-9789810.053849544, 5997074.725194179],
              [-9797949.512377365, 5992210.023156526],
              [-9806896.593810894, 5984838.032397222],
              [-9817735.438670961, 5976294.820982687],
              [-9818429.256982181, 5974734.098579303],
              [-9829336.933362456, 5974744.765154713],
              [-9829398.826999336, 5988898.055777373],
              [-9853216.133619674, 5988899.737491447],
              [-9851861.764407529, 5990113.51163496],
            ],
          ],
          [
            [
              [-9932073.246137604, 6091574.396217567],
              [-9927378.012654927, 6096052.939903227],
              [-9909472.161241338, 6105611.3513113875],
              [-9900854.140222594, 6110114.531868931],
              [-9895601.530049512, 6112641.27451488],
              [-9886961.245132612, 6116343.847267586],
              [-9877177.820364753, 6123826.471226589],
              [-9866458.86659627, 6131563.395531308],
              [-9857010.62481519, 6135999.940749177],
              [-9843444.007152723, 6141971.3111191895],
              [-9843690.134546869, 6134643.399593098],
              [-9857389.890320323, 6123859.309994403],
              [-9860588.321929798, 6113638.194328516],
              [-9876104.366515035, 6106045.344042528],
              [-9891062.143853944, 6101087.589095002],
              [-9896189.853558354, 6090348.232753449],
              [-9912384.279120488, 6082890.237773966],
              [-9924993.994440097, 6077626.979270669],
              [-9929900.289677318, 6081976.669392243],
              [-9935843.637290772, 6086267.3181260675],
              [-9932073.246137604, 6091574.396217567],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Menifee',
        GEOID: '21165',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9325809.042880947, 4577824.398764758],
              [-9324057.09673484, 4579246.547281437],
              [-9312909.896885274, 4583418.913955226],
              [-9304178.663944395, 4581060.1122096],
              [-9303525.21853344, 4587747.348636617],
              [-9295049.018545968, 4586579.191192903],
              [-9291104.078431236, 4581824.088665916],
              [-9287823.938315522, 4584226.311963488],
              [-9288981.77233926, 4571301.655753065],
              [-9295725.7297305, 4561090.952889944],
              [-9294629.78934364, 4559936.087590606],
              [-9300900.416260025, 4554256.553696988],
              [-9309767.013701709, 4554786.019964875],
              [-9313318.105458016, 4556105.645567404],
              [-9325098.267932232, 4567900.782015468],
              [-9325809.042880947, 4577824.398764758],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harnett',
        GEOID: '37085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8814673.133120662, 4205701.839849022],
              [-8790860.112928128, 4235001.810311758],
              [-8784748.004966632, 4243485.464801325],
              [-8761834.891537672, 4234699.40797501],
              [-8756452.92811629, 4231525.0279920325],
              [-8741903.025391644, 4209491.1423358675],
              [-8742849.018424407, 4206963.568238389],
              [-8747869.750098163, 4204285.721896106],
              [-8751618.545270119, 4197304.495793347],
              [-8771370.741758004, 4200094.9024979165],
              [-8780926.852125663, 4195241.283016901],
              [-8804905.070442533, 4190013.1482106093],
              [-8819066.356824819, 4200379.312993153],
              [-8814673.133120662, 4205701.839849022],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Utah',
        GEOID: '49049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12491410.976045474, 4932885.50010942],
              [-12487025.878664147, 4934048.845447753],
              [-12465756.397516748, 4926329.534056323],
              [-12458172.08928951, 4931909.104471456],
              [-12458133.016148243, 4931921.246644561],
              [-12423942.013787525, 4948334.209519642],
              [-12422580.799054105, 4950157.727323957],
              [-12420475.30220524, 4936896.85009305],
              [-12425203.820215667, 4929799.519829014],
              [-12418271.95552397, 4918789.105060943],
              [-12409934.348302534, 4918712.112655952],
              [-12403939.237125862, 4907722.689396014],
              [-12391510.193339812, 4907819.005166524],
              [-12387495.12194588, 4903620.948177673],
              [-12381566.802463684, 4890287.222260584],
              [-12384219.76856827, 4873969.51077571],
              [-12379369.91231288, 4872828.0575886695],
              [-12365709.786278147, 4857691.397660433],
              [-12365642.326666726, 4851443.666482065],
              [-12344402.567823369, 4851370.968983971],
              [-12340616.81458047, 4851378.659512521],
              [-12340631.620072749, 4838846.346014202],
              [-12384014.606746739, 4838809.101190605],
              [-12427924.357251162, 4838786.058743012],
              [-12441755.692662736, 4838457.383594815],
              [-12438609.469894446, 4846213.269825896],
              [-12446756.498147644, 4857189.0302589005],
              [-12457704.54742818, 4850633.431402472],
              [-12473035.46770023, 4833567.375311604],
              [-12477784.24585798, 4834303.070277533],
              [-12473739.78611848, 4850463.093099103],
              [-12487798.21329127, 4867636.242255206],
              [-12484130.903986577, 4891815.906807788],
              [-12487786.302105756, 4899748.378769474],
              [-12487323.213024056, 4914865.888168391],
              [-12491410.976045474, 4932885.50010942],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mason',
        GEOID: '26105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9630772.572771806, 5474440.641970104],
              [-9624467.801466728, 5480820.077066948],
              [-9621329.229048321, 5483997.473783804],
              [-9617046.561952325, 5492362.434784875],
              [-9616650.065676857, 5493137.263132377],
              [-9578319.385307468, 5491335.950708337],
              [-9577940.787719281, 5463843.885895116],
              [-9577693.43581074, 5436951.759788588],
              [-9621954.180928532, 5437540.825983385],
              [-9621476.950012604, 5440826.231744255],
              [-9623337.877940195, 5452775.005031836],
              [-9625032.271909561, 5460951.750519721],
              [-9625039.743144847, 5460965.448651379],
              [-9629329.426893163, 5468833.742185124],
              [-9630772.572771806, 5474440.641970104],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Roane',
        GEOID: '54087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9075578.634945361, 4707595.842827658],
              [-9072831.0472736, 4709921.413336892],
              [-9066766.361415183, 4713316.163199248],
              [-9055162.751653364, 4706732.902090819],
              [-9047871.436325897, 4709484.326808687],
              [-9041457.095946897, 4699293.882537741],
              [-9034532.021744138, 4670810.433674441],
              [-9026197.308829464, 4666242.747954642],
              [-9031436.56066365, 4659686.689259453],
              [-9038487.314571515, 4654233.297371533],
              [-9069383.03736577, 4656894.868270833],
              [-9075006.00748472, 4666351.5905880425],
              [-9077729.438826976, 4674851.877337482],
              [-9075578.634945361, 4707595.842827658],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Summers',
        GEOID: '54089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9024534.640914975, 4528669.089573023],
              [-9010980.71367446, 4539305.920364428],
              [-9003267.608796375, 4535106.771779067],
              [-9010766.2010157, 4553905.094300051],
              [-8995317.950000355, 4560924.413111552],
              [-8979946.064155692, 4545994.761963966],
              [-8979402.825040622, 4541592.484327199],
              [-8979511.250224654, 4538293.192036288],
              [-9000999.982922662, 4497970.394169603],
              [-9001087.874851473, 4497953.320795406],
              [-9002060.682877192, 4499857.254713126],
              [-9027412.917668926, 4521478.849529682],
              [-9024534.640914975, 4528669.089573023],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dodge',
        GEOID: '55027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9908452.029427705, 5355426.857511947],
              [-9908115.62192653, 5382062.387721242],
              [-9908196.9964743, 5408829.555184916],
              [-9894750.047264434, 5408905.688583382],
              [-9840758.869715298, 5408504.726396898],
              [-9840690.408228463, 5395072.316148756],
              [-9842695.60621612, 5368487.0672919685],
              [-9842645.289806282, 5341653.825534912],
              [-9855764.959713215, 5341860.118674929],
              [-9908417.854344033, 5342116.044565518],
              [-9908452.029427705, 5355426.857511947],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grant',
        GEOID: '46051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10823175.973822568, 5668502.262803507],
              [-10798830.289866589, 5668378.667451624],
              [-10797205.359259479, 5673129.688703385],
              [-10738999.915559033, 5673116.966364382],
              [-10737631.063969098, 5670079.0837629475],
              [-10737605.738616295, 5663953.766340324],
              [-10737415.005487103, 5617955.664017848],
              [-10784893.312258253, 5617880.875778236],
              [-10785071.757401993, 5645202.265544494],
              [-10823180.092643728, 5645455.135069695],
              [-10823175.973822568, 5668502.262803507],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montcalm',
        GEOID: '26117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9524757.01043687, 5383499.637222333],
              [-9471618.428867718, 5383202.077153423],
              [-9445009.28570544, 5383197.169026161],
              [-9443999.283965472, 5330079.713196054],
              [-9483708.17084583, 5330183.87505055],
              [-9496945.505454531, 5330070.867879832],
              [-9496916.228428451, 5343446.789258437],
              [-9496930.254684294, 5356860.602234062],
              [-9524778.16114012, 5356870.696580335],
              [-9524757.01043687, 5383499.637222333],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dyer',
        GEOID: '47045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9984516.414847769, 4303443.470624961],
              [-9983135.162606006, 4311978.364291218],
              [-9979015.339571238, 4314888.707430568],
              [-9973347.173739027, 4319300.900089347],
              [-9976876.224236153, 4325848.84794541],
              [-9977303.406289408, 4326170.52451943],
              [-9961790.09552436, 4326457.917332556],
              [-9961198.766389266, 4329922.514835614],
              [-9924629.534427239, 4328821.420714147],
              [-9925624.953313913, 4304205.5782828145],
              [-9930399.557593528, 4302247.082012051],
              [-9928456.698520713, 4300588.34846464],
              [-9938625.066087734, 4285003.623074432],
              [-9945598.230310515, 4284250.417802397],
              [-9951760.543362359, 4292556.832971085],
              [-9977715.684516227, 4290187.2050126465],
              [-9979670.4514734, 4287362.7051188005],
              [-9980046.046736494, 4289820.038643446],
              [-9983902.710495025, 4293429.557065215],
              [-9989042.442704441, 4300705.03222914],
              [-9984516.414847769, 4303443.470624961],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ohio',
        GEOID: '21183',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9695905.718154442, 4497257.427798002],
              [-9699893.8502316, 4506948.341148302],
              [-9689054.78273255, 4517566.452087831],
              [-9679091.688306553, 4527365.302502978],
              [-9664511.395360922, 4533429.610770227],
              [-9665139.90520594, 4542445.20117686],
              [-9644602.127071526, 4531769.874946256],
              [-9644791.926803328, 4525751.924361326],
              [-9639467.515558688, 4518065.972020126],
              [-9647491.424455067, 4516983.12388282],
              [-9641614.311938636, 4494325.878086557],
              [-9658027.035022214, 4481579.457419843],
              [-9664296.4374242, 4485045.160370644],
              [-9673582.264068212, 4468741.944309288],
              [-9682866.532239353, 4476756.946954291],
              [-9683232.43940559, 4483324.343751824],
              [-9692736.118293084, 4490848.0101907905],
              [-9700044.576822136, 4485978.267809285],
              [-9695905.718154442, 4497257.427798002],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monterey',
        GEOID: '06053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13577685.825478146, 4381106.560183828],
              [-13572502.678667322, 4388290.701071874],
              [-13565460.385040756, 4385041.881538347],
              [-13560323.881096572, 4394992.993952919],
              [-13558360.650556942, 4408144.344745613],
              [-13557772.661006574, 4413377.311771385],
              [-13560131.345884431, 4418226.1727525415],
              [-13547577.131483797, 4427917.538290369],
              [-13541348.249376463, 4424341.478516333],
              [-13536193.82299426, 4416459.658836954],
              [-13519901.324960738, 4400815.589642168],
              [-13521765.48115356, 4395362.235599095],
              [-13508630.449156903, 4390204.975037117],
              [-13505099.506228428, 4384887.946690161],
              [-13504366.467381556, 4370019.4033643585],
              [-13496830.471813323, 4370597.600618548],
              [-13491194.811272424, 4362130.644464561],
              [-13474199.887251996, 4345291.062013697],
              [-13472704.309893187, 4336467.243827847],
              [-13460814.163762067, 4343500.964485718],
              [-13454639.160288272, 4340954.694819414],
              [-13443106.795000562, 4328669.944555444],
              [-13438313.711685477, 4327741.268324133],
              [-13438232.448457196, 4336457.85607976],
              [-13442756.917840999, 4343168.315719103],
              [-13433878.297894312, 4337466.671582444],
              [-13428126.197166039, 4328621.246387491],
              [-13432650.33259137, 4319634.468147741],
              [-13406546.134639328, 4296347.442340605],
              [-13393412.104518084, 4287857.81265509],
              [-13389036.357973982, 4287678.45900016],
              [-13382158.928513281, 4271664.67973331],
              [-13441900.8709568, 4271919.249339793],
              [-13508292.25564626, 4272475.78304828],
              [-13514945.715189096, 4279262.74449394],
              [-13521117.379078163, 4284893.977765843],
              [-13523781.922409793, 4296542.069259204],
              [-13528866.551471267, 4302598.566829512],
              [-13533622.7880349, 4304083.351162399],
              [-13538900.111134935, 4314347.935537552],
              [-13545371.781051693, 4323461.7262576],
              [-13556471.002200728, 4331957.509819404],
              [-13561655.596164932, 4333952.171735906],
              [-13568564.75168051, 4342367.956253808],
              [-13570201.59347313, 4354916.574992286],
              [-13574476.81851705, 4367646.835996204],
              [-13577685.825478146, 4381106.560183828],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Frederick',
        GEOID: '24021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8647041.538229425, 4767316.7332662335],
              [-8644646.080592323, 4774579.50461954],
              [-8635073.160981556, 4810874.110858354],
              [-8623825.773999974, 4825369.621232036],
              [-8622744.685396876, 4825369.645747899],
              [-8598311.902897911, 4825370.199810508],
              [-8595759.765005136, 4825367.92014211],
              [-8605822.18366377, 4810744.480662634],
              [-8593644.72192691, 4804435.384902435],
              [-8583483.812765775, 4792373.055220267],
              [-8590311.371094598, 4772500.4443777995],
              [-8590391.63244746, 4772434.940807075],
              [-8600825.385680532, 4766214.477000662],
              [-8603406.884672029, 4764645.935943286],
              [-8622815.062355287, 4753067.60187505],
              [-8626882.718126949, 4757695.676905072],
              [-8633173.159912694, 4761753.630420992],
              [-8637082.811748846, 4765016.793355599],
              [-8645754.043484187, 4767182.510910242],
              [-8647041.538229425, 4767316.7332662335],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Loudoun',
        GEOID: '51107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8667650.030725772, 4733277.766327735],
              [-8663806.929384515, 4740657.742522319],
              [-8663790.80661895, 4740644.330791406],
              [-8661672.174070172, 4745846.192412001],
              [-8658214.924644604, 4754570.974208243],
              [-8651697.279778149, 4767802.112981256],
              [-8647041.538229425, 4767316.7332662335],
              [-8645754.043484187, 4767182.510910242],
              [-8637082.811748846, 4765016.793355599],
              [-8633173.159912694, 4761753.630420992],
              [-8626882.718126949, 4757695.676905072],
              [-8622815.062355287, 4753067.60187505],
              [-8622794.732466547, 4753044.476379032],
              [-8625698.835342363, 4748301.49217901],
              [-8629622.958712317, 4744767.93324439],
              [-8629479.022610718, 4739007.872922205],
              [-8625176.52429156, 4736817.494653637],
              [-8623099.079954376, 4732599.336745848],
              [-8611642.634559387, 4730557.009142358],
              [-8608340.420451455, 4729689.40466613],
              [-8616234.89751308, 4719421.786057487],
              [-8619712.852363937, 4714894.651401131],
              [-8631267.036271842, 4699831.8703372795],
              [-8632715.302847061, 4699715.3801290225],
              [-8633075.866677742, 4705439.271978678],
              [-8644533.870545603, 4713460.862041073],
              [-8678712.739081826, 4723638.897944132],
              [-8667650.030725772, 4733277.766327735],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '16087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13051434.064702025, 5526147.014383395],
              [-13048322.128336897, 5531786.214510274],
              [-13049531.058006914, 5539930.941425657],
              [-13042991.594520263, 5546804.897049499],
              [-13040291.31763209, 5552084.615460514],
              [-13034952.212214662, 5566903.101383464],
              [-13031312.621463178, 5578667.534026775],
              [-13025916.854424935, 5583321.964418688],
              [-13016788.433540909, 5588079.48342616],
              [-13012056.81939781, 5596451.004120787],
              [-12982639.398628218, 5596203.307092838],
              [-12982541.326156829, 5568664.947024351],
              [-12971967.533004338, 5561137.4749008175],
              [-12971937.588061314, 5541827.698123504],
              [-12958440.09980263, 5534479.2643931545],
              [-12946442.97564086, 5534501.093915555],
              [-12951732.65520437, 5515424.424633758],
              [-12952968.078913197, 5488864.107662322],
              [-12963384.911583666, 5488911.738256283],
              [-13013009.657482535, 5489098.13534861],
              [-13012795.514725642, 5489350.82022187],
              [-13013554.824972343, 5493257.249403069],
              [-13020539.677741656, 5495532.940188805],
              [-13021258.801652184, 5501986.47387866],
              [-13030987.45723057, 5502229.943133385],
              [-13037854.200020153, 5508500.072809833],
              [-13043342.807513718, 5505593.8074538605],
              [-13048533.858008388, 5510175.073636289],
              [-13047979.654697478, 5511433.8737486405],
              [-13045776.362901947, 5516440.078983272],
              [-13048526.84488047, 5521348.463306355],
              [-13051434.064702025, 5526147.014383395],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Garrett',
        GEOID: '24023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8848159.81706313, 4771110.276613696],
              [-8847936.5101646, 4798120.159352861],
              [-8847301.543789113, 4825492.494055585],
              [-8837928.042473245, 4825544.792835021],
              [-8799313.269781005, 4825760.244084326],
              [-8786271.092698833, 4825770.460328934],
              [-8801686.156046756, 4790752.398861356],
              [-8801747.983790558, 4789625.435342786],
              [-8804406.470443271, 4789567.506484106],
              [-8812774.133927219, 4779259.106736883],
              [-8823449.129540823, 4768511.526263293],
              [-8825823.672554951, 4766122.3977670595],
              [-8833619.042536732, 4761576.888562639],
              [-8841485.211714657, 4754408.010304045],
              [-8848438.227109605, 4751216.80521465],
              [-8848159.81706313, 4771110.276613696],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Preston',
        GEOID: '54077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8894398.371314952, 4790943.067692989],
              [-8882101.686403455, 4811420.830603762],
              [-8879262.705429753, 4825448.786354502],
              [-8847301.543789113, 4825492.494055585],
              [-8847936.5101646, 4798120.159352861],
              [-8848159.81706313, 4771110.276613696],
              [-8848438.227109605, 4751216.80521465],
              [-8848471.845595824, 4749628.762990908],
              [-8870747.766259486, 4760621.90340399],
              [-8884378.392629158, 4754746.443578319],
              [-8891306.917736132, 4763946.983091557],
              [-8893930.384175656, 4764675.71336154],
              [-8893835.985247465, 4784259.27373707],
              [-8894398.371314952, 4790943.067692989],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Richland',
        GEOID: '17159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9824811.462103236, 4683232.387053857],
              [-9824900.517695872, 4699854.8826712435],
              [-9790094.920426482, 4700229.233480485],
              [-9785886.375757553, 4700223.372975981],
              [-9786350.911992632, 4660278.404873281],
              [-9790983.138643522, 4660276.981069898],
              [-9812569.76902019, 4660133.462705788],
              [-9812612.070426691, 4664249.166794659],
              [-9824387.891440766, 4664464.959066899],
              [-9828667.346625334, 4668309.388827739],
              [-9824811.462103236, 4683232.387053857],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kent',
        GEOID: '24029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8491286.78410097, 4742572.574332246],
              [-8487350.415587028, 4752280.09284014],
              [-8483797.876677342, 4760393.847757785],
              [-8480063.219080718, 4764548.692427401],
              [-8478056.017342225, 4769902.511088869],
              [-8472585.109647699, 4775135.33730599],
              [-8467127.317833286, 4777366.337573399],
              [-8458222.55762606, 4774355.308265746],
              [-8434333.239801401, 4775912.200040437],
              [-8434332.170387425, 4775890.224576875],
              [-8433613.760752903, 4764273.743064022],
              [-8433167.792510703, 4757069.298658255],
              [-8445399.554162093, 4759106.5661136545],
              [-8461427.000488034, 4756038.630239107],
              [-8465583.447635274, 4744998.938068574],
              [-8477752.226451851, 4735286.075564388],
              [-8483768.710970754, 4720608.776969957],
              [-8489785.044140648, 4725762.077485783],
              [-8486081.262072494, 4724324.464410915],
              [-8486269.614650918, 4734770.156029955],
              [-8487719.439699009, 4738816.032663791],
              [-8491286.78410097, 4742572.574332246],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Loudon',
        GEOID: '47105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9415900.352057906, 4251804.32293166],
              [-9389534.5533025, 4277579.7777690515],
              [-9387569.319012037, 4285895.1161708],
              [-9380156.888078583, 4286449.725492009],
              [-9370852.248440629, 4275913.682588433],
              [-9369345.984410703, 4273837.289588138],
              [-9370074.570477946, 4261168.683488518],
              [-9365806.13592297, 4252211.856296621],
              [-9371800.801821679, 4247164.991541534],
              [-9383205.038375486, 4253242.8807327915],
              [-9406972.751535267, 4254741.916424567],
              [-9409374.580868622, 4249032.402760772],
              [-9413948.030828374, 4249797.5622991165],
              [-9415900.352057906, 4251804.32293166],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '24031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8629622.958712317, 4744767.93324439],
              [-8625698.835342363, 4748301.49217901],
              [-8622794.732466547, 4753044.476379032],
              [-8622815.062355287, 4753067.60187505],
              [-8603406.884672029, 4764645.935943286],
              [-8600825.385680532, 4766214.477000662],
              [-8590391.63244746, 4772434.940807075],
              [-8592410.522732487, 4770385.542327826],
              [-8586569.477731073, 4761403.601142271],
              [-8579405.623220563, 4758135.426465339],
              [-8568669.303611515, 4744933.325844177],
              [-8566982.924645487, 4740887.439999905],
              [-8559189.224456068, 4740448.87178462],
              [-8561280.583729602, 4738574.982002957],
              [-8568769.37983374, 4723779.446035016],
              [-8571884.237695077, 4716735.486341343],
              [-8576166.893955423, 4721033.8818413345],
              [-8584932.301979976, 4712271.12956013],
              [-8584935.659012271, 4712275.931616156],
              [-8587920.339751849, 4716546.258008318],
              [-8594143.210606685, 4717075.997244888],
              [-8599408.733840697, 4719653.358676215],
              [-8599252.96503109, 4725523.83078364],
              [-8599252.886553586, 4725526.789229158],
              [-8606188.313468989, 4729124.012649521],
              [-8608340.420451455, 4729689.40466613],
              [-8611642.634559387, 4730557.009142358],
              [-8623099.079954376, 4732599.336745848],
              [-8625176.52429156, 4736817.494653637],
              [-8629479.022610718, 4739007.872922205],
              [-8629622.958712317, 4744767.93324439],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Allegan',
        GEOID: '26005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9600264.353125002, 5242215.207744502],
              [-9598934.397016171, 5255748.721324314],
              [-9598705.434975931, 5258080.581051563],
              [-9596665.060029183, 5275935.329860299],
              [-9596690.608176226, 5276656.32027145],
              [-9588732.099156782, 5276777.347398563],
              [-9587580.610344017, 5276786.445785238],
              [-9549263.996335007, 5276755.814585212],
              [-9522888.624103395, 5276746.564589],
              [-9522624.462951742, 5224318.610110071],
              [-9547282.398079397, 5224210.337817056],
              [-9604311.044211544, 5223998.519166253],
              [-9600264.353125002, 5242215.207744502],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hancock',
        GEOID: '21091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9682317.885792283, 4568934.91362463],
              [-9676752.531846514, 4570241.347610255],
              [-9670978.055900594, 4575297.416715522],
              [-9664052.418564292, 4578865.635175497],
              [-9663746.630459173, 4579023.211277656],
              [-9660304.631803844, 4573285.649035696],
              [-9653876.376488496, 4564271.655852607],
              [-9646766.066653058, 4560989.421124017],
              [-9645466.863316856, 4560359.519898786],
              [-9648936.685404034, 4550203.3725064425],
              [-9643069.591641776, 4531799.827168947],
              [-9644602.127071526, 4531769.874946256],
              [-9665139.90520594, 4542445.20117686],
              [-9672980.136942511, 4562785.692768139],
              [-9683366.245433524, 4564843.247586232],
              [-9682317.885792283, 4568934.91362463],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wabash',
        GEOID: '17185',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9795068.786594618, 4616180.078545521],
              [-9790674.11573708, 4620561.135991011],
              [-9793451.31439339, 4636077.299927189],
              [-9790983.138643522, 4660276.981069898],
              [-9786350.911992632, 4660278.404873281],
              [-9756970.443732627, 4659783.604702094],
              [-9758348.048805622, 4656148.499781803],
              [-9757617.125029072, 4651996.217371908],
              [-9764283.047457265, 4647440.333916567],
              [-9767287.894472249, 4641142.153079244],
              [-9768408.430357415, 4638765.306204023],
              [-9771624.45655559, 4631946.623080576],
              [-9777410.398409061, 4622920.044606688],
              [-9785934.131819103, 4617437.0879908325],
              [-9792660.723369775, 4613015.40785597],
              [-9795068.786594618, 4616180.078545521],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ketchikan Gateway',
        GEOID: '02130',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-14716401.216376025, 7485865.028957299],
              [-14704322.67324366, 7491165.608827179],
              [-14700721.153758027, 7501083.902588861],
              [-14690025.465763116, 7499074.0176273305],
              [-14691785.092954086, 7509473.654946935],
              [-14687007.705687203, 7518393.169341102],
              [-14695401.417931994, 7529562.196952448],
              [-14679917.544679595, 7548245.4356315825],
              [-14683664.336100716, 7554248.422150146],
              [-14675177.7834006, 7569664.461955185],
              [-14656794.148732528, 7571865.147376477],
              [-14655589.783161635, 7579117.291420041],
              [-14641520.112720273, 7569005.794504549],
              [-14638384.910581574, 7562218.268309824],
              [-14623408.87684617, 7561988.429395308],
              [-14623955.344226474, 7572345.366149793],
              [-14631829.083129773, 7584554.951988737],
              [-14611056.977467239, 7599704.325098648],
              [-14609623.961662259, 7592855.242742591],
              [-14595133.392226204, 7597146.707470312],
              [-14582678.52231829, 7613269.077389874],
              [-14584320.150849018, 7621222.162500829],
              [-14593565.568517873, 7625429.122571086],
              [-14592515.235312507, 7639887.258933749],
              [-14592393.819557784, 7639775.641517081],
              [-14561781.293548107, 7632641.234498527],
              [-14553979.133077389, 7626993.042158858],
              [-14540828.182393542, 7611940.689656713],
              [-14523505.979070181, 7606299.710404726],
              [-14518908.595419914, 7586471.390474281],
              [-14509796.093223065, 7583771.773110129],
              [-14498982.660841003, 7577789.009813079],
              [-14502966.642462898, 7574277.712330969],
              [-14503738.086534096, 7567841.701896532],
              [-14496030.770269532, 7558243.859109144],
              [-14503662.723238828, 7558042.405668832],
              [-14507175.187131828, 7552241.734651965],
              [-14514793.225164777, 7547112.507600579],
              [-14503668.734491328, 7535954.551803853],
              [-14504760.444737539, 7532006.768448189],
              [-14498024.836308114, 7522001.114247658],
              [-14486920.64358487, 7511385.057244643],
              [-14488238.517233495, 7504279.497654702],
              [-14483965.629898883, 7495379.628353191],
              [-14484906.836193543, 7472089.566291209],
              [-14481041.934792688, 7457849.901925786],
              [-14475978.567753958, 7445658.201701304],
              [-14474156.267689671, 7427793.996029681],
              [-14469568.791474082, 7420715.595791119],
              [-14471726.94244209, 7413381.457223547],
              [-14483194.408466669, 7398629.025568843],
              [-14490379.52499992, 7382353.703684416],
              [-14496192.406170163, 7366911.876834844],
              [-14509327.215527844, 7346621.725943854],
              [-14530447.194599107, 7325251.815338031],
              [-14542415.932290727, 7318987.117446057],
              [-14541450.235708097, 7311440.975645578],
              [-14547920.347151984, 7307116.8304830585],
              [-14553623.355984813, 7314180.395836716],
              [-14559712.420811713, 7320208.613121277],
              [-14565503.594681252, 7316544.89220348],
              [-14568032.884831566, 7317175.30107371],
              [-14575334.107593715, 7324486.512693361],
              [-14576990.986894682, 7339914.2571915295],
              [-14578445.042083424, 7349006.346291082],
              [-14580073.64623373, 7356987.121897655],
              [-14584195.918297295, 7361136.019789991],
              [-14582525.680657431, 7370460.042043891],
              [-14584324.38098967, 7379366.328396073],
              [-14588675.080648346, 7384832.413291298],
              [-14592593.415404776, 7393572.587471197],
              [-14593295.730072191, 7399089.237281014],
              [-14600719.18163523, 7400287.865756291],
              [-14604073.905809777, 7382857.516836527],
              [-14604007.670712756, 7370249.624489829],
              [-14610239.892404815, 7359839.21535943],
              [-14610236.552820096, 7350325.184792995],
              [-14604582.524563212, 7346310.068579671],
              [-14611091.820467858, 7336053.443909964],
              [-14619324.230770495, 7334572.431350201],
              [-14631107.287551468, 7341811.504243135],
              [-14637567.268921692, 7348368.322500059],
              [-14649040.189601319, 7348511.306588212],
              [-14652088.228578731, 7351495.777966366],
              [-14650968.548561508, 7358425.964816857],
              [-14639699.70508733, 7365043.068026554],
              [-14620366.069884827, 7360999.401754047],
              [-14609520.323216328, 7394868.011773516],
              [-14646218.908426655, 7419270.971683047],
              [-14655030.068761926, 7406233.034802521],
              [-14659010.518196788, 7385014.146498619],
              [-14666157.453742132, 7386862.523181578],
              [-14675069.803494532, 7400483.104083688],
              [-14678828.72874015, 7418213.875946711],
              [-14677953.20094506, 7444020.622347977],
              [-14676824.421308413, 7451019.831596556],
              [-14691032.684515813, 7459178.709480249],
              [-14706936.009609524, 7469472.609802796],
              [-14714567.294661872, 7476856.725881321],
              [-14716401.216376025, 7485865.028957299],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Emanuel',
        GEOID: '13107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9191024.516623357, 3833412.9769220417],
              [-9194370.891836096, 3839576.529274404],
              [-9179969.044034207, 3848520.2280335585],
              [-9183794.649654808, 3853744.4678184963],
              [-9176527.490656842, 3863790.0391402044],
              [-9174855.471905127, 3870234.4919731906],
              [-9163432.199718393, 3873525.6762392204],
              [-9151992.22960804, 3869298.901264999],
              [-9144337.010865169, 3870474.7590052285],
              [-9137423.402569963, 3850700.6478109467],
              [-9128335.835939052, 3843243.322091686],
              [-9131563.767213585, 3834242.2046877462],
              [-9137086.215832349, 3837054.2203342333],
              [-9144711.155673726, 3831820.573237454],
              [-9156531.94976208, 3809539.1559981196],
              [-9154112.086671218, 3805236.2211036165],
              [-9167672.4704422, 3801764.04378352],
              [-9173741.052482795, 3809846.454971775],
              [-9170715.611362016, 3821285.67209803],
              [-9182626.908196386, 3828045.5252428837],
              [-9200303.552778432, 3830774.7545312364],
              [-9191024.516623357, 3833412.9769220417],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yavapai',
        GEOID: '04025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12616301.092002885, 4235872.819360153],
              [-12598523.035364727, 4232919.7659581285],
              [-12595583.866849313, 4229112.002605373],
              [-12576414.650534708, 4217404.250965229],
              [-12573916.084563855, 4212380.995469693],
              [-12551811.150638053, 4205584.527856896],
              [-12545132.871746384, 4206305.470688719],
              [-12528096.425555889, 4196045.096983204],
              [-12516847.145733267, 4199334.2835600795],
              [-12517019.579624504, 4184203.67666126],
              [-12505154.703017795, 4184049.9699592562],
              [-12505023.346018659, 4160215.8174260654],
              [-12468681.317137342, 4160606.260723659],
              [-12443049.447784737, 4161300.098956561],
              [-12443102.435862353, 4137216.45280324],
              [-12417923.636837278, 4137076.679641322],
              [-12418210.28452607, 4092321.5002877545],
              [-12418158.520962851, 4087961.4142865827],
              [-12429894.712238206, 4080784.7677724636],
              [-12431538.67847824, 4069986.698012486],
              [-12436676.963534275, 4050498.648219664],
              [-12409657.830687404, 4049110.2307114084],
              [-12411541.91306908, 4028777.4537319667],
              [-12437204.617920637, 4028781.7505416884],
              [-12486123.745510759, 4035271.915631985],
              [-12489563.51777627, 4025378.7813496185],
              [-12498511.601085214, 4013010.3289425764],
              [-12550599.215341786, 4028788.3300347137],
              [-12616255.673650641, 4028698.2315927525],
              [-12616228.400375396, 4071565.4244135185],
              [-12616294.8581114, 4233189.298980967],
              [-12616301.092002885, 4235872.819360153],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Delta',
        GEOID: '08029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12064689.860668128, 4697222.23784417],
              [-12038125.69058013, 4708611.640764636],
              [-12033056.534927877, 4718761.897551043],
              [-12020520.513111174, 4730252.2151917275],
              [-12006724.354658691, 4733109.266042968],
              [-11996399.471887615, 4727874.965287462],
              [-11982195.438820867, 4742035.1838815855],
              [-11966912.71988833, 4752934.413074504],
              [-11966918.174543379, 4674305.226638355],
              [-12064661.474197976, 4674240.21222767],
              [-12064689.860668128, 4697222.23784417],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Orange',
        GEOID: '12095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9090193.436933136, 3346007.139546474],
              [-9088848.25220639, 3348420.465537335],
              [-9063014.671936467, 3348303.9929669523],
              [-9067992.211647797, 3339298.948429573],
              [-9068055.44111857, 3329930.2683865177],
              [-9063099.05211049, 3329915.17460403],
              [-9053379.302091366, 3326135.9257414597],
              [-9031239.636484435, 3326422.2487194585],
              [-9015459.430747544, 3326480.832833107],
              [-9003613.923732232, 3312601.0576284253],
              [-9001617.742623327, 3292855.00966466],
              [-9027417.815726522, 3292933.179061825],
              [-9051340.040339522, 3292926.348708013],
              [-9090045.493329873, 3292805.806183544],
              [-9090046.940483252, 3318025.193714308],
              [-9090193.436933136, 3346007.139546474],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lewis',
        GEOID: '16061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12992486.943422772, 5832669.493580222],
              [-12954115.671543784, 5835521.613038549],
              [-12954151.405100329, 5855492.301830528],
              [-12947416.464587847, 5846781.258998907],
              [-12933565.759584874, 5845228.150104591],
              [-12932015.524356088, 5840097.73403882],
              [-12927209.973258032, 5828325.854891144],
              [-12914466.229271509, 5816585.7530841045],
              [-12927929.876404991, 5814907.4789950615],
              [-12934099.536543226, 5805280.336563432],
              [-12962950.988208555, 5811968.089953038],
              [-12970328.910099862, 5801493.228436692],
              [-12972048.684913127, 5780463.800247872],
              [-12985253.402911026, 5785253.767400001],
              [-12991187.06572878, 5779769.291934872],
              [-12992486.943422772, 5832669.493580222],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '17025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9873500.603625381, 4696820.848317612],
              [-9873318.707577424, 4709448.559513223],
              [-9860633.85160153, 4709558.007834458],
              [-9836384.459005088, 4708909.203972581],
              [-9836385.906158466, 4700511.685214267],
              [-9824900.517695872, 4699854.8826712435],
              [-9824811.462103236, 4683232.387053857],
              [-9828667.346625334, 4668309.388827739],
              [-9824387.891440766, 4664464.959066899],
              [-9861184.883080957, 4665577.038066851],
              [-9873867.290028054, 4665399.399294233],
              [-9873500.603625381, 4696820.848317612],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cass',
        GEOID: '18017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9638212.054341521, 4999211.986373061],
              [-9625630.391533593, 4999059.383855123],
              [-9592290.53799948, 4999051.577033841],
              [-9591846.595870197, 4948044.951588537],
              [-9615156.118005872, 4947856.220515974],
              [-9615056.37574212, 4967084.868520202],
              [-9631937.197284484, 4967078.849031336],
              [-9638235.097476115, 4973444.839670381],
              [-9638212.054341521, 4999211.986373061],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Delaware',
        GEOID: '19055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10197651.160949368, 5257936.961896685],
              [-10144853.105702553, 5258220.11619597],
              [-10144553.990230793, 5205386.48454684],
              [-10170511.91437193, 5205489.424810275],
              [-10196529.283121154, 5205483.856375609],
              [-10197651.160949368, 5257936.961896685],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coffey',
        GEOID: '20031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10682091.65494201, 4603601.983803768],
              [-10682063.602430329, 4614278.6931425845],
              [-10681104.473697653, 4616178.802615681],
              [-10681136.533711003, 4640933.104555091],
              [-10631931.648988012, 4640908.661361998],
              [-10631938.439476952, 4634706.6615513805],
              [-10633123.101497974, 4584827.838267016],
              [-10682112.137728315, 4585105.575435539],
              [-10682091.65494201, 4603601.983803768],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morrill',
        GEOID: '31123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11507139.289221589, 5116028.5107904505],
              [-11506274.225458635, 5122641.252781885],
              [-11506354.041533533, 5161418.353945097],
              [-11432270.697771627, 5161704.929571238],
              [-11430016.144124592, 5161770.694874565],
              [-11428601.050757628, 5122627.676013065],
              [-11425440.245136043, 5122580.232070932],
              [-11425464.624104528, 5077319.175717012],
              [-11506987.115477676, 5077111.584352465],
              [-11507139.289221589, 5116028.5107904505],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Woodford',
        GEOID: '21239',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9447106.767550964, 4599416.371355131],
              [-9431562.559134556, 4607069.855734845],
              [-9422952.33048017, 4604404.4460144015],
              [-9420420.702620547, 4595881.87942567],
              [-9424345.939185409, 4579967.725190075],
              [-9429864.93689996, 4559942.573655124],
              [-9436019.346267955, 4557952.246826016],
              [-9442837.665079044, 4567630.842982231],
              [-9439483.942779915, 4575201.111809004],
              [-9445434.192201797, 4586206.703509429],
              [-9443334.261327472, 4592657.512144942],
              [-9447118.344778009, 4595956.728608738],
              [-9447106.767550964, 4599416.371355131],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jessamine',
        GEOID: '21113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9427538.693500852, 4558411.269763061],
              [-9429864.93689996, 4559942.573655124],
              [-9424345.939185409, 4579967.725190075],
              [-9416967.349377159, 4577572.138927693],
              [-9414367.593989173, 4576260.09132287],
              [-9404229.282684667, 4570984.201227645],
              [-9399341.355163423, 4557863.010383519],
              [-9403856.807668472, 4558698.874315512],
              [-9402270.282285687, 4551694.300848517],
              [-9409351.53773403, 4546914.449229754],
              [-9414418.244357483, 4541149.684643651],
              [-9423930.494845768, 4552606.883120028],
              [-9423963.334095554, 4548945.9067479465],
              [-9430644.952571945, 4553379.195681401],
              [-9427538.693500852, 4558411.269763061],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Russell',
        GEOID: '20167',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11024804.069438832, 4740757.99151159],
              [-10963856.314271042, 4740697.142684218],
              [-10963167.914539976, 4738047.129826341],
              [-10963284.577366326, 4703180.355169527],
              [-10963423.392771346, 4678344.488674905],
              [-11024299.903465027, 4678327.515438062],
              [-11025374.693148637, 4678334.3617822975],
              [-11024804.069438832, 4740757.99151159],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rockcastle',
        GEOID: '21203',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9400565.758242661, 4507052.154233172],
              [-9392494.315923713, 4505208.502693998],
              [-9389554.702130333, 4514514.098706369],
              [-9380683.317950547, 4511179.838270487],
              [-9373044.24053384, 4512239.207816541],
              [-9365209.129493844, 4489040.113768043],
              [-9366187.961776389, 4483771.283864634],
              [-9379147.44293607, 4472484.3355870545],
              [-9383017.019755535, 4460278.544259485],
              [-9384588.294368083, 4462286.857616023],
              [-9406823.360778622, 4485037.040669232],
              [-9400565.758242661, 4507052.154233172],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nelson',
        GEOID: '21179',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9544285.677387241, 4552872.064075145],
              [-9537926.106197713, 4553307.189660163],
              [-9526305.575873295, 4563211.07823089],
              [-9516614.434963303, 4578105.620637238],
              [-9506635.421850123, 4570943.26738056],
              [-9480839.912846053, 4575444.1351476945],
              [-9479166.001662994, 4564978.814802475],
              [-9484894.05738125, 4557757.421964706],
              [-9490468.93748018, 4560573.010246259],
              [-9506883.107717138, 4541446.3836871525],
              [-9512305.368794186, 4535155.301500576],
              [-9520186.45478388, 4516659.3163398495],
              [-9531613.400513807, 4514714.1544095585],
              [-9528067.65209306, 4536214.71234078],
              [-9537908.295079187, 4541675.247448163],
              [-9544120.701901887, 4548538.146894526],
              [-9544285.677387241, 4552872.064075145],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Itasca',
        GEOID: '27061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10510624.128202805, 6081242.334928869],
              [-10439115.82690193, 6081339.866594712],
              [-10439071.18778612, 6090060.149568435],
              [-10361747.111008242, 6088884.670990798],
              [-10359531.296544002, 6060429.526033638],
              [-10360449.348384576, 6006609.728857305],
              [-10358940.19004789, 5946386.7390700495],
              [-10439013.858248362, 5947040.4783300245],
              [-10438866.13728408, 5976637.804086826],
              [-10442750.074317858, 5980126.906437224],
              [-10438875.042843344, 5992010.560274863],
              [-10451588.062650407, 5994275.677526814],
              [-10454180.916229963, 5990829.965224907],
              [-10468739.50187489, 6003189.5231110165],
              [-10467133.272942234, 6009030.319886427],
              [-10474620.287934517, 6020443.245684291],
              [-10500492.718706727, 6010216.521514061],
              [-10510372.100875648, 6014985.997269776],
              [-10510624.128202805, 6081242.334928869],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lamar',
        GEOID: '28073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9980261.227312196, 3689216.060942723],
              [-9972759.072869165, 3689200.796394991],
              [-9957708.343755443, 3689245.285429142],
              [-9957647.89727194, 3677815.7466045055],
              [-9946158.612627167, 3677857.066005797],
              [-9946279.61691366, 3634095.9585267026],
              [-9954782.978856888, 3630470.4111763197],
              [-9963243.594115647, 3634830.599492469],
              [-9980241.857720798, 3633074.0799748395],
              [-9980261.227312196, 3689216.060942723],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sunflower',
        GEOID: '28133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10103747.604490703, 3965784.164889296],
              [-10103743.15171107, 3977377.9419720517],
              [-10092069.188031072, 3977392.37883152],
              [-10091891.299484782, 4027135.251012914],
              [-10068960.597576275, 4026880.5703172926],
              [-10069030.840174967, 4003504.340623949],
              [-10069207.838165328, 3939119.5604093494],
              [-10080597.603185333, 3939079.190871561],
              [-10080559.977197446, 3931267.994625373],
              [-10098489.762301553, 3931201.2901667175],
              [-10103776.992836272, 3931244.82776402],
              [-10103747.604490703, 3965784.164889296],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rensselaer',
        GEOID: '36083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8212390.716730189, 5237589.697711009],
              [-8211066.460067711, 5252854.34524758],
              [-8201659.629137207, 5279042.359480956],
              [-8201169.044141281, 5280940.628326213],
              [-8202362.277763094, 5297337.022834756],
              [-8199841.893172043, 5301708.46521433],
              [-8197062.2454869365, 5303039.851458765],
              [-8174259.560992842, 5305680.071679334],
              [-8156805.756549043, 5303395.956006884],
              [-8157344.564366804, 5286649.427828375],
              [-8158710.565838329, 5281870.486265802],
              [-8155817.706231083, 5273380.928787319],
              [-8160498.365340853, 5256224.060174265],
              [-8165565.95403985, 5237684.0793805905],
              [-8213566.250552965, 5230774.664129046],
              [-8212390.716730189, 5237589.697711009],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ontario',
        GEOID: '36069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8639691.584015585, 5275992.94795965],
              [-8636208.063190192, 5303446.329957044],
              [-8625314.337821163, 5303324.825556329],
              [-8625637.275663953, 5317234.320831905],
              [-8612953.532882968, 5317254.423912024],
              [-8599074.886687808, 5317249.398137941],
              [-8595627.878655395, 5318038.477767651],
              [-8586450.477195416, 5313869.0350624295],
              [-8567585.051771188, 5313974.690969649],
              [-8569522.901466917, 5290870.85248451],
              [-8568416.16308945, 5276152.764221645],
              [-8606444.236978322, 5275704.254507294],
              [-8609182.807771327, 5271369.006281539],
              [-8612454.598925233, 5259616.489579515],
              [-8612399.941055253, 5247711.430220893],
              [-8622321.513311185, 5247791.098220815],
              [-8626246.304598084, 5247850.50952049],
              [-8625799.46816204, 5261918.8541803425],
              [-8638260.57196144, 5262174.11844691],
              [-8639691.584015585, 5275992.94795965],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mountrail',
        GEOID: '38061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11453190.747037426, 6198240.850853519],
              [-11380624.799254524, 6198232.275058999],
              [-11351618.279538522, 6198365.789389059],
              [-11351626.851139313, 6168982.946013143],
              [-11345931.523351347, 6169022.3265960645],
              [-11345918.832929397, 6110710.862595899],
              [-11340287.625168128, 6110711.361913344],
              [-11340323.804002635, 6081536.426117499],
              [-11397508.960381612, 6081563.132019437],
              [-11397530.445043335, 6066689.997181732],
              [-11417145.718557546, 6070350.791080758],
              [-11426084.784987736, 6077576.907947662],
              [-11426362.861075738, 6091349.542203909],
              [-11416032.412330123, 6106380.543175541],
              [-11428447.095901862, 6119616.316703099],
              [-11446813.698687844, 6127452.8315946385],
              [-11446767.389779674, 6169121.197796701],
              [-11453187.852730667, 6169063.885876424],
              [-11453190.747037426, 6198240.850853519],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pamlico',
        GEOID: '37137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8570183.248686302, 4184958.218257294],
              [-8560014.54716081, 4198437.395830728],
              [-8554402.486351958, 4193281.601056242],
              [-8530697.668704474, 4195906.89896717],
              [-8526015.125643747, 4213165.446663635],
              [-8518404.657336174, 4212041.543467755],
              [-8510902.502893142, 4209414.863202938],
              [-8494137.564940695, 4191291.613951718],
              [-8539494.023547469, 4161403.7640331695],
              [-8547175.73632915, 4157147.361074552],
              [-8566400.501069658, 4166769.0374235935],
              [-8565012.792297427, 4180078.5686229877],
              [-8570183.248686302, 4184958.218257294],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Appling',
        GEOID: '13001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9189503.447101159, 3728749.912262859],
              [-9186112.321453124, 3742115.18617143],
              [-9176217.243236, 3742063.4274154543],
              [-9176236.056229945, 3758872.3072953336],
              [-9173532.55107654, 3756681.967007111],
              [-9153249.805895533, 3751905.6397003955],
              [-9140645.767869955, 3750255.076217218],
              [-9133606.368550152, 3740632.876879483],
              [-9137120.502235513, 3740674.6720268796],
              [-9143005.184477318, 3733602.9961534883],
              [-9142980.805508835, 3694103.914147525],
              [-9145704.793448545, 3694224.3833000907],
              [-9153421.571869828, 3701864.006573611],
              [-9183381.543024473, 3725290.9684482045],
              [-9186242.453937862, 3725407.690086843],
              [-9189503.447101159, 3728749.912262859],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Garvin',
        GEOID: '40049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10872363.04742703, 4144215.888181922],
              [-10790473.313053755, 4144119.70826301],
              [-10790457.394366574, 4114634.091259206],
              [-10820262.631429018, 4112733.4477121085],
              [-10814015.938203154, 4097021.390036251],
              [-10837187.312850755, 4097055.9721998386],
              [-10860588.116968881, 4097089.473772109],
              [-10860636.429627886, 4120634.2769542667],
              [-10872399.33758103, 4120660.944995895],
              [-10872363.04742703, 4144215.888181922],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Payne',
        GEOID: '40119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10837412.400861138, 4322531.567295634],
              [-10813649.697078444, 4322553.489777366],
              [-10813683.092925683, 4334583.645404265],
              [-10789649.326182906, 4334589.028617386],
              [-10777838.216890248, 4334589.580741961],
              [-10777842.335711407, 4322505.922184748],
              [-10755849.611832324, 4322649.728619388],
              [-10755811.31792749, 4292577.457436398],
              [-10813640.234921725, 4292642.356009306],
              [-10820654.36471712, 4293027.9055226995],
              [-10834015.820558054, 4302118.133703079],
              [-10837383.235154552, 4298548.511653368],
              [-10837412.400861138, 4322531.567295634],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pawnee',
        GEOID: '40117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10801565.966352833, 4370603.971348799],
              [-10799079.868164947, 4370600.924477338],
              [-10791337.597580276, 4363483.303106689],
              [-10784111.404154921, 4365613.5255574435],
              [-10778067.868999753, 4375010.930958464],
              [-10770556.363719497, 4378313.113587365],
              [-10765284.383955019, 4366533.984463373],
              [-10766353.162386123, 4361764.207660268],
              [-10757439.922077797, 4359385.025116274],
              [-10750757.413045477, 4352253.955023927],
              [-10744413.53790415, 4352700.3984154705],
              [-10750510.72905388, 4344149.852547187],
              [-10744026.14607619, 4341749.424381531],
              [-10737620.265978493, 4346492.502184352],
              [-10734962.847094273, 4340030.898824169],
              [-10723042.756020129, 4331839.384623087],
              [-10715238.369159596, 4331718.638825247],
              [-10716536.688380718, 4322932.521349529],
              [-10719831.85662769, 4322973.748211371],
              [-10753341.917663224, 4323151.618414662],
              [-10755849.611832324, 4322649.728619388],
              [-10777842.335711407, 4322505.922184748],
              [-10777838.216890248, 4334589.580741961],
              [-10789649.326182906, 4334589.028617386],
              [-10789634.520690631, 4346586.467505696],
              [-10801564.630518945, 4346587.849354776],
              [-10801565.966352833, 4370603.971348799],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'DeKalb',
        GEOID: '47041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9580122.64973883, 4312464.606899677],
              [-9563470.589750046, 4316722.021869186],
              [-9558339.42914142, 4313537.034989168],
              [-9552037.744087104, 4318741.989893988],
              [-9547553.90631744, 4310269.525562364],
              [-9533913.70647156, 4302692.839361591],
              [-9535952.300306458, 4296700.661829456],
              [-9532560.618060967, 4279642.052110509],
              [-9538087.18550089, 4277426.9559553],
              [-9558801.405028213, 4279501.286518682],
              [-9560691.832620863, 4278580.930379972],
              [-9561143.12183654, 4281037.171832727],
              [-9575129.191340316, 4295264.610108367],
              [-9580535.311091201, 4310264.70532986],
              [-9580122.64973883, 4312464.606899677],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sequatchie',
        GEOID: '47153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9524221.229727682, 4236548.555522801],
              [-9513347.653186485, 4238446.447650589],
              [-9509334.362904405, 4241261.399299612],
              [-9510708.379379267, 4237696.034426105],
              [-9507051.645426199, 4230982.90559208],
              [-9487301.230050165, 4212130.670785939],
              [-9489541.868760852, 4207327.421358541],
              [-9505247.267799933, 4183898.8520742906],
              [-9507039.28896272, 4194284.496216712],
              [-9524334.330330325, 4207356.753872534],
              [-9516215.911186263, 4219234.648418467],
              [-9529763.93849377, 4236367.1696257],
              [-9524221.229727682, 4236548.555522801],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bradley',
        GEOID: '47011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9465122.602621458, 4182401.671098711],
              [-9456183.202232795, 4203049.8020937005],
              [-9448743.498024099, 4211988.040125196],
              [-9446590.245113686, 4211557.156601279],
              [-9431336.803207228, 4202743.503042382],
              [-9433708.019680616, 4199846.219743244],
              [-9428520.197451174, 4198339.790918666],
              [-9429162.399593562, 4196686.363836771],
              [-9428753.857062351, 4187140.1701438683],
              [-9437203.081142034, 4162241.9793702164],
              [-9441059.165548196, 4162233.9285964156],
              [-9446718.262528097, 4162222.113484436],
              [-9459593.453303201, 4162144.5066107847],
              [-9457831.50993297, 4165943.557219119],
              [-9463100.484071199, 4176484.4899388626],
              [-9465122.602621458, 4182401.671098711],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Liberty',
        GEOID: '48291',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10593819.194925122, 3547970.8134097857],
              [-10558934.226858798, 3565775.2937660157],
              [-10558588.468520394, 3567150.5535587966],
              [-10550565.338860448, 3566562.632901277],
              [-10545599.487695653, 3566700.0832135356],
              [-10530416.177068394, 3517967.535695738],
              [-10513559.28921655, 3518085.1555058914],
              [-10513261.509578679, 3489358.871007654],
              [-10573287.762001682, 3488683.2585817534],
              [-10575333.146325517, 3502434.416282922],
              [-10578331.870768506, 3503130.679246703],
              [-10579324.840626383, 3504200.790096704],
              [-10586117.110676624, 3525061.8031233433],
              [-10593819.194925122, 3547970.8134097857],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henrico',
        GEOID: '51087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8640221.464791762, 4519919.1929154685],
              [-8641806.654340658, 4537930.311101469],
              [-8621233.476608172, 4534889.164469919],
              [-8616928.863218687, 4524832.133440254],
              [-8615151.981506646, 4522818.994315626],
              [-8598427.452529354, 4514377.080304494],
              [-8596236.462311562, 4513698.191810941],
              [-8591340.408467492, 4507712.513700305],
              [-8596566.30196278, 4492238.038554099],
              [-8599393.371750966, 4492487.262919533],
              [-8602445.752188519, 4488317.630422185],
              [-8618197.90541373, 4497988.235510317],
              [-8618452.381769683, 4501611.489028066],
              [-8614515.901936252, 4513967.720434476],
              [-8620316.426643016, 4522870.838989977],
              [-8620315.981365053, 4522887.558601034],
              [-8620930.13099576, 4523249.214548353],
              [-8620977.553098837, 4523281.109437803],
              [-8621417.265087472, 4523383.820073503],
              [-8621425.280090809, 4523467.14148111],
              [-8622277.764751304, 4523322.137368221],
              [-8622192.716660338, 4522720.504192587],
              [-8623457.640034221, 4522616.816592088],
              [-8623482.019002706, 4522950.50325897],
              [-8623550.03521158, 4522945.58569392],
              [-8623586.43668507, 4522921.70041087],
              [-8623708.999444434, 4522898.377187144],
              [-8623790.04003373, 4522876.318523428],
              [-8624021.47325509, 4522846.953877711],
              [-8624529.53541107, 4522868.450476294],
              [-8624573.840568407, 4522865.640460896],
              [-8624677.590333825, 4522867.466970818],
              [-8624791.470172906, 4522894.443154536],
              [-8624815.181224445, 4522904.699742652],
              [-8624827.760326905, 4522916.642357932],
              [-8624839.782831911, 4522868.450476294],
              [-8624809.503930416, 4522866.764466966],
              [-8624786.46079582, 4522845.829873774],
              [-8624772.100581508, 4522822.787819664],
              [-8624735.476469038, 4522802.555814031],
              [-8624723.34264454, 4522776.984862927],
              [-8624937.521344827, 4522102.749219208],
              [-8624943.75523631, 4522062.288033882],
              [-8624969.024760723, 4521781.592871789],
              [-8624962.679549746, 4521482.502065329],
              [-8624945.758987145, 4521337.384996131],
              [-8624912.029181436, 4521337.384996131],
              [-8624848.465752192, 4521324.320344289],
              [-8624830.877272647, 4521292.852862771],
              [-8624815.403863426, 4521286.9527205285],
              [-8624672.135678777, 4521036.90213344],
              [-8624626.494687552, 4520948.683465578],
              [-8624563.710494744, 4520844.170592898],
              [-8624556.474727841, 4520817.902064699],
              [-8624375.691874793, 4520517.574597878],
              [-8624349.531794457, 4520351.260384909],
              [-8624208.489999622, 4520098.984752513],
              [-8624198.025967488, 4520078.055700029],
              [-8624206.263609806, 4520068.785126408],
              [-8625297.751217034, 4519298.794348261],
              [-8626219.253961822, 4520273.863371745],
              [-8626244.18952776, 4520279.622476411],
              [-8626540.076734288, 4520583.7358014155],
              [-8626928.025159702, 4520058.95270882],
              [-8626943.609888414, 4520039.990215289],
              [-8627060.161395274, 4519879.86386311],
              [-8627223.91236623, 4519664.9612960415],
              [-8627253.523350783, 4519616.082112848],
              [-8627307.513303816, 4519655.97200383],
              [-8627328.997965539, 4519666.084958111],
              [-8628735.29709273, 4520617.870089219],
              [-8628837.265746295, 4520482.878762481],
              [-8628889.363267988, 4520521.5077362815],
              [-8628925.764741477, 4520543.842371686],
              [-8628940.0136363, 4520515.748498409],
              [-8628995.562062206, 4520535.695140667],
              [-8629013.818458695, 4520547.494580756],
              [-8629063.912229553, 4520566.317524648],
              [-8629093.300575122, 4520496.64470769],
              [-8629139.4981638, 4520541.8757981],
              [-8629222.09722597, 4520604.665865907],
              [-8629241.244178386, 4520626.017384257],
              [-8629272.970233263, 4520644.278585853],
              [-8629809.418859396, 4521113.883362517],
              [-8629831.348799082, 4521115.990520917],
              [-8630765.208007347, 4521918.146333685],
              [-8630794.596352916, 4521955.937678861],
              [-8630865.952146513, 4522016.347919534],
              [-8637887.317708809, 4516856.8854919765],
              [-8644559.474028487, 4518013.448982266],
              [-8640221.464791762, 4519919.1929154685],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '46027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10815841.800491145, 5283368.860372533],
              [-10815862.17195796, 5324635.938801872],
              [-10789546.13301494, 5324725.560199105],
              [-10776359.226135569, 5324715.957865402],
              [-10776547.200238653, 5266522.545388463],
              [-10787615.29644713, 5271540.868327189],
              [-10794170.01070402, 5270136.359506858],
              [-10799730.654459087, 5274985.66202111],
              [-10800756.896293748, 5275880.8962437175],
              [-10812610.306992905, 5277321.294768591],
              [-10816366.158971634, 5280307.370487418],
              [-10815841.800491145, 5283368.860372533],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '55055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9908417.854344033, 5342116.044565518],
              [-9855764.959713215, 5341860.118674929],
              [-9856403.488312405, 5314923.211735523],
              [-9856398.59025481, 5288104.688418848],
              [-9873829.552720673, 5288049.728721723],
              [-9882618.894435747, 5288058.838041524],
              [-9898381.289054113, 5288579.146707931],
              [-9908946.621925302, 5288808.261719797],
              [-9908417.854344033, 5342116.044565518],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Arecibo',
        GEOID: '72013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7432705.774948867, 2092528.8305693073],
              [-7432309.341511004, 2094137.1398499017],
              [-7428793.340125448, 2093041.015242052],
              [-7416618.550056368, 2095475.5964421795],
              [-7412347.975459522, 2094742.3614082374],
              [-7411637.002843369, 2092395.5050742521],
              [-7412562.401770333, 2083178.8182952676],
              [-7412852.277724359, 2077156.0806380608],
              [-7414656.098753173, 2075998.1392790936],
              [-7426936.085741052, 2074531.7507836823],
              [-7429011.637646893, 2078518.276801405],
              [-7432810.415270213, 2075626.0500204663],
              [-7432705.774948867, 2092528.8305693073],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Walker',
        GEOID: '01127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9755608.030859236, 4029097.8390462818],
              [-9708922.52885188, 4027983.9144390775],
              [-9703726.02370216, 4029500.817595707],
              [-9701608.949626252, 4027892.3454370154],
              [-9695018.83577129, 4014053.7313821977],
              [-9680716.730233153, 4009780.420863514],
              [-9679637.599089403, 4004027.8077838505],
              [-9685459.719777381, 4000268.8070700816],
              [-9691225.178844549, 3982752.778876365],
              [-9704769.755247837, 3977061.137665815],
              [-9705478.192487247, 3969322.5886561396],
              [-9715028.514241382, 3965788.3046374368],
              [-9714509.431455811, 3963586.3017155738],
              [-9720221.67980638, 3963751.4607389607],
              [-9720254.519056164, 3973532.6333986353],
              [-9726099.682878736, 3973488.8028590116],
              [-9731961.878583401, 3975497.56197552],
              [-9731977.685951093, 3987133.364189005],
              [-9743610.016141536, 3987526.305935704],
              [-9743973.362959486, 4011040.1790298196],
              [-9755599.347938953, 4011627.5415793657],
              [-9755587.325433949, 4017427.9748861482],
              [-9755608.030859236, 4029097.8390462818],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'King George',
        GEOID: '51099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8608365.611389415, 4626698.403908337],
              [-8603254.098647783, 4629220.090108895],
              [-8601133.295392066, 4626598.354350453],
              [-8589711.581678202, 4628419.124815823],
              [-8582032.874522775, 4629385.347013687],
              [-8576959.37741038, 4630427.8957456285],
              [-8573932.60045571, 4626046.041543989],
              [-8574528.938967891, 4622273.737813153],
              [-8571243.595690668, 4618935.4398067165],
              [-8576558.515924035, 4616284.2800161345],
              [-8578468.647066556, 4602284.081736093],
              [-8579815.724224646, 4599410.426687459],
              [-8584513.518055612, 4600627.739559239],
              [-8595456.557959065, 4607296.914758436],
              [-8597177.223328255, 4614123.626562641],
              [-8607967.978168301, 4614113.421165739],
              [-8608365.611389415, 4626698.403908337],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grant',
        GEOID: '55043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10147782.846119171, 5310066.033284493],
              [-10136998.959029634, 5310838.254102586],
              [-10123404.177535996, 5321395.666605668],
              [-10112902.185455069, 5323794.637010031],
              [-10092980.449382704, 5338154.714605396],
              [-10079468.7122292, 5344213.038690029],
              [-10066602.07152484, 5342607.148777109],
              [-10066276.68465325, 5283530.774963537],
              [-10066218.237549746, 5237257.592763433],
              [-10067402.01338568, 5237252.951604307],
              [-10090315.126814643, 5237454.393795697],
              [-10093641.798477506, 5247746.351026026],
              [-10096773.104434032, 5255284.714444957],
              [-10101539.91634929, 5258177.135518945],
              [-10113653.703337414, 5261092.699336083],
              [-10118603.527518798, 5262530.388163766],
              [-10123568.930382371, 5263972.822593639],
              [-10131992.698889678, 5269383.8788585365],
              [-10137945.73129883, 5277863.150441182],
              [-10141074.254268084, 5291358.056405174],
              [-10145435.751917368, 5297336.41494514],
              [-10147385.958076574, 5308285.129378777],
              [-10147782.846119171, 5310066.033284493],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Delaware',
        GEOID: '42045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8415485.891915616, 4847672.513966859],
              [-8393978.743655372, 4869929.714844652],
              [-8389155.492758282, 4875471.385853519],
              [-8387863.184789662, 4873633.270876943],
              [-8383630.261152248, 4868821.432440787],
              [-8379739.644949025, 4862594.588870943],
              [-8375107.195659151, 4856857.713983796],
              [-8378186.292774496, 4848020.640799049],
              [-8372472.047516404, 4846564.047832595],
              [-8373566.1999481, 4845780.077521189],
              [-8381620.276426486, 4843991.962958099],
              [-8387006.915266481, 4843600.479644375],
              [-8394657.623080548, 4837598.247011665],
              [-8395166.299983155, 4837199.30141073],
              [-8402529.527701676, 4841151.738366237],
              [-8412462.120587198, 4842600.527155592],
              [-8413487.901000522, 4842343.792312707],
              [-8414925.581324793, 4841983.977288759],
              [-8415120.864754453, 4841935.103788403],
              [-8415485.891915616, 4847672.513966859],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Juan',
        GEOID: '49037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12402414.381391006, 4439312.759785206],
              [-12391513.087646574, 4440798.105942645],
              [-12386384.376066746, 4446664.263357258],
              [-12384013.716190813, 4442118.5342067825],
              [-12376317.197916856, 4453419.383865136],
              [-12362883.273087414, 4452970.23882086],
              [-12351825.128830481, 4456466.062381061],
              [-12345277.761659987, 4463688.768841336],
              [-12342404.27164414, 4479185.625550778],
              [-12338340.887591204, 4480906.745042783],
              [-12341970.125630045, 4487821.905890423],
              [-12331728.17587961, 4484223.842323192],
              [-12327086.04179404, 4487331.945769527],
              [-12322978.241264278, 4499310.79885479],
              [-12328188.216072384, 4502395.325038536],
              [-12319939.219165621, 4505873.51529101],
              [-12317100.23819192, 4514794.7393309465],
              [-12307825.766135968, 4528386.389415552],
              [-12300981.175925054, 4530099.858111376],
              [-12299347.339758681, 4537632.305104351],
              [-12292800.640505128, 4548250.963961234],
              [-12297652.16655288, 4552409.199483431],
              [-12293850.4946228, 4552185.876443692],
              [-12290185.189068941, 4562476.819678891],
              [-12269072.000486616, 4564258.537260632],
              [-12267673.048445817, 4571875.893421737],
              [-12260360.248456627, 4580186.701974441],
              [-12253762.008278836, 4579265.759205575],
              [-12246200.854505684, 4594928.130405921],
              [-12237128.427325523, 4600904.202816223],
              [-12232594.495785004, 4606331.62974641],
              [-12237571.256259898, 4619659.41828134],
              [-12246827.80587783, 4631060.943643786],
              [-12250102.602657989, 4643565.209801193],
              [-12247971.724965224, 4650299.134147595],
              [-12140499.435773766, 4650299.987597422],
              [-12140510.567722844, 4618416.601210922],
              [-12138473.421041328, 4602717.18118135],
              [-12138477.274349362, 4601066.758310871],
              [-12138567.163253656, 4562640.678881268],
              [-12138698.143979665, 4506901.517773736],
              [-12138858.697798962, 4438979.109432515],
              [-12188965.270397378, 4438982.036526837],
              [-12245219.350555358, 4438823.556440097],
              [-12297485.298636181, 4438827.598558858],
              [-12328710.415803695, 4439552.417190643],
              [-12363865.778913155, 4439439.788273322],
              [-12387442.133868262, 4439171.60245208],
              [-12401644.60846214, 4439313.221561922],
              [-12402414.381391006, 4439312.759785206],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hardeman',
        GEOID: '47069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9927911.233015826, 4217980.80084658],
              [-9927756.164965149, 4222855.779714753],
              [-9916215.116757158, 4222666.14924983],
              [-9889802.452496128, 4222174.054312467],
              [-9884362.602939533, 4208677.343520661],
              [-9883141.20548655, 4197578.338618312],
              [-9883680.437099952, 4163235.9285481144],
              [-9887736.752546899, 4163229.819793748],
              [-9909341.250806171, 4163197.2837779],
              [-9910389.099887002, 4163195.70573699],
              [-9929507.988826238, 4163127.0188445617],
              [-9927911.233015826, 4217980.80084658],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Columbia',
        GEOID: '55021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9994809.460244479, 5410060.993736515],
              [-9987443.67217767, 5410384.492754374],
              [-9974175.947347982, 5410304.809111126],
              [-9934756.602463176, 5410373.570824415],
              [-9921591.180245528, 5408626.3820538735],
              [-9908196.9964743, 5408829.555184916],
              [-9908115.62192653, 5382062.387721242],
              [-9908452.029427705, 5355426.857511947],
              [-9947853.117916023, 5354887.826656107],
              [-9987636.254896741, 5356689.152965305],
              [-9982866.21471625, 5367112.314068211],
              [-9974307.638305591, 5370093.755985648],
              [-9974154.796644732, 5397300.813494437],
              [-9988947.041900832, 5399418.605849938],
              [-9994910.53834212, 5410060.686087109],
              [-9994809.460244479, 5410060.993736515],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shelby',
        GEOID: '48419',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10520964.37306361, 3759896.107133915],
              [-10467308.089804841, 3760644.520789534],
              [-10461523.104564724, 3753655.848183811],
              [-10453964.065861898, 3749292.275269894],
              [-10450479.197557107, 3742886.818516478],
              [-10447711.584022513, 3737802.1485922784],
              [-10442148.837748082, 3724084.8233551444],
              [-10443642.633995038, 3713860.431743514],
              [-10445655.958305527, 3709116.112857409],
              [-10452507.78428334, 3712442.092036219],
              [-10462302.34100028, 3706921.944989802],
              [-10474130.70481401, 3713612.0469486583],
              [-10508458.741467893, 3717925.119877793],
              [-10512201.748026326, 3739995.4860232626],
              [-10514394.853314444, 3742887.4007104426],
              [-10520898.24928608, 3753233.7814193033],
              [-10520964.37306361, 3759896.107133915],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cameron',
        GEOID: '48061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10893934.093074989, 3013987.6388646155],
              [-10893934.093074989, 3042265.8456690256],
              [-10854422.464332314, 3037862.2563367807],
              [-10847748.972178748, 3039383.00285599],
              [-10841486.805543663, 3050116.012918537],
              [-10823302.457980404, 3050136.397593095],
              [-10819913.31086691, 3037013.216913792],
              [-10815667.919446526, 3009322.3455163343],
              [-10814902.486627832, 3001267.5074296463],
              [-10814195.05126384, 2995505.957162503],
              [-10815424.129761688, 2992768.4686343954],
              [-10821027.61896975, 2994238.9226208385],
              [-10828844.250974273, 2991086.8581787697],
              [-10835655.111379476, 2989562.7567455173],
              [-10838730.868910095, 2987003.5948813776],
              [-10838074.751831358, 2982849.47001848],
              [-10839497.63756268, 2979292.187012034],
              [-10845038.231258443, 2979324.4692045003],
              [-10848610.585037488, 2984143.9731985545],
              [-10853300.920462573, 2984233.1809763224],
              [-10858432.30371018, 2989180.3019663715],
              [-10862841.44610152, 2991386.3003823743],
              [-10869681.583532803, 2999900.138751455],
              [-10875587.973075313, 3001986.2357709818],
              [-10882464.066702122, 3003061.049934189],
              [-10886521.996100008, 3005921.5380648645],
              [-10893979.351472957, 3006234.8951113797],
              [-10893934.093074989, 3013987.6388646155],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Francisco',
        GEOID: '06075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13637971.563634187, 4547144.41894452],
              [-13632785.522516603, 4551334.756677154],
              [-13625298.50752432, 4552004.121798005],
              [-13623871.836930312, 4549904.170062459],
              [-13622885.434922393, 4542558.376501935],
              [-13620694.889982563, 4541284.098960869],
              [-13621247.591254354, 4539244.143511512],
              [-13624373.206178686, 4538304.308014546],
              [-13636713.098915081, 4538276.386953516],
              [-13637261.150623543, 4542137.419107052],
              [-13637971.563634187, 4547144.41894452],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jo Daviess',
        GEOID: '17085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10090315.126814643, 5237454.393795697],
              [-10067402.01338568, 5237252.951604307],
              [-10066218.237549746, 5237257.592763433],
              [-10043599.568544772, 5237346.27286466],
              [-10010628.61408458, 5237048.1140348],
              [-10009809.65030938, 5190508.47441118],
              [-10053897.346608536, 5190076.098604367],
              [-10056398.972276691, 5191484.769059129],
              [-10063354.659339417, 5196892.046388459],
              [-10066719.95886559, 5202748.494997868],
              [-10065188.313991766, 5209026.493394036],
              [-10068438.286525475, 5214613.410546577],
              [-10072671.285049323, 5218313.448117099],
              [-10076363.788991993, 5221542.224671476],
              [-10081677.290926538, 5226929.13185004],
              [-10084478.979870822, 5228249.221172136],
              [-10090747.491716882, 5231932.59826534],
              [-10090315.126814643, 5237454.393795697],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brown',
        GEOID: '27015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10587316.24423145, 5509150.475293141],
              [-10560463.645342806, 5509244.393319423],
              [-10560415.22136431, 5542869.0851428425],
              [-10554744.161225338, 5540720.58455505],
              [-10550931.468665669, 5536383.931150632],
              [-10538177.817244465, 5526625.9022856625],
              [-10518727.073937647, 5521272.637463596],
              [-10505413.04019979, 5506457.739941708],
              [-10505092.328746814, 5482278.886777776],
              [-10559744.966710245, 5482173.152415711],
              [-10586508.176047781, 5482175.943043023],
              [-10586582.871426104, 5493385.929829623],
              [-10587460.625611007, 5495675.471071638],
              [-10587316.24423145, 5509150.475293141],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '27081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10737188.646879781, 5563668.385719738],
              [-10697018.262823498, 5563535.450652115],
              [-10695622.31640895, 5549881.1453360235],
              [-10695418.601740798, 5495920.169791508],
              [-10737036.041764868, 5495948.364389946],
              [-10737011.237044362, 5521346.283499202],
              [-10737131.274365084, 5549960.302589466],
              [-10737188.646879781, 5563668.385719738],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Duplin',
        GEOID: '37061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8699298.60723626, 4150639.979147408],
              [-8701112.113060774, 4189692.77162945],
              [-8687868.54456059, 4190076.7615009914],
              [-8670885.75436466, 4183797.563402468],
              [-8664468.964956863, 4188076.0466039465],
              [-8657225.183051962, 4183681.981089621],
              [-8654684.538313588, 4167971.822760807],
              [-8652978.233158708, 4164987.120759299],
              [-8646719.740066819, 4160334.8237437294],
              [-8644331.603030832, 4155803.0215424667],
              [-8647312.182396822, 4125975.6495711757],
              [-8680776.045843678, 4125079.6463815295],
              [-8695611.483062208, 4126138.17294557],
              [-8705033.008165495, 4128825.839016222],
              [-8699298.60723626, 4150639.979147408],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Benton',
        GEOID: '18007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9743447.241804725, 4937584.558880625],
              [-9743382.256463373, 4944054.238650217],
              [-9743364.945216527, 4973609.394873826],
              [-9714551.17626486, 4973564.867814964],
              [-9695748.42371395, 4973558.844335613],
              [-9695601.370666612, 4970306.707531969],
              [-9695410.791698374, 4948080.998464193],
              [-9695223.663634352, 4935319.011194062],
              [-9743468.335751222, 4935485.446162954],
              [-9743447.241804725, 4937584.558880625],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Johnson',
        GEOID: '19103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10222622.349124115, 5140307.804913098],
              [-10170841.197425697, 5140041.45115762],
              [-10170866.466950107, 5101006.241066696],
              [-10171097.232254524, 5074962.133187098],
              [-10181323.374637265, 5075110.888217209],
              [-10183951.739134384, 5075061.599869122],
              [-10187940.65044798, 5088010.237089701],
              [-10222383.234857893, 5088076.687541745],
              [-10222622.349124115, 5140307.804913098],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shelby',
        GEOID: '19165',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10637387.417231793, 5140546.662685719],
              [-10585688.864595544, 5140535.452081027],
              [-10585650.904649181, 5101554.3565669805],
              [-10579887.671971833, 5101568.796751739],
              [-10579890.12100063, 5087070.763020055],
              [-10592575.199615505, 5087148.20670213],
              [-10630788.397817567, 5087276.488106963],
              [-10630765.688641446, 5101595.741896807],
              [-10637483.81991082, 5101603.18532037],
              [-10637387.417231793, 5140546.662685719],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hodgeman',
        GEOID: '20083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11157233.854507668, 4616537.628669218],
              [-11085663.214291949, 4616529.405727563],
              [-11084133.90712743, 4615168.032296821],
              [-11084081.475647267, 4606206.708779012],
              [-11084029.71208405, 4591775.909379143],
              [-11084068.228627864, 4567145.167952116],
              [-11157228.622491602, 4567286.550377815],
              [-11157175.189136019, 4579569.199320813],
              [-11157233.854507668, 4616537.628669218],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Copiah',
        GEOID: '28029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10100716.708714876, 3735270.0148796393],
              [-10098546.312602878, 3742926.9759048885],
              [-10098714.627672955, 3769659.2533122846],
              [-10044394.501028527, 3769839.971414464],
              [-10030720.01477948, 3734163.575979618],
              [-10032398.044783698, 3730889.637915442],
              [-10040508.448924422, 3727647.9948349437],
              [-10046048.708661713, 3726288.110998929],
              [-10060989.788077006, 3722058.0158518394],
              [-10064862.481842212, 3724054.7301415144],
              [-10100777.043878885, 3723797.6324666245],
              [-10100716.708714876, 3735270.0148796393],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Otero',
        GEOID: '35035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11841787.274527384, 3889737.125365436],
              [-11837793.576475684, 3889781.1719641825],
              [-11837771.98049447, 3902311.324495542],
              [-11838350.28524914, 3947264.4223800916],
              [-11769494.83873336, 3947269.4887928045],
              [-11769359.696871536, 3935835.8306235005],
              [-11723876.66800373, 3935988.0739156227],
              [-11723831.249651488, 3912878.1695482377],
              [-11723728.724400466, 3890274.452106093],
              [-11727954.746229451, 3831602.3456923114],
              [-11672018.260578703, 3831835.359520016],
              [-11671597.02762554, 3763371.613640914],
              [-11679458.075470142, 3763372.594230809],
              [-11705689.066958945, 3763375.8662945516],
              [-11772094.81676033, 3763600.202408094],
              [-11799640.173723338, 3763569.8256488587],
              [-11822207.734569717, 3763544.9384132563],
              [-11841852.75134353, 3763473.4107770766],
              [-11841787.274527384, 3889737.125365436],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'White',
        GEOID: '18181',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9695904.604959533, 4988418.160839388],
              [-9683285.984080661, 4988464.362231539],
              [-9683397.303571455, 4999396.408823098],
              [-9677087.826152783, 4999431.909072526],
              [-9638212.054341521, 4999211.986373061],
              [-9638235.097476115, 4973444.839670381],
              [-9656967.050830882, 4973483.3307875255],
              [-9659336.152233943, 4947961.868440664],
              [-9695410.791698374, 4948080.998464193],
              [-9695601.370666612, 4970306.707531969],
              [-9695748.42371395, 4973558.844335613],
              [-9695904.604959533, 4988418.160839388],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kosciusko',
        GEOID: '18085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9582109.146052036, 5037873.189059816],
              [-9579500.373785295, 5038390.811995843],
              [-9580069.661661213, 5076837.921024472],
              [-9534904.783898093, 5076992.941510568],
              [-9534873.614440672, 5064281.6710576685],
              [-9534729.010422131, 5055918.767110616],
              [-9538585.785500154, 5038687.792154559],
              [-9538319.397958685, 5019234.707030747],
              [-9550746.326674411, 5018773.011320243],
              [-9567416.086462231, 5018667.922523842],
              [-9581929.699032877, 5024869.222042781],
              [-9582109.146052036, 5037873.189059816],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sioux',
        GEOID: '38085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11354429.430639524, 5788920.5257867575],
              [-11337818.336223353, 5792099.375829769],
              [-11336595.491616987, 5785645.9662270965],
              [-11326712.658543851, 5787028.90223498],
              [-11317243.488698503, 5782214.09352592],
              [-11312589.109468944, 5786284.970014542],
              [-11304960.1621259, 5781444.7617291],
              [-11276655.177840877, 5797166.492606108],
              [-11276853.43785398, 5801731.451460568],
              [-11264391.109540181, 5804209.4798268555],
              [-11265317.955620525, 5809847.556520072],
              [-11246125.250893367, 5826013.085662703],
              [-11230416.957547529, 5846151.264346921],
              [-11212239.486576404, 5843082.339885604],
              [-11197649.731474057, 5849186.696729783],
              [-11193308.271333119, 5838791.964191299],
              [-11194126.46959045, 5820501.678706622],
              [-11201985.18036249, 5803713.786478546],
              [-11200355.351697786, 5791862.0537321875],
              [-11188938.9842306, 5771324.338617457],
              [-11216786.77645582, 5771342.417276023],
              [-11255160.386044113, 5771377.156456724],
              [-11283931.68767607, 5771394.446053556],
              [-11305304.250671942, 5771395.726765773],
              [-11331723.70542191, 5771443.273337602],
              [-11354434.114767106, 5771465.68232644],
              [-11354429.430639524, 5788920.5257867575],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Burlington',
        GEOID: '34005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8355531.551883664, 4864854.203406216],
              [-8347839.041111376, 4871365.69459416],
              [-8345940.014805582, 4872702.615629669],
              [-8341415.572534132, 4875888.565286111],
              [-8333801.096724892, 4877896.0141731],
              [-8329581.865384844, 4883964.914572131],
              [-8323301.331033777, 4884727.064628572],
              [-8318168.533711545, 4888185.582509505],
              [-8317622.033252488, 4887768.096308959],
              [-8316263.824145317, 4889481.527394359],
              [-8316030.943770579, 4890455.4781635795],
              [-8316766.209007269, 4890392.25439758],
              [-8316690.177795057, 4892320.906866863],
              [-8303079.811572709, 4886053.360230633],
              [-8299213.685657458, 4877447.907121867],
              [-8285979.801952973, 4844916.359660265],
              [-8281024.414820309, 4833050.871376883],
              [-8281960.83437686, 4804600.750884958],
              [-8284106.294922919, 4801810.836414741],
              [-8290592.992970935, 4800974.157989998],
              [-8310480.665279117, 4811857.013864107],
              [-8318221.6000299, 4825635.051960567],
              [-8319597.508936104, 4826751.2711475175],
              [-8328859.624528577, 4835182.817784241],
              [-8338093.464970388, 4835623.227721291],
              [-8341288.668314629, 4849386.285927708],
              [-8347185.70701991, 4855391.169628566],
              [-8347356.582438278, 4855837.700900884],
              [-8346184.499519715, 4857010.8846834265],
              [-8348341.537292817, 4857134.874827533],
              [-8349423.674062818, 4857439.775205613],
              [-8350640.61873617, 4858216.297098057],
              [-8350760.621147247, 4858744.854571571],
              [-8350419.204268984, 4859641.578906101],
              [-8350921.03253348, 4860040.520190176],
              [-8351105.04365176, 4861211.005035181],
              [-8355655.447217773, 4864781.408174961],
              [-8355531.551883664, 4864854.203406216],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Woodbury',
        GEOID: '19193',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10741548.285530623, 5238783.50659341],
              [-10739765.169927096, 5244644.799545276],
              [-10740106.974083642, 5245437.589719592],
              [-10671080.710149175, 5245331.073504615],
              [-10657907.38424768, 5245431.578067807],
              [-10657930.761340747, 5232379.4813930625],
              [-10649853.86436675, 5232346.277596698],
              [-10650027.188813915, 5192700.130936813],
              [-10724209.840104219, 5193217.388014465],
              [-10724110.421256328, 5193829.518474672],
              [-10724074.799019275, 5200729.005265188],
              [-10725850.811603947, 5203149.4209797],
              [-10732089.245758936, 5211656.292195268],
              [-10732513.373018859, 5222729.484280253],
              [-10729118.017230174, 5230391.836114789],
              [-10736264.839858592, 5234759.139206811],
              [-10739821.052311474, 5237621.711867567],
              [-10741548.285530623, 5238783.50659341],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '21051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9344571.94305415, 4474088.144899569],
              [-9339880.494434161, 4474534.133683614],
              [-9326900.753127158, 4487825.546719857],
              [-9312243.093135424, 4489136.047157901],
              [-9298172.754777117, 4475203.921510955],
              [-9296055.346742738, 4472036.196386965],
              [-9300888.50507451, 4462481.3119087545],
              [-9301088.657518957, 4450163.305099735],
              [-9296188.596173218, 4430539.197167167],
              [-9305142.913373647, 4432945.716394165],
              [-9310953.790793056, 4433512.5682156235],
              [-9325685.812204638, 4444241.797830209],
              [-9336512.077962248, 4446764.554696107],
              [-9338110.403211057, 4455674.330102027],
              [-9347449.885849632, 4462672.137634912],
              [-9344571.94305415, 4474088.144899569],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clatsop',
        GEOID: '41007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13803400.007997857, 5818141.067847624],
              [-13793865.827569889, 5809152.9902223665],
              [-13785672.267769538, 5811204.851574768],
              [-13776631.789283235, 5814548.729137334],
              [-13772241.348566348, 5810686.73615238],
              [-13765864.856814217, 5815078.815345191],
              [-13757553.40967312, 5817067.2035650015],
              [-13753262.488581004, 5821969.290465832],
              [-13745691.0934147, 5823583.043446603],
              [-13739900.810101084, 5817178.880654696],
              [-13740259.036222458, 5809535.1557123065],
              [-13733645.099996468, 5803836.542308092],
              [-13732789.220900351, 5803815.846318794],
              [-13732552.944472292, 5745096.685916349],
              [-13772447.512263296, 5744059.401904221],
              [-13799862.98530185, 5745656.301852303],
              [-13799335.956027975, 5754282.858949705],
              [-13800013.446448943, 5765587.515890483],
              [-13802915.879532399, 5771768.902160377],
              [-13796656.16192611, 5776713.236366782],
              [-13795749.909951562, 5787078.77791606],
              [-13799073.909946648, 5803081.877994485],
              [-13808195.20638327, 5812083.079956491],
              [-13803400.007997857, 5818141.067847624],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mississippi',
        GEOID: '05093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10050919.706188567, 4300141.715000816],
              [-10030313.809957577, 4300365.854716438],
              [-10014231.84993973, 4300485.715970212],
              [-10007753.9132729, 4300533.997375316],
              [-9989042.442704441, 4300705.03222914],
              [-9983902.710495025, 4293429.557065215],
              [-9980046.046736494, 4289820.038643446],
              [-9979670.4514734, 4287362.7051188005],
              [-9979488.447407108, 4286172.142465868],
              [-9987877.929511255, 4283259.047207036],
              [-9988644.141566385, 4279675.97345687],
              [-9987966.09454796, 4274424.229288706],
              [-9996162.214696597, 4270755.139404555],
              [-10003600.694390895, 4265945.7715298375],
              [-10009346.672547173, 4266950.5205021985],
              [-10013921.680979794, 4258801.20905039],
              [-10007501.551987275, 4252692.011717016],
              [-10005011.55761721, 4249370.26060027],
              [-10011240.105766075, 4246797.489863212],
              [-10012604.214806255, 4240287.879601467],
              [-10014134.189887717, 4237742.275361524],
              [-10022941.45404081, 4238922.442824867],
              [-10023853.160670407, 4231564.406399043],
              [-10021210.324639484, 4226211.604783774],
              [-10023797.612244502, 4220481.399379289],
              [-10026607.650150597, 4221554.526879669],
              [-10031278.059386829, 4219759.93841213],
              [-10034367.509214813, 4223377.690235055],
              [-10050691.62198372, 4223642.343852931],
              [-10050673.47690672, 4259408.176771606],
              [-10050919.706188567, 4300141.715000816],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gadsden',
        GEOID: '12039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9454644.766870031, 3581736.5923875463],
              [-9446676.962997012, 3592975.0482943947],
              [-9447094.411087489, 3595343.7714079157],
              [-9446957.582110042, 3595337.9467518535],
              [-9441339.638691438, 3595098.799548517],
              [-9403660.440086713, 3592915.111029001],
              [-9393222.588465454, 3592403.0276926225],
              [-9382620.556395348, 3591882.9111069166],
              [-9392958.740839303, 3577478.725750183],
              [-9395966.370841553, 3564626.3450577375],
              [-9408700.652671361, 3561718.8563958276],
              [-9422795.036039678, 3553558.0231923824],
              [-9437790.105408004, 3562790.053415145],
              [-9437868.25169054, 3570398.7586567374],
              [-9449089.590320976, 3572259.8133911043],
              [-9449167.51396453, 3581632.6048939717],
              [-9454644.766870031, 3581736.5923875463],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gulf',
        GEOID: '12045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9508526.628679208, 3483337.137111232],
              [-9504984.66512115, 3493392.6162438034],
              [-9505486.719723998, 3493799.2413151953],
              [-9505535.585281085, 3529409.2951422096],
              [-9475031.929733401, 3529280.8798892954],
              [-9479301.588802781, 3515386.6081007514],
              [-9474812.741656031, 3506528.8644933524],
              [-9464988.573954543, 3499873.9811500306],
              [-9468068.784264792, 3492064.6312329574],
              [-9466537.695988422, 3475323.9283266],
              [-9474335.181040527, 3474890.8100168696],
              [-9487584.886926338, 3461145.18634783],
              [-9491068.504257591, 3462648.8462913753],
              [-9501409.639674325, 3459893.1676768097],
              [-9506999.547904508, 3472581.0495731155],
              [-9508526.628679208, 3483337.137111232],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Levy',
        GEOID: '12075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9257988.067419002, 3412492.6559655294],
              [-9246255.68198044, 3420199.713747854],
              [-9237777.923520098, 3435731.969780494],
              [-9232541.2320342, 3451109.3936000606],
              [-9223545.392663706, 3450219.324916501],
              [-9214238.19267746, 3450300.7381143915],
              [-9212406.76441493, 3447432.1283445717],
              [-9201257.33817555, 3447732.117331384],
              [-9190266.096932584, 3444250.80484298],
              [-9190177.15265944, 3436889.3235002444],
              [-9173462.976394793, 3437527.8239396713],
              [-9173335.849536309, 3421686.3632910675],
              [-9173086.382557439, 3403118.740829917],
              [-9187738.587894123, 3402998.466863969],
              [-9187819.962441893, 3381356.310998398],
              [-9196398.465041403, 3376826.078407042],
              [-9207462.063953383, 3379571.0978602697],
              [-9212308.336689172, 3375764.418664997],
              [-9212731.817328047, 3376488.5122813894],
              [-9212768.107482046, 3382545.2719772137],
              [-9219887.54551573, 3388240.0757758114],
              [-9217128.714575399, 3390227.916279897],
              [-9220267.590257298, 3395825.4815815613],
              [-9231403.324199311, 3397161.7265557996],
              [-9239088.487885207, 3398330.447228265],
              [-9241326.454928113, 3391612.6516755316],
              [-9245440.711988343, 3392309.47089925],
              [-9248310.417141503, 3400736.5531145544],
              [-9247837.08666665, 3407245.714262059],
              [-9251482.020753695, 3409914.2969852365],
              [-9257988.067419002, 3412492.6559655294],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Livingston',
        GEOID: '26093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9368446.745564077, 5278035.586301393],
              [-9342211.747210355, 5278669.849924869],
              [-9315937.787034852, 5279040.23601327],
              [-9315524.457765538, 5265750.211622445],
              [-9313523.823877, 5225788.400966659],
              [-9365435.219379647, 5224791.222631146],
              [-9366501.326142972, 5224797.858074023],
              [-9368446.745564077, 5278035.586301393],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Guadalupe',
        GEOID: '35019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11723363.373831684, 4110594.8137062015],
              [-11720873.268142128, 4110569.7925705938],
              [-11720917.23934099, 4169594.321091527],
              [-11720959.31810851, 4193340.191614562],
              [-11591157.118300358, 4193232.1399660497],
              [-11591155.448507996, 4183203.055685637],
              [-11591603.175499968, 4133934.210719929],
              [-11615055.29790335, 4133896.939613248],
              [-11615045.056510197, 4122135.2313890797],
              [-11626756.980136557, 4122056.8415833525],
              [-11626737.72186465, 4110324.453145406],
              [-11676526.588636339, 4110253.3138293214],
              [-11676495.6418179, 4075497.160033336],
              [-11723397.548915358, 4075519.0023337724],
              [-11723363.373831684, 4110594.8137062015],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wyoming',
        GEOID: '42131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8485676.72704295, 5088029.116701673],
              [-8484787.061672533, 5092511.917522542],
              [-8482322.336826878, 5108370.15486756],
              [-8473102.188682435, 5108966.3652563775],
              [-8471137.844947897, 5107835.057040912],
              [-8429099.263764214, 5107541.898052104],
              [-8434915.37319969, 5087246.015544257],
              [-8441879.631863208, 5075566.075052851],
              [-8459052.444429925, 5069942.476853126],
              [-8463124.956681104, 5069113.21827821],
              [-8491795.848132368, 5068037.4694295],
              [-8485676.72704295, 5088029.116701673],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hopkins',
        GEOID: '48223',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10671284.313497834, 3924452.669921416],
              [-10662924.665017223, 3929066.5501498138],
              [-10656732.407022357, 3935887.510537447],
              [-10655527.37353452, 3935113.5346524324],
              [-10650350.015337216, 3935473.9444724373],
              [-10640423.322384706, 3943098.580736991],
              [-10631214.751467304, 3941568.7751320885],
              [-10609704.040983358, 3945477.3168011517],
              [-10609744.561278006, 3890337.075491621],
              [-10649422.390020434, 3890053.4154577074],
              [-10650692.100132423, 3892595.1905043484],
              [-10671367.023879495, 3892592.669155513],
              [-10671284.313497834, 3924452.669921416],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Waller',
        GEOID: '48473',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10704372.028385302, 3530135.760983669],
              [-10697042.196514018, 3532528.498014122],
              [-10694387.67193656, 3533143.953037005],
              [-10664886.559722964, 3535154.79390633],
              [-10664777.91189995, 3515136.109211334],
              [-10682286.798009368, 3524600.08470138],
              [-10667326.015044207, 3476364.138870355],
              [-10683436.17175181, 3468705.493577173],
              [-10690312.4880176, 3468627.297013537],
              [-10692151.819963979, 3478276.370901921],
              [-10700185.858934019, 3482570.214291526],
              [-10701326.327117197, 3495519.0922499946],
              [-10696082.177225418, 3504210.1740483833],
              [-10702929.550423602, 3512579.6814336274],
              [-10708020.190737577, 3521354.881421788],
              [-10704372.028385302, 3530135.760983669],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rockland',
        GEOID: '36087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8263731.46973568, 5033432.716961803],
              [-8235569.995061636, 5060352.417491841],
              [-8235703.578450589, 5059907.730610554],
              [-8234390.008459228, 5048974.87137927],
              [-8225116.649598184, 5032761.594664386],
              [-8225795.587172533, 5013123.001536169],
              [-8225840.114968851, 5011928.230778184],
              [-8242212.429077272, 5021061.040854202],
              [-8261199.486985984, 5031976.216075507],
              [-8263731.46973568, 5033432.716961803],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sharkey',
        GEOID: '28125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10126038.66460511, 3873838.482692419],
              [-10120537.70064807, 3896325.6559784925],
              [-10120551.949542891, 3908241.5909196273],
              [-10114807.97513745, 3907934.5088447714],
              [-10096883.199410425, 3908092.367423148],
              [-10092007.850991644, 3908121.6007273346],
              [-10091850.11127319, 3885022.9730220824],
              [-10103329.488483282, 3873524.483854425],
              [-10096080.140603844, 3870859.011018538],
              [-10101423.810120393, 3859418.0171574824],
              [-10093079.746368492, 3851713.448200868],
              [-10099255.863037195, 3850542.500630523],
              [-10126162.34055938, 3850631.0945260776],
              [-10126038.66460511, 3873838.482692419],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '21155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9520186.45478388, 4516659.3163398495],
              [-9512305.368794186, 4535155.301500576],
              [-9506883.107717138, 4541446.3836871525],
              [-9501044.40042503, 4530896.095342643],
              [-9480645.103737162, 4527444.298230934],
              [-9465515.449104467, 4527466.788227144],
              [-9466573.206905985, 4515380.051567601],
              [-9467168.65486224, 4496725.402632405],
              [-9470368.978903053, 4496924.838833169],
              [-9476481.866100984, 4502465.43844811],
              [-9489625.803656911, 4497840.9205401465],
              [-9500054.992790861, 4504754.337780663],
              [-9514059.430010619, 4504204.96198393],
              [-9518150.53261676, 4515921.729712427],
              [-9520186.45478388, 4516659.3163398495],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cumberland',
        GEOID: '21057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9529129.194757266, 4421307.498104003],
              [-9524575.670986366, 4418338.515103658],
              [-9512454.202953378, 4430487.526435397],
              [-9487985.733599052, 4428667.5122643905],
              [-9492764.011421863, 4424885.042195038],
              [-9486135.492342578, 4418840.731021784],
              [-9489581.053221611, 4403524.349639122],
              [-9495086.412709732, 4387124.180313105],
              [-9510737.01886592, 4385994.363854711],
              [-9517474.934627136, 4396084.098260705],
              [-9514590.535301192, 4401985.49063925],
              [-9519756.650229925, 4401722.970521924],
              [-9528526.956312073, 4413774.028366921],
              [-9529129.194757266, 4421307.498104003],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '01071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9613443.690278998, 4114065.717889882],
              [-9609718.383519601, 4155366.8488595174],
              [-9602081.755131694, 4155428.227046123],
              [-9608127.071398713, 4162671.463617419],
              [-9558330.758667426, 4162118.8292124174],
              [-9529523.377074165, 4161799.1403622804],
              [-9528410.182166232, 4153581.054663014],
              [-9527035.08965327, 4144931.019941691],
              [-9549594.949181138, 4112979.9220077144],
              [-9575212.124360958, 4093659.187019197],
              [-9579900.67867419, 4092896.877872386],
              [-9583230.91256076, 4091622.741622527],
              [-9584356.686571153, 4097833.9638694418],
              [-9590003.14510266, 4109528.8274828624],
              [-9609861.31774578, 4109573.996630209],
              [-9613443.690278998, 4114065.717889882],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tangipahoa',
        GEOID: '22105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10081894.074576212, 3632742.003758311],
              [-10079709.877582988, 3632746.8189615784],
              [-10057408.871676434, 3632795.98307589],
              [-10057349.752047557, 3620473.1200887184],
              [-10054028.089761777, 3618592.673361415],
              [-10047212.77657694, 3595390.77237221],
              [-10045823.954609804, 3580394.39228636],
              [-10045950.079592872, 3568447.5384121914],
              [-10045877.054006912, 3550112.897554704],
              [-10036636.089117689, 3533707.384070041],
              [-10054428.060692199, 3542039.7621338554],
              [-10072836.074328754, 3539204.503421794],
              [-10071492.893352842, 3548005.641139114],
              [-10079547.749067662, 3558979.4861781285],
              [-10081861.190725328, 3571359.814700207],
              [-10081890.690390388, 3587380.8906221977],
              [-10081891.358307334, 3610017.7075119806],
              [-10081894.074576212, 3632742.003758311],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lyon',
        GEOID: '32019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13326350.682915928, 4757670.6639401885],
              [-13319082.076764582, 4759927.399446425],
              [-13300319.844508316, 4770119.411699911],
              [-13278593.730809685, 4811099.992237198],
              [-13275824.435837222, 4815097.043329922],
              [-13268096.859425336, 4815336.610709333],
              [-13268188.141407784, 4812632.8831941765],
              [-13253689.89092687, 4828287.145043569],
              [-13255700.98884754, 4825689.760001814],
              [-13260114.472699022, 4796251.664387498],
              [-13260176.588974884, 4777476.939893595],
              [-13245742.347201176, 4762692.326902691],
              [-13234827.582448384, 4754347.941380982],
              [-13219636.368137281, 4737730.6326048905],
              [-13219616.441948427, 4732367.324554227],
              [-13236240.004147569, 4732287.02491132],
              [-13239266.001865804, 4732100.330704609],
              [-13248671.051684454, 4713556.327194006],
              [-13248636.653961798, 4700393.900743975],
              [-13236123.897918673, 4700516.545282402],
              [-13236651.218346559, 4638172.528681215],
              [-13264521.73388804, 4638132.03379144],
              [-13278106.708037466, 4650289.603962685],
              [-13283610.624307182, 4655189.278112298],
              [-13285968.31311627, 4682954.695193228],
              [-13295948.105465883, 4704783.294974992],
              [-13291730.655237691, 4719283.016874329],
              [-13281574.755453639, 4724447.685036989],
              [-13281719.248152688, 4733655.790793756],
              [-13308358.670216465, 4733967.858052398],
              [-13309523.072090162, 4749559.529747525],
              [-13319263.193576103, 4749683.489189495],
              [-13326350.682915928, 4757670.6639401885],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adams',
        GEOID: '39001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9318093.893685602, 4669955.430002672],
              [-9314437.756896414, 4724598.417422258],
              [-9307599.845854945, 4724377.7643117495],
              [-9282446.650312752, 4729581.156062116],
              [-9274537.623130871, 4729150.818545165],
              [-9269664.946379868, 4723933.750312768],
              [-9269383.864665614, 4669381.699167408],
              [-9268939.355024971, 4666403.803677922],
              [-9271412.328426851, 4664427.78264772],
              [-9275199.083545165, 4667771.637283273],
              [-9281407.482866196, 4673295.839056641],
              [-9288543.284865027, 4674420.42862858],
              [-9298888.7617419, 4679090.055270232],
              [-9309306.373648806, 4675850.011002281],
              [-9311095.500504836, 4670701.543530888],
              [-9311531.583937451, 4670499.007323768],
              [-9315157.548723884, 4668815.106285805],
              [-9318093.893685602, 4669955.430002672],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Matanuska-Susitna',
        GEOID: '02170',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-17032104.39639397, 9022574.595551088],
              [-17031620.15660902, 9033718.912965354],
              [-16908738.689543482, 9033345.529189259],
              [-16908764.404345855, 9050904.648790594],
              [-16778175.621015757, 9115760.558873488],
              [-16645174.655639661, 9182426.804837232],
              [-16478136.42011963, 9182430.773438837],
              [-16478137.421995046, 9218331.637759916],
              [-16363961.361748528, 9218839.208722103],
              [-16307141.110660372, 9219653.990533642],
              [-16307672.104631454, 9141804.39075137],
              [-16302754.34348668, 9089926.51318479],
              [-16301281.03002603, 9065270.35126019],
              [-16299844.00671938, 8981207.037157396],
              [-16299843.338802436, 8918788.874299297],
              [-16361717.272133626, 8918785.527112175],
              [-16359621.237441482, 8898099.736955807],
              [-16357575.519159172, 8815944.312873723],
              [-16357570.843740556, 8734707.236829596],
              [-16386964.310006557, 8734704.439907733],
              [-16386963.419450631, 8724363.664417287],
              [-16526766.673631145, 8724364.12990747],
              [-16606648.53834898, 8724360.173241857],
              [-16613370.788439516, 8737819.480047481],
              [-16626616.805968499, 8737819.480047481],
              [-16669912.184203234, 8717641.839223545],
              [-16686526.952162605, 8687479.36222655],
              [-16696531.568758667, 8677454.098070463],
              [-16722552.017703949, 8670313.609174516],
              [-16720732.314737633, 8685664.335330756],
              [-16745234.402578177, 8682424.854228588],
              [-16757590.53209776, 8688020.554333992],
              [-16773609.963420365, 8687132.25164294],
              [-16790017.677126855, 8678454.546019934],
              [-16802480.56203811, 8674271.664278015],
              [-16806350.12954492, 8670613.13417093],
              [-16806350.361496557, 8684134.68349766],
              [-16846290.458959293, 8684133.757655699],
              [-16846288.455208458, 8724357.613047607],
              [-16904700.129736993, 8724352.725406548],
              [-17031868.955670945, 8724342.01915667],
              [-17031864.168932837, 8928863.776987571],
              [-17032104.39639397, 9022574.595551088],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Litchfield',
        GEOID: '09005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8183977.283955082, 5111185.7988163205],
              [-8182540.0613155, 5134617.938653174],
              [-8180570.374245403, 5168417.878245771],
              [-8152043.864173701, 5167714.366525014],
              [-8140485.914425204, 5167291.377328389],
              [-8132266.971430512, 5166990.598031271],
              [-8127298.296298032, 5166808.769692409],
              [-8129610.87170853, 5155978.496620982],
              [-8113750.404618778, 5156953.950190745],
              [-8115852.673202409, 5149257.091939646],
              [-8120648.2055462925, 5132027.704010942],
              [-8128208.134805045, 5130796.0128242485],
              [-8126161.414647319, 5118009.856122651],
              [-8124458.226438183, 5107144.9261924075],
              [-8132782.03004276, 5102251.82740016],
              [-8144654.476374844, 5094862.550081815],
              [-8143658.612210206, 5088644.87994098],
              [-8149053.933970484, 5087641.12581759],
              [-8154404.839253935, 5088177.330375285],
              [-8161821.389008547, 5087144.936514854],
              [-8160884.524174032, 5081739.646458474],
              [-8175466.598231513, 5085079.737875741],
              [-8182753.23814037, 5111048.922918821],
              [-8183977.283955082, 5111185.7988163205],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Medina',
        GEOID: '39103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9147288.647163553, 5021717.878723969],
              [-9147108.643546939, 5032584.519496985],
              [-9136465.498351686, 5032489.775263954],
              [-9136265.011948766, 5041864.333739496],
              [-9125292.249741273, 5041861.522703794],
              [-9125135.289259255, 5052963.784193078],
              [-9114623.167104665, 5052995.629848336],
              [-9110288.052174702, 5053072.356090397],
              [-9095375.804507528, 5053322.979641149],
              [-9093127.039474012, 5053306.9821991185],
              [-9093354.13123523, 5032415.87244881],
              [-9093521.22179091, 5010658.837095315],
              [-9125680.309486179, 5010861.026387424],
              [-9142595.64007069, 5011133.273315779],
              [-9147496.480652863, 5011168.521444007],
              [-9147288.647163553, 5021717.878723969],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Transylvania',
        GEOID: '37175',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9245850.590353444, 4171198.4264099994],
              [-9237649.349508232, 4181823.027685301],
              [-9230710.249049632, 4203638.967526768],
              [-9220814.948193528, 4207227.282107666],
              [-9211146.739098642, 4221510.266497298],
              [-9197132.617083186, 4205230.826107747],
              [-9192509.201196479, 4183804.41776385],
              [-9204567.868512249, 4180819.2190413196],
              [-9211290.563880747, 4174639.9373108973],
              [-9213030.326343868, 4175013.1268242705],
              [-9215392.909755459, 4175519.935271766],
              [-9228107.376715904, 4171496.7826466886],
              [-9240460.9249891, 4167539.8686320805],
              [-9245850.590353444, 4171198.4264099994],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Geneva',
        GEOID: '01061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9595013.858022245, 3657736.9000833365],
              [-9587436.228964457, 3656415.3495875956],
              [-9550255.185081031, 3658275.138126615],
              [-9541230.625281911, 3658122.0970630767],
              [-9516231.273275994, 3658735.444013938],
              [-9516513.834308181, 3632484.8137944103],
              [-9517594.00029466, 3632471.882507432],
              [-9526666.092542166, 3632363.2758171842],
              [-9545614.609468333, 3632136.436430729],
              [-9561635.376624828, 3631899.179713098],
              [-9577376.63222299, 3631937.4375127866],
              [-9594320.56568616, 3631978.6184520707],
              [-9594689.139067601, 3634519.384878183],
              [-9595013.858022245, 3657736.9000833365],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jerome',
        GEOID: '16053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12759138.69286344, 5287613.554478418],
              [-12756587.472773438, 5289304.924544042],
              [-12731094.307506362, 5289288.07007026],
              [-12728900.534301298, 5282953.084996906],
              [-12695971.11572974, 5282860.3726344835],
              [-12695983.58351271, 5276271.490965892],
              [-12682817.382058626, 5276274.523597148],
              [-12682829.849841595, 5241496.528740356],
              [-12690465.142395616, 5240156.611282833],
              [-12695481.866567705, 5240507.962437803],
              [-12704932.446058089, 5235404.686105209],
              [-12717662.163788773, 5245123.115584142],
              [-12742264.439171033, 5251235.1531066885],
              [-12759048.96935386, 5258742.86168502],
              [-12759138.69286344, 5287613.554478418],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'New London',
        GEOID: '09011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8066959.483053642, 5098851.893415581],
              [-8060685.18259406, 5101632.661334321],
              [-8051526.7054475155, 5102062.9023378715],
              [-8052209.205245569, 5107740.762547887],
              [-8041670.923010643, 5118262.325155181],
              [-8032541.277612213, 5109830.802021424],
              [-8031335.798846413, 5111252.628686649],
              [-8021910.822838911, 5109028.044307193],
              [-8009992.067598656, 5106430.120324836],
              [-7999186.729905317, 5107834.461180229],
              [-7991566.6425739415, 5107207.366723304],
              [-7991554.554297038, 5100788.462410334],
              [-7991554.85182535, 5100779.852639698],
              [-7991815.891365181, 5093228.951748007],
              [-7992481.511696874, 5074001.812889026],
              [-7997153.145447505, 5073320.4873489775],
              [-7996741.48597055, 5064688.00160854],
              [-7999475.715303415, 5059693.547067485],
              [-8002346.533651483, 5062089.412385404],
              [-8010188.4351804145, 5061119.995215475],
              [-8017441.011325087, 5059188.122376357],
              [-8025516.683784687, 5058791.804913326],
              [-8029944.750489461, 5056603.607081564],
              [-8037425.53159026, 5059019.011103793],
              [-8041222.528101727, 5056754.00574217],
              [-8047624.84597572, 5053736.256068464],
              [-8052853.400975534, 5053411.153015709],
              [-8056859.910931931, 5067998.601698211],
              [-8063283.713467646, 5075083.423293362],
              [-8049014.892457257, 5076907.709632038],
              [-8050951.85159706, 5089067.106382311],
              [-8062956.100206244, 5090025.807602446],
              [-8066959.483053642, 5098851.893415581],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Miami',
        GEOID: '20121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10582673.330909444, 4678062.79365098],
              [-10581631.38047562, 4684295.277588117],
              [-10565177.691819428, 4684251.606701321],
              [-10531880.21453701, 4684226.019284004],
              [-10532154.989554215, 4657079.680343431],
              [-10532256.02063048, 4647116.428604466],
              [-10532256.065612227, 4647111.994855057],
              [-10532245.67159926, 4634485.172584119],
              [-10582679.8987594, 4634659.367139789],
              [-10582673.330909444, 4678062.79365098],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Mateo',
        GEOID: '06081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13638651.169125482, 4519720.161337914],
              [-13636279.841332603, 4524777.609033693],
              [-13636279.61869362, 4535223.524824137],
              [-13636713.098915081, 4538276.386953516],
              [-13624373.206178686, 4538304.308014546],
              [-13624747.587364385, 4538191.741693669],
              [-13621077.272433437, 4522018.736238548],
              [-13608181.243383508, 4517192.494805227],
              [-13599729.533684012, 4509612.734860287],
              [-13595360.321841594, 4512023.619757462],
              [-13594028.973879978, 4509974.493628701],
              [-13590047.409652777, 4505922.19009094],
              [-13597111.744538518, 4503167.8604543535],
              [-13602173.330465399, 4499420.284011124],
              [-13602425.246473063, 4483526.465272022],
              [-13597929.386198394, 4479054.524160409],
              [-13597984.600665826, 4469179.599471274],
              [-13616342.075253563, 4465196.642433233],
              [-13613740.337478403, 4453772.291086324],
              [-13616930.84404037, 4455212.664893321],
              [-13619275.009877495, 4459211.407796225],
              [-13625178.950391205, 4465239.120865763],
              [-13627559.740340803, 4473804.25469071],
              [-13626127.965069205, 4483100.256237402],
              [-13625652.948783003, 4486186.180744918],
              [-13626536.268942447, 4491479.334553656],
              [-13630368.887690969, 4500046.796588839],
              [-13630624.922519796, 4503636.401668603],
              [-13635946.216818694, 4507956.77447247],
              [-13638495.433157861, 4512026.146349799],
              [-13638651.169125482, 4519720.161337914],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brantley',
        GEOID: '13025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9159875.430668058, 3661932.5526503194],
              [-9149686.357675748, 3659026.1860879823],
              [-9140980.171620296, 3667909.8847672325],
              [-9127911.152081678, 3670277.7412021],
              [-9132776.70438527, 3681379.6333931587],
              [-9119653.138296159, 3677749.5315767243],
              [-9106051.454994092, 3680077.960631572],
              [-9098330.557751652, 3675686.747573472],
              [-9103971.005030656, 3654605.6696022097],
              [-9102185.329078842, 3654793.924304665],
              [-9110461.821899831, 3645439.3087277813],
              [-9121157.175936267, 3640646.0112280883],
              [-9121074.465554606, 3638983.5177643406],
              [-9134974.262453018, 3642598.303590589],
              [-9137238.166937282, 3634129.7281950526],
              [-9142858.799346926, 3634140.638415284],
              [-9151381.86484002, 3643762.7819001325],
              [-9151434.185000693, 3654968.651180234],
              [-9159875.430668058, 3661932.5526503194],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Manatee',
        GEOID: '12081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9208331.803134954, 3189711.7903323364],
              [-9200636.06409743, 3188981.460993421],
              [-9193278.847631413, 3198136.094176572],
              [-9189745.367404867, 3204345.9374052486],
              [-9134248.348053558, 3204463.3607245283],
              [-9134404.64061863, 3165797.304610081],
              [-9134487.46231978, 3149453.8075248254],
              [-9155882.511852793, 3149594.122543087],
              [-9156427.643399207, 3149796.899639459],
              [-9156280.145073906, 3171811.1404392123],
              [-9200352.268064393, 3172247.059667638],
              [-9205211.406488525, 3178203.363210189],
              [-9210910.519139178, 3189982.064665865],
              [-9208331.803134954, 3189711.7903323364],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bryan',
        GEOID: '13029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9103803.469197012, 3783396.5898644826],
              [-9065395.127927592, 3795025.39879791],
              [-9062160.851442084, 3776698.104463038],
              [-9060482.376159903, 3775903.746220116],
              [-9049197.362780735, 3760530.875241513],
              [-9032288.600046182, 3744386.1068066293],
              [-9036585.30975182, 3739196.7313752687],
              [-9034103.330385093, 3725705.2568328585],
              [-9045809.24275895, 3731030.2399906088],
              [-9056490.347900564, 3739037.8251853357],
              [-9062267.829472736, 3756001.6176612484],
              [-9069806.274069766, 3759920.121940302],
              [-9082923.71758688, 3759535.103437181],
              [-9084078.434664879, 3764422.3663446773],
              [-9093989.208930206, 3774908.6715111537],
              [-9096879.39686967, 3775045.057436202],
              [-9101074.137921743, 3777046.7451195256],
              [-9103803.469197012, 3783396.5898644826],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pointe Coupee',
        GEOID: '22077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10219692.8654044, 3629599.700213994],
              [-10213576.527302254, 3635192.7405380383],
              [-10206579.763347425, 3635105.4516267627],
              [-10200977.721292743, 3632673.3000998115],
              [-10201865.494231818, 3623528.107145272],
              [-10203697.256452825, 3614204.601070337],
              [-10192012.606101707, 3613108.1166965687],
              [-10198491.511785366, 3622052.5521038733],
              [-10191222.349036567, 3621874.5267171585],
              [-10187468.433168035, 3616549.6074988493],
              [-10190127.521844616, 3605665.18413223],
              [-10196263.674816122, 3600348.101694992],
              [-10191635.4556669, 3597837.267929],
              [-10180209.95709035, 3598532.7283961177],
              [-10172444.08677363, 3601464.708206096],
              [-10166905.942106664, 3588500.7384034027],
              [-10164524.261601143, 3587383.7373464117],
              [-10176244.534189314, 3569471.3711747457],
              [-10184073.522657314, 3567613.7009293996],
              [-10195014.113531968, 3567596.5183092714],
              [-10208101.166828096, 3567651.8128398415],
              [-10214252.681889333, 3567691.216800969],
              [-10211496.2999778, 3569549.286145305],
              [-10214340.290328586, 3576067.428760299],
              [-10211745.766956668, 3594073.3881007843],
              [-10220827.767613038, 3613038.6171605047],
              [-10219692.8654044, 3629599.700213994],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kennebec',
        GEOID: '23011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7803550.962478456, 5525037.91062602],
              [-7806767.9844428925, 5541152.335026416],
              [-7797078.735964245, 5540843.070410582],
              [-7796321.318148888, 5544408.833384798],
              [-7800438.024237913, 5547865.904785853],
              [-7797087.084926053, 5554239.084001359],
              [-7796841.068851402, 5557004.908368954],
              [-7787187.442609809, 5554811.496956389],
              [-7786437.817158806, 5556008.320636272],
              [-7784622.196263967, 5560464.741557742],
              [-7772598.244104913, 5559953.891575665],
              [-7769300.404190164, 5555224.381753525],
              [-7763897.957982475, 5559175.553425117],
              [-7755130.76884607, 5556642.2728290595],
              [-7748476.2010059375, 5555214.067219003],
              [-7745487.49531712, 5562694.241467383],
              [-7751506.874142786, 5574221.900092154],
              [-7733407.549454198, 5577260.297357944],
              [-7733555.604376952, 5573303.595393197],
              [-7732391.091183763, 5566181.278514136],
              [-7724807.116915001, 5565082.459179572],
              [-7727447.281278144, 5551122.933303574],
              [-7722502.358177616, 5550108.403285053],
              [-7725125.935936632, 5536450.681241351],
              [-7730637.475245299, 5537505.1792495],
              [-7737415.051122757, 5518656.331283838],
              [-7739846.3801211715, 5508167.659299262],
              [-7741980.931357133, 5505919.909833286],
              [-7753421.569384431, 5508817.260681937],
              [-7755121.418008843, 5500727.9018114405],
              [-7754175.313656591, 5484878.13420596],
              [-7755216.818812452, 5484652.029475145],
              [-7765448.193211263, 5487029.820120816],
              [-7766044.643042933, 5489183.563195425],
              [-7776221.13693278, 5491456.068560083],
              [-7780985.611138733, 5482118.270251268],
              [-7792973.38446328, 5484732.049441457],
              [-7795294.173207339, 5486177.3365549445],
              [-7791673.284130306, 5493432.18692686],
              [-7799098.962083162, 5495167.92841126],
              [-7800630.940915458, 5510454.529495321],
              [-7803516.676075293, 5517356.863596112],
              [-7807124.763410883, 5523095.434821806],
              [-7803550.962478456, 5525037.91062602],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Douglas',
        GEOID: '41019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13825152.170457337, 5420070.250043705],
              [-13821451.055190599, 5444376.780698032],
              [-13797637.999834908, 5444216.43943209],
              [-13784359.031736648, 5456909.546671296],
              [-13770644.025192956, 5456829.459750598],
              [-13761205.468207575, 5453242.961363716],
              [-13756838.404583754, 5445082.329625776],
              [-13744658.827776572, 5436094.809492212],
              [-13731058.81426687, 5435964.615558094],
              [-13731063.934963442, 5431485.7687152745],
              [-13707583.648728888, 5431408.677949195],
              [-13707571.626223886, 5404656.404718102],
              [-13704284.918258214, 5394531.43849966],
              [-13663559.684426911, 5395244.6296344185],
              [-13663545.324212598, 5378786.579748097],
              [-13595675.834426776, 5379219.832646186],
              [-13582135.933442099, 5364586.287521074],
              [-13578105.722597418, 5351889.397252079],
              [-13585391.69458933, 5344617.341995285],
              [-13591416.973348003, 5323586.152197888],
              [-13612435.095085192, 5322285.05609519],
              [-13612451.23641136, 5311438.974227934],
              [-13625619.775574747, 5311459.217052599],
              [-13632209.778110221, 5302824.377870704],
              [-13643350.076151356, 5300515.91309615],
              [-13656361.320874255, 5293888.491698854],
              [-13669451.93639409, 5278275.5155185545],
              [-13686864.865102446, 5277752.592966953],
              [-13693384.402400244, 5274321.408534073],
              [-13709243.86761458, 5274880.981044146],
              [-13717858.437729111, 5266815.049116024],
              [-13722830.411465902, 5271272.61941972],
              [-13741885.302663459, 5266877.913135118],
              [-13757051.804047605, 5272468.432029086],
              [-13772058.339323485, 5272428.720726918],
              [-13772056.892170105, 5279161.274437759],
              [-13779494.369988983, 5281492.099282575],
              [-13782639.034284404, 5279885.7174720615],
              [-13783703.80521384, 5311407.316364417],
              [-13777077.623843862, 5311411.425792571],
              [-13777048.569456765, 5324638.225051314],
              [-13770459.6801162, 5325236.174707276],
              [-13770750.00134819, 5351285.302841719],
              [-13777385.088277431, 5351333.145933874],
              [-13777070.27675747, 5376471.794515679],
              [-13783313.741718099, 5377853.146423691],
              [-13783207.208965411, 5390913.960590335],
              [-13789771.830656983, 5390836.90054381],
              [-13789779.623021336, 5405040.903457892],
              [-13828002.247413456, 5405429.071104315],
              [-13825152.170457337, 5420070.250043705],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crawford',
        GEOID: '55023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10153524.599903954, 5376034.6518762605],
              [-10150496.335968828, 5376582.607770634],
              [-10093178.041478863, 5376579.082570635],
              [-10092980.449382704, 5338154.714605396],
              [-10112902.185455069, 5323794.637010031],
              [-10123404.177535996, 5321395.666605668],
              [-10136998.959029634, 5310838.254102586],
              [-10147782.846119171, 5310066.033284493],
              [-10149520.286673553, 5317866.217873141],
              [-10149547.327726454, 5324196.283905526],
              [-10149582.736907888, 5332491.747300617],
              [-10145009.7322261, 5338555.854897765],
              [-10139809.21957471, 5345807.137206773],
              [-10136520.173899733, 5350708.606577988],
              [-10142011.230422093, 5359834.3198150275],
              [-10147306.587279638, 5363075.439500697],
              [-10153157.651035223, 5369020.608423665],
              [-10152271.659207998, 5373520.020339673],
              [-10153524.599903954, 5376034.6518762605],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Howard',
        GEOID: '48227',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11319938.75620959, 3832453.3634003857],
              [-11262701.724947903, 3832306.8139583226],
              [-11263751.022468122, 3774763.483958151],
              [-11272680.960700067, 3774754.0238346267],
              [-11320636.840736354, 3774806.054606252],
              [-11319938.75620959, 3832453.3634003857],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kaufman',
        GEOID: '48257',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10744881.636362936, 3837643.965871302],
              [-10744474.986263068, 3868261.28250484],
              [-10744442.592291247, 3870590.6558265546],
              [-10719774.861048402, 3870666.0224861605],
              [-10719768.8497959, 3874314.134029567],
              [-10695220.564366676, 3873885.649486737],
              [-10695120.15418598, 3810330.7436648416],
              [-10708515.451152118, 3809969.2713574073],
              [-10737002.88808255, 3810479.131023542],
              [-10735040.99337681, 3814446.344698942],
              [-10745668.999121316, 3835102.127589903],
              [-10744881.636362936, 3837643.965871302],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rabun',
        GEOID: '13241',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9312589.408071283, 4147420.9577836017],
              [-9300652.257675314, 4162359.6471987865],
              [-9293270.935061064, 4162641.021004369],
              [-9275448.105246069, 4163320.4512806665],
              [-9251608.47930643, 4163970.678648857],
              [-9251607.7004588, 4163970.6998926047],
              [-9253363.43146759, 4157800.101275488],
              [-9255171.593956547, 4153682.0682286914],
              [-9261913.324957969, 4148216.9748144452],
              [-9267635.035465252, 4143987.8522318266],
              [-9271222.86265352, 4139859.3216207474],
              [-9275570.33404696, 4135340.438700121],
              [-9275146.874703983, 4131261.7129064146],
              [-9278840.01013054, 4127066.3620553394],
              [-9278435.977253567, 4125490.2039439324],
              [-9287548.199936826, 4129589.236516611],
              [-9299062.97674499, 4128605.838470614],
              [-9304850.811029807, 4139445.467711725],
              [-9312119.639820134, 4139852.541452815],
              [-9312589.408071283, 4147420.9577836017],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '05143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10525470.060913056, 4314696.589874889],
              [-10507571.970404236, 4314306.741537631],
              [-10501483.350855295, 4320212.171713901],
              [-10501164.420514174, 4330207.843597853],
              [-10461059.681524554, 4328707.468506056],
              [-10451539.30471344, 4333011.724058735],
              [-10457817.946633162, 4313164.256033296],
              [-10459901.290903358, 4267775.375371236],
              [-10477864.471854707, 4268283.7902834695],
              [-10487688.305597723, 4266676.588643657],
              [-10518917.104370968, 4267533.450943507],
              [-10519085.077420037, 4268786.878218542],
              [-10523262.007353583, 4298949.954698023],
              [-10525470.060913056, 4314696.589874889],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Essex',
        GEOID: '36031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8266139.885706339, 5460769.3885503905],
              [-8269019.943572144, 5484116.87514898],
              [-8248049.577896507, 5486763.177814166],
              [-8253385.566368192, 5528685.6874537775],
              [-8227588.721530231, 5532181.687829685],
              [-8200826.848026584, 5533998.872218618],
              [-8181604.532314872, 5540975.076120657],
              [-8177957.037879541, 5549030.1108735185],
              [-8165060.144147287, 5550354.856283803],
              [-8161151.468312953, 5544278.18269302],
              [-8159007.677559256, 5533874.763330895],
              [-8162051.263757035, 5524853.3327155225],
              [-8163574.44834956, 5520836.845712804],
              [-8162415.835089383, 5513544.976309337],
              [-8161661.865357972, 5506313.8268518355],
              [-8161568.582444955, 5505419.569722388],
              [-8165272.293223137, 5501159.783330279],
              [-8170338.44324914, 5491307.240602483],
              [-8170835.993434873, 5489070.09201064],
              [-8172667.246996535, 5480840.879957023],
              [-8174956.087046736, 5472033.592865061],
              [-8171515.980822751, 5467219.685579509],
              [-8172102.745858722, 5461666.384474398],
              [-8171712.459724002, 5454598.4382441435],
              [-8167961.994759684, 5446205.421620373],
              [-8169771.047804565, 5437223.2854228215],
              [-8168905.444090864, 5435802.1824700525],
              [-8175094.123215319, 5435112.384352309],
              [-8243988.086274914, 5425989.733185174],
              [-8242881.236577957, 5433979.694415411],
              [-8254237.383111741, 5439112.152822501],
              [-8261435.078747455, 5436221.148729791],
              [-8275137.6175081795, 5453877.553141083],
              [-8266139.885706339, 5460769.3885503905],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sangamon',
        GEOID: '17167',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10018142.582112204, 4851700.506210422],
              [-9993065.640421202, 4851771.75501677],
              [-9985565.823687477, 4853857.351080806],
              [-9985164.516923167, 4862354.8991229],
              [-9971809.5176127, 4862473.726407995],
              [-9961293.944553893, 4862561.758296742],
              [-9952517.29326077, 4854060.549929296],
              [-9931685.186392698, 4853886.8146563405],
              [-9931643.664222633, 4838901.561359128],
              [-9934845.43541683, 4840681.659382222],
              [-9941178.067289587, 4833417.31700792],
              [-9954805.020116063, 4829342.706871904],
              [-9954751.141482519, 4820083.74473568],
              [-9960748.145090533, 4820122.510856669],
              [-9960698.051319677, 4813886.860400397],
              [-9966993.72512149, 4813929.650178516],
              [-9966990.385536768, 4809750.993970721],
              [-9966840.883460632, 4797095.885983303],
              [-9985541.444718994, 4796919.3872815],
              [-10010520.647897078, 4796736.830569794],
              [-10018058.981174618, 4834795.736698329],
              [-10018131.338843632, 4847483.805304745],
              [-10018142.582112204, 4851700.506210422],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Catahoula',
        GEOID: '22025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10241998.06309414, 3753770.876398305],
              [-10230748.894591007, 3753805.634284426],
              [-10229113.16599329, 3759566.7285558283],
              [-10219671.269423185, 3749298.6998072215],
              [-10211243.159455737, 3747898.1004274925],
              [-10202153.03247654, 3759429.4682692727],
              [-10196522.715271197, 3759341.549022204],
              [-10194162.63074689, 3747904.6553209242],
              [-10194377.7000031, 3736543.4155999566],
              [-10190719.518896652, 3730765.4014987783],
              [-10197045.916877925, 3732092.008517398],
              [-10200853.043463055, 3727805.5737552303],
              [-10207381.597639607, 3728612.739748073],
              [-10208659.434074424, 3716521.6048252364],
              [-10212137.166286297, 3712759.6027550315],
              [-10216439.330646984, 3717275.19105655],
              [-10222126.643431615, 3709829.6423260737],
              [-10216872.25214668, 3701899.7914322107],
              [-10218990.550736984, 3694376.9618625464],
              [-10212231.008617036, 3693601.1673001894],
              [-10212264.293144785, 3688924.733161574],
              [-10219919.400568165, 3689866.974642271],
              [-10225483.705315467, 3697140.804129971],
              [-10225350.789843457, 3687914.859268814],
              [-10216544.304926801, 3682878.3450119696],
              [-10224140.746978536, 3681665.82698937],
              [-10226049.764926149, 3672072.9220284],
              [-10222945.286966907, 3667387.5042678593],
              [-10233250.577507604, 3671097.916075507],
              [-10240346.304489749, 3662031.617321902],
              [-10242297.1785659, 3675132.7601198535],
              [-10241998.06309414, 3753770.876398305],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Moultrie',
        GEOID: '17139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9886585.541851183, 4828301.7666568905],
              [-9879122.905827386, 4835783.315761439],
              [-9848789.569100616, 4835738.5488016065],
              [-9848666.115785327, 4815440.420204196],
              [-9848491.566823764, 4785910.163643239],
              [-9861156.162652332, 4785988.1526720505],
              [-9867523.080928251, 4796571.450047856],
              [-9875917.349770501, 4796607.671900861],
              [-9875980.02264382, 4804999.229133354],
              [-9886178.335153863, 4805130.229252783],
              [-9886347.986057833, 4815676.6703436775],
              [-9886585.541851183, 4828301.7666568905],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hickman',
        GEOID: '21105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9929978.102001384, 4399680.256956768],
              [-9924910.727460982, 4405146.24015426],
              [-9924798.841250498, 4409360.455733325],
              [-9919029.496123392, 4410888.471496346],
              [-9914922.586149557, 4407480.033760572],
              [-9886643.427986396, 4407528.952319859],
              [-9887328.9334107, 4404312.757113573],
              [-9887036.95990226, 4369910.7517137155],
              [-9888196.227608878, 4369913.090790831],
              [-9889021.214856096, 4369914.755384033],
              [-9896690.123349981, 4380290.060408798],
              [-9900852.693069212, 4382321.028225877],
              [-9910399.007321682, 4382405.60248115],
              [-9923809.555058056, 4390310.424066224],
              [-9926987.923816958, 4390615.991059107],
              [-9925856.720493745, 4392157.199526824],
              [-9929978.102001384, 4399680.256956768],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mercer',
        GEOID: '21167',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9465555.07884319, 4564115.080191156],
              [-9454707.77370182, 4572955.851260042],
              [-9439483.942779915, 4575201.111809004],
              [-9442837.665079044, 4567630.842982231],
              [-9436019.346267955, 4557952.246826016],
              [-9429864.93689996, 4559942.573655124],
              [-9427538.693500852, 4558411.269763061],
              [-9430644.952571945, 4553379.195681401],
              [-9427574.538376886, 4540970.0929312855],
              [-9433757.779493, 4538971.851266934],
              [-9439177.48022176, 4539559.2233609725],
              [-9464942.042407392, 4534157.463288921],
              [-9462214.603563465, 4558923.324181164],
              [-9465658.383330647, 4562712.916363875],
              [-9465555.07884319, 4564115.080191156],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Livingston',
        GEOID: '36051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8689699.527545158, 5241181.850080818],
              [-8678059.40499036, 5261471.174319762],
              [-8677906.897287972, 5291104.88337782],
              [-8677969.904119762, 5297653.890665308],
              [-8672882.82602949, 5310109.284029496],
              [-8652970.552113842, 5310202.114222488],
              [-8656098.07320768, 5302913.942507255],
              [-8636208.063190192, 5303446.329957044],
              [-8639691.584015585, 5275992.94795965],
              [-8638260.57196144, 5262174.11844691],
              [-8625799.46816204, 5261918.8541803425],
              [-8626246.304598084, 5247850.50952049],
              [-8645062.41548789, 5248322.336215122],
              [-8645218.040136019, 5241469.940027123],
              [-8651819.508579042, 5241469.788955103],
              [-8652080.775423933, 5231828.76623925],
              [-8665134.878150789, 5232335.863702795],
              [-8665186.419075025, 5238857.360072105],
              [-8687179.476912579, 5239423.891355445],
              [-8689699.527545158, 5241181.850080818],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Iredell',
        GEOID: '37097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9029069.017733457, 4269924.433620792],
              [-9021480.590685062, 4281080.0253565125],
              [-9017495.575553644, 4294883.244506317],
              [-9020088.429133201, 4306904.836408533],
              [-9014170.907641612, 4308716.557613716],
              [-9003697.524669819, 4308290.793805432],
              [-8982725.600521311, 4307676.963269527],
              [-8984354.093352124, 4280403.453832745],
              [-8991451.37880714, 4255604.766878324],
              [-8988338.329247108, 4240184.018882198],
              [-8987643.918263538, 4232832.111032761],
              [-8992852.334598774, 4232861.238098832],
              [-9006495.206112435, 4234060.300997984],
              [-9011017.115147948, 4230462.411225926],
              [-9010164.519167963, 4236076.903710773],
              [-9012428.757610697, 4238469.706492195],
              [-9009474.115686063, 4244533.600894573],
              [-9008812.543952279, 4248866.969890516],
              [-9011450.92720357, 4251391.873521078],
              [-9013127.844012879, 4255351.262383611],
              [-9014879.12224204, 4257020.252135214],
              [-9016260.374483803, 4259709.205787022],
              [-9017471.08526567, 4260819.493318056],
              [-9023705.75598653, 4260878.719133586],
              [-9029069.017733457, 4269924.433620792],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '39159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9297429.140578618, 4939466.045585506],
              [-9286091.361760814, 4939635.143330008],
              [-9269325.421932949, 4939880.230424468],
              [-9267158.142766694, 4939015.132501626],
              [-9267191.20465546, 4930672.875677002],
              [-9267172.614300497, 4901531.266700294],
              [-9258701.423690112, 4901500.7860322315],
              [-9258439.934206236, 4886757.1305956505],
              [-9262479.941166107, 4881610.117957647],
              [-9295590.921827149, 4882153.751562055],
              [-9294565.001399998, 4898760.827147841],
              [-9300892.401256688, 4899329.900278836],
              [-9297429.140578618, 4939466.045585506],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crockett',
        GEOID: '47033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9945235.106131548, 4281686.173551227],
              [-9945598.230310515, 4284250.417802397],
              [-9938625.066087734, 4285003.623074432],
              [-9928456.698520713, 4300588.34846464],
              [-9922569.455930619, 4296197.245011454],
              [-9919600.231152691, 4281661.586326054],
              [-9898103.992202545, 4272766.851140196],
              [-9909812.910202654, 4255438.960571121],
              [-9915176.283269076, 4258416.4572190875],
              [-9945139.037410991, 4271664.268035255],
              [-9947068.09286695, 4275557.156205003],
              [-9945235.106131548, 4281686.173551227],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Randolph',
        GEOID: '13243',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9457552.543289043, 3734185.706385974],
              [-9452175.589244748, 3734053.055502222],
              [-9451804.672701422, 3753399.563495902],
              [-9441019.149877446, 3754366.8896424845],
              [-9423842.775087023, 3752854.353643562],
              [-9417603.985545006, 3752836.385876871],
              [-9417972.453059532, 3733419.2845598995],
              [-9410441.466868386, 3720919.949276096],
              [-9411712.735453244, 3713689.176420998],
              [-9417311.660562182, 3715835.1405863133],
              [-9441879.092943823, 3713502.497792887],
              [-9455739.482742494, 3713358.4382328116],
              [-9454475.449924536, 3720372.537993902],
              [-9456566.697878577, 3721367.314449827],
              [-9457552.543289043, 3734185.706385974],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '30057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12544265.470274122, 5720434.271399489],
              [-12528956.81390023, 5729904.31284655],
              [-12523268.165281713, 5741934.61599931],
              [-12519192.090806827, 5739193.649261066],
              [-12488963.617040385, 5740137.840249332],
              [-12477301.787184883, 5756510.164528462],
              [-12459652.749836553, 5757254.1622618055],
              [-12446104.499890069, 5748086.317107846],
              [-12446117.969548453, 5746241.04667758],
              [-12441436.31704365, 5746253.817609809],
              [-12441430.63974962, 5743975.454062217],
              [-12436819.118524019, 5743945.928868724],
              [-12436800.862127528, 5739304.350035034],
              [-12429905.17627034, 5739314.8778460035],
              [-12416157.553115843, 5723204.822081984],
              [-12395578.920728307, 5723154.029667037],
              [-12395428.639415737, 5676877.954883666],
              [-12398446.314525379, 5582437.130458831],
              [-12399322.038606232, 5583053.428847869],
              [-12405309.69137702, 5577633.94110154],
              [-12407330.611293994, 5573732.9410387],
              [-12409336.117359012, 5575789.684921885],
              [-12443415.0209925, 5575800.962677918],
              [-12443421.47752297, 5587114.29214746],
              [-12475107.457382366, 5587498.223315803],
              [-12475094.210362962, 5594167.861203063],
              [-12486385.346314121, 5594286.048012539],
              [-12489065.808332933, 5621602.090473434],
              [-12504991.28600531, 5621603.192490083],
              [-12504952.435503025, 5635452.635924012],
              [-12518639.723493509, 5635466.1958168475],
              [-12518774.197438387, 5676776.8952147355],
              [-12524062.541168014, 5691535.910159997],
              [-12537759.402634708, 5691151.482749989],
              [-12544751.157212453, 5697965.418762538],
              [-12544265.470274122, 5720434.271399489],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Richland',
        GEOID: '38077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10829154.27575613, 5881782.699725329],
              [-10777542.107044738, 5881918.38206749],
              [-10774589.748622362, 5882820.0133585],
              [-10774144.43387352, 5881822.066721337],
              [-10769541.352602443, 5871513.242885373],
              [-10765607.210478319, 5850381.908845511],
              [-10758727.777266786, 5837986.239077118],
              [-10753578.58290065, 5831706.688331561],
              [-10752980.797235092, 5815650.604077171],
              [-10748398.553035568, 5793816.9815087775],
              [-10750423.509586522, 5783858.070218685],
              [-10750597.892215172, 5783000.964628777],
              [-10749418.796168689, 5769978.251525402],
              [-10807129.157905228, 5770073.8099337],
              [-10823403.844820224, 5770044.133198858],
              [-10826892.708981175, 5779898.126007958],
              [-10826860.203689862, 5824171.6488159625],
              [-10829223.293840423, 5825707.360896612],
              [-10829154.27575613, 5881782.699725329],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '23015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7769151.570030974, 5471774.355061536],
              [-7765448.193211263, 5487029.820120816],
              [-7755216.818812452, 5484652.029475145],
              [-7754175.313656591, 5484878.13420596],
              [-7755121.418008843, 5500727.9018114405],
              [-7753421.569384431, 5508817.260681937],
              [-7741980.931357133, 5505919.909833286],
              [-7739846.3801211715, 5508167.659299262],
              [-7737415.051122757, 5518656.331283838],
              [-7729467.952675024, 5516943.668841637],
              [-7731277.896275832, 5514155.910155448],
              [-7729228.059172363, 5500598.030638946],
              [-7718634.339831022, 5497900.047972781],
              [-7712466.794763112, 5473583.28772962],
              [-7721564.714106664, 5467434.525881379],
              [-7723400.786545227, 5456724.518115164],
              [-7724825.4846309805, 5458700.552922629],
              [-7728027.033186196, 5453541.241863304],
              [-7729810.148789722, 5451453.790560867],
              [-7737070.851257223, 5440355.97414063],
              [-7742560.683265184, 5440923.002533804],
              [-7745446.195786037, 5438140.514997909],
              [-7753493.593094973, 5435127.500164868],
              [-7758502.687012817, 5433935.272994569],
              [-7758086.412646122, 5443366.223169721],
              [-7763784.523421357, 5449041.634402464],
              [-7758985.428853769, 5466461.283794987],
              [-7771605.1629275475, 5469593.733426468],
              [-7769151.570030974, 5471774.355061536],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Missoula',
        GEOID: '30063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12779166.293771548, 5986079.0043304125],
              [-12753176.866214516, 5983732.543844066],
              [-12728950.850711137, 5970887.702227733],
              [-12719826.77128725, 5961858.216487301],
              [-12711257.619524963, 5964659.603412652],
              [-12683019.538253907, 5964675.641048602],
              [-12683026.774020808, 5971786.007362499],
              [-12670545.521393577, 5971784.205746111],
              [-12670514.240616664, 5986043.56896421],
              [-12676036.021318482, 5989236.285313844],
              [-12676073.981264843, 6006289.895650473],
              [-12684987.332892658, 6020117.466123781],
              [-12680245.233904356, 6026451.119455671],
              [-12682661.757410498, 6040317.414671771],
              [-12684727.179242676, 6040518.65398153],
              [-12649687.811042622, 6040569.666167549],
              [-12631031.332302615, 6040574.618823013],
              [-12631027.436120436, 5971370.990321627],
              [-12612825.9201393, 5971445.836050872],
              [-12612821.46735967, 5914721.050769171],
              [-12632517.113546232, 5909940.651614345],
              [-12632519.78521401, 5900503.994790811],
              [-12653482.358525293, 5895877.803608187],
              [-12653463.434211858, 5886488.876822569],
              [-12671246.38890761, 5886898.257180603],
              [-12723205.540471805, 5886826.241184088],
              [-12727794.679289076, 5885986.255138844],
              [-12730575.892637739, 5888222.38641054],
              [-12740876.28512084, 5885012.0873231925],
              [-12751349.445453653, 5884236.815609503],
              [-12756224.682912173, 5885544.7278938405],
              [-12759605.121529864, 5886451.735096975],
              [-12760185.318715878, 5895335.520956294],
              [-12765766.00553945, 5898412.647251304],
              [-12751550.488454023, 5900934.825103219],
              [-12753443.142436493, 5936102.881274847],
              [-12748904.53547736, 5943584.038582752],
              [-12737124.03904467, 5945869.23706071],
              [-12744266.520212948, 5953100.065980544],
              [-12753439.246254314, 5953079.146701622],
              [-12755736.99186378, 5962297.8114520535],
              [-12769712.931293894, 5971862.494511577],
              [-12769711.929418474, 5978974.152807723],
              [-12779166.293771548, 5986079.0043304125],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Francois',
        GEOID: '29187',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10090570.27108754, 4542031.220813036],
              [-10089996.4191125, 4590245.128817882],
              [-10088672.162450025, 4580519.696834013],
              [-10065065.52859342, 4585405.2289827755],
              [-10054695.895387044, 4576845.337246866],
              [-10069864.623161009, 4562335.925826806],
              [-10041041.22400736, 4532859.881832485],
              [-10031059.093948437, 4533100.652153343],
              [-10035093.423614277, 4528921.431582422],
              [-10078311.880080875, 4529205.8332555685],
              [-10090875.175172823, 4529088.86633075],
              [-10090570.27108754, 4542031.220813036],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kiowa',
        GEOID: '08061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11522086.713847855, 4652636.146220315],
              [-11485152.242636537, 4653903.31762234],
              [-11485159.47840344, 4666309.421053263],
              [-11472825.278823543, 4666675.703462123],
              [-11359654.274900747, 4666696.16069714],
              [-11359591.204108117, 4633874.567343607],
              [-11359558.516157886, 4617460.939832172],
              [-11437223.858514475, 4617208.812975483],
              [-11510428.446216058, 4616991.034819999],
              [-11521763.664685573, 4616931.628687705],
              [-11522344.863747004, 4627888.571612047],
              [-11522086.713847855, 4652636.146220315],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lake',
        GEOID: '08065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11862345.758087086, 4743995.562688793],
              [-11856484.675577328, 4745575.396394615],
              [-11855790.709871722, 4764529.41645737],
              [-11847342.339756949, 4773639.8428621935],
              [-11831459.831408018, 4771854.35307827],
              [-11822879.325057674, 4776197.98485087],
              [-11814953.04335472, 4776185.023301604],
              [-11820345.69344722, 4766081.250131792],
              [-11819218.583602935, 4741325.5966892205],
              [-11823262.375425491, 4736567.884490913],
              [-11821128.714745458, 4729706.734348578],
              [-11864204.904902825, 4729969.7943705525],
              [-11862345.758087086, 4743995.562688793],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Winkler',
        GEOID: '48495',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11502253.476770671, 3763359.19549223],
              [-11473079.087262554, 3763378.622886138],
              [-11473079.020593978, 3774742.855642835],
              [-11448585.68234229, 3774744.300937658],
              [-11443541.907533938, 3774577.830396137],
              [-11443525.543568792, 3717688.029140508],
              [-11502368.915082626, 3717640.5592397004],
              [-11502253.476770671, 3763359.19549223],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Richland',
        GEOID: '22083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10240748.390490495, 3816076.370891174],
              [-10231714.702493127, 3829902.8693482755],
              [-10223529.936932553, 3831563.5325021814],
              [-10219610.15502274, 3838540.5938192867],
              [-10212704.561730871, 3836901.406401493],
              [-10201049.522364305, 3851231.831550183],
              [-10196517.59457462, 3851214.7730007684],
              [-10196423.084326936, 3839977.3477884363],
              [-10179644.120118648, 3839946.1695928676],
              [-10181018.247913, 3834115.0438634646],
              [-10184085.7678013, 3829514.1387650296],
              [-10183144.004909188, 3816697.906818317],
              [-10200748.5144612, 3816624.7289680564],
              [-10215163.943240965, 3806709.0044533713],
              [-10216348.382623008, 3795294.4188902276],
              [-10229674.43886587, 3783220.4009262156],
              [-10239233.888818253, 3785203.8593976772],
              [-10240654.770798735, 3799699.3654116807],
              [-10245222.209505985, 3799735.3098836807],
              [-10240748.390490495, 3816076.370891174],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Otero',
        GEOID: '08089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11583710.512283234, 4600140.938739569],
              [-11558927.89932589, 4595449.349491697],
              [-11534833.463460632, 4595451.471772983],
              [-11534845.819924109, 4603675.048188479],
              [-11522609.692815604, 4603825.001714524],
              [-11521763.664685573, 4616931.628687705],
              [-11510428.446216058, 4616991.034819999],
              [-11510918.36329504, 4529196.695167392],
              [-11583705.391586656, 4529263.192514753],
              [-11584032.225611625, 4542015.878096203],
              [-11583710.512283234, 4600140.938739569],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chippewa',
        GEOID: '26033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9488636.6384053, 5902289.313876223],
              [-9481419.664754104, 5903578.104846556],
              [-9458221.796067694, 5905075.093249859],
              [-9465306.057142286, 5889206.48847886],
              [-9465203.977169229, 5869537.45723799],
              [-9458757.46545739, 5857006.326139607],
              [-9445432.856367907, 5854413.070027709],
              [-9426358.929537425, 5858849.950442752],
              [-9418513.354465296, 5853847.810958125],
              [-9405762.374711871, 5851192.645759888],
              [-9402247.573109565, 5855434.60369904],
              [-9397621.914308632, 5861014.002217804],
              [-9383455.618549261, 5859676.020791269],
              [-9372403.04026687, 5867297.993730916],
              [-9363964.577586776, 5863689.605427569],
              [-9364755.057290899, 5856012.733449481],
              [-9366300.17182311, 5840199.86133633],
              [-9361720.487971874, 5821551.166915807],
              [-9362869.639075333, 5819092.415008526],
              [-9363632.40022625, 5808295.147548323],
              [-9353791.20064267, 5801471.06101019],
              [-9347944.255708246, 5793427.630492957],
              [-9337735.256527083, 5787092.730327261],
              [-9330335.070737619, 5797758.158307937],
              [-9319644.503439287, 5796554.316784139],
              [-9306154.91886445, 5794797.175473472],
              [-9293022.224577093, 5779734.519875238],
              [-9298110.415862273, 5767320.155284167],
              [-9304422.787587706, 5766885.403663746],
              [-9312728.11215681, 5771613.930807815],
              [-9328689.10074675, 5770352.3277462935],
              [-9340911.75819687, 5774840.390737066],
              [-9359750.689582286, 5775674.657549549],
              [-9363595.17081614, 5775208.005375245],
              [-9377479.543005515, 5777932.007671953],
              [-9377429.67187364, 5791807.658285245],
              [-9391256.22054711, 5791826.431897319],
              [-9391302.195496807, 5805702.512151825],
              [-9474681.607295876, 5805747.350408159],
              [-9474772.444000363, 5819814.161716477],
              [-9488632.833799034, 5819767.159466076],
              [-9488636.6384053, 5902289.313876223],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Park',
        GEOID: '08093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11823262.375425491, 4736567.884490913],
              [-11819218.583602935, 4741325.5966892205],
              [-11820345.69344722, 4766081.250131792],
              [-11814953.04335472, 4776185.023301604],
              [-11802311.268021764, 4773617.093941941],
              [-11796168.65851979, 4784611.973155649],
              [-11779564.79987052, 4799075.828509349],
              [-11780904.084664254, 4802909.669563755],
              [-11775001.925262395, 4802917.611635118],
              [-11754000.835407298, 4803390.826056184],
              [-11732957.33282621, 4803081.652917775],
              [-11732868.83383103, 4779314.138257134],
              [-11732837.775693098, 4740247.532868901],
              [-11725331.391109418, 4740264.8969366625],
              [-11725185.562576478, 4678391.129563581],
              [-11796498.609490503, 4677869.961845774],
              [-11789467.336493528, 4694058.134737445],
              [-11791530.75457487, 4703378.671304145],
              [-11802998.33191894, 4713488.485298832],
              [-11812221.9309676, 4713094.896754439],
              [-11821128.714745458, 4729706.734348578],
              [-11823262.375425491, 4736567.884490913],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coos',
        GEOID: '41011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13852174.197610967, 5322832.567187278],
              [-13849412.583683368, 5336334.841276788],
              [-13847655.628160179, 5346115.265327083],
              [-13846192.110814719, 5353184.847275169],
              [-13848189.627757512, 5358071.390160424],
              [-13842949.59668689, 5364275.557146121],
              [-13835553.974996548, 5378618.097974526],
              [-13829613.744328838, 5397160.873448459],
              [-13828002.247413456, 5405429.071104315],
              [-13789779.623021336, 5405040.903457892],
              [-13789771.830656983, 5390836.90054381],
              [-13783207.208965411, 5390913.960590335],
              [-13783313.741718099, 5377853.146423691],
              [-13777070.27675747, 5376471.794515679],
              [-13777385.088277431, 5351333.145933874],
              [-13770750.00134819, 5351285.302841719],
              [-13770459.6801162, 5325236.174707276],
              [-13777048.569456765, 5324638.225051314],
              [-13777077.623843862, 5311411.425792571],
              [-13783703.80521384, 5311407.316364417],
              [-13782639.034284404, 5279885.7174720615],
              [-13795347.712631324, 5277713.314287379],
              [-13803203.974374572, 5264246.466534428],
              [-13818413.222443182, 5261376.554146889],
              [-13821424.19203016, 5272472.524424726],
              [-13819365.7833259, 5289257.094359598],
              [-13828065.178892413, 5301898.217240783],
              [-13832380.478953015, 5305116.68108839],
              [-13857037.103508735, 5305021.838541753],
              [-13852174.197610967, 5322832.567187278],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tuolumne',
        GEOID: '06109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13415663.089615805, 4572843.473934368],
              [-13417814.227455895, 4577934.570161094],
              [-13409857.332892971, 4581110.83499558],
              [-13407600.998134086, 4587727.272688383],
              [-13377950.829122314, 4632397.017090069],
              [-13360559.830353646, 4640850.111624635],
              [-13345509.212559413, 4629865.7239783835],
              [-13325542.503412768, 4638374.985466144],
              [-13318175.37951207, 4625706.466200627],
              [-13319545.05452679, 4619972.698792527],
              [-13314276.636986015, 4612671.301779067],
              [-13317448.017959228, 4607555.991951769],
              [-13311194.645563914, 4601722.028149909],
              [-13299279.0072694, 4597563.7822249485],
              [-13285527.265293747, 4591173.554695507],
              [-13280926.208100276, 4582801.359868894],
              [-13281349.110845802, 4571916.548621007],
              [-13269314.805974104, 4563309.528675335],
              [-13269425.791506423, 4551820.820522046],
              [-13276962.009713639, 4542652.971746509],
              [-13281416.570457222, 4548109.981025912],
              [-13294529.672514198, 4560615.454343342],
              [-13299817.682285352, 4559050.2138126595],
              [-13306653.144298019, 4565890.306944879],
              [-13318954.393308641, 4557809.581663725],
              [-13321292.102615299, 4551383.362039963],
              [-13337122.402123049, 4544876.629650457],
              [-13347987.629702436, 4545285.09097072],
              [-13367189.68526682, 4555270.271963372],
              [-13372501.628728494, 4548614.204515605],
              [-13396792.766133986, 4540620.0668797055],
              [-13392437.391056696, 4532267.964860388],
              [-13401968.454538926, 4534819.255392671],
              [-13401487.77697768, 4527808.923265699],
              [-13431061.024221312, 4555700.1420184],
              [-13415663.089615805, 4572843.473934368],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Caldwell',
        GEOID: '22021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10276149.101757662, 3782506.8622104283],
              [-10276108.24750454, 3799784.4210038097],
              [-10253205.820746697, 3797297.650757592],
              [-10245222.209505985, 3799735.3098836807],
              [-10240654.770798735, 3799699.3654116807],
              [-10239233.888818253, 3785203.8593976772],
              [-10229674.43886587, 3783220.4009262156],
              [-10226721.466733597, 3775334.6527266754],
              [-10233960.239261411, 3772093.134391118],
              [-10229113.16599329, 3759566.7285558283],
              [-10230748.894591007, 3753805.634284426],
              [-10241998.06309414, 3753770.876398305],
              [-10276194.186151434, 3753782.1563050854],
              [-10276149.101757662, 3782506.8622104283],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kenai Peninsula',
        GEOID: '02122',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-16916458.250952035, 8255322.057337764],
              [-16907929.28552593, 8271950.14853053],
              [-16891944.02928699, 8282297.29188823],
              [-16866721.704341017, 8294410.417747608],
              [-16845733.972824816, 8305288.85133929],
              [-16832114.701043203, 8317880.721005268],
              [-16842293.31000338, 8332554.381936904],
              [-16859188.714399036, 8321820.178647409],
              [-16880828.33285332, 8321554.721812105],
              [-16892378.175301086, 8330210.221542037],
              [-16906031.844805352, 8348522.039556479],
              [-16899814.76256404, 8365153.618603598],
              [-16893589.108721934, 8381423.459557643],
              [-16889171.617368788, 8401847.250942446],
              [-16876800.79367642, 8421936.814864324],
              [-16856186.76169081, 8447297.975008486],
              [-16851762.591168217, 8466149.587126816],
              [-16850083.3366496, 8483176.881896412],
              [-16843316.89272122, 8486465.704034857],
              [-16840614.055484764, 8511012.175199084],
              [-16842986.830431018, 8525785.457309721],
              [-16848222.074763536, 8542413.971734693],
              [-16854914.491230536, 8559769.562673114],
              [-16850488.65091558, 8564902.328364799],
              [-16838333.007798918, 8573156.58743486],
              [-16816207.034489356, 8577176.248626264],
              [-16797611.11355234, 8592185.594349673],
              [-16776494.251426816, 8611553.287284695],
              [-16753797.431768468, 8627650.474523956],
              [-16742658.35824173, 8634146.205900488],
              [-16735962.490870511, 8631382.227758477],
              [-16719533.849099753, 8603204.501352618],
              [-16710088.16766696, 8600690.88031382],
              [-16696295.460118694, 8598100.122309105],
              [-16686806.698042966, 8612069.158453548],
              [-16681636.798251543, 8618340.447757034],
              [-16669922.733194293, 8626107.394782161],
              [-16626612.241869371, 8604346.822253112],
              [-16606857.818991672, 8604343.846034521],
              [-16590397.896443997, 8591126.986204712],
              [-16590805.43709979, 8564769.120918477],
              [-16558286.453490788, 8564773.67497914],
              [-16548434.789875073, 8564766.616186323],
              [-16549253.099451896, 8492759.612405246],
              [-16538037.10415702, 8492757.132182801],
              [-16537960.405027863, 8427914.162423898],
              [-16540537.89651769, 8386077.191283579],
              [-16547589.940149464, 8382737.478952189],
              [-16552038.981028488, 8387436.454086607],
              [-16564487.728364408, 8389235.484744484],
              [-16570969.973632792, 8382925.137679209],
              [-16579524.876500256, 8389376.660437176],
              [-16590663.61606852, 8386866.582192867],
              [-16600325.591271924, 8392741.221751167],
              [-16611213.194068959, 8386113.414296854],
              [-16616729.742754709, 8371309.9293587115],
              [-16628526.269194074, 8363288.452837584],
              [-16639172.1973766, 8378327.339148978],
              [-16650358.359047942, 8366931.038808593],
              [-16652898.33586937, 8354839.519040277],
              [-16643016.170713179, 8348912.950972878],
              [-16645357.776202017, 8334757.604536792],
              [-16656324.749795988, 8340843.103824131],
              [-16668086.210595753, 8334743.701322504],
              [-16669672.958617518, 8319488.449774298],
              [-16680409.946143512, 8333533.780539952],
              [-16688956.166090693, 8331445.847908811],
              [-16698183.77264102, 8317942.15223611],
              [-16712812.266926164, 8301715.415165756],
              [-16729186.362146437, 8281978.908225543],
              [-16730997.530261641, 8272762.892030013],
              [-16737886.425629893, 8267280.024251819],
              [-16740819.582892803, 8254668.187843135],
              [-16745807.030038817, 8254972.519259025],
              [-16751102.832174323, 8272186.040663839],
              [-16753460.912947802, 8279670.871675306],
              [-16762620.503289253, 8277247.49553019],
              [-16765771.512795648, 8264356.815780635],
              [-16773717.943326434, 8246693.002158361],
              [-16778273.91612613, 8243787.707298671],
              [-16789513.733792037, 8252223.510619349],
              [-16799537.942618478, 8246649.823218239],
              [-16796755.40062661, 8238521.395779006],
              [-16802810.179050345, 8230948.053507034],
              [-16809376.247895297, 8228992.615539365],
              [-16823296.86153849, 8225898.301441667],
              [-16841277.63096938, 8227963.209463502],
              [-16847269.959158782, 8228575.353861654],
              [-16861632.62249991, 8233012.407783907],
              [-16857487.86389921, 8209735.137981104],
              [-16882977.57826207, 8199807.3918868],
              [-16904769.036501795, 8211626.908041997],
              [-16911176.586391855, 8229726.469951639],
              [-16918792.731993463, 8240869.168075924],
              [-16916458.250952035, 8255322.057337764],
            ],
          ],
          [
            [
              [-16927698.06861794, 8493200.203409217],
              [-16915270.026707307, 8514307.403142162],
              [-16902661.758541077, 8508713.288897814],
              [-16908489.111245126, 8498397.296080517],
              [-16915693.82000876, 8482092.943204984],
              [-16929467.603243593, 8476095.221892878],
              [-16927698.06861794, 8493200.203409217],
            ],
          ],
          [
            [
              [-17098385.579685155, 8264468.956510957],
              [-17086317.87896622, 8270680.442630646],
              [-17077800.602086645, 8270653.094819986],
              [-17070595.893323015, 8262536.351124521],
              [-17074951.37971979, 8252220.673515823],
              [-17089243.466503758, 8250066.534063736],
              [-17092739.900390085, 8252351.181401487],
              [-17098385.579685155, 8264468.956510957],
            ],
          ],
          [
            [
              [-17226564.407359075, 8236691.363260487],
              [-17189066.65952434, 8236692.669954399],
              [-17189068.329316698, 8274543.405141581],
              [-17156929.613088246, 8274544.499626669],
              [-17156930.28100519, 8293539.551926014],
              [-17137989.71492468, 8293543.28273541],
              [-17137991.607356023, 8331684.527154385],
              [-17119052.822387364, 8331686.291909504],
              [-17119053.045026343, 8350830.220142511],
              [-17105016.436473746, 8350832.431813184],
              [-17105016.770432223, 8427905.893190311],
              [-17090702.419750094, 8427906.787161062],
              [-17090707.874405142, 8505793.712292721],
              [-17076106.653395247, 8505795.74517678],
              [-17080961.29638874, 8584512.789371269],
              [-17080961.073749755, 8604325.301930653],
              [-17085937.054988217, 8664083.829134524],
              [-17085936.053112797, 8724337.597014587],
              [-17031868.955670945, 8724342.01915667],
              [-16904700.129736993, 8724352.725406548],
              [-16846288.455208458, 8724357.613047607],
              [-16846290.458959293, 8684133.757655699],
              [-16806350.361496557, 8684134.68349766],
              [-16806350.12954492, 8670613.13417093],
              [-16814557.056996815, 8662859.873988885],
              [-16822789.801257923, 8645038.331954502],
              [-16827789.604867414, 8636486.040766519],
              [-16837338.36814868, 8635006.226911865],
              [-16848094.057349127, 8628120.629082019],
              [-16862709.86121232, 8628326.89111236],
              [-16876048.83051611, 8617926.200310033],
              [-16889483.868540462, 8603872.24518975],
              [-16898328.090764496, 8592301.246074237],
              [-16895772.86317283, 8582431.502105072],
              [-16887589.990043595, 8564629.995732263],
              [-16888990.055279303, 8559631.2152058],
              [-16909199.106957406, 8562210.870330695],
              [-16924946.473444514, 8548286.07667301],
              [-16935719.86244399, 8529670.618281588],
              [-16949672.31346155, 8520557.823590819],
              [-16957449.9836443, 8505926.076809324],
              [-16954175.520822614, 8492566.833979841],
              [-16946633.514001876, 8487959.697284792],
              [-16962501.439497516, 8477090.076906424],
              [-16966346.192070533, 8464108.397133328],
              [-16980657.648445893, 8453734.886459999],
              [-16984564.405975286, 8445846.061079806],
              [-16984986.529484376, 8437655.068324765],
              [-16981808.02406375, 8425098.913860315],
              [-16984588.339665804, 8410490.293587197],
              [-16996193.28526151, 8392628.896666283],
              [-16998577.748754304, 8382016.897915892],
              [-17016393.876658313, 8371967.763557437],
              [-17028238.270478718, 8373400.962954497],
              [-17032893.317625225, 8362128.556685064],
              [-17033702.499003798, 8344536.278569696],
              [-17037621.612996668, 8331385.407253188],
              [-17049138.727514137, 8323180.21619558],
              [-17058600.772912078, 8318352.367411714],
              [-17066261.66894898, 8316872.793281469],
              [-17077458.73993042, 8319211.625092848],
              [-17092269.13026352, 8317870.152242828],
              [-17093459.914856534, 8310565.907887638],
              [-17096205.610096954, 8301540.75418543],
              [-17108127.593602438, 8300854.014010033],
              [-17116649.657220118, 8298777.485126654],
              [-17109697.198422626, 8281271.194541996],
              [-17115060.12621108, 8273837.495946757],
              [-17127861.64501333, 8272626.553226469],
              [-17134886.79543831, 8268498.185937464],
              [-17143035.270844884, 8264009.037289504],
              [-17146631.001716997, 8251411.0521712],
              [-17156858.368614137, 8242814.442697152],
              [-17158919.003708214, 8227350.027993955],
              [-17162453.620179884, 8217763.66391522],
              [-17163316.012275055, 8207070.505983477],
              [-17150269.145315107, 8195995.471499882],
              [-17135723.5840506, 8193946.140014527],
              [-17120266.650114972, 8195838.660252805],
              [-17109323.053614065, 8196397.044661437],
              [-17098282.943114646, 8180428.3846183065],
              [-17085308.656462688, 8179368.079400782],
              [-17075641.89452118, 8169824.569943452],
              [-17067820.80973703, 8160496.119480502],
              [-17061649.70244541, 8151742.778923663],
              [-17064658.58311168, 8149120.352054005],
              [-17103060.107742548, 8149118.845424827],
              [-17103018.251614008, 8124283.873885452],
              [-17122838.57563026, 8124283.015817185],
              [-17122838.57563026, 8105710.517305595],
              [-17177230.948624216, 8105708.591449838],
              [-17214729.364375893, 8105707.735514111],
              [-17220572.63576712, 8124279.798062062],
              [-17220580.31681199, 8199032.500612028],
              [-17226561.401732817, 8199032.500612028],
              [-17226564.407359075, 8236691.363260487],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bibb',
        GEOID: '13021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9335678.96289315, 3877356.6377997175],
              [-9321243.27396606, 3888803.0314935585],
              [-9318630.828156123, 3889039.5660530115],
              [-9316997.993865168, 3884275.0374319553],
              [-9312832.863797646, 3880425.5143688624],
              [-9302421.04050426, 3879010.8658835497],
              [-9296681.51887845, 3874730.841608443],
              [-9294000.834220657, 3871974.0884063137],
              [-9306048.49743125, 3850834.73077386],
              [-9313671.433521794, 3852180.9339891016],
              [-9317569.619450392, 3854515.4659101446],
              [-9329710.011796815, 3859466.449535953],
              [-9338806.038709024, 3875192.350890771],
              [-9335678.96289315, 3877356.6377997175],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shannon',
        GEOID: '29203',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10203055.4995884, 4445928.49712607],
              [-10202055.739241587, 4498194.984555004],
              [-10153658.14346583, 4497150.207701385],
              [-10149599.657470489, 4497084.054148849],
              [-10147809.417419551, 4474701.401826857],
              [-10144103.034973588, 4466948.320983138],
              [-10133897.04141868, 4462737.376796621],
              [-10132051.364261327, 4452451.331165607],
              [-10154246.689613653, 4451128.357471059],
              [-10154878.984321361, 4422930.2915296545],
              [-10203334.243593346, 4423607.676864596],
              [-10203055.4995884, 4445928.49712607],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '21073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9462034.043349398, 4618344.283065494],
              [-9457365.41522502, 4626471.484395992],
              [-9461897.009056231, 4626941.932857962],
              [-9451721.18308333, 4632513.736539496],
              [-9447738.83961969, 4629946.072908206],
              [-9439159.446464252, 4627379.476340689],
              [-9433279.773599533, 4629330.553668148],
              [-9432210.549890464, 4610032.356070587],
              [-9431562.559134556, 4607069.855734845],
              [-9447106.767550964, 4599416.371355131],
              [-9447118.344778009, 4595956.728608738],
              [-9451277.018315064, 4592633.749043802],
              [-9464796.213874452, 4597672.607342948],
              [-9462034.043349398, 4618344.283065494],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Charles',
        GEOID: '22089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10078658.751614187, 3505720.3089491804],
              [-10070828.093353825, 3507626.3913120436],
              [-10055115.235908862, 3522869.7556860154],
              [-10047684.882537395, 3524572.016471029],
              [-10049428.813680163, 3514979.276516109],
              [-10049867.412473887, 3504423.56440225],
              [-10049871.642614538, 3499433.47821331],
              [-10045490.107456913, 3485838.553583583],
              [-10038034.929838996, 3481398.8718692875],
              [-10037599.225352032, 3478814.289618416],
              [-10044152.492455542, 3464024.0234283735],
              [-10057950.209380897, 3464470.4878375027],
              [-10060162.572940921, 3472639.6508751563],
              [-10070856.479823977, 3478313.1893272293],
              [-10072176.840304276, 3483946.6270764265],
              [-10077709.08503823, 3488775.828985669],
              [-10077998.738353275, 3499429.2377396394],
              [-10078658.751614187, 3505720.3089491804],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Benton',
        GEOID: '29015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10409790.933442257, 4652076.597523915],
              [-10385201.348481948, 4651200.985786349],
              [-10385045.835153311, 4655336.722156901],
              [-10360203.443629412, 4654569.264392977],
              [-10361361.277653152, 4616658.846932903],
              [-10359288.620054074, 4605690.186551319],
              [-10359970.563254673, 4588255.763803802],
              [-10408811.65588175, 4589760.796533616],
              [-10408069.600156121, 4607588.430177959],
              [-10410986.616092868, 4608739.982479146],
              [-10409790.933442257, 4652076.597523915],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pottawatomie',
        GEOID: '40125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10813810.66506213, 4215213.582025812],
              [-10813741.201699875, 4227113.899139917],
              [-10756230.7697688, 4226940.186003255],
              [-10756100.971242538, 4218471.88892966],
              [-10773097.342416344, 4219939.957754807],
              [-10773019.530092278, 4150294.1330598933],
              [-10777224.178579032, 4156361.7060289313],
              [-10785233.393302629, 4153863.4604789936],
              [-10790263.47581361, 4159039.4079203345],
              [-10799763.926435873, 4151297.2248712755],
              [-10813836.825142467, 4154124.828009497],
              [-10813810.66506213, 4215213.582025812],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carson',
        GEOID: '48065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11312598.348986682, 4248485.99078215],
              [-11312601.799890898, 4249014.736383079],
              [-11252849.616054226, 4249180.445387025],
              [-11252834.810561951, 4248336.17732279],
              [-11252873.327105764, 4188660.873368407],
              [-11312614.045034884, 4188793.941434583],
              [-11312598.348986682, 4248485.99078215],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Petersburg',
        GEOID: '51730',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8621406.0218189, 4470245.088260348],
              [-8617965.470316954, 4471663.017938595],
              [-8617845.133947406, 4471745.230714623],
              [-8617637.96837504, 4471766.622919634],
              [-8617588.987799091, 4471809.687097988],
              [-8617228.090009939, 4471735.023991582],
              [-8617150.834283328, 4471811.784383892],
              [-8617021.70367401, 4471850.933797401],
              [-8616842.701932812, 4472003.757721037],
              [-8616688.969716027, 4472067.376750467],
              [-8616537.241250077, 4472241.596981235],
              [-8616432.712248221, 4472063.042254954],
              [-8614331.445540007, 4472459.725888496],
              [-8613544.305420607, 4473290.7544903485],
              [-8608310.28560249, 4466670.91173987],
              [-8616039.865765212, 4462947.905063904],
              [-8618741.255848292, 4462143.952757395],
              [-8621406.0218189, 4470245.088260348],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gasconade',
        GEOID: '29073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10201844.56616755, 4620263.154791495],
              [-10201359.547146166, 4679330.6964885285],
              [-10192210.532156337, 4675457.590237116],
              [-10176676.119855117, 4680184.6120923655],
              [-10171171.927632846, 4678693.373395705],
              [-10170981.571303587, 4609097.699583568],
              [-10189642.391503736, 4609272.666726127],
              [-10189561.016955968, 4601004.569445097],
              [-10200266.612385556, 4601135.656243518],
              [-10201857.701867465, 4602723.835678747],
              [-10201844.56616755, 4620263.154791495],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pittsylvania',
        GEOID: '51143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8865556.827084305, 4419073.3443258535],
              [-8860371.23124468, 4444991.393292573],
              [-8847664.334009608, 4439948.021809805],
              [-8843538.61104183, 4446896.790069627],
              [-8832246.695854234, 4458243.243373741],
              [-8818407.679397793, 4455689.267897945],
              [-8815894.196615174, 4446889.676099257],
              [-8804510.554167163, 4447682.285503324],
              [-8818558.127235673, 4375381.35884603],
              [-8832435.262095891, 4375339.593153268],
              [-8827921.043080987, 4380368.65793234],
              [-8834872.833961535, 4384578.835564973],
              [-8838555.39403647, 4389605.600323527],
              [-8841237.859806115, 4383569.467594791],
              [-8849993.916993441, 4386030.168304052],
              [-8852014.031792866, 4383963.413454369],
              [-8845053.891950509, 4380304.89270151],
              [-8846566.242253846, 4375297.063635492],
              [-8851084.736683724, 4375283.46451614],
              [-8851418.768906225, 4375284.878476378],
              [-8873816.600948079, 4375379.689048399],
              [-8865556.827084305, 4419073.3443258535],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Maries',
        GEOID: '29125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10263175.594342142, 4620791.754682898],
              [-10226155.741081385, 4620986.4939244315],
              [-10201844.56616755, 4620263.154791495],
              [-10201857.701867465, 4602723.835678747],
              [-10200266.612385556, 4601135.656243518],
              [-10200475.559069775, 4586625.982813771],
              [-10229743.23431118, 4586661.04132697],
              [-10243749.230003808, 4580928.855791197],
              [-10262028.446989516, 4581734.081482966],
              [-10261583.391665326, 4602228.441313546],
              [-10263175.594342142, 4620791.754682898],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montour',
        GEOID: '42093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8542088.99219735, 5025940.773042756],
              [-8541841.974247279, 5037750.738307455],
              [-8535842.298971485, 5035108.663503877],
              [-8531611.156445924, 5035337.236317937],
              [-8529184.836824596, 5021750.655344647],
              [-8517587.349634768, 5006224.412748361],
              [-8519061.776290325, 4995028.066965756],
              [-8521706.504752593, 4995159.256581066],
              [-8522287.703814026, 5003291.896989398],
              [-8533902.22288594, 5007622.226605162],
              [-8548695.247378478, 5004851.118370057],
              [-8542088.99219735, 5025940.773042756],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bradley',
        GEOID: '05011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10283540.493307354, 3937154.4063178],
              [-10276022.30885765, 3961831.1155977556],
              [-10278221.981995724, 3989634.6670820443],
              [-10238704.119361566, 3989180.768770332],
              [-10238730.390761394, 3965823.9599489956],
              [-10241408.069792936, 3958380.1292947903],
              [-10240298.548428198, 3948280.282431195],
              [-10238864.41942831, 3935461.8240787643],
              [-10255693.700046435, 3923048.2531061354],
              [-10256702.588591496, 3916953.6756767277],
              [-10266146.377592942, 3923112.515947298],
              [-10266335.39808831, 3928771.697934788],
              [-10281030.016150983, 3932682.8583872006],
              [-10280403.064778836, 3935050.936895056],
              [-10283540.493307354, 3937154.4063178],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dunklin',
        GEOID: '29069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10056529.661358884, 4307105.848448015],
              [-10051536.870877312, 4316174.130766374],
              [-10044979.373633156, 4319829.78942706],
              [-10043291.770152727, 4326074.486494913],
              [-10039807.802069766, 4328036.279728072],
              [-10036111.996955035, 4330117.746225287],
              [-10031547.229915565, 4337228.645020226],
              [-10025876.392415576, 4342399.450117468],
              [-10025825.853366755, 4349843.563800817],
              [-10026116.397237726, 4353902.804542268],
              [-10033341.254829189, 4357885.559926357],
              [-10034494.636073299, 4364085.231492107],
              [-10035883.012762472, 4368995.759086912],
              [-10043327.84366958, 4369077.956135149],
              [-10042126.143764632, 4375463.032865902],
              [-10035273.761189362, 4387749.278182778],
              [-10014166.249901066, 4387565.480849032],
              [-10015190.83449433, 4356254.217915212],
              [-10014447.22029583, 4354252.79414803],
              [-10014231.84993973, 4300485.715970212],
              [-10030313.809957577, 4300365.854716438],
              [-10050919.706188567, 4300141.715000816],
              [-10059799.671400936, 4300045.125003324],
              [-10056529.661358884, 4307105.848448015],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bonneville',
        GEOID: '16019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12525653.63064992, 5407841.877304548],
              [-12426154.266028058, 5407862.331101797],
              [-12419467.415535599, 5407136.633451037],
              [-12400965.11429034, 5407127.253116894],
              [-12383607.511368906, 5407108.338701582],
              [-12379569.06288191, 5395122.228370369],
              [-12361512.992602644, 5388550.635043125],
              [-12361430.21977409, 5360151.786692224],
              [-12361377.454335455, 5322992.87987721],
              [-12361367.40275517, 5314926.261910123],
              [-12422085.093361603, 5315024.46401864],
              [-12421924.79329486, 5354969.787916062],
              [-12448023.09131389, 5355037.834659963],
              [-12448020.976243563, 5367853.105907741],
              [-12472661.100252692, 5367956.159970162],
              [-12472644.513648564, 5374609.624770825],
              [-12479282.049606603, 5376895.283011091],
              [-12525671.775726922, 5376912.603075049],
              [-12525653.63064992, 5407841.877304548],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Joseph',
        GEOID: '18141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9631832.083014052, 5125032.281019604],
              [-9629333.323075341, 5125029.422323989],
              [-9598644.915576762, 5125098.511152685],
              [-9598642.205505162, 5125098.517253894],
              [-9580440.69275347, 5125044.350541037],
              [-9580094.263268678, 5083275.745516059],
              [-9625474.43292699, 5082875.316938404],
              [-9625418.21658414, 5076415.636485661],
              [-9631886.769555157, 5076403.461186171],
              [-9627625.68208657, 5096864.6777350325],
              [-9632106.18027151, 5108760.02638553],
              [-9631832.083014052, 5125032.281019604],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sierra',
        GEOID: '06091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13476137.514308741, 4798892.943821809],
              [-13470713.36080035, 4813686.936262564],
              [-13464029.51593414, 4818471.323093363],
              [-13455549.865042454, 4833468.736346014],
              [-13446557.810534645, 4823859.51910174],
              [-13434120.751745258, 4819091.065062137],
              [-13431167.111696038, 4823401.541037971],
              [-13374719.446943568, 4823550.435866617],
              [-13360090.396060968, 4823704.252778598],
              [-13358331.709306521, 4825684.828265722],
              [-13358532.591106808, 4799154.064335972],
              [-13358676.0729867, 4785622.543059261],
              [-13414604.775216833, 4785776.963819549],
              [-13422413.726176491, 4796763.817004689],
              [-13431204.292405963, 4797431.86266633],
              [-13442466.262650538, 4786720.644821448],
              [-13468846.087661784, 4781204.697229725],
              [-13472116.87694027, 4777915.1058369335],
              [-13476137.514308741, 4798892.943821809],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tyrrell',
        GEOID: '37177',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8505432.819713015, 4271255.459536023],
              [-8499638.751536716, 4281553.348252033],
              [-8502583.708665652, 4288885.889143322],
              [-8500177.426552664, 4303376.305315466],
              [-8481065.20581735, 4307190.247079885],
              [-8477864.547818061, 4308813.91281373],
              [-8466761.987084303, 4311716.518604805],
              [-8462797.900017153, 4313938.757944343],
              [-8462774.634243578, 4312551.389038022],
              [-8449850.107404009, 4312444.357834132],
              [-8446344.767958418, 4306372.998559765],
              [-8442475.302458445, 4304589.611645589],
              [-8457292.594599973, 4297407.960625803],
              [-8461210.595397932, 4286293.343688296],
              [-8463340.248576298, 4255150.655423509],
              [-8476383.99859051, 4259761.023093302],
              [-8484091.982772019, 4245479.432302347],
              [-8492100.752217649, 4246331.832009612],
              [-8490253.739226406, 4258152.607805496],
              [-8505473.785285626, 4259088.10264591],
              [-8505432.819713015, 4271255.459536023],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '05139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10350315.823818171, 3945489.3143534074],
              [-10314890.510943538, 3942601.3284728355],
              [-10304528.670101518, 3944145.6656640186],
              [-10289382.094906222, 3931169.069786838],
              [-10280403.064778836, 3935050.936895056],
              [-10281030.016150983, 3932682.8583872006],
              [-10266335.39808831, 3928771.697934788],
              [-10266146.377592942, 3923112.515947298],
              [-10256702.588591496, 3916953.6756767277],
              [-10257378.18658112, 3908351.2175881406],
              [-10249090.516446276, 3896429.918269442],
              [-10266197.91851718, 3896509.2435543374],
              [-10297206.853233572, 3896918.1112627345],
              [-10321938.704503113, 3897205.9202132127],
              [-10322071.193975389, 3897207.7479387913],
              [-10349499.629311675, 3897586.1362435706],
              [-10351455.580749398, 3897593.9610906886],
              [-10350315.823818171, 3945489.3143534074],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Churchill',
        GEOID: '32001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13272085.882058421, 4865852.90978168],
              [-13191468.640784405, 4865749.88129672],
              [-13084687.645630771, 4866092.53870294],
              [-13075769.952542813, 4849508.440080968],
              [-13079521.86466051, 4829442.3185284985],
              [-13075764.052609801, 4811256.508046455],
              [-13078396.647247573, 4800131.341915014],
              [-13090085.639058828, 4796075.469156955],
              [-13097450.202611241, 4788938.197471877],
              [-13096294.038379863, 4782964.178951851],
              [-13108960.415320283, 4774698.732462175],
              [-13104518.990276614, 4752282.247975468],
              [-13114124.3038592, 4742584.200883844],
              [-13110705.125699485, 4735062.751034515],
              [-13120684.695410121, 4732227.374160524],
              [-13219616.441948427, 4732367.324554227],
              [-13219636.368137281, 4737730.6326048905],
              [-13234827.582448384, 4754347.941380982],
              [-13245742.347201176, 4762692.326902691],
              [-13260176.588974884, 4777476.939893595],
              [-13260114.472699022, 4796251.664387498],
              [-13255700.98884754, 4825689.760001814],
              [-13253689.89092687, 4828287.145043569],
              [-13268188.141407784, 4812632.8831941765],
              [-13268096.859425336, 4815336.610709333],
              [-13266015.07362801, 4819614.657666814],
              [-13270234.304968057, 4838365.507207915],
              [-13272085.882058421, 4865852.90978168],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Waynesboro',
        GEOID: '51820',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8788704.633627899, 4589246.509969522],
              [-8783530.281056846, 4593534.09756484],
              [-8779150.30437209, 4592959.223410569],
              [-8779875.21689614, 4585085.221924328],
              [-8785589.802956013, 4583890.653997471],
              [-8788704.633627899, 4589246.509969522],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Green',
        GEOID: '55045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10000739.004241074, 5290291.3436282305],
              [-9949542.613827793, 5290136.297672241],
              [-9948525.821598886, 5288414.4120700685],
              [-9948155.195339337, 5236177.704600818],
              [-9952120.195602246, 5236240.510122178],
              [-9962339.234572442, 5236402.3814121885],
              [-10000675.316838162, 5236915.213787509],
              [-10000766.054877335, 5283672.964682176],
              [-10000739.004241074, 5290291.3436282305],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bonner',
        GEOID: '16017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13028968.39478561, 6114421.94385698],
              [-13028956.433121046, 6127659.622077071],
              [-13028308.776323613, 6177472.743532081],
              [-13028128.661387509, 6216844.096792038],
              [-13028047.195793422, 6248884.08319229],
              [-13000466.101883851, 6249008.260077945],
              [-13000433.151314575, 6190523.105022161],
              [-12918533.010867551, 6190786.950896241],
              [-12918532.841589678, 6187293.906860646],
              [-12918509.798455082, 6158558.00897195],
              [-12918507.710967056, 6142886.438044546],
              [-12918505.679633925, 6127663.958059976],
              [-12918532.618950699, 6106842.024838255],
              [-12917354.060563218, 6104298.903249953],
              [-12939010.952477029, 6118323.337953355],
              [-12944479.299823266, 6116740.24182693],
              [-12949751.947504686, 6109803.65078961],
              [-12949744.934376767, 6088639.467825316],
              [-12969288.85209738, 6088597.7989236675],
              [-12969202.579492014, 6105421.891836799],
              [-12983650.17960462, 6103041.446203747],
              [-13028978.635399304, 6103105.122394984],
              [-13028968.39478561, 6114421.94385698],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Payette',
        GEOID: '16075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13021711.426701749, 5449292.198522886],
              [-13019913.282966964, 5462800.167862904],
              [-13017405.366158882, 5469989.312948892],
              [-13021859.147666031, 5478661.9761722125],
              [-13013009.657482535, 5489098.13534861],
              [-12963384.911583666, 5488911.738256283],
              [-12963438.67889772, 5475570.737154273],
              [-12972295.92550218, 5475665.240798963],
              [-12976760.616319425, 5462422.688620615],
              [-12992376.180529432, 5462552.793443447],
              [-12992395.216162357, 5435648.239624796],
              [-13008033.60086798, 5433419.416015102],
              [-13019317.612371732, 5440172.939767532],
              [-13019306.703061633, 5446914.431469175],
              [-13022771.303858278, 5447073.638456554],
              [-13021711.426701749, 5449292.198522886],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cherokee',
        GEOID: '01019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9556088.215079108, 4061692.6351170084],
              [-9548336.371018229, 4063645.3047292545],
              [-9532011.033734921, 4082089.1138047953],
              [-9524415.704878096, 4096443.640459196],
              [-9519268.539785383, 4099374.09357169],
              [-9518091.53328664, 4092698.6454316997],
              [-9515049.870812593, 4075044.367577907],
              [-9513713.318207871, 4067295.5255441284],
              [-9509968.327404473, 4045611.6221644757],
              [-9509030.36888143, 4039658.3595014215],
              [-9506558.834040457, 4023986.3094166615],
              [-9517292.036703764, 4023017.5583987557],
              [-9521166.511580821, 4020939.27556083],
              [-9522515.703809237, 4022993.6694841185],
              [-9544419.038137212, 4024567.7605573162],
              [-9550886.255274339, 4042261.5633936194],
              [-9555817.040799536, 4043675.362533873],
              [-9556067.732292801, 4055689.6665659687],
              [-9556088.215079108, 4061692.6351170084],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Whiteside',
        GEOID: '17195',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10045734.481279334, 5128494.591740493],
              [-10038863.258169988, 5132856.287723105],
              [-10038947.63834401, 5137736.650264697],
              [-10037129.123142414, 5143585.669944259],
              [-10036359.686574573, 5150476.086119436],
              [-10033025.775392283, 5150346.473143483],
              [-9983729.27472837, 5150550.418642075],
              [-9977491.375742277, 5146253.521420832],
              [-9977732.271120355, 5099008.161887306],
              [-10003431.154806416, 5098867.668974551],
              [-10039416.07076127, 5098964.10880378],
              [-10036702.546853691, 5107789.771734337],
              [-10044329.713084884, 5112475.550283988],
              [-10045734.481279334, 5128494.591740493],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Des Moines',
        GEOID: '19057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10171495.08811462, 4984743.9380792845],
              [-10171340.91061987, 5023279.32039818],
              [-10124759.872657463, 5023075.506583804],
              [-10124718.542647002, 5022653.345683433],
              [-10123987.157709282, 5015185.727963814],
              [-10124756.264071172, 5005565.967828125],
              [-10128455.299430741, 4999391.1058923835],
              [-10135044.411410287, 4992943.5522424625],
              [-10140425.595595233, 4985986.569656425],
              [-10140281.99345211, 4979902.743652152],
              [-10142957.223454854, 4971888.133236815],
              [-10143234.17949039, 4968123.601594652],
              [-10153248.710378692, 4970186.131930119],
              [-10175653.761651672, 4984784.238751283],
              [-10171495.08811462, 4984743.9380792845],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Leelanau',
        GEOID: '26089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9580819.509751197, 5593467.404538503],
              [-9580028.696088599, 5607523.009167808],
              [-9571274.197374145, 5606756.604724734],
              [-9565861.955051268, 5616609.133231293],
              [-9557257.40369091, 5611789.247576731],
              [-9549034.789503464, 5618048.000037654],
              [-9545250.483413948, 5629590.052495751],
              [-9537975.977329588, 5636125.925030811],
              [-9532635.758717252, 5648466.280847681],
              [-9523501.771858683, 5654759.741032564],
              [-9521318.685324738, 5649468.693627735],
              [-9525178.02075105, 5628393.226580689],
              [-9523954.920411399, 5625778.526429367],
              [-9530955.836281693, 5586099.650468286],
              [-9552895.349444175, 5586096.043753199],
              [-9566472.431138776, 5586693.680363057],
              [-9582214.586541254, 5586691.445254253],
              [-9580819.509751197, 5593467.404538503],
            ],
          ],
          [
            [
              [-9588848.873302624, 5628299.48508025],
              [-9578422.133197471, 5646679.490295702],
              [-9572297.557453008, 5645335.644651723],
              [-9568357.849354342, 5640319.425985486],
              [-9570902.835552858, 5631391.420717164],
              [-9582547.299567798, 5619962.438825733],
              [-9590711.137064103, 5621898.380369674],
              [-9588848.873302624, 5628299.48508025],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Buncombe',
        GEOID: '37021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9226594.544836026, 4256436.851032969],
              [-9217833.478271611, 4257510.212508185],
              [-9185323.0662634, 4273600.381345291],
              [-9173683.611625547, 4275631.700418245],
              [-9168491.002658002, 4276052.754378313],
              [-9165496.285716683, 4266193.21238679],
              [-9159894.577620475, 4262919.601059694],
              [-9158855.521493409, 4260028.338496708],
              [-9160595.111176036, 4244532.642646803],
              [-9147016.693647545, 4235841.906109828],
              [-9154158.284259897, 4234691.748865235],
              [-9157786.409103831, 4227638.882115828],
              [-9165219.76810155, 4232064.989355803],
              [-9183324.547445187, 4224545.930490439],
              [-9187499.58494739, 4220642.580385857],
              [-9203154.444937648, 4226495.59674833],
              [-9211146.739098642, 4221510.266497298],
              [-9217050.568292864, 4227910.472579324],
              [-9213975.47867919, 4242426.069022505],
              [-9222384.553013712, 4247679.843242544],
              [-9226594.544836026, 4256436.851032969],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Craighead',
        GEOID: '05031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10133691.434319187, 4284818.683131148],
              [-10115912.153166628, 4284241.624761596],
              [-10113605.501997901, 4296231.768206354],
              [-10061876.893099139, 4295766.3332512155],
              [-10059799.671400936, 4300045.125003324],
              [-10050919.706188567, 4300141.715000816],
              [-10050673.47690672, 4259408.176771606],
              [-10134188.809804048, 4260573.956381831],
              [-10133691.434319187, 4284818.683131148],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grafton',
        GEOID: '33009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8051685.558360877, 5405038.751081385],
              [-8046707.684691073, 5422268.740417074],
              [-8039723.945116667, 5428350.390621081],
              [-8038547.645677385, 5430383.341170915],
              [-8035411.8733212985, 5435804.960816077],
              [-8033903.16026258, 5445875.2588084545],
              [-8026789.288203434, 5457610.414307941],
              [-8027994.989608216, 5464197.13070759],
              [-8023902.68742353, 5470085.931414988],
              [-8023875.085627236, 5470125.663080384],
              [-8023406.400197717, 5470800.342994128],
              [-8019109.133894625, 5481413.978314226],
              [-8020995.318390674, 5490207.648276499],
              [-8021831.452041974, 5494108.529643339],
              [-8021013.476423626, 5503734.406874363],
              [-8020157.652178407, 5510738.970532595],
              [-8015260.930417392, 5515855.134173422],
              [-8008898.910199066, 5517858.480710375],
              [-8001184.469487092, 5517800.271167015],
              [-7996946.272243402, 5519418.221115346],
              [-7994836.475524605, 5520223.752013585],
              [-7990358.649007446, 5527521.898382242],
              [-7988642.049172265, 5528109.1909404695],
              [-7981260.729663893, 5516982.88652333],
              [-7969028.832696038, 5512726.105930396],
              [-7967783.724191515, 5504926.406353944],
              [-7953036.006731732, 5504083.44303915],
              [-7949981.399904364, 5498334.746832791],
              [-7946166.703593861, 5480600.924071899],
              [-7943977.605807411, 5452442.59741482],
              [-7966535.164782777, 5448925.1599401245],
              [-7966091.890570439, 5446125.427859276],
              [-7964219.942013259, 5433933.427361304],
              [-7962867.744158593, 5428527.333276977],
              [-7961733.175908429, 5418824.081004988],
              [-7968405.3322281055, 5417893.682902283],
              [-7975857.39290028, 5416748.635183631],
              [-7976169.866710936, 5406995.468117103],
              [-7984676.902197358, 5398125.750066875],
              [-7994734.395551548, 5395176.133871943],
              [-7999930.566742797, 5403450.741237723],
              [-8002993.299892992, 5399847.60040551],
              [-8007802.079256281, 5392822.399066797],
              [-8022741.822837681, 5396552.903826858],
              [-8025121.49959237, 5392818.867685627],
              [-8026849.06676999, 5396600.980819418],
              [-8052139.129777097, 5404608.030895275],
              [-8051685.558360877, 5405038.751081385],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wrangell',
        GEOID: '02275',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-14809931.408747798, 7606149.751052431],
              [-14801810.049388926, 7603192.831782844],
              [-14792978.294947859, 7592920.031924204],
              [-14786998.100582955, 7579127.870674219],
              [-14793963.249802398, 7578297.543316788],
              [-14789883.385029094, 7568927.716453427],
              [-14793622.055563118, 7571890.673200867],
              [-14806352.441210743, 7585312.040882572],
              [-14807330.828215327, 7588375.317049858],
              [-14809931.408747798, 7606149.751052431],
            ],
          ],
          [
            [
              [-14813240.112064598, 7627669.962628166],
              [-14812211.631289156, 7630091.89929584],
              [-14802950.072294138, 7646444.679807181],
              [-14793953.119728737, 7650131.619030697],
              [-14782323.572525563, 7648357.114466152],
              [-14764030.663242485, 7651117.252134065],
              [-14753020.386366595, 7664507.801023094],
              [-14744354.497966807, 7671541.080037242],
              [-14753064.91416291, 7686480.061714041],
              [-14754606.466471419, 7699433.137674075],
              [-14754933.441128528, 7701809.203790447],
              [-14743108.721545342, 7713336.32599016],
              [-14732964.065029863, 7713514.684554484],
              [-14718189.519572796, 7737996.074853425],
              [-14712004.608664325, 7740380.6808710415],
              [-14707410.667387074, 7737919.322984167],
              [-14708191.693465672, 7734551.037889629],
              [-14679893.277030604, 7720359.24808856],
              [-14683236.75793658, 7709832.771514316],
              [-14675819.874223495, 7679171.736858677],
              [-14647554.519677196, 7681482.791678558],
              [-14634261.302684117, 7668270.100266452],
              [-14601546.619410297, 7648194.369747273],
              [-14592515.235312507, 7639887.258933749],
              [-14593565.568517873, 7625429.122571086],
              [-14584320.150849018, 7621222.162500829],
              [-14582678.52231829, 7613269.077389874],
              [-14595133.392226204, 7597146.707470312],
              [-14609623.961662259, 7592855.242742591],
              [-14611056.977467239, 7599704.325098648],
              [-14631829.083129773, 7584554.951988737],
              [-14623955.344226474, 7572345.366149793],
              [-14623408.87684617, 7561988.429395308],
              [-14638384.910581574, 7562218.268309824],
              [-14641520.112720273, 7569005.794504549],
              [-14655589.783161635, 7579117.291420041],
              [-14656794.148732528, 7571865.147376477],
              [-14675177.7834006, 7569664.461955185],
              [-14683664.336100716, 7554248.422150146],
              [-14679917.544679595, 7548245.4356315825],
              [-14695401.417931994, 7529562.196952448],
              [-14687007.705687203, 7518393.169341102],
              [-14691785.092954086, 7509473.654946935],
              [-14690025.465763116, 7499074.0176273305],
              [-14700721.153758027, 7501083.902588861],
              [-14704322.67324366, 7491165.608827179],
              [-14716401.216376025, 7485865.028957299],
              [-14719126.941004768, 7499273.342914742],
              [-14723680.353456177, 7511216.172414826],
              [-14708690.293464934, 7520965.742235271],
              [-14701677.054225467, 7533587.305880724],
              [-14713119.139406145, 7542353.605897972],
              [-14725338.01199358, 7543467.753446297],
              [-14730155.91955511, 7528985.086552957],
              [-14738400.46368224, 7534339.196773532],
              [-14744248.076533614, 7549698.467532045],
              [-14749030.473177584, 7571652.568412413],
              [-14760322.722323652, 7562768.1967416555],
              [-14773064.573878832, 7580768.829454324],
              [-14774138.250367533, 7601876.998439603],
              [-14788094.820206247, 7606128.2415125985],
              [-14791864.766081452, 7606406.479770166],
              [-14797339.124680195, 7611589.685693023],
              [-14801159.943562692, 7617601.468750838],
              [-14808799.800215835, 7621521.02037687],
              [-14813290.873752397, 7624582.726722723],
              [-14813240.112064598, 7627669.962628166],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dallas',
        GEOID: '05039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10348417.826500146, 4025332.7387389215],
              [-10340814.371320494, 4026557.6965315966],
              [-10340053.947878886, 4049751.7524084942],
              [-10316910.403103981, 4048910.342696705],
              [-10296348.468640065, 4048185.609989173],
              [-10286575.841862816, 4044326.124126616],
              [-10278881.661298165, 4036812.0944721964],
              [-10293898.883245159, 4036465.5595881753],
              [-10292169.312316705, 4025126.421799265],
              [-10278951.12466042, 4005747.3653742075],
              [-10278601.581459329, 4001317.3451968073],
              [-10306298.427366149, 4002272.8735637693],
              [-10340860.902867645, 4003310.4749269816],
              [-10340817.042988274, 4015751.3243224476],
              [-10348417.826500146, 4025332.7387389215],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Desha',
        GEOID: '05041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10191151.104562458, 4025687.1239697677],
              [-10177018.761247778, 4030745.4277259205],
              [-10168771.434133379, 4022753.3068377078],
              [-10156727.778424453, 4025279.1792009915],
              [-10146923.536911817, 4020414.229131492],
              [-10151700.59022023, 4038331.2483279766],
              [-10143198.786749875, 4044806.1518939743],
              [-10127102.878937094, 4044749.945914688],
              [-10123928.328064518, 4044477.015419528],
              [-10124098.365880584, 4043497.7541128607],
              [-10119067.504133163, 4041520.5855635963],
              [-10116107.630192462, 4038479.479146071],
              [-10118097.911368353, 4032409.238360069],
              [-10123690.825224789, 4031225.957715348],
              [-10127841.149800036, 4028816.2593534766],
              [-10130628.144571537, 4025715.582655011],
              [-10135457.851999093, 4026798.542057391],
              [-10139947.255743295, 4023611.307930942],
              [-10134076.822396312, 4021252.5974113117],
              [-10133010.492994003, 4016452.6708716005],
              [-10136891.647040509, 4012365.7761171605],
              [-10135953.446372105, 4005218.1917080833],
              [-10132875.907729633, 4002775.920985319],
              [-10133055.02079032, 3997108.9042797475],
              [-10139592.591845628, 3998818.719462833],
              [-10142485.1174944, 3998572.03396906],
              [-10146024.298065191, 3994899.565042036],
              [-10138465.92727931, 3990517.4917593296],
              [-10141314.704368198, 3983312.8828650014],
              [-10149923.151910733, 3982050.1463744924],
              [-10144645.606171716, 3976676.840337356],
              [-10151106.589417357, 3972040.3507098155],
              [-10152965.957307804, 3968133.2926571337],
              [-10157431.540245248, 3964149.6145114033],
              [-10169125.652753083, 3964460.4563724766],
              [-10168984.276999775, 3970359.7595597683],
              [-10180550.149454214, 3970367.374374088],
              [-10180203.611879375, 3999355.09792179],
              [-10192150.753589783, 3999752.74398396],
              [-10191151.104562458, 4025687.1239697677],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '12063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9521068.10515096, 3629430.005693299],
              [-9517594.00029466, 3632471.882507432],
              [-9516513.834308181, 3632484.8137944103],
              [-9499261.618779978, 3632691.3517983775],
              [-9478404.798984949, 3632839.1429532184],
              [-9465639.34769772, 3632833.1689355997],
              [-9462434.904835746, 3632837.7143835262],
              [-9462831.536181442, 3629767.57932931],
              [-9460348.554939298, 3624568.0175253064],
              [-9454998.651531266, 3617006.4177791704],
              [-9454841.134451792, 3611213.874615287],
              [-9453045.217106823, 3603184.8923889566],
              [-9447094.411087489, 3595343.7714079157],
              [-9446676.962997012, 3592975.0482943947],
              [-9454644.766870031, 3581736.5923875463],
              [-9480823.548880905, 3581941.7244766494],
              [-9481291.5360202, 3576298.1952105835],
              [-9504897.613279348, 3576623.990368559],
              [-9510556.428274333, 3576715.007671094],
              [-9510277.238991424, 3604917.8830633233],
              [-9515843.436170071, 3610627.3792728395],
              [-9528941.064817823, 3610762.592259385],
              [-9521068.10515096, 3629430.005693299],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Thomas',
        GEOID: '13275',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9363821.97731907, 3642879.3072847715],
              [-9351240.982428087, 3642790.794330874],
              [-9351268.700981293, 3638150.5358809237],
              [-9321466.469545102, 3637643.4461640813],
              [-9322309.269409897, 3588481.3160384367],
              [-9330908.032156732, 3589008.8050186653],
              [-9351667.002119353, 3590234.0174362687],
              [-9360160.577108983, 3590735.3502125395],
              [-9359292.832516655, 3621395.73932701],
              [-9364090.702569846, 3630276.1643591207],
              [-9363821.97731907, 3642879.3072847715],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clarke',
        GEOID: '28023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9897844.172511034, 3792774.6327209915],
              [-9844110.072126634, 3793228.6517738537],
              [-9846586.0847293, 3770276.1758797565],
              [-9848286.18236325, 3754541.738024437],
              [-9848286.458886575, 3749385.5902555413],
              [-9865693.87905554, 3744513.4975313363],
              [-9886192.02745123, 3741395.6938129845],
              [-9897467.022076227, 3740577.062895334],
              [-9897844.172511034, 3792774.6327209915],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Utuado',
        GEOID: '72141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7439050.540646121, 2075434.78965042],
              [-7433613.696715777, 2075148.1956347474],
              [-7432810.415270213, 2075626.0500204663],
              [-7429011.637646893, 2078518.276801405],
              [-7426936.085741052, 2074531.7507836823],
              [-7414656.098753173, 2075998.1392790936],
              [-7410162.242229341, 2072522.9529255375],
              [-7413597.0051177675, 2070829.37127457],
              [-7419384.728083091, 2056150.8811105792],
              [-7421725.443016, 2055444.9218972588],
              [-7424312.062704073, 2062950.9404390205],
              [-7434104.949628648, 2066860.5295588258],
              [-7438064.583916164, 2064526.6641831968],
              [-7439170.877015668, 2066139.4313250748],
              [-7439050.540646121, 2075434.78965042],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Raleigh',
        GEOID: '54081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9080501.628106201, 4569218.2642727895],
              [-9067710.795975072, 4577632.872817695],
              [-9065695.801872224, 4574907.4014900355],
              [-9059272.44461447, 4575062.869232879],
              [-9055543.352992387, 4576136.097997363],
              [-9049732.141614506, 4563800.948573323],
              [-9025032.795636274, 4561904.511991618],
              [-9023255.80260474, 4556218.687609557],
              [-9010766.2010157, 4553905.094300051],
              [-9003267.608796375, 4535106.771779067],
              [-9010980.71367446, 4539305.920364428],
              [-9024534.640914975, 4528669.089573023],
              [-9027412.917668926, 4521478.849529682],
              [-9039016.750069728, 4519635.184295181],
              [-9041605.150869653, 4510493.017605907],
              [-9052692.126874696, 4522762.653917681],
              [-9067821.558868412, 4548958.583476055],
              [-9074122.353366803, 4549972.771746115],
              [-9080501.628106201, 4569218.2642727895],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Craven',
        GEOID: '37049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8619615.002531528, 4208787.865992887],
              [-8615129.606288996, 4210118.588926549],
              [-8604366.570002155, 4215524.460084297],
              [-8599196.447571753, 4212149.642850218],
              [-8592652.976583436, 4220881.214566457],
              [-8567024.112857081, 4204863.222920339],
              [-8560014.54716081, 4198437.395830728],
              [-8570183.248686302, 4184958.218257294],
              [-8565012.792297427, 4180078.5686229877],
              [-8566400.501069658, 4166769.0374235935],
              [-8547175.73632915, 4157147.361074552],
              [-8539494.023547469, 4161403.7640331695],
              [-8532925.171715248, 4155403.7843649085],
              [-8537427.711159363, 4146117.409215262],
              [-8558598.785876902, 4142822.6490449333],
              [-8566528.852442542, 4137964.1536754286],
              [-8580312.988390017, 4138270.027237823],
              [-8584234.10613372, 4173730.0854449905],
              [-8624331.943314912, 4195042.996085773],
              [-8619615.002531528, 4208787.865992887],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cayey',
        GEOID: '72035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7371231.478589625, 2054319.0223847383],
              [-7360278.085973532, 2053725.229331886],
              [-7357672.764611005, 2057348.2323698034],
              [-7354429.916524706, 2054927.1246088913],
              [-7354833.115720359, 2053650.8453430021],
              [-7352936.788194696, 2050787.3255650287],
              [-7352851.406145257, 2050413.587664792],
              [-7353002.578013754, 2050110.8309909853],
              [-7361450.057572601, 2047925.962024816],
              [-7362558.35442294, 2041870.0672814972],
              [-7365581.569153905, 2043409.163468547],
              [-7369577.159636946, 2042946.6966438233],
              [-7372076.504844239, 2048710.8297684412],
              [-7371231.478589625, 2054319.0223847383],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Emmet',
        GEOID: '26047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9475485.779297369, 5711552.276272317],
              [-9469001.53027815, 5722766.647502099],
              [-9458922.886220708, 5730225.71547226],
              [-9463771.851920173, 5742024.607910777],
              [-9447348.553484967, 5740706.253534467],
              [-9436861.032937843, 5746648.608093015],
              [-9432350.033212429, 5745243.191203637],
              [-9432399.57038583, 5667194.390612283],
              [-9458236.82419895, 5667545.511446935],
              [-9462357.426470153, 5664496.329477886],
              [-9472849.719536657, 5678864.537798121],
              [-9468257.58212118, 5679023.444845299],
              [-9457605.865325132, 5680906.221245239],
              [-9452467.023671644, 5686264.680395278],
              [-9460036.415087113, 5689374.097417797],
              [-9466713.692103367, 5690535.132356322],
              [-9474318.594436402, 5704018.066954897],
              [-9475485.779297369, 5711552.276272317],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Boone',
        GEOID: '17007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9900798.353615059, 5235485.281035025],
              [-9882554.302496253, 5235288.526749279],
              [-9874860.37120542, 5235205.552221236],
              [-9874660.552719446, 5184006.360885409],
              [-9900725.677530218, 5183823.620361634],
              [-9900798.353615059, 5235485.281035025],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ellsworth',
        GEOID: '20053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10963284.577366326, 4703180.355169527],
              [-10901360.995542243, 4703224.393313618],
              [-10900938.3154357, 4665943.294229932],
              [-10900879.761383545, 4653539.057370925],
              [-10962785.42076961, 4653409.008216801],
              [-10962733.768525882, 4676155.316808439],
              [-10963423.392771346, 4678344.488674905],
              [-10963284.577366326, 4703180.355169527],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Boone',
        GEOID: '19015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10482366.899979332, 5192476.493873074],
              [-10456415.65500764, 5192474.690369781],
              [-10430457.062949555, 5192389.17464857],
              [-10430417.210571853, 5140534.854182479],
              [-10443518.29012382, 5140542.178442265],
              [-10482303.893147541, 5140516.020397377],
              [-10482366.899979332, 5192476.493873074],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Diego',
        GEOID: '06073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13090747.843725963, 3946780.4560926636],
              [-13088776.5218471, 3955711.3431993164],
              [-13080999.074303338, 3957804.55349223],
              [-13081122.416299134, 3962530.2476919675],
              [-13064930.996363254, 3962531.048707744],
              [-13053246.45733163, 3955789.529876735],
              [-13052265.39865927, 3955404.7391088423],
              [-13051282.781514037, 3955044.37628],
              [-13051238.587676192, 3952785.1930678994],
              [-13040140.368402574, 3952867.4951035585],
              [-13034290.529161388, 3952557.4982641614],
              [-13027815.853618378, 3952109.991649787],
              [-13004546.183860408, 3952102.25547293],
              [-12935056.661525069, 3952371.690884364],
              [-12922541.456453143, 3951976.7433947558],
              [-12922087.829528162, 3905241.010154526],
              [-12924820.05511019, 3858405.084971196],
              [-12924880.711881777, 3844785.3398101237],
              [-12973245.035480682, 3840182.78244263],
              [-12982863.818721658, 3839193.8223425597],
              [-13008478.878831152, 3836710.292700295],
              [-13038279.997072438, 3833632.954306203],
              [-13039078.932130639, 3840427.748093211],
              [-13039593.78970278, 3844808.581993191],
              [-13043178.499945305, 3851841.5916870227],
              [-13046284.425057927, 3854076.590006825],
              [-13051772.698593019, 3851497.76297385],
              [-13052785.705959234, 3855558.093059232],
              [-13052763.553380568, 3867058.898041299],
              [-13055657.971460685, 3871733.9232293037],
              [-13055791.443530148, 3874025.8260761118],
              [-13054867.49175656, 3875602.5965707847],
              [-13053646.873540012, 3875324.5926054455],
              [-13052897.13676952, 3876662.7292160285],
              [-13052896.083147127, 3876692.7580838823],
              [-13052707.893635172, 3882057.502883407],
              [-13054674.845271235, 3892055.7115204083],
              [-13055635.596243035, 3896942.4048259994],
              [-13059477.00923133, 3907721.6423215847],
              [-13064741.753228907, 3917682.5586829805],
              [-13073982.495479148, 3930999.5814075167],
              [-13085349.328684049, 3943917.873995313],
              [-13090713.480986904, 3946735.6610623756],
              [-13090747.843725963, 3946780.4560926636],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Williamson',
        GEOID: '48491',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10905175.691852747, 3604941.725512626],
              [-10890220.140903652, 3620571.853030323],
              [-10867555.26993916, 3615920.969580657],
              [-10833112.685529249, 3600631.3890345944],
              [-10828204.720499665, 3598471.0808005105],
              [-10815269.506988978, 3562473.656620376],
              [-10835222.857796727, 3555437.3682182212],
              [-10839127.500255791, 3557595.566448436],
              [-10864363.294860153, 3568178.931793948],
              [-10884091.55765752, 3559027.3838839876],
              [-10892432.281824695, 3564451.977531115],
              [-10893447.62690022, 3568191.464057774],
              [-10904493.748652147, 3584563.7274774606],
              [-10914863.381858524, 3584034.1084754653],
              [-10905175.691852747, 3604941.725512626],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mineral',
        GEOID: '32021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13264521.73388804, 4638132.03379144],
              [-13236651.218346559, 4638172.528681215],
              [-13236123.897918673, 4700516.545282402],
              [-13248636.653961798, 4700393.900743975],
              [-13248671.051684454, 4713556.327194006],
              [-13239266.001865804, 4732100.330704609],
              [-13236240.004147569, 4732287.02491132],
              [-13219616.441948427, 4732367.324554227],
              [-13120684.695410121, 4732227.374160524],
              [-13157549.03534224, 4721660.972720597],
              [-13157544.693882098, 4710083.948511481],
              [-13101304.528660467, 4646575.355903559],
              [-13174826.933508266, 4564420.757573279],
              [-13183344.135264661, 4564776.139070745],
              [-13191466.303075098, 4572226.408587277],
              [-13241417.028386403, 4617487.989755633],
              [-13264521.73388804, 4638132.03379144],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bernalillo',
        GEOID: '35001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11933142.616522301, 4193744.883714015],
              [-11884809.697370697, 4193545.2610129435],
              [-11881016.819680387, 4193543.080853163],
              [-11870087.917352267, 4193735.7541330205],
              [-11866515.786212202, 4193525.912109914],
              [-11827052.024850568, 4193226.8259777813],
              [-11827013.953584718, 4169318.721670684],
              [-11827001.485801749, 4157544.080218109],
              [-11816544.800753573, 4157558.612820775],
              [-11816534.670679912, 4146247.933603032],
              [-11845705.275325343, 4146262.85852637],
              [-11846005.17003354, 4149244.5803035325],
              [-11847065.042905385, 4150553.3808861733],
              [-11876209.042192517, 4151162.840623404],
              [-11880090.196239023, 4146235.8579978542],
              [-11913968.05687214, 4146366.7908188906],
              [-11918595.162826454, 4158064.956841336],
              [-11933142.616522301, 4193744.883714015],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Northampton',
        GEOID: '51131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8462894.525335163, 4479475.957279378],
              [-8458847.727886355, 4490602.886702624],
              [-8457664.290379733, 4501299.793775383],
              [-8454222.661186079, 4515914.801748798],
              [-8449194.992200688, 4517069.624037726],
              [-8441937.40667893, 4516645.555443333],
              [-8436682.904074507, 4513075.494921128],
              [-8438551.401727472, 4511097.877737195],
              [-8437296.163149286, 4507465.172149028],
              [-8439441.512375856, 4505369.106175403],
              [-8435408.518543905, 4502661.478028623],
              [-8434000.104346389, 4503884.213881764],
              [-8428363.21929109, 4502000.59528965],
              [-8423035.792498857, 4504443.182422108],
              [-8422252.224524504, 4502272.487474846],
              [-8429194.10797037, 4491244.562066761],
              [-8430873.91908644, 4485964.5471002],
              [-8435659.321356663, 4480610.636476518],
              [-8437479.06107266, 4473604.836880767],
              [-8439952.91411656, 4466103.817707297],
              [-8448848.565945338, 4455572.418599774],
              [-8453869.186299607, 4451604.21819162],
              [-8458011.273232535, 4453117.206805183],
              [-8460130.685017748, 4465447.3235508455],
              [-8462894.525335163, 4479475.957279378],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Solano',
        GEOID: '06095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13626261.08716121, 4601434.78386351],
              [-13604740.580562072, 4601330.307637938],
              [-13602793.268709624, 4602476.631060187],
              [-13603907.688131955, 4624121.9767758325],
              [-13587810.555804776, 4625781.816050647],
              [-13595047.435901247, 4640195.997347416],
              [-13592475.065107996, 4652200.654500948],
              [-13582277.309195405, 4648736.017844839],
              [-13574330.433386656, 4655051.533656555],
              [-13548921.648293601, 4655703.038802391],
              [-13546880.382790923, 4623840.917499296],
              [-13535701.2342475, 4623749.691933947],
              [-13538165.847773662, 4607108.099886598],
              [-13545984.038251055, 4602002.767967351],
              [-13548932.334964717, 4591513.974831648],
              [-13565667.216654649, 4588757.84123201],
              [-13567423.058982931, 4586395.136779473],
              [-13586586.820642486, 4587933.265078431],
              [-13591634.825591486, 4586259.006473684],
              [-13596909.92230171, 4583913.549058142],
              [-13610958.448153151, 4587958.218787476],
              [-13614574.54437875, 4594289.517232101],
              [-13624791.892521717, 4599710.212050673],
              [-13625236.416921405, 4599505.62631665],
              [-13626261.08716121, 4601434.78386351],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Searcy',
        GEOID: '05129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10346137.224092264, 4299254.96778688],
              [-10345867.608285563, 4310495.252566423],
              [-10346552.891070887, 4316473.7036012],
              [-10340544.866833283, 4316337.144762474],
              [-10334551.870726936, 4316283.2658158345],
              [-10334515.357933955, 4310266.495701681],
              [-10287201.346081583, 4309259.940253196],
              [-10287515.4896846, 4297300.94124129],
              [-10287782.099865051, 4271570.538515925],
              [-10311506.28710393, 4271876.980767312],
              [-10311658.794806316, 4261937.708965957],
              [-10331535.557804402, 4262491.100778484],
              [-10347293.054365171, 4262801.264742029],
              [-10346137.224092264, 4299254.96778688],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wabasha',
        GEOID: '27157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10302700.47010422, 5522649.901165775],
              [-10289330.553981984, 5522614.085004644],
              [-10289291.369521225, 5536176.665879677],
              [-10268707.02076712, 5536009.815983914],
              [-10267271.817644862, 5534634.87884563],
              [-10253759.07861594, 5529726.663659762],
              [-10250802.831519105, 5528272.184047915],
              [-10237341.123516293, 5521651.9286859315],
              [-10232063.577777274, 5514800.647603924],
              [-10229448.34898007, 5501276.146263867],
              [-10225196.164320897, 5496014.343209354],
              [-10250231.586591683, 5495314.956074312],
              [-10250242.050623816, 5482013.777999365],
              [-10276900.842278989, 5482129.432698765],
              [-10276902.51207135, 5495522.227172948],
              [-10302715.83219395, 5495655.597351279],
              [-10302700.47010422, 5522649.901165775],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Prairie',
        GEOID: '05117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10219408.11014695, 4168016.549093191],
              [-10207492.249213457, 4172356.6754799443],
              [-10197763.148357106, 4166700.1204619505],
              [-10195084.801408619, 4176334.0193323526],
              [-10181849.915828718, 4176044.2399173514],
              [-10170567.574117329, 4170934.617636566],
              [-10171101.573714664, 4152028.4936161106],
              [-10171792.311155036, 4118579.1333898865],
              [-10179831.582141144, 4118791.2222583275],
              [-10179921.973567668, 4110896.9652262097],
              [-10172132.392199408, 4104716.9192332914],
              [-10196245.19578065, 4105334.7033244874],
              [-10196366.645345105, 4093506.7210634956],
              [-10205552.395766893, 4093697.1350223934],
              [-10200517.860476276, 4103313.850833686],
              [-10201154.607963614, 4113184.058768012],
              [-10208089.478281563, 4119400.03569272],
              [-10207296.54954864, 4152961.144691584],
              [-10219541.470896922, 4153221.6764589697],
              [-10219408.11014695, 4168016.549093191],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lorain',
        GEOID: '39093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9166939.56594584, 5075568.644816436],
              [-9158085.19061712, 5076099.97454415],
              [-9148413.64193751, 5082158.450218035],
              [-9136118.677232035, 5085914.679746318],
              [-9127593.22361597, 5088520.148280223],
              [-9124689.5329038, 5086947.539351643],
              [-9123781.64091206, 5086455.887144215],
              [-9124999.145522015, 5064292.496430884],
              [-9114501.494901229, 5064206.042076579],
              [-9114623.167104665, 5052995.629848336],
              [-9125135.289259255, 5052963.784193078],
              [-9125292.249741273, 5041861.522703794],
              [-9136265.011948766, 5041864.333739496],
              [-9136465.498351686, 5032489.775263954],
              [-9147108.643546939, 5032584.519496985],
              [-9147288.647163553, 5021717.878723969],
              [-9165656.808422405, 5022046.240498647],
              [-9166501.723357527, 5042204.9189462],
              [-9166492.483839791, 5043553.469923473],
              [-9166304.465219842, 5054256.209572379],
              [-9166608.81270767, 5064620.377527629],
              [-9166625.955909252, 5065206.320327469],
              [-9166939.56594584, 5075568.644816436],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nueces',
        GEOID: '48355',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10901993.512888933, 3234508.0826425343],
              [-10886881.112777308, 3248426.4998904183],
              [-10887802.949480569, 3240744.957355131],
              [-10874920.612728007, 3238557.8840303095],
              [-10863610.441143919, 3230843.5017637317],
              [-10835580.638640137, 3234251.538751947],
              [-10825909.089960527, 3233439.6223656153],
              [-10820398.218568806, 3226437.8878585426],
              [-10818755.031565204, 3226990.462943413],
              [-10813164.789376548, 3236924.8950020103],
              [-10808645.329369832, 3243658.787148422],
              [-10802853.496899288, 3228379.847902999],
              [-10802982.84083165, 3228119.7240330577],
              [-10808091.180944664, 3222005.8857449475],
              [-10813670.40250373, 3213301.3566917004],
              [-10821665.924929958, 3198186.2123957844],
              [-10822813.89688525, 3195697.770007281],
              [-10834193.486465361, 3193724.772457052],
              [-10891574.453828644, 3193406.081689669],
              [-10902869.819920456, 3203150.201960204],
              [-10901993.512888933, 3234508.0826425343],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oswego',
        GEOID: '36075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8528989.218709946, 5376147.110786269],
              [-8517709.021838205, 5383960.720812132],
              [-8506766.204573737, 5391656.348776543],
              [-8501574.468091516, 5392322.961758183],
              [-8501341.3831484, 5392352.89072171],
              [-8495870.25281489, 5390273.245752987],
              [-8486534.22108053, 5392880.129662941],
              [-8482931.811038971, 5399902.916337348],
              [-8482166.266900787, 5411400.904055592],
              [-8482710.234867498, 5416098.271931135],
              [-8462730.663044715, 5414229.352707893],
              [-8463073.972354323, 5420213.925225065],
              [-8435184.65504792, 5417421.822295444],
              [-8433143.055586772, 5383845.984628646],
              [-8439645.67232197, 5385869.415198555],
              [-8447675.035873398, 5361574.936499656],
              [-8447398.852216741, 5335680.024084007],
              [-8452798.181478687, 5338888.31986583],
              [-8455338.60357808, 5338216.533045899],
              [-8455757.164863462, 5339469.322469777],
              [-8457998.02621313, 5339013.188100631],
              [-8459438.389104504, 5340198.298401911],
              [-8459545.92373261, 5339925.326495586],
              [-8469007.635172075, 5342374.4207933],
              [-8483750.788532738, 5352925.865146951],
              [-8482405.826444972, 5344383.036392883],
              [-8489107.5937492, 5348187.030933107],
              [-8513628.271944707, 5346666.927203061],
              [-8527630.928052612, 5350647.775077169],
              [-8528989.218709946, 5376147.110786269],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Summit',
        GEOID: '08117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11848235.233392602, 4855036.978337717],
              [-11827921.541393155, 4853556.188999692],
              [-11809184.689980794, 4837785.430278034],
              [-11801311.73031393, 4820466.349791253],
              [-11791474.53823202, 4822293.653818623],
              [-11774946.376836488, 4809585.398365031],
              [-11780904.084664254, 4802909.669563755],
              [-11779564.79987052, 4799075.828509349],
              [-11796168.65851979, 4784611.973155649],
              [-11802311.268021764, 4773617.093941941],
              [-11814953.04335472, 4776185.023301604],
              [-11822879.325057674, 4776197.98485087],
              [-11828337.876288723, 4796418.338402227],
              [-11819509.906710342, 4813146.741866229],
              [-11842777.23875901, 4832164.650050623],
              [-11848235.233392602, 4855036.978337717],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Orange',
        GEOID: '51137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8723968.564868923, 4605462.029908009],
              [-8715073.469637595, 4618014.887428584],
              [-8708778.018474761, 4612054.263889165],
              [-8693439.75111632, 4623487.653479166],
              [-8687364.267267296, 4623533.61967723],
              [-8672787.870503845, 4633460.462628695],
              [-8657323.589481823, 4635092.126228142],
              [-8649840.915949682, 4630526.562902098],
              [-8651203.24387801, 4626967.194349559],
              [-8677759.398962671, 4596179.581466195],
              [-8694273.645421853, 4600997.916055866],
              [-8706228.802135598, 4597966.398432291],
              [-8720955.25757264, 4604445.795678365],
              [-8723968.564868923, 4605462.029908009],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nelson',
        GEOID: '38063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10967820.623977171, 6110374.1628152765],
              [-10956360.282400005, 6110368.337675835],
              [-10956298.054804651, 6139328.024419738],
              [-10941835.87183875, 6139386.974204717],
              [-10898560.419792866, 6139340.215135164],
              [-10896194.324016055, 6110316.410893292],
              [-10896219.482220974, 6052489.353583319],
              [-10907619.15467566, 6052509.356913566],
              [-10964989.991965279, 6052528.037751464],
              [-10967772.64527664, 6052541.924418236],
              [-10967810.271264527, 6081318.635117525],
              [-10967814.612724667, 6092734.796220178],
              [-10967820.623977171, 6110374.1628152765],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '39079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9215683.230987448, 4745875.196445667],
              [-9213122.994018694, 4751504.992358311],
              [-9187899.555877808, 4747596.634536361],
              [-9188342.162173202, 4742386.981931121],
              [-9175473.072440049, 4741454.191318402],
              [-9176656.62126616, 4726697.584668815],
              [-9178868.539548226, 4699432.9505137205],
              [-9192271.851517696, 4699418.800653304],
              [-9200560.2555242, 4700075.575027948],
              [-9212877.868499968, 4700904.929414468],
              [-9212065.347536666, 4713849.741457239],
              [-9218043.092872776, 4714236.202458142],
              [-9215683.230987448, 4745875.196445667],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nassau',
        GEOID: '36059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8213036.035818318, 4984608.917332696],
              [-8209596.486191786, 4993438.913513631],
              [-8208832.527794025, 4994047.453709213],
              [-8205768.654181369, 4993200.135933514],
              [-8199167.185738347, 4994392.6100543635],
              [-8195070.517157664, 4997293.286779655],
              [-8181976.005455649, 5000278.650469672],
              [-8181687.692274354, 5001017.660926814],
              [-8177781.264403578, 4992701.253936036],
              [-8175136.424621822, 4975729.006313059],
              [-8174858.793811782, 4973987.4021179695],
              [-8173440.917457547, 4963918.981852553],
              [-8173519.689083694, 4955461.658234892],
              [-8180298.13066944, 4953337.033133886],
              [-8182797.988575667, 4952553.597463364],
              [-8197667.7121973615, 4951001.528650077],
              [-8209881.65574212, 4951953.844593299],
              [-8208884.1527702, 4959708.34108318],
              [-8207015.432478255, 4961358.778625129],
              [-8207342.711781186, 4962793.472420537],
              [-8207371.20957083, 4964023.922500882],
              [-8207099.590013293, 4965195.224572131],
              [-8207257.3297317475, 4969586.507017973],
              [-8207494.328927645, 4971006.692223603],
              [-8206998.511915654, 4971762.690855415],
              [-8204428.256192728, 4975902.6988736605],
              [-8209845.28525371, 4980309.968504509],
              [-8213036.035818318, 4984608.917332696],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oneida',
        GEOID: '36065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8447675.035873398, 5361574.936499656],
              [-8439645.67232197, 5385869.415198555],
              [-8433143.055586772, 5383845.984628646],
              [-8408350.75783373, 5376082.809084288],
              [-8361224.764601304, 5406089.785387961],
              [-8357486.767419957, 5362444.754930448],
              [-8366982.876582077, 5351225.3846834],
              [-8366811.889844218, 5350989.384260497],
              [-8366595.150795643, 5350948.879608216],
              [-8366500.52922847, 5350952.242251884],
              [-8366403.458632497, 5350995.34533741],
              [-8366256.628224142, 5351124.350091058],
              [-8366223.677654866, 5351186.866071029],
              [-8366189.5025711935, 5351321.070497634],
              [-8366132.395672417, 5351424.094343081],
              [-8366044.1193162175, 5351434.641358967],
              [-8365969.757896368, 5351375.027948051],
              [-8365938.477119455, 5351296.002553439],
              [-8365983.004915771, 5351073.451082515],
              [-8365991.7991555445, 5350861.756991189],
              [-8365934.469617786, 5350655.875731468],
              [-8365804.003174577, 5350387.335156222],
              [-8365818.919986342, 5350155.941011108],
              [-8365835.729229453, 5350112.688978729],
              [-8365861.555351316, 5349807.17946259],
              [-8365837.844299777, 5349710.4394198125],
              [-8365768.15829854, 5349628.830118095],
              [-8365634.018312135, 5349595.055691302],
              [-8365586.373570075, 5349601.932827094],
              [-8365504.887702814, 5349648.697485212],
              [-8365464.144769184, 5349696.379339291],
              [-8365426.741420278, 5349868.158299963],
              [-8365460.137267517, 5349975.139681529],
              [-8365498.0972138755, 5350048.499053772],
              [-8365516.910207821, 5350112.688978729],
              [-8365500.100964711, 5350184.979590833],
              [-8365436.648854959, 5350317.946876124],
              [-8365357.834655479, 5350406.439949704],
              [-8365161.021795753, 5350441.287194005],
              [-8365130.96553324, 5350466.964194338],
              [-8365085.4358615065, 5350574.258140659],
              [-8365074.637870899, 5350802.605784414],
              [-8365039.238272827, 5350872.456216021],
              [-8364972.669217333, 5350896.60594014],
              [-8364901.090784754, 5350892.93762358],
              [-8364847.434790189, 5350866.49521781],
              [-8364806.580537069, 5350662.600808318],
              [-8364763.165935659, 5350514.8030803],
              [-8364644.833316946, 5350376.025136956],
              [-8364418.520792163, 5350264.606897905],
              [-8364326.014295314, 5350112.688978729],
              [-8364286.16191761, 5350090.3752879575],
              [-8364223.823002767, 5349985.99071891],
              [-8364145.565400739, 5349903.462019961],
              [-8363977.361650149, 5349845.081048865],
              [-8363632.827826144, 5349779.059030559],
              [-8363162.948255507, 5349731.071098151],
              [-8363082.464263663, 5349702.798069068],
              [-8363024.2441699775, 5349706.924397691],
              [-8362984.2804727815, 5349679.721227898],
              [-8362928.732046877, 5349678.040135744],
              [-8362801.716507883, 5349606.670412484],
              [-8362756.854753091, 5349567.241549481],
              [-8362734.813493915, 5349469.739884403],
              [-8362723.347586363, 5349303.622628377],
              [-8362675.368885831, 5349023.812682416],
              [-8362692.178128941, 5348843.186151748],
              [-8362664.793534205, 5348781.297156703],
              [-8362618.929904, 5348734.07842235],
              [-8362564.717311984, 5348706.572473888],
              [-8362382.821264027, 5348635.057388195],
              [-8362289.201572269, 5348589.520290825],
              [-8362216.398625291, 5348540.621642309],
              [-8362064.558839849, 5348455.04962537],
              [-8361947.562055026, 5348420.362621093],
              [-8361806.965538152, 5348416.084056831],
              [-8361673.15951022, 5348451.229464382],
              [-8361617.165806349, 5348432.128682952],
              [-8361537.015772981, 5348379.4107295275],
              [-8361424.471767788, 5348284.519165565],
              [-8361333.4124243185, 5348227.981978523],
              [-8361159.531379699, 5348139.6624112055],
              [-8360932.662257463, 5348086.182111593],
              [-8360829.135131026, 5348046.759687412],
              [-8360696.55361749, 5347985.945577452],
              [-8360552.283557422, 5347884.48774544],
              [-8360365.712090853, 5347743.151493869],
              [-8360234.91168917, 5347630.695208984],
              [-8360088.415239287, 5347515.642833946],
              [-8359840.3954138, 5347393.1052142875],
              [-8359434.190591895, 5347205.787730251],
              [-8359327.1012417525, 5347166.216247936],
              [-8359080.639889134, 5347121.144687205],
              [-8358827.722006054, 5347122.36696394],
              [-8358772.284899637, 5347117.1722889235],
              [-8358624.118657393, 5347123.283671597],
              [-8358450.794210227, 5347117.783427009],
              [-8358305.18831627, 5347128.172780624],
              [-8358153.014572356, 5347167.896886622],
              [-8358070.304190696, 5347217.246685099],
              [-8358008.299234324, 5347285.236773916],
              [-8357966.331786295, 5347315.335915581],
              [-8357804.361927189, 5347358.727742818],
              [-8357599.42274464, 5347509.683984717],
              [-8357513.150139275, 5347562.702597738],
              [-8357342.497359889, 5347707.855964734],
              [-8357253.887045218, 5347752.166390724],
              [-8357163.050340732, 5347777.988770704],
              [-8357088.354962409, 5347781.961450902],
              [-8356920.26253131, 5347730.469535099],
              [-8356826.976798025, 5347662.781782229],
              [-8356783.562196616, 5347599.372708419],
              [-8356749.609751925, 5347497.002343921],
              [-8356769.758579757, 5347438.636460755],
              [-8356820.63158705, 5347387.299232421],
              [-8356977.480749579, 5347339.476414232],
              [-8357065.868425269, 5347301.585026607],
              [-8357147.020334056, 5347209.760166335],
              [-8357171.399302539, 5347106.171810218],
              [-8357175.740762681, 5346970.3475258835],
              [-8357143.124151878, 5346840.789199763],
              [-8357068.762732028, 5346724.218802974],
              [-8356994.73527065, 5346682.663260726],
              [-8356827.644714969, 5346647.218974169],
              [-8356661.222076235, 5346638.5107002705],
              [-8373352.577845268, 5319961.576802733],
              [-8372579.130023237, 5293720.321649542],
              [-8376564.92439109, 5292449.0415395005],
              [-8397627.017327141, 5291190.691106551],
              [-8398406.921679636, 5301792.849655168],
              [-8409386.36305658, 5301592.91297942],
              [-8410496.329699278, 5317689.696659886],
              [-8429549.217146002, 5336753.4539430905],
              [-8447398.852216741, 5335680.024084007],
              [-8447675.035873398, 5361574.936499656],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gage',
        GEOID: '31067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10788645.892292894, 4916894.565452811],
              [-10788357.908770213, 4919763.468926818],
              [-10788265.402273363, 4942328.3625335395],
              [-10738282.39430973, 4942238.737745191],
              [-10738286.290491907, 4904114.006568065],
              [-10738291.308415525, 4866081.577632189],
              [-10738985.154255107, 4866082.656983539],
              [-10776368.799611777, 4866141.1416609585],
              [-10783943.423043314, 4866152.991788832],
              [-10788685.077362103, 4866153.586300824],
              [-10788645.892292894, 4916894.565452811],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Orange',
        GEOID: '36071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8322404.87517442, 5084923.844139314],
              [-8290587.983593849, 5086961.213232636],
              [-8278502.694395368, 5099905.34091877],
              [-8267063.16956298, 5106106.918641909],
              [-8243618.505565481, 5098362.417477006],
              [-8232444.477718633, 5099756.499848984],
              [-8237654.341207249, 5079917.564378013],
              [-8235581.349649697, 5077297.198737168],
              [-8231775.1136204945, 5070744.947719811],
              [-8235569.995061636, 5060352.417491841],
              [-8263731.46973568, 5033432.716961803],
              [-8263743.733667014, 5033439.77221335],
              [-8271260.137004867, 5037832.667745794],
              [-8278500.831068217, 5042509.631900809],
              [-8288580.336577393, 5049024.026761355],
              [-8314999.791327361, 5065205.282179186],
              [-8319450.233249785, 5075354.067551168],
              [-8321830.114245147, 5075622.704492177],
              [-8322404.87517442, 5084923.844139314],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sullivan',
        GEOID: '36105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8365288.47140127, 5138555.406693585],
              [-8324548.665928117, 5163432.655328705],
              [-8288146.3018827895, 5142362.356286957],
              [-8301660.599384584, 5122896.380257565],
              [-8281621.421249434, 5107931.140060133],
              [-8278502.694395368, 5099905.34091877],
              [-8290587.983593849, 5086961.213232636],
              [-8322404.87517442, 5084923.844139314],
              [-8321830.114245147, 5075622.704492177],
              [-8326647.372288042, 5076166.491346644],
              [-8336756.517885961, 5079735.61277256],
              [-8347009.599585476, 5085848.543432892],
              [-8353846.397432035, 5097541.570647099],
              [-8354104.614780966, 5101808.777921755],
              [-8354447.745321301, 5107482.165026921],
              [-8354909.721208094, 5123982.6130460445],
              [-8357245.315444427, 5131394.5160913095],
              [-8361581.98884726, 5137146.565916557],
              [-8365288.47140127, 5138555.406693585],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lynchburg',
        GEOID: '51680',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8823960.518237546, 4501719.035153208],
              [-8814912.024747903, 4504236.518405175],
              [-8807629.169701736, 4494755.210185688],
              [-8803715.621683408, 4494291.128736656],
              [-8818165.002907865, 4485566.0943159545],
              [-8822955.19191619, 4488819.680361753],
              [-8823960.518237546, 4501719.035153208],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pittsburg',
        GEOID: '40121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10696912.620626735, 4132327.1933962614],
              [-10696563.077425642, 4170645.1151173012],
              [-10684857.72164924, 4184496.256250104],
              [-10676425.938138595, 4183398.544055155],
              [-10672273.387173532, 4189184.710436971],
              [-10659505.820815979, 4187987.7941066995],
              [-10643887.028340738, 4197866.092172939],
              [-10642404.03008439, 4193919.301037068],
              [-10625584.545581453, 4204182.064069828],
              [-10625996.872975351, 4185724.3851661724],
              [-10614239.86495522, 4185686.1232191566],
              [-10614228.065089198, 4171835.8088295152],
              [-10614250.774265317, 4167863.474306784],
              [-10631863.85541812, 4167849.60795605],
              [-10632627.061846998, 4120633.600101245],
              [-10632604.90926833, 4108864.023557491],
              [-10650155.65150629, 4108823.3197946954],
              [-10673533.969087277, 4108779.5059424136],
              [-10673546.882148208, 4120543.308274376],
              [-10696917.296045346, 4120554.2732100543],
              [-10696912.620626735, 4132327.1933962614],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tuscaloosa',
        GEOID: '01125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9778380.102493363, 3965176.5727884485],
              [-9759008.062066535, 3964753.0132057182],
              [-9755118.225099744, 3976531.6795339026],
              [-9731961.878583401, 3975497.56197552],
              [-9726099.682878736, 3973488.8028590116],
              [-9720254.519056164, 3973532.6333986353],
              [-9720221.67980638, 3963751.4607389607],
              [-9714509.431455811, 3963586.3017155738],
              [-9722833.34637988, 3957922.9225265565],
              [-9706485.299920453, 3940929.6722561857],
              [-9704805.822762854, 3938923.1765848123],
              [-9692115.400812421, 3931987.5217384696],
              [-9692113.619700568, 3928122.783154081],
              [-9706965.309564753, 3921422.3748477106],
              [-9706983.565961242, 3912659.363930875],
              [-9716181.67284651, 3912978.800240465],
              [-9720255.2982926, 3896124.1510203406],
              [-9731765.399682151, 3895752.4777178145],
              [-9764468.060450964, 3896209.770292289],
              [-9777439.45279616, 3897594.898350744],
              [-9777353.291510286, 3907768.5470337546],
              [-9778086.664315632, 3913484.49257693],
              [-9778028.110263474, 3915714.5062686005],
              [-9778380.102493363, 3965176.5727884485],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Allegany',
        GEOID: '24001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8801686.156046756, 4790752.398861356],
              [-8786271.092698833, 4825770.460328934],
              [-8772899.773921257, 4825780.934408848],
              [-8763468.616384555, 4825788.322071034],
              [-8725274.794961123, 4825727.844333652],
              [-8721084.334589906, 4825721.209001011],
              [-8717799.46132814, 4821353.558099581],
              [-8719966.07497072, 4812106.851742902],
              [-8725551.082750041, 4811198.988563185],
              [-8731698.145031644, 4802716.029372906],
              [-8734233.11247599, 4797297.210864847],
              [-8735047.814745033, 4797331.4538835],
              [-8748671.584390348, 4797904.096358895],
              [-8755838.574943092, 4799952.370442795],
              [-8761634.071176281, 4801608.987664451],
              [-8765190.951546106, 4809385.560197724],
              [-8768763.194005664, 4813531.972508415],
              [-8777654.949652268, 4801347.2256369],
              [-8787852.037647912, 4790606.875693921],
              [-8789425.316011295, 4784933.261831994],
              [-8798205.306889141, 4789702.631371339],
              [-8801747.983790558, 4789625.435342786],
              [-8801686.156046756, 4790752.398861356],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Frederick',
        GEOID: '51069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8739485.277371107, 4734375.022777717],
              [-8729000.205852779, 4744388.631624609],
              [-8730642.613619944, 4748524.39139078],
              [-8728002.449256798, 4755821.457719386],
              [-8727649.900429456, 4761392.096688749],
              [-8720822.342100631, 4772433.501172949],
              [-8720449.755764946, 4780452.148168461],
              [-8721557.829976304, 4788645.331323461],
              [-8708426.864950242, 4777786.316945934],
              [-8703778.214865275, 4773944.798546591],
              [-8686614.445378203, 4759648.006960688],
              [-8686614.247849291, 4759647.842543078],
              [-8695142.494047495, 4735406.560980884],
              [-8699797.875152469, 4726919.721478121],
              [-8701162.318151122, 4724239.930197013],
              [-8717883.507543689, 4722816.709183843],
              [-8720395.765811913, 4736292.31628893],
              [-8726515.666137762, 4736277.971455407],
              [-8733474.470146233, 4725654.036817057],
              [-8742171.882729342, 4729232.458565867],
              [-8739485.277371107, 4734375.022777717],
            ],
            [
              [-8704808.922030529, 4742053.986323476],
              [-8703234.975750204, 4741270.915763534],
              [-8703368.893097626, 4740498.525476622],
              [-8698220.255328948, 4748176.83162159],
              [-8703825.41432937, 4751060.0727909645],
              [-8704808.922030529, 4742053.986323476],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Putnam',
        GEOID: '54079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9135385.254013028, 4665673.337521059],
              [-9123276.921679951, 4672708.786360586],
              [-9102911.243478306, 4676057.635068779],
              [-9099241.485144813, 4675270.226051235],
              [-9094395.859030074, 4668300.839297208],
              [-9100429.264111578, 4663256.011313097],
              [-9097370.09318509, 4645718.697191686],
              [-9117091.00889606, 4635884.689331749],
              [-9118758.01827069, 4625524.408483448],
              [-9127909.482289314, 4617156.920106441],
              [-9133607.147786586, 4620494.05046593],
              [-9133444.510010539, 4632456.370610329],
              [-9134334.954617394, 4646681.998927587],
              [-9135385.254013028, 4665673.337521059],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mesa',
        GEOID: '08077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12139558.786076562, 4739749.727778675],
              [-12139526.707252115, 4774331.916909256],
              [-12034306.541489994, 4774256.0990147805],
              [-11959158.538118143, 4774259.986731878],
              [-11962969.894843921, 4766823.803779764],
              [-11955099.495525347, 4758450.982676336],
              [-11958838.383262621, 4758637.44581896],
              [-11966912.71988833, 4752934.413074504],
              [-11982195.438820867, 4742035.1838815855],
              [-11996399.471887615, 4727874.965287462],
              [-12006724.354658691, 4733109.266042968],
              [-12020520.513111174, 4730252.2151917275],
              [-12033056.534927877, 4718761.897551043],
              [-12038125.69058013, 4708611.640764636],
              [-12064689.860668128, 4697222.23784417],
              [-12064661.474197976, 4674240.21222767],
              [-12064710.232134946, 4650299.987597422],
              [-12140499.435773766, 4650299.987597422],
              [-12139558.786076562, 4739749.727778675],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morrow',
        GEOID: '39117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9234886.956344197, 4937502.528879814],
              [-9234810.591173511, 4958748.195835351],
              [-9223905.511216423, 4960324.086517103],
              [-9223743.98663528, 4968928.915110041],
              [-9221584.722472364, 4970042.206848923],
              [-9209145.771251632, 4969837.043839216],
              [-9204909.953307457, 4969812.0779829165],
              [-9198016.827798557, 4969574.611818546],
              [-9199996.756261805, 4963263.238362258],
              [-9197618.081382535, 4946173.919652004],
              [-9200166.629804756, 4916215.226057604],
              [-9211123.584644556, 4916876.453022776],
              [-9231679.50785597, 4918121.029723506],
              [-9231144.395063726, 4926434.073457268],
              [-9241832.958611226, 4929181.884233482],
              [-9234886.956344197, 4937502.528879814],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marin',
        GEOID: '06041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13693581.21525997, 4579911.498349758],
              [-13687943.550968232, 4595395.868147157],
              [-13687135.371465076, 4604271.901633008],
              [-13690866.800796466, 4613036.525118738],
              [-13690774.405619107, 4618086.919668105],
              [-13692647.631796317, 4621283.678883626],
              [-13682383.587681072, 4624903.620153814],
              [-13663343.16801732, 4608711.932316031],
              [-13643883.741790218, 4605199.0399624705],
              [-13637272.92250997, 4595758.641214781],
              [-13635357.407874389, 4594848.687028568],
              [-13635667.250174766, 4594706.15338628],
              [-13636578.06624844, 4583970.645602872],
              [-13631405.049511274, 4578884.352672806],
              [-13635375.81574787, 4574724.683980464],
              [-13635120.894113954, 4568396.088308019],
              [-13630894.98360446, 4564379.144294907],
              [-13627561.744091637, 4558641.070800794],
              [-13634798.958146581, 4554977.124870468],
              [-13640788.169390239, 4555484.500064734],
              [-13647913.173398465, 4561800.292767942],
              [-13656505.25697585, 4566240.478893622],
              [-13659195.403790362, 4564436.97974392],
              [-13664980.232448924, 4570321.939644689],
              [-13669744.595335385, 4576128.754475635],
              [-13676331.146966642, 4581787.633543086],
              [-13685586.026792215, 4583934.324249607],
              [-13689446.475413432, 4578356.339691196],
              [-13693581.21525997, 4579911.498349758],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dinwiddie',
        GEOID: '51053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8671816.607946672, 4459181.522264978],
              [-8660202.868111191, 4465985.735179434],
              [-8654833.59511176, 4466004.879830878],
              [-8644026.364987077, 4476124.687041317],
              [-8629667.709147617, 4469396.26716416],
              [-8621406.0218189, 4470245.088260348],
              [-8618741.255848292, 4462143.952757395],
              [-8616039.865765212, 4462947.905063904],
              [-8615532.471526176, 4444088.817146134],
              [-8615961.385524204, 4438129.031818281],
              [-8640510.784148334, 4422093.466413142],
              [-8644853.023525707, 4424413.580882039],
              [-8665090.684312943, 4438536.988087075],
              [-8670654.3211433, 4437548.275244202],
              [-8671816.607946672, 4459181.522264978],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Moffat',
        GEOID: '08081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12139195.550578102, 4961381.375220222],
              [-12139196.747267975, 4962702.165985387],
              [-12139218.482393209, 4986722.397468061],
              [-12139398.931287784, 5012438.86668301],
              [-12050407.124721387, 5012358.4788360335],
              [-12013423.371241493, 5012522.658172204],
              [-11952089.082535824, 5012794.941212936],
              [-11946562.377036355, 5012760.938221394],
              [-11946156.866871452, 4953560.785296678],
              [-11958920.759685809, 4945050.006877778],
              [-11960097.740661966, 4898456.401794795],
              [-11963382.890154766, 4897997.886106072],
              [-11982894.74786203, 4898581.64078241],
              [-12035104.034322038, 4898207.240708402],
              [-12139471.969350098, 4898350.884187951],
              [-12139195.550578102, 4961381.375220222],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Muskingum',
        GEOID: '39119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9150325.442872392, 4858699.4033319],
              [-9149881.723382091, 4868949.931031274],
              [-9149026.678373309, 4890222.542831129],
              [-9096614.233842602, 4888079.329112021],
              [-9097987.359761536, 4856026.13266596],
              [-9093812.099620353, 4855885.026262413],
              [-9094150.733511345, 4843100.853304203],
              [-9094517.642553002, 4830485.98418306],
              [-9136729.659503339, 4832714.419521818],
              [-9136317.220789948, 4839272.714967304],
              [-9147127.790499356, 4839928.245732153],
              [-9146274.8605609, 4852781.047025274],
              [-9154244.111587297, 4853345.45353834],
              [-9150325.442872392, 4858699.4033319],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '01101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9628776.836940866, 3808608.742018376],
              [-9624633.302854557, 3816649.5170903634],
              [-9619247.665889978, 3817242.337780327],
              [-9602642.58272631, 3829346.902732988],
              [-9594881.165189222, 3820696.6067826883],
              [-9578641.655233316, 3816742.473008838],
              [-9576037.89234366, 3818566.401839156],
              [-9572505.836220281, 3807510.022018595],
              [-9564491.946078075, 3799381.663115302],
              [-9571979.740306793, 3799113.0776288263],
              [-9573382.365890788, 3796243.407970877],
              [-9573237.873191737, 3781912.8706679298],
              [-9573125.885784002, 3770013.468602482],
              [-9572982.283640876, 3759052.3385932846],
              [-9594780.421050053, 3758907.867200004],
              [-9607118.850770598, 3758725.738611637],
              [-9607274.586738218, 3770094.242182577],
              [-9618702.645663053, 3769971.702964224],
              [-9618924.839366678, 3790773.3424448096],
              [-9618980.387792585, 3795422.876803617],
              [-9620479.304736117, 3796661.1976461057],
              [-9623430.384437047, 3797961.519976597],
              [-9624517.530584132, 3799343.4814769262],
              [-9626979.695081497, 3798996.6924601328],
              [-9627432.876728518, 3800712.8303329004],
              [-9626294.968893629, 3806910.439497624],
              [-9628776.836940866, 3808608.742018376],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '17133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10060222.79678544, 4625206.134494831],
              [-10057687.384063132, 4632907.496970532],
              [-10056927.324273046, 4633875.7489047535],
              [-10056629.991579266, 4634254.550463483],
              [-10050904.910128081, 4641551.025081235],
              [-10048956.707719706, 4649740.2820166005],
              [-10047819.399457773, 4652899.928872969],
              [-10034940.025355965, 4639877.12642598],
              [-10022773.584248694, 4623160.504927493],
              [-10007761.149039803, 4620126.7188728405],
              [-10007515.689562604, 4610658.199657107],
              [-10022796.293424817, 4610994.020006236],
              [-10022746.867570903, 4598618.542617738],
              [-10041451.233823158, 4591774.936733772],
              [-10043100.634587036, 4592765.0125706615],
              [-10046860.56170807, 4597463.024490207],
              [-10046889.763479467, 4597491.727074672],
              [-10054638.343210304, 4605110.670047645],
              [-10057845.585207589, 4610486.674366841],
              [-10059266.228401054, 4612868.8637480475],
              [-10060222.79678544, 4625206.134494831],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morris',
        GEOID: '20127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10790230.079966374, 4665869.500606155],
              [-10789890.332880473, 4694800.709066843],
              [-10785772.73623552, 4703076.8376861755],
              [-10742504.074678574, 4703024.936361389],
              [-10742486.374879539, 4696804.987397802],
              [-10730130.022720974, 4696757.833457925],
              [-10725923.81576135, 4684357.216356296],
              [-10726053.725607106, 4653382.827842804],
              [-10777898.440734768, 4653495.5177546805],
              [-10790194.791687792, 4653490.253173104],
              [-10790230.079966374, 4665869.500606155],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lassen',
        GEOID: '06035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13506592.63455844, 5039502.759581628],
              [-13414154.933154538, 5039510.746897518],
              [-13358323.978381062, 5039515.775951642],
              [-13358253.290504409, 4992581.8734493395],
              [-13358064.270009043, 4971274.744112849],
              [-13357910.87175073, 4912735.861404558],
              [-13358018.740337307, 4884322.033164729],
              [-13358075.51327761, 4859623.716238367],
              [-13358331.709306521, 4825684.828265722],
              [-13360090.396060968, 4823704.252778598],
              [-13374719.446943568, 4823550.435866617],
              [-13370653.836500816, 4831964.069948495],
              [-13370446.114330996, 4857155.9271719465],
              [-13380743.501187844, 4867900.477690342],
              [-13381676.024562221, 4878448.610455314],
              [-13396341.69955729, 4882703.2375492845],
              [-13412089.28868338, 4895893.506499858],
              [-13415202.783521377, 4902184.508996511],
              [-13430936.791669589, 4910751.249019642],
              [-13443431.847913679, 4911970.817106252],
              [-13461708.170592628, 4893872.493718981],
              [-13476503.755433453, 4903274.363294799],
              [-13476495.295152154, 4931045.43944961],
              [-13506151.809374899, 4930874.441603257],
              [-13505277.951372169, 4998469.765511583],
              [-13506592.63455844, 5039502.759581628],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Prowers',
        GEOID: '08099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11437016.136344654, 4554601.683161887],
              [-11437223.858514475, 4617208.812975483],
              [-11359558.516157886, 4617460.939832172],
              [-11359556.725154627, 4616562.3780264],
              [-11359514.50497896, 4595402.800898428],
              [-11359259.656663178, 4542555.9234613385],
              [-11359249.675910363, 4540491.7128651785],
              [-11359251.331193902, 4529295.342698918],
              [-11437812.182023317, 4529205.973841604],
              [-11437016.136344654, 4554601.683161887],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Charlevoix',
        GEOID: '26029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9503522.260970598, 5664260.006939302],
              [-9494979.04664967, 5671471.7533153845],
              [-9484053.706545254, 5678476.845086218],
              [-9472849.719536657, 5678864.537798121],
              [-9462357.426470153, 5664496.329477886],
              [-9458236.82419895, 5667545.511446935],
              [-9432399.57038583, 5667194.390612283],
              [-9432579.462682953, 5653368.39690312],
              [-9432634.677150387, 5639628.786626626],
              [-9446288.346654654, 5639913.365270473],
              [-9487056.772448383, 5640095.411981596],
              [-9486948.347264351, 5653940.961230036],
              [-9504215.925660843, 5654270.297429689],
              [-9503522.260970598, 5664260.006939302],
            ],
          ],
          [
            [
              [-9540281.73794239, 5738164.070370363],
              [-9534722.108613702, 5739282.177867793],
              [-9520538.001735803, 5753115.416341209],
              [-9502337.710269066, 5751160.169486635],
              [-9504138.859630102, 5743410.34290129],
              [-9518849.062421488, 5715918.190060199],
              [-9524677.528320443, 5712059.076566115],
              [-9531479.928444346, 5714256.285870683],
              [-9539732.153616343, 5731965.346955916],
              [-9540281.73794239, 5738164.070370363],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Columbia',
        GEOID: '05027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10406341.92165901, 3929864.485681693],
              [-10401917.973775394, 3929621.39842162],
              [-10393409.3798161, 3954448.1545405844],
              [-10377346.533892086, 3953912.528399229],
              [-10365665.891042637, 3955575.5184527515],
              [-10365961.221651712, 3945890.9729074384],
              [-10350315.823818171, 3945489.3143534074],
              [-10351455.580749398, 3897593.9610906886],
              [-10374687.333896015, 3897686.9008720806],
              [-10379274.249328472, 3897695.5143572846],
              [-10394695.008615272, 3897724.4720952394],
              [-10407316.234383631, 3897777.6555847214],
              [-10406341.92165901, 3929864.485681693],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Valdez-Cordova',
        GEOID: '02261',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-16557478.830585081, 8591129.728514615],
              [-16527834.672825815, 8591123.786844462],
              [-16526766.673631145, 8724364.12990747],
              [-16386963.419450631, 8724363.664417287],
              [-16386964.310006557, 8734704.439907733],
              [-16357570.843740556, 8734707.236829596],
              [-16357575.519159172, 8815944.312873723],
              [-16359621.237441482, 8898099.736955807],
              [-16361717.272133626, 8918785.527112175],
              [-16299843.338802436, 8918788.874299297],
              [-16299844.00671938, 8981207.037157396],
              [-16301281.03002603, 9065270.35126019],
              [-16302754.34348668, 9089926.51318479],
              [-16307672.104631454, 9141804.39075137],
              [-16289298.711356536, 9147130.394530166],
              [-16268322.445747886, 9145514.187859092],
              [-16265056.220568523, 9153846.909816211],
              [-16158513.337805696, 9153851.603707032],
              [-16158512.224610785, 9132481.414937707],
              [-16094589.678690527, 9128980.24510516],
              [-15933418.87089123, 9128991.815989688],
              [-15929694.009409795, 9102186.059545308],
              [-15918891.677342707, 9099177.737270096],
              [-15929247.840890696, 9070792.66453777],
              [-15941793.77014208, 9058465.76708379],
              [-15919732.58477616, 9043406.22862894],
              [-15935503.662314804, 9010259.97933417],
              [-15930375.284693452, 9006441.415114967],
              [-15901831.074822713, 9002967.399591247],
              [-15890020.744766489, 9016833.322089434],
              [-15887464.626618892, 9030344.588811442],
              [-15863654.946011087, 9023139.781760342],
              [-15842273.47745595, 9023141.237232916],
              [-15842272.475580534, 9002156.118535263],
              [-15821408.531338092, 9002155.876664294],
              [-15821375.91472729, 8981231.636232495],
              [-15804846.640136851, 8981232.35973598],
              [-15804844.747705508, 8898130.967392769],
              [-15809036.037853366, 8887092.639200293],
              [-15788645.09012731, 8886981.239067983],
              [-15788644.199571382, 8836427.916498922],
              [-15696273.119506959, 8836426.504845526],
              [-15696254.105689205, 8487463.9966333],
              [-15719808.67924445, 8487461.290208412],
              [-15719809.458480889, 8497289.67268034],
              [-15784057.502592225, 8497282.904259646],
              [-15784059.50634306, 8516860.95197452],
              [-15940229.619976943, 8516844.890560392],
              [-16018131.667551022, 8405120.149818968],
              [-16018131.778870512, 8396782.194827696],
              [-16018543.99494492, 8396607.805670913],
              [-16030661.121517766, 8402628.533666883],
              [-16035855.288958183, 8409040.945078667],
              [-16042285.214065893, 8421798.586403303],
              [-16050795.032539584, 8425825.470626632],
              [-16068847.491722545, 8420067.0427598],
              [-16077790.454334917, 8432766.900403917],
              [-16091799.344334304, 8439583.264752511],
              [-16102909.697432417, 8445494.55282684],
              [-16133458.882651836, 8450732.175899899],
              [-16136633.82584875, 8464173.081144828],
              [-16151249.073114488, 8471332.720002264],
              [-16156546.656361852, 8465985.13879114],
              [-16169684.693984764, 8469407.186994871],
              [-16183634.695973523, 8478713.811540257],
              [-16198189.27411678, 8470946.493929772],
              [-16212482.028817693, 8467277.460477859],
              [-16233855.148411017, 8478143.123282516],
              [-16251370.602370393, 8486504.001977274],
              [-16262456.687819514, 8481450.401221154],
              [-16274601.087667607, 8477693.309987908],
              [-16278547.586255211, 8475568.826710934],
              [-16296422.71348934, 8473010.498886889],
              [-16307281.707177242, 8465697.58771014],
              [-16320293.619817087, 8453631.27015023],
              [-16325098.169039724, 8454034.978303134],
              [-16329905.167291157, 8462254.36435872],
              [-16354668.521976596, 8464806.700146114],
              [-16363225.205955913, 8453384.121995093],
              [-16380129.293271853, 8437979.793564605],
              [-16392662.754740264, 8423796.117226925],
              [-16405865.46898733, 8403343.742831882],
              [-16401790.841665823, 8391305.14666962],
              [-16414305.712779276, 8389506.055337546],
              [-16416316.588060966, 8379002.006729265],
              [-16407585.243800594, 8372572.64132446],
              [-16420549.845656851, 8364635.100392764],
              [-16435882.547040757, 8359290.504308444],
              [-16449138.138045944, 8354448.736175015],
              [-16461533.897304248, 8347357.829882902],
              [-16467407.670235956, 8351776.4333610935],
              [-16465635.018664567, 8363576.904526934],
              [-16459152.662076691, 8371276.218600149],
              [-16470472.852414949, 8390704.288915785],
              [-16486554.511332907, 8389235.484744484],
              [-16503566.467235425, 8384693.294406088],
              [-16499836.596376907, 8394474.359082634],
              [-16510234.727372926, 8407280.084127497],
              [-16519997.89199346, 8394804.971693685],
              [-16528593.426475063, 8385459.649633929],
              [-16545947.68981177, 8381003.728488967],
              [-16547589.940149464, 8382737.478952189],
              [-16540537.89651769, 8386077.191283579],
              [-16537960.405027863, 8427914.162423898],
              [-16538037.10415702, 8492757.132182801],
              [-16549253.099451896, 8492759.612405246],
              [-16548434.789875073, 8564766.616186323],
              [-16558286.453490788, 8564773.67497914],
              [-16557478.830585081, 8591129.728514615],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fremont',
        GEOID: '56013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12251063.846460989, 5466683.690233768],
              [-12244038.918674987, 5457563.409820603],
              [-12229420.554463508, 5458943.029702298],
              [-12224725.209661337, 5446973.119114925],
              [-12227717.47757386, 5437607.909010182],
              [-12221755.762244426, 5435045.288953016],
              [-12207951.366149625, 5441598.883023238],
              [-12205270.236213868, 5453500.749331472],
              [-12194196.618547717, 5459463.262955642],
              [-12183067.897733623, 5454682.98829237],
              [-12168661.819791084, 5436594.160396787],
              [-12152910.000524344, 5419009.771545401],
              [-12152931.151227595, 5406787.107102122],
              [-12126493.106122663, 5406694.69165336],
              [-12113149.79535873, 5404556.32390179],
              [-12113149.79535873, 5399991.576173419],
              [-12099835.53898189, 5400022.307684015],
              [-12099880.066778207, 5393340.605466129],
              [-12086643.622725433, 5393386.823208287],
              [-12086643.622725433, 5388888.967942655],
              [-12073373.782825422, 5388873.620639698],
              [-12073375.007339822, 5384442.8430493735],
              [-12060115.520152451, 5382216.669331797],
              [-12039902.572292171, 5383882.798222643],
              [-11977435.862672508, 5384136.049033221],
              [-11977432.300448803, 5388603.665736999],
              [-11970729.976547122, 5388598.294343473],
              [-11968741.14252461, 5384194.339115015],
              [-11967104.300731985, 5331484.242273112],
              [-11967003.89055129, 5278766.464379871],
              [-11971690.552433176, 5278781.631574539],
              [-11971527.135420691, 5227396.444411258],
              [-11969397.036964364, 5226267.572618167],
              [-11969374.661746714, 5200270.227041073],
              [-11982332.918391995, 5200210.061051252],
              [-12106665.991617477, 5200438.543425084],
              [-12138707.414610974, 5200560.232465861],
              [-12141558.640728664, 5226134.994839332],
              [-12141934.232690599, 5265437.296524155],
              [-12148793.183115829, 5265554.676330799],
              [-12148553.734891132, 5272099.365897679],
              [-12168930.211083386, 5290099.093098463],
              [-12178102.603166278, 5302721.736938399],
              [-12189752.187877797, 5313571.86519468],
              [-12195337.309369875, 5313880.453150482],
              [-12196213.6164014, 5324695.83872204],
              [-12206343.690063588, 5337431.0877409205],
              [-12210937.288851174, 5352399.51459074],
              [-12211185.086037677, 5367871.021613603],
              [-12217810.822129695, 5367833.19960842],
              [-12217839.208599847, 5382743.485232556],
              [-12250884.733400302, 5382986.275387254],
              [-12251063.846460989, 5466683.690233768],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marshall',
        GEOID: '27089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10814477.409382246, 6197291.520194346],
              [-10814435.119348958, 6197820.762036938],
              [-10729844.710866071, 6197890.763678391],
              [-10642401.024458138, 6196979.293017342],
              [-10641451.803160144, 6135670.258271632],
              [-10742424.703881636, 6135869.234733762],
              [-10814225.993571049, 6135721.584907471],
              [-10813787.998988727, 6139128.235910398],
              [-10812410.15454846, 6149853.741916561],
              [-10813342.010005891, 6164374.159488143],
              [-10813483.27443971, 6178780.57169403],
              [-10814590.79205361, 6195872.746495942],
              [-10814477.409382246, 6197291.520194346],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Red Lake',
        GEOID: '27125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10740388.336436555, 6100800.475576637],
              [-10654370.652705686, 6100922.668054705],
              [-10654346.05109822, 6096181.71116745],
              [-10654293.619618058, 6081703.13201705],
              [-10668506.780883051, 6081640.927945396],
              [-10668545.74270483, 6067167.900616678],
              [-10725825.186692508, 6067069.535788744],
              [-10725934.391112976, 6081493.1328749545],
              [-10740337.352109773, 6081509.72029846],
              [-10740388.336436555, 6100800.475576637],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ouachita',
        GEOID: '05103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10365665.891042637, 3955575.5184527515],
              [-10364322.153469272, 3998899.208114183],
              [-10356280.322134875, 3997955.745180466],
              [-10343554.945864333, 4004855.0605870564],
              [-10340860.902867645, 4003310.4749269816],
              [-10306298.427366149, 4002272.8735637693],
              [-10306518.394679956, 3993476.9279550263],
              [-10313520.501970345, 3983745.4173508836],
              [-10323286.115619674, 3978464.900943194],
              [-10321259.766928764, 3968863.3456946462],
              [-10327858.229745535, 3966887.126399896],
              [-10321136.424932966, 3959402.170563885],
              [-10319883.74670307, 3952681.415970427],
              [-10314108.268881733, 3953048.641677598],
              [-10304528.670101518, 3944145.6656640186],
              [-10314890.510943538, 3942601.3284728355],
              [-10350315.823818171, 3945489.3143534074],
              [-10365961.221651712, 3945890.9729074384],
              [-10365665.891042637, 3955575.5184527515],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yakutat',
        GEOID: '02282',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-16018131.667551022, 8405120.149818968],
              [-15940229.619976943, 8516844.890560392],
              [-15784059.50634306, 8516860.95197452],
              [-15784057.502592225, 8497282.904259646],
              [-15719809.458480889, 8497289.67268034],
              [-15719808.67924445, 8487461.290208412],
              [-15696254.105689205, 8487463.9966333],
              [-15696253.029714633, 8468206.401021276],
              [-15644294.657386873, 8449828.979285788],
              [-15637304.016004035, 8469214.346813528],
              [-15583520.004027268, 8441095.512570232],
              [-15551150.41117491, 8475922.00221683],
              [-15483057.169212589, 8479799.72701459],
              [-15482564.80310481, 8472189.5489792],
              [-15495711.634967493, 8419959.211547406],
              [-15478577.338944593, 8399344.942498738],
              [-15440241.911941642, 8379781.980754544],
              [-15433715.138876941, 8353684.93270208],
              [-15427191.482757982, 8344829.301948349],
              [-15318038.046616567, 8233107.314415057],
              [-15306269.461369392, 8177511.5043714745],
              [-15309288.346363604, 8160738.736807517],
              [-15354983.081510779, 8139573.195914283],
              [-15353697.130421866, 8146729.929950136],
              [-15356745.837316224, 8155794.048669541],
              [-15369473.77393505, 8171125.933979217],
              [-15387061.251604972, 8187353.260096561],
              [-15401931.977102084, 8195400.732544339],
              [-15432967.071898812, 8208665.004848359],
              [-15451945.263967212, 8225648.002453063],
              [-15464475.719809376, 8234298.974801576],
              [-15481366.33746693, 8242711.565300868],
              [-15503580.253174217, 8253676.686762443],
              [-15520182.108072652, 8262924.274344699],
              [-15543862.880710125, 8280461.241170734],
              [-15569289.36560222, 8299495.001190194],
              [-15556081.753297558, 8316468.824131779],
              [-15538618.953457328, 8320629.332324615],
              [-15538951.576095816, 8335225.915389394],
              [-15541152.139789818, 8360205.692926118],
              [-15559886.20821491, 8362835.637452206],
              [-15570393.209672924, 8355921.91415489],
              [-15593681.358466368, 8345679.268124134],
              [-15604345.877003852, 8341186.561643053],
              [-15611732.25917646, 8330575.020822819],
              [-15630581.209316049, 8333169.497049009],
              [-15672950.632026367, 8339554.009481488],
              [-15687435.969446354, 8344660.027597625],
              [-15713469.36820225, 8358350.411796055],
              [-15739775.722349571, 8370857.730106234],
              [-15750061.198020905, 8383064.193313203],
              [-15762325.155002108, 8391261.337101761],
              [-15778006.063753214, 8391261.337101761],
              [-15797595.845104031, 8401915.39830224],
              [-15814320.04012285, 8405034.371638501],
              [-15854853.470471516, 8415576.97559303],
              [-15890286.019113049, 8420724.780395688],
              [-15908541.413727732, 8419875.939249435],
              [-15926334.832455618, 8415027.455282962],
              [-15948500.546823395, 8412808.372893227],
              [-15988167.46625572, 8408037.425613465],
              [-16005699.95209719, 8402043.454687493],
              [-16018131.778870512, 8396782.194827696],
              [-16018131.667551022, 8405120.149818968],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rutherford',
        GEOID: '37161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9157786.409103831, 4227638.882115828],
              [-9154158.284259897, 4234691.748865235],
              [-9147016.693647545, 4235841.906109828],
              [-9124593.608617056, 4235595.1503655715],
              [-9110661.863024786, 4237818.887991122],
              [-9108619.595646692, 4242296.183743205],
              [-9100747.637855247, 4247581.115814939],
              [-9093910.617369706, 4242988.466771604],
              [-9095119.992317682, 4212543.968902652],
              [-9102387.08538934, 4188329.6002673497],
              [-9114217.653030455, 4188848.9124288517],
              [-9124787.237879336, 4189312.8933565533],
              [-9124723.741101792, 4198965.649665162],
              [-9145109.456811784, 4219427.497683072],
              [-9157286.584590169, 4217444.39817906],
              [-9159430.375343865, 4224256.659912458],
              [-9157786.409103831, 4227638.882115828],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McCurtain',
        GEOID: '40089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10592775.463379443, 4049898.1142894235],
              [-10592186.805912126, 4061599.8516176157],
              [-10580537.443839593, 4061568.205750163],
              [-10580555.36627761, 4097115.545629183],
              [-10568405.845732942, 4097061.780933048],
              [-10515369.197880393, 4097146.2985527036],
              [-10515843.008570176, 4077183.320995413],
              [-10516369.291295813, 4054324.7427854645],
              [-10516897.204147987, 4031441.5178545853],
              [-10517161.225207388, 4020870.5643470585],
              [-10517670.540650528, 4000506.0190448333],
              [-10518119.492156897, 3980279.4459485323],
              [-10522912.13019402, 3978136.703653604],
              [-10527803.953897439, 3984561.445823553],
              [-10534228.646989081, 3985031.6147176987],
              [-10543610.542353647, 3989561.737046739],
              [-10545510.532512743, 3991377.7010005424],
              [-10549319.117161019, 3995018.717391539],
              [-10557722.40288202, 3993867.409359471],
              [-10564473.039442707, 3998802.5146612176],
              [-10568623.475337444, 4003385.5020365273],
              [-10573308.912704933, 4008984.5804074113],
              [-10580535.55140825, 4010362.7585828914],
              [-10585927.199625332, 4016028.2900420027],
              [-10591989.659093935, 4020256.7064905604],
              [-10592707.181908188, 4020544.701998773],
              [-10592775.463379443, 4049898.1142894235],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nassau',
        GEOID: '12089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9133873.644608272, 3550988.512335565],
              [-9132736.29541011, 3551217.686857636],
              [-9132874.888176149, 3555490.28612255],
              [-9131341.016912509, 3561187.617821974],
              [-9130244.408608703, 3572011.9325298117],
              [-9129949.07799963, 3581129.3641827577],
              [-9133711.788107932, 3588095.309320217],
              [-9132855.184626278, 3592862.164526159],
              [-9131834.718854174, 3600411.5720074596],
              [-9127640.75703854, 3604997.8331955937],
              [-9121873.850817995, 3610358.772596906],
              [-9117731.812799564, 3609577.142192754],
              [-9117328.342050433, 3609501.0071747317],
              [-9113573.535625976, 3605863.7117361063],
              [-9106885.349299625, 3605508.6450145342],
              [-9101858.272414891, 3603410.1999424626],
              [-9098391.115554644, 3600276.989422384],
              [-9091271.67752096, 3599630.5210343106],
              [-9087374.382148288, 3597682.510582246],
              [-9079408.025428649, 3595868.819777436],
              [-9075686.72617092, 3596873.9184598736],
              [-9073342.003736341, 3596819.1422522482],
              [-9066318.411784232, 3595107.086044523],
              [-9064458.93101002, 3593593.0791109423],
              [-9066204.309306167, 3581031.072288855],
              [-9065198.53770685, 3570899.6306449724],
              [-9064629.777222972, 3568782.3130055196],
              [-9072491.188868208, 3576227.995219248],
              [-9077327.24150674, 3571070.2108046636],
              [-9084807.243371103, 3575011.128516522],
              [-9084355.954155428, 3579043.1548882416],
              [-9097196.546098942, 3577269.917220131],
              [-9100025.842276944, 3571965.7946615643],
              [-9109410.52062878, 3563777.133405185],
              [-9132377.401371794, 3540037.882085073],
              [-9133679.171497129, 3538745.620744483],
              [-9133873.644608272, 3550988.512335565],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chelan',
        GEOID: '53007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13482814.457366524, 6106372.890840882],
              [-13486719.21114508, 6113460.877974362],
              [-13471433.041308327, 6119307.090281689],
              [-13459352.984125916, 6134045.901983187],
              [-13469842.953701837, 6156242.228463628],
              [-13477627.637012502, 6159889.557436801],
              [-13475192.523151398, 6187991.209238989],
              [-13450060.255673474, 6198012.16595713],
              [-13436492.858774569, 6195752.383352647],
              [-13430950.706605937, 6196651.7859866265],
              [-13428842.426769802, 6185089.349108895],
              [-13430689.105802575, 6173348.4266518345],
              [-13420700.741852166, 6167131.928504492],
              [-13423256.63736078, 6160111.530266473],
              [-13414912.79624786, 6158641.193286845],
              [-13410561.53999173, 6151720.752108904],
              [-13396887.053742686, 6140190.1011100765],
              [-13398557.291382547, 6133108.849357594],
              [-13382056.625901243, 6120015.028654845],
              [-13374265.931338076, 6117655.683489801],
              [-13365688.541933473, 6101273.794076355],
              [-13343933.596486723, 6100278.4755895175],
              [-13357523.92520073, 6070854.245018365],
              [-13381648.639967486, 6065091.879284859],
              [-13380496.817196248, 6054158.71667357],
              [-13393581.978061033, 6019339.959918932],
              [-13393736.712153235, 6016981.188759518],
              [-13393057.551939905, 6015055.129879027],
              [-13392678.95435172, 6012932.022990392],
              [-13391334.437541919, 6009771.861934059],
              [-13390974.986906145, 6007736.556657143],
              [-13390235.268889824, 6006477.518737994],
              [-13387314.022812428, 6004961.6863997085],
              [-13367946.657804213, 5997574.5856567845],
              [-13368854.134293163, 5984970.5692551145],
              [-13401664.107051097, 5984769.796387894],
              [-13417393.88505866, 5996816.675086257],
              [-13432296.002652174, 5998291.327083305],
              [-13447676.460097628, 6011332.301352444],
              [-13460523.063293641, 6012441.4782896945],
              [-13469277.450688608, 6027128.387297826],
              [-13478004.008210875, 6032461.685018577],
              [-13482300.829236003, 6040117.500689035],
              [-13483193.054954711, 6054644.359128782],
              [-13477006.028975913, 6059340.147847357],
              [-13482925.331579354, 6070321.303740116],
              [-13477527.004192825, 6078058.234744199],
              [-13489782.278253747, 6090030.096489689],
              [-13482814.457366524, 6106372.890840882],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Snohomish',
        GEOID: '53061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13632028.549979208, 6156525.684567345],
              [-13603383.5959693, 6156514.13865092],
              [-13533945.50323871, 6156737.195130987],
              [-13469842.953701837, 6156242.228463628],
              [-13459352.984125916, 6134045.901983187],
              [-13471433.041308327, 6119307.090281689],
              [-13486719.21114508, 6113460.877974362],
              [-13482814.457366524, 6106372.890840882],
              [-13489782.278253747, 6090030.096489689],
              [-13477527.004192825, 6078058.234744199],
              [-13482925.331579354, 6070321.303740116],
              [-13580062.273967603, 6069561.956664271],
              [-13608096.640570508, 6069828.648162506],
              [-13611149.132327551, 6069851.176518239],
              [-13617422.987509169, 6069942.450091903],
              [-13629746.166459475, 6069970.279613499],
              [-13628803.513011437, 6078303.965520766],
              [-13625288.266131163, 6083863.6341062],
              [-13618086.006396333, 6095751.705761725],
              [-13619971.86988986, 6120226.305187771],
              [-13627499.2938573, 6135287.34175401],
              [-13624723.876312844, 6146446.0157635],
              [-13632028.549979208, 6156525.684567345],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cheyenne',
        GEOID: '08017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11484181.64799631, 4677382.478756969],
              [-11484055.411693752, 4727060.315099181],
              [-11434266.767561043, 4727212.94952757],
              [-11359772.320919638, 4728411.6038922835],
              [-11359676.798008231, 4678442.587416705],
              [-11359654.274900747, 4666696.16069714],
              [-11472825.278823543, 4666675.703462123],
              [-11485159.47840344, 4666309.421053263],
              [-11484181.64799631, 4677382.478756969],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ogemaw',
        GEOID: '26129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9392097.016661072, 5544274.592557128],
              [-9338217.381241709, 5544548.227410097],
              [-9337921.605354672, 5490513.170279413],
              [-9369328.173292177, 5490513.480631534],
              [-9391807.140707046, 5490319.512608079],
              [-9392097.016661072, 5544274.592557128],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Douglas',
        GEOID: '32005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13358629.978174409, 4737826.236977436],
              [-13331757.247944774, 4738015.565742072],
              [-13308358.670216465, 4733967.858052398],
              [-13281719.248152688, 4733655.790793756],
              [-13281574.755453639, 4724447.685036989],
              [-13291730.655237691, 4719283.016874329],
              [-13295948.105465883, 4704783.294974992],
              [-13285968.31311627, 4682954.695193228],
              [-13283610.624307182, 4655189.278112298],
              [-13312186.518350288, 4680665.795024685],
              [-13312439.531429455, 4680891.6501144385],
              [-13347687.289716275, 4712125.302827191],
              [-13358451.773156494, 4721610.551919035],
              [-13358558.779113531, 4731344.394105871],
              [-13358629.978174409, 4737826.236977436],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '23007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7884736.155794501, 5666808.15773714],
              [-7882378.742937971, 5670711.599308704],
              [-7883587.449969004, 5675434.557041408],
              [-7882115.0270642815, 5680998.928331189],
              [-7884271.062961966, 5684763.012113698],
              [-7879357.30931886, 5689655.9744212935],
              [-7876473.6892293515, 5689212.14508955],
              [-7873624.466862498, 5684613.03352324],
              [-7867838.413689534, 5683820.8521215],
              [-7863014.494875499, 5682116.243005381],
              [-7863107.669289295, 5689125.856308734],
              [-7867494.213824003, 5693025.861194917],
              [-7872892.429891041, 5702233.675919951],
              [-7868975.987565952, 5710750.073532021],
              [-7864675.047719662, 5716184.199808506],
              [-7858184.787447942, 5721341.136818312],
              [-7853904.430951595, 5727273.781548902],
              [-7850105.330125656, 5702508.968715851],
              [-7838953.67749646, 5644220.687709432],
              [-7826705.416563458, 5647247.9975890955],
              [-7825072.916230974, 5638840.090174345],
              [-7810105.899374328, 5641757.5078008305],
              [-7804650.13113055, 5613230.49192678],
              [-7808960.4218140645, 5605179.6758907335],
              [-7806828.096967921, 5598058.006962329],
              [-7796067.954987842, 5600221.231100929],
              [-7791940.3395887185, 5570892.078899706],
              [-7787928.1625015475, 5571475.875747001],
              [-7784622.196263967, 5560464.741557742],
              [-7786437.817158806, 5556008.320636272],
              [-7787187.442609809, 5554811.496956389],
              [-7796841.068851402, 5557004.908368954],
              [-7797087.084926053, 5554239.084001359],
              [-7800438.024237913, 5547865.904785853],
              [-7796321.318148888, 5544408.833384798],
              [-7797078.735964245, 5540843.070410582],
              [-7806767.9844428925, 5541152.335026416],
              [-7814770.297358056, 5539710.490163216],
              [-7818959.027157624, 5536741.39294947],
              [-7820293.859171728, 5543678.181385014],
              [-7826612.798747119, 5549060.564944496],
              [-7823617.07993038, 5554019.3795125615],
              [-7853588.405673088, 5560445.195192585],
              [-7849203.864889214, 5563023.958650888],
              [-7860829.181951735, 5589405.4168477105],
              [-7877994.424793079, 5579464.31298159],
              [-7878514.7320930455, 5596332.82385202],
              [-7884050.873009177, 5623692.700777302],
              [-7879175.969868357, 5624415.347803092],
              [-7885206.9857486235, 5664411.923716771],
              [-7884736.155794501, 5666808.15773714],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Floyd',
        GEOID: '19067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10355394.552946633, 5344420.3049472105],
              [-10303106.563606633, 5344420.457687494],
              [-10303087.639293198, 5297844.016507972],
              [-10355511.661050947, 5297910.43228002],
              [-10355394.552946633, 5344420.3049472105],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greene',
        GEOID: '19073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10534030.498295471, 5192397.741215098],
              [-10508284.526464803, 5192362.422964262],
              [-10482366.899979332, 5192476.493873074],
              [-10482303.893147541, 5140516.020397377],
              [-10495239.4406167, 5140479.399254813],
              [-10534021.370097226, 5140444.123511393],
              [-10534030.498295471, 5192397.741215098],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '21109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9369965.922654932, 4517109.504220109],
              [-9360896.501101023, 4518328.169845429],
              [-9346968.20641297, 4520462.229878645],
              [-9340325.32711937, 4515046.46591219],
              [-9338064.650900342, 4511513.581448821],
              [-9337918.933686892, 4505851.6327456655],
              [-9326900.753127158, 4487825.546719857],
              [-9339880.494434161, 4474534.133683614],
              [-9344571.94305415, 4474088.144899569],
              [-9351461.283700367, 4474478.611316727],
              [-9364746.040412145, 4485992.548566322],
              [-9366187.961776389, 4483771.283864634],
              [-9365209.129493844, 4489040.113768043],
              [-9373044.24053384, 4512239.207816541],
              [-9369965.922654932, 4517109.504220109],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '37069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8743568.476293402, 4311751.366718638],
              [-8738203.09947615, 4324755.340095988],
              [-8729883.748651205, 4323253.653805922],
              [-8725014.634123908, 4333014.346267326],
              [-8717091.469366696, 4337310.932030982],
              [-8697770.19062767, 4334576.467790953],
              [-8694973.622379962, 4329538.547073616],
              [-8683649.535859525, 4328539.30152408],
              [-8711415.065892166, 4275623.7380286055],
              [-8717140.895220608, 4286421.966870652],
              [-8743746.810117655, 4303625.011729436],
              [-8743568.476293402, 4311751.366718638],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Winnebago',
        GEOID: '19189',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10460777.15265692, 5388328.654390019],
              [-10424907.010567306, 5388317.987072279],
              [-10416913.711060666, 5388315.609969742],
              [-10408077.540043337, 5388317.255792705],
              [-10408109.118575353, 5350937.874601066],
              [-10460738.747432597, 5350921.061420824],
              [-10460777.15265692, 5388328.654390019],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yazoo',
        GEOID: '28163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10103329.488483282, 3873524.483854425],
              [-10091850.11127319, 3885022.9730220824],
              [-10068836.03106608, 3885126.4146749233],
              [-10068772.578956326, 3896499.951272367],
              [-10059277.916947588, 3896710.489641924],
              [-10057295.316816559, 3898275.5748134693],
              [-10014956.173007736, 3879330.180851773],
              [-10024223.186657803, 3860271.4353713267],
              [-10040204.991992522, 3851030.0397445243],
              [-10049680.173090372, 3850317.713129567],
              [-10059250.866311325, 3842770.3752131034],
              [-10063824.650229547, 3838989.725841065],
              [-10068852.061072752, 3838866.4770352393],
              [-10076887.101918211, 3829534.3339622836],
              [-10080405.243105242, 3830123.573668176],
              [-10080414.48262298, 3833335.999005212],
              [-10091622.685553499, 3835202.755322503],
              [-10091727.103235863, 3840978.6606893446],
              [-10098915.55935384, 3844822.3271714225],
              [-10095721.023926543, 3847125.6630659807],
              [-10099255.863037195, 3850542.500630523],
              [-10093079.746368492, 3851713.448200868],
              [-10101423.810120393, 3859418.0171574824],
              [-10096080.140603844, 3870859.011018538],
              [-10103329.488483282, 3873524.483854425],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Prairie',
        GEOID: '30079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11809525.995539567, 5971657.929745772],
              [-11795393.095627433, 5971668.08416827],
              [-11795401.778547715, 5957262.0404908005],
              [-11781235.260149363, 5957285.095456546],
              [-11781280.567182118, 5971683.152042859],
              [-11733776.644278448, 5971763.569075953],
              [-11724709.003836393, 5971749.319975141],
              [-11724698.317165276, 5938352.673223442],
              [-11710446.97331494, 5938348.757484424],
              [-11710477.697494399, 5928894.110101305],
              [-11696285.909571636, 5928890.85051952],
              [-11691610.7135973, 5919489.575002072],
              [-11644437.966178743, 5919391.242075091],
              [-11644832.148495642, 5914675.165258817],
              [-11644787.17542136, 5890796.437682377],
              [-11658806.752091866, 5886146.984258287],
              [-11658830.797101878, 5879083.59209386],
              [-11672821.319385285, 5879061.228609558],
              [-11672822.543899685, 5872024.098846247],
              [-11686847.79786422, 5872067.980411229],
              [-11686844.903557459, 5867373.895659334],
              [-11715178.385632128, 5867503.205571847],
              [-11715158.348123783, 5872210.313638266],
              [-11738550.8032801, 5872323.9875650555],
              [-11743306.705885261, 5877040.323448153],
              [-11743315.945402997, 5886447.51814244],
              [-11752673.573118571, 5886429.028442651],
              [-11757352.776594575, 5900539.409152709],
              [-11757359.567083513, 5914719.260904324],
              [-11781239.378970522, 5919385.869612607],
              [-11809504.622197334, 5919299.585061471],
              [-11809525.995539567, 5971657.929745772],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Onslow',
        GEOID: '37133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8644331.603030832, 4155803.0215424667],
              [-8646719.740066819, 4160334.8237437294],
              [-8627569.002787689, 4159755.427116923],
              [-8612429.21808133, 4151473.9629852073],
              [-8601371.296463381, 4153766.5184448613],
              [-8590078.268080875, 4134706.089385537],
              [-8582295.588521047, 4119293.240549638],
              [-8584175.929797145, 4114807.5222221985],
              [-8586834.084160687, 4114108.4700390706],
              [-8598427.786487825, 4107965.3296111305],
              [-8607503.998530675, 4100945.2522148495],
              [-8623133.032399068, 4092270.324028165],
              [-8628954.434473513, 4087684.4391122544],
              [-8635739.185494972, 4092979.655802519],
              [-8647312.182396822, 4125975.6495711757],
              [-8644331.603030832, 4155803.0215424667],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Renville',
        GEOID: '27129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10629106.582950663, 5604332.70494062],
              [-10603016.745212933, 5604426.669231382],
              [-10548433.347972777, 5604550.3327552],
              [-10519958.4901448, 5604581.445318596],
              [-10519472.357928507, 5601474.017696625],
              [-10519477.478625085, 5577105.204478234],
              [-10534106.529507682, 5577025.622495339],
              [-10533517.760720877, 5536287.23796168],
              [-10550931.468665669, 5536383.931150632],
              [-10554744.161225338, 5540720.58455505],
              [-10560415.22136431, 5542869.0851428425],
              [-10562030.578495212, 5545768.679745143],
              [-10590118.378453698, 5558211.86995252],
              [-10602537.84876354, 5569258.304965528],
              [-10615446.345596438, 5574186.976503705],
              [-10621644.280885335, 5579821.123434623],
              [-10629101.462254087, 5582642.254079926],
              [-10629106.582950663, 5604332.70494062],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Northampton',
        GEOID: '37131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8671763.18973574, 4375853.318018587],
              [-8656994.414399803, 4375935.302203676],
              [-8655057.681246728, 4375946.053411743],
              [-8604859.736364804, 4376017.9694760665],
              [-8592770.975243676, 4376035.288506666],
              [-8589893.099653801, 4376033.73933583],
              [-8578999.418398658, 4369157.358769839],
              [-8585288.524350515, 4365655.469854471],
              [-8594807.342688756, 4334603.383865506],
              [-8604801.829211159, 4329239.4397162935],
              [-8604052.537718628, 4323809.763619556],
              [-8606201.22652992, 4323962.826388136],
              [-8614636.349625291, 4330045.172165684],
              [-8621236.593553916, 4345418.039405959],
              [-8631836.65810623, 4342430.667810029],
              [-8636800.394200703, 4346885.780158383],
              [-8633413.721332299, 4358286.033189578],
              [-8643407.539937757, 4366960.116260351],
              [-8671735.344718393, 4370230.320570458],
              [-8671763.18973574, 4375853.318018587],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Trempealeau',
        GEOID: '55121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10198309.281778939, 5492122.642646134],
              [-10189044.160560215, 5503711.252230646],
              [-10188972.916086107, 5558173.412285722],
              [-10148510.284933586, 5558296.915127124],
              [-10148502.38124974, 5503815.060084602],
              [-10146986.655063098, 5477778.813634242],
              [-10164301.95657803, 5475487.388846336],
              [-10165934.456910511, 5463037.956809161],
              [-10177225.114167525, 5463012.410883479],
              [-10179113.905384, 5465674.469467949],
              [-10192325.253909148, 5469189.395479252],
              [-10189543.762434894, 5480317.573402599],
              [-10198309.281778939, 5492122.642646134],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wise',
        GEOID: '51195',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9224510.977926847, 4428090.197489229],
              [-9224955.254014602, 4435508.70172648],
              [-9219006.897024063, 4440109.864319923],
              [-9211767.456579305, 4442467.52506068],
              [-9208599.192551836, 4447187.072036742],
              [-9209048.923294643, 4454709.00235534],
              [-9191124.448441606, 4466448.16604592],
              [-9190334.33578044, 4466965.930078044],
              [-9189829.11727013, 4467223.6934816055],
              [-9188993.715152817, 4456561.001639643],
              [-9180222.852473214, 4442192.709486795],
              [-9168538.870039044, 4432936.104274965],
              [-9164692.11371519, 4435062.823727197],
              [-9161437.79972134, 4425979.21373478],
              [-9173464.423548173, 4421886.3926359955],
              [-9173961.465074565, 4423095.493299801],
              [-9196964.74729107, 4422501.085118052],
              [-9214091.807547066, 4411270.219953849],
              [-9222526.151406001, 4417894.192039885],
              [-9226577.314023376, 4424777.738246381],
              [-9224510.977926847, 4428090.197489229],
            ],
            [
              [-9199887.106563374, 4425193.375568578],
              [-9197029.869193183, 4426117.872526028],
              [-9197434.738181198, 4428945.876650084],
              [-9193799.822848326, 4431077.646231129],
              [-9196629.007706836, 4432183.181995513],
              [-9200821.522369092, 4429582.14561881],
              [-9199887.106563374, 4425193.375568578],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yolo',
        GEOID: '06113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13625944.3832099, 4710975.505949952],
              [-13618845.650601504, 4710826.26370846],
              [-13562664.484709993, 4710859.889525365],
              [-13553119.840249887, 4703244.982641254],
              [-13544668.35318937, 4684945.225253992],
              [-13536772.23906842, 4683902.959893301],
              [-13540209.784944119, 4676816.4399934085],
              [-13531285.857964674, 4665009.658962428],
              [-13530279.307128925, 4664208.857587951],
              [-13528398.007734515, 4665191.706873292],
              [-13526605.652613254, 4664664.659999929],
              [-13526015.993270522, 4662585.369023205],
              [-13527651.944507219, 4659723.278957974],
              [-13526574.928433796, 4656888.320942212],
              [-13526843.876323551, 4656008.312686838],
              [-13528757.124411814, 4654479.615189505],
              [-13527991.802912612, 4653270.566019634],
              [-13531082.477254996, 4652273.63826397],
              [-13531852.696811795, 4650577.647048465],
              [-13525884.747590877, 4645973.341292648],
              [-13527727.196482996, 4630422.075122823],
              [-13535701.2342475, 4623749.691933947],
              [-13546880.382790923, 4623840.917499296],
              [-13548921.648293601, 4655703.038802391],
              [-13574330.433386656, 4655051.533656555],
              [-13582277.309195405, 4648736.017844839],
              [-13592475.065107996, 4652200.654500948],
              [-13599713.058399376, 4672415.272669425],
              [-13605936.374532172, 4678787.514407873],
              [-13613037.667488856, 4698768.928786857],
              [-13624955.309534201, 4702244.446746245],
              [-13627944.015223019, 4707896.809402133],
              [-13625944.3832099, 4710975.505949952],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Buffalo',
        GEOID: '55011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10243929.901537364, 5557285.804551783],
              [-10202458.938437238, 5558244.074465417],
              [-10188972.916086107, 5558173.412285722],
              [-10189044.160560215, 5503711.252230646],
              [-10198309.281778939, 5492122.642646134],
              [-10189543.762434894, 5480317.573402599],
              [-10192325.253909148, 5469189.395479252],
              [-10193891.233828334, 5469606.119219462],
              [-10202194.554646604, 5475368.564594386],
              [-10210123.174058864, 5485404.182719481],
              [-10221055.304652218, 5490893.2043317435],
              [-10225196.164320897, 5496014.343209354],
              [-10229448.34898007, 5501276.146263867],
              [-10232063.577777274, 5514800.647603924],
              [-10237341.123516293, 5521651.9286859315],
              [-10250802.831519105, 5528272.184047915],
              [-10243929.901537364, 5557285.804551783],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Perquimans',
        GEOID: '37143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8525971.711042339, 4333538.386741635],
              [-8522580.808033284, 4349034.27675354],
              [-8510788.177776098, 4352771.742588878],
              [-8502012.750997372, 4336270.378939496],
              [-8492638.647997163, 4331417.953160388],
              [-8480028.932677556, 4315656.305468558],
              [-8477864.547818061, 4308813.91281373],
              [-8481065.20581735, 4307190.247079885],
              [-8500177.426552664, 4303376.305315466],
              [-8504452.206318617, 4304260.498349678],
              [-8505138.268340377, 4310652.396595255],
              [-8523964.620623333, 4315693.784275189],
              [-8525971.711042339, 4333538.386741635],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bent',
        GEOID: '08011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11510428.446216058, 4616991.034819999],
              [-11437223.858514475, 4617208.812975483],
              [-11437016.136344654, 4554601.683161887],
              [-11437812.182023317, 4529205.973841604],
              [-11474360.931199037, 4529174.763788388],
              [-11510918.36329504, 4529196.695167392],
              [-11510428.446216058, 4616991.034819999],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Howell',
        GEOID: '29091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10253899.45249383, 4410463.921004768],
              [-10252062.124298286, 4411048.898714707],
              [-10251268.082370458, 4446949.935764262],
              [-10203055.4995884, 4445928.49712607],
              [-10203334.243593346, 4423607.676864596],
              [-10205129.38170188, 4409574.421663339],
              [-10204918.482077906, 4369537.568504509],
              [-10239812.638850885, 4369423.235012755],
              [-10254799.259558342, 4369390.294250169],
              [-10253899.45249383, 4410463.921004768],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Lawrence',
        GEOID: '36089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8441816.291072948, 5531049.093068662],
              [-8438883.245129526, 5538722.659476187],
              [-8434258.142926047, 5545621.461218732],
              [-8412125.935725002, 5567951.278508694],
              [-8396154.92838089, 5583241.7007636735],
              [-8386114.021630827, 5591090.995757369],
              [-8377405.831824542, 5599139.318784011],
              [-8364875.821260342, 5605829.493134073],
              [-8356336.169163118, 5610535.501773368],
              [-8349535.661470558, 5614975.107996909],
              [-8348155.411104211, 5617971.991163041],
              [-8338715.518284942, 5618902.081657832],
              [-8330557.2467631735, 5623833.320295449],
              [-8320535.264326547, 5620038.149663107],
              [-8318439.500320991, 5620229.495743065],
              [-8309414.371479643, 5621053.548552426],
              [-8296161.082580924, 5491886.581405763],
              [-8297215.6121172095, 5480814.2178817745],
              [-8332728.199472625, 5476295.031760177],
              [-8355950.3358080285, 5473245.014986568],
              [-8367903.822729411, 5480459.09263646],
              [-8398624.106006175, 5499186.810319343],
              [-8444838.080116792, 5528362.200807323],
              [-8441816.291072948, 5531049.093068662],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Denver',
        GEOID: '08031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11695797.99624349, 4810669.478005597],
              [-11694473.850900503, 4835626.414969399],
              [-11665270.740963759, 4836667.685540793],
              [-11658662.81599027, 4851219.626396525],
              [-11648512.70481974, 4852326.816662355],
              [-11644067.160954911, 4851342.673694275],
              [-11646238.224983852, 4840170.439248579],
              [-11662104.814645598, 4840251.461613954],
              [-11659002.45175668, 4832456.765618594],
              [-11675705.384752758, 4828253.993148185],
              [-11676492.302233174, 4821949.028584598],
              [-11677809.100489767, 4822230.428231163],
              [-11677282.114020353, 4820900.324115832],
              [-11677279.219713593, 4821097.210019195],
              [-11677206.194127632, 4821096.4866987085],
              [-11677277.215962758, 4821191.2421287745],
              [-11677277.215962758, 4821219.162602551],
              [-11671527.89822176, 4816191.119281493],
              [-11678907.044627463, 4811464.476978675],
              [-11680943.746031016, 4815650.934133346],
              [-11683637.677708214, 4815644.28321336],
              [-11685595.008314831, 4817767.886610459],
              [-11690293.804021217, 4819358.788128266],
              [-11692112.98713976, 4816235.509455609],
              [-11692422.900602128, 4812002.990642033],
              [-11694495.112923246, 4811016.604851385],
              [-11695016.978696086, 4810069.476994941],
              [-11699339.514523586, 4810580.891776728],
              [-11695797.99624349, 4810669.478005597],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Perry',
        GEOID: '29157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10035093.423614277, 4528921.431582422],
              [-10031059.093948437, 4533100.652153343],
              [-10018728.345272755, 4554274.732954328],
              [-10011306.428907353, 4562501.65023269],
              [-10010203.164709335, 4561172.1790170595],
              [-10002172.910601981, 4565870.273290496],
              [-9994490.418583864, 4558975.348742709],
              [-9984975.27378882, 4553230.956822708],
              [-9983935.814780165, 4550704.699344508],
              [-9981795.32121482, 4545504.464261297],
              [-9973256.670993011, 4540452.869198614],
              [-9965537.666181915, 4536636.1995506715],
              [-9963825.01581606, 4526592.52526749],
              [-9962432.186347255, 4520278.920146404],
              [-9962843.503632458, 4518856.084294799],
              [-9963293.804716287, 4517298.616895901],
              [-9974496.770120448, 4523497.210415242],
              [-10003294.454471724, 4522972.000070488],
              [-10035091.753821913, 4522711.793270591],
              [-10035093.423614277, 4528921.431582422],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Westchester',
        GEOID: '36119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8235703.578450589, 5059907.730610554],
              [-8213152.809964159, 5062991.165937441],
              [-8186897.460893641, 5066524.798884355],
              [-8187655.525875923, 5056014.481766061],
              [-8180057.7479903, 5043774.547221169],
              [-8203794.047031296, 5029356.709896114],
              [-8207338.370321046, 5027205.6656565415],
              [-8199741.70563033, 5014975.924173135],
              [-8199722.669997406, 5012936.69613632],
              [-8199501.3678806815, 5010206.821911841],
              [-8199497.136709058, 5010154.635722668],
              [-8204020.938175915, 5003436.460791003],
              [-8210566.746873542, 4999458.571170673],
              [-8211624.282036075, 4994819.580705667],
              [-8208832.527794025, 4994047.453709213],
              [-8209596.486191786, 4993438.913513631],
              [-8218055.320338695, 4996110.470930334],
              [-8221097.904661057, 4999082.215160817],
              [-8228789.249849179, 5000343.519088235],
              [-8227320.775515893, 5005190.259988842],
              [-8225840.114968851, 5011928.230778184],
              [-8225795.587172533, 5013123.001536169],
              [-8225116.649598184, 5032761.594664386],
              [-8234390.008459228, 5048974.87137927],
              [-8235703.578450589, 5059907.730610554],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carroll',
        GEOID: '05015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10449199.726538556, 4369483.496320534],
              [-10430655.322962658, 4369520.724620235],
              [-10417754.568105983, 4369488.414282059],
              [-10400244.841828771, 4369444.560788655],
              [-10387814.696706578, 4369406.856609953],
              [-10385379.053978251, 4369399.4686257625],
              [-10386389.016129224, 4367216.246505097],
              [-10386199.772994876, 4317359.379800574],
              [-10406093.456555558, 4317844.761661312],
              [-10414064.711332792, 4318010.005940335],
              [-10421727.83375951, 4328342.719159692],
              [-10425926.24835478, 4342405.527891228],
              [-10443505.377062889, 4342886.373541487],
              [-10451847.325744465, 4352752.800388159],
              [-10449199.726538556, 4369483.496320534],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harrison',
        GEOID: '48203',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10542194.001833305, 3867871.950747833],
              [-10520507.07259543, 3854723.005132418],
              [-10507533.899138384, 3854807.5297997994],
              [-10491061.50880774, 3862264.0877325707],
              [-10483669.00406314, 3854849.461666836],
              [-10474355.681504901, 3860085.5016580108],
              [-10468824.608699977, 3854629.3510082844],
              [-10468828.112189561, 3837608.6991876955],
              [-10468795.298855547, 3814914.76232841],
              [-10503027.68615107, 3806260.563505446],
              [-10506983.5355759, 3811608.4378152755],
              [-10518781.063890683, 3815159.15706703],
              [-10525811.223692749, 3816934.584207788],
              [-10528510.498705504, 3815261.8572432348],
              [-10542176.85863172, 3818804.303279276],
              [-10542155.040011527, 3849230.99197038],
              [-10542194.001833305, 3867871.950747833],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '05047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10472369.407830678, 4224575.5821794],
              [-10466594.04132883, 4242189.566734523],
              [-10472515.68164158, 4242365.437451942],
              [-10472236.714997653, 4254275.646500054],
              [-10462273.731891144, 4254045.464737068],
              [-10454106.443490624, 4267613.774080727],
              [-10453029.650056181, 4269581.274817802],
              [-10430188.894296233, 4268834.34830765],
              [-10431757.942518966, 4214992.682351347],
              [-10442530.663601505, 4222472.560136684],
              [-10442891.116112692, 4206511.326586609],
              [-10454806.754407205, 4207323.192025747],
              [-10455145.165659215, 4195103.231327297],
              [-10467209.97207139, 4192977.343914998],
              [-10471253.763893947, 4191072.9633622593],
              [-10472918.769517742, 4202938.382443925],
              [-10472369.407830678, 4224575.5821794],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Herkimer',
        GEOID: '36043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8373352.577845268, 5319961.576802733],
              [-8356661.222076235, 5346638.5107002705],
              [-8356827.644714969, 5346647.218974169],
              [-8356994.73527065, 5346682.663260726],
              [-8357068.762732028, 5346724.218802974],
              [-8357143.124151878, 5346840.789199763],
              [-8357175.740762681, 5346970.3475258835],
              [-8357171.399302539, 5347106.171810218],
              [-8357147.020334056, 5347209.760166335],
              [-8357065.868425269, 5347301.585026607],
              [-8356977.480749579, 5347339.476414232],
              [-8356820.63158705, 5347387.299232421],
              [-8356769.758579757, 5347438.636460755],
              [-8356749.609751925, 5347497.002343921],
              [-8356783.562196616, 5347599.372708419],
              [-8356826.976798025, 5347662.781782229],
              [-8356920.26253131, 5347730.469535099],
              [-8357088.354962409, 5347781.961450902],
              [-8357163.050340732, 5347777.988770704],
              [-8357253.887045218, 5347752.166390724],
              [-8357342.497359889, 5347707.855964734],
              [-8357513.150139275, 5347562.702597738],
              [-8357599.42274464, 5347509.683984717],
              [-8357804.361927189, 5347358.727742818],
              [-8357966.331786295, 5347315.335915581],
              [-8358008.299234324, 5347285.236773916],
              [-8358070.304190696, 5347217.246685099],
              [-8358153.014572356, 5347167.896886622],
              [-8358305.18831627, 5347128.172780624],
              [-8358450.794210227, 5347117.783427009],
              [-8358624.118657393, 5347123.283671597],
              [-8358772.284899637, 5347117.1722889235],
              [-8358827.722006054, 5347122.36696394],
              [-8359080.639889134, 5347121.144687205],
              [-8359327.1012417525, 5347166.216247936],
              [-8359434.190591895, 5347205.787730251],
              [-8359840.3954138, 5347393.1052142875],
              [-8360088.415239287, 5347515.642833946],
              [-8360234.91168917, 5347630.695208984],
              [-8360365.712090853, 5347743.151493869],
              [-8360552.283557422, 5347884.48774544],
              [-8360696.55361749, 5347985.945577452],
              [-8360829.135131026, 5348046.759687412],
              [-8360932.662257463, 5348086.182111593],
              [-8361159.531379699, 5348139.6624112055],
              [-8361333.4124243185, 5348227.981978523],
              [-8361424.471767788, 5348284.519165565],
              [-8361537.015772981, 5348379.4107295275],
              [-8361617.165806349, 5348432.128682952],
              [-8361673.15951022, 5348451.229464382],
              [-8361806.965538152, 5348416.084056831],
              [-8361947.562055026, 5348420.362621093],
              [-8362064.558839849, 5348455.04962537],
              [-8362216.398625291, 5348540.621642309],
              [-8362289.201572269, 5348589.520290825],
              [-8362382.821264027, 5348635.057388195],
              [-8362564.717311984, 5348706.572473888],
              [-8362618.929904, 5348734.07842235],
              [-8362664.793534205, 5348781.297156703],
              [-8362692.178128941, 5348843.186151748],
              [-8362675.368885831, 5349023.812682416],
              [-8362723.347586363, 5349303.622628377],
              [-8362734.813493915, 5349469.739884403],
              [-8362756.854753091, 5349567.241549481],
              [-8362801.716507883, 5349606.670412484],
              [-8362928.732046877, 5349678.040135744],
              [-8362984.2804727815, 5349679.721227898],
              [-8363024.2441699775, 5349706.924397691],
              [-8363082.464263663, 5349702.798069068],
              [-8363162.948255507, 5349731.071098151],
              [-8363632.827826144, 5349779.059030559],
              [-8363977.361650149, 5349845.081048865],
              [-8364145.565400739, 5349903.462019961],
              [-8364223.823002767, 5349985.99071891],
              [-8364286.16191761, 5350090.3752879575],
              [-8364326.014295314, 5350112.688978729],
              [-8364418.520792163, 5350264.606897905],
              [-8364644.833316946, 5350376.025136956],
              [-8364763.165935659, 5350514.8030803],
              [-8364806.580537069, 5350662.600808318],
              [-8364847.434790189, 5350866.49521781],
              [-8364901.090784754, 5350892.93762358],
              [-8364972.669217333, 5350896.60594014],
              [-8365039.238272827, 5350872.456216021],
              [-8365074.637870899, 5350802.605784414],
              [-8365085.4358615065, 5350574.258140659],
              [-8365130.96553324, 5350466.964194338],
              [-8365161.021795753, 5350441.287194005],
              [-8365357.834655479, 5350406.439949704],
              [-8365436.648854959, 5350317.946876124],
              [-8365500.100964711, 5350184.979590833],
              [-8365516.910207821, 5350112.688978729],
              [-8365498.0972138755, 5350048.499053772],
              [-8365460.137267517, 5349975.139681529],
              [-8365426.741420278, 5349868.158299963],
              [-8365464.144769184, 5349696.379339291],
              [-8365504.887702814, 5349648.697485212],
              [-8365586.373570075, 5349601.932827094],
              [-8365634.018312135, 5349595.055691302],
              [-8365768.15829854, 5349628.830118095],
              [-8365837.844299777, 5349710.4394198125],
              [-8365861.555351316, 5349807.17946259],
              [-8365835.729229453, 5350112.688978729],
              [-8365818.919986342, 5350155.941011108],
              [-8365804.003174577, 5350387.335156222],
              [-8365934.469617786, 5350655.875731468],
              [-8365991.7991555445, 5350861.756991189],
              [-8365983.004915771, 5351073.451082515],
              [-8365938.477119455, 5351296.002553439],
              [-8365969.757896368, 5351375.027948051],
              [-8366044.1193162175, 5351434.641358967],
              [-8366132.395672417, 5351424.094343081],
              [-8366189.5025711935, 5351321.070497634],
              [-8366223.677654866, 5351186.866071029],
              [-8366256.628224142, 5351124.350091058],
              [-8366403.458632497, 5350995.34533741],
              [-8366500.52922847, 5350952.242251884],
              [-8366595.150795643, 5350948.879608216],
              [-8366811.889844218, 5350989.384260497],
              [-8366982.876582077, 5351225.3846834],
              [-8357486.767419957, 5362444.754930448],
              [-8361224.764601304, 5406089.785387961],
              [-8367903.822729411, 5480459.09263646],
              [-8355950.3358080285, 5473245.014986568],
              [-8332728.199472625, 5476295.031760177],
              [-8323983.608192851, 5386344.885756765],
              [-8334235.576697457, 5363840.705135391],
              [-8316970.257633894, 5355627.644932295],
              [-8315119.014502, 5338521.052088098],
              [-8322647.440344859, 5320798.419837993],
              [-8322233.443158599, 5319192.899003824],
              [-8320442.312551735, 5316652.111749091],
              [-8322612.8199832225, 5291178.237546764],
              [-8335472.33624017, 5296500.907950329],
              [-8338579.931145154, 5285364.231514651],
              [-8360204.966746148, 5298034.146209187],
              [-8372410.369675194, 5290162.568745908],
              [-8372579.130023237, 5293720.321649542],
              [-8373352.577845268, 5319961.576802733],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Texas',
        GEOID: '40139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11357727.73709927, 4438151.3522242615],
              [-11343727.731392112, 4438228.963623774],
              [-11305079.702415371, 4438450.425239011],
              [-11297294.813309368, 4438495.034907366],
              [-11266811.083950536, 4438705.917521118],
              [-11250665.774291005, 4438791.243957095],
              [-11237197.961294752, 4438862.420601723],
              [-11238164.811661048, 4369575.354725405],
              [-11252748.092678623, 4369535.818971088],
              [-11312722.470218915, 4369575.147471277],
              [-11335281.365028173, 4369592.596077415],
              [-11358188.02403762, 4369649.605165908],
              [-11357727.73709927, 4438151.3522242615],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McLean',
        GEOID: '38055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11397508.960381612, 6081563.132019437],
              [-11340323.804002635, 6081536.426117499],
              [-11240076.483722132, 6081721.212751576],
              [-11197088.90387944, 6081518.345771322],
              [-11197082.781307446, 6052775.851986127],
              [-11206801.195492681, 6052796.682593024],
              [-11206898.822686108, 5995683.053842213],
              [-11215364.558641445, 5995725.59070661],
              [-11215368.566143112, 5967778.334075781],
              [-11239378.287875878, 5967658.337035137],
              [-11240778.241792094, 5982975.020996967],
              [-11247122.784850366, 5988946.631358391],
              [-11271881.130158717, 5985419.372449473],
              [-11281755.614270044, 5989849.924119108],
              [-11283625.893034862, 6002348.940797694],
              [-11292264.61947889, 6020332.400200519],
              [-11284553.18439317, 6027153.276953633],
              [-11290917.431001311, 6034291.8173514],
              [-11314701.842084711, 6028749.496338121],
              [-11322031.22867803, 6030381.627454737],
              [-11333865.715063753, 6023495.76020922],
              [-11358667.697612496, 6036060.296225846],
              [-11377447.518348303, 6036357.470510996],
              [-11384138.04238396, 6044578.944686164],
              [-11383759.444795772, 6070665.218552676],
              [-11391941.76132755, 6073830.177745936],
              [-11397530.445043335, 6066689.997181732],
              [-11397508.960381612, 6081563.132019437],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hancock',
        GEOID: '13141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9267732.885297662, 3929771.164068045],
              [-9255754.35149085, 3936529.932373695],
              [-9257797.175466396, 3942523.6305672782],
              [-9240948.525256872, 3957746.370284744],
              [-9237698.441403672, 3954877.4737890633],
              [-9223037.330507724, 3954325.9522220776],
              [-9219937.194008622, 3952202.8261752706],
              [-9212338.636886565, 3928992.4037652137],
              [-9211499.84452344, 3926983.5760154417],
              [-9223381.530373259, 3921405.4799963357],
              [-9227146.355551885, 3913715.6773145837],
              [-9240490.668191241, 3906040.2394111957],
              [-9245328.279302642, 3906018.05262206],
              [-9250795.513453973, 3901970.000636544],
              [-9250387.972798178, 3915435.149531914],
              [-9270031.298824068, 3920183.129346],
              [-9267732.885297662, 3929771.164068045],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cassia',
        GEOID: '16031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12722197.876441145, 5223700.35881489],
              [-12698121.029055433, 5223668.844160967],
              [-12697888.482639164, 5238356.255172821],
              [-12690465.142395616, 5240156.611282833],
              [-12682829.849841595, 5241496.528740356],
              [-12665724.27424732, 5244696.937082325],
              [-12656919.681762006, 5239071.674358886],
              [-12651921.993222844, 5241634.307818207],
              [-12641128.90067349, 5259878.200203844],
              [-12631664.96284421, 5261778.507204552],
              [-12620637.654086227, 5264547.378053164],
              [-12612988.112637386, 5255633.301320856],
              [-12605481.616734214, 5255104.525506288],
              [-12598658.845143495, 5249691.387137547],
              [-12579413.263658209, 5249470.480983161],
              [-12579098.563457737, 5210153.310046322],
              [-12579106.927962419, 5160713.952701085],
              [-12579193.852941856, 5160713.261784365],
              [-12606838.712646475, 5160410.6888324665],
              [-12634377.930154333, 5159976.618270285],
              [-12670157.795607144, 5159268.936906446],
              [-12695066.533547556, 5160038.776920894],
              [-12721791.723629933, 5160112.751599109],
              [-12722197.876441145, 5223700.35881489],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'La Salle',
        GEOID: '48283',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11064682.71854265, 3330004.8496807017],
              [-10998459.310067184, 3330855.080613223],
              [-10998460.089303622, 3330832.1212542434],
              [-10998374.818573672, 3274507.3842322812],
              [-10998735.827682316, 3256222.6373096374],
              [-11063926.859200163, 3252809.4711991367],
              [-11064486.35096089, 3273896.2856804687],
              [-11064509.171456505, 3274797.1541504846],
              [-11064682.71854265, 3330004.8496807017],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Logan',
        GEOID: '08075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11529779.781907223, 5012595.632136616],
              [-11508486.327628251, 5012625.774185802],
              [-11474427.500254532, 5012673.986513086],
              [-11427331.355926355, 5012669.904191896],
              [-11427091.55846247, 4975448.489061515],
              [-11428580.901929794, 4968953.878711795],
              [-11428593.703671236, 4929866.068247792],
              [-11441412.810953027, 4929862.119208175],
              [-11517713.08237408, 4929554.976540786],
              [-11517916.017805796, 4942273.884623486],
              [-11530678.1295083, 4942292.922568438],
              [-11529779.781907223, 5012595.632136616],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Warren',
        GEOID: '34041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8370403.279256192, 4970523.042393555],
              [-8368718.458763036, 4977626.860508184],
              [-8361358.206800663, 4981413.27877571],
              [-8361040.53084404, 4981576.737494652],
              [-8359087.653017055, 4990122.165912385],
              [-8356246.334334048, 4995494.379710935],
              [-8359839.950135836, 5001532.840997888],
              [-8362682.375803069, 5007225.584164122],
              [-8363776.875247231, 5009418.510321124],
              [-8356813.395820149, 5015088.497655202],
              [-8354790.34227529, 5017155.477848882],
              [-8350661.7694394225, 5021375.059619443],
              [-8348114.222356304, 5026073.007682596],
              [-8347074.061835872, 5027991.828450128],
              [-8344805.69630675, 5025703.559412821],
              [-8325630.134781174, 5002086.250715237],
              [-8323294.317905858, 4999213.312081087],
              [-8332320.992775302, 4983468.08130744],
              [-8336696.516680425, 4981081.978188549],
              [-8345416.728991714, 4969829.113501484],
              [-8347112.570114459, 4968980.751366076],
              [-8365215.457026752, 4957711.579364713],
              [-8369912.124095771, 4952436.665797953],
              [-8370027.509334008, 4954847.550327736],
              [-8370230.400086989, 4959088.233455322],
              [-8370403.279256192, 4970523.042393555],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Orange',
        GEOID: '50017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8103094.457682083, 5459541.053039565],
              [-8097636.129090015, 5470032.510336475],
              [-8091120.487974394, 5467444.586969772],
              [-8085013.278070494, 5479169.534814695],
              [-8081950.322281317, 5486336.3181007225],
              [-8080607.586583369, 5490279.788463874],
              [-8064321.433760823, 5485375.64629408],
              [-8056008.205507872, 5497074.9690123405],
              [-8048953.55541783, 5493828.79680301],
              [-8033956.593618159, 5495211.089402113],
              [-8020995.318390674, 5490207.648276499],
              [-8019109.133894625, 5481413.978314226],
              [-8023406.400197717, 5470800.342994128],
              [-8023875.085627236, 5470125.663080384],
              [-8023902.68742353, 5470085.931414988],
              [-8027994.989608216, 5464197.13070759],
              [-8026789.288203434, 5457610.414307941],
              [-8033903.16026258, 5445875.2588084545],
              [-8035411.8733212985, 5435804.960816077],
              [-8038547.645677385, 5430383.341170915],
              [-8078950.039365457, 5445863.368226576],
              [-8102189.652860915, 5454456.2351635555],
              [-8103094.457682083, 5459541.053039565],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Maricopa',
        GEOID: '04013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12616274.264005603, 3945508.6437692684],
              [-12616208.696825527, 3970712.85176344],
              [-12616255.673650641, 4028698.2315927525],
              [-12550599.215341786, 4028788.3300347137],
              [-12498511.601085214, 4013010.3289425764],
              [-12489563.51777627, 4025378.7813496185],
              [-12486123.745510759, 4035271.915631985],
              [-12437204.617920637, 4028781.7505416884],
              [-12411541.91306908, 4028777.4537319667],
              [-12406009.445696145, 4028959.9352952433],
              [-12406657.881730016, 4018048.5320741045],
              [-12397909.616907045, 4005183.754056179],
              [-12399816.185825862, 3998852.6023038123],
              [-12388355.39897073, 3982888.1214684974],
              [-12381182.527581466, 3975544.3405254795],
              [-12373534.767244479, 3985594.103748347],
              [-12360913.586017318, 3957324.817668948],
              [-12421099.359270629, 3957295.5937930937],
              [-12421367.973201912, 3922605.8736050385],
              [-12432818.741302872, 3922497.7093843776],
              [-12453305.31247152, 3922357.4832184566],
              [-12455881.245488476, 3922520.858837889],
              [-12477076.810493989, 3922487.465100671],
              [-12490412.885491023, 3936594.9357748367],
              [-12490287.65106388, 3928116.793340094],
              [-12490437.487098489, 3853381.53812165],
              [-12490460.864191554, 3830016.12499977],
              [-12531066.095611783, 3829812.714398252],
              [-12616271.703657314, 3829775.62302906],
              [-12616250.775593046, 3864530.4509017183],
              [-12616274.264005603, 3945508.6437692684],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Woodford',
        GEOID: '17203',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9970040.09430654, 4981950.653955491],
              [-9960014.215687735, 5000726.50449813],
              [-9925246.133086743, 5001592.80693166],
              [-9912746.62406302, 5001395.819488675],
              [-9899797.05033802, 5001689.165741317],
              [-9899567.843506476, 4976026.72489281],
              [-9905975.949993992, 4975873.896848026],
              [-9905731.492392212, 4963047.357492999],
              [-9912373.703768862, 4957541.729648254],
              [-9922323.88513393, 4953040.7585094115],
              [-9937423.038226148, 4952688.176397173],
              [-9943874.336676091, 4955802.039685886],
              [-9944188.70291809, 4975280.241352094],
              [-9969216.330074668, 4975189.138997938],
              [-9970040.09430654, 4981950.653955491],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Douglas',
        GEOID: '20045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10631091.966068959, 4703040.806986291],
              [-10631039.645908287, 4729790.310715427],
              [-10622043.36125983, 4731302.689106697],
              [-10607124.991020657, 4726279.550737664],
              [-10596179.836046882, 4727991.779228659],
              [-10596078.090032298, 4716593.790236916],
              [-10581614.237274038, 4719110.739509456],
              [-10581631.38047562, 4684295.277588117],
              [-10631093.524541833, 4684326.817789396],
              [-10631091.966068959, 4703040.806986291],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ascension',
        GEOID: '22005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10141926.627609089, 3517452.5436067972],
              [-10140103.214349896, 3521701.1445346675],
              [-10138248.075035825, 3524227.606312207],
              [-10136671.902365685, 3530973.0516249505],
              [-10132773.827756576, 3542894.731636204],
              [-10132412.929967424, 3544941.5554825943],
              [-10128622.946583876, 3548067.944316803],
              [-10118020.878280725, 3548005.38315558],
              [-10111233.061010115, 3544572.218077934],
              [-10096071.569003053, 3526085.343139359],
              [-10089198.369683003, 3532041.7724660756],
              [-10090221.06184492, 3524960.8571146],
              [-10120674.400982765, 3518119.901172247],
              [-10126031.985435663, 3512094.234294001],
              [-10138375.981130747, 3514047.0689084223],
              [-10139992.562776048, 3511587.9689200413],
              [-10141868.073556932, 3511583.3385369657],
              [-10141926.627609089, 3517452.5436067972],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montrose',
        GEOID: '08085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12140499.435773766, 4650299.987597422],
              [-12064710.232134946, 4650299.987597422],
              [-12064661.474197976, 4674240.21222767],
              [-11966918.174543379, 4674305.226638355],
              [-11966847.486666726, 4622166.071244876],
              [-11981877.844313633, 4622161.815672434],
              [-11981950.981219083, 4626454.029256287],
              [-12037241.47986476, 4626372.430418952],
              [-12032145.718854206, 4615540.290444983],
              [-12015557.333614156, 4610408.396087728],
              [-12018696.654574018, 4600967.055710811],
              [-12138477.274349362, 4601066.758310871],
              [-12138473.421041328, 4602717.18118135],
              [-12140510.567722844, 4618416.601210922],
              [-12140499.435773766, 4650299.987597422],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dutchess',
        GEOID: '36027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8237654.341207249, 5079917.564378013],
              [-8232444.477718633, 5099756.499848984],
              [-8231083.485624194, 5121514.148085054],
              [-8233680.791983384, 5147978.301168782],
              [-8229808.320857159, 5172787.320687757],
              [-8205463.193498632, 5161801.555287227],
              [-8184996.2145603625, 5157681.525340629],
              [-8180833.749707664, 5169041.489660893],
              [-8180570.374245403, 5168417.878245771],
              [-8182540.0613155, 5134617.938653174],
              [-8183977.283955082, 5111185.7988163205],
              [-8184210.855552816, 5107383.107338173],
              [-8185286.281349535, 5090411.518672469],
              [-8190863.976239567, 5090307.429369799],
              [-8201272.571267719, 5088558.9502088325],
              [-8230270.185424459, 5084631.68021742],
              [-8235581.349649697, 5077297.198737168],
              [-8237654.341207249, 5079917.564378013],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Broomfield',
        GEOID: '08014',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11707042.266689027, 4853459.673926041],
              [-11700737.90996693, 4859695.021876218],
              [-11696550.293362271, 4858707.825590646],
              [-11694426.762755899, 4865980.062066537],
              [-11684212.976836635, 4872359.24039142],
              [-11684240.69538984, 4868119.661818753],
              [-11684258.840466842, 4868119.225771248],
              [-11684264.963038836, 4866000.987855842],
              [-11684250.15754656, 4866003.167628101],
              [-11684250.15754656, 4865991.251545606],
              [-11687228.39920324, 4861360.902128375],
              [-11690310.390625345, 4863209.673771147],
              [-11694434.443800762, 4853485.362809014],
              [-11706932.839629577, 4850185.828046106],
              [-11707042.266689027, 4853459.673926041],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Schuylkill',
        GEOID: '42107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8536787.40144832, 4963142.309267005],
              [-8522888.272466853, 4969496.779389253],
              [-8502599.627352836, 4979285.764201261],
              [-8494475.308275761, 4983152.34169382],
              [-8491964.051882956, 4995186.054228133],
              [-8483416.496101884, 5004931.149420654],
              [-8463414.943954622, 4997895.352785999],
              [-8459986.080999209, 4999515.43091661],
              [-8447594.997159518, 4985278.74448872],
              [-8433320.498855095, 4973393.273563986],
              [-8438884.469643926, 4969292.068372144],
              [-8448200.12991147, 4964854.974760781],
              [-8459525.663585287, 4959343.636170522],
              [-8462182.63719154, 4949775.05796882],
              [-8479386.396576695, 4943986.568748004],
              [-8509282.025065664, 4938276.58745265],
              [-8519883.314132381, 4946947.197180466],
              [-8538385.72669713, 4962038.900284303],
              [-8536787.40144832, 4963142.309267005],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scott',
        GEOID: '47151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9438260.986854061, 4383965.216126283],
              [-9437494.537059514, 4383942.823109911],
              [-9406490.070223188, 4383037.018949762],
              [-9379927.36971997, 4382491.2446153965],
              [-9378793.112996876, 4374374.8615604],
              [-9380545.838379415, 4371260.592350125],
              [-9387620.971255764, 4370953.397851821],
              [-9389792.257923687, 4364973.583893711],
              [-9387564.532273931, 4339920.004434237],
              [-9392329.451757848, 4330490.834262952],
              [-9395769.446662342, 4324697.282046636],
              [-9399932.9069375, 4323139.070885757],
              [-9414705.782602204, 4332312.16917022],
              [-9428848.255990544, 4351766.8841633275],
              [-9424209.572809188, 4355140.471983485],
              [-9432305.171457637, 4373057.953552706],
              [-9438267.552316247, 4383965.690358785],
              [-9438260.986854061, 4383965.216126283],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kings',
        GEOID: '36047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8245180.911389708, 4963843.776681525],
              [-8242909.177770146, 4966792.120108005],
              [-8242870.61578939, 4966892.434674884],
              [-8242223.810861073, 4968575.176812677],
              [-8241085.106132295, 4971538.360190446],
              [-8233809.8112732135, 4970974.82024125],
              [-8233483.97912366, 4971532.521491758],
              [-8233465.388768698, 4973597.1889870735],
              [-8229084.855486492, 4970691.942591654],
              [-8229038.546578322, 4970611.7513512205],
              [-8224241.233122587, 4966886.080529377],
              [-8223027.9619924305, 4967402.291692969],
              [-8222479.15690282, 4965419.226376583],
              [-8220759.382089555, 4959902.435357705],
              [-8218216.399767785, 4950023.414540903],
              [-8231028.939073707, 4945150.936952686],
              [-8234724.831911279, 4947782.033570186],
              [-8236678.959828919, 4949173.457483099],
              [-8241711.898180671, 4951905.271564356],
              [-8241869.178089705, 4951990.653338611],
              [-8242250.16638465, 4953974.979176654],
              [-8243946.341465866, 4957521.048666298],
              [-8243847.155799571, 4961111.246611949],
              [-8245539.717195785, 4963378.1859013755],
              [-8245180.911389708, 4963843.776681525],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hardin',
        GEOID: '39065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9337485.900867706, 4985815.933788372],
              [-9296945.568710612, 4985553.366320221],
              [-9294790.757327328, 4984340.205130804],
              [-9294654.056992631, 4968417.175315634],
              [-9286253.66557839, 4966257.2969596265],
              [-9285824.083663419, 4942672.517609332],
              [-9286091.361760814, 4939635.143330008],
              [-9297429.140578618, 4939466.045585506],
              [-9335160.99330249, 4943357.495342799],
              [-9337471.318014413, 4944537.462185802],
              [-9337500.483721001, 4960073.939849492],
              [-9337485.900867706, 4985815.933788372],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scott',
        GEOID: '51169',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9233683.14737076, 4394023.031994254],
              [-9219854.038349, 4402039.2455556225],
              [-9214091.807547066, 4411270.219953849],
              [-9196964.74729107, 4422501.085118052],
              [-9173961.465074565, 4423095.493299801],
              [-9173464.423548173, 4421886.3926359955],
              [-9167867.61350956, 4408465.257924226],
              [-9165164.998912081, 4398618.083824841],
              [-9162465.835218815, 4386227.115396792],
              [-9160941.361560961, 4382814.484477513],
              [-9182437.331103565, 4382918.330884634],
              [-9196012.069455983, 4382816.793467547],
              [-9220641.623746363, 4382632.569811528],
              [-9237787.663482662, 4382844.563178929],
              [-9233683.14737076, 4394023.031994254],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Langlade',
        GEOID: '55067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9954725.871958109, 5695369.505481969],
              [-9947960.429905148, 5695801.2587950975],
              [-9912609.923728326, 5694936.661952577],
              [-9898869.981618695, 5695047.450125056],
              [-9899199.821269915, 5681328.402812993],
              [-9871589.35928795, 5681335.692909649],
              [-9871819.790633893, 5653851.5351485945],
              [-9867488.683205599, 5640014.168843661],
              [-9905451.412553374, 5640121.5992464],
              [-9905395.307530016, 5626075.02538471],
              [-9932349.541113753, 5626126.846010439],
              [-9932394.06891007, 5640206.787261335],
              [-9954853.555414049, 5640290.556262189],
              [-9954725.871958109, 5695369.505481969],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tallapoosa',
        GEOID: '01123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9574497.0079521, 3907290.6061356943],
              [-9570661.494896818, 3909287.271918693],
              [-9534921.147863239, 3909466.411822965],
              [-9528188.879018534, 3909560.2354510087],
              [-9528185.984711774, 3859326.0491172364],
              [-9537837.718522023, 3857208.997466888],
              [-9539719.12923592, 3855211.245947443],
              [-9539618.830374716, 3841792.82655381],
              [-9541488.997820042, 3839930.0520832706],
              [-9551054.792983402, 3839831.630062034],
              [-9550895.717431057, 3828363.0693106465],
              [-9560802.261555731, 3828206.935817026],
              [-9560102.284597622, 3862766.8038952593],
              [-9574276.261401858, 3862827.163043443],
              [-9574978.01947182, 3871330.700497329],
              [-9574497.0079521, 3907290.6061356943],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'New Madrid',
        GEOID: '29143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10015190.83449433, 4356254.217915212],
              [-10014166.249901066, 4387565.480849032],
              [-9985464.300311875, 4387304.979550945],
              [-9984423.574392447, 4419543.316634767],
              [-9970564.075149704, 4421124.651911793],
              [-9965299.553791108, 4420948.627156235],
              [-9965287.531286104, 4417926.604459759],
              [-9949039.338409916, 4397782.056162342],
              [-9943871.75150456, 4386818.573311851],
              [-9949590.703847816, 4386589.119162812],
              [-9952842.56881287, 4378277.633616664],
              [-9960795.23323514, 4378819.270347098],
              [-9968040.796251891, 4379963.755169088],
              [-9971051.654519377, 4374916.162398325],
              [-9967461.712260785, 4369354.411207106],
              [-9965434.473013949, 4364370.359961876],
              [-9967807.359279698, 4358581.936496083],
              [-9964249.922312418, 4352808.244442027],
              [-9965620.821841538, 4348168.109871398],
              [-9968107.291165166, 4348096.574909754],
              [-9975485.1758792, 4357360.471487436],
              [-9988560.985906761, 4359605.833131016],
              [-9991163.301643034, 4353919.951140193],
              [-10014447.22029583, 4354252.79414803],
              [-10015190.83449433, 4356254.217915212],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Powell',
        GEOID: '30077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12631031.332302615, 6040574.618823013],
              [-12615375.359117448, 6039823.498522596],
              [-12595173.431886757, 6039823.498522596],
              [-12592805.666317584, 6026664.397888354],
              [-12585692.462175384, 6022193.738474147],
              [-12585676.20952973, 5971433.880344105],
              [-12556371.910175852, 5971013.639505962],
              [-12556353.431140382, 5914640.6699273],
              [-12527422.163400155, 5915058.690917684],
              [-12527405.354157044, 5893159.097090359],
              [-12513518.136361092, 5893162.830330013],
              [-12513494.981907008, 5886105.951558847],
              [-12503502.165176967, 5886092.328096347],
              [-12501015.287752647, 5881235.614793129],
              [-12503043.862833371, 5872882.8248032825],
              [-12502355.79706078, 5848100.971034794],
              [-12517823.417667523, 5834051.261684618],
              [-12531240.199295383, 5829356.614741679],
              [-12529965.925084272, 5823050.0311370725],
              [-12583201.799888374, 5823211.863798254],
              [-12583458.836592618, 5899015.421504348],
              [-12591972.551248487, 5895416.374144835],
              [-12612821.46735967, 5914721.050769171],
              [-12612825.9201393, 5971445.836050872],
              [-12631027.436120436, 5971370.990321627],
              [-12631031.332302615, 6040574.618823013],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Riverside',
        GEOID: '06065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13099313.356928648, 4011494.2729290035],
              [-13097336.434091648, 4018647.657944482],
              [-13092390.731754685, 4018751.092840224],
              [-13086526.643618677, 4031340.922615726],
              [-13066156.178678926, 4033351.518465168],
              [-13065745.409757897, 4031407.1354034063],
              [-13049468.830411559, 4031315.2703003245],
              [-13037882.697809795, 4029327.861379152],
              [-13036039.692320222, 4029341.1552810012],
              [-13016516.480024898, 4029461.8753616237],
              [-13016538.855242549, 4033383.488850187],
              [-12946527.021856407, 4033172.7277551913],
              [-12836942.000049185, 4033383.085861582],
              [-12836925.636084035, 4039259.234594715],
              [-12738299.476967935, 4039405.516092075],
              [-12738902.033951622, 4034525.6158115393],
              [-12741050.834082404, 4030274.8556588213],
              [-12747146.800717734, 4023065.0679617915],
              [-12749976.430854209, 4019205.224699549],
              [-12747051.06595565, 4015468.1958406186],
              [-12746709.315118916, 4010592.135923055],
              [-12748359.849208908, 4005700.1956986845],
              [-12746623.042513553, 3996683.498774724],
              [-12745699.313378949, 3991153.456609109],
              [-12746637.514047354, 3987656.486738274],
              [-12748887.058317304, 3983450.9069457445],
              [-12749330.666488117, 3976106.2325751195],
              [-12748820.043983847, 3968834.8940705075],
              [-12756911.189852668, 3960612.508123684],
              [-12760458.220472347, 3952992.216483465],
              [-12782909.856927434, 3952531.887881003],
              [-12853783.97108926, 3952118.1279793005],
              [-12922541.456453143, 3951976.7433947558],
              [-12935056.661525069, 3952371.690884364],
              [-13004546.183860408, 3952102.25547293],
              [-13027815.853618378, 3952109.991649787],
              [-13034290.529161388, 3952557.4982641614],
              [-13040140.368402574, 3952867.4951035585],
              [-13051238.587676192, 3952785.1930678994],
              [-13051282.781514037, 3955044.37628],
              [-13052265.39865927, 3955404.7391088423],
              [-13053246.45733163, 3955789.529876735],
              [-13064930.996363254, 3962531.048707744],
              [-13081122.416299134, 3962530.2476919675],
              [-13081176.740210645, 3966399.8018015944],
              [-13075357.736468408, 3975509.9916859856],
              [-13070353.92535725, 3983111.466973673],
              [-13083824.919577125, 3989975.7716849176],
              [-13099526.979031477, 4011188.592148611],
              [-13099313.356928648, 4011494.2729290035],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Elk',
        GEOID: '20049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10745147.24466797, 4524057.9978356995],
              [-10682329.878652306, 4523600.766238161],
              [-10682397.004305255, 4493136.759030481],
              [-10682723.17041328, 4489906.907230985],
              [-10682708.03096253, 4480898.348654882],
              [-10745099.7112454, 4481387.869257887],
              [-10745190.659269378, 4505721.180057836],
              [-10745147.24466797, 4524057.9978356995],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chaves',
        GEOID: '35005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11723728.724400466, 3890274.452106093],
              [-11723831.249651488, 3912878.1695482377],
              [-11678018.38113246, 3913755.6930792644],
              [-11675759.263386302, 3935968.094367211],
              [-11676572.229627565, 3948278.282356723],
              [-11676677.315226873, 4040679.112655441],
              [-11664771.918325514, 4040579.2422861885],
              [-11664735.739491006, 4028820.4219020326],
              [-11594622.828007225, 4028186.120733479],
              [-11594548.355267884, 4039979.904067373],
              [-11571217.90506794, 4039880.1742398725],
              [-11559604.16523246, 4039805.7134559792],
              [-11559631.104549231, 4004550.762889793],
              [-11545710.824864514, 4004598.731783337],
              [-11545872.015487181, 3982732.317140767],
              [-11522653.664014466, 3982873.0090250177],
              [-11522694.852226062, 3971224.273482822],
              [-11546147.642546387, 3971146.783886004],
              [-11551218.467991002, 3947891.3411098276],
              [-11551224.701882485, 3890694.2474671714],
              [-11556578.056194734, 3890674.3453248646],
              [-11670910.854284292, 3890422.1217690716],
              [-11670977.089381311, 3831835.227499554],
              [-11672018.260578703, 3831835.359520016],
              [-11727954.746229451, 3831602.3456923114],
              [-11723728.724400466, 3890274.452106093],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Miguel',
        GEOID: '35047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11768755.454675512, 4282911.072260488],
              [-11727266.79177635, 4282843.759006988],
              [-11700761.175740507, 4274222.859838829],
              [-11690617.298461461, 4268976.622615176],
              [-11660788.461666968, 4270820.868578686],
              [-11618428.612432858, 4270296.006783055],
              [-11579642.898089647, 4270596.787237823],
              [-11574655.673582617, 4273376.242885984],
              [-11546459.337120607, 4221485.40426183],
              [-11536823.967275504, 4216961.548877192],
              [-11536832.538876297, 4196655.832966756],
              [-11561367.354647133, 4196872.004245597],
              [-11591155.448507996, 4183203.055685637],
              [-11591157.118300358, 4193232.1399660497],
              [-11720959.31810851, 4193340.191614562],
              [-11720917.23934099, 4169594.321091527],
              [-11768075.292586764, 4169536.53574264],
              [-11768755.454675512, 4282911.072260488],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chaffee',
        GEOID: '08015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11864204.904902825, 4729969.7943705525],
              [-11821128.714745458, 4729706.734348578],
              [-11812221.9309676, 4713094.896754439],
              [-11802998.33191894, 4713488.485298832],
              [-11791530.75457487, 4703378.671304145],
              [-11789467.336493528, 4694058.134737445],
              [-11796498.609490503, 4677869.961845774],
              [-11786298.627188096, 4664837.870245],
              [-11789704.447008915, 4651102.830890472],
              [-11801062.819932517, 4642704.112004779],
              [-11804627.270027718, 4644367.383601652],
              [-11808385.861314863, 4639447.717872646],
              [-11827355.259143488, 4639322.1100311745],
              [-11839293.717933616, 4655051.533656555],
              [-11842156.187319871, 4670018.868691843],
              [-11850196.460181396, 4678615.351124307],
              [-11846334.230448324, 4682452.70001899],
              [-11845171.60968648, 4697254.532599138],
              [-11836167.198715193, 4708931.664626333],
              [-11851633.149529574, 4708838.674981499],
              [-11861560.510399029, 4721486.936072011],
              [-11866570.2214432, 4721384.234365464],
              [-11864204.904902825, 4729969.7943705525],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Presque Isle',
        GEOID: '26141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9378891.9647047, 5720616.369329383],
              [-9374313.766473997, 5720653.460753316],
              [-9372660.633568566, 5719893.411521527],
              [-9364922.704444034, 5709579.098176375],
              [-9361513.322399508, 5700153.606891633],
              [-9350653.54947517, 5699178.542569728],
              [-9340759.695772447, 5698325.210309893],
              [-9333197.874082351, 5690310.813556844],
              [-9317142.597883709, 5684118.407343045],
              [-9306228.501047865, 5677196.823030905],
              [-9293933.597248219, 5677721.324817698],
              [-9282387.317024158, 5664791.662305412],
              [-9284703.875627566, 5657353.878982931],
              [-9282399.237032467, 5654184.91143804],
              [-9337615.031477025, 5653389.725218227],
              [-9353294.270435767, 5652813.562517914],
              [-9378292.397927288, 5652861.429852188],
              [-9378891.9647047, 5720616.369329383],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Warren',
        GEOID: '28149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10142152.828814382, 3790664.669202326],
              [-10129097.056295164, 3791521.4516207697],
              [-10124266.569631172, 3800580.365305164],
              [-10121298.34672866, 3808297.2586472784],
              [-10128589.996014602, 3809573.6806163928],
              [-10126287.241028054, 3819203.1021746863],
              [-10135963.242487293, 3821001.5558956694],
              [-10136810.272492738, 3830755.481282246],
              [-10131328.789446589, 3831314.550227365],
              [-10135501.648177411, 3838736.233690581],
              [-10126070.947257439, 3839107.1634631883],
              [-10125997.253754536, 3817406.898226135],
              [-10114640.773262277, 3821486.0348203853],
              [-10114551.940308625, 3839050.0957668712],
              [-10099833.054596957, 3837873.4000047515],
              [-10098915.55935384, 3844822.3271714225],
              [-10091727.103235863, 3840978.6606893446],
              [-10091622.685553499, 3835202.755322503],
              [-10080414.48262298, 3833335.999005212],
              [-10080405.243105242, 3830123.573668176],
              [-10089571.401296651, 3812570.3241836163],
              [-10097253.893314768, 3808918.520565997],
              [-10099864.001415398, 3792897.4052129816],
              [-10123706.409953501, 3773600.2074364633],
              [-10134467.700629052, 3777491.48266979],
              [-10142152.828814382, 3790664.669202326],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '05089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10339849.120015826, 4368354.507913483],
              [-10336465.465573732, 4369366.788539354],
              [-10334776.402139867, 4369368.120541613],
              [-10327368.968713736, 4369375.065791245],
              [-10304203.839827383, 4369396.785570396],
              [-10300296.367743045, 4369386.494260298],
              [-10300745.922484873, 4353943.043779001],
              [-10307624.019862516, 4349536.8430667585],
              [-10305417.556235503, 4343269.021009764],
              [-10293631.159869803, 4335200.523899902],
              [-10294860.572326122, 4328089.167682186],
              [-10287240.307903359, 4322952.238524705],
              [-10287201.346081583, 4309259.940253196],
              [-10334515.357933955, 4310266.495701681],
              [-10334551.870726936, 4316283.2658158345],
              [-10340544.866833283, 4316337.144762474],
              [-10339849.120015826, 4368354.507913483],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Loving',
        GEOID: '48301',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11575024.416877937, 3763314.9393972587],
              [-11546378.405529568, 3763332.3606258933],
              [-11502253.476770671, 3763359.19549223],
              [-11502368.915082626, 3717640.5592397004],
              [-11533911.181479407, 3717690.513796069],
              [-11535563.05140329, 3724653.468278306],
              [-11549041.949307011, 3729165.4968637116],
              [-11556016.004085721, 3736341.7161336583],
              [-11558234.267578756, 3748616.8001361247],
              [-11564490.311641848, 3746307.0708330465],
              [-11575024.416877937, 3763314.9393972587],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adams',
        GEOID: '08001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11694434.443800762, 4853485.362809014],
              [-11690310.390625345, 4863209.673771147],
              [-11687228.39920324, 4861360.902128375],
              [-11684250.15754656, 4865991.251545606],
              [-11631746.542352892, 4866031.359392439],
              [-11593961.924190387, 4866066.671870049],
              [-11544465.827679483, 4866140.784886042],
              [-11544560.003968691, 4828216.064040549],
              [-11635887.738729892, 4828038.725660427],
              [-11644917.196586607, 4828220.40706083],
              [-11647853.470795263, 4828172.633941713],
              [-11650692.674407946, 4828300.463739982],
              [-11675705.384752758, 4828253.993148185],
              [-11659002.45175668, 4832456.765618594],
              [-11662104.814645598, 4840251.461613954],
              [-11646238.224983852, 4840170.439248579],
              [-11644067.160954911, 4851342.673694275],
              [-11648512.70481974, 4852326.816662355],
              [-11658662.81599027, 4851219.626396525],
              [-11665270.740963759, 4836667.685540793],
              [-11694473.850900503, 4835626.414969399],
              [-11694434.443800762, 4853485.362809014],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'York',
        GEOID: '23031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7902265.418574478, 5433460.065956226],
              [-7900424.300312506, 5432228.956765756],
              [-7887274.57414306, 5435274.032286206],
              [-7879525.73570843, 5436725.905926221],
              [-7865041.622802843, 5432597.951848693],
              [-7865793.14068519, 5420812.056873351],
              [-7853586.1792832725, 5421565.782584681],
              [-7843320.0732033355, 5410264.198406677],
              [-7847134.5468748575, 5404789.078806266],
              [-7830072.439009041, 5392704.0646557845],
              [-7832574.514076551, 5392869.996074812],
              [-7835290.820971398, 5386399.200499686],
              [-7828799.558824261, 5382025.888073549],
              [-7835108.92492344, 5375038.238589717],
              [-7838707.884060787, 5367091.184452368],
              [-7844236.455251547, 5363904.990317769],
              [-7849993.899315375, 5364485.260741996],
              [-7851825.557558474, 5362942.479605539],
              [-7854019.100782967, 5361095.224528414],
              [-7857506.740429521, 5353176.591535301],
              [-7856594.213839035, 5346743.342534114],
              [-7856460.6711745355, 5345802.248791227],
              [-7858731.366147736, 5336886.229658921],
              [-7861661.85174287, 5332477.71317524],
              [-7866498.460978857, 5323582.647010568],
              [-7870713.01690029, 5321082.259650181],
              [-7876566.084406708, 5324154.771958834],
              [-7883596.164694713, 5330747.707250365],
              [-7884548.02585506, 5331640.737808839],
              [-7884180.782854932, 5339361.8510501245],
              [-7884178.079134721, 5339373.774390735],
              [-7882880.348563486, 5345098.496488788],
              [-7889500.073402998, 5353182.554013358],
              [-7895217.887728103, 5361536.221983677],
              [-7901940.0264991475, 5369398.730613731],
              [-7900161.586314233, 5377543.044754621],
              [-7899318.886196935, 5384413.656319178],
              [-7898647.19596148, 5389893.657699171],
              [-7899653.265875484, 5394563.834271834],
              [-7900646.605335618, 5399177.228330239],
              [-7901674.084235641, 5419281.077374932],
              [-7902265.418574478, 5433460.065956226],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Millard',
        GEOID: '49027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12695925.219363924, 4675561.3203054],
              [-12695771.297243766, 4704310.251292343],
              [-12695888.1827091, 4722460.720284438],
              [-12695662.760740243, 4793539.235924119],
              [-12695674.161295015, 4799715.821608779],
              [-12672585.339742871, 4799873.94922216],
              [-12669910.555018092, 4801145.097478014],
              [-12626564.971693005, 4801119.39861866],
              [-12519259.216459775, 4801117.232987458],
              [-12507242.054789659, 4801295.249435021],
              [-12491387.710271899, 4801338.9960536305],
              [-12488813.669686288, 4768964.581313104],
              [-12469564.414657805, 4766830.4224077],
              [-12469350.681235481, 4728193.7343624355],
              [-12475036.769505711, 4715843.608757958],
              [-12482684.41852321, 4715843.608757958],
              [-12492769.85306959, 4702324.222931215],
              [-12492090.247578297, 4682693.2779077785],
              [-12502286.778976487, 4675408.396111035],
              [-12517600.333407974, 4676118.525620093],
              [-12525156.366484549, 4660668.6768516125],
              [-12576511.38717221, 4660609.586923561],
              [-12696005.02596275, 4660687.217348475],
              [-12695925.219363924, 4675561.3203054],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Butler',
        GEOID: '01013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9674658.834863674, 3758280.663617726],
              [-9668941.911094494, 3758345.4818893885],
              [-9623369.38135609, 3758668.5287587717],
              [-9623418.027973568, 3718189.4167689425],
              [-9629083.967415962, 3718141.0294763343],
              [-9629048.345178908, 3701162.9579651547],
              [-9651572.842265511, 3700982.086649469],
              [-9666916.230320528, 3701146.37254149],
              [-9674417.271568652, 3715188.9843252595],
              [-9674320.423611661, 3730936.112350133],
              [-9674431.743102456, 3741098.3965035463],
              [-9674658.834863674, 3758280.663617726],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Eagle',
        GEOID: '08037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11923839.424037725, 4854194.808590418],
              [-11914966.815343538, 4854165.924682105],
              [-11872951.277294451, 4854318.037865825],
              [-11869613.807640977, 4854130.799640374],
              [-11869615.366113849, 4855018.253001949],
              [-11848235.233392602, 4855036.978337717],
              [-11842777.23875901, 4832164.650050623],
              [-11819509.906710342, 4813146.741866229],
              [-11828337.876288723, 4796418.338402227],
              [-11822879.325057674, 4776197.98485087],
              [-11831459.831408018, 4771854.35307827],
              [-11847342.339756949, 4773639.8428621935],
              [-11856551.467271805, 4773701.322796538],
              [-11923814.265832806, 4774243.859915214],
              [-11923839.424037725, 4854194.808590418],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Assumption',
        GEOID: '22007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10158948.60226578, 3503575.5516654714],
              [-10155048.857864311, 3506806.9659696105],
              [-10141868.073556932, 3511583.3385369657],
              [-10139992.562776048, 3511587.9689200413],
              [-10138375.981130747, 3514047.0689084223],
              [-10126031.985435663, 3512094.234294001],
              [-10125606.29970287, 3500712.4950476885],
              [-10121819.210626082, 3495191.6522750063],
              [-10117337.487926746, 3491389.6464448944],
              [-10117293.628047373, 3487813.9511505337],
              [-10121729.821074976, 3481764.969042105],
              [-10124228.943643285, 3476880.555828506],
              [-10130824.289514314, 3466938.7517712526],
              [-10139268.8747664, 3455612.778370413],
              [-10141806.179920053, 3457778.8602436907],
              [-10141206.72446213, 3464968.9982532067],
              [-10140390.975233598, 3477995.8102732236],
              [-10150424.757536247, 3483791.9737935294],
              [-10158485.624503572, 3499881.434364305],
              [-10158948.60226578, 3503575.5516654714],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morris',
        GEOID: '34027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8332320.992775302, 4983468.08130744],
              [-8323294.317905858, 4999213.312081087],
              [-8316853.038210087, 4997481.649321561],
              [-8308459.659923765, 5003884.607483959],
              [-8309003.010358327, 5007095.922135149],
              [-8297288.192425207, 5020972.16667697],
              [-8293659.622303307, 5025016.174828111],
              [-8293054.600870847, 5017396.467697502],
              [-8287404.0235181805, 5020373.24679627],
              [-8278031.924268804, 5014278.08620477],
              [-8270910.259845304, 5012771.340177717],
              [-8267928.233325935, 4997223.921976148],
              [-8273945.1631228, 4998870.254322733],
              [-8278512.713149541, 4977169.3372266255],
              [-8279024.003570753, 4974014.141690547],
              [-8279978.679523797, 4972239.6448780345],
              [-8287041.678575648, 4966435.665965249],
              [-8288964.50014012, 4964302.204130078],
              [-8295871.095307409, 4960724.627921044],
              [-8294829.033554092, 4967861.560473517],
              [-8299534.953707886, 4976735.202278228],
              [-8310807.944582049, 4973364.03820001],
              [-8318423.088308236, 4971060.30201353],
              [-8329356.220777007, 4974413.480935511],
              [-8336696.516680425, 4981081.978188549],
              [-8332320.992775302, 4983468.08130744],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coles',
        GEOID: '17029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9848666.115785327, 4815440.420204196],
              [-9803176.964345526, 4815580.232188748],
              [-9792397.118815579, 4820406.6074691815],
              [-9791682.336365195, 4790851.338513752],
              [-9797696.483174792, 4790772.44632142],
              [-9797464.493355978, 4776101.781750171],
              [-9848527.745658271, 4775460.49927296],
              [-9848491.566823764, 4785910.163643239],
              [-9848666.115785327, 4815440.420204196],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Plymouth',
        GEOID: '25023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7912643.172899939, 5175301.483774375],
              [-7898002.433470807, 5183198.395055661],
              [-7895321.19221556, 5184613.469053142],
              [-7894120.500187864, 5204338.935299683],
              [-7897950.563434314, 5203369.095156888],
              [-7894498.87513707, 5206880.281457653],
              [-7890463.7662347965, 5206124.24780952],
              [-7887107.594906868, 5201250.083911676],
              [-7885410.949544706, 5200722.576908963],
              [-7887362.182582314, 5196939.260140911],
              [-7885961.783388135, 5192957.139713854],
              [-7884425.574415187, 5191104.728011048],
              [-7879759.172680623, 5194784.65774058],
              [-7879368.835958818, 5198297.123857397],
              [-7873689.922723084, 5192629.792905303],
              [-7868653.272362143, 5180926.819007406],
              [-7867976.758714324, 5179924.810707262],
              [-7863439.6240108395, 5173207.426651075],
              [-7864091.622268415, 5167856.773609253],
              [-7867927.803240642, 5161804.851065359],
              [-7866110.846511914, 5155078.143444602],
              [-7860065.0849669315, 5152100.8761086855],
              [-7857327.293410362, 5153493.674331429],
              [-7853187.766825723, 5148517.293288831],
              [-7850870.206346897, 5139841.317052497],
              [-7852591.539633034, 5133420.118138575],
              [-7852076.93791614, 5132804.782275694],
              [-7855300.276802507, 5129076.868061813],
              [-7862780.056027888, 5125529.513728746],
              [-7861469.825621252, 5123235.367158185],
              [-7869282.116165633, 5110252.470409484],
              [-7872066.867255927, 5103334.722380656],
              [-7877164.212912746, 5107133.020607525],
              [-7877575.306910241, 5107439.413688493],
              [-7881861.064248283, 5101474.048843166],
              [-7885780.889215595, 5103446.056743601],
              [-7888656.049023804, 5116170.746052251],
              [-7890878.765296473, 5124516.374485429],
              [-7893351.616464955, 5125624.878796785],
              [-7894976.658391554, 5129759.9201358715],
              [-7906610.213096397, 5127915.26891812],
              [-7905308.109012588, 5131002.826711502],
              [-7907754.800100733, 5133535.278053258],
              [-7900758.036145902, 5140162.520126307],
              [-7902265.190731754, 5146880.365266791],
              [-7902921.5304494705, 5146975.64434751],
              [-7903658.5767980125, 5150450.3157215],
              [-7909775.026219649, 5158741.317872866],
              [-7912643.172899939, 5175301.483774375],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clarke',
        GEOID: '51043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8695142.494047495, 4735406.560980884],
              [-8686614.247849291, 4759647.842543078],
              [-8686576.125272479, 4759616.11041282],
              [-8663806.929384515, 4740657.742522319],
              [-8667650.030725772, 4733277.766327735],
              [-8678712.739081826, 4723638.897944132],
              [-8683400.40283913, 4718726.67033574],
              [-8689440.375770591, 4724423.040791875],
              [-8699797.875152469, 4726919.721478121],
              [-8695142.494047495, 4735406.560980884],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morgan',
        GEOID: '01103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9696492.371870922, 4121296.25877836],
              [-9666783.09220954, 4103778.0064916816],
              [-9661424.839839697, 4103001.631101942],
              [-9650214.633158343, 4107819.024821789],
              [-9645432.347833863, 4102749.023298915],
              [-9637914.052064667, 4107133.5000287504],
              [-9634720.407193298, 4102349.241485091],
              [-9635011.618981214, 4101536.7469800403],
              [-9638188.45460947, 4078740.3948236224],
              [-9638257.027415803, 4069788.732584575],
              [-9697053.199465537, 4071015.796698422],
              [-9696492.371870922, 4121296.25877836],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dubois',
        GEOID: '18037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9692851.779244019, 4652393.002693085],
              [-9678969.570825152, 4648943.945499966],
              [-9676356.123139799, 4651063.995952192],
              [-9672073.662328983, 4649571.594030568],
              [-9666702.051620245, 4654067.3812568765],
              [-9649436.064639734, 4654054.574807472],
              [-9649331.980915843, 4635344.234201468],
              [-9649119.026729954, 4616657.99627345],
              [-9661658.1654924, 4614675.30000424],
              [-9661585.25122593, 4608444.467926331],
              [-9686742.676908774, 4608224.891647435],
              [-9692929.480248593, 4612336.135365352],
              [-9692851.779244019, 4652393.002693085],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Humboldt',
        GEOID: '19091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10513341.54829256, 5297990.0710347975],
              [-10460830.36337352, 5297942.804440279],
              [-10460883.351451136, 5258048.043327162],
              [-10513355.908506872, 5258117.205043314],
              [-10513341.54829256, 5297990.0710347975],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hardin',
        GEOID: '21093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9590317.177386187, 4551052.850049701],
              [-9574303.534677101, 4553808.987583139],
              [-9570798.751828967, 4561894.357975277],
              [-9573181.39633393, 4578186.35889763],
              [-9570807.65738823, 4579928.733680434],
              [-9568102.77698443, 4581536.566795176],
              [-9566610.133348888, 4579250.078882468],
              [-9557320.521842191, 4571713.41537955],
              [-9555464.491972193, 4562386.698165873],
              [-9544285.677387241, 4552872.064075145],
              [-9544120.701901887, 4548538.146894526],
              [-9537908.295079187, 4541675.247448163],
              [-9544082.185358072, 4530746.348052252],
              [-9559651.106701437, 4515206.658706867],
              [-9561543.20408645, 4500659.04584779],
              [-9578774.793344304, 4502008.587893879],
              [-9586195.684559058, 4518462.290716446],
              [-9604119.12445219, 4522161.755395159],
              [-9590317.177386187, 4551052.850049701],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Galveston',
        GEOID: '48167',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10599443.61219745, 3446614.744871973],
              [-10597725.173218075, 3447527.473918892],
              [-10593599.895528259, 3439190.783796717],
              [-10588391.479193022, 3440467.2755679055],
              [-10588209.026547614, 3440568.070057359],
              [-10588105.833379645, 3440714.2746261843],
              [-10588013.88348025, 3440796.907159904],
              [-10587870.281337127, 3440838.8631993076],
              [-10587689.49848408, 3440795.5000999635],
              [-10587537.547379147, 3440700.7157778256],
              [-10587385.484954724, 3440674.2376903608],
              [-10587206.817172, 3440746.253098356],
              [-10587062.32447295, 3440767.870590284],
              [-10586965.142557489, 3440813.024402862],
              [-10586914.826147648, 3440884.1451748665],
              [-10586932.859905157, 3441046.8545972826],
              [-10587020.023066448, 3441254.7214174517],
              [-10587153.717774892, 3441458.6260208166],
              [-10587171.528893419, 3441561.8587478064],
              [-10587110.19185399, 3441644.3687683484],
              [-10586887.664191896, 3441728.926094706],
              [-10586818.423468623, 3441844.697611288],
              [-10586867.626683552, 3442016.8856715355],
              [-10586840.353408309, 3442107.4580221805],
              [-10586693.968277914, 3442198.0310065784],
              [-10586545.022799233, 3442099.014810166],
              [-10586471.997213274, 3441981.7059039585],
              [-10586398.192390878, 3441794.6790721216],
              [-10586316.595204126, 3441764.4889476364],
              [-10586217.743496303, 3441820.647752476],
              [-10586154.736664513, 3442064.4744547256],
              [-10586084.382746331, 3442160.2921860595],
              [-10585903.04329583, 3442329.286201887],
              [-10585781.482411884, 3442681.993159842],
              [-10585801.297281243, 3442833.211056267],
              [-10585934.324072743, 3443042.2579952828],
              [-10585967.163322527, 3443197.8300019465],
              [-10585974.399089428, 3443372.083105011],
              [-10586094.846778465, 3443598.922708432],
              [-10586147.16693914, 3443755.9087893586],
              [-10586088.724206472, 3443911.36143093],
              [-10585873.320991786, 3444012.054797115],
              [-10585577.656424241, 3443774.2047646055],
              [-10585500.51201712, 3443683.4928055154],
              [-10585468.229364792, 3443476.610504961],
              [-10585374.609673034, 3443421.97980015],
              [-10585298.467141332, 3443432.9826870193],
              [-10585168.557295576, 3443519.598762701],
              [-10585033.415433753, 3443676.072109217],
              [-10584981.540551042, 3443841.8873034986],
              [-10584916.863926891, 3443897.9271783],
              [-10584605.503311142, 3443779.1945805256],
              [-10584500.862989798, 3443789.046274019],
              [-10584268.984490475, 3443747.4645018172],
              [-10584206.088978177, 3443806.702574633],
              [-10584133.953948142, 3443952.304001168],
              [-10584100.669420395, 3444205.894932008],
              [-10584269.318448948, 3444487.8959313203],
              [-10584283.010746315, 3444575.1588289333],
              [-10584227.239681426, 3444744.0564319994],
              [-10584164.678127602, 3444854.864693781],
              [-10584199.855086692, 3444984.4834147263],
              [-10584091.318583168, 3445200.3468919382],
              [-10584014.28549554, 3445199.835059634],
              [-10583974.655756818, 3445315.8935529343],
              [-10583698.583419649, 3445522.9332305607],
              [-10583525.036333501, 3445711.2935915184],
              [-10583419.171497758, 3445863.058758402],
              [-10583362.732515927, 3446032.6130115646],
              [-10583286.478664733, 3446347.413973105],
              [-10583228.59252952, 3446499.3145765574],
              [-10583156.680138469, 3446616.536481133],
              [-10583062.281210275, 3446702.5340126846],
              [-10582865.579670044, 3446810.031731472],
              [-10582594.628029453, 3446921.6255469257],
              [-10577378.19669088, 3446424.963679127],
              [-10565315.61666852, 3438984.868551467],
              [-10552153.867994068, 3445889.9313597176],
              [-10548920.927342452, 3442530.777030211],
              [-10524802.33514769, 3448716.6010938673],
              [-10518097.730705282, 3440874.9523642403],
              [-10519781.714793421, 3440126.524372358],
              [-10530250.867624566, 3435335.4678694475],
              [-10538659.496681128, 3430589.7655950487],
              [-10545411.914353665, 3422713.8344734753],
              [-10544463.806250578, 3417899.7008906193],
              [-10553499.052720813, 3411234.8820462613],
              [-10578270.311090099, 3394504.7957150377],
              [-10588158.9890597, 3385265.633299222],
              [-10581641.065271318, 3401123.330989107],
              [-10596746.118296549, 3427214.256510442],
              [-10601298.083594576, 3435036.660994341],
              [-10599443.61219745, 3446614.744871973],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Faulkner',
        GEOID: '05045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10303140.404731834, 4179285.711046503],
              [-10299440.144857867, 4179478.9529478448],
              [-10300178.081762334, 4195257.5004558675],
              [-10294990.036893914, 4214057.525747452],
              [-10269530.156154584, 4213419.480499205],
              [-10253801.157383459, 4213283.931356397],
              [-10254720.211099448, 4172920.952593248],
              [-10254900.21471606, 4165540.558115062],
              [-10266722.901235761, 4165849.6360547505],
              [-10266984.724678107, 4154040.9181807297],
              [-10288066.74380301, 4154599.921630176],
              [-10289940.47347204, 4142459.8195690275],
              [-10295217.462613605, 4157215.675619623],
              [-10301988.915919071, 4157539.1907485784],
              [-10307935.714436736, 4163314.0644922648],
              [-10303140.404731834, 4179285.711046503],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sarpy',
        GEOID: '31153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10723117.00612049, 5040406.9951572465],
              [-10687687.908383168, 5040510.692543516],
              [-10676642.175275948, 5040596.913228324],
              [-10676617.852940721, 5039578.491434159],
              [-10670728.829238776, 5039977.868420086],
              [-10671297.679429766, 5036015.054152967],
              [-10672053.531179216, 5030752.025769494],
              [-10671513.74296836, 5024666.740995742],
              [-10671619.024944747, 5020139.491260282],
              [-10684308.693920648, 5020215.735673652],
              [-10687248.97563097, 5021287.806560059],
              [-10692933.50542833, 5021986.443575081],
              [-10711043.29414905, 5011502.131395418],
              [-10722203.295740059, 5018981.1259155655],
              [-10724498.03572327, 5024518.316653172],
              [-10723117.00612049, 5040406.9951572465],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '35059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11578209.214367721, 4330675.313400721],
              [-11578100.834781598, 4438547.036624308],
              [-11547532.234372875, 4438830.246844399],
              [-11475492.279603174, 4439087.880954897],
              [-11466152.343267433, 4439121.283519302],
              [-11466126.183187095, 4426509.913601755],
              [-11466187.854184994, 4393928.094830813],
              [-11466151.118753035, 4383874.250907231],
              [-11466178.503347768, 4369695.488038599],
              [-11470574.510039195, 4369701.304302764],
              [-11470452.058599323, 4308223.73615349],
              [-11470511.360920837, 4264826.803492865],
              [-11507665.385135079, 4264838.117233016],
              [-11507637.221303908, 4300436.578888881],
              [-11506536.605498433, 4312468.188370992],
              [-11554353.670129703, 4312425.210793381],
              [-11554294.22552162, 4324586.131401982],
              [-11578213.778466843, 4324662.668013619],
              [-11578209.214367721, 4330675.313400721],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Surry',
        GEOID: '51181',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8572970.132138312, 4471617.577478686],
              [-8568532.71459631, 4473801.457780888],
              [-8562869.892099656, 4470562.994381522],
              [-8558593.776499815, 4470243.8300757455],
              [-8549085.310874216, 4468989.914055396],
              [-8544919.067611787, 4463779.022818807],
              [-8533801.701385753, 4467600.436124849],
              [-8531701.770511432, 4460570.031898665],
              [-8538010.69133265, 4447353.349580168],
              [-8554867.690503983, 4438578.662672523],
              [-8566429.555456754, 4431366.659517794],
              [-8567726.427524496, 4446708.062239541],
              [-8588901.509743702, 4454734.408261172],
              [-8572970.132138312, 4471617.577478686],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chase',
        GEOID: '31029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11360299.284968976, 4930090.58010256],
              [-11360298.099748353, 4967831.729722487],
              [-11281714.426058449, 4967911.922780268],
              [-11281427.555730674, 4916999.296850439],
              [-11360299.70277852, 4916820.7073894115],
              [-11360299.284968976, 4930090.58010256],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greene',
        GEOID: '37079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8663162.296773931, 4243719.668049032],
              [-8660854.198451823, 4243832.18594183],
              [-8649601.467724985, 4252882.572817691],
              [-8639546.868677557, 4241279.1900335485],
              [-8627639.913303325, 4234496.580138686],
              [-8624534.878746629, 4222014.080382268],
              [-8646932.805572197, 4211184.56580193],
              [-8649247.917022225, 4215245.939148558],
              [-8661351.907895159, 4214106.943715963],
              [-8663633.512178458, 4221663.675929118],
              [-8663162.296773931, 4243719.668049032],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oregon',
        GEOID: '29149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10205129.38170188, 4409574.421663339],
              [-10203334.243593346, 4423607.676864596],
              [-10154878.984321361, 4422930.2915296545],
              [-10155101.066705491, 4414836.461795107],
              [-10142978.485477597, 4414557.354155179],
              [-10144159.905269992, 4369335.53680833],
              [-10175148.593802454, 4369241.69067678],
              [-10175395.995083136, 4369244.558797017],
              [-10180167.980529418, 4369299.880520264],
              [-10201606.453776745, 4369548.420693119],
              [-10204918.482077906, 4369537.568504509],
              [-10205129.38170188, 4409574.421663339],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fairfax',
        GEOID: '51059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8631267.036271842, 4699831.8703372795],
              [-8619712.852363937, 4714894.651401131],
              [-8616234.89751308, 4719421.786057487],
              [-8608340.420451455, 4729689.40466613],
              [-8606188.313468989, 4729124.012649521],
              [-8599252.886553586, 4725526.789229158],
              [-8599252.96503109, 4725523.83078364],
              [-8599408.733840697, 4719653.358676215],
              [-8594143.210606685, 4717075.997244888],
              [-8587920.339751849, 4716546.258008318],
              [-8584935.659012271, 4712275.931616156],
              [-8585501.812494874, 4711708.012388302],
              [-8590778.467677968, 4706391.350573536],
              [-8592623.922196336, 4706824.299105356],
              [-8593276.031773405, 4707224.939540821],
              [-8592735.241687132, 4706555.831654566],
              [-8593226.049322037, 4705368.624066238],
              [-8592724.10973805, 4704230.602511916],
              [-8590886.113625564, 4704297.524605089],
              [-8589233.575784737, 4703521.369806612],
              [-8588265.430173308, 4703877.981838698],
              [-8583934.879342468, 4699271.300250418],
              [-8587542.410080606, 4693866.999901729],
              [-8575968.955108212, 4690969.322021806],
              [-8576128.440950336, 4685452.043427033],
              [-8576164.667565608, 4684199.2304270025],
              [-8577522.876672775, 4680204.156269974],
              [-8580450.579280639, 4680147.093082644],
              [-8581150.307457095, 4679543.139022089],
              [-8586350.734931663, 4675055.631266441],
              [-8586094.58878335, 4669524.919898922],
              [-8596552.59355765, 4669547.903080193],
              [-8598958.223861458, 4674835.622825535],
              [-8603037.860560048, 4678286.009574488],
              [-8604981.944147263, 4679526.12358761],
              [-8611217.616743539, 4682417.027624348],
              [-8613960.751635667, 4682004.949169993],
              [-8620924.676340712, 4693585.446827705],
              [-8623724.361534161, 4692535.012615963],
              [-8626159.920673227, 4694496.844187341],
              [-8628241.483831571, 4698931.714432296],
              [-8631267.036271842, 4699831.8703372795],
            ],
            [
              [-8607812.798798135, 4699677.360300822],
              [-8605338.05519831, 4697752.97084672],
              [-8601714.93973146, 4698907.703743075],
              [-8601682.434440149, 4702443.745412337],
              [-8608201.303821003, 4702330.6565218],
              [-8607812.798798135, 4699677.360300822],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Armstrong',
        GEOID: '42005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8871376.387423994, 4963750.345321573],
              [-8871129.369473923, 5037551.241543683],
              [-8863345.465399696, 5008679.491746222],
              [-8825965.604905715, 5013712.770912672],
              [-8818197.285560196, 5019795.4724806985],
              [-8817697.23840755, 5017124.930715427],
              [-8818207.972231312, 4999274.000241705],
              [-8818199.623269502, 4979359.999599098],
              [-8844353.135755965, 4943283.825355688],
              [-8868639.597742843, 4965262.894301444],
              [-8871338.204838654, 4963748.58411987],
              [-8871376.387423994, 4963750.345321573],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hardin',
        GEOID: '48199',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10545599.487695653, 3566700.0832135356],
              [-10523913.782972177, 3566828.3629153213],
              [-10524781.073124947, 3571469.274047475],
              [-10472012.517543195, 3571347.279275049],
              [-10477323.013851488, 3558465.016916478],
              [-10473314.621627003, 3547610.2875603954],
              [-10477123.751962967, 3534651.602762213],
              [-10474186.364559406, 3529882.6524680816],
              [-10476935.955982, 3524177.651521202],
              [-10483673.345523281, 3527730.725734584],
              [-10494695.199626213, 3525454.6503988774],
              [-10496607.445839059, 3518684.338521032],
              [-10513559.28921655, 3518085.1555058914],
              [-10530416.177068394, 3517967.535695738],
              [-10545599.487695653, 3566700.0832135356],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pope',
        GEOID: '05115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10385653.194295079, 4227925.507979678],
              [-10377607.355459014, 4227744.811166207],
              [-10377333.17555319, 4245575.265774039],
              [-10371392.054329554, 4245405.093486577],
              [-10371019.356674377, 4263372.801247357],
              [-10347293.054365171, 4262801.264742029],
              [-10331535.557804402, 4262491.100778484],
              [-10331942.319223762, 4238740.607220403],
              [-10336084.183517706, 4226973.534339016],
              [-10336617.069920134, 4187402.049604996],
              [-10341147.550556438, 4187099.860594862],
              [-10352731.679407367, 4186795.909531376],
              [-10359968.002906384, 4179953.4985825843],
              [-10370087.167258473, 4195904.582052632],
              [-10383692.078825774, 4207098.903280454],
              [-10385998.729994502, 4208466.398765023],
              [-10385653.194295079, 4227925.507979678],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stark',
        GEOID: '39151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9089241.432647873, 4963511.558615706],
              [-9089012.782413783, 4986677.528329742],
              [-9088984.28462414, 4999667.304041713],
              [-9063679.471935485, 4998560.790945016],
              [-9060655.032690123, 5010650.136118744],
              [-9056678.700478988, 5010677.566342486],
              [-9038661.640894096, 5010602.059676693],
              [-9037320.574988509, 5010602.649570246],
              [-9026486.962144507, 5010576.399341721],
              [-9026527.816397628, 4997839.828017931],
              [-9026528.595634066, 4997434.66880014],
              [-9026595.721287014, 4972277.102985772],
              [-9038986.693807213, 4972476.294393297],
              [-9043286.743097574, 4971649.294678026],
              [-9043734.581409035, 4960931.36064637],
              [-9052249.297940323, 4961084.689014297],
              [-9067976.515599597, 4963335.884592957],
              [-9089147.25635866, 4958667.955720073],
              [-9089241.432647873, 4963511.558615706],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hockley',
        GEOID: '48219',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11423099.307564152, 4005344.151316516],
              [-11364131.814818084, 4005284.3873296673],
              [-11363040.438530348, 3947129.8966000425],
              [-11420804.901539411, 3946983.6399171064],
              [-11423099.307564152, 4005344.151316516],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Walthall',
        GEOID: '28147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10047740.764921773, 3678322.9290807983],
              [-10045903.882004192, 3678322.9290807983],
              [-10030849.1453888, 3678400.48774701],
              [-10025504.140038362, 3675521.630370663],
              [-10023258.825909061, 3676464.2748702993],
              [-10022304.817872962, 3655591.729434638],
              [-10011872.1778348, 3650027.164942349],
              [-10009953.697730469, 3642451.1756205983],
              [-10000483.637329193, 3642483.5384248425],
              [-10000487.513955675, 3633022.0561855966],
              [-10007345.704700163, 3632997.585341889],
              [-10047647.695202991, 3632835.0885727433],
              [-10047740.764921773, 3678322.9290807983],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Beaverhead',
        GEOID: '30001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12684669.12418793, 5729627.115726052],
              [-12676000.733039899, 5745415.125556908],
              [-12671483.722061982, 5740495.666778183],
              [-12656763.27787744, 5755312.546885785],
              [-12637943.827402912, 5761325.43608042],
              [-12636559.346895916, 5770549.536447841],
              [-12621145.270964246, 5741969.399999082],
              [-12599116.702209126, 5761940.941709461],
              [-12588622.168534081, 5758046.016875274],
              [-12577806.478128098, 5749710.305641873],
              [-12552312.199666115, 5740090.939398378],
              [-12544265.470274122, 5720434.271399489],
              [-12544751.157212453, 5697965.418762538],
              [-12537759.402634708, 5691151.482749989],
              [-12524062.541168014, 5691535.910159997],
              [-12518774.197438387, 5676776.8952147355],
              [-12518639.723493509, 5635466.1958168475],
              [-12504952.435503025, 5635452.635924012],
              [-12504991.28600531, 5621603.192490083],
              [-12489065.808332933, 5621602.090473434],
              [-12486385.346314121, 5594286.048012539],
              [-12475094.210362962, 5594167.861203063],
              [-12475107.457382366, 5587498.223315803],
              [-12443421.47752297, 5587114.29214746],
              [-12443415.0209925, 5575800.962677918],
              [-12409336.117359012, 5575789.684921885],
              [-12407330.611293994, 5573732.9410387],
              [-12408653.72888045, 5571179.823897123],
              [-12414252.320030915, 5556097.408879802],
              [-12419115.645944692, 5551767.948974556],
              [-12425159.518877147, 5552067.625549927],
              [-12434856.667220823, 5552548.465070724],
              [-12446400.053138124, 5544975.944692274],
              [-12453367.540066874, 5553146.551978168],
              [-12471582.637025885, 5549035.576981313],
              [-12481709.148464369, 5547600.602210599],
              [-12492462.277316527, 5549941.903090516],
              [-12499641.159958294, 5553840.150836853],
              [-12507737.426523691, 5547650.570320714],
              [-12510906.915065555, 5535044.0421550805],
              [-12520460.131126452, 5540030.48167864],
              [-12534782.05153395, 5541744.991539455],
              [-12546576.57422248, 5543619.02627075],
              [-12549612.145416923, 5543015.946998686],
              [-12559976.769246211, 5534173.032893504],
              [-12559276.013051668, 5528711.866236298],
              [-12559824.916243251, 5528363.824184892],
              [-12565941.044923935, 5524486.680167853],
              [-12573664.0572367, 5530155.399655987],
              [-12579864.552873885, 5538733.735315817],
              [-12579862.549123049, 5546025.498254133],
              [-12585900.852262149, 5555224.225472612],
              [-12584595.965191072, 5563362.447380229],
              [-12590362.871411616, 5575759.14106974],
              [-12593728.39357677, 5584560.02732784],
              [-12606616.852901323, 5593691.5196601255],
              [-12612666.176670011, 5589931.106818896],
              [-12621086.939551068, 5595560.617420364],
              [-12626121.140883213, 5596775.235689875],
              [-12631931.684344148, 5607496.916397036],
              [-12629080.23558748, 5614210.902324093],
              [-12627829.895066889, 5622618.364445567],
              [-12629415.52989375, 5630853.541197006],
              [-12635966.570607442, 5637262.746811746],
              [-12643074.431414085, 5641759.874553819],
              [-12651467.253102953, 5658547.765958666],
              [-12660989.188386938, 5672873.980628923],
              [-12660631.741501998, 5682346.062589363],
              [-12664080.196687793, 5689112.373761852],
              [-12663703.71416993, 5697523.558652868],
              [-12668475.201503802, 5704261.637267738],
              [-12668907.121128082, 5716820.45982176],
              [-12674993.514287202, 5720244.218607165],
              [-12679165.657482643, 5723508.945726104],
              [-12684669.12418793, 5729627.115726052],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Skamania',
        GEOID: '53059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13608346.441507846, 5788983.405067233],
              [-13607802.089197868, 5842320.117160821],
              [-13607333.768100102, 5842405.970839228],
              [-13593700.69270163, 5842500.701338765],
              [-13584555.685213473, 5842715.34150349],
              [-13527803.227695208, 5842847.194483434],
              [-13527803.227695208, 5842782.1553739775],
              [-13527802.893736737, 5787404.019145596],
              [-13537811.740473451, 5787417.97206897],
              [-13537479.340473939, 5745565.969363689],
              [-13527990.478680441, 5736203.68969926],
              [-13529003.474444943, 5736634.994530323],
              [-13544060.103491675, 5733213.705138174],
              [-13551489.788946202, 5731453.589766151],
              [-13559972.334144648, 5733481.3470791895],
              [-13566190.974858832, 5731332.149365477],
              [-13569941.439823149, 5726350.375525282],
              [-13572489.694582885, 5725130.451490693],
              [-13575616.507463789, 5723633.78272606],
              [-13581388.645700403, 5719013.907742816],
              [-13592296.28600578, 5713856.724136927],
              [-13601426.710640647, 5712931.05664473],
              [-13608718.360822931, 5708527.168950148],
              [-13608346.441507846, 5788983.405067233],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cook',
        GEOID: '27031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10133695.938446615, 6138619.126096778],
              [-10119701.913911195, 6146430.80649131],
              [-10112665.965495605, 6147473.289228543],
              [-10108278.085127007, 6136491.065993405],
              [-10105133.86610955, 6127213.527872399],
              [-10097089.919704828, 6122842.200079219],
              [-10081773.582286075, 6127278.73122052],
              [-10071187.766628578, 6124520.279465621],
              [-10054068.05345897, 6124139.694852243],
              [-10033914.884165248, 6125530.58606223],
              [-10022052.122628862, 6121438.746610951],
              [-10015796.746482717, 6110241.017758805],
              [-10004077.030492, 6105174.386549074],
              [-9990847.933525618, 6110736.161383024],
              [-9977019.047142843, 6108771.067231778],
              [-9961895.069804177, 6109272.116836581],
              [-9969218.667783976, 6102671.624140834],
              [-9980974.117331235, 6098742.74942763],
              [-9989537.14652153, 6093254.178707077],
              [-9995771.038005952, 6088799.670861866],
              [-10010254.816953063, 6083937.468729895],
              [-10015892.81520327, 6078704.57810573],
              [-10026771.957719008, 6075486.772996028],
              [-10039641.715369109, 6070022.625862049],
              [-10054760.01541374, 6065988.424675025],
              [-10065663.091619998, 6062905.7923321845],
              [-10078544.42649714, 6057595.179365005],
              [-10090871.056351662, 6049844.197754897],
              [-10100677.190295642, 6044584.890633015],
              [-10115409.545665696, 6033452.828007469],
              [-10132647.814092997, 6018301.033434571],
              [-10132382.094468474, 6088241.380355214],
              [-10133695.938446615, 6138619.126096778],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Thurston',
        GEOID: '53067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13714771.770888396, 5955968.93449906],
              [-13703761.494012503, 5956003.26660597],
              [-13700641.542644043, 5956914.751796166],
              [-13700496.493347537, 5959432.7451609485],
              [-13699041.436283378, 5960705.755263794],
              [-13696094.364084115, 5960871.948914747],
              [-13694010.463216465, 5962303.537621529],
              [-13693461.324168384, 5965499.982613392],
              [-13692568.43053273, 5966805.472609821],
              [-13688860.155655425, 5968479.031978004],
              [-13687045.202677533, 5969883.544601782],
              [-13686402.555257183, 5972428.225495331],
              [-13685204.423577774, 5973053.291294681],
              [-13681434.47770257, 5967800.5983745195],
              [-13672323.979256557, 5973833.539991064],
              [-13665525.586634321, 5965170.858519073],
              [-13658030.77927768, 5958282.076729992],
              [-13654433.489932697, 5942600.490402601],
              [-13643365.326921595, 5931219.31680666],
              [-13635982.618292185, 5926616.9367959285],
              [-13635644.540998645, 5920549.1661936715],
              [-13614771.802516434, 5914063.381458975],
              [-13610578.397298252, 5903876.799492337],
              [-13603588.535151852, 5903484.988305654],
              [-13710209.675516704, 5903691.211087009],
              [-13710173.94196016, 5908413.888371726],
              [-13710164.145844968, 5913907.838997529],
              [-13709926.367412636, 5941400.140578301],
              [-13714771.770888396, 5955968.93449906],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clinch',
        GEOID: '13065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9236316.966522926, 3656666.610235379],
              [-9202968.096110059, 3656634.2102058125],
              [-9194107.287281895, 3635150.265053425],
              [-9182806.911812998, 3627966.470654504],
              [-9183354.38106872, 3609336.771996019],
              [-9176717.067749662, 3609403.528733108],
              [-9174839.343066614, 3578441.962461568],
              [-9179358.567946697, 3578874.793853892],
              [-9179382.104829283, 3578876.413872758],
              [-9193209.40502128, 3579828.1685929713],
              [-9192897.355736464, 3593362.2525460115],
              [-9213486.674795117, 3598045.2544649947],
              [-9222413.830039792, 3611337.6851894096],
              [-9236326.873957608, 3615798.799365071],
              [-9236316.966522926, 3656666.610235379],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Door',
        GEOID: '55029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9677479.336801903, 5688068.251827663],
              [-9666511.361332513, 5692675.010142708],
              [-9663185.02362812, 5686760.53514966],
              [-9670072.917120954, 5677276.66064634],
              [-9673651.616110977, 5668112.6504524965],
              [-9679919.682679074, 5677108.907431684],
              [-9677479.336801903, 5688068.251827663],
            ],
          ],
          [
            [
              [-9764921.242097983, 5573357.933140773],
              [-9765044.695413273, 5578260.945211281],
              [-9756741.485914495, 5589892.514395031],
              [-9749506.386929875, 5598219.1120284675],
              [-9743906.237306537, 5599105.712316495],
              [-9742141.04414103, 5601015.354516154],
              [-9734497.29130571, 5603609.464011195],
              [-9728589.343290329, 5611198.913369582],
              [-9722249.920928633, 5623651.759336461],
              [-9714281.67177765, 5634339.217643304],
              [-9711314.673389537, 5647891.538789567],
              [-9704284.179628998, 5648805.932775524],
              [-9698333.150970679, 5654608.209002552],
              [-9696900.914402133, 5662072.499674167],
              [-9691210.707310744, 5667741.252639271],
              [-9686692.137859954, 5668756.580233519],
              [-9682322.179929374, 5667400.4093734715],
              [-9682431.16171086, 5657381.697130959],
              [-9689712.680923138, 5651000.478701972],
              [-9689888.34307961, 5642797.519017836],
              [-9691826.30409483, 5634016.82187608],
              [-9700311.854919529, 5623499.805229289],
              [-9705765.508092983, 5613350.973011151],
              [-9707759.24017309, 5603581.025782958],
              [-9715523.218058467, 5595297.212617876],
              [-9720304.61282702, 5585594.410722521],
              [-9726595.227182401, 5570581.348005364],
              [-9766901.711670391, 5570816.123282051],
              [-9764921.242097983, 5573357.933140773],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Allamakee',
        GEOID: '19005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10198071.503408318, 5388494.833744067],
              [-10184736.207586005, 5388495.1641915925],
              [-10154308.583250536, 5388473.678887766],
              [-10155930.508231394, 5380865.182189407],
              [-10153524.599903954, 5376034.6518762605],
              [-10152271.659207998, 5373520.020339673],
              [-10153157.651035223, 5369020.608423665],
              [-10147306.587279638, 5363075.439500697],
              [-10142011.230422093, 5359834.3198150275],
              [-10136520.173899733, 5350708.606577988],
              [-10139809.21957471, 5345807.137206773],
              [-10145009.7322261, 5338555.854897765],
              [-10149582.736907888, 5332491.747300617],
              [-10149547.327726454, 5324196.283905526],
              [-10197456.129201498, 5324408.535987587],
              [-10198071.503408318, 5388494.833744067],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'La Crosse',
        GEOID: '55063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10177225.114167525, 5463012.410883479],
              [-10165934.456910511, 5463037.956809161],
              [-10164301.95657803, 5475487.388846336],
              [-10146986.655063098, 5477778.813634242],
              [-10145219.680785736, 5476439.277794873],
              [-10127079.94712199, 5476417.896391925],
              [-10120379.738290634, 5476517.056942076],
              [-10120127.599643987, 5423034.908380351],
              [-10158682.78868824, 5423084.93135175],
              [-10157230.608564368, 5430387.440317593],
              [-10162095.34015022, 5441805.562025203],
              [-10162467.856647717, 5442680.487637214],
              [-10169862.14250417, 5452642.41143159],
              [-10177225.114167525, 5463012.410883479],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hampton',
        GEOID: '51650',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8508760.938529262, 4452338.146246046],
              [-8504841.37925843, 4452475.615140964],
              [-8504340.998147314, 4454056.007773003],
              [-8502993.475711264, 4454671.033203299],
              [-8492912.03957186, 4455031.70389806],
              [-8490478.048000354, 4450897.691342133],
              [-8491876.883503085, 4446480.854998326],
              [-8494152.704391442, 4439298.864420292],
              [-8493320.066915823, 4438241.363380058],
              [-8498333.085229201, 4428626.1550969705],
              [-8503074.62762005, 4432287.236712404],
              [-8509608.859090634, 4441868.266183012],
              [-8508760.938529262, 4452338.146246046],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Baxter',
        GEOID: '05005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10307624.019862516, 4349536.8430667585],
              [-10300745.922484873, 4353943.043779001],
              [-10300296.367743045, 4369386.494260298],
              [-10280385.810257763, 4369334.054954871],
              [-10258125.168138688, 4369382.983879042],
              [-10258166.439895427, 4360761.137040285],
              [-10258869.199840805, 4336628.49348251],
              [-10259191.469766652, 4324559.929803634],
              [-10265204.392061852, 4324741.687462506],
              [-10265332.075517789, 4319658.590203737],
              [-10263148.321066897, 4318909.591004756],
              [-10263395.339016967, 4308782.241294818],
              [-10275340.143018069, 4309029.1438922165],
              [-10275592.726942679, 4297047.427808155],
              [-10287515.4896846, 4297300.94124129],
              [-10287201.346081583, 4309259.940253196],
              [-10287240.307903359, 4322952.238524705],
              [-10294860.572326122, 4328089.167682186],
              [-10293631.159869803, 4335200.523899902],
              [-10305417.556235503, 4343269.021009764],
              [-10307624.019862516, 4349536.8430667585],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Custer',
        GEOID: '08027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11777256.701548412, 4616936.023879072],
              [-11694025.122033115, 4615933.118181433],
              [-11694103.268315652, 4567492.70125804],
              [-11707320.788054992, 4582102.593083641],
              [-11720281.048451109, 4565227.100661816],
              [-11723843.828753946, 4570804.940402814],
              [-11741223.361615065, 4564740.2684695665],
              [-11753548.432996716, 4574792.743758373],
              [-11763828.565332493, 4600095.7844908],
              [-11777256.701548412, 4616936.023879072],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Baldwin',
        GEOID: '01003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9799045.007486263, 3600759.2396116997],
              [-9789942.078765623, 3610308.085404275],
              [-9794660.355382897, 3616549.9965975657],
              [-9787687.191160116, 3624363.0913126688],
              [-9792239.824375087, 3628565.988906893],
              [-9789564.260413872, 3639005.346775849],
              [-9793468.23495599, 3644382.434646583],
              [-9789449.490018863, 3651885.46942205],
              [-9793094.980703363, 3653896.130037909],
              [-9790169.393165823, 3657830.205137836],
              [-9777849.887758715, 3662792.2679141085],
              [-9774299.129960882, 3674249.246854978],
              [-9769972.030034255, 3671425.6886996683],
              [-9764684.131582594, 3672178.4524369063],
              [-9753356.260199469, 3664537.528889188],
              [-9753316.185182784, 3633752.2924482366],
              [-9751457.032384971, 3632414.3685098146],
              [-9751469.06087205, 3632414.345535916],
              [-9750703.962011829, 3626446.903543009],
              [-9755477.230457554, 3615340.3475321513],
              [-9745160.696648287, 3602588.7992874244],
              [-9743084.922103465, 3598806.9084716165],
              [-9734031.307917248, 3592899.317672156],
              [-9729344.53471587, 3588309.7334701563],
              [-9729455.854206663, 3581476.625272017],
              [-9732824.49331756, 3574477.5180491884],
              [-9734301.925599366, 3568950.3999087596],
              [-9730958.222054409, 3562466.5539264944],
              [-9725605.535659106, 3559800.6149179535],
              [-9732861.674027484, 3555482.5420251116],
              [-9735143.500949763, 3547857.430467621],
              [-9742495.262760732, 3539648.3206769857],
              [-9757920.136683013, 3535688.1596921925],
              [-9775951.556482214, 3532931.368374219],
              [-9784226.379510842, 3534338.745211936],
              [-9774571.08347689, 3539566.2075101226],
              [-9773485.829761146, 3545290.9142425256],
              [-9781088.950982325, 3552934.6050701193],
              [-9786556.8530506, 3561027.3725715475],
              [-9788696.302344156, 3566350.1304421597],
              [-9785173.708377492, 3574558.5664332556],
              [-9786648.13503305, 3579085.439466436],
              [-9788441.937307693, 3587726.5135557624],
              [-9797049.828252774, 3591901.917004652],
              [-9799045.007486263, 3600759.2396116997],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Halifax',
        GEOID: '51083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8818558.127235673, 4375381.35884603],
              [-8804510.554167163, 4447682.285503324],
              [-8791086.648091892, 4446086.804594357],
              [-8783618.446093554, 4442213.9025193425],
              [-8782295.413945476, 4435858.729090996],
              [-8771403.914966261, 4432973.85627146],
              [-8765729.849201037, 4439864.94082677],
              [-8766379.509749306, 4427970.72816368],
              [-8757667.201121863, 4419325.440566008],
              [-8755115.535753898, 4397082.431466219],
              [-8744060.285803728, 4387190.682795398],
              [-8755673.246402772, 4396102.423102018],
              [-8762146.586111894, 4389195.075791985],
              [-8764642.458275437, 4375404.109568935],
              [-8771561.093093524, 4375424.998151252],
              [-8787784.24407802, 4375473.9788734475],
              [-8809639.254489405, 4375408.201857613],
              [-8818558.127235673, 4375381.35884603],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Columbia',
        GEOID: '53013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13161151.4453838, 5875951.152603485],
              [-13159707.07499076, 5875232.241034123],
              [-13154100.13487848, 5869760.69032859],
              [-13119207.931045258, 5881024.408610859],
              [-13120487.771230908, 5856097.4277189085],
              [-13106456.61733336, 5856224.632285327],
              [-13099515.067845965, 5834624.11972515],
              [-13092497.153187884, 5834757.464102649],
              [-13091553.4794415, 5780150.539407464],
              [-13104291.34191794, 5780327.746688428],
              [-13133212.736346474, 5780376.174846944],
              [-13135362.663372366, 5780379.774857058],
              [-13134751.582864212, 5813696.3142495435],
              [-13148682.437900558, 5813752.292172114],
              [-13148625.998918723, 5827823.167498188],
              [-13162624.981483432, 5827760.172475853],
              [-13161151.4453838, 5875951.152603485],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Iberia',
        GEOID: '22045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10246168.125041166, 3449353.6743630166],
              [-10239744.956600482, 3455974.1722970093],
              [-10238014.38379661, 3480034.1516542677],
              [-10240324.040591588, 3499736.097470759],
              [-10237436.635639394, 3508296.1914073788],
              [-10235938.275293317, 3512964.16767699],
              [-10221268.370157598, 3509208.559756511],
              [-10211328.764144154, 3519303.755637073],
              [-10203420.516198711, 3517468.8861137303],
              [-10196904.7637636, 3507814.122093876],
              [-10171132.18657463, 3511113.363413792],
              [-10155882.19557239, 3508742.015671251],
              [-10155048.857864311, 3506806.9659696105],
              [-10158948.60226578, 3503575.5516654714],
              [-10158485.624503572, 3499881.434364305],
              [-10182611.00718727, 3497893.8933280366],
              [-10199615.949961869, 3496517.392771951],
              [-10209238.40674604, 3483778.241185596],
              [-10234189.223453972, 3461449.9787178705],
              [-10226093.067820966, 3460867.8774255896],
              [-10227285.188634973, 3455729.1865774896],
              [-10219544.476523174, 3451718.2548528924],
              [-10209230.837020665, 3448310.2300783736],
              [-10215596.308143206, 3438207.408137596],
              [-10221531.418114342, 3436105.4675158993],
              [-10231966.729820283, 3441808.1111416635],
              [-10244753.443130255, 3448737.847929953],
              [-10246168.125041166, 3449353.6743630166],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Van Buren',
        GEOID: '05141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10331942.319223762, 4238740.607220403],
              [-10331535.557804402, 4262491.100778484],
              [-10311658.794806316, 4261937.708965957],
              [-10311506.28710393, 4271876.980767312],
              [-10287782.099865051, 4271570.538515925],
              [-10287970.118485, 4261619.754447192],
              [-10268167.716906765, 4261091.084708496],
              [-10269530.156154584, 4213419.480499205],
              [-10294990.036893914, 4214057.525747452],
              [-10294757.490477646, 4225961.375402329],
              [-10336084.183517706, 4226973.534339016],
              [-10331942.319223762, 4238740.607220403],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '48339',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10667773.519397195, 3584826.99293872],
              [-10642028.772080926, 3569146.5368527286],
              [-10615332.688396338, 3568547.9282182525],
              [-10609681.99972418, 3555812.5738642276],
              [-10598039.984738039, 3548889.1366737676],
              [-10600525.30368949, 3544690.214015026],
              [-10593819.194925122, 3547970.8134097857],
              [-10586117.110676624, 3525061.8031233433],
              [-10607932.725245856, 3507118.7605536766],
              [-10620485.333666686, 3515390.8538871515],
              [-10622575.134467348, 3518403.7896928852],
              [-10630023.187637854, 3517744.524316844],
              [-10631110.779062904, 3521996.3123284266],
              [-10636735.530293707, 3525498.5583720086],
              [-10639319.144355528, 3523075.0911803422],
              [-10652297.104550678, 3516246.730433521],
              [-10664777.91189995, 3515136.109211334],
              [-10664886.559722964, 3535154.79390633],
              [-10667773.519397195, 3584826.99293872],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kitsap',
        GEOID: '53035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13686800.522436768, 6041606.649086277],
              [-13668167.420789827, 6052584.411144675],
              [-13661347.320866887, 6071602.273875146],
              [-13647272.52972895, 6087295.706002052],
              [-13651565.8848529, 6094060.188895017],
              [-13649628.718071079, 6094409.655733019],
              [-13644846.974239668, 6098707.541352114],
              [-13636838.999134855, 6095169.537990883],
              [-13628803.513011437, 6078303.965520766],
              [-13629746.166459475, 6069970.279613499],
              [-13630517.944489142, 6031112.963038866],
              [-13640755.664098928, 6008162.197580449],
              [-13670166.941483457, 6008198.874728153],
              [-13670146.124738676, 6027435.144942172],
              [-13696572.481297074, 6027407.122567139],
              [-13686800.522436768, 6041606.649086277],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Virginia Beach',
        GEOID: '51810',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8485446.184377518, 4416820.882029261],
              [-8482240.071723182, 4415179.828471179],
              [-8481779.542989772, 4422035.156924005],
              [-8479979.01537021, 4429150.676196862],
              [-8470072.406101514, 4426380.99508858],
              [-8465074.049645405, 4429012.579355305],
              [-8459864.074837297, 4428246.707124563],
              [-8456005.407327931, 4411265.215151372],
              [-8451570.327495236, 4396269.15283825],
              [-8448141.464539822, 4387762.733658898],
              [-8445480.70607088, 4376671.317937187],
              [-8463259.09666751, 4376643.4648772115],
              [-8473901.234088538, 4376643.372387726],
              [-8473857.268788485, 4392618.492247926],
              [-8467850.58038477, 4396342.453662986],
              [-8482957.080563381, 4407060.20501974],
              [-8485171.33655475, 4414156.992798612],
              [-8485446.184377518, 4416820.882029261],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gordon',
        GEOID: '13129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9469855.462092025, 4107921.654322055],
              [-9467772.34046081, 4112695.57069306],
              [-9453932.322128957, 4111840.936786293],
              [-9452522.68341704, 4114271.092043878],
              [-9446994.223545773, 4110817.436643035],
              [-9430507.695639798, 4112748.869106474],
              [-9423698.393707465, 4107381.2035701335],
              [-9423680.91654741, 4102752.402178049],
              [-9422575.06872587, 4090168.787328883],
              [-9423554.680244852, 4084338.247165392],
              [-9461034.171683094, 4080556.3979329485],
              [-9462799.587487584, 4081620.454605505],
              [-9473824.224577788, 4083261.2516877935],
              [-9469855.462092025, 4107921.654322055],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fremont',
        GEOID: '16043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12485141.573643489, 5474388.129623342],
              [-12471603.119812192, 5474322.760691393],
              [-12471530.428184705, 5487761.22615937],
              [-12458165.076161591, 5487805.903543178],
              [-12451959.014549866, 5494544.445586897],
              [-12451338.408388695, 5514629.812639575],
              [-12444577.419115365, 5514633.702288992],
              [-12444586.6586331, 5527804.067359587],
              [-12425196.250490293, 5527748.598886362],
              [-12425159.518877147, 5552067.625549927],
              [-12419115.645944692, 5551767.948974556],
              [-12414252.320030915, 5556097.408879802],
              [-12408653.72888045, 5571179.823897123],
              [-12407330.611293994, 5573732.9410387],
              [-12405309.69137702, 5577633.94110154],
              [-12399322.038606232, 5583053.428847869],
              [-12398446.314525379, 5582437.130458831],
              [-12392494.146318935, 5578249.351038544],
              [-12386380.591204058, 5569449.108074919],
              [-12381416.966429077, 5562427.410804752],
              [-12378889.791349089, 5554969.022326629],
              [-12372444.170193177, 5548725.731942114],
              [-12370117.258877123, 5542157.59563672],
              [-12361915.238795476, 5539101.429640606],
              [-12361934.608386874, 5523647.204150107],
              [-12361857.130021282, 5483229.775678805],
              [-12361719.893460823, 5462878.495605629],
              [-12377308.720621353, 5454942.6715472415],
              [-12400855.575911399, 5453516.97723312],
              [-12412260.369062662, 5454493.176839311],
              [-12418672.483051844, 5447401.086922598],
              [-12449672.178250501, 5454176.627042383],
              [-12465205.811315285, 5454211.712835335],
              [-12465224.401670245, 5460941.387189503],
              [-12485189.997621983, 5460993.667989576],
              [-12485141.573643489, 5474388.129623342],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rockdale',
        GEOID: '13247',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9371335.931628125, 3981387.9404621543],
              [-9363727.021793425, 3977177.6992499214],
              [-9353476.94572016, 3995658.278719454],
              [-9348837.149343897, 4000110.355954485],
              [-9341355.366367681, 3994506.237187972],
              [-9343140.931000005, 3982145.6291255886],
              [-9351202.1319258, 3969188.0731909648],
              [-9355790.164738845, 3965301.6940863873],
              [-9356372.031717222, 3967345.622941394],
              [-9361687.64872209, 3969873.8913602293],
              [-9364705.96539546, 3970024.044758854],
              [-9371335.931628125, 3981387.9404621543],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Huntingdon',
        GEOID: '42061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8711563.343453903, 4909324.718056655],
              [-8697400.832557216, 4936232.958973574],
              [-8704859.461079348, 4947428.804950941],
              [-8701440.616878105, 4956151.360833269],
              [-8707629.869246721, 4964454.1175356],
              [-8695891.340262061, 4973938.7715443745],
              [-8692411.715618845, 4972733.075146412],
              [-8676714.220263613, 4966952.293805868],
              [-8663384.379158063, 4974607.86720125],
              [-8647446.545022208, 4972562.3768918635],
              [-8648086.186816307, 4964778.647696128],
              [-8665312.544058092, 4946196.77427135],
              [-8662494.602468153, 4938880.009008595],
              [-8673329.439826554, 4924047.48909946],
              [-8666992.021215692, 4919159.027627789],
              [-8655326.4064975, 4921104.856259197],
              [-8649861.73269446, 4904318.676797509],
              [-8657130.338845806, 4895650.240200651],
              [-8667835.26635845, 4874893.2111809105],
              [-8674633.658980686, 4881063.45788023],
              [-8697933.16236219, 4889967.762437423],
              [-8709225.30018877, 4898628.4417895805],
              [-8711563.343453903, 4909324.718056655],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ripley',
        GEOID: '29181',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10142978.485477597, 4414557.354155179],
              [-10092516.358425587, 4412858.2513635],
              [-10088609.044298744, 4412788.869101411],
              [-10088705.892255733, 4394532.986698668],
              [-10082894.131579317, 4369419.763041698],
              [-10103988.388549289, 4369431.959188679],
              [-10106055.831401428, 4369427.555574012],
              [-10132074.518715411, 4369372.136410594],
              [-10144159.905269992, 4369335.53680833],
              [-10142978.485477597, 4414557.354155179],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Griggs',
        GEOID: '38039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10964989.991965279, 6052528.037751464],
              [-10907619.15467566, 6052509.356913566],
              [-10907816.746771818, 5995465.281502672],
              [-10904991.792053958, 5981420.493853017],
              [-10961349.288018884, 5981410.8199243],
              [-10961325.799606329, 5995343.423348148],
              [-10964885.90824139, 5995537.214747734],
              [-10964979.305294164, 6038456.957259581],
              [-10964989.991965279, 6052528.037751464],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Strafford',
        GEOID: '33017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7929956.470664033, 5355451.936587311],
              [-7921424.165653202, 5366182.350235789],
              [-7921792.744487219, 5394370.041324489],
              [-7907906.305927702, 5392967.647476398],
              [-7906382.676057215, 5385767.389360899],
              [-7899653.265875484, 5394563.834271834],
              [-7898647.19596148, 5389893.657699171],
              [-7899318.886196935, 5384413.656319178],
              [-7900161.586314233, 5377543.044754621],
              [-7901940.0264991475, 5369398.730613731],
              [-7895217.887728103, 5361536.221983677],
              [-7889500.073402998, 5353182.554013358],
              [-7882880.348563486, 5345098.496488788],
              [-7884178.079134721, 5339373.774390735],
              [-7884180.782854932, 5339361.8510501245],
              [-7884548.02585506, 5331640.737808839],
              [-7883596.164694713, 5330747.707250365],
              [-7889817.44527125, 5324220.917593725],
              [-7911803.044702922, 5324412.803549736],
              [-7906654.5182537325, 5332992.413280932],
              [-7917926.952530442, 5342474.596955645],
              [-7931217.1638972685, 5353959.237664486],
              [-7929956.470664033, 5355451.936587311],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Caswell',
        GEOID: '37033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8851418.768906225, 4375284.878476378],
              [-8851084.736683724, 4375283.46451614],
              [-8846566.242253846, 4375297.063635492],
              [-8832435.262095891, 4375339.593153268],
              [-8818558.127235673, 4375381.35884603],
              [-8809639.254489405, 4375408.201857613],
              [-8811382.640292302, 4333954.242080981],
              [-8822954.857957719, 4334170.940395969],
              [-8853446.713639377, 4335030.599272243],
              [-8851418.768906225, 4375284.878476378],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grant',
        GEOID: '05053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10315833.72098903, 4084560.4864101377],
              [-10307006.864605557, 4090148.8067208766],
              [-10286441.92451539, 4089645.9280795464],
              [-10286316.91272723, 4095571.0611006827],
              [-10268757.48756899, 4095261.8924694364],
              [-10264552.171165291, 4095161.809554009],
              [-10265093.740488, 4059781.2329003187],
              [-10267372.45046454, 4037172.0773151345],
              [-10278881.661298165, 4036812.0944721964],
              [-10286575.841862816, 4044326.124126616],
              [-10296348.468640065, 4048185.609989173],
              [-10316910.403103981, 4048910.342696705],
              [-10315833.72098903, 4084560.4864101377],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wells',
        GEOID: '38103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11139653.056007195, 6081488.654276089],
              [-11111039.605413185, 6081481.355823678],
              [-11053714.186475806, 6081407.3764055],
              [-11053726.876897756, 6052625.740845867],
              [-11050223.429883512, 6038521.326256555],
              [-11050271.742542515, 5995644.951499848],
              [-11074143.76206517, 5995625.571924401],
              [-11135655.127814846, 5995644.623032107],
              [-11135605.813280426, 6052727.743395755],
              [-11139653.056007195, 6081488.654276089],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gaston',
        GEOID: '37071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9067595.914260576, 4221079.146899588],
              [-9011853.79244075, 4218383.939398153],
              [-9008314.055272507, 4213000.416535752],
              [-9013828.26624895, 4211593.188027663],
              [-9018554.112591598, 4200450.484933726],
              [-9017525.075218704, 4185240.469778234],
              [-9021587.841463896, 4183844.3479624013],
              [-9021651.020825466, 4184181.893473709],
              [-9053401.676116984, 4185957.0799574098],
              [-9052693.462708589, 4199331.693264213],
              [-9056584.412870286, 4208900.163416892],
              [-9067595.914260576, 4221079.146899588],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dundy',
        GEOID: '31057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11360299.752667017, 4915237.415960205],
              [-11360299.70277852, 4916820.7073894115],
              [-11281427.555730674, 4916999.296850439],
              [-11279264.061427107, 4917015.218457483],
              [-11279504.625910113, 4866315.075919841],
              [-11289024.107744023, 4866317.578571956],
              [-11303634.12435157, 4866321.419516383],
              [-11335904.308898652, 4866368.504224215],
              [-11360348.176645512, 4866389.576156573],
              [-11360299.752667017, 4915237.415960205],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hale',
        GEOID: '48189',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11364653.012673978, 4070925.9018173427],
              [-11354367.648322133, 4070913.3678052016],
              [-11306148.052412156, 4070839.7813042975],
              [-11306115.435801353, 4038773.3931028447],
              [-11306006.008741904, 4006058.3952843477],
              [-11364131.814818084, 4005284.3873296673],
              [-11364653.012673978, 4070925.9018173427],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '51191',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9165164.998912081, 4398618.083824841],
              [-9139759.108125787, 4411011.085495788],
              [-9136959.422932334, 4418883.719580454],
              [-9122181.426571056, 4420251.514263386],
              [-9110063.854720246, 4429220.349131376],
              [-9094753.528553993, 4409780.699938447],
              [-9086506.535398062, 4389921.1003223695],
              [-9084323.337544626, 4388779.017846711],
              [-9088891.332849327, 4385150.330662628],
              [-9108910.378637785, 4385538.801699689],
              [-9119587.014518628, 4385745.988364287],
              [-9120867.18866275, 4382695.239708861],
              [-9144403.387395218, 4382743.397453228],
              [-9139632.20390628, 4389997.548733761],
              [-9142838.093921639, 4394214.296854471],
              [-9140930.189168932, 4388826.047259341],
              [-9148194.787818609, 4387214.124627448],
              [-9155291.739894036, 4382787.191485921],
              [-9160941.361560961, 4382814.484477513],
              [-9162465.835218815, 4386227.115396792],
              [-9165164.998912081, 4398618.083824841],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Richmond',
        GEOID: '36085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8265384.360322327, 4945468.529215492],
              [-8261780.725766366, 4947454.299906264],
              [-8260316.763142945, 4952448.046651298],
              [-8260156.351756712, 4958051.434315056],
              [-8259919.898247966, 4958193.115207205],
              [-8256634.648345974, 4960161.820560564],
              [-8255469.777055038, 4960277.360166626],
              [-8247305.518420045, 4961087.183371231],
              [-8245539.717195785, 4963378.1859013755],
              [-8243847.155799571, 4961111.246611949],
              [-8243946.341465866, 4957521.048666298],
              [-8242250.16638465, 4953974.979176654],
              [-8241869.178089705, 4951990.653338611],
              [-8244022.706636551, 4953159.803650016],
              [-8250175.223573205, 4945840.48267045],
              [-8259897.645260108, 4940586.390707576],
              [-8266653.40251737, 4939225.800031133],
              [-8265384.360322327, 4945468.529215492],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sonoma',
        GEOID: '06097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13752512.530466622, 4688444.7535504345],
              [-13733289.211584402, 4689788.31233607],
              [-13707464.982151704, 4694368.700787437],
              [-13701313.912368432, 4700556.569461268],
              [-13672437.079859203, 4700228.089967145],
              [-13666969.957027365, 4696139.422621008],
              [-13650819.280025113, 4674155.9507457],
              [-13652937.133337455, 4664335.483156983],
              [-13648065.569781361, 4658483.430914346],
              [-13641523.768585403, 4653142.227648249],
              [-13619891.163259035, 4606863.906333232],
              [-13626261.08716121, 4601434.78386351],
              [-13625236.416921405, 4599505.62631665],
              [-13635357.407874389, 4594848.687028568],
              [-13637272.92250997, 4595758.641214781],
              [-13643883.741790218, 4605199.0399624705],
              [-13663343.16801732, 4608711.932316031],
              [-13682383.587681072, 4624903.620153814],
              [-13692647.631796317, 4621283.678883626],
              [-13692756.226513699, 4621469.03194176],
              [-13698253.405608054, 4621805.630496961],
              [-13699915.739564069, 4626888.571708921],
              [-13701823.199038811, 4634741.741931291],
              [-13710824.047786392, 4646738.875660679],
              [-13720104.642414337, 4651873.01645173],
              [-13729244.195247445, 4659628.886344778],
              [-13731215.997387867, 4664080.809254147],
              [-13741475.424298357, 4678753.281212018],
              [-13749602.860321172, 4684777.525083735],
              [-13752512.530466622, 4688444.7535504345],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hardin',
        GEOID: '17069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9841991.28779787, 4523059.954805519],
              [-9837902.188942563, 4523015.415334429],
              [-9816116.741955336, 4522963.850947194],
              [-9810836.748998655, 4519525.663000829],
              [-9810767.283825265, 4519274.917393712],
              [-9804157.132461961, 4513076.898614579],
              [-9803490.141706174, 4509612.079180099],
              [-9803049.72616755, 4507324.878911982],
              [-9813599.140351556, 4504393.179911389],
              [-9827470.216821345, 4502382.003543703],
              [-9836016.102810051, 4495690.301315589],
              [-9842413.208569197, 4497983.278870246],
              [-9841991.28779787, 4523059.954805519],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oconee',
        GEOID: '45073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9278840.01013054, 4127066.3620553394],
              [-9275146.874703983, 4131261.7129064146],
              [-9275570.33404696, 4135340.438700121],
              [-9271222.86265352, 4139859.3216207474],
              [-9267635.035465252, 4143987.8522318266],
              [-9261913.324957969, 4148216.9748144452],
              [-9255171.593956547, 4153682.0682286914],
              [-9253363.43146759, 4157800.101275488],
              [-9251607.7004588, 4163970.6998926047],
              [-9240460.9249891, 4167539.8686320805],
              [-9228107.376715904, 4171496.7826466886],
              [-9233239.761838928, 4162271.436485703],
              [-9230142.964924552, 4160054.427330046],
              [-9228401.816769052, 4128934.6216719714],
              [-9223423.72046027, 4126545.9815645856],
              [-9221723.871835856, 4112781.8763726284],
              [-9237096.759555934, 4095136.687666293],
              [-9238559.06943917, 4092489.968671786],
              [-9238971.15714191, 4092422.7732542935],
              [-9244893.242732624, 4095227.8560745134],
              [-9245147.492453491, 4095470.9284570566],
              [-9250299.919080961, 4100397.9749555984],
              [-9250969.597771958, 4101196.1856809454],
              [-9256725.168770058, 4108058.7655519852],
              [-9264164.093742318, 4111000.028615772],
              [-9270460.101502605, 4115722.2121877377],
              [-9277220.53417848, 4120750.0194222312],
              [-9277370.716058766, 4121335.6148172077],
              [-9278435.977253567, 4125490.2039439324],
              [-9278840.01013054, 4127066.3620553394],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rogers',
        GEOID: '40131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10665750.176332537, 4335012.792540954],
              [-10665766.428978194, 4349027.918804223],
              [-10663781.602457348, 4358300.696742617],
              [-10665818.749138867, 4359060.18548559],
              [-10665800.047464414, 4380795.201648513],
              [-10665477.777538566, 4383147.666252489],
              [-10623393.778002642, 4383156.540271199],
              [-10611905.606552776, 4383169.019372466],
              [-10611883.342654618, 4371058.657373825],
              [-10623843.508745447, 4371047.5773754725],
              [-10624328.861725306, 4310973.715715549],
              [-10638973.497336615, 4310985.0095742745],
              [-10644204.956806444, 4323005.874938473],
              [-10656214.99402915, 4323003.668808237],
              [-10660138.115523685, 4323038.691178903],
              [-10666121.538153825, 4323022.145162873],
              [-10665750.176332537, 4335012.792540954],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Milwaukee',
        GEOID: '55079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9803828.51732514, 5304725.491371509],
              [-9803823.730587035, 5305760.5370880505],
              [-9803465.0591877, 5327848.824044913],
              [-9803416.523889715, 5330358.192438915],
              [-9803420.08611342, 5331080.965680654],
              [-9803167.613508299, 5341259.880931281],
              [-9791579.477155702, 5341304.160695489],
              [-9787728.60201069, 5341264.156209682],
              [-9784602.451392122, 5341262.573215328],
              [-9785037.23068178, 5331156.311798536],
              [-9781664.138791254, 5321781.15482161],
              [-9784513.917755563, 5314379.208843741],
              [-9778602.518835967, 5303469.596937078],
              [-9777734.004168797, 5290188.080610427],
              [-9776910.075680912, 5289004.586736354],
              [-9776207.139135055, 5287995.0041735945],
              [-9803899.093882302, 5288154.334609936],
              [-9803828.51732514, 5304725.491371509],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rawlins',
        GEOID: '20153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11289024.107744023, 4866317.578571956],
              [-11279504.625910113, 4866315.075919841],
              [-11275995.498538436, 4866314.153377667],
              [-11249983.02784681, 4866277.532119535],
              [-11216421.648526018, 4866276.805508639],
              [-11214194.670185266, 4866271.131633797],
              [-11214422.684429841, 4803368.587221285],
              [-11286579.421764588, 4803415.6642938135],
              [-11289345.154513346, 4803414.509025581],
              [-11289024.107744023, 4866317.578571956],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lunenburg',
        GEOID: '51111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8732306.506048828, 4450175.863052771],
              [-8713551.73219845, 4453546.8172419295],
              [-8709565.047274671, 4455858.890145671],
              [-8692051.040468674, 4440657.024616704],
              [-8683325.373502335, 4442279.155017394],
              [-8685971.660437472, 4408188.12401646],
              [-8729806.604244085, 4418449.111863657],
              [-8737803.907782163, 4423955.084986615],
              [-8732306.506048828, 4450175.863052771],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cascade',
        GEOID: '30013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12473101.925436234, 6026714.5042490885],
              [-12459668.779843228, 6024096.176365834],
              [-12459204.243608145, 6042419.515457343],
              [-12430631.201989291, 6042423.1481824275],
              [-12430655.914916249, 6056719.51957392],
              [-12401976.451864196, 6056779.39374301],
              [-12353810.845907252, 6056881.114624208],
              [-12362012.42071094, 6040290.010829873],
              [-12341394.158584682, 6028145.295200812],
              [-12330689.119752545, 6028297.619147405],
              [-12330763.035894431, 6015194.713591481],
              [-12316342.709057072, 6015084.264501109],
              [-12316339.369472349, 6010322.137687743],
              [-12316267.234442314, 6000875.406341546],
              [-12330539.951634882, 6000891.182319263],
              [-12332897.364491412, 5992468.264627557],
              [-12330937.696175486, 5957847.0995652145],
              [-12316968.658553801, 5957736.559959022],
              [-12315985.596130608, 5915534.989090922],
              [-12317821.922450732, 5913332.713858176],
              [-12328810.158067446, 5916734.392544798],
              [-12328935.83777255, 5924167.690902812],
              [-12340437.701519784, 5929245.337167426],
              [-12346782.57853653, 5938901.383531934],
              [-12368145.01145874, 5946777.212956421],
              [-12365438.16672061, 5956413.954492021],
              [-12374114.185194056, 5956498.97191989],
              [-12374094.92692215, 5943995.610918883],
              [-12388219.366552982, 5942241.543353159],
              [-12416506.205761006, 5942165.315936265],
              [-12416488.505961971, 5927945.460174124],
              [-12429726.397168124, 5927953.934171882],
              [-12444432.14717988, 5928009.504245558],
              [-12444325.5031077, 5963142.871208932],
              [-12461341.91178985, 5965541.880954813],
              [-12465304.88566209, 5972176.311785185],
              [-12472715.64680318, 5973605.175261682],
              [-12473101.925436234, 6026714.5042490885],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mathews',
        GEOID: '51115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8508990.367999787, 4511046.51238744],
              [-8505267.510269187, 4514019.661643774],
              [-8492507.491058977, 4514094.525946047],
              [-8490725.845186863, 4508374.879071109],
              [-8488161.712035928, 4498076.541383693],
              [-8487939.740971288, 4491525.561258101],
              [-8490955.608615858, 4482400.289136881],
              [-8501107.834856715, 4491435.909652922],
              [-8504136.504242728, 4494440.355588847],
              [-8505137.029950326, 4493972.365114456],
              [-8510146.198272692, 4497821.157223804],
              [-8508990.367999787, 4511046.51238744],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Whitman',
        GEOID: '53075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13163432.047791684, 5898786.082857587],
              [-13159104.05730913, 5899548.673313813],
              [-13137432.824119462, 5907030.291107973],
              [-13131173.106513174, 5928180.127766392],
              [-13131350.66110099, 5984709.598238274],
              [-13116066.38369558, 5984652.51699955],
              [-13028850.985940782, 5984497.021735121],
              [-13028814.946048247, 5967367.273327958],
              [-13028814.655062215, 5962872.409168645],
              [-13028808.451175122, 5867587.523786891],
              [-13028807.710281348, 5856277.163297294],
              [-13028459.808866974, 5848897.040935101],
              [-13047604.785538228, 5848510.504669739],
              [-13049774.62505277, 5854736.276207941],
              [-13052684.739181086, 5868133.436564089],
              [-13066987.067358207, 5879405.924295144],
              [-13076118.271229506, 5893182.470443075],
              [-13090926.3238533, 5888787.5907800095],
              [-13106853.471318038, 5892363.953284766],
              [-13119207.931045258, 5881024.408610859],
              [-13154100.13487848, 5869760.69032859],
              [-13159707.07499076, 5875232.241034123],
              [-13163432.047791684, 5898786.082857587],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Berrien',
        GEOID: '26021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9650650.337645307, 5136355.410952241],
              [-9640034.020447334, 5148747.679442027],
              [-9629283.117984992, 5173651.550263819],
              [-9625380.25663778, 5181134.122288974],
              [-9614261.346080715, 5197465.653334674],
              [-9598363.127541743, 5197506.444983566],
              [-9598293.775498979, 5171693.422370649],
              [-9598644.915576762, 5125098.511152685],
              [-9629333.323075341, 5125029.422323989],
              [-9631832.083014052, 5125032.281019604],
              [-9644725.580386817, 5125047.031783627],
              [-9644867.949167958, 5125047.619483903],
              [-9665295.641173562, 5125131.945649456],
              [-9650650.337645307, 5136355.410952241],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cooper',
        GEOID: '29053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10358329.046043435, 4711398.347033977],
              [-10358108.410812682, 4717721.457472292],
              [-10345428.898172347, 4730921.59834618],
              [-10336307.267777255, 4719119.761443458],
              [-10303519.002320023, 4717474.322105967],
              [-10296872.226844247, 4710516.91141878],
              [-10310093.642765766, 4675939.277425327],
              [-10334883.380170519, 4676504.1266801],
              [-10359388.918915277, 4677802.357475161],
              [-10358329.046043435, 4711398.347033977],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cooke',
        GEOID: '48097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10851885.208002012, 4017245.2897102516],
              [-10848247.906136483, 4011484.217510303],
              [-10847437.945521472, 4005163.520308974],
              [-10839506.20916347, 4004584.7966650776],
              [-10833417.25565606, 4010705.418654587],
              [-10825395.239191024, 4015428.496718086],
              [-10820938.118099153, 4017297.723861349],
              [-10816539.66237893, 4008318.004384875],
              [-10820883.682868155, 4003294.5317294695],
              [-10814621.070955107, 3991529.8059231755],
              [-10808128.69561306, 3993289.6568738767],
              [-10807770.246852707, 3998509.225100397],
              [-10806739.205728978, 4003687.35713804],
              [-10804206.46467445, 4009447.9761482286],
              [-10796383.932736915, 4013574.8620786793],
              [-10796737.706078658, 4017859.517464587],
              [-10792682.114390075, 4021363.167858963],
              [-10791825.387162393, 4021421.036678539],
              [-10791741.1307344, 3950706.760403741],
              [-10840636.547272986, 3952579.3738446413],
              [-10843271.813578535, 3952934.190861503],
              [-10852210.434730763, 3953010.3578870604],
              [-10851885.208002012, 4017245.2897102516],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Garfield',
        GEOID: '30033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12018484.924902529, 6000050.494165142],
              [-12012442.057664307, 6007870.266178442],
              [-12012388.290350253, 6015951.270127587],
              [-12007468.191496173, 6026336.406183257],
              [-11996002.172624974, 6031993.121283905],
              [-11988517.717980979, 6045479.967503866],
              [-11979185.248470325, 6048388.823574281],
              [-11960173.215276724, 6044769.712522768],
              [-11957370.413137529, 6055722.725347551],
              [-11938904.068087798, 6050735.027014248],
              [-11912449.8816567, 6050990.39299205],
              [-11899246.833451165, 6052925.635088497],
              [-11895786.467079857, 6063273.577642233],
              [-11881624.95805859, 6062741.270591067],
              [-11879122.050627595, 6069025.948294641],
              [-11867005.703291183, 6071118.160074007],
              [-11856674.697948113, 6086747.637634022],
              [-11855717.795605253, 6099918.081374939],
              [-11846466.58932288, 6099780.111578245],
              [-11839750.461804338, 6099740.050883818],
              [-11839727.863947708, 6084991.132980787],
              [-11828912.841458669, 6084994.285870675],
              [-11833047.358666223, 6028858.636215722],
              [-11833056.82082294, 6000097.4890455725],
              [-11818865.478178142, 6000129.859793168],
              [-11818837.091707988, 5971639.586302933],
              [-11809525.995539567, 5971657.929745772],
              [-11809504.622197334, 5919299.585061471],
              [-11809491.041219458, 5916954.11114352],
              [-11878868.464827565, 5916842.298099958],
              [-11963254.984059844, 5919130.925643791],
              [-12010508.438109227, 5917822.297754547],
              [-12015745.240914615, 5921896.797485801],
              [-12009493.204353193, 5941803.285609698],
              [-12013782.010374984, 5945993.179995066],
              [-12019012.467969397, 5982947.305999287],
              [-12018484.924902529, 6000050.494165142],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '39081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9008481.47978666, 4934182.000282218],
              [-9008075.608923227, 4947116.86342047],
              [-9001691.102167761, 4946984.4121493995],
              [-9001515.996608742, 4953432.2054827595],
              [-8988727.39086743, 4953078.436433233],
              [-8979915.896573689, 4950953.598437701],
              [-8974821.694036005, 4941870.288878799],
              [-8972895.866845284, 4931064.601925664],
              [-8975396.95196919, 4923534.713326366],
              [-8975868.208568953, 4922116.570236918],
              [-8973085.221299121, 4910198.449253995],
              [-8977315.584588248, 4902523.616984546],
              [-8981721.0768923, 4893156.5555332145],
              [-8983769.588505082, 4888803.984309647],
              [-8990859.938352555, 4888508.255129417],
              [-9003842.351327341, 4889146.799488217],
              [-9001906.728021428, 4927592.85380656],
              [-9010412.316354467, 4927851.825149719],
              [-9008481.47978666, 4934182.000282218],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Leflore',
        GEOID: '28083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10069030.840174967, 4003504.340623949],
              [-10039079.32930162, 4003227.275795814],
              [-10039414.957566362, 3997359.575530185],
              [-10051537.984072221, 3995413.669415291],
              [-10052045.044352785, 3988267.5400690543],
              [-10045426.655347163, 3993574.9151843926],
              [-10033981.23058176, 3991487.11133766],
              [-10032978.01933073, 3985507.1535871807],
              [-10030042.07908055, 3956380.2166116945],
              [-10038207.920327691, 3950785.8468553014],
              [-10038192.112959996, 3939638.38142127],
              [-10054544.834838038, 3945201.5098287696],
              [-10049882.106646672, 3940455.2983864225],
              [-10055666.490027271, 3935568.244230976],
              [-10064755.39249207, 3926580.574423668],
              [-10069207.838165328, 3939119.5604093494],
              [-10069030.840174967, 4003504.340623949],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Martin',
        GEOID: '37117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8616419.576548308, 4301304.707502374],
              [-8609453.648092428, 4309430.975095591],
              [-8608065.605361726, 4310444.983485442],
              [-8594512.234718664, 4301353.833356754],
              [-8593406.275577633, 4291928.768000436],
              [-8574666.975136474, 4290950.169923221],
              [-8576504.41465151, 4281597.302670095],
              [-8572185.218408728, 4281159.414701993],
              [-8564814.754923306, 4287077.748875884],
              [-8559803.374086775, 4281640.707832074],
              [-8559478.766451621, 4274873.377550267],
              [-8553213.594190286, 4284521.906433335],
              [-8544950.682347175, 4282045.922597953],
              [-8546821.517709445, 4281077.827735805],
              [-8554598.297336264, 4262159.418821531],
              [-8570024.729731413, 4253780.350671936],
              [-8590970.382480096, 4263921.328896908],
              [-8600009.525132509, 4271263.418736176],
              [-8610603.689751813, 4275775.848133156],
              [-8609718.588480515, 4287593.387304547],
              [-8616419.576548308, 4301304.707502374],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '13291',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9365247.196600344, 4162243.303862969],
              [-9351431.30908383, 4162202.89849972],
              [-9343784.691615263, 4162180.53558714],
              [-9343760.350968737, 4162180.4518037173],
              [-9341366.053038796, 4153961.7611060813],
              [-9329539.025058957, 4150899.6422301293],
              [-9326385.455204275, 4135773.25366671],
              [-9331408.079309376, 4133884.7418234986],
              [-9334863.54762309, 4126191.8061767714],
              [-9344092.378687816, 4128711.0968128033],
              [-9354901.50124384, 4115327.2453760463],
              [-9368429.602362495, 4116180.926964086],
              [-9361211.423940478, 4136926.333933791],
              [-9362795.388974976, 4148521.365248972],
              [-9370744.936451504, 4157371.727713471],
              [-9365247.196600344, 4162243.303862969],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Butte',
        GEOID: '06007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13585972.225733815, 4849066.545104411],
              [-13559163.820683017, 4849149.670926817],
              [-13547942.816011054, 4863650.890642574],
              [-13541574.339262262, 4863403.475539739],
              [-13534936.914623711, 4880560.632940786],
              [-13518292.313040813, 4888041.3165320065],
              [-13510492.37895991, 4878455.303490237],
              [-13516354.685984062, 4868233.616223421],
              [-13517520.980289107, 4851466.593148592],
              [-13508711.601065688, 4840646.2920182515],
              [-13493133.217565605, 4826154.356248736],
              [-13484877.430169905, 4812055.022483939],
              [-13478196.034332493, 4807589.2188534755],
              [-13486345.95689245, 4797363.454129518],
              [-13503624.411655929, 4796373.314499048],
              [-13506885.850097189, 4782763.862045022],
              [-13515024.084110612, 4770455.926348011],
              [-13539095.031563314, 4764105.642139784],
              [-13540687.568198603, 4765536.275636945],
              [-13570766.428569417, 4765293.434834701],
              [-13569746.74203375, 4772979.713152116],
              [-13568734.179945495, 4776806.908466446],
              [-13565007.092074247, 4798872.880116909],
              [-13580312.297543924, 4798443.035715827],
              [-13580348.142419957, 4818313.681911323],
              [-13575369.60083321, 4827212.8770098295],
              [-13577400.958901204, 4825683.3918546075],
              [-13583927.620646417, 4836941.096865154],
              [-13586151.00483603, 4836580.462096817],
              [-13585972.225733815, 4849066.545104411],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Iberville',
        GEOID: '22047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10208101.166828096, 3567651.8128398415],
              [-10195014.113531968, 3567596.5183092714],
              [-10184073.522657314, 3567613.7009293996],
              [-10180533.674169578, 3564744.1413773033],
              [-10166305.8187318, 3548206.869900964],
              [-10164725.74987948, 3545068.3242665036],
              [-10145892.718427073, 3545174.2023233715],
              [-10144166.37576385, 3543888.1212711316],
              [-10132412.929967424, 3544941.5554825943],
              [-10132773.827756576, 3542894.731636204],
              [-10136671.902365685, 3530973.0516249505],
              [-10138248.075035825, 3524227.606312207],
              [-10140103.214349896, 3521701.1445346675],
              [-10141926.627609089, 3517452.5436067972],
              [-10141868.073556932, 3511583.3385369657],
              [-10155048.857864311, 3506806.9659696105],
              [-10155882.19557239, 3508742.015671251],
              [-10171132.18657463, 3511113.363413792],
              [-10181707.315561011, 3516731.177966948],
              [-10182984.15012041, 3533083.0117356046],
              [-10192719.818826718, 3534688.197807587],
              [-10199209.188542511, 3543452.0208272305],
              [-10201329.156925177, 3560586.2890097983],
              [-10208101.166828096, 3567651.8128398415],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'James City',
        GEOID: '51095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8559555.799539251, 4499582.901716599],
              [-8542878.581345549, 4504412.675105916],
              [-8539574.730178295, 4499397.433621687],
              [-8533601.994219271, 4492226.551120489],
              [-8544372.15495352, 4488619.277636115],
              [-8541306.193538092, 4481835.28693388],
              [-8542784.96165379, 4477281.247897675],
              [-8534254.883032775, 4474093.039625415],
              [-8535995.363271328, 4476248.478306277],
              [-8527197.11599699, 4472360.029231668],
              [-8526135.350693805, 4468954.409574018],
              [-8524621.182980033, 4465214.528068193],
              [-8531701.770511432, 4460570.031898665],
              [-8533801.701385753, 4467600.436124849],
              [-8544919.067611787, 4463779.022818807],
              [-8549085.310874216, 4468989.914055396],
              [-8558593.776499815, 4470243.8300757455],
              [-8557623.18185959, 4490165.7406611135],
              [-8560966.551446075, 4491879.9727491075],
              [-8559555.799539251, 4499582.901716599],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gates',
        GEOID: '37073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8562254.143125819, 4376023.833434964],
              [-8562220.098229567, 4376025.00278539],
              [-8542471.708606698, 4376703.328259758],
              [-8520612.664487889, 4376675.548887093],
              [-8514976.573617194, 4371119.182066975],
              [-8514984.25466206, 4365299.709897161],
              [-8510788.177776098, 4352771.742588878],
              [-8522580.808033284, 4349034.27675354],
              [-8534862.576133015, 4344081.466716475],
              [-8537823.229310151, 4341446.387112774],
              [-8547051.16981895, 4350611.855378362],
              [-8565618.259007853, 4357713.063607337],
              [-8562254.143125819, 4376023.833434964],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Macomb',
        GEOID: '26099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9250971.509568917, 5295038.114305268],
              [-9237697.328208763, 5295812.103811583],
              [-9210464.46193957, 5296389.522777066],
              [-9209380.989335679, 5267337.514899043],
              [-9206999.642788628, 5262708.893795765],
              [-9217367.606202643, 5255753.736243876],
              [-9213469.420274042, 5251292.31767786],
              [-9212347.65376532, 5245904.644007977],
              [-9223856.864598945, 5242507.559729698],
              [-9223871.454742342, 5242344.1164192315],
              [-9223956.406502197, 5241392.516703173],
              [-9224771.45941066, 5232267.4538654545],
              [-9225083.190076463, 5228779.750232046],
              [-9248801.00213743, 5228197.928691374],
              [-9249189.395840809, 5241428.395312708],
              [-9249525.358064022, 5250227.41983128],
              [-9249697.79195526, 5254946.276771171],
              [-9250971.509568917, 5295038.114305268],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Saginaw',
        GEOID: '26145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9392011.63461163, 5383179.683843909],
              [-9369825.660096532, 5385622.560626756],
              [-9369553.038663581, 5398968.889715621],
              [-9356403.201174643, 5398726.909380555],
              [-9356513.073512057, 5392082.987934895],
              [-9341496.519482007, 5391862.680625883],
              [-9330491.140663711, 5391819.080358029],
              [-9330541.23443457, 5385175.048001063],
              [-9317309.577119898, 5385160.47390447],
              [-9317275.402036225, 5371938.78147376],
              [-9316953.911346816, 5345735.491623195],
              [-9343275.404944882, 5345575.856857213],
              [-9342942.33702843, 5332204.50957098],
              [-9391790.665422408, 5331544.033629908],
              [-9392011.63461163, 5383179.683843909],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Añasco',
        GEOID: '72011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7483479.512916238, 2072456.785455407],
              [-7478740.3918935545, 2073961.2892064494],
              [-7478760.874679861, 2074220.4280385107],
              [-7472896.007307417, 2074795.1183110126],
              [-7471368.703893733, 2075437.017688495],
              [-7464259.395933712, 2073473.3901828206],
              [-7462628.788032571, 2071486.0350918726],
              [-7467534.3040333595, 2067411.216371914],
              [-7473525.185069381, 2066354.164020946],
              [-7479692.5384140145, 2068794.7841345503],
              [-7481778.857394757, 2072103.7944443296],
              [-7483479.512916238, 2072456.785455407],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mayagüez',
        GEOID: '72097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7479692.5384140145, 2068794.7841345503],
              [-7473525.185069381, 2066354.164020946],
              [-7467534.3040333595, 2067411.216371914],
              [-7464664.042282745, 2066296.729835797],
              [-7460614.016568705, 2060440.8159604538],
              [-7464134.495465042, 2057931.2342427352],
              [-7468019.323054746, 2055093.240049888],
              [-7469357.717292553, 2056114.9147936634],
              [-7476187.279372212, 2055491.313424739],
              [-7478527.406410973, 2057245.3033087263],
              [-7475994.474014157, 2062930.7832146208],
              [-7479692.5384140145, 2068794.7841345503],
            ],
          ],
          [
            [
              [-7563182.236912755, 2052410.4881907164],
              [-7558180.763510904, 2053567.2076055934],
              [-7552606.551328921, 2052486.5075435897],
              [-7549789.722933889, 2047466.2041301427],
              [-7553097.915561284, 2042964.8438803593],
              [-7556984.52426284, 2041817.9699632756],
              [-7564806.276963938, 2046239.1014210428],
              [-7563182.236912755, 2052410.4881907164],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lafourche',
        GEOID: '22057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10124228.943643285, 3476880.555828506],
              [-10121729.821074976, 3481764.969042105],
              [-10117293.628047373, 3487813.9511505337],
              [-10117337.487926746, 3491389.6464448944],
              [-10105281.698393324, 3493531.3305631885],
              [-10091814.489036137, 3489321.3788476335],
              [-10088789.047915356, 3490089.7332708356],
              [-10077709.08503823, 3488775.828985669],
              [-10072176.840304276, 3483946.6270764265],
              [-10070856.479823977, 3478313.1893272293],
              [-10060162.572940921, 3472639.6508751563],
              [-10057950.209380897, 3464470.4878375027],
              [-10044152.492455542, 3464024.0234283735],
              [-10036098.52729665, 3462166.313341287],
              [-10035644.121135231, 3450683.7454518923],
              [-10039478.743634587, 3447543.983492446],
              [-10034061.046656659, 3436519.511475132],
              [-10021049.80193376, 3430293.3686009645],
              [-10022114.795502178, 3417979.5068679703],
              [-10018637.731207252, 3413672.9813480354],
              [-10028754.607742785, 3396596.764174814],
              [-10032418.972847968, 3394023.2584266835],
              [-10043643.762382617, 3386478.638644961],
              [-10056038.965043467, 3383769.236176027],
              [-10064336.26366873, 3383086.800735542],
              [-10064329.81807877, 3406194.8400032576],
              [-10061532.581914114, 3422281.3261448042],
              [-10087695.333918313, 3451992.2261767867],
              [-10095294.336318335, 3458044.378545004],
              [-10097549.669201804, 3460609.6719784965],
              [-10108666.033552423, 3474777.3064495493],
              [-10116736.919273915, 3467199.9727778533],
              [-10130824.289514314, 3466938.7517712526],
              [-10124228.943643285, 3476880.555828506],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bottineau',
        GEOID: '38009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11298565.080018809, 6274716.291475208],
              [-11257231.819128795, 6274704.951345161],
              [-11180003.031835034, 6274759.247819256],
              [-11152287.927564487, 6274730.780243198],
              [-11152324.331005214, 6227300.026262682],
              [-11148145.397320833, 6227294.289483294],
              [-11148185.917615483, 6198042.600871921],
              [-11162746.729650225, 6197975.677832589],
              [-11177187.984551854, 6197949.44683511],
              [-11177231.621792246, 6212628.067798767],
              [-11249905.883439688, 6212720.035243303],
              [-11249909.890941355, 6198063.787672445],
              [-11293504.273328366, 6198188.555456567],
              [-11298559.180085797, 6227497.272594994],
              [-11298565.080018809, 6274716.291475208],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yauco',
        GEOID: '72153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7450225.793007367, 2055261.6998212615],
              [-7442462.705677917, 2053776.6540112216],
              [-7440234.089472235, 2057521.1628637218],
              [-7439184.012715582, 2057601.887693766],
              [-7435870.031474667, 2053173.974247987],
              [-7440225.406551953, 2033565.894243251],
              [-7442588.935310856, 2031819.7425954281],
              [-7442634.233666767, 2031822.4972844524],
              [-7443179.491879135, 2037317.8439600305],
              [-7445565.513844797, 2040453.418355663],
              [-7447388.927103991, 2042213.9128864629],
              [-7450225.793007367, 2055261.6998212615],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kane',
        GEOID: '17089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9863080.542689675, 5163664.900414977],
              [-9861607.78582648, 5170940.334298964],
              [-9861644.187299969, 5184014.319262508],
              [-9839948.575141815, 5184060.868394128],
              [-9835543.328932652, 5184075.583973492],
              [-9824800.998071102, 5184086.845911865],
              [-9822659.21106824, 5184113.273979654],
              [-9822637.837726006, 5174822.780085082],
              [-9825463.571680302, 5171001.964716428],
              [-9825420.602356857, 5163300.353078063],
              [-9825378.300950356, 5158939.152868504],
              [-9825326.537387138, 5145897.116746503],
              [-9825334.775029456, 5143430.616511557],
              [-9825368.838793637, 5132904.380041011],
              [-9825368.616154658, 5132868.684167015],
              [-9825275.553060353, 5119822.471814399],
              [-9837895.621092606, 5119517.909327785],
              [-9841143.923833953, 5119467.199569661],
              [-9863122.064859742, 5119063.469979224],
              [-9863080.542689675, 5163664.900414977],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ponce',
        GEOID: '72113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7422431.319907121, 2048158.889653412],
              [-7424349.911330943, 2052832.990691765],
              [-7421725.443016, 2055444.9218972588],
              [-7419384.728083091, 2056150.8811105792],
              [-7412876.768012334, 2057746.8182680036],
              [-7408620.022003889, 2055354.2478516335],
              [-7406132.142704152, 2037858.0226158078],
              [-7407258.731154231, 2034678.2400986494],
              [-7412011.592929888, 2033010.9659289732],
              [-7418959.932906224, 2035238.1417747096],
              [-7421046.060163689, 2033833.6507256904],
              [-7424679.9120568475, 2035438.7139044486],
              [-7422431.319907121, 2048158.889653412],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Blaine',
        GEOID: '30005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12195233.225645984, 6155818.902443773],
              [-12189121.45164296, 6182259.807680958],
              [-12185512.139792971, 6182490.755440434],
              [-12185512.139792971, 6194688.521138691],
              [-12190077.908707857, 6201860.271333894],
              [-12190098.057535691, 6260266.4962133225],
              [-12188320.9285815, 6274932.795922439],
              [-12161734.74183749, 6274863.260476635],
              [-12133903.3106663, 6274731.420832706],
              [-12082973.085155508, 6274755.684602448],
              [-12048820.15406064, 6274786.416090535],
              [-12051378.16463958, 6260212.4620957775],
              [-12051379.500473468, 6231235.020574616],
              [-12058029.170256006, 6231232.319661095],
              [-12061043.034149742, 6201951.113029321],
              [-12061056.72644711, 6177401.117383968],
              [-12068187.630388344, 6181793.56739445],
              [-12070800.744115226, 6143458.33092482],
              [-12070815.43828801, 6102954.975589522],
              [-12090140.390570233, 6105357.187144522],
              [-12092145.031960435, 6093624.259956707],
              [-12121391.890457064, 6094008.144735886],
              [-12121703.473711794, 6062790.924709207],
              [-12131418.10303434, 6074086.726114255],
              [-12148604.16262046, 6070518.274464441],
              [-12164345.072577102, 6072525.8436535485],
              [-12181170.34569356, 6060423.900094005],
              [-12193789.745808868, 6063520.542202887],
              [-12193301.943800211, 6129270.757603427],
              [-12195233.225645984, 6155818.902443773],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bethel',
        GEOID: '02050',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-18408645.48598705, 8530278.647056183],
              [-18390695.997333065, 8536869.582293468],
              [-18375852.43379171, 8553672.471131383],
              [-18366788.132934377, 8556997.878855426],
              [-18368879.49220791, 8567456.965291841],
              [-18372262.60285261, 8573808.366639663],
              [-18371075.937080752, 8588731.514792487],
              [-18377188.156361736, 8606048.73121733],
              [-18379793.58823992, 8608983.274905393],
              [-18345187.031023905, 8621803.063479226],
              [-18325034.418327637, 8621014.125302754],
              [-18315385.91278262, 8612241.734782217],
              [-18282555.011960413, 8623123.658823952],
              [-18273617.837961566, 8631020.087748377],
              [-18272683.199516866, 8642991.495063696],
              [-18279971.843176555, 8644736.288371805],
              [-18278869.000981268, 8660719.197258225],
              [-18269919.804477416, 8655042.771323984],
              [-18258360.722511917, 8670247.814619096],
              [-18247588.22406836, 8674362.505604342],
              [-18254366.80182123, 8681900.506873872],
              [-18255590.536983524, 8711689.654902725],
              [-18232471.259857614, 8710605.640188856],
              [-18218034.680374596, 8703345.099311994],
              [-18203422.216096126, 8707818.750197662],
              [-18204233.512545027, 8718591.320453005],
              [-18193084.42026412, 8737838.600571526],
              [-18164152.039328985, 8729673.589583337],
              [-18151978.696413286, 8736864.916932462],
              [-18128067.269790888, 8741250.554991832],
              [-18117690.17817863, 8751506.09927296],
              [-18090058.565493416, 8754721.381845701],
              [-18086766.625511676, 8742469.115639018],
              [-18070303.029420804, 8745833.759916017],
              [-18035253.4198276, 8736194.885809684],
              [-18020987.60444346, 8737536.17574548],
              [-18000034.159330424, 8748568.025827428],
              [-17972488.4852921, 8757622.901995461],
              [-17936554.664983522, 8764805.017595291],
              [-17917312.97968041, 8784991.227061797],
              [-17897418.29424431, 8797407.557328394],
              [-17877657.86011411, 8802494.347605133],
              [-17850095.93343013, 8816368.35683362],
              [-17833675.19534321, 8814306.355318515],
              [-17831897.42307524, 8819344.199213477],
              [-17863380.46750292, 8828229.259719087],
              [-17870637.830385704, 8846335.636296837],
              [-17729302.820011877, 8846339.66014123],
              [-17729302.597372893, 8866876.465563536],
              [-17647629.268089723, 8866881.687718837],
              [-17647630.381284628, 8887477.792225791],
              [-17484269.362503972, 8887479.458569083],
              [-17484268.02667008, 8866885.010910537],
              [-17396664.59679286, 8866887.859361788],
              [-17309918.66095322, 8866890.945185242],
              [-17203013.433247864, 8866894.74312361],
              [-17116693.628418982, 8866898.066321319],
              [-17116693.18314102, 8887494.693725588],
              [-17075854.292109616, 8887497.550321015],
              [-17075854.292109616, 8908152.429366052],
              [-17039688.148023754, 8908158.397676757],
              [-17039687.81406528, 8928869.28363526],
              [-17031864.168932837, 8928863.776987571],
              [-17031868.955670945, 8724342.01915667],
              [-17085936.053112797, 8724337.597014587],
              [-17085937.054988217, 8664083.829134524],
              [-17080961.073749755, 8604325.301930653],
              [-17193928.426965244, 8604318.662695039],
              [-17270574.01144674, 8604316.83118283],
              [-17365850.137226887, 8604314.770732144],
              [-17495797.16369256, 8604313.16815979],
              [-17495798.054248486, 8624179.113564165],
              [-17535305.786808982, 8624177.965748774],
              [-17535305.007572547, 8604312.02346547],
              [-17555058.651213814, 8604311.336648958],
              [-17555056.981421452, 8584498.405292263],
              [-17574810.402423736, 8584498.405292263],
              [-17574812.18353559, 8604310.649832515],
              [-17693334.26802217, 8604308.360444838],
              [-17693333.488785733, 8584495.665470904],
              [-17701481.073636383, 8584495.665470904],
              [-17701480.40571944, 8564736.331765449],
              [-17721023.321564637, 8564735.876361582],
              [-17721022.87628667, 8545029.80000833],
              [-17740565.903451357, 8545029.34582974],
              [-17740564.901575938, 8505774.964610748],
              [-17748167.57751916, 8505774.512859967],
              [-17748167.020921703, 8486225.332690923],
              [-17767503.995708928, 8486224.882142847],
              [-17767503.105153, 8447281.16880829],
              [-17786840.413898703, 8447280.720643478],
              [-17786839.96862074, 8427885.778877154],
              [-17793923.339139406, 8427885.555385096],
              [-17793922.33726399, 8389247.49013123],
              [-17813058.825648297, 8389247.045486925],
              [-17813058.046411864, 8350809.651636986],
              [-17838782.53358081, 8350808.988137763],
              [-17838781.75434437, 8312569.620412322],
              [-17857722.0977859, 8312569.180363142],
              [-17857721.318549465, 8274525.45560918],
              [-17864034.692150317, 8274525.236712711],
              [-17864028.235619854, 8255576.197804727],
              [-17882776.998217728, 8255575.761129788],
              [-17882776.664259255, 8236674.3762605665],
              [-17901525.538176622, 8236673.940696976],
              [-17901524.758940183, 8199014.732799629],
              [-17907376.824571185, 8180255.907234871],
              [-17925938.793063514, 8180255.691100306],
              [-17925938.01441618, 8145843.497567745],
              [-17930647.656776372, 8142878.591530184],
              [-17963061.950811725, 8142877.988390975],
              [-17963075.086511638, 8124265.425439454],
              [-17960239.963787332, 8124259.982084658],
              [-17963883.822612252, 8108581.0223256145],
              [-17983723.5162199, 8096814.083064162],
              [-18006150.163474098, 8084146.829963822],
              [-18011733.615173813, 8097061.585697913],
              [-18036803.543736894, 8095935.707256516],
              [-18052873.514108323, 8104786.377587402],
              [-18033161.28131763, 8113432.483495824],
              [-18014177.189316217, 8123232.599742273],
              [-18007574.162400324, 8147226.329222841],
              [-18011942.673177525, 8178596.827130821],
              [-18023768.476642966, 8200623.975465361],
              [-18033407.853989735, 8218117.753633647],
              [-18039165.85465102, 8235528.279148324],
              [-18032967.474084157, 8253887.1131606735],
              [-18016946.929566644, 8274458.473591784],
              [-18010422.160252776, 8282277.789673606],
              [-18000643.299584042, 8287255.588497678],
              [-18008485.646390937, 8303793.428233256],
              [-18019725.018778883, 8322110.099245214],
              [-18021013.653204303, 8332891.718136455],
              [-18038939.09684827, 8366348.343524355],
              [-18045865.952162884, 8381972.033017197],
              [-18049681.650348805, 8392507.009204729],
              [-18059179.651942268, 8412286.04446399],
              [-18075195.075763207, 8437014.835418558],
              [-18083993.768315505, 8438661.517054187],
              [-18088769.37447054, 8428798.577098047],
              [-18088928.33870339, 8417336.028811658],
              [-18088042.346876167, 8405992.693234906],
              [-18091117.770448316, 8394437.205026202],
              [-18103061.572573993, 8393464.146940432],
              [-18115849.733037345, 8393563.137603674],
              [-18123760.76397006, 8385043.465973864],
              [-18137188.343588527, 8379295.514170094],
              [-18164294.416957706, 8365322.255671144],
              [-18196071.567480065, 8357548.128930888],
              [-18231041.138359386, 8354375.715623841],
              [-18248692.958694987, 8356196.798302394],
              [-18271245.730932254, 8365445.024108494],
              [-18279603.82093999, 8385160.786057645],
              [-18276289.839699075, 8391240.210753508],
              [-18271069.512178328, 8397773.807993582],
              [-18286765.337741196, 8410029.663666356],
              [-18302150.581924755, 8421516.331504853],
              [-18314020.69054753, 8444287.36536906],
              [-18325359.025962792, 8452231.023338795],
              [-18334196.457697887, 8466002.88645336],
              [-18342917.671884593, 8465449.13467219],
              [-18365993.534409095, 8478061.21425641],
              [-18382121.05695726, 8496937.497484783],
              [-18375474.170161992, 8503073.31513922],
              [-18369403.02777311, 8505449.259523613],
              [-18362905.643053982, 8518204.353746267],
              [-18366263.484174266, 8521501.460521381],
              [-18378173.222535767, 8519115.102154441],
              [-18388916.666592225, 8511456.803182473],
              [-18398314.035366014, 8511687.378391564],
              [-18408122.173060827, 8513461.01553562],
              [-18414509.0175256, 8523377.325368883],
              [-18408645.48598705, 8530278.647056183],
            ],
          ],
          [
            [
              [-18638291.250282593, 8443730.320478896],
              [-18625710.255391613, 8451469.341937078],
              [-18602916.36513729, 8451456.113549363],
              [-18583526.624911424, 8447695.28477499],
              [-18572833.163306333, 8446746.527618341],
              [-18569552.355273675, 8455557.15753588],
              [-18572079.085075703, 8459816.94264736],
              [-18558466.269824557, 8472980.141668113],
              [-18547671.284843855, 8471154.441996856],
              [-18540104.119818203, 8480745.560905972],
              [-18533621.87454982, 8486963.367584605],
              [-18520432.296002667, 8479237.506569939],
              [-18505867.031188298, 8486817.827354338],
              [-18495707.012583084, 8497612.75922802],
              [-18490534.329804394, 8481975.867593504],
              [-18483192.14146963, 8471207.272984654],
              [-18466020.664736807, 8476584.983277816],
              [-18443398.763095763, 8465135.09846579],
              [-18448147.986531477, 8452574.108461002],
              [-18443808.864099845, 8444027.9881898],
              [-18448253.851367217, 8436302.163552916],
              [-18441930.347692706, 8427464.955361111],
              [-18446666.324109018, 8414447.413395353],
              [-18438279.068394683, 8404102.23891082],
              [-18427008.415229835, 8389375.771133007],
              [-18432537.543018043, 8379337.2544527],
              [-18446375.334960084, 8373860.195809486],
              [-18453413.287126508, 8377617.439735178],
              [-18463096.969630614, 8370791.199942129],
              [-18477067.009127717, 8371214.563795657],
              [-18488497.071803387, 8364123.708730307],
              [-18488417.701006453, 8350047.772647804],
              [-18500231.370647397, 8344332.7601253195],
              [-18509333.074853636, 8357879.524937651],
              [-18519347.598884378, 8363892.1760709975],
              [-18536122.221632525, 8365625.191597902],
              [-18553121.709752075, 8372663.144355505],
              [-18567556.06284528, 8380434.797862626],
              [-18583628.14828703, 8392057.066202035],
              [-18597677.55858107, 8397057.804164896],
              [-18615484.113008864, 8408845.000611017],
              [-18627456.524243683, 8414586.396190863],
              [-18628594.20943959, 8427908.128117392],
              [-18638291.250282593, 8443730.320478896],
            ],
          ],
          [
            [
              [-19266581.01666812, 8558321.139822247],
              [-19248546.591242664, 8535486.465504471],
              [-19241278.319049787, 8515694.441975802],
              [-19207723.06230099, 8492092.688252619],
              [-19189359.131182786, 8485453.584404612],
              [-19173542.412652913, 8475071.935299028],
              [-19175256.84413062, 8466244.843038512],
              [-19193320.769221142, 8470058.790533848],
              [-19217113.974544313, 8474685.062606085],
              [-19246694.457554843, 8500746.670287224],
              [-19265374.09074894, 8512493.996594865],
              [-19271136.989467815, 8547934.84876976],
              [-19266581.01666812, 8558321.139822247],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Haines',
        GEOID: '02100',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-15191416.35597987, 8242079.946792269],
              [-15192252.476675214, 8281400.681370963],
              [-15179318.821637398, 8278247.411681895],
              [-15165525.000894224, 8294676.219033551],
              [-15165871.31583008, 8302143.406924259],
              [-15178481.810386123, 8311067.445060767],
              [-15160640.635596685, 8319988.169898082],
              [-15133428.920030741, 8325264.491723122],
              [-15107982.602701627, 8339886.132731914],
              [-15069878.292529225, 8256430.164854285],
              [-15031372.932607178, 8255461.541301174],
              [-15031386.795600183, 8255410.699844645],
              [-15023897.999496046, 8241235.257430642],
              [-14995000.68420051, 8234147.666431444],
              [-14990735.700549746, 8219648.571274089],
              [-14979895.297216807, 8208164.490607625],
              [-14970383.269367505, 8208119.5826554755],
              [-14959087.68063671, 8187947.139447468],
              [-14961455.557525372, 8175249.10561082],
              [-14953322.555528019, 8172487.116216032],
              [-14953323.699660614, 8172388.0530029945],
              [-15021722.037409512, 8173054.762808123],
              [-15052524.474470483, 8174979.339984235],
              [-15035007.359303035, 8062736.483509943],
              [-15039754.459084129, 8062291.781630875],
              [-15035749.62908335, 8046330.390327128],
              [-15033592.813949231, 8032573.353001879],
              [-15039397.90275512, 8029037.9584167125],
              [-15037913.123386918, 8009464.585185437],
              [-15053482.712647228, 8017248.346219197],
              [-15062251.460256508, 8018520.656723178],
              [-15073556.177185545, 8039718.718810177],
              [-15078221.26232835, 8038885.020757619],
              [-15077813.925069405, 8053012.28448371],
              [-15084572.46531394, 8073009.243732295],
              [-15063389.702049868, 8074029.609001837],
              [-15073240.475109655, 8098830.463660004],
              [-15087124.242001392, 8106571.638566714],
              [-15089468.407838514, 8115567.345636399],
              [-15111287.47331196, 8121314.690267538],
              [-15104216.681895755, 8148810.853770541],
              [-15086475.69464803, 8156153.171841262],
              [-15095534.429530824, 8159664.097978967],
              [-15091152.449095238, 8167958.505709307],
              [-15108625.379009133, 8195498.84170298],
              [-15105959.833802085, 8203638.6131154215],
              [-15128213.045289623, 8219189.6839365065],
              [-15151461.564344343, 8227153.185511715],
              [-15179786.14085975, 8230909.9711833615],
              [-15193958.58034115, 8236903.402320405],
              [-15191416.35597987, 8242079.946792269],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '05095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10179831.582141144, 4118791.2222583275],
              [-10171792.311155036, 4118579.1333898865],
              [-10171101.573714664, 4152028.4936161106],
              [-10162889.534878843, 4151990.076039021],
              [-10162702.6294538, 4161855.255048735],
              [-10156511.262014862, 4164464.289115039],
              [-10146753.997327339, 4164216.812264428],
              [-10147045.097795764, 4151907.9470339543],
              [-10141201.26980708, 4145837.913063579],
              [-10141488.585412819, 4127908.340698278],
              [-10135581.082675401, 4127816.2292675506],
              [-10135853.1475109, 4115839.663034411],
              [-10136171.075976605, 4092206.3202733453],
              [-10130124.757834168, 4092006.209612776],
              [-10130373.4455766, 4074055.931121518],
              [-10136338.277851775, 4074089.90372068],
              [-10142069.67315476, 4076354.8391062273],
              [-10162521.401322791, 4104484.5492770397],
              [-10172132.392199408, 4104716.9192332914],
              [-10179921.973567668, 4110896.9652262097],
              [-10179831.582141144, 4118791.2222583275],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pendleton',
        GEOID: '54071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8863165.907061046, 4667501.204832559],
              [-8864011.935191074, 4673686.608482819],
              [-8851020.839296008, 4690308.947422684],
              [-8852067.353828957, 4706214.715160936],
              [-8833186.788953982, 4715586.927720347],
              [-8809189.535004184, 4694969.288700689],
              [-8800613.147475, 4687553.425160462],
              [-8804042.010430414, 4677379.911616866],
              [-8804587.4759353, 4673016.991945208],
              [-8811422.715308988, 4665464.3574609095],
              [-8816666.085964335, 4654259.906809888],
              [-8819667.705015514, 4647420.647139146],
              [-8820023.593126148, 4646610.050312296],
              [-8827386.041608237, 4638422.723226689],
              [-8828893.092167625, 4638709.239907719],
              [-8835461.602748342, 4639958.122111666],
              [-8847298.872121336, 4644219.681107741],
              [-8854638.388788318, 4657874.31040903],
              [-8866494.471155256, 4663327.364886604],
              [-8863165.907061046, 4667501.204832559],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shenandoah',
        GEOID: '51171',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8774332.174171578, 4697490.030195319],
              [-8768947.205123944, 4706462.434679165],
              [-8758797.539231377, 4711054.34909366],
              [-8751988.793896498, 4719179.6214628825],
              [-8745449.66436832, 4722961.830178522],
              [-8742171.882729342, 4729232.458565867],
              [-8733474.470146233, 4725654.036817057],
              [-8726515.666137762, 4736277.971455407],
              [-8720395.765811913, 4736292.31628893],
              [-8717883.507543689, 4722816.709183843],
              [-8716362.21538251, 4713594.828386892],
              [-8726858.530169407, 4696319.455168904],
              [-8739610.84575672, 4682445.708219806],
              [-8744028.003151398, 4684288.855387147],
              [-8754361.680162247, 4665208.088495313],
              [-8779687.643554153, 4687778.704921804],
              [-8774332.174171578, 4697490.030195319],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Leake',
        GEOID: '28079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9988731.750005638, 3846853.881515778],
              [-9988699.689992288, 3880059.1104268692],
              [-9988715.052082019, 3886006.2360547925],
              [-9942963.7432414, 3886235.6847943463],
              [-9942788.415043402, 3839219.846550536],
              [-9943346.125692276, 3839216.543982905],
              [-9988714.829443038, 3839324.2081619445],
              [-9988731.750005638, 3846853.881515778],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crook',
        GEOID: '41013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13481629.016109064, 5526088.751924203],
              [-13468364.29690563, 5526036.565278184],
              [-13468414.279356996, 5539477.719394641],
              [-13450388.870810295, 5539480.059553716],
              [-13450461.896396257, 5552952.810008293],
              [-13401370.668873368, 5553142.802094401],
              [-13401316.456281353, 5533176.916195037],
              [-13360745.733903268, 5533599.422262642],
              [-13360644.099208174, 5525946.5245434595],
              [-13347127.1300386, 5525929.077306702],
              [-13347095.849261688, 5513015.595596326],
              [-13319991.22304589, 5513081.7081722],
              [-13320176.68131755, 5459087.157963022],
              [-13333336.76019964, 5459112.829113607],
              [-13333573.425437067, 5418818.692031807],
              [-13346921.300300125, 5418856.106967652],
              [-13387034.499571048, 5418942.639210847],
              [-13387102.29314094, 5432276.294631997],
              [-13400429.573898202, 5432296.648447268],
              [-13400500.039135873, 5445711.108367196],
              [-13441588.953743597, 5445551.902222558],
              [-13441633.592859404, 5458838.182452421],
              [-13468165.257656092, 5459385.937481199],
              [-13468241.400187794, 5486206.495890355],
              [-13481099.024013398, 5486842.285542015],
              [-13481629.016109064, 5526088.751924203],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oldham',
        GEOID: '21185',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9531355.69589262, 4638515.215769536],
              [-9527585.638697926, 4643262.5806961665],
              [-9517690.22652233, 4645785.52110639],
              [-9514961.563164005, 4650881.34568943],
              [-9510373.196392488, 4653703.968903025],
              [-9510354.969988374, 4653733.763817934],
              [-9504318.19532977, 4652979.459344229],
              [-9497111.705454286, 4649248.164629953],
              [-9500682.166801991, 4644548.354042308],
              [-9493669.261520995, 4630131.048185408],
              [-9498274.660174603, 4623327.3408769695],
              [-9514277.170934608, 4619809.179074618],
              [-9515172.958877023, 4620431.220233236],
              [-9527308.898443813, 4627487.623269342],
              [-9532782.716583902, 4633019.741702897],
              [-9531355.69589262, 4638515.215769536],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hart',
        GEOID: '21099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9580662.326630197, 4487810.983409692],
              [-9575601.18598128, 4494243.768920717],
              [-9578774.793344304, 4502008.587893879],
              [-9561543.20408645, 4500659.04584779],
              [-9535330.580950378, 4498091.959945705],
              [-9539782.581345672, 4481263.037941983],
              [-9538575.544107001, 4464565.354829298],
              [-9545003.020185914, 4462803.035460647],
              [-9563049.579435866, 4459808.856858611],
              [-9579759.414240373, 4462439.123963427],
              [-9578945.668762673, 4469157.3738113],
              [-9591018.93545615, 4485995.768739706],
              [-9580662.326630197, 4487810.983409692],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pickens',
        GEOID: '13227',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9423680.91654741, 4102752.402178049],
              [-9406787.515902586, 4104744.090204974],
              [-9402933.523811834, 4104718.0006637457],
              [-9399509.002316559, 4102807.0050056134],
              [-9392175.942180045, 4102691.4473544867],
              [-9389304.010637067, 4104616.211478159],
              [-9386423.730132282, 4091798.136101747],
              [-9379431.530276576, 4091726.573744389],
              [-9379511.568990454, 4080075.3930463707],
              [-9395451.184238164, 4079033.3310133168],
              [-9398095.133463996, 4080895.2448572074],
              [-9415695.301555865, 4080142.8350094054],
              [-9415717.565454023, 4084284.408444041],
              [-9423554.680244852, 4084338.247165392],
              [-9422575.06872587, 4090168.787328883],
              [-9423680.91654741, 4102752.402178049],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pickaway',
        GEOID: '39129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9267618.671500105, 4821782.362713118],
              [-9266646.518387008, 4838733.017839786],
              [-9219953.780612752, 4836196.224386915],
              [-9222035.343771094, 4802420.883294967],
              [-9209630.456314545, 4801405.121668217],
              [-9210655.820144244, 4788982.467003145],
              [-9239317.806036241, 4790671.344071569],
              [-9237798.96290386, 4794521.881629356],
              [-9269210.762857432, 4795891.917714334],
              [-9267618.671500105, 4821782.362713118],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Imperial',
        GEOID: '06025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12924820.05511019, 3858405.084971196],
              [-12922087.829528162, 3905241.010154526],
              [-12922541.456453143, 3951976.7433947558],
              [-12853783.97108926, 3952118.1279793005],
              [-12782909.856927434, 3952531.887881003],
              [-12760458.220472347, 3952992.216483465],
              [-12761130.198553732, 3951549.132224193],
              [-12765440.266598264, 3950958.6919751163],
              [-12771159.973354712, 3949191.552273827],
              [-12769163.569606826, 3945402.3990334426],
              [-12769231.919774175, 3938311.7966541694],
              [-12770934.774024839, 3933604.3567201653],
              [-12765505.945097834, 3929279.540598102],
              [-12765907.363181634, 3925912.4849610114],
              [-12766047.848379014, 3916496.634353626],
              [-12769032.991844127, 3909293.7836326603],
              [-12765095.398815788, 3900346.790067706],
              [-12760363.207262166, 3899426.322718884],
              [-12754448.580077337, 3900155.307772677],
              [-12747981.562233381, 3898573.476295551],
              [-12747344.392813891, 3898417.636333711],
              [-12744001.69114435, 3891596.5134110968],
              [-12743481.272524893, 3885171.239674324],
              [-12741977.012245804, 3882287.9351308118],
              [-12742627.563349998, 3874768.8693945776],
              [-12749615.644384546, 3866470.330574012],
              [-12753949.200841637, 3861825.585318869],
              [-12759149.103903266, 3860983.2740430483],
              [-12764726.931301262, 3860079.811206247],
              [-12768982.007517343, 3861053.183059569],
              [-12770531.129551224, 3858033.676238337],
              [-12801830.719458075, 3855508.4861544883],
              [-12853523.260841824, 3851199.9624972194],
              [-12918250.646680517, 3845416.4248947105],
              [-12924880.711881777, 3844785.3398101237],
              [-12924820.05511019, 3858405.084971196],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Juab',
        GEOID: '49023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12695683.817164456, 4852306.081288542],
              [-12606765.13046306, 4852105.223630472],
              [-12505852.898864051, 4852068.0742670065],
              [-12504773.990359282, 4859084.075503922],
              [-12497826.09566091, 4857074.186249844],
              [-12487798.21329127, 4867636.242255206],
              [-12473739.78611848, 4850463.093099103],
              [-12477784.24585798, 4834303.070277533],
              [-12473035.46770023, 4833567.375311604],
              [-12457704.54742818, 4850633.431402472],
              [-12446756.498147644, 4857189.0302589005],
              [-12438609.469894446, 4846213.269825896],
              [-12441755.692662736, 4838457.383594815],
              [-12427924.357251162, 4838786.058743012],
              [-12421569.572799738, 4834637.257986241],
              [-12421557.995572696, 4828251.821630497],
              [-12436333.208946707, 4821655.3397241],
              [-12435859.210554907, 4787820.853033337],
              [-12439662.440957861, 4781574.724794508],
              [-12439624.035733536, 4776646.464748416],
              [-12459143.351846684, 4776479.542628762],
              [-12469564.414657805, 4766830.4224077],
              [-12488813.669686288, 4768964.581313104],
              [-12491387.710271899, 4801338.9960536305],
              [-12507242.054789659, 4801295.249435021],
              [-12519259.216459775, 4801117.232987458],
              [-12626564.971693005, 4801119.39861866],
              [-12669910.555018092, 4801145.097478014],
              [-12672585.339742871, 4799873.94922216],
              [-12695674.161295015, 4799715.821608779],
              [-12695741.129661761, 4836075.1027502315],
              [-12695683.817164456, 4852306.081288542],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Whitfield',
        GEOID: '13313',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9478274.555180721, 4132348.8753450387],
              [-9469019.341396676, 4139375.905961652],
              [-9459914.077775491, 4162142.574012316],
              [-9459593.453303201, 4162144.5066107847],
              [-9446718.262528097, 4162222.113484436],
              [-9441059.165548196, 4162233.9285964156],
              [-9441976.163539795, 4147171.6883044103],
              [-9448631.287977379, 4133971.2108868994],
              [-9447122.463599166, 4124182.7669726815],
              [-9455960.674570698, 4120055.0410855464],
              [-9452522.68341704, 4114271.092043878],
              [-9453932.322128957, 4111840.936786293],
              [-9467772.34046081, 4112695.57069306],
              [-9467816.979576617, 4125892.357256009],
              [-9480953.124768188, 4125932.85214161],
              [-9478274.555180721, 4132348.8753450387],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Schley',
        GEOID: '13249',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9398643.493275642, 3793822.779268544],
              [-9394243.701721529, 3802391.155184607],
              [-9394509.643985033, 3817784.1563624777],
              [-9393340.900651196, 3819630.533427641],
              [-9379180.616144327, 3812248.061192522],
              [-9379325.220162867, 3802248.7945822286],
              [-9375343.544616172, 3793691.0485851816],
              [-9371059.191374013, 3793500.6272750413],
              [-9371272.03424041, 3784133.3243581327],
              [-9398728.87532508, 3785154.2820845745],
              [-9398643.493275642, 3793822.779268544],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Upson',
        GEOID: '13293',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9409504.82467285, 3891395.355163543],
              [-9405351.271832371, 3894471.62260718],
              [-9380909.073877875, 3894110.8847604254],
              [-9364458.390847934, 3893920.433461398],
              [-9364567.372629423, 3886305.9792367783],
              [-9364671.456353314, 3875352.8167311223],
              [-9364677.80156429, 3868911.1244208748],
              [-9373393.672415437, 3854230.948659461],
              [-9377086.696522506, 3860616.8431456313],
              [-9382701.98559659, 3861853.2476816117],
              [-9393182.938293759, 3866029.817990948],
              [-9407263.7406842, 3879623.7886159536],
              [-9409491.688972937, 3883907.452515196],
              [-9410072.331436915, 3890092.5542964824],
              [-9409504.82467285, 3891395.355163543],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lewis and Clark',
        GEOID: '30049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12597560.455727838, 6060359.532987168],
              [-12588119.004435696, 6065350.31982675],
              [-12588746.512405299, 6093254.012605964],
              [-12577403.056293463, 6099191.853184266],
              [-12569446.161730543, 6077991.911850392],
              [-12569553.473719668, 6056255.922329711],
              [-12563173.419743832, 6045435.203197199],
              [-12554672.840787875, 6040337.719984194],
              [-12528977.63064501, 6049150.274080922],
              [-12515559.401863769, 6041124.2161345715],
              [-12512883.615263572, 6032696.883570634],
              [-12503123.678908272, 6031006.927912086],
              [-12498729.78728717, 6024998.691448008],
              [-12473101.925436234, 6026714.5042490885],
              [-12472715.64680318, 5973605.175261682],
              [-12465304.88566209, 5972176.311785185],
              [-12461341.91178985, 5965541.880954813],
              [-12444325.5031077, 5963142.871208932],
              [-12444432.14717988, 5928009.504245558],
              [-12429726.397168124, 5927953.934171882],
              [-12427652.515054645, 5914716.982895051],
              [-12411911.159820043, 5903394.1478178585],
              [-12423536.365563074, 5905955.105810032],
              [-12427625.687057367, 5899442.605106825],
              [-12426806.932202581, 5872162.868972959],
              [-12444177.559504434, 5872080.77249543],
              [-12471036.94888202, 5871973.90249094],
              [-12477071.578477921, 5863534.954027965],
              [-12490687.733313791, 5860799.077045646],
              [-12487401.359306592, 5853782.367356444],
              [-12502355.79706078, 5848100.971034794],
              [-12503043.862833371, 5872882.8248032825],
              [-12501015.287752647, 5881235.614793129],
              [-12503502.165176967, 5886092.328096347],
              [-12513494.981907008, 5886105.951558847],
              [-12513518.136361092, 5893162.830330013],
              [-12527405.354157044, 5893159.097090359],
              [-12527422.163400155, 5915058.690917684],
              [-12556353.431140382, 5914640.6699273],
              [-12556371.910175852, 5971013.639505962],
              [-12585676.20952973, 5971433.880344105],
              [-12585692.462175384, 6022193.738474147],
              [-12592805.666317584, 6026664.397888354],
              [-12595173.431886757, 6039823.498522596],
              [-12597560.455727838, 6060359.532987168],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Saunders',
        GEOID: '31155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10787511.212723238, 5079448.2105027735],
              [-10749975.950220108, 5076418.309114438],
              [-10739071.426860472, 5070518.50409802],
              [-10733585.491034688, 5066205.219020866],
              [-10723117.00612049, 5040406.9951572465],
              [-10724498.03572327, 5024518.316653172],
              [-10722203.295740059, 5018981.1259155655],
              [-10725574.049921278, 5014585.54183247],
              [-10738307.886473121, 5014712.126678482],
              [-10738308.777029047, 5018993.671973393],
              [-10787805.652776387, 5019142.454694765],
              [-10787511.212723238, 5079448.2105027735],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stearns',
        GEOID: '27145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10590906.409129024, 5744113.026795664],
              [-10535720.773443677, 5744198.252734321],
              [-10521172.429191904, 5744266.88095597],
              [-10494286.100497548, 5744399.031673295],
              [-10484364.750880597, 5729149.5323112765],
              [-10486704.129979618, 5719591.002688412],
              [-10480670.724898113, 5709968.611298259],
              [-10479838.277745962, 5699509.6396249905],
              [-10469300.552108487, 5688339.778431882],
              [-10474353.677754069, 5675598.002696811],
              [-10493066.595475907, 5666333.498557961],
              [-10506717.481992906, 5666152.501801874],
              [-10506750.321242688, 5673105.463415298],
              [-10535287.295346526, 5672927.179974488],
              [-10548977.811602246, 5673006.187918198],
              [-10548961.558956591, 5686753.874942279],
              [-10590015.741883187, 5686681.088713044],
              [-10590899.618640084, 5741795.162245596],
              [-10590906.409129024, 5744113.026795664],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Deuel',
        GEOID: '31049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11422516.661349341, 5019454.787742009],
              [-11422538.925247498, 5045084.83719922],
              [-11360770.188835109, 5045074.92130519],
              [-11360769.409598673, 5019344.082535545],
              [-11360350.069076855, 5012915.454892307],
              [-11360345.228502197, 5012692.272351576],
              [-11416569.5288732, 5012668.971350708],
              [-11423721.140961709, 5012669.591256442],
              [-11422516.661349341, 5019454.787742009],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Walton',
        GEOID: '13297',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9348837.149343897, 4000110.355954485],
              [-9340647.597045217, 4007719.4192106277],
              [-9334703.247556347, 4013412.338044743],
              [-9328473.586212574, 4019385.675012915],
              [-9324236.321115019, 4014690.6009534574],
              [-9311544.89728917, 4016213.6529295878],
              [-9298869.392150503, 4004781.6317812805],
              [-9295837.383179765, 4004357.817413168],
              [-9298114.757322416, 4001458.5327946777],
              [-9315314.731844882, 3974805.6625679624],
              [-9316500.841019284, 3977488.2239961806],
              [-9327538.613809403, 3984129.415672315],
              [-9341355.366367681, 3994506.237187972],
              [-9348837.149343897, 4000110.355954485],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pope',
        GEOID: '27121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10659788.349683613, 5741961.262445673],
              [-10590899.618640084, 5741795.162245596],
              [-10590015.741883187, 5686681.088713044],
              [-10603761.027328378, 5686700.59346155],
              [-10658552.035418862, 5686666.975547523],
              [-10659788.349683613, 5741961.262445673],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Avery',
        GEOID: '37011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9137119.722999077, 4315178.048709864],
              [-9131397.567213831, 4317741.399133573],
              [-9123756.708685271, 4332057.420457304],
              [-9120892.26276497, 4337107.314849307],
              [-9119119.525300818, 4340233.759432053],
              [-9117923.233409232, 4330130.025914811],
              [-9109188.215605665, 4323871.677937828],
              [-9107104.982654959, 4315975.981810495],
              [-9098773.498005519, 4309924.815485635],
              [-9106731.617082838, 4295387.700674622],
              [-9117051.935754793, 4300608.850591831],
              [-9121873.962137485, 4295125.705111169],
              [-9126189.373517578, 4288431.626784716],
              [-9131994.684962448, 4292651.430840645],
              [-9137231.701182038, 4315174.206528392],
              [-9137119.722999077, 4315178.048709864],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henry',
        GEOID: '13151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9390224.73414542, 3948157.211825037],
              [-9383640.854181942, 3953281.681976837],
              [-9382438.492361885, 3968413.7380919876],
              [-9377987.716480985, 3973920.300395342],
              [-9382148.393768875, 3981555.6279373104],
              [-9380546.39497687, 3981523.400728944],
              [-9378160.929608662, 3979325.209914931],
              [-9371335.931628125, 3981387.9404621543],
              [-9364705.96539546, 3970024.044758854],
              [-9361687.64872209, 3969873.8913602293],
              [-9356372.031717222, 3967345.622941394],
              [-9355790.164738845, 3965301.6940863873],
              [-9356892.561656171, 3963850.3970649946],
              [-9344884.5281843, 3959425.660691396],
              [-9342367.260538992, 3954412.8011170956],
              [-9346871.358455978, 3945205.908825173],
              [-9355571.978536889, 3940669.0307297423],
              [-9357657.32655792, 3936468.3926037736],
              [-9362256.602639535, 3934951.04755523],
              [-9367599.826878121, 3939939.638675673],
              [-9390288.854172116, 3942188.3227619864],
              [-9390224.73414542, 3948157.211825037],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carroll',
        GEOID: '13045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9499795.651762685, 3982318.3280883045],
              [-9494410.649329677, 3982180.933872797],
              [-9467821.654995231, 3990548.1382481004],
              [-9466378.620436078, 4003578.297165054],
              [-9458951.050051881, 4001927.116617714],
              [-9451212.675649384, 3999393.6699236357],
              [-9451669.085561637, 3971659.961752841],
              [-9440887.347600346, 3971754.42317151],
              [-9441659.348268997, 3964563.6716068103],
              [-9445538.164606197, 3963389.7695599366],
              [-9454963.029294211, 3953509.2576268646],
              [-9463866.362167856, 3951919.923283907],
              [-9494923.260483768, 3952251.66415225],
              [-9496102.909663398, 3959558.505847626],
              [-9497116.3808729, 3965839.7177622197],
              [-9499795.651762685, 3982318.3280883045],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pecos',
        GEOID: '48371',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11531038.804658469, 3602457.820684132],
              [-11467136.518885534, 3681064.762969346],
              [-11458513.488489706, 3678297.7715011854],
              [-11446619.78013488, 3667457.4402349573],
              [-11440010.741966484, 3670964.125869568],
              [-11429851.6139172, 3675691.4391760337],
              [-11421455.118685136, 3667485.5710155317],
              [-11412815.167726705, 3666912.6795294425],
              [-11402404.791586703, 3657911.798840213],
              [-11397869.524212291, 3644073.1893337998],
              [-11387169.16079877, 3637513.2666077577],
              [-11377078.16027785, 3636779.115934376],
              [-11375931.45820319, 3633241.0970635256],
              [-11352766.874044526, 3631083.0357255572],
              [-11341612.215789078, 3623096.750950435],
              [-11333150.153376935, 3593785.200490945],
              [-11328808.693235999, 3587776.0738980635],
              [-11328803.906497894, 3587758.087223721],
              [-11328912.554320907, 3587813.8589384602],
              [-11354322.45260887, 3587906.6398129268],
              [-11354633.479266146, 3588016.2437687987],
              [-11358129.46787451, 3588090.0037602074],
              [-11358202.27082149, 3588074.7341122525],
              [-11358287.318912456, 3588089.0979331136],
              [-11358373.146239856, 3588080.9454922224],
              [-11358415.78160483, 3588059.5938864956],
              [-11369925.437716419, 3588151.9883700036],
              [-11369995.346356638, 3580589.156287178],
              [-11392769.087783126, 3580749.263357094],
              [-11392780.108412715, 3540122.834362881],
              [-11417699.19906577, 3540013.6469419906],
              [-11417711.66684874, 3510339.6271601347],
              [-11514885.455988439, 3589440.5355104157],
              [-11531038.804658469, 3602457.820684132],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rusk',
        GEOID: '48401',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10573727.585309807, 3812085.5490522287],
              [-10529865.59086693, 3811404.6828717054],
              [-10528510.498705504, 3815261.8572432348],
              [-10525811.223692749, 3816934.584207788],
              [-10518781.063890683, 3815159.15706703],
              [-10523110.946804576, 3799047.2487742],
              [-10528653.09897321, 3789771.7703733966],
              [-10530821.380014881, 3759792.3059805627],
              [-10520964.37306361, 3759896.107133915],
              [-10520898.24928608, 3753233.7814193033],
              [-10514394.853314444, 3742887.4007104426],
              [-10568397.719410114, 3743054.351251345],
              [-10573656.006877227, 3743131.537170949],
              [-10573712.111900587, 3781437.4882807354],
              [-10573727.585309807, 3812085.5490522287],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Throckmorton',
        GEOID: '48447',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11073221.814042421, 3948388.153625773],
              [-11015501.990149165, 3948189.612735426],
              [-11015161.018548865, 3889586.943628178],
              [-11031318.04076209, 3889602.7311938163],
              [-11073089.789126338, 3889601.1391694276],
              [-11073221.814042421, 3948388.153625773],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cumberland',
        GEOID: '17035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9848536.205939572, 4752519.603030327],
              [-9848527.745658271, 4775460.49927296],
              [-9797464.493355978, 4776101.781750171],
              [-9796979.696973573, 4746615.545428381],
              [-9836263.009440633, 4746212.482142389],
              [-9848531.641840449, 4746262.020581803],
              [-9848536.205939572, 4752519.603030327],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Worcester',
        GEOID: '25027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8047429.368949888, 5233082.825593974],
              [-8042261.918187264, 5238203.119923568],
              [-8045223.127961856, 5243307.607996914],
              [-8040356.573782847, 5253684.466827613],
              [-8040042.652818809, 5257174.863607112],
              [-8045277.340553873, 5262583.978939739],
              [-8046510.548171148, 5269754.240098131],
              [-8037669.486006435, 5269422.1421946045],
              [-8028865.50802622, 5269091.448945674],
              [-8024060.853070994, 5268912.743676296],
              [-8007102.999427905, 5268282.037123322],
              [-8003734.328355301, 5268156.75254694],
              [-7999249.736737104, 5256399.814196275],
              [-7990040.49790276, 5257975.855381957],
              [-7977666.891223123, 5253038.726356525],
              [-7979266.329666842, 5240769.445068931],
              [-7974468.459613651, 5239801.799166976],
              [-7963660.561572024, 5242673.003239593],
              [-7965922.573624943, 5222887.6460482525],
              [-7973225.354859963, 5213622.831933522],
              [-7968824.450110942, 5207676.718193733],
              [-7965034.912005357, 5209997.9206269],
              [-7957873.840482117, 5210569.200084447],
              [-7959014.753943257, 5204493.780496724],
              [-7961812.435385874, 5200976.905161488],
              [-7964922.368000164, 5200912.071492439],
              [-7969001.559420793, 5199937.664308223],
              [-7965548.317496895, 5188356.833166637],
              [-7959635.916701883, 5189695.898736537],
              [-7956907.809941012, 5184493.636073028],
              [-7956952.671695802, 5180679.592111384],
              [-7959308.971357425, 5176494.372339782],
              [-7959152.90143133, 5170702.81350232],
              [-7959145.889764447, 5163357.605568055],
              [-7965960.3109323215, 5163128.048257577],
              [-7969484.41078798, 5163003.892363101],
              [-7971220.7601210065, 5162942.720456199],
              [-7992655.05878302, 5162187.6185051715],
              [-7992811.796626057, 5164510.620037284],
              [-8002165.621211829, 5164733.952816859],
              [-8013592.473889383, 5165006.788510906],
              [-8026375.67334695, 5165269.080418114],
              [-8030112.894344229, 5165345.763901439],
              [-8030032.692887187, 5185244.794566393],
              [-8044383.222403822, 5188556.336409201],
              [-8039629.2122300025, 5197788.095231416],
              [-8038500.54391285, 5198691.898623193],
              [-8038822.702519205, 5205160.140297192],
              [-8038468.929177464, 5207737.383194999],
              [-8047145.058970401, 5213857.663201911],
              [-8049985.821055954, 5212602.0840266505],
              [-8047429.368949888, 5233082.825593974],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cloud',
        GEOID: '20029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10901682.708870638, 4815755.469826718],
              [-10839030.763618292, 4815795.37585694],
              [-10839020.076947175, 4803220.570260402],
              [-10839160.89610303, 4765600.295662836],
              [-10901417.211885093, 4765655.827970035],
              [-10901378.361382807, 4799653.806484454],
              [-10901723.006526304, 4803206.562914995],
              [-10901682.708870638, 4815755.469826718],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '41029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13717889.829825515, 5204642.307858447],
              [-13717850.200086791, 5235512.935778418],
              [-13717858.437729111, 5266815.049116024],
              [-13709243.86761458, 5274880.981044146],
              [-13693384.402400244, 5274321.408534073],
              [-13686864.865102446, 5277752.592966953],
              [-13669451.93639409, 5278275.5155185545],
              [-13656361.320874255, 5293888.491698854],
              [-13643350.076151356, 5300515.91309615],
              [-13632209.778110221, 5302824.377870704],
              [-13625619.775574747, 5311459.217052599],
              [-13612451.23641136, 5311438.974227934],
              [-13612669.311293822, 5232324.393340187],
              [-13613011.173450047, 5227162.181869294],
              [-13613232.598621387, 5162142.633994089],
              [-13636763.969798062, 5162246.795273963],
              [-13670042.374973258, 5161589.279614556],
              [-13697335.019809008, 5161436.180405489],
              [-13708545.449129345, 5162364.700463112],
              [-13718012.310272798, 5161723.964348736],
              [-13717889.829825515, 5204642.307858447],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Josephine',
        GEOID: '41033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13804551.608130112, 5235622.998434082],
              [-13791444.851284115, 5236255.015420558],
              [-13784833.25276743, 5256172.547061994],
              [-13772056.892170105, 5279161.274437759],
              [-13772058.339323485, 5272428.720726918],
              [-13757051.804047605, 5272468.432029086],
              [-13741885.302663459, 5266877.913135118],
              [-13722830.411465902, 5271272.61941972],
              [-13717858.437729111, 5266815.049116024],
              [-13717850.200086791, 5235512.935778418],
              [-13717889.829825515, 5204642.307858447],
              [-13718012.310272798, 5161723.964348736],
              [-13730987.79243174, 5160845.82771225],
              [-13740695.742584841, 5161225.2610610025],
              [-13750084.744229924, 5160855.492070109],
              [-13765434.05038485, 5160251.018066794],
              [-13783806.17446039, 5160323.486236625],
              [-13783817.462413939, 5174098.844638377],
              [-13787870.605073722, 5181240.702853495],
              [-13780484.668179082, 5196640.94534676],
              [-13791194.827707792, 5213797.862768737],
              [-13808290.384547897, 5219226.479638964],
              [-13804551.608130112, 5235622.998434082],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '42055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8693937.64937607, 4825693.406408801],
              [-8683220.844500482, 4840776.0212834915],
              [-8674120.69876711, 4866007.672492282],
              [-8667835.26635845, 4874893.2111809105],
              [-8657130.338845806, 4895650.240200651],
              [-8649861.73269446, 4904318.676797509],
              [-8646380.883536844, 4908148.674899745],
              [-8638694.940614514, 4899159.30612157],
              [-8640024.985890513, 4894836.966756197],
              [-8630876.304859156, 4873028.882159894],
              [-8622151.973726708, 4861936.981203702],
              [-8624041.733402414, 4857819.026257999],
              [-8622744.685396876, 4825369.645747899],
              [-8623825.773999974, 4825369.621232036],
              [-8623840.133804588, 4825369.620906401],
              [-8657165.84976337, 4825559.069067434],
              [-8691365.089766407, 4825690.773116518],
              [-8693937.64937607, 4825693.406408801],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Thayer',
        GEOID: '31169',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10889363.426102506, 4917014.049898293],
              [-10839032.767369125, 4916991.701230458],
              [-10839089.655560171, 4866224.098133224],
              [-10844280.924762575, 4866233.063630661],
              [-10884503.105814982, 4866257.187034534],
              [-10889439.659056272, 4866260.076337626],
              [-10889363.426102506, 4917014.049898293],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clinton',
        GEOID: '18023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9650914.164838485, 4897142.5816082405],
              [-9650805.962293437, 4928942.182453865],
              [-9615305.84272099, 4928897.577215292],
              [-9607901.649429856, 4928877.248993347],
              [-9600525.953928366, 4920391.180380528],
              [-9600498.235375157, 4897356.4372347295],
              [-9600456.156607637, 4892247.326199037],
              [-9613156.485992752, 4891858.450537805],
              [-9617875.987124424, 4891724.554965039],
              [-9650932.75519345, 4891938.2933746595],
              [-9650914.164838485, 4897142.5816082405],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Floyd',
        GEOID: '13115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9513713.318207871, 4067295.5255441284],
              [-9505276.433506519, 4067282.862369272],
              [-9499435.499824595, 4078558.864514281],
              [-9482255.228851996, 4087496.965234904],
              [-9474151.169922248, 4107962.0843825755],
              [-9469855.462092025, 4107921.654322055],
              [-9473824.224577788, 4083261.2516877935],
              [-9462799.587487584, 4081620.454605505],
              [-9464728.42030456, 4075506.4632302127],
              [-9467374.373281224, 4041755.1605887],
              [-9490835.28992438, 4042327.301965002],
              [-9509030.36888143, 4039658.3595014215],
              [-9509968.327404473, 4045611.6221644757],
              [-9513713.318207871, 4067295.5255441284],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Teton',
        GEOID: '30099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12580751.212618053, 6128681.30702838],
              [-12487570.5649326, 6128629.102410631],
              [-12487570.119654635, 6121367.755071677],
              [-12473126.193085227, 6121276.100198136],
              [-12473164.375670569, 6113996.334594562],
              [-12466015.771930298, 6113972.691214986],
              [-12466031.134020027, 6104291.875379571],
              [-12401939.048515288, 6104721.975972975],
              [-12401976.451864196, 6056779.39374301],
              [-12430655.914916249, 6056719.51957392],
              [-12430631.201989291, 6042423.1481824275],
              [-12459204.243608145, 6042419.515457343],
              [-12459668.779843228, 6024096.176365834],
              [-12473101.925436234, 6026714.5042490885],
              [-12498729.78728717, 6024998.691448008],
              [-12503123.678908272, 6031006.927912086],
              [-12512883.615263572, 6032696.883570634],
              [-12515559.401863769, 6041124.2161345715],
              [-12528977.63064501, 6049150.274080922],
              [-12554672.840787875, 6040337.719984194],
              [-12563173.419743832, 6045435.203197199],
              [-12569553.473719668, 6056255.922329711],
              [-12569446.161730543, 6077991.911850392],
              [-12577403.056293463, 6099191.853184266],
              [-12565625.120209062, 6102815.294129256],
              [-12580751.212618053, 6128681.30702838],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Elmore',
        GEOID: '16039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12942694.95970534, 5329075.975818252],
              [-12910684.372210788, 5329253.32235208],
              [-12910264.697730498, 5367697.684781401],
              [-12910357.983463783, 5402432.436978995],
              [-12899249.18883854, 5402405.847290398],
              [-12890475.097893704, 5409685.207620583],
              [-12879387.676610695, 5413803.075835797],
              [-12871384.584459094, 5423484.873016238],
              [-12867731.19009075, 5434279.819013467],
              [-12862693.092576427, 5433412.784792904],
              [-12858372.115221797, 5447640.485752962],
              [-12833715.293289049, 5455469.170944622],
              [-12823678.060082182, 5476125.224083611],
              [-12827403.70080005, 5480739.192458316],
              [-12821993.90750597, 5479463.079264803],
              [-12816904.15774792, 5462944.6660723],
              [-12809258.51248126, 5456358.847234576],
              [-12800714.741562873, 5457664.995478126],
              [-12798552.249134723, 5455900.162362604],
              [-12801372.639753463, 5452206.009633841],
              [-12800545.647256361, 5443580.506701542],
              [-12806454.708466649, 5426154.457197406],
              [-12805507.824877959, 5406613.655905183],
              [-12810988.862646148, 5404424.729269394],
              [-12811332.171955755, 5342167.963563269],
              [-12811409.761640836, 5298976.036656066],
              [-12805946.423671685, 5298566.256315958],
              [-12805937.852070894, 5276788.265463631],
              [-12852305.425612545, 5276715.781880317],
              [-12850891.445440486, 5301494.542660973],
              [-12871077.008706031, 5305231.060019901],
              [-12887624.984970925, 5302640.53735359],
              [-12889885.549870463, 5307763.8772477405],
              [-12905898.079384642, 5312235.630936503],
              [-12909160.964979284, 5303402.229303887],
              [-12929293.206208738, 5314014.121938365],
              [-12935518.52609237, 5319422.459848852],
              [-12934397.761459062, 5324533.515401157],
              [-12942694.95970534, 5329075.975818252],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Windham',
        GEOID: '50025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8126633.297968793, 5315474.4028415205],
              [-8125981.967628162, 5330107.011724845],
              [-8111710.697588974, 5329213.369528436],
              [-8109393.137110148, 5352010.924017917],
              [-8106214.965647999, 5350942.46001913],
              [-8091328.098824725, 5345899.406531478],
              [-8063272.714874809, 5347489.639706224],
              [-8064046.585938053, 5344793.304184498],
              [-8065141.183724568, 5336542.469117155],
              [-8065297.70569508, 5335363.237863284],
              [-8063448.577633513, 5325165.906397121],
              [-8066460.549095906, 5318704.09181425],
              [-8065314.705190792, 5315091.9017887805],
              [-8064537.9501704145, 5312644.031330891],
              [-8069838.984321992, 5307048.8383754175],
              [-8074246.011643006, 5305116.528989677],
              [-8074166.195568107, 5296451.67341305],
              [-8076909.441779725, 5291636.1445553955],
              [-8076663.431365512, 5290387.714891201],
              [-8075071.334347749, 5282312.311059446],
              [-8068171.195710927, 5275701.222060134],
              [-8066045.438714737, 5270488.0731914425],
              [-8072523.362870202, 5270732.760606553],
              [-8105073.384269914, 5271962.352838071],
              [-8111215.866293861, 5272134.056763198],
              [-8118559.697445221, 5272339.346729016],
              [-8117570.44426484, 5300835.47297836],
              [-8127220.396963237, 5301336.422521712],
              [-8126633.297968793, 5315474.4028415205],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ellis',
        GEOID: '48139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10807656.92361108, 3835649.6478558076],
              [-10802263.605601635, 3835548.488082721],
              [-10745668.999121316, 3835102.127589903],
              [-10735040.99337681, 3814446.344698942],
              [-10737002.88808255, 3810479.131023542],
              [-10736928.971940665, 3808758.557350388],
              [-10729315.609326333, 3806555.2626637802],
              [-10786436.645678611, 3773025.1800082177],
              [-10791384.4630859, 3770149.798960078],
              [-10807585.3451785, 3798205.8563039396],
              [-10807656.92361108, 3835649.6478558076],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ste. Genevieve',
        GEOID: '29186',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10054695.895387044, 4576845.337246866],
              [-10065065.52859342, 4585405.2289827755],
              [-10046926.46284662, 4595760.339090596],
              [-10046889.763479467, 4597491.727074672],
              [-10046860.56170807, 4597463.024490207],
              [-10043100.634587036, 4592765.0125706615],
              [-10041451.233823158, 4591774.936733772],
              [-10032781.095151518, 4586572.122990623],
              [-10027766.486049753, 4581605.5011500325],
              [-10019684.023101218, 4575213.961825453],
              [-10013734.775554752, 4574715.2234243],
              [-10015884.466241462, 4568020.161370043],
              [-10011306.428907353, 4562501.65023269],
              [-10018728.345272755, 4554274.732954328],
              [-10031059.093948437, 4533100.652153343],
              [-10041041.22400736, 4532859.881832485],
              [-10069864.623161009, 4562335.925826806],
              [-10054695.895387044, 4576845.337246866],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hopewell',
        GEOID: '51670',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8608894.490290172, 4483044.123524617],
              [-8607707.935837807, 4482233.878351063],
              [-8607120.725523874, 4482171.03762025],
              [-8605521.287080156, 4482646.761082296],
              [-8604465.53302947, 4482352.423023068],
              [-8604607.13142176, 4482777.767260004],
              [-8603866.07757155, 4482947.825788954],
              [-8603581.099675119, 4483364.375822105],
              [-8603217.64153768, 4482826.894997162],
              [-8599693.489098145, 4480139.202927956],
              [-8600606.754200613, 4478598.2704685405],
              [-8607710.384866605, 4476502.919384053],
              [-8608966.95927868, 4482830.674063366],
              [-8608894.490290172, 4483044.123524617],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pike',
        GEOID: '05109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10456837.667197235, 4075908.934947067],
              [-10405995.272764679, 4074662.330403246],
              [-10408618.182606751, 4057587.590739726],
              [-10404107.739478787, 4056462.93138659],
              [-10401043.670494704, 4035482.7155612893],
              [-10394280.009553595, 4023039.031623105],
              [-10399365.863129467, 4021928.3820615355],
              [-10403553.257095145, 4023007.7612535614],
              [-10411494.566929357, 4021152.4945068387],
              [-10424862.256661776, 4026515.1396288206],
              [-10444337.044978607, 4029996.20127509],
              [-10444074.998897279, 4053508.926366492],
              [-10455775.567935579, 4053871.4568261504],
              [-10456837.667197235, 4075908.934947067],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '41041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13816440.863705307, 5509884.118941394],
              [-13813012.334708365, 5529985.8353533],
              [-13812923.27911573, 5543322.476085256],
              [-13810853.51582341, 5563851.119728669],
              [-13810675.18199916, 5574913.195574181],
              [-13811861.847771019, 5589793.367133594],
              [-13810647.240806973, 5595635.182151245],
              [-13806270.047109488, 5613625.914979234],
              [-13804740.874628754, 5628608.435458263],
              [-13772966.483729376, 5628519.109557825],
              [-13773004.109717263, 5580532.749164615],
              [-13770718.275293313, 5577729.195303639],
              [-13759379.494600093, 5577729.195303639],
              [-13758830.4668715, 5532713.273414656],
              [-13772455.304627651, 5532754.5856167525],
              [-13771950.693375887, 5521394.395078205],
              [-13783192.514792627, 5514366.409437019],
              [-13778636.54199293, 5509427.100855397],
              [-13797057.35737093, 5509334.4249166325],
              [-13799347.421935529, 5508467.57722327],
              [-13816348.476794312, 5508283.800530963],
              [-13816440.863705307, 5509884.118941394],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '17121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9923453.332687518, 4650741.088430146],
              [-9922840.518890701, 4683973.31622976],
              [-9922812.132420547, 4696527.210973248],
              [-9873500.603625381, 4696820.848317612],
              [-9873867.290028054, 4665399.399294233],
              [-9873923.17241243, 4646734.183318256],
              [-9923507.879238008, 4646586.87329672],
              [-9923453.332687518, 4650741.088430146],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monona',
        GEOID: '19133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10724209.840104219, 5193217.388014465],
              [-10650027.188813915, 5192700.130936813],
              [-10650244.15050147, 5140501.521397622],
              [-10700788.793511795, 5140942.218261997],
              [-10704381.824500492, 5147515.926125282],
              [-10701425.067505531, 5157179.149656369],
              [-10711563.378810037, 5164373.207967751],
              [-10717047.644843457, 5168058.095888818],
              [-10716604.927228574, 5178009.891112428],
              [-10725382.691716606, 5185999.016233457],
              [-10724209.840104219, 5193217.388014465],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greer',
        GEOID: '40055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11119544.859787755, 4167994.389823945],
              [-11107787.072531188, 4167973.8619513744],
              [-11107762.35960423, 4179762.4258586946],
              [-11066191.654240353, 4179453.3686153754],
              [-11061636.015399128, 4175828.338766253],
              [-11057118.781782228, 4169549.044545613],
              [-11054717.843004799, 4144550.693010377],
              [-11048065.612873975, 4139733.3467727522],
              [-11065805.375607299, 4138502.691991043],
              [-11067740.108357288, 4126574.966203139],
              [-11094862.879650088, 4126511.9856589017],
              [-11100786.968991632, 4132458.776369368],
              [-11102014.37769712, 4156281.4460327188],
              [-11119528.607142098, 4156266.2360817175],
              [-11119544.859787755, 4167994.389823945],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oglala Lakota',
        GEOID: '46102',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11466020.763629315, 5404642.568596031],
              [-11455053.901354834, 5415267.42686553],
              [-11444689.834122999, 5417217.998287058],
              [-11374094.6866051, 5417248.171345973],
              [-11370079.058613714, 5419279.229635167],
              [-11370067.1474282, 5384810.549054724],
              [-11366924.375564124, 5371508.472511339],
              [-11366709.862905366, 5331666.973184812],
              [-11363770.39596377, 5311841.030581445],
              [-11363777.267034661, 5311841.044564907],
              [-11400077.657631667, 5311914.920505155],
              [-11442765.447388565, 5311977.362400839],
              [-11465975.403834797, 5312011.313119684],
              [-11466009.186402272, 5384836.934860865],
              [-11466020.763629315, 5404642.568596031],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ziebach',
        GEOID: '46137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11354587.39299696, 5627548.958032678],
              [-11354564.683820838, 5696202.554085529],
              [-11295609.88149672, 5696202.871573106],
              [-11297408.58182896, 5682430.384080391],
              [-11297435.855104202, 5627564.711526761],
              [-11298985.311096553, 5620542.327638436],
              [-11258426.054626023, 5620588.607016255],
              [-11258501.3066018, 5581799.114174811],
              [-11268815.836660232, 5573207.761311978],
              [-11283557.09758955, 5572509.080037752],
              [-11285732.503078632, 5567162.239314335],
              [-11294038.272925701, 5564429.770585525],
              [-11302383.115914037, 5553746.865819164],
              [-11322866.23617847, 5555560.860792525],
              [-11333570.718413154, 5546639.706391271],
              [-11342235.827576501, 5549151.459239721],
              [-11354636.150933927, 5544967.6711380705],
              [-11354587.39299696, 5627548.958032678],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '51067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8920544.981992984, 4434181.294489173],
              [-8919883.187620219, 4456251.474875975],
              [-8914772.62111739, 4461559.082746312],
              [-8901316.877667753, 4458268.797417459],
              [-8888551.537700018, 4470572.221351402],
              [-8874197.77991815, 4465584.404205707],
              [-8868877.821453141, 4459982.595467133],
              [-8860371.23124468, 4444991.393292573],
              [-8865556.827084305, 4419073.3443258535],
              [-8868729.543891402, 4415136.715805578],
              [-8876773.935574088, 4412212.137860516],
              [-8879038.062697332, 4409644.616989097],
              [-8905533.771298494, 4415540.0346652735],
              [-8910178.243093371, 4410482.5486018825],
              [-8912978.930162238, 4417051.364692526],
              [-8931769.994166616, 4421298.313973664],
              [-8920544.981992984, 4434181.294489173],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '29223',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10105474.83770985, 4458348.53201677],
              [-10100812.88875492, 4462328.067098804],
              [-10100624.424857005, 4476953.906467746],
              [-10080047.01698387, 4477173.252079092],
              [-10079949.723748917, 4483468.235959425],
              [-10042983.637802213, 4483100.53089248],
              [-10043566.617975498, 4451175.803033613],
              [-10031038.722481623, 4451082.865749178],
              [-10031138.1307869, 4444851.790190822],
              [-10035287.119528256, 4444907.01757146],
              [-10039495.998155659, 4438179.206665618],
              [-10047537.272892602, 4428246.15014668],
              [-10094291.347706286, 4428865.38834874],
              [-10099986.45285527, 4446013.438900616],
              [-10105533.614400988, 4446123.6271113735],
              [-10105474.83770985, 4458348.53201677],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Reynolds',
        GEOID: '29179',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10164856.327642178, 4522064.114403456],
              [-10147336.30958368, 4521399.336954519],
              [-10128632.631379576, 4523613.552713508],
              [-10104324.907369956, 4523495.383795279],
              [-10104798.460483791, 4491318.803395848],
              [-10100624.424857005, 4476953.906467746],
              [-10100812.88875492, 4462328.067098804],
              [-10105474.83770985, 4458348.53201677],
              [-10105533.614400988, 4446123.6271113735],
              [-10126118.035402047, 4446578.339961841],
              [-10132051.364261327, 4452451.331165607],
              [-10133897.04141868, 4462737.376796621],
              [-10144103.034973588, 4466948.320983138],
              [-10147809.417419551, 4474701.401826857],
              [-10149599.657470489, 4497084.054148849],
              [-10153658.14346583, 4497150.207701385],
              [-10153560.293633422, 4509299.5387544865],
              [-10165054.25369681, 4509751.515160663],
              [-10164856.327642178, 4522064.114403456],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Weld',
        GEOID: '08123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11694860.574811518, 4916829.4192874],
              [-11682485.298339522, 4916802.835101521],
              [-11682242.621849593, 5012057.598737369],
              [-11672435.597349687, 5012053.748556443],
              [-11632559.285955174, 5012607.9045810625],
              [-11583154.694065703, 5012549.050738533],
              [-11529863.04819671, 5012595.5142688155],
              [-11529779.781907223, 5012595.632136616],
              [-11530678.1295083, 4942292.922568438],
              [-11593670.489763487, 4942440.248221662],
              [-11593979.957947893, 4916970.229028728],
              [-11593961.924190387, 4866066.671870049],
              [-11631746.542352892, 4866031.359392439],
              [-11684250.15754656, 4865991.251545606],
              [-11684250.15754656, 4866003.167628101],
              [-11684264.963038836, 4866000.987855842],
              [-11684258.840466842, 4868119.225771248],
              [-11684240.69538984, 4868119.661818753],
              [-11684212.976836635, 4872359.24039142],
              [-11694426.762755899, 4865980.062066537],
              [-11694714.74627858, 4868516.182282677],
              [-11694712.853847235, 4886054.670743449],
              [-11694679.012722036, 4904058.572738929],
              [-11694860.574811518, 4916829.4192874],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Warren',
        GEOID: '39165',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9391494.666896388, 4806466.615080445],
              [-9363549.355886117, 4804804.10423975],
              [-9348277.434944188, 4803531.191790232],
              [-9351592.19542154, 4758274.011211118],
              [-9379716.953450968, 4760535.339429881],
              [-9380057.479773305, 4763057.21537711],
              [-9390156.27265858, 4763626.076555594],
              [-9387805.205013027, 4800590.565382324],
              [-9391494.666896388, 4806466.615080445],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Broward',
        GEOID: '12011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9003657.672292113, 3040483.3312359694],
              [-8938673.583707651, 3040551.6465313253],
              [-8933363.53267732, 3041442.259264816],
              [-8928277.679101449, 3039740.081797674],
              [-8924500.16350087, 3039734.9894791455],
              [-8916667.946767636, 3039733.623247653],
              [-8914005.567424927, 3038881.960891152],
              [-8915084.315691613, 3029985.6341626444],
              [-8917655.072974432, 3010640.3865043134],
              [-8917756.094790142, 3009880.7132675424],
              [-8918135.94486569, 3001189.586731491],
              [-8918363.004702104, 2995996.8443934894],
              [-8918375.356644908, 2995714.4149003555],
              [-8928516.4594092, 2995699.618980714],
              [-8938419.32999068, 2995436.368314532],
              [-8941928.676937938, 2993770.7928126985],
              [-8981258.298313163, 2993738.4786678106],
              [-8981260.74734196, 2996449.1541129407],
              [-9002733.60919904, 2996533.9792038496],
              [-9003499.153337223, 3031251.2051255326],
              [-9003657.672292113, 3040483.3312359694],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wheeler',
        GEOID: '48483',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11192079.192835271, 4248362.743728253],
              [-11131992.71656775, 4248337.957543823],
              [-11131992.365259355, 4221427.891884859],
              [-11131991.937331311, 4188737.417956186],
              [-11191947.835836133, 4188797.6188757084],
              [-11192079.192835271, 4248362.743728253],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Richmond',
        GEOID: '13245',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9167549.462404873, 3936832.7074623727],
              [-9160946.101530507, 3942470.988199738],
              [-9159682.736629494, 3943545.2063431176],
              [-9131341.684829453, 3967860.2345457436],
              [-9130014.917158335, 3965696.7002669447],
              [-9127189.467822863, 3961090.645065824],
              [-9119998.006078636, 3956913.5551212477],
              [-9119306.155443357, 3949952.3321439563],
              [-9120710.562139206, 3940992.5682252604],
              [-9111070.182917016, 3935703.834773491],
              [-9111110.762473475, 3928168.716535138],
              [-9139011.263786638, 3925954.006535009],
              [-9147594.553124253, 3934761.926090843],
              [-9157985.114394896, 3930850.4656305956],
              [-9165242.477277674, 3936348.244468934],
              [-9167549.462404873, 3936832.7074623727],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Towns',
        GEOID: '13281',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9343760.350968737, 4162180.4518037173],
              [-9308534.150341175, 4162059.1996708345],
              [-9300652.257675314, 4162359.6471987865],
              [-9312589.408071283, 4147420.9577836017],
              [-9312119.639820134, 4139852.541452815],
              [-9315392.655488439, 4136854.6187948356],
              [-9317924.394667549, 4135559.4873372284],
              [-9326385.455204275, 4135773.25366671],
              [-9329539.025058957, 4150899.6422301293],
              [-9341366.053038796, 4153961.7611060813],
              [-9343760.350968737, 4162180.4518037173],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adams',
        GEOID: '16003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13009389.917543802, 5601172.899553362],
              [-13005860.421768712, 5610347.132583345],
              [-13008607.89812098, 5618178.45982636],
              [-13006715.578096986, 5626388.473839207],
              [-13000303.130149331, 5633647.302729524],
              [-13000238.371512437, 5633764.037772157],
              [-12997067.406510442, 5639481.9261119235],
              [-12990544.529627917, 5661704.988744826],
              [-12989973.377691323, 5663967.402378859],
              [-12951229.71374497, 5663791.492961971],
              [-12944894.855482396, 5641810.52321694],
              [-12929133.90801741, 5638484.88385963],
              [-12922981.50240025, 5631542.247079241],
              [-12934992.09622041, 5600170.3442411255],
              [-12936572.832989672, 5587089.983328187],
              [-12930607.889395004, 5574733.0840621935],
              [-12933495.962264147, 5556212.912306403],
              [-12930540.541103076, 5542979.89461266],
              [-12936806.93787881, 5544834.983089172],
              [-12946442.97564086, 5534501.093915555],
              [-12958440.09980263, 5534479.2643931545],
              [-12971937.588061314, 5541827.698123504],
              [-12971967.533004338, 5561137.4749008175],
              [-12982541.326156829, 5568664.947024351],
              [-12982639.398628218, 5596203.307092838],
              [-13012056.81939781, 5596451.004120787],
              [-13009389.917543802, 5601172.899553362],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Butte',
        GEOID: '16023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12663835.516447028, 5407007.001151763],
              [-12633438.616291018, 5425108.840943346],
              [-12625048.911547892, 5437121.770925126],
              [-12619289.241094248, 5434026.270151156],
              [-12629639.838667698, 5445949.845536139],
              [-12630066.303636925, 5474658.904473804],
              [-12625469.810542582, 5501627.108326011],
              [-12614792.490263654, 5501596.035444063],
              [-12578555.99225961, 5501745.496973868],
              [-12578470.49889068, 5461166.134868751],
              [-12545176.954264736, 5461101.01470699],
              [-12545386.23490743, 5407306.249987481],
              [-12545583.159086643, 5394537.888302514],
              [-12558650.620152391, 5393907.825208479],
              [-12558698.042255469, 5380591.013662983],
              [-12572070.964003956, 5380625.054280948],
              [-12573204.307739723, 5355425.481223183],
              [-12579917.095673539, 5355418.905624119],
              [-12619395.439888466, 5355403.613551247],
              [-12619390.096552907, 5368025.373741577],
              [-12649815.939776525, 5368084.481485631],
              [-12649715.195637356, 5388001.628641234],
              [-12657154.45456809, 5401374.287852447],
              [-12667984.505188385, 5399017.747465302],
              [-12663835.516447028, 5407007.001151763],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rankin',
        GEOID: '28121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10047118.266329255, 3783172.804060388],
              [-10040445.330773143, 3787994.853869652],
              [-10038758.395209663, 3799616.0220521335],
              [-10029182.692611625, 3814645.933133586],
              [-10026067.527981266, 3815870.0344679346],
              [-10027141.983706404, 3818448.771620912],
              [-10003514.978382984, 3839129.224428733],
              [-10000941.383075336, 3841444.268978393],
              [-9994722.85368064, 3840598.154456141],
              [-9988704.922008358, 3809701.89696339],
              [-9988745.108344534, 3792492.1160278893],
              [-9988705.25596683, 3769491.1458891225],
              [-10044394.501028527, 3769839.971414464],
              [-10047118.266329255, 3783172.804060388],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wheeler',
        GEOID: '13309',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9231487.704373334, 3781080.569479656],
              [-9225587.6600418, 3786964.841869958],
              [-9226694.064460794, 3789075.7317528287],
              [-9214350.1800852, 3798194.139631079],
              [-9212262.049076898, 3798763.925524461],
              [-9208566.909899507, 3803977.6491854913],
              [-9203201.978360215, 3801911.534472386],
              [-9201166.612790553, 3802433.82418798],
              [-9199922.394841954, 3801990.284711376],
              [-9194730.676430339, 3765145.728027404],
              [-9188717.64281565, 3757918.6586701623],
              [-9194406.291434169, 3754333.4418162853],
              [-9200072.676154526, 3752667.463948203],
              [-9208692.033007158, 3763673.713103288],
              [-9227011.770287517, 3773802.13701053],
              [-9231487.704373334, 3781080.569479656],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Laurens',
        GEOID: '13175',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9264735.608008051, 3840242.7621069774],
              [-9234738.344823986, 3856651.746764849],
              [-9224240.58288371, 3857636.346671187],
              [-9216645.810624339, 3850291.532275078],
              [-9202621.66985471, 3843937.646046141],
              [-9200303.552778432, 3830774.7545312364],
              [-9211519.325434327, 3806551.1787186707],
              [-9208566.909899507, 3803977.6491854913],
              [-9212262.049076898, 3798763.925524461],
              [-9214350.1800852, 3798194.139631079],
              [-9226694.064460794, 3789075.7317528287],
              [-9238512.18688137, 3782658.1914533926],
              [-9254990.143186552, 3818974.028555941],
              [-9264735.608008051, 3840242.7621069774],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scott',
        GEOID: '05127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10514021.04246436, 4149018.0701120063],
              [-10513848.668216357, 4154912.3908687956],
              [-10489693.948863344, 4159604.9111945736],
              [-10489440.140424335, 4171710.8316674596],
              [-10479680.426708015, 4177435.25014463],
              [-10479813.342180023, 4171451.090378685],
              [-10472308.404749721, 4167494.526516426],
              [-10431180.083042257, 4166560.656675382],
              [-10431782.544126432, 4129321.5334343044],
              [-10443661.001711018, 4124716.9859050536],
              [-10450469.301767936, 4118485.203800684],
              [-10456296.431833, 4118530.950389938],
              [-10458199.215889128, 4120641.7223402155],
              [-10499303.15862811, 4126775.82910113],
              [-10514615.158386936, 4127108.44230586],
              [-10514021.04246436, 4149018.0701120063],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wilkinson',
        GEOID: '28157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10200010.944711655, 3633411.103798285],
              [-10192453.208646268, 3639180.3700647224],
              [-10196274.58412622, 3644630.5904358556],
              [-10199277.76134884, 3650537.104304386],
              [-10195862.80142577, 3657708.9953334085],
              [-10184503.77248923, 3662124.04368745],
              [-10182219.607857643, 3674321.3068371858],
              [-10164170.15430093, 3679703.1556234644],
              [-10147678.83965685, 3677856.4142791433],
              [-10143205.688558305, 3674418.256197034],
              [-10140693.318970593, 3674504.3906123163],
              [-10136693.72098588, 3669416.329969153],
              [-10136767.021307964, 3632661.3438261896],
              [-10149681.491096154, 3632648.391697472],
              [-10155016.797850963, 3632643.0408367757],
              [-10200977.721292743, 3632673.3000998115],
              [-10200010.944711655, 3633411.103798285],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chittenden',
        GEOID: '50007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8166696.493943083, 5552900.035049912],
              [-8155888.171468756, 5557612.8242929885],
              [-8151798.738654974, 5577997.416461012],
              [-8130556.085504857, 5566769.466719165],
              [-8117875.0143916495, 5563936.687023325],
              [-8110263.321569679, 5555207.815991657],
              [-8105099.655669741, 5550629.478004286],
              [-8108360.092235588, 5536786.154643169],
              [-8104614.970606827, 5535608.231162434],
              [-8108415.084064037, 5528075.961246652],
              [-8106965.7042939095, 5521196.967949031],
              [-8110247.402882495, 5522187.416336928],
              [-8116459.698385703, 5509150.630785764],
              [-8114743.374476653, 5508297.793550101],
              [-8117647.699991451, 5499897.752323557],
              [-8120998.082705857, 5490433.254958671],
              [-8122454.475603905, 5501155.122629471],
              [-8123352.601255624, 5510962.4550246075],
              [-8161661.865357972, 5506313.8268518355],
              [-8162415.835089383, 5513544.976309337],
              [-8163574.44834956, 5520836.845712804],
              [-8162051.263757035, 5524853.3327155225],
              [-8159007.677559256, 5533874.763330895],
              [-8161151.468312953, 5544278.18269302],
              [-8165060.144147287, 5550354.856283803],
              [-8166696.493943083, 5552900.035049912],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Custer',
        GEOID: '30017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11821198.066788225, 5802360.211140029],
              [-11817136.463847138, 5858193.547437142],
              [-11813294.494261391, 5914603.734039215],
              [-11809491.041219458, 5916954.11114352],
              [-11809504.622197334, 5919299.585061471],
              [-11781239.378970522, 5919385.869612607],
              [-11757359.567083513, 5914719.260904324],
              [-11757352.776594575, 5900539.409152709],
              [-11752673.573118571, 5886429.028442651],
              [-11743315.945402997, 5886447.51814244],
              [-11743306.705885261, 5877040.323448153],
              [-11738550.8032801, 5872323.9875650555],
              [-11715158.348123783, 5872210.313638266],
              [-11715178.385632128, 5867503.205571847],
              [-11686844.903557459, 5867373.895659334],
              [-11686847.79786422, 5872067.980411229],
              [-11672822.543899685, 5872024.098846247],
              [-11672821.319385285, 5879061.228609558],
              [-11658830.797101878, 5879083.59209386],
              [-11658787.716458939, 5857962.03963953],
              [-11678081.165325265, 5857969.961244209],
              [-11675799.895000443, 5802265.749756161],
              [-11681778.864850948, 5802262.536801658],
              [-11681788.215688175, 5746275.52823666],
              [-11686536.103289997, 5746278.401705946],
              [-11821209.755334755, 5746536.698457887],
              [-11821198.066788225, 5802360.211140029],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Norfolk',
        GEOID: '25021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7887362.182582314, 5196939.260140911],
              [-7885410.949544706, 5200722.576908963],
              [-7880164.709585584, 5199091.644793092],
              [-7879368.835958818, 5198297.123857397],
              [-7879759.172680623, 5194784.65774058],
              [-7884425.574415187, 5191104.728011048],
              [-7885961.783388135, 5192957.139713854],
              [-7887362.182582314, 5196939.260140911],
            ],
          ],
          [
            [
              [-7959308.971357425, 5176494.372339782],
              [-7956952.671695802, 5180679.592111384],
              [-7956907.809941012, 5184493.636073028],
              [-7941996.675468743, 5191091.353968914],
              [-7937404.969112502, 5198242.542679505],
              [-7940391.448411505, 5207979.896546516],
              [-7933735.4334179945, 5210252.537763119],
              [-7929388.963899971, 5209144.528832109],
              [-7924963.123585012, 5203475.068914807],
              [-7924630.50094652, 5203076.792986379],
              [-7920007.959091331, 5199367.626866157],
              [-7918241.20745295, 5195183.036643238],
              [-7917322.376375943, 5196276.484758956],
              [-7917752.069610404, 5196872.349000682],
              [-7915856.298682196, 5198199.833918387],
              [-7915878.228621881, 5199316.039416131],
              [-7916299.238936062, 5199854.187027117],
              [-7916136.823798995, 5200067.770004088],
              [-7915115.356151475, 5199988.653495433],
              [-7914118.490111421, 5201079.496698882],
              [-7909615.394069851, 5202638.9645592095],
              [-7908325.2011715565, 5206821.879734889],
              [-7902911.248975536, 5207965.035524997],
              [-7900049.376267513, 5201234.7399627045],
              [-7897950.563434314, 5203369.095156888],
              [-7894120.500187864, 5204338.935299683],
              [-7895321.19221556, 5184613.469053142],
              [-7898002.433470807, 5183198.395055661],
              [-7912643.172899939, 5175301.483774375],
              [-7919114.842816695, 5171892.726256994],
              [-7935773.359335947, 5163146.027745429],
              [-7943009.126237509, 5159412.715534568],
              [-7946144.589631155, 5158745.379234222],
              [-7946141.211430468, 5163795.709332947],
              [-7954677.189378485, 5163508.145617763],
              [-7959145.889764447, 5163357.605568055],
              [-7959152.90143133, 5170702.81350232],
              [-7959308.971357425, 5176494.372339782],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tyler',
        GEOID: '48457',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10526587.34318256, 3640407.551700265],
              [-10522656.206684686, 3639987.8221242544],
              [-10514995.978564728, 3637077.7856730614],
              [-10514489.920159582, 3633559.163052742],
              [-10503414.966659542, 3637863.2734349705],
              [-10490573.37284061, 3634529.1264524083],
              [-10491292.942029098, 3628616.620836323],
              [-10486345.124621809, 3623565.0923544625],
              [-10487989.536139807, 3619820.9315321813],
              [-10483996.506005052, 3606151.141770779],
              [-10480743.30520611, 3605532.8773486326],
              [-10478038.798177289, 3591784.9007808883],
              [-10473980.646140419, 3592163.654161291],
              [-10469704.97581854, 3585898.741036613],
              [-10474586.558128806, 3577747.143556541],
              [-10472012.517543195, 3571347.279275049],
              [-10524781.073124947, 3571469.274047475],
              [-10537279.468953762, 3634308.579089812],
              [-10526587.34318256, 3640407.551700265],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '13209',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9200477.767781524, 3804221.1866525444],
              [-9173742.388316683, 3809834.331534528],
              [-9177066.0543533, 3801856.883692141],
              [-9181980.141954878, 3759236.965320663],
              [-9181656.53619514, 3757400.009425008],
              [-9188717.64281565, 3757918.6586701623],
              [-9194730.676430339, 3765145.728027404],
              [-9199922.394841954, 3801990.284711376],
              [-9201166.612790553, 3802433.82418798],
              [-9200477.767781524, 3804221.1866525444],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McDuffie',
        GEOID: '13189',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9200523.074814277, 3976389.3274833164],
              [-9184662.051127069, 3983238.3879976952],
              [-9181577.94463464, 3980502.473421274],
              [-9175545.541428555, 3981985.9567349534],
              [-9176853.879403846, 3968608.752904611],
              [-9160946.101530507, 3942470.988199738],
              [-9167549.462404873, 3936832.7074623727],
              [-9170925.893880123, 3936804.4676570604],
              [-9189208.895728521, 3942224.171981171],
              [-9200523.074814277, 3976389.3274833164],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sherman',
        GEOID: '41055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13471404.98879665, 5670005.957964483],
              [-13464812.759871362, 5670511.994367018],
              [-13455027.553991651, 5684896.3461403735],
              [-13450331.652592028, 5702961.877962983],
              [-13459468.088479394, 5709837.4468198195],
              [-13460077.675467484, 5724129.782868585],
              [-13458033.848160014, 5723314.369089942],
              [-13453592.089157872, 5727869.403644375],
              [-13435079.212560987, 5734929.84550996],
              [-13430976.728671703, 5738170.566580201],
              [-13429023.209622853, 5739714.146288001],
              [-13424147.193287125, 5739825.810661753],
              [-13414651.306763988, 5732411.305708676],
              [-13412723.678502271, 5732389.6651133215],
              [-13398206.301028077, 5706022.27761093],
              [-13398965.499955287, 5700145.983826638],
              [-13413559.930476248, 5695049.354804773],
              [-13416788.195709255, 5685546.873428004],
              [-13418479.91801084, 5655756.376659871],
              [-13408683.134904087, 5644448.750191827],
              [-13414414.196248595, 5634672.818761027],
              [-13439578.969017835, 5634712.86433829],
              [-13438886.227826625, 5642154.342081816],
              [-13457341.663566263, 5653426.694417635],
              [-13472338.959324405, 5656021.395730595],
              [-13471404.98879665, 5670005.957964483],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Umatilla',
        GEOID: '41059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13295124.848719092, 5766451.816405575],
              [-13287583.78156666, 5767795.254179413],
              [-13275645.211457044, 5770727.540272015],
              [-13261059.018578403, 5769596.348292304],
              [-13253861.32294269, 5773705.631924139],
              [-13245597.580607753, 5780317.204391287],
              [-13245586.611233555, 5780325.9839351615],
              [-13211160.056830317, 5780499.055927769],
              [-13203247.373269482, 5780487.557719666],
              [-13176642.10912514, 5780448.896752617],
              [-13135362.663372366, 5780379.774857058],
              [-13133212.736346474, 5780376.174846944],
              [-13133206.468332002, 5760642.497018156],
              [-13132692.060965048, 5758037.544904314],
              [-13132688.49874134, 5751055.071168495],
              [-13140709.62465045, 5751083.342174524],
              [-13143089.635363612, 5730554.141330994],
              [-13148745.890010308, 5730587.924784029],
              [-13148664.292823557, 5695935.55102212],
              [-13157736.163406264, 5695882.849813294],
              [-13157727.369166492, 5689028.62380774],
              [-13183404.656871341, 5689325.558998281],
              [-13183381.279778272, 5677613.285395304],
              [-13213374.869419139, 5676101.662114804],
              [-13213287.928896831, 5662168.965878345],
              [-13208736.85415473, 5662187.310388543],
              [-13208724.609010743, 5652577.231164543],
              [-13196550.70949759, 5652572.491962981],
              [-13196664.2553782, 5634243.3647868335],
              [-13193440.108966352, 5620872.427577149],
              [-13265160.69653617, 5620929.727986209],
              [-13263319.24951947, 5634588.156059779],
              [-13263176.760571254, 5703109.781392619],
              [-13274650.460487315, 5703136.312127012],
              [-13274687.52987775, 5716786.887580008],
              [-13295403.307877943, 5716953.954487211],
              [-13295124.848719092, 5766451.816405575],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '41061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13213374.869419139, 5676101.662114804],
              [-13183381.279778272, 5677613.285395304],
              [-13183404.656871341, 5689325.558998281],
              [-13157727.369166492, 5689028.62380774],
              [-13157736.163406264, 5695882.849813294],
              [-13148664.292823557, 5695935.55102212],
              [-13148745.890010308, 5730587.924784029],
              [-13143089.635363612, 5730554.141330994],
              [-13140709.62465045, 5751083.342174524],
              [-13132688.49874134, 5751055.071168495],
              [-13132692.060965048, 5758037.544904314],
              [-13107572.483909072, 5758113.79293369],
              [-13107608.440104598, 5744146.382917907],
              [-13112144.152756969, 5744128.827048512],
              [-13112058.214110076, 5730740.908060888],
              [-13105334.739505146, 5719182.607865793],
              [-13105335.852700055, 5702930.422984134],
              [-13098228.771129848, 5679286.141458202],
              [-13089206.660359528, 5674905.754737291],
              [-13082516.915560305, 5663769.190914329],
              [-13082371.309666347, 5654605.838865964],
              [-13077444.64296231, 5647777.857898229],
              [-13053992.075280964, 5647777.857898229],
              [-13053991.963961475, 5634214.51453797],
              [-13087107.397402147, 5634037.316129076],
              [-13087168.289163612, 5620398.453810138],
              [-13110931.772182742, 5620287.480488201],
              [-13118270.620932778, 5630732.1957295565],
              [-13132258.248909425, 5620865.186342568],
              [-13150210.520550674, 5628612.380682334],
              [-13162935.562862746, 5614974.164104794],
              [-13176244.030626064, 5620067.4267892875],
              [-13184246.34354123, 5615607.223249033],
              [-13193440.108966352, 5620872.427577149],
              [-13196664.2553782, 5634243.3647868335],
              [-13196550.70949759, 5652572.491962981],
              [-13208724.609010743, 5652577.231164543],
              [-13208736.85415473, 5662187.310388543],
              [-13213287.928896831, 5662168.965878345],
              [-13213374.869419139, 5676101.662114804],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greene',
        GEOID: '13133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9284734.488487534, 3988363.6096518473],
              [-9271961.801433405, 3993182.56970804],
              [-9270725.041890692, 3996858.7741092974],
              [-9252734.587664101, 3988431.982782659],
              [-9239028.152721196, 3987731.545404336],
              [-9234081.225869834, 3983409.3123052693],
              [-9241080.438853463, 3972595.9255136056],
              [-9240948.525256872, 3957746.370284744],
              [-9257797.175466396, 3942523.6305672782],
              [-9264516.085972209, 3945908.303327493],
              [-9270679.512218958, 3959649.486629912],
              [-9269486.389916634, 3966296.570154503],
              [-9278131.127613168, 3975283.9868940827],
              [-9284734.488487534, 3988363.6096518473],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Juneau',
        GEOID: '02110',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-15002831.453780364, 8002374.773935118],
              [-14997460.27032596, 8011871.598164749],
              [-14994730.511796355, 8001319.170344565],
              [-14984595.428757083, 8003459.866265874],
              [-14968214.65436736, 8000853.882425722],
              [-14953532.949365616, 7995728.339343971],
              [-14945334.380188182, 7997795.727673756],
              [-14945129.891939072, 7997703.402054258],
              [-14976747.627295136, 7987968.743233526],
              [-14981129.16245276, 7978694.218755701],
              [-14994486.72211152, 7974050.311345858],
              [-15004162.055653814, 7987637.403299173],
              [-15002831.453780364, 8002374.773935118],
            ],
          ],
          [
            [
              [-15052524.474470483, 8174979.339984235],
              [-15021722.037409512, 8173054.762808123],
              [-14953323.699660614, 8172388.0530029945],
              [-14953431.871267976, 8163028.105855907],
              [-14944700.193049135, 8149768.2308263695],
              [-14899044.285012128, 8121826.127487347],
              [-14883397.551344696, 8095986.99643572],
              [-14847783.440613674, 8057750.205142101],
              [-14856863.437519211, 8048744.325503561],
              [-14843755.567478303, 8024444.944439063],
              [-14825193.55915119, 7999007.51013393],
              [-14883048.676060548, 7923900.7835958265],
              [-14883752.700626845, 7923757.143264458],
              [-14883760.675523665, 7923781.316076317],
              [-14899977.587622935, 7953767.705099752],
              [-14922333.547000475, 7980358.773609008],
              [-14925511.941101605, 7999325.704182294],
              [-14933140.66580567, 8009255.661266022],
              [-14942924.201893019, 8008864.868740357],
              [-14958621.029331306, 8011288.321813017],
              [-14968534.69790339, 8015237.114638984],
              [-14987076.962845845, 8019478.83882965],
              [-15000366.617615217, 8050020.082455134],
              [-15021106.663264403, 8064038.833884741],
              [-15035007.359303035, 8062736.483509943],
              [-15052524.474470483, 8174979.339984235],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Le Flore',
        GEOID: '40079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10581976.470897079, 4144196.2180323508],
              [-10575107.835676152, 4144204.2217441997],
              [-10575142.344718298, 4156023.287091277],
              [-10567299.66395293, 4156030.756098093],
              [-10567321.371253636, 4171803.850444205],
              [-10567329.497576464, 4191449.3720136844],
              [-10554677.814808825, 4191411.2265075385],
              [-10554604.900542354, 4207909.584024922],
              [-10547546.688228607, 4212498.24328253],
              [-10538482.164732294, 4204047.037571732],
              [-10530245.079011045, 4208541.306887073],
              [-10518842.512249598, 4204967.296346497],
              [-10512335.158183493, 4216510.913620293],
              [-10512068.164637374, 4214221.206552588],
              [-10512491.290021881, 4201437.395239965],
              [-10513338.41595022, 4172378.735955809],
              [-10513848.668216357, 4154912.3908687956],
              [-10514021.04246436, 4149018.0701120063],
              [-10514615.158386936, 4127108.44230586],
              [-10514960.80160564, 4114381.6276469384],
              [-10515369.197880393, 4097146.2985527036],
              [-10568405.845732942, 4097061.780933048],
              [-10568422.209698088, 4120597.726949518],
              [-10581988.048124122, 4120578.6397721856],
              [-10581976.470897079, 4144196.2180323508],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mason',
        GEOID: '54053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9147697.746292219, 4665744.423055237],
              [-9148855.468996467, 4673026.40077267],
              [-9150633.241264436, 4687404.811771335],
              [-9151496.301276555, 4693445.316008827],
              [-9146184.135175902, 4696582.6513410555],
              [-9143200.327544678, 4708155.584847392],
              [-9139204.030244574, 4716069.413916283],
              [-9138112.915495934, 4718231.211086311],
              [-9132825.017044272, 4724232.7663130015],
              [-9128984.383292412, 4725909.253295453],
              [-9121722.678949498, 4720711.184363776],
              [-9116895.977148192, 4711592.816917779],
              [-9118246.95048846, 4703920.879077091],
              [-9104961.971137699, 4683512.797867418],
              [-9102911.243478306, 4676057.635068779],
              [-9123276.921679951, 4672708.786360586],
              [-9135385.254013028, 4665673.337521059],
              [-9134334.954617394, 4646681.998927587],
              [-9152573.539988963, 4663351.291944887],
              [-9147697.746292219, 4665744.423055237],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washoe',
        GEOID: '32031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13358872.729180602, 4767105.820461366],
              [-13358676.0729867, 4785622.543059261],
              [-13358532.591106808, 4799154.064335972],
              [-13358331.709306521, 4825684.828265722],
              [-13358075.51327761, 4859623.716238367],
              [-13358018.740337307, 4884322.033164729],
              [-13357910.87175073, 4912735.861404558],
              [-13358064.270009043, 4971274.744112849],
              [-13358253.290504409, 4992581.8734493395],
              [-13358323.978381062, 5039515.775951642],
              [-13358147.425668662, 5104042.259214854],
              [-13358258.299881494, 5142257.106599642],
              [-13358246.27737649, 5160161.597614893],
              [-13327807.298452957, 5160424.61896044],
              [-13287108.126696646, 5160094.5335725],
              [-13283107.415610088, 5160062.086937743],
              [-13283081.91003949, 5073676.729991907],
              [-13281051.21988844, 5046998.350886388],
              [-13283723.889542894, 5008485.309628526],
              [-13281483.69611017, 5006499.183330351],
              [-13281866.412519518, 4942252.064255065],
              [-13284789.662347749, 4865740.14523287],
              [-13272085.882058421, 4865852.90978168],
              [-13270234.304968057, 4838365.507207915],
              [-13266015.07362801, 4819614.657666814],
              [-13268096.859425336, 4815336.610709333],
              [-13275824.435837222, 4815097.043329922],
              [-13278593.730809685, 4811099.992237198],
              [-13288274.852965506, 4806089.456563272],
              [-13307227.10759255, 4802742.309924905],
              [-13316226.39786726, 4795221.3774497835],
              [-13324458.02893346, 4796436.521189684],
              [-13320323.400406418, 4769274.288521236],
              [-13326350.682915928, 4757670.6639401885],
              [-13332832.371586857, 4752556.384942931],
              [-13345068.164736891, 4745407.121721721],
              [-13358713.377169533, 4745424.03005077],
              [-13358911.300014488, 4763478.068873594],
              [-13358872.729180602, 4767105.820461366],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Allen',
        GEOID: '18003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9499844.153675297, 5038797.830939362],
              [-9496418.741624096, 5051383.3346289955],
              [-9483540.523692697, 5051390.887470606],
              [-9440305.099087428, 5052434.914376411],
              [-9440298.576838242, 5049666.132042687],
              [-9440252.826502824, 5030266.729354332],
              [-9440211.15092909, 5010774.465260896],
              [-9440190.065258907, 5000927.266750002],
              [-9470378.886337735, 5000228.120864148],
              [-9499563.405919516, 5000118.960133272],
              [-9499520.32527658, 5013116.068492163],
              [-9499844.153675297, 5038797.830939362],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Muscatine',
        GEOID: '19139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10171097.232254524, 5074962.133187098],
              [-10170866.466950107, 5101006.241066696],
              [-10118925.349143421, 5100821.657334348],
              [-10106007.724112278, 5100732.046188235],
              [-10106282.683254538, 5079373.799219314],
              [-10115299.562008793, 5078679.767161081],
              [-10121651.563472947, 5074914.923986714],
              [-10126362.493003828, 5075982.531935463],
              [-10133166.896878567, 5075025.227605176],
              [-10137315.885619923, 5066937.365438967],
              [-10138038.794393135, 5062569.931872037],
              [-10138321.058729379, 5061779.674862213],
              [-10138357.557534566, 5061677.493678775],
              [-10171187.512361556, 5062037.966637408],
              [-10171097.232254524, 5074962.133187098],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scott',
        GEOID: '19163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10118760.596297046, 5126796.349743178],
              [-10094047.66934094, 5125248.796716853],
              [-10071266.135550097, 5127126.369536627],
              [-10053469.917183345, 5120401.3301130785],
              [-10053784.967993883, 5115375.508052504],
              [-10056238.672209948, 5110859.675642098],
              [-10056550.25546468, 5101044.944557122],
              [-10059288.714938194, 5098217.023072545],
              [-10065044.155251188, 5095732.115872692],
              [-10070120.546670344, 5089872.064033856],
              [-10075875.986983337, 5089277.33448413],
              [-10082332.740088329, 5088801.428639927],
              [-10087609.395271419, 5084149.1684727175],
              [-10096806.834239742, 5079649.3169268025],
              [-10106282.683254538, 5079373.799219314],
              [-10106007.724112278, 5100732.046188235],
              [-10118925.349143421, 5100821.657334348],
              [-10118760.596297046, 5126796.349743178],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kusilvak',
        GEOID: '02158',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-18502611.492680047, 8766872.638728427],
              [-18495038.42772138, 8794075.764347268],
              [-18484712.431755397, 8804031.506359141],
              [-18489534.235499106, 8815139.899761243],
              [-18472452.48227586, 8823445.47346214],
              [-18457214.513778623, 8817927.562576802],
              [-18438906.576364294, 8822956.132769758],
              [-18440085.11581332, 8829363.831439521],
              [-18450485.13924068, 8850264.211621804],
              [-18451683.716198053, 8872422.860425254],
              [-18442526.797524378, 8892389.462580994],
              [-18418755.856099367, 8926524.071995383],
              [-18397690.980176046, 8961193.451312091],
              [-18378419.90652737, 8984101.141122568],
              [-18373527.080948528, 9002403.798683133],
              [-18363533.930260018, 9016938.267226124],
              [-18349649.16149286, 9023490.316594468],
              [-18352617.384395376, 9039707.611174187],
              [-18353872.289015085, 9052900.810461018],
              [-18346900.015348233, 9076730.302761763],
              [-18332674.052341796, 9105694.259357912],
              [-18324014.73179197, 9127987.680616733],
              [-18305640.670600105, 9150119.945750266],
              [-18279715.140430786, 9162179.715515377],
              [-18263853.8941046, 9164852.424487127],
              [-18243601.316505596, 9154970.072868856],
              [-18226635.224233285, 9152734.050637137],
              [-18213680.084533744, 9134960.702622082],
              [-18204069.427615598, 9133528.552902022],
              [-18180276.556250896, 9109516.474153306],
              [-18151087.806528464, 9114568.847063385],
              [-18136141.049819145, 9129773.509523898],
              [-18127773.386335194, 9138159.13013838],
              [-18125164.391429473, 9150841.970385619],
              [-18114361.72540391, 9153069.495820032],
              [-18100867.686508447, 9168541.659468736],
              [-18076402.001682386, 9167213.275155134],
              [-18076401.333765443, 9145805.862811822],
              [-18055186.844446495, 9145803.148353836],
              [-18055180.16527705, 9124457.955478508],
              [-18033957.660954766, 9124453.034816124],
              [-18033954.432689533, 9103174.069431951],
              [-17906629.536829494, 9103182.409718515],
              [-17916141.78731778, 9100071.666460812],
              [-17922016.673444394, 9075512.569835925],
              [-17922015.11497152, 8991335.947936693],
              [-17927800.945505504, 8991332.566838888],
              [-17927799.7209911, 8908123.542812059],
              [-17913083.172988743, 8908122.826617975],
              [-17913081.94847434, 8846336.346386863],
              [-17870637.830385704, 8846335.636296837],
              [-17863380.46750292, 8828229.259719087],
              [-17831897.42307524, 8819344.199213477],
              [-17833675.19534321, 8814306.355318515],
              [-17850095.93343013, 8816368.35683362],
              [-17877657.86011411, 8802494.347605133],
              [-17897418.29424431, 8797407.557328394],
              [-17917312.97968041, 8784991.227061797],
              [-17936554.664983522, 8764805.017595291],
              [-17972488.4852921, 8757622.901995461],
              [-18000034.159330424, 8748568.025827428],
              [-18020987.60444346, 8737536.17574548],
              [-18035253.4198276, 8736194.885809684],
              [-18070303.029420804, 8745833.759916017],
              [-18086766.625511676, 8742469.115639018],
              [-18090058.565493416, 8754721.381845701],
              [-18117690.17817863, 8751506.09927296],
              [-18128067.269790888, 8741250.554991832],
              [-18151978.696413286, 8736864.916932462],
              [-18164152.039328985, 8729673.589583337],
              [-18193084.42026412, 8737838.600571526],
              [-18204233.512545027, 8718591.320453005],
              [-18203422.216096126, 8707818.750197662],
              [-18218034.680374596, 8703345.099311994],
              [-18232471.259857614, 8710605.640188856],
              [-18255590.536983524, 8711689.654902725],
              [-18254366.80182123, 8681900.506873872],
              [-18247588.22406836, 8674362.505604342],
              [-18258360.722511917, 8670247.814619096],
              [-18269919.804477416, 8655042.771323984],
              [-18278869.000981268, 8660719.197258225],
              [-18279971.843176555, 8644736.288371805],
              [-18272683.199516866, 8642991.495063696],
              [-18273617.837961566, 8631020.087748377],
              [-18282555.011960413, 8623123.658823952],
              [-18315385.91278262, 8612241.734782217],
              [-18325034.418327637, 8621014.125302754],
              [-18345187.031023905, 8621803.063479226],
              [-18379793.58823992, 8608983.274905393],
              [-18389417.159022834, 8619832.713426234],
              [-18382625.779528517, 8628406.824960046],
              [-18374154.922876604, 8639554.691709384],
              [-18383234.251865193, 8647196.281907903],
              [-18390398.106375705, 8660425.731080674],
              [-18403956.26375687, 8664802.418741593],
              [-18410622.631463025, 8644117.506472386],
              [-18418837.898564074, 8645003.798898803],
              [-18429513.883009117, 8647133.643539011],
              [-18438992.626330674, 8657594.3438971],
              [-18438167.860223386, 8678356.25273805],
              [-18437103.31193293, 8690037.237393891],
              [-18455373.623359375, 8697368.433868857],
              [-18460263.10935349, 8696593.061595738],
              [-18470262.82789196, 8718969.473174412],
              [-18465354.751542885, 8725500.480378972],
              [-18455779.160264336, 8729855.498734761],
              [-18450799.50548268, 8739050.524841024],
              [-18464081.70184617, 8749726.155977666],
              [-18469294.570961036, 8754668.561185874],
              [-18478983.70812019, 8750817.896186806],
              [-18487428.738650247, 8739907.87883345],
              [-18495686.3071578, 8744646.142639086],
              [-18502611.492680047, 8766872.638728427],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chicot',
        GEOID: '05017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10180987.857692014, 3947048.301942201],
              [-10180550.149454214, 3970367.374374088],
              [-10168984.276999775, 3970359.7595597683],
              [-10169125.652753083, 3964460.4563724766],
              [-10157431.540245248, 3964149.6145114033],
              [-10152965.957307804, 3968133.2926571337],
              [-10154082.048086772, 3965788.7052583033],
              [-10151154.79075687, 3960926.45845884],
              [-10149198.239386687, 3956834.1599148964],
              [-10146511.432156902, 3952142.136853817],
              [-10142737.8127385, 3947601.61031039],
              [-10145905.408849023, 3941718.561632021],
              [-10144048.59974259, 3932562.483075624],
              [-10139662.389166355, 3931683.275102795],
              [-10137722.201761318, 3926263.2936897343],
              [-10139465.24234816, 3919334.2504113684],
              [-10141686.177508976, 3912784.4521806748],
              [-10147107.214071626, 3913249.058428805],
              [-10150204.233624987, 3908367.4291343293],
              [-10143474.191170098, 3902544.1476135277],
              [-10147840.931746203, 3896796.288605548],
              [-10148560.823982406, 3895848.978902103],
              [-10159524.797540648, 3895932.9799505575],
              [-10178601.288071392, 3896079.136902335],
              [-10181324.239793636, 3896099.9992911154],
              [-10180987.857692014, 3947048.301942201],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'West Carroll',
        GEOID: '22123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10201049.522364305, 3851231.831550183],
              [-10193120.902952045, 3876147.7578436825],
              [-10178781.616703982, 3892773.278726157],
              [-10178601.288071392, 3896079.136902335],
              [-10159524.797540648, 3895932.9799505575],
              [-10164513.686249517, 3886710.909952582],
              [-10168268.270034993, 3862237.748008576],
              [-10174407.20599377, 3854622.7403490804],
              [-10174263.492531154, 3843581.360527643],
              [-10179644.120118648, 3839946.1695928676],
              [-10196423.084326936, 3839977.3477884363],
              [-10196517.59457462, 3851214.7730007684],
              [-10201049.522364305, 3851231.831550183],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greene',
        GEOID: '01063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9815632.724809367, 3886293.909783695],
              [-9815245.66693988, 3894754.4605289125],
              [-9812745.765135136, 3900255.6961578773],
              [-9792591.705285484, 3905692.961207098],
              [-9778028.110263474, 3915714.5062686005],
              [-9778086.664315632, 3913484.49257693],
              [-9777353.291510286, 3907768.5470337546],
              [-9777439.45279616, 3897594.898350744],
              [-9764468.060450964, 3896209.770292289],
              [-9766052.359443933, 3888570.7467295188],
              [-9774320.837261586, 3881709.7417187113],
              [-9777385.574162615, 3874152.754901715],
              [-9775318.259899093, 3870135.022327643],
              [-9781695.308248676, 3863814.396663104],
              [-9774773.46231115, 3862481.425791671],
              [-9775343.08414554, 3846807.21926108],
              [-9766830.148726106, 3840967.826662213],
              [-9772482.173232153, 3839990.1625790587],
              [-9775249.353134291, 3832365.9616233534],
              [-9776631.718570963, 3835037.023750749],
              [-9779797.978847597, 3833359.633681243],
              [-9784800.120166391, 3841315.577455843],
              [-9778399.58340425, 3842995.680044829],
              [-9788176.885600114, 3846596.9109303667],
              [-9802096.274728905, 3841412.162030217],
              [-9810885.616443979, 3873138.9524413054],
              [-9819193.501361372, 3885324.2825306016],
              [-9815632.724809367, 3886293.909783695],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grant',
        GEOID: '18053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9558424.81119086, 4961101.41589061],
              [-9533243.897095459, 4961312.118288608],
              [-9512119.687883545, 4961382.255608102],
              [-9511918.088285718, 4948672.127511735],
              [-9511619.30677243, 4921191.804337319],
              [-9526564.950286843, 4921247.919134941],
              [-9558147.06906133, 4921078.845050591],
              [-9558127.142872479, 4925247.653042722],
              [-9558296.793776447, 4948466.385942842],
              [-9558424.81119086, 4961101.41589061],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Howard',
        GEOID: '18067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9615156.118005872, 4947856.220515974],
              [-9591846.595870197, 4948044.951588537],
              [-9574959.540436348, 4948261.6744346265],
              [-9558296.793776447, 4948466.385942842],
              [-9558127.142872479, 4925247.653042722],
              [-9580227.178740684, 4925000.445308061],
              [-9600505.916420024, 4924666.556606463],
              [-9600525.953928366, 4920391.180380528],
              [-9607901.649429856, 4928877.248993347],
              [-9615305.84272099, 4928897.577215292],
              [-9615156.118005872, 4947856.220515974],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Asotin',
        GEOID: '53003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13077812.442559889, 5799920.442787751],
              [-13071076.945449952, 5799914.339793214],
              [-13071060.470165312, 5841961.541857057],
              [-13049849.877028545, 5846508.072800183],
              [-13049774.62505277, 5854736.276207941],
              [-13047604.785538228, 5848510.504669739],
              [-13028459.808866974, 5848897.040935101],
              [-13028337.274113253, 5846299.152431159],
              [-13031365.498221304, 5837199.941741321],
              [-13024075.407408234, 5829063.181549468],
              [-13020415.111231461, 5821031.156398375],
              [-13020257.81679097, 5812406.024919027],
              [-13015915.466094106, 5807781.703580773],
              [-13017197.310030593, 5803206.071037888],
              [-13022372.441838078, 5793967.366101294],
              [-13017996.917932957, 5790129.907351558],
              [-13015028.361071974, 5779614.1807582425],
              [-13063779.507550487, 5779764.164249305],
              [-13077806.794615686, 5779959.301510733],
              [-13077812.442559889, 5799920.442787751],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nevada',
        GEOID: '06057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13499284.064709898, 4760811.57025934],
              [-13483849.50599192, 4776284.539624936],
              [-13472116.87694027, 4777915.1058369335],
              [-13468846.087661784, 4781204.697229725],
              [-13442466.262650538, 4786720.644821448],
              [-13431204.292405963, 4797431.86266633],
              [-13422413.726176491, 4796763.817004689],
              [-13414604.775216833, 4785776.963819549],
              [-13358676.0729867, 4785622.543059261],
              [-13358872.729180602, 4767105.820461366],
              [-13362419.533766838, 4767085.530665988],
              [-13394225.849995783, 4767098.912157479],
              [-13420076.684786778, 4766979.342686742],
              [-13433082.47485463, 4766227.569585075],
              [-13439367.573304815, 4763021.11427271],
              [-13468138.652297791, 4736326.313625636],
              [-13477315.831118789, 4722413.160541445],
              [-13485018.138006266, 4727103.4537983015],
              [-13500775.857206019, 4726631.517822387],
              [-13499284.064709898, 4760811.57025934],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dixon',
        GEOID: '31051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10799970.869369257, 5213755.686367948],
              [-10799730.654459087, 5274985.66202111],
              [-10794170.01070402, 5270136.359506858],
              [-10787615.29644713, 5271540.868327189],
              [-10776547.200238653, 5266522.545388463],
              [-10775910.608587671, 5266233.993400245],
              [-10773297.940138754, 5260815.816678581],
              [-10764331.934391791, 5260233.012114696],
              [-10765630.030973932, 5251852.185856404],
              [-10760003.275992295, 5246208.59761938],
              [-10756573.68466251, 5240265.842801749],
              [-10767069.503309378, 5239896.656101675],
              [-10767557.86191549, 5203077.545286301],
              [-10767562.648653593, 5202714.64273543],
              [-10768800.410071723, 5200623.409097839],
              [-10778231.063373256, 5200651.6882980345],
              [-10778295.628677918, 5200651.6882980345],
              [-10799964.3015193, 5200675.906190763],
              [-10799970.869369257, 5213755.686367948],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hidalgo',
        GEOID: '35023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12139300.858816393, 3736634.3124319986],
              [-12139200.78259417, 3774354.2090391717],
              [-12139124.64006247, 3819410.2876981855],
              [-12139069.536914526, 3865817.18090144],
              [-12139069.543850843, 3865846.838771723],
              [-12117636.527435152, 3865778.255224682],
              [-12117451.514441453, 3842776.057335033],
              [-12094475.616819685, 3842823.100123679],
              [-12094503.112733912, 3831304.6491314513],
              [-12082284.796743933, 3831317.4545504],
              [-12082358.82420531, 3773794.3855849043],
              [-12080896.308735268, 3745421.1297847116],
              [-12046677.253862869, 3745489.9422305445],
              [-12046676.251987452, 3739768.1820955016],
              [-12045703.319637919, 3734938.0333075216],
              [-12045723.13450728, 3697821.6462700274],
              [-12045723.245826771, 3676122.9439617167],
              [-12101281.02256984, 3676096.3573023137],
              [-12118354.204192296, 3675982.1917140526],
              [-12139395.369064078, 3676006.5625894614],
              [-12139300.858816393, 3736634.3124319986],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Comanche',
        GEOID: '20033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11081097.111418592, 4492364.54124524],
              [-11021909.651358714, 4492804.30054706],
              [-11020782.986792397, 4491509.732090955],
              [-11020663.101699172, 4439017.314787637],
              [-11035039.785297781, 4439026.221810769],
              [-11065938.291079307, 4439048.105442314],
              [-11071413.811260788, 4439065.010147623],
              [-11080866.225038745, 4439094.192875734],
              [-11081097.111418592, 4492364.54124524],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Will',
        GEOID: '17197',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9825200.189765086, 5119823.068420345],
              [-9812612.070426691, 5120040.981226652],
              [-9799493.958992632, 5120455.193288434],
              [-9799340.449414827, 5113946.213419394],
              [-9799294.140506657, 5111661.841493413],
              [-9786311.28225391, 5107790.665521216],
              [-9786027.194913404, 5094831.755951655],
              [-9775216.291245526, 5095041.5150223],
              [-9772783.515093729, 5090542.368302358],
              [-9772437.756755326, 5081891.7745580515],
              [-9743284.000687467, 5081957.390356998],
              [-9743435.244540991, 5056422.687262126],
              [-9743435.231875895, 5056404.106866833],
              [-9797664.645800427, 5055573.698458452],
              [-9797429.872994343, 5042701.466889457],
              [-9823293.175568307, 5042118.2180132335],
              [-9824192.080456464, 5080839.109205385],
              [-9824193.416290352, 5080885.60469611],
              [-9824422.623121895, 5089453.965322708],
              [-9824754.800482424, 5100276.26289707],
              [-9825148.426201867, 5115526.529618378],
              [-9825200.189765086, 5119823.068420345],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lafayette',
        GEOID: '29107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10476277.83515243, 4723818.559153268],
              [-10475700.977551138, 4742248.615182164],
              [-10466726.734161858, 4743831.908109398],
              [-10461815.54086704, 4751204.306756064],
              [-10462795.597663982, 4743580.5455814],
              [-10446237.380005939, 4752582.534665484],
              [-10437144.35871998, 4751369.086528209],
              [-10425128.866842227, 4757288.720800926],
              [-10407477.3804651, 4753731.177823043],
              [-10405837.978324188, 4763699.290100304],
              [-10407969.078655934, 4713486.767788385],
              [-10408069.37751714, 4711424.963001096],
              [-10445633.137809912, 4712781.468068531],
              [-10476742.037429037, 4709832.993005465],
              [-10476277.83515243, 4723818.559153268],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hall',
        GEOID: '48191',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11237139.207638063, 4129725.935550364],
              [-11192139.861957753, 4129650.337662278],
              [-11178246.298950825, 4129623.512727977],
              [-11178456.470149443, 4070978.7335049985],
              [-11189539.10469435, 4071056.6337393955],
              [-11237272.01179058, 4070875.6310782884],
              [-11237139.207638063, 4129725.935550364],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sagadahoc',
        GEOID: '23023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7798133.376820019, 5464046.733094832],
              [-7796067.287070897, 5465650.172773835],
              [-7792973.38446328, 5484732.049441457],
              [-7780985.611138733, 5482118.270251268],
              [-7776221.13693278, 5491456.068560083],
              [-7766044.643042933, 5489183.563195425],
              [-7765448.193211263, 5487029.820120816],
              [-7769151.570030974, 5471774.355061536],
              [-7771605.1629275475, 5469593.733426468],
              [-7758985.428853769, 5466461.283794987],
              [-7763784.523421357, 5449041.634402464],
              [-7758086.412646122, 5443366.223169721],
              [-7758502.687012817, 5433935.272994569],
              [-7760869.177276972, 5433372.072277471],
              [-7764989.890867667, 5425890.037293315],
              [-7770919.657503243, 5423458.068619819],
              [-7773826.432046837, 5419330.504550942],
              [-7776232.046242879, 5419864.057737094],
              [-7777019.520320752, 5428216.4528369345],
              [-7779830.462603943, 5429392.733415314],
              [-7780478.996136134, 5446661.769984675],
              [-7776449.230569417, 5456894.858863313],
              [-7789717.84595503, 5452340.29679131],
              [-7796175.712254929, 5461676.439244827],
              [-7798133.376820019, 5464046.733094832],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tucker',
        GEOID: '54093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8887535.85866602, 4740453.894545842],
              [-8884378.392629158, 4754746.443578319],
              [-8870747.766259486, 4760621.90340399],
              [-8848471.845595824, 4749628.762990908],
              [-8828354.85513661, 4751682.563410618],
              [-8833810.289421916, 4734070.687470049],
              [-8827431.237321498, 4732163.708843286],
              [-8834054.969662677, 4716589.065637958],
              [-8850875.233402051, 4718115.941524206],
              [-8881701.826792525, 4727030.791710018],
              [-8886088.593966216, 4738272.959376681],
              [-8887535.85866602, 4740453.894545842],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stone',
        GEOID: '05137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10287782.099865051, 4271570.538515925],
              [-10287515.4896846, 4297300.94124129],
              [-10275592.726942679, 4297047.427808155],
              [-10275340.143018069, 4309029.1438922165],
              [-10263395.339016967, 4308782.241294818],
              [-10263148.321066897, 4318909.591004756],
              [-10256878.139428474, 4316073.815681586],
              [-10248470.400927842, 4303975.440074985],
              [-10253484.898710117, 4291176.320262519],
              [-10236163.3633037, 4291219.76366282],
              [-10224633.78100326, 4282392.633577768],
              [-10227031.046237491, 4274586.206051406],
              [-10223268.002170715, 4260096.0594369145],
              [-10268167.716906765, 4261091.084708496],
              [-10287970.118485, 4261619.754447192],
              [-10287782.099865051, 4271570.538515925],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Powder River',
        GEOID: '30075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11830985.276418768, 5677075.80069976],
              [-11826105.809178825, 5677075.64229464],
              [-11825970.667317003, 5746533.186338051],
              [-11821209.755334755, 5746536.698457887],
              [-11686536.103289997, 5746278.401705946],
              [-11687134.779511485, 5677114.293227387],
              [-11692799.494439483, 5677113.5011984045],
              [-11692804.747414116, 5621567.404252018],
              [-11697073.712292919, 5621568.182023334],
              [-11782952.697253322, 5621583.828502826],
              [-11802635.656249763, 5621141.163908156],
              [-11829208.283387234, 5620543.586938091],
              [-11829222.653894704, 5620543.655097926],
              [-11829219.304016823, 5647807.067434527],
              [-11831003.087537294, 5649860.498749106],
              [-11830985.276418768, 5677075.80069976],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scioto',
        GEOID: '39145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9269664.946379868, 4723933.750312768],
              [-9263129.379075395, 4715964.722088467],
              [-9244373.492030108, 4715505.329420303],
              [-9218043.092872776, 4714236.202458142],
              [-9212065.347536666, 4713849.741457239],
              [-9212877.868499968, 4700904.929414468],
              [-9200560.2555242, 4700075.575027948],
              [-9201990.377022423, 4685635.465390665],
              [-9206881.421489406, 4675580.220105392],
              [-9213234.64746796, 4675933.716075846],
              [-9210617.303600429, 4664132.3702368485],
              [-9218538.730064875, 4660600.985389511],
              [-9222966.086033618, 4665153.245776937],
              [-9225000.783686336, 4675677.469490355],
              [-9225178.894871606, 4681411.402827958],
              [-9226414.31786902, 4684728.032405375],
              [-9227182.757025376, 4686791.536797744],
              [-9233188.888831636, 4684965.064009854],
              [-9240833.08694492, 4683077.9860209115],
              [-9242894.6049396, 4681196.0620064335],
              [-9244230.780442912, 4679976.476056948],
              [-9252026.929661129, 4674751.784174984],
              [-9253874.944527788, 4670267.989838699],
              [-9258736.711968692, 4667420.988363905],
              [-9266180.423679058, 4668608.769399894],
              [-9268939.355024971, 4666403.803677922],
              [-9269383.864665614, 4669381.699167408],
              [-9269664.946379868, 4723933.750312768],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sabine',
        GEOID: '48403',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10468947.3353642, 3686107.965729712],
              [-10462166.30858253, 3693432.0234789946],
              [-10462302.34100028, 3706921.944989802],
              [-10452507.78428334, 3712442.092036219],
              [-10445655.958305527, 3709116.112857409],
              [-10440397.559518922, 3701425.846471496],
              [-10433522.245128548, 3698389.587746719],
              [-10436143.930456221, 3693768.2252244423],
              [-10430369.454510301, 3688512.0850408184],
              [-10427090.316270005, 3681559.823752515],
              [-10427902.28063585, 3671906.9414682863],
              [-10421056.354591046, 3666479.935604954],
              [-10419776.291766414, 3656478.3269175524],
              [-10419571.473628549, 3656489.2510797926],
              [-10421304.151777552, 3655529.927615508],
              [-10454138.726142954, 3653294.7316202368],
              [-10468377.379571341, 3650199.0931750857],
              [-10468947.3353642, 3686107.965729712],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Graham',
        GEOID: '37075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9355076.384163879, 4211323.637598072],
              [-9351681.696292136, 4214503.797151484],
              [-9353261.98778344, 4219386.387181156],
              [-9347850.636016486, 4225556.592577726],
              [-9346263.98089795, 4226283.277155543],
              [-9345630.967688218, 4226573.209226054],
              [-9304723.79549081, 4223131.214223189],
              [-9315227.680003082, 4201929.247104655],
              [-9317749.957025478, 4197705.516314219],
              [-9332071.988752468, 4198741.121659218],
              [-9347334.224898698, 4193556.161818292],
              [-9354077.11515597, 4203650.802504134],
              [-9353454.347863529, 4204149.875784994],
              [-9355076.384163879, 4211323.637598072],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marengo',
        GEOID: '01091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9808759.302850338, 3764129.751984751],
              [-9796902.997844419, 3787660.4947125106],
              [-9798246.401459312, 3800811.324168832],
              [-9788396.40763596, 3804147.690235639],
              [-9801273.178413982, 3812911.576585168],
              [-9799635.44606543, 3820364.2317082947],
              [-9779797.978847597, 3833359.633681243],
              [-9776631.718570963, 3835037.023750749],
              [-9775249.353134291, 3832365.9616233534],
              [-9765894.285767008, 3832362.264885649],
              [-9765919.110013453, 3826605.4652130785],
              [-9743181.102143511, 3826751.944279984],
              [-9743159.394842805, 3803715.5457286024],
              [-9737458.723719282, 3803757.824339029],
              [-9737361.430484328, 3798135.819733735],
              [-9742021.264368935, 3798277.2097732313],
              [-9742898.461956386, 3780757.445525454],
              [-9754259.617867257, 3780695.529765062],
              [-9754120.579823257, 3764030.2463449286],
              [-9759131.404062334, 3762175.890044237],
              [-9804296.05918647, 3762021.9310649326],
              [-9808759.302850338, 3764129.751984751],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '54043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9149606.54160085, 4585970.495306716],
              [-9159736.83790202, 4599496.058540249],
              [-9157681.100865541, 4611854.733587465],
              [-9152777.254657114, 4623369.759632217],
              [-9133444.510010539, 4632456.370610329],
              [-9133607.147786586, 4620494.05046593],
              [-9127909.482289314, 4617156.920106441],
              [-9118758.01827069, 4625524.408483448],
              [-9107362.0193592, 4623511.06216548],
              [-9109660.210246628, 4609073.473597823],
              [-9114703.985054981, 4598826.025942595],
              [-9122995.506007226, 4596232.925371062],
              [-9120684.958656322, 4583008.384766097],
              [-9126899.703188328, 4582924.161168534],
              [-9149422.196524097, 4575863.4026329275],
              [-9162305.535152072, 4571467.091664055],
              [-9149606.54160085, 4585970.495306716],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '54099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9194863.480582854, 4607860.405345663],
              [-9193286.062706871, 4613458.1698594615],
              [-9192963.479513995, 4614603.291619827],
              [-9191859.301484818, 4624131.624580396],
              [-9194764.962833503, 4628265.122470129],
              [-9194540.68350356, 4633373.378036773],
              [-9194285.621106148, 4639185.847154245],
              [-9190611.076034553, 4636703.735475584],
              [-9184856.186723126, 4638167.827845731],
              [-9166482.242446637, 4622631.783357003],
              [-9160049.089073695, 4624848.992574373],
              [-9163072.415124148, 4617409.014144635],
              [-9157681.100865541, 4611854.733587465],
              [-9159736.83790202, 4599496.058540249],
              [-9149606.54160085, 4585970.495306716],
              [-9162305.535152072, 4571467.091664055],
              [-9173142.71021978, 4560075.39786668],
              [-9172555.145493409, 4557278.291049188],
              [-9174806.602648668, 4561412.335673163],
              [-9182472.730701638, 4567703.794971685],
              [-9181567.049041664, 4570750.389929843],
              [-9179960.361113925, 4576157.281262267],
              [-9189357.952526692, 4588338.3341425955],
              [-9197904.506432347, 4598491.02594378],
              [-9194863.480582854, 4607860.405345663],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Saba',
        GEOID: '48411',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11030717.583428752, 3692755.0800946034],
              [-11025276.175399285, 3696589.2388645033],
              [-11019695.395367347, 3695775.8397917706],
              [-11013192.110715203, 3689623.5139892516],
              [-11006436.353457943, 3690585.2509562196],
              [-11004409.448169578, 3686557.4466556874],
              [-10995360.06412401, 3686231.4865562296],
              [-10994093.248318782, 3681670.6512667434],
              [-10990138.51208886, 3688494.994950959],
              [-10986859.03989009, 3685756.8446979146],
              [-10988695.477529706, 3678134.7047110563],
              [-10982175.383634454, 3680897.3568960484],
              [-10980991.055571904, 3673604.635061053],
              [-10974684.472459994, 3675089.2345250766],
              [-10979099.180825874, 3669320.071374738],
              [-10971953.916670324, 3662730.9506777134],
              [-10966120.99799174, 3652981.880752874],
              [-10970318.855989555, 3648794.996025863],
              [-10958255.830689231, 3636585.6794851054],
              [-10955924.68923253, 3623176.2989647286],
              [-10958934.322985616, 3622550.6993880784],
              [-11016690.214393891, 3622541.4862717013],
              [-11030272.862063032, 3622616.8783123363],
              [-11030906.269965645, 3625089.497973837],
              [-11030717.583428752, 3692755.0800946034],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hertford',
        GEOID: '37091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8594807.342688756, 4334603.383865506],
              [-8585288.524350515, 4365655.469854471],
              [-8578999.418398658, 4369157.358769839],
              [-8589893.099653801, 4376033.73933583],
              [-8562396.672944294, 4376018.937921222],
              [-8562254.143125819, 4376023.833434964],
              [-8565618.259007853, 4357713.063607337],
              [-8547051.16981895, 4350611.855378362],
              [-8537823.229310151, 4341446.387112774],
              [-8538937.871371465, 4334219.3875572765],
              [-8591669.134923803, 4334077.221291182],
              [-8594807.342688756, 4334603.383865506],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Patricio',
        GEOID: '48409',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10898632.44350341, 3263382.9751566877],
              [-10889018.335681047, 3271288.628014051],
              [-10861273.733712677, 3265354.2846510424],
              [-10858222.355150543, 3269750.6908261795],
              [-10851689.348194357, 3270249.090083562],
              [-10845543.06514919, 3263817.148516337],
              [-10833297.030606002, 3266281.219991859],
              [-10827024.733897256, 3258528.6282269196],
              [-10813164.789376548, 3236924.8950020103],
              [-10818755.031565204, 3226990.462943413],
              [-10820398.218568806, 3226437.8878585426],
              [-10825909.089960527, 3233439.6223656153],
              [-10835580.638640137, 3234251.538751947],
              [-10863610.441143919, 3230843.5017637317],
              [-10874920.612728007, 3238557.8840303095],
              [-10887802.949480569, 3240744.957355131],
              [-10886881.112777308, 3248426.4998904183],
              [-10887200.711035375, 3253810.9694167087],
              [-10891378.531524846, 3253338.3983356874],
              [-10896302.192602634, 3256149.4737128713],
              [-10898632.44350341, 3263382.9751566877],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rockingham',
        GEOID: '51165',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8816666.085964335, 4654259.906809888],
              [-8811422.715308988, 4665464.3574609095],
              [-8804587.4759353, 4673016.991945208],
              [-8804042.010430414, 4677379.911616866],
              [-8800613.147475, 4687553.425160462],
              [-8796806.020889869, 4692865.529179977],
              [-8794130.01165069, 4698789.366174378],
              [-8779687.643554153, 4687778.704921804],
              [-8754361.680162247, 4665208.088495313],
              [-8759876.781694617, 4651725.490278619],
              [-8736992.611333262, 4639153.167066915],
              [-8744495.878971202, 4626833.791668435],
              [-8756741.245597444, 4618763.16815737],
              [-8755864.938565917, 4616281.019273866],
              [-8766342.662997853, 4608659.51554906],
              [-8781800.71012839, 4622416.443854471],
              [-8784560.097666174, 4622409.918485347],
              [-8819667.705015514, 4647420.647139146],
              [-8816666.085964335, 4654259.906809888],
            ],
            [
              [-8784731.641001485, 4634676.694196234],
              [-8774984.95166559, 4639007.244642276],
              [-8779919.744692456, 4648810.968024952],
              [-8781880.303564306, 4643953.708256389],
              [-8783435.882128652, 4644048.809461759],
              [-8784731.641001485, 4634676.694196234],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Polk',
        GEOID: '48373',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10597635.561027985, 3609986.5959967356],
              [-10568575.27399793, 3638211.0814177413],
              [-10557868.565373434, 3651799.7533902023],
              [-10546252.042550683, 3646222.597877685],
              [-10527893.343448546, 3641639.5338097177],
              [-10526587.34318256, 3640407.551700265],
              [-10537279.468953762, 3634308.579089812],
              [-10524781.073124947, 3571469.274047475],
              [-10523913.782972177, 3566828.3629153213],
              [-10545599.487695653, 3566700.0832135356],
              [-10550565.338860448, 3566562.632901277],
              [-10558588.468520394, 3567150.5535587966],
              [-10556425.530814279, 3573296.106614844],
              [-10571536.595092013, 3577882.0011066874],
              [-10581429.892197285, 3591282.804884307],
              [-10590422.503302546, 3593048.8375472897],
              [-10589957.29915052, 3604431.455224925],
              [-10597635.561027985, 3609986.5959967356],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oceana',
        GEOID: '26127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9633676.341689149, 5410605.856905535],
              [-9630284.65944366, 5418921.544977161],
              [-9623027.0739219, 5430158.972383412],
              [-9621954.180928532, 5437540.825983385],
              [-9577693.43581074, 5436951.759788588],
              [-9577872.326232444, 5383394.8765830435],
              [-9625074.67202095, 5384143.826060433],
              [-9626828.968490964, 5390742.955696878],
              [-9632420.657833, 5402743.526643981],
              [-9633676.341689149, 5410605.856905535],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Orleans',
        GEOID: '36073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8734745.20301674, 5368597.390512586],
              [-8719586.027835883, 5368942.504907899],
              [-8699083.315341068, 5369304.083760811],
              [-8682429.340093587, 5367742.129702443],
              [-8682441.385425946, 5355447.1960252],
              [-8682618.606055288, 5332234.865131902],
              [-8734740.061437061, 5331569.5060845325],
              [-8734745.20301674, 5368597.390512586],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Beaufort',
        GEOID: '37013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8590970.382480096, 4263921.328896908],
              [-8570024.729731413, 4253780.350671936],
              [-8554598.297336264, 4262159.418821531],
              [-8554266.008656247, 4260203.67353511],
              [-8531248.922822883, 4260134.855225325],
              [-8525758.422897976, 4248548.7103709895],
              [-8512352.216621744, 4239767.354342638],
              [-8517010.269394496, 4234548.6886182465],
              [-8526971.137430679, 4234768.0666620005],
              [-8518404.657336174, 4212041.543467755],
              [-8526015.125643747, 4213165.446663635],
              [-8530697.668704474, 4195906.89896717],
              [-8554402.486351958, 4193281.601056242],
              [-8560014.54716081, 4198437.395830728],
              [-8567024.112857081, 4204863.222920339],
              [-8592652.976583436, 4220881.214566457],
              [-8591212.836331042, 4234611.054997671],
              [-8582822.129712498, 4239076.506049326],
              [-8581158.682561575, 4239331.276093447],
              [-8590833.014228454, 4251075.047315139],
              [-8593394.030433645, 4259389.671160015],
              [-8590970.382480096, 4263921.328896908],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '37187',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8554598.297336264, 4262159.418821531],
              [-8546821.517709445, 4281077.827735805],
              [-8544950.682347175, 4282045.922597953],
              [-8536396.113438183, 4294170.059375317],
              [-8527764.734080544, 4297601.6436336255],
              [-8517265.636306377, 4297969.623355083],
              [-8504452.206318617, 4304260.498349678],
              [-8500177.426552664, 4303376.305315466],
              [-8502583.708665652, 4288885.889143322],
              [-8499638.751536716, 4281553.348252033],
              [-8505432.819713015, 4271255.459536023],
              [-8505473.785285626, 4259088.10264591],
              [-8531248.922822883, 4260134.855225325],
              [-8554266.008656247, 4260203.67353511],
              [-8554598.297336264, 4262159.418821531],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Holt',
        GEOID: '29087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10636374.966594394, 4904441.024771265],
              [-10595457.483871125, 4904045.88135343],
              [-10582584.275316808, 4901840.891451236],
              [-10580147.269024363, 4884865.524549247],
              [-10582109.831647048, 4876100.216379431],
              [-10576525.155432932, 4872739.789133042],
              [-10574614.049099876, 4851212.989429962],
              [-10577438.086576927, 4851039.846584665],
              [-10584427.948723327, 4845867.816655887],
              [-10591208.530227037, 4850756.616542043],
              [-10601079.118156185, 4857776.483209957],
              [-10609670.311177649, 4865941.98886863],
              [-10614177.303401394, 4870200.553470894],
              [-10617982.203596707, 4869882.90397995],
              [-10621519.603055647, 4876093.524935453],
              [-10619235.54974355, 4881687.258258114],
              [-10623460.013099665, 4886456.860766282],
              [-10628898.52682237, 4893376.011885467],
              [-10627955.428096367, 4900308.030335157],
              [-10636261.197943436, 4903660.771210175],
              [-10636340.269988948, 4904203.06032728],
              [-10636374.966594394, 4904441.024771265],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mono',
        GEOID: '06051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13318175.37951207, 4625706.466200627],
              [-13307391.526480453, 4647631.028515589],
              [-13315933.516286984, 4665038.575589278],
              [-13312186.518350288, 4680665.795024685],
              [-13283610.624307182, 4655189.278112298],
              [-13278106.708037466, 4650289.603962685],
              [-13264521.73388804, 4638132.03379144],
              [-13241417.028386403, 4617487.989755633],
              [-13191466.303075098, 4572226.408587277],
              [-13183344.135264661, 4564776.139070745],
              [-13138169.091231568, 4523435.246024022],
              [-13117165.668581251, 4504112.925242692],
              [-13221974.077443939, 4503848.310900672],
              [-13230374.2462192, 4505635.75546766],
              [-13237786.565833159, 4516096.678928696],
              [-13249508.842172164, 4521068.50932133],
              [-13260857.752939047, 4541908.901982771],
              [-13276962.009713639, 4542652.971746509],
              [-13269425.791506423, 4551820.820522046],
              [-13269314.805974104, 4563309.528675335],
              [-13281349.110845802, 4571916.548621007],
              [-13280926.208100276, 4582801.359868894],
              [-13285527.265293747, 4591173.554695507],
              [-13299279.0072694, 4597563.7822249485],
              [-13311194.645563914, 4601722.028149909],
              [-13317448.017959228, 4607555.991951769],
              [-13314276.636986015, 4612671.301779067],
              [-13319545.05452679, 4619972.698792527],
              [-13318175.37951207, 4625706.466200627],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lancaster',
        GEOID: '45057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9006134.32910798, 4173681.9049641686],
              [-8999130.743751822, 4164081.1208292553],
              [-8992615.780680839, 4155157.5952391424],
              [-8994280.56366565, 4139972.008614429],
              [-8968088.373153362, 4139105.3108516256],
              [-8959942.396938104, 4123807.407084467],
              [-8951019.137875607, 4111651.7032861486],
              [-8966846.431757104, 4104262.186945459],
              [-8964316.028411882, 4096679.7617918923],
              [-8987931.901786221, 4093432.04185751],
              [-8988308.05034561, 4101532.017060761],
              [-9003434.365393583, 4090437.043921197],
              [-9005604.538866596, 4094341.865472646],
              [-9003241.114757566, 4101968.529417483],
              [-9005346.722925922, 4113953.5619181045],
              [-9001324.527084576, 4122624.401580097],
              [-9003088.60705518, 4135114.752607391],
              [-9005548.099884765, 4139547.8449544446],
              [-9002039.198215472, 4143253.719354232],
              [-9002257.161778444, 4157243.6534668235],
              [-9006441.43368687, 4174103.085732383],
              [-9006134.32910798, 4173681.9049641686],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dawes',
        GEOID: '31045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11522134.944312112, 5312087.34673944],
              [-11518910.434817052, 5312088.745107143],
              [-11465975.403834797, 5312011.313119684],
              [-11442765.447388565, 5311977.362400839],
              [-11442826.457166608, 5279328.728665017],
              [-11440679.104189208, 5279343.896767883],
              [-11440678.770230735, 5227107.124226588],
              [-11515392.627588492, 5226719.7688361835],
              [-11519350.035486193, 5226706.6460927855],
              [-11519385.769042738, 5279298.544213207],
              [-11522134.944312112, 5312087.34673944],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '16063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12756613.076256322, 5342210.873306234],
              [-12732162.529340014, 5342408.627166663],
              [-12658656.0431794, 5342430.464336761],
              [-12658589.474123904, 5289127.726320979],
              [-12664135.188516244, 5276195.978763289],
              [-12682817.382058626, 5276274.523597148],
              [-12695983.58351271, 5276271.490965892],
              [-12695971.11572974, 5282860.3726344835],
              [-12728900.534301298, 5282953.084996906],
              [-12731094.307506362, 5289288.07007026],
              [-12756587.472773438, 5289304.924544042],
              [-12756613.076256322, 5342210.873306234],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gonzales',
        GEOID: '48177',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10891541.61457886, 3423691.054808578],
              [-10872016.621171681, 3453224.913000098],
              [-10868475.436850058, 3458621.928549703],
              [-10864531.05333278, 3456169.8568619187],
              [-10833378.293834282, 3475899.560936347],
              [-10812845.525076954, 3458102.273275934],
              [-10813869.55307276, 3455834.710436257],
              [-10820709.467865063, 3449754.665069488],
              [-10824719.307242926, 3424674.3531121],
              [-10835305.679497877, 3415806.1498230635],
              [-10866244.148976596, 3389624.0915545514],
              [-10879080.51077946, 3403899.9746100027],
              [-10893589.781889964, 3420638.155526589],
              [-10891541.61457886, 3423691.054808578],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Indiana',
        GEOID: '42063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8844353.135755965, 4943283.825355688],
              [-8818199.623269502, 4979359.999599098],
              [-8818207.972231312, 4999274.000241705],
              [-8772551.062318886, 4998483.6107491935],
              [-8772685.536263764, 4974531.317046267],
              [-8772164.783685831, 4971795.740506986],
              [-8773607.818244986, 4969209.245333171],
              [-8791417.712257512, 4923651.803303854],
              [-8796089.568647124, 4927205.360013113],
              [-8805444.079416955, 4919668.789666559],
              [-8811582.124819806, 4925960.511542093],
              [-8835844.43047718, 4932115.816042405],
              [-8844752.66140842, 4936563.728041491],
              [-8844353.135755965, 4943283.825355688],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Minidoka',
        GEOID: '16067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12682817.382058626, 5276274.523597148],
              [-12664135.188516244, 5276195.978763289],
              [-12658589.474123904, 5289127.726320979],
              [-12658656.0431794, 5342430.464336761],
              [-12625173.923336053, 5342442.070126314],
              [-12625092.771427266, 5289041.937467228],
              [-12631662.51381541, 5289046.796283999],
              [-12631664.96284421, 5261778.507204552],
              [-12641128.90067349, 5259878.200203844],
              [-12651921.993222844, 5241634.307818207],
              [-12656919.681762006, 5239071.674358886],
              [-12665724.27424732, 5244696.937082325],
              [-12682829.849841595, 5241496.528740356],
              [-12682817.382058626, 5276274.523597148],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Juniata',
        GEOID: '42067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8655326.4064975, 4921104.856259197],
              [-8626982.905668663, 4950842.78820156],
              [-8626149.679280074, 4955688.5349914655],
              [-8603654.236580571, 4967251.50706065],
              [-8583785.043307861, 4966951.559731611],
              [-8564893.68044228, 4959147.939294773],
              [-8565969.583320796, 4957649.535474012],
              [-8591948.769484676, 4950911.824590497],
              [-8631729.012158634, 4924126.71587297],
              [-8646380.883536844, 4908148.674899745],
              [-8649861.73269446, 4904318.676797509],
              [-8655326.4064975, 4921104.856259197],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lake',
        GEOID: '17097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9818211.440813594, 5197233.073294706],
              [-9818184.167538349, 5197239.238355988],
              [-9818228.472695684, 5210369.2332973415],
              [-9818223.35199911, 5223434.070834394],
              [-9818310.406573858, 5235532.806211232],
              [-9784760.464884687, 5235095.412814201],
              [-9773904.391046528, 5234953.885610017],
              [-9774226.438333392, 5224196.162984683],
              [-9776173.193588385, 5215297.807866051],
              [-9777721.75902481, 5206253.535372445],
              [-9777566.888184074, 5205689.394758215],
              [-9773923.216179227, 5192426.439189487],
              [-9773858.638735812, 5192191.544602096],
              [-9769323.545602966, 5183829.923722001],
              [-9790120.523909364, 5183951.703532173],
              [-9796612.342653956, 5184022.577962771],
              [-9798759.027714413, 5184036.092215046],
              [-9818332.779058559, 5184114.92573633],
              [-9818211.440813594, 5197233.073294706],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '18161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9466005.58882243, 4824578.724530712],
              [-9464664.522916844, 4826665.002868604],
              [-9441465.556390135, 4826294.102870826],
              [-9441465.652355017, 4826285.344457439],
              [-9441641.196875228, 4803322.183889161],
              [-9441691.763938189, 4796717.219846312],
              [-9462964.006375486, 4797047.251116634],
              [-9466173.90389251, 4797329.827319528],
              [-9466005.58882243, 4824578.724530712],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '29221',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10140734.173223713, 4608296.147179084],
              [-10105603.96831917, 4608300.2553659],
              [-10094983.087022075, 4591620.049037917],
              [-10089996.4191125, 4590245.128817882],
              [-10090570.27108754, 4542031.220813036],
              [-10141207.503698565, 4542763.052412777],
              [-10140734.173223713, 4608296.147179084],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Knox',
        GEOID: '29103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10280110.183198558, 4910035.987193267],
              [-10235799.014610333, 4909755.151632785],
              [-10235917.569868028, 4903390.036105024],
              [-10235520.047966404, 4897059.781218346],
              [-10236130.635373406, 4858595.723007589],
              [-10261133.215644557, 4859331.673438582],
              [-10273440.030629717, 4859040.655739759],
              [-10279765.872013535, 4859157.8459732225],
              [-10279805.501752257, 4871351.009532936],
              [-10280110.183198558, 4910035.987193267],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lycoming',
        GEOID: '42081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8638312.112885676, 5092658.564243667],
              [-8567201.556125406, 5094033.820705854],
              [-8557654.01735854, 5100789.802113567],
              [-8550865.420851491, 5099764.983727996],
              [-8543714.924679877, 5072348.754021858],
              [-8526241.66080751, 5057334.729533351],
              [-8510107.57040939, 5053082.280185479],
              [-8526250.00976932, 5035639.889211688],
              [-8531611.156445924, 5035337.236317937],
              [-8535842.298971485, 5035108.663503877],
              [-8541841.974247279, 5037750.738307455],
              [-8558669.139795082, 5035587.992514064],
              [-8560036.254461516, 5032876.148352829],
              [-8567173.503613725, 5034314.61446103],
              [-8569144.971795673, 5025313.041011426],
              [-8587643.154219773, 5022500.856807901],
              [-8610536.452779373, 5044833.835007653],
              [-8630214.621805882, 5065369.162683277],
              [-8638089.919182053, 5077616.612339526],
              [-8638184.206790755, 5083189.863698646],
              [-8638312.112885676, 5092658.564243667],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jenkins',
        GEOID: '13165',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9144337.010865169, 3870474.7590052285],
              [-9137252.638471084, 3884262.5722426022],
              [-9112389.207563426, 3889184.168890941],
              [-9102322.363372007, 3883285.9525443558],
              [-9113577.877086116, 3851996.9790996816],
              [-9110499.002609756, 3848819.018679005],
              [-9128335.835939052, 3843243.322091686],
              [-9137423.402569963, 3850700.6478109467],
              [-9144337.010865169, 3870474.7590052285],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Forsyth',
        GEOID: '13117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9379640.365641303, 4053792.4634937267],
              [-9379634.3543888, 4060682.5612871214],
              [-9379566.004221454, 4073894.562669318],
              [-9346059.06013166, 4073740.206530286],
              [-9342552.273532689, 4067171.4403590444],
              [-9349619.28008621, 4055114.429408499],
              [-9357252.791528378, 4053438.2786827656],
              [-9357832.654755918, 4051365.6040090113],
              [-9363972.258631641, 4037660.269317464],
              [-9361712.361649048, 4035612.9056114885],
              [-9379661.627664044, 4043519.938207664],
              [-9379640.365641303, 4053792.4634937267],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Seneca',
        GEOID: '39147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9286389.252718177, 5036972.886818658],
              [-9286254.444814827, 5049879.548083441],
              [-9221716.302110482, 5050077.0779498285],
              [-9221543.868219243, 5044401.8482457595],
              [-9220539.098495342, 5011843.717370318],
              [-9223174.253481401, 5011406.707751588],
              [-9252067.561275266, 5011375.145886934],
              [-9286307.432892444, 5011145.366801442],
              [-9286389.252718177, 5036972.886818658],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Polk',
        GEOID: '12105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9140021.042887624, 3281697.512950341],
              [-9134411.987705022, 3288467.501085111],
              [-9123526.054700349, 3287978.290233197],
              [-9123482.86273792, 3292563.2065645666],
              [-9112349.02122725, 3294674.14714406],
              [-9090045.493329873, 3292805.806183544],
              [-9090034.917978248, 3282363.944151245],
              [-9078934.806273285, 3281712.931619385],
              [-9075235.436955245, 3266990.1923062047],
              [-9067664.26442792, 3267035.3880266496],
              [-9067613.50274012, 3259680.6983291255],
              [-9055442.942811692, 3259655.0844913595],
              [-9059095.44662411, 3250448.8459768244],
              [-9068037.852639023, 3255486.4781486816],
              [-9063630.491359537, 3249199.973889494],
              [-9051242.63578508, 3239128.21027662],
              [-9050481.878384998, 3231596.460623603],
              [-9040047.011957018, 3226440.4052342325],
              [-9033126.2792144, 3212527.399292514],
              [-9032704.378344294, 3204068.2689531012],
              [-9075866.952426516, 3204468.3874105536],
              [-9079610.960860364, 3204496.411218839],
              [-9134248.348053558, 3204463.3607245283],
              [-9134306.790786222, 3237345.1224940387],
              [-9134349.760109669, 3239795.951934789],
              [-9134461.190919952, 3270624.8904825593],
              [-9139981.747107372, 3270632.2146533243],
              [-9140021.042887624, 3281697.512950341],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Starr',
        GEOID: '48427',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11040312.665902004, 3069808.636283964],
              [-11021866.570715778, 3082928.506749814],
              [-11015534.495440476, 3096722.4653761927],
              [-10956355.4956619, 3096453.240626626],
              [-10945006.918853488, 3096396.628014584],
              [-10964072.942000125, 3054346.317331264],
              [-10975355.975927189, 3029200.8955300483],
              [-10977600.709160306, 3030329.3232536917],
              [-10982137.646327075, 3028335.072503314],
              [-10987106.391798634, 3032016.3609572053],
              [-10996129.504444374, 3039581.102947857],
              [-10999183.665993776, 3044907.7275714874],
              [-11008491.867855437, 3043435.2206937284],
              [-11015990.348755274, 3047968.8931532144],
              [-11024226.989198558, 3050209.232738353],
              [-11029758.009418111, 3048273.864997756],
              [-11032969.910685971, 3051973.8118162765],
              [-11030830.350072924, 3058277.530545627],
              [-11032321.585971592, 3061182.7090747887],
              [-11039710.194534013, 3067342.899911211],
              [-11040312.665902004, 3069808.636283964],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Effingham',
        GEOID: '13103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9077882.503126819, 3827709.7771611633],
              [-9075674.258387951, 3831089.0713180583],
              [-9059948.477050025, 3842193.4365156675],
              [-9053475.37081192, 3837208.0928797536],
              [-9048520.02617721, 3835343.654901367],
              [-9047483.48790048, 3834953.69664049],
              [-9038567.019326922, 3824516.4216337763],
              [-9038578.373914981, 3817446.983807617],
              [-9036189.76872333, 3813941.822844676],
              [-9031687.80875437, 3807338.220297832],
              [-9031131.433939386, 3799633.796653485],
              [-9033969.746996142, 3794551.3380054845],
              [-9033308.973473798, 3793167.2257594843],
              [-9038625.573379079, 3794526.0693293125],
              [-9060482.376159903, 3775903.746220116],
              [-9062160.851442084, 3776698.104463038],
              [-9065395.127927592, 3795025.39879791],
              [-9066564.427858884, 3800742.4574039984],
              [-9076423.995158443, 3815085.7250067024],
              [-9077882.503126819, 3827709.7771611633],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Terrell',
        GEOID: '48443',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11417699.19906577, 3540013.6469419906],
              [-11392780.108412715, 3540122.834362881],
              [-11392769.087783126, 3580749.263357094],
              [-11369995.346356638, 3580589.156287178],
              [-11369925.437716419, 3588151.9883700036],
              [-11358415.78160483, 3588059.5938864956],
              [-11358373.146239856, 3588080.9454922224],
              [-11358287.318912456, 3588089.0979331136],
              [-11358202.27082149, 3588074.7341122525],
              [-11358129.46787451, 3588090.0037602074],
              [-11354633.479266146, 3588016.2437687987],
              [-11354322.45260887, 3587906.6398129268],
              [-11328912.554320907, 3587813.8589384602],
              [-11328803.906497894, 3587758.087223721],
              [-11328808.693235999, 3587776.0738980635],
              [-11315898.52661074, 3583557.5481413123],
              [-11315208.234448329, 3575836.2787233274],
              [-11325692.749369204, 3557767.773549154],
              [-11316575.794392725, 3549632.977183629],
              [-11327693.271938251, 3540629.2081840746],
              [-11328051.632703664, 3475155.924491922],
              [-11333375.130067829, 3476605.4130603527],
              [-11340717.652361063, 3477100.802564417],
              [-11350821.788581895, 3478809.5428008595],
              [-11357028.072832601, 3478187.0834520794],
              [-11362786.296132866, 3476190.465306315],
              [-11367465.722247852, 3476891.3307701885],
              [-11372585.528268417, 3480367.6196166202],
              [-11379919.145002387, 3483453.4115445013],
              [-11388137.640368674, 3487835.647811706],
              [-11390063.796462629, 3487131.9945938424],
              [-11392460.621474138, 3489757.938201777],
              [-11417711.66684874, 3510339.6271601347],
              [-11417699.19906577, 3540013.6469419906],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '13119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9283866.975695783, 4090856.5198433097],
              [-9259314.5714454, 4093035.021478551],
              [-9250969.597771958, 4101196.1856809454],
              [-9250299.919080961, 4100397.9749555984],
              [-9245147.492453491, 4095470.9284570566],
              [-9249992.120688917, 4084808.233677815],
              [-9252136.913318032, 4065589.8241398684],
              [-9258747.621278789, 4060874.8467692505],
              [-9274426.52627906, 4063652.0391193717],
              [-9279064.096265506, 4058891.823704641],
              [-9277137.267199367, 4063843.701540165],
              [-9283368.153057538, 4072498.6935968096],
              [-9283866.975695783, 4090856.5198433097],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Collier',
        GEOID: '12021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9111109.061022284, 3040056.8087376407],
              [-9108051.532285176, 3038302.25654416],
              [-9099941.684741903, 3038383.104785715],
              [-9090115.847248053, 3038465.9405520535],
              [-9090294.626350267, 3051327.296339468],
              [-9079460.345589321, 3051519.7189706177],
              [-9079636.564343248, 3062798.4865875226],
              [-9047131.829629065, 3063264.3829280743],
              [-9046773.603507692, 3030455.555648398],
              [-9003499.153337223, 3031251.2051255326],
              [-9002733.60919904, 2996533.9792038496],
              [-9002751.865595527, 2974995.951082912],
              [-9066066.91565133, 2974717.991721159],
              [-9069448.159267884, 2976424.55079981],
              [-9085310.741427962, 2985955.4556472325],
              [-9088149.606413078, 2983921.337123022],
              [-9091755.91730591, 2981337.732409048],
              [-9097817.597538076, 2987592.6648310972],
              [-9101199.149709905, 2999127.265045648],
              [-9106917.631951954, 3017949.5140959574],
              [-9110894.186802072, 3039726.4194837427],
              [-9111109.061022284, 3040056.8087376407],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Glynn',
        GEOID: '13127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9103971.005030656, 3654605.6696022097],
              [-9098330.557751652, 3675686.747573472],
              [-9093901.934449423, 3684874.782321865],
              [-9086374.399162492, 3691718.26920249],
              [-9070500.907692315, 3676473.9193333187],
              [-9046309.17281333, 3671067.8313571704],
              [-9048364.58167011, 3664520.8627865957],
              [-9050826.412209004, 3659553.677934477],
              [-9057871.154864363, 3650493.4055378046],
              [-9061639.876225172, 3649043.240529793],
              [-9061547.592367303, 3642204.7531921105],
              [-9063685.70582697, 3634918.5359244007],
              [-9062800.05191891, 3631558.8863900444],
              [-9080630.536076538, 3645387.8278947584],
              [-9079507.7676924, 3649680.71472367],
              [-9087190.816307971, 3646798.168315958],
              [-9102185.329078842, 3654793.924304665],
              [-9103971.005030656, 3654605.6696022097],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tuscarawas',
        GEOID: '39157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9095818.967400374, 4930787.846736765],
              [-9091424.296542836, 4930654.884144265],
              [-9089147.25635866, 4958667.955720073],
              [-9067976.515599597, 4963335.884592957],
              [-9052249.297940323, 4961084.689014297],
              [-9052685.670344234, 4948630.949544575],
              [-9046349.921525732, 4948395.608323956],
              [-9046760.69044676, 4935460.8175351685],
              [-9046929.562114293, 4929136.692908044],
              [-9047527.125140872, 4910134.9529817],
              [-9054126.367194079, 4910263.697573557],
              [-9054511.08735426, 4897125.963164461],
              [-9086195.508740786, 4898154.464269166],
              [-9085454.90016854, 4919581.270604463],
              [-9096170.29171332, 4919973.724428436],
              [-9095818.967400374, 4930787.846736765],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hall',
        GEOID: '13139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9357252.791528378, 4053438.2786827656],
              [-9349619.28008621, 4055114.429408499],
              [-9342552.273532689, 4067171.4403590444],
              [-9346059.06013166, 4073740.206530286],
              [-9348770.357649421, 4076951.5179416104],
              [-9348683.083168639, 4085120.7592311455],
              [-9343254.810839087, 4091999.053224464],
              [-9333405.150974207, 4096881.1712583206],
              [-9327304.731559245, 4098043.2297038157],
              [-9313702.714298705, 4096625.5939317965],
              [-9308007.16387176, 4086923.6177178267],
              [-9314065.059241237, 4078094.127846162],
              [-9308548.621874977, 4068519.626006916],
              [-9330541.679712532, 4045934.0952065154],
              [-9338602.880638327, 4043068.197898406],
              [-9357832.654755918, 4051365.6040090113],
              [-9357252.791528378, 4053438.2786827656],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Van Wert',
        GEOID: '39161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9440211.15092909, 5010774.465260896],
              [-9395307.804734021, 5010913.2334958725],
              [-9395187.691003455, 4998083.726970154],
              [-9388744.964154303, 4991580.960174767],
              [-9395072.697969466, 4985230.793102911],
              [-9395006.351552954, 4965978.8129237285],
              [-9401618.951945053, 4965969.4177122945],
              [-9401618.061389128, 4972349.081713352],
              [-9440128.708862178, 4972325.569123957],
              [-9440128.705270588, 4972328.07562176],
              [-9440190.065258907, 5000927.266750002],
              [-9440211.15092909, 5010774.465260896],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hart',
        GEOID: '13147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9249992.120688917, 4084808.233677815],
              [-9245147.492453491, 4095470.9284570566],
              [-9244893.242732624, 4095227.8560745134],
              [-9238971.15714191, 4092422.7732542935],
              [-9238559.06943917, 4092489.968671786],
              [-9231254.044762157, 4093681.199546408],
              [-9225472.66700781, 4092291.1185752703],
              [-9221928.922337895, 4082607.9802723587],
              [-9219860.94015743, 4077092.163439019],
              [-9215061.73427035, 4068711.6403228594],
              [-9214429.520938538, 4067588.6814416684],
              [-9237293.349776674, 4057043.7558977734],
              [-9248201.101401543, 4058866.513049929],
              [-9252136.913318032, 4065589.8241398684],
              [-9249992.120688917, 4084808.233677815],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '48313',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10713501.339825256, 3629338.862388094],
              [-10683912.396533422, 3644698.577412706],
              [-10660445.357318277, 3644990.288689326],
              [-10648431.423913393, 3643057.1149586337],
              [-10651177.787070753, 3631055.5072237933],
              [-10644132.821776409, 3623715.889330787],
              [-10643950.369131, 3621091.8681280543],
              [-10655112.931070296, 3621248.7332453104],
              [-10671426.91376554, 3615115.7317581386],
              [-10705413.978819126, 3609783.2063816916],
              [-10709767.350145578, 3625878.5091983536],
              [-10713501.339825256, 3629338.862388094],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tulsa',
        GEOID: '40143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10719831.85662769, 4322973.748211371],
              [-10716536.688380718, 4322932.521349529],
              [-10686788.558217049, 4322837.934561739],
              [-10686801.471277982, 4359077.617005102],
              [-10665818.749138867, 4359060.18548559],
              [-10663781.602457348, 4358300.696742617],
              [-10665766.428978194, 4349027.918804223],
              [-10665750.176332537, 4335012.792540954],
              [-10666121.538153825, 4323022.145162873],
              [-10660138.115523685, 4323038.691178903],
              [-10660142.234344846, 4286981.68780805],
              [-10666629.600309806, 4280811.50686021],
              [-10690357.795050355, 4280938.417078742],
              [-10689962.83349702, 4287022.228498589],
              [-10689959.93919026, 4299023.558785994],
              [-10689964.2806504, 4310996.578905178],
              [-10719820.502039628, 4311053.461628534],
              [-10719831.85662769, 4322973.748211371],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Glascock',
        GEOID: '13125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9212338.636886565, 3928992.4037652137],
              [-9190509.66397844, 3938824.58622944],
              [-9176283.478333022, 3931840.124233951],
              [-9193313.690632032, 3918083.656600412],
              [-9192631.747431433, 3911221.5435260097],
              [-9201882.508435845, 3912084.3208525567],
              [-9210517.116058715, 3918471.3356411606],
              [-9211499.84452344, 3926983.5760154417],
              [-9212338.636886565, 3928992.4037652137],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McIntosh',
        GEOID: '38051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11118416.080151107, 5825786.287772466],
              [-11024789.263946556, 5825841.053774642],
              [-11020976.682706377, 5825800.301393607],
              [-11021270.159862906, 5770730.471142601],
              [-11030967.607005073, 5770768.840230654],
              [-11059030.36007813, 5770787.249188868],
              [-11075204.414173448, 5770797.3341125995],
              [-11088663.608527299, 5770915.152483208],
              [-11100565.109246481, 5770884.57718513],
              [-11118597.652794415, 5771006.865530876],
              [-11118416.080151107, 5825786.287772466],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'New Castle',
        GEOID: '10003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8435099.272998482, 4825654.879972615],
              [-8432810.766906753, 4830835.972547968],
              [-8428784.452244252, 4835809.248817214],
              [-8422749.488689877, 4840026.079028866],
              [-8415120.864754453, 4841935.103788403],
              [-8414925.581324793, 4841983.977288759],
              [-8413487.901000522, 4842343.792312707],
              [-8412462.120587198, 4842600.527155592],
              [-8402529.527701676, 4841151.738366237],
              [-8395166.299983155, 4837199.30141073],
              [-8400106.32502609, 4831968.993888253],
              [-8402132.451078016, 4824614.758519942],
              [-8405706.029371463, 4820433.368513577],
              [-8408533.767076595, 4814807.748432613],
              [-8411239.05334185, 4812292.493466451],
              [-8409515.716304881, 4807406.612005711],
              [-8406038.874648934, 4804806.559525666],
              [-8407702.43311935, 4798638.181056337],
              [-8407748.296749555, 4793275.376390223],
              [-8414981.837261302, 4790545.14797115],
              [-8412617.633915834, 4784736.220854812],
              [-8407035.184091533, 4777384.0373403095],
              [-8405249.714928852, 4774867.097051192],
              [-8414010.35206515, 4765989.747601618],
              [-8417938.816895245, 4766182.536921111],
              [-8421448.497800974, 4763526.397673462],
              [-8428544.22478312, 4764644.3535708655],
              [-8433613.760752903, 4764273.743064022],
              [-8434332.170387425, 4775890.224576875],
              [-8434333.239801401, 4775912.200040437],
              [-8436747.91465713, 4825654.735242456],
              [-8435099.272998482, 4825654.879972615],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ringgold',
        GEOID: '19159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10516439.013123881, 4997529.513722157],
              [-10465679.996989928, 4997165.602905701],
              [-10465756.696119083, 4949719.176743231],
              [-10474171.67038662, 4949546.723889514],
              [-10489885.05216957, 4949417.407106114],
              [-10498621.772024965, 4949345.507057257],
              [-10516486.738808924, 4949262.773163233],
              [-10516439.013123881, 4997529.513722157],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Baltimore',
        GEOID: '24510',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8539450.72026555, 4773773.313829705],
              [-8537363.813771648, 4775103.080890575],
              [-8529988.786187103, 4775100.776864865],
              [-8519257.587274631, 4775106.680931808],
              [-8519226.863095172, 4764312.060871377],
              [-8519223.412190957, 4753005.106338415],
              [-8524878.553642748, 4751309.610345432],
              [-8531994.652091706, 4757390.781720928],
              [-8533736.57948364, 4758337.410054719],
              [-8536496.078340916, 4759911.583143565],
              [-8539435.469495311, 4761555.317352041],
              [-8539450.163668096, 4772561.773382329],
              [-8539450.72026555, 4773773.313829705],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Atascosa',
        GEOID: '48013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10998895.905110076, 3407592.494538402],
              [-10958462.996261599, 3391708.9909701203],
              [-10954654.533842579, 3390219.12437198],
              [-10930571.118606908, 3360678.169788836],
              [-10920254.47347815, 3348557.261783364],
              [-10946605.57806077, 3326437.845763506],
              [-10946607.359172622, 3330955.036737275],
              [-10998460.089303622, 3330832.1212542434],
              [-10998459.310067184, 3330855.080613223],
              [-10998911.155880317, 3387161.299631976],
              [-10998895.905110076, 3407592.494538402],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tuscola',
        GEOID: '26157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9317376.490362024, 5404000.157221017],
              [-9315588.02119478, 5402301.179952441],
              [-9298477.043458644, 5422096.988136457],
              [-9296551.163754731, 5424327.710739048],
              [-9295854.921848603, 5426089.000721777],
              [-9291458.519689921, 5414149.020327405],
              [-9252636.069914749, 5415360.543740945],
              [-9251110.102334954, 5363592.752168815],
              [-9252920.157255253, 5361885.270541101],
              [-9278971.367129676, 5361151.99297906],
              [-9278669.802629117, 5347839.412707888],
              [-9290803.515806094, 5347472.403065839],
              [-9290806.298793362, 5345996.5652852915],
              [-9316953.911346816, 5345735.491623195],
              [-9317275.402036225, 5371938.78147376],
              [-9317309.577119898, 5385160.47390447],
              [-9317383.938539749, 5398496.304168456],
              [-9317376.490362024, 5404000.157221017],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bowman',
        GEOID: '38011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11582288.289896745, 5825363.803363236],
              [-11465401.49330203, 5825448.35684271],
              [-11465425.317803495, 5771558.449763712],
              [-11490219.283218466, 5771573.107193159],
              [-11514314.943598123, 5771586.394858884],
              [-11539465.133514067, 5771578.390238593],
              [-11582285.734120572, 5771589.436616487],
              [-11582288.289896745, 5825363.803363236],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McKenzie',
        GEOID: '38053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11582271.262586767, 5996426.904214481],
              [-11582233.82766821, 6007128.426606228],
              [-11582115.303980166, 6041098.295619737],
              [-11581945.207798233, 6074185.834055537],
              [-11582117.641689472, 6102117.253456951],
              [-11582135.47678043, 6106205.764815743],
              [-11568297.994824432, 6099529.610636876],
              [-11561231.099590402, 6109362.645026893],
              [-11555054.092365773, 6105901.453641434],
              [-11553225.892368477, 6116757.730244256],
              [-11544883.609728428, 6117752.296936243],
              [-11548530.6588858, 6122407.856588501],
              [-11532370.185768357, 6129245.070456788],
              [-11526974.307410626, 6121461.410700368],
              [-11531004.295616323, 6115863.86796355],
              [-11519905.519745253, 6107973.708193738],
              [-11492052.60391234, 6117162.805281925],
              [-11494015.389174007, 6122336.35702655],
              [-11488381.843703432, 6129378.177415024],
              [-11477827.976739794, 6131260.911677712],
              [-11446813.698687844, 6127452.8315946385],
              [-11428447.095901862, 6119616.316703099],
              [-11416032.412330123, 6106380.543175541],
              [-11426362.861075738, 6091349.542203909],
              [-11426084.784987736, 6077576.907947662],
              [-11426140.444733134, 6052775.686664052],
              [-11477024.695294231, 6052859.174715499],
              [-11476950.111235399, 5995894.590579741],
              [-11540126.816567343, 5995999.703920545],
              [-11582270.740483774, 5996126.803878607],
              [-11582271.262586767, 5996426.904214481],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stillwater',
        GEOID: '30095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12252333.111295015, 5676593.945263582],
              [-12237572.480774298, 5676593.945263582],
              [-12237577.04487342, 5704149.940468657],
              [-12223864.26471954, 5704152.1648578625],
              [-12223858.921383983, 5711059.179395852],
              [-12210121.205664167, 5711009.0920713395],
              [-12210121.205664167, 5717914.570323829],
              [-12196393.842656996, 5717930.005942666],
              [-12196598.336561583, 5745717.933117328],
              [-12194919.082042966, 5759660.794124794],
              [-12190148.039987056, 5759575.899507283],
              [-12190219.395780655, 5773799.308887242],
              [-12180915.535379134, 5773943.269088273],
              [-12180262.31260716, 5787524.784831025],
              [-12180158.67416123, 5801587.199665834],
              [-12125429.782346606, 5801587.039030403],
              [-12122876.781144755, 5773847.989272264],
              [-12123218.64330098, 5729665.937421905],
              [-12116349.117524128, 5718236.018618195],
              [-12130797.71951215, 5719113.217617811],
              [-12141449.658947177, 5713812.983392762],
              [-12148046.340652095, 5714501.089889909],
              [-12148098.438173786, 5704240.346447301],
              [-12155147.856247762, 5704251.468511351],
              [-12155171.233340828, 5694946.978844814],
              [-12173500.655416885, 5694918.7264605425],
              [-12191809.038109183, 5683422.964738564],
              [-12201599.253365979, 5669639.388268754],
              [-12201562.85189249, 5662774.987114572],
              [-12210396.387445407, 5662774.196350402],
              [-12210389.151678506, 5647904.170088413],
              [-12222732.368137155, 5647904.170088413],
              [-12224241.86043231, 5648660.501439633],
              [-12252326.098167093, 5648660.501439633],
              [-12252333.111295015, 5676593.945263582],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Le Sueur',
        GEOID: '27079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10466833.155595055, 5505225.285357316],
              [-10456538.663044965, 5518969.980682493],
              [-10456189.676441329, 5536394.224357015],
              [-10451271.915296555, 5545989.59006308],
              [-10454058.46479009, 5549886.299577073],
              [-10411080.458423607, 5549957.365925748],
              [-10411181.091243284, 5495844.709970599],
              [-10438202.784438442, 5495798.440676279],
              [-10438209.46360789, 5502562.451504516],
              [-10465353.27428445, 5502583.5832863385],
              [-10466833.155595055, 5505225.285357316],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Benton',
        GEOID: '53005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13344317.31477149, 5881610.060351923],
              [-13315868.171745889, 5884739.169595092],
              [-13303946.856157344, 5897738.380474332],
              [-13297468.28443216, 5889874.624677818],
              [-13291885.834607856, 5879139.987220351],
              [-13277111.289150793, 5864286.883030909],
              [-13276451.387209369, 5824140.88898605],
              [-13251638.940628493, 5811278.181350669],
              [-13244199.013780816, 5802736.138886888],
              [-13240487.510638278, 5784761.699472381],
              [-13245597.580607753, 5780317.204391287],
              [-13253861.32294269, 5773705.631924139],
              [-13261059.018578403, 5769596.348292304],
              [-13275645.211457044, 5770727.540272015],
              [-13287583.78156666, 5767795.254179413],
              [-13295124.848719092, 5766451.816405575],
              [-13301324.280273749, 5765347.542629541],
              [-13310647.844225137, 5768411.528447272],
              [-13313872.213275963, 5767471.371271772],
              [-13321589.770933682, 5757441.649924815],
              [-13336370.550282229, 5755949.37044799],
              [-13343661.853296764, 5754462.710604457],
              [-13343403.047793603, 5786899.162630407],
              [-13344317.31477149, 5881610.060351923],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ralls',
        GEOID: '29173',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10209997.49435376, 4770364.959772842],
              [-10209325.792546313, 4807853.744651247],
              [-10209694.59401931, 4816316.048483365],
              [-10209722.42389201, 4820488.192714926],
              [-10164110.746981, 4820448.191281212],
              [-10160813.42637555, 4817489.504887363],
              [-10150431.269817708, 4807729.226791167],
              [-10181329.831167731, 4786440.818149428],
              [-10178857.759235684, 4767428.275119686],
              [-10210053.042779664, 4768261.299271087],
              [-10209997.49435376, 4770364.959772842],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Laramie',
        GEOID: '56021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11719519.623134082, 5109685.978850002],
              [-11649956.295976348, 5109142.464465732],
              [-11649917.779432533, 5096041.727059859],
              [-11583086.296212759, 5095931.893481068],
              [-11583047.60471556, 5070528.594526325],
              [-11583047.619645841, 5070514.794413083],
              [-11583066.08375103, 5053463.402768237],
              [-11583142.782880187, 5029238.731860896],
              [-11583154.694065703, 5012549.050738533],
              [-11632559.285955174, 5012607.9045810625],
              [-11672435.597349687, 5012053.748556443],
              [-11682242.621849593, 5012057.598737369],
              [-11719366.446850732, 5012072.173349555],
              [-11719519.623134082, 5109685.978850002],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Malheur',
        GEOID: '41045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13161549.85784135, 5505164.669480719],
              [-13152671.23789466, 5511909.486531287],
              [-13132559.256812532, 5534387.736893753],
              [-13090153.432628721, 5534500.626139525],
              [-13078564.517039688, 5525566.275814701],
              [-13078594.573302202, 5512035.1633909885],
              [-13047979.654697478, 5511433.8737486405],
              [-13048533.858008388, 5510175.073636289],
              [-13043342.807513718, 5505593.8074538605],
              [-13037854.200020153, 5508500.072809833],
              [-13030987.45723057, 5502229.943133385],
              [-13021258.801652184, 5501986.47387866],
              [-13020539.677741656, 5495532.940188805],
              [-13013554.824972343, 5493257.249403069],
              [-13012795.514725642, 5489350.82022187],
              [-13013009.657482535, 5489098.13534861],
              [-13021859.147666031, 5478661.9761722125],
              [-13017405.366158882, 5469989.312948892],
              [-13019913.282966964, 5462800.167862904],
              [-13021711.426701749, 5449292.198522886],
              [-13022771.303858278, 5447073.638456554],
              [-13027005.00244744, 5438216.890629148],
              [-13027237.305123674, 5416099.453420004],
              [-13027373.692600949, 5403138.705529293],
              [-13027347.30988163, 5315797.367205538],
              [-13027302.893404802, 5282709.091089663],
              [-13027336.06661306, 5217855.207191273],
              [-13027296.659513319, 5160962.966597495],
              [-13046399.195452936, 5161036.3663768405],
              [-13069310.416450555, 5160873.090086427],
              [-13093813.840124987, 5160749.810850463],
              [-13121614.324477738, 5160730.038387469],
              [-13157650.892676316, 5160529.320251213],
              [-13157670.954221655, 5160529.182620462],
              [-13157439.942241263, 5201783.978538851],
              [-13159599.985640615, 5202396.587825647],
              [-13161169.033863347, 5298985.91659626],
              [-13161537.1674194, 5430045.665487859],
              [-13161041.239087915, 5471612.993293483],
              [-13161174.599837886, 5498393.919657721],
              [-13161549.85784135, 5505164.669480719],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cameron',
        GEOID: '22023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10456151.605175478, 3478246.2234894754],
              [-10449832.88823907, 3484495.051645579],
              [-10447591.344603593, 3487118.9077144708],
              [-10445149.454622416, 3489977.8927179254],
              [-10442638.198229609, 3497708.878091891],
              [-10435209.06937254, 3506322.8958822116],
              [-10431341.581181701, 3510258.8919221424],
              [-10367014.415354107, 3510311.2045659083],
              [-10352308.665342351, 3508496.919697668],
              [-10325728.799206153, 3508604.9362298287],
              [-10323614.174159043, 3508348.269872057],
              [-10309922.544708416, 3508456.9280948252],
              [-10310103.376258163, 3450835.8271148866],
              [-10317589.785956291, 3452876.7835559845],
              [-10339353.414323322, 3462519.306329361],
              [-10351947.656233711, 3468101.9822591846],
              [-10362529.019111572, 3471342.790885182],
              [-10372408.401280496, 3474082.0708936625],
              [-10385615.67962668, 3474669.9599308646],
              [-10398474.639286177, 3473680.6699709035],
              [-10412653.959425969, 3473160.2781155277],
              [-10435305.91732953, 3469704.015757822],
              [-10441684.746790966, 3467001.4289482487],
              [-10445995.148793971, 3463843.4685960077],
              [-10448804.07350516, 3468129.2857918125],
              [-10451878.383882396, 3472951.7682202994],
              [-10456151.605175478, 3478246.2234894754],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calvert',
        GEOID: '24009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8536686.323350681, 4685706.547365088],
              [-8531831.791676676, 4688676.732696518],
              [-8528843.19730735, 4681757.681555279],
              [-8518956.97426564, 4680608.643736819],
              [-8519160.73931764, 4673640.274223106],
              [-8517196.506902594, 4666778.85186913],
              [-8517889.804691255, 4655871.970125369],
              [-8515128.302083146, 4647862.54022414],
              [-8510479.377508637, 4642115.116123058],
              [-8504071.938938068, 4634592.899686206],
              [-8503362.16586477, 4630587.183337076],
              [-8504830.76212838, 4624712.062224935],
              [-8510759.457347473, 4622610.2208322445],
              [-8516105.241934348, 4632181.614969685],
              [-8528005.072861167, 4639560.396803232],
              [-8535323.77278337, 4650248.069528966],
              [-8535472.829581544, 4655406.170459606],
              [-8538423.130046038, 4680339.539959221],
              [-8536686.323350681, 4685706.547365088],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Quitman',
        GEOID: '28119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10068911.617000327, 4064090.8606078164],
              [-10063172.206694007, 4063972.600719052],
              [-10063226.085327553, 4085851.908521782],
              [-10052356.07101006, 4085951.6389058335],
              [-10052630.584874358, 4097438.6795634134],
              [-10040855.097818753, 4097636.860356488],
              [-10040359.726084724, 4069345.7823218065],
              [-10033720.07505636, 4064467.0645685294],
              [-10033833.064339513, 4050316.3591389284],
              [-10033859.669697816, 4038594.9204400345],
              [-10068957.146672063, 4038599.220953229],
              [-10068911.617000327, 4064090.8606078164],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'DeKalb',
        GEOID: '29063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10531422.393945675, 4871642.824679278],
              [-10488388.839153284, 4871012.968344394],
              [-10486696.226295771, 4869582.854492013],
              [-10486946.583830565, 4835320.87841046],
              [-10486959.608210988, 4829077.032390694],
              [-10531075.0771344, 4829273.066173739],
              [-10531138.863202624, 4839805.919228715],
              [-10531422.393945675, 4871642.824679278],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harrison',
        GEOID: '29081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10489885.05216957, 4949417.407106114],
              [-10474171.67038662, 4949546.723889514],
              [-10465756.696119083, 4949719.176743231],
              [-10446324.54316723, 4950117.42249446],
              [-10438912.246265817, 4950225.799390103],
              [-10437852.350681426, 4934846.338170391],
              [-10437685.482764727, 4904378.780336878],
              [-10437763.07244981, 4885275.091890915],
              [-10488154.622944655, 4885816.305879038],
              [-10487885.452415917, 4921939.151081209],
              [-10489809.83245326, 4934530.552578242],
              [-10489885.05216957, 4949417.407106114],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ritchie',
        GEOID: '54085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9045746.569885634, 4760008.350548835],
              [-9043537.21195186, 4760180.463668368],
              [-9041484.369222142, 4765911.625816492],
              [-9017751.053785015, 4772063.665991434],
              [-9006240.841075972, 4775979.800998577],
              [-9004493.792987462, 4763915.337886819],
              [-9007287.466928411, 4760844.64369293],
              [-8996058.669892093, 4737354.464296241],
              [-9017683.705493085, 4722930.026584288],
              [-9020622.651369518, 4723044.491338523],
              [-9032027.889798744, 4728143.71103348],
              [-9034963.16213198, 4726056.854755363],
              [-9044736.679465158, 4726696.8681063475],
              [-9050053.8549429, 4748288.13561708],
              [-9045746.569885634, 4760008.350548835],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Radford',
        GEOID: '51750',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8971812.950838843, 4456561.978959974],
              [-8971557.806565946, 4456944.676626056],
              [-8969355.016482132, 4458621.672964255],
              [-8967190.408983655, 4459578.839158499],
              [-8966655.518830393, 4459554.678512893],
              [-8964532.09954351, 4457779.092156668],
              [-8964637.519101294, 4457575.089904537],
              [-8964164.967862874, 4458123.293797817],
              [-8963975.279450564, 4459738.468396617],
              [-8962475.471951105, 4459725.759418752],
              [-8962169.677309897, 4458039.651069434],
              [-8964895.891639424, 4455579.538412524],
              [-8964541.227741756, 4454627.061745441],
              [-8967338.5752259, 4455545.335434309],
              [-8967506.222379036, 4453053.28315737],
              [-8970176.776963165, 4451611.893539982],
              [-8971282.95874318, 4453333.824310753],
              [-8971951.209646411, 4455691.361983173],
              [-8971812.950838843, 4456561.978959974],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Daniels',
        GEOID: '30019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11812340.856216105, 6274739.130663492],
              [-11805492.445110163, 6274726.839569312],
              [-11774909.084807072, 6274799.800725914],
              [-11728163.804233162, 6274752.291064028],
              [-11718067.571696175, 6274776.554893693],
              [-11694963.17984422, 6274730.553343566],
              [-11692795.709576797, 6259690.77112135],
              [-11692837.677024825, 6215697.7242346825],
              [-11685572.410458202, 6215691.15279615],
              [-11685580.314142046, 6201066.288917147],
              [-11778095.939189501, 6201094.548036498],
              [-11802238.242435802, 6201105.649859065],
              [-11802231.674585847, 6245046.242614699],
              [-11816776.345294423, 6245038.126667753],
              [-11812340.856216105, 6274739.130663492],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McCone',
        GEOID: '30055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11844461.168696238, 6117162.472153143],
              [-11825391.805964878, 6111250.641718564],
              [-11800553.533262137, 6112461.315197493],
              [-11782488.049698751, 6108566.728598158],
              [-11760674.99547781, 6119725.115074115],
              [-11744561.944463447, 6123139.386379409],
              [-11710229.67766891, 6117944.694197284],
              [-11710267.41497629, 6084936.206505603],
              [-11714681.121466752, 6072072.331009298],
              [-11728984.674158271, 6072058.578532792],
              [-11729011.947433515, 6028943.87179113],
              [-11733776.644278448, 5971763.569075953],
              [-11781280.567182118, 5971683.152042859],
              [-11781235.260149363, 5957285.095456546],
              [-11795401.778547715, 5957262.0404908005],
              [-11795393.095627433, 5971668.08416827],
              [-11809525.995539567, 5971657.929745772],
              [-11818837.091707988, 5971639.586302933],
              [-11818865.478178142, 6000129.859793168],
              [-11833056.82082294, 6000097.4890455725],
              [-11833047.358666223, 6028858.636215722],
              [-11828912.841458669, 6084994.285870675],
              [-11839727.863947708, 6084991.132980787],
              [-11839750.461804338, 6099740.050883818],
              [-11846466.58932288, 6099780.111578245],
              [-11844461.168696238, 6117162.472153143],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bland',
        GEOID: '51021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9065495.315469304, 4440519.5697165495],
              [-9047010.046106137, 4451995.807617205],
              [-9053407.131964063, 4458492.223383315],
              [-9041937.216910688, 4471895.955802687],
              [-9029412.883640518, 4477997.097922484],
              [-9016434.923445366, 4480942.149885436],
              [-9014746.45800619, 4481125.167699245],
              [-9018446.021366037, 4477596.008867802],
              [-9000695.905920068, 4459683.861797833],
              [-9009156.187220357, 4455160.594455453],
              [-9007157.668402145, 4449335.629330964],
              [-9029604.687123155, 4442259.077282873],
              [-9041883.783555105, 4445776.468393733],
              [-9059113.591701109, 4432479.88689394],
              [-9065495.315469304, 4440519.5697165495],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Doddridge',
        GEOID: '54017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9004493.792987462, 4763915.337886819],
              [-8984966.127912506, 4783489.921752033],
              [-8974424.728731837, 4786390.7932860665],
              [-8970468.656668026, 4786540.724458416],
              [-8966175.06390813, 4783327.065365482],
              [-8964759.859221675, 4773387.879844686],
              [-8972761.058941932, 4763446.856646925],
              [-8964420.112135775, 4749743.673986732],
              [-8971919.706230516, 4745631.105692513],
              [-8983554.374130266, 4734642.793789578],
              [-8986636.142913388, 4735386.049671703],
              [-8996058.669892093, 4737354.464296241],
              [-9007287.466928411, 4760844.64369293],
              [-9004493.792987462, 4763915.337886819],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '31061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11040600.639140869, 4917033.915423378],
              [-10990220.109275613, 4916992.577647848],
              [-10990169.566212501, 4866281.786161016],
              [-11028090.037118545, 4866253.773867553],
              [-11030158.202987514, 4866252.246091615],
              [-11040570.599672135, 4866248.751494222],
              [-11040600.639140869, 4917033.915423378],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kearney',
        GEOID: '31099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11040583.384619797, 4962399.74345183],
              [-11010176.24307063, 4961252.399251535],
              [-10989948.489718076, 4966690.232795952],
              [-10989899.620461619, 4916991.5551609],
              [-10990220.109275613, 4916992.577647848],
              [-11040600.639140869, 4917033.915423378],
              [-11040583.384619797, 4962399.74345183],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Atoka',
        GEOID: '40005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10732014.884339087, 4085121.0291187842],
              [-10702823.128990402, 4085159.62311749],
              [-10702850.513585139, 4096963.3030474004],
              [-10696898.371731913, 4096970.4625903005],
              [-10696917.296045346, 4120554.2732100543],
              [-10673546.882148208, 4120543.308274376],
              [-10673533.969087277, 4108779.5059424136],
              [-10650155.65150629, 4108823.3197946954],
              [-10650124.927326832, 4097057.4581545605],
              [-10662116.819472535, 4097024.632109575],
              [-10662111.364817487, 4049862.3307877583],
              [-10685733.583402801, 4049876.5903651384],
              [-10732049.393381232, 4049945.467066403],
              [-10732014.884339087, 4085121.0291187842],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Burleson',
        GEOID: '48051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10793941.805747895, 3575371.6645204406],
              [-10755831.800713798, 3597839.9875313295],
              [-10749787.375002705, 3593288.8498152834],
              [-10753666.63661787, 3586333.2106977366],
              [-10743499.048287284, 3584509.2639134647],
              [-10726614.441882232, 3573378.956897872],
              [-10724617.14757842, 3564694.930280667],
              [-10716929.534863727, 3557185.7126904516],
              [-10719974.902173359, 3552379.9940293175],
              [-10726457.481400214, 3551627.217595176],
              [-10758013.885372328, 3541756.246332405],
              [-10769456.304511476, 3544718.1979125906],
              [-10784310.55472395, 3561259.928997852],
              [-10789049.091488548, 3573098.8708562055],
              [-10793941.805747895, 3575371.6645204406],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tioga',
        GEOID: '36107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8523019.74078548, 5183845.0925663905],
              [-8520210.03683786, 5203278.862890765],
              [-8506612.36103746, 5200453.735667494],
              [-8506512.841412691, 5208789.373074882],
              [-8488127.759591237, 5205524.189976363],
              [-8488485.095156685, 5222228.027945597],
              [-8474772.98291975, 5222645.504321302],
              [-8469262.668125482, 5199717.917584697],
              [-8472409.336171737, 5172183.3664921755],
              [-8471950.81118916, 5165709.350922911],
              [-8472063.35519435, 5160808.379523182],
              [-8476480.400688684, 5160809.647263011],
              [-8511728.159556357, 5160819.763757096],
              [-8512938.857626429, 5160840.492236127],
              [-8522355.736004971, 5161001.721062562],
              [-8523019.74078548, 5183845.0925663905],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bryan',
        GEOID: '40013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10756223.867960373, 4030107.7965023946],
              [-10747677.314054718, 4037305.1085689976],
              [-10751832.536687559, 4044181.447462544],
              [-10737192.242536392, 4044174.3212431953],
              [-10732049.393381232, 4049945.467066403],
              [-10685733.583402801, 4049876.5903651384],
              [-10679786.005648699, 4045612.2945341133],
              [-10677639.877185695, 4018743.4458703585],
              [-10663253.872123523, 4011686.3176596737],
              [-10666699.954227986, 4009813.129655526],
              [-10669403.073555905, 4010075.460861581],
              [-10674146.671564603, 4010535.8301304197],
              [-10679471.528087208, 4012043.1781229596],
              [-10693787.103283731, 4007542.235422264],
              [-10703550.490543246, 4006258.7400036915],
              [-10705932.171048768, 4002053.4419489917],
              [-10712165.83989421, 3995017.378594226],
              [-10717536.560047021, 3997924.811087675],
              [-10720889.503109718, 3993274.932329366],
              [-10727095.119443478, 3987816.1040607314],
              [-10728934.765973404, 3990668.4376900806],
              [-10731589.309925783, 3994785.5012547066],
              [-10735257.06450844, 3999306.21345302],
              [-10742585.337906852, 3998423.6502442327],
              [-10744987.2785597, 4004405.2495417004],
              [-10750450.171250887, 4004537.095811628],
              [-10752675.336552354, 4006120.709487205],
              [-10752362.083505262, 4012789.484723662],
              [-10752869.957239324, 4013105.0850771703],
              [-10750903.57553689, 4024023.6223356086],
              [-10756223.867960373, 4030107.7965023946],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fulton',
        GEOID: '36035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8322647.440344859, 5320798.419837993],
              [-8315119.014502, 5338521.052088098],
              [-8316970.257633894, 5355627.644932295],
              [-8297160.063691303, 5346757.982817589],
              [-8273974.551468371, 5348823.778941122],
              [-8262233.016857459, 5345732.589148484],
              [-8253243.411378449, 5350710.287856269],
              [-8248492.295511391, 5309374.5883765435],
              [-8292060.183859592, 5309706.929055828],
              [-8298018.33696532, 5309769.62468354],
              [-8322233.443158599, 5319192.899003824],
              [-8322647.440344859, 5320798.419837993],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coal',
        GEOID: '40029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10743874.306290748, 4096866.9873751514],
              [-10743685.731073344, 4120487.806912651],
              [-10731906.570474545, 4120482.1214228207],
              [-10731920.596730385, 4132342.2352437605],
              [-10696912.620626735, 4132327.1933962614],
              [-10696917.296045346, 4120554.2732100543],
              [-10696898.371731913, 4096970.4625903005],
              [-10702850.513585139, 4096963.3030474004],
              [-10702823.128990402, 4085159.62311749],
              [-10732014.884339087, 4085121.0291187842],
              [-10743865.512050975, 4085279.994059226],
              [-10743874.306290748, 4096866.9873751514],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lee',
        GEOID: '48287',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10835222.857796727, 3555437.3682182212],
              [-10815269.506988978, 3562473.656620376],
              [-10793941.805747895, 3575371.6645204406],
              [-10789049.091488548, 3573098.8708562055],
              [-10784310.55472395, 3561259.928997852],
              [-10769456.304511476, 3544718.1979125906],
              [-10758013.885372328, 3541756.246332405],
              [-10768431.831237705, 3534595.4218420084],
              [-10775120.24020304, 3524203.143889988],
              [-10780831.486678189, 3518472.7680967785],
              [-10800036.547868825, 3507716.0131279794],
              [-10800713.59301183, 3510163.0479977145],
              [-10807100.326157114, 3536931.521422758],
              [-10815669.366599908, 3543549.632777242],
              [-10820207.528281078, 3547049.4613708314],
              [-10826010.50201664, 3550276.3584717694],
              [-10835222.857796727, 3555437.3682182212],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McIntosh',
        GEOID: '40091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10684597.90195773, 4203347.381260066],
              [-10684590.220912864, 4215209.213138883],
              [-10672825.86580634, 4215190.37233385],
              [-10672819.854553835, 4227065.789483409],
              [-10667011.648802208, 4227112.805736296],
              [-10666896.433129236, 4239109.070311608],
              [-10654717.635558488, 4239123.984228709],
              [-10613760.189269392, 4239184.050577182],
              [-10613717.887862891, 4203783.536071331],
              [-10618794.279282045, 4208476.222752046],
              [-10625584.545581453, 4204182.064069828],
              [-10642404.03008439, 4193919.301037068],
              [-10643887.028340738, 4197866.092172939],
              [-10659505.820815979, 4187987.7941066995],
              [-10672273.387173532, 4189184.710436971],
              [-10676425.938138595, 4183398.544055155],
              [-10684857.72164924, 4184496.256250104],
              [-10684597.90195773, 4203347.381260066],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pontotoc',
        GEOID: '40123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10790473.313053755, 4144119.70826301],
              [-10790287.966101585, 4146918.0823410177],
              [-10790263.47581361, 4159039.4079203345],
              [-10785233.393302629, 4153863.4604789936],
              [-10777224.178579032, 4156361.7060289313],
              [-10773019.530092278, 4150294.1330598933],
              [-10767666.17578003, 4144489.6460003546],
              [-10765811.927021887, 4151890.0280587366],
              [-10750912.369776662, 4152551.0129653104],
              [-10745513.151834207, 4146172.495205144],
              [-10741305.163762731, 4151736.631949902],
              [-10732160.601552535, 4154463.868171327],
              [-10731920.596730385, 4132342.2352437605],
              [-10731906.570474545, 4120482.1214228207],
              [-10743685.731073344, 4120487.806912651],
              [-10743874.306290748, 4096866.9873751514],
              [-10778764.395053647, 4096948.0383768],
              [-10778764.617692629, 4108737.8558955863],
              [-10790467.9697182, 4108743.400211093],
              [-10790457.394366574, 4114634.091259206],
              [-10790473.313053755, 4144119.70826301],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Robertson',
        GEOID: '48395',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10778968.443680273, 3646506.154299675],
              [-10753113.490068117, 3661470.5651291],
              [-10722200.401433297, 3679216.512867509],
              [-10723527.886361007, 3665549.5161360367],
              [-10716638.21175632, 3642864.230143562],
              [-10715680.307538046, 3642762.329947401],
              [-10713750.472845653, 3640691.4944941583],
              [-10713501.339825256, 3629338.862388094],
              [-10724297.21536188, 3622432.87582371],
              [-10737614.254725989, 3599608.502063827],
              [-10749787.375002705, 3593288.8498152834],
              [-10755831.800713798, 3597839.9875313295],
              [-10754698.123019561, 3601276.8729711305],
              [-10764021.79829044, 3615166.5682293028],
              [-10762921.62776293, 3620572.242255037],
              [-10770865.386625938, 3623299.060848733],
              [-10774962.945762549, 3641286.8209014335],
              [-10778968.443680273, 3646506.154299675],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Haskell',
        GEOID: '40061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10625584.545581453, 4204182.064069828],
              [-10618794.279282045, 4208476.222752046],
              [-10613717.887862891, 4203783.536071331],
              [-10602148.230545765, 4199585.408811415],
              [-10594327.368400592, 4206103.5746650025],
              [-10580910.14149477, 4226419.199728634],
              [-10576076.315246053, 4220367.344754137],
              [-10564423.613588795, 4218091.96291642],
              [-10565828.688201586, 4211209.268318647],
              [-10554604.900542354, 4207909.584024922],
              [-10554677.814808825, 4191411.2265075385],
              [-10567329.497576464, 4191449.3720136844],
              [-10567321.371253636, 4171803.850444205],
              [-10614228.065089198, 4171835.8088295152],
              [-10614239.86495522, 4185686.1232191566],
              [-10625996.872975351, 4185724.3851661724],
              [-10625584.545581453, 4204182.064069828],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brooke',
        GEOID: '54009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8981721.0768923, 4893156.5555332145],
              [-8977315.584588248, 4902523.616984546],
              [-8973085.221299121, 4910198.449253995],
              [-8975868.208568953, 4922116.570236918],
              [-8975396.95196919, 4923534.713326366],
              [-8969432.606167214, 4924204.773871383],
              [-8963337.384392204, 4924188.117988006],
              [-8963338.420643736, 4915780.712951546],
              [-8963343.471259862, 4889172.5802888675],
              [-8979476.073265564, 4891980.546231723],
              [-8981721.0768923, 4893156.5555332145],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Athens',
        GEOID: '39009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9159413.343461774, 4789639.46711002],
              [-9146830.79009792, 4788687.869204373],
              [-9145915.96652258, 4801712.510442372],
              [-9133489.037806856, 4800882.481341415],
              [-9134407.53492539, 4787786.104736408],
              [-9110928.473205235, 4786367.8713138085],
              [-9111908.64132167, 4767348.991045207],
              [-9107978.284060232, 4760792.013845335],
              [-9097230.05326567, 4760362.9326670775],
              [-9097192.220131414, 4751935.106034633],
              [-9100674.94622776, 4748159.453947248],
              [-9100624.077310355, 4747636.521646024],
              [-9123843.649207583, 4748743.704890713],
              [-9158096.767844161, 4750900.613336766],
              [-9157168.363290947, 4763716.406899696],
              [-9160443.382710082, 4776854.581195737],
              [-9159413.343461774, 4789639.46711002],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '54063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9000999.982922662, 4497970.394169603],
              [-8979511.250224654, 4538293.192036288],
              [-8979402.825040622, 4541592.484327199],
              [-8955725.503307365, 4534861.313312589],
              [-8949481.70438826, 4539512.6432926],
              [-8937845.679532306, 4535181.811339038],
              [-8938093.275202146, 4534843.58988754],
              [-8930528.58640919, 4526443.735129526],
              [-8930426.479232231, 4526330.401192841],
              [-8937000.340441538, 4521032.547372818],
              [-8938024.925034799, 4514154.850377848],
              [-8950073.701440299, 4503744.810025981],
              [-8957302.789172417, 4498673.396434442],
              [-8957831.433245175, 4499077.318353712],
              [-8966210.129547728, 4505481.319674898],
              [-8979583.496574178, 4497001.362794419],
              [-8991284.399570951, 4491137.263261441],
              [-8998672.006257957, 4498422.623468059],
              [-9000999.982922662, 4497970.394169603],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Albemarle',
        GEOID: '51003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8769869.487105167, 4590840.358302505],
              [-8766342.662997853, 4608659.51554906],
              [-8755864.938565917, 4616281.019273866],
              [-8756741.245597444, 4618763.16815737],
              [-8723968.564868923, 4605462.029908009],
              [-8720955.25757264, 4604445.795678365],
              [-8706228.802135598, 4597966.398432291],
              [-8711194.20802243, 4588302.9871703135],
              [-8717068.982829554, 4580340.412314643],
              [-8737616.557079159, 4550782.080359288],
              [-8738325.550916024, 4546013.630860606],
              [-8754600.905747961, 4541787.851389215],
              [-8757377.659126308, 4540615.140983756],
              [-8758949.935614273, 4548683.783640821],
              [-8776303.308395054, 4586119.7680861205],
              [-8769869.487105167, 4590840.358302505],
            ],
            [
              [-8740662.592305735, 4580938.180734818],
              [-8735185.228080744, 4581085.120348802],
              [-8732800.207990497, 4587565.818239428],
              [-8738027.214680696, 4588659.855748076],
              [-8740796.17569469, 4583508.37049618],
              [-8740662.592305735, 4580938.180734818],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hampton',
        GEOID: '45049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9062866.705532035, 3861407.92170064],
              [-9054565.188626787, 3864610.544717188],
              [-9046006.83485511, 3873971.769121625],
              [-9043256.57551557, 3887375.0371977985],
              [-9026039.346472029, 3898839.184172735],
              [-9015398.53898608, 3882127.507138571],
              [-9005753.373025788, 3873109.67376774],
              [-8997543.560579784, 3856122.9650483076],
              [-9002374.381202249, 3850384.752248627],
              [-9006019.315289292, 3845179.575241011],
              [-9018506.801808009, 3862572.2271662042],
              [-9048520.02617721, 3835343.654901367],
              [-9053475.37081192, 3837208.0928797536],
              [-9059948.477050025, 3842193.4365156675],
              [-9061084.391966112, 3843068.4920833036],
              [-9060718.373480383, 3849400.492210686],
              [-9062816.968520818, 3860722.584942638],
              [-9062866.705532035, 3861407.92170064],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '47125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9756168.190536907, 4388773.052478778],
              [-9723512.172634738, 4389245.297953294],
              [-9722196.715787003, 4389264.327010552],
              [-9697597.83638477, 4389620.174255234],
              [-9701534.922164874, 4378898.41147798],
              [-9698203.352444414, 4363474.306962374],
              [-9716031.61417292, 4349464.138126933],
              [-9716688.844446564, 4345009.7550829975],
              [-9718539.864939474, 4343698.514088829],
              [-9741961.931080343, 4346775.6442948915],
              [-9750135.453372348, 4347752.258440831],
              [-9750736.689942122, 4351329.880231433],
              [-9756168.190536907, 4388773.052478778],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adair',
        GEOID: '29001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10336641.337569125, 4915873.456157194],
              [-10317554.27503873, 4915980.075409314],
              [-10280352.191771545, 4916423.945216695],
              [-10280110.183198558, 4910035.987193267],
              [-10279805.501752257, 4871351.009532936],
              [-10335733.861080179, 4871364.240626733],
              [-10336703.899122952, 4871357.261586046],
              [-10336641.337569125, 4915873.456157194],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Johnson',
        GEOID: '48251',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10866682.079853378, 3836449.4479433694],
              [-10859281.114827478, 3836437.1652684878],
              [-10841000.784646861, 3836195.2123753615],
              [-10836839.99603948, 3836140.535931918],
              [-10832943.14594477, 3836072.1246984545],
              [-10807656.92361108, 3835649.6478558076],
              [-10807585.3451785, 3798205.8563039396],
              [-10849877.289523225, 3787473.194528237],
              [-10850988.258041343, 3786101.5467163846],
              [-10855284.745108, 3780861.1649996247],
              [-10866458.216357393, 3790063.5634878404],
              [-10866483.931159766, 3805207.2415023465],
              [-10866682.079853378, 3836449.4479433694],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Golden Valley',
        GEOID: '30037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12206613.083231308, 5815578.846904449],
              [-12178675.787224375, 5815627.435778317],
              [-12178746.809059499, 5859329.026221883],
              [-12177145.923462402, 5892208.471256526],
              [-12177138.019778557, 5892208.471256526],
              [-12177150.932839487, 5901582.247613163],
              [-12134889.823993709, 5901476.804648991],
              [-12132599.42547064, 5873438.782499306],
              [-12123238.458170343, 5873286.064717722],
              [-12118328.934667885, 5853026.650211455],
              [-12118493.242236298, 5838968.120515537],
              [-12109253.167903, 5824914.426577213],
              [-12109304.486188255, 5801601.014323845],
              [-12125429.782346606, 5801587.039030403],
              [-12180158.67416123, 5801587.199665834],
              [-12180262.31260716, 5787524.784831025],
              [-12201189.820278842, 5787562.474326184],
              [-12206609.632327093, 5801602.299409407],
              [-12206613.083231308, 5815578.846904449],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '30043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12534362.26573417, 5818337.412615938],
              [-12529965.925084272, 5823050.0311370725],
              [-12531240.199295383, 5829356.614741679],
              [-12517823.417667523, 5834051.261684618],
              [-12502355.79706078, 5848100.971034794],
              [-12487401.359306592, 5853782.367356444],
              [-12490687.733313791, 5860799.077045646],
              [-12477071.578477921, 5863534.954027965],
              [-12471036.94888202, 5871973.90249094],
              [-12444177.559504434, 5872080.77249543],
              [-12443800.85434759, 5788335.384905051],
              [-12429981.318802042, 5788235.780068217],
              [-12429940.6871879, 5753707.506437382],
              [-12434995.705264825, 5747676.294900241],
              [-12446104.499890069, 5748086.317107846],
              [-12459652.749836553, 5757254.1622618055],
              [-12477301.787184883, 5756510.164528462],
              [-12488963.617040385, 5740137.840249332],
              [-12512471.176550183, 5753444.048636176],
              [-12512794.89362941, 5762427.107761242],
              [-12525668.770100672, 5802233.459616475],
              [-12524041.279145272, 5809935.506654759],
              [-12532026.114900382, 5809077.588044801],
              [-12534362.26573417, 5818337.412615938],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jeff Davis',
        GEOID: '13161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9221302.082285238, 3739202.102519556],
              [-9220132.003117511, 3738840.014130499],
              [-9200072.676154526, 3752667.463948203],
              [-9194406.291434169, 3754333.4418162853],
              [-9188717.64281565, 3757918.6586701623],
              [-9181656.53619514, 3757400.009425008],
              [-9181980.141954878, 3759236.965320663],
              [-9176236.056229945, 3758872.3072953336],
              [-9176217.243236, 3742063.4274154543],
              [-9186112.321453124, 3742115.18617143],
              [-9189503.447101159, 3728749.912262859],
              [-9186242.453937862, 3725407.690086843],
              [-9186239.44831161, 3720399.090468889],
              [-9198033.637041666, 3720420.0185688925],
              [-9221331.80458928, 3720253.379572049],
              [-9221302.082285238, 3739202.102519556],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Uvalde',
        GEOID: '48463',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11144427.771606302, 3455215.1542966156],
              [-11133528.480262732, 3455244.863626714],
              [-11087769.71301623, 3455716.892591825],
              [-11066472.847274097, 3455759.5374047584],
              [-11066702.499383602, 3387276.077807583],
              [-11144350.738518674, 3386636.9761429043],
              [-11144427.771606302, 3455215.1542966156],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hendry',
        GEOID: '12051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9079877.904999286, 3094709.701002168],
              [-9010795.589361269, 3094646.9859558083],
              [-9004148.145968549, 3118340.1578916665],
              [-9003657.672292113, 3040483.3312359694],
              [-9003499.153337223, 3031251.2051255326],
              [-9046773.603507692, 3030455.555648398],
              [-9047131.829629065, 3063264.3829280743],
              [-9079636.564343248, 3062798.4865875226],
              [-9079784.841904983, 3073626.7621578407],
              [-9079877.904999286, 3094709.701002168],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Victoria',
        GEOID: '48469',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10832045.020293051, 3358352.346730694],
              [-10795361.017936017, 3388895.436115281],
              [-10791154.14305945, 3383698.0442063157],
              [-10779300.398401817, 3378357.1997648245],
              [-10774850.95835481, 3365315.529764195],
              [-10765876.492326548, 3356747.543824584],
              [-10764520.175650721, 3347502.303342318],
              [-10758298.751949267, 3339054.233468469],
              [-10781710.910655456, 3329296.471094049],
              [-10790239.096845128, 3323150.1897566826],
              [-10785851.32779602, 3313069.1257771873],
              [-10788584.109975506, 3310350.1257907115],
              [-10803392.830516243, 3318491.804517933],
              [-10815885.326412044, 3318935.239300591],
              [-10818290.717969105, 3326177.136596918],
              [-10815682.947577782, 3347186.4418082843],
              [-10820561.63558129, 3357057.4058401915],
              [-10832045.020293051, 3358352.346730694],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clermont',
        GEOID: '39025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9384158.26717515, 4746690.502327435],
              [-9382929.299996791, 4748419.5477206195],
              [-9386462.580634568, 4753727.154326263],
              [-9379716.953450968, 4760535.339429881],
              [-9351592.19542154, 4758274.011211118],
              [-9350071.34853832, 4758154.2589278435],
              [-9356697.77183, 4689009.932207949],
              [-9365875.154007262, 4691561.807923035],
              [-9374537.59150283, 4693878.856442565],
              [-9376013.535884261, 4697317.856515456],
              [-9376804.167654872, 4699160.533428073],
              [-9376697.305998005, 4703740.411049282],
              [-9376678.042671803, 4704566.218386467],
              [-9382915.496379932, 4715340.703269],
              [-9383927.501870735, 4720195.434004925],
              [-9386593.8515678, 4724620.820098309],
              [-9384158.26717515, 4746690.502327435],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Webb',
        GEOID: '48479',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11153935.79813228, 3273833.855037902],
              [-11144608.220500877, 3273937.2099774736],
              [-11064509.171456505, 3274797.1541504846],
              [-11064486.35096089, 3273896.2856804687],
              [-11063926.859200163, 3252809.4711991367],
              [-10998735.827682316, 3256222.6373096374],
              [-10998179.007589368, 3167773.050889515],
              [-10998152.73618954, 3156996.3963932833],
              [-11015583.364696933, 3157169.850225426],
              [-11057766.883857626, 3157649.019841596],
              [-11061886.929531377, 3163405.229364424],
              [-11071928.481838116, 3156273.5739268777],
              [-11072204.910494024, 3157049.6220686147],
              [-11074946.48691328, 3160369.3026606455],
              [-11079590.402110703, 3161761.088714643],
              [-11074900.17800511, 3175090.3365504346],
              [-11075744.313703796, 3179997.1014718013],
              [-11076013.15027406, 3186142.481299061],
              [-11079441.901909985, 3185941.682518852],
              [-11079644.280744247, 3196149.8512680526],
              [-11082613.616841666, 3200436.821552395],
              [-11090150.280326845, 3202972.1498009125],
              [-11099065.413066514, 3205540.62155899],
              [-11105069.207163468, 3213349.518278835],
              [-11109868.969648, 3216455.8578781025],
              [-11114665.28122832, 3221115.17844266],
              [-11118350.29033205, 3226849.6108169407],
              [-11121305.266215157, 3233259.0351559822],
              [-11122760.87987677, 3238635.9922441924],
              [-11124397.276391432, 3244903.3690157994],
              [-11130270.715364667, 3247804.9789329786],
              [-11135146.731700392, 3258195.4280952294],
              [-11140350.806575488, 3264727.695677283],
              [-11151364.645675084, 3271616.9729447705],
              [-11153935.79813228, 3273833.855037902],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fayette',
        GEOID: '39047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9312246.098761676, 4824884.366350133],
              [-9267618.671500105, 4821782.362713118],
              [-9269210.762857432, 4795891.917714334],
              [-9281008.06853323, 4775878.271513436],
              [-9305293.973922653, 4776068.370110229],
              [-9303881.997501433, 4797015.212846766],
              [-9304697.858049456, 4800057.284898916],
              [-9314123.613293393, 4800800.045260509],
              [-9312246.098761676, 4824884.366350133],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Meriwether',
        GEOID: '13199',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9446834.591395976, 3920706.560137307],
              [-9445721.507807534, 3925019.5408017025],
              [-9406758.795473963, 3924682.209381832],
              [-9406138.857229734, 3919734.6071054754],
              [-9410614.791315552, 3900180.2719996367],
              [-9409504.82467285, 3891395.355163543],
              [-9410072.331436915, 3890092.5542964824],
              [-9409491.688972937, 3883907.452515196],
              [-9407263.7406842, 3879623.7886159536],
              [-9414363.809126485, 3874772.0494240755],
              [-9428820.760076318, 3874700.631468781],
              [-9434475.790208615, 3877955.292769931],
              [-9446768.801576916, 3878392.0107288845],
              [-9446834.591395976, 3920706.560137307],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lewis',
        GEOID: '54041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8986636.142913388, 4735386.049671703],
              [-8983554.374130266, 4734642.793789578],
              [-8971919.706230516, 4745631.105692513],
              [-8969849.05238227, 4745713.521557669],
              [-8938978.376473442, 4736559.133901592],
              [-8940901.643315878, 4715749.839973971],
              [-8948638.681884484, 4703754.724781354],
              [-8951149.159040852, 4688540.524344439],
              [-8949314.836471561, 4682723.243522835],
              [-8956469.228825355, 4684378.338418606],
              [-8958337.058561374, 4697836.141532981],
              [-8970513.073144853, 4701476.168368571],
              [-8972996.499664959, 4707953.59924744],
              [-8985354.744254865, 4722879.169692835],
              [-8986636.142913388, 4735386.049671703],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Taylor',
        GEOID: '54091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8927521.040522527, 4778149.608804582],
              [-8915281.239870826, 4777145.519368436],
              [-8898755.193545619, 4786692.099548605],
              [-8893835.985247465, 4784259.27373707],
              [-8893930.384175656, 4764675.71336154],
              [-8908165.364060847, 4757242.43435805],
              [-8924081.379576506, 4756436.193112392],
              [-8927767.947153106, 4760520.097345328],
              [-8927521.040522527, 4778149.608804582],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Defiance',
        GEOID: '39039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9440366.289741125, 5075388.46820541],
              [-9388871.089137372, 5075613.88131023],
              [-9376268.609584667, 5075649.810392638],
              [-9376242.783462804, 5036837.138909374],
              [-9388864.187328942, 5036787.158132027],
              [-9388864.076009452, 5043222.603292857],
              [-9401716.801777463, 5043282.383367683],
              [-9401734.390257008, 5049802.847168642],
              [-9440298.576838242, 5049666.132042687],
              [-9440305.099087428, 5052434.914376411],
              [-9440352.902725047, 5072752.455992873],
              [-9440366.289741125, 5075388.46820541],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Richland',
        GEOID: '30083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11714681.121466752, 6072072.331009298],
              [-11710267.41497629, 6084936.206505603],
              [-11710229.67766891, 6117944.694197284],
              [-11708330.455836488, 6124024.1725123385],
              [-11707845.659454083, 6120483.409759591],
              [-11687471.854929607, 6117916.708872805],
              [-11676448.442353804, 6131960.99536073],
              [-11668796.340556672, 6126665.906040947],
              [-11653106.080968343, 6124061.346197797],
              [-11637842.397668732, 6127934.627799325],
              [-11604604.512788186, 6112014.51301192],
              [-11593086.730353769, 6116010.590222447],
              [-11588238.877849214, 6106857.995808656],
              [-11582135.483178295, 6106207.231809488],
              [-11582135.47678043, 6106205.764815743],
              [-11582117.641689472, 6102117.253456951],
              [-11581945.207798233, 6074185.834055537],
              [-11582115.303980166, 6041098.295619737],
              [-11582233.82766821, 6007128.426606228],
              [-11591905.964514924, 6000032.254961975],
              [-11624019.85649693, 6000120.000669426],
              [-11634366.446568714, 6000166.667287513],
              [-11634339.395932449, 6028924.747294911],
              [-11643355.940728232, 6028907.106633316],
              [-11643313.41668275, 6043255.577894547],
              [-11686159.064174682, 6043251.944819252],
              [-11686107.523250444, 6057634.5481009185],
              [-11714708.394741997, 6057682.187820022],
              [-11714681.121466752, 6072072.331009298],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Santa Fe',
        GEOID: '35049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11827751.445211224, 4267074.11444252],
              [-11818996.501218805, 4276947.221977239],
              [-11827501.866912864, 4278515.017078405],
              [-11827211.545680875, 4291095.7579607675],
              [-11805915.79313365, 4291101.394552897],
              [-11807786.739815412, 4300837.816577147],
              [-11768341.234850269, 4300940.605162316],
              [-11768415.70758961, 4297696.560573713],
              [-11768755.454675512, 4282911.072260488],
              [-11768075.292586764, 4169536.53574264],
              [-11821541.37609783, 4169353.1202382697],
              [-11827013.953584718, 4169318.721670684],
              [-11827052.024850568, 4193226.8259777813],
              [-11827157.333088858, 4196361.705065204],
              [-11827567.656731922, 4224285.7642603],
              [-11827751.445211224, 4267074.11444252],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hillsborough',
        GEOID: '12057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9200685.601270834, 3270836.282800903],
              [-9181000.196477424, 3270668.7092875317],
              [-9157112.480906567, 3270608.4742521634],
              [-9139981.747107372, 3270632.2146533243],
              [-9134461.190919952, 3270624.8904825593],
              [-9134349.760109669, 3239795.951934789],
              [-9134306.790786222, 3237345.1224940387],
              [-9134248.348053558, 3204463.3607245283],
              [-9189745.367404867, 3204345.9374052486],
              [-9185445.962981235, 3211905.6243749387],
              [-9181368.66399195, 3214095.6043673167],
              [-9176286.03868131, 3219766.8341384036],
              [-9178156.874043582, 3225044.7174173505],
              [-9180902.096041378, 3225994.9156912994],
              [-9182727.986294027, 3226626.9440631643],
              [-9189863.231695402, 3229881.713891663],
              [-9191247.436269354, 3228355.408821725],
              [-9192030.95613962, 3237505.608474865],
              [-9200424.223106451, 3246348.865371527],
              [-9200622.928397516, 3267258.2127114274],
              [-9200685.601270834, 3270836.282800903],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Owyhee',
        GEOID: '16073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13027373.692600949, 5403138.705529293],
              [-13027237.305123674, 5416099.453420004],
              [-13014532.878018454, 5404221.345454426],
              [-13007123.452711252, 5402887.701192806],
              [-13000038.857678188, 5385110.768736851],
              [-12982364.996083412, 5368461.646751557],
              [-12977533.507544, 5358691.987723438],
              [-12970045.045398338, 5356297.018614449],
              [-12960402.328466844, 5356759.353488087],
              [-12956025.246088851, 5341482.808777617],
              [-12942694.95970534, 5329075.975818252],
              [-12934397.761459062, 5324533.515401157],
              [-12935518.52609237, 5319422.459848852],
              [-12929293.206208738, 5314014.121938365],
              [-12909160.964979284, 5303402.229303887],
              [-12905898.079384642, 5312235.630936503],
              [-12889885.549870463, 5307763.8772477405],
              [-12887624.984970925, 5302640.53735359],
              [-12871077.008706031, 5305231.060019901],
              [-12850891.445440486, 5301494.542660973],
              [-12852305.425612545, 5276715.781880317],
              [-12805937.852070894, 5276788.265463631],
              [-12805983.79946167, 5160774.843398149],
              [-12836682.069038182, 5160395.710222949],
              [-12871417.86898684, 5160592.231451118],
              [-12898609.547044441, 5160495.018843313],
              [-12950103.939734576, 5160572.45931498],
              [-12982741.033323312, 5160586.839046285],
              [-13026406.795631418, 5160955.454441945],
              [-13027296.659513319, 5160962.966597495],
              [-13027336.06661306, 5217855.207191273],
              [-13027302.893404802, 5282709.091089663],
              [-13027347.30988163, 5315797.367205538],
              [-13027373.692600949, 5403138.705529293],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Matagorda',
        GEOID: '48321',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10728809.234694438, 3298216.3638450243],
              [-10722597.366737466, 3330278.8253700794],
              [-10722685.420454683, 3334421.238994604],
              [-10721088.653678745, 3370974.630908331],
              [-10682796.752596693, 3394351.9713489744],
              [-10672647.977260053, 3404914.5640918054],
              [-10669562.423614245, 3389373.5997351487],
              [-10661117.281764703, 3384075.7863301947],
              [-10661000.062340898, 3371969.3716364913],
              [-10650998.785329558, 3371285.463410397],
              [-10638548.590840256, 3353995.835300911],
              [-10631794.770198938, 3353357.648844724],
              [-10640896.652859557, 3348077.147476335],
              [-10651504.064498268, 3341838.7671785885],
              [-10665799.156908486, 3333069.3862207225],
              [-10686747.036046984, 3323341.619910507],
              [-10708312.960998364, 3312441.5761766275],
              [-10723274.857158436, 3302493.262348991],
              [-10728809.234694438, 3298216.3638450243],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henderson',
        GEOID: '21101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9787403.771736555, 4566421.21287278],
              [-9781926.407511564, 4568271.624503114],
              [-9774743.294729145, 4561809.459504815],
              [-9765350.378734991, 4564188.430657557],
              [-9764189.960461585, 4562923.262772751],
              [-9760674.737482691, 4559091.664761299],
              [-9754465.113647262, 4558528.002416031],
              [-9752531.2714532, 4565138.648143642],
              [-9746163.573940843, 4568895.228563011],
              [-9738935.599403637, 4568161.414602201],
              [-9734737.614235494, 4570089.179730595],
              [-9731392.368068503, 4571625.613361328],
              [-9721727.60987783, 4566473.133910731],
              [-9718643.219792543, 4564382.325112423],
              [-9720796.644976327, 4553921.722825051],
              [-9715030.96327018, 4548410.540356221],
              [-9728665.931099994, 4540508.6014610045],
              [-9730274.943019921, 4534819.81803931],
              [-9737428.778776258, 4532190.620147234],
              [-9739935.693708923, 4529754.976740614],
              [-9766564.874379545, 4528465.674018315],
              [-9769647.31107961, 4545950.828546041],
              [-9775531.436723962, 4545918.301038706],
              [-9787810.0190502, 4565251.150444555],
              [-9787403.771736555, 4566421.21287278],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adams',
        GEOID: '31001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10989948.489718076, 4966690.232795952],
              [-10989619.3179838, 4968030.855204459],
              [-10940796.927031178, 4967939.967209257],
              [-10940268.382088892, 4967940.995017082],
              [-10940266.93493551, 4916985.128102508],
              [-10989899.620461619, 4916991.5551609],
              [-10989948.489718076, 4966690.232795952],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mitchell',
        GEOID: '37121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9173778.901109666, 4312104.39958511],
              [-9166810.189666515, 4316485.554399044],
              [-9161333.048080504, 4319007.727071129],
              [-9157774.720557297, 4318195.099068025],
              [-9152716.697999222, 4321807.466491505],
              [-9151714.598798001, 4322523.29467257],
              [-9143877.261368193, 4319380.707378653],
              [-9142352.073024834, 4314998.518424454],
              [-9137231.701182038, 4315174.206528392],
              [-9131994.684962448, 4292651.430840645],
              [-9126189.373517578, 4288431.626784716],
              [-9125990.55690702, 4284815.385567815],
              [-9143057.615957482, 4276336.120358319],
              [-9150221.02519003, 4302731.236729909],
              [-9156469.610847237, 4301353.558141263],
              [-9167346.193014685, 4312231.813804884],
              [-9174611.525780024, 4310666.583839571],
              [-9173778.901109666, 4312104.39958511],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ottawa',
        GEOID: '40115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10576199.880378664, 4439040.238358801],
              [-10574827.644517824, 4439041.136128002],
              [-10543377.328020437, 4438938.68773644],
              [-10532823.57237629, 4438954.159470866],
              [-10532861.754961632, 4406618.019976247],
              [-10532826.664655548, 4392919.824343309],
              [-10575285.167624986, 4393295.895916735],
              [-10575257.337752286, 4431197.846945629],
              [-10579150.180345329, 4438301.857292326],
              [-10576199.880378664, 4439040.238358801],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yamhill',
        GEOID: '41071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13779631.960879603, 5655637.065318454],
              [-13743895.955306165, 5655639.909808821],
              [-13744047.572452625, 5690000.679071233],
              [-13707373.032252308, 5690020.82558876],
              [-13695877.513716051, 5685501.36827636],
              [-13688983.275012242, 5676229.4820719035],
              [-13677591.06096344, 5671620.087420196],
              [-13675591.094991848, 5662498.540203938],
              [-13678099.568397384, 5661559.822908801],
              [-13688809.282648133, 5666458.173271603],
              [-13696880.391008608, 5656347.267699342],
              [-13691929.234016594, 5639969.524868386],
              [-13699941.34304695, 5633314.370131894],
              [-13772933.644479591, 5633529.702972708],
              [-13779596.116003567, 5633597.330527315],
              [-13779631.960879603, 5655637.065318454],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sauk',
        GEOID: '55111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10053530.825596403, 5410051.30278514],
              [-9994910.53834212, 5410060.686087109],
              [-9988947.041900832, 5399418.605849938],
              [-9974154.796644732, 5397300.813494437],
              [-9974307.638305591, 5370093.755985648],
              [-9982866.21471625, 5367112.314068211],
              [-9987636.254896741, 5356689.152965305],
              [-9988891.382155435, 5350438.841769097],
              [-10000735.442017369, 5343388.601473752],
              [-10018767.86369199, 5341642.678811361],
              [-10025284.172724554, 5334112.830853973],
              [-10040329.447183227, 5337038.5425213305],
              [-10040120.6118185, 5370004.462683049],
              [-10040123.506125262, 5396833.074861379],
              [-10053382.214076193, 5396678.703258842],
              [-10053530.825596403, 5410051.30278514],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wood',
        GEOID: '55141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10053937.253057288, 5531371.5861041],
              [-10053959.294316465, 5572090.867850611],
              [-10014748.116879443, 5572039.982247469],
              [-10001491.969276799, 5572058.144460751],
              [-10001449.111272844, 5544942.694416311],
              [-9988333.33754809, 5544894.146109561],
              [-9988113.036275808, 5503851.268790015],
              [-10007932.024458172, 5504130.220492531],
              [-10027751.235279515, 5504058.422639093],
              [-10053561.549775863, 5504017.8617633935],
              [-10054133.509319559, 5506691.224021435],
              [-10053937.253057288, 5531371.5861041],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Claiborne',
        GEOID: '47025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9349458.083973577, 4382054.594031761],
              [-9343129.55236069, 4381791.450267911],
              [-9339084.226116516, 4381623.246807172],
              [-9316407.666605491, 4381082.577214184],
              [-9314704.367076863, 4383610.511611332],
              [-9292070.952084968, 4383424.945663836],
              [-9283856.622983139, 4374472.534759777],
              [-9280639.267060233, 4363990.005807019],
              [-9282576.114880545, 4357625.087401143],
              [-9298795.80996709, 4349356.18740199],
              [-9312766.740020115, 4346398.26131821],
              [-9313813.254553063, 4348111.722295086],
              [-9321116.035788082, 4348194.507098109],
              [-9329187.25546805, 4360764.596220638],
              [-9340332.896844745, 4358564.7824586695],
              [-9342223.101798415, 4359643.880083232],
              [-9344507.489068983, 4365980.232238405],
              [-9346046.035751237, 4369855.851906293],
              [-9349126.69133945, 4378019.437214582],
              [-9349458.083973577, 4382054.594031761],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greene',
        GEOID: '39057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9361183.037470324, 4842478.747719406],
              [-9356819.090792248, 4844234.98034547],
              [-9344111.636959722, 4843269.180793698],
              [-9331843.227198888, 4836597.5589907905],
              [-9311560.259378897, 4833014.082717603],
              [-9312246.098761676, 4824884.366350133],
              [-9314123.613293393, 4800800.045260509],
              [-9348277.434944188, 4803531.191790232],
              [-9363549.355886117, 4804804.10423975],
              [-9361183.037470324, 4842478.747719406],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Platte',
        GEOID: '29165',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10585528.386731982, 4798346.602586227],
              [-10530959.082224993, 4797900.921119169],
              [-10530914.999706639, 4787224.092975197],
              [-10531039.564204304, 4743970.617175943],
              [-10533488.149736324, 4744128.498097005],
              [-10539766.791656047, 4748105.884941031],
              [-10546624.294927893, 4746081.09876268],
              [-10552196.578359805, 4750541.5155976815],
              [-10553050.212533936, 4751224.993868327],
              [-10555944.519294562, 4756356.564296632],
              [-10559440.953180889, 4760970.898928965],
              [-10565117.467974909, 4768140.133069761],
              [-10562992.044937193, 4778040.999256026],
              [-10569414.066361057, 4779090.412514819],
              [-10571538.645444915, 4782255.124729736],
              [-10573363.904533383, 4784974.774981665],
              [-10580900.345379578, 4792741.763701743],
              [-10585528.386731982, 4798346.602586227],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Johns',
        GEOID: '12109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9092599.941685105, 3519143.6540755234],
              [-9065167.256929938, 3517122.7382907886],
              [-9065517.468047973, 3536026.5667408262],
              [-9058554.114191871, 3536103.3732558484],
              [-9049045.077717328, 3492651.67607309],
              [-9046984.219984274, 3488533.0417363956],
              [-9046037.053708065, 3480705.906212523],
              [-9045455.69205619, 3475904.050151245],
              [-9040301.443401547, 3461283.6561159],
              [-9052952.837122135, 3455515.708303319],
              [-9075172.318803964, 3455108.739110891],
              [-9075299.668301433, 3467812.286374412],
              [-9075347.09040451, 3472672.7344415993],
              [-9081578.421540644, 3483022.457069884],
              [-9083780.655027008, 3497897.4908730783],
              [-9093623.858361423, 3507565.315112798],
              [-9092599.941685105, 3519143.6540755234],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Anderson',
        GEOID: '21005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9480990.416797604, 4579131.417747205],
              [-9473471.898389427, 4584692.152589061],
              [-9467475.896656828, 4589650.216401146],
              [-9464796.213874452, 4597672.607342948],
              [-9451277.018315064, 4592633.749043802],
              [-9447118.344778009, 4595956.728608738],
              [-9443334.261327472, 4592657.512144942],
              [-9445434.192201797, 4586206.703509429],
              [-9439483.942779915, 4575201.111809004],
              [-9454707.77370182, 4572955.851260042],
              [-9465555.07884319, 4564115.080191156],
              [-9476261.453509215, 4567730.887523874],
              [-9479166.001662994, 4564978.814802475],
              [-9480839.912846053, 4575444.1351476945],
              [-9480990.416797604, 4579131.417747205],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Murray',
        GEOID: '13213',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9455960.674570698, 4120055.0410855464],
              [-9447122.463599166, 4124182.7669726815],
              [-9448631.287977379, 4133971.2108868994],
              [-9441976.163539795, 4147171.6883044103],
              [-9441059.165548196, 4162233.9285964156],
              [-9437203.081142034, 4162241.9793702164],
              [-9431814.809100695, 4162253.22907134],
              [-9420020.397731656, 4162295.214870235],
              [-9420159.324456166, 4146917.5395843037],
              [-9419703.582460858, 4144247.6318067657],
              [-9415659.234040847, 4140143.8211768847],
              [-9423985.041396257, 4127101.1723369774],
              [-9423698.393707465, 4107381.2035701335],
              [-9430507.695639798, 4112748.869106474],
              [-9446994.223545773, 4110817.436643035],
              [-9452522.68341704, 4114271.092043878],
              [-9455960.674570698, 4120055.0410855464],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pottawattamie',
        GEOID: '19155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10686005.469349204, 5087397.880002724],
              [-10630788.397817567, 5087276.488106963],
              [-10592575.199615505, 5087148.20670213],
              [-10592700.879320612, 5035857.385232355],
              [-10618137.160327893, 5035971.975513866],
              [-10671297.679429766, 5036015.054152967],
              [-10670728.829238776, 5039977.868420086],
              [-10676617.852940721, 5039578.491434159],
              [-10676642.175275948, 5040596.913228324],
              [-10676807.20739456, 5047509.948349557],
              [-10674442.892729603, 5053479.104215131],
              [-10678398.964793414, 5059982.436575889],
              [-10678744.055214873, 5067084.95840699],
              [-10678582.22365021, 5070036.095626734],
              [-10678047.083883017, 5079801.263486181],
              [-10684774.454670127, 5081882.712172314],
              [-10686005.469349204, 5087397.880002724],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bergen',
        GEOID: '34003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8265523.175727345, 5021316.152645653],
              [-8261199.486985984, 5031976.216075507],
              [-8242212.429077272, 5021061.040854202],
              [-8225840.114968851, 5011928.230778184],
              [-8227320.775515893, 5005190.259988842],
              [-8228789.249849179, 5000343.519088235],
              [-8228962.837955134, 4999770.746088701],
              [-8230394.593967924, 4995047.794169931],
              [-8230749.527151816, 4993877.325557945],
              [-8231796.3276737975, 4991385.860774572],
              [-8233839.034537133, 4986525.895642251],
              [-8234089.223195105, 4985930.818471316],
              [-8234437.209958511, 4985285.896961288],
              [-8235927.163055648, 4982525.0587894665],
              [-8239176.746563339, 4976506.385358802],
              [-8240257.384275266, 4973692.855212489],
              [-8240496.052796941, 4973071.571060094],
              [-8241085.106132295, 4971538.360190446],
              [-8242223.810861073, 4968575.176812677],
              [-8242870.61578939, 4966892.434674884],
              [-8242909.177770146, 4966792.120108005],
              [-8245180.911389708, 4963843.776681525],
              [-8245539.717195785, 4963378.1859013755],
              [-8247305.518420045, 4961087.183371231],
              [-8255469.777055038, 4960277.360166626],
              [-8253507.127252139, 4963423.207543466],
              [-8243389.076094955, 4972763.19003594],
              [-8250673.044336032, 4969716.327172121],
              [-8250734.047416988, 4974013.847848692],
              [-8256119.127784111, 4975252.4697380075],
              [-8254065.171859484, 4980899.960122439],
              [-8253179.736629714, 4983681.766496572],
              [-8252115.633617221, 4985818.728662172],
              [-8249529.681846094, 4991610.397333784],
              [-8252374.006155353, 5000906.830489253],
              [-8253343.710239654, 5007379.267950344],
              [-8256693.647676094, 5008959.492376475],
              [-8267946.378402934, 5014987.432280532],
              [-8265523.175727345, 5021316.152645653],
            ],
            [
              [-8247732.762625709, 4975360.323961667],
              [-8246401.604154803, 4975624.674702653],
              [-8245968.9052940905, 4976733.879621674],
              [-8244323.714539656, 4977379.504271037],
              [-8243643.107172946, 4980085.184166653],
              [-8242356.031220395, 4979954.785159743],
              [-8241388.108247947, 4981766.855242507],
              [-8242233.46846103, 4982244.297959811],
              [-8241391.33651318, 4983366.314093862],
              [-8242643.12418715, 4983997.376166433],
              [-8244159.9635687, 4983809.420995927],
              [-8245326.925790685, 4982643.532694576],
              [-8246186.4235791, 4982242.38637789],
              [-8246531.180042086, 4981375.596065723],
              [-8247671.982183737, 4979487.450598184],
              [-8247436.096182745, 4977658.460241015],
              [-8247748.681312892, 4977297.494494777],
              [-8247732.762625709, 4975360.323961667],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cheyenne',
        GEOID: '31033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11507766.017954756, 5019390.4309617635],
              [-11507944.017820533, 5070725.3599881055],
              [-11506987.115477676, 5077111.584352465],
              [-11425464.624104528, 5077319.175717012],
              [-11422424.600130454, 5070796.885079777],
              [-11422538.925247498, 5045084.83719922],
              [-11422516.661349341, 5019454.787742009],
              [-11423721.140961709, 5012669.591256442],
              [-11427331.355926355, 5012669.904191896],
              [-11474427.500254532, 5012673.986513086],
              [-11508486.327628251, 5012625.774185802],
              [-11507766.017954756, 5019390.4309617635],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '42127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8398015.6336695, 5050489.919512133],
              [-8400437.166552726, 5107441.201197088],
              [-8402745.740315804, 5160889.292440349],
              [-8402077.236610582, 5160890.6159395715],
              [-8389021.233565455, 5160033.667749798],
              [-8386935.670792372, 5159896.786188246],
              [-8381440.606768344, 5153057.374060929],
              [-8378239.392171603, 5143784.8358085],
              [-8370135.11060287, 5140397.93640011],
              [-8365288.47140127, 5138555.406693585],
              [-8361581.98884726, 5137146.565916557],
              [-8357245.315444427, 5131394.5160913095],
              [-8354909.721208094, 5123982.6130460445],
              [-8354447.745321301, 5107482.165026921],
              [-8354104.614780966, 5101808.777921755],
              [-8378540.734033179, 5067424.059947688],
              [-8387995.7663031975, 5066728.662451402],
              [-8383598.089819409, 5061352.444844918],
              [-8388945.989476608, 5047688.776991081],
              [-8405245.723277032, 5046701.855825369],
              [-8398015.6336695, 5050489.919512133],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sutter',
        GEOID: '06101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13570766.428569417, 4765293.434834701],
              [-13540687.568198603, 4765536.275636945],
              [-13539095.031563314, 4764105.642139784],
              [-13534881.58883679, 4734527.193865134],
              [-13537578.637459729, 4729961.049486129],
              [-13533713.290780915, 4709982.363722442],
              [-13530138.933251034, 4717719.452873829],
              [-13515831.373057844, 4721163.364764879],
              [-13515789.071651343, 4711107.86547839],
              [-13521906.85690687, 4711076.099034171],
              [-13523581.1020484, 4683726.000869276],
              [-13531982.606657552, 4683969.177608289],
              [-13536772.23906842, 4683902.959893301],
              [-13544668.35318937, 4684945.225253992],
              [-13553119.840249887, 4703244.982641254],
              [-13562664.484709993, 4710859.889525365],
              [-13558198.124100385, 4721053.647932859],
              [-13568632.656569893, 4732043.692206153],
              [-13574912.523004012, 4747465.376751602],
              [-13570766.428569417, 4765293.434834701],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Guernsey',
        GEOID: '39059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9096614.233842602, 4888079.329112021],
              [-9091562.889308874, 4887906.016235228],
              [-9086195.508740786, 4898154.464269166],
              [-9054511.08735426, 4897125.963164461],
              [-9054678.957146376, 4890968.275718254],
              [-9042028.498893138, 4890687.981941174],
              [-9042933.415033799, 4858863.493451874],
              [-9059848.745618308, 4858779.850715718],
              [-9068543.020488244, 4850630.384439559],
              [-9081287.09843324, 4851084.972608012],
              [-9081478.901915874, 4842588.784073637],
              [-9094150.733511345, 4843100.853304203],
              [-9093812.099620353, 4855885.026262413],
              [-9097987.359761536, 4856026.13266596],
              [-9096614.233842602, 4888079.329112021],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Muscogee',
        GEOID: '13215',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9470625.055210056, 3843396.2806657855],
              [-9452448.767275153, 3843338.3366109165],
              [-9451902.299894849, 3840141.2988877143],
              [-9428160.078898462, 3840208.9409373077],
              [-9425138.86791833, 3837567.35672969],
              [-9428149.726185815, 3831596.536907479],
              [-9436375.902596965, 3818647.240320377],
              [-9460058.377769614, 3813169.015309997],
              [-9459020.958692096, 3821582.0623911326],
              [-9462132.979249278, 3830056.64501703],
              [-9462282.601863671, 3830464.2462874507],
              [-9462947.085812887, 3832274.599729099],
              [-9469932.161221182, 3840103.382517163],
              [-9470625.055210056, 3843396.2806657855],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oglethorpe',
        GEOID: '13221',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9273650.406789249, 4003511.5754819135],
              [-9270234.456894767, 4008407.2721186746],
              [-9266330.148394175, 4015976.517731831],
              [-9270536.355353797, 4022324.397565321],
              [-9268284.139416069, 4028680.910215281],
              [-9253307.771722196, 4035189.6926252795],
              [-9244960.034427099, 4030924.31466803],
              [-9236878.79599296, 4034606.7592738457],
              [-9233091.03899923, 4030810.562661451],
              [-9214972.456038734, 4024925.3435558947],
              [-9225556.824542848, 4018302.076806705],
              [-9237995.441805108, 4000023.4297718904],
              [-9233845.562507825, 3993051.12157702],
              [-9239028.152721196, 3987731.545404336],
              [-9252734.587664101, 3988431.982782659],
              [-9270725.041890692, 3996858.7741092974],
              [-9273650.406789249, 4003511.5754819135],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pike',
        GEOID: '13231',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9410614.791315552, 3900180.2719996367],
              [-9406138.857229734, 3919734.6071054754],
              [-9401079.720331654, 3923063.4207012695],
              [-9378465.054457508, 3920420.0337366313],
              [-9378517.819896143, 3900525.527409776],
              [-9380800.982652314, 3899477.57592132],
              [-9380909.073877875, 3894110.8847604254],
              [-9405351.271832371, 3894471.62260718],
              [-9409504.82467285, 3891395.355163543],
              [-9410614.791315552, 3900180.2719996367],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Putnam',
        GEOID: '13237',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9298932.955579745, 3953115.8720551827],
              [-9270679.512218958, 3959649.486629912],
              [-9264516.085972209, 3945908.303327493],
              [-9257797.175466396, 3942523.6305672782],
              [-9255754.35149085, 3936529.932373695],
              [-9267732.885297662, 3929771.164068045],
              [-9270031.298824068, 3920183.129346],
              [-9279987.157483164, 3917757.165042645],
              [-9287283.816146193, 3919932.263355496],
              [-9288985.334562967, 3919877.7279852615],
              [-9300284.374197975, 3918148.956009283],
              [-9298932.955579745, 3953115.8720551827],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Screven',
        GEOID: '13251',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9113577.877086116, 3851996.9790996816],
              [-9102322.363372007, 3883285.9525443558],
              [-9077432.797354521, 3901198.798679645],
              [-9072764.478218105, 3897310.1332247984],
              [-9072490.186992792, 3887836.3803925132],
              [-9068538.679028101, 3881748.322415125],
              [-9063701.958472624, 3872923.0073767197],
              [-9062866.705532035, 3861407.92170064],
              [-9062816.968520818, 3860722.584942638],
              [-9060718.373480383, 3849400.492210686],
              [-9061084.391966112, 3843068.4920833036],
              [-9059948.477050025, 3842193.4365156675],
              [-9075674.258387951, 3831089.0713180583],
              [-9077882.503126819, 3827709.7771611633],
              [-9093649.461844305, 3835235.241623274],
              [-9109029.251372812, 3849307.544430062],
              [-9110499.002609756, 3848819.018679005],
              [-9113577.877086116, 3851996.9790996816],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'York',
        GEOID: '45091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9071093.127383336, 4168618.5368240876],
              [-9062394.622372748, 4170178.173926079],
              [-9057800.345724763, 4186203.033032396],
              [-9053401.676116984, 4185957.0799574098],
              [-9021651.020825466, 4184181.893473709],
              [-9021587.841463896, 4183844.3479624013],
              [-9020970.747417228, 4180547.96811625],
              [-9023338.512986401, 4173831.8262763466],
              [-9021497.288608681, 4169957.763835594],
              [-9009637.421379056, 4178487.1950109634],
              [-9006441.43368687, 4174103.085732383],
              [-9002257.161778444, 4157243.6534668235],
              [-9002039.198215472, 4143253.719354232],
              [-9005548.099884765, 4139547.8449544446],
              [-9070140.009903165, 4139651.3079424486],
              [-9067780.37065682, 4142061.3311004764],
              [-9071659.966230456, 4156946.6301050154],
              [-9071093.127383336, 4168618.5368240876],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Clair',
        GEOID: '29185',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10470520.391088601, 4584601.272447274],
              [-10469586.420560846, 4609698.975618769],
              [-10414718.602021713, 4607869.896275292],
              [-10410986.616092868, 4608739.982479146],
              [-10408069.600156121, 4607588.430177959],
              [-10408811.65588175, 4589760.796533616],
              [-10409719.688968148, 4567218.398728613],
              [-10416021.040063994, 4567413.542222251],
              [-10416521.198536128, 4555161.327391436],
              [-10422666.257066896, 4555358.640520443],
              [-10443037.501243087, 4556082.529889679],
              [-10442730.927365439, 4564289.570515729],
              [-10471343.042125564, 4565448.023639654],
              [-10470520.391088601, 4584601.272447274],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '39167',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9110928.473205235, 4786367.8713138085],
              [-9108512.283657568, 4792692.284428662],
              [-9095751.619108444, 4790774.3212657785],
              [-9096216.82326047, 4805833.066222264],
              [-9082355.208947401, 4806102.601259151],
              [-9069585.30488054, 4805574.660292832],
              [-9069550.684518903, 4814629.057716434],
              [-9060842.606032109, 4808207.997688603],
              [-9048390.519111466, 4808821.902248423],
              [-9020974.309640933, 4803957.066537825],
              [-9021038.21170263, 4799039.123194236],
              [-9025333.469580907, 4794941.169262824],
              [-9030378.898163617, 4787446.473703568],
              [-9031186.98236529, 4786246.630809155],
              [-9037578.168290205, 4783559.2446082225],
              [-9044607.103577875, 4777689.538734872],
              [-9055569.735711705, 4771321.87720498],
              [-9058110.359168721, 4771743.748999704],
              [-9060715.701812606, 4772176.385822555],
              [-9062820.976022488, 4778355.883751599],
              [-9067656.360744076, 4780467.27639964],
              [-9072893.497507935, 4775277.180360741],
              [-9079178.373319142, 4769163.4721147055],
              [-9079801.762467584, 4761308.8335979795],
              [-9085217.344375186, 4761188.613838109],
              [-9092390.215764452, 4760960.832963727],
              [-9096096.820849394, 4753122.929545875],
              [-9097192.220131414, 4751935.106034633],
              [-9097230.05326567, 4760362.9326670775],
              [-9107978.284060232, 4760792.013845335],
              [-9111908.64132167, 4767348.991045207],
              [-9110928.473205235, 4786367.8713138085],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '01099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9772158.790111398, 3674986.1550647337],
              [-9758886.83514106, 3687828.1087149223],
              [-9748663.364426097, 3689383.4503528667],
              [-9753796.417466067, 3700342.594193409],
              [-9747737.186262697, 3704851.7508801753],
              [-9747896.15049555, 3723617.6019166093],
              [-9742251.139117425, 3723710.364417437],
              [-9740558.971537875, 3740917.977680547],
              [-9674431.743102456, 3741098.3965035463],
              [-9674320.423611661, 3730936.112350133],
              [-9690484.124994338, 3726394.8964765426],
              [-9699829.507565923, 3716463.286547226],
              [-9703339.411110634, 3700409.453996023],
              [-9732379.77195184, 3666611.593368716],
              [-9747055.243062098, 3662302.519662465],
              [-9753356.260199469, 3664537.528889188],
              [-9764684.131582594, 3672178.4524369063],
              [-9769972.030034255, 3671425.6886996683],
              [-9772158.790111398, 3674986.1550647337],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'West Feliciana',
        GEOID: '22125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10201865.494231818, 3623528.107145272],
              [-10200977.721292743, 3632673.3000998115],
              [-10155016.797850963, 3632643.0408367757],
              [-10149681.491096154, 3632648.391697472],
              [-10154829.669786938, 3617273.481879132],
              [-10156214.595571896, 3610003.9665831593],
              [-10165774.490802241, 3593773.9372287854],
              [-10164589.494822748, 3587890.464576082],
              [-10166905.942106664, 3588500.7384034027],
              [-10172444.08677363, 3601464.708206096],
              [-10180209.95709035, 3598532.7283961177],
              [-10191635.4556669, 3597837.267929],
              [-10196263.674816122, 3600348.101694992],
              [-10190127.521844616, 3605665.18413223],
              [-10187468.433168035, 3616549.6074988493],
              [-10191222.349036567, 3621874.5267171585],
              [-10198491.511785366, 3622052.5521038733],
              [-10192012.606101707, 3613108.1166965687],
              [-10203697.256452825, 3614204.601070337],
              [-10201865.494231818, 3623528.107145272],
            ],
          ],
          [
            [
              [-10210647.15490203, 3638497.702294776],
              [-10200010.944711655, 3633411.103798285],
              [-10200977.721292743, 3632673.3000998115],
              [-10206579.763347425, 3635105.4516267627],
              [-10213576.527302254, 3635192.7405380383],
              [-10210647.15490203, 3638497.702294776],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Buchanan',
        GEOID: '51027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9162642.165292233, 4481015.059047233],
              [-9150656.395718522, 4491521.779065553],
              [-9124669.083231814, 4514336.368215123],
              [-9120659.57781242, 4510709.837000977],
              [-9126516.318862036, 4502623.055103962],
              [-9121179.551153917, 4497800.973449777],
              [-9120806.74217925, 4493498.370364107],
              [-9116621.129325423, 4485480.273538228],
              [-9111494.644135412, 4478938.674984134],
              [-9103123.195788775, 4477486.470982919],
              [-9099700.789363826, 4472966.193875962],
              [-9099149.983917011, 4472542.378889529],
              [-9101692.406373609, 4467290.306044338],
              [-9117165.592954893, 4458995.507681771],
              [-9129057.186239393, 4455828.455665428],
              [-9133245.248122018, 4445613.8419097485],
              [-9144826.593985677, 4444912.596110775],
              [-9145774.368130293, 4454530.325181975],
              [-9160815.635087298, 4481844.943640188],
              [-9163193.803789007, 4480488.928175628],
              [-9162642.165292233, 4481015.059047233],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monongalia',
        GEOID: '54061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8952467.96104828, 4825508.55885475],
              [-8914013.644829161, 4825531.860095889],
              [-8896210.35830054, 4825489.300422731],
              [-8879262.705429753, 4825448.786354502],
              [-8882101.686403455, 4811420.830603762],
              [-8894398.371314952, 4790943.067692989],
              [-8893835.985247465, 4784259.27373707],
              [-8898755.193545619, 4786692.099548605],
              [-8922650.367522359, 4809490.897389253],
              [-8944239.00164986, 4809669.929810777],
              [-8949620.631112771, 4813381.636833313],
              [-8950911.71456699, 4825011.140987139],
              [-8952467.96104828, 4825508.55885475],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pulaski',
        GEOID: '51155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9009156.187220357, 4455160.594455453],
              [-9000695.905920068, 4459683.861797833],
              [-8994780.722137786, 4464174.836140319],
              [-8973125.964232752, 4473293.830942098],
              [-8970792.373747254, 4464612.441600912],
              [-8962974.29458935, 4467288.069898407],
              [-8964532.09954351, 4457779.092156668],
              [-8966655.518830393, 4459554.678512893],
              [-8967190.408983655, 4459578.839158499],
              [-8969355.016482132, 4458621.672964255],
              [-8971557.806565946, 4456944.676626056],
              [-8971812.950838843, 4456561.978959974],
              [-8971951.209646411, 4455691.361983173],
              [-8971282.95874318, 4453333.824310753],
              [-8970176.776963165, 4451611.893539982],
              [-8966021.888288798, 4445864.337945236],
              [-8966109.608047543, 4436965.878176751],
              [-8968817.67730007, 4433626.388022993],
              [-8976134.373471439, 4429602.060102227],
              [-8981544.834682465, 4424501.27360792],
              [-8987989.453962961, 4422254.480196032],
              [-9004995.287293486, 4442926.542924044],
              [-9007157.668402145, 4449335.629330964],
              [-9009156.187220357, 4455160.594455453],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oconto',
        GEOID: '55083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9871589.35928795, 5681335.692909649],
              [-9843771.286455655, 5681070.55907833],
              [-9830157.914607055, 5680690.225378979],
              [-9830519.925591115, 5653312.153588941],
              [-9816860.133514855, 5652742.472887896],
              [-9817182.069482228, 5639146.253931867],
              [-9809348.739554087, 5638886.463613803],
              [-9809601.768756662, 5625234.596277106],
              [-9789929.833621636, 5620428.519157912],
              [-9769692.227489054, 5615659.482780225],
              [-9775297.220515335, 5614284.67728384],
              [-9778686.231093043, 5609620.580047726],
              [-9778121.395996759, 5601705.085942193],
              [-9779938.352725487, 5599158.163586807],
              [-9785482.397325464, 5593028.136169821],
              [-9789597.7675806, 5583202.666547855],
              [-9794277.75029304, 5577579.107722063],
              [-9795845.06264889, 5570918.213384117],
              [-9821119.217232605, 5570088.5390556455],
              [-9823130.98307022, 5571226.164532435],
              [-9823746.134576343, 5598367.971892104],
              [-9850567.007410113, 5598792.895489422],
              [-9849963.989728484, 5639941.7605289975],
              [-9867488.683205599, 5640014.168843661],
              [-9871819.790633893, 5653851.5351485945],
              [-9871589.35928795, 5681335.692909649],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scott',
        GEOID: '27139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10453176.146506066, 5556836.875015392],
              [-10438210.354163816, 5565071.194740662],
              [-10421523.785132887, 5575527.011156158],
              [-10418862.470066493, 5586359.651366068],
              [-10417129.11427535, 5589207.604683165],
              [-10410646.757687477, 5590759.1578940805],
              [-10401480.488176575, 5592131.147026954],
              [-10389405.217732266, 5588691.995670777],
              [-10388129.719006758, 5577162.384877596],
              [-10388193.616394473, 5563549.8416695455],
              [-10383678.275208917, 5563576.903101055],
              [-10384051.418142054, 5550010.314621336],
              [-10392532.07090916, 5550017.96799812],
              [-10411080.458423607, 5549957.365925748],
              [-10454058.46479009, 5549886.299577073],
              [-10453176.146506066, 5556836.875015392],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stanley',
        GEOID: '46117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11260544.019257857, 5518699.447708437],
              [-11260469.212560045, 5572841.346222089],
              [-11258501.3066018, 5581799.114174811],
              [-11245785.615126956, 5578199.057569045],
              [-11233284.547630364, 5587539.314952661],
              [-11211836.843978206, 5585530.90492743],
              [-11200277.539373722, 5575533.119761952],
              [-11201067.017202428, 5553562.954945582],
              [-11190558.568591034, 5550551.533573465],
              [-11196518.168850143, 5537193.698930289],
              [-11174960.258902099, 5533788.8547770735],
              [-11172624.108068312, 5520626.197142188],
              [-11141447.971476747, 5513300.427540387],
              [-11119937.817590253, 5502950.445018773],
              [-11125071.427227674, 5495698.915906627],
              [-11172830.828362714, 5495609.794800774],
              [-11172826.37558308, 5491585.18924896],
              [-11248491.235350687, 5491552.598518631],
              [-11261831.429168882, 5491490.676450677],
              [-11260544.019257857, 5518699.447708437],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hamilton',
        GEOID: '39061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9442136.9088845, 4754272.065357963],
              [-9441994.249536768, 4765475.504976539],
              [-9441994.208185507, 4765478.75421418],
              [-9420973.73785081, 4766470.001285061],
              [-9390156.27265858, 4763626.076555594],
              [-9380057.479773305, 4763057.21537711],
              [-9379716.953450968, 4760535.339429881],
              [-9386462.580634568, 4753727.154326263],
              [-9382929.299996791, 4748419.5477206195],
              [-9384158.26717515, 4746690.502327435],
              [-9386593.8515678, 4724620.820098309],
              [-9387187.381839124, 4725606.175487204],
              [-9395469.663273634, 4728314.708706724],
              [-9399031.99829851, 4733705.411138857],
              [-9400401.339354757, 4738080.415694686],
              [-9402271.506800085, 4739127.685252116],
              [-9404375.55649557, 4738410.2673570765],
              [-9405800.445977723, 4736358.733133344],
              [-9406406.562872164, 4736316.329709942],
              [-9407222.634563707, 4736259.23830802],
              [-9412156.90022151, 4735914.04983513],
              [-9418511.462033954, 4732167.723761367],
              [-9420081.03163931, 4732897.539971056],
              [-9426228.017816251, 4735756.263687311],
              [-9430324.686396934, 4740691.689269464],
              [-9434410.22302854, 4742801.375843784],
              [-9442136.68624552, 4736791.95953798],
              [-9442136.9088845, 4754272.065357963],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Alleghany',
        GEOID: '51005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8937845.679532306, 4535181.811339038],
              [-8934295.610773733, 4540032.494283863],
              [-8929895.485261148, 4548857.170083411],
              [-8927782.307367418, 4555086.913126375],
              [-8920245.755201733, 4563827.607780359],
              [-8911772.18175197, 4572630.047911998],
              [-8898364.01685497, 4572981.122208274],
              [-8893016.785114715, 4564317.21840293],
              [-8877708.68533828, 4563249.583809364],
              [-8871361.136653755, 4557476.187016228],
              [-8866329.050391937, 4561717.369423462],
              [-8861737.344035696, 4559964.992909321],
              [-8869287.143220786, 4546012.645171129],
              [-8885156.738508785, 4551347.999854955],
              [-8896382.084640888, 4537392.133663428],
              [-8907847.324275648, 4529740.2144412575],
              [-8921763.485139208, 4522570.452550619],
              [-8930528.58640919, 4526443.735129526],
              [-8938093.275202146, 4534843.58988754],
              [-8937845.679532306, 4535181.811339038],
            ],
            [
              [-8904731.714367328, 4543921.926101453],
              [-8901831.062395727, 4545170.055603974],
              [-8903332.98496551, 4548543.358232313],
              [-8901893.623949554, 4551690.6377183],
              [-8904156.860516872, 4553124.992697461],
              [-8906115.52695738, 4546331.027723459],
              [-8904731.714367328, 4543921.926101453],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Neshoba',
        GEOID: '28099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9942963.7432414, 3886235.6847943463],
              [-9909407.595936675, 3886192.18202963],
              [-9899698.53258867, 3884589.3237086134],
              [-9897907.179342823, 3885565.3887572326],
              [-9897918.645250374, 3839285.501786144],
              [-9942788.415043402, 3839219.846550536],
              [-9942963.7432414, 3886235.6847943463],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bowie',
        GEOID: '48037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10547087.161370613, 3988671.09123438],
              [-10545510.532512743, 3991377.7010005424],
              [-10543610.542353647, 3989561.737046739],
              [-10534228.646989081, 3985031.6147176987],
              [-10527803.953897439, 3984561.445823553],
              [-10522912.13019402, 3978136.703653604],
              [-10518119.492156897, 3980279.4459485323],
              [-10510681.34642107, 3972172.8952257116],
              [-10507229.885609027, 3970608.9135489133],
              [-10503457.602024516, 3969398.730180507],
              [-10501705.099280955, 3970818.794891879],
              [-10497844.539340246, 3970471.97838484],
              [-10490622.798694523, 3972106.756390769],
              [-10487810.534398612, 3971291.7432971126],
              [-10484447.572581748, 3974176.6141033834],
              [-10479953.493418932, 3972240.771434541],
              [-10472121.721963663, 3971507.114929089],
              [-10468911.685052494, 3968765.8004061896],
              [-10468866.517413884, 3968727.2326910845],
              [-10468817.536837937, 3953296.2221395494],
              [-10468826.331077708, 3939254.659487582],
              [-10468812.844407033, 3931362.40460824],
              [-10488357.335737389, 3934783.901314192],
              [-10489784.006331395, 3927346.2627621586],
              [-10506267.751250101, 3929286.729093771],
              [-10510311.98835062, 3933063.4336687624],
              [-10521680.936625846, 3932807.629246072],
              [-10527758.424225705, 3928511.329009915],
              [-10536641.385632535, 3931045.381637182],
              [-10541045.852605263, 3936844.2964589535],
              [-10547179.44522848, 3939046.815403093],
              [-10547087.161370613, 3988671.09123438],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Unicoi',
        GEOID: '47171',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9194491.784803096, 4304201.1736779725],
              [-9195624.862573624, 4305741.086249223],
              [-9194440.577837331, 4313867.119013872],
              [-9186930.964988418, 4321136.203183273],
              [-9175026.013365021, 4323101.704155193],
              [-9166098.07888391, 4335463.215249499],
              [-9159889.90220186, 4335308.470910833],
              [-9152716.697999222, 4321807.466491505],
              [-9157774.720557297, 4318195.099068025],
              [-9161333.048080504, 4319007.727071129],
              [-9166810.189666515, 4316485.554399044],
              [-9173778.901109666, 4312104.39958511],
              [-9174611.525780024, 4310666.583839571],
              [-9179912.605052374, 4301516.899762083],
              [-9184749.399047824, 4298146.699015091],
              [-9190300.494655238, 4294280.073309946],
              [-9196201.652181681, 4297105.20028898],
              [-9194491.784803096, 4304201.1736779725],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crook',
        GEOID: '56011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11698058.8951015, 5588019.881374026],
              [-11697073.712292919, 5621568.182023334],
              [-11692804.747414116, 5621567.404252018],
              [-11691359.131548109, 5621567.140872361],
              [-11583649.954480242, 5621117.058786711],
              [-11583439.783281624, 5573059.940793378],
              [-11583427.003721816, 5554233.673697692],
              [-11583392.917776, 5504209.478518109],
              [-11583394.852266854, 5493399.414850754],
              [-11619025.730181472, 5493591.7601842545],
              [-11697372.053843306, 5492747.357419419],
              [-11698058.8951015, 5588019.881374026],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '47179',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9203970.862083126, 4360200.211093934],
              [-9195154.024453826, 4359010.38129999],
              [-9175127.425421134, 4362338.638894455],
              [-9161578.396238213, 4355317.90570938],
              [-9161590.530062709, 4351810.5717078755],
              [-9166098.07888391, 4335463.215249499],
              [-9175026.013365021, 4323101.704155193],
              [-9186930.964988418, 4321136.203183273],
              [-9194440.577837331, 4313867.119013872],
              [-9200307.5602801, 4320785.081222844],
              [-9198529.231414678, 4358397.393692569],
              [-9206407.534417098, 4357241.375703985],
              [-9203970.862083126, 4360200.211093934],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lexington',
        GEOID: '45063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9069418.436963841, 4039085.726995614],
              [-9060752.437244566, 4038405.1619126196],
              [-9065544.518684234, 4046266.2600718453],
              [-9054611.720173938, 4055364.0900589675],
              [-9047585.67919303, 4041885.4223902533],
              [-9032383.555571828, 4037982.248302111],
              [-9022679.612920398, 4028481.917672612],
              [-9018251.323576638, 4012711.0438139364],
              [-9023393.282175872, 3994887.7837533085],
              [-9018437.561084738, 3999465.7249134206],
              [-9008526.230221957, 3996193.1705363677],
              [-9021649.239713613, 3989544.3409598884],
              [-9026522.695701052, 3987975.8573969225],
              [-9037725.666615507, 3982294.605196047],
              [-9063403.510917809, 3993199.7035874766],
              [-9080496.173451152, 4012328.903483729],
              [-9069418.436963841, 4039085.726995614],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '45067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8855235.06125897, 4059850.304381068],
              [-8847752.387726828, 4067550.1718802922],
              [-8836570.567515625, 4069233.26197101],
              [-8818097.765935427, 4063166.4998511043],
              [-8808507.035206132, 4062912.3576334016],
              [-8808341.837081794, 4060449.345457262],
              [-8817370.515702074, 4049482.7097522696],
              [-8821799.584282266, 4036494.4482896365],
              [-8827896.218834542, 4033129.0715465923],
              [-8831985.540328832, 4024737.1547106057],
              [-8829012.864646688, 4021419.3928053537],
              [-8822743.016966738, 4011635.451940403],
              [-8823214.343690759, 4003968.452614383],
              [-8815419.864264904, 3989364.4937282917],
              [-8821667.11408822, 3987967.561942916],
              [-8829532.615349203, 3999283.177556388],
              [-8830342.575964214, 4001860.940382535],
              [-8851785.270239286, 4027993.7158567477],
              [-8851603.59683031, 4041862.0316163395],
              [-8857896.042366892, 4053493.7202564813],
              [-8855235.06125897, 4059850.304381068],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Polk',
        GEOID: '55095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10340099.825358238, 5723505.920361307],
              [-10300293.074796325, 5723176.002525783],
              [-10300191.885379193, 5736976.095398411],
              [-10258585.669097755, 5736487.491187743],
              [-10258635.206271157, 5722804.38189335],
              [-10258810.757108137, 5654572.024985373],
              [-10326674.058495825, 5654645.926243057],
              [-10326203.910792857, 5666491.240840288],
              [-10324689.92950427, 5668251.020482905],
              [-10319201.80350247, 5674633.051271212],
              [-10314695.479195667, 5684089.713521362],
              [-10313391.037402552, 5690729.948434403],
              [-10317846.600021552, 5696179.853752965],
              [-10322436.302626958, 5704657.751108271],
              [-10325651.543479541, 5709719.479927764],
              [-10330616.058810448, 5710570.879711551],
              [-10339480.76382079, 5712249.273241015],
              [-10340236.957121748, 5722687.198820384],
              [-10340099.825358238, 5723505.920361307],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mercer',
        GEOID: '38057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11377447.518348303, 6036357.470510996],
              [-11358667.697612496, 6036060.296225846],
              [-11333865.715063753, 6023495.76020922],
              [-11322031.22867803, 6030381.627454737],
              [-11314701.842084711, 6028749.496338121],
              [-11290917.431001311, 6034291.8173514],
              [-11284553.18439317, 6027153.276953633],
              [-11292264.61947889, 6020332.400200519],
              [-11283625.893034862, 6002348.940797694],
              [-11281755.614270044, 5989849.924119108],
              [-11271881.130158717, 5985419.372449473],
              [-11328363.303953335, 5981569.867238412],
              [-11328360.298327083, 5939023.2694536075],
              [-11365349.872686345, 5938999.283736041],
              [-11370703.894915538, 5943756.599470107],
              [-11370668.495317465, 5995790.2996956855],
              [-11377475.459540492, 5995788.985802782],
              [-11377447.518348303, 6036357.470510996],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carbon',
        GEOID: '30009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12222732.368137155, 5647904.170088413],
              [-12210389.151678506, 5647904.170088413],
              [-12210396.387445407, 5662774.196350402],
              [-12201562.85189249, 5662774.987114572],
              [-12201599.253365979, 5669639.388268754],
              [-12191809.038109183, 5683422.964738564],
              [-12173500.655416885, 5694918.7264605425],
              [-12155171.233340828, 5694946.978844814],
              [-12155147.856247762, 5704251.468511351],
              [-12148098.438173786, 5704240.346447301],
              [-12148046.340652095, 5714501.089889909],
              [-12141449.658947177, 5713812.983392762],
              [-12130797.71951215, 5719113.217617811],
              [-12116349.117524128, 5718236.018618195],
              [-12109556.847473886, 5722628.767075161],
              [-12111756.631931452, 5708839.705902305],
              [-12100348.833153937, 5704177.427602683],
              [-12094342.256069714, 5694878.570135278],
              [-12098449.722641004, 5689968.95236389],
              [-12100386.347822335, 5676624.199067135],
              [-12100385.902544372, 5655860.6766136475],
              [-12033420.32702379, 5656304.439040549],
              [-12046718.998671917, 5636350.155667881],
              [-12051292.559951158, 5622809.351716724],
              [-12050170.702751337, 5621620.640173655],
              [-12078240.337004432, 5621472.840597347],
              [-12091689.34503822, 5621470.537576799],
              [-12140755.47060259, 5621462.135453146],
              [-12145339.941191928, 5622450.998051545],
              [-12197757.617738703, 5621935.692805386],
              [-12222711.303420976, 5621981.24068036],
              [-12222732.368137155, 5647904.170088413],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Knox',
        GEOID: '47093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9381212.86476825, 4292438.174307781],
              [-9372561.336582776, 4299659.326272706],
              [-9357358.879003102, 4305617.896968046],
              [-9361302.483283946, 4310107.566924913],
              [-9344348.52483613, 4326297.09540338],
              [-9340280.688003562, 4322784.436861629],
              [-9321081.9720239, 4323291.434722181],
              [-9317375.144299975, 4315694.611015034],
              [-9313819.043166583, 4311715.692168683],
              [-9318471.084686834, 4313457.821831154],
              [-9314468.815034345, 4305918.279305213],
              [-9311981.937610023, 4298745.791952301],
              [-9327936.024391534, 4285101.040697838],
              [-9334156.557537062, 4278905.147237873],
              [-9350244.672985487, 4284637.181235594],
              [-9352671.883162744, 4278558.959235135],
              [-9367051.912344437, 4279944.326617271],
              [-9366900.74047594, 4272554.944513689],
              [-9369345.984410703, 4273837.289588138],
              [-9370852.248440629, 4275913.682588433],
              [-9380156.888078583, 4286449.725492009],
              [-9381070.153181054, 4288267.244840193],
              [-9381212.86476825, 4292438.174307781],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Addison',
        GEOID: '50001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8172667.246996535, 5480840.879957023],
              [-8170835.993434873, 5489070.09201064],
              [-8170338.44324914, 5491307.240602483],
              [-8165272.293223137, 5501159.783330279],
              [-8161568.582444955, 5505419.569722388],
              [-8161661.865357972, 5506313.8268518355],
              [-8123352.601255624, 5510962.4550246075],
              [-8122454.475603905, 5501155.122629471],
              [-8120998.082705857, 5490433.254958671],
              [-8118895.702802733, 5489304.58374388],
              [-8116194.869317109, 5476682.068671946],
              [-8112889.2370380005, 5476100.744769119],
              [-8097636.129090015, 5470032.510336475],
              [-8103094.457682083, 5459541.053039565],
              [-8111326.2000677725, 5444058.031103355],
              [-8112581.104687485, 5450407.152579587],
              [-8124114.026572651, 5447290.193317262],
              [-8121742.364821299, 5438638.279487557],
              [-8128196.446258512, 5435307.657880666],
              [-8129655.51082434, 5441751.692293872],
              [-8150696.898335102, 5440297.0200077705],
              [-8149290.48788842, 5429420.729752799],
              [-8166521.092156276, 5427333.569039473],
              [-8165363.352566607, 5429989.243797977],
              [-8168905.444090864, 5435802.1824700525],
              [-8169771.047804565, 5437223.2854228215],
              [-8167961.994759684, 5446205.421620373],
              [-8171712.459724002, 5454598.4382441435],
              [-8172102.745858722, 5461666.384474398],
              [-8171515.980822751, 5467219.685579509],
              [-8174956.087046736, 5472033.592865061],
              [-8172667.246996535, 5480840.879957023],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hillsborough',
        GEOID: '33011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8021454.190287676, 5314852.411918372],
              [-8019275.779172343, 5328353.357845629],
              [-8019250.064369969, 5331598.181745405],
              [-8018960.077096453, 5339453.14061428],
              [-8016013.450175155, 5340613.267655181],
              [-8005342.475107202, 5343547.740581753],
              [-7993883.469363925, 5330906.329750961],
              [-7985232.052497944, 5333272.962730402],
              [-7978019.774008938, 5335217.9714804115],
              [-7975072.033892732, 5320220.40664717],
              [-7961288.009264747, 5322466.387970472],
              [-7960764.807658017, 5319526.807551998],
              [-7947364.278675814, 5313388.879021677],
              [-7945671.999776774, 5303930.234217882],
              [-7953906.079871773, 5301460.029672026],
              [-7952920.568419779, 5295304.308431053],
              [-7951224.727297033, 5285348.5983453905],
              [-7943834.44894225, 5281421.703387038],
              [-7944250.672518327, 5279339.64969661],
              [-7930999.871915956, 5271958.462025932],
              [-7932082.575178589, 5271934.473545108],
              [-7932137.664766639, 5271933.2529763775],
              [-7936434.597111258, 5265963.775338211],
              [-7942854.280825815, 5266140.082655446],
              [-7974506.864837975, 5267160.124740512],
              [-7986707.81498739, 5267523.543356648],
              [-7993339.406789446, 5267770.164521471],
              [-8003734.328355301, 5268156.75254694],
              [-8007102.999427905, 5268282.037123322],
              [-8012188.067193535, 5279971.422659015],
              [-8015138.590297012, 5299718.277179184],
              [-8021929.858471835, 5303573.006436843],
              [-8021454.190287676, 5314852.411918372],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '48245',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10513559.28921655, 3518085.1555058914],
              [-10496607.445839059, 3518684.338521032],
              [-10494695.199626213, 3525454.6503988774],
              [-10483673.345523281, 3527730.725734584],
              [-10476935.955982, 3524177.651521202],
              [-10467591.686605321, 3507151.161912891],
              [-10448466.218850601, 3500644.7693518843],
              [-10446378.644439753, 3497034.623019866],
              [-10447591.344603593, 3487118.9077144708],
              [-10449832.88823907, 3484495.051645579],
              [-10456151.605175478, 3478246.2234894754],
              [-10451878.383882396, 3472951.7682202994],
              [-10448804.07350516, 3468129.2857918125],
              [-10445995.148793971, 3463843.4685960077],
              [-10448591.11931927, 3462355.557381064],
              [-10459787.188425295, 3462766.343110653],
              [-10470322.353714481, 3461350.5585658615],
              [-10482015.686985878, 3456921.6308013652],
              [-10503452.875945926, 3447385.5206345734],
              [-10503881.840603927, 3489092.576333437],
              [-10513261.509578679, 3489358.871007654],
              [-10513559.28921655, 3518085.1555058914],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Garfield',
        GEOID: '08045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12139509.231790349, 4793221.250607766],
              [-12139487.53328266, 4816724.938967974],
              [-12122216.990522824, 4815259.549483497],
              [-12084245.800893746, 4815234.537243347],
              [-12084256.376245372, 4821522.242198008],
              [-12015663.977686336, 4821641.4512037],
              [-12015659.07962874, 4840543.669394432],
              [-11959249.931420084, 4841033.745440716],
              [-11959238.242873551, 4853993.4938500635],
              [-11946668.71389012, 4853593.343924474],
              [-11946473.014225304, 4879140.781518308],
              [-11915344.745014781, 4879253.262066305],
              [-11914753.304560196, 4866369.376165356],
              [-11914966.815343538, 4854165.924682105],
              [-11923839.424037725, 4854194.808590418],
              [-11923814.265832806, 4774243.859915214],
              [-11959158.538118143, 4774259.986731878],
              [-12034306.541489994, 4774256.0990147805],
              [-12139526.707252115, 4774331.916909256],
              [-12139509.231790349, 4793221.250607766],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cass',
        GEOID: '19029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10592575.199615505, 5087148.20670213],
              [-10579890.12100063, 5087070.763020055],
              [-10542025.798082715, 5086990.198468921],
              [-10542021.345303085, 5035687.202682469],
              [-10567290.647074176, 5035749.74553114],
              [-10592700.879320612, 5035857.385232355],
              [-10592575.199615505, 5087148.20670213],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Lucie',
        GEOID: '12111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8981236.591012457, 3193420.145114248],
              [-8940812.655808514, 3193278.2589531983],
              [-8933797.12209396, 3171002.1497834683],
              [-8927602.899606047, 3156369.826976966],
              [-8937259.826174576, 3156459.266790031],
              [-8937342.091278274, 3149235.51470901],
              [-8981018.516129995, 3149230.8835337497],
              [-8981236.591012457, 3193420.145114248],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sebastian',
        GEOID: '05131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10513338.41595022, 4172378.735955809],
              [-10512491.290021881, 4201437.395239965],
              [-10512068.164637374, 4214221.206552588],
              [-10512335.158183493, 4216510.913620293],
              [-10512443.78861443, 4217442.65239866],
              [-10509189.55392495, 4225104.133532306],
              [-10502156.945094086, 4214527.278435595],
              [-10491009.299966559, 4212261.838027389],
              [-10490054.735333005, 4212102.826952168],
              [-10479072.844927266, 4218270.316198768],
              [-10479888.148877837, 4225236.548644092],
              [-10472369.407830678, 4224575.5821794],
              [-10472918.769517742, 4202938.382443925],
              [-10471253.763893947, 4191072.9633622593],
              [-10467209.97207139, 4192977.343914998],
              [-10467221.771937415, 4192746.3974852026],
              [-10467509.310182134, 4183039.5614455915],
              [-10479539.718871655, 4183380.438093276],
              [-10479680.426708015, 4177435.25014463],
              [-10489440.140424335, 4171710.8316674596],
              [-10489693.948863344, 4159604.9111945736],
              [-10513848.668216357, 4154912.3908687956],
              [-10513338.41595022, 4172378.735955809],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Parke',
        GEOID: '18121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9731574.486755442, 4859035.137522456],
              [-9694926.440593934, 4859116.023277697],
              [-9694986.107840998, 4846672.29731584],
              [-9685850.673829047, 4846591.0776398415],
              [-9686249.754203541, 4808676.116371317],
              [-9706949.61351655, 4809015.66060188],
              [-9727366.276044983, 4809131.252756423],
              [-9728876.213618102, 4815625.19798928],
              [-9724187.54798538, 4845919.880408967],
              [-9731574.486755442, 4859035.137522456],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grand',
        GEOID: '08049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11872458.799867181, 4930854.548120501],
              [-11868029.286009027, 4921227.31444553],
              [-11854394.986096157, 4925933.171676749],
              [-11849227.312694553, 4916428.034929483],
              [-11839246.184511045, 4918035.27743485],
              [-11825477.74461177, 4913047.152148498],
              [-11801939.01564455, 4920337.700610694],
              [-11795375.284508906, 4916664.072658419],
              [-11789298.242187012, 4924067.514994891],
              [-11787816.13448659, 4935453.0613046745],
              [-11783716.460279655, 4936856.746049375],
              [-11778419.322310256, 4935140.768355546],
              [-11779309.766917113, 4927381.850576295],
              [-11761273.894338278, 4903863.681537658],
              [-11759657.090053994, 4871580.302524867],
              [-11765768.196140073, 4857576.257454251],
              [-11763776.022532837, 4856130.22169848],
              [-11766438.896072103, 4850187.714176815],
              [-11765395.72112388, 4844457.99316865],
              [-11770525.100620652, 4837616.905640511],
              [-11787330.892826222, 4836485.995041987],
              [-11791474.53823202, 4822293.653818623],
              [-11801311.73031393, 4820466.349791253],
              [-11809184.689980794, 4837785.430278034],
              [-11827921.541393155, 4853556.188999692],
              [-11848235.233392602, 4855036.978337717],
              [-11869615.366113849, 4855018.253001949],
              [-11870779.990626529, 4866248.322403403],
              [-11870248.55137748, 4915701.553299649],
              [-11872458.799867181, 4930854.548120501],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Custer',
        GEOID: '40039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11062465.34560554, 4274809.40848307],
              [-10979662.346129796, 4274838.784789203],
              [-10979684.610027956, 4241071.177102527],
              [-10978678.727109147, 4239095.935135358],
              [-10978699.543853926, 4227147.794706154],
              [-11061174.039512336, 4227298.549236616],
              [-11061165.579231035, 4233240.854249962],
              [-11062602.82517667, 4239115.637905632],
              [-11062465.34560554, 4274809.40848307],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Broadwater',
        GEOID: '30007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12444177.559504434, 5872080.77249543],
              [-12426806.932202581, 5872162.868972959],
              [-12427625.687057367, 5899442.605106825],
              [-12423536.365563074, 5905955.105810032],
              [-12411911.159820043, 5903394.1478178585],
              [-12407158.040202152, 5900149.696603894],
              [-12402237.607389597, 5883505.713326079],
              [-12393280.061923934, 5882498.743604229],
              [-12394862.691124542, 5868272.307097736],
              [-12385114.665954757, 5860594.830226771],
              [-12383905.847604234, 5850836.616607665],
              [-12370391.995380403, 5851102.506346241],
              [-12362833.847233502, 5845232.831622109],
              [-12370584.244141001, 5824223.022802344],
              [-12364827.245355137, 5820631.429195972],
              [-12363360.388424953, 5811305.036925197],
              [-12395052.602175837, 5810493.134087544],
              [-12395355.391190793, 5800018.89430757],
              [-12403644.129155772, 5790282.475370036],
              [-12403175.140141059, 5779759.837766914],
              [-12421885.49751461, 5765407.5353368465],
              [-12429940.6871879, 5753707.506437382],
              [-12429981.318802042, 5788235.780068217],
              [-12443800.85434759, 5788335.384905051],
              [-12444177.559504434, 5872080.77249543],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sampson',
        GEOID: '37163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8757759.48497973, 4175476.539085094],
              [-8754106.64720884, 4179625.519649807],
              [-8751618.545270119, 4197304.495793347],
              [-8747869.750098163, 4204285.721896106],
              [-8742849.018424407, 4206963.568238389],
              [-8737694.146764243, 4199736.877452986],
              [-8728754.301097615, 4198542.908255679],
              [-8717048.61136274, 4203034.391475383],
              [-8710329.032939987, 4194635.667284217],
              [-8702237.775751676, 4192094.7321717646],
              [-8701112.113060774, 4189692.77162945],
              [-8699298.60723626, 4150639.979147408],
              [-8705033.008165495, 4128825.839016222],
              [-8695611.483062208, 4126138.17294557],
              [-8695610.14722832, 4124117.7686890345],
              [-8711244.52443227, 4103380.756189694],
              [-8724594.18040718, 4123284.4699383406],
              [-8726555.073237503, 4128775.444420739],
              [-8726418.15026383, 4129886.074698991],
              [-8737990.590568224, 4144353.9871736704],
              [-8754947.665961782, 4162828.543422291],
              [-8757759.48497973, 4175476.539085094],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Caldwell',
        GEOID: '48055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10898093.323209498, 3485256.570319229],
              [-10877311.087473301, 3506199.727728516],
              [-10877051.37910128, 3506699.3503929777],
              [-10872102.782457555, 3511761.3522540103],
              [-10870278.144683965, 3512286.4043184766],
              [-10833147.86248834, 3476141.0829271944],
              [-10833378.293834282, 3475899.560936347],
              [-10864531.05333278, 3456169.8568619187],
              [-10868475.436850058, 3458621.928549703],
              [-10883519.820752805, 3467465.8135355995],
              [-10884921.889739348, 3472642.0872589266],
              [-10886978.962609716, 3471744.759891253],
              [-10895423.993139766, 3485336.7936136797],
              [-10898093.323209498, 3485256.570319229],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Winston',
        GEOID: '01133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9755452.96280856, 4070099.091090015],
              [-9743764.082316795, 4069775.7955498626],
              [-9697030.935567379, 4069061.7211218067],
              [-9697262.591427721, 4027779.563512059],
              [-9701608.949626252, 4027892.3454370154],
              [-9703726.02370216, 4029500.817595707],
              [-9708922.52885188, 4027983.9144390775],
              [-9755608.030859236, 4029097.8390462818],
              [-9755452.96280856, 4070099.091090015],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bayfield',
        GEOID: '55007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10191448.721190345, 5902577.323480247],
              [-10186966.49358405, 5902573.701031437],
              [-10175914.917177074, 5907805.306245858],
              [-10170238.17974407, 5909186.749494225],
              [-10165118.70768198, 5913853.172011167],
              [-10158649.932071982, 5915490.401143857],
              [-10153634.098455818, 5920363.386539814],
              [-10148730.920164337, 5916771.662940447],
              [-10144598.072749145, 5920881.820961586],
              [-10139798.198945124, 5922422.814370354],
              [-10133916.188371096, 5926264.186115171],
              [-10128361.234461023, 5929938.868755549],
              [-10128890.892598215, 5939181.217866657],
              [-10121627.629782427, 5942382.247530064],
              [-10113691.885922758, 5935964.72500971],
              [-10108508.850431422, 5932080.281224175],
              [-10101721.144480303, 5924830.682236454],
              [-10107691.320091037, 5913254.135340135],
              [-10114605.373664206, 5903902.639170776],
              [-10116808.942984458, 5899731.250081393],
              [-10113676.746472009, 5893175.328578688],
              [-10120628.426033067, 5886495.040093562],
              [-10122573.622815188, 5879829.236249184],
              [-10125136.642771212, 5875811.998608824],
              [-10121750.236551128, 5874999.64774979],
              [-10121678.280150738, 5805161.2568002585],
              [-10191442.093711391, 5805551.6065721745],
              [-10191514.89665837, 5901055.857794163],
              [-10191448.721190345, 5902577.323480247],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Winnebago',
        GEOID: '55139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9894819.17666822, 5503065.587632206],
              [-9881408.18365388, 5503181.197869165],
              [-9878466.009512214, 5503171.408235988],
              [-9854534.656700965, 5503284.067346904],
              [-9841096.056452911, 5503295.5664239],
              [-9841109.080833334, 5455883.466479493],
              [-9840998.651898468, 5448895.037474354],
              [-9894710.528845204, 5449235.967756425],
              [-9894765.743312636, 5462847.817984794],
              [-9894819.17666822, 5503065.587632206],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Columbia',
        GEOID: '36021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8227698.705187134, 5180066.4311056435],
              [-8213912.565488823, 5201962.702306407],
              [-8213566.250552965, 5230774.664129046],
              [-8165565.95403985, 5237684.0793805905],
              [-8169014.482394121, 5224953.950698474],
              [-8172035.554240882, 5213815.832932117],
              [-8182888.936599645, 5173909.094457056],
              [-8180833.749707664, 5169041.489660893],
              [-8184996.2145603625, 5157681.525340629],
              [-8205463.193498632, 5161801.555287227],
              [-8229808.320857159, 5172787.320687757],
              [-8227698.705187134, 5180066.4311056435],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Centre',
        GEOID: '42027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8724834.07390984, 4976185.433469578],
              [-8715029.387119241, 4990204.577850712],
              [-8710663.325370839, 4991034.033926524],
              [-8701636.20522343, 5006570.972845684],
              [-8691574.259089608, 5006270.109034695],
              [-8689184.89753922, 5012956.757353838],
              [-8695414.670202484, 5029203.2703295965],
              [-8687173.020382114, 5035028.9747668],
              [-8671587.401115129, 5049694.311971307],
              [-8670978.372180998, 5038670.487781978],
              [-8660496.08364994, 5039216.40386651],
              [-8654189.945815993, 5028227.685794385],
              [-8640814.6863582, 5025800.748355776],
              [-8628849.622209774, 5007853.101920397],
              [-8628041.999304071, 5006915.628859985],
              [-8609441.068989968, 5010448.983508869],
              [-8587648.608874822, 5018883.710017965],
              [-8602685.200413214, 4999033.017446107],
              [-8612141.123239158, 4989791.053537978],
              [-8644244.996466994, 4974790.061920715],
              [-8647446.545022208, 4972562.3768918635],
              [-8663384.379158063, 4974607.86720125],
              [-8676714.220263613, 4966952.293805868],
              [-8692411.715618845, 4972733.075146412],
              [-8695891.340262061, 4973938.7715443745],
              [-8700037.657335639, 4974385.271005077],
              [-8722985.502445726, 4972978.697831102],
              [-8724834.07390984, 4976185.433469578],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Big Horn',
        GEOID: '56003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12091689.34503822, 5621470.537576799],
              [-12078240.337004432, 5621472.840597347],
              [-12050170.702751337, 5621620.640173655],
              [-12022210.342981417, 5621767.866777123],
              [-12012655.76750493, 5621764.561393207],
              [-12009331.679772053, 5619232.751143294],
              [-12003838.842137838, 5588546.902597165],
              [-11994747.379324751, 5577954.488008632],
              [-11979746.187384432, 5574618.75426308],
              [-11952331.536386773, 5552490.970806028],
              [-11945059.25669223, 5537495.820646997],
              [-11930022.108556384, 5526541.619929815],
              [-11927528.106684651, 5491115.273181534],
              [-11971431.40065861, 5491246.0961365905],
              [-12083793.287163671, 5491548.097903086],
              [-12086379.127615308, 5492008.103295809],
              [-12086337.828084225, 5546395.829258659],
              [-12088439.094792439, 5601305.629058519],
              [-12091689.34503822, 5621470.537576799],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sullivan',
        GEOID: '33019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8064046.585938053, 5344793.304184498],
              [-8063272.714874809, 5347489.639706224],
              [-8061933.742002797, 5352156.758231703],
              [-8059812.994383695, 5360864.787962253],
              [-8060299.444754622, 5363476.865312716],
              [-8061020.254261347, 5367348.724061679],
              [-8059188.60614682, 5377487.726649181],
              [-8059185.018459337, 5377507.596997813],
              [-8057404.26324191, 5387375.539276305],
              [-8057242.4047022965, 5399763.244246122],
              [-8052139.129777097, 5404608.030895275],
              [-8026849.06676999, 5396600.980819418],
              [-8025121.49959237, 5392818.867685627],
              [-8022741.822837681, 5396552.903826858],
              [-8007802.079256281, 5392822.399066797],
              [-8016268.260489582, 5378706.247747359],
              [-8025038.343932746, 5361197.285576451],
              [-8016013.450175155, 5340613.267655181],
              [-8018960.077096453, 5339453.14061428],
              [-8019250.064369969, 5331598.181745405],
              [-8034873.532263824, 5332064.78374015],
              [-8032442.7598628625, 5339710.374379395],
              [-8044222.811017589, 5337876.155113299],
              [-8063052.391565778, 5332639.717081294],
              [-8065141.183724568, 5336542.469117155],
              [-8064046.585938053, 5344793.304184498],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ontonagon',
        GEOID: '26131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10005877.799186183, 5903876.661238399],
              [-10000047.598883756, 5910148.978129243],
              [-9987615.549471453, 5914436.954989321],
              [-9978930.180160781, 5913611.567547712],
              [-9970865.41701128, 5914672.236404629],
              [-9962992.012066454, 5916260.795676576],
              [-9953649.412482139, 5916645.204644745],
              [-9932805.951026006, 5927877.505527909],
              [-9923308.283391014, 5939603.025940559],
              [-9910655.153469997, 5942260.151431908],
              [-9902916.111150557, 5943460.946148238],
              [-9900017.29053394, 5947560.025800089],
              [-9899918.388582986, 5903765.478479305],
              [-9892284.765821328, 5903802.206131515],
              [-9892347.883972608, 5889885.65795159],
              [-9906269.05421325, 5890016.760267386],
              [-9906459.076584036, 5847864.076796777],
              [-9906434.141018098, 5833762.670127889],
              [-9948122.733722724, 5833886.811706911],
              [-9948076.758773027, 5861801.94439719],
              [-9989874.333259141, 5861752.2916046],
              [-9989811.21510786, 5875810.540662464],
              [-10003661.474832868, 5875834.67780559],
              [-10003591.677512143, 5903865.91109722],
              [-10005877.799186183, 5903876.661238399],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Independence',
        GEOID: '05063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10224633.78100326, 4282392.633577768],
              [-10213935.643979553, 4292765.004370772],
              [-10209171.949010035, 4292610.456662322],
              [-10181636.627684357, 4291930.005395735],
              [-10181801.380530732, 4285839.189595031],
              [-10169840.323883977, 4285581.408898492],
              [-10152176.815001845, 4285499.376557083],
              [-10155943.421292324, 4274874.750281145],
              [-10168844.125760866, 4262042.187632329],
              [-10166263.072047332, 4250793.29474838],
              [-10171126.064002639, 4251199.968615156],
              [-10171214.006400364, 4235643.707737155],
              [-10194848.247490684, 4236202.474922196],
              [-10218456.66245914, 4236704.09016137],
              [-10217996.35636471, 4261028.567364297],
              [-10223268.002170715, 4260096.0594369145],
              [-10227031.046237491, 4274586.206051406],
              [-10224633.78100326, 4282392.633577768],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'York',
        GEOID: '42133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8574812.692349924, 4887449.009109316],
              [-8563061.918221276, 4891709.548283718],
              [-8560919.351981977, 4898562.978760399],
              [-8555907.303228501, 4898886.361599169],
              [-8553730.45058604, 4898199.222170461],
              [-8552086.039068041, 4895386.429114164],
              [-8549402.014825525, 4895064.618275528],
              [-8544069.588577544, 4891522.476614853],
              [-8540611.671235034, 4883405.896256553],
              [-8534177.961264636, 4875134.5131880455],
              [-8532027.602660984, 4874384.299930018],
              [-8519829.101540364, 4873408.43862317],
              [-8512999.98473867, 4858294.562488452],
              [-8486962.772301096, 4825574.119412594],
              [-8506921.940541357, 4825557.3323223535],
              [-8523672.086997874, 4825547.573376843],
              [-8539960.563533382, 4825538.083417944],
              [-8547900.55977062, 4825488.173368769],
              [-8570605.817473354, 4825345.4516899595],
              [-8571524.874120742, 4825346.272625034],
              [-8571443.051363612, 4841469.7754010875],
              [-8571299.783178959, 4841498.9123921525],
              [-8570920.183715355, 4841707.07765451],
              [-8570661.25457977, 4841806.378076698],
              [-8570561.400996527, 4841899.300974547],
              [-8566583.844270993, 4845161.86485206],
              [-8567838.414932232, 4856529.021988586],
              [-8573676.676946377, 4867969.226567411],
              [-8586898.87210433, 4876111.70821768],
              [-8574812.692349924, 4887449.009109316],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Croix',
        GEOID: '55109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10330772.796653487, 5631823.733333422],
              [-10323826.237789003, 5639391.066241283],
              [-10324195.927524192, 5641011.280179705],
              [-10326767.632694235, 5652290.198030368],
              [-10326674.058495825, 5654645.926243057],
              [-10258810.757108137, 5654572.024985373],
              [-10256545.182831513, 5640651.828869092],
              [-10256571.342911849, 5599170.255689286],
              [-10326777.792351263, 5599818.657449062],
              [-10324972.04930774, 5612327.092306376],
              [-10326207.918294527, 5625059.1492600255],
              [-10330772.796653487, 5631823.733333422],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Orangeburg',
        GEOID: '45075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9058393.243276186, 3960581.0067750853],
              [-9037725.666615507, 3982294.605196047],
              [-9026522.695701052, 3987975.8573969225],
              [-9021649.239713613, 3989544.3409598884],
              [-9015121.019495532, 3981206.081208708],
              [-9010176.207714496, 3976393.337376163],
              [-8995464.33513075, 3975762.8656955524],
              [-8974196.078497749, 3957323.0829162663],
              [-8967037.90128127, 3970595.9547369224],
              [-8960804.121116336, 3969669.771368547],
              [-8949323.964669807, 3954565.5553632],
              [-8930301.912722034, 3954349.0318187657],
              [-8933816.157726886, 3935093.4234212674],
              [-8945840.332524924, 3929525.283173894],
              [-8959502.23967151, 3932533.055230018],
              [-8961529.590237835, 3939787.3435622496],
              [-8993534.611757847, 3919332.122306222],
              [-8994382.420999728, 3918813.9402701254],
              [-8999752.361916104, 3926980.9141361536],
              [-9004311.785620015, 3930422.5672238003],
              [-9004582.959899588, 3930036.753223734],
              [-9004884.85835862, 3930982.8057871438],
              [-9007797.866793698, 3932977.543476829],
              [-9010211.050715113, 3935666.14097661],
              [-9041666.599228568, 3953853.2975411285],
              [-9050435.458157338, 3959353.188462878],
              [-9058393.243276186, 3960581.0067750853],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Teton',
        GEOID: '56039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12362623.089061012, 5569133.449263772],
              [-12319490.601617724, 5569137.939850659],
              [-12319494.16384143, 5556078.0282051135],
              [-12286925.977017496, 5556113.038486272],
              [-12278116.931752551, 5550619.324884265],
              [-12275924.494381377, 5545592.423699487],
              [-12278166.691564936, 5532437.655667824],
              [-12270570.249513203, 5523478.851008232],
              [-12270035.470679432, 5517512.030450175],
              [-12261964.362318957, 5510813.775797542],
              [-12257532.06547353, 5496347.942474733],
              [-12258412.491326215, 5485982.839958239],
              [-12251083.66133035, 5485989.664330317],
              [-12251063.846460989, 5466683.690233768],
              [-12250884.733400302, 5382986.275387254],
              [-12251523.707277454, 5369649.901695938],
              [-12283462.159741972, 5369672.874999858],
              [-12283433.327993857, 5356395.662399957],
              [-12309528.954345105, 5356468.307717081],
              [-12309559.678524565, 5347844.149396489],
              [-12335757.273529382, 5347837.120762656],
              [-12335757.607487854, 5359879.45299922],
              [-12361430.21977409, 5360151.786692224],
              [-12361512.992602644, 5388550.635043125],
              [-12361596.419773843, 5417262.334244362],
              [-12361641.504167615, 5451274.089152033],
              [-12361719.893460823, 5462878.495605629],
              [-12361857.130021282, 5483229.775678805],
              [-12361934.608386874, 5523647.204150107],
              [-12361915.238795476, 5539101.429640606],
              [-12362609.204501081, 5562665.931394521],
              [-12362623.089061012, 5569133.449263772],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Niobrara',
        GEOID: '56027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11677408.01636444, 5388334.025627237],
              [-11583326.714332452, 5388899.945946368],
              [-11583314.500811996, 5384985.362818691],
              [-11583224.49138643, 5356187.058790436],
              [-11583141.113087825, 5312060.890334451],
              [-11583080.889243308, 5255961.323671098],
              [-11583089.370849859, 5253064.183112941],
              [-11650212.442124663, 5252716.553354062],
              [-11673424.114427932, 5252785.675929085],
              [-11676572.67490553, 5252636.541203568],
              [-11677245.378588393, 5279004.895514422],
              [-11677408.01636444, 5388334.025627237],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Richland',
        GEOID: '45079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9052157.125401946, 4061000.8844010653],
              [-9036726.240227163, 4052264.2458223514],
              [-9037049.400708936, 4058419.4123394284],
              [-9027550.174601074, 4057556.090683573],
              [-8997500.368617358, 4064947.271448786],
              [-9002354.232374415, 4053302.90549243],
              [-8985633.376940321, 4038067.0447831377],
              [-8982699.774399446, 4039721.172831561],
              [-8974152.77521583, 4042184.398356849],
              [-8976326.399593059, 4040205.8450897206],
              [-8972466.284930311, 4033627.568233248],
              [-8976085.170256509, 4009037.661525506],
              [-8974589.258939229, 3994376.9158607177],
              [-8992929.479005894, 3996756.206247143],
              [-9007673.745561464, 4003818.5252369065],
              [-9018251.323576638, 4012711.0438139364],
              [-9022679.612920398, 4028481.917672612],
              [-9032383.555571828, 4037982.248302111],
              [-9047585.67919303, 4041885.4223902533],
              [-9054611.720173938, 4055364.0900589675],
              [-9052157.125401946, 4061000.8844010653],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Merced',
        GEOID: '06047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13494906.09177598, 4457909.2311748145],
              [-13465629.956253277, 4487465.250749191],
              [-13468524.15169441, 4494430.687306016],
              [-13401494.122188656, 4527761.130516291],
              [-13378113.244259385, 4475623.1025226405],
              [-13364133.631286072, 4464660.50665271],
              [-13370181.619220871, 4462431.440746498],
              [-13383640.256977266, 4461907.179169868],
              [-13411404.005898057, 4452550.839993272],
              [-13418640.218077581, 4445312.027165317],
              [-13424080.40159265, 4432507.607634553],
              [-13431358.915178677, 4432534.21404165],
              [-13460611.562288824, 4402980.7644875115],
              [-13485412.65428164, 4416363.130726809],
              [-13495783.178043941, 4428921.64654361],
              [-13493637.272219917, 4433706.633810928],
              [-13497030.401618786, 4436742.488126183],
              [-13494906.09177598, 4457909.2311748145],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Palm Beach',
        GEOID: '12099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9004148.145968549, 3118340.1578916665],
              [-8970150.950841302, 3118217.1406063563],
              [-8921367.410390966, 3118055.5337464116],
              [-8914807.422902558, 3119790.8438749854],
              [-8910709.237064455, 3105896.3776336526],
              [-8909736.224290129, 3099134.1563611873],
              [-8909320.218174485, 3096243.993555411],
              [-8909134.845506165, 3094956.3246932984],
              [-8909540.382411126, 3083055.5776533894],
              [-8909518.614555556, 3079176.8253493276],
              [-8909495.854614807, 3075122.4271096494],
              [-8909885.472832583, 3069769.609987241],
              [-8911165.646976706, 3062328.8734745677],
              [-8912417.418768948, 3051989.2853674195],
              [-8914005.567424927, 3038881.960891152],
              [-8916667.946767636, 3039733.623247653],
              [-8924500.16350087, 3039734.9894791455],
              [-8928277.679101449, 3039740.081797674],
              [-8933363.53267732, 3041442.259264816],
              [-8938673.583707651, 3040551.6465313253],
              [-9003657.672292113, 3040483.3312359694],
              [-9004148.145968549, 3118340.1578916665],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Doniphan',
        GEOID: '20043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10613188.67175873, 4865946.472939975],
              [-10609670.311177649, 4865941.98886863],
              [-10601079.118156185, 4857776.483209957],
              [-10591208.530227037, 4850756.616542043],
              [-10584427.948723327, 4845867.816655887],
              [-10577438.086576927, 4851039.846584665],
              [-10574614.049099876, 4851212.989429962],
              [-10569957.082837146, 4851498.516443199],
              [-10567388.496906582, 4847989.163830361],
              [-10561846.010779476, 4840764.8601517705],
              [-10561754.804815559, 4839921.012703454],
              [-10561007.441055331, 4833009.013424801],
              [-10559808.196181016, 4829611.139392462],
              [-10564143.53374996, 4825921.476485636],
              [-10572132.043048266, 4825791.795641893],
              [-10572158.648406565, 4820476.330988858],
              [-10579522.09876407, 4815630.836801693],
              [-10580255.332706187, 4809959.40800257],
              [-10588174.406185977, 4815579.36468333],
              [-10613171.309163094, 4815641.680680658],
              [-10613188.67175873, 4865946.472939975],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Taliaferro',
        GEOID: '13265',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9241080.438853463, 3972595.9255136056],
              [-9234081.225869834, 3983409.3123052693],
              [-9239028.152721196, 3987731.545404336],
              [-9233845.562507825, 3993051.12157702],
              [-9226127.782211129, 3977990.722364963],
              [-9218696.31564475, 3982682.299718016],
              [-9203892.715800589, 3975189.6302024713],
              [-9211829.795494149, 3963214.335392095],
              [-9218958.69568455, 3964682.2434154884],
              [-9224668.272367338, 3957402.214591872],
              [-9223037.330507724, 3954325.9522220776],
              [-9237698.441403672, 3954877.4737890633],
              [-9240948.525256872, 3957746.370284744],
              [-9241080.438853463, 3972595.9255136056],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Love',
        GEOID: '40085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10860467.90864136, 4015256.492035388],
              [-10857748.9133562, 4026637.306558213],
              [-10860414.569882734, 4038351.5409188815],
              [-10794609.500053672, 4038342.268141066],
              [-10790731.574272396, 4030539.952944998],
              [-10790681.736885134, 4021498.2865672633],
              [-10791825.387162393, 4021421.036678539],
              [-10792682.114390075, 4021363.167858963],
              [-10796737.706078658, 4017859.517464587],
              [-10796383.932736915, 4013574.8620786793],
              [-10804206.46467445, 4009447.9761482286],
              [-10806739.205728978, 4003687.35713804],
              [-10807770.246852707, 3998509.225100397],
              [-10808128.69561306, 3993289.6568738767],
              [-10814621.070955107, 3991529.8059231755],
              [-10820883.682868155, 4003294.5317294695],
              [-10816539.66237893, 4008318.004384875],
              [-10820938.118099153, 4017297.723861349],
              [-10825395.239191024, 4015428.496718086],
              [-10833417.25565606, 4010705.418654587],
              [-10839506.20916347, 4004584.7966650776],
              [-10847437.945521472, 4005163.520308974],
              [-10848247.906136483, 4011484.217510303],
              [-10851885.208002012, 4017245.2897102516],
              [-10852148.095815917, 4017661.786576703],
              [-10860136.939072696, 4014993.2907122015],
              [-10860467.90864136, 4015256.492035388],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grayson',
        GEOID: '21085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9647491.424455067, 4516983.12388282],
              [-9639467.515558688, 4518065.972020126],
              [-9630430.71061558, 4526293.718401863],
              [-9619088.701657124, 4518368.476146359],
              [-9604119.12445219, 4522161.755395159],
              [-9586195.684559058, 4518462.290716446],
              [-9578774.793344304, 4502008.587893879],
              [-9575601.18598128, 4494243.768920717],
              [-9580662.326630197, 4487810.983409692],
              [-9591018.93545615, 4485995.768739706],
              [-9594352.397607952, 4486716.41234159],
              [-9625699.075659413, 4483958.855994849],
              [-9627705.720800452, 4489755.924007135],
              [-9641614.311938636, 4494325.878086557],
              [-9647491.424455067, 4516983.12388282],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Vermilion',
        GEOID: '22113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10312397.28830824, 3512830.5159061514],
              [-10311021.713360509, 3515423.5336238416],
              [-10310909.50331379, 3515086.5761167523],
              [-10310258.172973158, 3515517.4561691075],
              [-10310260.955960428, 3514977.732643567],
              [-10309891.15261201, 3514972.0717791845],
              [-10309700.684963264, 3515420.445771113],
              [-10309301.60458877, 3515299.634121489],
              [-10309395.669558492, 3515700.6714587198],
              [-10308870.352881435, 3515774.6530995886],
              [-10308720.850805303, 3516196.549672053],
              [-10308075.30907819, 3516046.2659092452],
              [-10307737.899701597, 3516341.3024067767],
              [-10307470.732923692, 3516158.5925609237],
              [-10307212.471705053, 3516332.552861362],
              [-10306772.314438457, 3515910.9091085605],
              [-10306663.777934933, 3516093.8727309857],
              [-10306156.049737426, 3516079.2046642136],
              [-10305821.53466759, 3516344.647822791],
              [-10305833.334533615, 3516604.177585759],
              [-10305481.230984237, 3516524.658235917],
              [-10305243.563871393, 3516798.860552402],
              [-10304955.914307183, 3516716.251817875],
              [-10304595.01651803, 3517011.1751825674],
              [-10304829.789324112, 3517438.9034202434],
              [-10304636.093410132, 3517840.1369102206],
              [-10304433.49193689, 3517654.3171322425],
              [-10304175.23071825, 3518011.160421782],
              [-10303696.89086631, 3517890.195472673],
              [-10303412.135608861, 3518468.3925898904],
              [-10303054.132126471, 3518418.2030597795],
              [-10303051.237819709, 3517828.297895992],
              [-10302387.996293562, 3517556.775704179],
              [-10302123.835141912, 3517730.755133155],
              [-10301742.343246963, 3517509.5494504846],
              [-10301883.273722306, 3517308.9363389136],
              [-10301407.716857638, 3517084.6497378023],
              [-10301375.434205307, 3517335.4443684486],
              [-10300908.782899903, 3517420.7594211837],
              [-10288499.776622195, 3509891.046284769],
              [-10273083.029022744, 3522516.380430429],
              [-10251236.1336766, 3520052.167098538],
              [-10248757.271255616, 3513055.885247987],
              [-10237436.635639394, 3508296.1914073788],
              [-10240324.040591588, 3499736.097470759],
              [-10238014.38379661, 3480034.1516542677],
              [-10239744.956600482, 3455974.1722970093],
              [-10246168.125041166, 3449353.6743630166],
              [-10248574.707290715, 3450401.353247045],
              [-10259051.09588876, 3449883.052882568],
              [-10269430.079932362, 3444474.4610800166],
              [-10277401.112070614, 3443469.189927304],
              [-10287018.559477698, 3445513.847983586],
              [-10294112.394028502, 3447254.7490531686],
              [-10304626.853892399, 3449343.0134461857],
              [-10310103.376258163, 3450835.8271148866],
              [-10309922.544708416, 3508456.9280948252],
              [-10323614.174159043, 3508348.269872057],
              [-10312397.28830824, 3512830.5159061514],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Santa Cruz',
        GEOID: '06087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13616342.075253563, 4465196.642433233],
              [-13597984.600665826, 4469179.599471274],
              [-13597929.386198394, 4479054.524160409],
              [-13579986.020116407, 4459235.288351595],
              [-13563866.95784954, 4452638.765823602],
              [-13559724.314319162, 4448770.860105776],
              [-13551881.967512265, 4437724.854210325],
              [-13534374.417236736, 4425059.183330044],
              [-13541348.249376463, 4424341.478516333],
              [-13547577.131483797, 4427917.538290369],
              [-13560131.345884431, 4418226.1727525415],
              [-13565645.398034455, 4429570.308356162],
              [-13570565.9421665, 4434779.700928727],
              [-13575597.805789338, 4435128.032214248],
              [-13584002.872622194, 4432299.912791821],
              [-13588471.540780202, 4432640.597116187],
              [-13592775.071135683, 4432968.701931917],
              [-13603929.729391133, 4441051.276352432],
              [-13609974.489060698, 4449223.872949057],
              [-13612690.795955544, 4453298.512004834],
              [-13613740.337478403, 4453772.291086324],
              [-13616342.075253563, 4465196.642433233],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Windham',
        GEOID: '09015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8041670.923010643, 5118262.325155181],
              [-8032449.216393327, 5124158.839071824],
              [-8039239.705331718, 5136322.690371831],
              [-8039157.440228021, 5154714.2236687625],
              [-8031885.383172459, 5154885.02920614],
              [-8026049.458867623, 5154832.035749873],
              [-8026375.67334695, 5165269.080418114],
              [-8013592.473889383, 5165006.788510906],
              [-8002165.621211829, 5164733.952816859],
              [-7992811.796626057, 5164510.620037284],
              [-7992655.05878302, 5162187.6185051715],
              [-7991934.265080134, 5132112.829167103],
              [-7991592.339659082, 5119903.945383535],
              [-7991590.399173074, 5119834.702243726],
              [-7991566.6425739415, 5107207.366723304],
              [-7999186.729905317, 5107834.461180229],
              [-8009992.067598656, 5106430.120324836],
              [-8021910.822838911, 5109028.044307193],
              [-8031335.798846413, 5111252.628686649],
              [-8032541.277612213, 5109830.802021424],
              [-8041670.923010643, 5118262.325155181],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Vanderburgh',
        GEOID: '18163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9762771.328772292, 4565152.19106408],
              [-9761425.14217013, 4603245.165170259],
              [-9736813.515950643, 4602818.131783849],
              [-9737447.925728677, 4584363.404873595],
              [-9734737.614235494, 4570089.179730595],
              [-9738935.599403637, 4568161.414602201],
              [-9746163.573940843, 4568895.228563011],
              [-9752531.2714532, 4565138.648143642],
              [-9754465.113647262, 4558528.002416031],
              [-9760674.737482691, 4559091.664761299],
              [-9764189.960461585, 4562923.262772751],
              [-9762771.328772292, 4565152.19106408],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Webster',
        GEOID: '22119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10410709.380886873, 3897791.9537119335],
              [-10407316.234383631, 3897777.6555847214],
              [-10394695.008615272, 3897724.4720952394],
              [-10379274.249328472, 3897695.5143572846],
              [-10379137.775818441, 3857701.178088137],
              [-10372060.305232784, 3846776.1552559184],
              [-10372612.895185081, 3840337.2240885403],
              [-10369098.093582777, 3823208.581250856],
              [-10379057.069187615, 3817260.006821706],
              [-10394210.434871847, 3817270.819233101],
              [-10401828.138946323, 3817307.4760180144],
              [-10402221.208068315, 3863645.483572761],
              [-10405455.484553821, 3866558.911739145],
              [-10402574.424812602, 3877621.8340808214],
              [-10404985.159705222, 3884387.357341632],
              [-10411762.512943696, 3892066.913423978],
              [-10410709.380886873, 3897791.9537119335],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '37179',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8999130.743751822, 4164081.1208292553],
              [-8991551.343709873, 4168387.9613371184],
              [-8966823.833900472, 4192239.6947504855],
              [-8961773.936520126, 4189050.139421844],
              [-8945298.31792425, 4186318.4835314313],
              [-8936375.726778697, 4190510.8945111088],
              [-8941274.18190995, 4138581.7152557713],
              [-8968082.634702364, 4139105.1209740546],
              [-8968088.373153362, 4139105.3108516256],
              [-8994280.56366565, 4139972.008614429],
              [-8992615.780680839, 4155157.5952391424],
              [-8999130.743751822, 4164081.1208292553],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kenedy',
        GEOID: '48261',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10907739.045767244, 3149646.4437586213],
              [-10888789.240168996, 3155467.841828326],
              [-10885387.761808317, 3158963.001097144],
              [-10854636.976991074, 3156824.071838061],
              [-10836601.869951444, 3158242.160018357],
              [-10837895.19349271, 3152837.1571835987],
              [-10840146.964152476, 3130975.4583511525],
              [-10838830.611173846, 3109183.8654212593],
              [-10833918.972601065, 3086258.015181105],
              [-10829999.537639128, 3073627.6188829164],
              [-10893913.27633021, 3073335.6903749565],
              [-10904568.44403047, 3075050.58478703],
              [-10907674.035184622, 3075553.6131722885],
              [-10907695.297207361, 3096126.785988783],
              [-10907739.045767244, 3149646.4437586213],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fannin',
        GEOID: '48147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10729484.814952338, 3948228.5472825724],
              [-10728934.765973404, 3990668.4376900806],
              [-10727095.119443478, 3987816.1040607314],
              [-10720889.503109718, 3993274.932329366],
              [-10717536.560047021, 3997924.811087675],
              [-10712165.83989421, 3995017.378594226],
              [-10705932.171048768, 4002053.4419489917],
              [-10703550.490543246, 4006258.7400036915],
              [-10693787.103283731, 4007542.235422264],
              [-10679471.528087208, 4012043.1781229596],
              [-10674146.671564603, 4010535.8301304197],
              [-10669403.073555905, 4010075.460861581],
              [-10670531.237142619, 4005728.872694182],
              [-10670834.582755031, 3956751.4293552726],
              [-10670944.232453462, 3949789.2370019658],
              [-10719556.340887975, 3942111.29395945],
              [-10729472.903766822, 3940669.8302346747],
              [-10729484.814952338, 3948228.5472825724],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hoonah-Angoon',
        GEOID: '02105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-14883048.676060548, 7923900.7835958265],
              [-14825193.55915119, 7999007.51013393],
              [-14825133.931738913, 7998925.935301079],
              [-14813999.422311297, 7967267.5388135845],
              [-14790944.82180954, 7934396.458997353],
              [-14778420.822497841, 7905620.266083819],
              [-14767118.070407577, 7884117.737202104],
              [-14786289.997302018, 7879738.410764344],
              [-14793007.794612922, 7886610.135341395],
              [-14787792.031191291, 7896877.118683679],
              [-14791232.026095781, 7907225.3977117995],
              [-14799908.935125157, 7914028.335873503],
              [-14802968.6626491, 7909039.10932113],
              [-14826442.269714206, 7913107.060432993],
              [-14836648.040630134, 7924327.707477119],
              [-14844838.260845758, 7919629.951624137],
              [-14860378.127802026, 7930587.7173034195],
              [-14866646.528328596, 7920246.811439938],
              [-14883048.676060548, 7923900.7835958265],
            ],
          ],
          [
            [
              [-15023734.359844578, 8052617.079588367],
              [-15013112.476672068, 8042747.548261316],
              [-15004580.616939198, 8028293.085825782],
              [-14998723.87588958, 8016761.346964321],
              [-14997460.27032596, 8011871.598164749],
              [-15002831.453780364, 8002374.773935118],
              [-15004162.055653814, 7987637.403299173],
              [-14994486.72211152, 7974050.311345858],
              [-14981129.16245276, 7978694.218755701],
              [-14976747.627295136, 7987968.743233526],
              [-14945129.891939072, 7997703.402054258],
              [-14936220.542157447, 7993681.968230864],
              [-14937292.66017328, 7983572.358801832],
              [-14932199.570830503, 7977218.920403025],
              [-14926560.236746406, 7966577.079033847],
              [-14916805.977685135, 7949443.026809036],
              [-14906222.388417458, 7926967.904067513],
              [-14905328.715545367, 7901544.06230714],
              [-14895470.150121227, 7885750.801859492],
              [-14896507.091177965, 7877183.3887557555],
              [-14902516.228610475, 7859727.025665285],
              [-14901998.592978287, 7835682.582538713],
              [-14893033.700426234, 7824060.660910763],
              [-14899100.278715994, 7815726.861387533],
              [-14902971.747966804, 7815014.297067433],
              [-14914975.10602006, 7822269.688828979],
              [-14927956.851077901, 7814740.900970136],
              [-14938366.44798147, 7798000.592524874],
              [-14950510.513871087, 7788082.13393201],
              [-14958930.497515708, 7783663.369402804],
              [-14959786.878358383, 7778001.855544608],
              [-14966213.79783984, 7772861.288915145],
              [-14972217.480617303, 7766497.130123919],
              [-14979783.755087033, 7764971.85798897],
              [-14987451.218973892, 7782606.946505617],
              [-14988075.0534003, 7809301.174273853],
              [-14978654.196213953, 7843853.412439483],
              [-14984444.702166544, 7865711.078149034],
              [-14994226.457142044, 7901504.70452309],
              [-14995739.956938868, 7921347.681952193],
              [-15000568.328532536, 7954505.014022012],
              [-15004060.866236683, 7984624.418239747],
              [-15013025.090871792, 8005328.593601644],
              [-15023474.874111539, 8035278.14027382],
              [-15023734.359844578, 8052617.079588367],
            ],
          ],
          [
            [
              [-15202148.445448264, 7974684.473040399],
              [-15199419.448131466, 7986980.875213455],
              [-15189131.07815337, 7991164.511835403],
              [-15180142.919827743, 7998652.33266775],
              [-15182543.969924662, 8020529.807104395],
              [-15171772.250717541, 8020391.658141899],
              [-15159092.181479752, 8023216.495815109],
              [-15143199.765696142, 8025675.499705369],
              [-15125810.548039323, 8022103.573194433],
              [-15115336.719789566, 8027788.850993682],
              [-15107435.03969408, 8016189.379960536],
              [-15083558.456072299, 8002878.3588468535],
              [-15058832.838694245, 7987726.924726939],
              [-15040253.50436136, 7985883.209205587],
              [-15022659.236202495, 7975092.627277511],
              [-15019937.585972095, 7950933.009836928],
              [-15028682.511210341, 7943059.7060917895],
              [-15022501.781186983, 7921506.633428207],
              [-15035003.788495036, 7917263.807302062],
              [-15054639.656115046, 7917426.159890839],
              [-15086967.392838866, 7942249.818506444],
              [-15107741.27961325, 7952504.004819872],
              [-15128537.430285797, 7967599.662672573],
              [-15142158.928457225, 7933529.364508327],
              [-15180860.094774544, 7932156.984826883],
              [-15180903.565908331, 7932231.20986482],
              [-15190527.358526394, 7936689.114255992],
              [-15193358.213177266, 7945598.392839235],
              [-15203268.8761231, 7951965.418896685],
              [-15202148.445448264, 7974684.473040399],
            ],
          ],
          [
            [
              [-15354983.081510779, 8139573.195914283],
              [-15309288.346363604, 8160738.736807517],
              [-15309371.490299838, 8160277.327617855],
              [-15300572.686428048, 8160854.822705969],
              [-15280242.29650498, 8180895.260751263],
              [-15235619.210703554, 8210376.380396397],
              [-15231471.112518122, 8214699.863601206],
              [-15204185.369490802, 8216115.739581015],
              [-15193958.58034115, 8236903.402320405],
              [-15179786.14085975, 8230909.9711833615],
              [-15151461.564344343, 8227153.185511715],
              [-15128213.045289623, 8219189.6839365065],
              [-15105959.833802085, 8203638.6131154215],
              [-15108625.379009133, 8195498.84170298],
              [-15091152.449095238, 8167958.505709307],
              [-15095534.429530824, 8159664.097978967],
              [-15086475.69464803, 8156153.171841262],
              [-15104216.681895755, 8148810.853770541],
              [-15111287.47331196, 8121314.690267538],
              [-15089468.407838514, 8115567.345636399],
              [-15087124.242001392, 8106571.638566714],
              [-15073240.475109655, 8098830.463660004],
              [-15063389.702049868, 8074029.609001837],
              [-15084572.46531394, 8073009.243732295],
              [-15077813.925069405, 8053012.28448371],
              [-15078221.26232835, 8038885.020757619],
              [-15088712.771135012, 8037010.420467041],
              [-15100473.452698339, 8035799.626635933],
              [-15109177.857641937, 8051195.576788889],
              [-15130313.310122421, 8047833.567568044],
              [-15144105.906351198, 8047605.099157213],
              [-15151910.738489697, 8039619.242413917],
              [-15169051.268404081, 8033676.174574607],
              [-15188114.285924466, 8031116.029491622],
              [-15200094.934801603, 8034135.236914797],
              [-15203659.718855273, 8025934.422562756],
              [-15202675.320598189, 8018993.809940457],
              [-15205343.426153524, 8013228.535646417],
              [-15217513.540803991, 8013551.9181727385],
              [-15219277.175496627, 8024993.832238852],
              [-15234918.899786972, 8034070.593471686],
              [-15240942.174794812, 8045501.436454746],
              [-15249254.512491835, 8052677.633824051],
              [-15259465.292784847, 8051282.036222585],
              [-15277416.339911701, 8063120.68165502],
              [-15290325.170703068, 8071469.051958956],
              [-15314023.754459072, 8091863.401744262],
              [-15323540.791685458, 8096207.971342068],
              [-15326649.277146371, 8106500.588024477],
              [-15343883.204113532, 8124737.162242379],
              [-15355614.052053325, 8136064.151469373],
              [-15354983.081510779, 8139573.195914283],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Santa Clara',
        GEOID: '06085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13602173.330465399, 4499420.284011124],
              [-13597111.744538518, 4503167.8604543535],
              [-13590047.409652777, 4505922.19009094],
              [-13587620.644753482, 4503993.466287432],
              [-13572633.479069004, 4502604.965527584],
              [-13564921.376066336, 4506861.924553797],
              [-13522273.32067056, 4506529.872612531],
              [-13514826.603333946, 4482543.888784739],
              [-13520759.709554246, 4478590.575466947],
              [-13514125.067902965, 4460089.437750879],
              [-13501080.64997181, 4464739.730631559],
              [-13494906.09177598, 4457909.2311748145],
              [-13497030.401618786, 4436742.488126183],
              [-13493637.272219917, 4433706.633810928],
              [-13516217.317732424, 4433609.252282348],
              [-13519995.055971986, 4437540.052617373],
              [-13525483.77478504, 4435190.036382574],
              [-13526451.92039647, 4432978.174774087],
              [-13526855.787509067, 4431464.856184998],
              [-13529154.534993948, 4429484.10562978],
              [-13529772.69212632, 4428068.197209419],
              [-13530662.468816234, 4427598.404645779],
              [-13534374.417236736, 4425059.183330044],
              [-13551881.967512265, 4437724.854210325],
              [-13559724.314319162, 4448770.860105776],
              [-13563866.95784954, 4452638.765823602],
              [-13579986.020116407, 4459235.288351595],
              [-13597929.386198394, 4479054.524160409],
              [-13602425.246473063, 4483526.465272022],
              [-13602173.330465399, 4499420.284011124],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Winn',
        GEOID: '22127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10349016.836680107, 3734636.8350221487],
              [-10338483.118544301, 3756205.482294402],
              [-10345931.060395315, 3782746.018510506],
              [-10332089.260951607, 3782609.9394369237],
              [-10276149.101757662, 3782506.8622104283],
              [-10276194.186151434, 3753782.1563050854],
              [-10278804.07161308, 3740113.00448398],
              [-10281758.490898736, 3736645.0524485973],
              [-10310324.853348142, 3736712.636186321],
              [-10310408.565605218, 3725247.5252550603],
              [-10349765.905533653, 3725162.471260981],
              [-10349016.836680107, 3734636.8350221487],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Talbot',
        GEOID: '13263',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9428820.760076318, 3874700.631468781],
              [-9414363.809126485, 3874772.0494240755],
              [-9407263.7406842, 3879623.7886159536],
              [-9393182.938293759, 3866029.817990948],
              [-9382701.98559659, 3861853.2476816117],
              [-9388456.535353659, 3858282.956762575],
              [-9396351.981557664, 3837299.8890407737],
              [-9400302.376327442, 3837321.0220706216],
              [-9415943.321381353, 3832153.00500459],
              [-9421783.698465822, 3833725.2509544007],
              [-9428149.726185815, 3831596.536907479],
              [-9425138.86791833, 3837567.35672969],
              [-9428160.078898462, 3840208.9409373077],
              [-9428075.253446475, 3853669.3415140277],
              [-9426854.635229927, 3859566.8878070274],
              [-9428820.760076318, 3874700.631468781],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coahoma',
        GEOID: '28027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10123178.978206122, 4048793.5860485737],
              [-10118316.654167764, 4050434.611279371],
              [-10117015.997237334, 4053584.5535170725],
              [-10118336.135078652, 4058970.717916376],
              [-10112260.428590646, 4060550.602549277],
              [-10109237.881776625, 4066385.724009311],
              [-10102542.237044392, 4067709.833041342],
              [-10103932.951442873, 4074927.5223467634],
              [-10099920.66303621, 4077811.465095092],
              [-10092270.008392463, 4073975.988066648],
              [-10090154.270150444, 4080463.4596097474],
              [-10082800.28194966, 4084683.954548319],
              [-10083733.250601998, 4090579.207652389],
              [-10082133.589519298, 4099498.4711289247],
              [-10063226.085327553, 4085851.908521782],
              [-10063172.206694007, 4063972.600719052],
              [-10068911.617000327, 4064090.8606078164],
              [-10068957.146672063, 4038599.220953229],
              [-10068960.597576275, 4026880.5703172926],
              [-10091891.299484782, 4027135.251012914],
              [-10092164.588834679, 4044774.1494123787],
              [-10123848.760887122, 4044935.2780859075],
              [-10123178.978206122, 4048793.5860485737],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Iosco',
        GEOID: '26069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9338217.381241709, 5544548.227410097],
              [-9274801.99305557, 5544970.795068857],
              [-9274873.919312557, 5540971.487287619],
              [-9277031.06840515, 5517107.543844949],
              [-9284248.35627124, 5512270.656618975],
              [-9288802.325320102, 5506599.663974224],
              [-9297940.09704136, 5506008.5097254515],
              [-9302373.817941004, 5490782.997240004],
              [-9337921.605354672, 5490513.170279413],
              [-9338217.381241709, 5544548.227410097],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Huron',
        GEOID: '26063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9292902.890082965, 5433560.523385866],
              [-9287675.660753785, 5447705.047278146],
              [-9284841.021240225, 5453040.507055515],
              [-9270944.341287555, 5455857.340575108],
              [-9268631.12226887, 5461346.029781186],
              [-9254532.620079393, 5464381.727029324],
              [-9244702.663764386, 5467873.663956519],
              [-9242256.640593184, 5472435.627268553],
              [-9231601.138934452, 5476186.577589342],
              [-9216497.421743112, 5469040.415178297],
              [-9207217.16107364, 5457433.5302502345],
              [-9198734.838514173, 5439360.7493334655],
              [-9196350.708979854, 5425259.065873059],
              [-9195711.18772674, 5417662.794678007],
              [-9252636.069914749, 5415360.543740945],
              [-9291458.519689921, 5414149.020327405],
              [-9295854.921848603, 5426089.000721777],
              [-9292902.890082965, 5433560.523385866],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kleberg',
        GEOID: '48273',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10915929.59994134, 3203141.4061042704],
              [-10902869.819920456, 3203150.201960204],
              [-10891574.453828644, 3193406.081689669],
              [-10834193.486465361, 3193724.772457052],
              [-10822813.89688525, 3195697.770007281],
              [-10826635.894915916, 3187416.11554327],
              [-10830947.52143332, 3176943.7459705374],
              [-10835407.53683195, 3163235.3312498447],
              [-10836601.869951444, 3158242.160018357],
              [-10854636.976991074, 3156824.071838061],
              [-10885387.761808317, 3158963.001097144],
              [-10888789.240168996, 3155467.841828326],
              [-10907739.045767244, 3149646.4437586213],
              [-10907760.085151006, 3156054.8991402853],
              [-10915775.311127102, 3156115.885395253],
              [-10915929.59994134, 3203141.4061042704],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '08121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11544560.003968691, 4828216.064040549],
              [-11544465.827679483, 4866140.784886042],
              [-11518449.238166695, 4866160.548450464],
              [-11517713.08237408, 4929554.976540786],
              [-11441412.810953027, 4929862.119208175],
              [-11442929.205056611, 4917121.557924053],
              [-11444062.99407034, 4866313.426764089],
              [-11443970.042295529, 4803339.416876367],
              [-11483092.60941788, 4803023.602790452],
              [-11544618.446701359, 4803116.165466424],
              [-11544560.003968691, 4828216.064040549],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McMullen',
        GEOID: '48311',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10998374.818573672, 3274507.3842322812],
              [-10998460.089303622, 3330832.1212542434],
              [-10946607.359172622, 3330955.036737275],
              [-10946605.57806077, 3326437.845763506],
              [-10946526.76386129, 3256263.0036009694],
              [-10998735.827682316, 3256222.6373096374],
              [-10998374.818573672, 3274507.3842322812],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pitkin',
        GEOID: '08097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11959158.538118143, 4774259.986731878],
              [-11923814.265832806, 4774243.859915214],
              [-11856551.467271805, 4773701.322796538],
              [-11847342.339756949, 4773639.8428621935],
              [-11855790.709871722, 4764529.41645737],
              [-11856484.675577328, 4745575.396394615],
              [-11862345.758087086, 4743995.562688793],
              [-11864204.904902825, 4729969.7943705525],
              [-11866570.2214432, 4721384.234365464],
              [-11877229.619284108, 4729648.532346319],
              [-11883284.063749373, 4727765.175744257],
              [-11889130.229447365, 4718564.139850124],
              [-11895788.582150184, 4723023.718539904],
              [-11900768.45957082, 4720538.7395019615],
              [-11911366.075094339, 4727728.627270088],
              [-11918568.223509682, 4738703.6851227665],
              [-11942632.157834463, 4738691.202139726],
              [-11952998.006178152, 4750063.2770738425],
              [-11955099.495525347, 4758450.982676336],
              [-11962969.894843921, 4766823.803779764],
              [-11959158.538118143, 4774259.986731878],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hanover',
        GEOID: '51085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8660356.489008486, 4541263.408895503],
              [-8648129.490098225, 4580528.597564763],
              [-8643125.567667577, 4578110.423086072],
              [-8625498.348939443, 4562962.840565486],
              [-8621195.40534232, 4564564.500993976],
              [-8615829.917205576, 4548011.8152143555],
              [-8610029.949096264, 4549685.971820181],
              [-8607500.881584931, 4541874.6980097545],
              [-8597263.050655656, 4539078.234367259],
              [-8585368.229105921, 4526849.877070662],
              [-8587236.392800415, 4521972.093871825],
              [-8598427.452529354, 4514377.080304494],
              [-8615151.981506646, 4522818.994315626],
              [-8616928.863218687, 4524832.133440254],
              [-8621233.476608172, 4534889.164469919],
              [-8641806.654340658, 4537930.311101469],
              [-8650827.874555055, 4538016.42206892],
              [-8660356.489008486, 4541263.408895503],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clinton',
        GEOID: '21053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9495086.412709732, 4387124.180313105],
              [-9489581.053221611, 4403524.349639122],
              [-9486135.492342578, 4418840.731021784],
              [-9488321.918461248, 4423183.035969692],
              [-9475338.169652576, 4415066.623328551],
              [-9469315.339922696, 4419435.630203725],
              [-9462613.016021013, 4405183.615733065],
              [-9462097.05018119, 4386903.004379709],
              [-9459359.084502835, 4385519.9756051395],
              [-9472857.637439229, 4386615.611107432],
              [-9492912.951056205, 4387125.287402575],
              [-9494509.16707903, 4387165.853928746],
              [-9495086.412709732, 4387124.180313105],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Meagher',
        GEOID: '30059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12429726.397168124, 5927953.934171882],
              [-12416488.505961971, 5927945.460174124],
              [-12416506.205761006, 5942165.315936265],
              [-12388219.366552982, 5942241.543353159],
              [-12374094.92692215, 5943995.610918883],
              [-12374114.185194056, 5956498.97191989],
              [-12365438.16672061, 5956413.954492021],
              [-12368145.01145874, 5946777.212956421],
              [-12346782.57853653, 5938901.383531934],
              [-12340437.701519784, 5929245.337167426],
              [-12328935.83777255, 5924167.690902812],
              [-12328810.158067446, 5916734.392544798],
              [-12317821.922450732, 5913332.713858176],
              [-12314238.548042098, 5904972.858886323],
              [-12297088.555970995, 5889758.289386233],
              [-12281713.664500082, 5888890.60985328],
              [-12275571.722915053, 5894949.124454258],
              [-12276532.855398564, 5815772.0777496565],
              [-12276526.732826568, 5809948.369636293],
              [-12290703.826576548, 5811181.373310192],
              [-12332399.877687057, 5811283.327322701],
              [-12363360.388424953, 5811305.036925197],
              [-12364827.245355137, 5820631.429195972],
              [-12370584.244141001, 5824223.022802344],
              [-12362833.847233502, 5845232.831622109],
              [-12370391.995380403, 5851102.506346241],
              [-12383905.847604234, 5850836.616607665],
              [-12385114.665954757, 5860594.830226771],
              [-12394862.691124542, 5868272.307097736],
              [-12393280.061923934, 5882498.743604229],
              [-12402237.607389597, 5883505.713326079],
              [-12407158.040202152, 5900149.696603894],
              [-12411911.159820043, 5903394.1478178585],
              [-12427652.515054645, 5914716.982895051],
              [-12429726.397168124, 5927953.934171882],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Barry',
        GEOID: '29009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10471701.82484439, 4404013.919506881],
              [-10471016.319420084, 4429601.363790989],
              [-10420729.186607605, 4428355.875353488],
              [-10420943.587946871, 4414124.869980207],
              [-10416587.767591624, 4414051.168642069],
              [-10417754.568105983, 4369488.414282059],
              [-10430655.322962658, 4369520.724620235],
              [-10449199.726538556, 4369483.496320534],
              [-10459489.186148442, 4369462.840058897],
              [-10472613.561184434, 4369498.700369426],
              [-10471701.82484439, 4404013.919506881],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Placer',
        GEOID: '06061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13521906.85690687, 4711076.099034171],
              [-13515789.071651343, 4711107.86547839],
              [-13515831.373057844, 4721163.364764879],
              [-13510361.578558227, 4726219.505457204],
              [-13506631.485060725, 4727692.508907568],
              [-13500775.857206019, 4726631.517822387],
              [-13485018.138006266, 4727103.4537983015],
              [-13477315.831118789, 4722413.160541445],
              [-13468138.652297791, 4736326.313625636],
              [-13439367.573304815, 4763021.11427271],
              [-13433082.47485463, 4766227.569585075],
              [-13420076.684786778, 4766979.342686742],
              [-13394225.849995783, 4767098.912157479],
              [-13362419.533766838, 4767085.530665988],
              [-13358872.729180602, 4767105.820461366],
              [-13358911.300014488, 4763478.068873594],
              [-13358713.377169533, 4745424.03005077],
              [-13358629.978174409, 4737826.236977436],
              [-13358558.779113531, 4731344.394105871],
              [-13374331.387198664, 4731314.159329468],
              [-13378832.590808889, 4726115.036116047],
              [-13406796.15821565, 4725706.48392324],
              [-13410768.705564097, 4716731.949937156],
              [-13421094.924169065, 4709318.081487524],
              [-13429856.992608894, 4713711.048487141],
              [-13441427.206523476, 4723154.516250977],
              [-13448763.160966752, 4721690.623706828],
              [-13453951.539793644, 4714834.959811674],
              [-13463010.497315418, 4716278.392294422],
              [-13473833.089529831, 4709601.930564382],
              [-13474168.049877627, 4709580.32685263],
              [-13476114.137215676, 4699900.192822635],
              [-13485355.43606337, 4680498.750053374],
              [-13504037.184327787, 4682041.048175088],
              [-13512144.360203281, 4682755.349636706],
              [-13523581.1020484, 4683726.000869276],
              [-13521906.85690687, 4711076.099034171],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dewey',
        GEOID: '40043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11063161.871659432, 4323252.550715461],
              [-11015714.72169607, 4322876.954958447],
              [-10980209.370107554, 4323334.3176010195],
              [-10979662.346129796, 4274838.784789203],
              [-11062465.34560554, 4274809.40848307],
              [-11062475.253040219, 4283441.487786985],
              [-11063051.442724565, 4286709.450678294],
              [-11063044.763555119, 4302399.977884329],
              [-11063161.871659432, 4323252.550715461],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Del Norte',
        GEOID: '06015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13828061.727988198, 5138003.388112108],
              [-13826259.465432256, 5152140.235656973],
              [-13827172.619215233, 5160748.762309728],
              [-13803749.105920987, 5160402.151022157],
              [-13783806.17446039, 5160323.486236625],
              [-13765434.05038485, 5160251.018066794],
              [-13750084.744229924, 5160855.492070109],
              [-13755242.083085777, 5146481.459876937],
              [-13763854.872088455, 5144419.443026765],
              [-13770630.778173553, 5135471.5463893125],
              [-13765791.05199182, 5118242.0438768035],
              [-13772355.45104441, 5100595.398242278],
              [-13764437.518303268, 5091580.777888813],
              [-13760401.518845066, 5080746.118897206],
              [-13765919.95996216, 5068864.261732508],
              [-13778039.98084177, 5068669.314547997],
              [-13778074.712522896, 5081053.02003118],
              [-13811127.99177474, 5081133.711472511],
              [-13812743.609457592, 5093475.126937442],
              [-13816534.038119104, 5105543.948144683],
              [-13819588.86758545, 5117530.5858924715],
              [-13820787.444542823, 5120441.32129476],
              [-13824883.33388707, 5121526.977385829],
              [-13830893.139236525, 5129917.588916392],
              [-13828061.727988198, 5138003.388112108],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '42091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8426527.226929436, 4901151.650546833],
              [-8411273.228425525, 4925661.970175256],
              [-8407927.07585177, 4931112.581418851],
              [-8402846.788250437, 4926938.071303756],
              [-8386737.076820797, 4914260.1409737505],
              [-8365853.54034798, 4897877.757056531],
              [-8350638.948943809, 4886015.209822526],
              [-8359730.077798424, 4875972.643323499],
              [-8361130.143034129, 4872633.6353592],
              [-8361134.9297722345, 4872620.6934015],
              [-8364482.752138351, 4875153.567424447],
              [-8373853.9608318005, 4879452.470725213],
              [-8378398.133765474, 4873806.188673562],
              [-8371925.461973297, 4867675.048668611],
              [-8371868.132435541, 4867632.318019607],
              [-8371908.76404968, 4867588.715506271],
              [-8372036.224866637, 4867474.7685095845],
              [-8372160.791376836, 4867371.723181646],
              [-8372407.809326906, 4867199.644230273],
              [-8376791.682193836, 4864515.3664612435],
              [-8379739.644949025, 4862594.588870943],
              [-8383630.261152248, 4868821.432440787],
              [-8387863.184789662, 4873633.270876943],
              [-8389155.492758282, 4875471.385853519],
              [-8407509.739080785, 4887561.584111913],
              [-8411425.958766893, 4896479.031790644],
              [-8426527.226929436, 4901151.650546833],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Niagara',
        GEOID: '36063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8800941.873931311, 5330986.860149107],
              [-8800390.446259093, 5332361.668031307],
              [-8799200.948414795, 5335327.98919481],
              [-8800125.011507869, 5345832.037613284],
              [-8802084.345865324, 5352005.726614316],
              [-8775767.527685866, 5360432.543541224],
              [-8743856.01453812, 5368389.979578455],
              [-8734745.20301674, 5368597.390512586],
              [-8734740.061437061, 5331569.5060845325],
              [-8734622.508054784, 5325483.108755265],
              [-8739735.968864374, 5326893.959077884],
              [-8750156.029800078, 5322941.219879102],
              [-8763921.57539259, 5325104.631642892],
              [-8765743.652817894, 5322689.933875296],
              [-8775455.721792156, 5319622.930336008],
              [-8774799.60471342, 5317096.037179798],
              [-8776356.296472672, 5314933.260785282],
              [-8779629.75741894, 5315513.231064628],
              [-8782012.328480387, 5315314.37135745],
              [-8782357.530221337, 5317872.767041833],
              [-8783760.155805333, 5319822.491095988],
              [-8788146.36638157, 5322168.792215581],
              [-8796419.172845855, 5322068.295659813],
              [-8802529.401189514, 5323829.689738138],
              [-8800941.873931311, 5330986.860149107],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pulaski',
        GEOID: '29169',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10286948.53951799, 4559551.724995162],
              [-10286685.93683921, 4576290.454379231],
              [-10286619.479103206, 4582418.127433061],
              [-10262028.446989516, 4581734.081482966],
              [-10243749.230003808, 4580928.855791197],
              [-10244650.1386428, 4523429.485180917],
              [-10269163.24711293, 4523710.646130042],
              [-10269096.678057436, 4529880.808615569],
              [-10287442.575418131, 4539093.71348025],
              [-10286948.53951799, 4559551.724995162],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Canadian',
        GEOID: '40017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10944194.286570698, 4262875.447613952],
              [-10932364.80956206, 4262866.671795066],
              [-10873022.838048963, 4262980.483743436],
              [-10872728.620634796, 4219227.819540434],
              [-10872727.062161926, 4215253.311670833],
              [-10872744.873280453, 4209842.2514811745],
              [-10872752.220366845, 4209627.463602997],
              [-10883903.093759608, 4210964.975144244],
              [-10885952.596904602, 4209226.146255889],
              [-10890794.883434618, 4209549.409578175],
              [-10894037.620201426, 4213161.761100301],
              [-10904314.52427197, 4211007.691940095],
              [-10919998.327329835, 4215335.501975468],
              [-10943410.15207755, 4215265.326162147],
              [-10944181.039551293, 4239085.810114399],
              [-10944194.286570698, 4262875.447613952],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Maunabo',
        GEOID: '72095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7345808.778560221, 2044448.6394868623],
              [-7332023.974695798, 2040561.2352492127],
              [-7330490.721899339, 2038949.2426559262],
              [-7334277.637786908, 2036204.991731457],
              [-7337617.120485103, 2035531.4225677082],
              [-7345071.509572699, 2041626.9085665394],
              [-7344864.566639313, 2042055.394315266],
              [-7345480.942659835, 2042840.9746741562],
              [-7345437.416738934, 2043455.8790495915],
              [-7345875.236296224, 2044211.772963662],
              [-7345808.778560221, 2044448.6394868623],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Caledonia',
        GEOID: '50005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8056724.323792145, 5556286.372624389],
              [-8044276.467012149, 5549757.132053442],
              [-8027749.752769999, 5582190.657396884],
              [-8016395.276028574, 5574230.983379352],
              [-8008317.04322069, 5585233.296048371],
              [-7996890.988046686, 5577021.549420522],
              [-8005015.975040706, 5566124.949640649],
              [-7997496.34343762, 5560513.685840647],
              [-8004835.080868166, 5550498.113127036],
              [-7999044.2409571, 5542550.710511948],
              [-8007576.991245895, 5533970.651330541],
              [-7996946.272243402, 5519418.221115346],
              [-8001184.469487092, 5517800.271167015],
              [-8008898.910199066, 5517858.480710375],
              [-8015260.930417392, 5515855.134173422],
              [-8020157.652178407, 5510738.970532595],
              [-8021013.476423626, 5503734.406874363],
              [-8021831.452041974, 5494108.529643339],
              [-8020995.318390674, 5490207.648276499],
              [-8033956.593618159, 5495211.089402113],
              [-8048953.55541783, 5493828.79680301],
              [-8056008.205507872, 5497074.9690123405],
              [-8050360.745100947, 5511734.5061602285],
              [-8045042.901706261, 5518244.945462997],
              [-8039171.24384488, 5529280.805851296],
              [-8039542.828305147, 5530856.444385713],
              [-8039904.282691753, 5531382.6530082105],
              [-8050767.729159286, 5537307.5588029325],
              [-8063351.061759577, 5544098.989813253],
              [-8056724.323792145, 5556286.372624389],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Caldwell',
        GEOID: '37027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9107104.982654959, 4315975.981810495],
              [-9092035.997144746, 4317494.435599106],
              [-9077602.200648999, 4316797.813818566],
              [-9061163.540124068, 4309715.075168967],
              [-9053427.614750369, 4300151.208299449],
              [-9055171.87985161, 4276453.367933439],
              [-9054089.743081609, 4272626.037080917],
              [-9056231.752723452, 4269879.70299312],
              [-9057376.33972779, 4268718.14299308],
              [-9078771.723219275, 4270053.961380777],
              [-9095887.651526194, 4283435.580401023],
              [-9106731.617082838, 4295387.700674622],
              [-9098773.498005519, 4309924.815485635],
              [-9107104.982654959, 4315975.981810495],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hartford',
        GEOID: '09003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8127298.296298032, 5166808.769692409],
              [-8126272.622818623, 5166771.235671275],
              [-8109306.753185292, 5166507.589441331],
              [-8105180.807578529, 5160727.192354507],
              [-8101249.149668912, 5161298.378866085],
              [-8100356.332167041, 5161428.091083197],
              [-8096878.377316186, 5166433.398099966],
              [-8082678.129112125, 5165593.50248682],
              [-8073794.61110784, 5166118.053876806],
              [-8071684.921554881, 5166085.9050282445],
              [-8069853.678494776, 5153117.990915451],
              [-8072146.971324608, 5152804.284144845],
              [-8072592.249287782, 5141510.52490866],
              [-8070307.973336703, 5140123.209910318],
              [-8066644.337575205, 5122943.22896519],
              [-8060557.1651796475, 5105826.918606968],
              [-8060685.18259406, 5101632.661334321],
              [-8066959.483053642, 5098851.893415581],
              [-8071267.658666832, 5108247.401504347],
              [-8075586.74359012, 5107606.398219888],
              [-8094473.987634543, 5105373.574162381],
              [-8094545.34342814, 5101890.059259125],
              [-8098735.743020071, 5098107.048622819],
              [-8108988.156802642, 5093023.554736603],
              [-8120350.537227911, 5094819.259811026],
              [-8119476.790544676, 5107846.974262362],
              [-8124458.226438183, 5107144.9261924075],
              [-8126161.414647319, 5118009.856122651],
              [-8128208.134805045, 5130796.0128242485],
              [-8120648.2055462925, 5132027.704010942],
              [-8115852.673202409, 5149257.091939646],
              [-8113750.404618778, 5156953.950190745],
              [-8129610.87170853, 5155978.496620982],
              [-8127298.296298032, 5166808.769692409],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Alcorn',
        GEOID: '28003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9887736.752546899, 4163229.819793748],
              [-9883680.437099952, 4163235.9285481144],
              [-9848421.658183545, 4163342.05767713],
              [-9838471.422441367, 4163309.363848526],
              [-9836583.1941898, 4163303.159643478],
              [-9836799.346747274, 4130718.1035586093],
              [-9876099.134498969, 4130877.5794355213],
              [-9879946.00214231, 4130901.832975337],
              [-9879933.868317815, 4144705.753917235],
              [-9887783.784850081, 4144685.947242172],
              [-9887736.752546899, 4163229.819793748],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Northampton',
        GEOID: '42095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8413247.479594745, 4982800.143043816],
              [-8401748.732793253, 4985055.022399948],
              [-8380580.886340947, 4992602.628768048],
              [-8362682.375803069, 5007225.584164122],
              [-8359839.950135836, 5001532.840997888],
              [-8356246.334334048, 4995494.379710935],
              [-8359087.653017055, 4990122.165912385],
              [-8361040.53084404, 4981576.737494652],
              [-8361358.206800663, 4981413.27877571],
              [-8368718.458763036, 4977626.860508184],
              [-8370403.279256192, 4970523.042393555],
              [-8370230.400086989, 4959088.233455322],
              [-8370027.509334008, 4954847.550327736],
              [-8377699.047363292, 4950882.216567979],
              [-8386088.418147945, 4944295.627730065],
              [-8393980.747406207, 4950756.896472715],
              [-8392077.852030586, 4958317.811393098],
              [-8402558.693408264, 4961695.825459599],
              [-8416753.709596258, 4981031.694991003],
              [-8413247.479594745, 4982800.143043816],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lowndes',
        GEOID: '01085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9674587.924348038, 3792885.43056291],
              [-9663679.838764697, 3792848.4539718693],
              [-9669697.102520037, 3799452.2336371485],
              [-9664191.797102854, 3808129.9253402846],
              [-9664324.823894354, 3804068.135484523],
              [-9660456.137630813, 3814942.553566708],
              [-9653392.136703545, 3816303.147316006],
              [-9628776.836940866, 3808608.742018376],
              [-9626294.968893629, 3806910.439497624],
              [-9627432.876728518, 3800712.8303329004],
              [-9626979.695081497, 3798996.6924601328],
              [-9624517.530584132, 3799343.4814769262],
              [-9623430.384437047, 3797961.519976597],
              [-9620479.304736117, 3796661.1976461057],
              [-9618980.387792585, 3795422.876803617],
              [-9618924.839366678, 3790773.3424448096],
              [-9618702.645663053, 3769971.702964224],
              [-9618561.158590257, 3758556.47171487],
              [-9623369.38135609, 3758668.5287587717],
              [-9668941.911094494, 3758345.4818893885],
              [-9668829.812367264, 3769659.2533122846],
              [-9674438.08831343, 3769609.083507057],
              [-9674587.924348038, 3792885.43056291],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sweetwater',
        GEOID: '56037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12251122.73447162, 5201622.257494168],
              [-12189123.678032776, 5200505.17888688],
              [-12138707.414610974, 5200560.232465861],
              [-12106665.991617477, 5200438.543425084],
              [-11982332.918391995, 5200210.061051252],
              [-11969374.661746714, 5200270.227041073],
              [-11969330.022630906, 5174164.095575],
              [-11967927.285727419, 5109804.727729432],
              [-12014683.252972446, 5110124.179938702],
              [-12014699.282979121, 5071303.659997849],
              [-12013423.371241493, 5012522.658172204],
              [-12050407.124721387, 5012358.4788360335],
              [-12139398.931287784, 5012438.86668301],
              [-12161736.188990869, 5012490.492256353],
              [-12213463.462055743, 5012074.840422042],
              [-12245223.773995738, 5011961.927158423],
              [-12250541.08965188, 5011943.023332941],
              [-12250487.32281817, 5097976.241680481],
              [-12251122.73447162, 5201622.257494168],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mower',
        GEOID: '27099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10358225.630236486, 5442018.265648149],
              [-10357829.555488244, 5442021.97025406],
              [-10318135.808058634, 5442037.869204688],
              [-10316961.276111273, 5439742.221460337],
              [-10291371.70816517, 5439805.338720016],
              [-10291369.810327906, 5388452.959208164],
              [-10302967.090361176, 5388435.317970392],
              [-10302970.753827866, 5388435.3123977035],
              [-10338271.945470266, 5388319.906953217],
              [-10355423.039664652, 5388321.159774422],
              [-10358188.673035672, 5388321.361793278],
              [-10358225.630236486, 5442018.265648149],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '25011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8128398.782051138, 5272614.396211953],
              [-8118559.697445221, 5272339.346729016],
              [-8111215.866293861, 5272134.056763198],
              [-8105073.384269914, 5271962.352838071],
              [-8072523.362870202, 5270732.760606553],
              [-8066045.438714737, 5270488.0731914425],
              [-8065230.140533045, 5270457.445163954],
              [-8060870.314115442, 5270293.662752085],
              [-8046510.548171148, 5269754.240098131],
              [-8045277.340553873, 5262583.978939739],
              [-8040042.652818809, 5257174.863607112],
              [-8040356.573782847, 5253684.466827613],
              [-8045223.127961856, 5243307.607996914],
              [-8042261.918187264, 5238203.119923568],
              [-8047429.368949888, 5233082.825593974],
              [-8049985.821055954, 5212602.0840266505],
              [-8054708.216494388, 5206540.563076905],
              [-8056750.595191972, 5224226.020635078],
              [-8068848.129534439, 5222214.911434992],
              [-8069537.753779904, 5226186.125298264],
              [-8089491.438546128, 5222551.121989979],
              [-8093024.6078644125, 5229067.977371048],
              [-8099356.571820226, 5228006.338651728],
              [-8111977.753047386, 5233764.4855330745],
              [-8112613.721298288, 5242396.056973511],
              [-8123585.370310874, 5244638.452386532],
              [-8120872.51432024, 5257487.958079999],
              [-8120627.500121005, 5267065.447332016],
              [-8128885.168069159, 5272627.993236743],
              [-8128398.782051138, 5272614.396211953],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Waukesha',
        GEOID: '55133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9856403.488312405, 5314923.211735523],
              [-9855764.959713215, 5341860.118674929],
              [-9842645.289806282, 5341653.825534912],
              [-9803167.613508299, 5341259.880931281],
              [-9803420.08611342, 5331080.965680654],
              [-9803416.523889715, 5330358.192438915],
              [-9803465.0591877, 5327848.824044913],
              [-9803823.730587035, 5305760.5370880505],
              [-9803828.51732514, 5304725.491371509],
              [-9803899.093882302, 5288154.334609936],
              [-9830221.700675279, 5287967.897062209],
              [-9856398.59025481, 5288104.688418848],
              [-9856403.488312405, 5314923.211735523],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Williamsburg',
        GEOID: '45089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8902707.480746744, 3991479.348702793],
              [-8905073.687843045, 3997679.8856520844],
              [-8896131.059189148, 4004476.8000731245],
              [-8891713.345197018, 4013403.6218870375],
              [-8870766.57925343, 4002636.7266935925],
              [-8865017.595470902, 4004395.0663563134],
              [-8849506.114984786, 3998679.7071153196],
              [-8830342.575964214, 4001860.940382535],
              [-8829532.615349203, 3999283.177556388],
              [-8839806.402474003, 3987103.663315807],
              [-8842745.348350437, 3971569.642930347],
              [-8854138.564274656, 3961445.856755656],
              [-8869645.925939614, 3940042.7687849263],
              [-8869604.62640853, 3935850.482122143],
              [-8902315.858778132, 3961952.195786629],
              [-8916880.121717088, 3961445.1893051895],
              [-8902707.480746744, 3991479.348702793],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Arkansas',
        GEOID: '05001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10209078.106679296, 4070202.4559728387],
              [-10208574.49730295, 4093798.4203543216],
              [-10205552.395766893, 4093697.1350223934],
              [-10196366.645345105, 4093506.7210634956],
              [-10196245.19578065, 4105334.7033244874],
              [-10172132.392199408, 4104716.9192332914],
              [-10162521.401322791, 4104484.5492770397],
              [-10142069.67315476, 4076354.8391062273],
              [-10136338.277851775, 4074089.90372068],
              [-10138826.491109988, 4048117.685480561],
              [-10143198.786749875, 4044806.1518939743],
              [-10151700.59022023, 4038331.2483279766],
              [-10146923.536911817, 4020414.229131492],
              [-10156727.778424453, 4025279.1792009915],
              [-10168771.434133379, 4022753.3068377078],
              [-10177018.761247778, 4030745.4277259205],
              [-10178669.963254716, 4032855.988965797],
              [-10179679.185758248, 4039568.8937679534],
              [-10180382.39098159, 4046791.0196497827],
              [-10187333.513945192, 4047924.5399875958],
              [-10189962.546359258, 4058893.5739115765],
              [-10209310.319137093, 4060255.047479591],
              [-10209078.106679296, 4070202.4559728387],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '22061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10339443.917069338, 3840384.917766865],
              [-10333625.247285573, 3863334.139141172],
              [-10322148.65306275, 3863430.2420295756],
              [-10304989.421473911, 3861979.3835841417],
              [-10299096.278950807, 3851678.6685264595],
              [-10287596.307634916, 3851590.8602222507],
              [-10287598.645344224, 3840063.6166979717],
              [-10287629.703482153, 3828528.04776063],
              [-10310671.168284, 3828649.4733644365],
              [-10310598.03137855, 3822921.780660799],
              [-10327910.327267228, 3822981.9369727448],
              [-10339272.819011988, 3823069.4016273413],
              [-10339443.917069338, 3840384.917766865],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Belknap',
        GEOID: '33001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7976169.866710936, 5406995.468117103],
              [-7975857.39290028, 5416748.635183631],
              [-7968405.3322281055, 5417893.682902283],
              [-7961733.175908429, 5418824.081004988],
              [-7962867.744158593, 5428527.333276977],
              [-7952652.177127476, 5418449.323909589],
              [-7942005.024430554, 5408241.27279474],
              [-7941935.4497488085, 5408175.7566024],
              [-7932433.106695203, 5399344.701561207],
              [-7921792.744487219, 5394370.041324489],
              [-7921424.165653202, 5366182.350235789],
              [-7929956.470664033, 5355451.936587311],
              [-7956165.865534875, 5374786.615207016],
              [-7964912.905843447, 5381133.378371978],
              [-7971858.796790984, 5378862.926454609],
              [-7984676.902197358, 5398125.750066875],
              [-7976169.866710936, 5406995.468117103],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gloucester',
        GEOID: '34015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8394657.623080548, 4837598.247011665],
              [-8387006.915266481, 4843600.479644375],
              [-8381620.276426486, 4843991.962958099],
              [-8373566.1999481, 4845780.077521189],
              [-8372472.047516404, 4846564.047832595],
              [-8369335.836658973, 4848811.514193849],
              [-8364706.339756507, 4850538.739846181],
              [-8358654.397558888, 4833962.375486571],
              [-8342691.961815568, 4822205.253852395],
              [-8335298.45519555, 4809191.216712707],
              [-8339152.558605796, 4804873.28576166],
              [-8347322.184715623, 4795706.926658008],
              [-8355847.365279045, 4803470.106460432],
              [-8371202.664519578, 4817668.391368928],
              [-8390883.505213864, 4826265.80467079],
              [-8391065.957859276, 4829081.23100594],
              [-8396724.66153477, 4834577.141035299],
              [-8394657.623080548, 4837598.247011665],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Russell',
        GEOID: '01113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9510474.385809619, 3817229.547520473],
              [-9498908.068077216, 3817361.67024863],
              [-9499319.950193152, 3824985.210524172],
              [-9468757.29531535, 3825548.6260937005],
              [-9462282.601863671, 3830464.2462874507],
              [-9462132.979249278, 3830056.64501703],
              [-9459020.958692096, 3821582.0623911326],
              [-9460058.377769614, 3813169.015309997],
              [-9460316.160967477, 3811079.4202345116],
              [-9463057.960025715, 3807586.305938144],
              [-9457225.709264074, 3803533.393802081],
              [-9450116.512623545, 3797935.5858644852],
              [-9453244.71810136, 3793651.3323890627],
              [-9454378.490648055, 3792098.9460056433],
              [-9461907.91836633, 3787677.85695662],
              [-9468696.626192866, 3781178.3760059145],
              [-9467395.746623456, 3774787.26569049],
              [-9467879.778008614, 3771485.4826930882],
              [-9482758.28163089, 3771413.489492874],
              [-9490858.667017447, 3782744.572251361],
              [-9507824.536650777, 3782576.2814695872],
              [-9509739.231892422, 3782563.1338517657],
              [-9510418.503425242, 3794151.388506816],
              [-9510474.385809619, 3817229.547520473],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lake',
        GEOID: '12069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9123105.044386167, 3318709.021087071],
              [-9123098.699175192, 3370562.6587324245],
              [-9101665.689695818, 3370674.4930180837],
              [-9090204.680201707, 3370599.809493332],
              [-9088226.198891837, 3397149.2328875926],
              [-9088336.516507214, 3410919.5272497237],
              [-9085044.131247513, 3401501.575875594],
              [-9076018.569572974, 3398145.194150966],
              [-9072767.261205377, 3388099.9368741983],
              [-9056347.524993876, 3373657.472805843],
              [-9057726.328206843, 3360283.300171943],
              [-9063281.838714372, 3353336.4913662826],
              [-9063014.671936467, 3348303.9929669523],
              [-9088848.25220639, 3348420.465537335],
              [-9090193.436933136, 3346007.139546474],
              [-9090046.940483252, 3318025.193714308],
              [-9090045.493329873, 3292805.806183544],
              [-9112349.02122725, 3294674.14714406],
              [-9123482.86273792, 3292563.2065645666],
              [-9123105.044386167, 3318709.021087071],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shelby',
        GEOID: '01117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9687784.182064636, 3928063.1513656424],
              [-9682386.745234035, 3929362.7410513274],
              [-9671717.662597425, 3939546.313647864],
              [-9665937.843315948, 3939456.7781055593],
              [-9648552.076563345, 3957391.8060100265],
              [-9631050.537540317, 3965082.699321592],
              [-9631004.228632146, 3967988.72407464],
              [-9627081.997693539, 3968012.3652352374],
              [-9627125.412294947, 3962199.8334202864],
              [-9615579.68866834, 3962182.0780925816],
              [-9615629.00320276, 3947316.1532245786],
              [-9611448.733684493, 3942466.1904262207],
              [-9613255.115061596, 3934781.3708318095],
              [-9624463.429311607, 3927394.311285633],
              [-9629484.049665874, 3919106.5453643803],
              [-9628137.306466257, 3908976.0428035352],
              [-9630376.275384583, 3907047.590586814],
              [-9631066.678866481, 3898034.0741863796],
              [-9641381.431563895, 3904599.381271767],
              [-9671619.701445526, 3904846.1983172526],
              [-9671568.939757725, 3901929.361183149],
              [-9687645.032701144, 3917331.2103739297],
              [-9687784.182064636, 3928063.1513656424],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Meeker',
        GEOID: '27093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10548977.811602246, 5673006.187918198],
              [-10535287.295346526, 5672927.179974488],
              [-10506750.321242688, 5673105.463415298],
              [-10506717.481992906, 5666152.501801874],
              [-10493066.595475907, 5666333.498557961],
              [-10492605.732784025, 5659268.9486611625],
              [-10492538.161853112, 5618289.249837247],
              [-10519901.717204498, 5618325.445732202],
              [-10519958.4901448, 5604581.445318596],
              [-10548433.347972777, 5604550.3327552],
              [-10548977.811602246, 5673006.187918198],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marshall',
        GEOID: '40095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10794474.58083083, 4052003.8893647925],
              [-10790606.896442708, 4051995.2781937644],
              [-10755776.474926874, 4050580.9819591027],
              [-10751832.536687559, 4044181.447462544],
              [-10747677.314054718, 4037305.1085689976],
              [-10756223.867960373, 4030107.7965023946],
              [-10750903.57553689, 4024023.6223356086],
              [-10752869.957239324, 4013105.0850771703],
              [-10760130.402850779, 4017617.787224299],
              [-10762602.474782826, 4012250.4657314764],
              [-10765977.570424186, 4006216.794631999],
              [-10773140.31173979, 4007602.9493768816],
              [-10775089.51602358, 4011210.177234053],
              [-10781358.695786586, 4008304.60088133],
              [-10786546.295377044, 4015778.551163653],
              [-10787443.419153346, 4021717.027322872],
              [-10790681.736885134, 4021498.2865672633],
              [-10790731.574272396, 4030539.952944998],
              [-10794609.500053672, 4038342.268141066],
              [-10794474.58083083, 4052003.8893647925],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hampshire',
        GEOID: '54027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8777642.70450828, 4769176.712452334],
              [-8768352.091126163, 4785938.562535525],
              [-8755838.574943092, 4799952.370442795],
              [-8748671.584390348, 4797904.096358895],
              [-8735047.814745033, 4797331.4538835],
              [-8733014.498010274, 4794519.861703846],
              [-8721557.829976304, 4788645.331323461],
              [-8720449.755764946, 4780452.148168461],
              [-8720822.342100631, 4772433.501172949],
              [-8727649.900429456, 4761392.096688749],
              [-8728002.449256798, 4755821.457719386],
              [-8730642.613619944, 4748524.39139078],
              [-8729000.205852779, 4744388.631624609],
              [-8739485.277371107, 4734375.022777717],
              [-8745401.908306768, 4740517.3250595145],
              [-8752334.106956936, 4738661.214346906],
              [-8792002.028264685, 4755766.554487558],
              [-8777642.70450828, 4769176.712452334],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'King',
        GEOID: '48269',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11189689.497326411, 4006755.1275671446],
              [-11137345.848241016, 4006798.549100645],
              [-11131552.114023188, 4006797.6109793535],
              [-11130944.9775204, 3948172.2789037847],
              [-11189551.238518845, 3948233.8807923696],
              [-11189689.497326411, 4006755.1275671446],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dickinson',
        GEOID: '19059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10618519.942863455, 5388462.741184914],
              [-10599278.414073113, 5388525.09023352],
              [-10565846.441958696, 5388480.718846877],
              [-10565747.313653816, 5350874.596062465],
              [-10618552.27070906, 5350900.121411535],
              [-10618519.942863455, 5388462.741184914],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mariposa',
        GEOID: '06043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13401968.454538926, 4534819.255392671],
              [-13392437.391056696, 4532267.964860388],
              [-13396792.766133986, 4540620.0668797055],
              [-13372501.628728494, 4548614.204515605],
              [-13367189.68526682, 4555270.271963372],
              [-13347987.629702436, 4545285.09097072],
              [-13337122.402123049, 4544876.629650457],
              [-13321292.102615299, 4551383.362039963],
              [-13318954.393308641, 4557809.581663725],
              [-13306653.144298019, 4565890.306944879],
              [-13299817.682285352, 4559050.2138126595],
              [-13294529.672514198, 4560615.454343342],
              [-13281416.570457222, 4548109.981025912],
              [-13311983.789434146, 4517500.731251865],
              [-13312054.477310803, 4508287.187965702],
              [-13319507.539858393, 4503609.755542777],
              [-13319509.654928716, 4497508.313087735],
              [-13331823.594361288, 4497407.677932861],
              [-13364133.631286072, 4464660.50665271],
              [-13378113.244259385, 4475623.1025226405],
              [-13401494.122188656, 4527761.130516291],
              [-13401487.77697768, 4527808.923265699],
              [-13401968.454538926, 4534819.255392671],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gentry',
        GEOID: '29075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10531485.289457973, 4884287.674680359],
              [-10530655.402654108, 4922298.66933485],
              [-10487885.452415917, 4921939.151081209],
              [-10488154.622944655, 4885816.305879038],
              [-10488388.839153284, 4871012.968344394],
              [-10531422.393945675, 4871642.824679278],
              [-10531485.289457973, 4884287.674680359],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Leslie',
        GEOID: '21131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9300888.50507451, 4462481.3119087545],
              [-9296055.346742738, 4472036.196386965],
              [-9283904.15640571, 4483883.966720894],
              [-9275654.268943017, 4470593.89078211],
              [-9261991.693879487, 4463406.136377907],
              [-9258134.028245537, 4453385.746176334],
              [-9259789.460393125, 4442050.354755273],
              [-9268463.029837774, 4434779.840258954],
              [-9284007.238254182, 4428094.6532476535],
              [-9285004.43825271, 4423815.619303689],
              [-9294043.469585631, 4424538.71723044],
              [-9296188.596173218, 4430539.197167167],
              [-9301088.657518957, 4450163.305099735],
              [-9300888.50507451, 4462481.3119087545],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Boone',
        GEOID: '31011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10942216.361858284, 5148248.466604572],
              [-10890751.802791681, 5148447.729731428],
              [-10890440.664814914, 5122445.808844204],
              [-10890368.641104368, 5090264.754369294],
              [-10913910.709656313, 5087939.476038959],
              [-10920388.947423028, 5083516.902188369],
              [-10941742.363466486, 5083509.472749088],
              [-10941703.179005723, 5119096.877323547],
              [-10942233.950337829, 5122287.666286389],
              [-10942216.361858284, 5148248.466604572],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rhea',
        GEOID: '47143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9478453.111643953, 4230848.780571818],
              [-9474152.728395117, 4241800.197634713],
              [-9452812.782010047, 4267913.794677956],
              [-9440074.270039592, 4276302.758573925],
              [-9437878.04780573, 4276568.2827645475],
              [-9434824.665492762, 4266878.230355564],
              [-9431416.174004162, 4266673.296564979],
              [-9431347.935156306, 4258004.0325486185],
              [-9437867.249815123, 4255843.88866509],
              [-9439325.535144517, 4239226.32982152],
              [-9448127.010684088, 4238907.118714812],
              [-9446566.311423166, 4231638.104560944],
              [-9452377.077523082, 4224202.277346828],
              [-9458700.581197595, 4227482.519034766],
              [-9463976.011866288, 4219641.793782022],
              [-9473528.893968714, 4222258.208910445],
              [-9477206.110708086, 4226385.716407891],
              [-9478453.111643953, 4230848.780571818],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Haskell',
        GEOID: '48207',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11130944.9775204, 3948172.2789037847],
              [-11073221.814042421, 3948388.153625773],
              [-11073089.789126338, 3889601.1391694276],
              [-11088757.228219057, 3889592.781044929],
              [-11130705.306656724, 3890011.888629265],
              [-11130944.9775204, 3948172.2789037847],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Smith',
        GEOID: '48423',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10641535.626736712, 3853835.201985298],
              [-10627570.819255678, 3843075.76009721],
              [-10621333.365547549, 3843269.8837928534],
              [-10612327.952700846, 3842892.0789327174],
              [-10593753.29378657, 3834980.239761021],
              [-10592429.148443585, 3838381.9486068245],
              [-10577025.536544047, 3834760.633541818],
              [-10576463.929712996, 3831298.9725068533],
              [-10573897.236213775, 3834040.966379429],
              [-10573727.585309807, 3812085.5490522287],
              [-10573712.111900587, 3781437.4882807354],
              [-10626548.349732742, 3781118.0355950417],
              [-10628627.463862287, 3782651.6175977583],
              [-10629757.134054856, 3793866.865285853],
              [-10625352.44444315, 3810031.338917827],
              [-10641508.798739431, 3826465.585988628],
              [-10641535.626736712, 3853835.201985298],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morgan',
        GEOID: '13211',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9314952.27558286, 3971415.461249244],
              [-9315314.731844882, 3974805.6625679624],
              [-9298114.757322416, 4001458.5327946777],
              [-9295837.383179765, 4004357.817413168],
              [-9293304.753444728, 4002725.4142952613],
              [-9284734.488487534, 3988363.6096518473],
              [-9278131.127613168, 3975283.9868940827],
              [-9269486.389916634, 3966296.570154503],
              [-9270679.512218958, 3959649.486629912],
              [-9298932.955579745, 3953115.8720551827],
              [-9315459.447182914, 3965360.9836273184],
              [-9314952.27558286, 3971415.461249244],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Owen',
        GEOID: '21187',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9470459.259010088, 4664085.509553954],
              [-9455746.718509395, 4671727.2092928095],
              [-9454869.298282962, 4673389.502601835],
              [-9441211.398638045, 4679118.86915368],
              [-9438310.746666444, 4681708.457038953],
              [-9437034.35738501, 4667184.759508175],
              [-9415462.532500615, 4646467.576481101],
              [-9429427.45130114, 4631841.55291724],
              [-9433279.773599533, 4629330.553668148],
              [-9439159.446464252, 4627379.476340689],
              [-9447738.83961969, 4629946.072908206],
              [-9452386.205721328, 4644591.571336351],
              [-9458067.395933961, 4641395.404515425],
              [-9459614.84817548, 4652149.580402986],
              [-9470459.259010088, 4664085.509553954],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Waupaca',
        GEOID: '55135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9932341.860068887, 5571497.637739626],
              [-9863481.181537041, 5571022.643235249],
              [-9863584.040746534, 5557285.179286305],
              [-9878135.61326354, 5557299.247769946],
              [-9878466.009512214, 5503171.408235988],
              [-9881408.18365388, 5503181.197869165],
              [-9894819.17666822, 5503065.587632206],
              [-9932460.749285055, 5503185.39342945],
              [-9932341.860068887, 5571497.637739626],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Woods',
        GEOID: '40151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11065938.291079307, 4439048.105442314],
              [-11035039.785297781, 4439026.221810769],
              [-11020663.101699172, 4439017.314787637],
              [-10997468.01000167, 4439002.944366937],
              [-10969941.591268469, 4438901.087390221],
              [-10968712.070459444, 4364549.745638428],
              [-10968704.61205356, 4355468.235717652],
              [-10978924.965822782, 4354777.177615196],
              [-10999236.208793432, 4364205.648902421],
              [-11003224.34087059, 4370505.779426962],
              [-11016213.989612276, 4370598.016100842],
              [-11016173.803276101, 4383357.73288947],
              [-11036198.175918978, 4408908.353594197],
              [-11048502.096597375, 4409182.865334023],
              [-11053489.543743387, 4413986.367509821],
              [-11062287.345739761, 4422337.42342507],
              [-11071413.811260788, 4439065.010147623],
              [-11065938.291079307, 4439048.105442314],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Alamance',
        GEOID: '37001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8854544.65777707, 4286849.759827146],
              [-8853507.382761858, 4333897.37674732],
              [-8853446.713639377, 4335030.599272243],
              [-8822954.857957719, 4334170.940395969],
              [-8824100.446837472, 4288132.140135827],
              [-8822018.215762183, 4283683.830756374],
              [-8820655.331236402, 4279211.10914188],
              [-8854622.581420625, 4279081.472528233],
              [-8854544.65777707, 4286849.759827146],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Natchitoches',
        GEOID: '22069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10401823.5748472, 3743012.1547430507],
              [-10399442.450939134, 3754657.8240594934],
              [-10392281.379415892, 3754416.9959714],
              [-10379373.77313892, 3750652.780133201],
              [-10379259.002743913, 3759738.240500248],
              [-10366203.230224695, 3759715.8007726436],
              [-10373547.422310293, 3782807.8133824733],
              [-10345931.060395315, 3782746.018510506],
              [-10338483.118544301, 3756205.482294402],
              [-10349016.836680107, 3734636.8350221487],
              [-10349765.905533653, 3725162.471260981],
              [-10348773.603592722, 3721472.8793368046],
              [-10342506.09362208, 3714208.178977038],
              [-10331139.59437565, 3710728.4091887353],
              [-10321429.974430189, 3700152.594215351],
              [-10346823.286114024, 3677863.7136196382],
              [-10350649.2256931, 3677849.7666692585],
              [-10351823.535001475, 3679646.838087615],
              [-10378995.620828697, 3680178.3451364897],
              [-10379057.73710456, 3702861.8427176005],
              [-10390278.073859576, 3702831.9325676267],
              [-10390446.83420762, 3725860.8476279187],
              [-10401887.249595935, 3725890.4218819146],
              [-10401823.5748472, 3743012.1547430507],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stark',
        GEOID: '38089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11491621.352205006, 5938858.470955467],
              [-11469545.583985792, 5938904.810020522],
              [-11413082.22318512, 5939023.43262198],
              [-11370703.894915538, 5943756.599470107],
              [-11365349.872686345, 5938999.283736041],
              [-11365301.337388357, 5896117.620142835],
              [-11365339.853932172, 5882054.390726517],
              [-11457892.882328534, 5881898.929273102],
              [-11491685.694870684, 5881850.135370278],
              [-11491621.352205006, 5938858.470955467],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '47115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9559341.415878052, 4194276.7288802783],
              [-9544545.719717735, 4193177.5013880013],
              [-9541128.767947836, 4203259.006774836],
              [-9524334.330330325, 4207356.753872534],
              [-9507039.28896272, 4194284.496216712],
              [-9505247.267799933, 4183898.8520742906],
              [-9502791.782472013, 4173745.3193069],
              [-9514959.875909435, 4161662.63567943],
              [-9529523.377074165, 4161799.1403622804],
              [-9558330.758667426, 4162118.8292124174],
              [-9558260.72626143, 4192268.57849876],
              [-9559341.415878052, 4194276.7288802783],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Atchison',
        GEOID: '20005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10638149.844424235, 4815626.065498676],
              [-10613171.309163094, 4815641.680680658],
              [-10588174.406185977, 4815579.36468333],
              [-10580255.332706187, 4809959.40800257],
              [-10580602.009144252, 4807279.049230619],
              [-10583888.494470943, 4804628.047366562],
              [-10587992.732777001, 4801332.354640483],
              [-10585528.386731982, 4798346.602586227],
              [-10580900.345379578, 4792741.763701743],
              [-10573363.904533383, 4784974.774981665],
              [-10571538.645444915, 4782255.124729736],
              [-10575112.511094766, 4781848.219660077],
              [-10595488.319370076, 4781900.095184982],
              [-10638842.808254423, 4781875.886573352],
              [-10638149.844424235, 4815626.065498676],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dakota',
        GEOID: '27037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10389405.217732266, 5588691.995670777],
              [-10380751.017879015, 5591890.9083826],
              [-10374747.223782063, 5599822.310927188],
              [-10372587.514341183, 5603959.685771681],
              [-10363403.878989719, 5609452.668408326],
              [-10354943.931647902, 5604338.675886548],
              [-10353829.40090608, 5597308.105360968],
              [-10354489.414166993, 5586257.563271821],
              [-10329598.35372504, 5583657.890220242],
              [-10322837.147560453, 5576753.010193313],
              [-10322883.806979949, 5563380.122970184],
              [-10329623.200272063, 5563415.943519083],
              [-10329624.981383918, 5549856.311306468],
              [-10357092.397820212, 5545543.247467001],
              [-10357108.093868414, 5538758.071010783],
              [-10384069.785858035, 5538777.882810488],
              [-10384051.418142054, 5550010.314621336],
              [-10383678.275208917, 5563576.903101055],
              [-10388193.616394473, 5563549.8416695455],
              [-10388129.719006758, 5577162.384877596],
              [-10389405.217732266, 5588691.995670777],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Barbour',
        GEOID: '01005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9544058.02902857, 3714119.8031739797],
              [-9536256.981752759, 3735283.503869668],
              [-9535367.984299285, 3747605.100325173],
              [-9527539.552428737, 3762963.434800381],
              [-9509854.447565392, 3765273.3382670265],
              [-9507824.536650777, 3782576.2814695872],
              [-9490858.667017447, 3782744.572251361],
              [-9482758.28163089, 3771413.489492874],
              [-9467879.778008614, 3771485.4826930882],
              [-9469235.584292576, 3762241.7793138865],
              [-9469707.407169271, 3759026.6196717178],
              [-9474850.5902829, 3749320.5957050235],
              [-9477945.272126954, 3742229.5803598952],
              [-9476534.66667018, 3734503.166680799],
              [-9476120.698622834, 3732236.6444866722],
              [-9486210.1877209, 3724310.2631503446],
              [-9508469.855738906, 3724867.0114031304],
              [-9508514.272215731, 3713462.6263283053],
              [-9514147.149769364, 3713606.425667252],
              [-9545451.637733812, 3713277.25841551],
              [-9544058.02902857, 3714119.8031739797],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mobile',
        GEOID: '01097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9844205.989067204, 3647601.827593285],
              [-9832826.35412086, 3651441.1572710793],
              [-9798636.46495505, 3651499.1666725976],
              [-9793094.980703363, 3653896.130037909],
              [-9789449.490018863, 3651885.46942205],
              [-9793468.23495599, 3644382.434646583],
              [-9789564.260413872, 3639005.346775849],
              [-9792239.824375087, 3628565.988906893],
              [-9787687.191160116, 3624363.0913126688],
              [-9794660.355382897, 3616549.9965975657],
              [-9789942.078765623, 3610308.085404275],
              [-9799045.007486263, 3600759.2396116997],
              [-9797049.828252774, 3591901.917004652],
              [-9803016.775598276, 3586716.8451983985],
              [-9803339.602121575, 3579395.6600458696],
              [-9805200.752688149, 3573968.8770638746],
              [-9807666.590728711, 3568100.120936736],
              [-9807881.548665432, 3555311.1405533114],
              [-9811273.898827866, 3544843.5459010126],
              [-9817896.406654648, 3544909.702285181],
              [-9824809.34703291, 3544611.9368058518],
              [-9830803.233695185, 3551058.2134562],
              [-9836637.933485622, 3553522.534891708],
              [-9840088.949019706, 3551124.9185091183],
              [-9841080.583043693, 3573586.537387747],
              [-9842008.876277415, 3597963.2767925933],
              [-9842030.854235789, 3598458.836693767],
              [-9843539.626564113, 3632525.946942491],
              [-9844205.989067204, 3647601.827593285],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McCulloch',
        GEOID: '48307',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11087780.065728873, 3644091.3876666017],
              [-11087627.224068016, 3696804.3789910483],
              [-11077566.947726555, 3687989.217376059],
              [-11065411.638568364, 3690833.0367160207],
              [-11055681.313197616, 3686094.4006885183],
              [-11043201.619043253, 3693578.1970142326],
              [-11031484.129442353, 3691109.925955086],
              [-11030717.583428752, 3692755.0800946034],
              [-11030906.269965645, 3625089.497973837],
              [-11074592.268293576, 3625037.9719261834],
              [-11087825.038803153, 3625053.676316018],
              [-11087780.065728873, 3644091.3876666017],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dallas',
        GEOID: '48113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10802044.528843755, 3854650.2535557947],
              [-10802021.151750688, 3857021.524386549],
              [-10801905.379480263, 3863407.4737813305],
              [-10801863.412032235, 3866938.798759243],
              [-10801784.931791224, 3870993.8532026242],
              [-10801584.779346777, 3893886.9886748544],
              [-10796901.234410632, 3893882.078138838],
              [-10795771.898176536, 3893870.92990255],
              [-10793389.215795597, 3893845.713692942],
              [-10780622.428674478, 3893652.0815552683],
              [-10776102.41207031, 3893578.9560630773],
              [-10754951.931458568, 3893183.210411414],
              [-10744208.37608262, 3892955.8816807494],
              [-10744442.592291247, 3870590.6558265546],
              [-10744474.986263068, 3868261.28250484],
              [-10744881.636362936, 3837643.965871302],
              [-10745668.999121316, 3835102.127589903],
              [-10802263.605601635, 3835548.488082721],
              [-10802044.528843755, 3854650.2535557947],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Salinas',
        GEOID: '72123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7383960.305764383, 2039408.6421606601],
              [-7381664.786544734, 2043046.682261905],
              [-7375754.166861574, 2046432.547618438],
              [-7372076.504844239, 2048710.8297684412],
              [-7369577.159636946, 2042946.6966438233],
              [-7365581.569153905, 2043409.163468547],
              [-7369972.789107225, 2039067.886829836],
              [-7371635.756914196, 2027930.632481206],
              [-7374163.188699157, 2027457.8212369536],
              [-7380223.867055907, 2032767.4434635185],
              [-7384727.901040895, 2034780.7100296852],
              [-7383960.305764383, 2039408.6421606601],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '26163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9300955.74204695, 5226389.744913868],
              [-9287800.783861436, 5226958.99813343],
              [-9274786.533512285, 5227425.557933835],
              [-9262177.708748603, 5227835.117769084],
              [-9256436.739969412, 5228025.044909693],
              [-9248801.00213743, 5228197.928691374],
              [-9225083.190076463, 5228779.750232046],
              [-9225084.829901885, 5228761.406948231],
              [-9231054.114956694, 5213864.290980982],
              [-9233915.25949024, 5212688.869860729],
              [-9238250.808716988, 5210908.008870561],
              [-9250262.404412564, 5204540.279694059],
              [-9250411.293814732, 5203919.310797065],
              [-9252395.49084015, 5195647.754917596],
              [-9254425.976007214, 5187190.694353502],
              [-9254380.112377007, 5174191.996112049],
              [-9260170.395690618, 5168808.407397165],
              [-9261219.727907954, 5165940.141813708],
              [-9271149.72574807, 5174463.355602271],
              [-9299563.023897635, 5173810.245861529],
              [-9299864.25443972, 5187131.212042426],
              [-9300045.259931752, 5200376.420944487],
              [-9300470.50038658, 5213434.850612739],
              [-9300955.74204695, 5226389.744913868],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Audubon',
        GEOID: '19009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10585688.864595544, 5140535.452081027],
              [-10546951.351591844, 5140388.968054864],
              [-10546876.544894032, 5101573.709396863],
              [-10542038.711143646, 5101573.560528793],
              [-10542025.798082715, 5086990.198468921],
              [-10579890.12100063, 5087070.763020055],
              [-10579887.671971833, 5101568.796751739],
              [-10585650.904649181, 5101554.3565669805],
              [-10585688.864595544, 5140535.452081027],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Darlington',
        GEOID: '45031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8937685.62322686, 4078081.3161658146],
              [-8910688.86559764, 4095094.547851435],
              [-8892706.537693875, 4094952.8673864985],
              [-8886632.834956702, 4100452.1609734064],
              [-8878037.634433573, 4098038.231055576],
              [-8877792.397595355, 4087605.0785198906],
              [-8867461.72621076, 4069855.574166189],
              [-8874958.537318232, 4068737.377226092],
              [-8913338.046839539, 4040381.25153419],
              [-8923212.530950863, 4050524.74741233],
              [-8918107.975700539, 4055287.508930437],
              [-8925287.860217722, 4078080.776726961],
              [-8932635.05792957, 4072452.055267401],
              [-8937696.309897978, 4077802.429713474],
              [-8937685.62322686, 4078081.3161658146],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chester',
        GEOID: '42029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8471612.622576129, 4825954.620632367],
              [-8459351.114623722, 4846882.311265827],
              [-8459683.40330374, 4859031.797550314],
              [-8453142.38134422, 4871388.231116559],
              [-8453935.755355101, 4881833.244283107],
              [-8446185.469767094, 4885886.344073617],
              [-8426527.226929436, 4901151.650546833],
              [-8411425.958766893, 4896479.031790644],
              [-8407509.739080785, 4887561.584111913],
              [-8389155.492758282, 4875471.385853519],
              [-8393978.743655372, 4869929.714844652],
              [-8415485.891915616, 4847672.513966859],
              [-8415120.864754453, 4841935.103788403],
              [-8422749.488689877, 4840026.079028866],
              [-8428784.452244252, 4835809.248817214],
              [-8432810.766906753, 4830835.972547968],
              [-8435099.272998482, 4825654.879972615],
              [-8436747.91465713, 4825654.735242456],
              [-8475387.068763297, 4825592.291699536],
              [-8471612.622576129, 4825954.620632367],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '21173',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9350040.735678354, 4603945.362589344],
              [-9348379.737556228, 4606601.305563837],
              [-9348009.934207812, 4601877.616243284],
              [-9337629.50301083, 4598729.077212684],
              [-9324057.09673484, 4579246.547281437],
              [-9325809.042880947, 4577824.398764758],
              [-9325098.267932232, 4567900.782015468],
              [-9330234.10395947, 4565340.806281725],
              [-9347086.872990154, 4569650.2643965],
              [-9359801.451270089, 4595700.913603124],
              [-9350040.735678354, 4603945.362589344],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carroll',
        GEOID: '28015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10038207.920327691, 3950785.8468553014],
              [-10030042.07908055, 3956380.2166116945],
              [-10032978.01933073, 3985507.1535871807],
              [-9995030.874711668, 3985476.52053313],
              [-9994845.750398478, 3950688.75597506],
              [-9979382.02597391, 3948857.6516968487],
              [-9979266.92162043, 3933262.9144240143],
              [-9985526.8618657, 3933242.14056749],
              [-9990862.071100948, 3923807.0562379244],
              [-10038192.112959996, 3939638.38142127],
              [-10038207.920327691, 3950785.8468553014],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dakota',
        GEOID: '31043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10767557.86191549, 5203077.545286301],
              [-10767069.503309378, 5239896.656101675],
              [-10756573.68466251, 5240265.842801749],
              [-10754741.76025995, 5237093.039162376],
              [-10745129.656188425, 5237719.114096514],
              [-10742477.914598238, 5233569.461765937],
              [-10736264.839858592, 5234759.139206811],
              [-10729118.017230174, 5230391.836114789],
              [-10732513.373018859, 5222729.484280253],
              [-10732089.245758936, 5211656.292195268],
              [-10725850.811603947, 5203149.4209797],
              [-10729005.695863962, 5202465.794702905],
              [-10767562.648653593, 5202714.64273543],
              [-10767557.86191549, 5203077.545286301],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Johnson',
        GEOID: '47091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9126399.656035686, 4370791.909594277],
              [-9113887.345270522, 4383777.046550987],
              [-9108910.378637785, 4385538.801699689],
              [-9088891.332849327, 4385150.330662628],
              [-9092301.605449779, 4381850.058903091],
              [-9094798.1676698, 4374741.868024692],
              [-9094280.42071812, 4365197.82906248],
              [-9098621.99217855, 4357646.666403914],
              [-9097626.882725026, 4354382.158698832],
              [-9095466.529892523, 4347298.41964922],
              [-9102480.882326897, 4347650.26742296],
              [-9109630.376623096, 4348520.538917141],
              [-9117972.102665689, 4342257.866585406],
              [-9119119.525300818, 4340233.759432053],
              [-9120892.26276497, 4337107.314849307],
              [-9134760.083752733, 4351309.419868708],
              [-9126399.656035686, 4370791.909594277],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Benito',
        GEOID: '06069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13541348.249376463, 4424341.478516333],
              [-13534374.417236736, 4425059.183330044],
              [-13530662.468816234, 4427598.404645779],
              [-13529772.69212632, 4428068.197209419],
              [-13529154.534993948, 4429484.10562978],
              [-13526855.787509067, 4431464.856184998],
              [-13526451.92039647, 4432978.174774087],
              [-13525483.77478504, 4435190.036382574],
              [-13519995.055971986, 4437540.052617373],
              [-13516217.317732424, 4433609.252282348],
              [-13493637.272219917, 4433706.633810928],
              [-13495783.178043941, 4428921.64654361],
              [-13485412.65428164, 4416363.130726809],
              [-13460611.562288824, 4402980.7644875115],
              [-13424813.885717485, 4368011.396817112],
              [-13424747.873259446, 4345915.462547273],
              [-13433878.297894312, 4337466.671582444],
              [-13442756.917840999, 4343168.315719103],
              [-13438232.448457196, 4336457.85607976],
              [-13438313.711685477, 4327741.268324133],
              [-13443106.795000562, 4328669.944555444],
              [-13454639.160288272, 4340954.694819414],
              [-13460814.163762067, 4343500.964485718],
              [-13472704.309893187, 4336467.243827847],
              [-13474199.887251996, 4345291.062013697],
              [-13491194.811272424, 4362130.644464561],
              [-13496830.471813323, 4370597.600618548],
              [-13504366.467381556, 4370019.4033643585],
              [-13505099.506228428, 4384887.946690161],
              [-13508630.449156903, 4390204.975037117],
              [-13521765.48115356, 4395362.235599095],
              [-13519901.324960738, 4400815.589642168],
              [-13536193.82299426, 4416459.658836954],
              [-13541348.249376463, 4424341.478516333],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '41047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13704582.141298633, 5610617.737635105],
              [-13697295.94666774, 5612714.140163973],
              [-13699941.34304695, 5633314.370131894],
              [-13691929.234016594, 5639969.524868386],
              [-13696880.391008608, 5656347.267699342],
              [-13688809.282648133, 5666458.173271603],
              [-13678099.568397384, 5661559.822908801],
              [-13675591.094991848, 5662498.540203938],
              [-13663246.32006033, 5662445.08634848],
              [-13668587.095270116, 5641793.640297562],
              [-13659470.919530075, 5630818.240528839],
              [-13647271.19389506, 5624620.074201588],
              [-13640645.012525082, 5611634.190688794],
              [-13625619.330296787, 5603548.345498573],
              [-13551391.71647481, 5603548.345498573],
              [-13553481.294636492, 5594785.337614692],
              [-13560529.376876576, 5591466.936471087],
              [-13554233.14647731, 5584120.563820015],
              [-13558715.648413084, 5571820.159722344],
              [-13584652.087892497, 5572174.9471496735],
              [-13596418.112791384, 5578359.809637999],
              [-13606643.587257182, 5574081.580121747],
              [-13611777.196894605, 5581643.786863874],
              [-13634424.813338023, 5583161.751345564],
              [-13650047.501995442, 5588398.2042166395],
              [-13657884.50546678, 5586234.511280786],
              [-13668097.400830118, 5589203.3692598175],
              [-13693059.572126111, 5572363.932702091],
              [-13696973.788061384, 5580324.787572929],
              [-13708309.897086827, 5582079.368370698],
              [-13702687.37224584, 5592293.872710071],
              [-13712435.954013078, 5599123.928890862],
              [-13704582.141298633, 5610617.737635105],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ravalli',
        GEOID: '30081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12747990.045860494, 5754105.82344202],
              [-12737505.976217581, 5757204.134252902],
              [-12733640.96349724, 5761514.129038682],
              [-12736415.601805262, 5766174.997802785],
              [-12735201.440119179, 5774179.951781541],
              [-12739534.439978817, 5778498.998457959],
              [-12743882.134011239, 5785210.155193165],
              [-12741634.370853141, 5795923.882554408],
              [-12748452.800983721, 5800449.331434432],
              [-12747718.760261431, 5807268.289429165],
              [-12740062.428323649, 5808266.050521449],
              [-12740495.572462326, 5818429.470846493],
              [-12739550.13602702, 5824334.951488376],
              [-12738479.46516457, 5830286.770620099],
              [-12737449.759874733, 5842600.274358862],
              [-12733252.792432843, 5846585.248656953],
              [-12735285.820293201, 5860625.555890018],
              [-12729568.005968094, 5862152.918386801],
              [-12727306.32787365, 5873427.445987359],
              [-12726118.214948412, 5884638.6316335285],
              [-12727794.679289076, 5885986.255138844],
              [-12723205.540471805, 5886826.241184088],
              [-12671246.38890761, 5886898.257180603],
              [-12669460.824275285, 5875255.890636049],
              [-12676468.16358174, 5862186.884355177],
              [-12673636.974972395, 5851300.071177151],
              [-12666157.863663958, 5838150.604245894],
              [-12666576.758907815, 5826634.554637576],
              [-12662650.743106518, 5824068.5796510205],
              [-12670515.13117259, 5814462.663512968],
              [-12662953.420801984, 5798443.961996444],
              [-12668567.374042178, 5786388.722280055],
              [-12655653.867832197, 5786024.873075302],
              [-12651277.342051659, 5774748.304276495],
              [-12636700.166051771, 5770753.632859189],
              [-12636559.346895916, 5770549.536447841],
              [-12637943.827402912, 5761325.43608042],
              [-12656763.27787744, 5755312.546885785],
              [-12671483.722061982, 5740495.666778183],
              [-12676000.733039899, 5745415.125556908],
              [-12684669.12418793, 5729627.115726052],
              [-12687256.58071248, 5732505.026826083],
              [-12692162.208032757, 5731786.3640679],
              [-12692088.737168835, 5725076.0633811755],
              [-12699678.054773157, 5717114.819006912],
              [-12711179.69588141, 5707818.233839629],
              [-12718456.205716603, 5706590.110415244],
              [-12721504.244694011, 5697504.66537264],
              [-12731445.409180325, 5699425.951106229],
              [-12741268.686325885, 5707570.910826],
              [-12746787.572720943, 5709992.459592157],
              [-12748728.099086149, 5714144.703690609],
              [-12750326.530652754, 5717566.400776209],
              [-12750063.5940155, 5724535.399771068],
              [-12746041.286854666, 5727469.550470385],
              [-12746623.710430497, 5735938.959646745],
              [-12753040.165879821, 5745152.232461805],
              [-12747990.045860494, 5754105.82344202],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cannon',
        GEOID: '47015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9589257.527153326, 4288845.753852964],
              [-9590531.912683927, 4294348.557546898],
              [-9583550.8447773, 4297106.438274076],
              [-9575129.191340316, 4295264.610108367],
              [-9561143.12183654, 4281037.171832727],
              [-9560691.832620863, 4278580.930379972],
              [-9573189.671852224, 4261058.866295653],
              [-9571813.317668056, 4253952.982356809],
              [-9583371.39775814, 4252132.951173079],
              [-9596535.70678088, 4259939.506806528],
              [-9589257.527153326, 4288845.753852964],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adams',
        GEOID: '42001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8624041.733402414, 4857819.026257999],
              [-8616530.005483175, 4865139.869955877],
              [-8591427.682948273, 4871284.854328797],
              [-8586898.87210433, 4876111.70821768],
              [-8573676.676946377, 4867969.226567411],
              [-8567838.414932232, 4856529.021988586],
              [-8566583.844270993, 4845161.86485206],
              [-8570561.400996527, 4841899.300974547],
              [-8570661.25457977, 4841806.378076698],
              [-8570920.183715355, 4841707.07765451],
              [-8571299.783178959, 4841498.9123921525],
              [-8571443.051363612, 4841469.7754010875],
              [-8571524.874120742, 4825346.272625034],
              [-8595759.765005136, 4825367.92014211],
              [-8598311.902897911, 4825370.199810508],
              [-8622744.685396876, 4825369.645747899],
              [-8624041.733402414, 4857819.026257999],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chesapeake',
        GEOID: '51550',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8512241.676367387, 4403795.944221131],
              [-8511061.689764977, 4413622.320414779],
              [-8507076.451994577, 4420493.759289769],
              [-8503408.808731413, 4418525.208667088],
              [-8504838.596271161, 4412160.834208024],
              [-8500783.672499524, 4409570.529658813],
              [-8492802.6216071, 4411080.039113471],
              [-8492559.72247819, 4414331.514566986],
              [-8485446.184377518, 4416820.882029261],
              [-8485171.33655475, 4414156.992798612],
              [-8482957.080563381, 4407060.20501974],
              [-8467850.58038477, 4396342.453662986],
              [-8473857.268788485, 4392618.492247926],
              [-8473901.234088538, 4376643.372387726],
              [-8495148.234597607, 4376643.187732699],
              [-8495158.027179547, 4376643.200177458],
              [-8514992.890324134, 4376668.407058502],
              [-8512241.676367387, 4403795.944221131],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rock',
        GEOID: '31149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11096069.026332831, 5271101.823115671],
              [-11080462.81296005, 5269089.9337884635],
              [-11066851.890140248, 5277346.9233977785],
              [-11049243.039128095, 5282230.984604434],
              [-11047992.253329542, 5278924.3560762275],
              [-11046748.369339418, 5174169.795678072],
              [-11094365.281526241, 5173871.894865102],
              [-11094518.1231871, 5226305.732437246],
              [-11096069.026332831, 5271101.823115671],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Garfield',
        GEOID: '40047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10920919.162157677, 4382607.196926517],
              [-10849471.307340302, 4382613.990753218],
              [-10849376.017856183, 4382615.377248993],
              [-10849285.73774915, 4323274.75043266],
              [-10873199.947358815, 4323302.465671545],
              [-10920876.638112193, 4323331.97351643],
              [-10920934.85820588, 4364532.443648541],
              [-10920919.162157677, 4382607.196926517],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calhoun',
        GEOID: '05013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10321259.766928764, 3968863.3456946462],
              [-10323286.115619674, 3978464.900943194],
              [-10313520.501970345, 3983745.4173508836],
              [-10306518.394679956, 3993476.9279550263],
              [-10306298.427366149, 4002272.8735637693],
              [-10278601.581459329, 4001317.3451968073],
              [-10279447.164311394, 3994331.2655122704],
              [-10278221.981995724, 3989634.6670820443],
              [-10276022.30885765, 3961831.1155977556],
              [-10283540.493307354, 3937154.4063178],
              [-10280403.064778836, 3935050.936895056],
              [-10289382.094906222, 3931169.069786838],
              [-10304528.670101518, 3944145.6656640186],
              [-10314108.268881733, 3953048.641677598],
              [-10319883.74670307, 3952681.415970427],
              [-10321136.424932966, 3959402.170563885],
              [-10327858.229745535, 3966887.126399896],
              [-10321259.766928764, 3968863.3456946462],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grundy',
        GEOID: '19075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10355718.27002586, 5244755.271016164],
              [-10303097.546727879, 5244610.796959012],
              [-10300839.430857137, 5231583.678890283],
              [-10300783.214514287, 5205573.102222494],
              [-10326896.540664574, 5205524.791971704],
              [-10326826.743343847, 5192509.558160839],
              [-10352898.99260203, 5192378.353733479],
              [-10353035.692936722, 5231741.536146038],
              [-10355718.27002586, 5244755.271016164],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ouray',
        GEOID: '08091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12037241.47986476, 4626372.430418952],
              [-11981950.981219083, 4626454.029256287],
              [-11981877.844313633, 4622161.815672434],
              [-11975777.870176632, 4612085.015706755],
              [-11974484.003735144, 4600250.640323262],
              [-11968056.41633674, 4588029.264305745],
              [-11974512.390205296, 4574484.783886511],
              [-11982606.764339346, 4574483.936691778],
              [-11988626.588442974, 4564238.0835750215],
              [-11993370.802501602, 4566075.126284031],
              [-11999736.718902105, 4577804.200802486],
              [-12010228.246950898, 4581066.752783048],
              [-12010423.39001826, 4595819.623429345],
              [-12018696.654574018, 4600967.055710811],
              [-12015557.333614156, 4610408.396087728],
              [-12032145.718854206, 4615540.290444983],
              [-12037241.47986476, 4626372.430418952],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Piscataquis',
        GEOID: '23021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7768414.30104345, 5745995.848332911],
              [-7762595.185981723, 5741330.385357983],
              [-7759607.816126794, 5756979.411270831],
              [-7753020.262620118, 5758579.927185785],
              [-7757138.861140488, 5777726.624643763],
              [-7762149.685379567, 5776645.318181569],
              [-7762566.354233607, 5843715.665928563],
              [-7761318.351422323, 5872823.716893867],
              [-7661164.762153068, 5872573.84867504],
              [-7660940.676018102, 5844002.001059373],
              [-7661790.934288781, 5729985.419307392],
              [-7676470.746859181, 5726380.001745458],
              [-7677110.054694806, 5702547.094179844],
              [-7665159.239441204, 5704919.771072401],
              [-7656116.089287121, 5659434.155392473],
              [-7667789.273730686, 5657004.578886819],
              [-7665080.20260274, 5644027.825540171],
              [-7678094.898229855, 5641571.325182718],
              [-7706873.324309223, 5635727.464250042],
              [-7720637.534067848, 5633095.101642617],
              [-7736689.136723293, 5629991.708606844],
              [-7738446.648843937, 5625464.855980848],
              [-7750170.594975302, 5623246.44910057],
              [-7767866.052551293, 5707377.475938915],
              [-7759156.4155916255, 5720932.184340708],
              [-7773753.74041935, 5738579.556124761],
              [-7768414.30104345, 5745995.848332911],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chattahoochee',
        GEOID: '13053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9460316.160967477, 3811079.4202345116],
              [-9460058.377769614, 3813169.015309997],
              [-9436375.902596965, 3818647.240320377],
              [-9428149.726185815, 3831596.536907479],
              [-9421783.698465822, 3833725.2509544007],
              [-9424010.310920669, 3828455.984891688],
              [-9424187.865508482, 3793915.0310905464],
              [-9439820.238961602, 3793651.832338358],
              [-9443562.132325126, 3793651.700740431],
              [-9453244.71810136, 3793651.3323890627],
              [-9450116.512623545, 3797935.5858644852],
              [-9457225.709264074, 3803533.393802081],
              [-9463057.960025715, 3807586.305938144],
              [-9460316.160967477, 3811079.4202345116],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Randolph',
        GEOID: '05121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10175148.593802454, 4369241.69067678],
              [-10144159.905269992, 4369335.53680833],
              [-10132074.518715411, 4369372.136410594],
              [-10106055.831401428, 4369427.555574012],
              [-10102092.061023626, 4357566.713649293],
              [-10102206.720099144, 4339291.670473255],
              [-10108546.142460838, 4337403.988903824],
              [-10108902.476150867, 4321221.124851462],
              [-10135107.863520037, 4321469.414268899],
              [-10138251.748579022, 4316442.147470232],
              [-10148227.644746462, 4328992.351281074],
              [-10158896.504744088, 4336163.526710928],
              [-10160717.914252447, 4352279.394471488],
              [-10175395.995083136, 4369244.558797017],
              [-10175148.593802454, 4369241.69067678],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Routt',
        GEOID: '08107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11958920.759685809, 4945050.006877778],
              [-11946156.866871452, 4953560.785296678],
              [-11946562.377036355, 5012760.938221394],
              [-11895642.859222148, 5012447.662073788],
              [-11894749.080745155, 5001312.428847401],
              [-11891707.943576172, 5002334.381793137],
              [-11882169.087729588, 4993309.66080512],
              [-11876862.264964491, 4995863.970867885],
              [-11872729.194910318, 4990111.864469065],
              [-11870767.856802031, 4981340.749616505],
              [-11878474.171191176, 4955953.234673918],
              [-11872570.230677465, 4938097.998177806],
              [-11872458.799867181, 4930854.548120501],
              [-11870248.55137748, 4915701.553299649],
              [-11870779.990626529, 4866248.322403403],
              [-11869615.366113849, 4855018.253001949],
              [-11869613.807640977, 4854130.799640374],
              [-11872951.277294451, 4854318.037865825],
              [-11914966.815343538, 4854165.924682105],
              [-11914753.304560196, 4866369.376165356],
              [-11915344.745014781, 4879253.262066305],
              [-11915426.453521023, 4898744.789179578],
              [-11960097.740661966, 4898456.401794795],
              [-11958920.759685809, 4945050.006877778],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Schleicher',
        GEOID: '48413',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11239058.021700865, 3643466.680235213],
              [-11208621.937084096, 3643997.796526371],
              [-11144774.865778595, 3644182.1197544937],
              [-11144888.189020224, 3595191.5050358814],
              [-11238881.135029996, 3594635.411904777],
              [-11239058.021700865, 3643466.680235213],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Caguas',
        GEOID: '72025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7360196.934064742, 2062137.401302838],
              [-7357126.631189173, 2064206.0012732102],
              [-7354444.944655963, 2073082.4696962489],
              [-7351710.047406155, 2074140.4581455737],
              [-7349507.257322336, 2073283.322623593],
              [-7350414.17721383, 2071622.622893242],
              [-7346824.791552692, 2061790.8776992036],
              [-7351055.043522327, 2051505.8912377278],
              [-7352936.788194696, 2050787.3255650287],
              [-7354833.115720359, 2053650.8453430021],
              [-7354429.916524706, 2054927.1246088913],
              [-7357672.764611005, 2057348.2323698034],
              [-7360196.934064742, 2062137.401302838],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bayamón',
        GEOID: '72021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7369877.276984126, 2074573.2608438316],
              [-7369816.941820115, 2074693.4528809774],
              [-7369520.720655115, 2076091.6024188432],
              [-7369752.710473928, 2076993.4207147113],
              [-7369445.134720867, 2077191.6150271704],
              [-7369300.642021816, 2077370.4606705164],
              [-7369014.105652514, 2083164.8584097822],
              [-7365956.827157368, 2088058.3305158233],
              [-7361733.810954634, 2087314.184426294],
              [-7360636.757372866, 2086117.8821903227],
              [-7363100.925621067, 2070300.1632725506],
              [-7368312.347582553, 2067867.6717750423],
              [-7370033.235590727, 2069956.6661142416],
              [-7369877.276984126, 2074573.2608438316],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '54015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9048479.240745626, 4646323.967138053],
              [-9038487.314571515, 4654233.297371533],
              [-9031436.56066365, 4659686.689259453],
              [-9026197.308829464, 4666242.747954642],
              [-9020405.021765018, 4674203.427941881],
              [-9007226.129888983, 4659384.722463593],
              [-9003657.560972624, 4651303.9783114055],
              [-8996554.486904087, 4647251.633655694],
              [-9007011.505910736, 4638187.872634539],
              [-9042641.869287409, 4616747.315899601],
              [-9048479.240745626, 4646323.967138053],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kanawha',
        GEOID: '54039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9117091.00889606, 4635884.689331749],
              [-9097370.09318509, 4645718.697191686],
              [-9100429.264111578, 4663256.011313097],
              [-9094395.859030074, 4668300.839297208],
              [-9087325.735530812, 4658038.437698822],
              [-9075006.00748472, 4666351.5905880425],
              [-9069383.03736577, 4656894.868270833],
              [-9038487.314571515, 4654233.297371533],
              [-9048479.240745626, 4646323.967138053],
              [-9042641.869287409, 4616747.315899601],
              [-9042664.355824549, 4616718.676823994],
              [-9053532.366391206, 4605236.42746197],
              [-9059272.44461447, 4575062.869232879],
              [-9065695.801872224, 4574907.4014900355],
              [-9067710.795975072, 4577632.872817695],
              [-9074301.355107997, 4595310.694725417],
              [-9088554.034792224, 4610658.766433289],
              [-9109660.210246628, 4609073.473597823],
              [-9107362.0193592, 4623511.06216548],
              [-9118758.01827069, 4625524.408483448],
              [-9117091.00889606, 4635884.689331749],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Camuy',
        GEOID: '72027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7447448.344834175, 2094778.6269707126],
              [-7440215.290842848, 2095115.313882336],
              [-7437322.305551555, 2082899.974342026],
              [-7438838.477016161, 2077735.193397621],
              [-7444712.69522583, 2079365.3122765415],
              [-7446532.434941827, 2080560.7458019825],
              [-7447151.482630129, 2080445.6799091813],
              [-7447448.344834175, 2094778.6269707126],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cataño',
        GEOID: '72033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7365956.827157368, 2088058.3305158233],
              [-7361491.4684231775, 2092122.636544927],
              [-7359140.178138642, 2088985.7941529679],
              [-7361733.810954634, 2087314.184426294],
              [-7365956.827157368, 2088058.3305158233],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ceiba',
        GEOID: '72037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7320242.921665655, 2071591.4362414149],
              [-7319656.267949177, 2072312.6104976384],
              [-7317891.63138112, 2069630.8767298153],
              [-7304111.465860912, 2071967.9470013422],
              [-7301258.050427808, 2067330.4527294696],
              [-7302454.512314854, 2062490.3762706432],
              [-7306486.058993422, 2060968.596156918],
              [-7309229.499448381, 2059984.0822748584],
              [-7311798.44773306, 2067149.819965791],
              [-7321130.138007278, 2070348.6988337396],
              [-7320242.921665655, 2071591.4362414149],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cidra',
        GEOID: '72041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7373854.277112206, 2059189.7360735459],
              [-7370669.537800101, 2057818.0537205818],
              [-7365913.412555958, 2063818.0715252238],
              [-7362789.676324808, 2060726.1483650596],
              [-7360196.934064742, 2062137.401302838],
              [-7357672.764611005, 2057348.2323698034],
              [-7360278.085973532, 2053725.229331886],
              [-7371231.478589625, 2054319.0223847383],
              [-7374107.528953761, 2058657.0807442088],
              [-7373854.277112206, 2059189.7360735459],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pierce',
        GEOID: '53053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13675924.162908303, 5984036.12913256],
              [-13670166.941483457, 6008198.874728153],
              [-13640755.664098928, 6008162.197580449],
              [-13640822.678432385, 5997311.264182034],
              [-13637765.845215201, 5994401.133311006],
              [-13629652.546767715, 5996716.315214516],
              [-13619996.02621936, 5986887.166800843],
              [-13618261.000635857, 5984221.795381352],
              [-13617860.473107986, 5984184.235369414],
              [-13606558.205207743, 5984216.054757659],
              [-13597005.211785829, 5984210.642173078],
              [-13591526.957004908, 5973957.554053977],
              [-13574060.928899445, 5964746.337918594],
              [-13558320.352901274, 5970367.595675473],
              [-13539900.205440221, 5967167.397760849],
              [-13534409.928154297, 5961461.994721295],
              [-13511955.451027405, 5956326.812489813],
              [-13520469.83360022, 5929608.802787105],
              [-13527886.27203534, 5921333.685090158],
              [-13520333.021946033, 5906855.365362045],
              [-13554104.572465442, 5906854.389949474],
              [-13563377.15209005, 5897863.104244376],
              [-13603588.535151852, 5903484.988305654],
              [-13610578.397298252, 5903876.799492337],
              [-13614771.802516434, 5914063.381458975],
              [-13635644.540998645, 5920549.1661936715],
              [-13635982.618292185, 5926616.9367959285],
              [-13643365.326921595, 5931219.31680666],
              [-13654433.489932697, 5942600.490402601],
              [-13658030.77927768, 5958282.076729992],
              [-13665525.586634321, 5965170.858519073],
              [-13672323.979256557, 5973833.539991064],
              [-13675924.162908303, 5984036.12913256],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gem',
        GEOID: '16045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12992376.180529432, 5462552.793443447],
              [-12976760.616319425, 5462422.688620615],
              [-12972295.92550218, 5475665.240798963],
              [-12963438.67889772, 5475570.737154273],
              [-12963384.911583666, 5488911.738256283],
              [-12952968.078913197, 5488864.107662322],
              [-12951732.65520437, 5515424.424633758],
              [-12946442.97564086, 5534501.093915555],
              [-12936806.93787881, 5544834.983089172],
              [-12930540.541103076, 5542979.89461266],
              [-12930014.333870094, 5515800.360734156],
              [-12936761.96480453, 5515777.6423018025],
              [-12936868.942835184, 5488899.636648674],
              [-12943458.834051162, 5488874.81288824],
              [-12944455.14349376, 5435679.707051678],
              [-12970112.393690268, 5435648.239624796],
              [-12992395.216162357, 5435648.239624796],
              [-12992376.180529432, 5462552.793443447],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Johnston',
        GEOID: '37101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8761834.891537672, 4234699.40797501],
              [-8754465.541247157, 4241623.104277991],
              [-8735073.79727046, 4260389.4302997785],
              [-8711415.065892166, 4275623.7380286055],
              [-8708803.176679682, 4266448.340207058],
              [-8704306.648488069, 4263607.841972048],
              [-8700871.106363207, 4261184.450092455],
              [-8695793.379110163, 4245779.941495324],
              [-8690132.00376689, 4243703.2421759],
              [-8700164.784194125, 4220805.81270924],
              [-8699979.214602973, 4211638.636926632],
              [-8717048.61136274, 4203034.391475383],
              [-8728754.301097615, 4198542.908255679],
              [-8737694.146764243, 4199736.877452986],
              [-8742849.018424407, 4206963.568238389],
              [-8741903.025391644, 4209491.1423358675],
              [-8756452.92811629, 4231525.0279920325],
              [-8761834.891537672, 4234699.40797501],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harris',
        GEOID: '13145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9482875.211823193, 3878079.6490373826],
              [-9448987.844306389, 3877897.1091137505],
              [-9446768.801576916, 3878392.0107288845],
              [-9434475.790208615, 3877955.292769931],
              [-9428820.760076318, 3874700.631468781],
              [-9426854.635229927, 3859566.8878070274],
              [-9428075.253446475, 3853669.3415140277],
              [-9428160.078898462, 3840208.9409373077],
              [-9451902.299894849, 3840141.2988877143],
              [-9452448.767275153, 3843338.3366109165],
              [-9470625.055210056, 3843396.2806657855],
              [-9472012.165906655, 3849991.1177318282],
              [-9474874.969251385, 3859579.723853232],
              [-9476019.692371696, 3862383.1607962083],
              [-9480075.036624812, 3872320.104439601],
              [-9482684.031530535, 3876910.5490077315],
              [-9482875.211823193, 3878079.6490373826],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '50011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8154856.351108594, 5583730.034585833],
              [-8147783.778580532, 5607159.603385768],
              [-8152012.80603577, 5610105.151551219],
              [-8153075.461894883, 5613903.6966607785],
              [-8147730.729173323, 5623546.440373514],
              [-8145238.660656072, 5623593.68305992],
              [-8131709.132790493, 5623850.169589752],
              [-8119247.361074149, 5623767.813057852],
              [-8079832.580288466, 5623338.878386239],
              [-8076704.571194863, 5623012.108206674],
              [-8074296.328052844, 5595323.270200481],
              [-8079363.925232226, 5587200.706607545],
              [-8098199.071754958, 5587920.9114646865],
              [-8102515.373690976, 5578758.411862958],
              [-8103558.548639199, 5573194.137921863],
              [-8109743.793506146, 5576149.483582085],
              [-8117875.0143916495, 5563936.687023325],
              [-8130556.085504857, 5566769.466719165],
              [-8151798.738654974, 5577997.416461012],
              [-8154856.351108594, 5583730.034585833],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hale',
        GEOID: '01065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9775318.259899093, 3870135.022327643],
              [-9777385.574162615, 3874152.754901715],
              [-9774320.837261586, 3881709.7417187113],
              [-9766052.359443933, 3888570.7467295188],
              [-9764468.060450964, 3896209.770292289],
              [-9731765.399682151, 3895752.4777178145],
              [-9731683.468536926, 3878658.8209162788],
              [-9737357.868260624, 3872843.1219554297],
              [-9737551.675494093, 3849714.64260842],
              [-9743260.472940445, 3849694.2807555296],
              [-9743181.102143511, 3826751.944279984],
              [-9765919.110013453, 3826605.4652130785],
              [-9765894.285767008, 3832362.264885649],
              [-9775249.353134291, 3832365.9616233534],
              [-9772482.173232153, 3839990.1625790587],
              [-9766830.148726106, 3840967.826662213],
              [-9775343.08414554, 3846807.21926108],
              [-9774773.46231115, 3862481.425791671],
              [-9781695.308248676, 3863814.396663104],
              [-9775318.259899093, 3870135.022327643],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jasper',
        GEOID: '18073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9715506.742773829, 5044638.040057689],
              [-9709159.305408798, 5048106.402113181],
              [-9699416.289616099, 5054654.859532346],
              [-9681247.390245765, 5044795.356473502],
              [-9677012.128899043, 5047332.307275992],
              [-9677022.258972704, 5037791.850827093],
              [-9677087.826152783, 4999431.909072526],
              [-9683397.303571455, 4999396.408823098],
              [-9683285.984080661, 4988464.362231539],
              [-9695904.604959533, 4988418.160839388],
              [-9695748.42371395, 4973558.844335613],
              [-9714551.17626486, 4973564.867814964],
              [-9715506.742773829, 5044638.040057689],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bannock',
        GEOID: '16005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12551335.14849542, 5304596.822121689],
              [-12543298.103899129, 5315279.959616953],
              [-12474798.657114904, 5315376.495528319],
              [-12476917.0670247, 5304429.068060881],
              [-12484462.52474965, 5296088.196809332],
              [-12481178.599771248, 5286284.813088321],
              [-12483482.801911179, 5275981.424311507],
              [-12479569.476531832, 5266298.974125773],
              [-12464382.047083415, 5269152.509984441],
              [-12458535.32478797, 5253895.79043413],
              [-12453938.831693625, 5223523.184493575],
              [-12456286.782393437, 5199445.986182701],
              [-12465984.936431346, 5203849.887876394],
              [-12481830.820667805, 5203801.586407601],
              [-12489006.697683323, 5213679.166806182],
              [-12504195.796924101, 5209612.620069236],
              [-12500968.756205495, 5229306.20997564],
              [-12514517.674068926, 5236632.494384843],
              [-12510047.639916124, 5258285.041604814],
              [-12523098.737016726, 5271421.595127623],
              [-12525170.281420898, 5298279.147165457],
              [-12529976.389116406, 5306075.104152341],
              [-12550993.286339194, 5298698.642588815],
              [-12551335.14849542, 5304596.822121689],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '53031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13871867.80175858, 6087009.2922274135],
              [-13748615.790396309, 6087093.5374075305],
              [-13686638.663897155, 6084727.289975236],
              [-13686640.111050535, 6117700.3254297525],
              [-13680828.231755711, 6117701.158303975],
              [-13682355.06269886, 6125141.077740597],
              [-13673726.27088208, 6129244.403259203],
              [-13665630.560914136, 6130718.035850142],
              [-13658730.6449163, 6124024.505907903],
              [-13659106.348197727, 6109534.71778638],
              [-13659045.567755753, 6102360.679967379],
              [-13653453.878413714, 6093719.606630841],
              [-13651565.8848529, 6094060.188895017],
              [-13647272.52972895, 6087295.706002052],
              [-13661347.320866887, 6071602.273875146],
              [-13668167.420789827, 6052584.411144675],
              [-13686800.522436768, 6041606.649086277],
              [-13748615.790396309, 6041327.125273131],
              [-13748615.790396309, 6026991.742715248],
              [-13808819.9313656, 6027125.090660045],
              [-13842981.174785584, 6029599.914289771],
              [-13843241.587711241, 6031605.227123311],
              [-13849492.288438777, 6055634.248268002],
              [-13856124.815019729, 6068163.700738286],
              [-13863721.257071463, 6079774.683208467],
              [-13871867.80175858, 6087009.2922274135],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lamar',
        GEOID: '48277',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10670531.237142619, 4005728.872694182],
              [-10669403.073555905, 4010075.460861581],
              [-10666699.954227986, 4009813.129655526],
              [-10663253.872123523, 4011686.3176596737],
              [-10657450.640376953, 4014841.4754410433],
              [-10649933.235163685, 4016166.171845758],
              [-10642550.415214784, 4019030.2778226063],
              [-10637347.119576124, 4019006.799726241],
              [-10633830.202903492, 4013436.0728463167],
              [-10625152.625957176, 4011205.350751787],
              [-10614573.71210811, 4011063.104507854],
              [-10609910.738507258, 4011874.7815852836],
              [-10609708.939040951, 3945940.16470581],
              [-10621760.498433722, 3950144.501975321],
              [-10630109.348923728, 3955899.4724466843],
              [-10642552.418965617, 3959820.7290782086],
              [-10650117.580240438, 3958207.8405589187],
              [-10660074.218135972, 3961244.421954459],
              [-10667410.506537719, 3956383.9526978685],
              [-10670834.582755031, 3956751.4293552726],
              [-10670531.237142619, 4005728.872694182],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '17077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9983935.814780165, 4550704.699344508],
              [-9981282.361001244, 4555659.268363456],
              [-9973679.128460573, 4573114.536894273],
              [-9927204.688207759, 4572408.799738433],
              [-9924216.650435887, 4571685.18313828],
              [-9924263.515941512, 4559949.2007252285],
              [-9924540.924112568, 4523138.215471496],
              [-9957901.928349933, 4523099.717332788],
              [-9962843.503632458, 4518856.084294799],
              [-9962432.186347255, 4520278.920146404],
              [-9963825.01581606, 4526592.52526749],
              [-9965537.666181915, 4536636.1995506715],
              [-9973256.670993011, 4540452.869198614],
              [-9981795.32121482, 4545504.464261297],
              [-9983935.814780165, 4550704.699344508],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montgomery',
        GEOID: '36057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8320442.312551735, 5316652.111749091],
              [-8322233.443158599, 5319192.899003824],
              [-8298018.33696532, 5309769.62468354],
              [-8292060.183859592, 5309706.929055828],
              [-8248492.295511391, 5309374.5883765435],
              [-8248428.843401641, 5308833.494838054],
              [-8247992.804956202, 5305256.917152907],
              [-8246980.131548456, 5296361.10685344],
              [-8266954.299100984, 5281053.34726591],
              [-8269863.300034394, 5279122.444898528],
              [-8283437.376102745, 5278012.988985533],
              [-8288282.779578502, 5277480.527029202],
              [-8309810.5219445415, 5286064.715295556],
              [-8322612.8199832225, 5291178.237546764],
              [-8320442.312551735, 5316652.111749091],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lee',
        GEOID: '13177',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9388479.13321029, 3752314.2831174857],
              [-9342209.298181556, 3751457.0134274405],
              [-9344095.384314066, 3743365.4567625932],
              [-9351777.31973473, 3737301.5213116044],
              [-9352885.950543538, 3717490.6968024285],
              [-9355647.675790628, 3713999.529443963],
              [-9383988.282312706, 3713787.4845251204],
              [-9383651.874811528, 3745516.2876706976],
              [-9388490.487798352, 3746728.895454436],
              [-9388479.13321029, 3752314.2831174857],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Houston',
        GEOID: '47083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9793971.176415395, 4349345.406211097],
              [-9776279.837660566, 4345948.072200315],
              [-9764444.126760442, 4351409.64836856],
              [-9750736.689942122, 4351329.880231433],
              [-9750135.453372348, 4347752.258440831],
              [-9741961.931080343, 4346775.6442948915],
              [-9743085.590020409, 4334922.51700671],
              [-9747891.363757446, 4325121.8990681255],
              [-9750025.914993407, 4327858.658964179],
              [-9773685.202969156, 4334351.617668935],
              [-9790505.021430565, 4334131.603117346],
              [-9789914.137573434, 4337032.870730391],
              [-9793971.176415395, 4349345.406211097],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kittson',
        GEOID: '27069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10823487.111799337, 6274977.96433674],
              [-10790305.109303169, 6274858.679141773],
              [-10731800.928277781, 6274858.679141773],
              [-10731747.049644237, 6226989.739556261],
              [-10729844.710866071, 6197890.763678391],
              [-10814435.119348958, 6197820.762036938],
              [-10813899.831974257, 6204522.503575183],
              [-10809123.55790228, 6218702.0779608665],
              [-10811488.429164693, 6226403.111020898],
              [-10814976.6254087, 6236364.424988155],
              [-10818847.649381546, 6252425.332868773],
              [-10823355.198202746, 6265680.634609406],
              [-10823487.111799337, 6274977.96433674],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jasper',
        GEOID: '48241',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10514995.978564728, 3637077.7856730614],
              [-10478462.70279823, 3645649.2643475845],
              [-10468844.921432672, 3648154.966967661],
              [-10468377.379571341, 3650199.0931750857],
              [-10454138.726142954, 3653294.7316202368],
              [-10449083.151468577, 3625896.291408148],
              [-10453061.82138902, 3534781.3610236337],
              [-10477123.751962967, 3534651.602762213],
              [-10473314.621627003, 3547610.2875603954],
              [-10477323.013851488, 3558465.016916478],
              [-10472012.517543195, 3571347.279275049],
              [-10474586.558128806, 3577747.143556541],
              [-10469704.97581854, 3585898.741036613],
              [-10473980.646140419, 3592163.654161291],
              [-10478038.798177289, 3591784.9007808883],
              [-10480743.30520611, 3605532.8773486326],
              [-10483996.506005052, 3606151.141770779],
              [-10487989.536139807, 3619820.9315321813],
              [-10486345.124621809, 3623565.0923544625],
              [-10491292.942029098, 3628616.620836323],
              [-10490573.37284061, 3634529.1264524083],
              [-10503414.966659542, 3637863.2734349705],
              [-10514489.920159582, 3633559.163052742],
              [-10514995.978564728, 3637077.7856730614],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tillamook',
        GEOID: '41057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13804704.449790973, 5628965.622305858],
              [-13800881.181879677, 5644452.853791167],
              [-13800602.21523575, 5655714.498988744],
              [-13799485.458104111, 5665744.481418713],
              [-13801358.74249518, 5676430.639845948],
              [-13799226.083690561, 5689595.537467734],
              [-13801005.748389876, 5698952.260266593],
              [-13797778.818990761, 5710892.699754274],
              [-13796826.926024985, 5726336.677413743],
              [-13796876.240559408, 5733805.58876363],
              [-13800117.307533856, 5741496.476887076],
              [-13799862.98530185, 5745656.301852303],
              [-13772447.512263296, 5744059.401904221],
              [-13732552.944472292, 5745096.685916349],
              [-13732486.820694763, 5733789.806815563],
              [-13746256.819066908, 5733800.646938503],
              [-13739415.90239919, 5722236.631504974],
              [-13725630.653256806, 5717632.119125424],
              [-13743635.801656181, 5699242.379033763],
              [-13744047.572452625, 5690000.679071233],
              [-13743895.955306165, 5655639.909808821],
              [-13779631.960879603, 5655637.065318454],
              [-13779596.116003567, 5633597.330527315],
              [-13772933.644479591, 5633529.702972708],
              [-13772966.483729376, 5628519.109557825],
              [-13804740.874628754, 5628608.435458263],
              [-13804704.449790973, 5628965.622305858],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Georgetown',
        GEOID: '45043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8869645.925939614, 3940042.7687849263],
              [-8854138.564274656, 3961445.856755656],
              [-8842745.348350437, 3971569.642930347],
              [-8839806.402474003, 3987103.663315807],
              [-8829532.615349203, 3999283.177556388],
              [-8821667.11408822, 3987967.561942916],
              [-8815419.864264904, 3989364.4937282917],
              [-8809566.574119503, 3983791.560672334],
              [-8805491.27888105, 3971605.31610857],
              [-8793697.75694388, 3971564.5658577713],
              [-8797414.159268072, 3966315.1330863684],
              [-8803656.065755833, 3959680.3180915946],
              [-8809316.995821144, 3949034.068414468],
              [-8812310.488248065, 3938821.3887184174],
              [-8814339.953884717, 3926931.270199013],
              [-8813430.584964428, 3922755.8150902246],
              [-8818223.890918495, 3915971.3980456158],
              [-8824796.370056558, 3911250.288591419],
              [-8824228.798210356, 3913487.0184348803],
              [-8833292.431150744, 3915700.013060577],
              [-8843966.077886475, 3923671.3382119043],
              [-8845305.807958173, 3926567.1324050194],
              [-8869604.62640853, 3935850.482122143],
              [-8869645.925939614, 3940042.7687849263],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Iron',
        GEOID: '49021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12696180.28505294, 4543605.588095533],
              [-12695949.853706999, 4562680.6184718525],
              [-12695977.126982244, 4600439.471327288],
              [-12695977.168800302, 4600462.406839003],
              [-12631600.731498022, 4600448.530772612],
              [-12521069.382699564, 4600272.156125414],
              [-12519900.194087762, 4563963.584906338],
              [-12533283.579868384, 4563957.80161058],
              [-12532186.86024509, 4551850.548641808],
              [-12544506.699610671, 4551998.486045786],
              [-12543897.67067654, 4515163.837430513],
              [-12568099.863808887, 4515134.915618393],
              [-12568081.050814945, 4509034.33969516],
              [-12583231.076914454, 4508996.0337192025],
              [-12583226.624134822, 4505450.320575589],
              [-12607320.837361101, 4506529.4517675685],
              [-12607304.13943748, 4513098.936626424],
              [-12631871.126541158, 4513113.254340505],
              [-12631921.88822896, 4525642.30408153],
              [-12644535.722369727, 4523720.2009578375],
              [-12696263.10675409, 4523743.38550277],
              [-12696180.28505294, 4543605.588095533],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dukes',
        GEOID: '25007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7885182.7695915615, 5064606.585832443],
              [-7876721.931693819, 5066433.193018488],
              [-7868827.598684724, 5077657.894832897],
              [-7859551.790794884, 5083755.687419643],
              [-7853954.869436779, 5079383.750395588],
              [-7847600.752902299, 5075218.967163844],
              [-7843998.008902266, 5074363.424824513],
              [-7842264.653111124, 5064645.884800752],
              [-7856646.24076569, 5063980.344992535],
              [-7869579.450525543, 5063041.727122089],
              [-7877934.200948559, 5057241.372754945],
              [-7883789.272205813, 5049436.971445392],
              [-7885137.685197791, 5059179.229510018],
              [-7885182.7695915615, 5064606.585832443],
            ],
          ],
          [
            [
              [-7896446.520947989, 5079642.7816446675],
              [-7882183.711190102, 5086014.410174688],
              [-7873192.20713569, 5092802.228428704],
              [-7870009.477718476, 5090411.069444842],
              [-7866843.592210097, 5088295.614949864],
              [-7874106.925535596, 5084342.794395559],
              [-7880336.80951835, 5078401.158467011],
              [-7887823.935830125, 5075346.495940915],
              [-7897943.211501705, 5072886.185997226],
              [-7896446.520947989, 5079642.7816446675],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Slope',
        GEOID: '38087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11582288.62842733, 5832511.194922607],
              [-11582241.428963235, 5862422.87058707],
              [-11582250.380533405, 5867461.439160097],
              [-11555061.216813186, 5867431.834033144],
              [-11555054.9829217, 5881817.552217498],
              [-11533724.498693349, 5881855.484854686],
              [-11491685.694870684, 5881850.135370278],
              [-11457892.882328534, 5881898.929273102],
              [-11457508.162168352, 5825578.180063814],
              [-11465401.49330203, 5825448.35684271],
              [-11582288.289896745, 5825363.803363236],
              [-11582288.62842733, 5832511.194922607],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Muskogee',
        GEOID: '40101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10660640.834344108, 4280880.593083614],
              [-10647756.04856275, 4280929.077315267],
              [-10641000.736583453, 4268355.678167227],
              [-10615467.051021725, 4276212.833285165],
              [-10604926.876355454, 4274957.388998478],
              [-10589507.345768735, 4274887.242140081],
              [-10589540.852935463, 4251046.830639926],
              [-10590094.444763178, 4235621.002009902],
              [-10584884.46995507, 4226761.145438283],
              [-10580910.14149477, 4226419.199728634],
              [-10594327.368400592, 4206103.5746650025],
              [-10602148.230545765, 4199585.408811415],
              [-10613717.887862891, 4203783.536071331],
              [-10613760.189269392, 4239184.050577182],
              [-10654717.635558488, 4239123.984228709],
              [-10654731.439175349, 4262958.1326286765],
              [-10660651.854973696, 4262950.316605474],
              [-10660640.834344108, 4280880.593083614],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Terrebonne',
        GEOID: '22109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10167352.8898622, 3413728.635885565],
              [-10160869.86535738, 3417692.7183872745],
              [-10159623.64365795, 3421670.90841426],
              [-10159720.566279061, 3421720.4322071807],
              [-10156322.241519494, 3423326.472777538],
              [-10153831.356593505, 3428892.2526831897],
              [-10158831.048883501, 3432320.3530357503],
              [-10160267.96087066, 3443941.1727270614],
              [-10149893.874884656, 3453478.8139873943],
              [-10139268.8747664, 3455612.778370413],
              [-10130824.289514314, 3466938.7517712526],
              [-10116736.919273915, 3467199.9727778533],
              [-10108666.033552423, 3474777.3064495493],
              [-10097549.669201804, 3460609.6719784965],
              [-10095294.336318335, 3458044.378545004],
              [-10087695.333918313, 3451992.2261767867],
              [-10061532.581914114, 3422281.3261448042],
              [-10064329.81807877, 3406194.8400032576],
              [-10064336.26366873, 3383086.800735542],
              [-10068039.09483149, 3382782.2620697105],
              [-10073091.107282162, 3383126.9941433924],
              [-10091347.392452767, 3382994.678102989],
              [-10102063.117956018, 3380745.7639880762],
              [-10109206.823638696, 3381010.3520973264],
              [-10115363.125438035, 3382783.6628836165],
              [-10116446.264083454, 3389003.094668554],
              [-10123603.439424517, 3396328.7564619444],
              [-10130084.34885901, 3397234.903994841],
              [-10140539.364114825, 3399559.20180161],
              [-10147678.617017869, 3403434.672522637],
              [-10161108.645665133, 3407220.324898092],
              [-10167352.8898622, 3413728.635885565],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sequoyah',
        GEOID: '40135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10589540.852935463, 4251046.830639926],
              [-10553900.025526652, 4251007.108259253],
              [-10516699.54421893, 4250999.321666263],
              [-10514092.064299487, 4231589.838361932],
              [-10512443.78861443, 4217442.65239866],
              [-10512335.158183493, 4216510.913620293],
              [-10518842.512249598, 4204967.296346497],
              [-10530245.079011045, 4208541.306887073],
              [-10538482.164732294, 4204047.037571732],
              [-10547546.688228607, 4212498.24328253],
              [-10554604.900542354, 4207909.584024922],
              [-10565828.688201586, 4211209.268318647],
              [-10564423.613588795, 4218091.96291642],
              [-10576076.315246053, 4220367.344754137],
              [-10580910.14149477, 4226419.199728634],
              [-10584884.46995507, 4226761.145438283],
              [-10590094.444763178, 4235621.002009902],
              [-10589540.852935463, 4251046.830639926],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Klamath',
        GEOID: '41035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13613232.598621387, 5162142.633994089],
              [-13613011.173450047, 5227162.181869294],
              [-13612669.311293822, 5232324.393340187],
              [-13612451.23641136, 5311438.974227934],
              [-13612435.095085192, 5322285.05609519],
              [-13591416.973348003, 5323586.152197888],
              [-13585391.69458933, 5344617.341995285],
              [-13578105.722597418, 5351889.397252079],
              [-13582135.933442099, 5364586.287521074],
              [-13595675.834426776, 5379219.832646186],
              [-13595561.731948713, 5397184.529465702],
              [-13581240.813416628, 5406131.146553841],
              [-13506724.325516047, 5406307.510181484],
              [-13506662.431879167, 5366418.124156782],
              [-13508584.474207202, 5273487.645158731],
              [-13456670.407036778, 5273119.2969023185],
              [-13456291.777192209, 5160003.317979952],
              [-13473576.275464572, 5159979.314299735],
              [-13497610.598804804, 5160615.448784541],
              [-13518595.547333734, 5160542.052246255],
              [-13519478.310678428, 5160558.533954817],
              [-13544837.781454356, 5161032.022292531],
              [-13563913.934674656, 5161439.326254903],
              [-13592323.781920008, 5161843.202021953],
              [-13613207.874990279, 5162142.524555888],
              [-13613232.598621387, 5162142.633994089],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McHenry',
        GEOID: '38049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11249909.890941355, 6198063.787672445],
              [-11249905.883439688, 6212720.035243303],
              [-11177231.621792246, 6212628.067798767],
              [-11177187.984551854, 6197949.44683511],
              [-11162746.729650225, 6197975.677832589],
              [-11162717.89790211, 6168855.42120247],
              [-11158368.756716305, 6168840.6746981535],
              [-11153941.135289494, 6110491.831478831],
              [-11153989.893226461, 6081538.250741702],
              [-11197088.90387944, 6081518.345771322],
              [-11240076.483722132, 6081721.212751576],
              [-11239984.311183756, 6110622.983178159],
              [-11244842.405081466, 6168871.843475908],
              [-11249925.69830905, 6183465.974510962],
              [-11249909.890941355, 6198063.787672445],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '23029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7581415.81290724, 5611937.230314979],
              [-7567705.036504195, 5614579.153918373],
              [-7575846.276143871, 5661372.597234464],
              [-7563019.487817215, 5663787.222352816],
              [-7575070.04533457, 5722829.06058999],
              [-7558845.452190432, 5729234.774536894],
              [-7547783.667238135, 5729045.631180825],
              [-7547830.277256946, 5728879.630528094],
              [-7537494.373856282, 5729116.391628648],
              [-7533592.95966245, 5721406.0870098155],
              [-7528733.307291869, 5719885.930758354],
              [-7517952.793844977, 5715751.61980961],
              [-7509101.44717353, 5717221.268042594],
              [-7505565.940145936, 5712049.5350335995],
              [-7504872.531037786, 5700897.998724212],
              [-7511489.138931557, 5700144.395688915],
              [-7512321.029486253, 5692955.40424899],
              [-7505966.356354319, 5680544.435073876],
              [-7509674.519912135, 5668934.622549365],
              [-7511867.736519743, 5663841.000542314],
              [-7508886.266597828, 5659562.212461228],
              [-7501884.938543876, 5645816.299376125],
              [-7496239.927165749, 5641315.409259317],
              [-7491602.357179301, 5644641.621384102],
              [-7488581.925435605, 5651653.607987374],
              [-7481107.600865274, 5648546.495022747],
              [-7476355.817081273, 5647200.002249489],
              [-7470919.752387364, 5639221.810628939],
              [-7468512.134440486, 5632346.696988549],
              [-7467542.319036696, 5626183.864793869],
              [-7462132.191784143, 5612068.545402614],
              [-7456575.568081707, 5606307.260408973],
              [-7457622.1939341435, 5597809.288986975],
              [-7452828.220063132, 5592823.49680843],
              [-7461316.887833573, 5585102.683648255],
              [-7466581.075233696, 5580988.96497486],
              [-7471401.8771019885, 5575371.947925791],
              [-7477314.277897001, 5568482.768409933],
              [-7484485.256854923, 5564585.898438189],
              [-7491067.355706547, 5558653.050443746],
              [-7499401.400704277, 5562626.047187504],
              [-7502820.9128224645, 5559179.305799388],
              [-7508334.121923491, 5558818.303223814],
              [-7513147.354066411, 5551910.736542484],
              [-7516422.039527078, 5544694.02367004],
              [-7514422.7414724305, 5539545.428240293],
              [-7522940.68626895, 5532093.145208886],
              [-7529072.163821844, 5541126.9006579155],
              [-7531111.202934704, 5547178.382640161],
              [-7537073.140903118, 5543455.454236385],
              [-7546747.806528472, 5542332.380622395],
              [-7551684.714625662, 5537634.7968833],
              [-7553596.070282583, 5530581.662090221],
              [-7558545.668801725, 5526630.576006569],
              [-7562660.037181445, 5529296.389468359],
              [-7563474.111837023, 5528646.3868290465],
              [-7565564.696654712, 5531201.99917009],
              [-7571642.184254572, 5557061.962260849],
              [-7581415.81290724, 5611937.230314979],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sanpete',
        GEOID: '49039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12469564.414657805, 4766830.4224077],
              [-12459143.351846684, 4776479.542628762],
              [-12439624.035733536, 4776646.464748416],
              [-12439662.440957861, 4781574.724794508],
              [-12435859.210554907, 4787820.853033337],
              [-12436333.208946707, 4821655.3397241],
              [-12421557.995572696, 4828251.821630497],
              [-12421569.572799738, 4834637.257986241],
              [-12427924.357251162, 4838786.058743012],
              [-12384014.606746739, 4838809.101190605],
              [-12384002.918200204, 4823071.780901693],
              [-12384042.659258418, 4788816.49331755],
              [-12389961.739222879, 4782387.450003421],
              [-12389788.080817241, 4726294.168019721],
              [-12451452.065588795, 4726397.349434302],
              [-12469350.681235481, 4728193.7343624355],
              [-12469564.414657805, 4766830.4224077],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Isle of Wight',
        GEOID: '51093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8563210.529741485, 4398445.902036327],
              [-8551311.36673161, 4422679.779844734],
              [-8554867.690503983, 4438578.662672523],
              [-8538010.69133265, 4447353.349580168],
              [-8531701.770511432, 4460570.031898665],
              [-8532173.765152395, 4456566.167476709],
              [-8509851.980858527, 4431010.234143564],
              [-8519672.475016817, 4427343.8843384925],
              [-8537206.741970139, 4410743.060352024],
              [-8560200.784668908, 4389607.403947003],
              [-8561545.52411769, 4390179.722924059],
              [-8562443.87240839, 4392149.150673023],
              [-8561806.34568462, 4393585.412003757],
              [-8563270.419627532, 4395093.631857448],
              [-8561829.277499722, 4397151.71156423],
              [-8563378.956131054, 4397176.563652869],
              [-8563210.529741485, 4398445.902036327],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lander',
        GEOID: '32015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13114124.3038592, 4742584.200883844],
              [-13104518.990276614, 4752282.247975468],
              [-13108960.415320283, 4774698.732462175],
              [-13096294.038379863, 4782964.178951851],
              [-13097450.202611241, 4788938.197471877],
              [-13090085.639058828, 4796075.469156955],
              [-13078396.647247573, 4800131.341915014],
              [-13075764.052609801, 4811256.508046455],
              [-13079521.86466051, 4829442.3185284985],
              [-13075769.952542813, 4849508.440080968],
              [-13084687.645630771, 4866092.53870294],
              [-13057842.727786994, 4942696.096334916],
              [-13051852.737306898, 4959744.577590655],
              [-13026458.089789174, 4959831.134973076],
              [-13026430.81651393, 5012379.128861721],
              [-12978381.650744358, 5012400.368933902],
              [-12978405.027837424, 5007147.519353747],
              [-12979498.073917521, 5004447.730625686],
              [-12979208.531921968, 4912590.002004074],
              [-12979851.068022827, 4876455.305791621],
              [-12979057.248733979, 4775519.974233617],
              [-12979957.934733989, 4744826.222341154],
              [-13061322.575069191, 4745108.627728277],
              [-13110705.125699485, 4735062.751034515],
              [-13114124.3038592, 4742584.200883844],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Holmes',
        GEOID: '39075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9152762.56048433, 4963432.7470726585],
              [-9142246.653467054, 4963527.99611249],
              [-9089241.432647873, 4963511.558615706],
              [-9089147.25635866, 4958667.955720073],
              [-9091424.296542836, 4930654.884144265],
              [-9095818.967400374, 4930787.846736765],
              [-9148748.602285307, 4932470.878546499],
              [-9148132.114945292, 4949578.233090013],
              [-9152700.778166939, 4948859.262302272],
              [-9152762.56048433, 4963432.7470726585],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Campbell',
        GEOID: '47013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9387564.532273931, 4339920.004434237],
              [-9389792.257923687, 4364973.583893711],
              [-9387620.971255764, 4370953.397851821],
              [-9380545.838379415, 4371260.592350125],
              [-9378793.112996876, 4374374.8615604],
              [-9379927.36971997, 4382491.2446153965],
              [-9376143.709115995, 4382413.505355549],
              [-9376128.342795936, 4382413.299098093],
              [-9349483.804265916, 4382055.663508619],
              [-9349458.083973577, 4382054.594031761],
              [-9349126.69133945, 4378019.437214582],
              [-9346046.035751237, 4369855.851906293],
              [-9344507.489068983, 4365980.232238405],
              [-9342223.101798415, 4359643.880083232],
              [-9340332.896844745, 4358564.7824586695],
              [-9342067.143191813, 4354125.0210394515],
              [-9345817.60815613, 4354089.620966321],
              [-9348723.93742176, 4339905.089709195],
              [-9351317.792876733, 4337889.029791659],
              [-9354457.225156086, 4342225.544361898],
              [-9358620.462792264, 4332367.508120131],
              [-9376165.4164167, 4334368.871195526],
              [-9377757.062496062, 4325083.422203618],
              [-9392329.451757848, 4330490.834262952],
              [-9387564.532273931, 4339920.004434237],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lauderdale',
        GEOID: '47097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10009346.672547173, 4266950.5205021985],
              [-10003600.694390895, 4265945.7715298375],
              [-9996162.214696597, 4270755.139404555],
              [-9987966.09454796, 4274424.229288706],
              [-9988644.141566385, 4279675.97345687],
              [-9987877.929511255, 4283259.047207036],
              [-9979488.447407108, 4286172.142465868],
              [-9979670.4514734, 4287362.7051188005],
              [-9977715.684516227, 4290187.2050126465],
              [-9951760.543362359, 4292556.832971085],
              [-9945598.230310515, 4284250.417802397],
              [-9945235.106131548, 4281686.173551227],
              [-9947068.09286695, 4275557.156205003],
              [-9952163.408599539, 4276246.606665383],
              [-9963330.200679485, 4243067.853542835],
              [-9976837.707692342, 4252885.4497540565],
              [-9995955.939680161, 4250553.187564781],
              [-10008712.819366597, 4237223.922890867],
              [-10012604.214806255, 4240287.879601467],
              [-10011240.105766075, 4246797.489863212],
              [-10005011.55761721, 4249370.26060027],
              [-10007501.551987275, 4252692.011717016],
              [-10013921.680979794, 4258801.20905039],
              [-10009346.672547173, 4266950.5205021985],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greensville',
        GEOID: '51081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8656994.414399803, 4375935.302203676],
              [-8644608.677243415, 4399252.681020406],
              [-8644853.023525707, 4424413.580882039],
              [-8640510.784148334, 4422093.466413142],
              [-8628413.80640332, 4417535.158064538],
              [-8622660.592480142, 4420022.771011229],
              [-8626147.230251279, 4400290.057938265],
              [-8619482.309698503, 4398436.043324467],
              [-8627473.935942553, 4393278.54740717],
              [-8617796.709968911, 4390997.533222953],
              [-8611131.566777155, 4377138.040683895],
              [-8604859.736364804, 4376017.9694760665],
              [-8655057.681246728, 4375946.053411743],
              [-8656994.414399803, 4375935.302203676],
            ],
            [
              [-8633552.7593763, 4393884.7904400695],
              [-8630124.230379358, 4393601.234297979],
              [-8628289.796490576, 4395012.427405408],
              [-8628869.103120664, 4400231.589970263],
              [-8633955.735932972, 4398316.073250837],
              [-8633552.7593763, 4393884.7904400695],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wood',
        GEOID: '54107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9100674.94622776, 4748159.453947248],
              [-9097192.220131414, 4751935.106034633],
              [-9096096.820849394, 4753122.929545875],
              [-9092390.215764452, 4760960.832963727],
              [-9085217.344375186, 4761188.613838109],
              [-9079801.762467584, 4761308.8335979795],
              [-9079178.373319142, 4769163.4721147055],
              [-9072893.497507935, 4775277.180360741],
              [-9067656.360744076, 4780467.27639964],
              [-9062820.976022488, 4778355.883751599],
              [-9060715.701812606, 4772176.385822555],
              [-9058110.359168721, 4771743.748999704],
              [-9057392.592373444, 4767728.7257006895],
              [-9043537.21195186, 4760180.463668368],
              [-9045746.569885634, 4760008.350548835],
              [-9050053.8549429, 4748288.13561708],
              [-9064179.073810166, 4741125.101408239],
              [-9081605.138218435, 4725422.183738116],
              [-9097104.150921583, 4733743.702149567],
              [-9100398.077224452, 4736584.122319668],
              [-9099583.903898494, 4736949.4749310305],
              [-9100624.077310355, 4747636.521646024],
              [-9100674.94622776, 4748159.453947248],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lampasas',
        GEOID: '48281',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10971953.916670324, 3662730.9506777134],
              [-10940652.879610091, 3684995.6822776184],
              [-10939485.472110143, 3686945.2448301446],
              [-10929348.274000544, 3693119.191886999],
              [-10898968.517046114, 3641761.9589925352],
              [-10899478.805591911, 3637284.8710556016],
              [-10958255.830689231, 3636585.6794851054],
              [-10970318.855989555, 3648794.996025863],
              [-10966120.99799174, 3652981.880752874],
              [-10971953.916670324, 3662730.9506777134],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Warrick',
        GEOID: '18173',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9736813.515950643, 4602818.131783849],
              [-9736753.403425615, 4607899.927334045],
              [-9720087.317180991, 4607966.08096534],
              [-9720072.066410752, 4614246.800830848],
              [-9718012.099233624, 4612205.047872783],
              [-9692929.480248593, 4612336.135365352],
              [-9686742.676908774, 4608224.891647435],
              [-9686738.558087613, 4596151.282424222],
              [-9692847.66042286, 4596148.311029313],
              [-9694847.403755471, 4586311.16834185],
              [-9701882.684254114, 4586998.768329782],
              [-9714629.65650587, 4568803.216736552],
              [-9714895.08756122, 4561842.1533145355],
              [-9718643.219792543, 4564382.325112423],
              [-9721727.60987783, 4566473.133910731],
              [-9731392.368068503, 4571625.613361328],
              [-9734737.614235494, 4570089.179730595],
              [-9737447.925728677, 4584363.404873595],
              [-9736813.515950643, 4602818.131783849],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Guánica',
        GEOID: '72055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7454168.506732283, 2036564.426611997],
              [-7453813.731515125, 2041350.270725965],
              [-7448485.869366269, 2040344.1972567583],
              [-7445565.513844797, 2040453.418355663],
              [-7443179.491879135, 2037317.8439600305],
              [-7442634.233666767, 2031822.4972844524],
              [-7445430.483302464, 2031992.5438610981],
              [-7450308.614708518, 2028991.1641122706],
              [-7453460.737409818, 2029538.9644946638],
              [-7456034.849511393, 2032550.1295349004],
              [-7454168.506732283, 2036564.426611997],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'King',
        GEOID: '53033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13640755.664098928, 6008162.197580449],
              [-13630517.944489142, 6031112.963038866],
              [-13629746.166459475, 6069970.279613499],
              [-13617422.987509169, 6069942.450091903],
              [-13611149.132327551, 6069851.176518239],
              [-13608096.640570508, 6069828.648162506],
              [-13580062.273967603, 6069561.956664271],
              [-13482925.331579354, 6070321.303740116],
              [-13477006.028975913, 6059340.147847357],
              [-13483193.054954711, 6054644.359128782],
              [-13482300.829236003, 6040117.500689035],
              [-13488833.16827524, 6038923.395769019],
              [-13515397.11572426, 6011647.055569139],
              [-13521336.678475026, 6000116.878615913],
              [-13517246.577744301, 5989386.777898129],
              [-13507640.93020324, 5988104.474306733],
              [-13510305.362215376, 5978805.809807047],
              [-13502791.407906322, 5966356.156364063],
              [-13511924.392889474, 5956367.195260472],
              [-13511955.451027405, 5956326.812489813],
              [-13534409.928154297, 5961461.994721295],
              [-13539900.205440221, 5967167.397760849],
              [-13558320.352901274, 5970367.595675473],
              [-13574060.928899445, 5964746.337918594],
              [-13591526.957004908, 5973957.554053977],
              [-13597005.211785829, 5984210.642173078],
              [-13606558.205207743, 5984216.054757659],
              [-13617860.473107986, 5984184.235369414],
              [-13618261.000635857, 5984221.795381352],
              [-13619996.02621936, 5986887.166800843],
              [-13629652.546767715, 5996716.315214516],
              [-13637765.845215201, 5994401.133311006],
              [-13640822.678432385, 5997311.264182034],
              [-13640755.664098928, 6008162.197580449],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Furnas',
        GEOID: '31065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11153968.853842702, 4916938.385985798],
              [-11142501.944415577, 4917116.299352024],
              [-11092119.96739694, 4917109.726140935],
              [-11090811.96338012, 4917098.0404431615],
              [-11090566.48711867, 4866199.777392302],
              [-11111176.973664822, 4866145.725773457],
              [-11151741.4115989, 4866169.821913793],
              [-11153499.419550026, 4866170.866209297],
              [-11153968.853842702, 4916938.385985798],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Accomack',
        GEOID: '51001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8453733.710479312, 4517992.804972728],
              [-8449000.739689255, 4528050.842272732],
              [-8444614.417793527, 4537569.834671866],
              [-8439370.490540728, 4544099.034528478],
              [-8440035.067900764, 4550041.373881928],
              [-8430879.59638047, 4553544.346403226],
              [-8427209.838046981, 4558209.3873993745],
              [-8433307.919752637, 4565860.679723214],
              [-8423513.69699417, 4572477.267832964],
              [-8418463.131696882, 4578608.05359909],
              [-8375930.737252042, 4583270.245394644],
              [-8386657.149426408, 4564601.459879061],
              [-8391334.237832088, 4558497.409311375],
              [-8397831.177273255, 4560983.63948387],
              [-8403427.09675594, 4555784.567766037],
              [-8410398.813825343, 4543904.750404606],
              [-8414857.716029067, 4531952.823900662],
              [-8417370.642214235, 4524378.521523172],
              [-8416624.46766745, 4517552.830427659],
              [-8423866.134502023, 4506743.944606839],
              [-8423035.792498857, 4504443.182422108],
              [-8428363.21929109, 4502000.59528965],
              [-8434000.104346389, 4503884.213881764],
              [-8435408.518543905, 4502661.478028623],
              [-8439441.512375856, 4505369.106175403],
              [-8437296.163149286, 4507465.172149028],
              [-8438551.401727472, 4511097.877737195],
              [-8436682.904074507, 4513075.494921128],
              [-8441937.40667893, 4516645.555443333],
              [-8449194.992200688, 4517069.624037726],
              [-8454222.661186079, 4515914.801748798],
              [-8453733.710479312, 4517992.804972728],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bedford',
        GEOID: '47003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9644657.898136413, 4257487.324359951],
              [-9633935.604783207, 4259093.311485995],
              [-9618307.461470738, 4248263.462387954],
              [-9611540.794903379, 4254521.7271220945],
              [-9600767.851181861, 4250090.657080894],
              [-9599588.977774357, 4225580.917390795],
              [-9602150.995854964, 4220077.227896635],
              [-9620490.659324177, 4207295.906046694],
              [-9631953.004652178, 4212190.99933373],
              [-9640209.793923296, 4213587.656576974],
              [-9642335.328280503, 4213922.241779636],
              [-9647410.606504751, 4230913.313506625],
              [-9644657.898136413, 4257487.324359951],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Choctaw',
        GEOID: '40023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10685733.583402801, 4049876.5903651384],
              [-10662111.364817487, 4049862.3307877583],
              [-10592775.463379443, 4049898.1142894235],
              [-10592707.181908188, 4020544.701998773],
              [-10600553.578840151, 4023694.5212273407],
              [-10603584.808574451, 4019367.6969356695],
              [-10606904.578428889, 4012398.090049972],
              [-10609910.738507258, 4011874.7815852836],
              [-10614573.71210811, 4011063.104507854],
              [-10625152.625957176, 4011205.350751787],
              [-10633830.202903492, 4013436.0728463167],
              [-10637347.119576124, 4019006.799726241],
              [-10642550.415214784, 4019030.2778226063],
              [-10649933.235163685, 4016166.171845758],
              [-10657450.640376953, 4014841.4754410433],
              [-10663253.872123523, 4011686.3176596737],
              [-10677639.877185695, 4018743.4458703585],
              [-10679786.005648699, 4045612.2945341133],
              [-10685733.583402801, 4049876.5903651384],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Piatt',
        GEOID: '17147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9879066.466845553, 4873965.729467756],
              [-9879086.504353896, 4880311.922315252],
              [-9860111.095272765, 4906933.956993568],
              [-9847368.68712013, 4906997.28673953],
              [-9847675.483636757, 4886627.381457133],
              [-9847567.83768916, 4848387.782752585],
              [-9847576.854567915, 4837036.437607283],
              [-9848789.569100616, 4835738.5488016065],
              [-9879122.905827386, 4835783.315761439],
              [-9879066.466845553, 4873965.729467756],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Orange',
        GEOID: '06059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13146063.646879643, 4000123.4819992473],
              [-13142742.87514979, 4005208.2757977024],
              [-13142229.358338762, 4008159.3079096545],
              [-13138896.341464922, 4010855.7043399992],
              [-13133094.258285284, 4015759.237535622],
              [-13131991.97268745, 4021561.231191036],
              [-13126763.74148285, 4021777.279799014],
              [-13111575.532797998, 4021608.60050499],
              [-13099313.356928648, 4011494.2729290035],
              [-13099526.979031477, 4011188.592148611],
              [-13083824.919577125, 3989975.7716849176],
              [-13070353.92535725, 3983111.466973673],
              [-13075357.736468408, 3975509.9916859856],
              [-13081176.740210645, 3966399.8018015944],
              [-13081122.416299134, 3962530.2476919675],
              [-13080999.074303338, 3957804.55349223],
              [-13088776.5218471, 3955711.3431993164],
              [-13090747.843725963, 3946780.4560926636],
              [-13096246.28231831, 3953950.4149629124],
              [-13104012.709232487, 3956595.844131311],
              [-13105252.47440145, 3959648.018467121],
              [-13105895.04363255, 3960252.386619232],
              [-13115015.416383, 3968833.959041796],
              [-13117920.966412196, 3971679.334965177],
              [-13127583.720852036, 3975955.3316625804],
              [-13135765.92606432, 3982479.4237911045],
              [-13145595.771059843, 3992580.490706142],
              [-13148510.195799666, 3994452.731034419],
              [-13146063.646879643, 4000123.4819992473],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '35027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11841461.665016813, 3983306.596923995],
              [-11805734.565002639, 3981941.559110365],
              [-11805728.331111154, 4005409.141656026],
              [-11791481.996637903, 4005411.553675721],
              [-11791624.819544591, 4063765.9856069917],
              [-11723413.801561013, 4063771.5078654103],
              [-11723397.548915358, 4075519.0023337724],
              [-11676495.6418179, 4075497.160033336],
              [-11676677.315226873, 4040679.112655441],
              [-11676572.229627565, 3948278.282356723],
              [-11675759.263386302, 3935968.094367211],
              [-11678018.38113246, 3913755.6930792644],
              [-11723831.249651488, 3912878.1695482377],
              [-11723876.66800373, 3935988.0739156227],
              [-11769359.696871536, 3935835.8306235005],
              [-11769494.83873336, 3947269.4887928045],
              [-11838350.28524914, 3947264.4223800916],
              [-11841265.186115563, 3947427.881970454],
              [-11841365.596296258, 3959173.9451048765],
              [-11841461.665016813, 3983306.596923995],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Navajo',
        GEOID: '04017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12328710.415803695, 4439552.417190643],
              [-12297485.298636181, 4438827.598558858],
              [-12245219.350555358, 4438823.556440097],
              [-12245219.016596887, 4254302.227325082],
              [-12225878.590905447, 4254278.523802739],
              [-12227751.875296514, 4234482.903413375],
              [-12227847.610058596, 4139794.0965758925],
              [-12228501.7233865, 4116072.5386830554],
              [-12230141.570805373, 4104204.4680804256],
              [-12228250.809254251, 4092551.323717381],
              [-12229491.687618123, 4045732.1114384597],
              [-12229478.440598719, 3998989.2060769205],
              [-12233095.433493575, 3999001.795133948],
              [-12233094.65425714, 3970918.593407253],
              [-12234346.219292128, 3971897.386054573],
              [-12245216.233609617, 3972134.5480166203],
              [-12245217.458124017, 4028808.2028121995],
              [-12328708.41205286, 4028808.471363485],
              [-12328709.079969805, 4064213.7013437976],
              [-12328733.792896762, 4168088.0572204976],
              [-12328710.415803695, 4439552.417190643],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Currituck',
        GEOID: '37053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8495148.234597607, 4376643.187732699],
              [-8473901.234088538, 4376643.372387726],
              [-8463259.09666751, 4376643.4648772115],
              [-8445480.70607088, 4376671.317937187],
              [-8442296.189397758, 4360628.720454134],
              [-8437617.765158188, 4340647.1223116955],
              [-8434750.337886754, 4332602.433685118],
              [-8439476.578015456, 4331426.646570506],
              [-8434263.708900586, 4308461.262558896],
              [-8442475.302458445, 4304589.611645589],
              [-8446344.767958418, 4306372.998559765],
              [-8449850.107404009, 4312444.357834132],
              [-8447811.736208092, 4323116.044139841],
              [-8454579.182011887, 4340025.650994194],
              [-8465931.321044004, 4350245.534630478],
              [-8472979.40328409, 4349924.703195209],
              [-8477929.00180323, 4359305.474468803],
              [-8495158.027179547, 4376643.200177458],
              [-8495148.234597607, 4376643.187732699],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Newberry',
        GEOID: '45071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9122077.788125128, 4056112.5665756236],
              [-9116546.545266593, 4069223.155407427],
              [-9104000.393376226, 4077930.544008507],
              [-9098932.684877353, 4086761.120567415],
              [-9095158.397542007, 4089742.452038955],
              [-9088518.63519415, 4100685.5286755543],
              [-9077103.155371774, 4088716.9103467646],
              [-9063993.726857994, 4095379.8050615448],
              [-9054983.081995225, 4064700.497796857],
              [-9052157.125401946, 4061000.8844010653],
              [-9054611.720173938, 4055364.0900589675],
              [-9065544.518684234, 4046266.2600718453],
              [-9060752.437244566, 4038405.1619126196],
              [-9069418.436963841, 4039085.726995614],
              [-9072814.238030491, 4038726.6243935646],
              [-9080165.109285535, 4042195.421901485],
              [-9098321.65219239, 4054021.7744472143],
              [-9112677.079766616, 4052912.9428396192],
              [-9113736.062082533, 4046991.677331446],
              [-9116749.480698308, 4048464.4409886524],
              [-9122077.788125128, 4056112.5665756236],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pike',
        GEOID: '17149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10170662.596804617, 4830941.568972348],
              [-10120730.728645107, 4830717.088072652],
              [-10120806.87117681, 4843454.329820708],
              [-10117837.646398878, 4842863.6628096895],
              [-10082401.535533639, 4842620.968849814],
              [-10085446.234926324, 4835481.106466754],
              [-10090665.449252168, 4822929.693669598],
              [-10083436.918117505, 4796682.569294965],
              [-10086714.943162896, 4787410.369425561],
              [-10087070.274977509, 4778522.548934567],
              [-10122876.851137891, 4779061.965114627],
              [-10123107.17713456, 4779246.861544311],
              [-10134333.859100554, 4786111.264128128],
              [-10137232.062043356, 4792774.653849244],
              [-10141239.786350897, 4799131.401865778],
              [-10146579.559685268, 4800156.749516457],
              [-10149469.079707788, 4806825.15274651],
              [-10150431.269817708, 4807729.226791167],
              [-10160813.42637555, 4817489.504887363],
              [-10164110.746981, 4820448.191281212],
              [-10171011.738885593, 4826643.291170912],
              [-10170662.596804617, 4830941.568972348],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Island',
        GEOID: '53029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13664752.806729235, 6150229.285048419],
              [-13659689.32837101, 6159468.394080181],
              [-13655226.032188393, 6175751.029620623],
              [-13646341.342188463, 6176486.636872048],
              [-13632028.549979208, 6156525.684567345],
              [-13624723.876312844, 6146446.0157635],
              [-13627499.2938573, 6135287.34175401],
              [-13619971.86988986, 6120226.305187771],
              [-13618086.006396333, 6095751.705761725],
              [-13625288.266131163, 6083863.6341062],
              [-13628803.513011437, 6078303.965520766],
              [-13636838.999134855, 6095169.537990883],
              [-13644846.974239668, 6098707.541352114],
              [-13641850.046012916, 6101402.311119447],
              [-13641415.899998821, 6106256.609464634],
              [-13648586.878956744, 6112012.348974508],
              [-13647580.439440483, 6125277.164633291],
              [-13651461.70480648, 6134062.090614581],
              [-13660182.585034717, 6139119.11499562],
              [-13664752.806729235, 6150229.285048419],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Bernardino',
        GEOID: '06071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13113718.65563475, 4025519.5950347083],
              [-13109846.184508525, 4031411.1645915397],
              [-13107240.195229053, 4031467.976295822],
              [-13103536.039172908, 4039486.7741299598],
              [-13102781.626983803, 4041572.742801497],
              [-13101585.49905523, 4045145.276161766],
              [-13099788.802473824, 4051127.4671021234],
              [-13096334.447355019, 4067696.8983824532],
              [-13097320.849362938, 4082264.7648376636],
              [-13098663.028463434, 4139789.214883074],
              [-13094735.565508755, 4139754.500684564],
              [-13094525.72826861, 4240802.818880394],
              [-13092974.93644237, 4256796.042626428],
              [-13096959.172337351, 4260781.791866583],
              [-13094845.215207187, 4272759.165335657],
              [-13052323.284794481, 4272450.7768980265],
              [-12943925.70799555, 4272229.818582951],
              [-12883660.452625811, 4272260.834821659],
              [-12873880.035668852, 4274458.163578493],
              [-12873841.182981921, 4274420.934871048],
              [-12846774.294073498, 4248131.179959239],
              [-12835553.957318481, 4237264.005752853],
              [-12819560.129478758, 4221669.0036325855],
              [-12806618.570757097, 4209092.2860840885],
              [-12779950.539584186, 4182880.561867231],
              [-12760941.400697347, 4164133.505810317],
              [-12760527.514830576, 4156143.1992061157],
              [-12761041.031641604, 4146620.7913056817],
              [-12754592.29353995, 4138809.393841907],
              [-12745076.59214745, 4126551.6701325886],
              [-12742212.898246793, 4121995.51108142],
              [-12737441.299593432, 4107046.4265000955],
              [-12732525.542199492, 4098370.8486517835],
              [-12732595.5621592, 4089438.033127476],
              [-12727755.39069951, 4089392.4047483965],
              [-12719845.584281195, 4082818.852477109],
              [-12709662.96781935, 4075218.8766403175],
              [-12706110.206270684, 4069953.81583636],
              [-12706097.644008636, 4069577.633544335],
              [-12705901.482225446, 4063705.1062535387],
              [-12710242.38576893, 4061069.6939986884],
              [-12715993.707260763, 4053929.591963682],
              [-12723016.965254402, 4051211.150802054],
              [-12729166.921842767, 4046870.7712398446],
              [-12735611.095845299, 4043788.974219848],
              [-12738069.586799469, 4041267.868312081],
              [-12738299.476967935, 4039405.516092075],
              [-12836925.636084035, 4039259.234594715],
              [-12836942.000049185, 4033383.085861582],
              [-12946527.021856407, 4033172.7277551913],
              [-13016538.855242549, 4033383.488850187],
              [-13016516.480024898, 4029461.8753616237],
              [-13036039.692320222, 4029341.1552810012],
              [-13037882.697809795, 4029327.861379152],
              [-13049468.830411559, 4031315.2703003245],
              [-13065745.409757897, 4031407.1354034063],
              [-13066156.178678926, 4033351.518465168],
              [-13086526.643618677, 4031340.922615726],
              [-13092390.731754685, 4018751.092840224],
              [-13097336.434091648, 4018647.657944482],
              [-13099313.356928648, 4011494.2729290035],
              [-13111575.532797998, 4021608.60050499],
              [-13113718.65563475, 4025519.5950347083],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dade',
        GEOID: '29057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10473169.5723305, 4487905.925352347],
              [-10472423.954381166, 4520483.159699959],
              [-10421289.123646295, 4519235.731215849],
              [-10421859.079439156, 4498852.683855169],
              [-10422381.279170468, 4478488.722157519],
              [-10469855.591089584, 4479617.418193607],
              [-10473364.381439388, 4479725.579007759],
              [-10473169.5723305, 4487905.925352347],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Emporia',
        GEOID: '51595',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8633955.735932972, 4398316.073250837],
              [-8628869.103120664, 4400231.589970263],
              [-8628289.796490576, 4395012.427405408],
              [-8630124.230379358, 4393601.234297979],
              [-8633552.7593763, 4393884.7904400695],
              [-8633955.735932972, 4398316.073250837],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Callahan',
        GEOID: '48059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11090714.00222822, 3831058.5765485945],
              [-11088760.011206327, 3831058.180513143],
              [-11033352.62709532, 3831078.906386196],
              [-11033839.315909067, 3773761.93475567],
              [-11042433.848515252, 3773715.9519494213],
              [-11090918.162174337, 3773983.837115611],
              [-11090714.00222822, 3831058.5765485945],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '36117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8613462.70778339, 5353776.032863234],
              [-8609570.978835724, 5354789.351768884],
              [-8601008.84020136, 5354285.066586387],
              [-8586120.08094674, 5355549.959719476],
              [-8571566.39335941, 5353381.917017731],
              [-8566276.825115386, 5353265.111794547],
              [-8553976.13270222, 5358572.821212238],
              [-8545888.771696089, 5360569.788530345],
              [-8540654.258255377, 5363496.970012454],
              [-8538463.650340686, 5324180.833892682],
              [-8539741.820733974, 5315630.934859753],
              [-8567585.051771188, 5313974.690969649],
              [-8586450.477195416, 5313869.0350624295],
              [-8595627.878655395, 5318038.477767651],
              [-8599074.886687808, 5317249.398137941],
              [-8612953.532882968, 5317254.423912024],
              [-8613462.70778339, 5353776.032863234],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '47051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9608894.507968241, 4181151.452624365],
              [-9607548.432685569, 4195341.85877837],
              [-9600784.549105478, 4208006.045629138],
              [-9602585.030549569, 4209306.108356901],
              [-9591066.691517698, 4213267.823915514],
              [-9576486.287252577, 4210705.948406013],
              [-9563857.424980553, 4203250.551228452],
              [-9559341.415878052, 4194276.7288802783],
              [-9558260.72626143, 4192268.57849876],
              [-9558330.758667426, 4162118.8292124174],
              [-9608127.071398713, 4162671.463617419],
              [-9608960.494317977, 4162668.824864519],
              [-9608894.507968241, 4181151.452624365],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ashtabula',
        GEOID: '39007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9017282.95532623, 5118403.400528956],
              [-9017131.38343309, 5138412.918628932],
              [-9005784.876441682, 5141363.278498217],
              [-8994703.243772194, 5147452.80192626],
              [-8970334.071403656, 5154631.741108119],
              [-8963381.38996718, 5157613.092878222],
              [-8963378.242596766, 5138471.279299565],
              [-8963373.820241809, 5111639.7858789],
              [-8963353.754942933, 5086362.3608014295],
              [-9017226.627663888, 5086624.0990496855],
              [-9017282.95532623, 5118403.400528956],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Houston',
        GEOID: '01069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9536308.96795496, 3667514.092567136],
              [-9516241.737308128, 3664750.8049149206],
              [-9508625.257748052, 3673722.296664517],
              [-9482097.489133544, 3672771.393860211],
              [-9472045.223735653, 3672898.1361010144],
              [-9472150.313394729, 3671123.449717661],
              [-9474200.59577616, 3666377.8399518477],
              [-9474125.34380038, 3656987.1018656488],
              [-9466121.361092854, 3646807.9195710314],
              [-9464506.400522366, 3642553.446570202],
              [-9463424.86906737, 3639705.064969238],
              [-9462434.904835746, 3632837.7143835262],
              [-9465639.34769772, 3632833.1689355997],
              [-9478404.798984949, 3632839.1429532184],
              [-9499261.618779978, 3632691.3517983775],
              [-9516513.834308181, 3632484.8137944103],
              [-9516231.273275994, 3658735.444013938],
              [-9541230.625281911, 3658122.0970630767],
              [-9536308.96795496, 3667514.092567136],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mackinac',
        GEOID: '26097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9419434.523251612, 5763454.0610808125],
              [-9408489.034319362, 5752915.558886595],
              [-9397557.571642954, 5748328.539260925],
              [-9390469.191747202, 5743870.28098206],
              [-9394701.336148178, 5736807.536674948],
              [-9404730.109073745, 5737299.826395822],
              [-9416245.442479365, 5749426.685098043],
              [-9423282.058811897, 5757816.157582656],
              [-9419434.523251612, 5763454.0610808125],
            ],
          ],
          [
            [
              [-9558450.859951705, 5819638.548422812],
              [-9488632.833799034, 5819767.159466076],
              [-9474772.444000363, 5819814.161716477],
              [-9474681.607295876, 5805747.350408159],
              [-9391302.195496807, 5805702.512151825],
              [-9391256.22054711, 5791826.431897319],
              [-9377429.67187364, 5791807.658285245],
              [-9377479.543005515, 5777932.007671953],
              [-9363595.17081614, 5775208.005375245],
              [-9379218.353451706, 5773311.879231427],
              [-9392741.1112348, 5769452.778694343],
              [-9404319.117513737, 5776786.601405845],
              [-9414010.258423727, 5771972.386217212],
              [-9421286.322980957, 5772501.530645387],
              [-9432545.955516223, 5765462.5690034265],
              [-9429471.422500005, 5756129.638952871],
              [-9439087.200114727, 5757733.198699859],
              [-9452971.078325955, 5769245.991336433],
              [-9462557.133636637, 5781331.611475687],
              [-9479080.285655081, 5788481.666502189],
              [-9491810.55998322, 5790896.624321728],
              [-9504613.303299863, 5793506.590650514],
              [-9522364.754579723, 5793111.315458739],
              [-9534356.424086444, 5777736.7174583655],
              [-9539769.000367798, 5773966.80896514],
              [-9552374.708185736, 5777158.722073076],
              [-9558541.5766474, 5771951.424932102],
              [-9558450.859951705, 5819638.548422812],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Curry',
        GEOID: '35009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11548079.814948086, 4110286.3137602177],
              [-11544508.908322418, 4110332.2974321777],
              [-11544475.51247518, 4122163.933838513],
              [-11521083.391277337, 4122021.370037997],
              [-11521082.6120409, 4133830.9361764058],
              [-11509352.654657032, 4133769.5411321335],
              [-11509299.666579414, 4145608.4872319507],
              [-11497557.57537105, 4145548.9268323407],
              [-11497538.873696595, 4157655.044590079],
              [-11470665.215231728, 4157650.9754732586],
              [-11470668.575008916, 4129601.2941442137],
              [-11470702.304814626, 4112330.3345670267],
              [-11470799.59804958, 4079881.567086352],
              [-11470788.944904776, 4070874.4010663335],
              [-11470787.333999647, 4069513.015233336],
              [-11517094.47996374, 4069595.621926559],
              [-11548291.321980594, 4069567.9964563395],
              [-11548079.814948086, 4110286.3137602177],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'White Pine',
        GEOID: '32033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12899244.624739416, 4788602.937818163],
              [-12892297.17531901, 4807048.48689069],
              [-12894481.820325827, 4826698.728466035],
              [-12890225.296956364, 4844618.658299123],
              [-12894726.723205574, 4868466.907066342],
              [-12894689.765134629, 4884537.358755483],
              [-12831099.61921388, 4883765.906255553],
              [-12718433.607859971, 4882913.869801216],
              [-12695584.148849798, 4882949.65487756],
              [-12695585.616333123, 4880178.473957892],
              [-12695683.817164456, 4852306.081288542],
              [-12695741.129661761, 4836075.1027502315],
              [-12695674.161295015, 4799715.821608779],
              [-12695662.760740243, 4793539.235924119],
              [-12695888.1827091, 4722460.720284438],
              [-12695771.297243766, 4704310.251292343],
              [-12695925.219363924, 4675561.3203054],
              [-12801835.617515672, 4675555.551420478],
              [-12902716.123059807, 4744881.496795392],
              [-12899244.624739416, 4788602.937818163],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Juan',
        GEOID: '53055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13718696.56217529, 6221321.874670727],
              [-13700137.265350746, 6224105.2403628975],
              [-13694490.250221787, 6227705.491404414],
              [-13690017.43308171, 6237901.638322155],
              [-13685387.210181657, 6239356.84215917],
              [-13672085.755546259, 6231640.842601297],
              [-13663693.713093827, 6217701.744604133],
              [-13669923.263118109, 6208048.640231215],
              [-13666828.135996094, 6200937.778391736],
              [-13667709.563724194, 6191940.979630997],
              [-13672027.424133085, 6187737.439652105],
              [-13670425.425341077, 6178481.947794976],
              [-13678286.139863955, 6176711.893235343],
              [-13684282.809513498, 6180364.124225965],
              [-13696656.19355415, 6183727.003023308],
              [-13708046.626491101, 6191332.738121317],
              [-13714859.60196663, 6205613.177540425],
              [-13718696.56217529, 6221321.874670727],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Skagit',
        GEOID: '53057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13657690.475594329, 6186555.35257098],
              [-13653369.720878676, 6195511.494072935],
              [-13652511.44760466, 6205297.623323311],
              [-13655711.707711019, 6214888.969730065],
              [-13648635.414254729, 6211650.512005512],
              [-13643975.246411653, 6212297.094297089],
              [-13636803.376897803, 6214892.508111602],
              [-13605004.630394233, 6214954.846873236],
              [-13532450.037199391, 6214389.09724986],
              [-13459456.845210826, 6214148.016464757],
              [-13442040.465598254, 6216860.948931394],
              [-13446092.829021603, 6211489.000429259],
              [-13434984.03439636, 6203171.682107329],
              [-13436492.858774569, 6195752.383352647],
              [-13450060.255673474, 6198012.16595713],
              [-13475192.523151398, 6187991.209238989],
              [-13477627.637012502, 6159889.557436801],
              [-13469842.953701837, 6156242.228463628],
              [-13533945.50323871, 6156737.195130987],
              [-13603383.5959693, 6156514.13865092],
              [-13632028.549979208, 6156525.684567345],
              [-13646341.342188463, 6176486.636872048],
              [-13655226.032188393, 6175751.029620623],
              [-13655042.964144789, 6176419.547519289],
              [-13657690.475594329, 6186555.35257098],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Spokane',
        GEOID: '53063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13115767.824821273, 6077918.791452349],
              [-13102056.269181794, 6082977.833956259],
              [-13083965.516093997, 6072727.835964974],
              [-13083965.516093997, 6114807.242063916],
              [-13073026.261053234, 6114711.993927258],
              [-13028968.39478561, 6114421.94385698],
              [-13028978.635399304, 6103105.122394984],
              [-13029015.098492695, 6062930.6198294265],
              [-13028887.790803267, 6002025.30163541],
              [-13028850.985940782, 5984497.021735121],
              [-13116066.38369558, 5984652.51699955],
              [-13115767.824821273, 6077918.791452349],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stevens',
        GEOID: '53065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13180317.544752661, 6111627.824839217],
              [-13166365.761652049, 6113606.393660973],
              [-13161659.396220291, 6117722.813062164],
              [-13163374.606934434, 6129219.216588289],
              [-13156995.109556053, 6133495.840494022],
              [-13157351.554565573, 6142345.338840792],
              [-13151449.06120524, 6150245.00270751],
              [-13155247.83882856, 6160172.464993721],
              [-13158688.167691529, 6185455.028798073],
              [-13152365.443253452, 6193899.913394367],
              [-13147384.007359942, 6216271.312452733],
              [-13150282.989539182, 6237217.628439857],
              [-13157463.764612293, 6247878.844716988],
              [-13160375.993810933, 6264194.972581733],
              [-13157671.603941314, 6274930.411494859],
              [-13135927.673284445, 6274935.5440887185],
              [-13091987.309920052, 6275004.434679395],
              [-13072244.241630409, 6274913.463555888],
              [-13072289.771302143, 6261834.652242106],
              [-13079924.061980749, 6261833.127481289],
              [-13079872.743695492, 6247231.913331604],
              [-13087148.808252722, 6247193.183581952],
              [-13087143.576236654, 6231359.263526054],
              [-13094447.248027602, 6231304.06296841],
              [-13094427.21051926, 6216667.15134703],
              [-13080037.385222374, 6216723.604969621],
              [-13080304.106722316, 6129294.776823233],
              [-13073097.060249379, 6129291.440816455],
              [-13073026.261053234, 6114711.993927258],
              [-13083965.516093997, 6114807.242063916],
              [-13083965.516093997, 6072727.835964974],
              [-13102056.269181794, 6082977.833956259],
              [-13115767.824821273, 6077918.791452349],
              [-13122505.548321025, 6081520.004517095],
              [-13144403.09403548, 6073656.498177183],
              [-13159335.60184998, 6097791.597945303],
              [-13163095.97424898, 6097477.672932493],
              [-13173652.958158357, 6089290.757423504],
              [-13174521.472825527, 6102161.64835108],
              [-13180317.544752661, 6111627.824839217],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tift',
        GEOID: '13277',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9313631.692463579, 3695914.7312557893],
              [-9311938.411689123, 3696593.9384869626],
              [-9311806.832051005, 3706733.540948946],
              [-9311760.9684208, 3710456.3020532643],
              [-9295255.627520878, 3710132.7089776713],
              [-9295283.346074088, 3707013.1429992127],
              [-9286365.430347148, 3704850.7058123006],
              [-9277224.764319131, 3694721.151640182],
              [-9280651.846162692, 3693293.8127893354],
              [-9280804.79914304, 3684955.3821596974],
              [-9287885.164035456, 3678334.2695610286],
              [-9290796.391358683, 3675193.4877047287],
              [-9296580.886058774, 3675342.310653739],
              [-9312330.70157468, 3675766.6353841717],
              [-9312071.772439094, 3689230.8036436606],
              [-9313631.692463579, 3695914.7312557893],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bennington',
        GEOID: '50003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8157344.564366804, 5286649.427828375],
              [-8156805.756549043, 5303395.956006884],
              [-8156380.062371839, 5316648.044589204],
              [-8156354.600135179, 5317441.2932486385],
              [-8154748.909772632, 5359997.626268507],
              [-8123668.0806925325, 5356468.460655189],
              [-8111617.74581416, 5357860.454548207],
              [-8106274.187617104, 5357626.121247328],
              [-8106214.965647999, 5350942.46001913],
              [-8109393.137110148, 5352010.924017917],
              [-8111710.697588974, 5329213.369528436],
              [-8125981.967628162, 5330107.011724845],
              [-8126633.297968793, 5315474.4028415205],
              [-8127220.396963237, 5301336.422521712],
              [-8117570.44426484, 5300835.47297836],
              [-8118559.697445221, 5272339.346729016],
              [-8128398.782051138, 5272614.396211953],
              [-8128885.168069159, 5272627.993236743],
              [-8142185.312165159, 5272999.809223575],
              [-8155817.706231083, 5273380.928787319],
              [-8158710.565838329, 5281870.486265802],
              [-8157344.564366804, 5286649.427828375],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Douglas',
        GEOID: '53017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13393581.978061033, 6019339.959918932],
              [-13380496.817196248, 6054158.71667357],
              [-13381648.639967486, 6065091.879284859],
              [-13357523.92520073, 6070854.245018365],
              [-13343933.596486723, 6100278.4755895175],
              [-13346689.310481314, 6115184.415091203],
              [-13333246.702731589, 6124209.709149583],
              [-13321570.846620245, 6119379.8974383585],
              [-13324243.070996739, 6112189.468919703],
              [-13319651.80991846, 6106891.601489269],
              [-13304635.144568922, 6117278.0686173],
              [-13295583.311494557, 6119622.481351842],
              [-13285260.209835334, 6115082.501803274],
              [-13280257.734558066, 6126088.973283246],
              [-13275611.815609807, 6123845.307661772],
              [-13263826.755077993, 6131189.671861418],
              [-13253361.275790047, 6129672.754805523],
              [-13247374.513575185, 6114055.276824606],
              [-13241540.48170169, 6109997.0348049905],
              [-13245041.702326123, 6100539.471616908],
              [-13258582.493866723, 6100495.91631444],
              [-13261034.97356839, 6093107.678773642],
              [-13270644.183333158, 6088193.737259967],
              [-13270664.777438954, 6073761.40154351],
              [-13280264.859005475, 6061776.713342129],
              [-13282675.482578602, 6044990.215663705],
              [-13292125.616791027, 6042651.517558849],
              [-13306340.33652889, 6028646.787409366],
              [-13306366.385289738, 6014389.998308943],
              [-13344508.561656673, 6013778.570036449],
              [-13349312.554281857, 6001769.916739541],
              [-13358862.54207752, 5994462.548191366],
              [-13359126.3692707, 5978079.693827465],
              [-13366795.725588903, 5979024.639951937],
              [-13368854.134293163, 5984970.5692551145],
              [-13367946.657804213, 5997574.5856567845],
              [-13387314.022812428, 6004961.6863997085],
              [-13390235.268889824, 6006477.518737994],
              [-13390974.986906145, 6007736.556657143],
              [-13391334.437541919, 6009771.861934059],
              [-13392678.95435172, 6012932.022990392],
              [-13393057.551939905, 6015055.129879027],
              [-13393736.712153235, 6016981.188759518],
              [-13393581.978061033, 6019339.959918932],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Berkeley',
        GEOID: '54003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8708426.864950242, 4777786.316945934],
              [-8698386.677967682, 4807088.213732129],
              [-8685995.939237695, 4810969.197531255],
              [-8683669.907326339, 4808177.657418626],
              [-8674681.303722745, 4809088.627993994],
              [-8663975.263015194, 4806148.102262804],
              [-8663301.557456914, 4797285.665242609],
              [-8661874.652675886, 4793654.096561806],
              [-8665903.984512677, 4785840.392086597],
              [-8675224.542837817, 4776418.909827218],
              [-8679241.506663091, 4774401.961430396],
              [-8681604.374174671, 4767625.121039021],
              [-8686867.003101924, 4761603.49311932],
              [-8686614.445378203, 4759648.006960688],
              [-8703778.214865275, 4773944.798546591],
              [-8708426.864950242, 4777786.316945934],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '01093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9818778.000829812, 4040426.5124094277],
              [-9815402.59787714, 4071991.685201181],
              [-9755452.96280856, 4070099.091090015],
              [-9755608.030859236, 4029097.8390462818],
              [-9755587.325433949, 4017427.9748861482],
              [-9767099.430574335, 4017358.2213206263],
              [-9790747.920559475, 4018055.64198202],
              [-9790763.95056615, 4031783.6020308854],
              [-9794660.244063407, 4035800.1991709513],
              [-9819183.816565672, 4036637.4148490047],
              [-9818778.000829812, 4040426.5124094277],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lamoille',
        GEOID: '50015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8117875.0143916495, 5563936.687023325],
              [-8109743.793506146, 5576149.483582085],
              [-8103558.548639199, 5573194.137921863],
              [-8102515.373690976, 5578758.411862958],
              [-8098199.071754958, 5587920.9114646865],
              [-8079363.925232226, 5587200.706607545],
              [-8061458.630416092, 5578001.646647982],
              [-8068692.950164273, 5564073.877952193],
              [-8056724.323792145, 5556286.372624389],
              [-8063351.061759577, 5544098.989813253],
              [-8069874.272600573, 5531142.1457116315],
              [-8081439.588457557, 5539915.807658066],
              [-8087850.589251833, 5527276.507283431],
              [-8100258.0370566705, 5534192.2110406365],
              [-8104614.970606827, 5535608.231162434],
              [-8108360.092235588, 5536786.154643169],
              [-8105099.655669741, 5550629.478004286],
              [-8110263.321569679, 5555207.815991657],
              [-8117875.0143916495, 5563936.687023325],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kemper',
        GEOID: '28069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9897907.179342823, 3885565.3887572326],
              [-9886593.668174013, 3885482.234399935],
              [-9834797.627252683, 3885888.3020611187],
              [-9837674.985861853, 3857115.723614321],
              [-9839446.141758405, 3839439.719830491],
              [-9897918.645250374, 3839285.501786144],
              [-9897907.179342823, 3885565.3887572326],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sutton',
        GEOID: '48435',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11238881.135029996, 3594635.411904777],
              [-11144888.189020224, 3595191.5050358814],
              [-11144913.458544632, 3540919.531444144],
              [-11209916.471442532, 3540659.1168443016],
              [-11238887.36892148, 3540594.6586128958],
              [-11238881.135029996, 3594635.411904777],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harris',
        GEOID: '48201',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10682286.798009368, 3524600.08470138],
              [-10664777.91189995, 3515136.109211334],
              [-10652297.104550678, 3516246.730433521],
              [-10639319.144355528, 3523075.0911803422],
              [-10636735.530293707, 3525498.5583720086],
              [-10631110.779062904, 3521996.3123284266],
              [-10630023.187637854, 3517744.524316844],
              [-10622575.134467348, 3518403.7896928852],
              [-10620485.333666686, 3515390.8538871515],
              [-10607932.725245856, 3507118.7605536766],
              [-10586117.110676624, 3525061.8031233433],
              [-10579324.840626383, 3504200.790096704],
              [-10578331.870768506, 3503130.679246703],
              [-10575333.146325517, 3502434.416282922],
              [-10573287.762001682, 3488683.2585817534],
              [-10565184.037030403, 3481212.298501513],
              [-10565757.332407989, 3473545.1198403914],
              [-10577025.75918303, 3456327.6361071514],
              [-10577378.19669088, 3446424.963679127],
              [-10582594.628029453, 3446921.6255469257],
              [-10582865.579670044, 3446810.031731472],
              [-10583062.281210275, 3446702.5340126846],
              [-10583156.680138469, 3446616.536481133],
              [-10583228.59252952, 3446499.3145765574],
              [-10583286.478664733, 3446347.413973105],
              [-10583362.732515927, 3446032.6130115646],
              [-10583419.171497758, 3445863.058758402],
              [-10583525.036333501, 3445711.2935915184],
              [-10583698.583419649, 3445522.9332305607],
              [-10583974.655756818, 3445315.8935529343],
              [-10584014.28549554, 3445199.835059634],
              [-10584091.318583168, 3445200.3468919382],
              [-10584199.855086692, 3444984.4834147263],
              [-10584164.678127602, 3444854.864693781],
              [-10584227.239681426, 3444744.0564319994],
              [-10584283.010746315, 3444575.1588289333],
              [-10584269.318448948, 3444487.8959313203],
              [-10584100.669420395, 3444205.894932008],
              [-10584133.953948142, 3443952.304001168],
              [-10584206.088978177, 3443806.702574633],
              [-10584268.984490475, 3443747.4645018172],
              [-10584500.862989798, 3443789.046274019],
              [-10584605.503311142, 3443779.1945805256],
              [-10584916.863926891, 3443897.9271783],
              [-10584981.540551042, 3443841.8873034986],
              [-10585033.415433753, 3443676.072109217],
              [-10585168.557295576, 3443519.598762701],
              [-10585298.467141332, 3443432.9826870193],
              [-10585374.609673034, 3443421.97980015],
              [-10585468.229364792, 3443476.610504961],
              [-10585500.51201712, 3443683.4928055154],
              [-10585577.656424241, 3443774.2047646055],
              [-10585873.320991786, 3444012.054797115],
              [-10586088.724206472, 3443911.36143093],
              [-10586147.16693914, 3443755.9087893586],
              [-10586094.846778465, 3443598.922708432],
              [-10585974.399089428, 3443372.083105011],
              [-10585967.163322527, 3443197.8300019465],
              [-10585934.324072743, 3443042.2579952828],
              [-10585801.297281243, 3442833.211056267],
              [-10585781.482411884, 3442681.993159842],
              [-10585903.04329583, 3442329.286201887],
              [-10586084.382746331, 3442160.2921860595],
              [-10586154.736664513, 3442064.4744547256],
              [-10586217.743496303, 3441820.647752476],
              [-10586316.595204126, 3441764.4889476364],
              [-10586398.192390878, 3441794.6790721216],
              [-10586471.997213274, 3441981.7059039585],
              [-10586545.022799233, 3442099.014810166],
              [-10586693.968277914, 3442198.0310065784],
              [-10586840.353408309, 3442107.4580221805],
              [-10586867.626683552, 3442016.8856715355],
              [-10586818.423468623, 3441844.697611288],
              [-10586887.664191896, 3441728.926094706],
              [-10587110.19185399, 3441644.3687683484],
              [-10587171.528893419, 3441561.8587478064],
              [-10587153.717774892, 3441458.6260208166],
              [-10587020.023066448, 3441254.7214174517],
              [-10586932.859905157, 3441046.8545972826],
              [-10586914.826147648, 3440884.1451748665],
              [-10586965.142557489, 3440813.024402862],
              [-10587062.32447295, 3440767.870590284],
              [-10587206.817172, 3440746.253098356],
              [-10587385.484954724, 3440674.2376903608],
              [-10587537.547379147, 3440700.7157778256],
              [-10587689.49848408, 3440795.5000999635],
              [-10587870.281337127, 3440838.8631993076],
              [-10588013.88348025, 3440796.907159904],
              [-10588105.833379645, 3440714.2746261843],
              [-10588209.026547614, 3440568.070057359],
              [-10588391.479193022, 3440467.2755679055],
              [-10593599.895528259, 3439190.783796717],
              [-10597725.173218075, 3447527.473918892],
              [-10599443.61219745, 3446614.744871973],
              [-10603610.746015806, 3446320.15651363],
              [-10607243.880236825, 3451965.8529834338],
              [-10608459.266437307, 3451791.2279553832],
              [-10612214.629459217, 3452122.300578534],
              [-10622564.22515725, 3449706.0239580823],
              [-10625037.855562167, 3451045.6414956087],
              [-10638953.459828272, 3458478.2110941326],
              [-10644575.428071804, 3461659.199146777],
              [-10651837.243734213, 3466337.2458396913],
              [-10651978.285529047, 3466437.729852099],
              [-10659002.211439632, 3471002.6336321943],
              [-10667326.015044207, 3476364.138870355],
              [-10682286.798009368, 3524600.08470138],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pierce',
        GEOID: '13229',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9174645.857303962, 3687039.2939350777],
              [-9166585.992212057, 3688736.606683072],
              [-9161641.06911153, 3696964.300534046],
              [-9153421.571869828, 3701864.006573611],
              [-9145704.793448545, 3694224.3833000907],
              [-9142980.805508835, 3694103.914147525],
              [-9135254.453611346, 3693464.390325348],
              [-9132776.70438527, 3681379.6333931587],
              [-9127911.152081678, 3670277.7412021],
              [-9140980.171620296, 3667909.8847672325],
              [-9149686.357675748, 3659026.1860879823],
              [-9159875.430668058, 3661932.5526503194],
              [-9163268.337427946, 3662128.990470252],
              [-9170912.090263266, 3670617.6068942235],
              [-9174645.857303962, 3687039.2939350777],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Meade',
        GEOID: '46093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11529098.394614452, 5559408.672620109],
              [-11461913.964974968, 5559438.223367882],
              [-11461162.113134151, 5627752.967911418],
              [-11354587.39299696, 5627548.958032678],
              [-11354636.150933927, 5544967.6711380705],
              [-11354706.950130071, 5544852.622682965],
              [-11367115.399810325, 5533146.203418308],
              [-11375676.2026108, 5531791.202636033],
              [-11386077.673191542, 5535132.6134622],
              [-11387984.130790869, 5523656.704281271],
              [-11392618.695151065, 5519575.050949514],
              [-11398394.729569854, 5496905.552069524],
              [-11397785.032718781, 5487161.515432825],
              [-11516274.389275067, 5487252.881137645],
              [-11516337.062148385, 5505239.273693624],
              [-11529849.02194087, 5505156.587394214],
              [-11529098.394614452, 5559408.672620109],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Koochiching',
        GEOID: '27071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10511921.92191067, 6223824.886970132],
              [-10507318.495923698, 6226125.079790979],
              [-10495401.633114787, 6224996.514970052],
              [-10491992.139750771, 6221329.967958983],
              [-10491883.269288776, 6216746.523562274],
              [-10474189.370185656, 6214614.348021559],
              [-10455906.257017769, 6212517.2365597505],
              [-10446667.184559891, 6212209.847449416],
              [-10442354.890125541, 6202262.169071017],
              [-10443457.84364032, 6194898.290997751],
              [-10427805.210039878, 6193182.1287181815],
              [-10415281.099408692, 6195299.860059178],
              [-10404754.95099826, 6198118.772710356],
              [-10404399.173905686, 6205878.757043554],
              [-10394029.54069931, 6208116.3159604035],
              [-10391399.283770846, 6211742.468872616],
              [-10375800.083525985, 6214413.020384241],
              [-10368566.76565322, 6211456.833213829],
              [-10362559.357600847, 6211775.1792305885],
              [-10363453.638802102, 6118146.091280045],
              [-10361747.111008242, 6088884.670990798],
              [-10439071.18778612, 6090060.149568435],
              [-10439115.82690193, 6081339.866594712],
              [-10510624.128202805, 6081242.334928869],
              [-10510535.517888132, 6095733.927794407],
              [-10511755.022909774, 6168184.983736651],
              [-10511921.92191067, 6223824.886970132],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wagoner',
        GEOID: '40145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10666629.600309806, 4280811.50686021],
              [-10660142.234344846, 4286981.68780805],
              [-10660138.115523685, 4323038.691178903],
              [-10656214.99402915, 4323003.668808237],
              [-10644204.956806444, 4323005.874938473],
              [-10638973.497336615, 4310985.0095742745],
              [-10624328.861725306, 4310973.715715549],
              [-10598500.068193486, 4310905.952810487],
              [-10606376.478764566, 4295682.9861895805],
              [-10601117.523380509, 4280165.304066349],
              [-10604926.876355454, 4274957.388998478],
              [-10615467.051021725, 4276212.833285165],
              [-10641000.736583453, 4268355.678167227],
              [-10647756.04856275, 4280929.077315267],
              [-10660640.834344108, 4280880.593083614],
              [-10666629.600309806, 4280811.50686021],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Andrew',
        GEOID: '29003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10580147.269024363, 4884865.524549247],
              [-10531485.289457973, 4884287.674680359],
              [-10531422.393945675, 4871642.824679278],
              [-10531138.863202624, 4839805.919228715],
              [-10561754.804815559, 4839921.012703454],
              [-10561846.010779476, 4840764.8601517705],
              [-10567388.496906582, 4847989.163830361],
              [-10569957.082837146, 4851498.516443199],
              [-10574614.049099876, 4851212.989429962],
              [-10576525.155432932, 4872739.789133042],
              [-10582109.831647048, 4876100.216379431],
              [-10580147.269024363, 4884865.524549247],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crittenden',
        GEOID: '05035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10075134.710494144, 4188194.398665238],
              [-10074684.311834395, 4224073.153990508],
              [-10050691.62198372, 4223642.343852931],
              [-10034367.509214813, 4223377.690235055],
              [-10031278.059386829, 4219759.93841213],
              [-10028539.488593822, 4213358.326198149],
              [-10032320.009820653, 4205343.632954705],
              [-10037299.330643835, 4201259.450349576],
              [-10029657.581559349, 4197904.94152154],
              [-10029138.610093271, 4191540.7855297043],
              [-10029861.2962275, 4186255.0280029387],
              [-10028840.8304554, 4179967.516155648],
              [-10036571.74645201, 4181402.437812377],
              [-10038946.07987114, 4176309.1224938664],
              [-10040700.36372655, 4170777.423223334],
              [-10048286.787024112, 4169358.150867753],
              [-10052227.608317686, 4167794.686501573],
              [-10053184.955938509, 4163295.9912598566],
              [-10045969.115225798, 4155403.920157434],
              [-10046594.619444566, 4151293.424082404],
              [-10053421.760363726, 4146615.519122166],
              [-10053650.160090534, 4146459.055284147],
              [-10063463.752440395, 4141522.2143022786],
              [-10064170.60379944, 4141516.9221733725],
              [-10064232.636163305, 4150859.192486514],
              [-10063330.725648899, 4184043.4350891584],
              [-10074747.096027201, 4183496.5618060133],
              [-10075134.710494144, 4188194.398665238],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gallatin',
        GEOID: '17059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9837807.678694878, 4566392.00740305],
              [-9837806.676819462, 4566492.604366913],
              [-9811242.061453499, 4567582.867098437],
              [-9802735.48580424, 4560610.321064749],
              [-9803614.115985872, 4559110.557425391],
              [-9799235.47513501, 4551101.594977435],
              [-9802748.495625462, 4543128.494778684],
              [-9810847.322539147, 4536730.0376393255],
              [-9813933.210143426, 4530708.946716816],
              [-9810836.748998655, 4519525.663000829],
              [-9816116.741955336, 4522963.850947194],
              [-9837902.188942563, 4523015.415334429],
              [-9837807.678694878, 4566392.00740305],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bay',
        GEOID: '26017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9369462.981195528, 5438539.526798878],
              [-9369358.229554692, 5464962.618459492],
              [-9355892.13339241, 5464973.914794551],
              [-9355829.126560623, 5451702.102584909],
              [-9339853.260363527, 5451281.977219905],
              [-9340886.71131144, 5448932.574716056],
              [-9342975.287597705, 5431011.054015817],
              [-9345019.670046123, 5424549.409414607],
              [-9340760.47500888, 5414918.670183882],
              [-9330565.279444579, 5415098.279769395],
              [-9320892.840209043, 5407341.465415537],
              [-9317376.490362024, 5404000.157221017],
              [-9317383.938539749, 5398496.304168456],
              [-9317309.577119898, 5385160.47390447],
              [-9330541.23443457, 5385175.048001063],
              [-9330491.140663711, 5391819.080358029],
              [-9341496.519482007, 5391862.680625883],
              [-9356513.073512057, 5392082.987934895],
              [-9356403.201174643, 5398726.909380555],
              [-9369553.038663581, 5398968.889715621],
              [-9369462.981195528, 5438539.526798878],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Beaver',
        GEOID: '40007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11237197.961294752, 4438862.420601723],
              [-11227197.820512768, 4438915.271100273],
              [-11202450.494293123, 4439130.986141301],
              [-11193473.469457457, 4439209.237267111],
              [-11141910.141493931, 4439313.008220717],
              [-11132235.33899225, 4439332.478828202],
              [-11132300.848918263, 4382561.719993577],
              [-11132367.86251345, 4369599.222225938],
              [-11166571.4447149, 4369597.304436317],
              [-11192745.676663704, 4369571.981702225],
              [-11197918.568044322, 4369566.977101973],
              [-11230374.87878001, 4369596.473549302],
              [-11238164.811661048, 4369575.354725405],
              [-11237197.961294752, 4438862.420601723],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carteret',
        GEOID: '37031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8589598.481075557, 4136067.409325856],
              [-8580312.988390017, 4138270.027237823],
              [-8566528.852442542, 4137964.1536754286],
              [-8558598.785876902, 4142822.6490449333],
              [-8537427.711159363, 4146117.409215262],
              [-8532925.171715248, 4155403.7843649085],
              [-8539494.023547469, 4161403.7640331695],
              [-8494137.564940695, 4191291.613951718],
              [-8467603.228476228, 4180872.5717354426],
              [-8461744.594995268, 4172290.1718236376],
              [-8475562.015470494, 4162231.2171624247],
              [-8486228.537758814, 4151043.253579426],
              [-8494813.719527774, 4143828.596098323],
              [-8503340.124605592, 4134644.6895355647],
              [-8510425.610194584, 4125143.4314212278],
              [-8519942.536101483, 4108110.013670062],
              [-8521930.702207051, 4113476.1336568682],
              [-8529156.784312915, 4119470.5562371137],
              [-8541207.119191287, 4122738.539850921],
              [-8561165.36805663, 4120860.754270511],
              [-8584175.929797145, 4114807.5222221985],
              [-8582295.588521047, 4119293.240549638],
              [-8590078.268080875, 4134706.089385537],
              [-8589598.481075557, 4136067.409325856],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '12083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9187738.587894123, 3402998.466863969],
              [-9173086.382557439, 3403118.740829917],
              [-9173335.849536309, 3421686.3632910675],
              [-9173462.976394793, 3437527.8239396713],
              [-9151736.64005718, 3437402.372041018],
              [-9150421.95687091, 3429489.590373112],
              [-9134392.395474643, 3432004.3588462654],
              [-9134420.893264286, 3435761.1229310245],
              [-9128686.381015562, 3439659.4130537612],
              [-9110722.086869305, 3442126.7750885654],
              [-9103285.499606352, 3437834.745020057],
              [-9099413.47375809, 3422957.5578479376],
              [-9092676.529494772, 3417003.864473427],
              [-9088336.516507214, 3410919.5272497237],
              [-9088226.198891837, 3397149.2328875926],
              [-9090204.680201707, 3370599.809493332],
              [-9101665.689695818, 3370674.4930180837],
              [-9123098.699175192, 3370562.6587324245],
              [-9162896.196370224, 3370605.662020015],
              [-9162917.124434492, 3370814.5734798936],
              [-9162894.971855825, 3371031.376695771],
              [-9162937.384581817, 3371179.3494843026],
              [-9162958.201326596, 3371401.3754026247],
              [-9163015.642183846, 3371471.482931463],
              [-9163057.832270855, 3371711.836258147],
              [-9163085.439504571, 3371761.587018273],
              [-9163280.916530406, 3371855.3632587604],
              [-9163332.791413115, 3371939.724273654],
              [-9163344.70259863, 3372057.9323968077],
              [-9163313.644460697, 3372178.686462227],
              [-9163356.947742617, 3372244.4718089513],
              [-9163564.113314983, 3372263.9402627875],
              [-9163700.479691206, 3372381.133328379],
              [-9163739.330193492, 3372388.7680919697],
              [-9163756.250756092, 3372264.1947525707],
              [-9163850.983642757, 3372228.566230777],
              [-9163938.48076252, 3372272.7201631516],
              [-9163963.416328458, 3372340.669155257],
              [-9163902.301928014, 3372438.6486563766],
              [-9163963.082369985, 3372509.0162024973],
              [-9164065.607621005, 3372475.1684751436],
              [-9164172.585651658, 3372507.1074937526],
              [-9164180.934613468, 3372602.670518129],
              [-9164369.28719189, 3372681.5646162126],
              [-9164480.05008523, 3372768.857669224],
              [-9164635.89737234, 3372949.171828525],
              [-9164780.056112919, 3372935.174169519],
              [-9164897.386856215, 3372967.114304107],
              [-9164944.252361838, 3373104.0378309437],
              [-9165083.847003294, 3373154.684626408],
              [-9165148.523627445, 3373260.1782003846],
              [-9165167.002662916, 3373351.4200070966],
              [-9165292.571048532, 3373402.067754359],
              [-9165372.721081901, 3373294.5369654964],
              [-9165454.095629672, 3373438.590245803],
              [-9165527.566493595, 3373498.273559682],
              [-9165730.39060582, 3373548.5401000716],
              [-9165808.202929884, 3373706.5946246334],
              [-9165898.81699539, 3373799.2393828286],
              [-9166035.851288557, 3373869.359681454],
              [-9166198.711703587, 3374090.2856058343],
              [-9166256.931797272, 3374099.0667243893],
              [-9166369.809760937, 3374022.58210588],
              [-9166693.526840163, 3374004.7654532497],
              [-9166792.935145441, 3374087.613092655],
              [-9166975.165151872, 3374104.793543994],
              [-9167081.363946088, 3374168.806830518],
              [-9167191.792880954, 3374308.669945434],
              [-9167426.565687036, 3374531.384979857],
              [-9167746.720542558, 3374544.493467906],
              [-9167865.387119744, 3374590.0551104564],
              [-9168007.096831525, 3374773.4486804875],
              [-9168129.770910379, 3374798.5207273117],
              [-9168379.460528228, 3374803.484234632],
              [-9168448.58993201, 3374837.7197591932],
              [-9168509.147735002, 3374924.0089486176],
              [-9168504.138357917, 3375095.0617578505],
              [-9168627.257714733, 3375196.1163225034],
              [-9168634.716120617, 3375259.498548788],
              [-9168498.68370287, 3375320.844689101],
              [-9168474.193414891, 3375367.172669278],
              [-9168477.087721653, 3375431.573923714],
              [-9168580.837487074, 3375509.7213237914],
              [-9181368.77531144, 3382327.7695192588],
              [-9187819.962441893, 3381356.310998398],
              [-9187738.587894123, 3402998.466863969],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scott',
        GEOID: '21209',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9433279.773599533, 4629330.553668148],
              [-9429427.45130114, 4631841.55291724],
              [-9415462.532500615, 4646467.576481101],
              [-9412883.92781588, 4649294.38852329],
              [-9403632.164936053, 4636111.532719397],
              [-9399039.345384903, 4621759.246476936],
              [-9400114.023749022, 4619515.190485867],
              [-9397582.28456991, 4609735.812708006],
              [-9395570.630051784, 4608835.325270666],
              [-9418690.129816676, 4598308.599166232],
              [-9420420.702620547, 4595881.87942567],
              [-9422952.33048017, 4604404.4460144015],
              [-9431562.559134556, 4607069.855734845],
              [-9432210.549890464, 4610032.356070587],
              [-9433279.773599533, 4629330.553668148],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mason',
        GEOID: '53045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13748615.790396309, 6041327.125273131],
              [-13686800.522436768, 6041606.649086277],
              [-13696572.481297074, 6027407.122567139],
              [-13670146.124738676, 6027435.144942172],
              [-13670166.941483457, 6008198.874728153],
              [-13675924.162908303, 5984036.12913256],
              [-13672323.979256557, 5973833.539991064],
              [-13681434.47770257, 5967800.5983745195],
              [-13685204.423577774, 5973053.291294681],
              [-13686402.555257183, 5972428.225495331],
              [-13687045.202677533, 5969883.544601782],
              [-13688860.155655425, 5968479.031978004],
              [-13692568.43053273, 5966805.472609821],
              [-13693461.324168384, 5965499.982613392],
              [-13694010.463216465, 5962303.537621529],
              [-13696094.364084115, 5960871.948914747],
              [-13699041.436283378, 5960705.755263794],
              [-13700496.493347537, 5959432.7451609485],
              [-13700641.542644043, 5956914.751796166],
              [-13703761.494012503, 5956003.26660597],
              [-13714771.770888396, 5955968.93449906],
              [-13746726.253359584, 5955574.451953889],
              [-13748516.04813256, 5984376.137572309],
              [-13748615.790396309, 6026991.742715248],
              [-13748615.790396309, 6041327.125273131],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tunica',
        GEOID: '28143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10082572.345564974, 4114209.1961626527],
              [-10079997.479810467, 4118238.2025118265],
              [-10079540.513300762, 4123467.8065940565],
              [-10075025.506073676, 4131932.724779027],
              [-10071466.955911485, 4135221.5632353188],
              [-10070383.594627086, 4141470.406209869],
              [-10064170.60379944, 4141516.9221733725],
              [-10063463.752440395, 4141522.2143022786],
              [-10053650.160090534, 4146459.055284147],
              [-10053421.760363726, 4146615.519122166],
              [-10041254.734790701, 4144922.680008761],
              [-10041040.222131943, 4126493.4301682687],
              [-10044491.460305007, 4123503.8243398773],
              [-10045467.620919773, 4113203.539209554],
              [-10040865.673170378, 4103492.941821365],
              [-10040855.097818753, 4097636.860356488],
              [-10052630.584874358, 4097438.6795634134],
              [-10052356.07101006, 4085951.6389058335],
              [-10063226.085327553, 4085851.908521782],
              [-10082133.589519298, 4099498.4711289247],
              [-10079895.733795883, 4105341.597824279],
              [-10084123.64805621, 4111782.5026560314],
              [-10082572.345564974, 4114209.1961626527],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fallon',
        GEOID: '30025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11678081.165325265, 5857969.961244209],
              [-11658787.716458939, 5857962.03963953],
              [-11658830.797101878, 5879083.59209386],
              [-11658806.752091866, 5886146.984258287],
              [-11644787.17542136, 5890796.437682377],
              [-11623758.367013058, 5890791.245012361],
              [-11616727.094016083, 5883738.057479915],
              [-11582279.289132712, 5883752.98399786],
              [-11582250.380533405, 5867461.439160097],
              [-11582241.428963235, 5862422.87058707],
              [-11582288.62842733, 5832511.194922607],
              [-11582288.289896745, 5825363.803363236],
              [-11582285.734120572, 5771589.436616487],
              [-11582139.922965381, 5761455.962943588],
              [-11592235.804166146, 5761448.245957222],
              [-11592237.585277999, 5775356.092580981],
              [-11620739.159783764, 5775601.1415414335],
              [-11620724.465610977, 5789139.482352984],
              [-11634676.582670063, 5789142.369728473],
              [-11634681.92600562, 5802201.651534409],
              [-11675799.895000443, 5802265.749756161],
              [-11678081.165325265, 5857969.961244209],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bay',
        GEOID: '12005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9572667.583440404, 3553692.1053463724],
              [-9557167.902820313, 3560314.4931646003],
              [-9516477.066711664, 3559802.1642680783],
              [-9516297.842331488, 3576716.8176809675],
              [-9510556.428274333, 3576715.007671094],
              [-9504897.613279348, 3576623.990368559],
              [-9505535.585281085, 3529409.2951422096],
              [-9505486.719723998, 3493799.2413151953],
              [-9509573.922448594, 3497110.038121057],
              [-9516454.357535543, 3498566.9088544794],
              [-9525821.113449361, 3506948.911919032],
              [-9529079.54626437, 3510794.140067266],
              [-9539725.251807915, 3516010.239243672],
              [-9552461.20343008, 3526491.8719999287],
              [-9573042.35096752, 3538161.6497334344],
              [-9572667.583440404, 3553692.1053463724],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '54035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9116895.977148192, 4711592.816917779],
              [-9108979.380240938, 4713924.885499082],
              [-9103233.068126189, 4718912.68859975],
              [-9105188.951579425, 4727453.442994623],
              [-9106808.761489958, 4733707.849138964],
              [-9100398.077224452, 4736584.122319668],
              [-9097104.150921583, 4733743.702149567],
              [-9081605.138218435, 4725422.183738116],
              [-9076121.428782469, 4722452.268386091],
              [-9072831.0472736, 4709921.413336892],
              [-9075578.634945361, 4707595.842827658],
              [-9077729.438826976, 4674851.877337482],
              [-9075006.00748472, 4666351.5905880425],
              [-9087325.735530812, 4658038.437698822],
              [-9094395.859030074, 4668300.839297208],
              [-9099241.485144813, 4675270.226051235],
              [-9102911.243478306, 4676057.635068779],
              [-9104961.971137699, 4683512.797867418],
              [-9118246.95048846, 4703920.879077091],
              [-9116895.977148192, 4711592.816917779],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Citrus',
        GEOID: '12017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9212308.336689172, 3375764.418664997],
              [-9207462.063953383, 3379571.0978602697],
              [-9196398.465041403, 3376826.078407042],
              [-9187819.962441893, 3381356.310998398],
              [-9181368.77531144, 3382327.7695192588],
              [-9168580.837487074, 3375509.7213237914],
              [-9168477.087721653, 3375431.573923714],
              [-9168474.193414891, 3375367.172669278],
              [-9168498.68370287, 3375320.844689101],
              [-9168634.716120617, 3375259.498548788],
              [-9168627.257714733, 3375196.1163225034],
              [-9168504.138357917, 3375095.0617578505],
              [-9168509.147735002, 3374924.0089486176],
              [-9168448.58993201, 3374837.7197591932],
              [-9168379.460528228, 3374803.484234632],
              [-9168129.770910379, 3374798.5207273117],
              [-9168007.096831525, 3374773.4486804875],
              [-9167865.387119744, 3374590.0551104564],
              [-9167746.720542558, 3374544.493467906],
              [-9167426.565687036, 3374531.384979857],
              [-9167191.792880954, 3374308.669945434],
              [-9167081.363946088, 3374168.806830518],
              [-9166975.165151872, 3374104.793543994],
              [-9166792.935145441, 3374087.613092655],
              [-9166693.526840163, 3374004.7654532497],
              [-9166369.809760937, 3374022.58210588],
              [-9166256.931797272, 3374099.0667243893],
              [-9166198.711703587, 3374090.2856058343],
              [-9166035.851288557, 3373869.359681454],
              [-9165898.81699539, 3373799.2393828286],
              [-9165808.202929884, 3373706.5946246334],
              [-9165730.39060582, 3373548.5401000716],
              [-9165527.566493595, 3373498.273559682],
              [-9165454.095629672, 3373438.590245803],
              [-9165372.721081901, 3373294.5369654964],
              [-9165292.571048532, 3373402.067754359],
              [-9165167.002662916, 3373351.4200070966],
              [-9165148.523627445, 3373260.1782003846],
              [-9165083.847003294, 3373154.684626408],
              [-9164944.252361838, 3373104.0378309437],
              [-9164897.386856215, 3372967.114304107],
              [-9164780.056112919, 3372935.174169519],
              [-9164635.89737234, 3372949.171828525],
              [-9164480.05008523, 3372768.857669224],
              [-9164369.28719189, 3372681.5646162126],
              [-9164180.934613468, 3372602.670518129],
              [-9164172.585651658, 3372507.1074937526],
              [-9164065.607621005, 3372475.1684751436],
              [-9163963.082369985, 3372509.0162024973],
              [-9163902.301928014, 3372438.6486563766],
              [-9163963.416328458, 3372340.669155257],
              [-9163938.48076252, 3372272.7201631516],
              [-9163850.983642757, 3372228.566230777],
              [-9163756.250756092, 3372264.1947525707],
              [-9163739.330193492, 3372388.7680919697],
              [-9163700.479691206, 3372381.133328379],
              [-9163564.113314983, 3372263.9402627875],
              [-9163356.947742617, 3372244.4718089513],
              [-9163313.644460697, 3372178.686462227],
              [-9163344.70259863, 3372057.9323968077],
              [-9163332.791413115, 3371939.724273654],
              [-9163280.916530406, 3371855.3632587604],
              [-9163085.439504571, 3371761.587018273],
              [-9163057.832270855, 3371711.836258147],
              [-9163015.642183846, 3371471.482931463],
              [-9162958.201326596, 3371401.3754026247],
              [-9162937.384581817, 3371179.3494843026],
              [-9162894.971855825, 3371031.376695771],
              [-9162917.124434492, 3370814.5734798936],
              [-9162896.196370224, 3370605.662020015],
              [-9147026.935040697, 3349320.0188444587],
              [-9157481.059740586, 3333410.9206544864],
              [-9174694.61524093, 3333190.5462063234],
              [-9174769.08798027, 3336865.4536380996],
              [-9202638.857822848, 3336794.928863727],
              [-9202640.037570693, 3336966.850927994],
              [-9207499.24466331, 3340173.257401396],
              [-9207582.511642424, 3350251.01035542],
              [-9209488.746602766, 3356587.9130699886],
              [-9204882.23475425, 3363637.652360439],
              [-9208778.082973544, 3369729.72037848],
              [-9212308.336689172, 3375764.418664997],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '49055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12450947.120378556, 4639629.738298507],
              [-12441777.956560895, 4650620.889771327],
              [-12440211.913964417, 4651742.134880339],
              [-12390489.950206693, 4651748.394395676],
              [-12389967.41651691, 4650298.707422708],
              [-12340890.994486295, 4650298.991905965],
              [-12247971.724965224, 4650299.134147595],
              [-12250102.602657989, 4643565.209801193],
              [-12246827.80587783, 4631060.943643786],
              [-12237571.256259898, 4619659.41828134],
              [-12232594.495785004, 4606331.62974641],
              [-12237128.427325523, 4600904.202816223],
              [-12321665.673148332, 4600833.564546748],
              [-12427172.95068831, 4600649.82237379],
              [-12450329.742482617, 4600818.700844173],
              [-12450947.120378556, 4639629.738298507],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wheeler',
        GEOID: '41069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13413459.854254026, 5632277.029794261],
              [-13335039.614450304, 5632205.156511344],
              [-13335091.155374542, 5620695.8060788335],
              [-13321851.483056538, 5620752.790533749],
              [-13319647.691097302, 5593746.293737775],
              [-13319991.22304589, 5513081.7081722],
              [-13347095.849261688, 5513015.595596326],
              [-13347127.1300386, 5525929.077306702],
              [-13360644.099208174, 5525946.5245434595],
              [-13360745.733903268, 5533599.422262642],
              [-13401316.456281353, 5533176.916195037],
              [-13401370.668873368, 5553142.802094401],
              [-13403387.221449088, 5589261.88102442],
              [-13399687.518172575, 5593506.169151992],
              [-13409011.97267989, 5600388.814234888],
              [-13413459.854254026, 5632277.029794261],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Perry',
        GEOID: '01105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9743260.472940445, 3849694.2807555296],
              [-9737551.675494093, 3849714.64260842],
              [-9737357.868260624, 3872843.1219554297],
              [-9731683.468536926, 3878658.8209162788],
              [-9720359.270697, 3878740.468960191],
              [-9720327.09936416, 3872962.6190886237],
              [-9686928.246499926, 3873692.876281815],
              [-9686772.95581027, 3859458.6421172367],
              [-9697131.791026039, 3827797.1446554307],
              [-9731900.875502447, 3826875.595132747],
              [-9731744.026339918, 3803821.966940539],
              [-9737458.723719282, 3803757.824339029],
              [-9743159.394842805, 3803715.5457286024],
              [-9743181.102143511, 3826751.944279984],
              [-9743260.472940445, 3849694.2807555296],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'White',
        GEOID: '13311',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9334863.54762309, 4126191.8061767714],
              [-9331408.079309376, 4133884.7418234986],
              [-9326385.455204275, 4135773.25366671],
              [-9317924.394667549, 4135559.4873372284],
              [-9315392.655488439, 4136854.6187948356],
              [-9308902.72917519, 4127546.6722291666],
              [-9313302.409409814, 4117745.028268773],
              [-9308173.475191003, 4101731.080811616],
              [-9313702.714298705, 4096625.5939317965],
              [-9327304.731559245, 4098043.2297038157],
              [-9333405.150974207, 4096881.1712583206],
              [-9337048.415268889, 4112473.9926922033],
              [-9334863.54762309, 4126191.8061767714],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Antelope',
        GEOID: '31003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10942732.105059128, 5226653.25029029],
              [-10890879.040969659, 5226769.544925032],
              [-10890890.729516191, 5174433.054158742],
              [-10890751.802791681, 5148447.729731428],
              [-10942216.361858284, 5148248.466604572],
              [-10942196.213030448, 5171545.1093951315],
              [-10942771.84611734, 5174298.498914214],
              [-10942732.105059128, 5226653.25029029],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Charles Mix',
        GEOID: '46023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11053802.574151495, 5388338.47608329],
              [-11053789.661090566, 5388367.173902961],
              [-10997763.229291255, 5388264.5067119],
              [-10987877.39059187, 5388284.763825435],
              [-10987996.836405488, 5368471.753705076],
              [-10921498.691426747, 5341980.751124665],
              [-10917893.721036896, 5337628.587580832],
              [-10921503.36684536, 5325296.230905583],
              [-10922339.71017969, 5292112.148549243],
              [-10926295.966459248, 5287824.941001175],
              [-10935127.536684567, 5290859.766156212],
              [-10940480.334399361, 5292964.277319572],
              [-10943617.297217367, 5294710.275547218],
              [-10952328.958360417, 5299560.795060469],
              [-10957678.750448959, 5301205.671346344],
              [-10962623.116952034, 5306423.756598287],
              [-10964808.429875797, 5311752.66683059],
              [-10967738.470192965, 5317962.780499849],
              [-10986171.753353935, 5323631.719752777],
              [-10995405.259837272, 5334208.646228802],
              [-11006020.241201354, 5336663.869557086],
              [-11009139.524652874, 5349629.747072567],
              [-11018542.682040181, 5351469.33959702],
              [-11028342.359453695, 5360911.915294681],
              [-11037649.114161976, 5377178.998928088],
              [-11055146.757002825, 5383469.727402238],
              [-11053802.574151495, 5388338.47608329],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '17189',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9985830.875395056, 4638329.094911584],
              [-9971159.189147484, 4647859.980483784],
              [-9961077.31682481, 4645834.999519604],
              [-9946561.589183839, 4652985.008221094],
              [-9923453.332687518, 4650741.088430146],
              [-9923507.879238008, 4646586.87329672],
              [-9923865.103483962, 4609544.544638596],
              [-9973424.540785126, 4610447.927843315],
              [-9985720.78041866, 4610466.77278374],
              [-9985830.875395056, 4638329.094911584],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Androscoggin',
        GEOID: '23001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7846381.915797605, 5474784.690475995],
              [-7835972.096255053, 5489237.091317652],
              [-7828567.457685957, 5497749.251586786],
              [-7821888.844835814, 5521776.649811614],
              [-7822911.759636713, 5533886.145105703],
              [-7818959.027157624, 5536741.39294947],
              [-7814770.297358056, 5539710.490163216],
              [-7806767.9844428925, 5541152.335026416],
              [-7803550.962478456, 5525037.91062602],
              [-7807124.763410883, 5523095.434821806],
              [-7803516.676075293, 5517356.863596112],
              [-7800630.940915458, 5510454.529495321],
              [-7799098.962083162, 5495167.92841126],
              [-7791673.284130306, 5493432.18692686],
              [-7795294.173207339, 5486177.3365549445],
              [-7792973.38446328, 5484732.049441457],
              [-7796067.287070897, 5465650.172773835],
              [-7798133.376820019, 5464046.733094832],
              [-7796175.712254929, 5461676.439244827],
              [-7801363.311845387, 5454068.4338102555],
              [-7805261.8317324575, 5451016.672614983],
              [-7817883.680876562, 5461429.404456399],
              [-7827471.628618587, 5471294.768948861],
              [-7832870.623922061, 5463344.755417274],
              [-7845806.394030202, 5470407.670393786],
              [-7846381.915797605, 5474784.690475995],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Denton',
        GEOID: '48121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10841702.43139733, 3919687.1222205097],
              [-10840636.547272986, 3952579.3738446413],
              [-10791741.1307344, 3950706.760403741],
              [-10781703.452249574, 3950333.741031837],
              [-10779523.81661984, 3949251.5593880797],
              [-10779934.028943414, 3930243.10487511],
              [-10780385.31815909, 3906785.1819879264],
              [-10780622.428674478, 3893652.0815552683],
              [-10793389.215795597, 3893845.713692942],
              [-10795771.898176536, 3893870.92990255],
              [-10796901.234410632, 3893882.078138838],
              [-10801584.779346777, 3893886.9886748544],
              [-10818129.082068475, 3893951.887573969],
              [-10837625.689005502, 3894002.8513786886],
              [-10842349.19763884, 3894088.056984945],
              [-10841702.43139733, 3919687.1222205097],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lyon',
        GEOID: '21143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9819405.564991333, 4439103.441960619],
              [-9821846.133507485, 4450483.398022085],
              [-9817657.626346897, 4459652.299033168],
              [-9816618.904178305, 4456710.532701527],
              [-9806777.481955744, 4464182.101472384],
              [-9800806.415789085, 4463493.593761188],
              [-9782422.447162537, 4433548.929122923],
              [-9796415.418474743, 4426592.750837229],
              [-9813630.977725923, 4420609.944244914],
              [-9817197.876849921, 4430126.952509345],
              [-9822873.167129545, 4436585.713764815],
              [-9819405.564991333, 4439103.441960619],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marshall',
        GEOID: '21157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9850005.28925957, 4431038.786731681],
              [-9850133.417993473, 4439261.368676118],
              [-9849877.717123121, 4442252.663570142],
              [-9833885.002478305, 4447642.946572255],
              [-9822873.167129545, 4436585.713764815],
              [-9817197.876849921, 4430126.952509345],
              [-9813630.977725923, 4420609.944244914],
              [-9810580.489719715, 4412315.023979148],
              [-9808452.840292182, 4403921.116227273],
              [-9850182.732527895, 4404362.633661937],
              [-9850005.28925957, 4431038.786731681],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Salt Lake',
        GEOID: '49035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12496750.081462903, 4978342.362297122],
              [-12468513.892623188, 5000820.792181497],
              [-12463182.356931137, 5000817.256376895],
              [-12461803.887676643, 4986091.1591506675],
              [-12438700.083959952, 4991860.469584326],
              [-12430379.174662137, 4990270.360737058],
              [-12427825.060265375, 4982728.2343179565],
              [-12428724.187792514, 4978981.772458749],
              [-12423947.691081556, 4970079.803400417],
              [-12423746.20280322, 4963277.620805529],
              [-12418052.767446596, 4954885.094265393],
              [-12422580.799054105, 4950157.727323957],
              [-12423942.013787525, 4948334.209519642],
              [-12458133.016148243, 4931921.246644561],
              [-12458172.08928951, 4931909.104471456],
              [-12465756.397516748, 4926329.534056323],
              [-12487025.878664147, 4934048.845447753],
              [-12487301.39440386, 4954103.272867205],
              [-12489645.337602004, 4957822.173941187],
              [-12490249.023200575, 4969132.296897161],
              [-12496750.081462903, 4978342.362297122],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Muhlenberg',
        GEOID: '21177',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9727879.68153652, 4477312.863463446],
              [-9717742.372107431, 4493862.936507376],
              [-9708279.436153566, 4492337.363351448],
              [-9695905.718154442, 4497257.427798002],
              [-9700044.576822136, 4485978.267809285],
              [-9692736.118293084, 4490848.0101907905],
              [-9683232.43940559, 4483324.343751824],
              [-9682866.532239353, 4476756.946954291],
              [-9673582.264068212, 4468741.944309288],
              [-9676365.807935499, 4459284.585809175],
              [-9673003.291396596, 4451428.663562533],
              [-9678271.374978898, 4448726.215602904],
              [-9682168.447712589, 4449368.975096796],
              [-9690713.888423333, 4447615.465207164],
              [-9712654.069502762, 4444761.418734775],
              [-9713668.746661343, 4449203.363479077],
              [-9722007.244438704, 4457496.47817839],
              [-9721235.355089543, 4458641.5024900045],
              [-9721947.577191638, 4461039.19444881],
              [-9727879.68153652, 4477312.863463446],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sumner',
        GEOID: '47165',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9650653.120632578, 4356801.382867991],
              [-9636045.293018544, 4389149.1093898],
              [-9634845.752939932, 4388765.977279265],
              [-9630001.017381117, 4390772.192071108],
              [-9619283.755553836, 4390188.800198285],
              [-9596359.629386678, 4388941.037171354],
              [-9597579.66096554, 4370606.4642442735],
              [-9598905.364781396, 4367905.751825223],
              [-9603397.551512871, 4363119.588081537],
              [-9605008.121905666, 4348542.790706995],
              [-9606699.732887762, 4343863.187576],
              [-9623761.559922155, 4346902.224631172],
              [-9631545.130037911, 4338955.147104481],
              [-9635018.298150662, 4344613.644276443],
              [-9639631.823127098, 4334400.065641651],
              [-9644619.938190054, 4335780.441182381],
              [-9657499.603274835, 4356561.406942498],
              [-9650653.120632578, 4356801.382867991],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Panola',
        GEOID: '48365',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10528653.09897321, 3789771.7703733966],
              [-10523110.946804576, 3799047.2487742],
              [-10518781.063890683, 3815159.15706703],
              [-10506983.5355759, 3811608.4378152755],
              [-10503027.68615107, 3806260.563505446],
              [-10468795.298855547, 3814914.76232841],
              [-10468789.818284728, 3811128.5780781074],
              [-10468785.023057412, 3789066.914754741],
              [-10468783.361754265, 3781433.149977378],
              [-10468688.96282607, 3762313.312893395],
              [-10467308.089804841, 3760644.520789534],
              [-10520964.37306361, 3759896.107133915],
              [-10530821.380014881, 3759792.3059805627],
              [-10528653.09897321, 3789771.7703733966],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bracken',
        GEOID: '21023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9374537.59150283, 4693878.856442565],
              [-9365875.154007262, 4691561.807923035],
              [-9356697.77183, 4689009.932207949],
              [-9356585.987778526, 4688978.853319833],
              [-9348478.811903033, 4691221.765227104],
              [-9342872.762346685, 4689433.764510042],
              [-9340192.309913017, 4688391.593199672],
              [-9349902.69950977, 4663638.705865874],
              [-9360159.788710952, 4665760.093279574],
              [-9368874.435047705, 4658003.562208852],
              [-9374840.49183728, 4658124.701666215],
              [-9373696.238791415, 4661977.855490802],
              [-9372769.392711071, 4663682.431090128],
              [-9376013.535884261, 4697317.856515456],
              [-9374537.59150283, 4693878.856442565],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '46083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10789623.945339004, 5388390.3470735485],
              [-10753343.476136098, 5388459.406534906],
              [-10751748.824430482, 5383726.648233098],
              [-10752823.168836128, 5378289.5749818245],
              [-10744732.245606292, 5370855.617465594],
              [-10745034.700662777, 5364971.577001515],
              [-10745714.083515089, 5357752.158790209],
              [-10751105.397773698, 5356384.956822243],
              [-10748901.755284224, 5351256.975508796],
              [-10748226.675741782, 5349686.598426237],
              [-10744789.241185578, 5345664.915915544],
              [-10739611.437710311, 5345679.275431773],
              [-10737750.50978272, 5333817.609733352],
              [-10735577.664641926, 5329327.128781474],
              [-10736998.381430265, 5324545.697202744],
              [-10776359.226135569, 5324715.957865402],
              [-10789546.13301494, 5324725.560199105],
              [-10789623.945339004, 5388390.3470735485],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '50023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8120998.082705857, 5490433.254958671],
              [-8117647.699991451, 5499897.752323557],
              [-8114743.374476653, 5508297.793550101],
              [-8116459.698385703, 5509150.630785764],
              [-8110247.402882495, 5522187.416336928],
              [-8106965.7042939095, 5521196.967949031],
              [-8108415.084064037, 5528075.961246652],
              [-8104614.970606827, 5535608.231162434],
              [-8100258.0370566705, 5534192.2110406365],
              [-8087850.589251833, 5527276.507283431],
              [-8081439.588457557, 5539915.807658066],
              [-8069874.272600573, 5531142.1457116315],
              [-8063351.061759577, 5544098.989813253],
              [-8050767.729159286, 5537307.5588029325],
              [-8039904.282691753, 5531382.6530082105],
              [-8039542.828305147, 5530856.444385713],
              [-8039171.24384488, 5529280.805851296],
              [-8045042.901706261, 5518244.945462997],
              [-8050360.745100947, 5511734.5061602285],
              [-8056008.205507872, 5497074.9690123405],
              [-8064321.433760823, 5485375.64629408],
              [-8080607.586583369, 5490279.788463874],
              [-8081950.322281317, 5486336.3181007225],
              [-8085013.278070494, 5479169.534814695],
              [-8091120.487974394, 5467444.586969772],
              [-8097636.129090015, 5470032.510336475],
              [-8112889.2370380005, 5476100.744769119],
              [-8116194.869317109, 5476682.068671946],
              [-8118895.702802733, 5489304.58374388],
              [-8120998.082705857, 5490433.254958671],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Walworth',
        GEOID: '55127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9882618.894435747, 5288058.838041524],
              [-9873829.552720673, 5288049.728721723],
              [-9856398.59025481, 5288104.688418848],
              [-9830221.700675279, 5287967.897062209],
              [-9830166.82016632, 5252920.594976369],
              [-9830033.348096859, 5235510.697209638],
              [-9852544.375525074, 5235401.213681566],
              [-9874860.37120542, 5235205.552221236],
              [-9882554.302496253, 5235288.526749279],
              [-9882625.684924686, 5286813.06885921],
              [-9882618.894435747, 5288058.838041524],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Moca',
        GEOID: '72099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7473123.433027107, 2083176.8240253225],
              [-7472339.855131414, 2085468.604631583],
              [-7464696.213615584, 2091573.6245310723],
              [-7461430.767672654, 2083644.3097445085],
              [-7463982.210401637, 2078442.863978052],
              [-7464259.395933712, 2073473.3901828206],
              [-7471368.703893733, 2075437.017688495],
              [-7472896.007307417, 2074795.1183110126],
              [-7472480.451648287, 2081043.302449945],
              [-7473123.433027107, 2083176.8240253225],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Peñuelas',
        GEOID: '72111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7433398.950518512, 2035726.3519054037],
              [-7428683.022510072, 2039596.2882592925],
              [-7432260.385666204, 2042111.5898286884],
              [-7432696.535431132, 2053354.132055439],
              [-7430533.486405527, 2050857.0142061326],
              [-7424349.911330943, 2052832.990691765],
              [-7422431.319907121, 2048158.889653412],
              [-7424679.9120568475, 2035438.7139044486],
              [-7426897.680516728, 2036418.3578890203],
              [-7430158.339721554, 2036418.9430981888],
              [-7431518.5525795575, 2036984.4969914714],
              [-7433398.950518512, 2035726.3519054037],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Randolph',
        GEOID: '18135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9486508.746595208, 4910612.571753738],
              [-9440440.210888702, 4911107.427164154],
              [-9440861.966756444, 4881534.870356867],
              [-9441023.96316241, 4866678.7084928835],
              [-9484584.589196846, 4866599.280653249],
              [-9485928.215450723, 4868209.924064656],
              [-9486022.05778146, 4877121.878334475],
              [-9486508.746595208, 4910612.571753738],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Leavenworth',
        GEOID: '20103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10596179.836046882, 4727991.779228659],
              [-10595403.048640126, 4740150.667749038],
              [-10595488.319370076, 4781900.095184982],
              [-10575112.511094766, 4781848.219660077],
              [-10571538.645444915, 4782255.124729736],
              [-10569414.066361057, 4779090.412514819],
              [-10562992.044937193, 4778040.999256026],
              [-10565117.467974909, 4768140.133069761],
              [-10559440.953180889, 4760970.898928965],
              [-10555944.519294562, 4756356.564296632],
              [-10553050.212533936, 4751224.993868327],
              [-10552196.578359805, 4750541.5155976815],
              [-10564240.938304402, 4750778.650103628],
              [-10565195.391618464, 4720439.914450018],
              [-10566818.875072194, 4722048.734255922],
              [-10581614.237274038, 4719110.739509456],
              [-10596078.090032298, 4716593.790236916],
              [-10596179.836046882, 4727991.779228659],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wright',
        GEOID: '19197',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10460883.351451136, 5258048.043327162],
              [-10460830.36337352, 5297942.804440279],
              [-10408218.43431531, 5298056.791810463],
              [-10408315.05963332, 5244889.7729123235],
              [-10460868.768597843, 5244956.117812535],
              [-10460883.351451136, 5258048.043327162],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grayson',
        GEOID: '48181',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10791825.387162393, 4021421.036678539],
              [-10790681.736885134, 4021498.2865672633],
              [-10787443.419153346, 4021717.027322872],
              [-10786546.295377044, 4015778.551163653],
              [-10781358.695786586, 4008304.60088133],
              [-10775089.51602358, 4011210.177234053],
              [-10773140.31173979, 4007602.9493768816],
              [-10765977.570424186, 4006216.794631999],
              [-10762602.474782826, 4012250.4657314764],
              [-10760130.402850779, 4017617.787224299],
              [-10752869.957239324, 4013105.0850771703],
              [-10752362.083505262, 4012789.484723662],
              [-10752675.336552354, 4006120.709487205],
              [-10750450.171250887, 4004537.095811628],
              [-10744987.2785597, 4004405.2495417004],
              [-10742585.337906852, 3998423.6502442327],
              [-10735257.06450844, 3999306.21345302],
              [-10731589.309925783, 3994785.5012547066],
              [-10728934.765973404, 3990668.4376900806],
              [-10729484.814952338, 3948228.5472825724],
              [-10779523.81661984, 3949251.5593880797],
              [-10781703.452249574, 3950333.741031837],
              [-10791741.1307344, 3950706.760403741],
              [-10791825.387162393, 4021421.036678539],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Louis',
        GEOID: '29189',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10100276.551448278, 4670135.590028786],
              [-10092281.696938993, 4677156.858131694],
              [-10078726.767823061, 4676952.206569772],
              [-10073539.947469039, 4686180.154382381],
              [-10072443.450484727, 4687972.438079777],
              [-10067803.43146948, 4697013.896269709],
              [-10061308.050501185, 4696198.290055978],
              [-10054400.119500007, 4706091.429753622],
              [-10040536.946714068, 4696100.987513523],
              [-10031857.254697425, 4693884.713293136],
              [-10037278.73653804, 4689157.61700126],
              [-10037299.401890047, 4689129.2229658505],
              [-10046778.296604374, 4681484.167468419],
              [-10054177.369198931, 4664538.315233093],
              [-10053661.959956557, 4661512.062594679],
              [-10047173.468292104, 4654694.87589059],
              [-10047819.399457773, 4652899.928872969],
              [-10048956.707719706, 4649740.2820166005],
              [-10050904.910128081, 4641551.025081235],
              [-10056629.991579266, 4634254.550463483],
              [-10063867.730872484, 4650465.842696531],
              [-10075807.85945497, 4650508.658213871],
              [-10092303.29292021, 4647342.926038415],
              [-10094315.058757825, 4642606.180567505],
              [-10100719.936980108, 4645558.17939745],
              [-10100276.551448278, 4670135.590028786],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crawford',
        GEOID: '13079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9364677.80156429, 3868911.1244208748],
              [-9364671.456353314, 3875352.8167311223],
              [-9349453.970642382, 3875281.1302345446],
              [-9346114.942516038, 3875246.148442944],
              [-9338806.038709024, 3875192.350890771],
              [-9329710.011796815, 3859466.449535953],
              [-9317569.619450392, 3854515.4659101446],
              [-9317562.71764196, 3854439.9378823815],
              [-9324856.48199823, 3854575.3860376417],
              [-9351211.594082518, 3833074.5683003473],
              [-9357820.854889894, 3839480.6201973935],
              [-9362628.632377766, 3853573.714884638],
              [-9373393.672415437, 3854230.948659461],
              [-9364677.80156429, 3868911.1244208748],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morrow',
        GEOID: '41049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13358283.809128199, 5750222.7815631805],
              [-13354525.534716215, 5752248.121854664],
              [-13343661.853296764, 5754462.710604457],
              [-13336370.550282229, 5755949.37044799],
              [-13321589.770933682, 5757441.649924815],
              [-13313872.213275963, 5767471.371271772],
              [-13310647.844225137, 5768411.528447272],
              [-13301324.280273749, 5765347.542629541],
              [-13295124.848719092, 5766451.816405575],
              [-13295403.307877943, 5716953.954487211],
              [-13274687.52987775, 5716786.887580008],
              [-13274650.460487315, 5703136.312127012],
              [-13263176.760571254, 5703109.781392619],
              [-13263319.24951947, 5634588.156059779],
              [-13265160.69653617, 5620929.727986209],
              [-13318680.77000027, 5620670.777108821],
              [-13321851.483056538, 5620752.790533749],
              [-13335091.155374542, 5620695.8060788335],
              [-13335039.614450304, 5632205.156511344],
              [-13331595.389405161, 5648199.747545992],
              [-13345416.2607846, 5648190.431655212],
              [-13345241.711823039, 5662058.74146391],
              [-13359068.594454976, 5662183.673111989],
              [-13358283.809128199, 5750222.7815631805],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Blair',
        GEOID: '42013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8745713.936839461, 4919945.232280262],
              [-8743014.99578518, 4939770.130805688],
              [-8732020.526276981, 4953625.5889893165],
              [-8731867.35065765, 4960101.081554207],
              [-8721929.971034026, 4971838.044224035],
              [-8722985.502445726, 4972978.697831102],
              [-8700037.657335639, 4974385.271005077],
              [-8695891.340262061, 4973938.7715443745],
              [-8707629.869246721, 4964454.1175356],
              [-8701440.616878105, 4956151.360833269],
              [-8704859.461079348, 4947428.804950941],
              [-8697400.832557216, 4936232.958973574],
              [-8711563.343453903, 4909324.718056655],
              [-8715065.343314767, 4901187.234383798],
              [-8731265.000892967, 4909969.572656208],
              [-8732779.725204192, 4901520.912013028],
              [-8751981.001532141, 4913579.084929904],
              [-8745713.936839461, 4919945.232280262],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gibson',
        GEOID: '47053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9930399.557593528, 4302247.082012051],
              [-9925624.953313913, 4304205.5782828145],
              [-9924629.534427239, 4328821.420714147],
              [-9903119.046582274, 4328401.624517241],
              [-9902963.978531599, 4331326.465792777],
              [-9892217.083570926, 4319576.851111719],
              [-9873227.202955991, 4309258.563172023],
              [-9874797.030415159, 4271911.564132612],
              [-9898103.992202545, 4272766.851140196],
              [-9919600.231152691, 4281661.586326054],
              [-9922569.455930619, 4296197.245011454],
              [-9928456.698520713, 4300588.34846464],
              [-9930399.557593528, 4302247.082012051],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Turner',
        GEOID: '46125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10842679.816526495, 5388355.971000213],
              [-10812404.031976467, 5388340.62458008],
              [-10789623.945339004, 5388390.3470735485],
              [-10789546.13301494, 5324725.560199105],
              [-10815862.17195796, 5324635.938801872],
              [-10815862.283277452, 5337880.123573647],
              [-10842428.345796794, 5337794.80204849],
              [-10842679.816526495, 5388355.971000213],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ballard',
        GEOID: '21007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9926146.039850317, 4449456.8744810885],
              [-9918460.542205948, 4458774.02612124],
              [-9913895.218569025, 4465451.236123851],
              [-9907542.437868435, 4470431.720639292],
              [-9900033.850800553, 4470866.549139392],
              [-9886946.550959827, 4432710.848844462],
              [-9916396.456207661, 4427341.238918752],
              [-9918915.6661918, 4431409.963484489],
              [-9918437.833029829, 4433233.2481604535],
              [-9922230.710720137, 4436606.059462145],
              [-9921783.651645109, 4441603.225546947],
              [-9925982.757759249, 4449162.811183773],
              [-9926146.039850317, 4449456.8744810885],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Northwest Arctic',
        GEOID: '02188',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-18411856.418386053, 10457325.715528982],
              [-18311993.562620185, 10457330.918146173],
              [-18311996.456926946, 10509053.887134043],
              [-18213568.65372346, 10509058.98473177],
              [-18114151.331566315, 10509064.682051355],
              [-18114152.6674002, 10535072.664486716],
              [-18036348.247019548, 10535077.179441622],
              [-18036346.91118566, 10509068.880079336],
              [-17984479.48688188, 10509071.578812966],
              [-17984478.596325953, 10535080.189413209],
              [-17932608.61167388, 10535083.50038348],
              [-17932607.164520502, 10509075.17712612],
              [-17828867.306535847, 10509081.474178677],
              [-17828868.64236974, 10535089.821331153],
              [-17776997.655842252, 10535093.132306067],
              [-17776996.542647343, 10509084.472777156],
              [-17608416.8661383, 10509094.068301102],
              [-17494406.115335606, 10509103.064116975],
              [-17494404.556862734, 10483192.740549233],
              [-17392204.470074736, 10483197.221532252],
              [-17392202.911601868, 10457383.893021109],
              [-17290003.938008778, 10457388.654827608],
              [-17290003.49273081, 10447006.82402071],
              [-17290001.155021507, 10406049.283375278],
              [-17295597.853740633, 10380521.72341576],
              [-17270421.615063842, 10380523.194956787],
              [-17270420.27922995, 10355089.567141596],
              [-17245243.817914184, 10355091.033262609],
              [-17245242.482080296, 10329750.882290239],
              [-17220066.46604249, 10329752.343034346],
              [-17220065.130208597, 10304504.635791844],
              [-17226569.194097172, 10229308.946351757],
              [-17176943.63301848, 10229310.673939196],
              [-17176942.185865097, 10204425.822750842],
              [-17159489.182140056, 10204426.10964828],
              [-17159478.829427414, 10105769.463806408],
              [-17166613.9635093, 10105769.180964846],
              [-17166612.29371694, 10081321.892406764],
              [-17238985.992739238, 10081318.228396753],
              [-17238984.322946876, 10032679.258419195],
              [-17311359.135164086, 10032675.619974412],
              [-17311358.689886123, 10008482.363991743],
              [-17316302.611111235, 9960346.493777195],
              [-17363892.361342303, 9960344.83186025],
              [-17363892.91793976, 9984371.01328829],
              [-17387687.793055292, 9984370.179457797],
              [-17387684.119512096, 10008516.66979268],
              [-17435278.322522797, 10008477.622552888],
              [-17435276.87536942, 9960342.338985566],
              [-17482866.959558956, 9960340.954055576],
              [-17482868.963309795, 10008476.506920688],
              [-17578050.0222448, 10008472.60220939],
              [-17578048.352452442, 9912529.990353135],
              [-17696702.684494082, 9912523.938320944],
              [-17696701.571299173, 9865045.902518686],
              [-17767126.51131565, 9865040.71120272],
              [-17765867.82183325, 9747724.499774266],
              [-17789043.871899467, 9747722.081623686],
              [-17789042.981343538, 9724493.97592611],
              [-17919807.76078858, 9724484.335328372],
              [-18070608.26746456, 9724474.42695006],
              [-18229166.740773413, 9724476.301507046],
              [-18229168.521885265, 9771012.877026597],
              [-18252333.106043927, 9771011.79871422],
              [-18252335.109794762, 9817858.593328359],
              [-18283572.583425753, 9817856.422219222],
              [-18283579.707873166, 9912501.655884048],
              [-18291897.72286422, 9912501.105701314],
              [-18291900.28321251, 10008443.31694452],
              [-18300466.429348543, 10008444.711478148],
              [-18300472.729087956, 10037756.362929774],
              [-18236822.73875272, 10040692.934652617],
              [-18212309.073685132, 10031286.992651982],
              [-18226151.875004258, 10014647.015167614],
              [-18233986.4294468, 9997450.810271198],
              [-18242270.714632142, 9984136.154980574],
              [-18239605.39206408, 9961555.64344659],
              [-18238931.35254733, 9948334.270801188],
              [-18248064.44884997, 9938720.880249938],
              [-18247106.98990966, 9929177.811508834],
              [-18234531.115715254, 9904284.841570169],
              [-18222487.90528429, 9893163.701626804],
              [-18200274.212215982, 9900254.891421057],
              [-18186495.86488203, 9900156.307539143],
              [-18161410.46290973, 9893145.870204486],
              [-18144795.69495036, 9897909.302295089],
              [-18117325.60684628, 9901565.447948683],
              [-18103029.84651912, 9887672.131739624],
              [-18080926.471066188, 9890265.18499807],
              [-18070635.874698278, 9885445.85759292],
              [-18049055.478213094, 9898376.545112425],
              [-18015725.754752643, 9883029.086221423],
              [-18008770.401648387, 9897054.784591516],
              [-17990781.83985314, 9925373.223466579],
              [-17983488.854733307, 9942818.1644949],
              [-17976376.652466524, 9949041.340202877],
              [-17960419.00346131, 9947015.724118918],
              [-17958146.861334726, 9938310.290276086],
              [-17944587.368119672, 9934820.561790667],
              [-17921766.20459011, 9941307.573375454],
              [-17932363.374835663, 9963633.987627247],
              [-17958296.92000832, 9978451.666195339],
              [-17986492.699872874, 9986301.876722097],
              [-17999738.71740186, 9986126.169904092],
              [-18024441.06900634, 9973156.969089331],
              [-18018583.548720285, 10003750.342743782],
              [-18019829.213822264, 10018247.378757415],
              [-18045517.410837207, 10049357.736856144],
              [-18053282.72455648, 10067675.315019403],
              [-18072694.172083046, 10078633.029101852],
              [-18089574.77098643, 10083083.095828323],
              [-18103520.988112498, 10116165.737493144],
              [-18098640.74163612, 10128844.96516408],
              [-18085710.53750252, 10142112.072286464],
              [-18085904.122097008, 10150534.994800592],
              [-18104497.70532472, 10155612.582714913],
              [-18127597.501539744, 10153545.501314377],
              [-18146376.765678093, 10164479.22812547],
              [-18178391.13803533, 10173387.511800198],
              [-18210890.863372426, 10182425.952031052],
              [-18223228.291217554, 10187290.01248327],
              [-18227544.704473063, 10216136.264209235],
              [-18242902.452742394, 10275639.953812549],
              [-18262105.84414067, 10319323.50360088],
              [-18284964.856297106, 10344251.141796995],
              [-18315834.085052554, 10365936.541394664],
              [-18378205.393868607, 10426808.83503429],
              [-18406683.368642326, 10454686.264475606],
              [-18411856.418386053, 10457325.715528982],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marshall',
        GEOID: '18099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9625474.43292699, 5082875.316938404],
              [-9580094.263268678, 5083275.745516059],
              [-9580069.661661213, 5076837.921024472],
              [-9579500.373785295, 5038390.811995843],
              [-9582109.146052036, 5037873.189059816],
              [-9625467.531118562, 5037662.302615456],
              [-9625418.21658414, 5076415.636485661],
              [-9625474.43292699, 5082875.316938404],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washita',
        GEOID: '40149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11061174.039512336, 4227298.549236616],
              [-10978699.543853926, 4227147.794706154],
              [-10978132.259728843, 4179816.0456497003],
              [-10978445.512775935, 4177118.7745488607],
              [-10981808.808551272, 4180769.67748384],
              [-10992838.009740598, 4179702.9544648607],
              [-11060729.76342458, 4179756.710058704],
              [-11061174.039512336, 4227298.549236616],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mason',
        GEOID: '17125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10058219.602548616, 4884009.608284921],
              [-10041702.016504709, 4888607.005417118],
              [-10040968.643699363, 4892708.780747158],
              [-10031997.405936334, 4900189.1855704645],
              [-10022978.746070225, 4920592.828026777],
              [-10010369.587348072, 4929492.817882445],
              [-9987262.332727166, 4929453.914075016],
              [-9987019.990195712, 4912439.180689526],
              [-9974557.995840384, 4912572.18949244],
              [-9974404.931540543, 4883749.747014129],
              [-9978485.681434043, 4888473.153863486],
              [-9990834.797825705, 4884393.225488682],
              [-10015423.826188559, 4886637.2836883105],
              [-10018207.592694825, 4881781.137359139],
              [-10040424.402708875, 4873759.068638538],
              [-10050501.599612935, 4873991.61691262],
              [-10058219.602548616, 4884009.608284921],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Linn',
        GEOID: '19113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10222590.066471785, 5205883.43749344],
              [-10196529.283121154, 5205483.856375609],
              [-10170511.91437193, 5205489.424810275],
              [-10170802.903520865, 5153104.969484596],
              [-10170841.197425697, 5140041.45115762],
              [-10222622.349124115, 5140307.804913098],
              [-10222590.066471785, 5205883.43749344],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nome',
        GEOID: '02180',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-18716026.875217937, 9783256.22050242],
              [-18699435.70699062, 9802788.613755485],
              [-18662718.308786344, 9821154.571312223],
              [-18621830.88245696, 9848817.855327155],
              [-18564633.926211953, 9895641.340632321],
              [-18483274.740531802, 9951001.157460123],
              [-18413045.72281912, 9992875.998051418],
              [-18347243.54729682, 10022041.029608196],
              [-18301004.88172551, 10037731.816632928],
              [-18300472.729087956, 10037756.362929774],
              [-18300466.429348543, 10008444.711478148],
              [-18291900.28321251, 10008443.31694452],
              [-18291897.72286422, 9912501.105701314],
              [-18283579.707873166, 9912501.655884048],
              [-18283572.583425753, 9817856.422219222],
              [-18252335.109794762, 9817858.593328359],
              [-18252333.106043927, 9771011.79871422],
              [-18229168.521885265, 9771012.877026597],
              [-18229166.740773413, 9724476.301507046],
              [-18070608.26746456, 9724474.42695006],
              [-17919807.76078858, 9724484.335328372],
              [-17789042.981343538, 9724493.97592611],
              [-17789043.871899467, 9747722.081623686],
              [-17765867.82183325, 9747724.499774266],
              [-17742721.382751588, 9747724.499774266],
              [-17741807.1157737, 9678265.13057815],
              [-17764668.910917405, 9678263.268324638],
              [-17763493.043136157, 9586699.596886916],
              [-17786062.847255513, 9586691.193860805],
              [-17786060.175587732, 9541360.447459534],
              [-17806920.668925956, 9541359.142906103],
              [-17806916.77274378, 9451540.504814431],
              [-17805250.653925076, 9362843.664459098],
              [-17781894.377603266, 9362843.664459098],
              [-17781891.705935486, 9297037.274446962],
              [-17803630.176097598, 9297036.770325469],
              [-17803631.066653524, 9275237.725657187],
              [-17823530.42750824, 9275237.4743679],
              [-17823533.09917602, 9253503.768791208],
              [-17866486.72657402, 9253501.76460698],
              [-17866486.058657076, 9231831.960840944],
              [-17887961.703501422, 9231825.966557218],
              [-17887958.25259721, 9188696.970760323],
              [-17885408.813619062, 9167220.4529352],
              [-17906631.095302362, 9167218.720366938],
              [-17906629.536829494, 9103182.409718515],
              [-18033954.432689533, 9103174.069431951],
              [-18033957.660954766, 9124453.034816124],
              [-18055180.16527705, 9124457.955478508],
              [-18055186.844446495, 9145803.148353836],
              [-18076401.333765443, 9145805.862811822],
              [-18076402.001682386, 9167213.275155134],
              [-18100867.686508447, 9168541.659468736],
              [-18092377.016528167, 9178294.207923966],
              [-18080682.013464406, 9201252.11598219],
              [-18072972.470810026, 9212465.783046426],
              [-18096319.84157257, 9233178.804443393],
              [-18112522.616096515, 9243303.766284065],
              [-18099160.71497762, 9255198.50848966],
              [-18078419.222175054, 9257517.277280785],
              [-18061855.77250094, 9234340.01197733],
              [-18041901.19717879, 9227351.392095733],
              [-18031772.459350493, 9210534.14762403],
              [-17997748.547545455, 9215189.79007576],
              [-17969312.98549773, 9213980.625023162],
              [-17943718.185535558, 9221439.20684607],
              [-17930628.12661318, 9239325.511307823],
              [-17898315.529340103, 9287289.712351728],
              [-17896346.95546492, 9306400.690239191],
              [-17911357.720881443, 9349342.648077462],
              [-17915880.854431357, 9366625.167568125],
              [-17918208.65630334, 9405999.117525298],
              [-17942220.827064898, 9437543.798563702],
              [-17951772.8186114, 9451602.07468856],
              [-17978643.562577043, 9458021.67828314],
              [-17974651.979595665, 9479585.233315794],
              [-17965839.14946804, 9490264.1623821],
              [-17944482.505159345, 9477012.517997742],
              [-17921646.98141547, 9488570.83598404],
              [-17899434.512861557, 9508804.883298613],
              [-17898325.99337224, 9534261.510024842],
              [-17915310.675999515, 9561737.769811234],
              [-17931312.184884105, 9574093.733407315],
              [-17937250.41180098, 9581612.873811198],
              [-17946233.22679105, 9577705.433432538],
              [-17958933.890134636, 9563691.638537869],
              [-17964403.795953747, 9548840.548808018],
              [-17980125.00236052, 9543674.583283832],
              [-17994296.975413922, 9549732.822208868],
              [-18008485.535071447, 9542632.76284595],
              [-18020216.9396087, 9532258.973278953],
              [-18040469.071929734, 9527933.72464633],
              [-18054701.825425107, 9522603.230184544],
              [-18059859.368753053, 9508809.817783676],
              [-18093869.58826072, 9485887.416137764],
              [-18100909.432858486, 9472690.47924006],
              [-18104138.36600844, 9448400.121731535],
              [-18119298.076903645, 9434966.798152005],
              [-18126880.715338524, 9461536.526378801],
              [-18129220.87367398, 9477828.010541303],
              [-18138484.21378085, 9488861.402455417],
              [-18148776.257302143, 9482880.783844955],
              [-18148100.214034554, 9472184.320740985],
              [-18155261.174238306, 9461803.280488074],
              [-18159901.638531514, 9447398.52130876],
              [-18172805.79390427, 9466574.30607633],
              [-18191040.817052133, 9484348.612146603],
              [-18221479.684656173, 9495696.786896687],
              [-18237443.122274913, 9497295.626750546],
              [-18253541.367797002, 9491180.40617162],
              [-18272767.023093436, 9494596.190698605],
              [-18290601.96399139, 9493802.084610147],
              [-18317432.744259834, 9482214.254466427],
              [-18346314.47482666, 9464821.34713455],
              [-18367934.278411586, 9460818.094621887],
              [-18400181.64246305, 9472904.167037996],
              [-18458952.878946852, 9488279.763552189],
              [-18505411.40051248, 9499524.028594892],
              [-18525113.50322951, 9517097.60682096],
              [-18532767.386138495, 9544157.70406342],
              [-18532355.05874459, 9555111.84034491],
              [-18524377.570075873, 9569568.809192616],
              [-18527152.87630084, 9577662.422988806],
              [-18544276.040374663, 9596715.514753683],
              [-18556715.10291489, 9606054.196567297],
              [-18561105.766270757, 9615625.71600868],
              [-18580550.1643666, 9641629.729511986],
              [-18577739.90382152, 9645017.57164209],
              [-18549662.011297718, 9641605.381500768],
              [-18532459.142468486, 9652564.153655725],
              [-18529319.710189134, 9670858.597680362],
              [-18517684.37437244, 9681540.268390981],
              [-18527949.701215938, 9692919.05621203],
              [-18545489.200185332, 9697502.737482326],
              [-18562603.236060902, 9696682.74593116],
              [-18579187.502479795, 9704013.78637651],
              [-18597892.071239825, 9710551.99615743],
              [-18629176.41037644, 9713966.842203308],
              [-18643123.072780475, 9717939.554175323],
              [-18666539.5729468, 9738392.35379056],
              [-18685113.897902604, 9751580.092940021],
              [-18706975.487421535, 9759910.21106078],
              [-18716026.875217937, 9783256.22050242],
            ],
          ],
          [
            [
              [-19128788.415130313, 9240121.384649167],
              [-19123784.715338647, 9254073.48103227],
              [-19125002.884526398, 9278107.525510015],
              [-19118387.612466518, 9294864.842689814],
              [-19103892.033653382, 9295392.516231036],
              [-19100537.7547568, 9277897.868772347],
              [-19097176.574051786, 9265513.949328613],
              [-19070067.717695333, 9254188.731796525],
              [-19030157.899134096, 9241432.781824332],
              [-19019940.439671636, 9245779.824243456],
              [-18991804.438373636, 9267140.51699864],
              [-18978658.719705857, 9273164.891023492],
              [-18962702.51785402, 9272537.380915323],
              [-18954089.172253888, 9267914.653845916],
              [-18943951.640185818, 9255292.227038858],
              [-18934981.5156177, 9252088.454163017],
              [-18929763.971084222, 9233391.894831115],
              [-18925197.64557188, 9217787.958662095],
              [-18908403.43059335, 9209453.994847577],
              [-18886072.29546226, 9206455.424185757],
              [-18876063.33740605, 9196208.170859601],
              [-18864505.145996477, 9189186.795778356],
              [-18822780.485776834, 9184341.911495836],
              [-18806023.674147215, 9182568.683715345],
              [-18777944.445789516, 9173307.331962775],
              [-18785335.16942226, 9153896.31934793],
              [-18795366.947974082, 9138073.593382278],
              [-18806220.153048463, 9134083.590818461],
              [-18821346.24545745, 9143953.85501966],
              [-18838655.647039372, 9142784.322229654],
              [-18861612.50902821, 9128155.067747746],
              [-18872548.090525784, 9118506.182870656],
              [-18877221.394068774, 9106880.567099707],
              [-18876225.195945665, 9094583.82957572],
              [-18884050.176911995, 9084948.751132281],
              [-18897290.51714695, 9090470.833012916],
              [-18900765.577691045, 9110806.060804704],
              [-18911092.01893499, 9126252.254662078],
              [-18929837.330628652, 9140423.88466064],
              [-18945072.850097094, 9144923.224766104],
              [-18953594.023158845, 9144313.559985507],
              [-18958113.37184607, 9159019.47152393],
              [-18972253.841483574, 9177732.254421307],
              [-18998177.92449951, 9193073.568585161],
              [-19024074.28896224, 9203423.783691147],
              [-19043165.136355326, 9205124.070745725],
              [-19060827.42072306, 9197794.631540043],
              [-19067404.732836578, 9190678.076809349],
              [-19083869.77608083, 9176070.201840091],
              [-19094418.967625853, 9180372.3576303],
              [-19109895.827750336, 9188121.289354557],
              [-19120248.206435636, 9194445.905666267],
              [-19130252.71171221, 9220184.09749653],
              [-19128788.415130313, 9240121.384649167],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '31119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10890890.729516191, 5174433.054158742],
              [-10839001.152633741, 5174608.863878299],
              [-10838963.971923815, 5122590.377296669],
              [-10890440.664814914, 5122445.808844204],
              [-10890751.802791681, 5148447.729731428],
              [-10890890.729516191, 5174433.054158742],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lonoke',
        GEOID: '05085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10254720.211099448, 4172920.952593248],
              [-10242865.909844363, 4174250.3608688973],
              [-10227910.136256287, 4167221.5619748235],
              [-10219408.11014695, 4168016.549093191],
              [-10219541.470896922, 4153221.6764589697],
              [-10207296.54954864, 4152961.144691584],
              [-10208089.478281563, 4119400.03569272],
              [-10201154.607963614, 4113184.058768012],
              [-10200517.860476276, 4103313.850833686],
              [-10205552.395766893, 4093697.1350223934],
              [-10208574.49730295, 4093798.4203543216],
              [-10238588.458410632, 4094610.491541861],
              [-10244732.292427003, 4094700.8453397364],
              [-10244681.41941971, 4112528.6427818267],
              [-10254007.098441426, 4112761.0439064633],
              [-10250155.221420998, 4127247.187071028],
              [-10249275.129526787, 4165485.104407148],
              [-10254900.21471606, 4165540.558115062],
              [-10254720.211099448, 4172920.952593248],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Newton',
        GEOID: '13217',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9355790.164738845, 3965301.6940863873],
              [-9351202.1319258, 3969188.0731909648],
              [-9343140.931000005, 3982145.6291255886],
              [-9341355.366367681, 3994506.237187972],
              [-9327538.613809403, 3984129.415672315],
              [-9316500.841019284, 3977488.2239961806],
              [-9315314.731844882, 3974805.6625679624],
              [-9314952.27558286, 3971415.461249244],
              [-9315459.447182914, 3965360.9836273184],
              [-9314618.762388444, 3960154.946120048],
              [-9331347.632825876, 3953488.1806787774],
              [-9335592.912926767, 3944289.3539916705],
              [-9341378.075543802, 3953273.278037909],
              [-9342367.260538992, 3954412.8011170956],
              [-9344884.5281843, 3959425.660691396],
              [-9356892.561656171, 3963850.3970649946],
              [-9355790.164738845, 3965301.6940863873],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Aitkin',
        GEOID: '27001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10442926.738349747, 5820655.41553744],
              [-10439308.632259982, 5875353.2434353605],
              [-10439099.240297802, 5909960.0041416995],
              [-10439013.858248362, 5947040.4783300245],
              [-10358940.19004789, 5946386.7390700495],
              [-10359562.02072346, 5904051.990756253],
              [-10358818.18388598, 5847793.833309267],
              [-10358709.536062967, 5805724.368764505],
              [-10384380.255917858, 5805936.991425857],
              [-10400783.850803193, 5805060.819650054],
              [-10400652.159845583, 5819925.229672163],
              [-10441354.2392228, 5819408.051214924],
              [-10442926.738349747, 5820655.41553744],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cumberland',
        GEOID: '37051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8805103.553094618, 4187582.9039354525],
              [-8804905.070442533, 4190013.1482106093],
              [-8780926.852125663, 4195241.283016901],
              [-8771370.741758004, 4200094.9024979165],
              [-8751618.545270119, 4197304.495793347],
              [-8754106.64720884, 4179625.519649807],
              [-8757759.48497973, 4175476.539085094],
              [-8754947.665961782, 4162828.543422291],
              [-8737990.590568224, 4144353.9871736704],
              [-8740374.831422035, 4142961.8159280876],
              [-8771931.012755167, 4143631.631689704],
              [-8783330.239931889, 4141517.196230457],
              [-8787654.556871245, 4150756.9828823805],
              [-8798553.068978379, 4157457.156635617],
              [-8798349.354310228, 4158032.766366936],
              [-8806810.08088848, 4180969.7505166857],
              [-8805103.553094618, 4187582.9039354525],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '41067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13746256.819066908, 5733800.646938503],
              [-13732486.820694763, 5733789.806815563],
              [-13732552.944472292, 5745096.685916349],
              [-13695734.134211909, 5745029.647443874],
              [-13684409.936371982, 5735828.300691762],
              [-13684407.932621147, 5722099.236882946],
              [-13663783.881881367, 5703229.885225972],
              [-13663767.629235713, 5690801.022456514],
              [-13663768.51979164, 5689994.650988185],
              [-13663770.746181456, 5673951.012184911],
              [-13677591.06096344, 5671620.087420196],
              [-13688983.275012242, 5676229.4820719035],
              [-13695877.513716051, 5685501.36827636],
              [-13707373.032252308, 5690020.82558876],
              [-13744047.572452625, 5690000.679071233],
              [-13743635.801656181, 5699242.379033763],
              [-13725630.653256806, 5717632.119125424],
              [-13739415.90239919, 5722236.631504974],
              [-13746256.819066908, 5733800.646938503],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '47123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9406972.751535267, 4254741.916424567],
              [-9383205.038375486, 4253242.8807327915],
              [-9371800.801821679, 4247164.991541534],
              [-9359916.55562357, 4237677.702274881],
              [-9350148.715584423, 4238877.565134445],
              [-9343995.530730827, 4230366.709665951],
              [-9346263.98089795, 4226283.277155543],
              [-9347850.636016486, 4225556.592577726],
              [-9353261.98778344, 4219386.387181156],
              [-9351681.696292136, 4214503.797151484],
              [-9355076.384163879, 4211323.637598072],
              [-9353454.347863529, 4204149.875784994],
              [-9354077.11515597, 4203650.802504134],
              [-9361691.767543249, 4197550.395162047],
              [-9370709.536853433, 4196636.751215819],
              [-9375741.40047627, 4200508.159084003],
              [-9382365.13281745, 4194714.842433785],
              [-9382741.212218596, 4191878.1390697416],
              [-9387096.433815146, 4193733.710198009],
              [-9390569.713247387, 4195682.296804045],
              [-9405999.26258828, 4202743.639415848],
              [-9395479.125430351, 4208868.780060558],
              [-9396392.056574348, 4218151.777860656],
              [-9409374.580868622, 4249032.402760772],
              [-9406972.751535267, 4254741.916424567],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '28063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10168558.368628, 3742701.3204070795],
              [-10162371.3426492, 3741495.4060061784],
              [-10157237.305692399, 3746223.105831338],
              [-10131596.067543983, 3745190.1849742243],
              [-10112472.492220607, 3740525.441740204],
              [-10113671.51445594, 3735176.77101001],
              [-10100716.708714876, 3735270.0148796393],
              [-10100777.043878885, 3723797.6324666245],
              [-10100833.371541226, 3712372.1597471233],
              [-10147201.72431931, 3712234.126352287],
              [-10163482.311167317, 3720362.8587810015],
              [-10163173.065621894, 3720958.9295627913],
              [-10163512.256110342, 3721500.611528699],
              [-10162651.088529564, 3722308.928096569],
              [-10162557.134879336, 3722864.2762939623],
              [-10162801.815120097, 3723719.5229538516],
              [-10163368.765286708, 3724006.711994274],
              [-10163127.313311178, 3724959.9143031915],
              [-10163705.061468396, 3724975.877971708],
              [-10163583.945862412, 3725809.0274274773],
              [-10164255.64766986, 3725481.623095724],
              [-10165458.120809408, 3730508.1615441176],
              [-10165746.96519706, 3730250.8765818276],
              [-10170094.577600947, 3737002.4908759366],
              [-10168558.368628, 3742701.3204070795],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '36053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8459438.389104504, 5340198.298401911],
              [-8457998.02621313, 5339013.188100631],
              [-8455757.164863462, 5339469.322469777],
              [-8455338.60357808, 5338216.533045899],
              [-8452798.181478687, 5338888.31986583],
              [-8447398.852216741, 5335680.024084007],
              [-8429549.217146002, 5336753.4539430905],
              [-8410496.329699278, 5317689.696659886],
              [-8409386.36305658, 5301592.91297942],
              [-8398406.921679636, 5301792.849655168],
              [-8397627.017327141, 5291190.691106551],
              [-8376564.92439109, 5292449.0415395005],
              [-8376949.3105927985, 5279237.720562356],
              [-8381898.686472958, 5273102.9262038125],
              [-8396680.912974888, 5273302.256556608],
              [-8448017.454627078, 5270032.105673769],
              [-8448712.867486063, 5280208.367441725],
              [-8451062.821936708, 5325037.412785477],
              [-8457563.768879546, 5325875.625390063],
              [-8459545.92373261, 5339925.326495586],
              [-8459438.389104504, 5340198.298401911],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marshall',
        GEOID: '01095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9638188.45460947, 4078740.3948236224],
              [-9635011.618981214, 4101536.7469800403],
              [-9634720.407193298, 4102349.241485091],
              [-9632859.033987746, 4096516.5835917788],
              [-9620666.098841667, 4093381.265681895],
              [-9610676.287737878, 4097462.7258540373],
              [-9609861.31774578, 4109573.996630209],
              [-9590003.14510266, 4109528.8274828624],
              [-9584356.686571153, 4097833.9638694418],
              [-9583230.91256076, 4091622.741622527],
              [-9579900.67867419, 4092896.877872386],
              [-9586711.427759903, 4083158.306987262],
              [-9585285.647721821, 4055790.611985311],
              [-9585598.900768915, 4053846.561082843],
              [-9596419.934510456, 4052008.3295024065],
              [-9607263.454789137, 4042112.880009625],
              [-9619007.772387318, 4056362.114586987],
              [-9623906.163940696, 4063675.34014006],
              [-9626634.048062585, 4069527.838575985],
              [-9638257.027415803, 4069788.732584575],
              [-9638188.45460947, 4078740.3948236224],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Appomattox',
        GEOID: '51011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8788667.341598483, 4509472.272545567],
              [-8779684.192649936, 4514939.204096666],
              [-8774785.355818598, 4516406.427651483],
              [-8753687.640645493, 4497278.591632765],
              [-8753123.918744117, 4492828.677676367],
              [-8749092.59470453, 4494725.3637508135],
              [-8749097.826720595, 4487297.919664172],
              [-8758792.641173782, 4473837.537974589],
              [-8769448.142832516, 4471089.643600659],
              [-8774670.808062572, 4467770.249833782],
              [-8785491.953123603, 4473421.784162583],
              [-8796653.958465446, 4499107.812752261],
              [-8788667.341598483, 4509472.272545567],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Andrews',
        GEOID: '48003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11473109.477483539, 3832053.459328404],
              [-11378080.592292445, 3832192.216196537],
              [-11378104.192024492, 3774709.876690061],
              [-11386542.098107133, 3774734.9722195915],
              [-11443541.907533938, 3774577.830396137],
              [-11448585.68234229, 3774744.300937658],
              [-11473079.020593978, 3774742.855642835],
              [-11473078.97594306, 3782360.0049888864],
              [-11473109.477483539, 3832053.459328404],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cheatham',
        GEOID: '47021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9716031.61417292, 4349464.138126933],
              [-9698203.352444414, 4363474.306962374],
              [-9691824.74562196, 4358763.4389571855],
              [-9683466.544294728, 4351536.006732382],
              [-9675136.84075714, 4353397.960111526],
              [-9674359.942030892, 4351130.116868453],
              [-9680716.730233153, 4337423.180257913],
              [-9689400.095792992, 4306307.329478149],
              [-9690776.004699195, 4306895.198938644],
              [-9694298.487346368, 4306650.547751357],
              [-9705119.6324074, 4307465.751918892],
              [-9701479.819016932, 4324986.8858707035],
              [-9706313.867904631, 4334933.421809412],
              [-9701832.367844274, 4342718.814146125],
              [-9716688.844446564, 4345009.7550829975],
              [-9716031.61417292, 4349464.138126933],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lake',
        GEOID: '46079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10839191.620282488, 5495664.136835207],
              [-10812425.516638191, 5495813.50146116],
              [-10785658.188479494, 5495778.100892749],
              [-10785596.740120575, 5442009.312856685],
              [-10812360.728694549, 5441945.717416147],
              [-10839119.039974492, 5442031.077416595],
              [-10839191.620282488, 5495664.136835207],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carbon',
        GEOID: '42025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8458722.15950074, 5000171.551587702],
              [-8430439.884391839, 5013554.187585563],
              [-8434699.636026535, 5019751.779142522],
              [-8426290.005094554, 5031632.832824277],
              [-8421279.069535987, 5030404.158578356],
              [-8404175.163734073, 5010451.048103965],
              [-8412924.875710424, 5005164.466534339],
              [-8406620.073710365, 4994391.579458181],
              [-8401748.732793253, 4985055.022399948],
              [-8413247.479594745, 4982800.143043816],
              [-8416753.709596258, 4981031.694991003],
              [-8426300.914404653, 4978486.703645485],
              [-8433320.498855095, 4973393.273563986],
              [-8447594.997159518, 4985278.74448872],
              [-8459986.080999209, 4999515.43091661],
              [-8458722.15950074, 5000171.551587702],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Torrance',
        GEOID: '35057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11851819.609676655, 4125490.2604684206],
              [-11851812.03995128, 4130617.8395152264],
              [-11851604.540420443, 4134458.1878647194],
              [-11851579.048257051, 4138160.8825633945],
              [-11851503.573642293, 4146254.9890188477],
              [-11845705.275325343, 4146262.85852637],
              [-11816534.670679912, 4146247.933603032],
              [-11816544.800753573, 4157558.612820775],
              [-11827001.485801749, 4157544.080218109],
              [-11827013.953584718, 4169318.721670684],
              [-11821541.37609783, 4169353.1202382697],
              [-11768075.292586764, 4169536.53574264],
              [-11720917.23934099, 4169594.321091527],
              [-11720873.268142128, 4110569.7925705938],
              [-11723363.373831684, 4110594.8137062015],
              [-11723397.548915358, 4075519.0023337724],
              [-11723413.801561013, 4063771.5078654103],
              [-11791624.819544591, 4063765.9856069917],
              [-11846171.815311257, 4063743.3578445013],
              [-11846277.791466493, 4087995.158787437],
              [-11846273.00472839, 4099072.593240427],
              [-11852162.807666771, 4099005.308170092],
              [-11851819.609676655, 4125490.2604684206],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Castro',
        GEOID: '48069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11413051.276366679, 4129543.0383108836],
              [-11373383.132419951, 4129608.880972733],
              [-11354420.302441278, 4129713.60682767],
              [-11354367.648322133, 4070913.3678052016],
              [-11364653.012673978, 4070925.9018173427],
              [-11413101.036179064, 4070912.6939339754],
              [-11413051.276366679, 4129543.0383108836],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Humacao',
        GEOID: '72069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7330900.315755732, 2058284.136538651],
              [-7327723.8140859455, 2061019.3359575307],
              [-7323985.037668162, 2061763.5732486388],
              [-7317403.8400319405, 2056960.8396521038],
              [-7320228.11617338, 2055886.5828749181],
              [-7322327.156491778, 2052681.3011012005],
              [-7325146.065044617, 2045882.4251294555],
              [-7330178.854135901, 2051304.9011396787],
              [-7333462.55647532, 2051384.4302028927],
              [-7330900.315755732, 2058284.136538651],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Amador',
        GEOID: '06005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13472720.451219352, 4651481.372560541],
              [-13461544.642260652, 4652430.7045002915],
              [-13448903.31220566, 4659152.095941143],
              [-13428203.45289265, 4650748.912060371],
              [-13415178.18191391, 4651933.051818951],
              [-13391926.323274467, 4657289.566056564],
              [-13382026.235680258, 4668720.34469853],
              [-13373932.974741114, 4670003.3344508605],
              [-13369284.050166603, 4680077.761739648],
              [-13366397.535770336, 4679184.485231583],
              [-13366407.777163489, 4651705.71595788],
              [-13381237.537087986, 4650449.6268994715],
              [-13395190.099425035, 4645351.88431042],
              [-13405450.973488905, 4646507.815895457],
              [-13426787.135011286, 4634583.100033921],
              [-13428613.776535716, 4627605.706254275],
              [-13448521.70899122, 4619341.325642702],
              [-13457732.061020475, 4610774.247730618],
              [-13469157.114319062, 4611316.672899656],
              [-13472673.363074746, 4621928.612993237],
              [-13472720.451219352, 4651481.372560541],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Humphreys',
        GEOID: '28053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10098489.762301553, 3931201.2901667175],
              [-10080559.977197446, 3931267.994625373],
              [-10080597.603185333, 3939079.190871561],
              [-10069207.838165328, 3939119.5604093494],
              [-10064755.39249207, 3926580.574423668],
              [-10055666.490027271, 3935568.244230976],
              [-10055524.335037528, 3913611.3179095257],
              [-10066838.625442775, 3908042.272340173],
              [-10059277.916947588, 3896710.489641924],
              [-10068772.578956326, 3896499.951272367],
              [-10068836.03106608, 3885126.4146749233],
              [-10091850.11127319, 3885022.9730220824],
              [-10092007.850991644, 3908121.6007273346],
              [-10096883.199410425, 3908092.367423148],
              [-10094407.676574165, 3908914.7813458303],
              [-10094486.93605161, 3922143.0229360396],
              [-10098489.762301553, 3931201.2901667175],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hamilton',
        GEOID: '12047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9273954.099896116, 3585338.6321019065],
              [-9254726.07756969, 3583999.303032056],
              [-9254148.567836156, 3583959.0787725034],
              [-9225860.05883577, 3582075.851120376],
              [-9204956.351101212, 3580636.786069802],
              [-9209081.094627481, 3575671.192629753],
              [-9200243.996850858, 3554398.9315718827],
              [-9205000.010775508, 3546440.165102913],
              [-9210401.343788289, 3545495.323903393],
              [-9215973.9974974, 3545267.055917226],
              [-9216652.044515822, 3546945.1153640975],
              [-9239746.83135376, 3558861.7438049354],
              [-9248709.83147447, 3560594.4236077247],
              [-9258549.917863142, 3553163.6569979186],
              [-9264215.968625028, 3558092.1850747312],
              [-9269864.764865842, 3584491.023200341],
              [-9273954.099896116, 3585338.6321019065],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Knox',
        GEOID: '17095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10067670.515997473, 5021785.499080754],
              [-10067473.925776733, 5034676.96241539],
              [-10017035.287137281, 5034398.141041884],
              [-10017137.701068811, 5008580.409725721],
              [-10017202.822970925, 4970007.107073899],
              [-10068217.762614215, 4970375.293830053],
              [-10067670.515997473, 5021785.499080754],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Black Hawk',
        GEOID: '19013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10303118.920070112, 5257685.898478405],
              [-10250483.613918837, 5257646.854859358],
              [-10248538.417136716, 5231376.778202669],
              [-10248602.871121883, 5205611.931200696],
              [-10274654.526274271, 5205652.265346503],
              [-10300783.214514287, 5205573.102222494],
              [-10300839.430857137, 5231583.678890283],
              [-10303097.546727879, 5244610.796959012],
              [-10303118.920070112, 5257685.898478405],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chilton',
        GEOID: '01021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9686928.246499926, 3873692.876281815],
              [-9671005.217856348, 3873590.8601252967],
              [-9671568.939757725, 3901929.361183149],
              [-9671619.701445526, 3904846.1983172526],
              [-9641381.431563895, 3904599.381271767],
              [-9631066.678866481, 3898034.0741863796],
              [-9630912.501371734, 3885931.5667101783],
              [-9623739.62998247, 3877225.300927492],
              [-9624350.885306414, 3870628.140414153],
              [-9615218.122962244, 3862641.321392063],
              [-9619488.449948564, 3862245.6896277033],
              [-9619464.070980081, 3856528.4460331765],
              [-9652982.703616409, 3856304.6029320597],
              [-9652890.41975854, 3850490.137983626],
              [-9675622.41637598, 3850812.3835077295],
              [-9686761.601222208, 3850693.375109905],
              [-9686772.95581027, 3859458.6421172367],
              [-9686928.246499926, 3873692.876281815],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Whitley',
        GEOID: '21235',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9386240.498250438, 4415960.754250169],
              [-9383945.42430875, 4431572.943212515],
              [-9379526.485802222, 4435322.40604487],
              [-9371223.276303444, 4430658.9739548825],
              [-9361062.255822813, 4432974.413497507],
              [-9358165.722672373, 4418796.212309244],
              [-9349019.824628288, 4411382.550583942],
              [-9346221.252629746, 4401156.143567878],
              [-9337200.922971277, 4395603.915335612],
              [-9345974.679957638, 4389799.2834756905],
              [-9343129.55236069, 4381791.450267911],
              [-9349458.083973577, 4382054.594031761],
              [-9349483.804265916, 4382055.663508619],
              [-9376128.342795936, 4382413.299098093],
              [-9385078.87936401, 4394153.363773161],
              [-9390463.291814188, 4412797.906845405],
              [-9386240.498250438, 4415960.754250169],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Archuleta',
        GEOID: '08007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11964856.092295924, 4498186.854685138],
              [-11925510.10695555, 4498224.560514025],
              [-11925516.452166526, 4493945.6031499505],
              [-11878989.135155588, 4495601.735240922],
              [-11875382.161014903, 4495513.169913285],
              [-11875380.045944579, 4471014.006934349],
              [-11866366.506775048, 4466318.605527773],
              [-11865453.019033598, 4458665.242112039],
              [-11852880.104693986, 4438239.012682642],
              [-11896691.271901025, 4438051.12190105],
              [-11897525.72280401, 4439126.162075733],
              [-11958041.33570854, 4439107.484186128],
              [-11964812.232322486, 4439107.425687349],
              [-11964856.092295924, 4498186.854685138],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grundy',
        GEOID: '47061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9563857.424980553, 4203250.551228452],
              [-9558972.614405053, 4215691.712559551],
              [-9559779.680713303, 4235333.628159569],
              [-9553475.880588664, 4232663.777248786],
              [-9529763.93849377, 4236367.1696257],
              [-9516215.911186263, 4219234.648418467],
              [-9524334.330330325, 4207356.753872534],
              [-9541128.767947836, 4203259.006774836],
              [-9544545.719717735, 4193177.5013880013],
              [-9559341.415878052, 4194276.7288802783],
              [-9563857.424980553, 4203250.551228452],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Anderson',
        GEOID: '48001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10692547.226795277, 3764084.4623764795],
              [-10623053.362999797, 3774404.3986640014],
              [-10625050.100706156, 3763115.961923896],
              [-10622532.387782883, 3754389.0570764565],
              [-10625083.273914412, 3742734.73602521],
              [-10621316.333665458, 3741691.8191569922],
              [-10619493.254364736, 3732537.429131569],
              [-10606058.995576823, 3718400.230681077],
              [-10604167.677428246, 3712219.878676249],
              [-10605764.444204183, 3709988.427923238],
              [-10647905.661958378, 3703312.7242605537],
              [-10657647.78719515, 3698384.8874329487],
              [-10654400.931607181, 3712955.5511329123],
              [-10657247.259667275, 3717954.6748112733],
              [-10662993.460462535, 3713321.3124520457],
              [-10663748.317929601, 3718803.1674460764],
              [-10671226.872640586, 3722353.2765246877],
              [-10672860.486167977, 3731259.212782949],
              [-10684507.955809167, 3735064.014986351],
              [-10689174.802821696, 3757739.562744537],
              [-10693592.071535861, 3757580.9371475265],
              [-10692547.226795277, 3764084.4623764795],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Allendale',
        GEOID: '45005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9085446.63033141, 3907168.1728837155],
              [-9077200.671245707, 3916331.7474966845],
              [-9057494.44970752, 3909656.0532769714],
              [-9038374.436607849, 3911065.7692369274],
              [-9027999.014787951, 3901717.002414814],
              [-9026039.346472029, 3898839.184172735],
              [-9043256.57551557, 3887375.0371977985],
              [-9046006.83485511, 3873971.769121625],
              [-9054565.188626787, 3864610.544717188],
              [-9062866.705532035, 3861407.92170064],
              [-9063701.958472624, 3872923.0073767197],
              [-9068538.679028101, 3881748.322415125],
              [-9072490.186992792, 3887836.3803925132],
              [-9072764.478218105, 3897310.1332247984],
              [-9077432.797354521, 3901198.798679645],
              [-9083854.682488386, 3906550.281466793],
              [-9085446.63033141, 3907168.1728837155],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Berks',
        GEOID: '42011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8509282.025065664, 4938276.58745265],
              [-8479386.396576695, 4943986.568748004],
              [-8462182.63719154, 4949775.05796882],
              [-8459525.663585287, 4959343.636170522],
              [-8448200.12991147, 4964854.974760781],
              [-8407927.07585177, 4931112.581418851],
              [-8411273.228425525, 4925661.970175256],
              [-8426527.226929436, 4901151.650546833],
              [-8446185.469767094, 4885886.344073617],
              [-8470496.422041945, 4906378.161064868],
              [-8477114.477089096, 4911965.123296853],
              [-8483160.572592553, 4918491.803748322],
              [-8509282.025065664, 4938276.58745265],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carroll',
        GEOID: '47017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9873227.202955991, 4309258.563172023],
              [-9869083.780189175, 4316778.934683343],
              [-9855363.096351448, 4316514.079047068],
              [-9855150.364804545, 4321559.715276629],
              [-9819681.303370029, 4320725.803807141],
              [-9819777.149451602, 4317185.7391081415],
              [-9820320.0546082, 4279531.774131539],
              [-9815914.363121076, 4279430.011756736],
              [-9816061.082209941, 4275440.467392151],
              [-9859517.205789382, 4276492.908383738],
              [-9863670.75862986, 4271675.383888194],
              [-9874797.030415159, 4271911.564132612],
              [-9873227.202955991, 4309258.563172023],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henry',
        GEOID: '47079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9853595.906111984, 4369843.277265465],
              [-9853101.863534965, 4369842.280432537],
              [-9850558.963320462, 4369818.283765223],
              [-9810294.84390634, 4369438.3292263765],
              [-9802054.17378386, 4369639.991437734],
              [-9802953.323488522, 4361887.228289559],
              [-9795104.408831673, 4350288.939531823],
              [-9799652.811905995, 4350244.152311658],
              [-9806787.166751444, 4350168.954435405],
              [-9806386.52790408, 4347549.797541365],
              [-9807543.248732911, 4343490.051011859],
              [-9806220.995821267, 4341268.49135558],
              [-9806546.939290313, 4341016.845696353],
              [-9806006.037884546, 4340399.220011663],
              [-9806415.137013212, 4339360.3020931445],
              [-9806319.847529093, 4338554.5640456425],
              [-9805809.113705333, 4337546.613236553],
              [-9805602.727369403, 4335703.687664119],
              [-9819777.149451602, 4317185.7391081415],
              [-9819681.303370029, 4320725.803807141],
              [-9855150.364804545, 4321559.715276629],
              [-9853595.906111984, 4369843.277265465],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Aransas',
        GEOID: '48007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10814122.582275335, 3261918.2476627147],
              [-10800616.188457387, 3272653.711313579],
              [-10811789.77102627, 3283349.4330070023],
              [-10774670.509460235, 3289282.3440901134],
              [-10779169.598000135, 3262583.577264835],
              [-10781523.183996486, 3256517.927277523],
              [-10785351.280643377, 3252849.1967702364],
              [-10798360.744254423, 3237418.3109211894],
              [-10802853.496899288, 3228379.847902999],
              [-10808645.329369832, 3243658.787148422],
              [-10813164.789376548, 3236924.8950020103],
              [-10827024.733897256, 3258528.6282269196],
              [-10814122.582275335, 3261918.2476627147],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Barnwell',
        GEOID: '45011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9101760.53198681, 3921517.0780334473],
              [-9099535.59123949, 3923057.699588503],
              [-9058393.243276186, 3960581.0067750853],
              [-9050435.458157338, 3959353.188462878],
              [-9041666.599228568, 3953853.2975411285],
              [-9042192.361183586, 3916662.4543748247],
              [-9038374.436607849, 3911065.7692369274],
              [-9057494.44970752, 3909656.0532769714],
              [-9077200.671245707, 3916331.7474966845],
              [-9085446.63033141, 3907168.1728837155],
              [-9090175.180536648, 3909003.683653217],
              [-9100939.997935338, 3915437.011001589],
              [-9101760.53198681, 3921517.0780334473],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cherokee',
        GEOID: '20021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10583719.066205956, 4486596.138293546],
              [-10532800.183216926, 4486383.456818987],
              [-10532866.653019225, 4461461.723962467],
              [-10532839.033663152, 4447026.431282266],
              [-10532823.57237629, 4438954.159470866],
              [-10543377.328020437, 4438938.68773644],
              [-10574827.644517824, 4439041.136128002],
              [-10576199.880378664, 4439040.238358801],
              [-10583534.04949756, 4439035.440066088],
              [-10583719.066205956, 4486596.138293546],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wibaux',
        GEOID: '30109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11644832.148495642, 5914675.165258817],
              [-11644437.966178743, 5919391.242075091],
              [-11623104.47632414, 5926418.971033963],
              [-11611297.708491622, 5948939.75223701],
              [-11612422.480626596, 5971592.74518697],
              [-11624019.85649693, 6000120.000669426],
              [-11591905.964514924, 6000032.254961975],
              [-11582233.82766821, 6007128.426606228],
              [-11582271.262586767, 5996426.904214481],
              [-11582270.740483774, 5996126.803878607],
              [-11582212.8198541, 5962898.7525858665],
              [-11582296.754750159, 5931289.41677471],
              [-11582300.094334882, 5895496.578647311],
              [-11582279.289132712, 5883752.98399786],
              [-11616727.094016083, 5883738.057479915],
              [-11623758.367013058, 5890791.245012361],
              [-11644787.17542136, 5890796.437682377],
              [-11644832.148495642, 5914675.165258817],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ware',
        GEOID: '13299',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9206033.500928033, 3668919.1539758258],
              [-9198287.445480675, 3668479.1758656176],
              [-9198215.421770131, 3680103.1218653205],
              [-9198127.034094442, 3693854.495875006],
              [-9194712.642672831, 3693846.9259599554],
              [-9183270.000894697, 3693768.2252244423],
              [-9181794.127085762, 3687093.427936308],
              [-9174645.857303962, 3687039.2939350777],
              [-9170912.090263266, 3670617.6068942235],
              [-9163268.337427946, 3662128.990470252],
              [-9159875.430668058, 3661932.5526503194],
              [-9151434.185000693, 3654968.651180234],
              [-9151381.86484002, 3643762.7819001325],
              [-9142858.799346926, 3634140.638415284],
              [-9174462.95938059, 3634514.189375063],
              [-9175001.634396538, 3606184.1875785156],
              [-9144881.919772603, 3604772.6265180507],
              [-9152533.464972276, 3576305.8228576174],
              [-9174839.343066614, 3578441.962461568],
              [-9176717.067749662, 3609403.528733108],
              [-9183354.38106872, 3609336.771996019],
              [-9182806.911812998, 3627966.470654504],
              [-9194107.287281895, 3635150.265053425],
              [-9202968.096110059, 3656634.2102058125],
              [-9206033.500928033, 3668919.1539758258],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sitka',
        GEOID: '02220',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-15180860.094774544, 7932156.984826883],
              [-15142158.928457225, 7933529.364508327],
              [-15128537.430285797, 7967599.662672573],
              [-15107741.27961325, 7952504.004819872],
              [-15086967.392838866, 7942249.818506444],
              [-15054639.656115046, 7917426.159890839],
              [-15035003.788495036, 7917263.807302062],
              [-15022501.781186983, 7921506.633428207],
              [-15021443.627363034, 7917822.874174371],
              [-15008638.212378614, 7863022.392343126],
              [-15008714.800188279, 7836564.943729765],
              [-15011984.142313387, 7814428.195682945],
              [-14998990.374750542, 7755161.959403037],
              [-14994260.632225718, 7739868.189493917],
              [-14990664.901353601, 7720302.723469857],
              [-14986906.31006646, 7700992.797886942],
              [-14985379.563250227, 7686342.21098333],
              [-14986602.741815066, 7669474.5887601655],
              [-14991371.112203196, 7663470.390273639],
              [-14988253.27590506, 7647613.91491194],
              [-14987480.495999971, 7627463.867156449],
              [-14987462.684881445, 7611518.324202246],
              [-14989595.455005553, 7598010.290885423],
              [-14991844.220039066, 7591717.721766201],
              [-15001808.0937015, 7600407.464101322],
              [-15006999.589474136, 7607341.02553763],
              [-15010254.571384931, 7620257.2261551665],
              [-15018770.512430616, 7630529.355963924],
              [-15025580.03700193, 7645965.639017936],
              [-15034614.28159675, 7664544.94051555],
              [-15041866.857741425, 7679368.713575261],
              [-15047704.117880149, 7694562.342150442],
              [-15052157.342789842, 7692022.467056893],
              [-15062092.27338467, 7704397.943549853],
              [-15068455.740756376, 7710966.665718921],
              [-15080137.16284226, 7713539.671338018],
              [-15089436.90442262, 7727736.054068254],
              [-15084555.656070828, 7732774.930330538],
              [-15081210.282733506, 7737919.854787858],
              [-15077372.209329939, 7748345.650655686],
              [-15067476.79715434, 7764392.674280895],
              [-15079105.23116261, 7774473.332191332],
              [-15091750.791358251, 7781752.977096946],
              [-15095430.01184846, 7769492.520260789],
              [-15099028.414388351, 7762137.100624847],
              [-15120036.40605188, 7757877.239241655],
              [-15123423.078920279, 7759226.76148826],
              [-15122153.034849819, 7777218.462551486],
              [-15112178.25187729, 7785499.799728154],
              [-15112019.510283416, 7794363.39394804],
              [-15120777.237263106, 7795077.717123968],
              [-15125036.988897802, 7805555.335140098],
              [-15121385.70959978, 7817990.793786746],
              [-15123661.191311087, 7826087.092464013],
              [-15127442.825732825, 7843981.542369658],
              [-15133190.807639934, 7854473.234263629],
              [-15144743.655713953, 7865860.3048994485],
              [-15149254.766758861, 7874472.567966311],
              [-15157602.392734468, 7875213.370982063],
              [-15165963.265729476, 7889156.913604143],
              [-15167371.67992699, 7901399.751435729],
              [-15173368.015618065, 7919375.498606258],
              [-15180860.094774544, 7932156.984826883],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Charlottesville',
        GEOID: '51540',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8740796.17569469, 4583508.37049618],
              [-8738027.214680696, 4588659.855748076],
              [-8732800.207990497, 4587565.818239428],
              [-8735185.228080744, 4581085.120348802],
              [-8740662.592305735, 4580938.180734818],
              [-8740796.17569469, 4583508.37049618],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sedgwick',
        GEOID: '08115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11427331.355926355, 5012669.904191896],
              [-11423721.140961709, 5012669.591256442],
              [-11416569.5288732, 5012668.971350708],
              [-11360345.228502197, 5012692.272351576],
              [-11360333.705111708, 5012692.277127216],
              [-11360297.860235674, 4975476.261232729],
              [-11427091.55846247, 4975448.489061515],
              [-11427331.355926355, 5012669.904191896],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tehama',
        GEOID: '06103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13699580.556577291, 4907732.174998332],
              [-13689686.702874565, 4911847.013992285],
              [-13683221.712127255, 4910620.162458885],
              [-13678134.07743953, 4916766.172413409],
              [-13664399.923943417, 4919201.9816224445],
              [-13653484.82523216, 4913763.5086243255],
              [-13639308.955996577, 4923436.645780373],
              [-13630517.38789169, 4920352.750899063],
              [-13615532.782555496, 4920011.714087578],
              [-13582126.248646399, 4928123.525734572],
              [-13574408.802308176, 4926481.88415489],
              [-13559441.89677102, 4930813.444802015],
              [-13541607.51247052, 4929318.044466234],
              [-13525054.860787014, 4930907.207427308],
              [-13522022.517857805, 4916965.554814144],
              [-13507759.04018297, 4911057.07577875],
              [-13510667.92979689, 4896831.063325017],
              [-13518292.313040813, 4888041.3165320065],
              [-13534936.914623711, 4880560.632940786],
              [-13541574.339262262, 4863403.475539739],
              [-13547942.816011054, 4863650.890642574],
              [-13559163.820683017, 4849149.670926817],
              [-13585972.225733815, 4849066.545104411],
              [-13586151.00483603, 4836580.462096817],
              [-13682478.320567738, 4836846.626391307],
              [-13685357.042599652, 4836654.065882961],
              [-13686739.964633774, 4852541.15856392],
              [-13682254.902349714, 4856702.222731506],
              [-13684951.728333674, 4862764.844740575],
              [-13691142.205216687, 4887107.942342289],
              [-13689798.24500434, 4901067.358198867],
              [-13699580.556577291, 4907732.174998332],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Vigo',
        GEOID: '18167',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9751631.58732861, 4766592.010663492],
              [-9749175.211444763, 4770540.704482052],
              [-9743978.26101708, 4771626.762617896],
              [-9743975.811988283, 4789130.706464737],
              [-9743980.56332393, 4790245.888232354],
              [-9744060.557600928, 4809039.926784131],
              [-9727366.276044983, 4809131.252756423],
              [-9706949.61351655, 4809015.66060188],
              [-9711397.049812723, 4796522.67341677],
              [-9711554.566892195, 4758848.496930193],
              [-9751002.503676813, 4758894.4480704805],
              [-9751631.58732861, 4766592.010663492],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jasper',
        GEOID: '17079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9836384.459005088, 4708909.203972581],
              [-9836263.009440633, 4746212.482142389],
              [-9796979.696973573, 4746615.545428381],
              [-9790592.073272366, 4746752.966835048],
              [-9790094.920426482, 4700229.233480485],
              [-9824900.517695872, 4699854.8826712435],
              [-9836385.906158466, 4700511.685214267],
              [-9836384.459005088, 4708909.203972581],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brazos',
        GEOID: '48041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10749787.375002705, 3593288.8498152834],
              [-10737614.254725989, 3599608.502063827],
              [-10724297.21536188, 3622432.87582371],
              [-10713501.339825256, 3629338.862388094],
              [-10709767.350145578, 3625878.5091983536],
              [-10705413.978819126, 3609783.2063816916],
              [-10707573.020343062, 3580746.418140906],
              [-10700230.498049827, 3560676.4154835083],
              [-10695573.22451351, 3558946.8228875073],
              [-10703063.467771025, 3552855.889593536],
              [-10703884.449015627, 3546076.329677158],
              [-10706559.56769888, 3554388.736060721],
              [-10717000.668018343, 3549711.2855249783],
              [-10719974.902173359, 3552379.9940293175],
              [-10716929.534863727, 3557185.7126904516],
              [-10724617.14757842, 3564694.930280667],
              [-10726614.441882232, 3573378.956897872],
              [-10743499.048287284, 3584509.2639134647],
              [-10753666.63661787, 3586333.2106977366],
              [-10749787.375002705, 3593288.8498152834],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Houston',
        GEOID: '27055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10211384.089931082, 5441785.495899332],
              [-10162095.34015022, 5441805.562025203],
              [-10157230.608564368, 5430387.440317593],
              [-10158682.78868824, 5423084.93135175],
              [-10160491.93568614, 5413995.436609698],
              [-10158229.255716275, 5403804.291953437],
              [-10155990.175478458, 5398345.591941578],
              [-10154308.583250536, 5388473.678887766],
              [-10184736.207586005, 5388495.1641915925],
              [-10198071.503408318, 5388494.833744067],
              [-10211361.046555782, 5388494.504430286],
              [-10211384.089931082, 5441785.495899332],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '26075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9430819.50153351, 5224331.729538986],
              [-9417673.782865733, 5224401.700133987],
              [-9366501.326142972, 5224797.858074023],
              [-9365435.219379647, 5224791.222631146],
              [-9365527.280598532, 5171707.369007943],
              [-9391279.263681704, 5171989.1554441415],
              [-9429824.639244292, 5171525.764394775],
              [-9430819.50153351, 5224331.729538986],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'New Haven',
        GEOID: '09009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8161821.389008547, 5087144.936514854],
              [-8154404.839253935, 5088177.330375285],
              [-8149053.933970484, 5087641.12581759],
              [-8143658.612210206, 5088644.87994098],
              [-8144654.476374844, 5094862.550081815],
              [-8132782.03004276, 5102251.82740016],
              [-8124458.226438183, 5107144.9261924075],
              [-8119476.790544676, 5107846.974262362],
              [-8120350.537227911, 5094819.259811026],
              [-8108988.156802642, 5093023.554736603],
              [-8098735.743020071, 5098107.048622819],
              [-8098368.054741981, 5092957.218841152],
              [-8097907.637328061, 5086031.502340081],
              [-8098063.373295681, 5074979.799582534],
              [-8090560.216977232, 5076538.726657645],
              [-8087769.771301517, 5077181.3749417355],
              [-8083344.487584013, 5061054.3232789],
              [-8074510.82926441, 5049853.083887883],
              [-8075921.258659954, 5049360.718231576],
              [-8081576.400111742, 5052055.708738764],
              [-8087788.250336989, 5051640.875047082],
              [-8087845.693437461, 5051600.786008934],
              [-8091862.655019514, 5048797.7956276005],
              [-8099644.110064946, 5047989.151410908],
              [-8102516.264246902, 5051477.819621248],
              [-8113125.345677974, 5048190.78796764],
              [-8115628.782996749, 5049167.516668394],
              [-8119158.973398459, 5050545.005873764],
              [-8123039.505781183, 5047994.970831197],
              [-8124635.314903984, 5046946.503238592],
              [-8124791.850952091, 5046843.663113517],
              [-8128599.200176203, 5042833.006055062],
              [-8135167.1614524955, 5041001.08823429],
              [-8137585.446216047, 5036521.328485716],
              [-8139943.101565998, 5038897.961403666],
              [-8135980.016374268, 5049967.355089735],
              [-8135991.148323347, 5053225.514154982],
              [-8133875.966678783, 5056840.393420356],
              [-8139208.504246254, 5061464.669021877],
              [-8142748.575372972, 5066728.959112004],
              [-8146724.239667163, 5070291.769021798],
              [-8149442.550312843, 5074571.105462518],
              [-8159469.3194875745, 5078688.826534232],
              [-8160884.524174032, 5081739.646458474],
              [-8161821.389008547, 5087144.936514854],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Floyd',
        GEOID: '18043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9577129.37995089, 4638630.15774074],
              [-9572877.30936106, 4638693.667639082],
              [-9552069.915419944, 4636718.651073523],
              [-9546853.484081369, 4629018.691405984],
              [-9550601.266999602, 4618766.2504143715],
              [-9553011.678312056, 4619477.3257062975],
              [-9555627.686345696, 4613352.864059952],
              [-9561761.390288405, 4606084.480317003],
              [-9561889.16143467, 4604874.726206408],
              [-9568753.590144113, 4605744.995882054],
              [-9568491.766701767, 4616291.510361371],
              [-9577100.659522265, 4626242.866986564],
              [-9577129.37995089, 4638630.15774074],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Perry',
        GEOID: '18123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9664052.418564292, 4578865.635175497],
              [-9662341.778485361, 4581619.6307788715],
              [-9659455.709367055, 4579166.59215629],
              [-9661585.25122593, 4608444.467926331],
              [-9661658.1654924, 4614675.30000424],
              [-9649119.026729954, 4616657.99627345],
              [-9636943.45742444, 4617117.646169007],
              [-9637115.89131568, 4608785.741242329],
              [-9624730.48477002, 4608684.5905638],
              [-9624749.965680908, 4607926.983692992],
              [-9624796.942506023, 4596545.495059239],
              [-9621741.48565283, 4591743.71703642],
              [-9621793.987922383, 4591689.775742252],
              [-9626008.209885344, 4585956.925160806],
              [-9627805.960342651, 4585596.094284625],
              [-9631565.501504725, 4584841.548272996],
              [-9631938.310479393, 4574938.466611029],
              [-9630178.794607915, 4565716.0718785105],
              [-9640250.98213489, 4566261.641960382],
              [-9641961.628749909, 4558660.24461395],
              [-9645466.863316856, 4560359.519898786],
              [-9646766.066653058, 4560989.421124017],
              [-9653876.376488496, 4564271.655852607],
              [-9660304.631803844, 4573285.649035696],
              [-9663746.630459173, 4579023.211277656],
              [-9664052.418564292, 4578865.635175497],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hampden',
        GEOID: '25013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8134239.090857752, 5183205.902320176],
              [-8127198.57834304, 5196759.127404456],
              [-8126493.035410392, 5200406.354001773],
              [-8126342.086180879, 5207932.778320736],
              [-8121119.0869923495, 5212623.3202460315],
              [-8113541.56925405, 5210934.511757832],
              [-8116560.331205382, 5196867.988515785],
              [-8103325.779583951, 5196525.320814133],
              [-8091464.353881456, 5188490.085244201],
              [-8083257.547061702, 5203957.47614478],
              [-8082902.437886072, 5203800.8340502195],
              [-8081676.253694985, 5201223.006371422],
              [-8084464.806939356, 5196385.641040756],
              [-8082578.498167865, 5193329.589342464],
              [-8081065.666287983, 5192722.524992118],
              [-8064776.507839185, 5195082.012184128],
              [-8059027.746695639, 5188842.678958696],
              [-8052170.132104301, 5194099.6354597965],
              [-8047460.42708782, 5195828.746648205],
              [-8039629.2122300025, 5197788.095231416],
              [-8044383.222403822, 5188556.336409201],
              [-8030032.692887187, 5185244.794566393],
              [-8030112.894344229, 5165345.763901439],
              [-8037138.770147641, 5165489.928475967],
              [-8050308.090981802, 5165760.156826355],
              [-8059250.191446521, 5165896.418568561],
              [-8071684.921554881, 5166085.9050282445],
              [-8073794.61110784, 5166118.053876806],
              [-8082678.129112125, 5165593.50248682],
              [-8096878.377316186, 5166433.398099966],
              [-8100356.332167041, 5161428.091083197],
              [-8101249.149668912, 5161298.378866085],
              [-8105180.807578529, 5160727.192354507],
              [-8109306.753185292, 5166507.589441331],
              [-8126272.622818623, 5166771.235671275],
              [-8127298.296298032, 5166808.769692409],
              [-8132266.971430512, 5166990.598031271],
              [-8134239.090857752, 5183205.902320176],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clark',
        GEOID: '20025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11143887.872075954, 4505501.097428691],
              [-11106847.869987365, 4504458.678298562],
              [-11082536.472434549, 4504503.27914755],
              [-11082467.009072293, 4493830.570592353],
              [-11081097.111418592, 4492364.54124524],
              [-11080866.225038745, 4439094.192875734],
              [-11093839.742210206, 4439134.24654562],
              [-11131414.85709104, 4439334.13005539],
              [-11132235.33899225, 4439332.478828202],
              [-11141910.141493931, 4439313.008220717],
              [-11142138.041000174, 4493172.625386944],
              [-11143887.872075954, 4505501.097428691],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marshall',
        GEOID: '46091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10906947.654314568, 5770088.534679322],
              [-10884490.304073542, 5770001.940951155],
              [-10858392.340012984, 5769980.332350808],
              [-10823403.844820224, 5770044.133198858],
              [-10823270.03879229, 5709824.250984974],
              [-10838582.146070395, 5709914.873376034],
              [-10839553.519947056, 5714511.747527285],
              [-10907038.2895727, 5714646.798392371],
              [-10906947.654314568, 5770088.534679322],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Patillas',
        GEOID: '72109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7357038.243513484, 2044134.262118135],
              [-7353002.578013754, 2050110.8309909853],
              [-7352851.406145257, 2050413.587664792],
              [-7348226.860539231, 2046395.1931564207],
              [-7345808.778560221, 2044448.6394868623],
              [-7345875.236296224, 2044211.772963662],
              [-7345437.416738934, 2043455.8790495915],
              [-7345480.942659835, 2042840.9746741562],
              [-7344864.566639313, 2042055.394315266],
              [-7345071.509572699, 2041626.9085665394],
              [-7337617.120485103, 2035531.4225677082],
              [-7345366.506223299, 2033968.466490863],
              [-7349085.115349731, 2034611.1078331247],
              [-7353460.88035735, 2042281.8163404246],
              [-7356243.867627183, 2041406.5813860754],
              [-7357038.243513484, 2044134.262118135],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Harrison',
        GEOID: '21097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9404860.018919501, 4651518.35971964],
              [-9403858.588780325, 4656380.6310610175],
              [-9400770.252147248, 4654487.726275618],
              [-9395400.756508833, 4658925.738612665],
              [-9373696.238791415, 4661977.855490802],
              [-9374840.49183728, 4658124.701666215],
              [-9368874.435047705, 4658003.562208852],
              [-9371309.214950336, 4650020.059866349],
              [-9367509.435451597, 4647328.279386429],
              [-9362202.946644973, 4644525.466009695],
              [-9372438.773823414, 4632075.548478755],
              [-9382211.957198117, 4623660.595273028],
              [-9384919.803811666, 4623751.252551127],
              [-9388000.79335835, 4620297.334967065],
              [-9400114.023749022, 4619515.190485867],
              [-9399039.345384903, 4621759.246476936],
              [-9403632.164936053, 4636111.532719397],
              [-9412883.92781588, 4649294.38852329],
              [-9404860.018919501, 4651518.35971964],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shasta',
        GEOID: '06089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13699954.924024828, 4914339.581107404],
              [-13692150.648483785, 4926892.8902865425],
              [-13681581.530749908, 4930831.144074675],
              [-13675149.045293909, 4939627.676614905],
              [-13658766.823750807, 4949018.556828557],
              [-13664692.694204206, 4966706.382010959],
              [-13655544.013172852, 4978999.999936793],
              [-13655123.11417816, 4986692.092388083],
              [-13647820.555582125, 4997565.890823898],
              [-13648589.216666048, 5006111.499619211],
              [-13639727.072003998, 5014465.154977064],
              [-13638124.182656065, 5025363.848870292],
              [-13631866.914078575, 5026602.224987288],
              [-13630565.47791171, 5035664.285191214],
              [-13636456.839322964, 5039323.638357174],
              [-13519361.982027845, 5039443.298659246],
              [-13506592.63455844, 5039502.759581628],
              [-13505277.951372169, 4998469.765511583],
              [-13506151.809374899, 4930874.441603257],
              [-13509895.483850276, 4931087.275132594],
              [-13525054.860787014, 4930907.207427308],
              [-13541607.51247052, 4929318.044466234],
              [-13559441.89677102, 4930813.444802015],
              [-13574408.802308176, 4926481.88415489],
              [-13582126.248646399, 4928123.525734572],
              [-13615532.782555496, 4920011.714087578],
              [-13630517.38789169, 4920352.750899063],
              [-13639308.955996577, 4923436.645780373],
              [-13653484.82523216, 4913763.5086243255],
              [-13664399.923943417, 4919201.9816224445],
              [-13678134.07743953, 4916766.172413409],
              [-13683221.712127255, 4910620.162458885],
              [-13689686.702874565, 4911847.013992285],
              [-13699580.556577291, 4907732.174998332],
              [-13699954.924024828, 4914339.581107404],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lake of the Woods',
        GEOID: '27077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10613504.154440567, 6226307.789822119],
              [-10585355.128762145, 6226313.525934785],
              [-10585533.351266906, 6261402.647666825],
              [-10601579.16530883, 6254769.826680637],
              [-10608863.244869396, 6258624.453517912],
              [-10610961.481847594, 6274650.713589811],
              [-10592462.655610314, 6274675.258108437],
              [-10592417.905175013, 6306290.083738753],
              [-10592420.242884321, 6327504.804503615],
              [-10592418.461772468, 6340332.343706039],
              [-10581853.12890128, 6335000.807875903],
              [-10574116.86956911, 6337688.889165317],
              [-10570020.64626639, 6337651.622417688],
              [-10561821.18653303, 6331587.5494184205],
              [-10554893.551981984, 6329502.721160001],
              [-10552780.930685708, 6311299.431094653],
              [-10550218.80128561, 6296096.934921277],
              [-10547546.354270136, 6291806.072254894],
              [-10547546.020311663, 6274860.036574066],
              [-10544063.278722705, 6274859.866895017],
              [-10540071.027824385, 6255189.473588376],
              [-10540361.794334339, 6247776.347196226],
              [-10541322.592859374, 6239194.126715772],
              [-10532940.012563659, 6230416.176740457],
              [-10520678.39329176, 6224171.188779377],
              [-10513747.864433954, 6222912.691277411],
              [-10511921.92191067, 6223824.886970132],
              [-10511755.022909774, 6168184.983736651],
              [-10598834.805902302, 6167956.768853147],
              [-10598947.572546475, 6197159.864398312],
              [-10613483.003737317, 6197201.897392366],
              [-10613504.154440567, 6226307.789822119],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marshall',
        GEOID: '20117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10776417.00095129, 4840912.130116973],
              [-10776368.799611777, 4866141.1416609585],
              [-10738985.154255107, 4866082.656983539],
              [-10738291.308415525, 4866081.577632189],
              [-10713299.615372725, 4866042.700461116],
              [-10713332.134199252, 4853502.924173995],
              [-10713273.02354964, 4803105.335155924],
              [-10751276.718470028, 4803121.508423918],
              [-10776455.183536634, 4803134.649223399],
              [-10776417.00095129, 4840912.130116973],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carter',
        GEOID: '30011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11692799.494439483, 5677113.5011984045],
              [-11687134.779511485, 5677114.293227387],
              [-11686536.103289997, 5746278.401705946],
              [-11681788.215688175, 5746275.52823666],
              [-11681778.864850948, 5802262.536801658],
              [-11675799.895000443, 5802265.749756161],
              [-11634681.92600562, 5802201.651534409],
              [-11634676.582670063, 5789142.369728473],
              [-11620724.465610977, 5789139.482352984],
              [-11620739.159783764, 5775601.1415414335],
              [-11592237.585277999, 5775356.092580981],
              [-11592235.804166146, 5761448.245957222],
              [-11582139.922965381, 5761455.962943588],
              [-11582100.164529417, 5758694.865966345],
              [-11581968.918849774, 5740376.336493697],
              [-11581895.447985848, 5709785.617508275],
              [-11581876.189713942, 5699119.946813508],
              [-11581719.674509885, 5674565.272602386],
              [-11581694.934475856, 5655099.277185003],
              [-11581677.261783892, 5641219.797655736],
              [-11581583.864731118, 5621288.493491449],
              [-11583649.954480242, 5621117.058786711],
              [-11691359.131548109, 5621567.140872361],
              [-11692804.747414116, 5621567.404252018],
              [-11692799.494439483, 5677113.5011984045],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nemaha',
        GEOID: '20131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10713299.615372725, 4866042.700461116],
              [-10713295.621406272, 4866042.6942481],
              [-10703854.949350566, 4866014.211814897],
              [-10689352.802687474, 4866046.763173804],
              [-10687859.876729006, 4866044.68014114],
              [-10663083.740000913, 4866010.110840289],
              [-10663176.135746924, 4815644.716968876],
              [-10663193.946865452, 4803061.436417332],
              [-10690673.27448726, 4803088.006683488],
              [-10713273.02354964, 4803105.335155924],
              [-10713332.134199252, 4853502.924173995],
              [-10713299.615372725, 4866042.700461116],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ottawa',
        GEOID: '20143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10901697.403043421, 4761440.990706943],
              [-10901417.211885093, 4765655.827970035],
              [-10839160.89610303, 4765600.295662836],
              [-10839307.281233422, 4740591.519174572],
              [-10839358.488199187, 4715636.030171608],
              [-10901357.433318539, 4715713.764275752],
              [-10901489.458234617, 4753129.395493434],
              [-10901697.403043421, 4761440.990706943],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scott',
        GEOID: '20171',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11257559.65502918, 4678875.808055769],
              [-11223086.123800829, 4678769.969880646],
              [-11208537.556910073, 4678792.792035787],
              [-11208169.42335402, 4616807.004526002],
              [-11254764.31129587, 4616866.55171889],
              [-11257232.264406757, 4616859.7463079905],
              [-11257559.65502918, 4678875.808055769],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ashland',
        GEOID: '55003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10105240.621501222, 5946045.272478935],
              [-10101150.632089986, 5947969.31987081],
              [-10091158.817235364, 5951003.484909287],
              [-10081197.281282237, 5948117.630093197],
              [-10079409.378940605, 5944911.882172952],
              [-10075707.783232749, 5935776.986058295],
              [-10077091.818461781, 5931579.11493775],
              [-10079880.14906717, 5928286.056175728],
              [-10089678.490646794, 5926862.322807568],
              [-10094389.754136149, 5934900.326349107],
              [-10098017.211063137, 5939668.461051417],
              [-10104245.870531494, 5942453.906330238],
              [-10105240.621501222, 5946045.272478935],
            ],
          ],
          [
            [
              [-10121750.236551128, 5874999.64774979],
              [-10118753.360530145, 5874280.802348437],
              [-10111041.48016646, 5879629.894615374],
              [-10107228.119689845, 5881068.335187854],
              [-10102832.3356374, 5884529.338447076],
              [-10100825.57917687, 5891988.074526934],
              [-10092589.384011546, 5884373.184521195],
              [-10081712.022607664, 5874579.1484300485],
              [-10079821.656904876, 5874796.882478414],
              [-10080227.799836919, 5819030.126075284],
              [-10066173.825443758, 5818965.584259102],
              [-10066206.776013033, 5805070.300868278],
              [-10052491.99210832, 5805198.70006174],
              [-10052379.67074211, 5777360.888016023],
              [-10094113.904437963, 5777393.728402205],
              [-10121744.069969798, 5777313.790308572],
              [-10121678.280150738, 5805161.2568002585],
              [-10121750.236551128, 5874999.64774979],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '20201',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10839089.655560171, 4866224.098133224],
              [-10799010.850080656, 4866154.8809537],
              [-10788685.077362103, 4866153.586300824],
              [-10783943.423043314, 4866152.991788832],
              [-10776368.799611777, 4866141.1416609585],
              [-10776417.00095129, 4840912.130116973],
              [-10776455.183536634, 4803134.649223399],
              [-10793395.227048099, 4803131.47232524],
              [-10839020.076947175, 4803220.570260402],
              [-10839030.763618292, 4815795.37585694],
              [-10839089.655560171, 4866224.098133224],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fulton',
        GEOID: '05049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10258166.439895427, 4360761.137040285],
              [-10258125.168138688, 4369382.983879042],
              [-10254799.259558342, 4369390.294250169],
              [-10239812.638850885, 4369423.235012755],
              [-10204918.482077906, 4369537.568504509],
              [-10201606.453776745, 4369548.420693119],
              [-10180167.980529418, 4369299.880520264],
              [-10180661.357625518, 4346879.561666816],
              [-10193065.577165121, 4347146.960048175],
              [-10193089.176897168, 4335068.145344626],
              [-10207043.85430454, 4335531.408374686],
              [-10258869.199840805, 4336628.49348251],
              [-10258166.439895427, 4360761.137040285],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cass',
        GEOID: '29037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10532154.989554215, 4657079.680343431],
              [-10531880.21453701, 4684226.019284004],
              [-10531876.46614862, 4684596.840158712],
              [-10531821.289947208, 4699809.474876063],
              [-10477289.84064323, 4697802.272975566],
              [-10477353.070114002, 4660080.213348666],
              [-10471191.870257068, 4659890.568156981],
              [-10471581.822433315, 4645469.035525289],
              [-10471347.272266215, 4642778.165279884],
              [-10487595.576461893, 4642708.091821709],
              [-10498782.74000865, 4646248.182028323],
              [-10532256.02063048, 4647116.428604466],
              [-10532154.989554215, 4657079.680343431],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Story',
        GEOID: '19169',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10430457.062949555, 5192389.17464857],
              [-10404258.354749832, 5192383.613898997],
              [-10378507.81882004, 5192321.093263104],
              [-10378522.95827079, 5140436.350907465],
              [-10391444.368164618, 5140495.094013016],
              [-10430417.210571853, 5140534.854182479],
              [-10430457.062949555, 5192389.17464857],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Meigs',
        GEOID: '47121',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9463976.011866288, 4219641.793782022],
              [-9458700.581197595, 4227482.519034766],
              [-9452377.077523082, 4224202.277346828],
              [-9446566.311423166, 4231638.104560944],
              [-9448127.010684088, 4238907.118714812],
              [-9439325.535144517, 4239226.32982152],
              [-9437867.249815123, 4255843.88866509],
              [-9431347.935156306, 4258004.0325486185],
              [-9431416.174004162, 4266673.296564979],
              [-9419747.442340229, 4260500.200412074],
              [-9419840.282795552, 4251835.418220037],
              [-9440020.502725538, 4225911.767523037],
              [-9446590.245113686, 4211557.156601279],
              [-9448743.498024099, 4211988.040125196],
              [-9456183.202232795, 4203049.8020937005],
              [-9465642.575962953, 4215570.88092488],
              [-9463976.011866288, 4219641.793782022],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: "St. Mary's",
        GEOID: '24037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8557291.783735497, 4634658.230940387],
              [-8545806.951870354, 4652143.889711462],
              [-8535323.77278337, 4650248.069528966],
              [-8528005.072861167, 4639560.396803232],
              [-8516105.241934348, 4632181.614969685],
              [-8510759.457347473, 4622610.2208322445],
              [-8504830.76212838, 4624712.062224935],
              [-8505131.255212456, 4623510.352810567],
              [-8501968.334520547, 4621374.848729345],
              [-8503992.902099604, 4613337.698844297],
              [-8499634.521396067, 4604620.967154233],
              [-8495918.676793385, 4598986.948690082],
              [-8497105.11992626, 4593467.470502052],
              [-8496136.529036868, 4584583.746664113],
              [-8501668.77377082, 4590671.784251217],
              [-8508195.992113486, 4596304.381165884],
              [-8513829.982862024, 4595807.738236322],
              [-8520436.12672366, 4601060.911083238],
              [-8526030.71037246, 4609731.137224003],
              [-8535250.74719741, 4612591.937922392],
              [-8542663.846047807, 4612708.999825089],
              [-8549999.13257414, 4615125.363810124],
              [-8552346.541068092, 4615979.490225175],
              [-8557291.783735497, 4634658.230940387],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Winnebago',
        GEOID: '17201',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9952120.195602246, 5236240.510122178],
              [-9948155.195339337, 5236177.704600818],
              [-9912210.064117396, 5235608.353534842],
              [-9906606.488839032, 5235547.920148891],
              [-9900798.353615059, 5235485.281035025],
              [-9900725.677530218, 5183823.620361634],
              [-9917657.260760386, 5183577.519325311],
              [-9926670.577290934, 5183519.861431608],
              [-9926692.952508584, 5191623.024222188],
              [-9951538.572297717, 5191273.633265565],
              [-9951718.575914329, 5207103.806840273],
              [-9952120.195602246, 5236240.510122178],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Humphreys',
        GEOID: '47085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9798607.633206936, 4295919.000319996],
              [-9787103.097791923, 4318530.700417823],
              [-9790505.021430565, 4334131.603117346],
              [-9773685.202969156, 4334351.617668935],
              [-9750025.914993407, 4327858.658964179],
              [-9747891.363757446, 4325121.8990681255],
              [-9746341.351167642, 4302855.788268757],
              [-9744299.306428527, 4299668.406969673],
              [-9763436.017451817, 4287661.14225212],
              [-9764585.057235787, 4278456.244720869],
              [-9779715.82506339, 4273657.892201069],
              [-9791967.425581116, 4278754.36666013],
              [-9787859.17977339, 4291053.139919768],
              [-9798607.633206936, 4295919.000319996],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kimball',
        GEOID: '31105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11583142.782880187, 5029238.731860896],
              [-11583066.08375103, 5053463.402768237],
              [-11583047.619645841, 5070514.794413083],
              [-11507944.017820533, 5070725.3599881055],
              [-11507766.017954756, 5019390.4309617635],
              [-11508486.327628251, 5012625.774185802],
              [-11529779.781907223, 5012595.632136616],
              [-11529863.04819671, 5012595.5142688155],
              [-11583154.694065703, 5012549.050738533],
              [-11583142.782880187, 5029238.731860896],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sublette',
        GEOID: '56035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12314544.342683306, 5278424.753977138],
              [-12310562.221858649, 5278422.175650303],
              [-12310599.068610102, 5331192.4598484],
              [-12309559.678524565, 5347844.149396489],
              [-12309528.954345105, 5356468.307717081],
              [-12283433.327993857, 5356395.662399957],
              [-12283462.159741972, 5369672.874999858],
              [-12251523.707277454, 5369649.901695938],
              [-12250884.733400302, 5382986.275387254],
              [-12217839.208599847, 5382743.485232556],
              [-12217810.822129695, 5367833.19960842],
              [-12211185.086037677, 5367871.021613603],
              [-12210937.288851174, 5352399.51459074],
              [-12206343.690063588, 5337431.0877409205],
              [-12196213.6164014, 5324695.83872204],
              [-12195337.309369875, 5313880.453150482],
              [-12189752.187877797, 5313571.86519468],
              [-12178102.603166278, 5302721.736938399],
              [-12168930.211083386, 5290099.093098463],
              [-12148553.734891132, 5272099.365897679],
              [-12148793.183115829, 5265554.676330799],
              [-12141934.232690599, 5265437.296524155],
              [-12141558.640728664, 5226134.994839332],
              [-12138707.414610974, 5200560.232465861],
              [-12189123.678032776, 5200505.17888688],
              [-12251122.73447162, 5201622.257494168],
              [-12305438.408336418, 5202637.309576022],
              [-12305627.094873311, 5228406.570136837],
              [-12310837.069681417, 5228391.332970077],
              [-12310830.724470444, 5267947.726240734],
              [-12314549.12942141, 5267961.966998104],
              [-12314544.342683306, 5278424.753977138],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Martin',
        GEOID: '27091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10559148.405559083, 5441965.166460558],
              [-10505106.132363673, 5441957.139865823],
              [-10491541.741091022, 5441941.549769119],
              [-10491635.743894951, 5388416.202370332],
              [-10507513.193713095, 5388461.248127587],
              [-10513329.969920952, 5388462.707230125],
              [-10559160.769548949, 5388474.2036123425],
              [-10559148.405559083, 5441965.166460558],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Horry',
        GEOID: '45051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8831985.540328832, 4024737.1547106057],
              [-8827896.218834542, 4033129.0715465923],
              [-8821799.584282266, 4036494.4482896365],
              [-8817370.515702074, 4049482.7097522696],
              [-8808341.837081794, 4060449.345457262],
              [-8808507.035206132, 4062912.3576334016],
              [-8803820.707282716, 4068476.5074504726],
              [-8802171.754046177, 4069063.6112697553],
              [-8802170.575303806, 4069062.388284627],
              [-8802162.269508878, 4069053.770744861],
              [-8773279.425747145, 4039684.34611043],
              [-8755374.94139627, 4021426.735687417],
              [-8751485.51847862, 4017464.461536129],
              [-8743153.811190197, 4008827.4831866473],
              [-8757755.922756024, 4004334.6373765687],
              [-8768940.971232459, 3997760.901961658],
              [-8778981.321385069, 3989346.696499021],
              [-8787346.42452073, 3980541.3833330395],
              [-8793697.75694388, 3971564.5658577713],
              [-8805491.27888105, 3971605.31610857],
              [-8809566.574119503, 3983791.560672334],
              [-8815419.864264904, 3989364.4937282917],
              [-8823214.343690759, 4003968.452614383],
              [-8822743.016966738, 4011635.451940403],
              [-8829012.864646688, 4021419.3928053537],
              [-8831985.540328832, 4024737.1547106057],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brewster',
        GEOID: '48043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11555038.841595536, 3556687.3226688863],
              [-11514885.455988439, 3589440.5355104157],
              [-11417711.66684874, 3510339.6271601347],
              [-11392460.621474138, 3489757.938201777],
              [-11390063.796462629, 3487131.9945938424],
              [-11393534.40928233, 3485864.226149432],
              [-11395723.061790816, 3480484.1237416635],
              [-11398326.156763526, 3473451.3769253823],
              [-11406790.890843447, 3475278.653505143],
              [-11411660.116690235, 3475340.9865868506],
              [-11415934.117219752, 3471757.3256321936],
              [-11422813.439111797, 3471221.8820931897],
              [-11429972.729523184, 3469949.908453845],
              [-11431784.342916353, 3462035.2407307415],
              [-11436789.489861399, 3455044.326975978],
              [-11441142.415909888, 3446668.1093369084],
              [-11444611.242562497, 3442295.0010906705],
              [-11447091.21817839, 3432313.7058295486],
              [-11446378.105520368, 3426599.773868905],
              [-11451642.738198455, 3420536.3662408227],
              [-11453776.17623951, 3412240.08647238],
              [-11451585.96525815, 3406435.575490066],
              [-11456757.646161426, 3399939.9517145376],
              [-11465427.542062877, 3396181.647264026],
              [-11469879.765097154, 3388765.864803688],
              [-11474407.351426698, 3386561.0554307844],
              [-11477080.466359118, 3379067.319725938],
              [-11480017.074526245, 3373371.0173535263],
              [-11491266.243029376, 3374568.2924067657],
              [-11497209.479323339, 3373372.798931921],
              [-11506204.984735362, 3378053.5836280463],
              [-11517470.294564659, 3384153.7304272237],
              [-11524307.20373071, 3391055.4013719107],
              [-11531848.765273482, 3394784.702181318],
              [-11539401.013487369, 3397420.1441843486],
              [-11546585.573423168, 3400038.520058926],
              [-11553742.414805759, 3408461.2718939567],
              [-11554281.091038875, 3408682.831923076],
              [-11554160.86477165, 3439464.1061689965],
              [-11555038.841595536, 3556687.3226688863],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McCormick',
        GEOID: '45065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9194436.213290341, 4030617.282099467],
              [-9187260.693320148, 4038463.889957436],
              [-9164593.818604821, 4037415.028494762],
              [-9162289.059867436, 4024987.0895020976],
              [-9155477.642864779, 4031324.1344446694],
              [-9150493.980581453, 4025928.488089349],
              [-9133222.093667934, 4026572.7324468615],
              [-9133427.366808955, 4022521.001349118],
              [-9145530.689764947, 4019311.3479215982],
              [-9140858.38809737, 4005981.8765870687],
              [-9148568.264710221, 3991817.028167963],
              [-9138832.262045441, 3979744.8928891164],
              [-9140961.451977186, 3974937.444293974],
              [-9144056.427250078, 3975939.105587174],
              [-9146221.76116379, 3976639.948468124],
              [-9150433.979375917, 3982919.6838038363],
              [-9152236.393854856, 3986951.812153611],
              [-9154814.512658123, 3992721.704713203],
              [-9164319.193421034, 4004662.377971594],
              [-9176193.643503953, 4010964.1632996434],
              [-9185299.577850841, 4020341.639637867],
              [-9190184.833704304, 4021466.6273417766],
              [-9190870.761984702, 4022969.90281851],
              [-9194083.242271885, 4030012.9874910037],
              [-9194436.213290341, 4030617.282099467],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '45087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9104085.3301477, 4141769.05197028],
              [-9096104.167935787, 4152007.0449171653],
              [-9070528.626245523, 4145753.115858284],
              [-9067780.37065682, 4142061.3311004764],
              [-9070140.009903165, 4139651.3079424486],
              [-9071233.278622245, 4127660.996130174],
              [-9063175.862559136, 4114198.168906705],
              [-9063934.17093042, 4105872.622200167],
              [-9064472.84594637, 4100122.0492068334],
              [-9063993.726857994, 4095379.8050615448],
              [-9077103.155371774, 4088716.9103467646],
              [-9088518.63519415, 4100685.5286755543],
              [-9092277.783078749, 4103972.3790544854],
              [-9111945.822031597, 4108917.5742474818],
              [-9104085.3301477, 4141769.05197028],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '53021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13297468.28443216, 5889874.624677818],
              [-13288114.664218253, 5889701.988202522],
              [-13288144.052563822, 5899363.826335713],
              [-13175650.36378166, 5899189.703400902],
              [-13159104.05730913, 5899548.673313813],
              [-13163432.047791684, 5898786.082857587],
              [-13159707.07499076, 5875232.241034123],
              [-13161151.4453838, 5875951.152603485],
              [-13188203.306160966, 5876582.962159745],
              [-13204227.301582694, 5861574.5466098655],
              [-13206257.101177821, 5846946.595661571],
              [-13218766.406316731, 5838149.636434161],
              [-13221070.60845666, 5828219.675905192],
              [-13231516.27287525, 5820898.019311323],
              [-13249626.17291546, 5815136.732609374],
              [-13251638.940628493, 5811278.181350669],
              [-13276451.387209369, 5824140.88898605],
              [-13277111.289150793, 5864286.883030909],
              [-13291885.834607856, 5879139.987220351],
              [-13297468.28443216, 5889874.624677818],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Maui',
        GEOID: '15009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-17443751.96216198, 2382416.9566685413],
              [-17441638.56162927, 2389525.19789418],
              [-17434812.005175862, 2395192.91494416],
              [-17428488.16754288, 2393806.4343878413],
              [-17423582.762861583, 2386473.3361878204],
              [-17419391.361394238, 2379744.0376537475],
              [-17410736.159665566, 2381844.5632401127],
              [-17402889.582718022, 2385494.4668251304],
              [-17392841.662840035, 2384467.975203436],
              [-17387515.58180303, 2379002.412188748],
              [-17380609.20927473, 2375355.978101277],
              [-17372496.133466225, 2369301.7917449446],
              [-17366233.74419216, 2367516.1439106753],
              [-17364216.746338475, 2361408.5331858383],
              [-17366048.73119846, 2355912.145278731],
              [-17370714.798974555, 2351966.2903385265],
              [-17380300.742965743, 2347519.698646046],
              [-17389246.377245888, 2347638.0493136477],
              [-17397498.825056866, 2343828.6164940014],
              [-17407878.477017414, 2341680.915533333],
              [-17413916.33487855, 2344025.431446418],
              [-17415230.0161894, 2350909.35402003],
              [-17416873.648470964, 2360507.568187949],
              [-17417297.10781394, 2362564.0579124247],
              [-17418557.24444972, 2366945.8933808114],
              [-17422171.120398834, 2367982.693513552],
              [-17425702.842563745, 2365475.6378387087],
              [-17427580.24577597, 2366391.020907581],
              [-17436171.550116926, 2370576.0871839863],
              [-17442406.554796252, 2378852.8754326724],
              [-17443751.96216198, 2382416.9566685413],
            ],
          ],
          [
            [
              [-17440476.831423353, 2339479.1348858275],
              [-17433827.161640815, 2343505.3927060426],
              [-17428974.299759172, 2344828.4110262925],
              [-17426290.832114115, 2341881.631145952],
              [-17425913.347720835, 2335643.4804894235],
              [-17431100.279394343, 2333749.668165417],
              [-17440292.04106864, 2332920.912397188],
              [-17444016.34595262, 2336214.884034115],
              [-17440476.831423353, 2339479.1348858275],
            ],
          ],
          [
            [
              [-17483742.376034558, 2381556.287922224],
              [-17478273.360771373, 2383504.828843165],
              [-17470205.814634603, 2382970.538029386],
              [-17463036.394149553, 2379324.6055918345],
              [-17459020.209560715, 2375618.778644908],
              [-17455838.921152823, 2370475.56937819],
              [-17459162.030591987, 2363828.7086248393],
              [-17464947.74980647, 2361481.1456186986],
              [-17467038.99776052, 2360847.641766853],
              [-17473585.585694578, 2360317.5963830505],
              [-17476122.334250778, 2365177.267321763],
              [-17476251.01958213, 2371214.8171577533],
              [-17478374.661507994, 2374534.840595759],
              [-17483801.70932315, 2378127.729259621],
              [-17483742.376034558, 2381556.287922224],
            ],
          ],
          [
            [
              [-17508020.043781664, 2410779.8490342265],
              [-17504955.974797577, 2413880.0683533307],
              [-17506179.93259885, 2418809.4282614035],
              [-17499660.50662054, 2418046.8234920725],
              [-17491431.992500085, 2415920.159266885],
              [-17481611.3870223, 2414657.058839367],
              [-17478748.34648902, 2415825.386733431],
              [-17478786.65494342, 2413635.0870510037],
              [-17474226.00672511, 2412786.3940053605],
              [-17470718.5522092, 2410987.786651299],
              [-17468039.87130224, 2407324.288698711],
              [-17466054.933461905, 2407580.400944576],
              [-17468016.22272309, 2412044.026530014],
              [-17459526.15664637, 2411913.270036752],
              [-17448465.34072166, 2412902.6705393894],
              [-17444777.88258913, 2410806.5871441034],
              [-17448143.738712758, 2405159.178431154],
              [-17455141.059265044, 2399880.750314558],
              [-17463483.007946618, 2397758.057944651],
              [-17472025.109072637, 2399765.3943380956],
              [-17480073.28561801, 2402495.8461016477],
              [-17486139.084671333, 2404042.2984237843],
              [-17496263.14708102, 2402697.0049363337],
              [-17505272.01083194, 2402335.374053724],
              [-17511752.36366898, 2404000.655434916],
              [-17508020.043781664, 2410779.8490342265],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Multnomah',
        GEOID: '41051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13684409.936371982, 5735828.300691762],
              [-13668334.177387035, 5735742.835926663],
              [-13666305.465531392, 5736973.316536912],
              [-13667196.046913164, 5729286.079596439],
              [-13665184.826983104, 5726416.003324225],
              [-13663143.794809308, 5723504.328064459],
              [-13652657.276137602, 5718028.667229739],
              [-13635775.897997783, 5713819.345669506],
              [-13629810.843083622, 5710687.108834087],
              [-13623312.901767038, 5712651.943780574],
              [-13617880.510616329, 5708247.727472411],
              [-13610213.15804896, 5707624.634651846],
              [-13608718.360822931, 5708527.168950148],
              [-13601426.710640647, 5712931.05664473],
              [-13592296.28600578, 5713856.724136927],
              [-13581388.645700403, 5719013.907742816],
              [-13575616.507463789, 5723633.78272606],
              [-13572489.694582885, 5725130.451490693],
              [-13570581.749534192, 5703955.149674819],
              [-13560894.39348689, 5694497.966957514],
              [-13564591.202456642, 5694269.58107925],
              [-13638223.14568338, 5694432.101078303],
              [-13654557.722484423, 5693885.98845074],
              [-13659460.455497941, 5689953.882217288],
              [-13663768.51979164, 5689994.650988185],
              [-13663767.629235713, 5690801.022456514],
              [-13663783.881881367, 5703229.885225972],
              [-13684407.932621147, 5722099.236882946],
              [-13684409.936371982, 5735828.300691762],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kauai',
        GEOID: '15007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-17787045.241761763, 2519318.679506918],
              [-17782759.55268571, 2523236.2666187356],
              [-17781122.82221258, 2528336.5768714976],
              [-17778338.38778937, 2530664.400713892],
              [-17767887.602674205, 2535721.503019437],
              [-17764482.116811853, 2538378.8709400194],
              [-17760348.37884074, 2538163.259830019],
              [-17756656.133970108, 2535981.2092150105],
              [-17754116.157148678, 2539103.286740339],
              [-17747856.439542387, 2537961.2396516385],
              [-17744601.346312106, 2539475.0068646963],
              [-17740041.8112887, 2537249.0175752644],
              [-17734563.333868805, 2533520.6533934907],
              [-17732417.094086308, 2526294.465979862],
              [-17735229.803660177, 2518900.677547281],
              [-17737034.18128645, 2516532.3141630343],
              [-17736819.89126667, 2511447.434887405],
              [-17737389.40178157, 2505663.9788525705],
              [-17742687.20766791, 2501015.7315525725],
              [-17749321.51536072, 2495759.625417561],
              [-17758455.279580306, 2497590.0575988684],
              [-17763754.42130054, 2498660.1695830585],
              [-17766955.747216772, 2498593.2256374788],
              [-17772130.65638528, 2503584.747617482],
              [-17778590.415116522, 2506870.9492836064],
              [-17783822.431183808, 2508856.707143611],
              [-17787374.302176546, 2513782.669034414],
              [-17787045.241761763, 2519318.679506918],
            ],
          ],
          [
            [
              [-17838904.98502068, 2489345.5994392564],
              [-17836606.79413325, 2498217.600579623],
              [-17832709.944038544, 2502209.293797132],
              [-17826374.863136988, 2505359.009086311],
              [-17824728.670507137, 2507069.238592504],
              [-17823669.354232747, 2510954.3498990852],
              [-17819147.222558256, 2511925.526053863],
              [-17817635.50387328, 2511090.616175745],
              [-17816810.069849048, 2509251.4135308894],
              [-17818943.39657061, 2507197.6717601484],
              [-17820668.29208045, 2502798.366154977],
              [-17819920.00246334, 2499052.960664203],
              [-17824953.647198033, 2496738.694553536],
              [-17828494.608880676, 2495676.0196823473],
              [-17830576.728636473, 2493156.403866293],
              [-17832244.962525498, 2490221.5370394117],
              [-17834033.755423058, 2485074.2302980553],
              [-17836763.531976286, 2486291.8585170833],
              [-17838904.98502068, 2489345.5994392564],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cass',
        GEOID: '27021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10551654.600077862, 5910131.088850521],
              [-10537496.54196081, 5910094.172000062],
              [-10538640.01577024, 6009280.015732764],
              [-10510384.123380655, 6009556.202854287],
              [-10510372.100875648, 6014985.997269776],
              [-10500492.718706727, 6010216.521514061],
              [-10474620.287934517, 6020443.245684291],
              [-10467133.272942234, 6009030.319886427],
              [-10468739.50187489, 6003189.5231110165],
              [-10454180.916229963, 5990829.965224907],
              [-10451588.062650407, 5994275.677526814],
              [-10438875.042843344, 5992010.560274863],
              [-10442750.074317858, 5980126.906437224],
              [-10438866.13728408, 5976637.804086826],
              [-10439013.858248362, 5947040.4783300245],
              [-10439099.240297802, 5909960.0041416995],
              [-10502204.701155636, 5910389.023262194],
              [-10500872.652128804, 5882074.330194615],
              [-10502067.66686247, 5824963.87215559],
              [-10511513.12565628, 5833767.184336504],
              [-10523557.337962657, 5829006.139656754],
              [-10536775.19166047, 5836402.264367127],
              [-10543862.235722331, 5836836.091267936],
              [-10545455.88555253, 5839616.477097192],
              [-10550763.48755406, 5843749.076594355],
              [-10551654.600077862, 5910131.088850521],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Irwin',
        GEOID: '13155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9295255.627520878, 3710132.7089776713],
              [-9289936.448292304, 3725119.9444874967],
              [-9290016.04172822, 3731567.920514112],
              [-9275729.520918794, 3731400.735580016],
              [-9275765.254475338, 3721457.443521581],
              [-9269169.129367875, 3718004.4998839665],
              [-9259151.82234986, 3721166.9137438866],
              [-9239335.171876805, 3720484.372702309],
              [-9246064.101136787, 3712383.6626007035],
              [-9251947.670183685, 3695013.270254238],
              [-9255724.406547826, 3694236.2606048184],
              [-9277224.764319131, 3694721.151640182],
              [-9286365.430347148, 3704850.7058123006],
              [-9295283.346074088, 3707013.1429992127],
              [-9295255.627520878, 3710132.7089776713],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Williams',
        GEOID: '39171',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9440569.864412602, 5115563.204513563],
              [-9399602.622008316, 5116877.331738036],
              [-9395314.793981038, 5117029.175793959],
              [-9393284.684308343, 5103739.239597206],
              [-9388897.58317618, 5084221.536262935],
              [-9388871.089137372, 5075613.88131023],
              [-9440366.289741125, 5075388.46820541],
              [-9440444.758697465, 5090854.163933776],
              [-9440569.864412602, 5115563.204513563],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hubbard',
        GEOID: '27057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10595747.13718617, 6009711.32551003],
              [-10553080.380115941, 6009230.174682625],
              [-10538640.01577024, 6009280.015732764],
              [-10537496.54196081, 5910094.172000062],
              [-10551654.600077862, 5910131.088850521],
              [-10593497.8155552, 5910257.452993587],
              [-10594183.766257469, 5967004.0303149745],
              [-10594235.084542723, 5995350.156705539],
              [-10595747.13718617, 6009711.32551003],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Box Elder',
        GEOID: '49003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12695113.51037267, 5012330.748870536],
              [-12695035.809368096, 5043033.499447262],
              [-12694900.44486729, 5085138.588789126],
              [-12694863.70943533, 5124168.090654713],
              [-12695066.533547556, 5160038.776920894],
              [-12670157.795607144, 5159268.936906446],
              [-12634377.930154333, 5159976.618270285],
              [-12606838.712646475, 5160410.6888324665],
              [-12579193.852941856, 5160713.261784365],
              [-12579106.927962419, 5160713.952701085],
              [-12539920.113951007, 5161025.431271843],
              [-12497275.509459447, 5161127.892199628],
              [-12485502.521694504, 5160782.005561605],
              [-12468761.355851224, 5130332.228400431],
              [-12472546.552496666, 5117701.921502173],
              [-12465672.573940182, 5091445.895785377],
              [-12461781.623778483, 5094258.735348502],
              [-12453667.323455581, 5084170.269497057],
              [-12455030.541939834, 5075436.613335054],
              [-12463139.387607688, 5076550.0112394085],
              [-12463684.18519563, 5066378.757618797],
              [-12470974.721286666, 5062104.534818781],
              [-12494284.243422342, 5062110.465191275],
              [-12522720.807345483, 5023689.249685975],
              [-12556767.20568766, 5012332.666365606],
              [-12695113.526651476, 5012326.409029432],
              [-12695113.51037267, 5012330.748870536],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lenoir',
        GEOID: '37107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8662667.704276336, 4212552.431575537],
              [-8661351.907895159, 4214106.943715963],
              [-8649247.917022225, 4215245.939148558],
              [-8646932.805572197, 4211184.56580193],
              [-8624534.878746629, 4222014.080382268],
              [-8619072.765291873, 4211514.164712524],
              [-8615129.606288996, 4210118.588926549],
              [-8619615.002531528, 4208787.865992887],
              [-8624331.943314912, 4195042.996085773],
              [-8630286.422877444, 4196953.239942631],
              [-8628091.313838493, 4187390.7463074266],
              [-8638535.197145225, 4173584.004652099],
              [-8652978.233158708, 4164987.120759299],
              [-8654684.538313588, 4167971.822760807],
              [-8657225.183051962, 4183681.981089621],
              [-8664468.964956863, 4188076.0466039465],
              [-8662667.704276336, 4212552.431575537],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Duchesne',
        GEOID: '49013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12344484.387649102, 4972151.214934259],
              [-12336805.12389622, 4969730.278535589],
              [-12328715.2025418, 4975199.277766317],
              [-12318223.229215043, 4974107.436926043],
              [-12314800.711470604, 4978397.923174628],
              [-12307636.189043147, 4976765.623428357],
              [-12287329.844130093, 4981001.260549872],
              [-12277765.83007859, 4987799.024445995],
              [-12260485.928161731, 4984491.253717392],
              [-12245223.135418046, 4984897.9346098825],
              [-12242517.069916354, 4984310.789903926],
              [-12242562.93354656, 4837823.975436618],
              [-12340631.620072749, 4838846.346014202],
              [-12340616.81458047, 4851378.659512521],
              [-12344402.567823369, 4851370.968983971],
              [-12345551.273648866, 4964985.9064198015],
              [-12344484.387649102, 4972151.214934259],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Emery',
        GEOID: '49015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12390489.950206693, 4651748.394395676],
              [-12389788.080817241, 4726294.168019721],
              [-12389961.739222879, 4782387.450003421],
              [-12384042.659258418, 4788816.49331755],
              [-12384002.918200204, 4823071.780901693],
              [-12374175.856191957, 4807398.9553040285],
              [-12371171.120496465, 4809976.994491291],
              [-12365964.48527308, 4796652.84116789],
              [-12365517.426198056, 4788853.408165741],
              [-12365095.74796693, 4789183.3406525655],
              [-12247828.790739045, 4789114.988363551],
              [-12246325.866293844, 4781482.792997698],
              [-12253745.64431369, 4761264.829548145],
              [-12251218.691872682, 4754424.105387268],
              [-12256138.23412931, 4748853.578867939],
              [-12256210.369159343, 4741210.781438852],
              [-12262534.5407508, 4726350.057822132],
              [-12255868.061725153, 4719703.196888821],
              [-12249727.678612998, 4720742.837767546],
              [-12245587.484111413, 4714499.290627203],
              [-12252837.72254678, 4718661.514629968],
              [-12261881.206659334, 4718777.506396951],
              [-12260778.921061499, 4710837.13842855],
              [-12265098.22862377, 4708394.339296074],
              [-12254479.351077506, 4686202.850388902],
              [-12257716.410550283, 4683305.450095295],
              [-12252990.78684662, 4672554.9721598765],
              [-12249189.782833483, 4671989.771201782],
              [-12251589.051818551, 4662220.087573303],
              [-12244507.573731227, 4654159.872755908],
              [-12247971.724965224, 4650299.134147595],
              [-12340890.994486295, 4650298.991905965],
              [-12389967.41651691, 4650298.707422708],
              [-12390489.950206693, 4651748.394395676],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hudspeth',
        GEOID: '48229',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11799640.173723338, 3763569.8256488587],
              [-11772094.81676033, 3763600.202408094],
              [-11705689.066958945, 3763375.8662945516],
              [-11679458.075470142, 3763372.594230809],
              [-11678849.492450723, 3714201.773017066],
              [-11679249.908659106, 3609528.747189921],
              [-11679325.160634883, 3589141.1956084184],
              [-11686404.066276273, 3584636.56397558],
              [-11688684.569462309, 3590300.417263121],
              [-11695485.522432832, 3592076.278388228],
              [-11699487.235487869, 3596298.327054549],
              [-11706374.683702739, 3601238.6585627496],
              [-11712887.653150583, 3607005.5660579316],
              [-11723596.922123369, 3609000.790124704],
              [-11732433.351983046, 3613670.351101915],
              [-11733030.803690134, 3618334.401740835],
              [-11742873.450427094, 3625384.900806005],
              [-11750599.357046619, 3631480.2580394926],
              [-11753060.853627041, 3637346.8414455745],
              [-11758382.704523394, 3645553.7113473406],
              [-11767526.710136136, 3650472.7267111517],
              [-11774625.10878606, 3654442.9168178975],
              [-11776977.17830703, 3659041.803582596],
              [-11785322.46657333, 3670290.7676938423],
              [-11793014.532067655, 3674212.500336199],
              [-11794738.98229953, 3680209.894722156],
              [-11799468.544296091, 3683220.6634216765],
              [-11794781.840303488, 3687867.505130818],
              [-11799115.174121598, 3695034.5463690404],
              [-11799282.264677279, 3721337.751213481],
              [-11799640.173723338, 3763569.8256488587],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lafayette',
        GEOID: '12067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9280400.932030443, 3537071.097947834],
              [-9267041.813898817, 3537100.740436633],
              [-9264637.980814625, 3518124.533934936],
              [-9257390.859325001, 3517674.3917142474],
              [-9235411.382465323, 3502656.517085039],
              [-9226137.355687337, 3489013.3566630417],
              [-9227647.849857911, 3481310.9741742103],
              [-9230679.858828647, 3480965.035228985],
              [-9275012.95735656, 3480769.9995812513],
              [-9278797.93136302, 3480718.5465923203],
              [-9280805.021782024, 3489152.9222784536],
              [-9280400.932030443, 3537071.097947834],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fulton',
        GEOID: '17057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10068873.211776005, 4906180.159945852],
              [-10068347.67245997, 4957602.599458461],
              [-10068217.762614215, 4970375.293830053],
              [-10017202.822970925, 4970007.107073899],
              [-10017531.660746729, 4957308.08109418],
              [-10004673.369004179, 4957109.638205603],
              [-10004556.81749732, 4940791.088585987],
              [-10005978.59003373, 4937768.348471592],
              [-10010369.587348072, 4929492.817882445],
              [-10022978.746070225, 4920592.828026777],
              [-10031997.405936334, 4900189.1855704645],
              [-10040968.643699363, 4892708.780747158],
              [-10069015.144126765, 4893429.637133944],
              [-10068873.211776005, 4906180.159945852],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grant',
        GEOID: '31075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11362007.504975276, 5162356.909986296],
              [-11355541.178394077, 5162312.86394869],
              [-11355278.687034784, 5175421.350988185],
              [-11290752.678154936, 5174799.678103199],
              [-11290681.767639302, 5122568.296524995],
              [-11352976.48864569, 5122453.566848176],
              [-11362148.658089602, 5122425.071133658],
              [-11362007.504975276, 5162356.909986296],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Benton',
        GEOID: '47005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9819777.149451602, 4317185.7391081415],
              [-9805602.727369403, 4335703.687664119],
              [-9805809.113705333, 4337546.613236553],
              [-9806319.847529093, 4338554.5640456425],
              [-9806415.137013212, 4339360.3020931445],
              [-9806006.037884546, 4340399.220011663],
              [-9806546.939290313, 4341016.845696353],
              [-9806220.995821267, 4341268.49135558],
              [-9807543.248732911, 4343490.051011859],
              [-9806386.52790408, 4347549.797541365],
              [-9806787.166751444, 4350168.954435405],
              [-9799652.811905995, 4350244.152311658],
              [-9795104.408831673, 4350288.939531823],
              [-9793971.176415395, 4349345.406211097],
              [-9789914.137573434, 4337032.870730391],
              [-9790505.021430565, 4334131.603117346],
              [-9787103.097791923, 4318530.700417823],
              [-9798607.633206936, 4295919.000319996],
              [-9787859.17977339, 4291053.139919768],
              [-9791967.425581116, 4278754.36666013],
              [-9792857.758868482, 4275292.205761424],
              [-9801863.171715185, 4279989.922591389],
              [-9815914.363121076, 4279430.011756736],
              [-9820320.0546082, 4279531.774131539],
              [-9819777.149451602, 4317185.7391081415],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wise',
        GEOID: '48497',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10900202.938879522, 3953035.9693287318],
              [-10852210.434730763, 3953010.3578870604],
              [-10843271.813578535, 3952934.190861503],
              [-10840636.547272986, 3952579.3738446413],
              [-10841702.43139733, 3919687.1222205097],
              [-10842349.19763884, 3894088.056984945],
              [-10858568.55876691, 3894531.0830392023],
              [-10873639.436708467, 3894822.5497018737],
              [-10900587.32508123, 3895474.3941586562],
              [-10900202.938879522, 3953035.9693287318],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Knott',
        GEOID: '21119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9253360.091882868, 4495706.136784245],
              [-9249371.06924978, 4512212.259091157],
              [-9233789.680123447, 4509475.780572455],
              [-9231219.980997976, 4507140.817033309],
              [-9220757.396016788, 4504400.613326608],
              [-9221203.007938433, 4497033.598329695],
              [-9213142.474929582, 4498589.991680525],
              [-9211949.01866879, 4482130.870133673],
              [-9207324.695701744, 4478952.10670736],
              [-9209761.256716227, 4477018.534610674],
              [-9219410.43017819, 4476622.518605721],
              [-9237200.39800186, 4463167.238912173],
              [-9239533.5432094, 4466421.459278948],
              [-9246906.78968209, 4473227.267913832],
              [-9253633.603871746, 4472049.619312414],
              [-9253360.091882868, 4495706.136784245],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pitt',
        GEOID: '37147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8645642.835312886, 4255984.623530225],
              [-8630740.60639988, 4266759.988301372],
              [-8615032.535693023, 4277675.206673458],
              [-8610603.689751813, 4275775.848133156],
              [-8600009.525132509, 4271263.418736176],
              [-8590970.382480096, 4263921.328896908],
              [-8593394.030433645, 4259389.671160015],
              [-8590833.014228454, 4251075.047315139],
              [-8581158.682561575, 4239331.276093447],
              [-8582822.129712498, 4239076.506049326],
              [-8591212.836331042, 4234611.054997671],
              [-8592652.976583436, 4220881.214566457],
              [-8599196.447571753, 4212149.642850218],
              [-8604366.570002155, 4215524.460084297],
              [-8615129.606288996, 4210118.588926549],
              [-8619072.765291873, 4211514.164712524],
              [-8624534.878746629, 4222014.080382268],
              [-8627639.913303325, 4234496.580138686],
              [-8639546.868677557, 4241279.1900335485],
              [-8649601.467724985, 4252882.572817691],
              [-8645642.835312886, 4255984.623530225],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Creek',
        GEOID: '40037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10755849.611832324, 4322649.728619388],
              [-10753341.917663224, 4323151.618414662],
              [-10719831.85662769, 4322973.748211371],
              [-10719820.502039628, 4311053.461628534],
              [-10689964.2806504, 4310996.578905178],
              [-10689959.93919026, 4299023.558785994],
              [-10689962.83349702, 4287022.228498589],
              [-10690357.795050355, 4280938.417078742],
              [-10702429.61459045, 4280998.5763354665],
              [-10708086.982432054, 4280969.183415085],
              [-10708107.131259887, 4251073.26664902],
              [-10755761.335476125, 4251062.034761708],
              [-10755811.31792749, 4292577.457436398],
              [-10755849.611832324, 4322649.728619388],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Williamsburg',
        GEOID: '51830',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8541306.193538092, 4481835.28693388],
              [-8536164.457577841, 4479971.428614203],
              [-8535995.363271328, 4476248.478306277],
              [-8534254.883032775, 4474093.039625415],
              [-8542784.96165379, 4477281.247897675],
              [-8541306.193538092, 4481835.28693388],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Habersham',
        GEOID: '13137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9312119.639820134, 4139852.541452815],
              [-9304850.811029807, 4139445.467711725],
              [-9299062.97674499, 4128605.838470614],
              [-9287548.199936826, 4129589.236516611],
              [-9278435.977253567, 4125490.2039439324],
              [-9277370.716058766, 4121335.6148172077],
              [-9280154.248038847, 4119843.8758366],
              [-9290699.09812373, 4093592.069333626],
              [-9299344.837695679, 4095022.5593657875],
              [-9308007.16387176, 4086923.6177178267],
              [-9313702.714298705, 4096625.5939317965],
              [-9308173.475191003, 4101731.080811616],
              [-9313302.409409814, 4117745.028268773],
              [-9308902.72917519, 4127546.6722291666],
              [-9315392.655488439, 4136854.6187948356],
              [-9312119.639820134, 4139852.541452815],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Douglas',
        GEOID: '46043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10987877.39059187, 5388284.763825435],
              [-10944998.56989168, 5388182.251008927],
              [-10922084.899865264, 5388127.925814434],
              [-10921498.691426747, 5341980.751124665],
              [-10987996.836405488, 5368471.753705076],
              [-10987877.39059187, 5388284.763825435],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lewis',
        GEOID: '36049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8442532.520676712, 5447504.722683929],
              [-8433359.460676873, 5446703.004606533],
              [-8416162.046502693, 5461011.610581256],
              [-8409396.938408203, 5460459.737247405],
              [-8402899.2197306, 5476927.655007725],
              [-8409729.561046695, 5481392.1202404965],
              [-8398624.106006175, 5499186.810319343],
              [-8367903.822729411, 5480459.09263646],
              [-8361224.764601304, 5406089.785387961],
              [-8408350.75783373, 5376082.809084288],
              [-8433143.055586772, 5383845.984628646],
              [-8435184.65504792, 5417421.822295444],
              [-8436543.420752542, 5432742.4391129995],
              [-8443642.821277885, 5433292.344122371],
              [-8442532.520676712, 5447504.722683929],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Otoe',
        GEOID: '31131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10738297.088482514, 4980527.848125025],
              [-10668219.222235074, 4980502.029730483],
              [-10668209.446523141, 4980389.063243247],
              [-10674280.922870498, 4973522.262796853],
              [-10669531.699434785, 4965638.095478093],
              [-10662393.337087667, 4961333.100739463],
              [-10658688.290475594, 4954011.487724487],
              [-10660582.836889405, 4951351.118478886],
              [-10659632.725035483, 4942674.714382615],
              [-10654866.135759206, 4942853.094013989],
              [-10654642.31365193, 4942347.316554126],
              [-10694130.857871301, 4942258.507848747],
              [-10738282.39430973, 4942238.737745191],
              [-10738297.088482514, 4980527.848125025],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fillmore',
        GEOID: '31059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10889804.696564011, 4967977.115189253],
              [-10839000.818675267, 4967990.036258845],
              [-10839032.767369125, 4916991.701230458],
              [-10889363.426102506, 4917014.049898293],
              [-10889730.557783144, 4917013.465618749],
              [-10889804.696564011, 4967977.115189253],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fannin',
        GEOID: '13111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9420020.397731656, 4162295.214870235],
              [-9407504.636062277, 4162254.99546098],
              [-9386667.51981712, 4162305.949129048],
              [-9365247.196600344, 4162243.303862969],
              [-9370744.936451504, 4157371.727713471],
              [-9362795.388974976, 4148521.365248972],
              [-9361211.423940478, 4136926.333933791],
              [-9368429.602362495, 4116180.926964086],
              [-9371827.295860486, 4110018.8007199187],
              [-9372739.78172652, 4112079.0049049295],
              [-9389093.394160487, 4140095.002816148],
              [-9397897.9866458, 4144165.831110814],
              [-9419703.582460858, 4144247.6318067657],
              [-9420159.324456166, 4146917.5395843037],
              [-9420020.397731656, 4162295.214870235],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tensas',
        GEOID: '22107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10194162.63074689, 3747904.6553209242],
              [-10186999.555472814, 3754128.821840474],
              [-10188873.062502865, 3757974.9465108314],
              [-10184593.607318299, 3775448.574385652],
              [-10184922.779052574, 3790033.0419632844],
              [-10165778.49830391, 3789915.429574969],
              [-10144986.911730487, 3796084.930767693],
              [-10142152.828814382, 3790664.669202326],
              [-10134467.700629052, 3777491.48266979],
              [-10133937.227754857, 3776582.7254283624],
              [-10138879.924465569, 3769909.186116534],
              [-10139069.167599916, 3766389.9856081153],
              [-10143143.572282443, 3761611.777152756],
              [-10149822.853049528, 3759800.704523553],
              [-10150234.735165464, 3752821.696919606],
              [-10156222.499255743, 3747157.813654661],
              [-10157237.305692399, 3746223.105831338],
              [-10162371.3426492, 3741495.4060061784],
              [-10168558.368628, 3742701.3204070795],
              [-10170094.577600947, 3737002.4908759366],
              [-10165746.96519706, 3730250.8765818276],
              [-10165537.380286852, 3729925.497233792],
              [-10172388.93130369, 3728264.704576649],
              [-10174411.10217595, 3730959.2841771063],
              [-10190719.518896652, 3730765.4014987783],
              [-10194377.7000031, 3736543.4155999566],
              [-10194162.63074689, 3747904.6553209242],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Miami-Dade',
        GEOID: '12086',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9002755.093860762, 2969495.5411023553],
              [-9002751.865595527, 2974995.951082912],
              [-9002733.60919904, 2996533.9792038496],
              [-8981260.74734196, 2996449.1541129407],
              [-8981258.298313163, 2993738.4786678106],
              [-8941928.676937938, 2993770.7928126985],
              [-8938419.32999068, 2995436.368314532],
              [-8928516.4594092, 2995699.618980714],
              [-8918375.356644908, 2995714.4149003555],
              [-8918684.276704375, 2988652.679351446],
              [-8918306.930804541, 2983508.353812703],
              [-8918292.568382576, 2983312.587881475],
              [-8917799.175433079, 2976589.022448044],
              [-8919341.284339039, 2969728.1652339],
              [-8922810.667589102, 2957709.08878584],
              [-8925253.462495068, 2960126.521330713],
              [-8931063.338039061, 2965988.57955458],
              [-8935156.77835451, 2956830.132029429],
              [-8939118.082434388, 2951264.6641367753],
              [-8940504.455372728, 2942115.4797765133],
              [-8940733.548817879, 2941308.242480866],
              [-8943079.386514267, 2933044.9428001326],
              [-8940108.380624486, 2923687.7886432307],
              [-8931702.534555195, 2927662.571026988],
              [-8925154.165509282, 2939893.6755477684],
              [-8923721.706301752, 2931388.2696492],
              [-8931428.86214718, 2917203.1440226124],
              [-8934997.702802166, 2919328.9866046435],
              [-8946983.583695369, 2913895.914778583],
              [-8949539.479203982, 2909306.20143342],
              [-8949522.781280365, 2906918.2073562685],
              [-8952187.658570463, 2904798.012934903],
              [-8955726.393863292, 2905281.7900478477],
              [-8959307.20792364, 2903379.8768118215],
              [-8960414.057620596, 2901016.5741421087],
              [-8960706.271283926, 2900306.5611154297],
              [-8965937.953392738, 2901115.001754501],
              [-8977976.154446615, 2898988.8631655127],
              [-8984663.672856022, 2894491.1584170163],
              [-8988797.967424592, 2893865.323348478],
              [-8995965.4954783, 2898612.6804947606],
              [-9001090.315332135, 2897564.797855998],
              [-9002762.329627665, 2920519.6177478544],
              [-9002755.093860762, 2969495.5411023553],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Suffolk',
        GEOID: '25025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7924963.123585012, 5203475.068914807],
              [-7921148.4272745075, 5210577.030195137],
              [-7922343.775966646, 5215070.172096853],
              [-7916699.432505463, 5215698.8578601675],
              [-7912292.62782343, 5214921.179841986],
              [-7910814.86158315, 5216415.276077804],
              [-7912694.825143666, 5218431.030005656],
              [-7901740.831579085, 5224135.965430532],
              [-7900889.39314504, 5214432.941575452],
              [-7901000.260915378, 5214206.419279745],
              [-7901801.832918926, 5212568.828343325],
              [-7903443.173583328, 5209216.495037733],
              [-7902911.248975536, 5207965.035524997],
              [-7908325.2011715565, 5206821.879734889],
              [-7909615.394069851, 5202638.9645592095],
              [-7914118.490111421, 5201079.496698882],
              [-7915115.356151475, 5199988.653495433],
              [-7916136.823798995, 5200067.770004088],
              [-7916299.238936062, 5199854.187027117],
              [-7915878.228621881, 5199316.039416131],
              [-7915856.298682196, 5198199.833918387],
              [-7917752.069610404, 5196872.349000682],
              [-7917322.376375943, 5196276.484758956],
              [-7918241.20745295, 5195183.036643238],
              [-7920007.959091331, 5199367.626866157],
              [-7924630.50094652, 5203076.792986379],
              [-7924963.123585012, 5203475.068914807],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '27027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10777850.462034235, 5955330.218505116],
              [-10778684.370502757, 5966680.578370188],
              [-10708341.79274648, 5966780.428142816],
              [-10706052.730057297, 5938381.878165718],
              [-10706106.052093389, 5896141.650868332],
              [-10705848.12483322, 5882003.326441674],
              [-10717949.332718885, 5882012.404515035],
              [-10774144.43387352, 5881822.066721337],
              [-10774589.748622362, 5882820.0133585],
              [-10774671.733974632, 5883003.754222621],
              [-10774262.300887497, 5892075.388621445],
              [-10774480.26445047, 5905843.920913907],
              [-10771716.201494072, 5927804.662645402],
              [-10779456.357008418, 5943724.43791051],
              [-10777850.462034235, 5955330.218505116],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McDowell',
        GEOID: '54047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9126516.318862036, 4502623.055103962],
              [-9120659.57781242, 4510709.837000977],
              [-9116066.312983308, 4512746.334002958],
              [-9112161.447885262, 4515896.456391646],
              [-9107931.084596137, 4509958.917256791],
              [-9089729.679934492, 4512302.930599318],
              [-9068736.382443752, 4506885.212072442],
              [-9051521.491109516, 4498444.21017301],
              [-9057193.775762888, 4486281.108017692],
              [-9064517.485062176, 4476950.409285175],
              [-9070708.295903664, 4474095.556913876],
              [-9076219.83521233, 4470293.738180119],
              [-9079287.243781138, 4467952.226077396],
              [-9092420.494665947, 4467365.776247478],
              [-9099149.983917011, 4472542.378889529],
              [-9099700.789363826, 4472966.193875962],
              [-9103123.195788775, 4477486.470982919],
              [-9111494.644135412, 4478938.674984134],
              [-9116621.129325423, 4485480.273538228],
              [-9120806.74217925, 4493498.370364107],
              [-9121179.551153917, 4497800.973449777],
              [-9126516.318862036, 4502623.055103962],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bullock',
        GEOID: '01011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9573382.365890788, 3796243.407970877],
              [-9571979.740306793, 3799113.0776288263],
              [-9564491.946078075, 3799381.663115302],
              [-9562198.319289768, 3799461.3183055124],
              [-9562181.62136615, 3803451.604145168],
              [-9557470.469196288, 3793799.6177245732],
              [-9510418.503425242, 3794151.388506816],
              [-9509739.231892422, 3782563.1338517657],
              [-9507824.536650777, 3782576.2814695872],
              [-9509854.447565392, 3765273.3382670265],
              [-9527539.552428737, 3762963.434800381],
              [-9535367.984299285, 3747605.100325173],
              [-9550215.6666618, 3747615.8500914485],
              [-9550104.458490498, 3759012.9729193044],
              [-9560602.109111285, 3759012.8417006065],
              [-9561637.603014644, 3769527.7878536345],
              [-9567498.128926948, 3771437.395947462],
              [-9573125.885784002, 3770013.468602482],
              [-9573237.873191737, 3781912.8706679298],
              [-9573382.365890788, 3796243.407970877],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Logan',
        GEOID: '05083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10479680.426708015, 4177435.25014463],
              [-10479539.718871655, 4183380.438093276],
              [-10467509.310182134, 4183039.5614455915],
              [-10467221.771937415, 4192746.3974852026],
              [-10467209.97207139, 4192977.343914998],
              [-10455145.165659215, 4195103.231327297],
              [-10454806.754407205, 4207323.192025747],
              [-10442891.116112692, 4206511.326586609],
              [-10442530.663601505, 4222472.560136684],
              [-10431757.942518966, 4214992.682351347],
              [-10418902.099805214, 4216145.8329043975],
              [-10401188.163193753, 4222180.2019479945],
              [-10399232.502379498, 4208378.256161775],
              [-10385998.729994502, 4208466.398765023],
              [-10383692.078825774, 4207098.903280454],
              [-10383877.537097435, 4192803.758950717],
              [-10403588.100095764, 4193243.858000482],
              [-10411693.94013737, 4183663.602387729],
              [-10431381.237362122, 4182234.513417459],
              [-10431180.083042257, 4166560.656675382],
              [-10472308.404749721, 4167494.526516426],
              [-10479813.342180023, 4171451.090378685],
              [-10479680.426708015, 4177435.25014463],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Butler',
        GEOID: '20015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10814964.157625731, 4567105.2369371215],
              [-10815012.804243209, 4591822.865949738],
              [-10780265.427067505, 4591528.4008597685],
              [-10744866.942190152, 4591634.1923476355],
              [-10745147.24466797, 4524057.9978356995],
              [-10745190.659269378, 4505721.180057836],
              [-10815059.335790358, 4505600.407564999],
              [-10814964.157625731, 4567105.2369371215],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Westmoreland',
        GEOID: '51193',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8576558.515924035, 4616284.2800161345],
              [-8571243.595690668, 4618935.4398067165],
              [-8570515.982644284, 4618196.245151857],
              [-8566902.663292626, 4613836.6036303695],
              [-8567405.270793557, 4609711.726903996],
              [-8561674.65472701, 4607303.147266246],
              [-8553655.532568734, 4602545.298415929],
              [-8543735.852744147, 4602352.464650941],
              [-8536523.128977178, 4601557.240406012],
              [-8528624.677146925, 4600437.489574683],
              [-8527177.30112763, 4594988.6832823185],
              [-8519939.53047523, 4589253.014396597],
              [-8517131.492013877, 4585005.776873065],
              [-8528886.83454774, 4579655.09087427],
              [-8530883.46093461, 4574712.822986048],
              [-8545409.09601026, 4579705.382969689],
              [-8557915.39552292, 4597008.353283827],
              [-8564583.099062966, 4590319.5129530495],
              [-8575140.082972344, 4592336.149116827],
              [-8578468.647066556, 4602284.081736093],
              [-8576558.515924035, 4616284.2800161345],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Webster',
        GEOID: '29225',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10360881.268008852, 4497109.842772291],
              [-10360681.338203387, 4507269.744183889],
              [-10336402.223302903, 4506782.38263633],
              [-10317833.019043675, 4506442.196943751],
              [-10317743.518173078, 4448456.9574388275],
              [-10333194.997453656, 4448683.3849599995],
              [-10341945.04338848, 4448959.206175902],
              [-10342811.554304816, 4451041.141918615],
              [-10359978.912216483, 4451476.808222491],
              [-10359630.259571318, 4471929.9321638085],
              [-10361259.642958058, 4476814.020070656],
              [-10360881.268008852, 4497109.842772291],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ulster',
        GEOID: '36111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8296751.29852111, 5182946.0042733075],
              [-8287926.779846947, 5186362.331548163],
              [-8271880.965805022, 5178123.339657672],
              [-8245968.682655108, 5175459.0067075],
              [-8237915.0514546875, 5187528.969527555],
              [-8227698.705187134, 5180066.4311056435],
              [-8229808.320857159, 5172787.320687757],
              [-8233680.791983384, 5147978.301168782],
              [-8231083.485624194, 5121514.148085054],
              [-8232444.477718633, 5099756.499848984],
              [-8243618.505565481, 5098362.417477006],
              [-8267063.16956298, 5106106.918641909],
              [-8278502.694395368, 5099905.34091877],
              [-8281621.421249434, 5107931.140060133],
              [-8301660.599384584, 5122896.380257565],
              [-8288146.3018827895, 5142362.356286957],
              [-8324548.665928117, 5163432.655328705],
              [-8296751.29852111, 5182946.0042733075],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Davie',
        GEOID: '37059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8982725.600521311, 4307676.963269527],
              [-8960805.234311242, 4307027.783740622],
              [-8957166.088837719, 4309230.333046568],
              [-8949453.317918109, 4296874.112210008],
              [-8946748.476930814, 4284911.702308529],
              [-8949956.03673853, 4278812.865980744],
              [-8959837.088699814, 4277654.335820073],
              [-8956641.996675067, 4265320.199120218],
              [-8958082.025607966, 4268794.149634982],
              [-8982571.089068089, 4281856.499987721],
              [-8984354.093352124, 4280403.453832745],
              [-8982725.600521311, 4307676.963269527],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Westmoreland',
        GEOID: '42129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8894971.666692538, 4888380.085134843],
              [-8891152.851560874, 4894671.696787847],
              [-8883935.22973631, 4900966.733327871],
              [-8879072.79437846, 4923183.490912919],
              [-8872690.95929077, 4928221.942276038],
              [-8872344.199076952, 4942595.484403779],
              [-8879445.380714145, 4946170.257057699],
              [-8880326.585803265, 4950698.854023973],
              [-8871338.204838654, 4963748.58411987],
              [-8868639.597742843, 4965262.894301444],
              [-8844353.135755965, 4943283.825355688],
              [-8844752.66140842, 4936563.728041491],
              [-8835844.43047718, 4932115.816042405],
              [-8811582.124819806, 4925960.511542093],
              [-8805444.079416955, 4919668.789666559],
              [-8796089.568647124, 4927205.360013113],
              [-8791417.712257512, 4923651.803303854],
              [-8791396.56155426, 4923496.135195814],
              [-8798780.272059087, 4909971.908104867],
              [-8800471.77172169, 4907457.534019595],
              [-8814680.14624858, 4882039.928079549],
              [-8826932.303363761, 4871816.725582189],
              [-8832225.322511999, 4872175.442180429],
              [-8841112.291420499, 4881856.532382496],
              [-8850477.043583484, 4886390.31335204],
              [-8860254.56841833, 4877873.462846839],
              [-8877106.446893089, 4884584.821280557],
              [-8891909.824098269, 4884384.490206646],
              [-8894971.666692538, 4888380.085134843],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chariton',
        GEOID: '29041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10383670.37152507, 4810243.173008096],
              [-10381810.000194931, 4811344.522167501],
              [-10382431.38559254, 4822957.763695704],
              [-10361874.905783674, 4823413.840332291],
              [-10336896.370522533, 4822440.217189142],
              [-10318129.128889186, 4822166.624325635],
              [-10318442.827214241, 4809467.633524502],
              [-10319008.218907982, 4807652.062961851],
              [-10320136.887225132, 4767845.28221977],
              [-10329376.627599956, 4771007.500789463],
              [-10335928.336230595, 4754127.356419267],
              [-10342879.68183318, 4753800.870789806],
              [-10348237.711564042, 4766537.624224881],
              [-10360829.504445633, 4769846.523568243],
              [-10364343.860769976, 4776776.951096649],
              [-10365939.625670498, 4781595.186217988],
              [-10383419.902670784, 4787533.64250698],
              [-10383670.37152507, 4810243.173008096],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fort Bend',
        GEOID: '48157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10696568.754719675, 3452448.772614061],
              [-10689437.405500475, 3452604.841966065],
              [-10690312.4880176, 3468627.297013537],
              [-10683436.17175181, 3468705.493577173],
              [-10667326.015044207, 3476364.138870355],
              [-10659002.211439632, 3471002.6336321943],
              [-10651978.285529047, 3466437.729852099],
              [-10651837.243734213, 3466337.2458396913],
              [-10644575.428071804, 3461659.199146777],
              [-10638953.459828272, 3458478.2110941326],
              [-10625037.855562167, 3451045.6414956087],
              [-10622564.22515725, 3449706.0239580823],
              [-10624691.095348347, 3440746.5089264517],
              [-10626837.22381135, 3431671.116029435],
              [-10636576.677380344, 3431568.7289884286],
              [-10639872.179585788, 3419008.4731877465],
              [-10645022.375827339, 3413036.0346418913],
              [-10659160.285116557, 3417013.1851451085],
              [-10669712.259648852, 3409110.500308505],
              [-10680750.03243897, 3418153.421748355],
              [-10683713.357283885, 3428118.719479636],
              [-10693308.763431793, 3436029.25827153],
              [-10691635.52016568, 3447402.8209200734],
              [-10696568.754719675, 3452448.772614061],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '29071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10171171.927632846, 4678693.373395705],
              [-10165587.028779745, 4679983.4661633],
              [-10155292.758868638, 4667608.351080249],
              [-10138681.330493992, 4665866.793900354],
              [-10126117.478804592, 4657066.950648583],
              [-10120784.495959159, 4655242.369992248],
              [-10104873.378501093, 4663769.169954818],
              [-10101399.097193437, 4669460.220931755],
              [-10100276.551448278, 4670135.590028786],
              [-10100719.936980108, 4645558.17939745],
              [-10100863.316484248, 4638345.859858195],
              [-10102176.997795101, 4630150.355083111],
              [-10105603.96831917, 4608300.2553659],
              [-10140734.173223713, 4608296.147179084],
              [-10168922.606001876, 4608294.163917069],
              [-10170981.571303587, 4609097.699583568],
              [-10171171.927632846, 4678693.373395705],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ness',
        GEOID: '20135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11159467.257451454, 4678528.05817513],
              [-11149072.577359652, 4678410.52767181],
              [-11087234.600223986, 4678292.570627597],
              [-11085761.175443847, 4678295.851155733],
              [-11085728.558833046, 4628900.592190804],
              [-11085663.214291949, 4616529.405727563],
              [-11157233.854507668, 4616537.628669218],
              [-11159154.783640798, 4616545.142742333],
              [-11159467.257451454, 4678528.05817513],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '29113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10159042.55591601, 4741723.011047023],
              [-10150718.974950414, 4741608.908900532],
              [-10150438.672472598, 4754273.214990416],
              [-10099269.736052036, 4753823.426994],
              [-10097557.46156616, 4743304.068379361],
              [-10094572.318101047, 4736090.4863521755],
              [-10098194.988289936, 4729406.266523545],
              [-10094050.341008719, 4719393.717008581],
              [-10092401.24370568, 4712322.69287067],
              [-10097519.056341836, 4707736.884037755],
              [-10109794.25659161, 4703920.307112721],
              [-10125457.91082164, 4703190.935745172],
              [-10142458.066858137, 4703454.595809036],
              [-10142339.622919932, 4711921.664094576],
              [-10151151.785130618, 4711957.440104532],
              [-10151045.14105844, 4720545.900775047],
              [-10159493.956451178, 4720634.844208407],
              [-10159042.55591601, 4741723.011047023],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morgan',
        GEOID: '21175',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9295725.7297305, 4561090.952889944],
              [-9288981.77233926, 4571301.655753065],
              [-9287823.938315522, 4584226.311963488],
              [-9287456.13871794, 4586061.670185941],
              [-9268826.933253177, 4595738.832684241],
              [-9269324.08609906, 4587789.621359209],
              [-9261163.254229005, 4580930.268660904],
              [-9241979.5663806, 4580421.365460416],
              [-9238294.77991585, 4574336.949453478],
              [-9235223.363845374, 4564437.967181213],
              [-9240035.260154404, 4559561.171741082],
              [-9253906.670582663, 4564524.156712335],
              [-9252127.673800295, 4560248.410293279],
              [-9269536.372368002, 4546423.685774603],
              [-9268702.589381961, 4538913.03144728],
              [-9282535.705905387, 4553137.674517295],
              [-9293425.089814276, 4557398.936843519],
              [-9294629.78934364, 4559936.087590606],
              [-9295725.7297305, 4561090.952889944],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chisago',
        GEOID: '27025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10368496.968332492, 5737291.374156157],
              [-10334984.136179183, 5737090.394135856],
              [-10338206.48960968, 5734817.445337758],
              [-10340099.825358238, 5723505.920361307],
              [-10340236.957121748, 5722687.198820384],
              [-10339480.76382079, 5712249.273241015],
              [-10330616.058810448, 5710570.879711551],
              [-10325651.543479541, 5709719.479927764],
              [-10322436.302626958, 5704657.751108271],
              [-10317846.600021552, 5696179.853752965],
              [-10313391.037402552, 5690729.948434403],
              [-10314695.479195667, 5684089.713521362],
              [-10319201.80350247, 5674633.051271212],
              [-10324689.92950427, 5668251.020482905],
              [-10354876.694675462, 5668388.637308055],
              [-10354890.38697283, 5686580.869862137],
              [-10355192.174112372, 5709664.630623031],
              [-10368517.117160324, 5709816.460681985],
              [-10368496.968332492, 5737291.374156157],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Richmond',
        GEOID: '37153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8913948.856885519, 4183342.3203755035],
              [-8889002.49295722, 4188894.4585983325],
              [-8862623.781140883, 4186146.773165888],
              [-8858352.118320674, 4173384.8808575138],
              [-8845307.700389516, 4169813.0923474566],
              [-8858072.929037763, 4162822.564565577],
              [-8856785.296487758, 4151704.7312544147],
              [-8862594.949392766, 4138810.614157865],
              [-8871378.211250173, 4137407.787190801],
              [-8897175.152872315, 4137796.4446609183],
              [-8888809.687599167, 4150300.6481146584],
              [-8891888.896033999, 4168680.667947668],
              [-8897095.865215855, 4179578.7051908746],
              [-8904773.459176376, 4175518.5748871616],
              [-8913948.856885519, 4183342.3203755035],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bath',
        GEOID: '21011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9348379.737556228, 4606601.305563837],
              [-9333956.182453634, 4621460.095846947],
              [-9320268.11522671, 4620840.971026022],
              [-9311537.550202776, 4603654.941271331],
              [-9310227.31979614, 4605950.781317071],
              [-9299009.098111449, 4592811.40783656],
              [-9291090.386133868, 4590692.431596401],
              [-9295049.018545968, 4586579.191192903],
              [-9303525.21853344, 4587747.348636617],
              [-9304178.663944395, 4581060.1122096],
              [-9312909.896885274, 4583418.913955226],
              [-9324057.09673484, 4579246.547281437],
              [-9337629.50301083, 4598729.077212684],
              [-9348009.934207812, 4601877.616243284],
              [-9348379.737556228, 4606601.305563837],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Noble',
        GEOID: '40103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10849376.017856183, 4382615.377248993],
              [-10804381.904191941, 4382616.7637449475],
              [-10788278.649292769, 4383351.909204338],
              [-10785524.716410032, 4380015.8746247925],
              [-10799079.868164947, 4370600.924477338],
              [-10801565.966352833, 4370603.971348799],
              [-10801564.630518945, 4346587.849354776],
              [-10789634.520690631, 4346586.467505696],
              [-10789649.326182906, 4334589.028617386],
              [-10813683.092925683, 4334583.645404265],
              [-10813649.697078444, 4322553.489777366],
              [-10837412.400861138, 4322531.567295634],
              [-10839709.589873148, 4323256.411532567],
              [-10849285.73774915, 4323274.75043266],
              [-10849376.017856183, 4382615.377248993],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bamberg',
        GEOID: '45009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9041666.599228568, 3953853.2975411285],
              [-9010211.050715113, 3935666.14097661],
              [-9007797.866793698, 3932977.543476829],
              [-9004884.85835862, 3930982.8057871438],
              [-9004582.959899588, 3930036.753223734],
              [-9004311.785620015, 3930422.5672238003],
              [-8999752.361916104, 3926980.9141361536],
              [-8994382.420999728, 3918813.9402701254],
              [-9005237.629824944, 3911953.657362933],
              [-9005309.764854977, 3903457.95342697],
              [-9009883.103495236, 3908928.2030259944],
              [-9026039.346472029, 3898839.184172735],
              [-9027999.014787951, 3901717.002414814],
              [-9038374.436607849, 3911065.7692369274],
              [-9042192.361183586, 3916662.4543748247],
              [-9041666.599228568, 3953853.2975411285],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Deuel',
        GEOID: '46039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10785140.998125268, 5590786.300676137],
              [-10784893.312258253, 5617880.875778236],
              [-10737415.005487103, 5617955.664017848],
              [-10737302.617542954, 5590961.115329271],
              [-10737188.646879781, 5563668.385719738],
              [-10737131.274365084, 5549960.302589466],
              [-10785244.97052967, 5549981.575468067],
              [-10785140.998125268, 5590786.300676137],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cambria',
        GEOID: '42021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8798780.272059087, 4909971.908104867],
              [-8791396.56155426, 4923496.135195814],
              [-8791417.712257512, 4923651.803303854],
              [-8773607.818244986, 4969209.245333171],
              [-8772164.783685831, 4971795.740506986],
              [-8721929.971034026, 4971838.044224035],
              [-8731867.35065765, 4960101.081554207],
              [-8732020.526276981, 4953625.5889893165],
              [-8743014.99578518, 4939770.130805688],
              [-8745713.936839461, 4919945.232280262],
              [-8751981.001532141, 4913579.084929904],
              [-8755485.895699767, 4906959.784974511],
              [-8756214.036489047, 4901307.695374006],
              [-8781422.669137657, 4901555.330452081],
              [-8783556.997734634, 4905998.650251894],
              [-8786180.35285467, 4907450.529461263],
              [-8800471.77172169, 4907457.534019595],
              [-8798780.272059087, 4909971.908104867],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Edgefield',
        GEOID: '45037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9140858.38809737, 4005981.8765870687],
              [-9145530.689764947, 4019311.3479215982],
              [-9133427.366808955, 4022521.001349118],
              [-9129121.974183036, 4023653.1829333226],
              [-9116464.614121368, 4025501.3388249916],
              [-9110031.238109443, 4010890.427183093],
              [-9089432.234255092, 4003922.3621304813],
              [-9130014.917158335, 3965696.7002669447],
              [-9131341.684829453, 3967860.2345457436],
              [-9140024.82775031, 3974634.331328763],
              [-9140961.451977186, 3974937.444293974],
              [-9138832.262045441, 3979744.8928891164],
              [-9148568.264710221, 3991817.028167963],
              [-9140858.38809737, 4005981.8765870687],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '55069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10023459.980228923, 5681840.15030652],
              [-10023586.99576792, 5709335.223911975],
              [-9955108.143089494, 5709378.306821336],
              [-9954725.871958109, 5695369.505481969],
              [-9954853.555414049, 5640290.556262189],
              [-10023617.163349925, 5640466.615686345],
              [-10023459.980228923, 5681840.15030652],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Irion',
        GEOID: '48235',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11273096.293720217, 3701601.369820842],
              [-11209100.722213997, 3700983.1313858316],
              [-11208621.937084096, 3643997.796526371],
              [-11239058.021700865, 3643466.680235213],
              [-11273859.054871133, 3643062.3140519294],
              [-11273096.293720217, 3701601.369820842],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calhoun',
        GEOID: '48057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10790239.096845128, 3323150.1897566826],
              [-10781710.910655456, 3329296.471094049],
              [-10758298.751949267, 3339054.233468469],
              [-10734359.718093157, 3337965.001984873],
              [-10731147.705505809, 3341355.087693822],
              [-10731693.727608148, 3334270.504724193],
              [-10722685.420454683, 3334421.238994604],
              [-10722597.366737466, 3330278.8253700794],
              [-10728809.234694438, 3298216.3638450243],
              [-10730127.573692176, 3297197.7688967413],
              [-10735968.841332573, 3289083.560330297],
              [-10757026.147530518, 3277095.575925319],
              [-10766779.627355354, 3269741.220534355],
              [-10774853.74134208, 3262912.0895036836],
              [-10781523.183996486, 3256517.927277523],
              [-10779169.598000135, 3262583.577264835],
              [-10774670.509460235, 3289282.3440901134],
              [-10771733.901293106, 3302855.6607242706],
              [-10777228.853997646, 3303328.9578892984],
              [-10785851.32779602, 3313069.1257771873],
              [-10790239.096845128, 3323150.1897566826],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tooele',
        GEOID: '49045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12695585.616333123, 4880178.473957892],
              [-12695584.148849798, 4882949.65487756],
              [-12695562.461879037, 4923993.98946188],
              [-12695495.558865072, 4938254.4831941845],
              [-12695264.904880147, 4972053.237841001],
              [-12695113.526651476, 5012326.409029432],
              [-12556767.20568766, 5012332.666365606],
              [-12522720.807345483, 5023689.249685975],
              [-12496750.081462903, 4978342.362297122],
              [-12490249.023200575, 4969132.296897161],
              [-12489645.337602004, 4957822.173941187],
              [-12487301.39440386, 4954103.272867205],
              [-12487025.878664147, 4934048.845447753],
              [-12491410.976045474, 4932885.50010942],
              [-12487323.213024056, 4914865.888168391],
              [-12487786.302105756, 4899748.378769474],
              [-12484130.903986577, 4891815.906807788],
              [-12487798.21329127, 4867636.242255206],
              [-12497826.09566091, 4857074.186249844],
              [-12504773.990359282, 4859084.075503922],
              [-12505852.898864051, 4852068.0742670065],
              [-12606765.13046306, 4852105.223630472],
              [-12695683.817164456, 4852306.081288542],
              [-12695585.616333123, 4880178.473957892],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Maverick',
        GEOID: '48323',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11206668.412401143, 3386280.05393947],
              [-11144350.738518674, 3386636.9761429043],
              [-11144676.904626697, 3330935.628953928],
              [-11144608.220500877, 3273937.2099774736],
              [-11153935.79813228, 3273833.855037902],
              [-11161738.6203416, 3280563.7835978013],
              [-11163959.444182927, 3286988.03728085],
              [-11167615.064941086, 3294705.6467926274],
              [-11169470.315574646, 3302935.280821375],
              [-11172946.71195263, 3309271.5962069277],
              [-11175236.77651723, 3314154.8029740616],
              [-11176172.973434802, 3321744.21317708],
              [-11181892.34623278, 3326959.786648516],
              [-11187648.231823735, 3332691.0696853995],
              [-11188354.7766318, 3339643.181674344],
              [-11191284.260351516, 3345551.2453038334],
              [-11191597.402079117, 3350963.048999149],
              [-11196163.282313494, 3354810.3718406428],
              [-11201769.331869844, 3363399.2264341777],
              [-11203972.010634169, 3370184.2867448344],
              [-11205443.097705001, 3379655.508367384],
              [-11206668.412401143, 3386280.05393947],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'New Kent',
        GEOID: '51127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8598427.452529354, 4514377.080304494],
              [-8587236.392800415, 4521972.093871825],
              [-8585368.229105921, 4526849.877070662],
              [-8569503.309236538, 4518452.6002503345],
              [-8555840.956811987, 4520198.15251017],
              [-8558027.49425015, 4513434.986961225],
              [-8548466.81978337, 4511500.388707499],
              [-8542878.581345549, 4504412.675105916],
              [-8559555.799539251, 4499582.901716599],
              [-8560966.551446075, 4491879.9727491075],
              [-8560927.033026842, 4495544.700205373],
              [-8573973.677347815, 4497252.942752406],
              [-8591340.408467492, 4507712.513700305],
              [-8596236.462311562, 4513698.191810941],
              [-8598427.452529354, 4514377.080304494],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clallam',
        GEOID: '53009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13884416.886243822, 6171315.427812291],
              [-13876335.536490194, 6172099.76898563],
              [-13864426.132087165, 6165883.175086096],
              [-13846015.558102323, 6154349.97324577],
              [-13831544.914855119, 6151017.210103117],
              [-13814946.176902426, 6143012.582095019],
              [-13809264.541411828, 6136476.709111209],
              [-13790266.089196103, 6133618.1660399055],
              [-13773419.888015376, 6133981.815330512],
              [-13767153.60255913, 6133967.629547765],
              [-13753648.989853036, 6132076.457939526],
              [-13741497.465557532, 6127552.0570498975],
              [-13727316.030347416, 6125795.519504642],
              [-13718917.086086553, 6126544.513493329],
              [-13708414.537408173, 6136175.554017058],
              [-13699667.831058072, 6126920.03557041],
              [-13692756.894430643, 6121926.70436937],
              [-13686299.362089217, 6123266.064547659],
              [-13682355.06269886, 6125141.077740597],
              [-13680828.231755711, 6117701.158303975],
              [-13686640.111050535, 6117700.3254297525],
              [-13686638.663897155, 6084727.289975236],
              [-13748615.790396309, 6087093.5374075305],
              [-13871867.80175858, 6087009.2922274135],
              [-13873248.535691004, 6088236.068220019],
              [-13878471.089601573, 6100936.633020051],
              [-13879914.458119197, 6115050.196209903],
              [-13880104.59180947, 6123283.566283925],
              [-13883958.917858697, 6132377.302001061],
              [-13880470.610295199, 6143490.743852173],
              [-13878119.097371683, 6156299.789036536],
              [-13884416.886243822, 6171315.427812291],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ferry',
        GEOID: '53019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13232507.016343307, 6216325.741313484],
              [-13228874.995317196, 6216332.987287191],
              [-13228831.250718063, 6274913.614481609],
              [-13157671.603941314, 6274930.411494859],
              [-13160375.993810933, 6264194.972581733],
              [-13157463.764612293, 6247878.844716988],
              [-13150282.989539182, 6237217.628439857],
              [-13147384.007359942, 6216271.312452733],
              [-13152365.443253452, 6193899.913394367],
              [-13158688.167691529, 6185455.028798073],
              [-13155247.83882856, 6160172.464993721],
              [-13151449.06120524, 6150245.00270751],
              [-13157351.554565573, 6142345.338840792],
              [-13156995.109556053, 6133495.840494022],
              [-13163374.606934434, 6129219.216588289],
              [-13161659.396220291, 6117722.813062164],
              [-13166365.761652049, 6113606.393660973],
              [-13180317.544752661, 6111627.824839217],
              [-13174521.472825527, 6102161.64835108],
              [-13173652.958158357, 6089290.757423504],
              [-13176783.93015641, 6079064.58156553],
              [-13196267.735351993, 6087573.737078982],
              [-13199196.1058768, 6095602.338750258],
              [-13212331.583151426, 6097330.436248739],
              [-13214923.99145302, 6090790.255812054],
              [-13230539.666982519, 6099854.747976198],
              [-13229641.096052835, 6187376.532196021],
              [-13232507.016343307, 6216325.741313484],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Okanogan',
        GEOID: '53047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13453130.462037047, 6274961.700869561],
              [-13438110.887573252, 6274893.293733342],
              [-13400219.06874111, 6274981.0186028145],
              [-13358472.367262289, 6274762.641360469],
              [-13297970.335335638, 6274905.680361827],
              [-13261724.931772329, 6274905.850041796],
              [-13228831.250718063, 6274913.614481609],
              [-13228874.995317196, 6216332.987287191],
              [-13232507.016343307, 6216325.741313484],
              [-13229641.096052835, 6187376.532196021],
              [-13230539.666982519, 6099854.747976198],
              [-13240912.75109311, 6097257.815924325],
              [-13244069.883171495, 6097446.098261786],
              [-13245041.702326123, 6100539.471616908],
              [-13241540.48170169, 6109997.0348049905],
              [-13247374.513575185, 6114055.276824606],
              [-13253361.275790047, 6129672.754805523],
              [-13263826.755077993, 6131189.671861418],
              [-13275611.815609807, 6123845.307661772],
              [-13280257.734558066, 6126088.973283246],
              [-13285260.209835334, 6115082.501803274],
              [-13295583.311494557, 6119622.481351842],
              [-13304635.144568922, 6117278.0686173],
              [-13319651.80991846, 6106891.601489269],
              [-13324243.070996739, 6112189.468919703],
              [-13321570.846620245, 6119379.8974383585],
              [-13333246.702731589, 6124209.709149583],
              [-13346689.310481314, 6115184.415091203],
              [-13343933.596486723, 6100278.4755895175],
              [-13365688.541933473, 6101273.794076355],
              [-13374265.931338076, 6117655.683489801],
              [-13382056.625901243, 6120015.028654845],
              [-13398557.291382547, 6133108.849357594],
              [-13396887.053742686, 6140190.1011100765],
              [-13410561.53999173, 6151720.752108904],
              [-13414912.79624786, 6158641.193286845],
              [-13423256.63736078, 6160111.530266473],
              [-13420700.741852166, 6167131.928504492],
              [-13430689.105802575, 6173348.4266518345],
              [-13428842.426769802, 6185089.349108895],
              [-13430950.706605937, 6196651.7859866265],
              [-13436492.858774569, 6195752.383352647],
              [-13434984.03439636, 6203171.682107329],
              [-13446092.829021603, 6211489.000429259],
              [-13442040.465598254, 6216860.948931394],
              [-13431348.562466033, 6228216.779683316],
              [-13440206.254348453, 6238710.054063759],
              [-13440190.001702799, 6251879.754015409],
              [-13453130.462037047, 6274961.700869561],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Miller',
        GEOID: '13201',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9452964.065198034, 3666039.1332780593],
              [-9422267.938250773, 3666426.8040878177],
              [-9410627.036459537, 3666031.5805251207],
              [-9411245.082272422, 3643016.8220597757],
              [-9422602.453320606, 3643078.561232577],
              [-9432195.633078696, 3641738.0456980397],
              [-9453520.885290984, 3642179.9292642158],
              [-9452964.065198034, 3666039.1332780593],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mitchell',
        GEOID: '13205',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9403268.818118103, 3654583.943087025],
              [-9395849.262737239, 3658638.7484176094],
              [-9388747.30186361, 3672467.297713266],
              [-9373174.59565756, 3679007.417548304],
              [-9366547.078453688, 3690047.6814228822],
              [-9364044.171022695, 3690347.778005431],
              [-9350591.87847727, 3690514.008586687],
              [-9350773.774525227, 3676327.6892353143],
              [-9351167.622883653, 3647455.5501685264],
              [-9352379.112901958, 3646059.5656345054],
              [-9351240.982428087, 3642790.794330874],
              [-9363821.97731907, 3642879.3072847715],
              [-9392761.482701614, 3642997.8454497],
              [-9407396.210878244, 3642935.066872014],
              [-9403268.818118103, 3654583.943087025],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hawaii',
        GEOID: '15001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-17371367.68778805, 2247040.5087789693],
              [-17366538.202999476, 2251433.2487811637],
              [-17363241.364960145, 2255332.534559062],
              [-17360191.21091241, 2256102.3101486773],
              [-17356452.100536153, 2259664.2351228055],
              [-17353877.3920336, 2264996.313839516],
              [-17349876.01293703, 2269345.2921522087],
              [-17347133.100683887, 2270990.5008776933],
              [-17346412.306980997, 2276104.6033366406],
              [-17349185.49813564, 2280437.0926965754],
              [-17353667.33215447, 2287675.9609944574],
              [-17355018.082855754, 2294019.4948072038],
              [-17353669.224585813, 2303292.248578131],
              [-17349509.21521487, 2305227.4134224285],
              [-17343452.433040295, 2303158.759603482],
              [-17336563.98295001, 2299440.2046705503],
              [-17332926.841227323, 2295753.711697128],
              [-17325482.684238993, 2291170.7602466834],
              [-17321093.801994976, 2287790.1318067275],
              [-17316741.20990496, 2288623.730460654],
              [-17310465.907569963, 2286559.0684558135],
              [-17297666.058560077, 2280983.791309357],
              [-17284612.512430675, 2274751.692040133],
              [-17273069.683110833, 2265674.5945509574],
              [-17268393.48526108, 2260867.2418934107],
              [-17264132.509111986, 2255908.7980946535],
              [-17264675.191629604, 2246557.3793749493],
              [-17264219.004356332, 2240838.0155326584],
              [-17259572.974088583, 2242234.844666804],
              [-17255236.078046765, 2242171.2157956897],
              [-17252417.35722039, 2236424.3307066164],
              [-17251664.83746263, 2229628.7994866944],
              [-17248632.939811382, 2226278.977918463],
              [-17238114.58376531, 2219699.941868164],
              [-17233862.067897514, 2217445.9359768783],
              [-17234039.28852686, 2213968.7073657713],
              [-17240786.25154435, 2206007.902541117],
              [-17248307.77557878, 2199944.79671704],
              [-17256807.24133982, 2193982.226241017],
              [-17267130.45431854, 2189180.9464379586],
              [-17272291.559870183, 2186558.3460028763],
              [-17277440.86555581, 2185677.700047897],
              [-17283978.325291626, 2187246.806068853],
              [-17289405.26178729, 2184473.8931417996],
              [-17294666.332241673, 2179549.547211508],
              [-17298013.709329825, 2178634.917753852],
              [-17305006.243144006, 2172833.9951075856],
              [-17310768.696584918, 2171179.0950004035],
              [-17316339.68050167, 2163105.637851379],
              [-17320277.162210517, 2155839.3073316566],
              [-17322867.455441784, 2151451.186787768],
              [-17325548.919336013, 2148075.942686976],
              [-17329328.32736794, 2145221.279666711],
              [-17335343.810011424, 2151337.947332401],
              [-17344256.716361277, 2156580.3720426564],
              [-17352654.770066213, 2159250.6276943726],
              [-17356291.132552467, 2166612.3525375687],
              [-17356052.129605733, 2176035.0782812554],
              [-17354994.14916523, 2185385.2608792367],
              [-17353689.150774665, 2190158.940424124],
              [-17353450.815744877, 2195954.0887452764],
              [-17355720.17488419, 2203910.6025935006],
              [-17357461.768317647, 2208450.0446756473],
              [-17360440.455252297, 2212315.5864193244],
              [-17362428.621357862, 2220502.1733412575],
              [-17363414.466768328, 2226669.297161177],
              [-17365587.645867594, 2230765.2376403767],
              [-17369066.825232845, 2231625.9737996347],
              [-17369550.39710085, 2233887.5722546848],
              [-17373005.531456098, 2241163.5901303743],
              [-17371367.68778805, 2247040.5087789693],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hickman',
        GEOID: '47081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9764585.057235787, 4278456.244720869],
              [-9763436.017451817, 4287661.14225212],
              [-9744299.306428527, 4299668.406969673],
              [-9707531.8144534, 4295006.880859975],
              [-9707218.338767326, 4292448.211433076],
              [-9708740.410164941, 4280090.591487374],
              [-9713250.074056467, 4259490.698472809],
              [-9722558.832515582, 4253816.246877337],
              [-9735956.689830009, 4247791.4432786945],
              [-9750104.172595434, 4252995.1848915005],
              [-9758064.963340534, 4247000.68226279],
              [-9767589.570292298, 4254479.662837344],
              [-9764585.057235787, 4278456.244720869],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Surry',
        GEOID: '37171',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9013944.70643632, 4363199.443787296],
              [-9005931.720088264, 4378195.335390087],
              [-8999091.35537876, 4378219.902915986],
              [-8984020.6914772, 4378274.030188716],
              [-8973707.807625268, 4377705.435037472],
              [-8954551.143010618, 4376649.323043629],
              [-8955841.832175244, 4336663.5600793455],
              [-8955911.51817648, 4333891.303768236],
              [-8966549.542675158, 4339965.991633052],
              [-9002763.999420026, 4333185.481258523],
              [-9002267.625810578, 4345633.448439676],
              [-9013222.242941072, 4356080.6413252195],
              [-9013944.70643632, 4363199.443787296],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'DeKalb',
        GEOID: '01049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9586711.427759903, 4083158.306987262],
              [-9579900.67867419, 4092896.877872386],
              [-9575212.124360958, 4093659.187019197],
              [-9549594.949181138, 4112979.9220077144],
              [-9527035.08965327, 4144931.019941691],
              [-9524654.151227377, 4129969.532219532],
              [-9521646.438605512, 4112872.557360585],
              [-9520810.38028755, 4108124.7110695024],
              [-9519268.539785383, 4099374.09357169],
              [-9524415.704878096, 4096443.640459196],
              [-9532011.033734921, 4082089.1138047953],
              [-9548336.371018229, 4063645.3047292545],
              [-9556088.215079108, 4061692.6351170084],
              [-9556067.732292801, 4055689.6665659687],
              [-9585285.647721821, 4055790.611985311],
              [-9586711.427759903, 4083158.306987262],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Columbia',
        GEOID: '42037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8531611.156445924, 5035337.236317937],
              [-8526250.00976932, 5035639.889211688],
              [-8510107.57040939, 5053082.280185479],
              [-8505692.305446055, 5057940.236821044],
              [-8494805.14792698, 5058204.176370677],
              [-8495818.489251673, 5043083.808403938],
              [-8491187.932393143, 5031802.205231446],
              [-8485770.680693181, 5032786.87026507],
              [-8483416.496101884, 5004931.149420654],
              [-8491964.051882956, 4995186.054228133],
              [-8494475.308275761, 4983152.34169382],
              [-8502599.627352836, 4979285.764201261],
              [-8505885.222123599, 4987832.128415549],
              [-8516070.510253219, 4986524.680584407],
              [-8519061.776290325, 4995028.066965756],
              [-8517587.349634768, 5006224.412748361],
              [-8529184.836824596, 5021750.655344647],
              [-8531611.156445924, 5035337.236317937],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Twiggs',
        GEOID: '13289',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9306048.49743125, 3850834.73077386],
              [-9294000.834220657, 3871974.0884063137],
              [-9296681.51887845, 3874730.841608443],
              [-9284823.65539966, 3881802.149990298],
              [-9264735.608008051, 3840242.7621069774],
              [-9285387.488620529, 3829399.8319563125],
              [-9294946.270655965, 3822816.1120867855],
              [-9301974.426707199, 3850033.032506836],
              [-9306048.49743125, 3850834.73077386],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jayuya',
        GEOID: '72073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7413597.0051177675, 2070829.37127457],
              [-7410162.242229341, 2072522.9529255375],
              [-7406199.602315571, 2058644.0750353665],
              [-7407547.681349078, 2056647.7382304522],
              [-7408002.64410795, 2055479.949833792],
              [-7408620.022003889, 2055354.2478516335],
              [-7412876.768012334, 2057746.8182680036],
              [-7419384.728083091, 2056150.8811105792],
              [-7413597.0051177675, 2070829.37127457],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lanier',
        GEOID: '13173',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9261555.766753541, 3636048.9059294513],
              [-9257893.466825932, 3651880.3966812715],
              [-9243775.261086585, 3651816.2722149384],
              [-9244736.95016755, 3656626.533102862],
              [-9236316.966522926, 3656666.610235379],
              [-9236326.873957608, 3615798.799365071],
              [-9241679.449033422, 3613213.1447173757],
              [-9244296.013664516, 3625906.415597377],
              [-9259495.688256921, 3626274.007142194],
              [-9259609.45677651, 3634921.523436014],
              [-9261555.766753541, 3636048.9059294513],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tippah',
        GEOID: '28139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9917238.031558057, 4138810.342976528],
              [-9909388.44898426, 4144698.6994809895],
              [-9909341.250806171, 4163197.2837779],
              [-9887736.752546899, 4163229.819793748],
              [-9887783.784850081, 4144685.947242172],
              [-9879933.868317815, 4144705.753917235],
              [-9879946.00214231, 4130901.832975337],
              [-9876099.134498969, 4130877.5794355213],
              [-9876033.233360419, 4110359.211492233],
              [-9877983.99611708, 4109179.1108305757],
              [-9917285.119702661, 4109417.663468672],
              [-9917238.031558057, 4138810.342976528],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chester',
        GEOID: '47023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9889802.452496128, 4222174.054312467],
              [-9871352.360092051, 4230556.74643662],
              [-9864422.053873224, 4244090.078024707],
              [-9859074.154216027, 4243953.054989454],
              [-9852370.939758418, 4233683.528418019],
              [-9836636.041054279, 4231054.138811956],
              [-9836282.49035152, 4220964.539683459],
              [-9836476.520223973, 4215778.002176545],
              [-9859763.555822507, 4215926.826047244],
              [-9867463.63632017, 4213050.785270582],
              [-9876238.61782093, 4197573.295160005],
              [-9883141.20548655, 4197578.338618312],
              [-9884362.602939533, 4208677.343520661],
              [-9889802.452496128, 4222174.054312467],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lewis',
        GEOID: '53041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13733591.332682414, 5908209.993198651],
              [-13731414.03476199, 5908434.3757092],
              [-13710173.94196016, 5908413.888371726],
              [-13710209.675516704, 5903691.211087009],
              [-13603588.535151852, 5903484.988305654],
              [-13563377.15209005, 5897863.104244376],
              [-13554104.572465442, 5906854.389949474],
              [-13520333.021946033, 5906855.365362045],
              [-13509016.727789953, 5895110.986797406],
              [-13519891.974123511, 5866322.81746926],
              [-13513488.654374098, 5843101.706979562],
              [-13527803.227695208, 5842782.1553739775],
              [-13527803.227695208, 5842847.194483434],
              [-13584555.685213473, 5842715.34150349],
              [-13593700.69270163, 5842500.701338765],
              [-13607333.768100102, 5842405.970839228],
              [-13607802.089197868, 5842320.117160821],
              [-13716559.450591043, 5842361.430104639],
              [-13721136.68541348, 5842013.019592554],
              [-13732186.925986568, 5842104.518378991],
              [-13733591.332682414, 5908209.993198651],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Brevard',
        GEOID: '12009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9012923.12746931, 3326480.1988045233],
              [-9013304.842003241, 3348969.8183494764],
              [-8986544.82420371, 3349096.315151999],
              [-8977615.034018483, 3334710.278008463],
              [-8970556.933024226, 3324541.8608934158],
              [-8964012.460160488, 3307024.896596104],
              [-8970994.307303552, 3300872.779236424],
              [-8973116.168117562, 3291463.341660458],
              [-8972820.058272053, 3281507.055928215],
              [-8971234.980042648, 3271432.846227547],
              [-8966526.16558209, 3255127.116814824],
              [-8955394.433488674, 3231399.089892039],
              [-8962229.233237471, 3226557.841325571],
              [-9002282.653941836, 3226616.245073643],
              [-9001617.742623327, 3292855.00966466],
              [-9003613.923732232, 3312601.0576284253],
              [-9015459.430747544, 3326480.832833107],
              [-9012923.12746931, 3326480.1988045233],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Allegany',
        GEOID: '36003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8717300.082092442, 5239377.824491603],
              [-8687179.476912579, 5239423.891355445],
              [-8665186.419075025, 5238857.360072105],
              [-8665134.878150789, 5232335.863702795],
              [-8652080.775423933, 5231828.76623925],
              [-8652978.56711718, 5221681.069813782],
              [-8655082.719797364, 5160793.01686994],
              [-8664221.947006792, 5160758.348972161],
              [-8686390.8896398, 5160891.814289683],
              [-8705919.226846058, 5160842.87765206],
              [-8713110.573056437, 5160824.856708247],
              [-8717221.040850913, 5160840.305554305],
              [-8717300.082092442, 5239377.824491603],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Loup',
        GEOID: '31115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11097101.51460994, 5173881.79474231],
              [-11094365.281526241, 5173871.894865102],
              [-11046748.369339418, 5174169.795678072],
              [-11045424.11267694, 5174157.945467624],
              [-11045323.591176754, 5122230.079173163],
              [-11097087.59967359, 5122160.557368139],
              [-11097101.51460994, 5173881.79474231],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Macoupin',
        GEOID: '17117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10035869.543104088, 4796478.659204884],
              [-10010520.647897078, 4796736.830569794],
              [-9985541.444718994, 4796919.3872815],
              [-9985197.467492443, 4721525.324145835],
              [-10035005.815175021, 4721678.161687554],
              [-10035237.137076888, 4759262.992322826],
              [-10035869.543104088, 4796478.659204884],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Baca',
        GEOID: '08009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11474360.931199037, 4529174.763788388],
              [-11437812.182023317, 4529205.973841604],
              [-11359251.331193902, 4529295.342698918],
              [-11359256.635924859, 4493494.595222321],
              [-11359259.360706063, 4475152.871242457],
              [-11359261.587095879, 4453969.047236944],
              [-11359254.57396796, 4443998.033847073],
              [-11359290.196205013, 4438142.690503197],
              [-11394138.540158864, 4438341.022166393],
              [-11432304.872855302, 4438430.641977827],
              [-11448317.847647442, 4439050.753782956],
              [-11466152.343267433, 4439121.283519302],
              [-11475492.279603174, 4439087.880954897],
              [-11474360.931199037, 4529174.763788388],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wicomico',
        GEOID: '24045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8452336.205591895, 4621505.911145302],
              [-8445165.560592445, 4629098.749818672],
              [-8440656.341978882, 4647602.729838616],
              [-8427083.32514276, 4658949.075832898],
              [-8426927.977096291, 4656383.47758393],
              [-8426186.477968117, 4644631.945551919],
              [-8402315.34900139, 4643717.878130439],
              [-8386953.74021088, 4643538.560733269],
              [-8383457.9385805, 4628885.687939154],
              [-8389553.459937867, 4620525.394811179],
              [-8417174.385951968, 4618861.439876754],
              [-8422730.898334913, 4621729.033145141],
              [-8434529.873803074, 4619791.309774586],
              [-8446416.158424107, 4610510.031540105],
              [-8447870.624218723, 4613587.148217899],
              [-8451794.979403533, 4614276.322761121],
              [-8452336.205591895, 4621505.911145302],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kodiak Island',
        GEOID: '02150',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-17229993.270314485, 7835365.9154991405],
              [-17220380.498326015, 7851846.46481225],
              [-17212075.396395892, 7866111.0953776045],
              [-17201317.03552767, 7879141.670300702],
              [-17188996.75088412, 7883433.686465757],
              [-17175759.304955933, 7892948.323222682],
              [-17165126.95775128, 7897196.164291504],
              [-17142597.339968104, 7895586.713645339],
              [-17135440.275946528, 7903890.698590917],
              [-17135990.305550545, 7928146.66041164],
              [-17118868.032032646, 7941401.288782226],
              [-17112163.03646319, 7944374.179070449],
              [-17104105.954358548, 7942172.980025211],
              [-17088880.342324793, 7948258.209321743],
              [-17091238.089139793, 7954958.213853379],
              [-17085827.85056775, 7962382.53810232],
              [-17074898.391642172, 7953995.432739898],
              [-17065167.62099346, 7964298.612390085],
              [-17072577.602898113, 7975525.618822671],
              [-17078612.12117453, 7979856.064859633],
              [-17072211.027814932, 7989783.472968644],
              [-17067073.188036863, 7996867.093476095],
              [-17056785.26333673, 8001451.270945699],
              [-17054457.79542322, 8011156.259269074],
              [-17043218.979632735, 8021698.568756209],
              [-17036815.32592485, 8031946.35981938],
              [-17023598.362782966, 8039016.049223597],
              [-17018869.622133557, 8051912.774185912],
              [-17008257.42375675, 8054222.463601952],
              [-17002253.852298774, 8064717.253710515],
              [-16991841.917685896, 8066676.6745830905],
              [-16994725.871733878, 8082492.349074749],
              [-16989149.878440045, 8094824.95549255],
              [-16982920.55105474, 8098635.278683484],
              [-16971081.277930915, 8098386.2274926985],
              [-16960048.625837374, 8102612.671531588],
              [-16958100.868706964, 8092099.633530913],
              [-16963711.148403965, 8077967.704432796],
              [-16972570.732717726, 8068111.7660843795],
              [-16977611.94717779, 8057631.141207375],
              [-16976053.140348215, 8045947.001026235],
              [-16968678.78068061, 8042311.509763566],
              [-16963681.42609992, 8043219.262278531],
              [-16958952.24017255, 8050040.684941402],
              [-16960202.358054157, 8056806.462827341],
              [-16954149.13810329, 8057917.748314523],
              [-16945925.076762468, 8046811.671451871],
              [-16934951.42399905, 8051056.861404604],
              [-16930497.865130883, 8044947.860986172],
              [-16918534.470774822, 8040773.377092714],
              [-16900203.490225893, 8022863.70326267],
              [-16897819.583330553, 8011793.561735509],
              [-16905236.244404655, 8002748.132687163],
              [-16924360.82160345, 8006014.388820424],
              [-16933053.20404204, 7998590.103699432],
              [-16950074.622101277, 7995884.802363921],
              [-16962240.50661109, 7992571.097706954],
              [-16974293.624476735, 7994636.773640167],
              [-16979454.61870889, 7987043.429314847],
              [-16993677.353450093, 7980152.972492221],
              [-17005908.248542532, 7973598.482745453],
              [-17000993.6043435, 7964663.574264489],
              [-17004272.408625327, 7953353.786867953],
              [-17010153.306004442, 7946167.107318412],
              [-17008528.486716826, 7937558.8741656765],
              [-17004434.823762394, 7932621.176440838],
              [-16996393.882983927, 7941245.955178809],
              [-16991292.555998832, 7950239.436245353],
              [-16979148.15615074, 7949119.457150813],
              [-16968720.30285068, 7962283.661251988],
              [-16967603.21176057, 7956540.747511982],
              [-16956641.581502154, 7949819.005396274],
              [-16959652.662408624, 7932687.253206199],
              [-16944189.828539982, 7923631.1489254655],
              [-16953820.634285964, 7914132.630426433],
              [-16969563.436673947, 7910111.03404165],
              [-16963621.53621387, 7897879.670719929],
              [-16955514.02637991, 7891325.428433493],
              [-16938553.72272112, 7888594.769191639],
              [-16938337.76290898, 7882428.688297226],
              [-16949465.70448664, 7868636.874119222],
              [-16956594.82731602, 7856352.77723991],
              [-16948793.55740123, 7839017.2668084325],
              [-16956595.272593986, 7830480.3106209105],
              [-16973426.334323965, 7849388.948856746],
              [-16984073.375701398, 7852430.710249615],
              [-16987482.08982898, 7838634.374564349],
              [-16990742.971672785, 7826357.186830965],
              [-16998007.347683482, 7817836.3290289],
              [-17011642.760791257, 7814552.12342455],
              [-17025588.421319876, 7812820.612364844],
              [-17026241.86673083, 7798507.36339878],
              [-17018559.486032207, 7793876.813892268],
              [-17020810.25481656, 7787161.910013803],
              [-17039043.274213586, 7781362.101863003],
              [-17054170.145859014, 7768715.937968172],
              [-17061584.5805433, 7760045.705551586],
              [-17069955.36097299, 7756609.061883616],
              [-17076884.44267742, 7776592.256945124],
              [-17086041.250031598, 7777699.264523916],
              [-17096539.9025278, 7770150.272827794],
              [-17092376.330933154, 7759146.854274059],
              [-17092160.70507949, 7737235.74252676],
              [-17099077.207681455, 7737125.9071719535],
              [-17109739.94510709, 7730617.2724802205],
              [-17118318.11374813, 7725515.324212374],
              [-17125350.388620522, 7723843.844590492],
              [-17132308.969990008, 7713498.636175723],
              [-17140060.146133944, 7708148.283329964],
              [-17145098.688926227, 7696879.884771775],
              [-17160249.828220647, 7695336.669672416],
              [-17157563.688907806, 7707601.620291975],
              [-17177233.397653013, 7728884.624563355],
              [-17178032.114999454, 7743514.274211982],
              [-17188563.161467478, 7753649.169596218],
              [-17202038.163189024, 7760505.391110408],
              [-17201469.765869036, 7786552.728153629],
              [-17209434.11883784, 7812862.804498787],
              [-17220218.52846691, 7818411.365784719],
              [-17231571.44673546, 7819390.181949461],
              [-17229993.270314485, 7835365.9154991405],
            ],
          ],
          [
            [
              [-17236756.152019158, 7642548.5859597735],
              [-17221808.727392893, 7662894.022089405],
              [-17200428.48335215, 7679618.683127153],
              [-17166616.078579623, 7680756.39060234],
              [-17153869.66292532, 7682395.391739029],
              [-17145989.133533083, 7673242.1629920285],
              [-17129705.652378317, 7671910.198431134],
              [-17130697.954319246, 7665389.508973355],
              [-17145531.499106433, 7654977.796225404],
              [-17172849.524786085, 7657869.391118145],
              [-17202146.0317756, 7659137.795413985],
              [-17212696.336515535, 7653598.216578208],
              [-17225899.384721074, 7638797.502629964],
              [-17236756.152019158, 7642548.5859597735],
            ],
          ],
          [
            [
              [-17338010.91369134, 7523032.26581258],
              [-17331119.791933272, 7531565.16479483],
              [-17321910.887057398, 7544259.953191872],
              [-17313586.192896895, 7540959.559137506],
              [-17316219.344132118, 7527910.705402388],
              [-17317562.07983007, 7516622.300742057],
              [-17320311.11465521, 7511127.335653205],
              [-17334514.47980501, 7513231.003677637],
              [-17338010.91369134, 7523032.26581258],
            ],
          ],
          [
            [
              [-17447507.659142368, 7573877.759779655],
              [-17441872.109920952, 7578111.131189965],
              [-17434274.99995228, 7571401.7088664165],
              [-17434658.49559806, 7561960.347295125],
              [-17441739.7510464, 7557288.395541621],
              [-17447692.89477504, 7562923.960509277],
              [-17447507.659142368, 7573877.759779655],
            ],
          ],
          [
            [
              [-17449417.01104845, 7808466.6172992475],
              [-17440730.862501346, 7808284.372310613],
              [-17440663.068931453, 7820238.509133294],
              [-17434568.66076899, 7828888.294532454],
              [-17421748.106333822, 7834596.18492424],
              [-17422475.35656717, 7849518.620226298],
              [-17407054.935424525, 7867644.207109792],
              [-17380538.29875909, 7865016.797966805],
              [-17373760.722881638, 7880520.0168844545],
              [-17360583.16683949, 7883384.035835172],
              [-17357107.327058963, 7874273.995297079],
              [-17348722.965651397, 7889812.455110898],
              [-17354536.626058076, 7897916.511892447],
              [-17340016.890915435, 7897950.022945644],
              [-17337768.125881918, 7912861.378179104],
              [-17331607.70526142, 7912699.540930658],
              [-17331751.530043524, 7925000.098958755],
              [-17314503.354181543, 7925380.082024593],
              [-17304197.50704339, 7931082.755316754],
              [-17304171.792241022, 7940363.41966802],
              [-17291283.778194427, 7941385.797146955],
              [-17291443.299024735, 7977451.986924376],
              [-17285773.24076118, 7977381.0985985845],
              [-17285709.343373463, 7990163.791724246],
              [-17291473.021328773, 8008030.330779811],
              [-17279157.523423336, 8008011.321884443],
              [-17279174.221346952, 8017144.30377486],
              [-17260948.771675296, 8017102.221976538],
              [-17255426.323056534, 8028677.479130211],
              [-17224505.887335323, 8031593.1562704835],
              [-17224439.095640846, 8037563.621817294],
              [-17206665.603101812, 8037609.847466078],
              [-17206622.856417347, 8043497.0420968635],
              [-17195047.633125678, 8043613.3349495],
              [-17191328.560257766, 8055855.824912067],
              [-17182308.78719675, 8055661.333146824],
              [-17176981.147686876, 8064658.304504213],
              [-17177230.948624216, 8105708.591449838],
              [-17122838.57563026, 8105710.517305595],
              [-17122838.57563026, 8124283.015817185],
              [-17103018.251614008, 8124283.873885452],
              [-17103060.107742548, 8149118.845424827],
              [-17064658.58311168, 8149120.352054005],
              [-17073002.28675549, 8141853.118266518],
              [-17076685.069469407, 8124961.135040724],
              [-17081419.487412844, 8117821.1285022525],
              [-17093402.80795776, 8113078.624545263],
              [-17097742.59830633, 8102998.548556619],
              [-17113258.754211064, 8096186.600175924],
              [-17126663.068055954, 8096966.259878561],
              [-17133182.16007579, 8086146.563023517],
              [-17135461.871927746, 8072557.165633823],
              [-17143415.09294747, 8071463.087793899],
              [-17151067.41738358, 8060325.213415502],
              [-17141578.0987104, 8049880.7516646115],
              [-17151455.365808994, 8041768.353748625],
              [-17154713.353346042, 8026402.32709975],
              [-17159373.743828103, 8011758.6946505625],
              [-17167966.272683457, 7995217.221414491],
              [-17181100.19148521, 7986441.499332832],
              [-17196409.96105401, 7978328.7856407175],
              [-17207939.098076485, 7971369.802900069],
              [-17228392.941314843, 7968096.9305553455],
              [-17240779.68369439, 7973143.317590186],
              [-17257445.992577996, 7967170.908440118],
              [-17267728.907901045, 7957644.83784367],
              [-17261401.28540537, 7947247.0499091735],
              [-17265329.63891598, 7939086.061516906],
              [-17284902.054426234, 7930431.979383292],
              [-17286284.865140866, 7916803.270843458],
              [-17293929.39721262, 7907739.120299333],
              [-17310908.068587393, 7917271.528361439],
              [-17322353.938630756, 7920763.30074355],
              [-17323005.157651898, 7902075.100095951],
              [-17324642.556041975, 7895476.640923046],
              [-17335134.974646695, 7890706.769529699],
              [-17336093.658101406, 7873319.17638557],
              [-17356407.461420342, 7870332.048615684],
              [-17371050.76119777, 7868339.97258023],
              [-17367270.01733195, 7852944.858723689],
              [-17376044.998832714, 7850552.348012848],
              [-17390342.54027173, 7851683.033121891],
              [-17406142.560877983, 7842416.4391580885],
              [-17403291.446079787, 7829123.218596957],
              [-17404016.803881794, 7810989.082596484],
              [-17403066.24674991, 7797470.850799664],
              [-17407506.03557006, 7792737.911615293],
              [-17449420.907230627, 7793482.64532241],
              [-17449417.01104845, 7808466.6172992475],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Taylor',
        GEOID: '13269',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9400302.376327442, 3837321.0220706216],
              [-9396351.981557664, 3837299.8890407737],
              [-9388456.535353659, 3858282.956762575],
              [-9382701.98559659, 3861853.2476816117],
              [-9377086.696522506, 3860616.8431456313],
              [-9373393.672415437, 3854230.948659461],
              [-9362628.632377766, 3853573.714884638],
              [-9357820.854889894, 3839480.6201973935],
              [-9351211.594082518, 3833074.5683003473],
              [-9351782.329111814, 3831997.481755396],
              [-9363218.848317953, 3830988.2144574733],
              [-9372868.68969686, 3816044.4643222988],
              [-9379180.616144327, 3812248.061192522],
              [-9393340.900651196, 3819630.533427641],
              [-9394509.643985033, 3817784.1563624777],
              [-9401282.099165915, 3833656.721614753],
              [-9400302.376327442, 3837321.0220706216],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henry',
        GEOID: '21103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9497111.705454286, 4649248.164629953],
              [-9493284.652680302, 4649771.004579442],
              [-9480888.448144037, 4662463.322268661],
              [-9470459.259010088, 4664085.509553954],
              [-9459614.84817548, 4652149.580402986],
              [-9458067.395933961, 4641395.404515425],
              [-9452386.205721328, 4644591.571336351],
              [-9447738.83961969, 4629946.072908206],
              [-9451721.18308333, 4632513.736539496],
              [-9461897.009056231, 4626941.932857962],
              [-9493669.261520995, 4630131.048185408],
              [-9500682.166801991, 4644548.354042308],
              [-9497111.705454286, 4649248.164629953],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bienville',
        GEOID: '22013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10397565.826963339, 3811809.6920760972],
              [-10399843.089786498, 3815634.1692891708],
              [-10394210.434871847, 3817270.819233101],
              [-10379057.069187615, 3817260.006821706],
              [-10369098.093582777, 3823208.581250856],
              [-10372612.895185081, 3840337.2240885403],
              [-10339443.917069338, 3840384.917766865],
              [-10339272.819011988, 3823069.4016273413],
              [-10327910.327267228, 3822981.9369727448],
              [-10327462.377636276, 3794327.2119758967],
              [-10332089.260951607, 3782609.9394369237],
              [-10345931.060395315, 3782746.018510506],
              [-10373547.422310293, 3782807.8133824733],
              [-10376439.614000592, 3794297.337596363],
              [-10400378.536537215, 3794315.7623150074],
              [-10397565.826963339, 3811809.6920760972],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Newton',
        GEOID: '28101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9943346.125692276, 3839216.543982905],
              [-9942788.415043402, 3839219.846550536],
              [-9897918.645250374, 3839285.501786144],
              [-9897844.172511034, 3792774.6327209915],
              [-9943356.589724408, 3792680.6790606156],
              [-9943346.125692276, 3839216.543982905],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Glenn',
        GEOID: '06021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13682478.320567738, 4836846.626391307],
              [-13586151.00483603, 4836580.462096817],
              [-13583927.620646417, 4836941.096865154],
              [-13577400.958901204, 4825683.3918546075],
              [-13575369.60083321, 4827212.8770098295],
              [-13580348.142419957, 4818313.681911323],
              [-13580312.297543924, 4798443.035715827],
              [-13565007.092074247, 4798872.880116909],
              [-13568734.179945495, 4776806.908466446],
              [-13581963.833509332, 4781085.824444537],
              [-13596135.249965278, 4781220.114772795],
              [-13602388.39972161, 4777007.538729774],
              [-13663249.882284034, 4776720.781268915],
              [-13662868.83566705, 4805191.902449389],
              [-13679534.810592182, 4805111.019646199],
              [-13680350.11454275, 4823729.865043964],
              [-13685357.042599652, 4836654.065882961],
              [-13682478.320567738, 4836846.626391307],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '05069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10265093.740488, 4059781.2329003187],
              [-10264552.171165291, 4095161.809554009],
              [-10244732.292427003, 4094700.8453397364],
              [-10238588.458410632, 4094610.491541861],
              [-10208574.49730295, 4093798.4203543216],
              [-10209078.106679296, 4070202.4559728387],
              [-10209310.319137093, 4060255.047479591],
              [-10189962.546359258, 4058893.5739115765],
              [-10187333.513945192, 4047924.5399875958],
              [-10180382.39098159, 4046791.0196497827],
              [-10179679.185758248, 4039568.8937679534],
              [-10197125.176355371, 4040631.9328697617],
              [-10209361.526102858, 4052117.0461408054],
              [-10210961.187185556, 4037548.6001015916],
              [-10213005.569633976, 4041433.746981421],
              [-10236231.156873593, 4041347.581179561],
              [-10236250.081187027, 4037417.850413918],
              [-10267372.45046454, 4037172.0773151345],
              [-10265093.740488, 4059781.2329003187],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lawrence',
        GEOID: '05075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10169017.004930068, 4332448.79202992],
              [-10158896.504744088, 4336163.526710928],
              [-10148227.644746462, 4328992.351281074],
              [-10138251.748579022, 4316442.147470232],
              [-10135107.863520037, 4321469.414268899],
              [-10108902.476150867, 4321221.124851462],
              [-10101957.141800784, 4321158.94999328],
              [-10110121.09061658, 4311603.159705798],
              [-10113605.501997901, 4296231.768206354],
              [-10115912.153166628, 4284241.624761596],
              [-10133691.434319187, 4284818.683131148],
              [-10145524.918829491, 4285495.941380398],
              [-10152176.815001845, 4285499.376557083],
              [-10169840.323883977, 4285581.408898492],
              [-10169017.004930068, 4332448.79202992],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marinette',
        GEOID: '55075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9843459.591881435, 5735978.822719461],
              [-9802710.424359612, 5734485.992660574],
              [-9802461.565847406, 5745958.339671028],
              [-9801515.743584419, 5745570.7580978405],
              [-9795656.108228043, 5747627.917357983],
              [-9792438.30702717, 5742613.726367879],
              [-9782735.922848612, 5741149.29966144],
              [-9777530.341602098, 5736030.896175368],
              [-9774416.349384686, 5732970.459221339],
              [-9771737.000560785, 5728249.997684568],
              [-9776598.211404234, 5724949.135872507],
              [-9771365.638739496, 5717943.532022353],
              [-9772436.643560417, 5712487.342847197],
              [-9774319.167469224, 5704502.671958264],
              [-9774493.939069768, 5696317.64407047],
              [-9779131.063778253, 5691721.228156285],
              [-9780177.578311201, 5683621.747700238],
              [-9780918.854800394, 5677269.53225891],
              [-9773902.943893146, 5677362.676968148],
              [-9768388.621597212, 5677589.0479910895],
              [-9763472.641564291, 5682150.953309463],
              [-9757971.454968268, 5679761.961982702],
              [-9759092.88751852, 5671464.15462259],
              [-9763997.2903244, 5660209.956249399],
              [-9767373.053882705, 5652596.661917056],
              [-9762168.86768812, 5645249.303157774],
              [-9756951.991071584, 5638282.523473206],
              [-9750497.353036916, 5636531.341885565],
              [-9754453.64773971, 5628633.335307619],
              [-9754960.15142282, 5617880.088948177],
              [-9762328.83379639, 5617465.91112839],
              [-9769692.227489054, 5615659.482780225],
              [-9789929.833621636, 5620428.519157912],
              [-9809601.768756662, 5625234.596277106],
              [-9809348.739554087, 5638886.463613803],
              [-9817182.069482228, 5639146.253931867],
              [-9816860.133514855, 5652742.472887896],
              [-9830519.925591115, 5653312.153588941],
              [-9830157.914607055, 5680690.225378979],
              [-9843771.286455655, 5681070.55907833],
              [-9843459.591881435, 5735978.822719461],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stewart',
        GEOID: '47161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9803966.776132705, 4394335.053646599],
              [-9797427.869243508, 4394183.34447131],
              [-9779369.064849569, 4392334.1370692],
              [-9779773.933837583, 4388108.697799236],
              [-9762072.12079412, 4388606.889733747],
              [-9756168.190536907, 4388773.052478778],
              [-9750736.689942122, 4351329.880231433],
              [-9764444.126760442, 4351409.64836856],
              [-9776279.837660566, 4345948.072200315],
              [-9793971.176415395, 4349345.406211097],
              [-9795104.408831673, 4350288.939531823],
              [-9802953.323488522, 4361887.228289559],
              [-9802054.17378386, 4369639.991437734],
              [-9801733.039230447, 4369647.850184169],
              [-9799878.011235867, 4376806.9813893335],
              [-9802319.915585909, 4387724.170587055],
              [-9803966.776132705, 4394335.053646599],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '56023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12361704.399679912, 5213465.427448409],
              [-12361531.887053847, 5238274.685088881],
              [-12361313.000350285, 5269847.23980088],
              [-12361356.971549148, 5306562.338904803],
              [-12361367.40275517, 5314926.261910123],
              [-12361377.454335455, 5322992.87987721],
              [-12361430.21977409, 5360151.786692224],
              [-12335757.607487854, 5359879.45299922],
              [-12335757.273529382, 5347837.120762656],
              [-12309559.678524565, 5347844.149396489],
              [-12310599.068610102, 5331192.4598484],
              [-12310562.221858649, 5278422.175650303],
              [-12314544.342683306, 5278424.753977138],
              [-12314549.12942141, 5267961.966998104],
              [-12310830.724470444, 5267947.726240734],
              [-12310837.069681417, 5228391.332970077],
              [-12305627.094873311, 5228406.570136837],
              [-12305438.408336418, 5202637.309576022],
              [-12251122.73447162, 5201622.257494168],
              [-12250487.32281817, 5097976.241680481],
              [-12254581.431050565, 5097916.716926395],
              [-12361563.966228507, 5098248.564427235],
              [-12361660.873759013, 5161214.175940458],
              [-12361704.399679912, 5213465.427448409],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sumter',
        GEOID: '45085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8974152.77521583, 4042184.398356849],
              [-8974415.043936139, 4043471.1332562133],
              [-8970136.81326597, 4042230.6435425226],
              [-8958976.700355474, 4051476.332644391],
              [-8959139.338131523, 4043934.452615629],
              [-8941373.081359388, 4039596.9839274148],
              [-8930978.401267583, 4028154.567722443],
              [-8925644.193907753, 4022369.7570457915],
              [-8905625.387239415, 4035232.550621721],
              [-8894852.888795862, 4029118.7865973786],
              [-8893705.630123746, 4027193.1154742944],
              [-8902731.859715227, 4021624.166668042],
              [-8927307.863697657, 4007201.680331406],
              [-8934799.776747536, 4001442.4582176623],
              [-8955574.331438867, 3993612.6645860067],
              [-8965013.33370221, 3981087.6067993282],
              [-8975415.694838878, 3992767.2148105116],
              [-8974589.258939229, 3994376.9158607177],
              [-8976085.170256509, 4009037.661525506],
              [-8972466.284930311, 4033627.568233248],
              [-8976326.399593059, 4040205.8450897206],
              [-8974152.77521583, 4042184.398356849],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Petroleum',
        GEOID: '30069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12102564.75893767, 5986312.946997216],
              [-12088307.18119585, 5986278.987186767],
              [-12088276.457016388, 5992249.587943787],
              [-12057624.1899485, 5993667.472581755],
              [-12057353.349627398, 6037866.435357617],
              [-12029787.30412226, 6040283.572590474],
              [-12014555.79215549, 6035219.9802795],
              [-12012388.290350253, 6015951.270127587],
              [-12012442.057664307, 6007870.266178442],
              [-12018484.924902529, 6000050.494165142],
              [-12019012.467969397, 5982947.305999287],
              [-12013782.010374984, 5945993.179995066],
              [-12009493.204353193, 5941803.285609698],
              [-12015745.240914615, 5921896.797485801],
              [-12010508.438109227, 5917822.297754547],
              [-12007154.715810098, 5915313.190711211],
              [-12003323.210256483, 5902317.2967107175],
              [-12092799.033968847, 5901263.972949763],
              [-12090534.127609167, 5915472.338208112],
              [-12090293.454870073, 5958105.466839811],
              [-12104529.436630681, 5958120.511246431],
              [-12102564.75893767, 5986312.946997216],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '22117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10057408.871676434, 3632795.98307589],
              [-10057271.494445529, 3632796.285934124],
              [-10047647.695202991, 3632835.0885727433],
              [-10007345.704700163, 3632997.585341889],
              [-10000487.513955675, 3633022.0561855966],
              [-9988491.633863997, 3633064.859034784],
              [-9988494.827638065, 3633049.649431783],
              [-9990932.42501913, 3621446.601501089],
              [-9995571.330839466, 3609444.879202227],
              [-10000534.621655978, 3597370.929644308],
              [-9999404.657481456, 3589813.817124796],
              [-10018151.932949431, 3589358.7436973713],
              [-10047212.77657694, 3595390.77237221],
              [-10054028.089761777, 3618592.673361415],
              [-10057349.752047557, 3620473.1200887184],
              [-10057408.871676434, 3632795.98307589],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mississippi',
        GEOID: '29133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9965299.553791108, 4420948.627156235],
              [-9963281.77670099, 4426048.960551103],
              [-9959241.992380101, 4430152.020984002],
              [-9949186.614096235, 4434221.976697873],
              [-9941658.376513895, 4443116.242135955],
              [-9936111.47198562, 4441266.949970202],
              [-9929146.322766177, 4437680.674350956],
              [-9922230.710720137, 4436606.059462145],
              [-9918437.833029829, 4433233.2481604535],
              [-9918915.6661918, 4431409.963484489],
              [-9920845.562296195, 4424049.176641184],
              [-9923873.675084753, 4417822.551204767],
              [-9924788.387340602, 4409754.289424144],
              [-9924798.841250498, 4409360.455733325],
              [-9924910.727460982, 4405146.24015426],
              [-9929978.102001384, 4399680.256956768],
              [-9925856.720493745, 4392157.199526824],
              [-9926987.923816958, 4390615.991059107],
              [-9929602.398719955, 4387054.748924545],
              [-9932739.715928983, 4379251.989595379],
              [-9938485.58276577, 4380405.808285438],
              [-9943575.44384331, 4386830.461816176],
              [-9943871.75150456, 4386818.573311851],
              [-9949039.338409916, 4397782.056162342],
              [-9965287.531286104, 4417926.604459759],
              [-9965299.553791108, 4420948.627156235],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Briscoe',
        GEOID: '48045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11295762.61183809, 4129614.9775350927],
              [-11253370.70259063, 4129721.1937323366],
              [-11237139.207638063, 4129725.935550364],
              [-11237272.01179058, 4070875.6310782884],
              [-11247886.547876699, 4070833.1774109523],
              [-11295764.615588922, 4070812.422342672],
              [-11295762.61183809, 4129614.9775350927],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clark',
        GEOID: '05019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10405995.272764679, 4074662.330403246],
              [-10398144.799634956, 4074483.831550173],
              [-10392435.890869113, 4066502.661878351],
              [-10374784.84976995, 4066102.680087654],
              [-10356613.167412348, 4060624.660835476],
              [-10356958.591792278, 4049641.7131920336],
              [-10340053.947878886, 4049751.7524084942],
              [-10340814.371320494, 4026557.6965315966],
              [-10348417.826500146, 4025332.7387389215],
              [-10340817.042988274, 4015751.3243224476],
              [-10340860.902867645, 4003310.4749269816],
              [-10343554.945864333, 4004855.0605870564],
              [-10356280.322134875, 3997955.745180466],
              [-10364322.153469272, 3998899.208114183],
              [-10368217.111132639, 4003963.8971513235],
              [-10382154.9792969, 4006303.7677940703],
              [-10394280.009553595, 4023039.031623105],
              [-10401043.670494704, 4035482.7155612893],
              [-10404107.739478787, 4056462.93138659],
              [-10408618.182606751, 4057587.590739726],
              [-10405995.272764679, 4074662.330403246],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cottle',
        GEOID: '48101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11189539.10469435, 4071056.6337393955],
              [-11178456.470149443, 4070978.7335049985],
              [-11131695.270888349, 4070750.2921385695],
              [-11131684.250258759, 4058967.352111151],
              [-11136103.41140427, 4060909.318460951],
              [-11137184.212340383, 4059697.755259023],
              [-11137345.848241016, 4006798.549100645],
              [-11189689.497326411, 4006755.1275671446],
              [-11189539.10469435, 4071056.6337393955],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hopkins',
        GEOID: '21107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9775344.419979429, 4488095.531738824],
              [-9750872.165762417, 4503695.5843586875],
              [-9740133.953722028, 4507319.968682701],
              [-9726556.649388442, 4518856.3772770995],
              [-9721368.938478496, 4494793.744440678],
              [-9717742.372107431, 4493862.936507376],
              [-9727879.68153652, 4477312.863463446],
              [-9721947.577191638, 4461039.19444881],
              [-9742665.581581647, 4453828.348558677],
              [-9760561.636880046, 4459929.244561424],
              [-9774411.117368618, 4472764.135120881],
              [-9779501.869002085, 4484104.016722536],
              [-9775344.419979429, 4488095.531738824],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McHenry',
        GEOID: '17111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9874860.37120542, 5235205.552221236],
              [-9852544.375525074, 5235401.213681566],
              [-9830033.348096859, 5235510.697209638],
              [-9820260.387361137, 5235558.228896999],
              [-9818310.406573858, 5235532.806211232],
              [-9818223.35199911, 5223434.070834394],
              [-9818228.472695684, 5210369.2332973415],
              [-9818184.167538349, 5197239.238355988],
              [-9818211.440813594, 5197233.073294706],
              [-9818332.779058559, 5184114.92573633],
              [-9822659.21106824, 5184113.273979654],
              [-9824800.998071102, 5184086.845911865],
              [-9835543.328932652, 5184075.583973492],
              [-9839948.575141815, 5184060.868394128],
              [-9861644.187299969, 5184014.319262508],
              [-9874660.552719446, 5184006.360885409],
              [-9874860.37120542, 5235205.552221236],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grant',
        GEOID: '21081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9437751.700183682, 4688095.218554537],
              [-9424320.001744056, 4689820.726305283],
              [-9419372.62961473, 4693388.89282941],
              [-9410091.255750349, 4691912.002359901],
              [-9403858.588780325, 4656380.6310610175],
              [-9404860.018919501, 4651518.35971964],
              [-9412883.92781588, 4649294.38852329],
              [-9415462.532500615, 4646467.576481101],
              [-9437034.35738501, 4667184.759508175],
              [-9438310.746666444, 4681708.457038953],
              [-9437751.700183682, 4688095.218554537],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Amite',
        GEOID: '28005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10137391.916832136, 3676840.1538792076],
              [-10128181.453483392, 3678113.9793511173],
              [-10089253.027552983, 3678196.7506521465],
              [-10079779.404928003, 3678231.6842193333],
              [-10079709.877582988, 3632746.8189615784],
              [-10081894.074576212, 3632742.003758311],
              [-10103220.618021289, 3632694.9881149423],
              [-10110685.050885484, 3632687.5018936126],
              [-10136767.021307964, 3632661.3438261896],
              [-10136693.72098588, 3669416.329969153],
              [-10140693.318970593, 3674504.3906123163],
              [-10137391.916832136, 3676840.1538792076],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bolivar',
        GEOID: '28011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10152965.957307804, 3968133.2926571337],
              [-10151106.589417357, 3972040.3507098155],
              [-10144645.606171716, 3976676.840337356],
              [-10149923.151910733, 3982050.1463744924],
              [-10141314.704368198, 3983312.8828650014],
              [-10138465.92727931, 3990517.4917593296],
              [-10146024.298065191, 3994899.565042036],
              [-10142485.1174944, 3998572.03396906],
              [-10139592.591845628, 3998818.719462833],
              [-10133055.02079032, 3997108.9042797475],
              [-10132875.907729633, 4002775.920985319],
              [-10135953.446372105, 4005218.1917080833],
              [-10136891.647040509, 4012365.7761171605],
              [-10133010.492994003, 4016452.6708716005],
              [-10134076.822396312, 4021252.5974113117],
              [-10139947.255743295, 4023611.307930942],
              [-10135457.851999093, 4026798.542057391],
              [-10130628.144571537, 4025715.582655011],
              [-10127841.149800036, 4028816.2593534766],
              [-10123690.825224789, 4031225.957715348],
              [-10118097.911368353, 4032409.238360069],
              [-10116107.630192462, 4038479.479146071],
              [-10119067.504133163, 4041520.5855635963],
              [-10124098.365880584, 4043497.7541128607],
              [-10123928.328064518, 4044477.015419528],
              [-10123848.760887122, 4044935.2780859075],
              [-10092164.588834679, 4044774.1494123787],
              [-10091891.299484782, 4027135.251012914],
              [-10092069.188031072, 3977392.37883152],
              [-10103743.15171107, 3977377.9419720517],
              [-10103747.604490703, 3965784.164889296],
              [-10154082.048086772, 3965788.7052583033],
              [-10152965.957307804, 3968133.2926571337],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calhoun',
        GEOID: '28013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9964179.568394238, 4050586.4978028466],
              [-9934761.945798734, 4050465.9570474736],
              [-9934645.17165289, 4038734.956735749],
              [-9922925.678301157, 4038758.3410834875],
              [-9922782.96671396, 4003605.3610910256],
              [-9928589.8366317, 4003547.213922978],
              [-9928783.643865172, 3993756.4347198736],
              [-9931531.899453877, 3991531.411992185],
              [-9963888.690564793, 3991509.997757188],
              [-9963912.958213788, 4011020.203065932],
              [-9964179.568394238, 4050586.4978028466],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Claiborne',
        GEOID: '28021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10156222.499255743, 3747157.813654661],
              [-10150234.735165464, 3752821.696919606],
              [-10149822.853049528, 3759800.704523553],
              [-10143143.572282443, 3761611.777152756],
              [-10139069.167599916, 3766389.9856081153],
              [-10138879.924465569, 3769909.186116534],
              [-10133937.227754857, 3776582.7254283624],
              [-10134467.700629052, 3777491.48266979],
              [-10123706.409953501, 3773600.2074364633],
              [-10099864.001415398, 3792897.4052129816],
              [-10098714.627672955, 3769659.2533122846],
              [-10098546.312602878, 3742926.9759048885],
              [-10100716.708714876, 3735270.0148796393],
              [-10113671.51445594, 3735176.77101001],
              [-10112472.492220607, 3740525.441740204],
              [-10131596.067543983, 3745190.1849742243],
              [-10157237.305692399, 3746223.105831338],
              [-10156222.499255743, 3747157.813654661],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'DeSoto',
        GEOID: '28033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10046594.619444566, 4151293.424082404],
              [-10045969.115225798, 4155403.920157434],
              [-10053184.955938509, 4163295.9912598566],
              [-9995954.492526779, 4163105.612603425],
              [-9991994.373135014, 4163098.379601131],
              [-9988065.150857514, 4163091.203035854],
              [-9987967.875659814, 4132982.0067829834],
              [-10008980.542741952, 4133008.433210837],
              [-10022099.43341245, 4124263.2028708463],
              [-10037843.571634324, 4131179.6007280755],
              [-10041040.222131943, 4126493.4301682687],
              [-10041254.734790701, 4144922.680008761],
              [-10053421.760363726, 4146615.519122166],
              [-10046594.619444566, 4151293.424082404],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Walworth',
        GEOID: '46129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11179825.254608238, 5715655.370030927],
              [-11100497.53831557, 5715433.442677681],
              [-11099410.948765935, 5715427.556507569],
              [-11099553.660353133, 5660311.46195045],
              [-11160916.971180055, 5660460.718522804],
              [-11166166.909685357, 5667594.248547559],
              [-11162470.212035093, 5681836.822030816],
              [-11170011.884897357, 5696280.338878697],
              [-11186112.802087223, 5706384.936324903],
              [-11179825.254608238, 5715655.370030927],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '28085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10100777.043878885, 3723797.6324666245],
              [-10064862.481842212, 3724054.7301415144],
              [-10060989.788077006, 3722058.0158518394],
              [-10046048.708661713, 3726288.110998929],
              [-10045903.882004192, 3678322.9290807983],
              [-10047740.764921773, 3678322.9290807983],
              [-10079779.404928003, 3678231.6842193333],
              [-10089253.027552983, 3678196.7506521465],
              [-10089245.123869136, 3712409.4133464317],
              [-10100833.371541226, 3712372.1597471233],
              [-10100777.043878885, 3723797.6324666245],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greene',
        GEOID: '28041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9889813.584445208, 3689202.7533872253],
              [-9846147.297350096, 3689481.153241499],
              [-9846059.792547382, 3687581.6883165464],
              [-9844205.989067204, 3647601.827593285],
              [-9843539.626564113, 3632525.946942491],
              [-9886187.908630071, 3632408.3717232123],
              [-9888993.382437043, 3632487.20030966],
              [-9889723.304338174, 3633600.204420698],
              [-9889813.584445208, 3689202.7533872253],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grady',
        GEOID: '13131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9392761.482701614, 3642997.8454497],
              [-9363821.97731907, 3642879.3072847715],
              [-9364090.702569846, 3630276.1643591207],
              [-9359292.832516655, 3621395.73932701],
              [-9360160.577108983, 3590735.3502125395],
              [-9364751.383747702, 3591006.3306807675],
              [-9382620.556395348, 3591882.9111069166],
              [-9393222.588465454, 3592403.0276926225],
              [-9392761.482701614, 3642997.8454497],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Las Marías',
        GEOID: '72083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7467534.3040333595, 2067411.216371914],
              [-7462628.788032571, 2071486.0350918726],
              [-7462657.174502724, 2070403.3307875795],
              [-7450849.404794792, 2067228.4729709355],
              [-7448079.441905382, 2067193.6593082338],
              [-7447047.287586747, 2059535.3953313092],
              [-7455999.155758379, 2061899.1583692015],
              [-7460614.016568705, 2060440.8159604538],
              [-7464664.042282745, 2066296.729835797],
              [-7467534.3040333595, 2067411.216371914],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pocahontas',
        GEOID: '54075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8945639.62348302, 4611379.44756107],
              [-8944762.759854043, 4628325.871507011],
              [-8932890.202202467, 4634448.036213634],
              [-8918574.738325436, 4646597.537561182],
              [-8908810.683148975, 4644497.744547915],
              [-8890336.323095905, 4657533.110581785],
              [-8880677.464838246, 4684469.963006476],
              [-8876524.913873183, 4675882.238087315],
              [-8864011.935191074, 4673686.608482819],
              [-8863165.907061046, 4667501.204832559],
              [-8866494.471155256, 4663327.364886604],
              [-8868726.760904133, 4651849.96979285],
              [-8871171.336921953, 4645146.019884224],
              [-8871014.042481462, 4640554.241605397],
              [-8876015.07060535, 4629942.807833444],
              [-8883750.995979048, 4623867.8738865],
              [-8881908.547086928, 4618105.920382203],
              [-8882962.9137413, 4617250.940130533],
              [-8888897.407357913, 4612440.014530073],
              [-8896227.79582665, 4605506.216275521],
              [-8898763.431187939, 4595205.85597912],
              [-8901327.14941054, 4588415.263638881],
              [-8924391.070399892, 4584528.342770582],
              [-8935020.300658798, 4586013.18484009],
              [-8946001.077869626, 4595589.562478891],
              [-8945639.62348302, 4611379.44756107],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lares',
        GEOID: '72081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7448383.67807372, 2073022.671485151],
              [-7446532.434941827, 2080560.7458019825],
              [-7444712.69522583, 2079365.3122765415],
              [-7438838.477016161, 2077735.193397621],
              [-7439050.540646121, 2075434.78965042],
              [-7439170.877015668, 2066139.4313250748],
              [-7438064.583916164, 2064526.6641831968],
              [-7439756.751495713, 2064239.872226886],
              [-7439184.012715582, 2057601.887693766],
              [-7440234.089472235, 2057521.1628637218],
              [-7443265.430526026, 2059418.6907383143],
              [-7447047.287586747, 2059535.3953313092],
              [-7448079.441905382, 2067193.6593082338],
              [-7448383.67807372, 2073022.671485151],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jasper',
        GEOID: '45053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9048520.02617721, 3835343.654901367],
              [-9018506.801808009, 3862572.2271662042],
              [-9006019.315289292, 3845179.575241011],
              [-9002374.381202249, 3850384.752248627],
              [-8998683.360846017, 3843499.0304961293],
              [-8996695.41737943, 3824364.5606935467],
              [-8999229.939545812, 3813963.0750680463],
              [-9009636.308184149, 3802769.2552768732],
              [-9017587.74809202, 3803613.8669423456],
              [-9018679.56965772, 3795252.1702265013],
              [-9002120.871310048, 3773618.0748480614],
              [-9004134.564990671, 3767853.2722187866],
              [-9010558.70148486, 3770903.3213275825],
              [-9017629.604220558, 3776595.7350818026],
              [-9021138.394570364, 3774403.610343665],
              [-9029495.037424723, 3778179.7329257946],
              [-9030165.959995735, 3786585.7945008427],
              [-9033308.973473798, 3793167.2257594843],
              [-9033969.746996142, 3794551.3380054845],
              [-9031131.433939386, 3799633.796653485],
              [-9031687.80875437, 3807338.220297832],
              [-9036189.76872333, 3813941.822844676],
              [-9038578.373914981, 3817446.983807617],
              [-9038567.019326922, 3824516.4216337763],
              [-9047483.48790048, 3834953.69664049],
              [-9048520.02617721, 3835343.654901367],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Haywood',
        GEOID: '37087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9268031.283015143, 4261493.351608459],
              [-9267943.279135259, 4261644.982065872],
              [-9261588.717322817, 4262915.2131316345],
              [-9257499.95242598, 4268109.14859957],
              [-9250337.211110376, 4269852.123771134],
              [-9244920.070729904, 4271449.226541895],
              [-9237114.793313444, 4270749.924998512],
              [-9235805.202203352, 4272511.435483729],
              [-9234739.012740932, 4265823.42479679],
              [-9226594.544836026, 4256436.851032969],
              [-9222384.553013712, 4247679.843242544],
              [-9213975.47867919, 4242426.069022505],
              [-9217050.568292864, 4227910.472579324],
              [-9211146.739098642, 4221510.266497298],
              [-9220814.948193528, 4207227.282107666],
              [-9230710.249049632, 4203638.967526768],
              [-9257837.695761045, 4233347.247586154],
              [-9260259.006005289, 4234003.271432274],
              [-9256865.208689475, 4239236.181319338],
              [-9259775.322817793, 4255490.209524964],
              [-9268988.921846239, 4259843.478391529],
              [-9268031.283015143, 4261493.351608459],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monmouth',
        GEOID: '34025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8306056.606076011, 4892481.1834846735],
              [-8298118.635826524, 4897481.516495373],
              [-8291628.041596332, 4902823.3543892205],
              [-8281433.625268465, 4906661.964734964],
              [-8274085.759639674, 4916145.556615842],
              [-8270023.266142663, 4920291.380935493],
              [-8263950.6766003985, 4930593.1573472265],
              [-8262650.516824453, 4931356.503638878],
              [-8260595.061869927, 4930192.820205544],
              [-8255129.942788923, 4931196.838656453],
              [-8249697.662957701, 4930643.474896661],
              [-8242972.741199388, 4927004.892800227],
              [-8239794.569737242, 4934660.3483008975],
              [-8237413.334509682, 4935454.085712125],
              [-8235079.966663163, 4925484.3408983415],
              [-8234456.46619523, 4916643.7696859175],
              [-8235603.0569504015, 4906628.987642515],
              [-8237755.953018908, 4897521.546855062],
              [-8241002.052253876, 4883805.358208059],
              [-8241534.313292735, 4880860.768468984],
              [-8249641.891892814, 4885859.988686502],
              [-8254819.361409609, 4880429.073118968],
              [-8266649.061057229, 4890164.856129359],
              [-8282917.068802776, 4891026.986907788],
              [-8299213.685657458, 4877447.907121867],
              [-8303079.811572709, 4886053.360230633],
              [-8306056.606076011, 4892481.1834846735],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rich',
        GEOID: '49033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12412992.205178913, 5160932.36030942],
              [-12408937.37094299, 5160940.347595745],
              [-12398111.327824362, 5161113.212057583],
              [-12361660.873759013, 5161214.175940458],
              [-12361563.966228507, 5098248.564427235],
              [-12361560.6862173, 5096124.599213459],
              [-12361650.966324335, 5065690.109576778],
              [-12361655.083267089, 5049527.72928537],
              [-12382381.327177819, 5033439.476571999],
              [-12385960.248806823, 5033611.39353967],
              [-12381151.469443535, 5044123.6347069405],
              [-12387777.428174531, 5045581.5328903925],
              [-12385607.254701518, 5056201.024352585],
              [-12393415.315105248, 5065212.54921951],
              [-12403298.704775838, 5065781.471641943],
              [-12409601.169066591, 5069172.713612358],
              [-12413329.815410713, 5074950.553550512],
              [-12401166.713888166, 5109302.476194063],
              [-12413401.950440746, 5146719.724196912],
              [-12412992.205178913, 5160932.36030942],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pierce',
        GEOID: '55093',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10331037.291763611, 5585128.084711781],
              [-10326950.419298118, 5598623.771621349],
              [-10326788.264020506, 5599746.170354767],
              [-10326777.792351263, 5599818.657449062],
              [-10256571.342911849, 5599170.255689286],
              [-10256443.7707754, 5571968.7428826755],
              [-10256454.680085499, 5549326.691012125],
              [-10276673.988007419, 5549279.214457137],
              [-10281637.15265377, 5552350.048901759],
              [-10285840.910584599, 5552249.592603073],
              [-10302538.722884098, 5555282.831003629],
              [-10310191.38127868, 5560780.303898684],
              [-10318926.176443266, 5572761.331904736],
              [-10322837.147560453, 5576753.010193313],
              [-10329598.35372504, 5583657.890220242],
              [-10331037.291763611, 5585128.084711781],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Warren',
        GEOID: '51187',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8716362.21538251, 4713594.828386892],
              [-8717883.507543689, 4722816.709183843],
              [-8701162.318151122, 4724239.930197013],
              [-8699797.875152469, 4726919.721478121],
              [-8689440.375770591, 4724423.040791875],
              [-8683400.40283913, 4718726.67033574],
              [-8689823.871416373, 4706202.7012039395],
              [-8697455.71306618, 4702333.086990416],
              [-8705298.393831545, 4689717.201875182],
              [-8714624.629450716, 4687253.9164368],
              [-8715247.795960177, 4690260.538375334],
              [-8726858.530169407, 4696319.455168904],
              [-8716362.21538251, 4713594.828386892],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '47027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9550882.02513369, 4384922.061789736],
              [-9549938.430325055, 4386508.653270385],
              [-9543627.222599199, 4386330.72211929],
              [-9516519.92471562, 4385576.926380291],
              [-9510737.01886592, 4385994.363854711],
              [-9495086.412709732, 4387124.180313105],
              [-9494509.16707903, 4387165.853928746],
              [-9492912.951056205, 4387125.287402575],
              [-9491885.366681032, 4379787.438040787],
              [-9493869.191326458, 4373974.895633943],
              [-9511846.621172627, 4369359.396417625],
              [-9517306.842196038, 4356226.417810667],
              [-9526272.291345548, 4365710.70368384],
              [-9540533.987908527, 4372742.257704177],
              [-9552757.981192537, 4369567.531025119],
              [-9550882.02513369, 4384922.061789736],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pondera',
        GEOID: '30073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12617958.082623342, 6158627.63602936],
              [-12531887.856092818, 6158530.727371054],
              [-12532012.311283525, 6187646.749509024],
              [-12488353.029633382, 6186677.768807273],
              [-12466774.859538015, 6180125.851070626],
              [-12466768.736966021, 6172698.927498394],
              [-12445063.77397064, 6172500.432719487],
              [-12445057.651398648, 6165249.65419791],
              [-12430575.096965933, 6165190.023240984],
              [-12430557.619805878, 6143457.99677157],
              [-12401995.15353865, 6143456.827235297],
              [-12402003.947778422, 6128879.453968609],
              [-12401939.048515288, 6104721.975972975],
              [-12466031.134020027, 6104291.875379571],
              [-12466015.771930298, 6113972.691214986],
              [-12473164.375670569, 6113996.334594562],
              [-12473126.193085227, 6121276.100198136],
              [-12487570.119654635, 6121367.755071677],
              [-12487570.5649326, 6128629.102410631],
              [-12580751.212618053, 6128681.30702838],
              [-12604806.797981026, 6135254.626054215],
              [-12604447.681303725, 6146165.567819343],
              [-12617958.082623342, 6158627.63602936],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Custer',
        GEOID: '31041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11159915.207082406, 5122084.621037409],
              [-11097087.59967359, 5122160.557368139],
              [-11045323.591176754, 5122230.079173163],
              [-11044231.101694109, 5122203.374385806],
              [-11044273.180461628, 5072809.747421386],
              [-11043256.499552215, 5070652.203129726],
              [-11043735.507321099, 5019277.069596991],
              [-11068050.133139146, 5019198.544010627],
              [-11156910.805345386, 5019217.142118444],
              [-11158458.257586904, 5020290.431351456],
              [-11158232.279020594, 5070531.117135052],
              [-11159901.180826567, 5070527.259027856],
              [-11159915.207082406, 5122084.621037409],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Caribou',
        GEOID: '16029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12484462.52474965, 5296088.196809332],
              [-12476917.0670247, 5304429.068060881],
              [-12474798.657114904, 5315376.495528319],
              [-12422085.093361603, 5315024.46401864],
              [-12361367.40275517, 5314926.261910123],
              [-12361356.971549148, 5306562.338904803],
              [-12361313.000350285, 5269847.23980088],
              [-12361531.887053847, 5238274.685088881],
              [-12375518.480570413, 5232128.191926164],
              [-12382604.300117876, 5232902.305648212],
              [-12383453.44519365, 5251742.841077808],
              [-12387564.807947116, 5244158.498661786],
              [-12397435.95247372, 5249816.88712228],
              [-12425217.735152017, 5248719.650447277],
              [-12421002.511313638, 5225596.708943065],
              [-12423169.122562947, 5223408.136052435],
              [-12438143.263867006, 5225706.354494911],
              [-12453938.831693625, 5223523.184493575],
              [-12458535.32478797, 5253895.79043413],
              [-12464382.047083415, 5269152.509984441],
              [-12479569.476531832, 5266298.974125773],
              [-12483482.801911179, 5275981.424311507],
              [-12481178.599771248, 5286284.813088321],
              [-12484462.52474965, 5296088.196809332],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chippewa',
        GEOID: '27023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10690756.318827394, 5645515.117647969],
              [-10602790.766646622, 5645543.214887971],
              [-10603016.745212933, 5604426.669231382],
              [-10629106.582950663, 5604332.70494062],
              [-10629101.462254087, 5582642.254079926],
              [-10630797.41469632, 5588437.1039790325],
              [-10657360.248950431, 5611457.90713666],
              [-10664883.776735693, 5613527.136237504],
              [-10667147.235941993, 5619456.876714347],
              [-10690756.318827394, 5645515.117647969],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Osceola',
        GEOID: '26133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9525002.58123356, 5490990.3490916705],
              [-9499423.922597554, 5491030.231504057],
              [-9471886.374882057, 5490894.290609302],
              [-9472043.112725094, 5436653.245102633],
              [-9524766.472593587, 5436932.012781914],
              [-9525002.58123356, 5490990.3490916705],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nantucket',
        GEOID: '25019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7823035.769549457, 5058243.449294965],
              [-7813928.2767296955, 5058735.930497874],
              [-7801173.4007940935, 5059583.270334011],
              [-7797824.910511033, 5070290.433556116],
              [-7790679.980313957, 5065412.172507266],
              [-7787931.724725251, 5051440.795611468],
              [-7794059.194776478, 5047504.915140913],
              [-7803158.672592901, 5047932.155054999],
              [-7815906.09012262, 5049103.978819956],
              [-7823035.769549457, 5058243.449294965],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henry',
        GEOID: '01067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9508514.272215731, 3713462.6263283053],
              [-9508469.855738906, 3724867.0114031304],
              [-9486210.1877209, 3724310.2631503446],
              [-9476120.698622834, 3732236.6444866722],
              [-9475395.944468297, 3728269.553479051],
              [-9476130.653107533, 3723336.309527294],
              [-9468632.060888207, 3713562.109144323],
              [-9468608.79511463, 3707107.6081327903],
              [-9466818.889022164, 3703690.605093823],
              [-9467909.867844352, 3700406.754673484],
              [-9470129.530678358, 3693728.2877316657],
              [-9469504.360418063, 3688897.4663844854],
              [-9472452.323173251, 3679966.3653159738],
              [-9471944.928934215, 3674592.089359863],
              [-9472045.223735653, 3672898.1361010144],
              [-9482097.489133544, 3672771.393860211],
              [-9508625.257748052, 3673722.296664517],
              [-9508514.272215731, 3713462.6263283053],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bremer',
        GEOID: '19017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10303087.639293198, 5297844.016507972],
              [-10250473.261206193, 5297828.970437386],
              [-10250483.613918837, 5257646.854859358],
              [-10303118.920070112, 5257685.898478405],
              [-10303087.639293198, 5297844.016507972],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cedar',
        GEOID: '29039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10472216.788808798, 4528654.891123035],
              [-10471343.042125564, 4565448.023639654],
              [-10442730.927365439, 4564289.570515729],
              [-10443037.501243087, 4556082.529889679],
              [-10422666.257066896, 4555358.640520443],
              [-10420560.648898542, 4543008.415422663],
              [-10421289.123646295, 4519235.731215849],
              [-10472423.954381166, 4520483.159699959],
              [-10472216.788808798, 4528654.891123035],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hamilton',
        GEOID: '19079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10460868.768597843, 5244956.117812535],
              [-10408315.05963332, 5244889.7729123235],
              [-10404212.936397586, 5231766.286471255],
              [-10404258.354749832, 5192383.613898997],
              [-10430457.062949555, 5192389.17464857],
              [-10456415.65500764, 5192474.690369781],
              [-10456427.232234681, 5231948.746662652],
              [-10460868.768597843, 5244956.117812535],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carter',
        GEOID: '47019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9161590.530062709, 4351810.5717078755],
              [-9161578.396238213, 4355317.90570938],
              [-9149199.000945058, 4355857.6928777965],
              [-9126399.656035686, 4370791.909594277],
              [-9134760.083752733, 4351309.419868708],
              [-9120892.26276497, 4337107.314849307],
              [-9123756.708685271, 4332057.420457304],
              [-9131397.567213831, 4317741.399133573],
              [-9137119.722999077, 4315178.048709864],
              [-9137231.701182038, 4315174.206528392],
              [-9142352.073024834, 4314998.518424454],
              [-9143877.261368193, 4319380.707378653],
              [-9151714.598798001, 4322523.29467257],
              [-9152716.697999222, 4321807.466491505],
              [-9159889.90220186, 4335308.470910833],
              [-9166098.07888391, 4335463.215249499],
              [-9161590.530062709, 4351810.5717078755],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Essex',
        GEOID: '51057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8584513.518055612, 4600627.739559239],
              [-8579815.724224646, 4599410.426687459],
              [-8578468.647066556, 4602284.081736093],
              [-8575140.082972344, 4592336.149116827],
              [-8564583.099062966, 4590319.5129530495],
              [-8561473.83436562, 4577797.844808517],
              [-8547527.394600565, 4564671.005008017],
              [-8534662.980286023, 4548166.317634192],
              [-8540774.865608536, 4545112.045594887],
              [-8543890.252877876, 4541157.4257353],
              [-8549556.192320272, 4550468.069597895],
              [-8565280.181714313, 4548809.844171602],
              [-8576315.950753596, 4561415.156101398],
              [-8579405.957179036, 4574450.190157868],
              [-8590536.236466002, 4590668.6730109975],
              [-8584513.518055612, 4600627.739559239],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carbon',
        GEOID: '56007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12014683.252972446, 5110124.179938702],
              [-11967927.285727419, 5109804.727729432],
              [-11969330.022630906, 5174164.095575],
              [-11969374.661746714, 5200270.227041073],
              [-11969397.036964364, 5226267.572618167],
              [-11872755.91158811, 5225775.581158508],
              [-11808309.83010265, 5226095.930751765],
              [-11808037.208669698, 5226098.645625218],
              [-11808206.302976212, 5179933.447180053],
              [-11807480.945174202, 5070783.974909896],
              [-11835809.417871784, 5070800.743294821],
              [-11835618.417661019, 5012078.381952536],
              [-11895642.859222148, 5012447.662073788],
              [-11946562.377036355, 5012760.938221394],
              [-11952089.082535824, 5012794.941212936],
              [-12013423.371241493, 5012522.658172204],
              [-12014699.282979121, 5071303.659997849],
              [-12014683.252972446, 5110124.179938702],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Northumberland',
        GEOID: '42097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8564893.68044228, 4959147.939294773],
              [-8556462.89880705, 4969174.735940618],
              [-8554863.349043842, 4984211.367093352],
              [-8549363.832240181, 4994951.356460164],
              [-8557654.573955992, 5004695.921910001],
              [-8555830.715418836, 5023126.6350233145],
              [-8560036.254461516, 5032876.148352829],
              [-8558669.139795082, 5035587.992514064],
              [-8541841.974247279, 5037750.738307455],
              [-8542088.99219735, 5025940.773042756],
              [-8548695.247378478, 5004851.118370057],
              [-8533902.22288594, 5007622.226605162],
              [-8522287.703814026, 5003291.896989398],
              [-8521706.504752593, 4995159.256581066],
              [-8519061.776290325, 4995028.066965756],
              [-8516070.510253219, 4986524.680584407],
              [-8505885.222123599, 4987832.128415549],
              [-8502599.627352836, 4979285.764201261],
              [-8522888.272466853, 4969496.779389253],
              [-8536787.40144832, 4963142.309267005],
              [-8538385.72669713, 4962038.900284303],
              [-8562614.191229304, 4954039.199122673],
              [-8565969.583320796, 4957649.535474012],
              [-8564893.68044228, 4959147.939294773],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Green Lake',
        GEOID: '55047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9934749.700654747, 5428347.616285915],
              [-9926123.664632667, 5429246.2362685],
              [-9929509.224306162, 5436499.132004146],
              [-9926204.482582983, 5462786.089465111],
              [-9894765.743312636, 5462847.817984794],
              [-9894710.528845204, 5449235.967756425],
              [-9894750.047264434, 5408905.688583382],
              [-9908196.9964743, 5408829.555184916],
              [-9921591.180245528, 5408626.3820538735],
              [-9934756.602463176, 5410373.570824415],
              [-9934749.700654747, 5428347.616285915],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hunterdon',
        GEOID: '34019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8369912.124095771, 4952436.665797953],
              [-8365215.457026752, 4957711.579364713],
              [-8347112.570114459, 4968980.751366076],
              [-8345416.728991714, 4969829.113501484],
              [-8336696.516680425, 4981081.978188549],
              [-8329356.220777007, 4974413.480935511],
              [-8318423.088308236, 4971060.30201353],
              [-8317029.8135614665, 4951159.8319338905],
              [-8326457.57255624, 4941146.904067625],
              [-8320925.661780761, 4927772.275914487],
              [-8332960.968527874, 4916451.8429340655],
              [-8340959.114653353, 4915448.808629548],
              [-8342951.224909626, 4918001.677934179],
              [-8345577.363016929, 4924206.9665207295],
              [-8351719.74987992, 4924745.642179545],
              [-8355207.055568001, 4926589.349415059],
              [-8356817.403321817, 4932307.755943592],
              [-8355888.88744911, 4936145.292401725],
              [-8357700.723481261, 4945942.006878373],
              [-8364184.527222516, 4949962.067247118],
              [-8369749.27724778, 4949035.116573597],
              [-8369912.124095771, 4952436.665797953],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Champaign',
        GEOID: '39021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9353388.55804447, 4892708.780747158],
              [-9352480.636277562, 4905760.533273428],
              [-9326814.035243828, 4903803.727009558],
              [-9300892.401256688, 4899329.900278836],
              [-9294565.001399998, 4898760.827147841],
              [-9295590.921827149, 4882153.751562055],
              [-9296975.847612107, 4867422.882364411],
              [-9354852.409348402, 4871783.13746109],
              [-9353388.55804447, 4892708.780747158],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clinton',
        GEOID: '36019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8240695.969670164, 5621106.725461657],
              [-8223682.520598294, 5621714.024566627],
              [-8197535.909920262, 5622066.838582596],
              [-8164519.216867922, 5623228.1838001665],
              [-8164699.1091650445, 5616873.474759805],
              [-8164057.7975785835, 5608571.340713266],
              [-8168604.419541052, 5599042.896824265],
              [-8167029.916663273, 5594241.001861909],
              [-8164395.483467228, 5591357.343850848],
              [-8163551.405214965, 5590433.607746979],
              [-8166138.581500491, 5582409.164053527],
              [-8167016.78096336, 5574462.140439808],
              [-8169733.644455661, 5561835.906778094],
              [-8167207.69389007, 5553695.301647412],
              [-8166696.493943083, 5552900.035049912],
              [-8165060.144147287, 5550354.856283803],
              [-8177957.037879541, 5549030.1108735185],
              [-8181604.532314872, 5540975.076120657],
              [-8200826.848026584, 5533998.872218618],
              [-8227588.721530231, 5532181.687829685],
              [-8236126.369876621, 5575633.05087189],
              [-8240695.969670164, 5621106.725461657],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dickey',
        GEOID: '38021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11021270.159862906, 5770730.471142601],
              [-11020976.682706377, 5825800.301393607],
              [-10913158.746496005, 5825783.87163314],
              [-10910057.608121486, 5825756.488767005],
              [-10910211.985799603, 5770101.121748125],
              [-10917159.791634098, 5770127.912135201],
              [-10955454.030425455, 5770179.773726672],
              [-10978926.969573615, 5770455.733710596],
              [-10989947.088638509, 5770527.243523093],
              [-11021257.653101139, 5770730.421658242],
              [-11021270.159862906, 5770730.471142601],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Doña Ana',
        GEOID: '35013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11944522.919385588, 3866160.897561036],
              [-11898688.009607384, 3866042.6610762943],
              [-11898705.598086929, 3871804.660836153],
              [-11837771.98049447, 3902311.324495542],
              [-11837793.576475684, 3889781.1719641825],
              [-11841787.274527384, 3889737.125365436],
              [-11841852.75134353, 3763473.4107770766],
              [-11868715.570669767, 3763375.6037620534],
              [-11870009.993708713, 3759538.3840472894],
              [-11869267.604024611, 3752031.5360686886],
              [-11870651.861892626, 3746456.6346829315],
              [-11864580.942142723, 3738907.6101272074],
              [-11858669.65454262, 3734878.971661956],
              [-11859058.048245996, 3734978.761128929],
              [-11910466.83624771, 3734949.819479696],
              [-11944224.359444171, 3734941.482347328],
              [-11944540.285226151, 3843039.8165083365],
              [-11944522.919385588, 3866160.897561036],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '05021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10102206.720099144, 4339291.670473255],
              [-10102092.061023626, 4357566.713649293],
              [-10106055.831401428, 4369427.555574012],
              [-10103988.388549289, 4369431.959188679],
              [-10082894.131579317, 4369419.763041698],
              [-10073810.008553704, 4369414.510843929],
              [-10043327.84366958, 4369077.956135149],
              [-10035883.012762472, 4368995.759086912],
              [-10034494.636073299, 4364085.231492107],
              [-10033341.254829189, 4357885.559926357],
              [-10026116.397237726, 4353902.804542268],
              [-10025825.853366755, 4349843.563800817],
              [-10025876.392415576, 4342399.450117468],
              [-10031547.229915565, 4337228.645020226],
              [-10036111.996955035, 4330117.746225287],
              [-10039807.802069766, 4328036.279728072],
              [-10054483.275159629, 4328255.396352013],
              [-10054356.370940125, 4336338.024954477],
              [-10108546.142460838, 4337403.988903824],
              [-10102206.720099144, 4339291.670473255],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ashe',
        GEOID: '37009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9098621.99217855, 4357646.666403914],
              [-9094280.42071812, 4365197.82906248],
              [-9094798.1676698, 4374741.868024692],
              [-9092301.605449779, 4381850.058903091],
              [-9072519.686657852, 4380699.827382345],
              [-9056199.161115253, 4380203.317019849],
              [-9044057.630571319, 4353402.799647061],
              [-9045114.831775382, 4351183.064166645],
              [-9056870.837920096, 4351159.839210025],
              [-9057702.394516323, 4339831.759277949],
              [-9070035.5922208, 4333729.957007635],
              [-9079924.43654644, 4338140.8785859635],
              [-9087921.294806553, 4348833.864940861],
              [-9097626.882725026, 4354382.158698832],
              [-9098621.99217855, 4357646.666403914],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Luna',
        GEOID: '35029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12048035.351650547, 3831346.3658048306],
              [-12014018.67561241, 3831422.8027483434],
              [-12014044.390414786, 3842908.8611941803],
              [-11978921.755235616, 3843050.2559953285],
              [-11944540.285226151, 3843039.8165083365],
              [-11944224.359444171, 3734941.482347328],
              [-11958189.724589769, 3734938.0333075216],
              [-12045703.319637919, 3734938.0333075216],
              [-12046676.251987452, 3739768.1820955016],
              [-12046677.253862869, 3745489.9422305445],
              [-12046657.327674018, 3773798.458367237],
              [-12048035.351650547, 3831346.3658048306],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '29137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10274885.959495632, 4808757.17247884],
              [-10274712.857687447, 4808756.594536354],
              [-10262175.500036854, 4808574.255349147],
              [-10261985.700305052, 4817080.6955001475],
              [-10224332.661780663, 4816441.702230431],
              [-10209694.59401931, 4816316.048483365],
              [-10209325.792546313, 4807853.744651247],
              [-10209997.49435376, 4770364.959772842],
              [-10227439.366129722, 4770173.817497073],
              [-10275905.312072827, 4771613.375104106],
              [-10274885.959495632, 4808757.17247884],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grant',
        GEOID: '38037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11365301.337388357, 5896117.620142835],
              [-11323213.219031274, 5896168.44195757],
              [-11323207.653056733, 5882050.337994641],
              [-11276558.886481341, 5881938.645440841],
              [-11276551.984672913, 5840075.630814285],
              [-11248671.12764781, 5840066.273261479],
              [-11246125.250893367, 5826013.085662703],
              [-11265317.955620525, 5809847.556520072],
              [-11264391.109540181, 5804209.4798268555],
              [-11276853.43785398, 5801731.451460568],
              [-11276655.177840877, 5797166.492606108],
              [-11304960.1621259, 5781444.7617291],
              [-11312589.109468944, 5786284.970014542],
              [-11317243.488698503, 5782214.09352592],
              [-11326712.658543851, 5787028.90223498],
              [-11336595.491616987, 5785645.9662270965],
              [-11337818.336223353, 5792099.375829769],
              [-11354429.430639524, 5788920.5257867575],
              [-11354352.954149349, 5813338.900357842],
              [-11359812.173297342, 5825914.344103432],
              [-11360291.737663679, 5882035.2618484935],
              [-11365339.853932172, 5882054.390726517],
              [-11365301.337388357, 5896117.620142835],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sheridan',
        GEOID: '38083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11206801.195492681, 6052796.682593024],
              [-11197082.781307446, 6052775.851986127],
              [-11197088.90387944, 6081518.345771322],
              [-11153989.893226461, 6081538.250741702],
              [-11139653.056007195, 6081488.654276089],
              [-11135605.813280426, 6052727.743395755],
              [-11135655.127814846, 5995644.623032107],
              [-11144557.236174094, 5995656.119410445],
              [-11206898.822686108, 5995683.053842213],
              [-11206801.195492681, 6052796.682593024],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Benewah',
        GEOID: '16009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13028887.790803267, 6002025.30163541],
              [-12983087.45957866, 6002914.360677814],
              [-12978355.268025037, 6010027.501389725],
              [-12949730.240203984, 6009914.979618759],
              [-12949731.576037873, 5945651.892111416],
              [-12964058.617141949, 5948049.518146864],
              [-13006042.651775142, 5947372.67439726],
              [-13020788.699442564, 5960903.192366837],
              [-13028814.655062215, 5962872.409168645],
              [-13028814.946048247, 5967367.273327958],
              [-13028850.985940782, 5984497.021735121],
              [-13028887.790803267, 6002025.30163541],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mercer',
        GEOID: '17131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10142784.789563615, 5049291.128444535],
              [-10138357.557534566, 5061677.493678775],
              [-10138321.058729379, 5061779.674862213],
              [-10067041.33823551, 5060691.875589861],
              [-10067473.925776733, 5034676.96241539],
              [-10067670.515997473, 5021785.499080754],
              [-10106161.567648554, 5022487.420294706],
              [-10124718.542647002, 5022653.345683433],
              [-10124759.872657463, 5023075.506583804],
              [-10125314.308678519, 5028740.509230951],
              [-10129840.559174174, 5036349.467664099],
              [-10134697.428557483, 5036877.951806348],
              [-10139140.078115555, 5044021.526424645],
              [-10142784.789563615, 5049291.128444535],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'New Hanover',
        GEOID: '37129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8686251.183678854, 4073437.836374505],
              [-8663180.998448383, 4081159.099264077],
              [-8651028.713891832, 4067842.035087699],
              [-8656651.331076924, 4061833.495117983],
              [-8663907.914723264, 4050658.6076162467],
              [-8670169.199209392, 4033938.0126370382],
              [-8678089.572572364, 4060332.066099402],
              [-8686251.183678854, 4073437.836374505],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cottonwood',
        GEOID: '27033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10626842.121868946, 5495814.898854828],
              [-10588847.33250782, 5495715.3739061495],
              [-10587460.625611007, 5495675.471071638],
              [-10586582.871426104, 5493385.929829623],
              [-10586508.176047781, 5482175.943043023],
              [-10559744.966710245, 5482173.152415711],
              [-10559698.769121565, 5441964.240314654],
              [-10586548.80766192, 5441940.160553861],
              [-10625723.917583928, 5441942.630270019],
              [-10626828.76353005, 5441936.147266519],
              [-10626842.121868946, 5495814.898854828],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Owsley',
        GEOID: '21189',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9338064.650900342, 4511513.581448821],
              [-9331839.4423362, 4507182.342906479],
              [-9310284.204055935, 4514647.047579105],
              [-9303992.426436298, 4509908.259126317],
              [-9298993.624702226, 4497449.0251290295],
              [-9300479.405945845, 4485823.420845741],
              [-9300941.270513145, 4479217.246834866],
              [-9298172.754777117, 4475203.921510955],
              [-9312243.093135424, 4489136.047157901],
              [-9326900.753127158, 4487825.546719857],
              [-9337918.933686892, 4505851.6327456655],
              [-9338064.650900342, 4511513.581448821],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sanborn',
        GEOID: '46111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10946258.149930006, 5495930.572737442],
              [-10893019.603458121, 5495704.815940787],
              [-10892555.623820495, 5495705.126469007],
              [-10892735.738756599, 5442236.53122301],
              [-10905667.612682562, 5442364.498382764],
              [-10945515.871565394, 5442421.922101369],
              [-10946217.406996375, 5445066.734235371],
              [-10946213.399494706, 5455807.407840177],
              [-10946258.149930006, 5495930.572737442],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hawkins',
        GEOID: '47073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9270753.428360844, 4355066.761094066],
              [-9252983.609365005, 4371563.224934088],
              [-9240718.761827875, 4378464.181966155],
              [-9234009.536117764, 4375597.572544908],
              [-9220641.623746363, 4382632.569811528],
              [-9196012.069455983, 4382816.793467547],
              [-9196122.615343217, 4372313.541285621],
              [-9206375.58572324, 4363479.704648058],
              [-9203970.862083126, 4360200.211093934],
              [-9206407.534417098, 4357241.375703985],
              [-9232524.979388544, 4346787.252036668],
              [-9248680.665767882, 4334012.349928157],
              [-9257617.171849784, 4348237.627314518],
              [-9267936.711285302, 4340473.244836646],
              [-9271677.49145392, 4352868.113280037],
              [-9270753.428360844, 4355066.761094066],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cache',
        GEOID: '49005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12479976.01531221, 5160619.642889512],
              [-12479966.114091383, 5160619.7072101105],
              [-12440039.702712158, 5160879.081827467],
              [-12412992.966547346, 5160932.358809663],
              [-12412992.205178913, 5160932.36030942],
              [-12413401.950440746, 5146719.724196912],
              [-12401166.713888166, 5109302.476194063],
              [-12413329.815410713, 5074950.553550512],
              [-12430666.378948383, 5075801.248492768],
              [-12441131.969555821, 5066895.387147802],
              [-12455030.541939834, 5075436.613335054],
              [-12453667.323455581, 5084170.269497057],
              [-12461781.623778483, 5094258.735348502],
              [-12465672.573940182, 5091445.895785377],
              [-12472546.552496666, 5117701.921502173],
              [-12468761.355851224, 5130332.228400431],
              [-12485502.521694504, 5160782.005561605],
              [-12479976.01531221, 5160619.642889512],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Newport',
        GEOID: '44005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7949150.399905592, 5082285.328026812],
              [-7946045.5879878765, 5108743.042733837],
              [-7940527.258190272, 5114202.6001984645],
              [-7932262.676554798, 5106927.30618465],
              [-7926905.15142351, 5114701.566944637],
              [-7926095.486320537, 5113428.441570652],
              [-7925462.391501219, 5112433.074766067],
              [-7918476.8708149595, 5110199.57459525],
              [-7918989.385750572, 5101629.683955067],
              [-7917105.637327369, 5085994.345497517],
              [-7919293.51059942, 5084271.465897307],
              [-7925170.73443534, 5080122.83962075],
              [-7927358.469571859, 5081410.841948125],
              [-7930378.752671917, 5083189.279789679],
              [-7931067.550501643, 5083594.911646896],
              [-7935481.034353123, 5084561.2412086865],
              [-7938492.783176535, 5079153.0936829215],
              [-7942767.674261978, 5079063.9811709775],
              [-7947018.742976393, 5080520.034384329],
              [-7950127.761822829, 5079840.670879717],
              [-7949150.399905592, 5082285.328026812],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Charlton',
        GEOID: '13049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9174462.95938059, 3634514.189375063],
              [-9142858.799346926, 3634140.638415284],
              [-9137238.166937282, 3634129.7281950526],
              [-9134974.262453018, 3642598.303590589],
              [-9121074.465554606, 3638983.5177643406],
              [-9117738.220415534, 3637907.966927725],
              [-9117731.812799564, 3609577.142192754],
              [-9121873.850817995, 3610358.772596906],
              [-9127640.75703854, 3604997.8331955937],
              [-9131834.718854174, 3600411.5720074596],
              [-9132855.184626278, 3592862.164526159],
              [-9133711.788107932, 3588095.309320217],
              [-9129949.07799963, 3581129.3641827577],
              [-9130244.408608703, 3572011.9325298117],
              [-9131341.016912509, 3561187.617821974],
              [-9132874.888176149, 3555490.28612255],
              [-9132736.29541011, 3551217.686857636],
              [-9133873.644608272, 3550988.512335565],
              [-9138741.202701973, 3550007.7521486217],
              [-9144150.995996054, 3550344.7365948404],
              [-9148240.540129326, 3551019.764669109],
              [-9151610.737713093, 3558242.839826032],
              [-9150569.566515703, 3564679.9474128424],
              [-9153737.941862661, 3570672.8401570646],
              [-9152533.464972276, 3576305.8228576174],
              [-9144881.919772603, 3604772.6265180507],
              [-9175001.634396538, 3606184.1875785156],
              [-9174462.95938059, 3634514.189375063],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Osage',
        GEOID: '29151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10263042.12227268, 4626934.836944519],
              [-10254192.334074106, 4636362.6713819],
              [-10260023.249001859, 4645990.971827428],
              [-10246234.326316277, 4645534.86258411],
              [-10242393.135966964, 4660391.740258107],
              [-10225237.021323867, 4674559.442662126],
              [-10202116.408364069, 4679274.208769116],
              [-10201359.547146166, 4679330.6964885285],
              [-10201844.56616755, 4620263.154791495],
              [-10226155.741081385, 4620986.4939244315],
              [-10263175.594342142, 4620791.754682898],
              [-10263042.12227268, 4626934.836944519],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Delta',
        GEOID: '26041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9725744.462383615, 5777997.212170896],
              [-9711833.533536125, 5777964.529757693],
              [-9711680.023958322, 5805882.348681632],
              [-9697724.12203655, 5805873.8308725115],
              [-9642004.598073358, 5805816.134985221],
              [-9628038.566077923, 5805733.689983403],
              [-9624584.544917589, 5763756.843848312],
              [-9624669.873283137, 5740412.79756419],
              [-9633747.920121728, 5733696.391008494],
              [-9642157.217095234, 5719754.143022752],
              [-9644375.035310308, 5707264.1507892255],
              [-9652772.198459318, 5718219.627657733],
              [-9651976.932017092, 5730953.495432125],
              [-9645535.429682339, 5737604.112365633],
              [-9659557.232742658, 5750174.881576894],
              [-9666844.98584642, 5735959.847874602],
              [-9680818.810206212, 5728063.123821391],
              [-9692637.26658526, 5735397.317892701],
              [-9703969.479428526, 5726315.174606678],
              [-9713009.582632355, 5708545.713271037],
              [-9721253.054888578, 5708726.044273041],
              [-9721018.059443515, 5764125.0595159],
              [-9725744.462383615, 5777997.212170896],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bucks',
        GEOID: '42017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8394573.078416718, 4937110.253195782],
              [-8386088.418147945, 4944295.627730065],
              [-8377699.047363292, 4950882.216567979],
              [-8370027.509334008, 4954847.550327736],
              [-8369912.124095771, 4952436.665797953],
              [-8369749.27724778, 4949035.116573597],
              [-8364184.527222516, 4949962.067247118],
              [-8357700.723481261, 4945942.006878373],
              [-8355888.88744911, 4936145.292401725],
              [-8356817.403321817, 4932307.755943592],
              [-8355207.055568001, 4926589.349415059],
              [-8351719.74987992, 4924745.642179545],
              [-8345577.363016929, 4924206.9665207295],
              [-8342951.224909626, 4918001.677934179],
              [-8340959.114653353, 4915448.808629548],
              [-8338198.327930715, 4911911.981234398],
              [-8332988.353122609, 4906336.576122898],
              [-8329359.226403257, 4901099.879209789],
              [-8322312.479997061, 4894889.433990843],
              [-8320964.69676814, 4892849.190487674],
              [-8317970.9085366335, 4888318.768031609],
              [-8318168.533711545, 4888185.582509505],
              [-8323301.331033777, 4884727.064628572],
              [-8329581.865384844, 4883964.914572131],
              [-8333801.096724892, 4877896.0141731],
              [-8341415.572534132, 4875888.565286111],
              [-8345940.014805582, 4872702.615629669],
              [-8344944.289072788, 4883054.05117855],
              [-8350638.948943809, 4886015.209822526],
              [-8365853.54034798, 4897877.757056531],
              [-8386737.076820797, 4914260.1409737505],
              [-8402846.788250437, 4926938.071303756],
              [-8394573.078416718, 4937110.253195782],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Salem',
        GEOID: '34033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8411239.05334185, 4812292.493466451],
              [-8408533.767076595, 4814807.748432613],
              [-8405706.029371463, 4820433.368513577],
              [-8402132.451078016, 4824614.758519942],
              [-8400106.32502609, 4831968.993888253],
              [-8395166.299983155, 4837199.30141073],
              [-8394657.623080548, 4837598.247011665],
              [-8396724.66153477, 4834577.141035299],
              [-8391065.957859276, 4829081.23100594],
              [-8390883.505213864, 4826265.80467079],
              [-8371202.664519578, 4817668.391368928],
              [-8355847.365279045, 4803470.106460432],
              [-8357906.66453923, 4787831.811027446],
              [-8375504.160963322, 4802068.423274695],
              [-8389951.09315898, 4787270.8059398215],
              [-8395393.956967764, 4777533.789004615],
              [-8398208.772986026, 4779461.2266008],
              [-8400748.972446438, 4784740.977467822],
              [-8408677.035261244, 4787859.06188046],
              [-8407748.296749555, 4793275.376390223],
              [-8407702.43311935, 4798638.181056337],
              [-8406038.874648934, 4804806.559525666],
              [-8409515.716304881, 4807406.612005711],
              [-8411239.05334185, 4812292.493466451],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Belmont',
        GEOID: '39013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9042933.415033799, 4858863.493451874],
              [-9042028.498893138, 4890687.981941174],
              [-9038685.017987162, 4890988.525940269],
              [-9026864.335218297, 4890239.7323679505],
              [-9003842.351327341, 4889146.799488217],
              [-8990859.938352555, 4888508.255129417],
              [-8983769.588505082, 4888803.984309647],
              [-8984150.156044992, 4887995.5851159245],
              [-8987579.909556333, 4877584.955892948],
              [-8987737.364295065, 4870817.887631429],
              [-8987949.712904748, 4861698.905138067],
              [-8990660.676464036, 4858715.376587315],
              [-8994992.674448257, 4854144.0078026615],
              [-8997223.97398643, 4844173.223119576],
              [-9043296.650532255, 4846753.952765556],
              [-9042933.415033799, 4858863.493451874],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kane',
        GEOID: '49025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12568099.863808887, 4515134.915618393],
              [-12543897.67067654, 4515163.837430513],
              [-12510298.108770406, 4515048.150661516],
              [-12450324.733105531, 4514048.018845172],
              [-12384373.389465565, 4514641.853135273],
              [-12317100.23819192, 4514794.7393309465],
              [-12319939.219165621, 4505873.51529101],
              [-12328188.216072384, 4502395.325038536],
              [-12322978.241264278, 4499310.79885479],
              [-12327086.04179404, 4487331.945769527],
              [-12331728.17587961, 4484223.842323192],
              [-12341970.125630045, 4487821.905890423],
              [-12338340.887591204, 4480906.745042783],
              [-12342404.27164414, 4479185.625550778],
              [-12345277.761659987, 4463688.768841336],
              [-12351825.128830481, 4456466.062381061],
              [-12362883.273087414, 4452970.23882086],
              [-12376317.197916856, 4453419.383865136],
              [-12384013.716190813, 4442118.5342067825],
              [-12386384.376066746, 4446664.263357258],
              [-12391513.087646574, 4440798.105942645],
              [-12402414.381391006, 4439312.759785206],
              [-12507600.837508487, 4439249.659995082],
              [-12527736.418322666, 4439210.509727913],
              [-12528462.555361109, 4439209.097878662],
              [-12560122.702906163, 4439160.646747587],
              [-12567880.4416952, 4439148.774719873],
              [-12568081.050814945, 4509034.33969516],
              [-12568099.863808887, 4515134.915618393],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Plumas',
        GEOID: '06063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13525054.860787014, 4930907.207427308],
              [-13509895.483850276, 4931087.275132594],
              [-13506151.809374899, 4930874.441603257],
              [-13476495.295152154, 4931045.43944961],
              [-13476503.755433453, 4903274.363294799],
              [-13461708.170592628, 4893872.493718981],
              [-13443431.847913679, 4911970.817106252],
              [-13430936.791669589, 4910751.249019642],
              [-13415202.783521377, 4902184.508996511],
              [-13412089.28868338, 4895893.506499858],
              [-13396341.69955729, 4882703.2375492845],
              [-13381676.024562221, 4878448.610455314],
              [-13380743.501187844, 4867900.477690342],
              [-13370446.114330996, 4857155.9271719465],
              [-13370653.836500816, 4831964.069948495],
              [-13374719.446943568, 4823550.435866617],
              [-13431167.111696038, 4823401.541037971],
              [-13434120.751745258, 4819091.065062137],
              [-13446557.810534645, 4823859.51910174],
              [-13455549.865042454, 4833468.736346014],
              [-13464029.51593414, 4818471.323093363],
              [-13470713.36080035, 4813686.936262564],
              [-13478196.034332493, 4807589.2188534755],
              [-13484877.430169905, 4812055.022483939],
              [-13493133.217565605, 4826154.356248736],
              [-13508711.601065688, 4840646.2920182515],
              [-13517520.980289107, 4851466.593148592],
              [-13516354.685984062, 4868233.616223421],
              [-13510492.37895991, 4878455.303490237],
              [-13518292.313040813, 4888041.3165320065],
              [-13510667.92979689, 4896831.063325017],
              [-13507759.04018297, 4911057.07577875],
              [-13522022.517857805, 4916965.554814144],
              [-13525054.860787014, 4930907.207427308],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Iowa',
        GEOID: '19095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10274584.617634054, 5140446.5150831025],
              [-10222622.349124115, 5140307.804913098],
              [-10222383.234857893, 5088076.687541745],
              [-10235386.687216435, 5087971.437373499],
              [-10274510.033575222, 5087828.875774914],
              [-10274584.617634054, 5140446.5150831025],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Edmonson',
        GEOID: '21061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9625699.075659413, 4483958.855994849],
              [-9594352.397607952, 4486716.41234159],
              [-9591018.93545615, 4485995.768739706],
              [-9578945.668762673, 4469157.3738113],
              [-9579759.414240373, 4462439.123963427],
              [-9581743.57284427, 4446536.633889853],
              [-9586112.306260454, 4447622.858663851],
              [-9597811.428145371, 4453617.024895423],
              [-9604840.474752532, 4450346.931764398],
              [-9617911.052764025, 4462814.630543743],
              [-9625699.075659413, 4483958.855994849],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hudson',
        GEOID: '34017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8247748.681312892, 4977297.494494777],
              [-8247436.096182745, 4977658.460241015],
              [-8247671.982183737, 4979487.450598184],
              [-8246531.180042086, 4981375.596065723],
              [-8246186.4235791, 4982242.38637789],
              [-8245326.925790685, 4982643.532694576],
              [-8244159.9635687, 4983809.420995927],
              [-8242643.12418715, 4983997.376166433],
              [-8241391.33651318, 4983366.314093862],
              [-8242233.46846103, 4982244.297959811],
              [-8241388.108247947, 4981766.855242507],
              [-8242356.031220395, 4979954.785159743],
              [-8243643.107172946, 4980085.184166653],
              [-8244323.714539656, 4977379.504271037],
              [-8245968.9052940905, 4976733.879621674],
              [-8246401.604154803, 4975624.674702653],
              [-8247732.762625709, 4975360.323961667],
              [-8247748.681312892, 4977297.494494777],
            ],
          ],
          [
            [
              [-8252860.027052157, 4964440.173694772],
              [-8250259.047149772, 4968555.64344117],
              [-8250673.044336032, 4969716.327172121],
              [-8243389.076094955, 4972763.19003594],
              [-8253507.127252139, 4963423.207543466],
              [-8252860.027052157, 4964440.173694772],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Prince of Wales-Hyder',
        GEOID: '02198',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-14507175.187131828, 7552241.734651965],
              [-14503662.723238828, 7558042.405668832],
              [-14496030.770269532, 7558243.859109144],
              [-14503738.086534096, 7567841.701896532],
              [-14502966.642462898, 7574277.712330969],
              [-14498982.660841003, 7577789.009813079],
              [-14498867.190894946, 7577725.148720483],
              [-14482973.105318971, 7581681.689611824],
              [-14472008.024156341, 7557097.715141123],
              [-14473002.997765053, 7541787.653665696],
              [-14480941.413292503, 7523457.923544106],
              [-14485306.250526508, 7520098.284402293],
              [-14486920.64358487, 7511385.057244643],
              [-14498024.836308114, 7522001.114247658],
              [-14504760.444737539, 7532006.768448189],
              [-14503668.734491328, 7535954.551803853],
              [-14514793.225164777, 7547112.507600579],
              [-14507175.187131828, 7552241.734651965],
            ],
          ],
          [
            [
              [-14655030.068761926, 7406233.034802521],
              [-14646218.908426655, 7419270.971683047],
              [-14609520.323216328, 7394868.011773516],
              [-14620366.069884827, 7360999.401754047],
              [-14639699.70508733, 7365043.068026554],
              [-14650968.548561508, 7358425.964816857],
              [-14650275.168032182, 7362720.692468055],
              [-14654796.409150753, 7368774.335612461],
              [-14648463.554639013, 7379146.722312628],
              [-14650235.204334987, 7382745.231202194],
              [-14659010.518196788, 7385014.146498619],
              [-14655030.068761926, 7406233.034802521],
            ],
          ],
          [
            [
              [-14909577.780508948, 7542643.252860345],
              [-14896369.388967853, 7551257.381841055],
              [-14886911.351071587, 7564162.414623991],
              [-14878878.647935433, 7575119.575730584],
              [-14877161.65610944, 7583887.017835312],
              [-14880310.105267545, 7602884.075214457],
              [-14878616.82449309, 7614605.1150001865],
              [-14878564.05905445, 7623771.15804541],
              [-14870293.132208, 7628912.076401196],
              [-14852065.010868566, 7624819.868778271],
              [-14827423.217067078, 7624997.378726178],
              [-14823106.692492077, 7621333.956863317],
              [-14814200.799270142, 7607704.6577117015],
              [-14809931.408747798, 7606149.751052431],
              [-14807330.828215327, 7588375.317049858],
              [-14806352.441210743, 7585312.040882572],
              [-14793622.055563118, 7571890.673200867],
              [-14789883.385029094, 7568927.716453427],
              [-14787413.099644631, 7563259.99871549],
              [-14763019.882266082, 7540813.177017934],
              [-14746570.535070034, 7515171.929010031],
              [-14745661.500108216, 7493761.2976686815],
              [-14736753.046537993, 7492079.951281804],
              [-14727693.198460292, 7469538.928163962],
              [-14710085.349323554, 7451255.223906735],
              [-14722899.447228262, 7443053.302803742],
              [-14708243.3457094, 7418044.58196455],
              [-14698305.186849343, 7415450.115293809],
              [-14691656.63026171, 7397064.119724346],
              [-14697235.517862305, 7382207.956179319],
              [-14692457.573997969, 7367297.966825623],
              [-14692316.420883644, 7342058.904289364],
              [-14689487.792622583, 7321454.8205873985],
              [-14694127.25504038, 7310020.728040561],
              [-14697484.205604738, 7304087.634077723],
              [-14712560.760840328, 7302712.445477847],
              [-14719578.452859426, 7308708.876961592],
              [-14728452.842665464, 7307464.508830379],
              [-14734959.021624368, 7313727.488189215],
              [-14739093.87279039, 7320172.320672015],
              [-14750875.70505697, 7319527.964742414],
              [-14765309.501552716, 7314123.684496906],
              [-14769238.189021796, 7298977.021968242],
              [-14777998.47634977, 7298705.956462919],
              [-14790614.982158316, 7303932.9397678925],
              [-14791823.355230877, 7314224.183445448],
              [-14796447.678197922, 7319913.066221079],
              [-14804444.64777753, 7327201.918549091],
              [-14816518.137109986, 7346162.863716783],
              [-14823836.391754225, 7357385.909863957],
              [-14827502.25390554, 7368351.849160341],
              [-14832175.000851078, 7379822.677607709],
              [-14829435.539502146, 7388476.3987651495],
              [-14831373.055239402, 7400550.590201297],
              [-14836882.034199784, 7404118.632089243],
              [-14843481.05361401, 7401891.2668860275],
              [-14850520.67557279, 7403703.976913037],
              [-14858028.173351381, 7410055.018692112],
              [-14857613.953526137, 7416727.108380014],
              [-14870792.845402172, 7422030.030733437],
              [-14871923.51747016, 7404336.408098712],
              [-14878780.464144552, 7407154.9728429355],
              [-14882322.093744142, 7421171.251779971],
              [-14875958.18109447, 7432305.0036543915],
              [-14875728.751623947, 7443047.811472289],
              [-14883181.92549103, 7450630.537082185],
              [-14893329.47631327, 7451245.603897263],
              [-14889301.380538916, 7468224.867940125],
              [-14886593.979203332, 7477841.676373045],
              [-14885271.058374746, 7491070.8849522695],
              [-14877106.775600478, 7504662.607254442],
              [-14883544.15911407, 7515765.427908651],
              [-14883468.016582368, 7526118.6187432],
              [-14901342.698538534, 7528383.43052089],
              [-14907934.036907896, 7530654.461972553],
              [-14909577.780508948, 7542643.252860345],
            ],
          ],
          [
            [
              [-14960558.433749074, 7732429.940962182],
              [-14946919.124459116, 7746963.166357404],
              [-14938380.028959345, 7746558.773408756],
              [-14933187.197352823, 7751328.795216586],
              [-14922127.60594251, 7744396.798656402],
              [-14917550.371120071, 7729844.647266969],
              [-14910459.43087603, 7720478.398478077],
              [-14902233.36578437, 7728694.7107414035],
              [-14908067.731616337, 7752255.92082156],
              [-14922290.688996522, 7766089.856405051],
              [-14917797.611709125, 7775377.069605772],
              [-14904339.196591709, 7780122.99429732],
              [-14887805.580541126, 7774886.789471662],
              [-14865188.242999204, 7768032.733935215],
              [-14842703.264331834, 7760617.812883397],
              [-14840877.51630629, 7760665.385719901],
              [-14835995.15181663, 7744155.098751287],
              [-14854477.52687304, 7736110.973036194],
              [-14862898.51239308, 7718533.186238457],
              [-14860858.137446329, 7708512.882464325],
              [-14869988.339442208, 7710783.69609562],
              [-14854618.346028892, 7686410.427553737],
              [-14851732.042224053, 7649822.761256571],
              [-14856769.817827454, 7649354.404282665],
              [-14878458.63949667, 7646969.464238428],
              [-14896955.48608688, 7636770.807053145],
              [-14898394.513144365, 7622344.194223663],
              [-14903077.612802548, 7613533.53941739],
              [-14903580.33162297, 7602976.780972346],
              [-14910353.677359775, 7594351.332396753],
              [-14908766.150101574, 7587525.0060407575],
              [-14912417.429399595, 7576624.187357949],
              [-14918820.303871041, 7575989.066056615],
              [-14926546.210490568, 7577338.586950271],
              [-14930378.050002653, 7564369.208280396],
              [-14927922.00807728, 7555259.02630276],
              [-14929954.368020693, 7541442.024110729],
              [-14939994.161575848, 7533910.953271993],
              [-14945208.923122061, 7527544.68061747],
              [-14951517.06470684, 7521137.3040299695],
              [-14955178.25143954, 7527881.3593290625],
              [-14958552.679163959, 7544193.585700954],
              [-14949295.238990102, 7543741.944285829],
              [-14939318.118308261, 7565421.19273713],
              [-14945726.89271272, 7585225.541198955],
              [-14948227.462434411, 7609305.044484322],
              [-14949615.282526128, 7625574.113634376],
              [-14943876.428817263, 7637610.706313885],
              [-14944855.372419298, 7647426.817235688],
              [-14938849.35193253, 7664862.853878397],
              [-14943744.1812622, 7669810.48181839],
              [-14952448.92016427, 7669599.006836967],
              [-14950332.291366328, 7682907.474685409],
              [-14958698.396377405, 7692684.503670769],
              [-14963402.758058328, 7723891.444950732],
              [-14960558.433749074, 7732429.940962182],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Vinton',
        GEOID: '39163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9212813.414514799, 4755769.428994899],
              [-9211531.01398086, 4774546.098037952],
              [-9185814.987093214, 4774733.723510411],
              [-9185469.785352265, 4778521.3965296885],
              [-9160443.382710082, 4776854.581195737],
              [-9157168.363290947, 4763716.406899696],
              [-9158096.767844161, 4750900.613336766],
              [-9162336.481970515, 4751149.715969012],
              [-9164140.41431882, 4725636.411211194],
              [-9176656.62126616, 4726697.584668815],
              [-9175473.072440049, 4741454.191318402],
              [-9188342.162173202, 4742386.981931121],
              [-9187899.555877808, 4747596.634536361],
              [-9213122.994018694, 4751504.992358311],
              [-9212813.414514799, 4755769.428994899],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nicollet',
        GEOID: '27103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10550931.468665669, 5536383.931150632],
              [-10533517.760720877, 5536287.23796168],
              [-10456189.676441329, 5536394.224357015],
              [-10456538.663044965, 5518969.980682493],
              [-10466833.155595055, 5505225.285357316],
              [-10465353.27428445, 5502583.5832863385],
              [-10469227.526522528, 5489363.07758237],
              [-10505413.04019979, 5506457.739941708],
              [-10518727.073937647, 5521272.637463596],
              [-10538177.817244465, 5526625.9022856625],
              [-10550931.468665669, 5536383.931150632],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Finney',
        GEOID: '20055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11254764.31129587, 4616866.55171889],
              [-11208169.42335402, 4616807.004526002],
              [-11159154.783640798, 4616545.142742333],
              [-11157233.854507668, 4616537.628669218],
              [-11157175.189136019, 4579569.199320813],
              [-11205883.700249562, 4579783.223183035],
              [-11204557.32851676, 4542237.012464338],
              [-11253250.254901592, 4542245.739696691],
              [-11254821.084236177, 4555302.264958721],
              [-11254764.31129587, 4616866.55171889],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shelby',
        GEOID: '18145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9568141.778222714, 4813525.901216195],
              [-9568101.814525519, 4822028.022234917],
              [-9532647.335944297, 4822219.86655878],
              [-9532213.07861071, 4786733.187467005],
              [-9532358.127907217, 4771960.304600014],
              [-9538356.57866861, 4771937.847390791],
              [-9568133.429260904, 4771552.627684725],
              [-9568141.778222714, 4813525.901216195],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nobles',
        GEOID: '27105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10692495.351912566, 5442115.048966801],
              [-10626828.76353005, 5441936.147266519],
              [-10625723.917583928, 5441942.630270019],
              [-10625938.790768735, 5388438.701725406],
              [-10629542.287437627, 5388427.025256712],
              [-10668238.946188202, 5388384.055014877],
              [-10671191.71812042, 5388388.180902283],
              [-10692589.175821044, 5388418.079473969],
              [-10692495.351912566, 5442115.048966801],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clinton',
        GEOID: '26037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9443999.283965472, 5330079.713196054],
              [-9391776.082569113, 5329941.086704119],
              [-9391319.56133737, 5277905.007931564],
              [-9393662.94793806, 5277010.875446438],
              [-9417936.274225025, 5277010.572159494],
              [-9444021.102585668, 5277101.407037098],
              [-9443999.283965472, 5330079.713196054],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fredericksburg',
        GEOID: '51630',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8630631.624618394, 4623194.4109941125],
              [-8623659.35095154, 4624578.554856862],
              [-8621374.629722498, 4619710.614671072],
              [-8626371.650344716, 4618165.616883725],
              [-8630631.624618394, 4623194.4109941125],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Phelps',
        GEOID: '29161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10243749.230003808, 4580928.855791197],
              [-10229743.23431118, 4586661.04132697],
              [-10200475.559069775, 4586625.982813771],
              [-10200266.612385556, 4601135.656243518],
              [-10189561.016955968, 4601004.569445097],
              [-10188515.281659456, 4599338.10017154],
              [-10188939.074960904, 4549659.77143503],
              [-10219821.550735757, 4549983.336727308],
              [-10220142.818786187, 4522912.567817069],
              [-10244650.1386428, 4523429.485180917],
              [-10243749.230003808, 4580928.855791197],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Seminole',
        GEOID: '12117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9067992.211647797, 3339298.948429573],
              [-9063014.671936467, 3348303.9929669523],
              [-9063281.838714372, 3353336.4913662826],
              [-9057726.328206843, 3360283.300171943],
              [-9052553.64542815, 3354602.221850064],
              [-9042037.29313291, 3354360.7821310232],
              [-9037075.783428255, 3348090.8647864666],
              [-9024429.443996176, 3351907.8773352955],
              [-9023681.488337535, 3343865.080805442],
              [-9015459.430747544, 3326480.832833107],
              [-9031239.636484435, 3326422.2487194585],
              [-9053379.302091366, 3326135.9257414597],
              [-9063099.05211049, 3329915.17460403],
              [-9068055.44111857, 3329930.2683865177],
              [-9067992.211647797, 3339298.948429573],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Powhatan',
        GEOID: '51145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8692879.59143865, 4528611.733576723],
              [-8690954.65480385, 4531138.226491576],
              [-8680942.802440885, 4526484.161112689],
              [-8673888.486309316, 4535965.007491385],
              [-8662315.266768485, 4523989.847420108],
              [-8644559.474028487, 4518013.448982266],
              [-8661658.593092294, 4498686.012337283],
              [-8666795.430994952, 4497582.738871634],
              [-8671761.72743771, 4505583.294734309],
              [-8682872.971091751, 4508758.062735041],
              [-8697619.797995608, 4502675.080338608],
              [-8692879.59143865, 4528611.733576723],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Douglas',
        GEOID: '29067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10341945.04338848, 4448959.206175902],
              [-10333194.997453656, 4448683.3849599995],
              [-10317743.518173078, 4448456.9574388275],
              [-10269374.308867473, 4447424.911105524],
              [-10251268.082370458, 4446949.935764262],
              [-10252062.124298286, 4411048.898714707],
              [-10253899.45249383, 4410463.921004768],
              [-10326537.980584728, 4412113.562768757],
              [-10342619.97346116, 4412541.933096054],
              [-10341945.04338848, 4448959.206175902],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Barbour',
        GEOID: '54001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8930571.305889754, 4746192.236067545],
              [-8924081.379576506, 4756436.193112392],
              [-8908165.364060847, 4757242.43435805],
              [-8893930.384175656, 4764675.71336154],
              [-8891306.917736132, 4763946.983091557],
              [-8884378.392629158, 4754746.443578319],
              [-8887535.85866602, 4740453.894545842],
              [-8886088.593966216, 4738272.959376681],
              [-8893992.500451518, 4717862.639474965],
              [-8915028.321987743, 4714116.397973609],
              [-8910505.299757322, 4723302.937166318],
              [-8919830.199542603, 4727086.828895813],
              [-8930848.046143865, 4737840.960747123],
              [-8930571.305889754, 4746192.236067545],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Berkshire',
        GEOID: '25003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8182888.936599645, 5173909.094457056],
              [-8172035.554240882, 5213815.832932117],
              [-8169014.482394121, 5224953.950698474],
              [-8165565.95403985, 5237684.0793805905],
              [-8160498.365340853, 5256224.060174265],
              [-8155817.706231083, 5273380.928787319],
              [-8142185.312165159, 5272999.809223575],
              [-8128885.168069159, 5272627.993236743],
              [-8120627.500121005, 5267065.447332016],
              [-8120872.51432024, 5257487.958079999],
              [-8123585.370310874, 5244638.452386532],
              [-8124016.733337697, 5235850.223750342],
              [-8127334.1654828265, 5219238.235553737],
              [-8133644.533457425, 5219445.775069802],
              [-8133323.265406996, 5210382.785129977],
              [-8126342.086180879, 5207932.778320736],
              [-8126493.035410392, 5200406.354001773],
              [-8127198.57834304, 5196759.127404456],
              [-8134239.090857752, 5183205.902320176],
              [-8132266.971430512, 5166990.598031271],
              [-8140485.914425204, 5167291.377328389],
              [-8152043.864173701, 5167714.366525014],
              [-8180570.374245403, 5168417.878245771],
              [-8180833.749707664, 5169041.489660893],
              [-8182888.936599645, 5173909.094457056],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scurry',
        GEOID: '48415',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11262568.920795387, 3890473.0702245757],
              [-11247572.181634698, 3891352.496695495],
              [-11242175.524040531, 3890662.271374999],
              [-11204960.193753941, 3890456.0873814696],
              [-11205489.629252153, 3832465.2458669282],
              [-11262700.723072486, 3832780.927753317],
              [-11262568.920795387, 3890473.0702245757],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '08073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11583408.391185218, 4702905.407045704],
              [-11546020.181729427, 4702613.595566401],
              [-11545429.186552808, 4803121.364019624],
              [-11544618.446701359, 4803116.165466424],
              [-11483092.60941788, 4803023.602790452],
              [-11483190.236611307, 4740020.798193209],
              [-11484055.411693752, 4727060.315099181],
              [-11484181.64799631, 4677382.478756969],
              [-11485159.47840344, 4666309.421053263],
              [-11485152.242636537, 4653903.31762234],
              [-11522086.713847855, 4652636.146220315],
              [-11534145.286368545, 4653509.604080856],
              [-11583229.500763515, 4653487.549740372],
              [-11583408.391185218, 4702905.407045704],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Macon',
        GEOID: '37113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9316351.784221115, 4196263.709601635],
              [-9317749.957025478, 4197705.516314219],
              [-9315227.680003082, 4201929.247104655],
              [-9291524.086869998, 4204433.299586107],
              [-9277322.836790519, 4208953.242427152],
              [-9270348.225414358, 4194914.895079405],
              [-9264490.259850342, 4196359.524350027],
              [-9264430.592603277, 4185289.8951694905],
              [-9255465.032134278, 4174476.1611908968],
              [-9251608.47930643, 4163970.678648857],
              [-9275448.105246069, 4163320.4512806665],
              [-9293270.935061064, 4162641.021004369],
              [-9312969.007534888, 4185687.212525428],
              [-9321685.880261455, 4185094.37342353],
              [-9316351.784221115, 4196263.709601635],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Monroe',
        GEOID: '42089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8415835.435116706, 5036191.696927449],
              [-8409414.304248767, 5045445.516249876],
              [-8405245.723277032, 5046701.855825369],
              [-8388945.989476608, 5047688.776991081],
              [-8363402.285160712, 5049597.919522446],
              [-8366384.089041099, 5034542.281524641],
              [-8348114.222356304, 5026073.007682596],
              [-8350661.7694394225, 5021375.059619443],
              [-8354790.34227529, 5017155.477848882],
              [-8356813.395820149, 5015088.497655202],
              [-8363776.875247231, 5009418.510321124],
              [-8362682.375803069, 5007225.584164122],
              [-8380580.886340947, 4992602.628768048],
              [-8401748.732793253, 4985055.022399948],
              [-8406620.073710365, 4994391.579458181],
              [-8412924.875710424, 5005164.466534339],
              [-8404175.163734073, 5010451.048103965],
              [-8421279.069535987, 5030404.158578356],
              [-8415835.435116706, 5036191.696927449],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Camden',
        GEOID: '29029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10361361.277653152, 4616658.846932903],
              [-10354381.322941434, 4606269.452341127],
              [-10331223.529271707, 4606465.192045841],
              [-10326501.245152768, 4606247.3574992],
              [-10318858.828151336, 4610839.002840104],
              [-10308706.267952006, 4603572.814833414],
              [-10304876.543510247, 4588843.38487365],
              [-10298831.67252119, 4582581.621247049],
              [-10286619.479103206, 4582418.127433061],
              [-10286685.93683921, 4576290.454379231],
              [-10286948.53951799, 4559551.724995162],
              [-10302515.791068994, 4551286.855962011],
              [-10310431.386100832, 4564253.74122039],
              [-10336614.064293882, 4564707.25894147],
              [-10360777.406923942, 4565679.391184492],
              [-10359970.563254673, 4588255.763803802],
              [-10359288.620054074, 4605690.186551319],
              [-10361361.277653152, 4616658.846932903],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kidder',
        GEOID: '38043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11144557.236174094, 5995656.119410445],
              [-11135655.127814846, 5995644.623032107],
              [-11074143.76206517, 5995625.571924401],
              [-11070325.16957249, 5938955.228508232],
              [-11070692.189933633, 5882152.62951988],
              [-11122543.47291125, 5882362.565941805],
              [-11140987.99934079, 5882438.922442209],
              [-11140323.533300243, 5939019.353413583],
              [-11144557.236174094, 5995656.119410445],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Douglas',
        GEOID: '31055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10739071.426860472, 5070518.50409802],
              [-10723296.56445914, 5070503.22008701],
              [-10681665.969209217, 5070497.136167037],
              [-10678582.22365021, 5070036.095626734],
              [-10678744.055214873, 5067084.95840699],
              [-10678398.964793414, 5059982.436575889],
              [-10674442.892729603, 5053479.104215131],
              [-10676807.20739456, 5047509.948349557],
              [-10676642.175275948, 5040596.913228324],
              [-10687687.908383168, 5040510.692543516],
              [-10723117.00612049, 5040406.9951572465],
              [-10733585.491034688, 5066205.219020866],
              [-10739071.426860472, 5070518.50409802],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wilcox',
        GEOID: '13315',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9307385.110557204, 3766978.4827428428],
              [-9307260.878005482, 3778863.1782993125],
              [-9279716.651120538, 3779610.6755406386],
              [-9277067.247239657, 3777217.718098626],
              [-9272379.917440824, 3773708.7260958753],
              [-9272029.817642279, 3761276.9706689008],
              [-9262420.496558024, 3750233.834240232],
              [-9262253.183363361, 3748182.84827815],
              [-9259273.494553298, 3743356.0212628795],
              [-9260672.223955115, 3743570.6807036777],
              [-9292970.683652857, 3743284.600010862],
              [-9299812.824834974, 3744043.3904837617],
              [-9307673.761996834, 3744172.743456888],
              [-9307385.110557204, 3766978.4827428428],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McPherson',
        GEOID: '46089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11100565.109246481, 5770884.57718513],
              [-11088663.608527299, 5770915.152483208],
              [-11075204.414173448, 5770797.3341125995],
              [-11059030.36007813, 5770787.249188868],
              [-11030967.607005073, 5770768.840230654],
              [-11021270.159862906, 5770730.471142601],
              [-11021257.653101139, 5770730.421658242],
              [-10989947.088638509, 5770527.243523093],
              [-10990016.951204913, 5715087.2788374815],
              [-11099410.948765935, 5715427.556507569],
              [-11100497.53831557, 5715433.442677681],
              [-11100565.109246481, 5770884.57718513],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cleburne',
        GEOID: '01029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9556988.678440135, 3961692.282102362],
              [-9551795.73551412, 3966558.724252718],
              [-9550773.043352202, 3969367.73918364],
              [-9535161.15268539, 3978848.723160142],
              [-9533184.00720941, 3998407.44600062],
              [-9521166.511580821, 4020939.27556083],
              [-9517292.036703764, 4023017.5583987557],
              [-9506558.834040457, 4023986.3094166615],
              [-9505200.688805385, 4015610.563124312],
              [-9502290.956082933, 3997686.7151040384],
              [-9499795.651762685, 3982318.3280883045],
              [-9497116.3808729, 3965839.7177622197],
              [-9496102.909663398, 3959558.505847626],
              [-9500867.40243467, 3962044.174859623],
              [-9533788.80600289, 3961310.8990553804],
              [-9547363.661307678, 3961672.3916708687],
              [-9549290.379054327, 3957769.189810591],
              [-9560984.157603689, 3957779.598732069],
              [-9556988.678440135, 3961692.282102362],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Naguabo',
        GEOID: '72103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7326671.95621744, 2067634.167886593],
              [-7327518.652264413, 2069533.9263803586],
              [-7321130.138007278, 2070348.6988337396],
              [-7311798.44773306, 2067149.819965791],
              [-7309229.499448381, 2059984.0822748584],
              [-7313229.237148226, 2058548.8172579757],
              [-7317403.8400319405, 2056960.8396521038],
              [-7323985.037668162, 2061763.5732486388],
              [-7327723.8140859455, 2061019.3359575307],
              [-7326671.95621744, 2067634.167886593],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fajardo',
        GEOID: '72053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7319656.267949177, 2072312.6104976384],
              [-7317260.004590359, 2071305.951633958],
              [-7309388.2353850845, 2083135.52289892],
              [-7305232.712846583, 2082916.280214077],
              [-7301025.9492895035, 2083645.1309334517],
              [-7298768.056057745, 2079533.738395876],
              [-7298654.732816117, 2075629.450742319],
              [-7305327.223094266, 2073944.169743983],
              [-7304111.465860912, 2071967.9470013422],
              [-7317891.63138112, 2069630.8767298153],
              [-7319656.267949177, 2072312.6104976384],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Elko',
        GEOID: '32007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13026406.795631418, 5160955.454441945],
              [-12982741.033323312, 5160586.839046285],
              [-12950103.939734576, 5160572.45931498],
              [-12898609.547044441, 5160495.018843313],
              [-12871417.86898684, 5160592.231451118],
              [-12836682.069038182, 5160395.710222949],
              [-12805983.79946167, 5160774.843398149],
              [-12790521.549749408, 5160965.812700855],
              [-12757020.728231605, 5160157.25392921],
              [-12721797.905510725, 5160112.768710465],
              [-12721791.723629933, 5160112.751599109],
              [-12695066.533547556, 5160038.776920894],
              [-12694863.70943533, 5124168.090654713],
              [-12694900.44486729, 5085138.588789126],
              [-12695035.809368096, 5043033.499447262],
              [-12695113.51037267, 5012330.748870536],
              [-12695113.526651476, 5012326.409029432],
              [-12695264.904880147, 4972053.237841001],
              [-12695495.558865072, 4938254.4831941845],
              [-12695562.461879037, 4923993.98946188],
              [-12695584.148849798, 4882949.65487756],
              [-12718433.607859971, 4882913.869801216],
              [-12831099.61921388, 4883765.906255553],
              [-12894689.765134629, 4884537.358755483],
              [-12913160.785602976, 4884469.513946179],
              [-12930630.932529598, 4963257.95502106],
              [-12930666.666086145, 5012328.6838762695],
              [-12978381.650744358, 5012400.368933902],
              [-13026430.81651393, 5012379.128861721],
              [-13026406.795631418, 5160955.454441945],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '18097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9609910.075682748, 4840180.7300670305],
              [-9609696.564899407, 4846514.354661976],
              [-9609798.978830935, 4854908.514534147],
              [-9600163.831624815, 4855202.604742973],
              [-9566528.424842646, 4855359.669317918],
              [-9566581.858198225, 4847041.710171692],
              [-9568320.223366456, 4845055.570366435],
              [-9568101.814525519, 4822028.022234917],
              [-9568141.778222714, 4813525.901216195],
              [-9601293.279178403, 4812846.517994609],
              [-9609804.322166495, 4812634.328610508],
              [-9609910.075682748, 4840180.7300670305],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Greenville',
        GEOID: '45045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9213030.326343868, 4175013.1268242705],
              [-9211290.563880747, 4174639.9373108973],
              [-9204567.868512249, 4180819.2190413196],
              [-9192509.201196479, 4183804.41776385],
              [-9187482.553065296, 4185049.0335673145],
              [-9178916.406929266, 4188018.7096391064],
              [-9173984.062931197, 4191431.934051699],
              [-9167513.536590606, 4190918.497785217],
              [-9161076.90193219, 4190407.774459722],
              [-9152242.851704404, 4190174.5802678936],
              [-9153416.339853758, 4143587.410130852],
              [-9146576.313741967, 4136272.3739743703],
              [-9144539.055740958, 4134776.8419487015],
              [-9154698.295109734, 4107890.824808453],
              [-9154483.559811994, 4100979.8464373997],
              [-9163152.119879559, 4093978.305348622],
              [-9175002.970230427, 4104166.619805189],
              [-9180263.372767864, 4118726.1198879746],
              [-9179223.760043345, 4133915.642916709],
              [-9182433.434921388, 4139285.462774524],
              [-9188073.214283446, 4166014.3723989036],
              [-9194337.718627838, 4164996.226701116],
              [-9191817.890634242, 4174028.5097253365],
              [-9211672.167095186, 4170400.7640023013],
              [-9213030.326343868, 4175013.1268242705],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Blount',
        GEOID: '47009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9365806.13592297, 4252211.856296621],
              [-9370074.570477946, 4261168.683488518],
              [-9369345.984410703, 4273837.289588138],
              [-9366900.74047594, 4272554.944513689],
              [-9367051.912344437, 4279944.326617271],
              [-9352671.883162744, 4278558.959235135],
              [-9350244.672985487, 4284637.181235594],
              [-9334156.557537062, 4278905.147237873],
              [-9327936.024391534, 4285101.040697838],
              [-9318025.806723662, 4261007.454131482],
              [-9313301.85281236, 4258133.967256593],
              [-9313312.751167428, 4241313.10105996],
              [-9325426.994388543, 4240535.561966139],
              [-9333972.54641878, 4234672.190805589],
              [-9341575.55632047, 4228430.846079299],
              [-9345630.967688218, 4226573.209226054],
              [-9346263.98089795, 4226283.277155543],
              [-9343995.530730827, 4230366.709665951],
              [-9350148.715584423, 4238877.565134445],
              [-9359916.55562357, 4237677.702274881],
              [-9371800.801821679, 4247164.991541534],
              [-9365806.13592297, 4252211.856296621],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lee',
        GEOID: '51105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9307925.010087553, 4388210.79681447],
              [-9298195.57527273, 4392651.105453645],
              [-9290830.97247617, 4392671.372359233],
              [-9288109.584128896, 4392678.861451843],
              [-9282498.079917498, 4395510.907552178],
              [-9265833.552145746, 4401106.420905718],
              [-9254701.157788454, 4403356.811879346],
              [-9252285.30219926, 4410722.069041094],
              [-9247932.376150768, 4418301.232429939],
              [-9240918.914272321, 4417842.1654436905],
              [-9227878.726481816, 4422692.02694537],
              [-9226577.314023376, 4424777.738246381],
              [-9222526.151406001, 4417894.192039885],
              [-9214091.807547066, 4411270.219953849],
              [-9219854.038349, 4402039.2455556225],
              [-9233683.14737076, 4394023.031994254],
              [-9237787.663482662, 4382844.563178929],
              [-9270275.31114789, 4383246.251467463],
              [-9292070.952084968, 4383424.945663836],
              [-9314704.367076863, 4383610.511611332],
              [-9307925.010087553, 4388210.79681447],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Christian',
        GEOID: '17021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9966993.72512149, 4813929.650178516],
              [-9960698.051319677, 4813886.860400397],
              [-9960748.145090533, 4820122.510856669],
              [-9954751.141482519, 4820083.74473568],
              [-9954805.020116063, 4829342.706871904],
              [-9941178.067289587, 4833417.31700792],
              [-9934845.43541683, 4840681.659382222],
              [-9931643.664222633, 4838901.561359128],
              [-9923238.374750795, 4837105.697867408],
              [-9922922.004757961, 4815952.688136834],
              [-9910293.365124919, 4815815.618107091],
              [-9910277.001159772, 4771332.673272844],
              [-9922997.924650682, 4771770.715504838],
              [-9966527.073816085, 4771767.260611426],
              [-9966840.883460632, 4797095.885983303],
              [-9966990.385536768, 4809750.993970721],
              [-9966993.72512149, 4813929.650178516],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coos',
        GEOID: '33007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7988642.049172265, 5528109.1909404695],
              [-7980596.708901311, 5530862.211317896],
              [-7975657.574414306, 5538289.776298536],
              [-7968246.256675761, 5543424.706768158],
              [-7969148.167190169, 5550618.387673757],
              [-7964344.285884475, 5555528.822075164],
              [-7965101.25842187, 5563083.70944099],
              [-7968758.326333411, 5568990.811710038],
              [-7973471.036976144, 5581814.474638847],
              [-7967180.706509888, 5590918.0933762165],
              [-7961836.3690763945, 5602777.093664973],
              [-7958720.53652909, 5607652.688212842],
              [-7962861.844225582, 5617747.58774484],
              [-7959464.707325042, 5623627.666960074],
              [-7959165.3692143, 5632489.815901337],
              [-7953630.452812567, 5638697.816690853],
              [-7950333.16949527, 5648401.383682375],
              [-7948839.039289844, 5652768.539020291],
              [-7952502.56373185, 5659226.580343056],
              [-7943832.779149889, 5664101.987507509],
              [-7935263.404748621, 5669187.527840798],
              [-7930901.350501887, 5663833.724650775],
              [-7924009.338187895, 5659553.04288204],
              [-7919205.122923728, 5659851.691402716],
              [-7915856.5213211775, 5666061.530160219],
              [-7913026.223267758, 5669737.360309045],
              [-7910124.903379214, 5621529.200242513],
              [-7907769.82823199, 5580133.442050021],
              [-7906243.304054744, 5543156.256129044],
              [-7905850.316138705, 5533844.241501715],
              [-7905195.109022123, 5518339.961419922],
              [-7904938.416983663, 5512272.989805511],
              [-7904827.227499375, 5509635.67516008],
              [-7908390.434393162, 5502271.894457502],
              [-7931731.571264222, 5503321.050916362],
              [-7941074.05952905, 5478722.10684322],
              [-7943367.241039391, 5491141.654884373],
              [-7949981.399904364, 5498334.746832791],
              [-7953036.006731732, 5504083.44303915],
              [-7967783.724191515, 5504926.406353944],
              [-7969028.832696038, 5512726.105930396],
              [-7981260.729663893, 5516982.88652333],
              [-7988642.049172265, 5528109.1909404695],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Isabella',
        GEOID: '26073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9472043.112725094, 5436653.245102633],
              [-9418300.956876865, 5436913.808547633],
              [-9418468.270071525, 5383173.855457152],
              [-9445009.28570544, 5383197.169026161],
              [-9471618.428867718, 5383202.077153423],
              [-9472043.112725094, 5436653.245102633],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Merrimack',
        GEOID: '33013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8016268.260489582, 5378706.247747359],
              [-8007802.079256281, 5392822.399066797],
              [-8002993.299892992, 5399847.60040551],
              [-7999930.566742797, 5403450.741237723],
              [-7994734.395551548, 5395176.133871943],
              [-7984676.902197358, 5398125.750066875],
              [-7971858.796790984, 5378862.926454609],
              [-7964912.905843447, 5381133.378371978],
              [-7956165.865534875, 5374786.615207016],
              [-7929956.470664033, 5355451.936587311],
              [-7931217.1638972685, 5353959.237664486],
              [-7937688.722494535, 5339174.542318988],
              [-7939051.050422862, 5336723.388899867],
              [-7943326.609425252, 5327516.752309511],
              [-7948541.370971464, 5318222.773478266],
              [-7947364.278675814, 5313388.879021677],
              [-7960764.807658017, 5319526.807551998],
              [-7961288.009264747, 5322466.387970472],
              [-7975072.033892732, 5320220.40664717],
              [-7978019.774008938, 5335217.9714804115],
              [-7985232.052497944, 5333272.962730402],
              [-7993883.469363925, 5330906.329750961],
              [-8005342.475107202, 5343547.740581753],
              [-8016013.450175155, 5340613.267655181],
              [-8025038.343932746, 5361197.285576451],
              [-8016268.260489582, 5378706.247747359],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Menominee',
        GEOID: '26109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9780177.578311201, 5683621.747700238],
              [-9779131.063778253, 5691721.228156285],
              [-9774493.939069768, 5696317.64407047],
              [-9774319.167469224, 5704502.671958264],
              [-9772436.643560417, 5712487.342847197],
              [-9771365.638739496, 5717943.532022353],
              [-9776598.211404234, 5724949.135872507],
              [-9771737.000560785, 5728249.997684568],
              [-9774416.349384686, 5732970.459221339],
              [-9777530.341602098, 5736030.896175368],
              [-9762403.083896749, 5736063.970840218],
              [-9762379.37284521, 5764153.372125808],
              [-9753523.907352604, 5764154.011959844],
              [-9753489.954907913, 5778108.237150537],
              [-9725744.462383615, 5777997.212170896],
              [-9721018.059443515, 5764125.0595159],
              [-9721253.054888578, 5708726.044273041],
              [-9713009.582632355, 5708545.713271037],
              [-9716936.53031358, 5700837.803439843],
              [-9723852.364998601, 5685942.3181730015],
              [-9736581.637451323, 5664658.152314515],
              [-9745906.091958638, 5651734.166518856],
              [-9750497.353036916, 5636531.341885565],
              [-9756951.991071584, 5638282.523473206],
              [-9762168.86768812, 5645249.303157774],
              [-9767373.053882705, 5652596.661917056],
              [-9763997.2903244, 5660209.956249399],
              [-9759092.88751852, 5671464.15462259],
              [-9757971.454968268, 5679761.961982702],
              [-9763472.641564291, 5682150.953309463],
              [-9768388.621597212, 5677589.0479910895],
              [-9773902.943893146, 5677362.676968148],
              [-9780918.854800394, 5677269.53225891],
              [-9780177.578311201, 5683621.747700238],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Schoolcraft',
        GEOID: '26153',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9641981.888897235, 5833916.6381908525],
              [-9614106.597846672, 5833701.244876066],
              [-9614102.590345005, 5861786.256025254],
              [-9558440.50723906, 5861609.319005821],
              [-9558450.859951705, 5819638.548422812],
              [-9558541.5766474, 5771951.424932102],
              [-9563877.017210932, 5767448.648704979],
              [-9581498.669964526, 5774792.3455079505],
              [-9604423.805898493, 5771068.6708861105],
              [-9612341.627320144, 5753812.955652622],
              [-9622419.046863189, 5742078.85879335],
              [-9624669.873283137, 5740412.79756419],
              [-9624584.544917589, 5763756.843848312],
              [-9628038.566077923, 5805733.689983403],
              [-9642004.598073358, 5805816.134985221],
              [-9641981.888897235, 5833916.6381908525],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grand Forks',
        GEOID: '38035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10898560.419792866, 6139340.215135164],
              [-10813787.998988727, 6139128.235910398],
              [-10814225.993571049, 6135721.584907471],
              [-10814326.185623994, 6134942.497858814],
              [-10809747.726287158, 6122067.69733764],
              [-10805670.204658892, 6111225.840761675],
              [-10802148.835206628, 6095762.007030648],
              [-10797585.84927901, 6081007.135561686],
              [-10790031.931272762, 6064517.079683157],
              [-10786134.335486619, 6052480.750420442],
              [-10850616.339622602, 6052468.193086101],
              [-10896219.482220974, 6052489.353583319],
              [-10896194.324016055, 6110316.410893292],
              [-10898560.419792866, 6139340.215135164],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bristol',
        GEOID: '51520',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9148194.787818609, 4387214.124627448],
              [-9140930.189168932, 4388826.047259341],
              [-9142838.093921639, 4394214.296854471],
              [-9139632.20390628, 4389997.548733761],
              [-9144403.387395218, 4382743.397453228],
              [-9147565.832695628, 4382749.868193164],
              [-9155291.739894036, 4382787.191485921],
              [-9148194.787818609, 4387214.124627448],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Colonial Heights',
        GEOID: '51570',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8619657.971854974, 4477695.6151877],
              [-8613712.286532214, 4478837.797693766],
              [-8612588.96155062, 4480802.77024469],
              [-8611934.291625265, 4478509.848243738],
              [-8613812.362754438, 4476469.907440384],
              [-8614182.834019799, 4473009.402790726],
              [-8616537.241250077, 4472241.596981235],
              [-8616688.969716027, 4472067.376750467],
              [-8616842.701932812, 4472003.757721037],
              [-8617021.70367401, 4471850.933797401],
              [-8617150.834283328, 4471811.784383892],
              [-8617228.090009939, 4471735.023991582],
              [-8617588.987799091, 4471809.687097988],
              [-8617637.96837504, 4471766.622919634],
              [-8617845.133947406, 4471745.230714623],
              [-8617965.470316954, 4471663.017938595],
              [-8617732.255983742, 4475542.398041716],
              [-8619657.971854974, 4477695.6151877],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Galax',
        GEOID: '51640',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9011268.140599687, 4392235.745556432],
              [-9010656.996595232, 4394083.131541307],
              [-9009339.196463222, 4393429.41098938],
              [-9008028.52077862, 4394337.9684826],
              [-9007411.142882682, 4396650.516988265],
              [-9006357.949180286, 4395547.555298466],
              [-9004760.737126386, 4396812.2572642],
              [-9003216.958428064, 4396291.920464768],
              [-9004495.351460334, 4393962.932785446],
              [-9007324.536318844, 4390467.07329516],
              [-9007532.70376663, 4387567.145414478],
              [-9009214.07335557, 4387001.90163114],
              [-9008163.662640445, 4389535.675463414],
              [-9011062.756139174, 4390205.530029283],
              [-9011268.140599687, 4392235.745556432],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Breathitt',
        GEOID: '21025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9303992.426436298, 4509908.259126317],
              [-9297660.796438958, 4528485.354686709],
              [-9294675.207695883, 4525825.848430042],
              [-9286102.04843193, 4535827.848216017],
              [-9267202.002646066, 4532858.194209653],
              [-9254540.189804766, 4524029.472968503],
              [-9249513.780836979, 4527592.873665052],
              [-9240872.49404466, 4520750.615600939],
              [-9233789.680123447, 4509475.780572455],
              [-9249371.06924978, 4512212.259091157],
              [-9253360.091882868, 4495706.136784245],
              [-9263421.9266972, 4501111.911772053],
              [-9282002.819502957, 4486362.174906866],
              [-9289550.726256706, 4492046.396182867],
              [-9300479.405945845, 4485823.420845741],
              [-9298993.624702226, 4497449.0251290295],
              [-9303992.426436298, 4509908.259126317],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Roosevelt',
        GEOID: '35041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11571525.03554304, 4110338.789259856],
              [-11548079.814948086, 4110286.3137602177],
              [-11548291.321980594, 4069567.9964563395],
              [-11517094.47996374, 4069595.621926559],
              [-11470787.333999647, 4069513.015233336],
              [-11470757.065186592, 4043963.009322937],
              [-11470751.730668537, 4039466.0763114104],
              [-11471178.084318276, 4005284.3873296673],
              [-11471764.070117813, 3971288.670405903],
              [-11471764.127621453, 3971285.4340434056],
              [-11522694.852226062, 3971224.273482822],
              [-11522653.664014466, 3982873.0090250177],
              [-11545872.015487181, 3982732.317140767],
              [-11545710.824864514, 4004598.731783337],
              [-11559631.104549231, 4004550.762889793],
              [-11559604.16523246, 4039805.7134559792],
              [-11571217.90506794, 4039880.1742398725],
              [-11571525.03554304, 4110338.789259856],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Culberson',
        GEOID: '48109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11679458.075470142, 3763372.594230809],
              [-11671597.02762554, 3763371.613640914],
              [-11648864.029132683, 3763368.777919089],
              [-11579956.707734192, 3763311.939800119],
              [-11588620.703702632, 3646419.305515244],
              [-11679325.160634883, 3589141.1956084184],
              [-11679249.908659106, 3609528.747189921],
              [-11678849.492450723, 3714201.773017066],
              [-11679458.075470142, 3763372.594230809],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rockbridge',
        GEOID: '51163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8869287.143220786, 4546012.645171129],
              [-8861737.344035696, 4559964.992909321],
              [-8866329.050391937, 4561717.369423462],
              [-8853668.796023507, 4579894.969412032],
              [-8847970.12865082, 4591589.499554941],
              [-8814720.109945778, 4567311.3842162965],
              [-8811760.347324565, 4564039.614386629],
              [-8810312.971305272, 4559116.901984466],
              [-8813401.307938349, 4551647.243812319],
              [-8820159.959502371, 4553018.747836351],
              [-8832671.157072628, 4531593.819487179],
              [-8842880.49021226, 4525469.16259766],
              [-8842560.001398267, 4519184.887720007],
              [-8849754.691407727, 4513634.320159371],
              [-8870332.655878317, 4531753.8442144925],
              [-8869287.143220786, 4546012.645171129],
            ],
            [
              [-8844964.39107991, 4546312.017434944],
              [-8841334.596443614, 4549602.1589921],
              [-8840431.572734298, 4549608.77947666],
              [-8844704.014790945, 4550246.901262286],
              [-8845619.39496374, 4548918.299704591],
              [-8844964.39107991, 4546312.017434944],
            ],
            [
              [-8834994.394845482, 4540835.119691972],
              [-8835855.117148297, 4536741.714701923],
              [-8831143.185742, 4544484.375426796],
              [-8831276.65781146, 4545681.599596595],
              [-8836709.160281662, 4543063.879806698],
              [-8834994.394845482, 4540835.119691972],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Russell',
        GEOID: '21207',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9487985.733599052, 4428667.5122643905],
              [-9485069.719537724, 4438669.399544068],
              [-9466978.632491454, 4465068.509513022],
              [-9457081.216565024, 4453371.649085464],
              [-9451148.555622688, 4455329.510214344],
              [-9451667.97236673, 4445686.089044498],
              [-9443868.260924809, 4438773.936073344],
              [-9456092.810806273, 4433497.522359405],
              [-9457801.676309438, 4427451.790178975],
              [-9469315.339922696, 4419435.630203725],
              [-9475338.169652576, 4415066.623328551],
              [-9488321.918461248, 4423183.035969692],
              [-9486135.492342578, 4418840.731021784],
              [-9492764.011421863, 4424885.042195038],
              [-9487985.733599052, 4428667.5122643905],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dallas',
        GEOID: '29059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10373051.382659316, 4565893.410753945],
              [-10360777.406923942, 4565679.391184492],
              [-10336614.064293882, 4564707.25894147],
              [-10335600.72296919, 4540092.587014646],
              [-10336402.223302903, 4506782.38263633],
              [-10360681.338203387, 4507269.744183889],
              [-10360881.268008852, 4497109.842772291],
              [-10373027.226329815, 4497420.292314428],
              [-10371991.287148492, 4541305.915060672],
              [-10373631.245886859, 4551596.523891838],
              [-10373051.382659316, 4565893.410753945],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '40081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10813694.670152724, 4262770.823857186],
              [-10813640.234921725, 4292642.356009306],
              [-10755811.31792749, 4292577.457436398],
              [-10755761.335476125, 4251062.034761708],
              [-10756230.7697688, 4226940.186003255],
              [-10813741.201699875, 4227113.899139917],
              [-10813694.670152724, 4262770.823857186],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mille Lacs',
        GEOID: '27095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10442970.70954861, 5817974.982894113],
              [-10441354.2392228, 5819408.051214924],
              [-10400652.159845583, 5819925.229672163],
              [-10400783.850803193, 5805060.819650054],
              [-10400857.432986606, 5777368.737658249],
              [-10410385.045564622, 5777431.37484815],
              [-10409895.573763603, 5737875.235456814],
              [-10409563.953000529, 5709921.868826899],
              [-10437252.56126503, 5710060.825054182],
              [-10437754.94612698, 5751893.176943718],
              [-10442917.164873539, 5777638.19285461],
              [-10442921.72897266, 5805477.681455855],
              [-10442970.70954861, 5817974.982894113],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Luce',
        GEOID: '26095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9558440.50723906, 5861609.319005821],
              [-9558404.344137248, 5891063.2664431995],
              [-9555782.754396372, 5891441.001736362],
              [-9515823.398661729, 5890067.546716066],
              [-9490750.241833413, 5901911.907227528],
              [-9488636.6384053, 5902289.313876223],
              [-9488632.833799034, 5819767.159466076],
              [-9558450.859951705, 5819638.548422812],
              [-9558440.50723906, 5861609.319005821],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '29123',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10079691.128571805, 4522848.920884895],
              [-10078311.880080875, 4529205.8332555685],
              [-10035093.423614277, 4528921.431582422],
              [-10035091.753821913, 4522711.793270591],
              [-10034973.30988371, 4482697.987662712],
              [-10042983.637802213, 4483100.53089248],
              [-10079949.723748917, 4483468.235959425],
              [-10079691.128571805, 4522848.920884895],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Upton',
        GEOID: '48461',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11389993.224960703, 3717628.3975594086],
              [-11386575.159995899, 3717621.7282560286],
              [-11329630.453717032, 3717627.35139393],
              [-11329673.756998952, 3643114.9549947577],
              [-11388118.827374728, 3643950.4812753373],
              [-11389993.224960703, 3717628.3975594086],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grimes',
        GEOID: '48185',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10705413.978819126, 3609783.2063816916],
              [-10671426.91376554, 3615115.7317581386],
              [-10667773.519397195, 3584826.99293872],
              [-10664886.559722964, 3535154.79390633],
              [-10694387.67193656, 3533143.953037005],
              [-10697042.196514018, 3532528.498014122],
              [-10697180.12136311, 3543378.9090678766],
              [-10703884.449015627, 3546076.329677158],
              [-10703063.467771025, 3552855.889593536],
              [-10695573.22451351, 3558946.8228875073],
              [-10700230.498049827, 3560676.4154835083],
              [-10707573.020343062, 3580746.418140906],
              [-10705413.978819126, 3609783.2063816916],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Giles',
        GEOID: '47055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9710671.02409377, 4203043.392364885],
              [-9707791.856783893, 4222909.199261443],
              [-9699168.3811101, 4226026.289632018],
              [-9680432.420253666, 4220698.038125445],
              [-9674381.871970579, 4206645.019021328],
              [-9665682.253765086, 4199771.779612587],
              [-9666571.175070409, 4162903.1440913873],
              [-9708257.236818744, 4163751.9323108136],
              [-9708916.74023836, 4163765.3612702996],
              [-9709737.236338781, 4163776.605462412],
              [-9710671.02409377, 4203043.392364885],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bartholomew',
        GEOID: '18005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9583005.26795292, 4771094.298790582],
              [-9568133.429260904, 4771552.627684725],
              [-9538356.57866861, 4771937.847390791],
              [-9538609.05127373, 4740433.372994302],
              [-9551193.8310274, 4740151.815774653],
              [-9551079.171951883, 4731493.5266292365],
              [-9557955.265578693, 4727533.274329472],
              [-9582412.046386484, 4728874.87889708],
              [-9582273.78757892, 4733085.891331496],
              [-9583005.26795292, 4771094.298790582],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hall',
        GEOID: '31079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10989679.987106284, 5019228.507646307],
              [-10941277.493272932, 5019182.602803698],
              [-10940746.165343376, 5016265.5071592145],
              [-10940766.536810191, 4992990.805530157],
              [-10940796.927031178, 4967939.967209257],
              [-10989619.3179838, 4968030.855204459],
              [-10989679.987106284, 5019228.507646307],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Trigg',
        GEOID: '21221',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9813630.977725923, 4420609.944244914],
              [-9796415.418474743, 4426592.750837229],
              [-9782422.447162537, 4433548.929122923],
              [-9780317.618230619, 4432239.179186221],
              [-9766433.851338882, 4439399.922383969],
              [-9758235.8387589, 4434423.996826343],
              [-9762072.12079412, 4388606.889733747],
              [-9779773.933837583, 4388108.697799236],
              [-9779369.064849569, 4392334.1370692],
              [-9797427.869243508, 4394183.34447131],
              [-9803966.776132705, 4394335.053646599],
              [-9805034.775327375, 4398308.436312648],
              [-9808452.840292182, 4403921.116227273],
              [-9810580.489719715, 4412315.023979148],
              [-9813630.977725923, 4420609.944244914],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Osage',
        GEOID: '20139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10681066.625070784, 4678131.540782372],
              [-10680651.403370123, 4684370.203565101],
              [-10680725.208192522, 4703063.3976482665],
              [-10631091.966068959, 4703040.806986291],
              [-10631093.524541833, 4684326.817789396],
              [-10631906.602102585, 4678114.853158109],
              [-10631931.648988012, 4640908.661361998],
              [-10681136.533711003, 4640933.104555091],
              [-10681066.625070784, 4678131.540782372],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rio Grande',
        GEOID: '08105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11879083.645403272, 4532106.807250534],
              [-11877104.496176457, 4556177.389065151],
              [-11865226.03859187, 4556062.09229059],
              [-11865140.879181415, 4543860.685016802],
              [-11804142.139686842, 4543937.271625042],
              [-11804244.33097939, 4495128.648102369],
              [-11875382.161014903, 4495513.169913285],
              [-11878989.135155588, 4495601.735240922],
              [-11879083.645403272, 4532106.807250534],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marion',
        GEOID: '28091',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10023260.940979386, 3684111.718564835],
              [-10014183.39310265, 3683566.0873676147],
              [-9999087.579595154, 3683505.0574740507],
              [-9999188.212414833, 3689253.635295232],
              [-9980261.227312196, 3689216.060942723],
              [-9980241.857720798, 3633074.0799748395],
              [-9988494.827638065, 3633049.649431783],
              [-9988491.633863997, 3633064.859034784],
              [-10000487.513955675, 3633022.0561855966],
              [-10000483.637329193, 3642483.5384248425],
              [-10009953.697730469, 3642451.1756205983],
              [-10011872.1778348, 3650027.164942349],
              [-10022304.817872962, 3655591.729434638],
              [-10023258.825909061, 3676464.2748702993],
              [-10023260.940979386, 3684111.718564835],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '20087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10640971.348237881, 4752670.754559232],
              [-10640923.36953735, 4779791.8590919245],
              [-10638842.808254423, 4781875.886573352],
              [-10595488.319370076, 4781900.095184982],
              [-10595403.048640126, 4740150.667749038],
              [-10596179.836046882, 4727991.779228659],
              [-10607124.991020657, 4726279.550737664],
              [-10622043.36125983, 4731302.689106697],
              [-10631039.645908287, 4729790.310715427],
              [-10641782.533367291, 4730939.519900126],
              [-10640971.348237881, 4752670.754559232],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Borden',
        GEOID: '48033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11320221.952994168, 3890239.690964447],
              [-11305321.839151489, 3890131.8259406225],
              [-11262568.920795387, 3890473.0702245757],
              [-11262700.723072486, 3832780.927753317],
              [-11262701.724947903, 3832306.8139583226],
              [-11319938.75620959, 3832453.3634003857],
              [-11320221.952994168, 3890239.690964447],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kendall',
        GEOID: '48259',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11011740.393235767, 3521338.147755797],
              [-10974754.492419703, 3521423.6184041016],
              [-10955398.370680058, 3495525.900624104],
              [-10981236.292410122, 3470837.109932164],
              [-10981951.854096942, 3471437.672387945],
              [-10996003.713419776, 3467630.3965841555],
              [-11011470.777429067, 3475481.4295155806],
              [-11011740.393235767, 3521338.147755797],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '36033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8305663.870912492, 5621396.015726417],
              [-8286281.589092511, 5620919.65316264],
              [-8263706.2189986175, 5620285.434184446],
              [-8240695.969670164, 5621106.725461657],
              [-8236126.369876621, 5575633.05087189],
              [-8227588.721530231, 5532181.687829685],
              [-8253385.566368192, 5528685.6874537775],
              [-8248049.577896507, 5486763.177814166],
              [-8269019.943572144, 5484116.87514898],
              [-8297215.6121172095, 5480814.2178817745],
              [-8296161.082580924, 5491886.581405763],
              [-8309414.371479643, 5621053.548552426],
              [-8305663.870912492, 5621396.015726417],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '48477',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10768431.831237705, 3534595.4218420084],
              [-10758013.885372328, 3541756.246332405],
              [-10726457.481400214, 3551627.217595176],
              [-10719974.902173359, 3552379.9940293175],
              [-10717000.668018343, 3549711.2855249783],
              [-10706559.56769888, 3554388.736060721],
              [-10703884.449015627, 3546076.329677158],
              [-10697180.12136311, 3543378.9090678766],
              [-10697042.196514018, 3532528.498014122],
              [-10704372.028385302, 3530135.760983669],
              [-10708020.190737577, 3521354.881421788],
              [-10702929.550423602, 3512579.6814336274],
              [-10704534.77748084, 3510416.9215041497],
              [-10719270.91771358, 3515915.0264044497],
              [-10755909.613037864, 3509243.28119566],
              [-10758719.650943957, 3522224.290055548],
              [-10775120.24020304, 3524203.143889988],
              [-10768431.831237705, 3534595.4218420084],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pushmataha',
        GEOID: '40127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10662116.819472535, 4097024.632109575],
              [-10650124.927326832, 4097057.4581545605],
              [-10650155.65150629, 4108823.3197946954],
              [-10632604.90926833, 4108864.023557491],
              [-10632627.061846998, 4120633.600101245],
              [-10581988.048124122, 4120578.6397721856],
              [-10568422.209698088, 4120597.726949518],
              [-10568405.845732942, 4097061.780933048],
              [-10580555.36627761, 4097115.545629183],
              [-10580537.443839593, 4061568.205750163],
              [-10592186.805912126, 4061599.8516176157],
              [-10592775.463379443, 4049898.1142894235],
              [-10662111.364817487, 4049862.3307877583],
              [-10662116.819472535, 4097024.632109575],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calhoun',
        GEOID: '54013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9047234.466199577, 4712556.635462249],
              [-9034963.16213198, 4726056.854755363],
              [-9032027.889798744, 4728143.71103348],
              [-9020622.651369518, 4723044.491338523],
              [-9017187.888481092, 4699639.912338328],
              [-9022657.237702748, 4690206.70321536],
              [-9015203.39591872, 4681343.061609085],
              [-9020405.021765018, 4674203.427941881],
              [-9026197.308829464, 4666242.747954642],
              [-9034532.021744138, 4670810.433674441],
              [-9041457.095946897, 4699293.882537741],
              [-9047871.436325897, 4709484.326808687],
              [-9047234.466199577, 4712556.635462249],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Idaho',
        GEOID: '16049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13002027.973617421, 5756511.193053616],
              [-12996576.710195025, 5759427.056099698],
              [-12997334.461968856, 5771076.034713575],
              [-12991187.06572878, 5779769.291934872],
              [-12985253.402911026, 5785253.767400001],
              [-12972048.684913127, 5780463.800247872],
              [-12970328.910099862, 5801493.228436692],
              [-12962950.988208555, 5811968.089953038],
              [-12934099.536543226, 5805280.336563432],
              [-12927929.876404991, 5814907.4789950615],
              [-12914466.229271509, 5816585.7530841045],
              [-12927209.973258032, 5828325.854891144],
              [-12932015.524356088, 5840097.73403882],
              [-12921531.009435214, 5838549.029102957],
              [-12912998.370465908, 5829606.0648014555],
              [-12892437.994474862, 5823039.403424338],
              [-12888440.511560477, 5823296.404427928],
              [-12883391.727375036, 5838693.240758022],
              [-12872340.262287555, 5850751.326825563],
              [-12871951.534625705, 5856480.663317318],
              [-12756224.682912173, 5885544.7278938405],
              [-12751349.445453653, 5884236.815609503],
              [-12740876.28512084, 5885012.0873231925],
              [-12730575.892637739, 5888222.38641054],
              [-12727794.679289076, 5885986.255138844],
              [-12726118.214948412, 5884638.6316335285],
              [-12727306.32787365, 5873427.445987359],
              [-12729568.005968094, 5862152.918386801],
              [-12735285.820293201, 5860625.555890018],
              [-12733252.792432843, 5846585.248656953],
              [-12737449.759874733, 5842600.274358862],
              [-12738479.46516457, 5830286.770620099],
              [-12739550.13602702, 5824334.951488376],
              [-12740495.572462326, 5818429.470846493],
              [-12740062.428323649, 5808266.050521449],
              [-12747718.760261431, 5807268.289429165],
              [-12748452.800983721, 5800449.331434432],
              [-12741634.370853141, 5795923.882554408],
              [-12743882.134011239, 5785210.155193165],
              [-12739534.439978817, 5778498.998457959],
              [-12735201.440119179, 5774179.951781541],
              [-12736415.601805262, 5766174.997802785],
              [-12733640.96349724, 5761514.129038682],
              [-12737505.976217581, 5757204.134252902],
              [-12747990.045860494, 5754105.82344202],
              [-12753040.165879821, 5745152.232461805],
              [-12746623.710430497, 5735938.959646745],
              [-12746041.286854666, 5727469.550470385],
              [-12750063.5940155, 5724535.399771068],
              [-12750326.530652754, 5717566.400776209],
              [-12748728.099086149, 5714144.703690609],
              [-12764307.479459954, 5695978.886887267],
              [-12778784.91319609, 5701902.477990442],
              [-12778721.349766847, 5690476.9104587715],
              [-12757652.243702877, 5668214.087295335],
              [-12767677.78836321, 5652617.356504542],
              [-12910365.553189157, 5652317.210664427],
              [-12910462.623785129, 5656099.938960254],
              [-12926604.283908626, 5646516.412219499],
              [-12929133.90801741, 5638484.88385963],
              [-12944894.855482396, 5641810.52321694],
              [-12951229.71374497, 5663791.492961971],
              [-12989973.377691323, 5663967.402378859],
              [-12988162.403844435, 5671144.698736418],
              [-12978538.499906885, 5691521.789339855],
              [-12969027.473932998, 5711167.7824007],
              [-12964657.96128038, 5718990.831087143],
              [-12971867.90206008, 5729451.150052138],
              [-12972694.560598709, 5737861.360133538],
              [-12979073.83533811, 5744931.006038244],
              [-12987126.687302094, 5745482.805424883],
              [-12995021.910867115, 5752537.902866577],
              [-13000727.257409252, 5754778.67299942],
              [-13002027.973617421, 5756511.193053616],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adams',
        GEOID: '55001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10021643.24613918, 5479651.392823936],
              [-10010225.651246475, 5489059.286066127],
              [-10007932.024458172, 5504130.220492531],
              [-9988113.036275808, 5503851.268790015],
              [-9974001.509705909, 5503547.772790887],
              [-9973998.170121185, 5462672.534825761],
              [-9974175.947347982, 5410304.809111126],
              [-9987443.67217767, 5410384.492754374],
              [-9994809.460244479, 5410060.993736515],
              [-9995045.34624547, 5414076.383220814],
              [-10003740.734310314, 5431985.9492666535],
              [-10016603.033554532, 5450848.722251691],
              [-10013683.457269497, 5453377.263665691],
              [-10021643.24613918, 5479651.392823936],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'East Carroll',
        GEOID: '22035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10179644.120118648, 3839946.1695928676],
              [-10174263.492531154, 3843581.360527643],
              [-10174407.20599377, 3854622.7403490804],
              [-10168268.270034993, 3862237.748008576],
              [-10164513.686249517, 3886710.909952582],
              [-10159524.797540648, 3895932.9799505575],
              [-10148560.823982406, 3895848.978902103],
              [-10145036.56022338, 3892720.3297097967],
              [-10138097.01448682, 3887055.1054188735],
              [-10137933.040876882, 3880534.615869534],
              [-10145423.506773379, 3875275.034914884],
              [-10148070.57294495, 3870438.202073201],
              [-10147619.172409786, 3865613.6831214624],
              [-10142725.344955532, 3860839.9740054877],
              [-10136418.76184362, 3858935.68915664],
              [-10141067.797737619, 3853605.7226052275],
              [-10138924.229622904, 3842420.0710564135],
              [-10136228.862475296, 3839553.4768197155],
              [-10144958.525260337, 3834128.9086846123],
              [-10181018.247913, 3834115.0438634646],
              [-10179644.120118648, 3839946.1695928676],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '12065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9359246.189650012, 3538769.466765754],
              [-9359151.79072182, 3559498.3661777745],
              [-9355433.942368306, 3564565.380729131],
              [-9348324.077810831, 3570856.3398367087],
              [-9351667.002119353, 3590234.0174362687],
              [-9330908.032156732, 3589008.8050186653],
              [-9322309.269409897, 3588481.3160384367],
              [-9307612.32018644, 3587579.7868114337],
              [-9306775.413706131, 3578571.1807457022],
              [-9321555.079859773, 3568961.382463038],
              [-9319859.238737026, 3559505.079868521],
              [-9329315.495521443, 3551417.031444387],
              [-9330825.878372528, 3542627.0558830434],
              [-9334917.092298161, 3538730.9264618647],
              [-9341434.403206144, 3535131.0835546157],
              [-9349981.217652617, 3515029.6760459025],
              [-9350916.931390388, 3515922.6176722404],
              [-9357849.241360048, 3516587.707517781],
              [-9359312.210113196, 3516293.2936904593],
              [-9359246.189650012, 3538769.466765754],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Orleans',
        GEOID: '22071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10034347.137748, 3496855.1445779577],
              [-10032644.060858352, 3500438.381686507],
              [-10030789.9234197, 3524769.0104076993],
              [-10023237.7865253, 3523503.924792658],
              [-10007982.22954852, 3529111.3788987803],
              [-9996202.401032774, 3524230.4388062456],
              [-9983720.480488598, 3526108.907807977],
              [-9977015.373599647, 3523295.235116382],
              [-9974792.819469893, 3521920.5125791878],
              [-9980570.027579656, 3518775.711265105],
              [-9983545.1522906, 3513324.995876786],
              [-9994545.96700977, 3509383.325294176],
              [-10001506.886088563, 3505916.4969167057],
              [-10001532.72552117, 3505655.7502135816],
              [-10020101.359872201, 3496607.964365713],
              [-10009962.046692278, 3492722.184911916],
              [-10008814.23142271, 3486576.4036379238],
              [-10014173.819626441, 3491035.4734684317],
              [-10019650.96121245, 3490127.9981161137],
              [-10025271.593622094, 3496524.972497734],
              [-10033501.109617969, 3492372.3415977345],
              [-10034347.137748, 3496855.1445779577],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clear Creek',
        GEOID: '08019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11787330.892826222, 4836485.995041987],
              [-11770525.100620652, 4837616.905640511],
              [-11765395.72112388, 4844457.99316865],
              [-11743859.295837559, 4830808.025156562],
              [-11732846.013335418, 4829257.4296597],
              [-11732957.33282621, 4803081.652917775],
              [-11754000.835407298, 4803390.826056184],
              [-11775001.925262395, 4802917.611635118],
              [-11780904.084664254, 4802909.669563755],
              [-11774946.376836488, 4809585.398365031],
              [-11791474.53823202, 4822293.653818623],
              [-11787330.892826222, 4836485.995041987],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dent',
        GEOID: '29065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10219821.550735757, 4549983.336727308],
              [-10188939.074960904, 4549659.77143503],
              [-10164394.68571386, 4549405.800151785],
              [-10164655.61860028, 4537138.88330174],
              [-10147143.94950359, 4536757.893786163],
              [-10147336.30958368, 4521399.336954519],
              [-10164856.327642178, 4522064.114403456],
              [-10165054.25369681, 4509751.515160663],
              [-10153560.293633422, 4509299.5387544865],
              [-10153658.14346583, 4497150.207701385],
              [-10202055.739241587, 4498194.984555004],
              [-10214124.330516448, 4498388.281074415],
              [-10214097.057241205, 4522899.220194325],
              [-10220142.818786187, 4522912.567817069],
              [-10219821.550735757, 4549983.336727308],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Menard',
        GEOID: '48327',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11144774.865778595, 3644182.1197544937],
              [-11087780.065728873, 3644091.3876666017],
              [-11087825.038803153, 3625053.676316018],
              [-11074592.268293576, 3625037.9719261834],
              [-11074493.639224734, 3595243.9435003437],
              [-11144888.189020224, 3595191.5050358814],
              [-11144774.865778595, 3644182.1197544937],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '40067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10924808.665165994, 4067778.413927555],
              [-10860616.16948056, 4067698.5152140055],
              [-10860414.569882734, 4038351.5409188815],
              [-10857748.9133562, 4026637.306558213],
              [-10860467.90864136, 4015256.492035388],
              [-10864354.2779814, 4018347.5544727016],
              [-10865794.306914302, 4024518.4998133704],
              [-10872771.923916714, 4027643.286840304],
              [-10882574.940914953, 4018763.9719589306],
              [-10887432.81217368, 4012725.7933456507],
              [-10894367.125894176, 4008597.068892417],
              [-10903879.376382459, 4012488.998616012],
              [-10903956.292679824, 4014205.6454732264],
              [-10904155.448719626, 4018651.6826310907],
              [-10903473.8394775, 4027600.725888235],
              [-10909940.945295135, 4028260.102816468],
              [-10918531.693038633, 4029125.9034023406],
              [-10920341.414000459, 4035334.9268018594],
              [-10920367.240122324, 4042814.9085034835],
              [-10923044.362556411, 4049571.89668682],
              [-10924726.291608883, 4047778.340677588],
              [-10924808.665165994, 4067778.413927555],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Little River',
        GEOID: '05081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10517670.540650528, 4000506.0190448333],
              [-10517161.225207388, 4020870.5643470585],
              [-10509525.293509183, 4021456.965716164],
              [-10507285.100076461, 4014735.3937047045],
              [-10490464.391059123, 4002256.2619881225],
              [-10468579.42444713, 3999573.540380979],
              [-10459448.888492776, 3995415.4099119073],
              [-10459280.462103205, 3995408.180158462],
              [-10460642.010795096, 3993961.5177651076],
              [-10460206.862905586, 3984541.382144615],
              [-10444649.630108753, 3976534.3528286708],
              [-10460404.12104327, 3972685.317033033],
              [-10462503.16136167, 3966356.265444605],
              [-10468911.685052494, 3968765.8004061896],
              [-10472121.721963663, 3971507.114929089],
              [-10479953.493418932, 3972240.771434541],
              [-10484447.572581748, 3974176.6141033834],
              [-10487810.534398612, 3971291.7432971126],
              [-10490622.798694523, 3972106.756390769],
              [-10497844.539340246, 3970471.97838484],
              [-10501705.099280955, 3970818.794891879],
              [-10503457.602024516, 3969398.730180507],
              [-10507229.885609027, 3970608.9135489133],
              [-10510681.34642107, 3972172.8952257116],
              [-10518119.492156897, 3980279.4459485323],
              [-10517670.540650528, 4000506.0190448333],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Allegheny',
        GEOID: '42003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8945731.462062927, 4935581.552101138],
              [-8925599.666111436, 4954900.490849439],
              [-8921743.224991884, 4955485.578970552],
              [-8922084.753189638, 4964417.570037108],
              [-8913168.50725506, 4964399.51650388],
              [-8886483.110241588, 4963945.400371323],
              [-8881776.744809829, 4964014.382395445],
              [-8871376.387423994, 4963750.345321573],
              [-8871338.204838654, 4963748.58411987],
              [-8880326.585803265, 4950698.854023973],
              [-8879445.380714145, 4946170.257057699],
              [-8872344.199076952, 4942595.484403779],
              [-8872690.95929077, 4928221.942276038],
              [-8879072.79437846, 4923183.490912919],
              [-8883935.22973631, 4900966.733327871],
              [-8891152.851560874, 4894671.696787847],
              [-8900669.33218981, 4897028.148154015],
              [-8896001.260662884, 4902705.646206291],
              [-8925851.136841137, 4914340.60331918],
              [-8945731.462062927, 4935581.552101138],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ray',
        GEOID: '29177',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10487480.694747392, 4787011.724738138],
              [-10487233.676797323, 4797472.272991861],
              [-10437224.508753352, 4797090.9791907985],
              [-10437144.35871998, 4751369.086528209],
              [-10446237.380005939, 4752582.534665484],
              [-10462795.597663982, 4743580.5455814],
              [-10461815.54086704, 4751204.306756064],
              [-10466726.734161858, 4743831.908109398],
              [-10475700.977551138, 4742248.615182164],
              [-10483348.181290673, 4752347.189602615],
              [-10487689.196153648, 4751378.424608072],
              [-10487480.694747392, 4787011.724738138],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Inyo',
        GEOID: '06027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13221974.077443939, 4503848.310900672],
              [-13117165.668581251, 4504112.925242692],
              [-13100145.581441818, 4488481.196639443],
              [-13051644.458539626, 4443323.24966062],
              [-13042859.521072337, 4435094.248955445],
              [-13024480.053757267, 4417898.504416229],
              [-12967410.780968208, 4363977.68742982],
              [-12954903.145621657, 4352007.16785438],
              [-12923480.547677478, 4322081.132181996],
              [-12901146.963517584, 4300616.831296111],
              [-12895930.412261426, 4295607.434296599],
              [-12873880.035668852, 4274458.163578493],
              [-12883660.452625811, 4272260.834821659],
              [-12943925.70799555, 4272229.818582951],
              [-13052323.284794481, 4272450.7768980265],
              [-13094845.215207187, 4272759.165335657],
              [-13127290.727952266, 4272882.413354372],
              [-13136595.256270733, 4271648.897985657],
              [-13136310.946291244, 4281745.375421774],
              [-13133558.237922909, 4282406.9198455075],
              [-13136098.103424849, 4298381.225171407],
              [-13139441.473011335, 4301852.122450251],
              [-13149853.852902176, 4339170.150769497],
              [-13146867.150964191, 4348354.412101562],
              [-13159613.566618493, 4360647.953273864],
              [-13162307.609615179, 4372914.026121688],
              [-13168040.786030015, 4377749.60576007],
              [-13166270.917445894, 4383127.977049758],
              [-13176479.360029599, 4396211.401027823],
              [-13175840.163513463, 4403590.893144861],
              [-13179087.575698886, 4416058.530473365],
              [-13175867.436788708, 4423469.885923803],
              [-13184361.781853182, 4447447.928073248],
              [-13201674.634339312, 4458380.23052728],
              [-13208568.873043124, 4458893.983086092],
              [-13215406.450126117, 4484954.024081694],
              [-13223278.964515015, 4487078.222893942],
              [-13221974.077443939, 4503848.310900672],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lake and Peninsula',
        GEOID: '02164',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-17509298.21417495, 7671933.231040029],
              [-17496310.012586646, 7678401.270971679],
              [-17487306.38085179, 7674983.644602969],
              [-17474438.181674566, 7666764.150769123],
              [-17482411.32888314, 7662623.208623888],
              [-17495948.22424157, 7664697.739129639],
              [-17513456.776392516, 7663680.283036337],
              [-17509298.21417495, 7671933.231040029],
            ],
          ],
          [
            [
              [-17800003.164448574, 7657440.452238274],
              [-17765258.90421861, 7657441.6621871805],
              [-17765259.460816067, 7674948.677681681],
              [-17730515.200586103, 7674949.890404596],
              [-17730515.64586407, 7692496.907295355],
              [-17705486.237595633, 7692497.920222369],
              [-17705486.79419309, 7710085.162102316],
              [-17687955.42154653, 7710085.771261064],
              [-17687948.852200996, 7721242.458706278],
              [-17683467.79891418, 7717849.592923115],
              [-17671360.6910955, 7718356.133142791],
              [-17661544.649716843, 7721385.507135549],
              [-17660482.327816203, 7728909.254676999],
              [-17664865.198807716, 7742062.72672267],
              [-17664098.09619666, 7757794.076942022],
              [-17647626.707741432, 7787178.3196287155],
              [-17624121.819899414, 7817885.757408987],
              [-17614070.003839254, 7826123.379391658],
              [-17597806.44887334, 7833476.510061466],
              [-17580867.963834744, 7858080.812294097],
              [-17563153.91590379, 7872763.810265859],
              [-17552733.854968086, 7876256.6360636065],
              [-17553333.978342954, 7885827.691078416],
              [-17556105.499705233, 7895701.990012627],
              [-17553230.117258042, 7915753.553163204],
              [-17548652.32583815, 7939802.050275212],
              [-17543573.374070708, 7985967.444968052],
              [-17539115.58506189, 7998566.056032878],
              [-17530607.881658524, 8013116.094791773],
              [-17538075.081781447, 8025846.349679854],
              [-17537388.463162236, 8046998.078007455],
              [-17530758.94220753, 8068997.951722987],
              [-17512066.729910977, 8086964.023369435],
              [-17503242.28211149, 8097991.183062272],
              [-17400782.527396284, 8097990.969299292],
              [-17400782.527396284, 8155751.825366801],
              [-17482224.646097083, 8155751.825366801],
              [-17487776.84718068, 8151624.945183878],
              [-17490169.518154997, 8151810.60141566],
              [-17499011.195626494, 8147898.6923902985],
              [-17499012.738503613, 8199024.483423129],
              [-17507797.516119566, 8199024.266742466],
              [-17507798.851953458, 8236683.523101846],
              [-17489049.866716597, 8236683.740883915],
              [-17489050.534633543, 8255584.931308933],
              [-17451552.67547932, 8255585.80465992],
              [-17451553.343396265, 8274534.86816343],
              [-17441034.98735019, 8274535.087060181],
              [-17441035.655267134, 8293532.748690192],
              [-17422095.311825603, 8293533.187608442],
              [-17422095.757103566, 8312579.521525781],
              [-17384215.626817957, 8312580.181600483],
              [-17384215.84945694, 8331675.482791022],
              [-17365856.705076844, 8331675.923979224],
              [-17365850.137226887, 8604314.770732144],
              [-17270574.01144674, 8604316.83118283],
              [-17193928.426965244, 8604318.662695039],
              [-17080961.073749755, 8604325.301930653],
              [-17080961.29638874, 8584512.789371269],
              [-17076106.653395247, 8505795.74517678],
              [-17090707.874405142, 8505793.712292721],
              [-17090702.419750094, 8427906.787161062],
              [-17105016.770432223, 8427905.893190311],
              [-17105016.436473746, 8350832.431813184],
              [-17119053.045026343, 8350830.220142511],
              [-17119052.822387364, 8331686.291909504],
              [-17137991.607356023, 8331684.527154385],
              [-17137989.71492468, 8293543.28273541],
              [-17156930.28100519, 8293539.551926014],
              [-17156929.613088246, 8274544.499626669],
              [-17189068.329316698, 8274543.405141581],
              [-17189066.65952434, 8236692.669954399],
              [-17226564.407359075, 8236691.363260487],
              [-17226561.401732817, 8199032.500612028],
              [-17220580.31681199, 8199032.500612028],
              [-17220572.63576712, 8124279.798062062],
              [-17214729.364375893, 8105707.735514111],
              [-17177230.948624216, 8105708.591449838],
              [-17176981.147686876, 8064658.304504213],
              [-17182308.78719675, 8055661.333146824],
              [-17191328.560257766, 8055855.824912067],
              [-17195047.633125678, 8043613.3349495],
              [-17206622.856417347, 8043497.0420968635],
              [-17206665.603101812, 8037609.847466078],
              [-17224439.095640846, 8037563.621817294],
              [-17224505.887335323, 8031593.1562704835],
              [-17255426.323056534, 8028677.479130211],
              [-17260948.771675296, 8017102.221976538],
              [-17279174.221346952, 8017144.30377486],
              [-17279157.523423336, 8008011.321884443],
              [-17291473.021328773, 8008030.330779811],
              [-17285709.343373463, 7990163.791724246],
              [-17285773.24076118, 7977381.0985985845],
              [-17291443.299024735, 7977451.986924376],
              [-17291283.778194427, 7941385.797146955],
              [-17304171.792241022, 7940363.41966802],
              [-17304197.50704339, 7931082.755316754],
              [-17314503.354181543, 7925380.082024593],
              [-17331751.530043524, 7925000.098958755],
              [-17331607.70526142, 7912699.540930658],
              [-17337768.125881918, 7912861.378179104],
              [-17340016.890915435, 7897950.022945644],
              [-17354536.626058076, 7897916.511892447],
              [-17348722.965651397, 7889812.455110898],
              [-17357107.327058963, 7874273.995297079],
              [-17360583.16683949, 7883384.035835172],
              [-17373760.722881638, 7880520.0168844545],
              [-17380538.29875909, 7865016.797966805],
              [-17407054.935424525, 7867644.207109792],
              [-17422475.35656717, 7849518.620226298],
              [-17421748.106333822, 7834596.18492424],
              [-17434568.66076899, 7828888.294532454],
              [-17440663.068931453, 7820238.509133294],
              [-17440730.862501346, 7808284.372310613],
              [-17449417.01104845, 7808466.6172992475],
              [-17449420.907230627, 7793482.64532241],
              [-17407506.03557006, 7792737.911615293],
              [-17415156.211367004, 7784589.526024206],
              [-17419174.95630413, 7774110.884432263],
              [-17427124.16982219, 7756973.74081811],
              [-17436844.587758258, 7758873.009831943],
              [-17444233.530279152, 7757478.191087917],
              [-17457788.45939509, 7739231.394653555],
              [-17469994.307602096, 7743802.658973862],
              [-17481014.380593177, 7736545.3751843665],
              [-17485336.80510119, 7727149.317996601],
              [-17497602.320555266, 7713066.155245676],
              [-17509499.591133792, 7720308.009927221],
              [-17522966.689171493, 7714949.8305833675],
              [-17536244.54407484, 7709958.052041318],
              [-17539922.206092183, 7699741.556436415],
              [-17527494.275501035, 7687542.871159344],
              [-17532432.7420711, 7682215.533532795],
              [-17544534.061276257, 7683109.4038311895],
              [-17552254.73587971, 7680720.588158378],
              [-17557204.11175987, 7689540.138431527],
              [-17565307.725411657, 7693106.713672538],
              [-17579411.570936695, 7687526.067497264],
              [-17573996.545626543, 7672094.461245839],
              [-17568200.02842145, 7661468.827501208],
              [-17573910.495660163, 7649856.42199327],
              [-17585330.42826217, 7653911.845508092],
              [-17602666.10124392, 7650701.183428511],
              [-17615880.170079045, 7651772.93367663],
              [-17620172.093046576, 7654789.107292433],
              [-17629885.16389625, 7652016.76320987],
              [-17637283.568573866, 7643987.975047576],
              [-17642975.55677711, 7626774.512058326],
              [-17634687.709368058, 7625642.392924537],
              [-17620580.635577787, 7621599.098665859],
              [-17611565.760574367, 7617237.768228667],
              [-17601592.6473942, 7604487.662259234],
              [-17620004.22325446, 7592974.823202003],
              [-17630149.102408923, 7585241.922126628],
              [-17632442.061280288, 7571310.57988189],
              [-17636510.677349288, 7557311.285468975],
              [-17645234.674523264, 7554359.046889702],
              [-17659524.86887589, 7557369.2072415035],
              [-17661194.99519626, 7550181.480445083],
              [-17671808.863365438, 7550330.626003334],
              [-17688457.361130513, 7548675.471095914],
              [-17710506.52399143, 7541463.476528135],
              [-17709396.66866822, 7525612.730538299],
              [-17743725.15060007, 7501877.094670813],
              [-17759104.94012858, 7494268.6553266775],
              [-17762298.064101987, 7487261.334565088],
              [-17762289.34548221, 7535992.463822381],
              [-17796421.12587383, 7535991.669851491],
              [-17796421.014554337, 7553225.218690808],
              [-17789567.741423137, 7553225.417628287],
              [-17789565.848991796, 7622545.73574772],
              [-17800001.38333672, 7622545.334265312],
              [-17800003.164448574, 7657440.452238274],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lehigh',
        GEOID: '42077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8438884.469643926, 4969292.068372144],
              [-8433320.498855095, 4973393.273563986],
              [-8426300.914404653, 4978486.703645485],
              [-8416753.709596258, 4981031.694991003],
              [-8402558.693408264, 4961695.825459599],
              [-8392077.852030586, 4958317.811393098],
              [-8393980.747406207, 4950756.896472715],
              [-8386088.418147945, 4944295.627730065],
              [-8394573.078416718, 4937110.253195782],
              [-8402846.788250437, 4926938.071303756],
              [-8407927.07585177, 4931112.581418851],
              [-8448200.12991147, 4964854.974760781],
              [-8438884.469643926, 4969292.068372144],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lincoln',
        GEOID: '30053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12918537.071730327, 6275016.142742015],
              [-12857514.287225742, 6274979.152106748],
              [-12824886.099196272, 6274730.402773957],
              [-12771356.254472066, 6274960.9968718],
              [-12766653.537728421, 6270328.106251059],
              [-12770439.068332337, 6264462.731767862],
              [-12767418.413949663, 6248113.950975609],
              [-12771968.486816345, 6242641.726093273],
              [-12758556.491926592, 6232861.295439064],
              [-12767469.620915426, 6221509.202548686],
              [-12761555.884286523, 6217177.101261937],
              [-12789339.336757181, 6217158.057638232],
              [-12789349.244191863, 6202808.437250153],
              [-12785021.587667782, 6202801.034551907],
              [-12784831.78793598, 6144556.7632126445],
              [-12803976.6252821, 6144528.189487392],
              [-12802929.442832207, 6109786.842229956],
              [-12818943.308180273, 6109798.658144691],
              [-12822357.365643412, 6093390.54880331],
              [-12832794.347141718, 6088619.712424458],
              [-12838285.403664079, 6093136.247725636],
              [-12860150.221448237, 6091661.582702083],
              [-12863873.190498328, 6097259.47770978],
              [-12862392.863909759, 6106752.35504588],
              [-12866830.50409074, 6110511.470818867],
              [-12873628.006157054, 6129200.368333345],
              [-12879232.163282057, 6136431.134516834],
              [-12876588.102736734, 6141260.386135285],
              [-12883814.964079035, 6150769.5543547245],
              [-12890816.180813497, 6144004.18768823],
              [-12906019.417629605, 6137548.36631321],
              [-12908302.135107813, 6131686.027164722],
              [-12918507.710967056, 6142886.438044546],
              [-12918509.798455082, 6158558.00897195],
              [-12918532.841589678, 6187293.906860646],
              [-12918533.010867551, 6190786.950896241],
              [-12918537.071730327, 6275016.142742015],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sedgwick',
        GEOID: '20173',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10887917.051958632, 4541896.374588679],
              [-10875768.64460887, 4542065.42529976],
              [-10876133.438580198, 4566906.571838361],
              [-10814964.157625731, 4567105.2369371215],
              [-10815059.335790358, 4505600.407564999],
              [-10887892.227712186, 4505409.643163517],
              [-10887917.051958632, 4541896.374588679],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Posey',
        GEOID: '18129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9802735.48580424, 4560610.321064749],
              [-9800663.815521376, 4564147.382544251],
              [-9797930.922022404, 4573998.929070902],
              [-9799553.180961734, 4583765.438697165],
              [-9794865.071926467, 4587281.935965822],
              [-9791908.426250996, 4593569.745341666],
              [-9788040.964501856, 4600912.9795487905],
              [-9793423.373201203, 4607410.941917633],
              [-9792797.962580297, 4612006.65662663],
              [-9773758.78515257, 4611767.01516721],
              [-9761406.663134659, 4607859.555412093],
              [-9761425.14217013, 4603245.165170259],
              [-9762771.328772292, 4565152.19106408],
              [-9764189.960461585, 4562923.262772751],
              [-9765350.378734991, 4564188.430657557],
              [-9774743.294729145, 4561809.459504815],
              [-9781926.407511564, 4568271.624503114],
              [-9787403.771736555, 4566421.21287278],
              [-9787810.0190502, 4565251.150444555],
              [-9789227.630273711, 4561169.217636688],
              [-9785406.700071724, 4553713.586339126],
              [-9788975.268988086, 4549760.347466392],
              [-9792804.770790862, 4548655.050504405],
              [-9799235.47513501, 4551101.594977435],
              [-9803614.115985872, 4559110.557425391],
              [-9802735.48580424, 4560610.321064749],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Warren',
        GEOID: '29219',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10176363.868683442, 4699536.287970067],
              [-10159565.200925285, 4699326.612650786],
              [-10159493.956451178, 4720634.844208407],
              [-10151045.14105844, 4720545.900775047],
              [-10151151.785130618, 4711957.440104532],
              [-10142339.622919932, 4711921.664094576],
              [-10142458.066858137, 4703454.595809036],
              [-10125457.91082164, 4703190.935745172],
              [-10126117.478804592, 4657066.950648583],
              [-10138681.330493992, 4665866.793900354],
              [-10155292.758868638, 4667608.351080249],
              [-10165587.028779745, 4679983.4661633],
              [-10171171.927632846, 4678693.373395705],
              [-10176676.119855117, 4680184.6120923655],
              [-10176363.868683442, 4699536.287970067],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Elmore',
        GEOID: '01051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9619488.449948564, 3862245.6896277033],
              [-9615218.122962244, 3862641.321392063],
              [-9610956.812854676, 3864567.3866597293],
              [-9609040.559140163, 3862656.9404494287],
              [-9574276.261401858, 3862827.163043443],
              [-9560102.284597622, 3862766.8038952593],
              [-9560802.261555731, 3828206.935817026],
              [-9557070.498265866, 3825923.1077112104],
              [-9576037.89234366, 3818566.401839156],
              [-9578641.655233316, 3816742.473008838],
              [-9594881.165189222, 3820696.6067826883],
              [-9602642.58272631, 3829346.902732988],
              [-9619247.665889978, 3817242.337780327],
              [-9619464.070980081, 3856528.4460331765],
              [-9619488.449948564, 3862245.6896277033],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Middlesex',
        GEOID: '09007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8098735.743020071, 5098107.048622819],
              [-8094545.34342814, 5101890.059259125],
              [-8094473.987634543, 5105373.574162381],
              [-8075586.74359012, 5107606.398219888],
              [-8071267.658666832, 5108247.401504347],
              [-8066959.483053642, 5098851.893415581],
              [-8062956.100206244, 5090025.807602446],
              [-8050951.85159706, 5089067.106382311],
              [-8049014.892457257, 5076907.709632038],
              [-8063283.713467646, 5075083.423293362],
              [-8056859.910931931, 5067998.601698211],
              [-8052853.400975534, 5053411.153015709],
              [-8053814.098344335, 5053351.4196034465],
              [-8058042.68052161, 5051033.837037768],
              [-8060191.2580134105, 5053492.435652324],
              [-8067606.137975659, 5052263.798745931],
              [-8074510.82926441, 5049853.083887883],
              [-8083344.487584013, 5061054.3232789],
              [-8087769.771301517, 5077181.3749417355],
              [-8090560.216977232, 5076538.726657645],
              [-8098063.373295681, 5074979.799582534],
              [-8097907.637328061, 5086031.502340081],
              [-8098368.054741981, 5092957.218841152],
              [-8098735.743020071, 5098107.048622819],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Elkhart',
        GEOID: '18039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9580440.69275347, 5125044.350541037],
              [-9550250.843620889, 5124954.507866062],
              [-9550247.722440865, 5124954.513769283],
              [-9535599.777972143, 5124982.218095689],
              [-9535042.820066677, 5089844.408294806],
              [-9534904.783898093, 5076992.941510568],
              [-9580069.661661213, 5076837.921024472],
              [-9580094.263268678, 5083275.745516059],
              [-9580440.69275347, 5125044.350541037],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morgan',
        GEOID: '17137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10082401.535533639, 4842620.968849814],
              [-10083726.014835097, 4848028.183681915],
              [-10018131.338843632, 4847483.805304745],
              [-10018058.981174618, 4834795.736698329],
              [-10010520.647897078, 4796736.830569794],
              [-10035869.543104088, 4796478.659204884],
              [-10052350.505035521, 4796460.909265929],
              [-10052224.157413471, 4813265.128239878],
              [-10060272.890556298, 4817492.686348957],
              [-10060081.866310095, 4830169.745432903],
              [-10072564.343451727, 4830176.406035807],
              [-10072528.498575693, 4835362.311458374],
              [-10085446.234926324, 4835481.106466754],
              [-10082401.535533639, 4842620.968849814],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henderson',
        GEOID: '37089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9203154.444937648, 4226495.59674833],
              [-9187499.58494739, 4220642.580385857],
              [-9183324.547445187, 4224545.930490439],
              [-9165219.76810155, 4232064.989355803],
              [-9157786.409103831, 4227638.882115828],
              [-9159430.375343865, 4224256.659912458],
              [-9157286.584590169, 4217444.39817906],
              [-9168178.862805817, 4197156.059188346],
              [-9167513.536590606, 4190918.497785217],
              [-9173984.062931197, 4191431.934051699],
              [-9178916.406929266, 4188018.7096391064],
              [-9187482.553065296, 4185049.0335673145],
              [-9192509.201196479, 4183804.41776385],
              [-9197132.617083186, 4205230.826107747],
              [-9211146.739098642, 4221510.266497298],
              [-9203154.444937648, 4226495.59674833],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Switzerland',
        GEOID: '18155',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9484773.05309476, 4709332.102072162],
              [-9477277.466501685, 4711589.239439624],
              [-9477776.177820439, 4707814.414624416],
              [-9447768.561923731, 4707486.987817054],
              [-9447064.969196318, 4709337.9164785845],
              [-9443284.946793051, 4706965.043534132],
              [-9438379.542111756, 4704814.612731231],
              [-9439748.084222708, 4701527.116866793],
              [-9440254.273656204, 4700311.4238385465],
              [-9441326.280352544, 4691076.525756091],
              [-9446227.343573699, 4691667.3505737],
              [-9457986.132705685, 4689926.679294468],
              [-9464500.225091103, 4687141.473422996],
              [-9470163.705762032, 4684720.579015229],
              [-9478505.209165644, 4678137.531218252],
              [-9483004.409025036, 4677022.514971062],
              [-9484616.607192496, 4678424.761320528],
              [-9484773.05309476, 4709332.102072162],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Boyle',
        GEOID: '21021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9465515.449104467, 4527466.788227144],
              [-9465109.578241035, 4532128.463538559],
              [-9464942.042407392, 4534157.463288921],
              [-9439177.48022176, 4539559.2233609725],
              [-9433757.779493, 4538971.851266934],
              [-9423450.262562487, 4530225.272343218],
              [-9424118.402146228, 4527920.955950085],
              [-9424070.98004315, 4525640.75816273],
              [-9445173.147995885, 4515816.845830107],
              [-9450813.261316419, 4513538.302849323],
              [-9466573.206905985, 4515380.051567601],
              [-9465515.449104467, 4527466.788227144],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Keya Paha',
        GEOID: '31103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11154036.40248467, 5311663.913126071],
              [-11154036.27021385, 5311663.913226846],
              [-11115255.274529526, 5311693.458639113],
              [-11080080.320838217, 5311697.490312079],
              [-11048955.390934963, 5311701.05778202],
              [-11049243.039128095, 5282230.984604434],
              [-11066851.890140248, 5277346.9233977785],
              [-11080462.81296005, 5269089.9337884635],
              [-11096069.026332831, 5271101.823115671],
              [-11144566.030413866, 5281531.090339816],
              [-11154043.549221024, 5288576.261929014],
              [-11154036.40248467, 5311663.913126071],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Aroostook',
        GEOID: '23003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7792039.970532978, 5892468.962018766],
              [-7772165.656563692, 5921699.590028331],
              [-7744094.331889844, 5962506.410056957],
              [-7729936.162453299, 5982981.74476713],
              [-7705534.707432432, 6017015.927601337],
              [-7698418.942941947, 6016007.734678566],
              [-7693091.303432071, 6013505.210553717],
              [-7685419.832043542, 6011257.275375754],
              [-7687043.315497272, 6003972.978449552],
              [-7685519.908265765, 5982172.797778116],
              [-7677308.203388419, 5976863.462560269],
              [-7670022.56535498, 5971261.752743949],
              [-7659174.703616157, 5977407.721809223],
              [-7644967.664923157, 5981767.1227464415],
              [-7637053.517044699, 5982880.888761197],
              [-7635261.941159871, 5988179.956601736],
              [-7626212.445794815, 5990627.743696452],
              [-7620939.46415492, 5988892.804379491],
              [-7611538.644476918, 5989910.8144220635],
              [-7612503.339184133, 5995603.728895502],
              [-7609973.937714328, 6000312.255604399],
              [-7599749.353804457, 6000004.6497544795],
              [-7592463.827090508, 5997704.031708163],
              [-7586813.917654788, 5993484.559671172],
              [-7578953.314451401, 5986571.997458447],
              [-7569521.770593942, 5977704.202570077],
              [-7564411.983327549, 5974148.411385207],
              [-7557386.164985623, 5961482.279790654],
              [-7546321.675517716, 5952811.776591942],
              [-7546325.905658366, 5908655.349326453],
              [-7546170.837607691, 5877317.376412807],
              [-7545470.415371619, 5825233.814464723],
              [-7545283.843905051, 5786513.322819559],
              [-7545233.30485623, 5770445.329031196],
              [-7541942.478069399, 5767202.064589546],
              [-7547870.908871085, 5759441.764467203],
              [-7543448.964738305, 5753145.611023495],
              [-7547865.120257564, 5745423.106646645],
              [-7545445.702444663, 5737376.21586906],
              [-7547783.667238135, 5729045.631180825],
              [-7558845.452190432, 5729234.774536894],
              [-7575070.04533457, 5722829.06058999],
              [-7598683.580999603, 5717192.308687458],
              [-7615464.771597705, 5712237.8231593855],
              [-7617926.824775579, 5713488.990442686],
              [-7617325.365566825, 5771474.33083182],
              [-7618361.082109166, 5787225.038766871],
              [-7618309.986462891, 5841797.266957184],
              [-7647078.727746558, 5841876.499360467],
              [-7648104.091576257, 5843955.999579327],
              [-7660940.676018102, 5844002.001059373],
              [-7661164.762153068, 5872573.84867504],
              [-7761318.351422323, 5872823.716893867],
              [-7794926.906502414, 5872731.97451706],
              [-7792039.970532978, 5892468.962018766],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sheridan',
        GEOID: '31161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11442765.447388565, 5311977.362400839],
              [-11400077.657631667, 5311914.920505155],
              [-11363777.267034661, 5311841.044564907],
              [-11364045.87617119, 5279380.907041706],
              [-11362015.07470065, 5228538.878053341],
              [-11359072.010003056, 5175482.260313784],
              [-11355278.687034784, 5175421.350988185],
              [-11355541.178394077, 5162312.86394869],
              [-11362007.504975276, 5162356.909986296],
              [-11430016.144124592, 5161770.694874565],
              [-11432270.697771627, 5161704.929571238],
              [-11437217.068025537, 5174828.780609034],
              [-11438034.375726942, 5225679.056102445],
              [-11440678.770230735, 5227107.124226588],
              [-11440679.104189208, 5279343.896767883],
              [-11442826.457166608, 5279328.728665017],
              [-11442765.447388565, 5311977.362400839],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pinal',
        GEOID: '04021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12490437.487098489, 3853381.53812165],
              [-12490287.65106388, 3928116.793340094],
              [-12490412.885491023, 3936594.9357748367],
              [-12477076.810493989, 3922487.465100671],
              [-12455881.245488476, 3922520.858837889],
              [-12453305.31247152, 3922357.4832184566],
              [-12432818.741302872, 3922497.7093843776],
              [-12421367.973201912, 3922605.8736050385],
              [-12421099.359270629, 3957295.5937930937],
              [-12360913.586017318, 3957324.817668948],
              [-12353647.76285324, 3940799.8837704556],
              [-12351509.426754594, 3932413.8798750145],
              [-12332049.889208002, 3893137.0276852883],
              [-12325915.517348347, 3904585.1675317343],
              [-12315556.793452071, 3914269.7948625186],
              [-12311207.540946776, 3913093.9217531565],
              [-12295128.77633558, 3921152.5922752526],
              [-12295137.013977898, 3833948.667274074],
              [-12295373.345256852, 3830971.185045972],
              [-12338882.902191876, 3830954.023648251],
              [-12340736.260394093, 3830605.2566198255],
              [-12373995.518616872, 3830609.480837423],
              [-12395595.729971416, 3829302.685233596],
              [-12444687.959369723, 3830018.633004283],
              [-12490460.864191554, 3830016.12499977],
              [-12490437.487098489, 3853381.53812165],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Webster',
        GEOID: '19187',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10513355.908506872, 5258117.205043314],
              [-10460883.351451136, 5258048.043327162],
              [-10460868.768597843, 5244956.117812535],
              [-10456427.232234681, 5231948.746662652],
              [-10456415.65500764, 5192474.690369781],
              [-10482366.899979332, 5192476.493873074],
              [-10508284.526464803, 5192362.422964262],
              [-10508300.667790968, 5232143.284197938],
              [-10513350.342532331, 5232155.05618666],
              [-10513349.340656916, 5245062.512431039],
              [-10513355.908506872, 5258117.205043314],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morgan',
        GEOID: '47129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9448335.512090342, 4339920.833030679],
              [-9439654.70687879, 4341550.805555606],
              [-9428848.255990544, 4351766.8841633275],
              [-9414705.782602204, 4332312.16917022],
              [-9399932.9069375, 4323139.070885757],
              [-9400901.386507401, 4320133.461060938],
              [-9388887.56442201, 4307362.626099107],
              [-9400491.730781281, 4298692.963403587],
              [-9418070.525530921, 4294277.047911847],
              [-9426604.945612077, 4288032.084020523],
              [-9431068.189275943, 4299921.5688528465],
              [-9440500.623689331, 4313081.3261704575],
              [-9451887.828361047, 4322148.413614531],
              [-9448335.512090342, 4339920.833030679],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '48159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10609704.040983358, 3945477.3168011517],
              [-10609486.63401784, 3945588.8945163256],
              [-10592432.265389327, 3945953.762475518],
              [-10589316.766800497, 3947112.297703685],
              [-10589392.352734743, 3899894.9128149915],
              [-10592295.11977667, 3897089.3620458567],
              [-10594603.997335212, 3890238.4968812596],
              [-10601087.912395958, 3890287.1890387605],
              [-10609744.561278006, 3890337.075491621],
              [-10609704.040983358, 3945477.3168011517],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nelson',
        GEOID: '51125',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8810312.971305272, 4559116.901984466],
              [-8811760.347324565, 4564039.614386629],
              [-8801192.120146615, 4567791.9871329265],
              [-8794810.73033689, 4562726.03300372],
              [-8783361.854667276, 4572562.8182935305],
              [-8776303.308395054, 4586119.7680861205],
              [-8758949.935614273, 4548683.783640821],
              [-8757377.659126308, 4540615.140983756],
              [-8754600.905747961, 4541787.851389215],
              [-8754350.214254696, 4534835.572157528],
              [-8758298.49395415, 4536603.138356229],
              [-8765234.032189045, 4527505.0213318225],
              [-8774485.015832435, 4527378.515269966],
              [-8774785.355818598, 4516406.427651483],
              [-8779684.192649936, 4514939.204096666],
              [-8792683.192228848, 4536505.5029298635],
              [-8801737.696970992, 4539982.253086289],
              [-8802189.876742596, 4548154.62776291],
              [-8809597.854896415, 4553203.338409472],
              [-8813401.307938349, 4551647.243812319],
              [-8810312.971305272, 4559116.901984466],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Woodruff',
        GEOID: '05147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10175467.746782556, 4192817.7927987343],
              [-10178820.244567288, 4204330.185946228],
              [-10178854.085692488, 4214192.128800762],
              [-10169769.969965793, 4219474.617882406],
              [-10168730.134602295, 4223715.16911993],
              [-10158229.367035765, 4224635.978954397],
              [-10158076.636694398, 4212579.048089062],
              [-10134502.285490124, 4212127.940995204],
              [-10134823.664860046, 4184037.7170809847],
              [-10135130.906654632, 4164022.4768082723],
              [-10146753.997327339, 4164216.812264428],
              [-10156511.262014862, 4164464.289115039],
              [-10162702.6294538, 4161855.255048735],
              [-10162889.534878843, 4151990.076039021],
              [-10171101.573714664, 4152028.4936161106],
              [-10170567.574117329, 4170934.617636566],
              [-10181849.915828718, 4176044.2399173514],
              [-10175467.746782556, 4192817.7927987343],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cherokee',
        GEOID: '37039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9382741.212218596, 4191878.1390697416],
              [-9382365.13281745, 4194714.842433785],
              [-9375741.40047627, 4200508.159084003],
              [-9370709.536853433, 4196636.751215819],
              [-9361691.767543249, 4197550.395162047],
              [-9354077.11515597, 4203650.802504134],
              [-9347334.224898698, 4193556.161818292],
              [-9332071.988752468, 4198741.121659218],
              [-9317749.957025478, 4197705.516314219],
              [-9316351.784221115, 4196263.709601635],
              [-9321685.880261455, 4185094.37342353],
              [-9334220.120966304, 4182997.36099263],
              [-9351431.30908383, 4162202.89849972],
              [-9365247.196600344, 4162243.303862969],
              [-9386667.51981712, 4162305.949129048],
              [-9382741.212218596, 4191878.1390697416],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ohio',
        GEOID: '18115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9477277.466501685, 4711589.239439624],
              [-9476907.440514289, 4714233.626002731],
              [-9472957.045744509, 4712415.384169992],
              [-9461946.434910145, 4721175.969385609],
              [-9448527.897899128, 4726150.69659649],
              [-9445397.011491872, 4721803.785272818],
              [-9443523.727100803, 4716152.550823032],
              [-9448549.245512664, 4710269.808383316],
              [-9447064.969196318, 4709337.9164785845],
              [-9447768.561923731, 4707486.987817054],
              [-9477776.177820439, 4707814.414624416],
              [-9477277.466501685, 4711589.239439624],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kent',
        GEOID: '10001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8433613.760752903, 4764273.743064022],
              [-8428544.22478312, 4764644.3535708655],
              [-8421448.497800974, 4763526.397673462],
              [-8417938.816895245, 4766182.536921111],
              [-8414010.35206515, 4765989.747601618],
              [-8405249.714928852, 4774867.097051192],
              [-8401206.71819258, 4769170.092281342],
              [-8394422.01786771, 4759658.525673732],
              [-8392909.631265795, 4748687.691166522],
              [-8394321.496367525, 4740841.946273468],
              [-8393075.163348604, 4729966.3537593875],
              [-8386909.510712037, 4724531.074729621],
              [-8383098.16617682, 4714177.110662906],
              [-8391335.462346485, 4716211.677508773],
              [-8394654.341644997, 4709706.229925399],
              [-8402854.357975809, 4707993.795778243],
              [-8410745.574039165, 4698156.969537831],
              [-8429457.233108558, 4697324.917876361],
              [-8432246.02245282, 4742194.751838656],
              [-8433167.792510703, 4757069.298658255],
              [-8433613.760752903, 4764273.743064022],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Forrest',
        GEOID: '28035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9957708.343755443, 3689245.285429142],
              [-9951870.972297223, 3689245.285429142],
              [-9923697.567650318, 3689248.286161611],
              [-9923706.918487545, 3632807.194979458],
              [-9922793.096787622, 3621050.4789031576],
              [-9945373.03098064, 3621055.020033948],
              [-9945363.012226468, 3632147.344894845],
              [-9946279.61691366, 3634095.9585267026],
              [-9946158.612627167, 3677857.066005797],
              [-9957647.89727194, 3677815.7466045055],
              [-9957708.343755443, 3689245.285429142],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clarion',
        GEOID: '42031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8871605.037658084, 5037872.745394877],
              [-8861494.667545766, 5059875.8621701915],
              [-8847466.073996507, 5061985.335103915],
              [-8847430.674398435, 5069515.449489892],
              [-8838816.438242378, 5069530.286815832],
              [-8838797.513928944, 5076887.366943181],
              [-8817304.725883015, 5076111.852510928],
              [-8817491.96526653, 5061415.005585883],
              [-8817763.807463046, 5023962.299368423],
              [-8818197.285560196, 5019795.4724806985],
              [-8825965.604905715, 5013712.770912672],
              [-8863345.465399696, 5008679.491746222],
              [-8871129.369473923, 5037551.241543683],
              [-8871605.037658084, 5037872.745394877],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Orocovis',
        GEOID: '72107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7407547.681349078, 2056647.7382304522],
              [-7404104.903457314, 2057025.2218061315],
              [-7402864.693010387, 2067622.4458744363],
              [-7397815.018269022, 2067737.0874430907],
              [-7390607.526518121, 2069573.5505302274],
              [-7389836.193766415, 2071614.064145682],
              [-7389133.099862565, 2071986.7833549175],
              [-7386136.4904899, 2065804.0918330431],
              [-7386232.336571473, 2060291.4135192519],
              [-7388694.055790875, 2057889.1722571165],
              [-7393137.707224362, 2056675.7387903696],
              [-7394246.783311135, 2057693.6261675344],
              [-7396574.585183112, 2058238.3245088041],
              [-7399467.222151377, 2058373.651900888],
              [-7405183.923281573, 2055342.1814391466],
              [-7408002.64410795, 2055479.949833792],
              [-7407547.681349078, 2056647.7382304522],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Goshen',
        GEOID: '56015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11650212.442124663, 5252716.553354062],
              [-11583089.370849859, 5253064.183112941],
              [-11583138.88669801, 5236168.34838086],
              [-11583103.932377899, 5198496.3930867],
              [-11583096.80793049, 5163424.114810856],
              [-11583100.496734697, 5161236.835418615],
              [-11583129.869819256, 5143837.91750163],
              [-11583107.520788291, 5115841.230582752],
              [-11583097.475847434, 5103284.504755136],
              [-11583086.296212759, 5095931.893481068],
              [-11649917.779432533, 5096041.727059859],
              [-11649956.295976348, 5109142.464465732],
              [-11650212.442124663, 5252716.553354062],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hemphill',
        GEOID: '48211',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11192086.20596319, 4308397.233189219],
              [-11131993.495804183, 4308285.148278696],
              [-11131993.183923595, 4284252.34128058],
              [-11131992.71656775, 4248337.957543823],
              [-11192079.192835271, 4248362.743728253],
              [-11192086.20596319, 4308397.233189219],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '19175',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10516419.420893501, 5035610.466263535],
              [-10490931.04236453, 5035546.593638304],
              [-10465611.646822581, 5035491.5925483415],
              [-10465679.996989928, 4997165.602905701],
              [-10516439.013123881, 4997529.513722157],
              [-10516419.420893501, 5035610.466263535],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dubuque',
        GEOID: '19061',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10144853.105702553, 5258220.11619597],
              [-10118653.952224867, 5258200.441918051],
              [-10118603.527518798, 5262530.388163766],
              [-10113653.703337414, 5261092.699336083],
              [-10101539.91634929, 5258177.135518945],
              [-10096773.104434032, 5255284.714444957],
              [-10093641.798477506, 5247746.351026026],
              [-10090315.126814643, 5237454.393795697],
              [-10090747.491716882, 5231932.59826534],
              [-10084478.979870822, 5228249.221172136],
              [-10081677.290926538, 5226929.13185004],
              [-10076363.788991993, 5221542.224671476],
              [-10072671.285049323, 5218313.448117099],
              [-10092784.861037381, 5218397.423052826],
              [-10092842.969811575, 5205226.658458648],
              [-10118721.300516797, 5205307.474138142],
              [-10144553.990230793, 5205386.48454684],
              [-10144853.105702553, 5258220.11619597],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nicholas',
        GEOID: '21181',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9362202.946644973, 4644525.466009695],
              [-9350751.176668596, 4639253.62314531],
              [-9348618.40654449, 4641692.435770236],
              [-9341500.972261637, 4630428.889510829],
              [-9332981.246353267, 4627336.75719802],
              [-9333956.182453634, 4621460.095846947],
              [-9348379.737556228, 4606601.305563837],
              [-9347417.6031973, 4609039.472310321],
              [-9361448.645775357, 4616080.698261117],
              [-9372438.773823414, 4632075.548478755],
              [-9362202.946644973, 4644525.466009695],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Arapahoe',
        GEOID: '08005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11694495.112923246, 4811016.604851385],
              [-11692422.900602128, 4812002.990642033],
              [-11692112.98713976, 4816235.509455609],
              [-11690293.804021217, 4819358.788128266],
              [-11685595.008314831, 4817767.886610459],
              [-11683637.677708214, 4815644.28321336],
              [-11680943.746031016, 4815650.934133346],
              [-11678907.044627463, 4811464.476978675],
              [-11671527.89822176, 4816191.119281493],
              [-11677277.215962758, 4821219.162602551],
              [-11677277.215962758, 4821191.2421287745],
              [-11677206.194127632, 4821096.4866987085],
              [-11677279.219713593, 4821097.210019195],
              [-11677282.114020353, 4820900.324115832],
              [-11677809.100489767, 4822230.428231163],
              [-11676492.302233174, 4821949.028584598],
              [-11675705.384752758, 4828253.993148185],
              [-11650692.674407946, 4828300.463739982],
              [-11647853.470795263, 4828172.633941713],
              [-11644917.196586607, 4828220.40706083],
              [-11635887.738729892, 4828038.725660427],
              [-11544560.003968691, 4828216.064040549],
              [-11544618.446701359, 4803116.165466424],
              [-11545429.186552808, 4803121.364019624],
              [-11648708.070526082, 4803057.681928886],
              [-11650767.592425248, 4803060.425593382],
              [-11677906.05976625, 4803070.96704817],
              [-11693972.245274989, 4803086.273837895],
              [-11694495.112923246, 4811016.604851385],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Stephens',
        GEOID: '40137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10925095.090215804, 4120635.7660310604],
              [-10919228.441731507, 4120630.4865778643],
              [-10872399.33758103, 4120660.944995895],
              [-10860636.429627886, 4120634.2769542667],
              [-10860588.116968881, 4097089.473772109],
              [-10860616.16948056, 4067698.5152140055],
              [-10924808.665165994, 4067778.413927555],
              [-10924816.123571876, 4094690.986070958],
              [-10925133.940718092, 4097083.8001117287],
              [-10925095.090215804, 4120635.7660310604],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wyoming',
        GEOID: '54109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9112161.447885262, 4515896.456391646],
              [-9105437.528002368, 4527500.3827491645],
              [-9106261.292234238, 4531577.367171857],
              [-9094995.425807487, 4537330.368147107],
              [-9101719.45700987, 4545057.274305148],
              [-9084508.907135777, 4549620.330119379],
              [-9081057.780282205, 4546043.201588283],
              [-9074122.353366803, 4549972.771746115],
              [-9067821.558868412, 4548958.583476055],
              [-9052692.126874696, 4522762.653917681],
              [-9041605.150869653, 4510493.017605907],
              [-9051096.91857163, 4503348.20637539],
              [-9049323.376444312, 4497026.029977738],
              [-9051521.491109516, 4498444.21017301],
              [-9068736.382443752, 4506885.212072442],
              [-9089729.679934492, 4512302.930599318],
              [-9107931.084596137, 4509958.917256791],
              [-9112161.447885262, 4515896.456391646],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sussex',
        GEOID: '34037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8346721.282104322, 5028642.699845406],
              [-8338414.955659798, 5035329.843839856],
              [-8334201.401613783, 5045995.958814083],
              [-8328445.961300789, 5056122.495263352],
              [-8322281.31053964, 5062669.863951086],
              [-8314999.791327361, 5065205.282179186],
              [-8288580.336577393, 5049024.026761355],
              [-8278500.831068217, 5042509.631900809],
              [-8293659.622303307, 5025016.174828111],
              [-8297288.192425207, 5020972.16667697],
              [-8309003.010358327, 5007095.922135149],
              [-8308459.659923765, 5003884.607483959],
              [-8316853.038210087, 4997481.649321561],
              [-8323294.317905858, 4999213.312081087],
              [-8325630.134781174, 5002086.250715237],
              [-8344805.69630675, 5025703.559412821],
              [-8347074.061835872, 5027991.828450128],
              [-8346721.282104322, 5028642.699845406],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lewis',
        GEOID: '29111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10235520.047966404, 4897059.781218346],
              [-10235917.569868028, 4903390.036105024],
              [-10185394.71695839, 4902149.341083388],
              [-10186430.436260208, 4895071.041268383],
              [-10187064.343416456, 4890741.301247275],
              [-10185473.253934547, 4877320.8986477805],
              [-10183959.420179248, 4868751.950864722],
              [-10178730.298418727, 4858158.796387854],
              [-10178702.832404815, 4857988.396393196],
              [-10223621.330234494, 4858422.779664671],
              [-10236130.635373406, 4858595.723007589],
              [-10235520.047966404, 4897059.781218346],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dearborn',
        GEOID: '18029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9476907.440514289, 4714233.626002731],
              [-9469456.381717531, 4765775.957195439],
              [-9441994.249536768, 4765475.504976539],
              [-9442136.9088845, 4754272.065357963],
              [-9442136.68624552, 4736791.95953798],
              [-9446648.687846351, 4732870.645759796],
              [-9450709.845509471, 4729181.208202545],
              [-9448527.897899128, 4726150.69659649],
              [-9461946.434910145, 4721175.969385609],
              [-9472957.045744509, 4712415.384169992],
              [-9476907.440514289, 4714233.626002731],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morgan',
        GEOID: '18109',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9645646.74917313, 4803055.371475158],
              [-9646574.15185093, 4808186.037103044],
              [-9625307.11973233, 4808095.594673149],
              [-9625343.409886327, 4812324.291591552],
              [-9610868.87045695, 4812606.576653458],
              [-9609804.322166495, 4812634.328610508],
              [-9601293.279178403, 4812846.517994609],
              [-9601493.542942341, 4770731.997666988],
              [-9615932.905412627, 4770455.638477804],
              [-9641571.008656716, 4770527.462349523],
              [-9643698.546764757, 4771491.448782401],
              [-9643820.107648702, 4785051.747734214],
              [-9649809.096253382, 4789229.485921093],
              [-9645646.74917313, 4803055.371475158],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Boone',
        GEOID: '29019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10304280.984234503, 4721397.55544858],
              [-10289286.026185667, 4757372.238181186],
              [-10276399.90457042, 4757035.729172674],
              [-10253012.013513224, 4756080.599260058],
              [-10253681.377611365, 4730872.421765165],
              [-10259482.570235075, 4702436.025018225],
              [-10256448.557513503, 4695048.43637353],
              [-10265481.354954943, 4680857.552523103],
              [-10265957.023139102, 4670686.435827808],
              [-10281224.713940382, 4675868.548693629],
              [-10285349.435032744, 4684372.772465507],
              [-10283839.720098607, 4694310.986784281],
              [-10296872.226844247, 4710516.91141878],
              [-10303519.002320023, 4717474.322105967],
              [-10304280.984234503, 4721397.55544858],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kingman',
        GEOID: '20095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10961036.146291284, 4504964.867000593],
              [-10961051.842339488, 4541730.282472354],
              [-10887917.051958632, 4541896.374588679],
              [-10887892.227712186, 4505409.643163517],
              [-10887831.781228684, 4493088.7039089],
              [-10948250.100898258, 4492775.3002427695],
              [-10961066.2025538, 4492787.628864762],
              [-10961036.146291284, 4504964.867000593],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Summit',
        GEOID: '49043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12427825.060265375, 4982728.2343179565],
              [-12415306.404289236, 4980701.773065919],
              [-12409847.296460735, 4991461.593405882],
              [-12414894.522173302, 5005535.751478839],
              [-12422473.821023453, 5011311.432528389],
              [-12412959.23282586, 5021673.143244583],
              [-12398815.20096465, 5025219.253947378],
              [-12397273.648656143, 5031538.24568189],
              [-12385960.248806823, 5033611.39353967],
              [-12382381.327177819, 5033439.476571999],
              [-12361655.083267089, 5049527.72928537],
              [-12361664.6586217, 5012040.6214743825],
              [-12305236.363460626, 5011802.714620352],
              [-12258684.778800696, 5011914.071412547],
              [-12250541.08965188, 5011943.023332941],
              [-12245223.773995738, 5011961.927158423],
              [-12245223.135418046, 4984897.9346098825],
              [-12260485.928161731, 4984491.253717392],
              [-12277765.83007859, 4987799.024445995],
              [-12287329.844130093, 4981001.260549872],
              [-12307636.189043147, 4976765.623428357],
              [-12314800.711470604, 4978397.923174628],
              [-12318223.229215043, 4974107.436926043],
              [-12328715.2025418, 4975199.277766317],
              [-12336805.12389622, 4969730.278535589],
              [-12344484.387649102, 4972151.214934259],
              [-12345551.273648866, 4964985.9064198015],
              [-12353801.383750536, 4952486.601885615],
              [-12369918.66490555, 4952120.553171183],
              [-12373312.796179837, 4945950.2109006485],
              [-12397498.402708055, 4957764.089631272],
              [-12400350.074103707, 4966812.673873065],
              [-12410987.096726969, 4953421.649404207],
              [-12418052.767446596, 4954885.094265393],
              [-12423746.20280322, 4963277.620805529],
              [-12423947.691081556, 4970079.803400417],
              [-12428724.187792514, 4978981.772458749],
              [-12427825.060265375, 4982728.2343179565],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Page',
        GEOID: '19145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10618205.62181473, 4997831.13849401],
              [-10567387.717670146, 4997699.0292291455],
              [-10567395.510034503, 4972215.848037086],
              [-10565878.099290261, 4949843.378832046],
              [-10583023.87598595, 4950130.466584783],
              [-10597867.773578208, 4950349.672773114],
              [-10612709.110637324, 4950568.846048424],
              [-10616976.771900179, 4950636.470198723],
              [-10616608.63239981, 4972339.533484306],
              [-10618205.62181473, 4997831.13849401],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '22065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10192100.771138417, 3796126.392623713],
              [-10182659.98776322, 3804932.070523376],
              [-10183144.004909188, 3816697.906818317],
              [-10184085.7678013, 3829514.1387650296],
              [-10181018.247913, 3834115.0438634646],
              [-10144958.525260337, 3834128.9086846123],
              [-10136228.862475296, 3839553.4768197155],
              [-10135563.048917893, 3838845.4733473314],
              [-10135501.648177411, 3838736.233690581],
              [-10131328.789446589, 3831314.550227365],
              [-10136810.272492738, 3830755.481282246],
              [-10135963.242487293, 3821001.5558956694],
              [-10126287.241028054, 3819203.1021746863],
              [-10128589.996014602, 3809573.6806163928],
              [-10121298.34672866, 3808297.2586472784],
              [-10124266.569631172, 3800580.365305164],
              [-10129097.056295164, 3791521.4516207697],
              [-10142152.828814382, 3790664.669202326],
              [-10144986.911730487, 3796084.930767693],
              [-10165778.49830391, 3789915.429574969],
              [-10184922.779052574, 3790033.0419632844],
              [-10192100.771138417, 3796126.392623713],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Benton',
        GEOID: '05007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10532818.562999206, 4369559.360661618],
              [-10504241.068600718, 4369585.1180998795],
              [-10472613.561184434, 4369498.700369426],
              [-10459489.186148442, 4369462.840058897],
              [-10449199.726538556, 4369483.496320534],
              [-10451847.325744465, 4352752.800388159],
              [-10443505.377062889, 4342886.373541487],
              [-10449456.62836019, 4343008.902135822],
              [-10451539.30471344, 4333011.724058735],
              [-10461059.681524554, 4328707.468506056],
              [-10501164.420514174, 4330207.843597853],
              [-10501483.350855295, 4320212.171713901],
              [-10507571.970404236, 4314306.741537631],
              [-10525470.060913056, 4314696.589874889],
              [-10526623.5140636, 4322931.503037883],
              [-10529287.620070733, 4341975.533857764],
              [-10532818.562999206, 4369559.360661618],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Las Animas',
        GEOID: '08071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11705709.32710627, 4480044.33105255],
              [-11701395.585518539, 4480487.213720966],
              [-11688046.152182609, 4491583.835211674],
              [-11660598.439296184, 4495994.262402159],
              [-11654602.437563587, 4500603.946157487],
              [-11654717.764556048, 4506986.499351871],
              [-11649498.884188678, 4508374.7387647545],
              [-11638302.703763163, 4519518.183975951],
              [-11638276.543682825, 4524396.5082379505],
              [-11627869.618447036, 4542879.468909441],
              [-11616312.317593386, 4553674.975153782],
              [-11584032.225611625, 4542015.878096203],
              [-11583705.391586656, 4529263.192514753],
              [-11510918.36329504, 4529196.695167392],
              [-11474360.931199037, 4529174.763788388],
              [-11475492.279603174, 4439087.880954897],
              [-11547532.234372875, 4438830.246844399],
              [-11578100.834781598, 4438547.036624308],
              [-11614945.759524409, 4438205.687930802],
              [-11658716.360665342, 4438193.422915544],
              [-11701993.927781554, 4438469.528570305],
              [-11705805.813057618, 4438476.0021021925],
              [-11705709.32710627, 4480044.33105255],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Norman',
        GEOID: '27107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10781956.075030606, 6023935.890425903],
              [-10694198.651441194, 6023929.756077843],
              [-10694137.203082277, 5966889.118378349],
              [-10708341.79274648, 5966780.428142816],
              [-10778684.370502757, 5966680.578370188],
              [-10779735.278516958, 5981005.6519308705],
              [-10780203.978708588, 5987402.192238324],
              [-10782125.353119679, 6014266.557090678],
              [-10781956.075030606, 6023935.890425903],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Deer Lodge',
        GEOID: '30023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12636700.166051771, 5770753.632859189],
              [-12621231.098291645, 5783335.193596156],
              [-12610050.613914333, 5787606.418876182],
              [-12610776.416994305, 5816122.51049863],
              [-12583201.02065194, 5816210.523111492],
              [-12583201.799888374, 5823211.863798254],
              [-12529965.925084272, 5823050.0311370725],
              [-12534362.26573417, 5818337.412615938],
              [-12532026.114900382, 5809077.588044801],
              [-12543591.987354822, 5802117.473121591],
              [-12554291.571531909, 5802142.212495681],
              [-12554358.029267913, 5788094.795426083],
              [-12562712.111773985, 5788114.202735126],
              [-12572306.961324438, 5779268.875847153],
              [-12570555.79441477, 5769874.2108770935],
              [-12588622.168534081, 5758046.016875274],
              [-12599116.702209126, 5761940.941709461],
              [-12621145.270964246, 5741969.399999082],
              [-12636559.346895916, 5770549.536447841],
              [-12636700.166051771, 5770753.632859189],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cumberland',
        GEOID: '42041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8638998.95414387, 4892915.254756163],
              [-8611684.935965888, 4911688.320529182],
              [-8618449.04218496, 4903121.350525118],
              [-8594386.443694066, 4907743.26586799],
              [-8568730.863289922, 4911141.599501379],
              [-8562135.294779912, 4913792.128921077],
              [-8563157.430344375, 4908052.501847197],
              [-8555907.303228501, 4898886.361599169],
              [-8560919.351981977, 4898562.978760399],
              [-8563061.918221276, 4891709.548283718],
              [-8574812.692349924, 4887449.009109316],
              [-8586898.87210433, 4876111.70821768],
              [-8591427.682948273, 4871284.854328797],
              [-8616530.005483175, 4865139.869955877],
              [-8624041.733402414, 4857819.026257999],
              [-8622151.973726708, 4861936.981203702],
              [-8630876.304859156, 4873028.882159894],
              [-8640024.985890513, 4894836.966756197],
              [-8638998.95414387, 4892915.254756163],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Linn',
        GEOID: '41043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13721257.244422011, 5551758.419468344],
              [-13711319.642159402, 5564123.467429775],
              [-13700487.587788275, 5566665.877736069],
              [-13708886.754688116, 5577583.651046615],
              [-13708309.897086827, 5582079.368370698],
              [-13696973.788061384, 5580324.787572929],
              [-13693059.572126111, 5572363.932702091],
              [-13668097.400830118, 5589203.3692598175],
              [-13657884.50546678, 5586234.511280786],
              [-13650047.501995442, 5588398.2042166395],
              [-13634424.813338023, 5583161.751345564],
              [-13611777.196894605, 5581643.786863874],
              [-13606643.587257182, 5574081.580121747],
              [-13596418.112791384, 5578359.809637999],
              [-13584652.087892497, 5572174.9471496735],
              [-13558715.648413084, 5571820.159722344],
              [-13558034.373129426, 5557838.712393266],
              [-13563932.63634911, 5541756.695255697],
              [-13563516.07881456, 5526404.993810426],
              [-13563316.59428706, 5509754.428600183],
              [-13560876.805007344, 5506138.457787796],
              [-13584221.281463126, 5504809.530691641],
              [-13617396.048192395, 5504653.646994672],
              [-13623787.011478327, 5499094.859436126],
              [-13645211.33803742, 5500775.283499867],
              [-13652980.659258354, 5506795.065728527],
              [-13665885.148589583, 5510514.091866123],
              [-13677320.999878775, 5510013.344602012],
              [-13681610.585137004, 5505630.955803035],
              [-13681806.062162837, 5496559.274219695],
              [-13710712.728295596, 5496456.014527947],
              [-13712378.067877866, 5509454.779422127],
              [-13719646.11743176, 5516979.929628757],
              [-13716195.76981462, 5544346.083356036],
              [-13721257.244422011, 5551758.419468344],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Providence',
        GEOID: '44007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7992655.05878302, 5162187.6185051715],
              [-7971220.7601210065, 5162942.720456199],
              [-7969484.41078798, 5163003.892363101],
              [-7965960.3109323215, 5163128.048257577],
              [-7959145.889764447, 5163357.605568055],
              [-7954677.189378485, 5163508.145617763],
              [-7946141.211430468, 5163795.709332947],
              [-7946144.589631155, 5158745.379234222],
              [-7946147.890599917, 5153813.091707264],
              [-7946174.4959582165, 5144994.573543393],
              [-7941454.3269096, 5145024.4824738065],
              [-7941487.611437347, 5135846.984625258],
              [-7940352.041311765, 5128469.403246586],
              [-7939016.876222088, 5127671.667311579],
              [-7944338.503596563, 5121462.831053733],
              [-7945793.004063266, 5124394.30955906],
              [-7948142.401916459, 5126329.475498395],
              [-7954491.397754364, 5120976.526319349],
              [-7991592.339659082, 5119903.945383535],
              [-7991934.265080134, 5132112.829167103],
              [-7992655.05878302, 5162187.6185051715],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Osceola',
        GEOID: '12097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9090045.493329873, 3292805.806183544],
              [-9051340.040339522, 3292926.348708013],
              [-9027417.815726522, 3292933.179061825],
              [-9001617.742623327, 3292855.00966466],
              [-9002282.653941836, 3226616.245073643],
              [-9003650.881803175, 3224935.726603954],
              [-9002757.876848033, 3203948.8891314026],
              [-9032704.378344294, 3204068.2689531012],
              [-9033126.2792144, 3212527.399292514],
              [-9040047.011957018, 3226440.4052342325],
              [-9050481.878384998, 3231596.460623603],
              [-9051242.63578508, 3239128.21027662],
              [-9063630.491359537, 3249199.973889494],
              [-9068037.852639023, 3255486.4781486816],
              [-9059095.44662411, 3250448.8459768244],
              [-9055442.942811692, 3259655.0844913595],
              [-9067613.50274012, 3259680.6983291255],
              [-9067664.26442792, 3267035.3880266496],
              [-9075235.436955245, 3266990.1923062047],
              [-9078934.806273285, 3281712.931619385],
              [-9090034.917978248, 3282363.944151245],
              [-9090045.493329873, 3292805.806183544],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Randolph',
        GEOID: '17157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10041451.233823158, 4591774.936733772],
              [-10022746.867570903, 4598618.542617738],
              [-10022796.293424817, 4610994.020006236],
              [-10007515.689562604, 4610658.199657107],
              [-9985720.78041866, 4610466.77278374],
              [-9973424.540785126, 4610447.927843315],
              [-9973679.128460573, 4573114.536894273],
              [-9981282.361001244, 4555659.268363456],
              [-9983935.814780165, 4550704.699344508],
              [-9984975.27378882, 4553230.956822708],
              [-9994490.418583864, 4558975.348742709],
              [-10002172.910601981, 4565870.273290496],
              [-10010203.164709335, 4561172.1790170595],
              [-10011306.428907353, 4562501.65023269],
              [-10015884.466241462, 4568020.161370043],
              [-10013734.775554752, 4574715.2234243],
              [-10019684.023101218, 4575213.961825453],
              [-10027766.486049753, 4581605.5011500325],
              [-10032781.095151518, 4586572.122990623],
              [-10041451.233823158, 4591774.936733772],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chatham',
        GEOID: '13051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9060482.376159903, 3775903.746220116],
              [-9038625.573379079, 3794526.0693293125],
              [-9033308.973473798, 3793167.2257594843],
              [-9030165.959995735, 3786585.7945008427],
              [-9029495.037424723, 3778179.7329257946],
              [-9021138.394570364, 3774403.610343665],
              [-9017629.604220558, 3776595.7350818026],
              [-9010558.70148486, 3770903.3213275825],
              [-9004134.564990671, 3767853.2722187866],
              [-8999416.065734418, 3766491.0863694903],
              [-9000007.28355002, 3761772.1620749733],
              [-9006994.362709152, 3755931.695772228],
              [-9010350.86799555, 3751893.8369832207],
              [-9016914.04253374, 3744520.7058943794],
              [-9020983.43783918, 3738752.3756969743],
              [-9025456.700257216, 3732012.4053821648],
              [-9031420.864615448, 3726964.434899607],
              [-9031940.124421326, 3725377.4101308044],
              [-9034103.330385093, 3725705.2568328585],
              [-9036585.30975182, 3739196.7313752687],
              [-9032288.600046182, 3744386.1068066293],
              [-9049197.362780735, 3760530.875241513],
              [-9060482.376159903, 3775903.746220116],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rock Island',
        GEOID: '17161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10138038.794393135, 5062569.931872037],
              [-10137315.885619923, 5066937.365438967],
              [-10133166.896878567, 5075025.227605176],
              [-10126362.493003828, 5075982.531935463],
              [-10121651.563472947, 5074914.923986714],
              [-10115299.562008793, 5078679.767161081],
              [-10106282.683254538, 5079373.799219314],
              [-10096806.834239742, 5079649.3169268025],
              [-10087609.395271419, 5084149.1684727175],
              [-10082332.740088329, 5088801.428639927],
              [-10075875.986983337, 5089277.33448413],
              [-10070120.546670344, 5089872.064033856],
              [-10065044.155251188, 5095732.115872692],
              [-10059288.714938194, 5098217.023072545],
              [-10056550.25546468, 5101044.944557122],
              [-10056238.672209948, 5110859.675642098],
              [-10053784.967993883, 5115375.508052504],
              [-10053469.917183345, 5120401.3301130785],
              [-10053342.027740017, 5122442.228229105],
              [-10046431.647710042, 5128052.157416316],
              [-10045734.481279334, 5128494.591740493],
              [-10044329.713084884, 5112475.550283988],
              [-10036702.546853691, 5107789.771734337],
              [-10039416.07076127, 5098964.10880378],
              [-10040632.347517677, 5092339.543556033],
              [-10055785.379243439, 5088454.8840865325],
              [-10066836.399052959, 5079959.896468772],
              [-10067041.33823551, 5060691.875589861],
              [-10138321.058729379, 5061779.674862213],
              [-10138038.794393135, 5062569.931872037],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Presidio',
        GEOID: '48377',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11686404.066276273, 3584636.56397558],
              [-11566207.526106825, 3556643.8225846193],
              [-11555038.841595536, 3556687.3226688863],
              [-11554160.86477165, 3439464.1061689965],
              [-11554281.091038875, 3408682.831923076],
              [-11561296.4441315, 3411568.6227647658],
              [-11574470.215310955, 3413376.586644149],
              [-11583415.960910594, 3417831.2596740737],
              [-11593222.762771519, 3424519.7696547955],
              [-11597406.260555021, 3430012.698772653],
              [-11602728.222770864, 3437016.560713525],
              [-11611603.948410794, 3442553.165093651],
              [-11618546.054495644, 3444949.0396670448],
              [-11627576.95950574, 3452705.090953422],
              [-11637312.962170519, 3461979.762696103],
              [-11640199.142608317, 3474078.864766314],
              [-11646138.148761628, 3483570.328732495],
              [-11652070.14178702, 3492129.2292473717],
              [-11653534.215729933, 3502257.17541873],
              [-11655595.741379933, 3506662.193015401],
              [-11654270.594161531, 3517350.2425643126],
              [-11655461.044796074, 3530795.67020565],
              [-11659653.336819349, 3536944.022673883],
              [-11662011.751551297, 3542318.6426791013],
              [-11668989.257234218, 3551259.2328482363],
              [-11672908.482546577, 3553833.157697999],
              [-11674060.750595778, 3562641.668784778],
              [-11676231.92594421, 3572524.7592432178],
              [-11680174.862308107, 3581534.6970602353],
              [-11685437.49123536, 3582236.7532512634],
              [-11686404.066276273, 3584636.56397558],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Valley',
        GEOID: '16085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12936761.96480453, 5515777.6423018025],
              [-12930014.333870094, 5515800.360734156],
              [-12930540.541103076, 5542979.89461266],
              [-12933495.962264147, 5556212.912306403],
              [-12930607.889395004, 5574733.0840621935],
              [-12936572.832989672, 5587089.983328187],
              [-12934992.09622041, 5600170.3442411255],
              [-12922981.50240025, 5631542.247079241],
              [-12929133.90801741, 5638484.88385963],
              [-12926604.283908626, 5646516.412219499],
              [-12910462.623785129, 5656099.938960254],
              [-12910365.553189157, 5652317.210664427],
              [-12767677.78836321, 5652617.356504542],
              [-12771937.873956379, 5645349.219440961],
              [-12770938.670207016, 5604405.770734406],
              [-12780858.683990076, 5591399.780640387],
              [-12796856.296692487, 5577702.248289669],
              [-12811974.151459161, 5584871.725394938],
              [-12818654.99069912, 5578894.573636773],
              [-12820442.89304075, 5566215.701886701],
              [-12833046.374468874, 5560475.843911883],
              [-12835693.218001464, 5555619.31220694],
              [-12829252.383583656, 5546225.025480315],
              [-12827146.998054283, 5531218.677156937],
              [-12834537.72168703, 5518123.229868819],
              [-12841536.378073202, 5519137.16099487],
              [-12846425.97538681, 5505707.739898772],
              [-12859659.52513282, 5501936.599994162],
              [-12924534.854574777, 5502100.205997344],
              [-12925583.26153907, 5488349.185560025],
              [-12936868.942835184, 5488899.636648674],
              [-12936761.96480453, 5515777.6423018025],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Juan',
        GEOID: '08111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12019040.186522605, 4536637.6064123325],
              [-12008363.645480113, 4540286.377876239],
              [-12007014.341932207, 4547762.2500589425],
              [-12004662.161091745, 4547930.832637549],
              [-11993370.802501602, 4566075.126284031],
              [-11988626.588442974, 4564238.0835750215],
              [-11982606.764339346, 4574483.936691778],
              [-11974512.390205296, 4574484.783886511],
              [-11968687.263891065, 4554938.086193588],
              [-11962182.532085542, 4548688.854202539],
              [-11964861.435631482, 4528623.823294842],
              [-12019174.994425954, 4528635.913026955],
              [-12019040.186522605, 4536637.6064123325],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mohave',
        GEOID: '04015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12773170.40335844, 4310331.224727834],
              [-12772371.463373018, 4314991.629370755],
              [-12764620.621187553, 4316779.623702299],
              [-12760314.449325198, 4320041.793509452],
              [-12754100.150071153, 4321502.777301462],
              [-12747386.471581412, 4321412.614632111],
              [-12744638.327312198, 4318440.700348345],
              [-12740365.885255553, 4318029.16286322],
              [-12736836.612119444, 4320696.440928552],
              [-12731844.600874308, 4320331.548333437],
              [-12727967.009051505, 4315494.955176537],
              [-12725611.043348357, 4309308.551330707],
              [-12720550.014018934, 4305537.50274058],
              [-12714209.812420802, 4302769.909485565],
              [-12707311.900173796, 4304001.72953944],
              [-12705806.63801929, 4307938.711339049],
              [-12701539.427978711, 4317373.712172701],
              [-12695635.932742963, 4327357.929867772],
              [-12695790.444196183, 4337681.36942178],
              [-12695718.977083094, 4345512.686205587],
              [-12695931.485991018, 4384060.480835881],
              [-12696005.8224851, 4417265.235328801],
              [-12696054.716667328, 4439161.984687457],
              [-12686626.735033574, 4439110.271928755],
              [-12575370.028433105, 4439137.313070294],
              [-12567880.4416952, 4439148.774719873],
              [-12560122.702906163, 4439160.646747587],
              [-12528462.555361109, 4439209.097878662],
              [-12527736.418322666, 4439210.509727913],
              [-12526704.26400403, 4432479.190393853],
              [-12534617.076048596, 4415705.538897133],
              [-12538880.389906997, 4393829.827427787],
              [-12536906.36137676, 4382934.969319083],
              [-12541260.400620157, 4375674.472914417],
              [-12537136.904042192, 4366142.478680092],
              [-12537857.475106098, 4354641.100966802],
              [-12543655.105506102, 4347735.950868997],
              [-12548377.278305553, 4348334.372018443],
              [-12555996.540852897, 4339913.099466374],
              [-12564078.001926016, 4339546.4520268645],
              [-12568298.791738937, 4335594.908433581],
              [-12580108.565197704, 4333562.953919908],
              [-12594362.135437855, 4323545.28729595],
              [-12601004.680772983, 4321687.378751503],
              [-12604140.328189647, 4313169.904103536],
              [-12614721.468428528, 4313944.819721752],
              [-12618529.151611112, 4306177.36919788],
              [-12614404.319199257, 4295309.307638718],
              [-12616377.791132042, 4288774.967657387],
              [-12613669.721879514, 4281972.158651597],
              [-12616285.841232646, 4273552.478739953],
              [-12616301.092002885, 4235872.819360153],
              [-12616294.8581114, 4233189.298980967],
              [-12616228.400375396, 4071565.4244135185],
              [-12620347.110215258, 4068073.8958562943],
              [-12639161.996590663, 4070015.5373767526],
              [-12646572.423773281, 4059637.705593897],
              [-12654700.527713044, 4057038.7753526196],
              [-12673914.160504472, 4062590.8833004795],
              [-12693887.548820563, 4063742.953777724],
              [-12706097.644008636, 4069577.633544335],
              [-12706110.206270684, 4069953.81583636],
              [-12709662.96781935, 4075218.8766403175],
              [-12719845.584281195, 4082818.852477109],
              [-12727755.39069951, 4089392.4047483965],
              [-12732595.5621592, 4089438.033127476],
              [-12732525.542199492, 4098370.8486517835],
              [-12737441.299593432, 4107046.4265000955],
              [-12742212.898246793, 4121995.51108142],
              [-12745076.59214745, 4126551.6701325886],
              [-12754592.29353995, 4138809.393841907],
              [-12761041.031641604, 4146620.7913056817],
              [-12760527.514830576, 4156143.1992061157],
              [-12760941.400697347, 4164133.505810317],
              [-12760004.313223846, 4173190.9290106986],
              [-12759429.45937339, 4180422.75668181],
              [-12757115.683757253, 4180343.5475698584],
              [-12754179.854826562, 4182749.3344816417],
              [-12755780.85174315, 4199594.406890517],
              [-12760234.521930808, 4219671.295674917],
              [-12764393.752065318, 4225135.016584028],
              [-12764238.461375661, 4235387.792288965],
              [-12763158.773634456, 4247197.853693041],
              [-12767166.386622507, 4252761.605177897],
              [-12768046.033238756, 4264038.580255761],
              [-12768758.589299321, 4275138.455089337],
              [-12764971.166264063, 4282072.9832398975],
              [-12768375.761570482, 4287113.7548166085],
              [-12771814.198002107, 4292907.041703163],
              [-12773107.730485125, 4301992.352090824],
              [-12773165.643992241, 4309697.747159225],
              [-12773170.40335844, 4310331.224727834],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Alfalfa',
        GEOID: '40003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10969941.591268469, 4438901.087390221],
              [-10948725.323804457, 4438822.580756489],
              [-10947954.523131495, 4438823.724905764],
              [-10921776.231371783, 4438862.583110307],
              [-10921485.667046323, 4384960.7534368085],
              [-10920919.162157677, 4382607.196926517],
              [-10920934.85820588, 4364532.443648541],
              [-10968712.070459444, 4364549.745638428],
              [-10969941.591268469, 4438901.087390221],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lyon',
        GEOID: '19119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10753343.476136098, 5388459.406534906],
              [-10737127.788551223, 5388449.124315824],
              [-10708766.253964875, 5388440.683696749],
              [-10692589.175821044, 5388418.079473969],
              [-10671191.71812042, 5388388.180902283],
              [-10671299.452948583, 5351258.553616236],
              [-10745784.771391742, 5351588.568008863],
              [-10748901.755284224, 5351256.975508796],
              [-10751105.397773698, 5356384.956822243],
              [-10745714.083515089, 5357752.158790209],
              [-10745034.700662777, 5364971.577001515],
              [-10744732.245606292, 5370855.617465594],
              [-10752823.168836128, 5378289.5749818245],
              [-10751748.824430482, 5383726.648233098],
              [-10753343.476136098, 5388459.406534906],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gibson',
        GEOID: '18051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9792660.723369775, 4613015.40785597],
              [-9785934.131819103, 4617437.0879908325],
              [-9777410.398409061, 4622920.044606688],
              [-9771624.45655559, 4631946.623080576],
              [-9768408.430357415, 4638765.306204023],
              [-9751511.362278553, 4643294.705297318],
              [-9739862.222845, 4649689.077949898],
              [-9736324.60074708, 4655070.745207179],
              [-9736279.405033818, 4645411.312793404],
              [-9730167.631030796, 4632608.16382838],
              [-9719997.037073957, 4633456.344387177],
              [-9720072.066410752, 4614246.800830848],
              [-9720087.317180991, 4607966.08096534],
              [-9736753.403425615, 4607899.927334045],
              [-9736813.515950643, 4602818.131783849],
              [-9761425.14217013, 4603245.165170259],
              [-9761406.663134659, 4607859.555412093],
              [-9773758.78515257, 4611767.01516721],
              [-9792797.962580297, 4612006.65662663],
              [-9792660.723369775, 4613015.40785597],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bond',
        GEOID: '17005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9978597.334883308, 4721546.810071514],
              [-9972706.196111038, 4725730.271498076],
              [-9935313.97915358, 4725709.92308723],
              [-9936083.864751903, 4721552.682899126],
              [-9936011.952360852, 4709847.157375691],
              [-9935730.425368635, 4684784.946649933],
              [-9961050.822786001, 4684572.863253002],
              [-9973928.150161475, 4684958.784111734],
              [-9974181.06804456, 4703714.973984221],
              [-9978448.834682591, 4709982.936028264],
              [-9978350.650891712, 4709984.652945928],
              [-9978597.334883308, 4721546.810071514],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Campbell',
        GEOID: '46021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11187536.936309379, 5771320.805222123],
              [-11164691.035876421, 5771262.693771744],
              [-11148878.99276516, 5771137.346818587],
              [-11118623.245723477, 5771007.039091459],
              [-11118597.652794415, 5771006.865530876],
              [-11100565.109246481, 5770884.57718513],
              [-11100497.53831557, 5715433.442677681],
              [-11179825.254608238, 5715655.370030927],
              [-11177193.550526394, 5724439.532943556],
              [-11166329.992739368, 5730751.585116773],
              [-11175033.729766022, 5759403.874482942],
              [-11187536.936309379, 5771320.805222123],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Blaine',
        GEOID: '16013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12801372.639753463, 5452206.009633841],
              [-12798552.249134723, 5455900.162362604],
              [-12787645.27674629, 5464351.089662935],
              [-12781021.878363581, 5464349.851791693],
              [-12781012.638845846, 5454271.52901134],
              [-12766249.22533786, 5454261.173211411],
              [-12753022.466080785, 5441389.276047964],
              [-12746947.538829215, 5449839.385081447],
              [-12730418.264238775, 5445991.385818413],
              [-12722981.120378368, 5447981.369546579],
              [-12721115.517032161, 5439347.478338381],
              [-12698216.429859042, 5424477.152624519],
              [-12693730.143060582, 5430436.002045329],
              [-12687579.963833235, 5420393.791841174],
              [-12669644.724074077, 5403757.560996763],
              [-12667984.505188385, 5399017.747465302],
              [-12657154.45456809, 5401374.287852447],
              [-12649715.195637356, 5388001.628641234],
              [-12649815.939776525, 5368084.481485631],
              [-12619390.096552907, 5368025.373741577],
              [-12619395.439888466, 5355403.613551247],
              [-12579917.095673539, 5355418.905624119],
              [-12579960.955552911, 5328872.252574971],
              [-12606206.30661928, 5328874.234890494],
              [-12605478.833746944, 5275847.842000939],
              [-12599014.956194542, 5275869.524358078],
              [-12598987.794238789, 5262703.291518219],
              [-12605481.616734214, 5255104.525506288],
              [-12612988.112637386, 5255633.301320856],
              [-12620637.654086227, 5264547.378053164],
              [-12631664.96284421, 5261778.507204552],
              [-12631662.51381541, 5289046.796283999],
              [-12625092.771427266, 5289041.937467228],
              [-12625173.923336053, 5342442.070126314],
              [-12658656.0431794, 5342430.464336761],
              [-12732162.529340014, 5342408.627166663],
              [-12734349.289417157, 5361796.209120081],
              [-12749920.882428301, 5362854.595554941],
              [-12751263.172848288, 5378487.6378479265],
              [-12746998.189197525, 5385552.448376668],
              [-12756734.74845976, 5393183.988918912],
              [-12755737.882419705, 5397421.400192707],
              [-12766381.361573434, 5402265.06154239],
              [-12764583.217838649, 5424980.34279078],
              [-12769976.201889617, 5436806.435151824],
              [-12784796.4996574, 5437070.551268821],
              [-12800545.647256361, 5443580.506701542],
              [-12801372.639753463, 5452206.009633841],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henry',
        GEOID: '17073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10067041.33823551, 5060691.875589861],
              [-10066836.399052959, 5079959.896468772],
              [-10055785.379243439, 5088454.8840865325],
              [-10040632.347517677, 5092339.543556033],
              [-10039416.07076127, 5098964.10880378],
              [-10003431.154806416, 5098867.668974551],
              [-10002924.317164836, 5046989.617252483],
              [-10004048.310063375, 5044288.04610306],
              [-10004102.745294373, 5034337.380926755],
              [-10017035.287137281, 5034398.141041884],
              [-10067473.925776733, 5034676.96241539],
              [-10067041.33823551, 5060691.875589861],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Camas',
        GEOID: '16025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12810988.862646148, 5404424.729269394],
              [-12805507.824877959, 5406613.655905183],
              [-12806454.708466649, 5426154.457197406],
              [-12800545.647256361, 5443580.506701542],
              [-12784796.4996574, 5437070.551268821],
              [-12769976.201889617, 5436806.435151824],
              [-12764583.217838649, 5424980.34279078],
              [-12766381.361573434, 5402265.06154239],
              [-12755737.882419705, 5397421.400192707],
              [-12756734.74845976, 5393183.988918912],
              [-12746998.189197525, 5385552.448376668],
              [-12751263.172848288, 5378487.6378479265],
              [-12749920.882428301, 5362854.595554941],
              [-12734349.289417157, 5361796.209120081],
              [-12732162.529340014, 5342408.627166663],
              [-12756613.076256322, 5342210.873306234],
              [-12811332.171955755, 5342167.963563269],
              [-12810988.862646148, 5404424.729269394],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cibola',
        GEOID: '35006',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12138928.606439183, 4158408.3276939187],
              [-12138928.632619632, 4158421.980685238],
              [-12074758.59729089, 4158321.804847167],
              [-12074678.55857701, 4204621.798174337],
              [-12074682.120800715, 4205633.22582317],
              [-11992918.956688473, 4205405.288453907],
              [-11992920.849119816, 4211293.885093778],
              [-11981128.998099066, 4211316.950101579],
              [-11981181.874857193, 4205316.079059787],
              [-11945626.20685884, 4205500.7733138725],
              [-11937778.628035877, 4205476.219985262],
              [-11933142.616522301, 4193744.883714015],
              [-11918595.162826454, 4158064.956841336],
              [-11933770.235811394, 4158116.8421057174],
              [-11933643.442911379, 4106782.2354815877],
              [-11991869.213890292, 4106697.7335240897],
              [-12138960.659257174, 4106854.4361904655],
              [-12138928.606439183, 4158408.3276939187],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crawford',
        GEOID: '18025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9649331.980915843, 4635344.234201468],
              [-9641913.65004938, 4635442.806551209],
              [-9607859.236703863, 4635245.094665721],
              [-9607837.64072265, 4639337.313613467],
              [-9601867.687750898, 4639310.316613691],
              [-9601687.572814794, 4620676.161027239],
              [-9609240.266306644, 4600272.014573937],
              [-9613151.283807082, 4598553.699522276],
              [-9616580.896168534, 4597047.12620724],
              [-9621741.48565283, 4591743.71703642],
              [-9624796.942506023, 4596545.495059239],
              [-9624749.965680908, 4607926.983692992],
              [-9624730.48477002, 4608684.5905638],
              [-9637115.89131568, 4608785.741242329],
              [-9636943.45742444, 4617117.646169007],
              [-9649119.026729954, 4616657.99627345],
              [-9649331.980915843, 4635344.234201468],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Saline',
        GEOID: '29195',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10405837.978324188, 4763699.290100304],
              [-10397143.926093234, 4754158.827203445],
              [-10389819.548876999, 4757547.181304663],
              [-10389698.767229488, 4766117.5060813315],
              [-10378324.920896668, 4768746.554306618],
              [-10375055.356132578, 4779388.618569502],
              [-10364343.860769976, 4776776.951096649],
              [-10360829.504445633, 4769846.523568243],
              [-10348237.711564042, 4766537.624224881],
              [-10342879.68183318, 4753800.870789806],
              [-10335928.336230595, 4754127.356419267],
              [-10346462.0543664, 4739124.528501855],
              [-10345428.898172347, 4730921.59834618],
              [-10358108.410812682, 4717721.457472292],
              [-10358329.046043435, 4711398.347033977],
              [-10407969.078655934, 4713486.767788385],
              [-10405837.978324188, 4763699.290100304],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Philadelphia',
        GEOID: '42101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8376791.682193836, 4864515.3664612435],
              [-8372407.809326906, 4867199.644230273],
              [-8372160.791376836, 4867371.723181646],
              [-8372036.224866637, 4867474.7685095845],
              [-8371908.76404968, 4867588.715506271],
              [-8371868.132435541, 4867632.318019607],
              [-8371925.461973297, 4867675.048668611],
              [-8378398.133765474, 4873806.188673562],
              [-8373853.9608318005, 4879452.470725213],
              [-8364482.752138351, 4875153.567424447],
              [-8361134.9297722345, 4872620.6934015],
              [-8361130.143034129, 4872633.6353592],
              [-8359730.077798424, 4875972.643323499],
              [-8350638.948943809, 4886015.209822526],
              [-8344944.289072788, 4883054.05117855],
              [-8345940.014805582, 4872702.615629669],
              [-8347839.041111376, 4871365.69459416],
              [-8355531.551883664, 4864854.203406216],
              [-8355655.447217773, 4864781.408174961],
              [-8362233.319187893, 4860917.31787202],
              [-8363685.442424065, 4858816.1978773],
              [-8364070.09078598, 4858259.713258873],
              [-8363944.1018814165, 4854623.543040126],
              [-8363814.055957157, 4850871.677773931],
              [-8364706.339756507, 4850538.739846181],
              [-8369335.836658973, 4848811.514193849],
              [-8372472.047516404, 4846564.047832595],
              [-8378186.292774496, 4848020.640799049],
              [-8375107.195659151, 4856857.713983796],
              [-8379739.644949025, 4862594.588870943],
              [-8376791.682193836, 4864515.3664612435],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Essex',
        GEOID: '50009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8012144.429953144, 5587975.650631072],
              [-8001025.282615257, 5602081.31098447],
              [-8007045.106718886, 5606939.240736149],
              [-8003616.634701805, 5622792.390031265],
              [-7980705.579363307, 5623319.353211195],
              [-7971570.924587792, 5623522.480083791],
              [-7959464.707325042, 5623627.666960074],
              [-7962861.844225582, 5617747.58774484],
              [-7958720.53652909, 5607652.688212842],
              [-7961836.3690763945, 5602777.093664973],
              [-7967180.706509888, 5590918.0933762165],
              [-7973471.036976144, 5581814.474638847],
              [-7968758.326333411, 5568990.811710038],
              [-7965101.25842187, 5563083.70944099],
              [-7964344.285884475, 5555528.822075164],
              [-7969148.167190169, 5550618.387673757],
              [-7968246.256675761, 5543424.706768158],
              [-7975657.574414306, 5538289.776298536],
              [-7980596.708901311, 5530862.211317896],
              [-7988642.049172265, 5528109.1909404695],
              [-7990358.649007446, 5527521.898382242],
              [-7994836.475524605, 5520223.752013585],
              [-7996946.272243402, 5519418.221115346],
              [-8007576.991245895, 5533970.651330541],
              [-7999044.2409571, 5542550.710511948],
              [-8004835.080868166, 5550498.113127036],
              [-7997496.34343762, 5560513.685840647],
              [-8005015.975040706, 5566124.949640649],
              [-7996890.988046686, 5577021.549420522],
              [-8008317.04322069, 5585233.296048371],
              [-8012144.429953144, 5587975.650631072],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pennington',
        GEOID: '27113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10742424.703881636, 6135869.234733762],
              [-10641451.803160144, 6135670.258271632],
              [-10641284.712604465, 6113072.293262213],
              [-10640238.309391009, 6110275.468844022],
              [-10640156.823523749, 6095876.152562982],
              [-10654346.05109822, 6096181.71116745],
              [-10654370.652705686, 6100922.668054705],
              [-10740388.336436555, 6100800.475576637],
              [-10742431.160412105, 6110458.378130243],
              [-10742424.703881636, 6135869.234733762],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calhoun',
        GEOID: '12013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9504897.613279348, 3576623.990368559],
              [-9481291.5360202, 3576298.1952105835],
              [-9480823.548880905, 3581941.7244766494],
              [-9454644.766870031, 3581736.5923875463],
              [-9461045.414951663, 3571187.2921643252],
              [-9460286.883941399, 3560471.2431163047],
              [-9466917.852049481, 3548936.996059918],
              [-9465973.862767555, 3543779.54606942],
              [-9475031.929733401, 3529280.8798892954],
              [-9505535.585281085, 3529409.2951422096],
              [-9504897.613279348, 3576623.990368559],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hughes',
        GEOID: '46065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11190558.568591034, 5550551.533573465],
              [-11095925.86946767, 5550659.156420131],
              [-11094513.447768487, 5549251.568956439],
              [-11094490.961231347, 5499165.375740285],
              [-11098080.346892485, 5492156.477037392],
              [-11088569.098279616, 5488511.773080824],
              [-11088784.835452773, 5481503.116388723],
              [-11106198.766036548, 5486472.811775747],
              [-11119090.008348372, 5485517.243670023],
              [-11125071.427227674, 5495698.915906627],
              [-11119937.817590253, 5502950.445018773],
              [-11141447.971476747, 5513300.427540387],
              [-11172624.108068312, 5520626.197142188],
              [-11174960.258902099, 5533788.8547770735],
              [-11196518.168850143, 5537193.698930289],
              [-11190558.568591034, 5550551.533573465],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dallam',
        GEOID: '48111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11470574.510039195, 4369701.304302764],
              [-11466178.503347768, 4369695.488038599],
              [-11372673.359346652, 4369685.655789684],
              [-11372734.80770557, 4308226.214663013],
              [-11470452.058599323, 4308223.73615349],
              [-11470574.510039195, 4369701.304302764],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sherburne',
        GEOID: '27141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10480670.724898113, 5709968.611298259],
              [-10437252.56126503, 5710060.825054182],
              [-10409563.953000529, 5709921.868826899],
              [-10409493.376443366, 5687061.042517037],
              [-10409729.373763848, 5660282.527965502],
              [-10410782.790105226, 5660430.361052912],
              [-10415495.389428467, 5669070.570127285],
              [-10436938.08370354, 5668039.224186484],
              [-10469300.552108487, 5688339.778431882],
              [-10479838.277745962, 5699509.6396249905],
              [-10480670.724898113, 5709968.611298259],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Polk',
        GEOID: '05113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10515843.008570176, 4077183.320995413],
              [-10515369.197880393, 4097146.2985527036],
              [-10514960.80160564, 4114381.6276469384],
              [-10514615.158386936, 4127108.44230586],
              [-10499303.15862811, 4126775.82910113],
              [-10458199.215889128, 4120641.7223402155],
              [-10456296.431833, 4118530.950389938],
              [-10456837.667197235, 4075908.934947067],
              [-10492381.646649057, 4076634.903418705],
              [-10491165.035934176, 4054679.5888504577],
              [-10516369.291295813, 4054324.7427854645],
              [-10515843.008570176, 4077183.320995413],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Charlotte',
        GEOID: '12015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9169297.556024864, 3116736.899325148],
              [-9156642.71265542, 3116634.87201546],
              [-9156611.097920034, 3127592.1439951444],
              [-9134595.66486483, 3127485.167126611],
              [-9126332.753021719, 3127876.4614823163],
              [-9079509.771443233, 3127699.6215768154],
              [-9079499.41873059, 3127681.1253762124],
              [-9079877.904999286, 3094709.701002168],
              [-9120528.109493794, 3094771.6682293243],
              [-9151081.30221488, 3094831.3914272026],
              [-9159427.957220566, 3097173.2115005716],
              [-9163183.40065647, 3105789.815093056],
              [-9169297.556024864, 3116736.899325148],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mitchell',
        GEOID: '48335',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11262701.724947903, 3832306.8139583226],
              [-11262700.723072486, 3832780.927753317],
              [-11205489.629252153, 3832465.2458669282],
              [-11206015.836485133, 3774526.851717961],
              [-11223408.505046166, 3774684.9126027776],
              [-11263751.022468122, 3774763.483958151],
              [-11262701.724947903, 3832306.8139583226],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Midland',
        GEOID: '48329',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11386542.098107133, 3774734.9722195915],
              [-11378104.192024492, 3774709.876690061],
              [-11329661.957132928, 3774726.3004600005],
              [-11329630.453717032, 3717627.35139393],
              [-11386575.159995899, 3717621.7282560286],
              [-11386542.098107133, 3774734.9722195915],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pickens',
        GEOID: '01107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9831418.496520799, 3919768.791021999],
              [-9830005.608783722, 3933636.450681111],
              [-9826674.223550081, 3966400.132703268],
              [-9790161.71212096, 3965073.218544462],
              [-9778380.102493363, 3965176.5727884485],
              [-9778028.110263474, 3915714.5062686005],
              [-9792591.705285484, 3905692.961207098],
              [-9812745.765135136, 3900255.6961578773],
              [-9815245.66693988, 3894754.4605289125],
              [-9833973.277959457, 3894144.5077491836],
              [-9831418.496520799, 3919768.791021999],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '48239',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10791154.14305945, 3383698.0442063157],
              [-10759971.215978947, 3409274.598925148],
              [-10757950.655901559, 3407223.897267927],
              [-10721088.653678745, 3370974.630908331],
              [-10722685.420454683, 3334421.238994604],
              [-10731693.727608148, 3334270.504724193],
              [-10731147.705505809, 3341355.087693822],
              [-10734359.718093157, 3337965.001984873],
              [-10758298.751949267, 3339054.233468469],
              [-10764520.175650721, 3347502.303342318],
              [-10765876.492326548, 3356747.543824584],
              [-10774850.95835481, 3365315.529764195],
              [-10779300.398401817, 3378357.1997648245],
              [-10791154.14305945, 3383698.0442063157],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gilliam',
        GEOID: '41021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13416788.195709255, 5685546.873428004],
              [-13413559.930476248, 5695049.354804773],
              [-13398965.499955287, 5700145.983826638],
              [-13398206.301028077, 5706022.27761093],
              [-13412723.678502271, 5732389.6651133215],
              [-13403307.51669368, 5732283.954953544],
              [-13389748.357437095, 5735791.308379365],
              [-13381799.923155475, 5736540.911035112],
              [-13374074.12785544, 5744070.892925191],
              [-13366147.957471976, 5745986.270409681],
              [-13358283.809128199, 5750222.7815631805],
              [-13359068.594454976, 5662183.673111989],
              [-13345241.711823039, 5662058.74146391],
              [-13345416.2607846, 5648190.431655212],
              [-13331595.389405161, 5648199.747545992],
              [-13335039.614450304, 5632205.156511344],
              [-13413459.854254026, 5632277.029794261],
              [-13414414.196248595, 5634672.818761027],
              [-13408683.134904087, 5644448.750191827],
              [-13418479.91801084, 5655756.376659871],
              [-13416788.195709255, 5685546.873428004],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washtenaw',
        GEOID: '26161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9365435.219379647, 5224791.222631146],
              [-9313523.823877, 5225788.400966659],
              [-9300955.74204695, 5226389.744913868],
              [-9300470.50038658, 5213434.850612739],
              [-9300045.259931752, 5200376.420944487],
              [-9299864.25443972, 5187131.212042426],
              [-9299563.023897635, 5173810.245861529],
              [-9325670.338795418, 5173335.066944918],
              [-9365527.280598532, 5171707.369007943],
              [-9365435.219379647, 5224791.222631146],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Freeborn',
        GEOID: '27047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10424879.956460813, 5441971.340768961],
              [-10397979.8241496, 5441968.407971955],
              [-10358225.630236486, 5442018.265648149],
              [-10358188.673035672, 5388321.361793278],
              [-10378189.33375688, 5388322.822764567],
              [-10408077.540043337, 5388317.255792705],
              [-10416913.711060666, 5388315.609969742],
              [-10424907.010567306, 5388317.987072279],
              [-10424879.956460813, 5441971.340768961],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Phillips',
        GEOID: '30071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12121391.890457064, 6094008.144735886],
              [-12092145.031960435, 6093624.259956707],
              [-12090140.390570233, 6105357.187144522],
              [-12070815.43828801, 6102954.975589522],
              [-12070800.744115226, 6143458.33092482],
              [-12068187.630388344, 6181793.56739445],
              [-12061056.72644711, 6177401.117383968],
              [-12061043.034149742, 6201951.113029321],
              [-12058029.170256006, 6231232.319661095],
              [-12051379.500473468, 6231235.020574616],
              [-12051378.16463958, 6260212.4620957775],
              [-12048820.15406064, 6274786.416090535],
              [-11989631.914764328, 6274839.67511257],
              [-11960279.30275145, 6274753.309125411],
              [-11951659.277981872, 6274864.617909662],
              [-11931202.096554516, 6274846.394685937],
              [-11934120.892207392, 6260063.065485017],
              [-11934152.506942777, 6201904.009806898],
              [-11932635.77888072, 6192023.48203287],
              [-11939909.28308966, 6192934.086084026],
              [-11944772.942961909, 6187242.854208472],
              [-11944700.807931876, 6172654.500478593],
              [-11940159.640624454, 6172667.912384713],
              [-11940179.566813307, 6157707.968619561],
              [-11952290.45949467, 6157774.0742568225],
              [-11952343.670211269, 6143261.516920813],
              [-11956215.69605953, 6143272.710804673],
              [-11956233.84113653, 6085339.119435488],
              [-11957370.413137529, 6055722.725347551],
              [-11960173.215276724, 6044769.712522768],
              [-11979185.248470325, 6048388.823574281],
              [-11988517.717980979, 6045479.967503866],
              [-11996002.172624974, 6031993.121283905],
              [-12007468.191496173, 6026336.406183257],
              [-12012388.290350253, 6015951.270127587],
              [-12014555.79215549, 6035219.9802795],
              [-12029787.30412226, 6040283.572590474],
              [-12057353.349627398, 6037866.435357617],
              [-12059888.205752252, 6035185.003260341],
              [-12081066.51623669, 6044003.693690558],
              [-12108401.239839962, 6048083.79953117],
              [-12121703.473711794, 6062790.924709207],
              [-12121391.890457064, 6094008.144735886],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Eddy',
        GEOID: '35015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11672018.260578703, 3831835.359520016],
              [-11670977.089381311, 3831835.227499554],
              [-11670910.854284292, 3890422.1217690716],
              [-11556578.056194734, 3890674.3453248646],
              [-11556545.662222914, 3832076.563356531],
              [-11546384.641742285, 3832073.3948014397],
              [-11546378.405529568, 3763332.3606258933],
              [-11575024.416877937, 3763314.9393972587],
              [-11579956.707734192, 3763311.939800119],
              [-11648864.029132683, 3763368.777919089],
              [-11671597.02762554, 3763371.613640914],
              [-11672018.260578703, 3831835.359520016],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mercer',
        GEOID: '39107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9440351.344252177, 4917349.87029974],
              [-9440219.137503644, 4933803.263166711],
              [-9440176.350012647, 4939134.153976488],
              [-9440161.531003894, 4949446.463847456],
              [-9440128.708862178, 4972325.569123957],
              [-9401618.061389128, 4972349.081713352],
              [-9401618.951945053, 4965969.4177122945],
              [-9401566.965742856, 4948812.661448898],
              [-9401490.823211152, 4931743.065416301],
              [-9401546.81691502, 4918974.210706439],
              [-9399192.966282198, 4917596.739923255],
              [-9399220.12823795, 4917556.568409192],
              [-9440351.514238698, 4917337.925808274],
              [-9440351.344252177, 4917349.87029974],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McKean',
        GEOID: '42083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8788527.85827652, 5135619.897261604],
              [-8784863.88855655, 5137176.151451227],
              [-8785207.015704634, 5160845.108509315],
              [-8749339.056057144, 5160961.019264107],
              [-8717221.040850913, 5160840.305554305],
              [-8713110.573056437, 5160824.856708247],
              [-8705919.226846058, 5160842.87765206],
              [-8705565.115331488, 5103951.724587941],
              [-8728762.761378916, 5103772.891426767],
              [-8729576.284217633, 5101574.156001091],
              [-8736733.125600224, 5105700.176595056],
              [-8789347.948965192, 5104801.4137342],
              [-8788527.85827652, 5135619.897261604],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mifflin',
        GEOID: '42087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8673329.439826554, 4924047.48909946],
              [-8662494.602468153, 4938880.009008595],
              [-8665312.544058092, 4946196.77427135],
              [-8648086.186816307, 4964778.647696128],
              [-8647446.545022208, 4972562.3768918635],
              [-8644244.996466994, 4974790.061920715],
              [-8612141.123239158, 4989791.053537978],
              [-8611300.438444689, 4983964.873487645],
              [-8611018.68881349, 4968436.704635592],
              [-8603654.236580571, 4967251.50706065],
              [-8626149.679280074, 4955688.5349914655],
              [-8626982.905668663, 4950842.78820156],
              [-8655326.4064975, 4921104.856259197],
              [-8666992.021215692, 4919159.027627789],
              [-8673329.439826554, 4924047.48909946],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pocahontas',
        GEOID: '19151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10565765.90400878, 5298237.350643307],
              [-10513341.54829256, 5297990.0710347975],
              [-10513355.908506872, 5258117.205043314],
              [-10513349.340656916, 5245062.512431039],
              [-10565832.139105802, 5245284.070986289],
              [-10565765.90400878, 5298237.350643307],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Williams',
        GEOID: '38105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11582580.126176316, 6212987.584203432],
              [-11453192.082871316, 6212867.252601584],
              [-11453190.747037426, 6198240.850853519],
              [-11453187.852730667, 6169063.885876424],
              [-11446767.389779674, 6169121.197796701],
              [-11446813.698687844, 6127452.8315946385],
              [-11477827.976739794, 6131260.911677712],
              [-11488381.843703432, 6129378.177415024],
              [-11494015.389174007, 6122336.35702655],
              [-11492052.60391234, 6117162.805281925],
              [-11519905.519745253, 6107973.708193738],
              [-11531004.295616323, 6115863.86796355],
              [-11526974.307410626, 6121461.410700368],
              [-11532370.185768357, 6129245.070456788],
              [-11548530.6588858, 6122407.856588501],
              [-11544883.609728428, 6117752.296936243],
              [-11553225.892368477, 6116757.730244256],
              [-11555054.092365773, 6105901.453641434],
              [-11561231.099590402, 6109362.645026893],
              [-11568297.994824432, 6099529.610636876],
              [-11582135.47678043, 6106205.764815743],
              [-11582135.483178295, 6106207.231809488],
              [-11582313.452673778, 6147112.074710859],
              [-11582434.808919773, 6171866.710567258],
              [-11582520.840885125, 6189459.392022973],
              [-11582580.126176316, 6212987.584203432],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Prince Edward',
        GEOID: '51147',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8758792.641173782, 4473837.537974589],
              [-8749097.826720595, 4487297.919664172],
              [-8749092.59470453, 4494725.3637508135],
              [-8739859.19954068, 4485166.256661389],
              [-8734693.75252889, 4486559.734312724],
              [-8722188.232252667, 4481230.570846836],
              [-8709084.703671899, 4490540.416145068],
              [-8708661.13300943, 4480476.8585895905],
              [-8709565.047274671, 4455858.890145671],
              [-8713551.73219845, 4453546.8172419295],
              [-8732306.506048828, 4450175.863052771],
              [-8743826.292234082, 4460095.722624759],
              [-8760001.459524307, 4467534.328317359],
              [-8758792.641173782, 4473837.537974589],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McMinn',
        GEOID: '47107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9440020.502725538, 4225911.767523037],
              [-9419840.282795552, 4251835.418220037],
              [-9415900.352057906, 4251804.32293166],
              [-9413948.030828374, 4249797.5622991165],
              [-9409374.580868622, 4249032.402760772],
              [-9396392.056574348, 4218151.777860656],
              [-9395479.125430351, 4208868.780060558],
              [-9405999.26258828, 4202743.639415848],
              [-9425131.632151429, 4200366.769327022],
              [-9429162.399593562, 4196686.363836771],
              [-9428520.197451174, 4198339.790918666],
              [-9433708.019680616, 4199846.219743244],
              [-9431336.803207228, 4202743.503042382],
              [-9446590.245113686, 4211557.156601279],
              [-9440020.502725538, 4225911.767523037],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson Davis',
        GEOID: '22053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10367312.751589432, 3558118.262289182],
              [-10360008.857159505, 3560049.288053309],
              [-10327747.800810669, 3559926.3711233046],
              [-10327551.767187381, 3566469.8806262896],
              [-10311563.060044236, 3566416.787361824],
              [-10311745.624009136, 3565547.94988385],
              [-10307582.163733978, 3557695.74060741],
              [-10311632.968684454, 3551790.6981338016],
              [-10307197.332254305, 3527012.7682120437],
              [-10311021.713360509, 3515423.5336238416],
              [-10312397.28830824, 3512830.5159061514],
              [-10323614.174159043, 3508348.269872057],
              [-10325728.799206153, 3508604.9362298287],
              [-10352308.665342351, 3508496.919697668],
              [-10340158.254241757, 3514281.722519834],
              [-10340837.525774578, 3523658.416583641],
              [-10352300.761658506, 3523740.941718946],
              [-10356128.482349433, 3537091.0744000496],
              [-10356158.538611948, 3552410.7047519907],
              [-10367307.630892856, 3555464.9887551987],
              [-10367312.751589432, 3558118.262289182],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Manassas',
        GEOID: '51683',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8624562.152021872, 4690374.492782739],
              [-8622662.484911485, 4689110.4984740075],
              [-8624051.974795567, 4682736.656731444],
              [-8629916.396890046, 4681303.826251975],
              [-8624562.152021872, 4690374.492782739],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Moniteau',
        GEOID: '29135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10334883.380170519, 4676504.1266801],
              [-10310093.642765766, 4675939.277425327],
              [-10296872.226844247, 4710516.91141878],
              [-10283839.720098607, 4694310.986784281],
              [-10285349.435032744, 4684372.772465507],
              [-10296516.895029634, 4640041.249927496],
              [-10310988.874110725, 4640460.309632263],
              [-10335109.804014793, 4664078.957621484],
              [-10334883.380170519, 4676504.1266801],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lake',
        GEOID: '27075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10218826.86432117, 6141157.145806989],
              [-10217034.444644766, 6140264.589147294],
              [-10209659.417060219, 6140047.1393396845],
              [-10207147.49275047, 6126730.104718269],
              [-10192331.53644283, 6124885.709947636],
              [-10190465.821777135, 6115721.311623878],
              [-10181892.773832673, 6117970.180911552],
              [-10167541.353760114, 6118446.1134081865],
              [-10157916.002669184, 6120855.333583975],
              [-10147451.413937159, 6130256.76859172],
              [-10134031.070085596, 6138432.137873466],
              [-10133695.938446615, 6138619.126096778],
              [-10132382.094468474, 6088241.380355214],
              [-10132647.814092997, 6018301.033434571],
              [-10146432.951915892, 6004562.507060655],
              [-10159296.36435502, 5987781.056512247],
              [-10173156.642834198, 5972698.81974361],
              [-10180942.773298243, 5964817.526319473],
              [-10193950.678436417, 5956763.1852242425],
              [-10201826.198451571, 5946399.150350622],
              [-10212127.036212634, 5939275.694575644],
              [-10218460.882812738, 5932739.413658984],
              [-10217785.405929657, 6031789.771536784],
              [-10219030.625753669, 6062413.891599562],
              [-10218826.86432117, 6141157.145806989],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dunn',
        GEOID: '38025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11477024.695294231, 6052859.174715499],
              [-11426140.444733134, 6052775.686664052],
              [-11426084.784987736, 6077576.907947662],
              [-11417145.718557546, 6070350.791080758],
              [-11397530.445043335, 6066689.997181732],
              [-11391941.76132755, 6073830.177745936],
              [-11383759.444795772, 6070665.218552676],
              [-11384138.04238396, 6044578.944686164],
              [-11377447.518348303, 6036357.470510996],
              [-11377475.459540492, 5995788.985802782],
              [-11370668.495317465, 5995790.2996956855],
              [-11370703.894915538, 5943756.599470107],
              [-11413082.22318512, 5939023.43262198],
              [-11469545.583985792, 5938904.810020522],
              [-11469533.116202824, 5995890.977331293],
              [-11476950.111235399, 5995894.590579741],
              [-11477024.695294231, 6052859.174715499],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Labette',
        GEOID: '20099',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10633363.551598089, 4492766.05378577],
              [-10585168.779934557, 4492744.618848574],
              [-10583719.066205956, 4486596.138293546],
              [-10583534.04949756, 4439035.440066088],
              [-10611259.396908721, 4439017.301107691],
              [-10620727.676852377, 4439015.034224298],
              [-10633506.547317008, 4439011.97472434],
              [-10633363.551598089, 4492766.05378577],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Vernon',
        GEOID: '22115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10411816.168938259, 3622952.320051596],
              [-10413920.663911706, 3628479.5256286315],
              [-10412772.403364172, 3633852.8196337386],
              [-10411847.672354152, 3639462.335584223],
              [-10412856.11562125, 3649496.439423161],
              [-10412279.36933945, 3656878.1884273924],
              [-10414216.362710254, 3656774.874244196],
              [-10412314.65761803, 3668697.4697257937],
              [-10401977.529702969, 3668738.3676942624],
              [-10396182.348331762, 3680131.4120188477],
              [-10378995.620828697, 3680178.3451364897],
              [-10351823.535001475, 3679646.838087615],
              [-10350649.2256931, 3677849.7666692585],
              [-10339327.142923495, 3674035.0240181317],
              [-10333749.479837298, 3665556.1570891584],
              [-10333112.843669452, 3618471.7740740227],
              [-10333711.519890938, 3616624.314675666],
              [-10350314.04270632, 3616937.934077799],
              [-10399589.50398647, 3617581.6698288866],
              [-10406003.287768018, 3614474.846931578],
              [-10414447.745486427, 3616846.4287503874],
              [-10411816.168938259, 3622952.320051596],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Real',
        GEOID: '48385',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11135386.625203053, 3484061.6235903674],
              [-11132205.336795164, 3490294.9266318427],
              [-11128345.222132415, 3514140.3380548814],
              [-11104967.572468374, 3513082.3844168065],
              [-11097426.567523055, 3513058.7152536763],
              [-11097575.290362757, 3491804.3160993983],
              [-11087730.30591649, 3491688.3510731277],
              [-11087769.71301623, 3455716.892591825],
              [-11133528.480262732, 3455244.863626714],
              [-11135386.625203053, 3484061.6235903674],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Richland',
        GEOID: '39139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9208881.72141947, 5011698.291131613],
              [-9176383.109277284, 5011300.96115987],
              [-9175036.143438684, 4986317.700014729],
              [-9165959.040839909, 4972110.6725696735],
              [-9165878.000250611, 4959166.129844002],
              [-9165708.683305116, 4946924.340812835],
              [-9169931.69950785, 4946319.252497573],
              [-9197618.081382535, 4946173.919652004],
              [-9199996.756261805, 4963263.238362258],
              [-9198016.827798557, 4969574.611818546],
              [-9204909.953307457, 4969812.0779829165],
              [-9209145.771251632, 4969837.043839216],
              [-9208881.72141947, 5011698.291131613],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Red River',
        GEOID: '48387',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10609910.738507258, 4011874.7815852836],
              [-10606904.578428889, 4012398.090049972],
              [-10603584.808574451, 4019367.6969356695],
              [-10600553.578840151, 4023694.5212273407],
              [-10592707.181908188, 4020544.701998773],
              [-10591989.659093935, 4020256.7064905604],
              [-10585927.199625332, 4016028.2900420027],
              [-10580535.55140825, 4010362.7585828914],
              [-10573308.912704933, 4008984.5804074113],
              [-10568623.475337444, 4003385.5020365273],
              [-10564473.039442707, 3998802.5146612176],
              [-10557722.40288202, 3993867.409359471],
              [-10549319.117161019, 3995018.717391539],
              [-10545510.532512743, 3991377.7010005424],
              [-10547087.161370613, 3988671.09123438],
              [-10547179.44522848, 3939046.815403093],
              [-10551049.801284382, 3937710.173743339],
              [-10554065.44628997, 3943670.6271309205],
              [-10554502.597930316, 3945262.296108694],
              [-10589316.766800497, 3947112.297703685],
              [-10592432.265389327, 3945953.762475518],
              [-10609486.63401784, 3945588.8945163256],
              [-10609708.939040951, 3945940.16470581],
              [-10609910.738507258, 4011874.7815852836],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pasco',
        GEOID: '12101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9223891.151002109, 3270946.0212167073],
              [-9213257.801922046, 3279815.1776902387],
              [-9209623.99978408, 3290020.4746473273],
              [-9205836.131470855, 3302051.1318829083],
              [-9205097.194179991, 3303718.966023266],
              [-9156410.94547559, 3303906.582835357],
              [-9156394.692829933, 3309435.599032568],
              [-9134286.75327788, 3309423.694512678],
              [-9134411.987705022, 3288467.501085111],
              [-9140021.042887624, 3281697.512950341],
              [-9139981.747107372, 3270632.2146533243],
              [-9157112.480906567, 3270608.4742521634],
              [-9181000.196477424, 3270668.7092875317],
              [-9200685.601270834, 3270836.282800903],
              [-9223864.540749427, 3270698.520628292],
              [-9223891.151002109, 3270946.0212167073],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sac',
        GEOID: '19161',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10618544.700983686, 5245500.647238271],
              [-10565832.139105802, 5245284.070986289],
              [-10565832.361744784, 5232277.606479101],
              [-10559398.317815913, 5232248.32707748],
              [-10559590.121298552, 5192442.227369089],
              [-10585465.11241905, 5192549.385751274],
              [-10611363.14667414, 5192628.590550318],
              [-10611236.242454635, 5232360.162806434],
              [-10618481.80547139, 5232369.067462548],
              [-10618544.700983686, 5245500.647238271],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sandusky',
        GEOID: '39143',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9285673.691031357, 5086407.537657359],
              [-9277165.542350028, 5080060.008890196],
              [-9247027.23737113, 5080009.655479944],
              [-9234199.335849568, 5080168.588968429],
              [-9222575.354620932, 5076051.571980876],
              [-9222214.790790254, 5065942.543882591],
              [-9221870.813563703, 5055214.567525783],
              [-9221716.302110482, 5050077.0779498285],
              [-9286254.444814827, 5049879.548083441],
              [-9285673.691031357, 5086407.537657359],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coleman',
        GEOID: '48083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11100108.476695249, 3774090.9140253416],
              [-11090918.162174337, 3773983.837115611],
              [-11042433.848515252, 3773715.9519494213],
              [-11043201.619043253, 3693578.1970142326],
              [-11055681.313197616, 3686094.4006885183],
              [-11065411.638568364, 3690833.0367160207],
              [-11077566.947726555, 3687989.217376059],
              [-11087627.224068016, 3696804.3789910483],
              [-11090195.364720615, 3693605.3437204584],
              [-11100968.642400606, 3707880.995467351],
              [-11100108.476695249, 3774090.9140253416],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dorchester',
        GEOID: '24019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8497724.724212017, 4649197.389701275],
              [-8491168.117523784, 4656256.523431627],
              [-8492568.739356944, 4660143.71395074],
              [-8491405.005400192, 4665892.009029525],
              [-8486016.919406815, 4666531.667856623],
              [-8482886.392686727, 4666065.952377933],
              [-8478697.440248176, 4665988.881290766],
              [-8479223.633520277, 4670355.076378786],
              [-8463366.742615107, 4660610.014078442],
              [-8454186.335528878, 4675097.409166541],
              [-8442370.328178626, 4679378.0551206255],
              [-8427726.474745816, 4669577.414014843],
              [-8427726.026525788, 4669570.237921713],
              [-8427083.32514276, 4658949.075832898],
              [-8440656.341978882, 4647602.729838616],
              [-8445165.560592445, 4629098.749818672],
              [-8452336.205591895, 4621505.911145302],
              [-8451794.979403533, 4614276.322761121],
              [-8454103.068549765, 4614681.678723976],
              [-8464615.524662826, 4615502.014995883],
              [-8463842.188160287, 4605935.910243016],
              [-8461607.783341084, 4596704.9672574075],
              [-8460938.530562434, 4590333.088822522],
              [-8465701.668934498, 4591684.8255550405],
              [-8470917.654995106, 4597116.606517961],
              [-8470148.548633216, 4606676.515780671],
              [-8475366.53844466, 4612277.889797961],
              [-8484505.86863879, 4622699.024678311],
              [-8488964.659523021, 4625419.1201442955],
              [-8488111.172987109, 4630734.405882157],
              [-8491512.094750335, 4636533.983292291],
              [-8497724.724212017, 4649197.389701275],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Zapata',
        GEOID: '48505',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11071928.481838116, 3156273.5739268777],
              [-11061886.929531377, 3163405.229364424],
              [-11057766.883857626, 3157649.019841596],
              [-11015583.364696933, 3157169.850225426],
              [-11015534.495440476, 3096722.4653761927],
              [-11021866.570715778, 3082928.506749814],
              [-11040312.665902004, 3069808.636283964],
              [-11042951.59546693, 3080614.0218790853],
              [-11043885.009397235, 3089126.157489644],
              [-11047618.331159966, 3097042.6986112376],
              [-11050531.450914538, 3103896.904271925],
              [-11057242.569055991, 3108457.489703512],
              [-11060831.95471713, 3114594.1705223676],
              [-11063751.085724201, 3121272.9087933414],
              [-11070386.061333952, 3126723.7303344496],
              [-11069846.495762078, 3136826.2231504307],
              [-11068495.188463336, 3143369.4230094976],
              [-11070193.255975898, 3151403.073504418],
              [-11071928.481838116, 3156273.5739268777],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lauderdale',
        GEOID: '28075',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9897918.645250374, 3839285.501786144],
              [-9839446.141758405, 3839439.719830491],
              [-9843015.451758672, 3803898.1117699086],
              [-9843790.878686035, 3796190.7575041833],
              [-9844110.072126634, 3793228.6517738537],
              [-9897844.172511034, 3792774.6327209915],
              [-9897918.645250374, 3839285.501786144],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Judith Basin',
        GEOID: '30045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12332897.364491412, 5992468.264627557],
              [-12330539.951634882, 6000891.182319263],
              [-12316267.234442314, 6000875.406341546],
              [-12316339.369472349, 6010322.137687743],
              [-12268921.385215573, 6010350.269315662],
              [-12268886.764853936, 6000832.51554723],
              [-12259387.538746074, 6000873.434346349],
              [-12259359.374914903, 5986570.192773655],
              [-12245176.158592932, 5986606.778729529],
              [-12245146.65892787, 5979486.578158544],
              [-12230947.969196681, 5979513.954259583],
              [-12230893.422646191, 5972376.138707055],
              [-12218045.260977305, 5972436.906657047],
              [-12217917.800160347, 5925118.862953583],
              [-12226823.4707433, 5910979.73147222],
              [-12218056.170287402, 5906301.348525317],
              [-12216840.45012845, 5892285.075835973],
              [-12225091.562105538, 5892179.420118657],
              [-12241738.056119781, 5901842.042399008],
              [-12275571.722915053, 5894949.124454258],
              [-12281713.664500082, 5888890.60985328],
              [-12297088.555970995, 5889758.289386233],
              [-12314238.548042098, 5904972.858886323],
              [-12317821.922450732, 5913332.713858176],
              [-12315985.596130608, 5915534.989090922],
              [-12316968.658553801, 5957736.559959022],
              [-12330937.696175486, 5957847.0995652145],
              [-12332897.364491412, 5992468.264627557],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carroll',
        GEOID: '29033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10437224.508753352, 4797090.9791907985],
              [-10437132.558853954, 4809632.649187686],
              [-10383670.37152507, 4810243.173008096],
              [-10383419.902670784, 4787533.64250698],
              [-10365939.625670498, 4781595.186217988],
              [-10364343.860769976, 4776776.951096649],
              [-10375055.356132578, 4779388.618569502],
              [-10378324.920896668, 4768746.554306618],
              [-10389698.767229488, 4766117.5060813315],
              [-10389819.548876999, 4757547.181304663],
              [-10397143.926093234, 4754158.827203445],
              [-10405837.978324188, 4763699.290100304],
              [-10407477.3804651, 4753731.177823043],
              [-10425128.866842227, 4757288.720800926],
              [-10437144.35871998, 4751369.086528209],
              [-10437224.508753352, 4797090.9791907985],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Houston',
        GEOID: '48225',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10656470.47226052, 3654074.3567065685],
              [-10656083.41439103, 3668004.82990561],
              [-10648516.026726395, 3676651.1702745194],
              [-10654510.02470816, 3691868.4675730565],
              [-10658489.139906565, 3692395.285657484],
              [-10657647.78719515, 3698384.8874329487],
              [-10647905.661958378, 3703312.7242605537],
              [-10605764.444204183, 3709988.427923238],
              [-10594109.961435074, 3708784.1921520988],
              [-10586479.78957763, 3700319.0888811024],
              [-10586637.417976594, 3693924.4525532904],
              [-10575723.989057694, 3688159.9818279096],
              [-10572759.884976339, 3685999.184957143],
              [-10570688.451891657, 3683101.980922176],
              [-10623751.22488758, 3640296.575373994],
              [-10644132.821776409, 3623715.889330787],
              [-10651177.787070753, 3631055.5072237933],
              [-10648431.423913393, 3643057.1149586337],
              [-10660445.357318277, 3644990.288689326],
              [-10656470.47226052, 3654074.3567065685],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Norfolk',
        GEOID: '51710',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8498333.085229201, 4428626.1550969705],
              [-8493320.066915823, 4438241.363380058],
              [-8491558.965912836, 4436005.003775606],
              [-8490110.693680737, 4434166.247684388],
              [-8481427.43944039, 4429555.685873469],
              [-8479979.01537021, 4429150.676196862],
              [-8481779.542989772, 4422035.156924005],
              [-8482240.071723182, 4415179.828471179],
              [-8485446.184377518, 4416820.882029261],
              [-8492559.72247819, 4414331.514566986],
              [-8497771.923676113, 4421701.4491045885],
              [-8497360.486838141, 4424670.954128068],
              [-8498333.085229201, 4428626.1550969705],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Graham',
        GEOID: '04009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12294296.440502917, 3946074.5433653323],
              [-12283098.256326567, 3952127.9982883534],
              [-12264010.080601264, 3957283.8508866043],
              [-12245215.899651146, 3957311.073097134],
              [-12245216.233609617, 3972134.5480166203],
              [-12234346.219292128, 3971897.386054573],
              [-12233094.65425714, 3970918.593407253],
              [-12219236.936126247, 3958578.9785093493],
              [-12200936.902395759, 3976938.294795556],
              [-12188976.62498544, 3982262.5096498597],
              [-12189010.020832676, 3905716.077339241],
              [-12170941.197684567, 3874518.5772701497],
              [-12161098.328308623, 3861106.6513598626],
              [-12156784.03012344, 3847062.0793712814],
              [-12158990.493750453, 3832964.8483424177],
              [-12146513.47126387, 3819383.9112375663],
              [-12159184.74626189, 3819159.449924393],
              [-12264117.392590389, 3819410.4195806365],
              [-12295405.071311729, 3819539.1375490655],
              [-12295373.345256852, 3830971.185045972],
              [-12295137.013977898, 3833948.667274074],
              [-12295128.77633558, 3921152.5922752526],
              [-12289842.77031526, 3921430.090614757],
              [-12296038.590533832, 3934561.7536973003],
              [-12294296.440502917, 3946074.5433653323],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Abbeville',
        GEOID: '45001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9210127.165731916, 4057770.218567085],
              [-9163152.119879559, 4093978.305348622],
              [-9162742.241514456, 4091635.973751321],
              [-9155620.354451975, 4083945.0549965245],
              [-9165405.003734231, 4074902.175822002],
              [-9155777.314933993, 4058329.751988091],
              [-9157941.031876544, 4043361.4237166215],
              [-9164593.818604821, 4037415.028494762],
              [-9187260.693320148, 4038463.889957436],
              [-9194436.213290341, 4030617.282099467],
              [-9199754.079771876, 4039725.4737702655],
              [-9207833.20313569, 4048714.3590063415],
              [-9210127.165731916, 4057770.218567085],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '36045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8506160.292585349, 5453947.568019441],
              [-8491374.392540224, 5461181.602908515],
              [-8494531.41329912, 5469354.690896207],
              [-8502088.448251113, 5470323.7496435605],
              [-8500560.699559467, 5476702.830921514],
              [-8501548.103442803, 5481007.82971484],
              [-8499875.30545465, 5486087.377488101],
              [-8497527.020796368, 5491003.384569212],
              [-8492179.566417132, 5497030.867507933],
              [-8483299.610636553, 5498703.457235416],
              [-8478567.196443949, 5502596.479912479],
              [-8478296.46744234, 5508996.383404633],
              [-8471118.364037009, 5511915.397037912],
              [-8460392.397140602, 5519382.3331937315],
              [-8454664.118783362, 5519630.625404213],
              [-8444838.080116792, 5528362.200807323],
              [-8398624.106006175, 5499186.810319343],
              [-8409729.561046695, 5481392.1202404965],
              [-8402899.2197306, 5476927.655007725],
              [-8409396.938408203, 5460459.737247405],
              [-8416162.046502693, 5461011.610581256],
              [-8433359.460676873, 5446703.004606533],
              [-8442532.520676712, 5447504.722683929],
              [-8443642.821277885, 5433292.344122371],
              [-8436543.420752542, 5432742.4391129995],
              [-8435184.65504792, 5417421.822295444],
              [-8463073.972354323, 5420213.925225065],
              [-8462730.663044715, 5414229.352707893],
              [-8482710.234867498, 5416098.271931135],
              [-8484015.172323372, 5427376.650240123],
              [-8485803.297303984, 5435181.485412147],
              [-8493316.249737622, 5443351.402591142],
              [-8500471.755286323, 5445745.544200145],
              [-8509467.594656818, 5447332.9752322845],
              [-8506160.292585349, 5453947.568019441],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henry',
        GEOID: '19087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10210021.094085807, 4997762.948092326],
              [-10209783.093014492, 5036385.54680636],
              [-10184143.431297531, 5036325.957147785],
              [-10171295.046989663, 5036154.731334335],
              [-10171340.91061987, 5023279.32039818],
              [-10171495.08811462, 4984743.9380792845],
              [-10175653.761651672, 4984784.238751283],
              [-10210088.665016718, 4984878.225271694],
              [-10210021.094085807, 4997762.948092326],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Johnson',
        GEOID: '21115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9235223.363845374, 4564437.967181213],
              [-9238294.77991585, 4574336.949453478],
              [-9234179.187021734, 4579470.453168113],
              [-9220773.203384481, 4574889.892099222],
              [-9196369.521973798, 4562385.005750573],
              [-9202881.044268258, 4558514.468128211],
              [-9199526.208774222, 4539971.97970596],
              [-9211936.105607856, 4545045.869522689],
              [-9232923.503165584, 4539431.0231308],
              [-9234016.549245685, 4550469.055709278],
              [-9240035.260154404, 4559561.171741082],
              [-9235223.363845374, 4564437.967181213],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adams',
        GEOID: '17001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10186430.436260208, 4895071.041268383],
              [-10120274.096093873, 4894041.102116263],
              [-10120441.075330062, 4881133.025830563],
              [-10120806.87117681, 4843454.329820708],
              [-10120730.728645107, 4830717.088072652],
              [-10170662.596804617, 4830941.568972348],
              [-10170323.561793508, 4835117.192574791],
              [-10174362.455558471, 4839982.162630137],
              [-10178614.637467792, 4843517.54515571],
              [-10177824.825680615, 4852542.754898736],
              [-10178702.832404815, 4857988.396393196],
              [-10178730.298418727, 4858158.796387854],
              [-10183959.420179248, 4868751.950864722],
              [-10185473.253934547, 4877320.8986477805],
              [-10187064.343416456, 4890741.301247275],
              [-10186430.436260208, 4895071.041268383],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Oneida',
        GEOID: '16071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12579098.563457737, 5210153.310046322],
              [-12540589.032771183, 5210370.889631402],
              [-12540584.691311043, 5223524.843131403],
              [-12523203.26601858, 5223499.058885343],
              [-12523235.54867091, 5236621.773774012],
              [-12514517.674068926, 5236632.494384843],
              [-12500968.756205495, 5229306.20997564],
              [-12504195.796924101, 5209612.620069236],
              [-12489006.697683323, 5213679.166806182],
              [-12481830.820667805, 5203801.586407601],
              [-12475682.08859384, 5196737.174900738],
              [-12479946.960925112, 5186465.366034624],
              [-12479966.114091383, 5160619.7072101105],
              [-12479976.01531221, 5160619.642889512],
              [-12485502.521694504, 5160782.005561605],
              [-12497275.509459447, 5161127.892199628],
              [-12539920.113951007, 5161025.431271843],
              [-12579106.927962419, 5160713.952701085],
              [-12579098.563457737, 5210153.310046322],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bell',
        GEOID: '21013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9345974.679957638, 4389799.2834756905],
              [-9337200.922971277, 4395603.915335612],
              [-9328378.296728455, 4409208.162468093],
              [-9302540.374998393, 4429566.54828726],
              [-9305142.913373647, 4432945.716394165],
              [-9296188.596173218, 4430539.197167167],
              [-9294043.469585631, 4424538.71723044],
              [-9295276.66690464, 4401990.768887775],
              [-9290830.97247617, 4392671.372359233],
              [-9298195.57527273, 4392651.105453645],
              [-9307925.010087553, 4388210.79681447],
              [-9314704.367076863, 4383610.511611332],
              [-9316407.666605491, 4381082.577214184],
              [-9339084.226116516, 4381623.246807172],
              [-9343129.55236069, 4381791.450267911],
              [-9345974.679957638, 4389799.2834756905],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Adams',
        GEOID: '28001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10199242.918348221, 3667578.559331799],
              [-10192879.228337532, 3666773.986242429],
              [-10186719.475633977, 3670682.8715628465],
              [-10189747.699742027, 3676769.382436496],
              [-10189333.034638824, 3683538.1804981986],
              [-10186886.232231187, 3689884.4580697007],
              [-10187641.423656728, 3697645.6550557935],
              [-10184577.688631115, 3702329.8709578738],
              [-10178788.852470882, 3703884.1870226357],
              [-10181004.22165716, 3709293.1844933648],
              [-10181705.534449156, 3713580.149479307],
              [-10174124.454487154, 3716691.8539546984],
              [-10172476.926023416, 3728243.376435385],
              [-10172388.93130369, 3728264.704576649],
              [-10165537.380286852, 3729925.497233792],
              [-10165746.96519706, 3730250.8765818276],
              [-10165458.120809408, 3730508.1615441176],
              [-10164255.64766986, 3725481.623095724],
              [-10163583.945862412, 3725809.0274274773],
              [-10163705.061468396, 3724975.877971708],
              [-10163127.313311178, 3724959.9143031915],
              [-10163368.765286708, 3724006.711994274],
              [-10162801.815120097, 3723719.5229538516],
              [-10162557.134879336, 3722864.2762939623],
              [-10162651.088529564, 3722308.928096569],
              [-10163512.256110342, 3721500.611528699],
              [-10163173.065621894, 3720958.9295627913],
              [-10163482.311167317, 3720362.8587810015],
              [-10147201.72431931, 3712234.126352287],
              [-10147678.83965685, 3677856.4142791433],
              [-10164170.15430093, 3679703.1556234644],
              [-10182219.607857643, 3674321.3068371858],
              [-10184503.77248923, 3662124.04368745],
              [-10195862.80142577, 3657708.9953334085],
              [-10195757.839049956, 3657929.497067101],
              [-10201803.043997487, 3663229.829295381],
              [-10199242.918348221, 3667578.559331799],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hyde',
        GEOID: '46069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11095686.97784043, 5605399.838481899],
              [-11084382.1495919, 5605362.122882109],
              [-11055333.885066848, 5605356.465555719],
              [-11054080.538920008, 5550544.973150858],
              [-11054045.473280407, 5495642.244719655],
              [-11084813.178660253, 5495268.22368875],
              [-11094490.961231347, 5499165.375740285],
              [-11094513.447768487, 5549251.568956439],
              [-11095925.86946767, 5550659.156420131],
              [-11095686.97784043, 5605399.838481899],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Colfax',
        GEOID: '31037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10826090.42941103, 5122572.175575795],
              [-10800207.089328721, 5122556.510187977],
              [-10787517.891892686, 5122524.135134334],
              [-10787516.556058796, 5079900.780126857],
              [-10817857.128552467, 5068081.826306499],
              [-10826212.212933956, 5069179.093433062],
              [-10826090.42941103, 5122572.175575795],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sacramento',
        GEOID: '06067',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13565667.216654649, 4588757.84123201],
              [-13548932.334964717, 4591513.974831648],
              [-13545984.038251055, 4602002.767967351],
              [-13538165.847773662, 4607108.099886598],
              [-13535701.2342475, 4623749.691933947],
              [-13527727.196482996, 4630422.075122823],
              [-13525884.747590877, 4645973.341292648],
              [-13531852.696811795, 4650577.647048465],
              [-13531082.477254996, 4652273.63826397],
              [-13527991.802912612, 4653270.566019634],
              [-13528757.124411814, 4654479.615189505],
              [-13526843.876323551, 4656008.312686838],
              [-13526574.928433796, 4656888.320942212],
              [-13527651.944507219, 4659723.278957974],
              [-13526015.993270522, 4662585.369023205],
              [-13526605.652613254, 4664664.659999929],
              [-13528398.007734515, 4665191.706873292],
              [-13530279.307128925, 4664208.857587951],
              [-13531285.857964674, 4665009.658962428],
              [-13540209.784944119, 4676816.4399934085],
              [-13536772.23906842, 4683902.959893301],
              [-13531982.606657552, 4683969.177608289],
              [-13523581.1020484, 4683726.000869276],
              [-13512144.360203281, 4682755.349636706],
              [-13504037.184327787, 4682041.048175088],
              [-13485355.43606337, 4680498.750053374],
              [-13482862.770025527, 4681231.776262075],
              [-13472720.451219352, 4651481.372560541],
              [-13472673.363074746, 4621928.612993237],
              [-13494428.308521494, 4614009.950351261],
              [-13501080.204693846, 4614779.628005191],
              [-13513985.027983546, 4611603.6256573945],
              [-13519545.325229183, 4615512.788811618],
              [-13522216.547730258, 4616172.139429074],
              [-13534226.139674999, 4592771.94355752],
              [-13544583.639056876, 4592645.206246461],
              [-13551792.577961158, 4583188.422069144],
              [-13558855.35437403, 4582480.726747443],
              [-13565667.216654649, 4588757.84123201],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '42119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8612141.123239158, 4989791.053537978],
              [-8602685.200413214, 4999033.017446107],
              [-8587648.608874822, 5018883.710017965],
              [-8587643.154219773, 5022500.856807901],
              [-8569144.971795673, 5025313.041011426],
              [-8567173.503613725, 5034314.61446103],
              [-8560036.254461516, 5032876.148352829],
              [-8555830.715418836, 5023126.6350233145],
              [-8557654.573955992, 5004695.921910001],
              [-8549363.832240181, 4994951.356460164],
              [-8565152.386938881, 4995840.410853891],
              [-8611300.438444689, 4983964.873487645],
              [-8612141.123239158, 4989791.053537978],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bosque',
        GEOID: '48035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10894266.82703297, 3774779.2508472567],
              [-10869477.53490618, 3789762.9561744984],
              [-10866458.216357393, 3790063.5634878404],
              [-10855284.745108, 3780861.1649996247],
              [-10850988.258041343, 3786101.5467163846],
              [-10852088.317249361, 3765622.566625378],
              [-10840291.122893054, 3759732.860210872],
              [-10846833.703325447, 3754585.417723437],
              [-10840609.05135876, 3746361.46938976],
              [-10829389.382520689, 3742739.453531681],
              [-10834339.760276264, 3735561.5375645487],
              [-10828855.605562333, 3729948.6671288507],
              [-10865364.502360348, 3709318.798020666],
              [-10874782.576559423, 3725436.8706719363],
              [-10883309.315595714, 3720392.4196445905],
              [-10909918.124799522, 3765660.1158419447],
              [-10894266.82703297, 3774779.2508472567],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clark',
        GEOID: '55019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10121542.359052481, 5626425.647343616],
              [-10067023.638436474, 5626399.49986266],
              [-10053824.041135153, 5626848.743029106],
              [-10053959.294316465, 5572090.867850611],
              [-10053937.253057288, 5531371.5861041],
              [-10080953.491597401, 5531014.334954999],
              [-10108023.274812581, 5531050.49586527],
              [-10107979.5262527, 5544658.276833371],
              [-10121489.704933336, 5544683.096674493],
              [-10121429.703727797, 5558188.420136322],
              [-10121418.237820245, 5599085.6113115065],
              [-10121465.21464536, 5612777.050769742],
              [-10121542.359052481, 5626425.647343616],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lane',
        GEOID: '41039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13820344.504288955, 5451656.364458823],
              [-13817243.031955965, 5481619.074694472],
              [-13815979.33309648, 5501892.319670507],
              [-13816348.476794312, 5508283.800530963],
              [-13799347.421935529, 5508467.57722327],
              [-13797057.35737093, 5509334.4249166325],
              [-13778636.54199293, 5509427.100855397],
              [-13758345.781808587, 5508361.539797384],
              [-13712378.067877866, 5509454.779422127],
              [-13710712.728295596, 5496456.014527947],
              [-13681806.062162837, 5496559.274219695],
              [-13681610.585137004, 5505630.955803035],
              [-13677320.999878775, 5510013.344602012],
              [-13665885.148589583, 5510514.091866123],
              [-13652980.659258354, 5506795.065728527],
              [-13645211.33803742, 5500775.283499867],
              [-13623787.011478327, 5499094.859436126],
              [-13617396.048192395, 5504653.646994672],
              [-13584221.281463126, 5504809.530691641],
              [-13560876.805007344, 5506138.457787796],
              [-13557561.59925203, 5504107.3756598085],
              [-13555153.53602719, 5483197.834877181],
              [-13565066.202723857, 5460065.805344799],
              [-13566503.44866949, 5451782.144852932],
              [-13572986.5844938, 5451398.473674016],
              [-13578207.468612002, 5443427.203926405],
              [-13576758.645439329, 5428921.613183424],
              [-13579449.12621231, 5413239.0971348565],
              [-13577072.566403367, 5407906.775975133],
              [-13581240.813416628, 5406131.146553841],
              [-13595561.731948713, 5397184.529465702],
              [-13595675.834426776, 5379219.832646186],
              [-13663545.324212598, 5378786.579748097],
              [-13663559.684426911, 5395244.6296344185],
              [-13704284.918258214, 5394531.43849966],
              [-13707571.626223886, 5404656.404718102],
              [-13707583.648728888, 5431408.677949195],
              [-13731063.934963442, 5431485.7687152745],
              [-13731058.81426687, 5435964.615558094],
              [-13744658.827776572, 5436094.809492212],
              [-13756838.404583754, 5445082.329625776],
              [-13761205.468207575, 5453242.961363716],
              [-13770644.025192956, 5456829.459750598],
              [-13784359.031736648, 5456909.546671296],
              [-13797637.999834908, 5444216.43943209],
              [-13821451.055190599, 5444376.780698032],
              [-13820344.504288955, 5451656.364458823],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kings',
        GEOID: '06031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13393412.104518084, 4287857.81265509],
              [-13353781.25260077, 4325658.382886649],
              [-13353800.065594712, 4355936.1115625],
              [-13330978.011509221, 4356081.056245998],
              [-13321202.713064192, 4358412.749082296],
              [-13310827.068605315, 4368094.473557335],
              [-13305827.932912769, 4367915.859361345],
              [-13305884.260575112, 4356003.881257083],
              [-13299884.140021354, 4355933.068851543],
              [-13299852.413966477, 4337702.218121377],
              [-13305947.267406901, 4337816.127291307],
              [-13306704.573902767, 4307611.148600156],
              [-13306922.203507269, 4271704.61451851],
              [-13379951.12905238, 4271654.798984281],
              [-13382158.928513281, 4271664.67973331],
              [-13389036.357973982, 4287678.45900016],
              [-13393412.104518084, 4287857.81265509],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '20085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10690673.27448726, 4803088.006683488],
              [-10663193.946865452, 4803061.436417332],
              [-10663176.135746924, 4815644.716968876],
              [-10638149.844424235, 4815626.065498676],
              [-10638842.808254423, 4781875.886573352],
              [-10640923.36953735, 4779791.8590919245],
              [-10640971.348237881, 4752670.754559232],
              [-10690631.084400253, 4752733.8308194475],
              [-10690673.27448726, 4803088.006683488],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pierce',
        GEOID: '38069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11162746.729650225, 6197975.677832589],
              [-11148185.917615483, 6198042.600871921],
              [-11075531.136878928, 6197979.208934577],
              [-11075501.080616413, 6168790.402715871],
              [-11114874.116593048, 6168849.388538532],
              [-11111035.820550496, 6110424.259177733],
              [-11111039.605413185, 6081481.355823678],
              [-11139653.056007195, 6081488.654276089],
              [-11153989.893226461, 6081538.250741702],
              [-11153941.135289494, 6110491.831478831],
              [-11158368.756716305, 6168840.6746981535],
              [-11162717.89790211, 6168855.42120247],
              [-11162746.729650225, 6197975.677832589],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Frio',
        GEOID: '48163',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11066702.499383602, 3387276.077807583],
              [-10998911.155880317, 3387161.299631976],
              [-10998459.310067184, 3330855.080613223],
              [-11064682.71854265, 3330004.8496807017],
              [-11066161.597977838, 3329977.1987439627],
              [-11066702.499383602, 3387276.077807583],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lee',
        GEOID: '01081',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9539719.12923592, 3855211.245947443],
              [-9537837.718522023, 3857208.997466888],
              [-9528185.984711774, 3859326.0491172364],
              [-9526160.303937808, 3860360.4993199594],
              [-9493887.55904244, 3859617.3057595496],
              [-9476019.692371696, 3862383.1607962083],
              [-9474874.969251385, 3859579.723853232],
              [-9472012.165906655, 3849991.1177318282],
              [-9470625.055210056, 3843396.2806657855],
              [-9469932.161221182, 3840103.382517163],
              [-9462947.085812887, 3832274.599729099],
              [-9462282.601863671, 3830464.2462874507],
              [-9468757.29531535, 3825548.6260937005],
              [-9499319.950193152, 3824985.210524172],
              [-9498908.068077216, 3817361.67024863],
              [-9510474.385809619, 3817229.547520473],
              [-9510978.663102914, 3828739.7514661094],
              [-9516630.68760896, 3828719.5576206013],
              [-9539618.830374716, 3841792.82655381],
              [-9539719.12923592, 3855211.245947443],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washakie',
        GEOID: '56043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12083793.287163671, 5491548.097903086],
              [-11971431.40065861, 5491246.0961365905],
              [-11927528.106684651, 5491115.273181534],
              [-11925476.043191368, 5489324.443678976],
              [-11923837.53160638, 5437025.965715501],
              [-11923512.367373774, 5388433.163878956],
              [-11970729.976547122, 5388598.294343473],
              [-11977432.300448803, 5388603.665736999],
              [-11977438.089062324, 5410887.992355966],
              [-11990914.537937248, 5410786.305685549],
              [-11990876.466671396, 5424268.704970423],
              [-12017671.17942483, 5424284.573325412],
              [-12017656.819210516, 5437423.077861166],
              [-12041979.01475394, 5437469.671006558],
              [-12043127.497940455, 5441989.24628675],
              [-12056979.984055279, 5441736.719960334],
              [-12056942.803345352, 5450482.857560705],
              [-12070323.740097176, 5450498.307633411],
              [-12070045.552689685, 5464212.603852759],
              [-12076988.215371987, 5464183.514361406],
              [-12077079.83131291, 5477793.53489544],
              [-12083815.105783867, 5477738.21406795],
              [-12083793.287163671, 5491548.097903086],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Marquette',
        GEOID: '26103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9809091.814169336, 5847903.962428787],
              [-9809010.773580039, 5889734.762911024],
              [-9795174.094832908, 5889853.531693083],
              [-9801092.17292195, 5903857.460411836],
              [-9801071.32080891, 5928610.196171408],
              [-9785020.978036126, 5927344.967999659],
              [-9771283.150996817, 5921975.779424982],
              [-9761290.44558627, 5916280.487681256],
              [-9751064.971120471, 5906717.670696048],
              [-9748604.365095977, 5896566.583435769],
              [-9740792.185871085, 5884725.22393804],
              [-9727280.671356563, 5873796.375987713],
              [-9725624.014694577, 5862020.937583844],
              [-9704283.845670523, 5860443.305763035],
              [-9697748.789263593, 5861834.680154832],
              [-9697724.12203655, 5805873.8308725115],
              [-9711680.023958322, 5805882.348681632],
              [-9711833.533536125, 5777964.529757693],
              [-9725744.462383615, 5777997.212170896],
              [-9753489.954907913, 5778108.237150537],
              [-9753323.643588666, 5819964.023301821],
              [-9809184.877263641, 5819958.389361625],
              [-9809091.814169336, 5847903.962428787],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Aleutians East',
        GEOID: '02013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-17839254.416902278, 7345048.070827026],
              [-17832498.325686548, 7369275.133166337],
              [-17831964.32608921, 7384874.458523029],
              [-17826380.651750512, 7395234.831289506],
              [-17813930.12330274, 7401542.66478383],
              [-17796712.782939706, 7417354.737406084],
              [-17793736.99031182, 7410414.353821664],
              [-17790682.38348445, 7396499.146445864],
              [-17774417.04740668, 7397334.728793231],
              [-17757807.17750491, 7411200.6527283555],
              [-17754208.218367565, 7398597.240766447],
              [-17737477.344179295, 7370931.607862181],
              [-17722422.273605432, 7345356.19169397],
              [-17730117.34472601, 7335555.357497099],
              [-17734272.56735885, 7335866.585239938],
              [-17749668.16425505, 7350496.305236894],
              [-17755952.37214931, 7367169.397508705],
              [-17770512.070989147, 7369107.48478026],
              [-17783598.011090368, 7374712.939577399],
              [-17790371.356827177, 7367198.723555666],
              [-17814128.04935737, 7365925.375712519],
              [-17822171.995762087, 7354659.972938541],
              [-17836384.37779065, 7335530.405655241],
              [-17839254.416902278, 7345048.070827026],
            ],
          ],
          [
            [
              [-17906477.140446596, 7423925.117836783],
              [-17901168.091291685, 7434033.156403146],
              [-17887644.220313683, 7440319.101296074],
              [-17868727.81056267, 7435846.53466767],
              [-17848234.782863554, 7447130.906383302],
              [-17840124.49004232, 7452380.847527572],
              [-17826372.859386157, 7449835.518312758],
              [-17828265.958646588, 7435482.100910355],
              [-17845243.51682645, 7420949.482818274],
              [-17849102.62961378, 7410889.326646941],
              [-17863245.21432161, 7418143.694736808],
              [-17869852.582697645, 7411782.908982334],
              [-17865276.6837091, 7397259.47201091],
              [-17869586.417795163, 7387112.33263146],
              [-17884097.024739552, 7393031.8355905665],
              [-17892931.89612636, 7391288.045320112],
              [-17902554.241591044, 7384772.265646743],
              [-17904840.29865397, 7401645.273514677],
              [-17906477.140446596, 7423925.117836783],
            ],
          ],
          [
            [
              [-17969860.677392434, 7404010.526911978],
              [-17962148.574389767, 7404927.517318014],
              [-17959159.534742475, 7404567.6554394225],
              [-17960748.843112532, 7392689.476285852],
              [-17972674.945439175, 7396494.467749659],
              [-17969860.677392434, 7404010.526911978],
            ],
          ],
          [
            [
              [-18000042.06301427, 7410371.584257547],
              [-17980706.424060933, 7414769.099147138],
              [-17984799.97569587, 7402153.460309871],
              [-17999421.345533606, 7400482.518946507],
              [-18000042.06301427, 7410371.584257547],
            ],
          ],
          [
            [
              [-18127751.456395507, 7267424.098502336],
              [-18098914.47626398, 7255461.909546341],
              [-18072144.921715472, 7246533.929239172],
              [-18077033.40583417, 7240089.4232702805],
              [-18085738.144736238, 7235327.067736523],
              [-18101507.44116303, 7240380.6336927535],
              [-18118387.81742743, 7240962.704758927],
              [-18129685.521228552, 7251016.835768727],
              [-18127751.456395507, 7267424.098502336],
            ],
          ],
          [
            [
              [-18362015.198447123, 7280752.053562889],
              [-18352613.599532686, 7288498.55776224],
              [-18338974.958159678, 7293355.299419235],
              [-18331518.889985833, 7304358.693633016],
              [-18320616.25905754, 7327891.738854807],
              [-18320545.459861394, 7341580.565901381],
              [-18304851.63804936, 7348898.035504144],
              [-18294638.52004704, 7341347.698708241],
              [-18279205.519801937, 7348532.618804332],
              [-18269665.32812146, 7355932.643345521],
              [-18255748.49934096, 7358628.567902762],
              [-18244673.99111888, 7369461.24070291],
              [-18231248.637890227, 7372699.4082500255],
              [-18203754.504776143, 7369802.384653431],
              [-18192894.063934863, 7353090.703487802],
              [-18183345.078014616, 7356906.823677588],
              [-18176332.28405311, 7368265.412229511],
              [-18180103.899720676, 7386419.389145017],
              [-18159771.95132474, 7396806.776904307],
              [-18148667.72079862, 7395348.272073891],
              [-18129661.476218536, 7400455.212593609],
              [-18133948.055850517, 7411019.597710048],
              [-18124288.640995402, 7420203.063677522],
              [-18105185.65977782, 7438432.939210448],
              [-18096698.773119234, 7453004.300987703],
              [-18074441.108852062, 7480099.262335976],
              [-18058197.81403347, 7501071.454035372],
              [-18047214.476474352, 7508627.662986161],
              [-18039393.614329185, 7516901.280115578],
              [-18022509.3418826, 7525334.228670916],
              [-18012365.575923048, 7536936.7516209865],
              [-18001728.99857775, 7539374.529851098],
              [-17972580.99178895, 7549360.237339682],
              [-17939900.706237786, 7560847.900612812],
              [-17918513.337749638, 7563145.859610693],
              [-17900966.603013348, 7563190.8776242575],
              [-17901403.198056236, 7547917.805687079],
              [-17899418.816813357, 7535746.932225694],
              [-17873904.278204046, 7531333.660322484],
              [-17867717.029586267, 7532456.531874983],
              [-17862013.13019751, 7541956.699976117],
              [-17870528.06936778, 7550446.961545016],
              [-17876749.04779127, 7555041.732224618],
              [-17865521.25263037, 7573802.160114878],
              [-17856299.657332547, 7599922.085145344],
              [-17854079.167449694, 7614299.909248338],
              [-17835929.192392793, 7627779.440547374],
              [-17827399.225091267, 7638495.354996537],
              [-17809517.196048707, 7648472.72977246],
              [-17791977.029162377, 7667468.6268195985],
              [-17759350.62224476, 7684164.459146396],
              [-17724284.426047422, 7707066.159912952],
              [-17696763.91021402, 7727921.262835157],
              [-17687948.852200996, 7721242.458706278],
              [-17687955.42154653, 7710085.771261064],
              [-17705486.79419309, 7710085.162102316],
              [-17705486.237595633, 7692497.920222369],
              [-17730515.64586407, 7692496.907295355],
              [-17730515.200586103, 7674949.890404596],
              [-17765259.460816067, 7674948.677681681],
              [-17765258.90421861, 7657441.6621871805],
              [-17800003.164448574, 7657440.452238274],
              [-17800001.38333672, 7622545.334265312],
              [-17789565.848991796, 7622545.73574772],
              [-17789567.741423137, 7553225.417628287],
              [-17796421.014554337, 7553225.218690808],
              [-17796421.12587383, 7535991.669851491],
              [-17762289.34548221, 7535992.463822381],
              [-17762298.064101987, 7487261.334565088],
              [-17763487.6998006, 7484652.299446022],
              [-17777356.77251955, 7473937.675743874],
              [-17781496.29910419, 7473283.787872395],
              [-17784442.480747525, 7482191.733594849],
              [-17775407.345596783, 7490216.843797356],
              [-17774738.315457113, 7508997.933767571],
              [-17769650.01285244, 7519347.187144092],
              [-17775473.135415837, 7526385.055972908],
              [-17785548.217249572, 7529080.078729921],
              [-17794126.608529594, 7519204.978126249],
              [-17804115.306438476, 7519358.674895115],
              [-17814044.225780796, 7517178.0914834915],
              [-17817624.371924203, 7503219.027685459],
              [-17825639.5979003, 7495254.840760103],
              [-17842268.72607398, 7487354.087285565],
              [-17854821.11185583, 7479741.60636412],
              [-17862804.27781858, 7466053.163426235],
              [-17862631.064690903, 7460824.805654848],
              [-17869153.273656484, 7454491.170115415],
              [-17883934.49828299, 7461992.910979895],
              [-17885359.38776515, 7451615.492049893],
              [-17898103.688349124, 7450045.748671409],
              [-17904262.327857774, 7454238.788769826],
              [-17919827.686977435, 7454160.424562944],
              [-17931404.69138095, 7441554.313810967],
              [-17950710.60803025, 7431246.913267728],
              [-17976551.980664525, 7431917.823344566],
              [-17979679.724397343, 7436997.9444411015],
              [-17975682.464121938, 7447851.4682440655],
              [-17974677.026481096, 7458893.945798028],
              [-17964305.500843376, 7473246.182633197],
              [-17966143.496955864, 7484758.183853931],
              [-17976101.13672681, 7485893.624063697],
              [-17987787.79082876, 7483149.173398932],
              [-17995715.408365607, 7471406.111957623],
              [-18000369.342317197, 7462345.6182989385],
              [-17998858.291549172, 7441464.705262744],
              [-18008979.348332606, 7426055.687548499],
              [-18018544.47557902, 7413856.611655637],
              [-18013411.86781701, 7396202.444704147],
              [-18002433.762273964, 7391844.262176124],
              [-17986629.622846548, 7382043.725948857],
              [-17983703.478711557, 7374634.207885886],
              [-17999286.98290822, 7377116.291916773],
              [-18010636.11631408, 7372018.824598462],
              [-18023341.789034754, 7381360.573195393],
              [-18028925.686012436, 7383667.3057911405],
              [-18039688.722299274, 7376282.490886045],
              [-18046975.58484711, 7381864.711165061],
              [-18054946.95094384, 7374876.626286204],
              [-18058172.767148044, 7367491.601662616],
              [-18059992.729503024, 7354611.110263082],
              [-18060118.63184711, 7338926.717829243],
              [-18065254.690513328, 7331110.160378474],
              [-18072643.07643677, 7330111.364452511],
              [-18081428.63328916, 7341598.374817584],
              [-18082234.14112454, 7348146.876712201],
              [-18079789.231148247, 7368964.899075944],
              [-18086229.5089686, 7371951.58569837],
              [-18097130.69274351, 7362758.736339832],
              [-18099209.695553567, 7356435.718671358],
              [-18112622.135721285, 7353812.093884762],
              [-18126625.237107154, 7347682.306610011],
              [-18135468.346136276, 7352221.09131584],
              [-18140869.679149058, 7360612.07160404],
              [-18152379.780538615, 7347550.7673959285],
              [-18161728.16873645, 7339754.2065565325],
              [-18173417.605825674, 7330663.808249865],
              [-18184372.44559514, 7325111.575062892],
              [-18176399.96630351, 7318653.98033481],
              [-18165592.624859337, 7318303.101575222],
              [-18152752.70083277, 7306287.206022767],
              [-18149283.54022169, 7293654.26844119],
              [-18169921.171939343, 7299408.859513027],
              [-18188736.28095373, 7295867.263949615],
              [-18208794.383402318, 7289079.792393869],
              [-18234532.228910156, 7291635.006749569],
              [-18260656.687009525, 7289363.792073025],
              [-18285070.721132852, 7279377.888950268],
              [-18293971.048380245, 7270076.596851237],
              [-18295659.31977762, 7258722.671040948],
              [-18307219.848896496, 7250076.427719796],
              [-18327691.83721185, 7244589.295839483],
              [-18339215.630898774, 7245172.444041418],
              [-18352295.448427998, 7252276.374748401],
              [-18357037.881374776, 7265270.5033190865],
              [-18361552.888601862, 7271734.792661489],
              [-18362015.198447123, 7280752.053562889],
            ],
          ],
          [
            [
              [-18434755.361233115, 7178733.987462238],
              [-18419838.104188856, 7185253.797571062],
              [-18398971.15432017, 7192084.768091549],
              [-18383409.580063198, 7195020.276069376],
              [-18368596.518062312, 7195752.709118131],
              [-18354706.517279092, 7207399.667144235],
              [-18348144.121977337, 7212984.639491723],
              [-18341411.18521569, 7212532.5926866615],
              [-18347251.67361965, 7200279.91692066],
              [-18362833.396704458, 7181715.162726903],
              [-18377543.59949584, 7183897.193053382],
              [-18399738.702209186, 7177422.483539651],
              [-18429583.791649338, 7174617.833792409],
              [-18434755.361233115, 7178733.987462238],
            ],
          ],
          [
            [
              [-18485887.18634174, 7205288.727978014],
              [-18474554.97349847, 7212119.223015731],
              [-18464362.67224093, 7210958.248405664],
              [-18437351.888355874, 7226981.053276979],
              [-18420977.013899162, 7226288.431965623],
              [-18410431.38457784, 7207503.183376093],
              [-18428854.537665147, 7191433.573320171],
              [-18455038.774331067, 7183317.4344748],
              [-18465134.895548567, 7177056.825567821],
              [-18468087.0884444, 7182072.122249811],
              [-18484204.92619687, 7178529.0387351],
              [-18491530.19396903, 7193395.866894748],
              [-18485887.18634174, 7205288.727978014],
            ],
          ],
          [
            [
              [-18504154.04686397, 7167548.682608327],
              [-18498223.055713996, 7169801.010061805],
              [-18487415.936908804, 7164395.510619837],
              [-18496949.52202229, 7157976.3224338135],
              [-18504153.712905496, 7162623.386100162],
              [-18504154.04686397, 7167548.682608327],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Phillips',
        GEOID: '05107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10138826.491109988, 4048117.685480561],
              [-10136338.277851775, 4074089.90372068],
              [-10130373.4455766, 4074055.931121518],
              [-10130124.757834168, 4092006.209612776],
              [-10136171.075976605, 4092206.3202733453],
              [-10135853.1475109, 4115839.663034411],
              [-10084378.9036486, 4115254.180069445],
              [-10082572.345564974, 4114209.1961626527],
              [-10084123.64805621, 4111782.5026560314],
              [-10079895.733795883, 4105341.597824279],
              [-10082133.589519298, 4099498.4711289247],
              [-10083733.250601998, 4090579.207652389],
              [-10082800.28194966, 4084683.954548319],
              [-10090154.270150444, 4080463.4596097474],
              [-10092270.008392463, 4073975.988066648],
              [-10099920.66303621, 4077811.465095092],
              [-10103932.951442873, 4074927.5223467634],
              [-10102542.237044392, 4067709.833041342],
              [-10109237.881776625, 4066385.724009311],
              [-10112260.428590646, 4060550.602549277],
              [-10118336.135078652, 4058970.717916376],
              [-10117015.997237334, 4053584.5535170725],
              [-10118316.654167764, 4050434.611279371],
              [-10123178.978206122, 4048793.5860485737],
              [-10123848.760887122, 4044935.2780859075],
              [-10123928.328064518, 4044477.015419528],
              [-10127102.878937094, 4044749.945914688],
              [-10143198.786749875, 4044806.1518939743],
              [-10138826.491109988, 4048117.685480561],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Denali',
        GEOID: '02068',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-16968216.693474334, 9145306.419898957],
              [-16968218.2519472, 9175247.745429065],
              [-16989526.360957902, 9175246.50648817],
              [-16989526.91755536, 9185987.279416556],
              [-17010835.02656606, 9185986.038610142],
              [-17010836.585038934, 9218304.714572886],
              [-17017790.157031335, 9261623.84215414],
              [-16945992.313734904, 9261627.60429004],
              [-16946083.261758886, 9305211.26146033],
              [-16926699.866744, 9305212.52321437],
              [-16926769.552745234, 9349063.845193861],
              [-16901697.8430703, 9349065.368677123],
              [-16897628.11380639, 9367417.095551569],
              [-16872127.824091904, 9367418.622981241],
              [-16866721.03642407, 9355005.122752277],
              [-16840634.64959056, 9349069.685214808],
              [-16779118.38578329, 9441306.747846037],
              [-16601370.992609965, 9441317.294734377],
              [-16480482.81234657, 9437610.903081322],
              [-16450736.351975264, 9415848.693365796],
              [-16363955.016537555, 9415378.879181972],
              [-16363961.361748528, 9218839.208722103],
              [-16478137.421995046, 9218331.637759916],
              [-16478136.42011963, 9182430.773438837],
              [-16645174.655639661, 9182426.804837232],
              [-16778175.621015757, 9115760.558873488],
              [-16908764.404345855, 9050904.648790594],
              [-16908738.689543482, 9033345.529189259],
              [-17031620.15660902, 9033718.912965354],
              [-16968216.693474334, 9145306.419898957],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Madison',
        GEOID: '12079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9329315.495521443, 3551417.031444387],
              [-9319859.238737026, 3559505.079868521],
              [-9321555.079859773, 3568961.382463038],
              [-9306775.413706131, 3578571.1807457022],
              [-9307612.32018644, 3587579.7868114337],
              [-9295172.026583293, 3586816.734424898],
              [-9279338.533723233, 3585713.710852956],
              [-9273954.099896116, 3585338.6321019065],
              [-9269864.764865842, 3584491.023200341],
              [-9264215.968625028, 3558092.1850747312],
              [-9258549.917863142, 3553163.6569979186],
              [-9260929.260659356, 3551824.3751298883],
              [-9267041.813898817, 3537100.740436633],
              [-9280400.932030443, 3537071.097947834],
              [-9291756.299327793, 3537059.6276121023],
              [-9291700.750901887, 3542713.7017491497],
              [-9330825.878372528, 3542627.0558830434],
              [-9329315.495521443, 3551417.031444387],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Holmes',
        GEOID: '28051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10066838.625442775, 3908042.272340173],
              [-10055524.335037528, 3913611.3179095257],
              [-10055666.490027271, 3935568.244230976],
              [-10049882.106646672, 3940455.2983864225],
              [-10054544.834838038, 3945201.5098287696],
              [-10038192.112959996, 3939638.38142127],
              [-9990862.071100948, 3923807.0562379244],
              [-10007217.353327278, 3886361.41930166],
              [-10014956.173007736, 3879330.180851773],
              [-10057295.316816559, 3898275.5748134693],
              [-10059277.916947588, 3896710.489641924],
              [-10066838.625442775, 3908042.272340173],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Giles',
        GEOID: '51071',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9014746.45800619, 4481125.167699245],
              [-9007890.70724902, 4481868.315705169],
              [-8998564.360310359, 4485880.2631371245],
              [-9003881.981066063, 4492758.06821582],
              [-9001867.098282704, 4497801.954604562],
              [-9001087.874851473, 4497953.320795406],
              [-9000999.982922662, 4497970.394169603],
              [-8998672.006257957, 4498422.623468059],
              [-8991284.399570951, 4491137.263261441],
              [-8979583.496574178, 4497001.362794419],
              [-8966210.129547728, 4505481.319674898],
              [-8957831.433245175, 4499077.318353712],
              [-8955053.244902464, 4484991.1224757545],
              [-8953531.61878281, 4483298.029047336],
              [-8961310.624799445, 4477597.827514075],
              [-8973125.964232752, 4473293.830942098],
              [-8994780.722137786, 4464174.836140319],
              [-9000695.905920068, 4459683.861797833],
              [-9018446.021366037, 4477596.008867802],
              [-9014746.45800619, 4481125.167699245],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Anderson',
        GEOID: '45007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9237096.759555934, 4095136.687666293],
              [-9221723.871835856, 4112781.8763726284],
              [-9215869.913773509, 4119495.461871258],
              [-9182433.434921388, 4139285.462774524],
              [-9179223.760043345, 4133915.642916709],
              [-9180263.372767864, 4118726.1198879746],
              [-9175002.970230427, 4104166.619805189],
              [-9163152.119879559, 4093978.305348622],
              [-9210127.165731916, 4057770.218567085],
              [-9211129.261938587, 4061728.4559455365],
              [-9214429.520938538, 4067588.6814416684],
              [-9215061.73427035, 4068711.6403228594],
              [-9219860.94015743, 4077092.163439019],
              [-9221928.922337895, 4082607.9802723587],
              [-9225472.66700781, 4092291.1185752703],
              [-9231254.044762157, 4093681.199546408],
              [-9238559.06943917, 4092489.968671786],
              [-9237096.759555934, 4095136.687666293],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Eureka',
        GEOID: '32011',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12979057.248733979, 4775519.974233617],
              [-12979851.068022827, 4876455.305791621],
              [-12979208.531921968, 4912590.002004074],
              [-12979498.073917521, 5004447.730625686],
              [-12978405.027837424, 5007147.519353747],
              [-12978381.650744358, 5012400.368933902],
              [-12930666.666086145, 5012328.6838762695],
              [-12930630.932529598, 4963257.95502106],
              [-12913160.785602976, 4884469.513946179],
              [-12894689.765134629, 4884537.358755483],
              [-12894726.723205574, 4868466.907066342],
              [-12890225.296956364, 4844618.658299123],
              [-12894481.820325827, 4826698.728466035],
              [-12892297.17531901, 4807048.48689069],
              [-12899244.624739416, 4788602.937818163],
              [-12902716.123059807, 4744881.496795392],
              [-12979957.934733989, 4744826.222341154],
              [-12979057.248733979, 4775519.974233617],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Burnet',
        GEOID: '48053',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10958934.322985616, 3622550.6993880784],
              [-10955924.68923253, 3623176.2989647286],
              [-10958255.830689231, 3636585.6794851054],
              [-10899478.805591911, 3637284.8710556016],
              [-10891539.610828023, 3623573.138274218],
              [-10890220.140903652, 3620571.853030323],
              [-10905175.691852747, 3604941.725512626],
              [-10914863.381858524, 3584034.1084754653],
              [-10923049.149294516, 3566237.0986826997],
              [-10923286.927726848, 3558450.557858179],
              [-10948387.80310837, 3566187.2358524255],
              [-10948492.666068697, 3575529.895138116],
              [-10955078.883741481, 3577630.906045832],
              [-10958178.797601601, 3590391.2751710536],
              [-10950710.372964282, 3599091.8445507055],
              [-10957411.027073601, 3605028.4139328627],
              [-10951263.853472505, 3611324.9799638274],
              [-10960225.629078818, 3617031.580446069],
              [-10958934.322985616, 3622550.6993880784],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fairfax',
        GEOID: '51600',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8608201.303821003, 4702330.6565218],
              [-8601682.434440149, 4702443.745412337],
              [-8601714.93973146, 4698907.703743075],
              [-8605338.05519831, 4697752.97084672],
              [-8607812.798798135, 4699677.360300822],
              [-8608201.303821003, 4702330.6565218],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Colorado',
        GEOID: '48089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10783989.064034538, 3456424.456144879],
              [-10750105.860065864, 3498604.04266407],
              [-10746305.523969673, 3491643.0184084657],
              [-10732677.56926778, 3481073.075989421],
              [-10724871.401295392, 3481667.829726872],
              [-10715528.02247464, 3461062.1675938787],
              [-10706199.0038682, 3456565.3331590793],
              [-10720921.00652561, 3441297.702296334],
              [-10725545.774770617, 3427429.568699839],
              [-10757950.655901559, 3407223.897267927],
              [-10759971.215978947, 3409274.598925148],
              [-10749071.813315885, 3418409.573739703],
              [-10774962.166526113, 3449340.581463748],
              [-10783989.064034538, 3456424.456144879],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jennings',
        GEOID: '18079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9551193.8310274, 4740151.815774653],
              [-9538609.05127373, 4740433.372994302],
              [-9525199.1714543, 4740706.3273894],
              [-9511143.304629795, 4749730.890073766],
              [-9511682.424923709, 4709216.933557685],
              [-9522068.867373195, 4709105.199887083],
              [-9530127.841909172, 4696527.639634727],
              [-9538281.326692834, 4695264.452649654],
              [-9543775.166202463, 4697608.638452016],
              [-9550695.45366712, 4694136.132495411],
              [-9551079.171951883, 4731493.5266292365],
              [-9551193.8310274, 4740151.815774653],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Coweta',
        GEOID: '13077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9463866.362167856, 3951919.923283907],
              [-9454963.029294211, 3953509.2576268646],
              [-9445538.164606197, 3963389.7695599366],
              [-9428669.365568839, 3963378.5545105925],
              [-9420716.255868603, 3963333.8279339997],
              [-9418690.909053111, 3962195.4279604917],
              [-9420649.018896164, 3953829.4185196543],
              [-9406221.678930884, 3929522.487589934],
              [-9406758.795473963, 3924682.209381832],
              [-9445721.507807534, 3925019.5408017025],
              [-9446834.591395976, 3920706.560137307],
              [-9446809.655830039, 3925055.2040241393],
              [-9455367.898282224, 3925166.319615465],
              [-9457553.211205987, 3932136.1194885164],
              [-9463866.362167856, 3951919.923283907],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'El Dorado',
        GEOID: '06017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13485355.43606337, 4680498.750053374],
              [-13476114.137215676, 4699900.192822635],
              [-13474168.049877627, 4709580.32685263],
              [-13473833.089529831, 4709601.930564382],
              [-13463010.497315418, 4716278.392294422],
              [-13453951.539793644, 4714834.959811674],
              [-13448763.160966752, 4721690.623706828],
              [-13441427.206523476, 4723154.516250977],
              [-13429856.992608894, 4713711.048487141],
              [-13421094.924169065, 4709318.081487524],
              [-13410768.705564097, 4716731.949937156],
              [-13406796.15821565, 4725706.48392324],
              [-13378832.590808889, 4726115.036116047],
              [-13374331.387198664, 4731314.159329468],
              [-13358558.779113531, 4731344.394105871],
              [-13358451.773156494, 4721610.551919035],
              [-13347687.289716275, 4712125.302827191],
              [-13344678.546519114, 4703094.853084018],
              [-13354436.924401542, 4689634.097507938],
              [-13366397.535770336, 4679184.485231583],
              [-13369284.050166603, 4680077.761739648],
              [-13373932.974741114, 4670003.3344508605],
              [-13382026.235680258, 4668720.34469853],
              [-13391926.323274467, 4657289.566056564],
              [-13415178.18191391, 4651933.051818951],
              [-13428203.45289265, 4650748.912060371],
              [-13448903.31220566, 4659152.095941143],
              [-13461544.642260652, 4652430.7045002915],
              [-13472720.451219352, 4651481.372560541],
              [-13482862.770025527, 4681231.776262075],
              [-13485355.43606337, 4680498.750053374],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Decatur',
        GEOID: '13087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9446957.582110042, 3595337.9467518535],
              [-9438425.628380941, 3606995.457252671],
              [-9432195.633078696, 3641738.0456980397],
              [-9422602.453320606, 3643078.561232577],
              [-9411245.082272422, 3643016.8220597757],
              [-9407396.210878244, 3642935.066872014],
              [-9392761.482701614, 3642997.8454497],
              [-9393222.588465454, 3592403.0276926225],
              [-9403660.440086713, 3592915.111029001],
              [-9441339.638691438, 3595098.799548517],
              [-9446957.582110042, 3595337.9467518535],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Charles',
        GEOID: '24017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8599050.396399833, 4655756.976975781],
              [-8592057.639946673, 4664635.459548677],
              [-8585970.356231622, 4666582.101457865],
              [-8586094.58878335, 4669524.919898922],
              [-8586350.734931663, 4675055.631266441],
              [-8581150.307457095, 4679543.139022089],
              [-8576905.83273531, 4666858.35093741],
              [-8572828.422426533, 4671941.876669379],
              [-8556345.0114663, 4672893.252415099],
              [-8543474.251940781, 4666911.635605322],
              [-8542740.879135435, 4658717.608179913],
              [-8535472.829581544, 4655406.170459606],
              [-8535323.77278337, 4650248.069528966],
              [-8545806.951870354, 4652143.889711462],
              [-8557291.783735497, 4634658.230940387],
              [-8552346.541068092, 4615979.490225175],
              [-8556493.84562549, 4617488.698695637],
              [-8562937.574350059, 4623501.41494285],
              [-8568872.573001703, 4628608.330855907],
              [-8571783.132407984, 4639206.165695785],
              [-8573423.202465842, 4642562.829504115],
              [-8580004.188122557, 4639598.051450527],
              [-8585329.267284144, 4637599.846233518],
              [-8595110.131703714, 4633341.034294947],
              [-8600539.628547667, 4641176.971228176],
              [-8599050.396399833, 4655756.976975781],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Alexandria',
        GEOID: '51510',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8583934.879342468, 4699271.300250418],
              [-8581375.198971167, 4696972.028416076],
              [-8575949.638024257, 4698960.568712582],
              [-8575942.919139948, 4691870.298312257],
              [-8575968.955108212, 4690969.322021806],
              [-8587542.410080606, 4693866.999901729],
              [-8583934.879342468, 4699271.300250418],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gila',
        GEOID: '04007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12431538.67847824, 4069986.698012486],
              [-12429894.712238206, 4080784.7677724636],
              [-12418158.520962851, 4087961.4142865827],
              [-12418210.28452607, 4092321.5002877545],
              [-12412392.06002027, 4095876.591257888],
              [-12409011.39840437, 4091043.108613623],
              [-12414088.79169894, 4086740.606143409],
              [-12403558.969745314, 4087662.8473416725],
              [-12403054.358493548, 4079575.6606472204],
              [-12400682.808061687, 4086156.2306532105],
              [-12384326.969237905, 4089829.256808906],
              [-12372837.907232111, 4079292.151582333],
              [-12367223.731352935, 4082158.051787606],
              [-12351884.128160603, 4071106.0966233723],
              [-12339549.483302746, 4064737.8098435774],
              [-12332319.505014705, 4069137.452110978],
              [-12328709.079969805, 4064213.7013437976],
              [-12328708.41205286, 4028808.471363485],
              [-12245217.458124017, 4028808.2028121995],
              [-12245216.233609617, 3972134.5480166203],
              [-12245215.899651146, 3957311.073097134],
              [-12264010.080601264, 3957283.8508866043],
              [-12283098.256326567, 3952127.9982883534],
              [-12294296.440502917, 3946074.5433653323],
              [-12296038.590533832, 3934561.7536973003],
              [-12289842.77031526, 3921430.090614757],
              [-12295128.77633558, 3921152.5922752526],
              [-12311207.540946776, 3913093.9217531565],
              [-12315556.793452071, 3914269.7948625186],
              [-12325915.517348347, 3904585.1675317343],
              [-12332049.889208002, 3893137.0276852883],
              [-12351509.426754594, 3932413.8798750145],
              [-12353647.76285324, 3940799.8837704556],
              [-12360913.586017318, 3957324.817668948],
              [-12373534.767244479, 3985594.103748347],
              [-12381182.527581466, 3975544.3405254795],
              [-12388355.39897073, 3982888.1214684974],
              [-12399816.185825862, 3998852.6023038123],
              [-12397909.616907045, 4005183.754056179],
              [-12406657.881730016, 4018048.5320741045],
              [-12406009.445696145, 4028959.9352952433],
              [-12411541.91306908, 4028777.4537319667],
              [-12409657.830687404, 4049110.2307114084],
              [-12436676.963534275, 4050498.648219664],
              [-12431538.67847824, 4069986.698012486],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yankton',
        GEOID: '46135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10868956.337050285, 5337695.744584716],
              [-10842428.345796794, 5337794.80204849],
              [-10815862.283277452, 5337880.123573647],
              [-10815862.17195796, 5324635.938801872],
              [-10815841.800491145, 5283368.860372533],
              [-10816366.158971634, 5280307.370487418],
              [-10821808.191239191, 5284635.723145822],
              [-10824469.951583551, 5289644.753639895],
              [-10831617.442128915, 5291546.232028348],
              [-10835970.702135874, 5290061.281254312],
              [-10844418.181694724, 5291585.416773658],
              [-10848326.720335964, 5288568.063088515],
              [-10851971.306698995, 5289168.603826988],
              [-10855425.675583344, 5289737.836769467],
              [-10864699.925000314, 5290113.974910262],
              [-10868727.696884098, 5289442.809730268],
              [-10868956.337050285, 5337695.744584716],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Arroyo',
        GEOID: '72015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7356243.867627183, 2041406.5813860754],
              [-7353460.88035735, 2042281.8163404246],
              [-7349085.115349731, 2034611.1078331247],
              [-7349758.060135094, 2034727.4067139719],
              [-7351728.860400097, 2029934.9061260277],
              [-7354667.62833523, 2031182.666665527],
              [-7357500.775997729, 2040023.4441056727],
              [-7356243.867627183, 2041406.5813860754],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Louis',
        GEOID: '29510',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10054177.369198931, 4664538.315233093],
              [-10046778.296604374, 4681484.167468419],
              [-10037299.401890047, 4689129.2229658505],
              [-10042121.245707037, 4682506.208844982],
              [-10040484.849192377, 4677014.10075553],
              [-10038961.373113248, 4673139.00590918],
              [-10038915.244372189, 4673021.696357855],
              [-10039293.730640886, 4666181.346404513],
              [-10046463.039806448, 4656669.414844018],
              [-10047173.468292104, 4654694.87589059],
              [-10053661.959956557, 4661512.062594679],
              [-10054177.369198931, 4664538.315233093],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bedford',
        GEOID: '42009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8767215.964403126, 4840324.512755308],
              [-8767879.98516571, 4874229.551875987],
              [-8756214.036489047, 4901307.695374006],
              [-8755485.895699767, 4906959.784974511],
              [-8751981.001532141, 4913579.084929904],
              [-8732779.725204192, 4901520.912013028],
              [-8731265.000892967, 4909969.572656208],
              [-8715065.343314767, 4901187.234383798],
              [-8711563.343453903, 4909324.718056655],
              [-8709225.30018877, 4898628.4417895805],
              [-8697933.16236219, 4889967.762437423],
              [-8705951.616603522, 4878486.004208385],
              [-8703128.442997513, 4874508.798238705],
              [-8716205.143581, 4840616.722679207],
              [-8725274.794961123, 4825727.844333652],
              [-8763468.616384555, 4825788.322071034],
              [-8772899.773921257, 4825780.934408848],
              [-8767215.964403126, 4840324.512755308],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Shelby',
        GEOID: '29205',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10273440.030629717, 4859040.655739759],
              [-10261133.215644557, 4859331.673438582],
              [-10236130.635373406, 4858595.723007589],
              [-10223621.330234494, 4858422.779664671],
              [-10224332.661780663, 4816441.702230431],
              [-10261985.700305052, 4817080.6955001475],
              [-10262175.500036854, 4808574.255349147],
              [-10274712.857687447, 4808756.594536354],
              [-10273440.030629717, 4859040.655739759],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lexington',
        GEOID: '51678',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8845619.39496374, 4548918.299704591],
              [-8844704.014790945, 4550246.901262286],
              [-8840431.572734298, 4549608.77947666],
              [-8841334.596443614, 4549602.1589921],
              [-8844964.39107991, 4546312.017434944],
              [-8845619.39496374, 4548918.299704591],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Perry',
        GEOID: '05105',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10386741.230998093, 4146987.419728329],
              [-10357223.86613884, 4174339.5922543765],
              [-10310280.659510298, 4174488.1314566717],
              [-10303140.404731834, 4179285.711046503],
              [-10307935.714436736, 4163314.0644922648],
              [-10301988.915919071, 4157539.1907485784],
              [-10303156.65737749, 4155272.881140672],
              [-10325286.415549738, 4151826.6331276894],
              [-10323744.974560725, 4143984.5965470597],
              [-10360936.593795776, 4144612.96130464],
              [-10361081.420453297, 4132925.224054372],
              [-10384748.723432384, 4133101.536046517],
              [-10386741.230998093, 4146987.419728329],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chesterfield',
        GEOID: '51041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8666795.430994952, 4497582.738871634],
              [-8661658.593092294, 4498686.012337283],
              [-8644559.474028487, 4518013.448982266],
              [-8637887.317708809, 4516856.8854919765],
              [-8638041.717842538, 4513894.722413758],
              [-8618452.381769683, 4501611.489028066],
              [-8618197.90541373, 4497988.235510317],
              [-8602445.752188519, 4488317.630422185],
              [-8599393.371750966, 4492487.262919533],
              [-8601732.194252534, 4483910.842810216],
              [-8603217.64153768, 4482826.894997162],
              [-8603581.099675119, 4483364.375822105],
              [-8603866.07757155, 4482947.825788954],
              [-8604607.13142176, 4482777.767260004],
              [-8604465.53302947, 4482352.423023068],
              [-8605521.287080156, 4482646.761082296],
              [-8607120.725523874, 4482171.03762025],
              [-8607707.935837807, 4482233.878351063],
              [-8608894.490290172, 4483044.123524617],
              [-8608966.95927868, 4482830.674063366],
              [-8610908.816476079, 4481946.969382964],
              [-8611726.458135955, 4477834.254204002],
              [-8613610.65183712, 4474786.015904039],
              [-8613544.305420607, 4473290.7544903485],
              [-8614331.445540007, 4472459.725888496],
              [-8616432.712248221, 4472063.042254954],
              [-8616537.241250077, 4472241.596981235],
              [-8614182.834019799, 4473009.402790726],
              [-8613812.362754438, 4476469.907440384],
              [-8611934.291625265, 4478509.848243738],
              [-8612588.96155062, 4480802.77024469],
              [-8613712.286532214, 4478837.797693766],
              [-8619657.971854974, 4477695.6151877],
              [-8617732.255983742, 4475542.398041716],
              [-8617965.470316954, 4471663.017938595],
              [-8621406.0218189, 4470245.088260348],
              [-8629667.709147617, 4469396.26716416],
              [-8644026.364987077, 4476124.687041317],
              [-8644203.36297744, 4476223.999692161],
              [-8656049.983187659, 4476628.953222226],
              [-8669247.02014069, 4490129.88456748],
              [-8666795.430994952, 4497582.738871634],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cattaraugus',
        GEOID: '36009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8801005.437360555, 5241890.836067326],
              [-8793316.043534009, 5240591.043944185],
              [-8785308.164644303, 5227478.807251189],
              [-8760391.634339537, 5231938.031367895],
              [-8734565.84643397, 5241661.048069757],
              [-8733063.812544696, 5239074.5439982815],
              [-8717300.082092442, 5239377.824491603],
              [-8717221.040850913, 5160840.305554305],
              [-8749339.056057144, 5160961.019264107],
              [-8785207.015704634, 5160845.108509315],
              [-8792354.577092027, 5160822.010646973],
              [-8801059.694832126, 5160805.400138249],
              [-8801005.437360555, 5241890.836067326],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Juan',
        GEOID: '72127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7361475.5881900545, 2092890.5027031559],
              [-7351476.833072943, 2090809.2810776916],
              [-7350907.082940557, 2090883.0861684873],
              [-7346130.714527596, 2084254.110377973],
              [-7347036.966502144, 2082082.8206439766],
              [-7349898.767971456, 2082054.9023957502],
              [-7351710.047406155, 2074140.4581455737],
              [-7354444.944655963, 2073082.4696962489],
              [-7356044.828377644, 2072375.924042815],
              [-7358181.272044947, 2077691.4485794576],
              [-7359140.178138642, 2088985.7941529679],
              [-7361491.4684231775, 2092122.636544927],
              [-7361475.5881900545, 2092890.5027031559],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mitchell',
        GEOID: '19131',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10355423.039664652, 5388321.159774422],
              [-10338271.945470266, 5388319.906953217],
              [-10302970.753827866, 5388435.3123977035],
              [-10302967.090361176, 5388435.317970392],
              [-10303106.563606633, 5344420.457687494],
              [-10355394.552946633, 5344420.3049472105],
              [-10355400.230240664, 5350948.573913397],
              [-10355423.039664652, 5388321.159774422],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calhoun',
        GEOID: '26025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9495427.775517058, 5224079.749207861],
              [-9470128.19484447, 5224317.856120455],
              [-9430819.50153351, 5224331.729538986],
              [-9429824.639244292, 5171525.764394775],
              [-9442841.783900203, 5171840.987826764],
              [-9494843.014231918, 5171703.769873782],
              [-9495427.775517058, 5224079.749207861],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fairbanks North Star',
        GEOID: '02090',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-16548888.973397512, 9663871.897372406],
              [-16426055.93031047, 9663877.207207648],
              [-16395036.086283978, 9682450.862023696],
              [-16353182.96337196, 9683412.689994123],
              [-16313721.539719632, 9699839.198413754],
              [-16309238.592505896, 9723390.2135923],
              [-16296843.946442503, 9719458.568289833],
              [-16274785.544063851, 9728858.2427835],
              [-16265931.525724627, 9715597.058932146],
              [-16251202.95521726, 9716788.940027593],
              [-16253524.968475718, 9703691.241033113],
              [-16268118.953718716, 9691888.753377689],
              [-16261540.973688249, 9673996.014526336],
              [-16247065.543702945, 9662705.954747027],
              [-16218072.71628431, 9658352.635695053],
              [-16211889.58648769, 9644498.35659954],
              [-16228010.318546917, 9629476.26937003],
              [-16213718.56572142, 9617412.8754995],
              [-16182793.009303633, 9626700.9125792],
              [-16166478.136052461, 9626626.967350755],
              [-16139490.951899452, 9644547.602275085],
              [-16106247.946322326, 9636385.738779739],
              [-16079396.683267573, 9623780.666995488],
              [-16066895.393131997, 9636799.359246697],
              [-16027072.18113459, 9639867.098493736],
              [-16017102.518858636, 9632400.202786794],
              [-16040969.862962676, 9613743.057294354],
              [-16028553.843557049, 9599748.458071899],
              [-16044234.08439121, 9555653.523552418],
              [-16033322.770542635, 9547419.047845623],
              [-16040623.770665802, 9540664.11115418],
              [-16037690.947361363, 9525509.681736566],
              [-16038078.561828304, 9517839.468451468],
              [-16065181.406932252, 9515513.513539376],
              [-16081224.326667415, 9499446.73720641],
              [-16091513.587201439, 9503957.249409769],
              [-16118844.525942022, 9495566.655654902],
              [-16139693.219414221, 9495647.792980399],
              [-16150541.971708972, 9479785.421516262],
              [-16182951.750897506, 9473706.522910543],
              [-16182968.894099085, 9466321.31210927],
              [-16208464.953672923, 9458025.80387828],
              [-16223702.810850672, 9467583.532313269],
              [-16244400.666412845, 9458397.37516148],
              [-16253065.552937213, 9447204.654627971],
              [-16278325.503871078, 9442737.409620462],
              [-16278508.40179445, 9429128.897979643],
              [-16291014.478668133, 9420293.350014914],
              [-16306796.576836368, 9421679.494661221],
              [-16325578.290003516, 9415382.979989253],
              [-16363955.016537555, 9415378.879181972],
              [-16450736.351975264, 9415848.693365796],
              [-16480482.81234657, 9437610.903081322],
              [-16494889.22424758, 9452312.614362923],
              [-16505436.300722284, 9475756.88486507],
              [-16520159.416574601, 9485982.162542881],
              [-16522586.292793382, 9497266.845989607],
              [-16536592.956402957, 9508257.176895406],
              [-16549118.959465489, 9501400.030723734],
              [-16548888.973397512, 9663871.897372406],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Telfair',
        GEOID: '13271',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9262420.496558024, 3750233.834240232],
              [-9233068.552462088, 3779608.309553606],
              [-9232233.656281138, 3783447.080306356],
              [-9231487.704373334, 3781080.569479656],
              [-9227011.770287517, 3773802.13701053],
              [-9208692.033007158, 3763673.713103288],
              [-9200072.676154526, 3752667.463948203],
              [-9220132.003117511, 3738840.014130499],
              [-9221302.082285238, 3739202.102519556],
              [-9224836.698756907, 3734774.075746586],
              [-9239038.839392312, 3734595.453582184],
              [-9254953.185115611, 3738978.3505281755],
              [-9259273.494553298, 3743356.0212628795],
              [-9262253.183363361, 3748182.84827815],
              [-9262420.496558024, 3750233.834240232],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sarasota',
        GEOID: '12115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9200352.268064393, 3172247.059667638],
              [-9156280.145073906, 3171811.1404392123],
              [-9156427.643399207, 3149796.899639459],
              [-9155882.511852793, 3149594.122543087],
              [-9134487.46231978, 3149453.8075248254],
              [-9134595.66486483, 3127485.167126611],
              [-9156611.097920034, 3127592.1439951444],
              [-9156642.71265542, 3116634.87201546],
              [-9169297.556024864, 3116736.899325148],
              [-9178589.572904296, 3133390.1108806827],
              [-9185704.271264443, 3149460.9801091678],
              [-9188279.489299886, 3155282.5131746153],
              [-9196167.81105648, 3167119.8266543346],
              [-9200352.268064393, 3172247.059667638],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lowndes',
        GEOID: '13185',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9289532.80381869, 3609129.8931970294],
              [-9278079.364049949, 3613743.4849359337],
              [-9288670.745681984, 3621630.4596183514],
              [-9292463.17809433, 3636900.9733563294],
              [-9272362.774239244, 3636292.2178723575],
              [-9261555.766753541, 3636048.9059294513],
              [-9259609.45677651, 3634921.523436014],
              [-9259495.688256921, 3626274.007142194],
              [-9244296.013664516, 3625906.415597377],
              [-9241679.449033422, 3613213.1447173757],
              [-9249322.97922976, 3613110.0616518566],
              [-9251008.467639862, 3610636.842837702],
              [-9254324.229992628, 3605461.087576065],
              [-9254726.07756969, 3583999.303032056],
              [-9273954.099896116, 3585338.6321019065],
              [-9279338.533723233, 3585713.710852956],
              [-9293225.048689319, 3601222.077432148],
              [-9289532.80381869, 3609129.8931970294],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sussex',
        GEOID: '10005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8429457.233108558, 4697324.917876361],
              [-8410745.574039165, 4698156.969537831],
              [-8402854.357975809, 4707993.795778243],
              [-8394654.341644997, 4709706.229925399],
              [-8391335.462346485, 4716211.677508773],
              [-8383098.16617682, 4714177.110662906],
              [-8382641.744074003, 4712937.894965222],
              [-8382811.617616953, 4709240.110222071],
              [-8374791.15962479, 4699386.78488019],
              [-8366664.057560445, 4691662.923187479],
              [-8361577.758706611, 4690635.39320176],
              [-8358921.898295265, 4692663.418597518],
              [-8356955.105531929, 4678290.145890087],
              [-8354970.056372102, 4655462.668709125],
              [-8354409.674055449, 4643371.747892376],
              [-8369606.565660584, 4643336.069423092],
              [-8386953.74021088, 4643538.560733269],
              [-8402315.34900139, 4643717.878130439],
              [-8426186.477968117, 4644631.945551919],
              [-8426927.977096291, 4656383.47758393],
              [-8427083.32514276, 4658949.075832898],
              [-8427726.026525788, 4669570.237921713],
              [-8427726.474745816, 4669577.414014843],
              [-8429457.233108558, 4697324.917876361],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Tammany',
        GEOID: '22103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10047212.77657694, 3595390.77237221],
              [-10018151.932949431, 3589358.7436973713],
              [-9999404.657481456, 3589813.817124796],
              [-9998924.607860632, 3586604.6648544767],
              [-9995562.313960714, 3574641.9421114544],
              [-9986749.03855512, 3565078.161941463],
              [-9985350.76365306, 3562046.5827400074],
              [-9982966.513577454, 3556879.0088055255],
              [-9978034.392218368, 3543235.1367359357],
              [-9975078.525779335, 3531486.1448986796],
              [-9965822.198800381, 3526805.1798159922],
              [-9974792.819469893, 3521920.5125791878],
              [-9977015.373599647, 3523295.235116382],
              [-9983720.480488598, 3526108.907807977],
              [-9996202.401032774, 3524230.4388062456],
              [-10007982.22954852, 3529111.3788987803],
              [-10023237.7865253, 3523503.924792658],
              [-10030789.9234197, 3524769.0104076993],
              [-10036148.509748014, 3527946.185309402],
              [-10036636.089117689, 3533707.384070041],
              [-10045877.054006912, 3550112.897554704],
              [-10045950.079592872, 3568447.5384121914],
              [-10045823.954609804, 3580394.39228636],
              [-10047212.77657694, 3595390.77237221],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kenosha',
        GEOID: '55059',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9830166.82016632, 5252920.594976369],
              [-9817062.512349116, 5253017.24781359],
              [-9817077.317841392, 5261832.55643931],
              [-9774075.60655814, 5261620.912486997],
              [-9775484.793857321, 5257944.074701052],
              [-9775328.835250719, 5248142.582728739],
              [-9773904.391046528, 5234953.885610017],
              [-9784760.464884687, 5235095.412814201],
              [-9818310.406573858, 5235532.806211232],
              [-9820260.387361137, 5235558.228896999],
              [-9830033.348096859, 5235510.697209638],
              [-9830166.82016632, 5252920.594976369],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Polk',
        GEOID: '13233',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9509030.36888143, 4039658.3595014215],
              [-9490835.28992438, 4042327.301965002],
              [-9467374.373281224, 4041755.1605887],
              [-9467393.854192114, 4039936.356164596],
              [-9453556.396208547, 4039884.744051139],
              [-9459783.719843011, 4022277.15948131],
              [-9467704.101612953, 4022443.835637959],
              [-9467757.201010061, 4015984.2969759065],
              [-9485844.503193645, 4015276.6756694675],
              [-9505200.688805385, 4015610.563124312],
              [-9506558.834040457, 4023986.3094166615],
              [-9509030.36888143, 4039658.3595014215],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ocean',
        GEOID: '34029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8299213.685657458, 4877447.907121867],
              [-8282917.068802776, 4891026.986907788],
              [-8266649.061057229, 4890164.856129359],
              [-8254819.361409609, 4880429.073118968],
              [-8249641.891892814, 4885859.988686502],
              [-8241534.313292735, 4880860.768468984],
              [-8244781.794244271, 4862913.893658308],
              [-8246241.415407552, 4853016.152041313],
              [-8247766.269792438, 4836918.058737572],
              [-8248731.845518304, 4831675.207150011],
              [-8248934.901806787, 4830573.009517891],
              [-8258901.447136999, 4811614.061198694],
              [-8270037.997736029, 4794755.01226226],
              [-8280032.33551836, 4793336.399601815],
              [-8284106.294922919, 4801810.836414741],
              [-8281960.83437686, 4804600.750884958],
              [-8281024.414820309, 4833050.871376883],
              [-8285979.801952973, 4844916.359660265],
              [-8299213.685657458, 4877447.907121867],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Paulding',
        GEOID: '13223',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9467704.101612953, 4022443.835637959],
              [-9459783.719843011, 4022277.15948131],
              [-9453556.396208547, 4039884.744051139],
              [-9452142.52735598, 4038917.0602534045],
              [-9432972.754443925, 4039468.361133688],
              [-9433173.129527353, 4021768.4230676703],
              [-9431458.141452191, 4015864.658152211],
              [-9431448.011378529, 4002804.9925762573],
              [-9432208.8800981, 4000447.083934667],
              [-9451212.675649384, 3999393.6699236357],
              [-9458951.050051881, 4001927.116617714],
              [-9466378.620436078, 4003578.297165054],
              [-9466260.065178385, 4014388.18741781],
              [-9467757.201010061, 4015984.2969759065],
              [-9467704.101612953, 4022443.835637959],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nemaha',
        GEOID: '31127',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10694130.857871301, 4942258.507848747],
              [-10654642.31365193, 4942347.316554126],
              [-10652688.169921836, 4937932.5864183],
              [-10651534.566038745, 4933507.6115647685],
              [-10647644.506432975, 4923677.675143519],
              [-10646710.424585728, 4919330.1142093055],
              [-10648124.404757785, 4912930.343962753],
              [-10641993.817760816, 4911065.5427165795],
              [-10636943.809060981, 4908343.2129397085],
              [-10636374.966594394, 4904441.024771265],
              [-10636340.269988948, 4904203.06032728],
              [-10687803.903292576, 4904013.204757831],
              [-10694100.133691842, 4904094.312935212],
              [-10694130.857871301, 4942258.507848747],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Polk',
        GEOID: '27119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10814225.993571049, 6135721.584907471],
              [-10742424.703881636, 6135869.234733762],
              [-10742431.160412105, 6110458.378130243],
              [-10740388.336436555, 6100800.475576637],
              [-10740337.352109773, 6081509.72029846],
              [-10725934.391112976, 6081493.1328749545],
              [-10725825.186692508, 6067069.535788744],
              [-10668545.74270483, 6067167.900616678],
              [-10668506.780883051, 6081640.927945396],
              [-10654293.619618058, 6081703.13201705],
              [-10654346.05109822, 6096181.71116745],
              [-10640156.823523749, 6095876.152562982],
              [-10639787.688092276, 6052737.001385427],
              [-10636954.94101006, 6052725.924863237],
              [-10637050.230494179, 6024054.488607022],
              [-10694198.651441194, 6023929.756077843],
              [-10781956.075030606, 6023935.890425903],
              [-10781746.087614547, 6035945.620375673],
              [-10784896.763162468, 6048662.462116643],
              [-10786134.335486619, 6052480.750420442],
              [-10790031.931272762, 6064517.079683157],
              [-10797585.84927901, 6081007.135561686],
              [-10802148.835206628, 6095762.007030648],
              [-10805670.204658892, 6111225.840761675],
              [-10809747.726287158, 6122067.69733764],
              [-10814326.185623994, 6134942.497858814],
              [-10814225.993571049, 6135721.584907471],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clinton',
        GEOID: '17027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9986131.883298162, 4672376.784370126],
              [-9973681.243530897, 4672508.215382927],
              [-9973928.150161475, 4684958.784111734],
              [-9961050.822786001, 4684572.863253002],
              [-9935730.425368635, 4684784.946649933],
              [-9922840.518890701, 4683973.31622976],
              [-9923453.332687518, 4650741.088430146],
              [-9946561.589183839, 4652985.008221094],
              [-9961077.31682481, 4645834.999519604],
              [-9971159.189147484, 4647859.980483784],
              [-9985830.875395056, 4638329.094911584],
              [-9986131.883298162, 4672376.784370126],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Champaign',
        GEOID: '17019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9847675.483636757, 4886627.381457133],
              [-9847368.68712013, 4906997.28673953],
              [-9847317.368834876, 4924072.484931455],
              [-9834741.60595996, 4924009.191515109],
              [-9788588.545077067, 4924152.881312816],
              [-9789670.125249617, 4898763.014145533],
              [-9789173.862959659, 4848490.921472191],
              [-9834986.508839706, 4848439.859693945],
              [-9847567.83768916, 4848387.782752585],
              [-9847675.483636757, 4886627.381457133],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Butler',
        GEOID: '42019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8923959.262095107, 5012410.988987396],
              [-8916341.780659612, 5022643.196397294],
              [-8905534.66185442, 5037724.266669514],
              [-8892818.302462632, 5037813.294476711],
              [-8871605.037658084, 5037872.745394877],
              [-8871129.369473923, 5037551.241543683],
              [-8871376.387423994, 4963750.345321573],
              [-8881776.744809829, 4964014.382395445],
              [-8886483.110241588, 4963945.400371323],
              [-8913168.50725506, 4964399.51650388],
              [-8922084.753189638, 4964417.570037108],
              [-8922433.18319582, 4971726.850470657],
              [-8923207.187615307, 4991000.771909702],
              [-8923959.262095107, 5012410.988987396],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carroll',
        GEOID: '33003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7966535.164782777, 5448925.1599401245],
              [-7943977.605807411, 5452442.59741482],
              [-7946166.703593861, 5480600.924071899],
              [-7949981.399904364, 5498334.746832791],
              [-7943367.241039391, 5491141.654884373],
              [-7941074.05952905, 5478722.10684322],
              [-7931731.571264222, 5503321.050916362],
              [-7908390.434393162, 5502271.894457502],
              [-7904827.227499375, 5509635.67516008],
              [-7904656.333393994, 5505583.704372462],
              [-7903836.020066339, 5479834.750401626],
              [-7902562.747730645, 5440597.659164477],
              [-7902265.418574478, 5433460.065956226],
              [-7901674.084235641, 5419281.077374932],
              [-7900646.605335618, 5399177.228330239],
              [-7899653.265875484, 5394563.834271834],
              [-7906382.676057215, 5385767.389360899],
              [-7907906.305927702, 5392967.647476398],
              [-7921792.744487219, 5394370.041324489],
              [-7932433.106695203, 5399344.701561207],
              [-7941935.4497488085, 5408175.7566024],
              [-7942005.024430554, 5408241.27279474],
              [-7952652.177127476, 5418449.323909589],
              [-7962867.744158593, 5428527.333276977],
              [-7964219.942013259, 5433933.427361304],
              [-7966091.890570439, 5446125.427859276],
              [-7966535.164782777, 5448925.1599401245],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tipton',
        GEOID: '47167',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10022941.45404081, 4238922.442824867],
              [-10014134.189887717, 4237742.275361524],
              [-10012604.214806255, 4240287.879601467],
              [-10008712.819366597, 4237223.922890867],
              [-9995955.939680161, 4250553.187564781],
              [-9976837.707692342, 4252885.4497540565],
              [-9963330.200679485, 4243067.853542835],
              [-9959739.479184456, 4238407.591813426],
              [-9960219.154870285, 4218788.321859427],
              [-9976027.079160383, 4216825.000312771],
              [-9977874.98270755, 4215072.14019143],
              [-9985634.396493806, 4219545.6400132375],
              [-10003783.369675288, 4217112.846663747],
              [-10023182.126779906, 4217899.546726605],
              [-10023797.612244502, 4220481.399379289],
              [-10021210.324639484, 4226211.604783774],
              [-10023853.160670407, 4231564.406399043],
              [-10022941.45404081, 4238922.442824867],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Twin Falls',
        GEOID: '16083',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12805937.852070894, 5276788.265463631],
              [-12805946.423671685, 5298566.256315958],
              [-12797324.506470764, 5299031.516455275],
              [-12790791.610834071, 5290551.176634411],
              [-12794352.276066585, 5276563.386212473],
              [-12785912.58887209, 5274800.022135599],
              [-12780831.967312288, 5261031.085049365],
              [-12759048.96935386, 5258742.86168502],
              [-12742264.439171033, 5251235.1531066885],
              [-12717662.163788773, 5245123.115584142],
              [-12704932.446058089, 5235404.686105209],
              [-12695481.866567705, 5240507.962437803],
              [-12690465.142395616, 5240156.611282833],
              [-12697888.482639164, 5238356.255172821],
              [-12698121.029055433, 5223668.844160967],
              [-12722197.876441145, 5223700.35881489],
              [-12721791.723629933, 5160112.751599109],
              [-12721797.905510725, 5160112.768710465],
              [-12757020.728231605, 5160157.25392921],
              [-12790521.549749408, 5160965.812700855],
              [-12805983.79946167, 5160774.843398149],
              [-12805937.852070894, 5276788.265463631],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Columbia',
        GEOID: '12023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9217306.93708016, 3494828.253822464],
              [-9212970.152357835, 3499118.1450125175],
              [-9216583.137751022, 3501776.3625280494],
              [-9216652.044515822, 3546945.1153640975],
              [-9215973.9974974, 3545267.055917226],
              [-9210401.343788289, 3545495.323903393],
              [-9205000.010775508, 3546440.165102913],
              [-9200243.996850858, 3554398.9315718827],
              [-9209081.094627481, 3575671.192629753],
              [-9204956.351101212, 3580636.786069802],
              [-9193209.40502128, 3579828.1685929713],
              [-9179382.104829283, 3578876.413872758],
              [-9179221.75629251, 3524724.589939326],
              [-9179223.092126401, 3521101.1756676137],
              [-9192317.269869942, 3502374.65023416],
              [-9187164.735919083, 3495952.908541987],
              [-9199554.929202847, 3481520.6464599343],
              [-9201508.140988305, 3481735.0700727594],
              [-9213741.15115107, 3490317.911574955],
              [-9213956.443046262, 3494312.2688906216],
              [-9217306.93708016, 3494828.253822464],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Aguas Buenas',
        GEOID: '72007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7368312.347582553, 2067867.6717750423],
              [-7363100.925621067, 2070300.1632725506],
              [-7356711.632127496, 2070945.437786772],
              [-7356044.828377644, 2072375.924042815],
              [-7354444.944655963, 2073082.4696962489],
              [-7357126.631189173, 2064206.0012732102],
              [-7360196.934064742, 2062137.401302838],
              [-7362789.676324808, 2060726.1483650596],
              [-7365913.412555958, 2063818.0715252238],
              [-7368312.347582553, 2067867.6717750423],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Columbiana',
        GEOID: '39029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9026528.595634066, 4997434.66880014],
              [-9026527.816397628, 4997839.828017931],
              [-9005305.089436363, 4997749.398436529],
              [-9005280.710467879, 5002049.709380539],
              [-8997055.313293165, 4997740.56171464],
              [-8963430.894600362, 4997650.565202894],
              [-8963412.57195909, 4990438.540115653],
              [-8963333.077308176, 4959209.992678288],
              [-8970528.991832035, 4955795.293892102],
              [-8975375.619822193, 4956442.91127595],
              [-8979915.896573689, 4950953.598437701],
              [-8988727.39086743, 4953078.436433233],
              [-9001515.996608742, 4953432.2054827595],
              [-9007764.470946461, 4959894.072940042],
              [-9007658.383471733, 4972147.5426117005],
              [-9026595.721287014, 4972277.102985772],
              [-9026528.595634066, 4997434.66880014],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ellis',
        GEOID: '40045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11132300.848918263, 4382561.719993577],
              [-11088040.775976311, 4382492.811716586],
              [-11086984.799286647, 4323219.458053969],
              [-11063161.871659432, 4323252.550715461],
              [-11063044.763555119, 4302399.977884329],
              [-11075823.127903277, 4297695.322521326],
              [-11082799.965669256, 4282197.160855338],
              [-11089626.856081134, 4278914.759913784],
              [-11100456.90670143, 4281342.918933876],
              [-11109839.803941414, 4288333.217228446],
              [-11110736.482439755, 4300627.426378104],
              [-11119515.694081165, 4298949.266811705],
              [-11123616.481483009, 4288748.165237588],
              [-11131993.183923595, 4284252.34128058],
              [-11131993.495804183, 4308285.148278696],
              [-11131994.27504062, 4369599.243172936],
              [-11132367.86251345, 4369599.222225938],
              [-11132300.848918263, 4382561.719993577],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cameron',
        GEOID: '42023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8729576.284217633, 5101574.156001091],
              [-8728762.761378916, 5103772.891426767],
              [-8705565.115331488, 5103951.724587941],
              [-8688535.459629932, 5082727.184871105],
              [-8681717.363457827, 5082632.096279435],
              [-8681671.945105582, 5066692.914915509],
              [-8693315.407245105, 5044391.785063482],
              [-8709282.62972653, 5046396.34071278],
              [-8711190.868437707, 5072222.452206871],
              [-8729677.584954256, 5072270.687134869],
              [-8729576.284217633, 5101574.156001091],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pierce',
        GEOID: '31139',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10890879.040969659, 5226769.544925032],
              [-10852013.73319053, 5226904.394191816],
              [-10838910.538568236, 5226934.109557385],
              [-10838925.455380002, 5213833.110333518],
              [-10839001.152633741, 5174608.863878299],
              [-10890890.729516191, 5174433.054158742],
              [-10890879.040969659, 5226769.544925032],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carter',
        GEOID: '40019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10860588.116968881, 4097089.473772109],
              [-10837187.312850755, 4097055.9721998386],
              [-10837192.656186314, 4079432.691342645],
              [-10802052.4325276, 4079323.1726842327],
              [-10801185.921611266, 4073555.116750246],
              [-10790583.07407168, 4073558.2172824293],
              [-10790606.896442708, 4051995.2781937644],
              [-10794474.58083083, 4052003.8893647925],
              [-10794609.500053672, 4038342.268141066],
              [-10860414.569882734, 4038351.5409188815],
              [-10860616.16948056, 4067698.5152140055],
              [-10860588.116968881, 4097089.473772109],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Penobscot',
        GEOID: '23019',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7720637.534067848, 5633095.101642617],
              [-7706873.324309223, 5635727.464250042],
              [-7678094.898229855, 5641571.325182718],
              [-7665080.20260274, 5644027.825540171],
              [-7667789.273730686, 5657004.578886819],
              [-7656116.089287121, 5659434.155392473],
              [-7665159.239441204, 5704919.771072401],
              [-7677110.054694806, 5702547.094179844],
              [-7676470.746859181, 5726380.001745458],
              [-7661790.934288781, 5729985.419307392],
              [-7660940.676018102, 5844002.001059373],
              [-7648104.091576257, 5843955.999579327],
              [-7647078.727746558, 5841876.499360467],
              [-7618309.986462891, 5841797.266957184],
              [-7618361.082109166, 5787225.038766871],
              [-7617325.365566825, 5771474.33083182],
              [-7617926.824775579, 5713488.990442686],
              [-7615464.771597705, 5712237.8231593855],
              [-7598683.580999603, 5717192.308687458],
              [-7575070.04533457, 5722829.06058999],
              [-7563019.487817215, 5663787.222352816],
              [-7575846.276143871, 5661372.597234464],
              [-7603534.661769391, 5656464.691969635],
              [-7599836.962243711, 5637297.284218275],
              [-7613908.413796925, 5634644.282454377],
              [-7611569.479975868, 5621107.928287759],
              [-7625507.014181658, 5618486.44053718],
              [-7622930.747206231, 5604078.000631069],
              [-7620363.385790064, 5590333.513236014],
              [-7619286.926314092, 5584289.730444968],
              [-7638373.098288562, 5580837.726340078],
              [-7641764.001297616, 5574985.084559254],
              [-7646639.349716398, 5577809.723485589],
              [-7652541.84307673, 5568243.938413231],
              [-7660539.03529532, 5571871.670363193],
              [-7662958.675747203, 5574748.432555938],
              [-7682621.927961944, 5569999.313422511],
              [-7701497.817418305, 5565653.209048698],
              [-7703887.624246657, 5579050.323904717],
              [-7710743.23508716, 5577850.457857883],
              [-7712421.376410867, 5588249.821980321],
              [-7712356.254508753, 5591448.578402456],
              [-7715055.306882528, 5605161.761397679],
              [-7720637.534067848, 5633095.101642617],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Treasure',
        GEOID: '30103',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11993400.302166663, 5857898.020402315],
              [-11930614.216927914, 5858044.651010506],
              [-11928266.822825555, 5843974.722959757],
              [-11914349.437447598, 5843950.027474976],
              [-11912008.6111952, 5829506.4773037555],
              [-11912008.6111952, 5801880.685469658],
              [-11904402.484347766, 5802277.316402032],
              [-11904405.601293508, 5759547.60148168],
              [-11916991.828200558, 5759549.360113415],
              [-11916968.11714902, 5766496.593415202],
              [-11930817.820276575, 5766470.033336322],
              [-11930817.597637592, 5773422.84558681],
              [-11958510.547362236, 5773408.914669484],
              [-11958488.394783568, 5787302.660637668],
              [-11968129.219283719, 5787307.311556479],
              [-11963074.980443232, 5808883.538916228],
              [-11979358.79555647, 5836866.572845538],
              [-11993400.302166663, 5857898.020402315],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grady',
        GEOID: '40051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10919998.327329835, 4215335.501975468],
              [-10904314.52427197, 4211007.691940095],
              [-10894037.620201426, 4213161.761100301],
              [-10890794.883434618, 4209549.409578175],
              [-10885952.596904602, 4209226.146255889],
              [-10883903.093759608, 4210964.975144244],
              [-10872752.220366845, 4209627.463602997],
              [-10872644.685738737, 4146630.289299306],
              [-10872363.04742703, 4144215.888181922],
              [-10872399.33758103, 4120660.944995895],
              [-10919228.441731507, 4120630.4865778643],
              [-10919218.64561632, 4141454.5383343645],
              [-10919623.291965352, 4144182.6524321553],
              [-10919998.327329835, 4215335.501975468],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cherokee',
        GEOID: '48073',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10626548.349732742, 3781118.0355950417],
              [-10573712.111900587, 3781437.4882807354],
              [-10573656.006877227, 3743131.537170949],
              [-10568397.719410114, 3743054.351251345],
              [-10572916.845458359, 3736207.731917293],
              [-10566915.723029183, 3708237.4574542777],
              [-10560418.894907506, 3701369.9511732315],
              [-10575723.989057694, 3688159.9818279096],
              [-10586637.417976594, 3693924.4525532904],
              [-10586479.78957763, 3700319.0888811024],
              [-10594109.961435074, 3708784.1921520988],
              [-10605764.444204183, 3709988.427923238],
              [-10604167.677428246, 3712219.878676249],
              [-10606058.995576823, 3718400.230681077],
              [-10619493.254364736, 3732537.429131569],
              [-10621316.333665458, 3741691.8191569922],
              [-10625083.273914412, 3742734.73602521],
              [-10622532.387782883, 3754389.0570764565],
              [-10625050.100706156, 3763115.961923896],
              [-10623053.362999797, 3774404.3986640014],
              [-10626548.349732742, 3781118.0355950417],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sanders',
        GEOID: '30089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12918505.679633925, 6127663.958059976],
              [-12918507.710967056, 6142886.438044546],
              [-12908302.135107813, 6131686.027164722],
              [-12906019.417629605, 6137548.36631321],
              [-12890816.180813497, 6144004.18768823],
              [-12883814.964079035, 6150769.5543547245],
              [-12876588.102736734, 6141260.386135285],
              [-12879232.163282057, 6136431.134516834],
              [-12873628.006157054, 6129200.368333345],
              [-12866830.50409074, 6110511.470818867],
              [-12862392.863909759, 6106752.35504588],
              [-12863873.190498328, 6097259.47770978],
              [-12860150.221448237, 6091661.582702083],
              [-12838285.403664079, 6093136.247725636],
              [-12832794.347141718, 6088619.712424458],
              [-12822357.365643412, 6093390.54880331],
              [-12818943.308180273, 6109798.658144691],
              [-12802929.442832207, 6109786.842229956],
              [-12800555.220732568, 6085720.476985388],
              [-12757723.933454948, 6086184.833335536],
              [-12757710.352477072, 6071967.779600578],
              [-12755483.07210528, 6064760.603289575],
              [-12755405.816378668, 6040848.835278847],
              [-12726102.964178173, 6039665.689022102],
              [-12733107.74313634, 6021313.259097134],
              [-12723979.990169255, 6023586.05064647],
              [-12729726.636242475, 6005941.299121384],
              [-12722543.968738021, 6000356.622733214],
              [-12713022.701370982, 6000335.425076682],
              [-12713033.054083627, 5971816.798682076],
              [-12711257.619524963, 5964659.603412652],
              [-12719826.77128725, 5961858.216487301],
              [-12728950.850711137, 5970887.702227733],
              [-12753176.866214516, 5983732.543844066],
              [-12779166.293771548, 5986079.0043304125],
              [-12798288.087983072, 5993252.5580884125],
              [-12799767.190057242, 6007084.813955405],
              [-12829466.33964496, 6020845.793081321],
              [-12860285.474629551, 6023315.841198724],
              [-12872394.1409211, 6021067.16918838],
              [-12881560.187793016, 6029460.743807813],
              [-12882025.837223005, 6036657.295236195],
              [-12879028.782572377, 6044439.050951548],
              [-12883702.642712826, 6049610.514915967],
              [-12882311.149077907, 6056539.237983902],
              [-12894733.847652983, 6067178.333315819],
              [-12895859.176385412, 6076126.955526707],
              [-12902032.95534481, 6080785.874889657],
              [-12908602.1411355, 6089925.99078066],
              [-12916484.117681118, 6102422.2027872475],
              [-12917354.060563218, 6104298.903249953],
              [-12918532.618950699, 6106842.024838255],
              [-12918505.679633925, 6127663.958059976],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carter',
        GEOID: '21043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9277516.310065517, 4624662.2677661795],
              [-9265196.915977897, 4627467.044041744],
              [-9265920.603987545, 4639816.309033085],
              [-9258043.414180031, 4650865.840482186],
              [-9245278.630809749, 4645382.025029079],
              [-9236250.28614794, 4635187.85551283],
              [-9219196.808075357, 4632385.799597254],
              [-9214107.614914762, 4630774.72563559],
              [-9216608.852553396, 4613920.08750067],
              [-9219836.449869456, 4608888.451279884],
              [-9231147.066731505, 4604193.168810735],
              [-9245426.685732502, 4606236.876629192],
              [-9259308.226234425, 4617207.678702327],
              [-9266713.755359447, 4606638.414867829],
              [-9273044.27216188, 4609139.068065071],
              [-9277516.310065517, 4624662.2677661795],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'San Luis Obispo',
        GEOID: '06079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13508292.25564626, 4272475.78304828],
              [-13441900.8709568, 4271919.249339793],
              [-13382158.928513281, 4271664.67973331],
              [-13379951.12905238, 4271654.798984281],
              [-13379925.748208478, 4247686.689837787],
              [-13367903.688480766, 4247709.283632456],
              [-13367987.400737846, 4235669.969841715],
              [-13348727.459038245, 4223736.483923431],
              [-13344985.56567472, 4223718.858217581],
              [-13344999.70325005, 4211712.338242179],
              [-13337115.38899513, 4211665.114749949],
              [-13337126.854902681, 4199759.100299667],
              [-13321231.99009027, 4199614.993432395],
              [-13321275.738650152, 4187662.4371967106],
              [-13308650.438601833, 4188366.004591744],
              [-13309466.855747312, 4175801.9466011655],
              [-13299642.242767861, 4174334.423343569],
              [-13299646.138950037, 4150459.1822875463],
              [-13306659.600828487, 4149970.82824981],
              [-13321933.302882269, 4160263.501311488],
              [-13330015.431872332, 4160304.3927833913],
              [-13350370.534722356, 4172009.8816495854],
              [-13356126.086354839, 4171707.839848393],
              [-13367476.444275104, 4179476.367294541],
              [-13376997.822961632, 4174118.4194336613],
              [-13379309.594826937, 4168010.1596061145],
              [-13395580.608198736, 4164739.3604582753],
              [-13391938.12314049, 4151056.013089375],
              [-13406815.527807048, 4162081.8906094413],
              [-13413578.07555325, 4162950.9748086184],
              [-13430730.54023507, 4160506.8556396943],
              [-13428867.584974723, 4168378.1728610056],
              [-13428423.75416493, 4174535.332516859],
              [-13429114.380285809, 4180718.502920668],
              [-13433487.789120605, 4184701.0257146964],
              [-13437841.605725024, 4187824.365413872],
              [-13442506.00370875, 4185708.3178555965],
              [-13452590.213740734, 4191697.048534894],
              [-13458169.101341328, 4197617.868506378],
              [-13456252.179709867, 4203931.788988415],
              [-13454311.101748906, 4213016.114084245],
              [-13456829.593908615, 4222497.834457071],
              [-13464745.077620957, 4225715.251456815],
              [-13470032.308155676, 4226667.3894812185],
              [-13482375.524614325, 4241849.603633251],
              [-13488216.68093523, 4250568.117064977],
              [-13499973.132357908, 4254857.699136337],
              [-13504683.060013372, 4261244.637598414],
              [-13506666.439380834, 4270817.986915569],
              [-13508292.25564626, 4272475.78304828],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Ashland',
        GEOID: '39005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9176835.511687865, 5021989.8394398885],
              [-9165656.808422405, 5022046.240498647],
              [-9147288.647163553, 5021717.878723969],
              [-9147496.480652863, 5011168.521444007],
              [-9142595.64007069, 5011133.273315779],
              [-9142246.653467054, 4963527.99611249],
              [-9152762.56048433, 4963432.7470726585],
              [-9152700.778166939, 4948859.262302272],
              [-9165708.683305116, 4946924.340812835],
              [-9165878.000250611, 4959166.129844002],
              [-9165959.040839909, 4972110.6725696735],
              [-9175036.143438684, 4986317.700014729],
              [-9176383.109277284, 5011300.96115987],
              [-9176835.511687865, 5021989.8394398885],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Camden',
        GEOID: '13039',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9121157.175936267, 3640646.0112280883],
              [-9110461.821899831, 3645439.3087277813],
              [-9102185.329078842, 3654793.924304665],
              [-9087190.816307971, 3646798.168315958],
              [-9079507.7676924, 3649680.71472367],
              [-9080630.536076538, 3645387.8278947584],
              [-9062800.05191891, 3631558.8863900444],
              [-9062350.985132359, 3629855.7394970604],
              [-9061980.179908525, 3620833.28504417],
              [-9065873.801738003, 3609572.1721041775],
              [-9068092.510509003, 3602903.7495136894],
              [-9066318.411784232, 3595107.086044523],
              [-9073342.003736341, 3596819.1422522482],
              [-9075686.72617092, 3596873.9184598736],
              [-9079408.025428649, 3595868.819777436],
              [-9087374.382148288, 3597682.510582246],
              [-9091271.67752096, 3599630.5210343106],
              [-9098391.115554644, 3600276.989422384],
              [-9101858.272414891, 3603410.1999424626],
              [-9106885.349299625, 3605508.6450145342],
              [-9113573.535625976, 3605863.7117361063],
              [-9117328.342050433, 3609501.0071747317],
              [-9117731.812799564, 3609577.142192754],
              [-9117738.220415534, 3637907.966927725],
              [-9121074.465554606, 3638983.5177643406],
              [-9121157.175936267, 3640646.0112280883],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cleveland',
        GEOID: '40027',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10872727.062161926, 4215253.311670833],
              [-10845141.75838488, 4215275.838852796],
              [-10833371.503345342, 4215271.742998104],
              [-10813810.66506213, 4215213.582025812],
              [-10813836.825142467, 4154124.828009497],
              [-10835152.726517528, 4158303.7397222742],
              [-10837419.080030587, 4174303.2739057257],
              [-10843306.767898645, 4182670.244868025],
              [-10858265.658432461, 4193023.533779594],
              [-10859994.116166009, 4203148.403284602],
              [-10872744.873280453, 4209842.2514811745],
              [-10872727.062161926, 4215253.311670833],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hamilton',
        GEOID: '36041',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8323983.608192851, 5386344.885756765],
              [-8332728.199472625, 5476295.031760177],
              [-8297215.6121172095, 5480814.2178817745],
              [-8269019.943572144, 5484116.87514898],
              [-8266139.885706339, 5460769.3885503905],
              [-8275137.6175081795, 5453877.553141083],
              [-8261435.078747455, 5436221.148729791],
              [-8254237.383111741, 5439112.152822501],
              [-8242881.236577957, 5433979.694415411],
              [-8243988.086274914, 5425989.733185174],
              [-8261534.26441375, 5423553.886992938],
              [-8255464.569178248, 5368694.875162165],
              [-8253243.411378449, 5350710.287856269],
              [-8262233.016857459, 5345732.589148484],
              [-8273974.551468371, 5348823.778941122],
              [-8297160.063691303, 5346757.982817589],
              [-8316970.257633894, 5355627.644932295],
              [-8334235.576697457, 5363840.705135391],
              [-8323983.608192851, 5386344.885756765],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Newton',
        GEOID: '05101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10411003.870613942, 4284340.821665163],
              [-10402886.008067332, 4296149.380365033],
              [-10402318.723942248, 4311738.005966088],
              [-10406093.456555558, 4317844.761661312],
              [-10386199.772994876, 4317359.379800574],
              [-10382229.785994714, 4317189.184332878],
              [-10362314.506452816, 4317111.735945643],
              [-10346552.891070887, 4316473.7036012],
              [-10345867.608285563, 4310495.252566423],
              [-10346137.224092264, 4299254.96778688],
              [-10347293.054365171, 4262801.264742029],
              [-10371019.356674377, 4263372.801247357],
              [-10410551.468203356, 4264139.513427864],
              [-10410510.168672273, 4268130.824320444],
              [-10411003.870613942, 4284340.821665163],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Susquehanna',
        GEOID: '42115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8476480.400688684, 5160809.647263011],
              [-8472063.35519435, 5160808.379523182],
              [-8445885.129780933, 5160803.885750381],
              [-8410534.015698958, 5160873.873277695],
              [-8402745.740315804, 5160889.292440349],
              [-8400437.166552726, 5107441.201197088],
              [-8429099.263764214, 5107541.898052104],
              [-8471137.844947897, 5107835.057040912],
              [-8473102.188682435, 5108966.3652563775],
              [-8476480.400688684, 5160809.647263011],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'McClain',
        GEOID: '40087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10872744.873280453, 4209842.2514811745],
              [-10859994.116166009, 4203148.403284602],
              [-10858265.658432461, 4193023.533779594],
              [-10843306.767898645, 4182670.244868025],
              [-10837419.080030587, 4174303.2739057257],
              [-10835152.726517528, 4158303.7397222742],
              [-10813836.825142467, 4154124.828009497],
              [-10799763.926435873, 4151297.2248712755],
              [-10790263.47581361, 4159039.4079203345],
              [-10790287.966101585, 4146918.0823410177],
              [-10790473.313053755, 4144119.70826301],
              [-10872363.04742703, 4144215.888181922],
              [-10872644.685738737, 4146630.289299306],
              [-10872752.220366845, 4209627.463602997],
              [-10872744.873280453, 4209842.2514811745],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wood',
        GEOID: '48499',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10649422.390020434, 3890053.4154577074],
              [-10609744.561278006, 3890337.075491621],
              [-10601087.912395958, 3890287.1890387605],
              [-10594603.997335212, 3890238.4968812596],
              [-10592295.11977667, 3897089.3620458567],
              [-10592063.57523582, 3895732.036028445],
              [-10592284.433105553, 3882388.3031794266],
              [-10592354.564384753, 3850386.603432852],
              [-10592429.148443585, 3838381.9486068245],
              [-10593753.29378657, 3834980.239761021],
              [-10612327.952700846, 3842892.0789327174],
              [-10621333.365547549, 3843269.8837928534],
              [-10627570.819255678, 3843075.76009721],
              [-10641535.626736712, 3853835.201985298],
              [-10646041.39444606, 3858247.6284699063],
              [-10649422.390020434, 3890053.4154577074],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. John the Baptist',
        GEOID: '22095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10095436.602627568, 3508172.1040715463],
              [-10090221.06184492, 3524960.8571146],
              [-10089198.369683003, 3532041.7724660756],
              [-10084657.647653546, 3530356.1562803504],
              [-10080441.53325924, 3528720.865483212],
              [-10072836.074328754, 3539204.503421794],
              [-10054428.060692199, 3542039.7621338554],
              [-10036636.089117689, 3533707.384070041],
              [-10036148.509748014, 3527946.185309402],
              [-10043281.417440085, 3526141.615125466],
              [-10047684.882537395, 3524572.016471029],
              [-10055115.235908862, 3522869.7556860154],
              [-10070828.093353825, 3507626.3913120436],
              [-10078658.751614187, 3505720.3089491804],
              [-10077998.738353275, 3499429.2377396394],
              [-10077709.08503823, 3488775.828985669],
              [-10088789.047915356, 3490089.7332708356],
              [-10091814.489036137, 3489321.3788476335],
              [-10095436.602627568, 3508172.1040715463],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Landry',
        GEOID: '22097',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10288234.168317162, 3572999.8663946874],
              [-10270638.898282886, 3572989.268052128],
              [-10264937.670561908, 3576788.701141428],
              [-10260585.523749854, 3590453.659473058],
              [-10260586.30298629, 3602647.61703074],
              [-10265072.033187296, 3613103.4488051147],
              [-10244607.05799986, 3613218.849968594],
              [-10220827.767613038, 3613038.6171605047],
              [-10211745.766956668, 3594073.3881007843],
              [-10214340.290328586, 3576067.428760299],
              [-10211496.2999778, 3569549.286145305],
              [-10214252.681889333, 3567691.216800969],
              [-10205648.019209484, 3554390.4138024976],
              [-10238964.606970022, 3556025.931076498],
              [-10240137.246486038, 3551018.2163982578],
              [-10246895.67541108, 3552658.0707369084],
              [-10251350.236154662, 3546060.5950954654],
              [-10257221.00346012, 3542018.101766454],
              [-10259043.303524405, 3547644.3403667193],
              [-10259049.092137925, 3548584.827463622],
              [-10260960.336475356, 3548563.6718607936],
              [-10260991.951210741, 3555131.223142466],
              [-10268643.607729908, 3565424.720883811],
              [-10296302.493690368, 3565464.2470352827],
              [-10288234.168317162, 3572999.8663946874],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Osage',
        GEOID: '40113',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10805126.96554382, 4395180.250620395],
              [-10790414.536362616, 4395442.60981524],
              [-10785687.02022761, 4404487.95125614],
              [-10770426.676512722, 4408776.451482172],
              [-10770142.70049171, 4438965.7284401925],
              [-10745178.641693924, 4438922.514741895],
              [-10742362.921564247, 4438917.6406384865],
              [-10710891.009085646, 4438977.158036749],
              [-10686761.30789584, 4438995.424917139],
              [-10686801.471277982, 4359077.617005102],
              [-10686788.558217049, 4322837.934561739],
              [-10716536.688380718, 4322932.521349529],
              [-10715238.369159596, 4331718.638825247],
              [-10723042.756020129, 4331839.384623087],
              [-10734962.847094273, 4340030.898824169],
              [-10737620.265978493, 4346492.502184352],
              [-10744026.14607619, 4341749.424381531],
              [-10750510.72905388, 4344149.852547187],
              [-10744413.53790415, 4352700.3984154705],
              [-10750757.413045477, 4352253.955023927],
              [-10757439.922077797, 4359385.025116274],
              [-10766353.162386123, 4361764.207660268],
              [-10765284.383955019, 4366533.984463373],
              [-10770556.363719497, 4378313.113587365],
              [-10778067.868999753, 4375010.930958464],
              [-10784111.404154921, 4365613.5255574435],
              [-10791337.597580276, 4363483.303106689],
              [-10799079.868164947, 4370600.924477338],
              [-10785524.716410032, 4380015.8746247925],
              [-10788278.649292769, 4383351.909204338],
              [-10804381.904191941, 4382616.7637449475],
              [-10805126.96554382, 4395180.250620395],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hunt',
        GEOID: '48231',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10719758.274444275, 3892882.0970047135],
              [-10719556.340887975, 3942111.29395945],
              [-10670944.232453462, 3949789.2370019658],
              [-10671284.313497834, 3924452.669921416],
              [-10671367.023879495, 3892592.669155513],
              [-10680581.940007871, 3892633.276208002],
              [-10685252.794522066, 3878911.5870745564],
              [-10679372.23110142, 3873717.1218101825],
              [-10695220.564366676, 3873885.649486737],
              [-10719768.8497959, 3874314.134029567],
              [-10719758.274444275, 3892882.0970047135],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Colleton',
        GEOID: '45029',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9026039.346472029, 3898839.184172735],
              [-9009883.103495236, 3908928.2030259944],
              [-9005309.764854977, 3903457.95342697],
              [-9005237.629824944, 3911953.657362933],
              [-8994382.420999728, 3918813.9402701254],
              [-8993534.611757847, 3919332.122306222],
              [-8984566.71357954, 3916091.203029718],
              [-8974811.118684381, 3904078.2663826924],
              [-8964782.679717287, 3904552.8877938017],
              [-8949033.198159855, 3901133.6000797246],
              [-8952181.313359488, 3890959.612593683],
              [-8950236.227896856, 3876532.7253076085],
              [-8956057.124070436, 3860830.709888161],
              [-8948907.184496276, 3849311.775323118],
              [-8953117.176318588, 3845658.3019235777],
              [-8952808.82132909, 3843361.0662056273],
              [-8952109.95756589, 3842921.4148698845],
              [-8950922.067279635, 3844165.6162577467],
              [-8949541.037676854, 3844870.9640841475],
              [-8948707.254690811, 3844513.857493987],
              [-8948732.746854203, 3843537.8827991886],
              [-8949667.385298904, 3841884.7903846055],
              [-8949661.485365892, 3840732.387203742],
              [-8948833.26835439, 3838957.2292468906],
              [-8949125.148059249, 3837872.739566213],
              [-8949648.906263432, 3837262.1138438103],
              [-8950968.82146577, 3836947.5013214643],
              [-8951787.24236208, 3836235.097283054],
              [-8951933.404853491, 3835238.9392566467],
              [-8942999.013841914, 3828274.5098242923],
              [-8933327.056541838, 3832999.6238329336],
              [-8943224.658449752, 3826316.7351892157],
              [-8951590.429502359, 3825319.69406225],
              [-8957401.863519222, 3828503.498822086],
              [-8958134.693608109, 3826926.2586477925],
              [-8962106.781797599, 3829811.1304228217],
              [-8962786.38728889, 3830958.2479900033],
              [-8966952.407912338, 3837807.884681025],
              [-8979002.408832239, 3844006.2348827138],
              [-8980271.339707792, 3851800.596199707],
              [-8997543.560579784, 3856122.9650483076],
              [-9005753.373025788, 3873109.67376774],
              [-9015398.53898608, 3882127.507138571],
              [-9026039.346472029, 3898839.184172735],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Duval',
        GEOID: '12031',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9133679.171497129, 3538745.620744483],
              [-9132377.401371794, 3540037.882085073],
              [-9109410.52062878, 3563777.133405185],
              [-9100025.842276944, 3571965.7946615643],
              [-9097196.546098942, 3577269.917220131],
              [-9084355.954155428, 3579043.1548882416],
              [-9084807.243371103, 3575011.128516522],
              [-9077327.24150674, 3571070.2108046636],
              [-9072491.188868208, 3576227.995219248],
              [-9064629.777222972, 3568782.3130055196],
              [-9064301.970528001, 3567562.1531394897],
              [-9062609.802948454, 3565663.1713831206],
              [-9061006.579642048, 3547334.127853153],
              [-9058554.114191871, 3536103.3732558484],
              [-9065517.468047973, 3536026.5667408262],
              [-9065167.256929938, 3517122.7382907886],
              [-9092599.941685105, 3519143.6540755234],
              [-9092534.374505028, 3528059.7763494626],
              [-9096065.651391974, 3528149.6711136173],
              [-9099135.397670088, 3527908.5794295804],
              [-9133698.652408019, 3527601.0396377877],
              [-9133679.171497129, 3538745.620744483],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'St. Louis',
        GEOID: '27137',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10362559.357600847, 6211775.1792305885],
              [-10347689.463071886, 6212563.219557954],
              [-10340989.25424053, 6206404.386557588],
              [-10322438.862975247, 6197047.048868583],
              [-10312073.348590031, 6197649.477587321],
              [-10311648.776052145, 6191830.24955783],
              [-10314541.30170092, 6184887.375733377],
              [-10305472.659383444, 6180508.601544825],
              [-10298712.671985533, 6181764.868771684],
              [-10292191.019617409, 6176042.347460189],
              [-10293707.525040487, 6165588.687555567],
              [-10287733.787206046, 6156150.868583152],
              [-10282489.414675286, 6143578.125706396],
              [-10276421.500551634, 6146963.648550581],
              [-10274306.764185034, 6153249.111121174],
              [-10274278.26639539, 6160919.955201205],
              [-10270590.029026428, 6166107.481563472],
              [-10259444.832927696, 6167505.718914527],
              [-10247541.105818698, 6166824.497743333],
              [-10241407.958473444, 6160484.343770709],
              [-10239252.701812195, 6148179.548650307],
              [-10229534.28762696, 6146490.975198815],
              [-10218826.86432117, 6141157.145806989],
              [-10219030.625753669, 6062413.891599562],
              [-10217785.405929657, 6031789.771536784],
              [-10218460.882812738, 5932739.413658984],
              [-10219891.904653937, 5931263.332999914],
              [-10230982.888160653, 5924339.053865693],
              [-10242885.390755251, 5914976.191615233],
              [-10248304.757525543, 5910146.538679991],
              [-10243095.227995396, 5894293.263516742],
              [-10247050.298183791, 5894950.423237489],
              [-10252553.488530647, 5898836.10805601],
              [-10257349.466152495, 5898373.223460329],
              [-10261774.749869999, 5892470.747340422],
              [-10264268.417783258, 5887521.933960614],
              [-10273919.817635037, 5887278.78395343],
              [-10274975.57168572, 5903659.359181828],
              [-10359562.02072346, 5904051.990756253],
              [-10358940.19004789, 5946386.7390700495],
              [-10360449.348384576, 6006609.728857305],
              [-10359531.296544002, 6060429.526033638],
              [-10361747.111008242, 6088884.670990798],
              [-10363453.638802102, 6118146.091280045],
              [-10362559.357600847, 6211775.1792305885],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Morgan',
        GEOID: '39115',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9136729.659503339, 4832714.419521818],
              [-9094517.642553002, 4830485.98418306],
              [-9088110.537940903, 4830174.378895322],
              [-9088479.450733393, 4817478.22516805],
              [-9082126.670032801, 4817234.123592557],
              [-9082355.208947401, 4806102.601259151],
              [-9096216.82326047, 4805833.066222264],
              [-9095751.619108444, 4790774.3212657785],
              [-9108512.283657568, 4792692.284428662],
              [-9110928.473205235, 4786367.8713138085],
              [-9134407.53492539, 4787786.104736408],
              [-9133489.037806856, 4800882.481341415],
              [-9132458.664600072, 4803568.882924321],
              [-9130894.291795956, 4826014.685632919],
              [-9137128.739877833, 4826447.0195674645],
              [-9136729.659503339, 4832714.419521818],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '44009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7973978.987812634, 5036957.80362371],
              [-7969734.375628686, 5047425.568432964],
              [-7964398.609795982, 5048210.478106254],
              [-7963137.805243257, 5039203.3878987795],
              [-7961482.039137199, 5034436.282622612],
              [-7969774.22800639, 5033950.653938363],
              [-7973978.987812634, 5036957.80362371],
            ],
          ],
          [
            [
              [-7999475.715303415, 5059693.547067485],
              [-7996741.48597055, 5064688.00160854],
              [-7997153.145447505, 5073320.4873489775],
              [-7992481.511696874, 5074001.812889026],
              [-7991815.891365181, 5093228.951748007],
              [-7991554.85182535, 5100779.852639698],
              [-7957610.013288936, 5101634.150024293],
              [-7946045.5879878765, 5108743.042733837],
              [-7949150.399905592, 5082285.328026812],
              [-7950127.761822829, 5079840.670879717],
              [-7951401.168689941, 5079562.427742588],
              [-7954375.514164447, 5072703.476544083],
              [-7957483.999625358, 5067326.155392211],
              [-7965508.576438682, 5067562.611425192],
              [-7973203.424920277, 5065716.509565209],
              [-7981789.051967198, 5062172.141281115],
              [-7984868.769822329, 5061625.9661660595],
              [-7991176.179347832, 5060507.46979798],
              [-7999727.186033117, 5058143.711199332],
              [-7999475.715303415, 5059693.547067485],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Tallahatchie',
        GEOID: '28135',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10068960.597576275, 4026880.5703172926],
              [-10068957.146672063, 4038599.220953229],
              [-10033859.669697816, 4038594.9204400345],
              [-10033833.064339513, 4050316.3591389284],
              [-10014143.206766473, 4050246.4039584887],
              [-10011127.11648292, 4050885.2990972633],
              [-10010460.53537205, 4047690.5101537607],
              [-10010527.549705507, 4015108.36052009],
              [-10010549.257006213, 4005174.3741689264],
              [-10033948.280012485, 4003226.8738691094],
              [-10033981.23058176, 3991487.11133766],
              [-10045426.655347163, 3993574.9151843926],
              [-10052045.044352785, 3988267.5400690543],
              [-10051537.984072221, 3995413.669415291],
              [-10039414.957566362, 3997359.575530185],
              [-10039079.32930162, 4003227.275795814],
              [-10069030.840174967, 4003504.340623949],
              [-10068960.597576275, 4026880.5703172926],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Portage',
        GEOID: '39133',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9060658.706233319, 5016094.044728428],
              [-9060575.439254206, 5027167.109328625],
              [-9060528.68506807, 5032381.28612483],
              [-9060497.181652179, 5053234.105298167],
              [-9060481.93088194, 5063848.221224275],
              [-9017248.2236451, 5063787.127567912],
              [-9017233.97475028, 5063786.9792828085],
              [-9017199.354388643, 5052521.362614812],
              [-9017133.675889077, 5032154.704413028],
              [-9017141.46825343, 5021504.685747519],
              [-9017067.440792054, 5010539.826107757],
              [-9026486.962144507, 5010576.399341721],
              [-9037320.574988509, 5010602.649570246],
              [-9038661.640894096, 5010602.059676693],
              [-9056678.700478988, 5010677.566342486],
              [-9060655.032690123, 5010650.136118744],
              [-9060658.706233319, 5016094.044728428],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chautauqua',
        GEOID: '36013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8879059.769998036, 5201489.272208658],
              [-8864090.972029539, 5209740.60014962],
              [-8844726.835286558, 5222769.137554181],
              [-8836757.472940667, 5231115.70648585],
              [-8825783.708857756, 5237869.221204984],
              [-8815750.260513578, 5243103.774338407],
              [-8809665.203188345, 5245911.747734913],
              [-8809373.034500493, 5246624.6732459655],
              [-8806237.564747328, 5246743.525358721],
              [-8801005.437360555, 5241890.836067326],
              [-8801059.694832126, 5160805.400138249],
              [-8846835.11512269, 5160718.055096527],
              [-8862237.700098446, 5160757.735441714],
              [-8878988.748162912, 5160800.889903024],
              [-8879078.805630963, 5180659.77821218],
              [-8879059.769998036, 5201489.272208658],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clay',
        GEOID: '29047',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10530914.999706639, 4787224.092975197],
              [-10487480.694747392, 4787011.724738138],
              [-10487689.196153648, 4751378.424608072],
              [-10496402.172698038, 4755664.653731798],
              [-10501347.875035, 4747967.152589474],
              [-10504772.841808237, 4745079.482322897],
              [-10509520.395451589, 4749441.604507278],
              [-10508551.915881688, 4746741.6226773625],
              [-10508819.082659591, 4745300.443923108],
              [-10511427.966245823, 4742004.61204695],
              [-10515416.098322984, 4738928.524939267],
              [-10517979.34091799, 4742535.2546273945],
              [-10519181.034821102, 4743237.175239925],
              [-10522303.769176833, 4743004.201089689],
              [-10524059.166227154, 4742133.2153179245],
              [-10525210.321081446, 4740438.5392551],
              [-10529370.441771884, 4739353.108467173],
              [-10528213.609623559, 4747657.812161326],
              [-10529925.814711452, 4743898.805187246],
              [-10531039.564204304, 4743970.617175943],
              [-10530914.999706639, 4787224.092975197],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sully',
        GEOID: '46119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11207244.135746548, 5593724.792126211],
              [-11199746.65672213, 5585295.388558237],
              [-11190907.889153143, 5584805.08884026],
              [-11178556.546371667, 5596896.282585384],
              [-11177005.977184407, 5605430.011075073],
              [-11095686.97784043, 5605399.838481899],
              [-11095925.86946767, 5550659.156420131],
              [-11190558.568591034, 5550551.533573465],
              [-11201067.017202428, 5553562.954945582],
              [-11200277.539373722, 5575533.119761952],
              [-11211836.843978206, 5585530.90492743],
              [-11207244.135746548, 5593724.792126211],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grundy',
        GEOID: '29079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10437685.482764727, 4904378.780336878],
              [-10393590.719266603, 4904718.109613281],
              [-10393523.482294165, 4873437.814863454],
              [-10393004.844786556, 4870753.156992743],
              [-10393005.512703503, 4861235.987726898],
              [-10437535.090132665, 4860066.226093693],
              [-10437763.07244981, 4885275.091890915],
              [-10437685.482764727, 4904378.780336878],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'El Paso',
        GEOID: '48141',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11869267.604024611, 3752031.5360686886],
              [-11870009.993708713, 3759538.3840472894],
              [-11868715.570669767, 3763375.6037620534],
              [-11841852.75134353, 3763473.4107770766],
              [-11822207.734569717, 3763544.9384132563],
              [-11799640.173723338, 3763569.8256488587],
              [-11799282.264677279, 3721337.751213481],
              [-11799115.174121598, 3695034.5463690404],
              [-11794781.840303488, 3687867.505130818],
              [-11799468.544296091, 3683220.6634216765],
              [-11800414.383898646, 3683822.8596322034],
              [-11808800.303779086, 3684637.1593512488],
              [-11819422.075632107, 3692148.5122091942],
              [-11826226.92478481, 3699601.806875874],
              [-11831125.761616148, 3705960.7490320257],
              [-11833655.497044424, 3713586.4243847015],
              [-11839118.500887904, 3722287.26630357],
              [-11841069.70908973, 3725396.4366064095],
              [-11846390.89206914, 3730801.7951749354],
              [-11851923.693400545, 3731796.6416190513],
              [-11853816.124744032, 3730251.9743027645],
              [-11858669.65454262, 3734878.971661956],
              [-11864580.942142723, 3738907.6101272074],
              [-11870651.861892626, 3746456.6346829315],
              [-11869267.604024611, 3752031.5360686886],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Linn',
        GEOID: '20107',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10582679.8987594, 4634659.367139789],
              [-10532245.67159926, 4634485.172584119],
              [-10532228.013100546, 4613068.838866345],
              [-10532374.505215181, 4587912.758952558],
              [-10532393.461549634, 4584661.98868634],
              [-10584020.742026005, 4584753.776280674],
              [-10582679.8987594, 4634659.367139789],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Prentiss',
        GEOID: '28117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9877983.99611708, 4109179.1108305757],
              [-9876033.233360419, 4110359.211492233],
              [-9876099.134498969, 4130877.5794355213],
              [-9836799.346747274, 4130718.1035586093],
              [-9832928.434093919, 4128701.749506846],
              [-9832760.786940783, 4091219.439190419],
              [-9856459.148057802, 4091449.6452052956],
              [-9856422.412625838, 4097380.7255122433],
              [-9878098.098595142, 4097342.6300047506],
              [-9877983.99611708, 4109179.1108305757],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Mecklenburg',
        GEOID: '51117',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8762146.586111894, 4389195.075791985],
              [-8755673.246402772, 4396102.423102018],
              [-8744060.285803728, 4387190.682795398],
              [-8755115.535753898, 4397082.431466219],
              [-8737803.907782163, 4423955.084986615],
              [-8729806.604244085, 4418449.111863657],
              [-8685971.660437472, 4408188.12401646],
              [-8688064.166787146, 4375762.829028816],
              [-8697715.866716163, 4375709.251461024],
              [-8718956.461519804, 4375516.708807429],
              [-8733824.224437563, 4375381.936932338],
              [-8739689.325997729, 4375328.77198713],
              [-8764642.458275437, 4375404.109568935],
              [-8762146.586111894, 4389195.075791985],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Drew',
        GEOID: '05043',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10241408.069792936, 3958380.1292947903],
              [-10238730.390761394, 3965823.9599489956],
              [-10238704.119361566, 3989180.768770332],
              [-10238718.59089537, 4000878.254840184],
              [-10203960.63836804, 4000939.737193896],
              [-10192150.753589783, 3999752.74398396],
              [-10180203.611879375, 3999355.09792179],
              [-10180550.149454214, 3970367.374374088],
              [-10180987.857692014, 3947048.301942201],
              [-10240298.548428198, 3948280.282431195],
              [-10241408.069792936, 3958380.1292947903],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Perry',
        GEOID: '21193',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9300479.405945845, 4485823.420845741],
              [-9289550.726256706, 4492046.396182867],
              [-9282002.819502957, 4486362.174906866],
              [-9263421.9266972, 4501111.911772053],
              [-9253360.091882868, 4495706.136784245],
              [-9253633.603871746, 4472049.619312414],
              [-9246906.78968209, 4473227.267913832],
              [-9239533.5432094, 4466421.459278948],
              [-9246065.325651186, 4456415.940381203],
              [-9245678.156462207, 4441531.145679198],
              [-9253108.732472656, 4439245.757104277],
              [-9259789.460393125, 4442050.354755273],
              [-9258134.028245537, 4453385.746176334],
              [-9261991.693879487, 4463406.136377907],
              [-9275654.268943017, 4470593.89078211],
              [-9283904.15640571, 4483883.966720894],
              [-9296055.346742738, 4472036.196386965],
              [-9298172.754777117, 4475203.921510955],
              [-9300941.270513145, 4479217.246834866],
              [-9300479.405945845, 4485823.420845741],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Iron',
        GEOID: '55051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10079821.656904876, 5874796.882478414],
              [-10075071.703662356, 5875344.010261636],
              [-10067467.135287793, 5870789.837475947],
              [-10065300.857996957, 5871534.939491575],
              [-10061860.195175517, 5866285.437326735],
              [-10055699.663235528, 5869460.079724085],
              [-10050558.929150695, 5863888.100280135],
              [-10042672.945103409, 5860831.2588852355],
              [-10036369.478937238, 5847990.193522053],
              [-10032166.94552081, 5834495.291945754],
              [-10010864.472133335, 5828541.878840093],
              [-10010832.3424713, 5777459.8901348375],
              [-10023647.55357091, 5777456.84636391],
              [-10052379.67074211, 5777360.888016023],
              [-10052491.99210832, 5805198.70006174],
              [-10066206.776013033, 5805070.300868278],
              [-10066173.825443758, 5818965.584259102],
              [-10080227.799836919, 5819030.126075284],
              [-10079821.656904876, 5874796.882478414],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wayne',
        GEOID: '21231',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9469315.339922696, 4419435.630203725],
              [-9457801.676309438, 4427451.790178975],
              [-9456092.810806273, 4433497.522359405],
              [-9443868.260924809, 4438773.936073344],
              [-9436572.381498218, 4433217.227532419],
              [-9426441.528599592, 4436446.778779375],
              [-9415197.480793037, 4420602.98702623],
              [-9415571.29164312, 4411777.941585357],
              [-9420140.28882324, 4410422.495569785],
              [-9437494.537059514, 4383942.823109911],
              [-9438260.986854061, 4383965.216126283],
              [-9438267.552316247, 4383965.690358785],
              [-9455917.037330309, 4385240.613317201],
              [-9459359.084502835, 4385519.9756051395],
              [-9462097.05018119, 4386903.004379709],
              [-9462613.016021013, 4405183.615733065],
              [-9469315.339922696, 4419435.630203725],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Washington',
        GEOID: '01129',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9847725.722644474, 3723725.851683206],
              [-9805943.36501123, 3723903.8726776787],
              [-9804877.258247903, 3720020.5596838584],
              [-9806065.816451102, 3718598.7548176902],
              [-9804156.241906036, 3710199.361129131],
              [-9801842.466289897, 3708762.369336072],
              [-9799197.960466612, 3708859.9842720004],
              [-9799596.929521617, 3705755.898801103],
              [-9792817.572532305, 3701844.0245632147],
              [-9789715.877560332, 3701344.2237505317],
              [-9787703.889083734, 3698249.7541861385],
              [-9785667.076360691, 3696778.5306444135],
              [-9788891.222772533, 3690337.2092615278],
              [-9783568.370000765, 3683788.8229787783],
              [-9785881.366380466, 3674773.6134247286],
              [-9791619.99745035, 3673882.959346979],
              [-9790169.393165823, 3657830.205137836],
              [-9793094.980703363, 3653896.130037909],
              [-9798636.46495505, 3651499.1666725976],
              [-9832826.35412086, 3651441.1572710793],
              [-9844205.989067204, 3647601.827593285],
              [-9846059.792547382, 3687581.6883165464],
              [-9846147.297350096, 3689481.153241499],
              [-9847264.046798784, 3713748.396500281],
              [-9847725.722644474, 3723725.851683206],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Liberty',
        GEOID: '30051',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12401995.15353865, 6143456.827235297],
              [-12387110.4017857, 6143454.989392903],
              [-12386504.378570106, 6274391.359859661],
              [-12356899.405179312, 6274443.484771698],
              [-12327861.493366906, 6274523.419077833],
              [-12328699.840452071, 6260296.477675025],
              [-12329287.384724477, 6143466.6847603265],
              [-12337251.18109583, 6143460.837074617],
              [-12337223.907820582, 6129044.079534134],
              [-12402003.947778422, 6128879.453968609],
              [-12401995.15353865, 6143456.827235297],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Somerset',
        GEOID: '42111',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8840722.116605269, 4844716.10267423],
              [-8826932.303363761, 4871816.725582189],
              [-8814680.14624858, 4882039.928079549],
              [-8800471.77172169, 4907457.534019595],
              [-8786180.35285467, 4907450.529461263],
              [-8783556.997734634, 4905998.650251894],
              [-8781422.669137657, 4901555.330452081],
              [-8756214.036489047, 4901307.695374006],
              [-8767879.98516571, 4874229.551875987],
              [-8767215.964403126, 4840324.512755308],
              [-8772899.773921257, 4825780.934408848],
              [-8786271.092698833, 4825770.460328934],
              [-8799313.269781005, 4825760.244084326],
              [-8837928.042473245, 4825544.792835021],
              [-8834948.753854258, 4839898.678524918],
              [-8840722.116605269, 4844716.10267423],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yell',
        GEOID: '05149',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10431180.083042257, 4166560.656675382],
              [-10431381.237362122, 4182234.513417459],
              [-10411693.94013737, 4183663.602387729],
              [-10403588.100095764, 4193243.858000482],
              [-10383877.537097435, 4192803.758950717],
              [-10383692.078825774, 4207098.903280454],
              [-10370087.167258473, 4195904.582052632],
              [-10359968.002906384, 4179953.4985825843],
              [-10352731.679407367, 4186795.909531376],
              [-10341147.550556438, 4187099.860594862],
              [-10357244.348925145, 4178697.0244325097],
              [-10357223.86613884, 4174339.5922543765],
              [-10386741.230998093, 4146987.419728329],
              [-10384748.723432384, 4133101.536046517],
              [-10396623.284834793, 4132987.969663813],
              [-10396604.694479832, 4129063.726245701],
              [-10431782.544126432, 4129321.5334343044],
              [-10431180.083042257, 4166560.656675382],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Webster',
        GEOID: '13307',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9421093.18366443, 3787494.896997839],
              [-9423119.087077377, 3793928.322781187],
              [-9409515.622663457, 3780986.181679854],
              [-9398839.74953791, 3780920.7153692883],
              [-9399040.12462134, 3768819.7903103773],
              [-9400241.595885469, 3759039.4791256376],
              [-9401299.465006478, 3752712.186060896],
              [-9417603.985545006, 3752836.385876871],
              [-9423842.775087023, 3752854.353643562],
              [-9421093.18366443, 3787494.896997839],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Holt',
        GEOID: '31089',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11049243.039128095, 5282230.984604434],
              [-11018684.503071452, 5296221.611750965],
              [-11008701.259817619, 5288529.19460886],
              [-10982428.63547601, 5282947.9258561125],
              [-10974293.963686291, 5278505.289130573],
              [-10943279.129036887, 5275695.460413222],
              [-10943311.523008706, 5228841.971243545],
              [-10942732.105059128, 5226653.25029029],
              [-10942771.84611734, 5174298.498914214],
              [-10994041.484755564, 5174248.247443536],
              [-11045424.11267694, 5174157.945467624],
              [-11046748.369339418, 5174169.795678072],
              [-11047992.253329542, 5278924.3560762275],
              [-11049243.039128095, 5282230.984604434],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Franklin',
        GEOID: '39049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9267909.88328802, 4873009.250324341],
              [-9262960.17344939, 4875432.694369393],
              [-9262479.941166107, 4881610.117957647],
              [-9258439.934206236, 4886757.1305956505],
              [-9240097.042471794, 4885774.079348472],
              [-9236323.645692375, 4885569.79285056],
              [-9213004.438761, 4884248.075219219],
              [-9213634.061800927, 4873360.302496859],
              [-9214340.050011538, 4862473.435875001],
              [-9215305.189996716, 4857177.995884328],
              [-9218455.754225146, 4857395.781859107],
              [-9217166.229243796, 4845572.842206661],
              [-9217529.464742254, 4840247.548175075],
              [-9219953.780612752, 4836196.224386915],
              [-9266646.518387008, 4838733.017839786],
              [-9267909.88328802, 4873009.250324341],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Bath',
        GEOID: '51017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8909593.036530271, 4574894.975467702],
              [-8902356.713031255, 4585689.483832771],
              [-8901327.14941054, 4588415.263638881],
              [-8898763.431187939, 4595205.85597912],
              [-8896227.79582665, 4605506.216275521],
              [-8888897.407357913, 4612440.014530073],
              [-8882962.9137413, 4617250.940130533],
              [-8872853.151788857, 4610720.120139389],
              [-8851252.940434312, 4604944.412035002],
              [-8842850.545269238, 4602449.5889897905],
              [-8847970.12865082, 4591589.499554941],
              [-8853668.796023507, 4579894.969412032],
              [-8866329.050391937, 4561717.369423462],
              [-8871361.136653755, 4557476.187016228],
              [-8877708.68533828, 4563249.583809364],
              [-8893016.785114715, 4564317.21840293],
              [-8898364.01685497, 4572981.122208274],
              [-8911772.18175197, 4572630.047911998],
              [-8909593.036530271, 4574894.975467702],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cabo Rojo',
        GEOID: '72023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7481770.397113455, 2041697.0344493347],
              [-7480593.4161373, 2048218.4980029403],
              [-7478534.896113549, 2057228.4940904088],
              [-7478527.406410973, 2057245.3033087263],
              [-7476187.279372212, 2055491.313424739],
              [-7472431.471072337, 2051016.3034176233],
              [-7469592.601418126, 2050005.657764345],
              [-7470544.60570339, 2044114.2404819203],
              [-7471292.784001012, 2041231.445201842],
              [-7470407.174475678, 2031886.9005547022],
              [-7473292.972611586, 2031921.5147998682],
              [-7478828.22297179, 2029489.5893254862],
              [-7482002.609571253, 2036728.404029648],
              [-7481770.397113455, 2041697.0344493347],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Benton',
        GEOID: '28009',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9946694.770915193, 4163065.27363886],
              [-9929507.988826238, 4163127.0188445617],
              [-9910389.099887002, 4163195.70573699],
              [-9909341.250806171, 4163197.2837779],
              [-9909388.44898426, 4144698.6994809895],
              [-9917238.031558057, 4138810.342976528],
              [-9917285.119702661, 4109417.663468672],
              [-9932178.777014878, 4109334.088328455],
              [-9934779.75691726, 4107387.5584817347],
              [-9940645.069567667, 4107345.9135945113],
              [-9940744.477872947, 4142757.8136040783],
              [-9946697.621601589, 4142760.1194605804],
              [-9946694.770915193, 4163065.27363886],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Crawford',
        GEOID: '05033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10518917.104370968, 4267533.450943507],
              [-10487688.305597723, 4266676.588643657],
              [-10477864.471854707, 4268283.7902834695],
              [-10459901.290903358, 4267775.375371236],
              [-10454106.443490624, 4267613.774080727],
              [-10462273.731891144, 4254045.464737068],
              [-10472236.714997653, 4254275.646500054],
              [-10472515.68164158, 4242365.437451942],
              [-10466594.04132883, 4242189.566734523],
              [-10472369.407830678, 4224575.5821794],
              [-10479888.148877837, 4225236.548644092],
              [-10479072.844927266, 4218270.316198768],
              [-10490054.735333005, 4212102.826952168],
              [-10491009.299966559, 4212261.838027389],
              [-10502156.945094086, 4214527.278435595],
              [-10509189.55392495, 4225104.133532306],
              [-10512443.78861443, 4217442.65239866],
              [-10514092.064299487, 4231589.838361932],
              [-10516699.54421893, 4250999.321666263],
              [-10518917.104370968, 4267533.450943507],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jefferson',
        GEOID: '19101',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10261427.767017197, 5036363.958450998],
              [-10235334.144416781, 5036499.403996797],
              [-10209783.093014492, 5036385.54680636],
              [-10210021.094085807, 4997762.948092326],
              [-10261327.356836502, 4997561.619821107],
              [-10261427.767017197, 5036363.958450998],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Watauga',
        GEOID: '37189',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9117972.102665689, 4342257.866585406],
              [-9109630.376623096, 4348520.538917141],
              [-9102480.882326897, 4347650.26742296],
              [-9095466.529892523, 4347298.41964922],
              [-9097626.882725026, 4354382.158698832],
              [-9087921.294806553, 4348833.864940861],
              [-9079924.43654644, 4338140.8785859635],
              [-9070035.5922208, 4333729.957007635],
              [-9067617.287602806, 4328236.911045684],
              [-9077602.200648999, 4316797.813818566],
              [-9092035.997144746, 4317494.435599106],
              [-9107104.982654959, 4315975.981810495],
              [-9109188.215605665, 4323871.677937828],
              [-9117923.233409232, 4330130.025914811],
              [-9119119.525300818, 4340233.759432053],
              [-9117972.102665689, 4342257.866585406],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Kershaw',
        GEOID: '45055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9003434.365393583, 4090437.043921197],
              [-8988308.05034561, 4101532.017060761],
              [-8987931.901786221, 4093432.04185751],
              [-8964316.028411882, 4096679.7617918923],
              [-8966846.431757104, 4104262.186945459],
              [-8951019.137875607, 4111651.7032861486],
              [-8942026.415450854, 4095836.474756554],
              [-8937345.208224015, 4081786.655066148],
              [-8937685.62322686, 4078081.3161658146],
              [-8937696.309897978, 4077802.429713474],
              [-8944858.494616127, 4069604.92027073],
              [-8954245.84463574, 4067067.9684221535],
              [-8958976.700355474, 4051476.332644391],
              [-8970136.81326597, 4042230.6435425226],
              [-8974415.043936139, 4043471.1332562133],
              [-8974152.77521583, 4042184.398356849],
              [-8982699.774399446, 4039721.172831561],
              [-8985633.376940321, 4038067.0447831377],
              [-9002354.232374415, 4053302.90549243],
              [-8997500.368617358, 4064947.271448786],
              [-8991267.033730388, 4079551.9222223125],
              [-9003434.365393583, 4090437.043921197],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Power',
        GEOID: '16077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12606206.30661928, 5328874.234890494],
              [-12579960.955552911, 5328872.252574971],
              [-12579966.29888847, 5291149.989289535],
              [-12558684.01599963, 5291177.326311331],
              [-12551335.14849542, 5304596.822121689],
              [-12550993.286339194, 5298698.642588815],
              [-12529976.389116406, 5306075.104152341],
              [-12525170.281420898, 5298279.147165457],
              [-12523098.737016726, 5271421.595127623],
              [-12510047.639916124, 5258285.041604814],
              [-12514517.674068926, 5236632.494384843],
              [-12523235.54867091, 5236621.773774012],
              [-12523203.26601858, 5223499.058885343],
              [-12540584.691311043, 5223524.843131403],
              [-12540589.032771183, 5210370.889631402],
              [-12579098.563457737, 5210153.310046322],
              [-12579413.263658209, 5249470.480983161],
              [-12598658.845143495, 5249691.387137547],
              [-12605481.616734214, 5255104.525506288],
              [-12598987.794238789, 5262703.291518219],
              [-12599014.956194542, 5275869.524358078],
              [-12605478.833746944, 5275847.842000939],
              [-12606206.30661928, 5328874.234890494],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cherokee',
        GEOID: '40021',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10606376.478764566, 4295682.9861895805],
              [-10598500.068193486, 4310905.952810487],
              [-10588529.292722624, 4310883.36526967],
              [-10588542.985019993, 4322884.262680911],
              [-10576609.869565425, 4322909.770807479],
              [-10552784.826867884, 4322851.171146955],
              [-10553900.025526652, 4251007.108259253],
              [-10589540.852935463, 4251046.830639926],
              [-10589507.345768735, 4274887.242140081],
              [-10604926.876355454, 4274957.388998478],
              [-10601117.523380509, 4280165.304066349],
              [-10606376.478764566, 4295682.9861895805],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lyman',
        GEOID: '46085',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11172830.828362714, 5495609.794800774],
              [-11125071.427227674, 5495698.915906627],
              [-11119090.008348372, 5485517.243670023],
              [-11106198.766036548, 5486472.811775747],
              [-11088784.835452773, 5481503.116388723],
              [-11088569.098279616, 5488511.773080824],
              [-11098080.346892485, 5492156.477037392],
              [-11094490.961231347, 5499165.375740285],
              [-11084813.178660253, 5495268.22368875],
              [-11083250.809606967, 5481165.946495621],
              [-11059145.575751103, 5462571.357896593],
              [-11060244.18780574, 5455291.555182031],
              [-11055230.580579393, 5443063.795462449],
              [-11066287.277682945, 5430629.943178477],
              [-11065932.279826803, 5419945.825755704],
              [-11072849.227706734, 5414946.52714011],
              [-11062416.47634908, 5412494.513325643],
              [-11053789.661090566, 5388367.173902961],
              [-11053802.574151495, 5388338.47608329],
              [-11080127.741292764, 5388358.733358537],
              [-11090045.97396397, 5388367.634296515],
              [-11090046.975839388, 5425666.303294486],
              [-11093725.751051633, 5429311.902156883],
              [-11103655.672269376, 5420718.576998031],
              [-11113895.840907957, 5417450.610490051],
              [-11129885.772565505, 5417150.109264978],
              [-11132720.523398554, 5419862.055892615],
              [-11144769.633762527, 5416890.71929891],
              [-11157646.627179531, 5421266.995515143],
              [-11163121.653695216, 5418639.779907957],
              [-11169683.047121553, 5421742.287120039],
              [-11172711.382549094, 5441792.133151511],
              [-11172826.37558308, 5491585.18924896],
              [-11172830.828362714, 5495609.794800774],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Clackamas',
        GEOID: '41005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13677591.06096344, 5671620.087420196],
              [-13663770.746181456, 5673951.012184911],
              [-13663768.51979164, 5689994.650988185],
              [-13659460.455497941, 5689953.882217288],
              [-13654557.722484423, 5693885.98845074],
              [-13638223.14568338, 5694432.101078303],
              [-13564591.202456642, 5694269.58107925],
              [-13560894.39348689, 5694497.966957514],
              [-13547305.623245755, 5680540.156481181],
              [-13547190.07361431, 5662217.515655089],
              [-13545525.401948987, 5660778.213210382],
              [-13551081.691692952, 5648424.27922251],
              [-13542309.71581844, 5637592.355772401],
              [-13542985.64776654, 5631973.778871774],
              [-13559206.678686973, 5623548.934152762],
              [-13551391.71647481, 5603548.345498573],
              [-13625619.330296787, 5603548.345498573],
              [-13640645.012525082, 5611634.190688794],
              [-13647271.19389506, 5624620.074201588],
              [-13659470.919530075, 5630818.240528839],
              [-13668587.095270116, 5641793.640297562],
              [-13663246.32006033, 5662445.08634848],
              [-13675591.094991848, 5662498.540203938],
              [-13677591.06096344, 5671620.087420196],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Gove',
        GEOID: '20063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11222324.698483802, 4740792.290894143],
              [-11212243.38275858, 4740795.304652986],
              [-11150227.739715613, 4740607.305226774],
              [-11148417.684795314, 4740622.804283835],
              [-11149072.577359652, 4678410.52767181],
              [-11159467.257451454, 4678528.05817513],
              [-11208537.556910073, 4678792.792035787],
              [-11223086.123800829, 4678769.969880646],
              [-11222324.698483802, 4740792.290894143],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Graham',
        GEOID: '20065',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11149945.767445432, 4803257.971412708],
              [-11090532.996736191, 4803281.076441471],
              [-11087663.514222015, 4803265.336134838],
              [-11087998.697208792, 4740666.144365853],
              [-11148417.684795314, 4740622.804283835],
              [-11150227.739715613, 4740607.305226774],
              [-11149945.767445432, 4803257.971412708],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Nez Perce',
        GEOID: '16069',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13028337.274113253, 5846299.152431159],
              [-13028459.808866974, 5848897.040935101],
              [-13028807.710281348, 5856277.163297294],
              [-13028808.451175122, 5867587.523786891],
              [-12993109.108056817, 5867776.073534179],
              [-12981159.517317612, 5882090.216957728],
              [-12963833.529131563, 5881742.011642175],
              [-12963339.715870405, 5859341.799777373],
              [-12954172.444484087, 5860919.395682097],
              [-12954151.405100329, 5855492.301830528],
              [-12954115.671543784, 5835521.613038549],
              [-12992486.943422772, 5832669.493580222],
              [-12991187.06572878, 5779769.291934872],
              [-12997334.461968856, 5771076.034713575],
              [-12996576.710195025, 5759427.056099698],
              [-13002027.973617421, 5756511.193053616],
              [-13008772.873606335, 5765500.644821187],
              [-13011783.843193311, 5773720.043700242],
              [-13015028.361071974, 5779614.1807582425],
              [-13017996.917932957, 5790129.907351558],
              [-13022372.441838078, 5793967.366101294],
              [-13017197.310030593, 5803206.071037888],
              [-13015915.466094106, 5807781.703580773],
              [-13020257.81679097, 5812406.024919027],
              [-13020415.111231461, 5821031.156398375],
              [-13024075.407408234, 5829063.181549468],
              [-13031365.498221304, 5837199.941741321],
              [-13028337.274113253, 5846299.152431159],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rockingham',
        GEOID: '37157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8908602.617574245, 4375526.961257087],
              [-8908594.834656326, 4375526.907827227],
              [-8893500.041609472, 4375463.010227935],
              [-8873816.600948079, 4375379.689048399],
              [-8851418.768906225, 4375284.878476378],
              [-8853446.713639377, 4335030.599272243],
              [-8853507.382761858, 4333897.37674732],
              [-8909468.692659054, 4336067.443440427],
              [-8908602.617574245, 4375526.961257087],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pratt',
        GEOID: '20151',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11022112.141512468, 4554780.946431161],
              [-10961881.506504368, 4554662.705610295],
              [-10961053.62345134, 4552648.872002595],
              [-10961051.842339488, 4541730.282472354],
              [-10961036.146291284, 4504964.867000593],
              [-11022031.991479097, 4504881.83298593],
              [-11022137.967634333, 4541771.805253286],
              [-11022112.141512468, 4554780.946431161],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Yadkin',
        GEOID: '37197',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9002763.999420026, 4333185.481258523],
              [-8966549.542675158, 4339965.991633052],
              [-8955911.51817648, 4333891.303768236],
              [-8953676.11148186, 4330658.755682907],
              [-8954440.097147176, 4319895.264886708],
              [-8961834.828281593, 4315651.345047996],
              [-8960805.234311242, 4307027.783740622],
              [-8982725.600521311, 4307676.963269527],
              [-9003697.524669819, 4308290.793805432],
              [-9002763.999420026, 4333185.481258523],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Terry',
        GEOID: '48445',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11420804.901539411, 3946983.6399171064],
              [-11363040.438530348, 3947129.8966000425],
              [-11363072.164585222, 3889956.2986323102],
              [-11377800.401134117, 3889857.3252090234],
              [-11420825.71828419, 3889840.741272108],
              [-11420804.901539411, 3946983.6399171064],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Faulk',
        GEOID: '46049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11084452.39219059, 5660232.091351202],
              [-10989736.314768625, 5659979.122009902],
              [-10989210.664133098, 5659974.062695749],
              [-10989070.29025521, 5605309.007012696],
              [-11055333.885066848, 5605356.465555719],
              [-11084382.1495919, 5605362.122882109],
              [-11084452.39219059, 5660232.091351202],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Huerfano',
        GEOID: '08055',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11744401.644396704, 4522731.041607928],
              [-11739447.927056404, 4544375.262107313],
              [-11736290.683658525, 4558501.779749385],
              [-11741392.56724107, 4562488.102552494],
              [-11741223.361615065, 4564740.2684695665],
              [-11723843.828753946, 4570804.940402814],
              [-11720281.048451109, 4565227.100661816],
              [-11707320.788054992, 4582102.593083641],
              [-11694103.268315652, 4567492.70125804],
              [-11690074.838582825, 4562666.937735641],
              [-11649182.06891788, 4565383.128790751],
              [-11616312.317593386, 4553674.975153782],
              [-11627869.618447036, 4542879.468909441],
              [-11638276.543682825, 4524396.5082379505],
              [-11638302.703763163, 4519518.183975951],
              [-11649498.884188678, 4508374.7387647545],
              [-11654717.764556048, 4506986.499351871],
              [-11654602.437563587, 4500603.946157487],
              [-11660598.439296184, 4495994.262402159],
              [-11688046.152182609, 4491583.835211674],
              [-11701395.585518539, 4480487.213720966],
              [-11705709.32710627, 4480044.33105255],
              [-11709424.392472513, 4525836.248436047],
              [-11721451.127618836, 4530720.7576503735],
              [-11742593.927185712, 4519967.511667972],
              [-11744401.644396704, 4522731.041607928],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Effingham',
        GEOID: '17049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9885763.558731167, 4752696.90457825],
              [-9848536.205939572, 4752519.603030327],
              [-9848531.641840449, 4746262.020581803],
              [-9836263.009440633, 4746212.482142389],
              [-9836384.459005088, 4708909.203972581],
              [-9860633.85160153, 4709558.007834458],
              [-9873318.707577424, 4709448.559513223],
              [-9885926.530465689, 4709024.7981856875],
              [-9885763.558731167, 4752696.90457825],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Scott',
        GEOID: '29201',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9992617.57947076, 4456693.359558862],
              [-9976481.262682822, 4471635.05455547],
              [-9961189.669877445, 4475542.638393862],
              [-9959813.284006853, 4474480.569279348],
              [-9958208.056949614, 4465360.828111053],
              [-9950200.845976854, 4453510.666763214],
              [-9947449.139483934, 4445047.179262553],
              [-9941658.376513895, 4443116.242135955],
              [-9949186.614096235, 4434221.976697873],
              [-9959241.992380101, 4430152.020984002],
              [-9963281.77670099, 4426048.960551103],
              [-9965299.553791108, 4420948.627156235],
              [-9970564.075149704, 4421124.651911793],
              [-9984423.574392447, 4419543.316634767],
              [-9984192.809088033, 4428797.154799588],
              [-9995028.314363379, 4451254.646865611],
              [-9992617.57947076, 4456693.359558862],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Albany',
        GEOID: '36001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8266939.938886671, 5224587.034233743],
              [-8264533.990732156, 5243847.3578324085],
              [-8256536.019277132, 5261486.91920885],
              [-8257710.32858551, 5270961.793678557],
              [-8219009.4396942835, 5277371.945499661],
              [-8216421.37285283, 5278373.794236828],
              [-8207214.583047284, 5285005.130529227],
              [-8201659.629137207, 5279042.359480956],
              [-8211066.460067711, 5252854.34524758],
              [-8212390.716730189, 5237589.697711009],
              [-8213566.250552965, 5230774.664129046],
              [-8265951.199169445, 5222324.367012005],
              [-8266939.938886671, 5224587.034233743],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Jackson',
        GEOID: '13157',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9330541.679712532, 4045934.0952065154],
              [-9308548.621874977, 4068519.626006916],
              [-9302025.967631437, 4062785.760033357],
              [-9292991.277758654, 4064041.832440348],
              [-9284315.815882662, 4055352.246195114],
              [-9279264.471348936, 4044415.4050681856],
              [-9282571.996059386, 4035550.161614135],
              [-9279595.869473027, 4034251.156363697],
              [-9282360.489026878, 4033879.444293988],
              [-9290059.567649122, 4029447.7756200037],
              [-9295517.450963225, 4028745.2277106424],
              [-9299339.16040165, 4024225.758469563],
              [-9302214.542848838, 4033067.0128548187],
              [-9324959.00724925, 4037727.862648071],
              [-9330541.679712532, 4045934.0952065154],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Middlesex',
        GEOID: '34023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8306687.1196718635, 4920404.03894774],
              [-8302762.773662929, 4926897.861650444],
              [-8292132.207570136, 4935129.79291698],
              [-8288834.033696912, 4937558.444077556],
              [-8295964.492360184, 4949073.804936468],
              [-8289215.63691135, 4953400.390669405],
              [-8286814.2528559575, 4953092.217499914],
              [-8277574.512481134, 4954115.002659853],
              [-8271363.330172833, 4954792.715269135],
              [-8270035.177328178, 4952335.753562921],
              [-8260316.763142945, 4952448.046651298],
              [-8261780.725766366, 4947454.299906264],
              [-8265384.360322327, 4945468.529215492],
              [-8266653.40251737, 4939225.800031133],
              [-8266795.668826603, 4933703.67554622],
              [-8262650.516824453, 4931356.503638878],
              [-8263950.6766003985, 4930593.1573472265],
              [-8270023.266142663, 4920291.380935493],
              [-8274085.759639674, 4916145.556615842],
              [-8281433.625268465, 4906661.964734964],
              [-8291628.041596332, 4902823.3543892205],
              [-8306934.471580408, 4913254.19805917],
              [-8306687.1196718635, 4920404.03894774],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Fillmore',
        GEOID: '27045',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10291371.70816517, 5439805.338720016],
              [-10289766.147149459, 5441984.769904038],
              [-10250219.898045149, 5441807.8773502335],
              [-10211384.089931082, 5441785.495899332],
              [-10211361.046555782, 5388494.504430286],
              [-10221895.321529746, 5388494.243391836],
              [-10250276.670220498, 5388497.44856982],
              [-10261304.091062926, 5388498.693924844],
              [-10291369.810327906, 5388452.959208164],
              [-10291371.70816517, 5439805.338720016],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Iowa',
        GEOID: '55049',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10066602.07152484, 5342607.148777109],
              [-10057773.100071043, 5343958.124318806],
              [-10053365.293513592, 5343474.126952054],
              [-10047705.810601663, 5342110.699979232],
              [-10040329.447183227, 5337038.5425213305],
              [-10025284.172724554, 5334112.830853973],
              [-10018767.86369199, 5341642.678811361],
              [-10000735.442017369, 5343388.601473752],
              [-10000739.004241074, 5290291.3436282305],
              [-10000766.054877335, 5283672.964682176],
              [-10066276.68465325, 5283530.774963537],
              [-10066602.07152484, 5342607.148777109],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Florence',
        GEOID: '55037',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9871715.81822949, 5782518.959720573],
              [-9869336.698072257, 5778632.62066603],
              [-9864361.050792271, 5778847.317638704],
              [-9862223.382610567, 5782774.465542982],
              [-9854744.15998264, 5783686.588431484],
              [-9841741.04158257, 5777094.805273308],
              [-9838436.967776334, 5779011.868762406],
              [-9830570.798598407, 5773840.463011073],
              [-9823533.959626893, 5774419.203085925],
              [-9815930.949725203, 5771877.767951899],
              [-9809123.600044647, 5767988.284132233],
              [-9808955.447793117, 5767892.229324658],
              [-9804346.598235292, 5760435.275128988],
              [-9811150.77947105, 5751821.454872583],
              [-9807861.399837598, 5748171.421437191],
              [-9802461.565847406, 5745958.339671028],
              [-9802710.424359612, 5734485.992660574],
              [-9843459.591881435, 5735978.822719461],
              [-9871347.239395475, 5736054.403595054],
              [-9872172.25135179, 5782667.657173625],
              [-9871715.81822949, 5782518.959720573],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cheshire',
        GEOID: '33005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8076909.441779725, 5291636.1445553955],
              [-8074166.195568107, 5296451.67341305],
              [-8074246.011643006, 5305116.528989677],
              [-8069838.984321992, 5307048.8383754175],
              [-8064537.9501704145, 5312644.031330891],
              [-8065314.705190792, 5315091.9017887805],
              [-8066460.549095906, 5318704.09181425],
              [-8063448.577633513, 5325165.906397121],
              [-8065297.70569508, 5335363.237863284],
              [-8065141.183724568, 5336542.469117155],
              [-8063052.391565778, 5332639.717081294],
              [-8044222.811017589, 5337876.155113299],
              [-8032442.7598628625, 5339710.374379395],
              [-8034873.532263824, 5332064.78374015],
              [-8019250.064369969, 5331598.181745405],
              [-8019275.779172343, 5328353.357845629],
              [-8021454.190287676, 5314852.411918372],
              [-8021929.858471835, 5303573.006436843],
              [-8015138.590297012, 5299718.277179184],
              [-8012188.067193535, 5279971.422659015],
              [-8007102.999427905, 5268282.037123322],
              [-8024060.853070994, 5268912.743676296],
              [-8028865.50802622, 5269091.448945674],
              [-8037669.486006435, 5269422.1421946045],
              [-8046510.548171148, 5269754.240098131],
              [-8060870.314115442, 5270293.662752085],
              [-8065230.140533045, 5270457.445163954],
              [-8066045.438714737, 5270488.0731914425],
              [-8068171.195710927, 5275701.222060134],
              [-8075071.334347749, 5282312.311059446],
              [-8076663.431365512, 5290387.714891201],
              [-8076909.441779725, 5291636.1445553955],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Simpson',
        GEOID: '21213',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9657114.994434146, 4401138.7822768185],
              [-9646489.326398944, 4421872.476532204],
              [-9641557.650317824, 4422818.952273968],
              [-9638407.642686844, 4415476.615238516],
              [-9618061.668035066, 4412270.532562581],
              [-9618646.206681222, 4407955.887462417],
              [-9620116.51451562, 4394079.106387866],
              [-9619283.755553836, 4390188.800198285],
              [-9630001.017381117, 4390772.192071108],
              [-9634845.752939932, 4388765.977279265],
              [-9636045.293018544, 4389149.1093898],
              [-9640979.679521622, 4390725.292847606],
              [-9658445.36967319, 4390255.434279811],
              [-9657114.994434146, 4401138.7822768185],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Montague',
        GEOID: '48337',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10906963.371555395, 3957472.9398191404],
              [-10906846.486090064, 4013872.024203676],
              [-10903956.292679824, 4014205.6454732264],
              [-10903879.376382459, 4012488.998616012],
              [-10894367.125894176, 4008597.068892417],
              [-10887432.81217368, 4012725.7933456507],
              [-10882574.940914953, 4018763.9719589306],
              [-10872771.923916714, 4027643.286840304],
              [-10865794.306914302, 4024518.4998133704],
              [-10864354.2779814, 4018347.5544727016],
              [-10860467.90864136, 4015256.492035388],
              [-10860136.939072696, 4014993.2907122015],
              [-10852148.095815917, 4017661.786576703],
              [-10851885.208002012, 4017245.2897102516],
              [-10852210.434730763, 3953010.3578870604],
              [-10900202.938879522, 3953035.9693287318],
              [-10906968.714890955, 3953019.295206623],
              [-10906963.371555395, 3957472.9398191404],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lucas',
        GEOID: '39095',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9337806.50100119, 5084522.306787876],
              [-9337522.354144087, 5119157.650699898],
              [-9324471.188694643, 5119657.631280538],
              [-9324458.737457624, 5119658.108290761],
              [-9304699.955543414, 5120436.99987642],
              [-9290038.082987398, 5121015.01211368],
              [-9285106.518225767, 5114841.361025197],
              [-9275899.728420218, 5116379.182669006],
              [-9265306.009078875, 5107833.120493825],
              [-9257754.252621377, 5104841.221559789],
              [-9259819.627975129, 5104695.831374136],
              [-9285820.076161752, 5104093.632038972],
              [-9302483.268099615, 5103863.8710784605],
              [-9304977.381290836, 5101389.859087082],
              [-9315224.34041836, 5093340.961968042],
              [-9322697.551793784, 5081353.54305643],
              [-9334613.524046768, 5073666.636269176],
              [-9337838.894973012, 5073674.354997371],
              [-9337806.50100119, 5084522.306787876],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Cowlitz',
        GEOID: '53015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13716559.450591043, 5842361.430104639],
              [-13607802.089197868, 5842320.117160821],
              [-13608346.441507846, 5788983.405067233],
              [-13620804.094403032, 5773447.504965352],
              [-13634088.851114808, 5778440.679564206],
              [-13654185.136148738, 5768840.113129472],
              [-13661095.850137185, 5769659.890984973],
              [-13661101.972709177, 5759685.4153143605],
              [-13668707.249364577, 5756505.122874604],
              [-13668366.571358856, 5759173.180723317],
              [-13671314.756753026, 5766374.353710742],
              [-13671591.719646119, 5774099.081815631],
              [-13676284.949377961, 5782668.190896703],
              [-13681623.943475898, 5793777.820945479],
              [-13688143.035495736, 5797162.157616665],
              [-13692768.582977178, 5801820.445389046],
              [-13705199.741833555, 5810088.416559065],
              [-13710822.489313522, 5810684.163339663],
              [-13715952.045942867, 5807810.068958266],
              [-13716559.450591043, 5842361.430104639],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Austin',
        GEOID: '48015',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10755909.613037864, 3509243.28119566],
              [-10719270.91771358, 3515915.0264044497],
              [-10704534.77748084, 3510416.9215041497],
              [-10702929.550423602, 3512579.6814336274],
              [-10696082.177225418, 3504210.1740483833],
              [-10701326.327117197, 3495519.0922499946],
              [-10700185.858934019, 3482570.214291526],
              [-10692151.819963979, 3478276.370901921],
              [-10690312.4880176, 3468627.297013537],
              [-10689437.405500475, 3452604.841966065],
              [-10696568.754719675, 3452448.772614061],
              [-10699203.68706675, 3455260.4866639497],
              [-10706199.0038682, 3456565.3331590793],
              [-10715528.02247464, 3461062.1675938787],
              [-10724871.401295392, 3481667.829726872],
              [-10732677.56926778, 3481073.075989421],
              [-10746305.523969673, 3491643.0184084657],
              [-10750105.860065864, 3498604.04266407],
              [-10755909.613037864, 3509243.28119566],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Calhoun',
        GEOID: '45017',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9023393.282175872, 3994887.7837533085],
              [-9018251.323576638, 4012711.0438139364],
              [-9007673.745561464, 4003818.5252369065],
              [-8992929.479005894, 3996756.206247143],
              [-8974589.258939229, 3994376.9158607177],
              [-8975415.694838878, 3992767.2148105116],
              [-8965013.33370221, 3981087.6067993282],
              [-8965729.006708521, 3979098.1944063357],
              [-8960804.121116336, 3969669.771368547],
              [-8967037.90128127, 3970595.9547369224],
              [-8974196.078497749, 3957323.0829162663],
              [-8995464.33513075, 3975762.8656955524],
              [-9010176.207714496, 3976393.337376163],
              [-9015121.019495532, 3981206.081208708],
              [-9021649.239713613, 3989544.3409598884],
              [-9008526.230221957, 3996193.1705363677],
              [-9018437.561084738, 3999465.7249134206],
              [-9023393.282175872, 3994887.7837533085],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Dorchester',
        GEOID: '45035',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8993534.611757847, 3919332.122306222],
              [-8961529.590237835, 3939787.3435622496],
              [-8959502.23967151, 3932533.055230018],
              [-8945840.332524924, 3929525.283173894],
              [-8938549.017197452, 3919147.776672707],
              [-8937850.487392725, 3910608.2939639236],
              [-8933539.862750737, 3907215.933788798],
              [-8922173.252184818, 3898171.4859717404],
              [-8925183.331215868, 3896636.9468051326],
              [-8916766.353197498, 3888142.935604021],
              [-8916371.169005182, 3880291.4919196884],
              [-8926230.958943723, 3876842.961273667],
              [-8922088.426732834, 3871308.3143575764],
              [-8924495.042804293, 3871559.7303736587],
              [-8938073.015054822, 3875259.7966295592],
              [-8950236.227896856, 3876532.7253076085],
              [-8952181.313359488, 3890959.612593683],
              [-8949033.198159855, 3901133.6000797246],
              [-8964782.679717287, 3904552.8877938017],
              [-8974811.118684381, 3904078.2663826924],
              [-8984566.71357954, 3916091.203029718],
              [-8993534.611757847, 3919332.122306222],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Grainger',
        GEOID: '47057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9319078.221189622, 4324560.067706618],
              [-9313813.254553063, 4348111.722295086],
              [-9312766.740020115, 4346398.26131821],
              [-9298795.80996709, 4349356.18740199],
              [-9282576.114880545, 4357625.087401143],
              [-9273380.790982548, 4354167.888471544],
              [-9270753.428360844, 4355066.761094066],
              [-9271677.49145392, 4352868.113280037],
              [-9267936.711285302, 4340473.244836646],
              [-9276063.368071683, 4341522.6290507065],
              [-9289555.624314299, 4330657.9277976835],
              [-9291514.736032771, 4324684.870627624],
              [-9299752.600990456, 4325691.483017856],
              [-9314573.45535569, 4317835.941353739],
              [-9312980.362122947, 4313136.704513391],
              [-9313819.043166583, 4311715.692168683],
              [-9317375.144299975, 4315694.611015034],
              [-9321081.9720239, 4323291.434722181],
              [-9319078.221189622, 4324560.067706618],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Skagway',
        GEOID: '02230',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-15081279.18949831, 8355261.304514381],
              [-15053862.534749815, 8332623.877670446],
              [-15051991.922026524, 8325383.730587751],
              [-15040887.13490295, 8316368.440671865],
              [-15031187.645031154, 8303232.8323727995],
              [-15031062.076645538, 8283693.696305399],
              [-15035629.292713804, 8272130.021072712],
              [-15029248.125543062, 8263258.232399667],
              [-15031372.932607178, 8255461.541301174],
              [-15069878.292529225, 8256430.164854285],
              [-15107982.602701627, 8339886.132731914],
              [-15081279.18949831, 8355261.304514381],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hamblen',
        GEOID: '47063',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9289555.624314299, 4330657.9277976835],
              [-9276063.368071683, 4341522.6290507065],
              [-9267936.711285302, 4340473.244836646],
              [-9257617.171849784, 4348237.627314518],
              [-9248680.665767882, 4334012.349928157],
              [-9255346.254237602, 4326436.676563174],
              [-9258006.233470106, 4325540.740324353],
              [-9260377.449943492, 4324727.20741554],
              [-9259009.556040626, 4318159.678916956],
              [-9266878.619525312, 4317723.758694156],
              [-9265631.618589446, 4312336.501204624],
              [-9270075.047383951, 4318633.381350319],
              [-9286927.705095144, 4321907.967142018],
              [-9291514.736032771, 4324684.870627624],
              [-9289555.624314299, 4330657.9277976835],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Custer',
        GEOID: '46033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11583403.938405588, 5442795.339374613],
              [-11431085.813111624, 5443122.921690748],
              [-11432013.661067387, 5434258.381218026],
              [-11444689.834122999, 5417217.998287058],
              [-11455053.901354834, 5415267.42686553],
              [-11466020.763629315, 5404642.568596031],
              [-11466009.186402272, 5384836.934860865],
              [-11570032.797768954, 5385140.0702077355],
              [-11583314.500811996, 5384985.362818691],
              [-11583326.714332452, 5388899.945946368],
              [-11583353.176717786, 5397387.144193825],
              [-11583403.938405588, 5442795.339374613],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Chesterfield',
        GEOID: '45025',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8968082.634702364, 4139105.1209740546],
              [-8941274.18190995, 4138581.7152557713],
              [-8914155.688499413, 4138052.281281022],
              [-8897477.25010739, 4137800.996146698],
              [-8891305.804541223, 4122352.8032048712],
              [-8880785.778702788, 4111395.3842240367],
              [-8886632.834956702, 4100452.1609734064],
              [-8892706.537693875, 4094952.8673864985],
              [-8910688.86559764, 4095094.547851435],
              [-8937685.62322686, 4078081.3161658146],
              [-8937345.208224015, 4081786.655066148],
              [-8942026.415450854, 4095836.474756554],
              [-8951019.137875607, 4111651.7032861486],
              [-8959942.396938104, 4123807.407084467],
              [-8968088.373153362, 4139105.3108516256],
              [-8968082.634702364, 4139105.1209740546],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Hamlin',
        GEOID: '46057',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10852686.993470848, 5590723.386028181],
              [-10785140.998125268, 5590786.300676137],
              [-10785244.97052967, 5549981.575468067],
              [-10812242.173436854, 5549880.520579732],
              [-10852789.40740238, 5549998.912663789],
              [-10852686.993470848, 5590723.386028181],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Henderson',
        GEOID: '47077',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9863304.851463623, 4249292.334620357],
              [-9863670.75862986, 4271675.383888194],
              [-9859517.205789382, 4276492.908383738],
              [-9816061.082209941, 4275440.467392151],
              [-9817317.656622013, 4246964.945320983],
              [-9823172.171281815, 4235985.119997745],
              [-9823638.154670276, 4223741.12946301],
              [-9823018.55038452, 4221550.701901325],
              [-9825085.975967532, 4220658.425425795],
              [-9836282.49035152, 4220964.539683459],
              [-9836636.041054279, 4231054.138811956],
              [-9852370.939758418, 4233683.528418019],
              [-9859074.154216027, 4243953.054989454],
              [-9864422.053873224, 4244090.078024707],
              [-9863304.851463623, 4249292.334620357],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Rosebud',
        GEOID: '30087',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12010508.438109227, 5917822.297754547],
              [-11963254.984059844, 5919130.925643791],
              [-11878868.464827565, 5916842.298099958],
              [-11809491.041219458, 5916954.11114352],
              [-11813294.494261391, 5914603.734039215],
              [-11817136.463847138, 5858193.547437142],
              [-11821198.066788225, 5802360.211140029],
              [-11821209.755334755, 5746536.698457887],
              [-11825970.667317003, 5746533.186338051],
              [-11826105.809178825, 5677075.64229464],
              [-11830985.276418768, 5677075.80069976],
              [-11831003.087537294, 5649860.498749106],
              [-11885360.951489104, 5649860.498749106],
              [-11885434.644992009, 5677238.801053558],
              [-11880859.079961933, 5728653.868901628],
              [-11901496.155082135, 5729840.256791962],
              [-11901478.4552831, 5746476.194405369],
              [-11897517.373842202, 5753422.160740705],
              [-11904403.597542673, 5753405.225617675],
              [-11904405.601293508, 5759547.60148168],
              [-11904402.484347766, 5802277.316402032],
              [-11912008.6111952, 5801880.685469658],
              [-11912008.6111952, 5829506.4773037555],
              [-11914349.437447598, 5843950.027474976],
              [-11928266.822825555, 5843974.722959757],
              [-11930614.216927914, 5858044.651010506],
              [-11993400.302166663, 5857898.020402315],
              [-11998149.85956085, 5860195.244667874],
              [-12004441.414541502, 5876483.327632936],
              [-11999455.0805904, 5889969.868248531],
              [-12003323.210256483, 5902317.2967107175],
              [-12007154.715810098, 5915313.190711211],
              [-12010508.438109227, 5917822.297754547],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Carbon',
        GEOID: '49007',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-12384014.606746739, 4838809.101190605],
              [-12340631.620072749, 4838846.346014202],
              [-12242562.93354656, 4837823.975436618],
              [-12232128.512396544, 4837824.844878005],
              [-12240929.765297132, 4826188.224858339],
              [-12249368.78457468, 4803169.883979646],
              [-12247811.53621797, 4789114.844160903],
              [-12247828.790739045, 4789114.988363551],
              [-12365095.74796693, 4789183.3406525655],
              [-12365517.426198056, 4788853.408165741],
              [-12365964.48527308, 4796652.84116789],
              [-12371171.120496465, 4809976.994491291],
              [-12374175.856191957, 4807398.9553040285],
              [-12384002.918200204, 4823071.780901693],
              [-12384014.606746739, 4838809.101190605],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Union',
        GEOID: '28145',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9934834.080828767, 4095549.1799486154],
              [-9934779.75691726, 4107387.5584817347],
              [-9932178.777014878, 4109334.088328455],
              [-9917285.119702661, 4109417.663468672],
              [-9877983.99611708, 4109179.1108305757],
              [-9878098.098595142, 4097342.6300047506],
              [-9883995.471258897, 4095454.227046677],
              [-9887949.984849837, 4077886.0409834776],
              [-9899516.525221221, 4079839.079585501],
              [-9934857.012643872, 4079853.107187157],
              [-9934834.080828767, 4095549.1799486154],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Colbert',
        GEOID: '01033',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9811061.27860045, 4112719.649640371],
              [-9807012.032122847, 4149241.458801679],
              [-9793134.27648361, 4147931.5908834077],
              [-9787241.913196942, 4137340.772399782],
              [-9774626.409263812, 4127528.656839403],
              [-9743167.521165634, 4141126.0648139077],
              [-9732274.575033039, 4136738.0318384925],
              [-9734333.874293225, 4116787.8394969483],
              [-9743757.9597448, 4105203.7086318224],
              [-9811650.875743126, 4107179.7068555816],
              [-9811061.27860045, 4112719.649640371],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Alexander',
        GEOID: '17003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9962555.639662545, 4484476.2364589935],
              [-9960164.434053719, 4485884.449625278],
              [-9935090.783574536, 4485920.164929136],
              [-9936575.78558172, 4453856.125232733],
              [-9925982.757759249, 4449162.811183773],
              [-9921783.651645109, 4441603.225546947],
              [-9922230.710720137, 4436606.059462145],
              [-9929146.322766177, 4437680.674350956],
              [-9936111.47198562, 4441266.949970202],
              [-9941658.376513895, 4443116.242135955],
              [-9947449.139483934, 4445047.179262553],
              [-9950200.845976854, 4453510.666763214],
              [-9958208.056949614, 4465360.828111053],
              [-9959813.284006853, 4474480.569279348],
              [-9961189.669877445, 4475542.638393862],
              [-9964990.419565175, 4478475.990563116],
              [-9962555.639662545, 4484476.2364589935],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Baker',
        GEOID: '41001',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13193523.70990394, 5575337.489790297],
              [-13178008.778513609, 5581344.738349239],
              [-13167474.837738823, 5582402.423812458],
              [-13168612.522934731, 5599986.117356957],
              [-13161107.9194629, 5600321.435075694],
              [-13162935.562862746, 5614974.164104794],
              [-13150210.520550674, 5628612.380682334],
              [-13132258.248909425, 5620865.186342568],
              [-13118270.620932778, 5630732.1957295565],
              [-13110931.772182742, 5620287.480488201],
              [-13087168.289163612, 5620398.453810138],
              [-13087107.397402147, 5634037.316129076],
              [-13053991.963961475, 5634214.51453797],
              [-13000238.371512437, 5633764.037772157],
              [-13000303.130149331, 5633647.302729524],
              [-13006715.578096986, 5626388.473839207],
              [-13008607.89812098, 5618178.45982636],
              [-13005860.421768712, 5610347.132583345],
              [-13009389.917543802, 5601172.899553362],
              [-13012056.81939781, 5596451.004120787],
              [-13016788.433540909, 5588079.48342616],
              [-13025916.854424935, 5583321.964418688],
              [-13031312.621463178, 5578667.534026775],
              [-13034952.212214662, 5566903.101383464],
              [-13040291.31763209, 5552084.615460514],
              [-13042991.594520263, 5546804.897049499],
              [-13049531.058006914, 5539930.941425657],
              [-13048322.128336897, 5531786.214510274],
              [-13051434.064702025, 5526147.014383395],
              [-13048526.84488047, 5521348.463306355],
              [-13045776.362901947, 5516440.078983272],
              [-13047979.654697478, 5511433.8737486405],
              [-13078594.573302202, 5512035.1633909885],
              [-13078564.517039688, 5525566.275814701],
              [-13090153.432628721, 5534500.626139525],
              [-13132559.256812532, 5534387.736893753],
              [-13152671.23789466, 5511909.486531287],
              [-13161549.85784135, 5505164.669480719],
              [-13191081.248956446, 5505027.741249552],
              [-13181205.7629697, 5535759.810284702],
              [-13169738.96486207, 5557018.663795045],
              [-13177448.841474917, 5565978.49620565],
              [-13191841.338439582, 5568978.446794132],
              [-13193523.70990394, 5575337.489790297],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Wadena',
        GEOID: '27159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10593497.8155552, 5910257.452993587],
              [-10551654.600077862, 5910131.088850521],
              [-10550763.48755406, 5843749.076594355],
              [-10545455.88555253, 5839616.477097192],
              [-10592669.598543698, 5839660.842627929],
              [-10592666.258958975, 5881878.665991477],
              [-10593575.739198755, 5896106.903759471],
              [-10593497.8155552, 5910257.452993587],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Pulaski',
        GEOID: '05119',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10325286.415549738, 4151826.6331276894],
              [-10303156.65737749, 4155272.881140672],
              [-10301988.915919071, 4157539.1907485784],
              [-10295217.462613605, 4157215.675619623],
              [-10289940.47347204, 4142459.8195690275],
              [-10288066.74380301, 4154599.921630176],
              [-10266984.724678107, 4154040.9181807297],
              [-10266722.901235761, 4165849.6360547505],
              [-10254900.21471606, 4165540.558115062],
              [-10249275.129526787, 4165485.104407148],
              [-10250155.221420998, 4127247.187071028],
              [-10254007.098441426, 4112761.0439064633],
              [-10244681.41941971, 4112528.6427818267],
              [-10244732.292427003, 4094700.8453397364],
              [-10264552.171165291, 4095161.809554009],
              [-10268757.48756899, 4095261.8924694364],
              [-10268578.374508303, 4107070.628546724],
              [-10280215.714075832, 4107259.920094994],
              [-10279979.494116368, 4113117.771407678],
              [-10290946.801668812, 4113298.642128329],
              [-10290737.187067648, 4119401.6599613056],
              [-10302837.393077897, 4121755.8785632155],
              [-10302602.842910795, 4131543.9611785165],
              [-10314232.167474987, 4131929.0660833493],
              [-10313889.748721305, 4143743.542859107],
              [-10323744.974560725, 4143984.5965470597],
              [-10325286.415549738, 4151826.6331276894],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Beaufort',
        GEOID: '45013',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9017587.74809202, 3803613.8669423456],
              [-9009636.308184149, 3802769.2552768732],
              [-8999229.939545812, 3813963.0750680463],
              [-8996695.41737943, 3824364.5606935467],
              [-8998683.360846017, 3843499.0304961293],
              [-9002374.381202249, 3850384.752248627],
              [-8997543.560579784, 3856122.9650483076],
              [-8980271.339707792, 3851800.596199707],
              [-8979002.408832239, 3844006.2348827138],
              [-8966952.407912338, 3837807.884681025],
              [-8962786.38728889, 3830958.2479900033],
              [-8962106.781797599, 3829811.1304228217],
              [-8958134.693608109, 3826926.2586477925],
              [-8959506.58113165, 3823974.1642824262],
              [-8956488.153138788, 3817285.4555617375],
              [-8953905.652271876, 3812661.930183504],
              [-8956231.005115058, 3806240.012561707],
              [-8965608.22506101, 3801046.2378805787],
              [-8971949.539854048, 3799271.989978795],
              [-8977337.403208444, 3801635.2542971983],
              [-8985108.28290225, 3806134.360191943],
              [-8990834.223550184, 3801781.558207481],
              [-8986484.8597254, 3798239.4266100265],
              [-8980050.481838057, 3791800.524374018],
              [-8985872.157248072, 3784387.635161318],
              [-8996006.683689892, 3777725.131881313],
              [-9001153.206388246, 3776389.29062868],
              [-9002120.871310048, 3773618.0748480614],
              [-9018679.56965772, 3795252.1702265013],
              [-9017587.74809202, 3803613.8669423456],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Allen',
        GEOID: '22003',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10367216.905507859, 3580636.36050143],
              [-10350393.858781217, 3580695.0750325155],
              [-10350314.04270632, 3616937.934077799],
              [-10333711.519890938, 3616624.314675666],
              [-10333112.843669452, 3618471.7740740227],
              [-10309415.039149888, 3619642.0300148507],
              [-10307933.37672743, 3619263.2187731653],
              [-10306348.96641497, 3576085.3986563813],
              [-10311563.060044236, 3566416.787361824],
              [-10327551.767187381, 3566469.8806262896],
              [-10327747.800810669, 3559926.3711233046],
              [-10360008.857159505, 3560049.288053309],
              [-10367312.751589432, 3558118.262289182],
              [-10367216.905507859, 3580636.36050143],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Benson',
        GEOID: '38005',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-11114874.116593048, 6168849.388538532],
              [-11075501.080616413, 6168790.402715871],
              [-11042927.55045692, 6168742.141891519],
              [-11042883.579258058, 6132731.720879931],
              [-11028471.267424034, 6124817.190545072],
              [-11028461.026030881, 6110508.142114002],
              [-11020745.138165526, 6115725.641571263],
              [-11019655.876948114, 6105234.598872129],
              [-10998799.057153087, 6116826.018691562],
              [-10992867.62072515, 6103936.634526266],
              [-10997732.505111795, 6098759.03775452],
              [-10984126.369030097, 6106921.380890471],
              [-10978927.526171071, 6092957.859429201],
              [-10967814.612724667, 6092734.796220178],
              [-10967810.271264527, 6081318.635117525],
              [-10971245.813389389, 6081514.862406242],
              [-11053714.186475806, 6081407.3764055],
              [-11111039.605413185, 6081481.355823678],
              [-11111035.820550496, 6110424.259177733],
              [-11114874.116593048, 6168849.388538532],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Lajas',
        GEOID: '72079',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7470544.60570339, 2044114.2404819203],
              [-7465965.81240808, 2045313.1142028715],
              [-7456550.966474241, 2043696.6006166257],
              [-7453813.731515125, 2041350.270725965],
              [-7454168.506732283, 2036564.426611997],
              [-7456034.849511393, 2032550.1295349004],
              [-7456425.064130153, 2033006.636095566],
              [-7460047.177721585, 2033858.109423365],
              [-7464467.786020476, 2034407.7941039735],
              [-7468405.379048817, 2031862.8896792808],
              [-7470407.174475678, 2031886.9005547022],
              [-7471292.784001012, 2041231.445201842],
              [-7470544.60570339, 2044114.2404819203],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Seward',
        GEOID: '31159',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10838969.315259375, 5019268.803715899],
              [-10788076.493097488, 5019146.14477138],
              [-10788088.626921983, 4970262.794929921],
              [-10788360.691757483, 4967890.632560643],
              [-10839000.818675267, 4967990.036258845],
              [-10838969.315259375, 5019268.803715899],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Burke',
        GEOID: '37023',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9117806.793221863, 4284585.932573211],
              [-9121873.962137485, 4295125.705111169],
              [-9117051.935754793, 4300608.850591831],
              [-9106731.617082838, 4295387.700674622],
              [-9095887.651526194, 4283435.580401023],
              [-9078771.723219275, 4270053.961380777],
              [-9057376.33972779, 4268718.14299308],
              [-9065068.739180585, 4256383.679071632],
              [-9076479.54358435, 4241359.24869347],
              [-9076724.001186132, 4240824.303718044],
              [-9080024.735407645, 4239999.5624798825],
              [-9093910.617369706, 4242988.466771604],
              [-9100747.637855247, 4247581.115814939],
              [-9108619.595646692, 4242296.183743205],
              [-9113658.583716942, 4262110.332392728],
              [-9126738.289926678, 4274106.322572185],
              [-9117806.793221863, 4284585.932573211],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'Sumter',
        GEOID: '13261',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9399040.12462134, 3768819.7903103773],
              [-9398839.74953791, 3780920.7153692883],
              [-9398728.87532508, 3785154.2820845745],
              [-9371272.03424041, 3784133.3243581327],
              [-9371059.191374013, 3793500.6272750413],
              [-9365835.969546502, 3787670.8857495203],
              [-9353909.644580875, 3785799.7237400305],
              [-9354565.76165961, 3783421.309116739],
              [-9346526.713312482, 3767327.3666838524],
              [-9341943.021959579, 3753763.7936715316],
              [-9342209.298181556, 3751457.0134274405],
              [-9388479.13321029, 3752314.2831174857],
              [-9388490.487798352, 3746728.895454436],
              [-9390646.746335015, 3748244.990276269],
              [-9400241.595885469, 3759039.4791256376],
              [-9399040.12462134, 3768819.7903103773],
            ],
          ],
        ],
      },
    },
  ],
};
